webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5c836d4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(1455);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1452)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5c836d4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-awesome/components/Icon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Icon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c836d4e", Component.options)
  } else {
    hotAPI.reload("data-v-5c836d4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var iconNames = {
  fileText: 'file-text-o',
  inbox: 'inbox',
  eye: 'eye',
  calendar: 'calendar-check-o',
  archive: 'archive',
  pencil: 'pencil',
  areaChart: 'area-chart',
  plusCircle: 'plus-circle',
  arrowCircleORight: 'arrow-circle-o-right',
  exchange: 'exchange',
  angleRight: 'angle-right',
  angleDoubleRight: 'angle-double-right',
  plus: 'plus',
  repeat: 'files-o',
  trashO: 'trash-o',
  chevronRight: 'chevron-right',
  refresh: 'refresh',
  questionCirle: 'question-circle',
  deleted: 'trash',
  userLock: 'user-lock'

};
var headerManaging = 'MANAGING';
var headerDropdownTextDefault = 'CHOOSE CLIENT';
var iconHomeForManager = '/manager/dashboard';
var iconHomeForUser = '/manager-dashboard'; // '/user/dashboard';
var userRole = 'User';
var emRole = 'Event Manager';
var amRole = 'Account Manager';
var listOptionPrefMonth = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUL', 'JUN', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

var eventStatus = {
  drafts: 'drafts',
  submitted: 'submitted',
  review: 'review',
  approved: 'approved',
  archived: 'archived',
  deleted: 'deleted'
};

var modalAction = {
  saveEvent: 'saveEvent',
  submitEvent: 'submitEvent',
  approveEvent: 'approveEvent',
  suggestChanges: 'suggestChanges',
  reviewSuggestChanges: 'reviewSuggestChanges',
  reviewResubmit: 'reviewResubmit',
  changeOrder: 'changeOrder',
  changeOrderDetail: 'changeOrderDetail',
  deleteEvent: 'deleteEvent',
  showInfo: 'showInfo',
  submitAllEventError: 'submitAllEventError',
  eventPrefDateInvalid: 'eventPrefDateInvalid',
  eventNameNotUnique: 'eventNameNotUnique',
  someFieldsBlank: 'someFieldsBlank',
  lessThan90Days: 'lessThan90Days',
  someEmptyFields: 'someEmptyFields',
  someEmptyFieldsOrLessThan90Days: 'someEmptyFieldsOrLessThan90Days',
  submitAllError: 'submitAllError',
  eventDurationRestricted: 'eventDurationRestricted',
  addClient: 'addClient',
  createUser: 'createUser',
  editUser: 'editUser',
  createValidator: 'createValidator',
  createStaff: 'createStaff',
  editValidator: 'editValidator',
  readOnly: 'readOnly',
  resetPassword: 'resetPassword',
  moveEvent: 'moveEvent',
  emailMustBeAValid: 'emailMustBeAValid',
  editEvent: 'editEvent',
  deleteUser: 'deleteUser',
  deleteValidator: 'deleteValidator',
  forceUserResetPassword: 'forceUserResetPassword',
  modalManageRelatedEvents: 'modalManageRelatedEvents',
  modalAlertChangeEmailTemplate: 'modalAlertChangeEmailTemplate',
  modalCancelEmail: 'modalCancelEmail',
  emailIsNotValid: 'emailIsNotValid',
  deleteClient: 'deleteClient'
};

var EVENT_TYPES = {
  eventManager: {
    magagerOverview: {
      text: eventStatus.eventManager,
      btnRight: 'Go to event',
      btnRightIcon: '',
      btnLeft: '',
      lastUpdateText: 'updated',
      action: modalAction.saveEvent
    }
  },
  drafts: {
    text: eventStatus.drafts,
    btnRight: 'save event',
    btnRightIcon: iconNames.fileText,
    btnLeft: '',
    lastUpdateText: 'updated',
    action: modalAction.saveEvent
  },
  submitted: {
    approve: {
      text: eventStatus.submitted,
      btnRight: 'Review for approval',
      btnRightRelated: 'Approve event',
      btnRightIcon: iconNames.angleRight,
      btnLeft: 'cancel',
      lastUpdateText: 'submitted',
      action: modalAction.approveEvent
    },
    suggestChanges: {
      text: eventStatus.submitted,
      btnRight: 'suggest changes',
      btnRightIcon: iconNames.exchange,
      btnLeft: '',
      lastUpdateText: 'submitted',
      action: modalAction.suggestChanges
    }
  },
  review: {
    suggestChanges: {
      text: eventStatus.submitted,
      btnRight: 'suggest changes',
      btnRightIcon: iconNames.exchange,
      btnLeft: 'cancel',
      lastUpdateText: 'submitted',
      action: modalAction.reviewSuggestChanges
    },
    resubmit: {
      text: eventStatus.submitted,
      btnRight: 'Resubmit',
      btnRightIcon: iconNames.angleRight,
      btnLeft: 'cancel',
      lastUpdateText: 'submitted',
      action: modalAction.reviewResubmit
    }
  },
  approved: {
    text: eventStatus.review,
    funcBtnText: '',
    funcBtnIcon: '',
    isShowFuncBtn: false,
    lastUpdateText: 'approved'
  },
  archived: {
    text: eventStatus.archived,
    funcBtnText: '',
    funcBtnIcon: '',
    isShowFuncBtn: false,
    lastUpdateText: 'archived'
  },
  changeOrderDetail: {
    text: eventStatus.submitted,
    btnRight: 'Request Change',
    btnRightIcon: '',
    btnLeft: '',
    lastUpdateText: 'submitted',
    action: modalAction.changeOrderDetail
  },
  editEventAdmin: {
    text: eventStatus.submitted,
    btnRight: 'Save',
    btnRightIcon: '',
    btnLeft: 'Cancel',
    lastUpdateText: 'updated',
    action: modalAction.editEvent
  }
};

var USER_ROLE = {
  client: 'CLIENT',
  accountManager: 'ACCOUNT_MANAGER',
  eventManager: 'EVENT_MANAGER',
  clientManager: 'CLIENT_MANAGER',
  secondaryAccountManager: 'SECONDARY_ACCOUNT_MANAGER',
  admin: 'ADMIN',
  staff: 'STAFF',
  unknown: 'UNKNOWN'
};

var LOCAL_STORE = {
  token: 'sof_token',
  userId: 'sof_userId',
  role: 'sof_role',
  userName: 'sof_userName',
  clientId: 'sof_clientId',
  clientName: 'sof_clientName',
  pagingOptions: 'sof_pagingOptions',
  googleAPIKey: 'sof_google_api_key',
  addOns: 'sof_add_ons',
  readOnly: 'sof_read_only',
  isForceResetPassword: 'sof_is_force_reset_password',
  isBingMap: 'ems_is_use_bing',
  isShiftboardEnabled: 'is_shiftboard_enabled',
  searchEventString: 'search_event_string',
  sortEventString: 'sort_event_string',
  filterEventString: 'filter_event_string',
  dateRangeEvent: 'date_range_event'
};

var modalTypes = {
  changeSubmmitted: 'ChangeSubmitted',
  submitForApproval: 'SubmitForApprove',
  suggestChanges: 'SuggestChanges',
  approveEvent: 'ApproveEvent',
  changeOrder: 'ChangeOrder'
};

var sideBarItemNames = {
  dashboard: 'Dashboard',
  newEvent: 'New Event',
  draft: 'Drafts',
  submitted: 'Submitted to ',
  review: 'Needs review by ',
  approved: 'Approved',
  archived: 'Archived',
  events: 'Events',
  overview: 'Overview',
  deleted: 'Deleted'
};

var subHeaderBtn = {
  createNewEvent: {
    iconName: iconNames.plus,
    name: 'CreateEvent',
    btnText: 'New Event'
  },
  submitAllEvent: {
    iconName: iconNames.angleDoubleRight,
    name: 'SubmitAllEvent',
    btnText: 'Submit All Event'
  },
  addUser: {
    iconName: iconNames.plus,
    name: 'AddUser',
    btnText: 'Add User'
  },
  addValidator: {
    iconName: iconNames.plus,
    name: 'AddValidator',
    btnText: 'Add'
  },
  addStaff: {
    iconName: iconNames.plus,
    name: 'AddStaff',
    btnText: 'Add'
  }
};

var mappingModalActionToModalData = {
  submitEvent: {
    title: 'SUBMIT EVENT FOR APPROVAL',
    modalAction: modalAction.submitEvent,
    btnRight: 'SUBMIT',
    btnLeft: 'CANCEL',
    height: 370
  },
  approveEvent: {
    title: 'APPROVE EVENT',
    modalAction: modalAction.approveEvent,
    btnRight: 'APPROVE',
    btnLeft: 'CANCEL',
    height: 310
  },
  suggestChanges: {
    title: 'Suggest changes',
    modalAction: modalAction.suggestChanges,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 310
  },
  reviewSuggestChanges: {
    title: 'Suggest changes',
    modalAction: modalAction.reviewSuggestChanges,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 310
  },
  reviewResubmit: {
    title: 'Submit Event',
    modalAction: modalAction.reviewResubmit,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 310
  },
  changeOrder: {
    title: 'Change Order',
    modalAction: modalAction.changeOrder,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 400
  },
  changeOrderDetail: {
    title: 'Change Order',
    modalAction: modalAction.changeOrderDetail,
    btnRight: 'Request Change',
    btnLeft: '',
    height: 600
  },
  deleteEvent: {
    title: 'Delete Event',
    modalAction: modalAction.deleteEvent,
    btnRight: 'Delete Event',
    btnLeft: 'Cancel',
    height: 290
  },
  showInfo: {
    title: 'Changes submitted',
    modalAction: modalAction.showInfo,
    btnRight: 'DONE',
    btnLeft: '',
    height: 310
  },
  submitAllEventError: {
    title: 'Warning',
    modalAction: modalAction.submitAllEventError,
    btnRight: 'DONE',
    btnLeft: '',
    height: 310
  },
  eventPrefDateInvalid: {
    title: 'Warning',
    modalAction: modalAction.eventPrefDateInvalid,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  emailIsNotValid: {
    title: 'Warning',
    modalAction: modalAction.emailIsNotValid,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  eventNameNotUnique: {
    title: 'Warning',
    modalAction: modalAction.eventNameNotUnique,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  someFieldsBlank: {
    title: 'Warning',
    modalAction: modalAction.someFieldsBlank,
    btnRight: 'OK',
    btnLeft: '',
    height: 290
  },
  lessThan90Days: {
    title: 'Warning',
    modalAction: modalAction.lessThan90Days,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  someEmptyFields: {
    title: 'Warning',
    modalAction: modalAction.someEmptyFields,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  someEmptyFieldsOrLessThan90Days: {
    title: 'Warning',
    modalAction: modalAction.someEmptyFieldsOrLessThan90Days,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  submitAllError: {
    title: 'Warning',
    modalAction: modalAction.submitAllError,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  eventDurationRestricted: {
    title: 'Warning',
    modalAction: modalAction.eventDurationRestricted,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  addClient: {
    title: 'Add New Client',
    modalAction: modalAction.addClient,
    btnRight: 'Add Client',
    btnLeft: 'Cancel',
    height: 570
  },
  resetPassword: {
    title: 'Change password',
    modalAction: modalAction.resetPassword,
    btnRight: 'Continue',
    btnLeft: 'Cancel',
    height: 570
  },
  createUser: {
    title: 'Add New User',
    modalAction: modalAction.createUser,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  editUser: {
    title: 'Edit User',
    modalAction: modalAction.editUser,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  createValidator: {
    title: 'Add New Validator',
    modalAction: modalAction.createValidator,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  editValidator: {
    title: 'Edit Validator',
    modalAction: modalAction.editValidator,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  createStaff: {
    title: 'Add New Staff',
    modalAction: modalAction.createStaff,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  readOnly: {
    title: 'Warning',
    modalAction: modalAction.readOnly,
    btnRight: 'OK',
    btnLeft: '',
    height: 290
  },
  moveEvent: {
    title: 'Move Event',
    modalAction: modalAction.moveEvent,
    btnRight: 'Continue',
    btnLeft: 'Cancel',
    height: 290
  },
  emailMustBeAValid: {
    title: 'Warning',
    modalAction: modalAction.emailMustBeAValid,
    btnRight: 'OK',
    btnLeft: '',
    height: 290
  },
  editEvent: {
    title: 'Edit Event',
    modalAction: modalAction.editEvent,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 600
  },
  deleteUser: {
    title: 'Delete User',
    modalAction: modalAction.deleteUser,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 290
  },
  deleteValidator: {
    title: 'Delete Validator',
    modalAction: modalAction.deleteValidator,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 290
  },
  forceUserResetPassword: {
    title: 'Force Reset Password',
    modalAction: modalAction.forceUserResetPassword,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 300
  },
  modalManageRelatedEvents: {
    title: 'Manage Releted Events',
    modalAction: modalAction.modalManageRelatedEvents,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 570
  },
  modalAlertChangeEmailTemplate: {
    title: 'CHANGE TEMPLATE',
    modalAction: modalAction.modalAlertChangeEmailTemplate,
    btnRight: 'CHANGE TEMPLATE',
    btnLeft: 'Cancel',
    height: 300
  },
  modalCancelEmail: {
    title: 'CANCEL EMAIL',
    modalAction: modalAction.modalCancelEmail,
    btnRight: 'CANCEL EMAIL',
    btnLeft: 'KEEP EDITING',
    height: 300
  },
  deleteClient: {
    title: 'DELETE CLIENT',
    modalAction: modalAction.deleteClient,
    btnRight: 'DELETE',
    btnLeft: 'CANCEL',
    height: 300
  }
};

var routeDirect = {
  managerDashboard: '/manager/dashboard',
  managerEvents: '/manager/events',
  userDrafts: '/user/drafts',
  userDashboard: '/user/dashboard',
  userSubmitted: '/user/submitted',
  userRelatedEvent: '/user/relatedEvents',
  clientDashboard: '/manager-dashboard/dashboard',
  mfaEnterCode: '/login/mfa'
};

var listAPI = {
  client: {
    getClients: '/api/clients'
  }
};

var dataTableViewModes = {
  manager: 'Manager',
  client: 'Client',
  relatedEvents: 'RelatedEvent',
  modal: 'Modal'
};

var fields = {
  event: {
    id: 'id',
    eventName: 'eventName',
    prefDate: 'prefDate',
    projPart: 'projPart',
    fullAddress: 'fullAddress',
    eventLocation: 'eventLocation',
    startTime: 'startTime',
    endTime: 'endTime',
    timeZone: 'timeZone',
    duration: 'duration',
    contactName: 'contactName',
    email: 'email',
    phone: 'phone',
    customEventNote: 'customEventNote',
    additionalComments: 'additionalComments',
    status: 'status',
    shippingAddress: 'shippingAddress',
    index: 'index',
    clientId: 'clientId',
    createdBy: 'createdBy',
    lastModifiedBy: 'lastModifiedBy',
    timeStartModel: 'timeStartModel',
    contact: 'contact',
    showCollapse: 'showCollapse',
    userManualFilled: 'userManualFilled',
    durationBackup: 'durationBackup',
    shippingAddressBackup: 'shippingAddressBackup',
    eventNameBackup: 'eventNameBackup',
    additionalServices: 'additionalServices'
  }
};

var siteKey = '6LfuaDgUAAAAAPwpgrR-L_rns8N6zsxrymaTnZIg';

var sofMessages = {
  insertFieldBlank: '',
  submitAllEventSuccess: 'Submit all events successful'
};

var instructions = {
  duplicated: 'Duplicate',
  delete: 'Delete',
  submit: 'Submit',
  restoreToDrafts: 'Restore to Drafts',
  edit: 'Edit',
  forceResetPassword: 'Force reset password',
  prefDate: 'Format: XX/XX/XXXX\nPlease use leading zeros',
  startTime: 'Format: XX:XX AM/PM\nPlease use leading zeros'
};

var dateTimeFotmat = {
  usFormat: 'MM-DD-YYYY'
};

var messageErrors = {
  notUniqueName: 'Event name is not unique.',
  someEmptyFields: 'Some fields are empty.',
  lessThan90Days: 'Date must be over 90 days',
  someEmptyFieldsOrLessThan90Days: 'Some fields are empty or Date must be over 90 days',
  emailIsDuplicated: 'Email is existed.',
  userDeleted: 'Your account is disabled'
};

var modalBodies = {
  eventNameNotUnique: ['Event name is not unique.'],
  someFieldsBlank: ['Please enter blank fields.'],
  emailIsNotValid: ['Contact email is not valid.'],
  eventDurationRestricted: ['Standard events can only be submitted with durations between 4 - 8 hours.', 'To request an event outside of this range please contact ADURO'],
  INVALID_DURATION: ['Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO.'],
  IS_EMPTY: ['Incomplete information. Please fill in required information and continue submitting.'],
  INVALID_DATE: ['Events requested within 90 days. Normal event scheduling requires advanced notice of 90 days. Please choose dates that meet these requirements or contact ADURO for assistance.'],
  readOnly: ['You are not authorized to submit events, please contact your ADURO Event Manager for assistance.'],
  emailMustBeAValid: ['The email field must be a valid email.'],
  deleteUser: ['Are you sure you want to delete this user?'],
  deleteClient: ['Are you sure you want to delete client {clientName}?', 'Page will be reload after delete.'],
  deleteValidator: ['Are you sure you want to delete this validator?'],
  modalAlertChangeEmailTemplate: ['Changing your email template will erase any changs you have made. Are you sure you want to change your email template?'],
  modalCancelEmail: ['Canceling the creation of this email will erase any changes you have made. Are you sure you want to cancel?']
};

var defaultModalMessage = {
  submissionMessage: '<p>By submitting this event to ADURO you are agreeing all of the information is accurate and if approved, ADURO will schedule the event.</p><br/><p>If the event is not approved, ADURO will send the event with changes or suggestions back to you.</p>',
  changeOrderMessage: '<p>Upon submitting, you agree:</p><ul><li>To accept your request to change the event must go through approval again</li><li>That we cannot guarantee your event will be approved for your requested change</li><li>To pay the fee associated with your contract with ADURO (review for details)</li></ul><p><br></p><p>Continuing to the next screen to change your event will NOT charge you.</p><p><br></p><p>Submitting your changes will.</p>'
};

var addOns = [{
  key: 'venipuncture',
  text: 'Venipuncture',
  value: false,
  isShow: false
}, {
  key: 'smallSiteConcierge',
  text: 'Micro Site Concierge',
  value: false,
  isShow: false
}, {
  key: 'cotinine',
  text: 'Cotinine',
  value: false,
  isShow: false
}, {
  key: 'paperScheduler',
  text: 'Paper Scheduler',
  value: false,
  isShow: false
}, {
  key: 'wbaStation',
  text: 'WBA Station',
  value: false,
  isShow: false
}, {
  key: 'smallSiteModel',
  text: 'Micro Site Model',
  value: false,
  isShow: false
}, {
  key: 'tobaccoSelfAttestation',
  text: 'Tobacco Self Attestation',
  value: false,
  isShow: false
}, {
  key: 'fluShots',
  text: 'Flu Shots',
  value: false,
  isShow: false
}, {
  key: 'covidVaccine',
  text: 'Covid Vaccine',
  value: false,
  isShow: false
}, {
  key: 'covidFluShots',
  text: 'Covid & Flu Shots',
  value: false,
  isShow: false
}];

var initEvent = {
  id: 0,
  eventName: 'New Event',
  prefDate: '',
  projPart: null,
  fullAddress: '',
  building: '',
  eventLocation: '',
  startTime: '',
  endTime: '',
  timeZone: '',
  duration: 0,
  contactName: '',
  email: '',
  phone: '',
  customEventNote: '',
  additionalComments: '',
  status: eventStatus.drafts.toUpperCase(),
  shippingAddress: '',
  index: 0,
  clientId: 0,
  createdBy: 0,
  lastModifiedBy: 0,
  timeStartModel: '',
  contact: [],
  showCollapse: true,
  userManualFilled: '',
  eventNameBackup: 'New Event',
  addOns: '',
  addOnsView: addOns,
  fluShot: 0,
  isOnlineScheduler: true,
  isChangeOrder: false,
  maxAppointmentPerslot: 0,
  maxStaffConcierge: 0,
  maxStaffLead: null,
  maxStaffScreener: 0,
  relatedEvents: [],
  shippingAddressBackup: '',
  startTime12HourString: '',
  additionalServices: [],
  isLive: true
};

var listAdditionalServicesKey = {
  venipuncture: 'venipuncture',
  smallSiteConcierge: 'smallSiteConcierge',
  cotinine: 'cotinine',
  paperScheduler: 'paperScheduler',
  wbaStation: 'wbaStation',
  smallSiteModel: 'smallSiteModel',
  tobaccoSelfAttestation: 'tobaccoSelfAttestation',
  fluShots: 'fluShots',
  covidVaccine: 'covidVaccine',
  covidFluShots: 'covidFluShots'
};

var mappingKeyToTextAdditionalServices = function mappingKeyToTextAdditionalServices(key) {
  if (key) {
    var mapping = {};
    mapping[listAdditionalServicesKey.venipuncture] = 'Venipuncture';
    mapping[listAdditionalServicesKey.fluShots] = 'Flu Shots';
    mapping[listAdditionalServicesKey.smallSiteConcierge] = 'Small Site Concierge';
    mapping[listAdditionalServicesKey.cotinine] = 'Cotinine';
    mapping[listAdditionalServicesKey.paperScheduler] = 'Paper Scheduler';
    mapping[listAdditionalServicesKey.kioskModel] = 'Kiosk Model';
    mapping[listAdditionalServicesKey.wbaStation] = 'WBA Station';
    mapping[listAdditionalServicesKey.smallSiteModel] = 'Small Site Model';
    return mapping[key];
  }
  return null;
};

var validateEmail = function validateEmail(email) {
  return new RegExp(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/).test(email);
};

var cleanArray = function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
};

var viewNames = {
  managerEvent: 'managerEvent',
  managerDashboard: 'managerDashboard',
  manageApprovedDashboard: 'ManageApprovedDashboard',
  staffing: 'StaffingSection',
  planAndApprove: 'PlanAndApprove',
  globalSettings: 'globalSettings',
  managerUsers: 'managerUsers'
};

var planMessage = {
  drafts: 'Create new events and submit them to ADURO for approval.',
  submitted: 'Events that have been sent to ADURO for approval.',
  review: 'Review and approve event ADURO has sent to you.',
  approved: 'Events that have been approved and scheduled.',
  archived: 'Events that have taken place are automatically moved here.'
};

var reportMessage = {
  upcoming: 'Reports based on projected participant sign ups.',
  completed: 'Reports based on event attendance.',
  satisfaction: 'Reports based on event satisfaction.'
};

var reportType = {
  upcoming: 'upcoming',
  completed: 'completed',
  satisfaction: 'satisfaction'
};

var listTime = [{ name: '0:00 AM' }, { name: '0:30 AM' }, { name: '1:00 AM' }, { name: '1:30 AM' }, { name: '2:00 AM' }, { name: '2:30 AM' }, { name: '3:00 AM' }, { name: '3:30 AM' }, { name: '4:00 AM' }, { name: '4:30 AM' }, { name: '5:00 AM' }, { name: '5:30 AM' }, { name: '6:00 AM' }, { name: '6:30 AM' }, { name: '7:00 AM' }, { name: '7:30 AM' }, { name: '8:00 AM' }, { name: '8:30 AM' }, { name: '9:00 AM' }, { name: '9:30 AM' }, { name: '10:00 AM' }, { name: '10:30 AM' }, { name: '11:00 AM' }, { name: '11:30 AM' }, { name: '12:00 PM' }, { name: '12:30 PM' }, { name: '1:00 PM' }, { name: '1:30 PM' }, { name: '2:00 PM' }, { name: '2:30 PM' }, { name: '3:00 PM' }, { name: '3:30 PM' }, { name: '4:00 PM' }, { name: '4:30 PM' }, { name: '5:00 PM' }, { name: '5:30 PM' }, { name: '6:00 PM' }, { name: '6:30 PM' }, { name: '7:00 PM' }, { name: '7:30 PM' }, { name: '8:00 PM' }, { name: '8:30 PM' }, { name: '9:00 PM' }, { name: '9:30 PM' }, { name: '10:00 PM' }, { name: '10:30 PM' }, { name: '11:00 PM' }, { name: '11:30 PM' }];

var defaultColumnEmailHistories = [{
  pre: null,
  next: 'emailTemplate',
  colName: 'sentDate',
  size: 125,
  show: true
}, {
  colName: 'emailTemplate',
  pre: 'sentDate',
  next: 'relatedEvent',
  size: 165,
  show: true
}, {
  colName: 'relatedEvent',
  pre: 'emailTemplate',
  next: 'recipients',
  size: 265,
  show: true
}, {
  colName: 'recipients',
  pre: 'relatedEvent',
  next: 'actions',
  size: 265,
  show: true
}, {
  colName: 'actions',
  pre: 'recipients',
  next: null,
  size: 135,
  show: true
}];

var mfaType = {
  text: 'TEXT',
  email: 'EMAIL'
};

var mfaFlow = {
  init: 'INIT',
  login: 'LOGIN_TOKEN',
  disable: 'MFA_DISABLE',
  enable: 'MFA_ENABLE'
};

var googleApisMaps = 'https://maps.googleapis.com/maps/api/timezone/json';

/* harmony default export */ __webpack_exports__["a"] = ({
  headerManaging: headerManaging,
  headerDropdownTextDefault: headerDropdownTextDefault,
  iconHomeForManager: iconHomeForManager,
  iconHomeForUser: iconHomeForUser,
  userRole: userRole,
  emRole: emRole,
  amRole: amRole,
  iconNames: iconNames,
  API_HOST: "https://resources.adurolife.com/cw/prod2/api/v1" || 'http://172.24.0.47:8000',
  listOptionPrefMonth: listOptionPrefMonth,
  modalTypes: modalTypes,
  mappingModalActionToModalData: mappingModalActionToModalData,
  EVENT_TYPES: EVENT_TYPES,
  USER_ROLE: USER_ROLE,
  LOCAL_STORE: LOCAL_STORE,
  sideBarItemNames: sideBarItemNames,
  subHeaderBtn: subHeaderBtn,
  modalAction: modalAction,
  eventStatus: eventStatus,
  routeDirect: routeDirect,
  listAPI: listAPI,
  dataTableViewModes: dataTableViewModes,
  initEvent: initEvent,
  siteKey: siteKey,
  sofMessages: sofMessages,
  instructions: instructions,
  fields: fields,
  dateTimeFotmat: dateTimeFotmat,
  messageErrors: messageErrors,
  modalBodies: modalBodies,
  defaultModalMessage: defaultModalMessage,
  addOns: addOns,
  mappingKeyToTextAdditionalServices: mappingKeyToTextAdditionalServices,
  listAdditionalServicesKey: listAdditionalServicesKey,
  cleanArray: cleanArray,
  viewNames: viewNames,
  validateEmail: validateEmail,
  planMessage: planMessage,
  listTime: listTime,
  reportMessage: reportMessage,
  reportType: reportType,
  defaultColumnEmailHistories: defaultColumnEmailHistories,
  mfaFlow: mfaFlow,
  mfaType: mfaType,
  googleApisMaps: googleApisMaps
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMDU5OTUgNy45OTk4NUwxNS43OCAxLjI3OTg1QzE1LjkxMjQgMS4xMzc2NyAxNS45ODQ2IDAuOTQ5NjI1IDE1Ljk4MTEgMC43NTUzMjRDMTUuOTc3NyAwLjU2MTAyMyAxNS44OTkgMC4zNzU2MzggMTUuNzYxNiAwLjIzODIyNUMxNS42MjQyIDAuMTAwODEyIDE1LjQzODggMC4wMjIwOTk4IDE1LjI0NDUgMC4wMTg2NzE1QzE1LjA1MDIgMC4wMTUyNDMzIDE0Ljg2MjEgMC4wODczNjYzIDE0LjcxOTkgMC4yMTk4NDZMNy45OTk5NSA2LjkzOTg1TDEuMjc5OTUgMC4yMTk4NDZDMS4xMzc3OCAwLjA4NzM2NjMgMC45NDk3MjkgMC4wMTUyNDMzIDAuNzU1NDI4IDAuMDE4NjcxNUMwLjU2MTEyNyAwLjAyMjA5OTggMC4zNzU3NDEgMC4xMDA4MTIgMC4yMzgzMjggMC4yMzgyMjVDMC4xMDA5MTUgMC4zNzU2MzggMC4wMjIyMDM3IDAuNTYxMDIzIDAuMDE4Nzc1NSAwLjc1NTMyNEMwLjAxNTM0NzIgMC45NDk2MjUgMC4wODc0NzAyIDEuMTM3NjcgMC4yMTk5NSAxLjI3OTg1TDYuOTM5OTUgNy45OTk4NUwwLjIxOTk1IDE0LjcxOThDMC4wNzk0OTk3IDE0Ljg2MDUgMC4wMDA2MTAzNTIgMTUuMDUxMSAwLjAwMDYxMDM1MiAxNS4yNDk4QzAuMDAwNjEwMzUyIDE1LjQ0ODYgMC4wNzk0OTk3IDE1LjYzOTIgMC4yMTk5NSAxNS43Nzk4QzAuMzYwNTc2IDE1LjkyMDMgMC41NTEyIDE1Ljk5OTIgMC43NDk5NSAxNS45OTkyQzAuOTQ4NzAxIDE1Ljk5OTIgMS4xMzkzMyAxNS45MjAzIDEuMjc5OTUgMTUuNzc5OEw3Ljk5OTk1IDkuMDU5ODVMMTQuNzE5OSAxNS43Nzk4QzE0Ljg2MDYgMTUuOTIwMyAxNS4wNTEyIDE1Ljk5OTIgMTUuMjUgMTUuOTk5MkMxNS40NDg3IDE1Ljk5OTIgMTUuNjM5MyAxNS45MjAzIDE1Ljc4IDE1Ljc3OThDMTUuOTIwNCAxNS42MzkyIDE1Ljk5OTMgMTUuNDQ4NiAxNS45OTkzIDE1LjI0OThDMTUuOTk5MyAxNS4wNTExIDE1LjkyMDQgMTQuODYwNSAxNS43OCAxNC43MTk4TDkuMDU5OTUgNy45OTk4NVoiIGZpbGw9IiMxRDFEMUQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjYjliOWI5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAxMTwvdGl0bGU+PHBhdGggZD0iTTE4LjUsMTlhLjQ3LjQ3LDAsMCwxLS4zNS0uMTVsLTEzLTEzYS40OS40OSwwLDAsMSwuNy0uN2wxMywxM2EuNDguNDgsMCwwLDEsMCwuN0EuNDcuNDcsMCwwLDEsMTguNSwxOVoiLz48cGF0aCBkPSJNNS41LDE5YS40Ny40NywwLDAsMS0uMzUtLjE1LjQ4LjQ4LDAsMCwxLDAtLjdsMTMtMTNhLjQ5LjQ5LDAsMSwxLC43LjdsLTEzLDEzQS40Ny40NywwLDAsMSw1LjUsMTlaIi8+PC9zdmc+"

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNlYXJjaDwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMTlBOC41LDguNSwwLDEsMSwxOSwxMC41LDguNTEsOC41MSwwLDAsMSwxMC41LDE5Wm0wLTE2QTcuNSw3LjUsMCwxLDAsMTgsMTAuNSw3LjUsNy41LDAsMCwwLDEwLjUsM1oiLz48cGF0aCBkPSJNMjEuNSwyMmEuNDcuNDcsMCwwLDEtLjM1LS4xNWwtNS01YS40OS40OSwwLDAsMSwuNy0uN2w1LDVhLjQ4LjQ4LDAsMCwxLDAsLjdBLjQ3LjQ3LDAsMCwxLDIxLjUsMjJaIi8+PC9zdmc+"

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmJhY2t3YXJkLWxpbmU8L3RpdGxlPjxwYXRoIGQ9Ik0xNSwyMGEuNDguNDgsMCwwLDEtLjM0LS4xM2wtOC03LjVhLjUxLjUxLDAsMCwxLDAtLjc0bDgtNy41YS41LjUsMCwwLDEsLjY4Ljc0TDcuNzMsMTJsNy42MSw3LjEzYS41MS41MSwwLDAsMSwwLC43MUEuNS41LDAsMCwxLDE1LDIwWiIvPjwvc3ZnPg=="

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmxpdmU8L3RpdGxlPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjMiLz48cGF0aCBkPSJNMTYuMjQsNy43NmEuNDkuNDksMCwxLDAtLjcuNyw1LDUsMCwwLDEsMCw3LjA4LjQ4LjQ4LDAsMCwwLDAsLjcuNDguNDgsMCwwLDAsLjcsMCw2LDYsMCwwLDAsMC04LjQ4WiIvPjxwYXRoIGQ9Ik04LjQ2LDcuNzZhLjQ4LjQ4LDAsMCwwLS43LDAsNiw2LDAsMCwwLDAsOC40OC40OC40OCwwLDAsMCwuNywwLC40OC40OCwwLDAsMCwwLS43LDUsNSwwLDAsMSwwLTcuMDhBLjQ4LjQ4LDAsMCwwLDguNDYsNy43NloiLz48cGF0aCBkPSJNMTkuMDcsNC45M2EuNS41LDAsMCwwLS43MSwwLC41MS41MSwwLDAsMCwwLC43MSw5LDksMCwwLDEsMCwxMi43Mi41MS41MSwwLDAsMCwwLC43MS41MS41MSwwLDAsMCwuMzYuMTUuNDkuNDksMCwwLDAsLjM1LS4xNSwxMCwxMCwwLDAsMCwwLTE0LjE0WiIvPjxwYXRoIGQ9Ik0zLDEyQTguOTQsOC45NCwwLDAsMSw1LjY0LDUuNjRhLjUxLjUxLDAsMCwwLDAtLjcxLjUuNSwwLDAsMC0uNzEsMCwxMCwxMCwwLDAsMCwwLDE0LjE0LjQ5LjQ5LDAsMCwwLC4zNS4xNS41MS41MSwwLDAsMCwuMzYtLjE1LjUxLjUxLDAsMCwwLDAtLjcxQTguOTQsOC45NCwwLDAsMSwzLDEyWiIvPjxwYXRoIGQ9Ik0xNy42Niw2LjM0YS41MS41MSwwLDAsMC0uNzEsMCwuNS41LDAsMCwwLDAsLjcxQTcsNywwLDAsMSwxNywxN2EuNS41LDAsMCwwLDAsLjcxLjUyLjUyLDAsMCwwLC43MSwwLDgsOCwwLDAsMCwwLTExLjMyWiIvPjxwYXRoIGQ9Ik01LDEyQTcsNywwLDAsMSw3LjA1LDcuMDVhLjUuNSwwLDAsMCwwLS43MS41MS41MSwwLDAsMC0uNzEsMCw4LDgsMCwwLDAsMCwxMS4zMi41Mi41MiwwLDAsMCwuNzEsMCwuNS41LDAsMCwwLDAtLjcxQTcsNywwLDAsMSw1LDEyWiIvPjwvc3ZnPgo="

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSA2PC90aXRsZT48cGF0aCBkPSJNMTIsM2E5LDksMCwxLDEtOSw5LDksOSwwLDAsMSw5LTltMC0xQTEwLDEwLDAsMSwwLDIyLDEyLDEwLDEwLDAsMCwwLDEyLDJaIi8+PHBhdGggZD0iTTEyLDE3YS41LjUsMCwwLDEtLjUtLjV2LTZhLjUuNSwwLDAsMSwxLDB2NkEuNS41LDAsMCwxLDEyLDE3WiIvPjxwYXRoIGQ9Ik0xMiw3LjVhLjUuNSwwLDEsMCwuNS41LjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4wNCAyNC4wNCI+PHRpdGxlPmRvY3VtZW50XzE8L3RpdGxlPjxwYXRoIGQ9Ik03LjUyLDhoNGEuNTEuNTEsMCwwLDAsLjUtLjUuNS41LDAsMCwwLS41LS41aC00YS41LjUsMCwwLDAtLjUuNUEuNS41LDAsMCwwLDcuNTIsOFoiLz48cGF0aCBkPSJNMTYuNTIsMTBoLTlhLjUuNSwwLDAsMC0uNS41LjUuNSwwLDAsMCwuNS41aDlhLjUxLjUxLDAsMCwwLC41LS41QS41LjUsMCwwLDAsMTYuNTIsMTBaIi8+PHBhdGggZD0iTTE2LjUyLDEzaC05YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWg5YS41MS41MSwwLDAsMCwuNS0uNUEuNS41LDAsMCwwLDE2LjUyLDEzWiIvPjxwYXRoIGQ9Ik0xNi41MiwxNmgtOWEuNS41LDAsMCwwLS41LjUuNS41LDAsMCwwLC41LjVoOWEuNTEuNTEsMCwwLDAsLjUtLjVBLjUuNSwwLDAsMCwxNi41MiwxNloiLz48cGF0aCBkPSJNMTkuNTgsNi42NmwtLjM2LS4zNS0zLjUtMy41LS4zNS0uMzVBMS40NiwxLjQ2LDAsMCwwLDE0LjMxLDJINS41MkExLjUsMS41LDAsMCwwLDQsMy41MnYxN0ExLjUsMS41LDAsMCwwLDUuNTIsMjJoMTNhMS41LDEuNSwwLDAsMCwxLjUtMS41VjcuNzNBMS41MiwxLjUyLDAsMCwwLDE5LjU4LDYuNjZaTTE1LDMuNTIsMTguNTIsN2gtM2EuNTEuNTEsMCwwLDEtLjQ5LS41Wm00LDE3YS41MS41MSwwLDAsMS0uNS41aC0xM2EuNS41LDAsMCwxLS41LS41di0xN2EuNS41LDAsMCwxLC41LS41SDE0VjdhMSwxLDAsMCwwLDEsMWg0WiIvPjwvc3ZnPg=="

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4wNCAyNC4wNCI+PHRpdGxlPmRvY3VtZW50LXF1ZXN0aW9uPC90aXRsZT48cGF0aCBkPSJNMTUsMTBhNyw3LDAsMSwwLDcsN0E3LDcsMCwwLDAsMTUsMTBabTAsMTNhNiw2LDAsMSwxLDYtNkE2LDYsMCwwLDEsMTUsMjNaIi8+PHBhdGggZD0iTTE1LjA4LDEzLjQxYTQuNTUsNC41NSwwLDAsMC0yLjI3LjU5bC41MiwxLjA1QTMuNzUsMy43NSwwLDAsMSwxNSwxNC41OGExLjA4LDEuMDgsMCwwLDEsLjY0LjE3LjUzLjUzLDAsMCwxLC4yMy40Ny44My44MywwLDAsMS0uMTYuNSwyLjk0LDIuOTQsMCwwLDEtLjY2LjU4LDIuNTcsMi41NywwLDAsMC0uNzIuNzMsMS41NiwxLjU2LDAsMCwwLS4yLjh2LjM1aDEuMjd2LS4yOWEuODEuODEsMCwwLDEsLjEyLS40NiwyLjgyLDIuODIsMCwwLDEsLjU5LS41MiwzLjI1LDMuMjUsMCwwLDAsLjktLjg2LDEuNjcsMS42NywwLDAsMCwuMjQtLjkxLDEuNTMsMS41MywwLDAsMC0uNTgtMS4yNkEyLjM4LDIuMzgsMCwwLDAsMTUuMDgsMTMuNDFaIi8+PHBhdGggZD0iTTE0Ljc5LDE5YS44NS44NSwwLDAsMC0uNjIuMjEuOTQuOTQsMCwwLDAsMCwxLjIxLjg2Ljg2LDAsMCwwLC42Mi4yMS44NC44NCwwLDAsMCwuNjItLjIyLjgxLjgxLDAsMCwwLC4yMi0uNTkuODQuODQsMCwwLDAtLjIyLS42MUEuODYuODYsMCwwLDAsMTQuNzksMTlaIi8+PHBhdGggZD0iTTExLjUyLDdoLTRhLjUuNSwwLDAsMC0uNS41LjUuNSwwLDAsMCwuNS41aDRhLjUxLjUxLDAsMCwwLC41LS41QS41LjUsMCwwLDAsMTEuNTIsN1oiLz48cGF0aCBkPSJNOS41MiwxMGgtMmEuNS41LDAsMCwwLS41LjUuNS41LDAsMCwwLC41LjVoMmEuNTEuNTEsMCwwLDAsLjUtLjVBLjUuNSwwLDAsMCw5LjUyLDEwWiIvPjxwYXRoIGQ9Ik0xOS41OCw2LjY2bC0uMzYtLjM1LTMuNS0zLjUtLjM1LS4zNUExLjQ2LDEuNDYsMCwwLDAsMTQuMzEsMkg1LjUyQTEuNSwxLjUsMCwwLDAsNCwzLjUydjE3QTEuNSwxLjUsMCwwLDAsNS41MiwyMkg4Ljc4YTguMzgsOC4zOCwwLDAsMS0uNjgtMUg1LjUyYS41LjUsMCwwLDEtLjUtLjV2LTE3YS41LjUsMCwwLDEsLjUtLjVIMTRWN2ExLDEsMCwwLDAsMSwxaDRWMTAuMWE4LjM4LDguMzgsMCwwLDEsMSwuNjh2LTNBMS41MiwxLjUyLDAsMCwwLDE5LjU4LDYuNjZaTTE4LjUyLDdoLTNhLjUxLjUxLDAsMCwxLS40OS0uNXYtM1oiLz48L3N2Zz4="

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4wNCAyNC4wNCI+PHRpdGxlPmRvY3VtZW50LWFwcHJvdmU8L3RpdGxlPjxwYXRoIGQ9Ik0xNy40NCwxNC41OWwtMy4zNiwzLjc3LTEuNDktMS42N2EuNDkuNDksMCwwLDAtLjctLjA1LjUxLjUxLDAsMCwwLS4wNS43MWwxLjg3LDIuMWEuNS41LDAsMCwwLC4zNy4xNy41LjUsMCwwLDAsLjM4LS4xN2wzLjczLTQuMmEuNS41LDAsMSwwLS43NS0uNjZaIi8+PHBhdGggZD0iTTE1LDEwYTcsNywwLDEsMCw3LDdBNyw3LDAsMCwwLDE1LDEwWm0wLDEzYTYsNiwwLDEsMSw2LTZBNiw2LDAsMCwxLDE1LDIzWiIvPjxwYXRoIGQ9Ik0xMS41Miw3aC00YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWg0YS41MS41MSwwLDAsMCwuNS0uNUEuNS41LDAsMCwwLDExLjUyLDdaIi8+PHBhdGggZD0iTTkuNTIsMTBoLTJhLjUuNSwwLDAsMC0uNS41LjUuNSwwLDAsMCwuNS41aDJhLjUxLjUxLDAsMCwwLC41LS41QS41LjUsMCwwLDAsOS41MiwxMFoiLz48cGF0aCBkPSJNMTkuNTgsNi42NmwtLjM2LS4zNS0zLjUtMy41LS4zNS0uMzVBMS40NiwxLjQ2LDAsMCwwLDE0LjMxLDJINS41MkExLjUsMS41LDAsMCwwLDQsMy41MnYxN0ExLjUsMS41LDAsMCwwLDUuNTIsMjJIOC43OGE4LjM4LDguMzgsMCwwLDEtLjY4LTFINS41MmEuNS41LDAsMCwxLS41LS41di0xN2EuNS41LDAsMCwxLC41LS41SDE0VjdhMSwxLDAsMCwwLDEsMWg0VjEwLjFhOC4zOCw4LjM4LDAsMCwxLDEsLjY4di0zQTEuNTIsMS41MiwwLDAsMCwxOS41OCw2LjY2Wk0xOC41Miw3aC0zYS41MS41MSwwLDAsMS0uNDktLjV2LTNaIi8+PC9zdmc+"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmNhbGVuZGFyLWFwcHJvdmU8L3RpdGxlPjxwYXRoIGQ9Ik0yMC41LDVhLjUuNSwwLDAsMSwuNS41djE1YS41LjUsMCwwLDEtLjUuNUgzLjVhLjUuNSwwLDAsMS0uNS0uNVY1LjVBLjUuNSwwLDAsMSwzLjUsNWgxN20wLTFIMy41QTEuNSwxLjUsMCwwLDAsMiw1LjV2MTVBMS41LDEuNSwwLDAsMCwzLjUsMjJoMTdBMS41LDEuNSwwLDAsMCwyMiwyMC41VjUuNUExLjUsMS41LDAsMCwwLDIwLjUsNFoiLz48cGF0aCBkPSJNMjAuNSw1YS41LjUsMCwwLDEsLjUuNVY5SDNWNS41QS41LjUsMCwwLDEsMy41LDVoMTdtMC0xSDMuNUExLjUsMS41LDAsMCwwLDIsNS41VjEwSDIyVjUuNUExLjUsMS41LDAsMCwwLDIwLjUsNFoiLz48cGF0aCBkPSJNMTAuNSwxOWEuNDcuNDcsMCwwLDEtLjM1LS4xNWwtMy0zYS40OS40OSwwLDAsMSwuNy0uN2wyLjY1LDIuNjQsNS42NS01LjY0YS40OS40OSwwLDEsMSwuNy43bC02LDZBLjQ3LjQ3LDAsMCwxLDEwLjUsMTlaIi8+PHBhdGggZD0iTTE2LjUsN2EuNS41LDAsMCwxLS41LS41di00YS41LjUsMCwwLDEsMSwwdjRBLjUuNSwwLDAsMSwxNi41LDdaIi8+PHBhdGggZD0iTTcuNSw3QS41LjUsMCwwLDEsNyw2LjV2LTRhLjUuNSwwLDAsMSwxLDB2NEEuNS41LDAsMCwxLDcuNSw3WiIvPjwvc3ZnPg=="

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8605342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(1525);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1459)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8605342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/DataTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DataTable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8605342", Component.options)
  } else {
    hotAPI.reload("data-v-d8605342", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CLIENT_VIEW_BASE_ROUTE = '/client';
/* harmony default export */ __webpack_exports__["a"] = ({
  oauth2LoginSuccess: '/oauth2-login-success',
  oauth2LogoutSuccess: '/',
  clientDashboard: {
    name: 'client-view',
    path: CLIENT_VIEW_BASE_ROUTE + '/:clientId',
    children: {
      dashboard: {
        name: 'client-dashboard',
        path: CLIENT_VIEW_BASE_ROUTE + '/:clientId/dashboard'
      },
      plan: {
        name: 'client-plan',
        path: CLIENT_VIEW_BASE_ROUTE + '/:clientId/plan'
      },
      manage: {
        name: 'client-manage',
        path: CLIENT_VIEW_BASE_ROUTE + '/:clientId/manage'
      },
      reports: {
        name: 'client-reports',
        path: CLIENT_VIEW_BASE_ROUTE + '/:clientId/reports',
        children: {
          upcoming: {
            path: CLIENT_VIEW_BASE_ROUTE + '/:clientId/reports/upcoming',
            name: 'upcoming-reports'
          },
          completed: {
            path: CLIENT_VIEW_BASE_ROUTE + '/:clientId/reports/completed',
            name: 'completed-reports'
          }
        }
      }
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDcuMTY2ODNDNS45Mjk2NyA3LjE2NjExIDUuODYwMjQgNy4xNTA5NCA1Ljc5NjAyIDcuMTIyMjdDNS43MzE4IDcuMDkzNiA1LjY3NDE2IDcuMDUyMDQgNS42MjY2NiA3LjAwMDE3TDAuNzkzMzMxIDEuNjY2ODNDMC43NDk1NTcgMS42MTc4IDAuNzE1ODY4IDEuNTYwNjQgMC42OTQxODggMS40OTg1OUMwLjY3MjUwOCAxLjQzNjU0IDAuNjYzMjYxIDEuMzcwODMgMC42NjY5NzYgMS4zMDUyMUMwLjY3NDQ3NyAxLjE3MjY5IDAuNzM0MzE3IDEuMDQ4NTcgMC44MzMzMzEgMC45NjAxNjRDMC45MzIzNDUgMC44NzE3NTggMS4wNjI0MiAwLjgyNjMwNyAxLjE5NDk1IDAuODMzODA4QzEuMzI3NDcgMC44NDEzMSAxLjQ1MTU5IDAuOTAxMTUgMS41NCAxLjAwMDE2TDYgNS45MjAxN0wxMC40NiAxLjAwMDE2QzEwLjUwMzggMC45NTExMzcgMTAuNTU2OCAwLjkxMTIxMiAxMC42MTYgMC44ODI2NjlDMTAuNjc1MiAwLjg1NDEyNiAxMC43Mzk0IDAuODM3NTIzIDEwLjgwNSAwLjgzMzgwOEMxMC44NzA3IDAuODMwMDk0IDEwLjkzNjQgMC44MzkzNDEgMTAuOTk4NCAwLjg2MTAyMUMxMS4wNjA1IDAuODgyNzAxIDExLjExNzYgMC45MTYzOSAxMS4xNjY3IDAuOTYwMTY0QzExLjIxNTcgMS4wMDM5NCAxMS4yNTU2IDEuMDU2OTQgMTEuMjg0MiAxLjExNjE0QzExLjMxMjcgMS4xNzUzNSAxMS4zMjkzIDEuMjM5NTkgMTEuMzMzIDEuMzA1MjFDMTEuMzM2NyAxLjM3MDgzIDExLjMyNzUgMS40MzY1NCAxMS4zMDU4IDEuNDk4NTlDMTEuMjg0MSAxLjU2MDY0IDExLjI1MDQgMS42MTc4IDExLjIwNjcgMS42NjY4M0w2LjM3MzMzIDcuMDAwMTdDNi4zMjU4NCA3LjA1MjA0IDYuMjY4MTkgNy4wOTM2IDYuMjAzOTcgNy4xMjIyN0M2LjEzOTc1IDcuMTUwOTQgNi4wNzAzMiA3LjE2NjExIDYgNy4xNjY4M1oiIGZpbGw9IiMxRDFEMUQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjYjliOWI5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmJhY2t3YXJkLWxpbmU8L3RpdGxlPjxwYXRoIGQ9Ik0xNSwyMGEuNDguNDgsMCwwLDEtLjM0LS4xM2wtOC03LjVhLjUxLjUxLDAsMCwxLDAtLjc0bDgtNy41YS41LjUsMCwwLDEsLjY4Ljc0TDcuNzMsMTJsNy42MSw3LjEzYS41MS41MSwwLDAsMSwwLC43MUEuNS41LDAsMCwxLDE1LDIwWiIvPjwvc3ZnPg=="

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmZvcndhcmQtbGluZTwvdGl0bGU+PHBhdGggZD0iTTksMjBhLjUuNSwwLDAsMS0uMzctLjE2LjUxLjUxLDAsMCwxLDAtLjcxTDE2LjI3LDEyLDguNjYsNC44N2EuNS41LDAsMCwxLC42OC0uNzRsOCw3LjVhLjUxLjUxLDAsMCwxLDAsLjc0bC04LDcuNUEuNDguNDgsMCwwLDEsOSwyMFoiLz48L3N2Zz4="

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollTop_vue__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc39b020_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollTop_vue__ = __webpack_require__(1621);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1617)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc39b020"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc39b020_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollTop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/ScrollTop.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ScrollTop.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cc39b020", Component.options)
  } else {
    hotAPI.reload("data-v-cc39b020", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjI1IDcuMjVIOC43NVYwLjc1QzguNzUgMC41NTEwODggOC42NzA5OCAwLjM2MDMyMiA4LjUzMDMzIDAuMjE5NjdDOC4zODk2OCAwLjA3OTAxNzUgOC4xOTg5MSAwIDggMEM3LjgwMTA5IDAgNy42MTAzMiAwLjA3OTAxNzUgNy40Njk2NyAwLjIxOTY3QzcuMzI5MDIgMC4zNjAzMjIgNy4yNSAwLjU1MTA4OCA3LjI1IDAuNzVWNy4yNUgwLjc1QzAuNTUxMDg4IDcuMjUgMC4zNjAzMjIgNy4zMjkwMiAwLjIxOTY3IDcuNDY5NjdDMC4wNzkwMTc1IDcuNjEwMzIgMCA3LjgwMTA5IDAgOEMwIDguMTk4OTEgMC4wNzkwMTc1IDguMzg5NjggMC4yMTk2NyA4LjUzMDMzQzAuMzYwMzIyIDguNjcwOTggMC41NTEwODggOC43NSAwLjc1IDguNzVINy4yNVYxNS4yNUM3LjI1IDE1LjQ0ODkgNy4zMjkwMiAxNS42Mzk3IDcuNDY5NjcgMTUuNzgwM0M3LjYxMDMyIDE1LjkyMSA3LjgwMTA5IDE2IDggMTZDOC4xOTg5MSAxNiA4LjM4OTY4IDE1LjkyMSA4LjUzMDMzIDE1Ljc4MDNDOC42NzA5OCAxNS42Mzk3IDguNzUgMTUuNDQ4OSA4Ljc1IDE1LjI1VjguNzVIMTUuMjVDMTUuNDQ4OSA4Ljc1IDE1LjYzOTcgOC42NzA5OCAxNS43ODAzIDguNTMwMzNDMTUuOTIxIDguMzg5NjggMTYgOC4xOTg5MSAxNiA4QzE2IDcuODAxMDkgMTUuOTIxIDcuNjEwMzIgMTUuNzgwMyA3LjQ2OTY3QzE1LjYzOTcgNy4zMjkwMiAxNS40NDg5IDcuMjUgMTUuMjUgNy4yNVoiIGZpbGw9IiMxNjc0Q0QiLz4KPC9zdmc+Cg=="

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMDU5ODMgNy45OTk4NUwxNS43Nzk4IDEuMjc5ODVDMTUuOTEyMyAxLjEzNzY3IDE1Ljk4NDQgMC45NDk2MjUgMTUuOTgxIDAuNzU1MzI0QzE1Ljk3NzYgMC41NjEwMjMgMTUuODk4OSAwLjM3NTYzOCAxNS43NjE0IDAuMjM4MjI1QzE1LjYyNCAwLjEwMDgxMiAxNS40Mzg3IDAuMDIyMDk5OCAxNS4yNDQ0IDAuMDE4NjcxNUMxNS4wNSAwLjAxNTI0MzMgMTQuODYyIDAuMDg3MzY2MyAxNC43MTk4IDAuMjE5ODQ2TDcuOTk5ODMgNi45Mzk4NUwxLjI3OTgzIDAuMjE5ODQ2QzEuMTM3NjUgMC4wODczNjYzIDAuOTQ5NjA3IDAuMDE1MjQzMyAwLjc1NTMwNiAwLjAxODY3MTVDMC41NjEwMDUgMC4wMjIwOTk4IDAuMzc1NjE5IDAuMTAwODEyIDAuMjM4MjA2IDAuMjM4MjI1QzAuMTAwNzkzIDAuMzc1NjM4IDAuMDIyMDgxNiAwLjU2MTAyMyAwLjAxODY1MzQgMC43NTUzMjRDMC4wMTUyMjUyIDAuOTQ5NjI1IDAuMDg3MzQ4MSAxLjEzNzY3IDAuMjE5ODI4IDEuMjc5ODVMNi45Mzk4MyA3Ljk5OTg1TDAuMjE5ODI4IDE0LjcxOThDMC4wNzkzNzc3IDE0Ljg2MDUgMC4wMDA0ODgyODEgMTUuMDUxMSAwLjAwMDQ4ODI4MSAxNS4yNDk4QzAuMDAwNDg4MjgxIDE1LjQ0ODYgMC4wNzkzNzc3IDE1LjYzOTIgMC4yMTk4MjggMTUuNzc5OEMwLjM2MDQ1MyAxNS45MjAzIDAuNTUxMDc4IDE1Ljk5OTIgMC43NDk4MjggMTUuOTk5MkMwLjk0ODU3OSAxNS45OTkyIDEuMTM5MiAxNS45MjAzIDEuMjc5ODMgMTUuNzc5OEw3Ljk5OTgzIDkuMDU5ODVMMTQuNzE5OCAxNS43Nzk4QzE0Ljg2MDUgMTUuOTIwMyAxNS4wNTExIDE1Ljk5OTIgMTUuMjQ5OCAxNS45OTkyQzE1LjQ0ODYgMTUuOTk5MiAxNS42MzkyIDE1LjkyMDMgMTUuNzc5OCAxNS43Nzk4QzE1LjkyMDMgMTUuNjM5MiAxNS45OTkyIDE1LjQ0ODYgMTUuOTk5MiAxNS4yNDk4QzE1Ljk5OTIgMTUuMDUxMSAxNS45MjAzIDE0Ljg2MDUgMTUuNzc5OCAxNC43MTk4TDkuMDU5ODMgNy45OTk4NVoiIGZpbGw9IiNERTI4MTQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmFkZDwvdGl0bGU+PHBhdGggZD0iTTEyLDIyYS41LjUsMCwwLDEtLjUtLjVWMi41YS41LjUsMCwwLDEsMSwwdjE5QS41LjUsMCwwLDEsMTIsMjJaIi8+PHBhdGggZD0iTTIxLjUsMTIuNUgyLjVhLjUuNSwwLDAsMSwwLTFoMTlhLjUuNSwwLDAsMSwwLDFaIi8+PC9zdmc+"

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjM2NhYWU5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNlYXJjaDwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMTlBOC41LDguNSwwLDEsMSwxOSwxMC41LDguNTEsOC41MSwwLDAsMSwxMC41LDE5Wm0wLTE2QTcuNSw3LjUsMCwxLDAsMTgsMTAuNSw3LjUsNy41LDAsMCwwLDEwLjUsM1oiLz48cGF0aCBkPSJNMjEuNSwyMmEuNDcuNDcsMCwwLDEtLjM1LS4xNWwtNS01YS40OS40OSwwLDAsMSwuNy0uN2w1LDVhLjQ4LjQ4LDAsMCwxLDAsLjdBLjQ3LjQ3LDAsMCwxLDIxLjUsMjJaIi8+PC9zdmc+"

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAxMTwvdGl0bGU+PHBhdGggZD0iTTE4LjUsMTlhLjQ3LjQ3LDAsMCwxLS4zNS0uMTVsLTEzLTEzYS40OS40OSwwLDAsMSwuNy0uN2wxMywxM2EuNDguNDgsMCwwLDEsMCwuN0EuNDcuNDcsMCwwLDEsMTguNSwxOVoiLz48cGF0aCBkPSJNNS41LDE5YS40Ny40NywwLDAsMS0uMzUtLjE1LjQ4LjQ4LDAsMCwxLDAtLjdsMTMtMTNhLjQ5LjQ5LDAsMSwxLC43LjdsLTEzLDEzQS40Ny40NywwLDAsMSw1LjUsMTlaIi8+PC9zdmc+"

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzBweCIgaGVpZ2h0PSIzMHB4IiB2aWV3Qm94PSIwIDAgMzAgMzAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Nb2RhbCAtIGNsb3NlPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ik1vZGFsLS0tY2xvc2UiIHN0cm9rZT0iIzIzMUYyMCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTE1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDAgTDE0LjE0MjEzNTYsMTQuMTQyMTM1NiIgaWQ9IkxpbmUtMiI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE0LjE0MjEzNTYsMCBMMCwxNC4xNDIxMzU2IiBpZD0iTGluZS0yIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzBweCIgaGVpZ2h0PSIzMHB4IiB2aWV3Qm94PSIwIDAgMzAgMzAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Nb2RhbCAtIGNsb3NlIGhvdmVyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJNb2RhbC0tLWNsb3NlLWhvdmVyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTE1Ij4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTkiIGZpbGw9IiNGNUY1RjUiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMSIgaGVpZ2h0PSIzMCI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTgsOCBMMjIuMTQyMTM1NiwyMi4xNDIxMzU2IiBpZD0iTGluZS0yIiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjIuMTQyMTM1Niw4IEw4LDIyLjE0MjEzNTYiIGlkPSJMaW5lLTIiIHN0cm9rZT0iIzIzMUYyMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    prefMonth: 'FEB',
    prefDate: '12/2017',
    projectPart: '120',
    address: '1530 Lone Oak Road Paducah, KY 42003',
    location: 'Building 3',
    startTime: '9:30 AM',
    endTime: '11:30 PM',
    timeZone: 'EST',
    duration: '4 HR',
    onSiteContact: 'Deanne Neel',
    name: 'KY - Paducah 1'
  }, {
    prefMonth: 'JAN',
    prefDate: '11/2017',
    projectPart: '130',
    address: '1530 Lone Oak Road Paducah, KY 42003',
    location: 'Building 3',
    startTime: '8:30 AM',
    endTime: '11:30 PM',
    timeZone: 'EST',
    duration: '4 HR',
    onSiteContact: 'Deanne Neel',
    name: 'KY - Paducah 1'
  }, {
    prefMonth: 'MAR',
    prefDate: '09/2017',
    projectPart: '150',
    address: '1530 Lone Oak Road Paducah, KY 42003',
    location: 'Building 3',
    startTime: '8:30 AM',
    endTime: '10:30 PM',
    timeZone: 'EST',
    duration: '4 HR',
    onSiteContact: 'Deanne Neel',
    name: 'KY - Paducah 1'
  }, {
    prefMonth: 'MAY',
    prefDate: '12/2018',
    projectPart: '200',
    address: '1530 Lone Oak Road Paducah, KY 42003',
    location: 'Building 3',
    startTime: '8:30 AM',
    endTime: '09:30 PM',
    timeZone: 'EST',
    duration: '4 HR',
    onSiteContact: 'Deanne Neel',
    name: 'KY - Paducah 1'
  }],
  eventItems: [{
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }, {
    url: '/user/submitted/1',
    footerIcons: [],
    eventName: 'Mercy Health',
    eventManager: 'Kimberly Olson'
  }],
  listNewEvent: [],
  currentUser: {
    role: 'em' // 'user' || 'em' || 'am'
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildApiServer */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildOptions;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildOptionsFormData;
/* harmony export (immutable) */ __webpack_exports__["d"] = showApiCallbackErrorMessage;
/* unused harmony export updateRequestOptions */
/* harmony export (immutable) */ __webpack_exports__["c"] = getEndPoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_VueIziToast__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__izi_toast__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_local_storage_keys__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(9);









__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__plugins_VueIziToast__["a" /* default */], {
  progressBar: false,
  position: 'topRight',
  animateInside: false,
  overlayColor: 'rgba(0, 0, 0, 0.3)',
  drag: false,
  messageColor: '#fff'
});
var defaultMethod = 'GET';

/**
 * Build api server
 */
function buildApiServer() {
  if (parseInt("https://resources.adurolife.com/cw/prod2/api/v1", 10) !== 80) {
    return '' + "https://resources.adurolife.com/cw/prod2/api/v1";
  }
  return "https://resources.adurolife.com/cw/prod2/api/v1";
}

/**
 * Build options
 */
function buildOptions(method, body, customHeaders) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  method = method || defaultMethod;
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__["a" /* default */].currentSession().then(function (currentSession) {
      return resolve(currentSession);
    }).catch(function () {
      return resolve(null);
    }); // user not login, not problem here, just call api without token
  }).then(function (currentSession) {
    var token = currentSession && !options.skipAuthen ? 'Bearer ' + currentSession.idToken.jwtToken : null;
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.token, token);
    return {
      method: method,
      headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        'Content-Type': 'application/json',
        'Authorization': token
      }, customHeaders),
      data: body,
      params: body && body.params ? body.params : null
    };
  });
}

function buildOptionsFormData() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMethod;
  var body = arguments[1];
  var customHeaders = arguments[2];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__["a" /* default */].currentSession().then(function (currentSession) {
      return resolve(currentSession);
    }).catch(function () {
      return resolve(null);
    }); // user not login, not problem here, just call api without token
  }).then(function (currentSession) {
    var token = currentSession && !options.skipAuthen ? 'Bearer ' + currentSession.idToken.jwtToken : null;
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.token, token);
    return {
      method: method,
      headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customHeaders),
      data: body,
      params: body && body.params ? body.params : null
    };
  });
}

function showApiCallbackErrorMessage(ex) {
  if (ex.response && ex.response.data) {
    // check if general exception not fired - status will be 500, to get error message in error list
    if (ex.response.data.status === 500) {
      if (ex.response.data.errors && ex.response.data.errors.length) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$toast.success(ex.response.data.errors[0].defaultMessage || 'Internal server error.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__izi_toast__["a" /* default */].optError));
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$toast.success(ex.response.data && ex.response.data.message || 'Internal server error.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__izi_toast__["a" /* default */].optError));
    }
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$toast.success('Internal server error.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__izi_toast__["a" /* default */].optError));
}

function updateRequestOptions(options) {
  if (options.headers.Authorization) {
    var token = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__store_local_storage_keys__["a" /* default */].TOKEN).replace('Bearer ', '');
    options.headers.Authorization = 'Bearer ' + token;
  }
}

/**
 * Build endpoints
 */
function getEndPoint() {
  return {
    mfa: {
      updateMFAConfirm: buildApiServer() + '/mfa/confirm',
      sendNewCode: buildApiServer() + '/mfa/non-auth/send-code',
      confirmLogin: buildApiServer() + '/mfa/non-auth/confirm-login'
    },
    settings: {
      updateValidator: buildApiServer() + '/configs/update_system_config',
      saveEmailTemplates: buildApiServer() + '/system/update_email_config'
    },
    emailHistory: {
      resendEmail: buildApiServer() + '/events/resend-participant-email'
    },
    clients: {
      // doLogin: buildApiServer() + '/login',
      requestResetPassword: buildApiServer() + '/public/request_reset_password',
      checkToken: buildApiServer() + '/public/check_token',
      internalPasswordChange: buildApiServer() + '/clients/password_change',
      internalPasswordReset: buildApiServer() + '/public/internal_password_reset',
      externalPasswordReset: buildApiServer() + '/public/external_password_reset',
      forceResetPassword: buildApiServer() + '/clients/force_password_reset',
      getClient: buildApiServer() + '/clients/get_client',
      getClients: buildApiServer() + '/clients',
      syncClientsAndPrograms: buildApiServer() + '/client/sync-es-clients',
      syncStaffs: buildApiServer() + '/sales-force/sync-staff-manually',
      syncEvents: buildApiServer() + '/sales-force/sync-manually',
      syncBiometricOrders: buildApiServer() + '/sales-force/sync-order-manually',
      syncUsersStatus: buildApiServer() + '/users/sync_cognito_statuses',
      syncBasicShiftBoard: buildApiServer() + '/shiftboard/sync-basic-data',
      searchClients: buildApiServer() + '/clients/search',
      importUser: buildApiServer() + '/clients/import_user',
      getAllAM: buildApiServer() + '/clients/get_all_am',
      updateClient: buildApiServer() + '/clients/update',
      verifyRecaptcha: buildApiServer() + '/public/clients/verify_recaptcha',
      updateMessage: buildApiServer() + '/clients/update_messages',
      getMessages: buildApiServer() + '/clients/get_client',
      changeNotification: buildApiServer() + '/clients/email_notification',
      updateAddOn: buildApiServer() + '/clients/update_add_on',
      updateSecondaryAM: buildApiServer() + '/clients/update_secondary_am',
      updateReseller: buildApiServer() + '/clients/update_reseller_toggle',
      updateClientManager: buildApiServer() + '/clients/update_client_manager',
      addClient: buildApiServer() + '/clients/create_new_client',
      getAllUsers: buildApiServer() + '/clients/get_users',
      updateUser: buildApiServer() + '/clients/update_user_info',
      deleteUser: buildApiServer() + '/clients/delete_user',
      createUser: buildApiServer() + '/clients/create_user',
      updateReadOnly: buildApiServer() + '/clients/update_read_only',
      updateClientName: buildApiServer() + '/clients/update_client_name',
      updateValidatorsToClient: buildApiServer() + '/clients/update_validators_to_client',
      getAllValidators: buildApiServer() + '/clients/get_all_validators',
      addValidator: buildApiServer() + '/clients/create_new_validator',
      deleteValidator: buildApiServer() + '/clients/delete_validator',
      getValidatorsByClientId: buildApiServer() + '/clients/get_validators_by_client_id',
      getValidatorsByEventId: buildApiServer() + '/clients/get_validators_by_event_id',
      getStaffLIst: buildApiServer() + '/clients/get_all_staff',
      updateStaff: buildApiServer() + '/clients/update_staff',
      deleteStaff: buildApiServer() + '/clients/delete_staff',
      getSchedulerConfiguration: buildApiServer() + '/config-scheduler/configuration',
      getAvailableEmailTags: buildApiServer() + '/config-scheduler/available-tag',
      saveConfigurations: buildApiServer() + '/config-scheduler/configuration',
      uploadAvatar: buildApiServer() + '/client/avatar/upload',
      getClientEventSchedulerStatus: buildApiServer() + '/events/client-event-scheduler-status',
      updateClientEventSchedulerStatus: buildApiServer() + '/events/client-event-scheduler-status',
      deleteClient: buildApiServer() + '/clients/delete_client',
      getListEM: buildApiServer() + '/users/get_all_em',
      getProgramClient: buildApiServer() + '/programs-of-client',
      getClientsPaging: buildApiServer() + '/clients-overview'
    },
    events: {
      updateEvent: buildApiServer() + '/events/update',
      getEvents: buildApiServer() + '/events',
      countEvents: buildApiServer() + '/events/count_events',
      exportExcel: buildApiServer() + '/public/export',
      getRelatedItemInfo: buildApiServer() + '/events/count_related',
      getEventsRelated: buildApiServer() + '/events/related',
      deleteEvent: buildApiServer() + '/events/delete',
      submitEvents: buildApiServer() + '/events/submit_events',
      submitAllEvent: buildApiServer() + '/events/submit_all',
      getOnSiteContact: buildApiServer() + '/events/search_contact',
      getEventLockList: buildApiServer() + '/events/locked_events',
      removeEventLockList: buildApiServer() + '/events/remove_locked_events',
      getEventHistory: buildApiServer() + '/events/event_history',
      updateAddOn: buildApiServer() + '/events/update_add_on',
      changeEventStatus: buildApiServer() + '/events/change_status',
      getEventsByDates: buildApiServer() + '/events/get_events_by_dates',
      getDateHasData: buildApiServer() + '/events/date-has-data',
      getLockedDate: buildApiServer() + '/events/locked-date',
      getDateRangeHasData: buildApiServer() + '/events/date-range-has-data',
      getEventById: buildApiServer() + '/events/get_events_by_id',
      blockDate: buildApiServer() + '/events/block-date',
      openDate: buildApiServer() + '/events/open-date',
      blockOrOpenSlots: buildApiServer() + '/events/block-event-staffing',
      changeDuration: buildApiServer() + '/events/event-staffing-duration',
      getEventStaffing: buildApiServer() + '/events/event-staffing',
      updateEventStaffing: buildApiServer() + '/events/update-event-staffing',
      getTrackingStatus: buildApiServer() + '/events/tracking',
      getEventByStatus: buildApiServer() + '/events/get-events-by-status',
      getPackingSlip: buildApiServer() + '/public/packaging-slips/export',
      getURLForPackingSlip: buildApiServer() + '/event/packaging-slips/download-url',
      getStaffMaxSlots: buildApiServer() + '/events/set-max-staff-number',
      getAllAvailableStaffs: buildApiServer() + '/clients/get_all_available_staff',
      assignStaff: buildApiServer() + '/clients/event/assign_staff',
      getEventStaff: buildApiServer() + '/clients/get_event_staff',
      getEventReportChart: buildApiServer() + '/events/event-report-chart',
      updateIsLiveEvent: buildApiServer() + '/events/update-is-live-event',
      clearSingleSlot: buildApiServer() + '/events/slot/remove-participant',
      searchRelatedEvents: buildApiServer() + '/events/get_eligible_related_events',
      addOrRemoveRelatedEvents: buildApiServer() + '/events/add-remove-related-events',
      getDefaultEmailTemplate: buildApiServer() + '/events/get_default_templates',
      sendOnSiteContactEmail: buildApiServer() + '/events/send-onsite-contact-emails',
      getEventHistoriesById: buildApiServer() + '/events/email-histories',
      getEmailHistoryDetails: buildApiServer() + '/events/email-history-detail',
      addParticipant: buildApiServer() + '/events/add-participant-to-slot',
      updateParticipant: buildApiServer() + '/events/update-participant-to-slot',
      updateMaxNumberSlotFluShot: buildApiServer() + '/events/update-max-slot-flushot',
      searchParticipant: buildApiServer() + '/events/get-filled-slots',
      generatePackingSlip: buildApiServer() + '/public/packaging-slips/export-by-event',
      resendBiometricSurvey: buildApiServer() + '/events/resend-biometric-survey-emails',
      cancelAllAppointments: buildApiServer() + '/events/cancel-all-appointments',
      bulkCreateEventTemplate: buildApiServer() + '/public/event/bulk-create-event-template',
      uploadBulkCreateEvent: buildApiServer() + '/events/upload',
      uploadHistories: buildApiServer() + '/events/upload-histories',
      downloadUploadedFile: buildApiServer() + '/public/events/download-uploaded-file',
      exportParticipantReport: buildApiServer() + '/event/participant-report',
      updateEventShiftboard: buildApiServer() + '/events/{eventId}/update-shiftboard'
    },
    oauth2: {
      createUserIfNotExist: buildApiServer() + '/users/get-user-info'
    },
    staff: {
      forceResetPassword: buildApiServer() + '/staff/reset-password'
    },
    shiftboard: {
      getWorkgroups: buildApiServer() + '/shiftboard/workgroups'
    }
  };
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  return response.data;
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  // const error = new Error(response.statusText);
  // error.response = response;
  // throw error;
  throw response;
}

/**
 * Add set timeout for api call,
 * if time is exceeded then throwing error timeout
 * regardless request is still calling in background
 *
 * @param  {promise function} fetchPromise Promise function
 * @param  {number} ms                    Timeout in ms
 * @return {promise}                       The response
 */
function fetchWithTimeout(fetchPromise, ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var timeoutId = setTimeout(function () {
      return reject(new Error('Time out'));
    }, ms);
    fetchPromise.then(function (res) {
      clearTimeout(timeoutId);
      resolve(res);
    }, function (err) {
      clearTimeout(timeoutId);
      reject(err);
    });
  });
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param buildOptions
 * @param timeout
 *
 * @return {object}           The response data
 */
function makeCall(url, buildOptions) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20000;

  return buildOptions.then(function (options) {
    return fetchWithTimeout(__WEBPACK_IMPORTED_MODULE_2_axios___default()(url, options), timeout).then(checkStatus).then(parseJSON);
  });
}

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIGZpbGw9IiNmZmYiIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHRpdGxlPnRyYXNoX2V4cG9ydDwvdGl0bGU+CjxwYXRoIGQ9Ik0xOC41LDZIMTVWNC41QzE1LDQuMiwxNC44LDQsMTQuNSw0aC01QzkuMiw0LDksNC4yLDksNC41VjZINS41QzUuMiw2LjEsNSw2LjMsNS4xLDYuNkM1LjEsNi44LDUuMyw3LDUuNSw3SDYKCWMwLDAsMCwwLDAsMC4xbDEsMTJDNywxOS42LDcuNSwyMCw4LDIwaDhjMC41LDAsMS0wLjQsMS0wLjlsMS0xMmMwLDAsMCwwLDAtMC4xaDAuNWMwLjMsMC4xLDAuNS0wLjEsMC42LTAuNAoJQzE5LjIsNi4zLDE5LDYuMSwxOC43LDZDMTguNiw2LDE4LjYsNiwxOC41LDZMMTguNSw2eiBNMTAsNWg0djFoLTRWNXogTTE2LDE5SDhMNyw3aDEwTDE2LDE5eiIvPgo8L3N2Zz4K"

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageEmail_vue__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb29f698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageEmail_vue__ = __webpack_require__(1683);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1674)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb29f698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageEmail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/email/ManageEmail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManageEmail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eb29f698", Component.options)
  } else {
    hotAPI.reload("data-v-eb29f698", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  day60: 'REMINDED_60_DAYS',
  day30: 'REMINDED_30_DAYS',
  day7: 'REMIND_7_DAYS',
  thankyou: 'THANK_YOU',
  tracking: 'TRACKING',
  eventConfirmation: 'EVENT_CONFIRMATION',
  notReminded: 'NOT_REMINDED',
  cancellation: 'CANCELLATION'
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db4f778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__(1696);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db4f778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Spinner.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Spinner.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2db4f778", Component.options)
  } else {
    hotAPI.reload("data-v-2db4f778", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNvcnQ8L3RpdGxlPjxwYXRoIGQ9Ik03Ljg1LDQuMTVhLjQ4LjQ4LDAsMCwwLS43LDBsLTMsM2EuNDkuNDksMCwwLDAsLjcuN0w3LDUuNzFWMTkuNWEuNS41LDAsMCwwLDEsMFY1LjcxbDIuMTUsMi4xNGEuNDguNDgsMCwwLDAsLjcsMCwuNDguNDgsMCwwLDAsMC0uN1oiLz48cGF0aCBkPSJNMTkuODUsMTYuMjFhLjQ4LjQ4LDAsMCwwLS43LDBMMTcsMTguMzVWNC41YS41LjUsMCwwLDAtMSwwVjE4LjM1bC0yLjE1LTIuMTRhLjQ5LjQ5LDAsMCwwLS43LjdsMywzYS40OC40OCwwLDAsMCwuNywwbDMtM0EuNDguNDgsMCwwLDAsMTkuODUsMTYuMjFaIi8+PC9zdmc+"

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59073bd1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1435);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59073bd1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/Modal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Modal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59073bd1", Component.options)
  } else {
    hotAPI.reload("data-v-59073bd1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tokens__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directive__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_vue__ = __webpack_require__(1472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__component_vue__["a"]; });
/* unused harmony reexport mask */
/* unused harmony reexport tokens */




function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__component_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__component_vue__["a" /* default */]);
  Vue.directive('mask', __WEBPACK_IMPORTED_MODULE_1__directive__["a" /* default */]);
}

var version = '1.0.0';



// Install by default if included from script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install);
}

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_520c1b11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(1519);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_520c1b11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-google-autocomplete/src/VueGoogleAutocomplete.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] VueGoogleAutocomplete.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-520c1b11", Component.options)
  } else {
    hotAPI.reload("data-v-520c1b11", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventDetailModal_vue__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cb2843_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventDetailModal_vue__ = __webpack_require__(1673);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1660)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43cb2843"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventDetailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cb2843_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventDetailModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/event/EventDetailModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventDetailModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43cb2843", Component.options)
  } else {
    hotAPI.reload("data-v-43cb2843", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoriesManagement_vue__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_478c16ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoriesManagement_vue__ = __webpack_require__(1697);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1684)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoriesManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_478c16ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoriesManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/email/EmailHistoriesManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmailHistoriesManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-478c16ac", Component.options)
  } else {
    hotAPI.reload("data-v-478c16ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventStaffingDetail_vue__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0871f9c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventStaffingDetail_vue__ = __webpack_require__(1733);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1698)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0871f9c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventStaffingDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0871f9c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventStaffingDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/staffing/EventStaffingDetail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventStaffingDetail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0871f9c0", Component.options)
  } else {
    hotAPI.reload("data-v-0871f9c0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNDI0MjQyIiBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJzb3J0IiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtc29ydCBmYS13LTEwIiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyMCA1MTIiPjxwYXRoIGQ9Ik00MSAyODhoMjM4YzIxLjQgMCAzMi4xIDI1LjkgMTcgNDFMMTc3IDQ0OGMtOS40IDkuNC0yNC42IDkuNC0zMy45IDBMMjQgMzI5Yy0xNS4xLTE1LjEtNC40LTQxIDE3LTQxem0yNTUtMTA1TDE3NyA2NGMtOS40LTkuNC0yNC42LTkuNC0zMy45IDBMMjQgMTgzYy0xNS4xIDE1LjEtNC40IDQxIDE3IDQxaDIzOGMyMS40IDAgMzIuMS0yNS45IDE3LTQxeiI+PC9wYXRoPjwvc3ZnPgo="

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJzb3J0LXVwIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtc29ydC11cCBmYS13LTEwIiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyMCA1MTIiPjxwYXRoIGZpbGw9IiM0MjQyNDIiIGQ9Ik0yNzkgMjI0SDQxYy0yMS40IDAtMzIuMS0yNS45LTE3LTQxTDE0MyA2NGM5LjQtOS40IDI0LjYtOS40IDMzLjkgMGwxMTkgMTE5YzE1LjIgMTUuMSA0LjUgNDEtMTYuOSA0MXoiPjwvcGF0aD48L3N2Zz4K"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJzb3J0LWRvd24iIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1zb3J0LWRvd24gZmEtdy0xMCIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48cGF0aCBmaWxsPSIjNDI0MjQyIiBkPSJNNDEgMjg4aDIzOGMyMS40IDAgMzIuMSAyNS45IDE3IDQxTDE3NyA0NDhjLTkuNCA5LjQtMjQuNiA5LjQtMzMuOSAwTDI0IDMyOWMtMTUuMS0xNS4xLTQuNC00MSAxNy00MXoiPjwvcGF0aD48L3N2Zz4K"

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjM2NhYWU5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAxMTwvdGl0bGU+PHBhdGggZD0iTTE4LjUsMTlhLjQ3LjQ3LDAsMCwxLS4zNS0uMTVsLTEzLTEzYS40OS40OSwwLDAsMSwuNy0uN2wxMywxM2EuNDguNDgsMCwwLDEsMCwuN0EuNDcuNDcsMCwwLDEsMTguNSwxOVoiLz48cGF0aCBkPSJNNS41LDE5YS40Ny40NywwLDAsMS0uMzUtLjE1LjQ4LjQ4LDAsMCwxLDAtLjdsMTMtMTNhLjQ5LjQ5LDAsMSwxLC43LjdsLTEzLDEzQS40Ny40NywwLDAsMSw1LjUsMTlaIi8+PC9zdmc+"

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyOEMzMC4yMDkxIDAgMzIgMS43OTA4NiAzMiA0VjI4QzMyIDMwLjIwOTEgMzAuMjA5MSAzMiAyOCAzMkg0QzEuNzkwODYgMzIgMCAzMC4yMDkxIDAgMjhWNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMi41IDEwSDE5VjguNUMxOSA4LjIgMTguOCA4IDE4LjUgOEgxMy41QzEzLjIgOCAxMyA4LjIgMTMgOC41VjEwSDkuNUM5LjIgMTAuMSA5IDEwLjMgOS4xIDEwLjZDOS4xIDEwLjggOS4zIDExIDkuNSAxMUgxMEMxMCAxMSAxMCAxMSAxMCAxMS4xTDExIDIzLjFDMTEgMjMuNiAxMS41IDI0IDEyIDI0SDIwQzIwLjUgMjQgMjEgMjMuNiAyMSAyMy4xTDIyIDExLjFDMjIgMTEuMSAyMiAxMS4xIDIyIDExSDIyLjVDMjIuOCAxMS4xIDIzIDEwLjkgMjMuMSAxMC42QzIzLjIgMTAuMyAyMyAxMC4xIDIyLjcgMTBDMjIuNiAxMCAyMi42IDEwIDIyLjUgMTBaTTE0IDlIMThWMTBIMTRWOVpNMjAgMjNIMTJMMTEgMTFIMjFMMjAgMjNaIiBmaWxsPSIjMTY3NENEIi8+CjxwYXRoIGQ9Ik00IDFIMjhWLTFINFYxWk0zMSA0VjI4SDMzVjRIMzFaTTI4IDMxSDRWMzNIMjhWMzFaTTEgMjhWNEgtMVYyOEgxWk00IDMxQzIuMzQzMTUgMzEgMSAyOS42NTY5IDEgMjhILTFDLTEgMzAuNzYxNCAxLjIzODU4IDMzIDQgMzNWMzFaTTMxIDI4QzMxIDI5LjY1NjkgMjkuNjU2OSAzMSAyOCAzMVYzM0MzMC43NjE0IDMzIDMzIDMwLjc2MTQgMzMgMjhIMzFaTTI4IDFDMjkuNjU2OSAxIDMxIDIuMzQzMTUgMzEgNEgzM0MzMyAxLjIzODU4IDMwLjc2MTQgLTEgMjggLTFWMVpNNCAtMUMxLjIzODU4IC0xIC0xIDEuMjM4NTggLTEgNEgxQzEgMi4zNDMxNSAyLjM0MzE1IDEgNCAxVi0xWiIgZmlsbD0iI0I5QjlCOSIvPgo8L3N2Zz4K"

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjYjliOWI5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNlYXJjaDwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMTlBOC41LDguNSwwLDEsMSwxOSwxMC41LDguNTEsOC41MSwwLDAsMSwxMC41LDE5Wm0wLTE2QTcuNSw3LjUsMCwxLDAsMTgsMTAuNSw3LjUsNy41LDAsMCwwLDEwLjUsM1oiLz48cGF0aCBkPSJNMjEuNSwyMmEuNDcuNDcsMCwwLDEtLjM1LS4xNWwtNS01YS40OS40OSwwLDAsMSwuNy0uN2w1LDVhLjQ4LjQ4LDAsMCwxLDAsLjdBLjQ3LjQ3LDAsMCwxLDIxLjUsMjJaIi8+PC9zdmc+"

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNjhCODE0O3N0cm9rZTojNjhCODE0O3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPHRpdGxlPmFwcHJvdmUtZXhwb3J0LWZpbGw8L3RpdGxlPgo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPgo8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTAuNSwxNi44Yy0wLjEsMC0wLjMtMC4xLTAuNC0wLjFsLTMuNS0zLjVjLTAuMi0wLjItMC4yLTAuNSwwLTAuN3MwLjUtMC4yLDAuNywwbDMuMiwzLjFsNi4xLTYuMQoJYzAuMi0wLjIsMC41LTAuMiwwLjcsMHMwLjIsMC41LDAsMC43bDAsMGwtNi41LDYuNUMxMC44LDE2LjcsMTAuNiwxNi44LDEwLjUsMTYuOHoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMy41IDE5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMy41IDE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0U4MzAwMTtzdHJva2U6I0U4MzAwMTtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qxe3N0cm9rZTojRkZGRkZGO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDJ7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHRpdGxlPjI0cHgtZXJyb3ItaGV4YWdvbi1maWxsPC90aXRsZT4KPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIyMi42LDkgMTcuNiwxIDE3LjMsMC41IDE2LjgsMC41IDYuOCwwLjUgNi4yLDAuNSA1LjksMSAwLjksOSAwLjYsOS41IDAuOSwxMCA1LjksMTggNi4yLDE4LjUgCgk2LjgsMTguNSAxNi44LDE4LjUgMTcuMywxOC41IDE3LjYsMTggMjIuNiwxMCAyMyw5LjUgIi8+CjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xMS44LDExYy0wLjMsMC0wLjUtMC4yLTAuNS0wLjV2LTVjMC0wLjMsMC4yLTAuNSwwLjUtMC41czAuNSwwLjIsMC41LDAuNXY1QzEyLjMsMTAuOCwxMiwxMSwxMS44LDExeiIvPgo8cGF0aCBjbGFzcz0ic3QyIiBkPSJNMTEuOCwxM2MtMC4zLDAtMC41LDAuMi0wLjUsMC41czAuMiwwLjUsMC41LDAuNXMwLjUtMC4yLDAuNS0wLjVTMTIsMTMsMTEuOCwxM3oiLz4KPC9zdmc+Cg=="

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjOGU4ZThlIiBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJzb3J0IiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtc29ydCBmYS13LTEwIiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyMCA1MTIiPjxwYXRoIGQ9Ik00MSAyODhoMjM4YzIxLjQgMCAzMi4xIDI1LjkgMTcgNDFMMTc3IDQ0OGMtOS40IDkuNC0yNC42IDkuNC0zMy45IDBMMjQgMzI5Yy0xNS4xLTE1LjEtNC40LTQxIDE3LTQxem0yNTUtMTA1TDE3NyA2NGMtOS40LTkuNC0yNC42LTkuNC0zMy45IDBMMjQgMTgzYy0xNS4xIDE1LjEtNC40IDQxIDE3IDQxaDIzOGMyMS40IDAgMzIuMS0yNS45IDE3LTQxeiI+PC9wYXRoPjwvc3ZnPgo="

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJzb3J0LXVwIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtc29ydC11cCBmYS13LTEwIiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyMCA1MTIiPjxwYXRoIGZpbGw9IiM4ZThlOGUiIGQ9Ik0yNzkgMjI0SDQxYy0yMS40IDAtMzIuMS0yNS45LTE3LTQxTDE0MyA2NGM5LjQtOS40IDI0LjYtOS40IDMzLjkgMGwxMTkgMTE5YzE1LjIgMTUuMSA0LjUgNDEtMTYuOSA0MXoiPjwvcGF0aD48L3N2Zz4K"

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJzb3J0LWRvd24iIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1zb3J0LWRvd24gZmEtdy0xMCIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48cGF0aCBmaWxsPSIjOGU4ZThlIiBkPSJNNDEgMjg4aDIzOGMyMS40IDAgMzIuMSAyNS45IDE3IDQxTDE3NyA0NDhjLTkuNCA5LjQtMjQuNiA5LjQtMzMuOSAwTDI0IDMyOWMtMTUuMS0xNS4xLTQuNC00MSAxNy00MXoiPjwvcGF0aD48L3N2Zz4K"

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  managerNav: [
  // '/manager/dashboard' --> dashboard for event manager
  {
    eventStatus: 'drafts',
    name: 'Drafts',
    url: '/manager/events',
    icon: 'file-text-o',
    lineColor: 'line-white',
    routeTitle: 'Drafts'
  }, {
    eventStatus: 'submitted',
    name: 'Submitted to',
    url: '/manager/events',
    icon: 'inbox',
    lineColor: 'line-blue',
    routeTitle: 'Submitted to ADURO',
    companyName: 'ADURO'
  }, {
    eventStatus: 'review',
    name: 'Needs Review',
    url: '/manager/events',
    icon: 'eye',
    lineColor: 'line-red',
    routeTitle: 'Needs Review'
  }, {
    eventStatus: 'approved',
    name: 'Approved',
    url: '/manager/events',
    icon: 'calendar-check-o',
    lineColor: 'line-green',
    routeTitle: 'Approved'
  }, {
    eventStatus: 'archived',
    name: 'Archived',
    url: '/manager/events',
    icon: 'archive',
    lineColor: 'line-brown',
    routeTitle: 'Archived'
  }],
  managerDashboardNav: [{
    text: 'Clients',
    viewName: 'ManagerDashboard',
    url: '/dashboard',
    active: false
  }, {
    text: 'Calendar',
    viewName: 'ManagerCalendar',
    url: '/calendar',
    active: false
  }, {
    text: 'Plan and Approve',
    viewName: 'PlanAndApprove',
    url: '/plan-and-approve',
    active: false
  }, {
    text: 'Manage',
    viewName: 'ManageApprovedDashboard',
    url: '/manage',
    active: false
  }, {
    text: 'Staff',
    viewName: 'StaffingSection',
    url: '/staffing',
    active: false
  }]
});

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeOrderDetail_vue__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79eb3b64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeOrderDetail_vue__ = __webpack_require__(1526);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeOrderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79eb3b64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeOrderDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalChangeOrderDetail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalChangeOrderDetail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-79eb3b64", Component.options)
  } else {
    hotAPI.reload("data-v-79eb3b64", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 259 */,
/* 260 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyNDwvdGl0bGU+PHBhdGggZD0iTTIwLDRIMTYuNVYzYS41LjUsMCwwLDAtMSwwVjRoLTdWM2EuNS41LDAsMCwwLTEsMFY0SDRBMiwyLDAsMCwwLDIsNlYxOGEyLDIsMCwwLDAsMiwySDIwYTIsMiwwLDAsMCwyLTJWNkEyLDIsMCwwLDAsMjAsNFpNNCw1SDcuNVY2YS41LjUsMCwwLDAsMSwwVjVoN1Y2YS41LjUsMCwwLDAsMSwwVjVIMjBhMSwxLDAsMCwxLDEsMVY3LjE1SDNWNkExLDEsMCwwLDEsNCw1Wk0yMCwxOUg0YTEsMSwwLDAsMS0xLTFWOC4xNUgyMVYxOEExLDEsMCwwLDEsMjAsMTlaIi8+PHBhdGggZD0iTTE0LjY1LDExLjY1LDExLjUsMTQuNzksOS44NSwxMy4xNWEuNDkuNDksMCwwLDAtLjcuN2wyLDJhLjQ5LjQ5LDAsMCwwLC4zNS4xNS40Ny40NywwLDAsMCwuMzUtLjE1bDMuNS0zLjVhLjQ5LjQ5LDAsMCwwLS43LS43WiIvPjwvc3ZnPgo="

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DtPaging_vue__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e9ccf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DtPaging_vue__ = __webpack_require__(1506);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1503)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DtPaging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e9ccf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DtPaging_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/DtPaging.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DtPaging.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17e9ccf1", Component.options)
  } else {
    hotAPI.reload("data-v-17e9ccf1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavIcons_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Switch_vue__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Navigator_vue__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchSession_vue__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ClientCardsManagement_vue__ = __webpack_require__(1578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */
/* unused harmony reexport SidebarNavIcons */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__Navigator_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__SearchSession_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__ClientCardsManagement_vue__["a"]; });














/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientDetailModal_vue__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0687cf26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PatientDetailModal_vue__ = __webpack_require__(1616);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1613)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0687cf26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientDetailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0687cf26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PatientDetailModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/patient/PatientDetailModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PatientDetailModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0687cf26", Component.options)
  } else {
    hotAPI.reload("data-v-0687cf26", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 264 */,
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  optSuccess: {
    icon: 'alert-icon-checked',
    backgroundColor: '#68B814',
    onClosed: function onClosed(instance, toast, closedBy) {}
  },
  optInfo: {
    icon: 'alert-icon-info',
    backgroundColor: '#00A4D6',
    onClosed: function onClosed(instance, toast, closedBy) {}
  },
  optWaring: {
    icon: 'alert-icon-warning',
    backgroundColor: '#FFA71B',
    onClosed: function onClosed(instance, toast, closedBy) {}
  },
  optError: {
    icon: 'alert-icon-error',
    backgroundColor: '#FF3400',
    onClosed: function onClosed(instance, toast, closedBy) {}
  }
});

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ACTION_UPDATE_MFA_STATUS: 'ACTION_UPDATE_MFA_STATUS',
  ACTION_UPDATE_MFA_CONFIRM: 'ACTION_UPDATE_MFA_CONFIRM',
  ACTION_SEND_MFA_CODE: 'ACTION_SEND_MFA_CODE',
  ACTION_REQUEST_NEW_CODE: 'ACTION_REQUEST_NEW_CODE',
  ACTION_CONFIRM_LOGIN_MFA: 'ACTION_CONFIRM_LOGIN_MFA',
  ACTION_SEND_NEW_CODE_MFA: 'ACTION_SEND_NEW_CODE_MFA',
  MUTATION_UPDATE_MFA_TYPE: 'MUTATION_UPDATE_MFA_TYPE',
  MUTATION_UPDATE_MFA_FLOW: 'MUTATION_UPDATE_MFA_FLOW',
  MUTATION_UPDATE_MFA_LOGIN: 'MUTATION_UPDATE_MFA_LOGIN',
  GETTER_MFA_DATA: 'GETTER_MFA_DATA',
  MUTATION_UPDATE_MFA_DATA: 'MUTATION_UPDATE_MFA_DATA'
});

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iNCIgZmlsbD0iI0ZGNDEyRCIvPgo8L3N2Zz4K"

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var customColorForUI = function customColorForUI() {
  var css = document.getElementById('customCSS');
  var updateCSS = !!css;
  if (!css) {
    css = document.createElement('style');
    css.setAttribute('id', 'customCSS');
  }
  css.type = 'text/css';
  var unavailable = '#c1c1ba';
  var config = JSON.parse(localStorage.getItem('SchedulerConfigurations'));
  var color = config && config.urlHyperlinkColor ? config.urlHyperlinkColor : '#9D001D';
  var hoverColor = config && config.urlHyperlinkColor ? config.urlHyperlinkColor : '#631412';
  css.innerHTML = '.scheduler-text-custom-color { color: ' + color + ' !important; } ' + ('.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label { color:  ' + color + ' !important; } ') + ('.scheduler-text-underline-custom-color { border-color: ' + color + ' !important; } ') + ('.scheduler-button-custom-color {background-color: ' + color + ' !important; border-color: ' + color + ' !important;} ') + ('.scheduler-button-custom-color:hover {background-color: ' + hoverColor + ' !important; } ') + ('.scheduler-button-custom-color.secondary-custom { background-color: #fff !important; color: ' + color + ' !important; border-color: ' + color + ' !important; }') + ('.scheduler-button-custom-color.scheduler-button-custom-color-for-time-slot:focus{background-color: #fff !important; border-color: ' + color + ' !important; color: ' + color + ' !important; }') + ('.scheduler-button-custom-color.secondary-custom:hover{background-color: ' + color + ' !important; border-color: ' + color + ' !important; color: #fff !important; }') + ('.scheduler-button-custom-color.unavailable-custom {background-color: ' + unavailable + ' !important; border-color: ' + unavailable + ' !important;}') + ('.scheduler-button-custom-color.secondary-2-custom { background-color: #fff !important; color: ' + color + ' !important; border-color: ' + color + ' !important; }') + ('.scheduler-checkbox-group-custom .custom-control-input:checked ~ .custom-control-label:before { background-color: ' + color + ' !important; border-color: ' + color + ' !important }') + ('#Embed { background: ' + color + ' !important; background-color: ' + color + ' !important;}');
  if (!updateCSS) {
    document.body.appendChild(css);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  customColorForUI: customColorForUI
});

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'TOTAL DRAFTS',
    description: 'Drafts that need to be submitted or deleted.',
    url: '/user/drafts',
    color: '#BBB4AB',
    eventStatus: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.drafts
  }, {
    name: 'TOTAL SUBMITTED TO ADURO',
    url: '/user/submitted',
    description: 'Events waiting for approval from ADURO.',
    color: '#4A90E2',
    eventStatus: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.submitted
  }, {
    name: 'TOTAL EVENTS TO REVIEW',
    url: '/user/review',
    description: 'Drafts that need to be reviewed by you.',
    color: '#A42022',
    eventStatus: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.review
  }, {
    name: 'TOTAL APPROVED EVENTS',
    url: '/user/approved',
    description: 'Events that have been approved and scheduled.',
    color: '#417505',
    eventStatus: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.approved
  }, {
    name: 'TOTAL ARCHIVED EVENTS',
    url: '/user/archived',
    description: 'Events that have been approved and scheduled.',
    color: '#463E38',
    eventStatus: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.archived
  }]
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator__);


var validator = {
  isValidEmail: function isValidEmail(email) {
    return __WEBPACK_IMPORTED_MODULE_0_validator___default.a.isEmail(email);
  },
  isUSPhoneNumber: function isUSPhoneNumber(phone) {
    if (!phone) {
      return false;
    }
    var plus = '+';
    var phoneFormatted = phone.replace(/[^0-9]/g, '');
    phoneFormatted = plus.concat(phoneFormatted);
    return __WEBPACK_IMPORTED_MODULE_0_validator___default.a.isMobilePhone(phoneFormatted, ['en-US']);
  },
  validateAge: function validateAge(age, dateStr) {
    if (!dateStr || dateStr.length !== 10) {
      // MM/DD/YYYY
      return false;
    }
    var date = new Date(dateStr);
    if (date) {
      var currentAge = new Date().getYear() - date.getYear();
      return currentAge > age;
    }
    return false;
  },
  isPasswordValid: function isPasswordValid(password) {
    var rulesCheck = {
      lowerCaseChars: [],
      upperCaseChars: [],
      numbers: []
    };
    for (var i = 0; i < password.length; i++) {
      var chrCode = password.charCodeAt(i);
      if (chrCode > 64 && chrCode < 91) {
        rulesCheck.upperCaseChars.push(password[i]);
      }
      if (chrCode > 96 && chrCode < 123) {
        rulesCheck.lowerCaseChars.push(password[i]);
      }
      if (chrCode > 47 && chrCode < 58) {
        rulesCheck.numbers.push(password[i]);
      }
    }
    var summary = rulesCheck.lowerCaseChars.length >= 4 && rulesCheck.upperCaseChars.length >= 1 && rulesCheck.numbers.length >= 2 && validator.isHasSpecialCase(password) && password.length >= 8;
    var result = {
      summary: summary,
      detail: {
        length: password.length >= 8,
        lowerCaseChars: rulesCheck.lowerCaseChars.length >= 4,
        upperCaseChars: rulesCheck.upperCaseChars.length >= 1,
        numbers: rulesCheck.numbers.length >= 2,
        specialChars: validator.isHasSpecialCase(password)
      }
    };
    return result;
  },
  isHasSpecialCase: function isHasSpecialCase(password) {
    var specialChars = '<>@!#$%^&*()_+[]{}?:;|\'"\\,./~`-=';
    for (var i = 0; i < specialChars.length; i++) {
      if (password.indexOf(specialChars[i]) > -1) {
        return true;
      }
    }
    return false;
  },
  isValidUrl: function isValidUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_0_validator___default.a.isURL(url);
  },
  isValidImageUrl: function isValidImageUrl(url) {
    return url.match(/\.(jpeg|jpg|gif|png)$/) != null || url.indexOf('data:image') > -1;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (validator);

/***/ }),
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqModal_vue__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0496e3c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FaqModal_vue__ = __webpack_require__(1439);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1436)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0496e3c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0496e3c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FaqModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/FaqModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FaqModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0496e3c3", Component.options)
  } else {
    hotAPI.reload("data-v-0496e3c3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */
/***/ (function(module, exports) {

module.exports = {
  '#': { pattern: /\d/ },
  'X': { pattern: /[0-9a-zA-Z]/ },
  'S': { pattern: /[a-zA-Z]/ },
  'A': { pattern: /[a-zA-Z]/, transform: function transform(v) {
      return v.toLocaleUpperCase();
    } },
  'a': { pattern: /[a-zA-Z]/, transform: function transform(v) {
      return v.toLocaleLowerCase();
    } },
  '!': { escape: true }
};

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjA2MDYwIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyNDwvdGl0bGU+PHBhdGggZD0iTTIwLDRIMTYuNVYzYS41LjUsMCwwLDAtMSwwVjRoLTdWM2EuNS41LDAsMCwwLTEsMFY0SDRBMiwyLDAsMCwwLDIsNlYxOGEyLDIsMCwwLDAsMiwySDIwYTIsMiwwLDAsMCwyLTJWNkEyLDIsMCwwLDAsMjAsNFpNNCw1SDcuNVY2YS41LjUsMCwwLDAsMSwwVjVoN1Y2YS41LjUsMCwwLDAsMSwwVjVIMjBhMSwxLDAsMCwxLDEsMVY3LjE1SDNWNkExLDEsMCwwLDEsNCw1Wk0yMCwxOUg0YTEsMSwwLDAsMS0xLTFWOC4xNUgyMVYxOEExLDEsMCwwLDEsMjAsMTlaIi8+PHBhdGggZD0iTTE0LjY1LDExLjY1LDExLjUsMTQuNzksOS44NSwxMy4xNWEuNDkuNDksMCwwLDAtLjcuN2wyLDJhLjQ5LjQ5LDAsMCwwLC4zNS4xNS40Ny40NywwLDAsMCwuMzUtLjE1bDMuNS0zLjVhLjQ5LjQ5LDAsMCwwLS43LS43WiIvPjwvc3ZnPgo="

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmJhY2t3YXJkLWxpbmU8L3RpdGxlPjxwYXRoIGQ9Ik0xNSwyMGEuNDguNDgsMCwwLDEtLjM0LS4xM2wtOC03LjVhLjUxLjUxLDAsMCwxLDAtLjc0bDgtNy41YS41LjUsMCwwLDEsLjY4Ljc0TDcuNzMsMTJsNy42MSw3LjEzYS41MS41MSwwLDAsMSwwLC43MUEuNS41LDAsMCwxLDE1LDIwWiIvPjwvc3ZnPg=="

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmZvcndhcmQtbGluZTwvdGl0bGU+PHBhdGggZD0iTTksMjBhLjUuNSwwLDAsMS0uMzctLjE2LjUxLjUxLDAsMCwxLDAtLjcxTDE2LjI3LDEyLDguNjYsNC44N2EuNS41LDAsMCwxLC42OC0uNzRsOCw3LjVhLjUxLjUxLDAsMCwxLDAsLjc0bC04LDcuNUEuNDguNDgsMCwwLDEsOSwyMFoiLz48L3N2Zz4="

/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f55ba174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(1523);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1520)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f55ba174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-dropdowns/Dropdown.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dropdown.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f55ba174", Component.options)
  } else {
    hotAPI.reload("data-v-f55ba174", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalInfo_vue__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e88dc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalInfo_vue__ = __webpack_require__(1530);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1527)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e88dc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalInfo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05e88dc2", Component.options)
  } else {
    hotAPI.reload("data-v-05e88dc2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomMessageModal_vue__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cf7a83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomMessageModal_vue__ = __webpack_require__(1659);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomMessageModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cf7a83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomMessageModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/CustomMessageModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CustomMessageModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42cf7a83", Component.options)
  } else {
    hotAPI.reload("data-v-42cf7a83", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffManagement_vue__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e80233_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffManagement_vue__ = __webpack_require__(1625);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1622)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55e80233"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e80233_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/eventDetail/StaffManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StaffManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55e80233", Component.options)
  } else {
    hotAPI.reload("data-v-55e80233", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
// type 1 is Number, 2 is Date, 0 is String
// type 3 is hour

var sortFunction = function sortFunction(field) {
  var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  reverse = !reverse ? 1 : -1;
  return function (el1, el2) {
    var a = el1[field];
    var b = el2[field];
    if (type === 2) {
      a = new Date(a);
      b = new Date(b);
    }
    if (type === 0) {
      a = a ? a.toString().toLowerCase() : '';
      b = b ? b.toString().toLowerCase() : '';
    }

    function getMomentObject(str) {
      var listStr = str.toString().split(/[\s:]/);
      var minute = Number(listStr[1]);
      var hour = Number(listStr[0]);
      var hourType = listStr[2];
      hour = hourType === 'AM' ? hour : hour + 12;
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()({ h: hour, m: minute });
    }

    if (type === 3) {
      a = getMomentObject(a);
      b = getMomentObject(b);
    }
    return reverse * ((a > b) - (b > a));
  };
};

// Return: 1 is Number, 2 is Date, 0 is String, 3 is Time
var getMappingObjectType = function getMappingObjectType(fieldName) {
  var mappingObj = {
    fullName: 0,
    firstName: 0,
    lastName: 0,
    cardCode: 0,
    email: 0,
    prefDate: 2,
    timeSlot: 3,
    startTime: 3,
    endTime: 3,
    phone: 0,
    agency: 1,
    role: 0,
    name: 0,
    screeningTime: 3,
    mileageRate: 1,
    internalName: 2
  };
  return mappingObj[fieldName] ? mappingObj[fieldName] : 0;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  sortFunction: sortFunction,
  getMappingObjectType: getMappingObjectType
});

/***/ }),
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ae53c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__ = __webpack_require__(1755);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1752)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47ae53c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ae53c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/manage/EventCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47ae53c8", Component.options)
  } else {
    hotAPI.reload("data-v-47ae53c8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZmlsbD0iIzAwQTRENiIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNvcnQ8L3RpdGxlPjxwYXRoIGQ9Ik03Ljg1LDQuMTVhLjQ4LjQ4LDAsMCwwLS43LDBsLTMsM2EuNDkuNDksMCwwLDAsLjcuN0w3LDUuNzFWMTkuNWEuNS41LDAsMCwwLDEsMFY1LjcxbDIuMTUsMi4xNGEuNDguNDgsMCwwLDAsLjcsMCwuNDguNDgsMCwwLDAsMC0uN1oiLz48cGF0aCBkPSJNMTkuODUsMTYuMjFhLjQ4LjQ4LDAsMCwwLS43LDBMMTcsMTguMzVWNC41YS41LjUsMCwwLDAtMSwwVjE4LjM1bC0yLjE1LTIuMTRhLjQ5LjQ5LDAsMCwwLS43LjdsMywzYS40OC40OCwwLDAsMCwuNywwbDMtM0EuNDguNDgsMCwwLDAsMTkuODUsMTYuMjFaIi8+PC9zdmc+Cg=="

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginHeader_vue__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e30d620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LoginHeader_vue__ = __webpack_require__(1849);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1846)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e30d620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LoginHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/login/LoginHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoginHeader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e30d620", Component.options)
  } else {
    hotAPI.reload("data-v-3e30d620", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AUTHORIZE_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_USER_IF_NOT_EXIST; });
var AUTHORIZE_USER = 'AUTHORIZE_USER';
var CREATE_USER_IF_NOT_EXIST = 'CREATE_USER_IF_NOT_EXIST';

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashCards_vue__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22bba277_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DashCards_vue__ = __webpack_require__(1280);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1277)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22bba277"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22bba277_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DashCards_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DashCards.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DashCards.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22bba277", Component.options)
  } else {
    hotAPI.reload("data-v-22bba277", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalInfoBody_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb61a61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalInfoBody_vue__ = __webpack_require__(1419);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1416)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalInfoBody_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb61a61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalInfoBody_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalInfoBody.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalInfoBody.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3fb61a61", Component.options)
  } else {
    hotAPI.reload("data-v-3fb61a61", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryModal_vue__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c76d03f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryModal_vue__ = __webpack_require__(1457);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1445)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c76d03f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/HistoryModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HistoryModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c76d03f6", Component.options)
  } else {
    hotAPI.reload("data-v-c76d03f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTableRow_vue__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb6fa2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTableRow_vue__ = __webpack_require__(1475);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1463)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTableRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb6fa2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTableRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/DataTableRow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DataTableRow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6bb6fa2b", Component.options)
  } else {
    hotAPI.reload("data-v-6bb6fa2b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowStatus_vue__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_838bd2f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RowStatus_vue__ = __webpack_require__(1469);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1466)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_838bd2f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RowStatus_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/RowStatus.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RowStatus.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-838bd2f2", Component.options)
  } else {
    hotAPI.reload("data-v-838bd2f2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__masker__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tokens__);



// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event(name) {
  var evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}

/* harmony default export */ __webpack_exports__["a"] = (function (el, binding) {
  var config = binding.value;
  if (Array.isArray(config) || typeof config === 'string') {
    config = {
      mask: config,
      tokens: __WEBPACK_IMPORTED_MODULE_1__tokens___default.a
    };
  }

  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      throw new Error('v-mask directive requires 1 input, found ' + els.length);
    } else {
      el = els[0];
    }
  }

  el.oninput = function (evt) {
    if (!evt.isTrusted) return; // avoid infinite loop
    /* other properties to try to diferentiate InputEvent of Event (custom)
    InputEvent (native)
      cancelable: false
      isTrusted: true
       composed: true
      isComposing: false
      which: 0
     Event (custom)
      cancelable: true
      isTrusted: false
    */
    // by default, keep cursor at same position as before the mask
    var position = el.selectionEnd;
    // save the character just inserted
    var digit = el.value[position - 1];
    el.value = Object(__WEBPACK_IMPORTED_MODULE_0__masker__["a" /* default */])(el.value, config.mask, true, config.tokens);
    // if the digit was changed, increment position until find the digit again
    while (position < el.value.length && el.value.charAt(position - 1) !== digit) {
      position++;
    }
    if (el === document.activeElement) {
      el.setSelectionRange(position, position);
      setTimeout(function () {
        el.setSelectionRange(position, position);
      }, 0);
    }
    el.dispatchEvent(event('input'));
  };

  var newDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__masker__["a" /* default */])(el.value, config.mask, true, config.tokens);
  if (newDisplay !== el.value) {
    el.value = newDisplay;
    el.dispatchEvent(event('input'));
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maskit__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dynamic_mask__ = __webpack_require__(1471);


// Facade to maskit/dynamicMask when mask is String or Array
/* harmony default export */ __webpack_exports__["a"] = (function (value, mask) {
  var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var tokens = arguments[3];

  return Array.isArray(mask) ? Object(__WEBPACK_IMPORTED_MODULE_1__dynamic_mask__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__maskit__["a" /* default */], mask, tokens)(value, mask, masked, tokens) : Object(__WEBPACK_IMPORTED_MODULE_0__maskit__["a" /* default */])(value, mask, masked, tokens);
});

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMTwvdGl0bGU+PHBhdGggZD0iTTcuNSwxMGEuNS41LDAsMCwwLC41LjVoOGEuNS41LDAsMCwwLDAtMUg4QS41LjUsMCwwLDAsNy41LDEwWiIvPjxwYXRoIGQ9Ik0xOS40MSw1LjQxLDE2LjU5LDIuNTlBMiwyLDAsMCwwLDE1LjE3LDJINkEyLDIsMCwwLDAsNCw0VjIwYTIsMiwwLDAsMCwyLDJIMThhMiwyLDAsMCwwLDItMlY2LjgzQTIsMiwwLDAsMCwxOS40MSw1LjQxWm0tLjcuNzFhMSwxLDAsMCwxLC4yMy4zOEgxNmEuNS41LDAsMCwxLS41LS41VjMuMDZhMSwxLDAsMCwxLC4zOC4yM1pNMTksMjBhMSwxLDAsMCwxLTEsMUg2YTEsMSwwLDAsMS0xLTFWNEExLDEsMCwwLDEsNiwzaDguNVY2QTEuNSwxLjUsMCwwLDAsMTYsNy41aDNaIi8+PHBhdGggZD0iTTE2LDEzLjVIOGEuNS41LDAsMCwwLDAsMWg4YS41LjUsMCwwLDAsMC0xWiIvPjxwYXRoIGQ9Ik0xNiwxNy41SDhhLjUuNSwwLDAsMCwwLDFoOGEuNS41LDAsMCwwLDAtMVoiLz48L3N2Zz4="

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMjwvdGl0bGU+PHBhdGggZD0iTTE2LjUsMTBhLjUuNSwwLDAsMC0uNS0uNUg4YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWg4QS41LjUsMCwwLDAsMTYuNSwxMFoiLz48cGF0aCBkPSJNMTIuNSwyMUg2LjM4QTEuMzksMS4zOSwwLDAsMSw1LDE5LjY0VjQuNDRBMS4zOSwxLjM5LDAsMCwxLDYuMzgsM0gxNC41VjZBMS41LDEuNSwwLDAsMCwxNiw3LjU0aDN2My44OGEuNS41LDAsMSwwLDEsMFY3LjEzYTIuNDUsMi40NSwwLDAsMC0uNjktMS43TDE2LjY2LDIuNzVBMi4zNCwyLjM0LDAsMCwwLDE1LDJINi4zOEEyLjQsMi40LDAsMCwwLDQsNC40NHYxNS4yQTIuMzksMi4zOSwwLDAsMCw2LjM4LDIySDEyLjVhLjUuNSwwLDAsMCwuNS0uNUEuNTEuNTEsMCwwLDAsMTIuNSwyMVptNi4wOS0xNC45YTEuMDksMS4wOSwwLDAsMSwuMjcuNEgxNmEuNS41LDAsMCwxLS41LS41VjMuMTVhMS40MywxLjQzLDAsMCwxLC40NC4zWiIvPjxwYXRoIGQ9Ik0xMywxNGEuNS41LDAsMCwwLS41LS41SDhhLjUuNSwwLDAsMC0uNS41LjUuNSwwLDAsMCwuNS41aDQuNUEuNS41LDAsMCwwLDEzLDE0WiIvPjxwYXRoIGQ9Ik04LDE3LjU0YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWgzLjVBLjUuNSwwLDAsMCwxMiwxOGEuNS41LDAsMCwwLS41LS41WiIvPjxwYXRoIGQ9Ik0xOCwxM2E1LDUsMCwxLDAsNSw1QTUsNSwwLDAsMCwxOCwxM1ptMCw5YTQsNCwwLDEsMSw0LTRBNCw0LDAsMCwxLDE4LDIyWiIvPjxwYXRoIGQ9Ik0yMS4zNSwxNi42OWEuNDguNDgsMCwwLDAtLjcsMEwxNy41LDE5LjgzbC0xLjY1LTEuNjRhLjQ4LjQ4LDAsMCwwLS43LDAsLjUuNSwwLDAsMCwwLC43MWwyLDJhLjUxLjUxLDAsMCwwLC43LDBsMy41LTMuNUEuNS41LDAsMCwwLDIxLjM1LDE2LjY5WiIvPjwvc3ZnPg=="

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMzwvdGl0bGU+PHBhdGggZD0iTTE2LjUsMTBhLjUuNSwwLDAsMC0uNS0uNUg4YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWg4QS41LjUsMCwwLDAsMTYuNSwxMFoiLz48cGF0aCBkPSJNMTIuNSwyMUg2LjM4QTEuMzksMS4zOSwwLDAsMSw1LDE5LjY0VjQuNDRBMS4zOSwxLjM5LDAsMCwxLDYuMzgsM0gxNC41VjZBMS41LDEuNSwwLDAsMCwxNiw3LjU0aDN2My44OGEuNS41LDAsMSwwLDEsMFY3LjEzYTIuNDUsMi40NSwwLDAsMC0uNjktMS43TDE2LjY1LDIuNzVBMi4zLDIuMywwLDAsMCwxNSwySDYuMzhBMi40LDIuNCwwLDAsMCw0LDQuNDR2MTUuMkEyLjQsMi40LDAsMCwwLDYuMzgsMjJIMTIuNWEuNS41LDAsMCwwLC41LS41QS41MS41MSwwLDAsMCwxMi41LDIxWm02LjA5LTE0LjlhMS4yMywxLjIzLDAsMCwxLC4yNy40SDE2YS41LjUsMCwwLDEtLjUtLjVWMy4xNWExLjQzLDEuNDMsMCwwLDEsLjQ0LjNaIi8+PHBhdGggZD0iTTEzLDE0YS41LjUsMCwwLDAtLjUtLjVIOGEuNS41LDAsMCwwLS41LjUuNS41LDAsMCwwLC41LjVoNC41QS41LjUsMCwwLDAsMTMsMTRaIi8+PHBhdGggZD0iTTgsMTcuNTRhLjUuNSwwLDAsMC0uNS41LjUuNSwwLDAsMCwuNS41aDMuNUEuNS41LDAsMCwwLDEyLDE4YS41LjUsMCwwLDAtLjUtLjVaIi8+PHBhdGggZD0iTTE4LDEzYTUsNSwwLDEsMCw1LDVBNSw1LDAsMCwwLDE4LDEzWm0wLDlhNCw0LDAsMSwxLDQtNEE0LDQsMCwwLDEsMTgsMjJaIi8+PHBhdGggZD0iTTE5LjA1LDE1LjI5YTIuMjksMi4yOSwwLDAsMC0xLS4yMSwyLjI1LDIuMjUsMCwwLDAtMS4wNy4yNSwxLjg4LDEuODgsMCwwLDAtLjcuNjMsMS40MiwxLjQyLDAsMCwwLS4yMy43Ni40Ni40NiwwLDAsMCwuMTUuMzMuNS41LDAsMCwwLC4zNy4xNWMuMjQsMCwuNDEtLjE0LjUtLjQ0YTEuODIsMS44MiwwLDAsMSwuMzQtLjY0Ljg3Ljg3LDAsMCwxLC42NC0uMjEuODguODgsMCwwLDEsLjYuMjEuNzIuNzIsMCwwLDEsLjIzLjUzLjYxLjYxLDAsMCwxLS4wOC4zLjg4Ljg4LDAsMCwxLS4xOS4yNCwzLjMxLDMuMzEsMCwwLDEtLjM2LjMzYy0uMTkuMTctLjM0LjMyLS40NS40NGExLjUxLDEuNTEsMCwwLDAtLjI3LjQyLDEuNDIsMS40MiwwLDAsMC0uMS41Ny40OS40OSwwLDAsMCwuMTQuMzkuNDUuNDUsMCwwLDAsLjM0LjEzLjQzLjQzLDAsMCwwLC40Ni0uNCwyLjM4LDIuMzgsMCwwLDEsLjA3LS4yNy40Ny40NywwLDAsMSwuMDYtLjE1Ljc3Ljc3LDAsMCwxLC4xMi0uMTdsLjIxLS4yMS42Ny0uNjFhMi4wNywyLjA3LDAsMCwwLC4zMi0uNDQsMS4xOCwxLjE4LDAsMCwwLC4xMy0uNTgsMS40NSwxLjQ1LDAsMCwwLS4yMy0uNzhBMS43LDEuNywwLDAsMCwxOS4wNSwxNS4yOVoiLz48cGF0aCBkPSJNMTgsMTkuODNhLjU3LjU3LDAsMCwwLS40Mi4xNy41Ny41NywwLDAsMC0uMTcuNDEuNTIuNTIsMCwwLDAsLjE4LjQzQS41Ni41NiwwLDAsMCwxOCwyMWEuNTcuNTcsMCwwLDAsLjQxLS4xNi41My41MywwLDAsMCwuMTctLjQzLjU2LjU2LDAsMCwwLS4xNi0uNDFBLjU5LjU5LDAsMCwwLDE4LDE5LjgzWiIvPjwvc3ZnPg=="

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyNTwvdGl0bGU+PHBhdGggZD0iTTIwLjE0LDNIMy44NkExLjg2LDEuODYsMCwwLDAsMiw0Ljg2VjcuMTRBMS44NSwxLjg1LDAsMCwwLDMsOC43OFYxOS4yMkExLjc4LDEuNzgsMCwwLDAsNC43OCwyMUgxOS4yMkExLjc4LDEuNzgsMCwwLDAsMjEsMTkuMjJWOC43OGExLjg1LDEuODUsMCwwLDAsMS0xLjY0VjQuODZBMS44NiwxLjg2LDAsMCwwLDIwLjE0LDNabS0uOTIsMTdINC43OEEuNzguNzgsMCwwLDEsNCwxOS4yMlY5SDIwVjE5LjIyQS43OC43OCwwLDAsMSwxOS4yMiwyMFpNMjEsNy4xNGEuODUuODUsMCwwLDEtLjg2Ljg2SDMuODZBLjg1Ljg1LDAsMCwxLDMsNy4xNFY0Ljg2QS44NS44NSwwLDAsMSwzLjg2LDRIMjAuMTRhLjg1Ljg1LDAsMCwxLC44Ni44NloiLz48cGF0aCBkPSJNMTUsMTFIOWEuNS41LDAsMCwxLDAtMWg2YS41LjUsMCwwLDEsMCwxWiIvPjwvc3ZnPg=="

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHRpdGxlPmNvcHlfZXhwb3J0PC90aXRsZT4KPHBhdGggZD0iTTE4LjcsNGgtOC4zQzkuNyw0LDkuMiw0LjQsOS4xLDVoOS42QzE4LjgsNSwxOSw1LjEsMTksNS4zYzAsMCwwLDAsMCwwdjExLjRjMCwwLjItMC4xLDAuMy0xLjMsMC4zSDE2djFoMS43CgljMC44LDAsMi4zLDAsMi4zLTEuM1Y1LjNDMjAsNC42LDE5LjQsNCwxOC43LDRDMTguNyw0LDE4LjcsNCwxOC43LDR6Ii8+CjxwYXRoIGQ9Ik0xMy43LDdDMTMuOCw3LDE0LDcuMSwxNCw3LjNjMCwwLDAsMCwwLDB2MTEuNGMwLDAuMi0wLjEsMC4zLTAuMywwLjNINS4zQzUuMSwxOSw1LDE4LjksNSwxOC43VjcuM0M1LDcuMiw1LjEsNyw1LjMsNwoJYzAsMCwwLDAsMCwwSDEzLjcgTTEzLjcsNkg1LjNDNC42LDYsNCw2LjYsNCw3LjNjMCwwLDAsMCwwLDB2MTEuNEM0LDE5LjQsNC42LDIwLDUuMywyMGg4LjNjMC43LDAsMS4zLTAuNiwxLjMtMS4zVjcuMwoJQzE1LDYuNiwxNC40LDYsMTMuNyw2QzEzLjcsNiwxMy43LDYsMTMuNyw2eiIvPgo8cGF0aCBkPSJNMTIuNSwxMGgtNkM2LjIsMTAsNiw5LjgsNiw5LjVTNi4yLDksNi41LDloNkMxMi44LDksMTMsOS4yLDEzLDkuNVMxMi44LDEwLDEyLjUsMTB6Ii8+CjxwYXRoIGQ9Ik0xMi41LDEzaC02QzYuMiwxMyw2LDEyLjgsNiwxMi41UzYuMiwxMiw2LjUsMTJoNmMwLjMsMCwwLjUsMC4yLDAuNSwwLjVTMTIuOCwxMywxMi41LDEzeiIvPgo8cGF0aCBkPSJNMTAuNSwxNmgtNEM2LjIsMTYsNiwxNS44LDYsMTUuNVM2LjIsMTUsNi41LDE1aDRjMC4zLDAsMC41LDAuMiwwLjUsMC41UzEwLjgsMTYsMTAuNSwxNnoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHRpdGxlPnRyYXNoX2V4cG9ydDwvdGl0bGU+CjxwYXRoIGQ9Ik0xOC41LDZIMTVWNC41QzE1LDQuMiwxNC44LDQsMTQuNSw0aC01QzkuMiw0LDksNC4yLDksNC41VjZINS41QzUuMiw2LjEsNSw2LjMsNS4xLDYuNkM1LjEsNi44LDUuMyw3LDUuNSw3SDYKCWMwLDAsMCwwLDAsMC4xbDEsMTJDNywxOS42LDcuNSwyMCw4LDIwaDhjMC41LDAsMS0wLjQsMS0wLjlsMS0xMmMwLDAsMCwwLDAtMC4xaDAuNWMwLjMsMC4xLDAuNS0wLjEsMC42LTAuNAoJQzE5LjIsNi4zLDE5LDYuMSwxOC43LDZDMTguNiw2LDE4LjYsNiwxOC41LDZMMTguNSw2eiBNMTAsNWg0djFoLTRWNXogTTE2LDE5SDhMNyw3aDEwTDE2LDE5eiIvPgo8L3N2Zz4K"

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmV4cG9ydDwvdGl0bGU+PHBhdGggZD0iTTE3LjUsMTYuNWEuNDcuNDcsMCwwLDEtLjM1LS4xNS40OC40OCwwLDAsMSwwLS43TDIwLjc5LDEyLDE3LjE1LDguMzVhLjQ5LjQ5LDAsMCwxLC43LS43bDQsNGEuNDguNDgsMCwwLDEsMCwuN2wtNCw0QS40Ny40NywwLDAsMSwxNy41LDE2LjVaIi8+PHBhdGggZD0iTTIxLDEyLjVIOWEuNS41LDAsMCwxLDAtMUgyMWEuNS41LDAsMCwxLDAsMVoiLz48cGF0aCBkPSJNMTAuNSwyMkgzYTEsMSwwLDAsMS0xLTFWM0ExLDEsMCwwLDEsMywyaDcuNWEuNS41LDAsMCwxLDAsMUgzVjIxaDcuNWEuNS41LDAsMCwxLDAsMVoiLz48L3N2Zz4="

/***/ }),
/* 809 */,
/* 810 */,
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTableGroupBtn_vue__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6849885c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTableGroupBtn_vue__ = __webpack_require__(1491);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1488)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTableGroupBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6849885c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTableGroupBtn_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/DataTableGroupBtn.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DataTableGroupBtn.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6849885c", Component.options)
  } else {
    hotAPI.reload("data-v-6849885c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 812 */,
/* 813 */,
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavIcons_vue__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfa3c92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavIcons_vue__ = __webpack_require__(1560);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1556)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bfa3c92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavIcons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bfa3c92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavIcons_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/SidebarNavIcons.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarNavIcons.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7bfa3c92", Component.options)
  } else {
    hotAPI.reload("data-v-7bfa3c92", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 815 */,
/* 816 */,
/* 817 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZmlsbD0iI2YwMCIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnN0YXR1cy1lcnJvci1vY3RhZ29uLW91dGxpbmU8L3RpdGxlPjxwYXRoIGQ9Ik0xNS43MywzLDIxLDguMjd2Ny40NkwxNS43MywyMUg4LjI3TDMsMTUuNzNWOC4yN0w4LjI3LDNoNy40Nm0uNDEtMUg3Ljg2TDIsNy44NnY4LjI4TDcuODYsMjJoOC4yOEwyMiwxNi4xNFY3Ljg2TDE2LjE0LDJaIi8+PHBhdGggZD0iTTExLjUsNy41djZhLjUuNSwwLDAsMCwxLDB2LTZhLjUuNSwwLDAsMC0xLDAiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjE2LjI1IiByPSIwLjc1Ii8+PC9zdmc+Cg=="

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4wNCAyNCI+PHRpdGxlPnVwLW88L3RpdGxlPjxwYXRoIGQ9Ik0xMiwzYTksOSwwLDEsMS05LDksOSw5LDAsMCwxLDktOW0wLTFBMTAsMTAsMCwxLDAsMjIsMTIsMTAsMTAsMCwwLDAsMTIsMloiLz48cGF0aCBkPSJNMTYsMTMuNWEuNTEuNTEsMCwwLDEtLjM2LS4xNUwxMiw5LjcxLDguMzcsMTMuMzVhLjUuNSwwLDAsMS0uNzEsMCwuNS41LDAsMCwxLDAtLjdsNC00YS41LjUsMCwwLDEsLjcxLDBsNCw0YS41LjUsMCwwLDEtLjM1Ljg1WiIvPjwvc3ZnPg=="

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreview_vue__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc93c00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreview_vue__ = __webpack_require__(1651);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1631)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc93c00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc93c00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreview_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/preview/SchedulerPreview.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SchedulerPreview.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5cc93c00", Component.options)
  } else {
    hotAPI.reload("data-v-5cc93c00", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c874b6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__ = __webpack_require__(1655);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1652)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c874b6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c874b6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Popup.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Popup.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c874b6a", Component.options)
  } else {
    hotAPI.reload("data-v-2c874b6a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeToggleVaccines_vue__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cca9f9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeToggleVaccines_vue__ = __webpack_require__(1658);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeToggleVaccines_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cca9f9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeToggleVaccines_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalChangeToggleVaccines.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalChangeToggleVaccines.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cca9f9da", Component.options)
  } else {
    hotAPI.reload("data-v-cca9f9da", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNC4wNCI+PHRpdGxlPm1haWw8L3RpdGxlPjxwYXRoIGQ9Ik0yMC41LDVhLjQ5LjQ5LDAsMCwxLC41LjQ5djEzYS41LjUsMCwwLDEtLjUuNUgzLjVhLjUuNSwwLDAsMS0uNS0uNXYtMTNBLjQ5LjQ5LDAsMCwxLDMuNSw1aDE3bTAtMUgzLjVBMS41LDEuNSwwLDAsMCwyLDUuNTF2MTNBMS41LDEuNSwwLDAsMCwzLjUsMjBoMTdhMS41LDEuNSwwLDAsMCwxLjUtMS41di0xM0ExLjUsMS41LDAsMCwwLDIwLjUsNFoiLz48cGF0aCBkPSJNMjAuNSw1YS41LjUsMCwwLDEsLjUuNVY5bC04LjgsMy45MWEuNTIuNTIsMCwwLDEtLjQsMEwzLDlWNS41MkEuNS41LDAsMCwxLDMuNSw1aDE3bTAtMUgzLjVBMS41LDEuNSwwLDAsMCwyLDUuNTJWOS42N2wuNTkuMjYsOC44LDMuOTFhMS41LDEuNSwwLDAsMCwxLjIyLDBsOC44LTMuOTFMMjIsOS42N1Y1LjUyQTEuNSwxLjUsMCwwLDAsMjAuNSw0WiIvPjwvc3ZnPg=="

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRelatedEvents_vue__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65072ff3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRelatedEvents_vue__ = __webpack_require__(1668);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRelatedEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65072ff3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRelatedEvents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/events/ManageRelatedEvents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManageRelatedEvents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65072ff3", Component.options)
  } else {
    hotAPI.reload("data-v-65072ff3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ACTION_RESEND_EMAIL: 'ACTION_RESEND_EMAIL'
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  statusCodes: {
    NOT_FOUND: 'NOT_FOUND',
    OK: 'OK'
  },
  store: {
    SETTING: 'setting',
    CLIENTS: 'clients',
    EVENTS: 'events',
    EMAIL_HISTORY: 'emailHistory'
  }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderColumn_vue__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bd26b18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderColumn_vue__ = __webpack_require__(1720);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bd26b18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderColumn_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/HeaderColumn.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HeaderColumn.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8bd26b18", Component.options)
  } else {
    hotAPI.reload("data-v-8bd26b18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  INIT: 0,
  LOADING: 1,
  LOADED: 2
});

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPm1vcmU8L3RpdGxlPjxjaXJjbGUgY3g9IjYiIGN5PSIxMiIgcj0iMiIvPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjIiLz48Y2lyY2xlIGN4PSIxOCIgY3k9IjEyIiByPSIyIi8+PC9zdmc+"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZmlsbD0iIzJGQkVGRiIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPm1vcmU8L3RpdGxlPjxjaXJjbGUgY3g9IjYiIGN5PSIxMiIgcj0iMiIvPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjIiLz48Y2lyY2xlIGN4PSIxOCIgY3k9IjEyIiByPSIyIi8+PC9zdmc+Cg=="

/***/ }),
/* 830 */,
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableHeader_vue__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d3a054_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableHeader_vue__ = __webpack_require__(1770);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1767)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d3a054_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/TableHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TableHeader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f9d3a054", Component.options)
  } else {
    hotAPI.reload("data-v-f9d3a054", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyNDwvdGl0bGU+PHBhdGggZD0iTTIwLDRIMTYuNVYzYS41LjUsMCwwLDAtMSwwVjRoLTdWM2EuNS41LDAsMCwwLTEsMFY0SDRBMiwyLDAsMCwwLDIsNlYxOGEyLDIsMCwwLDAsMiwySDIwYTIsMiwwLDAsMCwyLTJWNkEyLDIsMCwwLDAsMjAsNFpNNCw1SDcuNVY2YS41LjUsMCwwLDAsMSwwVjVoN1Y2YS41LjUsMCwwLDAsMSwwVjVIMjBhMSwxLDAsMCwxLDEsMVY3LjE1SDNWNkExLDEsMCwwLDEsNCw1Wk0yMCwxOUg0YTEsMSwwLDAsMS0xLTFWOC4xNUgyMVYxOEExLDEsMCwwLDEsMjAsMTlaIi8+PHBhdGggZD0iTTE0LjY1LDExLjY1LDExLjUsMTQuNzksOS44NSwxMy4xNWEuNDkuNDksMCwwLDAtLjcuN2wyLDJhLjQ5LjQ5LDAsMCwwLC4zNS4xNS40Ny40NywwLDAsMCwuMzUtLjE1bDMuNS0zLjVhLjQ5LjQ5LDAsMCwwLS43LS43WiIvPjwvc3ZnPg=="

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmZpbHRlcjwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMjJhMS41MiwxLjUyLDAsMCwxLS43NC0uMkExLjUsMS41LDAsMCwxLDksMjAuNDhWMTEuNzZMMi40Miw3LjA2QTEsMSwwLDAsMSwyLDYuMjRWMy41QTEuNSwxLjUsMCwwLDEsMy41LDJoMTdBMS41LDEuNSwwLDAsMSwyMiwzLjVWNi4yNGExLDEsMCwwLDEtLjQyLjgyTDE1LDExLjc2djYuOTJBMS41MSwxLjUxLDAsMCwxLDE0LjI3LDIwbC0zLDEuOEExLjUyLDEuNTIsMCwwLDEsMTAuNSwyMlpNMy41LDNhLjUuNSwwLDAsMC0uNS41VjYuMjRsNi41OCw0LjdhMSwxLDAsMCwxLC40Mi44MnY4LjcyYS41LjUsMCwwLDAsLjI1LjQ0LjUuNSwwLDAsMCwuNTEsMGwzLTEuOGEuNS41LDAsMCwwLC4yNC0uNDNWMTEuNzZhMSwxLDAsMCwxLC40Mi0uODJMMjEsNi4yNFYzLjVhLjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMDwvdGl0bGU+PHBhdGggZD0iTTIwLDIySDIuNWEuNS41LDAsMCwxLS41LS41VjRBLjUuNSwwLDAsMSwzLDRWMjFIMjBhLjUuNSwwLDAsMSwwLDFaIi8+PHBhdGggZD0iTTE3LDdoMFYxOUg1VjEzbDUuMTQtNC41aDBWMTNhLjQ1LjQ1LDAsMCwwLC40Ni40My40Ny40NywwLDAsMCwuMzEtLjEyTDE3LDdtMC0xYTEsMSwwLDAsMC0uNzIuMzFsLTUuMTQsNS4zM1Y4LjVhMSwxLDAsMCwwLS42Mi0uOTMsMS4yMiwxLjIyLDAsMCwwLS4zOC0uMDcsMSwxLDAsMCwwLS42Ni4yNWwtNS4xNCw0LjVBMSwxLDAsMCwwLDQsMTN2NmExLDEsMCwwLDAsMSwxSDE3YTEsMSwwLDAsMCwxLTFWN2ExLDEsMCwwLDAtLjYzLS45M0ExLDEsMCwwLDAsMTcsNloiLz48L3N2Zz4="

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPk1hbmFnZSAtIGV4cG9ydDwvdGl0bGU+PGcgaWQ9IkxheWVyXzEiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggZD0iTTE3LDVIMTZWNGgxWk0xNSw1SDE0VjRoMVpNMTMsNUgxMlY0aDFaTTExLDVIMTBWNGgxWk05LDVIOFY0SDlaIi8+PHBhdGggZD0iTTE5LDVIMThWNGguNWEuNS41LDAsMCwxLC41LjVaIi8+PHBhdGggZD0iTTE5LDE1SDE4VjE0aDFabTAtMkgxOFYxMmgxWm0wLTJIMThWMTBoMVptMC0ySDE4VjhoMVptMC0ySDE4VjZoMVoiLz48cGF0aCBkPSJNMTguNSwxN0gxOFYxNmgxdi41QS41LjUsMCwwLDEsMTguNSwxN1oiLz48cGF0aCBkPSJNMTcsMTdIMTZWMTZoMVptLTIsMEgxNFYxNmgxWk05LDE3SDhWMTZIOVpNNywxN0g2VjE2SDdaIi8+PHBhdGggZD0iTTUsMTdINHYtLjVhLjUuNSwwLDAsMSwuNS0uNUg1WiIvPjxyZWN0IHg9IjQiIHk9IjE4IiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHBhdGggZD0iTTUsMjFINC41YS41LjUsMCwwLDEtLjUtLjVWMjBINVoiLz48cGF0aCBkPSJNMTUsMjFIMTRWMjBoMVptLTIsMEgxMlYyMGgxWm0tMiwwSDEwVjIwaDFaTTksMjFIOFYyMEg5Wk03LDIxSDZWMjBIN1oiLz48cGF0aCBkPSJNMTEuNSwxNi45NGEuNDYuNDYsMCwwLDEtLjM4LS4yTDEwLjY0LDE2Yy0xLjUtMi4zNi0yLjU4LTQuMDctMi41OC01LjYyYTMuNDQsMy40NCwwLDAsMSw2Ljg4LDBjMCwxLjU1LTEuMDgsMy4yNi0yLjU4LDUuNjJsLS40OC43N0EuNDYuNDYsMCwwLDEsMTEuNSwxNi45NFptMC05YTIuNTYsMi41NiwwLDAsMC0yLjU2LDIuNDFjMCwxLjI5LDEsMi45MSwyLjQ1LDUuMTVsLjExLjE3LjExLS4xN2MxLjQyLTIuMjQsMi40NS0zLjg2LDIuNDUtNS4xNUEyLjU2LDIuNTYsMCwwLDAsMTEuNSw3Ljk0Wm0wLDRhMS40NCwxLjQ0LDAsMSwxLDEuNDQtMS40NEExLjQzLDEuNDMsMCwwLDEsMTEuNSwxMS45NFptMC0yYS41Ni41NiwwLDEsMCwuNTYuNTZBLjU2LjU2LDAsMCwwLDExLjUsOS45NFoiLz48Y2lyY2xlIGN4PSI0LjUiIGN5PSI0LjUiIHI9IjEuNSIvPjxjaXJjbGUgY3g9IjE4LjUiIGN5PSIyMC41IiByPSIxLjUiLz48L2c+PC9zdmc+"

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmdyYXBoPC90aXRsZT48cGF0aCBkPSJNMjEuNSwyMkgyLjVhLjUuNSwwLDAsMSwwLTFoMTlhLjUuNSwwLDAsMSwwLDFaIi8+PHBhdGggZD0iTTEzLjUsM2EuNS41LDAsMCwxLC41LjV2MTRhLjUuNSwwLDAsMS0uNS41aC0zYS41LjUsMCwwLDEtLjUtLjVWMy41YS41LjUsMCwwLDEsLjUtLjVoM20wLTFoLTNBMS41LDEuNSwwLDAsMCw5LDMuNXYxNEExLjUsMS41LDAsMCwwLDEwLjUsMTloM0ExLjUsMS41LDAsMCwwLDE1LDE3LjVWMy41QTEuNSwxLjUsMCwwLDAsMTMuNSwyWiIvPjxwYXRoIGQ9Ik0yMC41LDdhLjUxLjUxLDAsMCwxLC41LjV2MTBhLjUxLjUxLDAsMCwxLS41LjVoLTJhLjUxLjUxLDAsMCwxLS41LS41VjcuNWEuNTEuNTEsMCwwLDEsLjUtLjVoMm0wLTFoLTJBMS41LDEuNSwwLDAsMCwxNyw3LjV2MTBBMS41LDEuNSwwLDAsMCwxOC41LDE5aDJBMS41LDEuNSwwLDAsMCwyMiwxNy41VjcuNUExLjUsMS41LDAsMCwwLDIwLjUsNloiLz48cGF0aCBkPSJNNS41LDExYS41MS41MSwwLDAsMSwuNS41djZhLjUxLjUxLDAsMCwxLS41LjVoLTJhLjUxLjUxLDAsMCwxLS41LS41di02YS41MS41MSwwLDAsMSwuNS0uNWgybTAtMWgtMkExLjUsMS41LDAsMCwwLDIsMTEuNXY2QTEuNSwxLjUsMCwwLDAsMy41LDE5aDJBMS41LDEuNSwwLDAsMCw3LDE3LjV2LTZBMS41LDEuNSwwLDAsMCw1LjUsMTBaIi8+PC9zdmc+"

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSA2PC90aXRsZT48cGF0aCBkPSJNMTIsM2E5LDksMCwxLDEtOSw5LDksOSwwLDAsMSw5LTltMC0xQTEwLDEwLDAsMSwwLDIyLDEyLDEwLDEwLDAsMCwwLDEyLDJaIi8+PHBhdGggZD0iTTEyLDE3YS41LjUsMCwwLDEtLjUtLjV2LTZhLjUuNSwwLDAsMSwxLDB2NkEuNS41LDAsMCwxLDEyLDE3WiIvPjxwYXRoIGQ9Ik0xMiw3LjVhLjUuNSwwLDEsMCwuNS41LjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iNCIgZmlsbD0iIzBGQUE1NSIvPgo8L3N2Zz4K"

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventChart_vue__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94099b20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventChart_vue__ = __webpack_require__(2007);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2001)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94099b20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94099b20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventChart_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/reports/EventChart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventChart.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-94099b20", Component.options)
  } else {
    hotAPI.reload("data-v-94099b20", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 842 */,
/* 843 */,
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(842);


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* default */].Bar,
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* default */].mixins.reactiveProp],
  props: {
    labels: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    }
  },
  mounted: function mounted() {},

  watch: {
    data: {
      handler: function handler() {
        this.renderChart({
          labels: this.labels,
          datasets: [{
            label: '',
            data: this.data,
            backgroundColor: ['#FF4040', '#A60000', '#FF7400', '#A64B00', '#CD0074', '#E667AF', '#00CC00', '#008500', '#0F4DA8', '#052F6D', '#B1F100', '#D4F870', '#AF3BD4', '#E9FB00', '#F3FD72'],
            borderColor: ['#FF4040', '#A60000', '#FF7400', '#A64B00', '#CD0074', '#E667AF', '#00CC00', '#008500', '#0F4DA8', '#052F6D', '#B1F100', '#D4F870', '#AF3BD4', '#E9FB00', '#F3FD72'],
            pointBackgroundColor: 'rgba(139, 197, 213, 0.8)',
            pointBorderWidth: 1,
            pointRadius: 4,
            borderWidth: 3,
            pointHoverRadius: 20,
            showLine: true,

            lineTension: 0.1 // smooth line
            // steppedLine: true,

          }]
        }, {
          chartArea: {
            backgroundColor: '#f5f5f5'
          },
          layout: {
            padding: {
              left: 20,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(221, 221, 221, 0.8)',
                display: false,
                drawBorder: false
              },
              ticks: {
                padding: 5 // spacing with label

              },
              barPercentage: 1 // width of bar
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(221, 221, 221, 0.8)',
                display: true,
                drawBorder: false,
                zeroLineColor: 'rgba(221, 221, 221, 0.8)'
              },
              ticks: {
                padding: 5,
                min: 0,
                max: 5 // calculate max data value
              }
            }]
          },
          legend: {
            display: false // hide header
          },
          tooltips: {
            enabled: true
          },

          responsive: true,
          maintainAspectRatio: false
        });
      },
      deep: true
    }
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCompletedReportCard_vue__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660535c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventCompletedReportCard_vue__ = __webpack_require__(2014);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCompletedReportCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660535c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventCompletedReportCard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/EventCompletedReportCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventCompletedReportCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-660535c6", Component.options)
  } else {
    hotAPI.reload("data-v-660535c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ACTION_UPDATE_SETTINGS: 'ACTION_UPDATE_SETTINGS'
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMileageRateModal_vue__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d88948cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EditMileageRateModal_vue__ = __webpack_require__(2065);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMileageRateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d88948cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EditMileageRateModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/globalSettings/EditMileageRateModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditMileageRateModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d88948cc", Component.options)
  } else {
    hotAPI.reload("data-v-d88948cc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSA2PC90aXRsZT48cGF0aCBkPSJNMTIsM2E5LDksMCwxLDEtOSw5LDksOSwwLDAsMSw5LTltMC0xQTEwLDEwLDAsMSwwLDIyLDEyLDEwLDEwLDAsMCwwLDEyLDJaIi8+PHBhdGggZD0iTTEyLDE3YS41LjUsMCwwLDEtLjUtLjV2LTZhLjUuNSwwLDAsMSwxLDB2NkEuNS41LDAsMCwxLDEyLDE3WiIvPjxwYXRoIGQ9Ik0xMiw3LjVhLjUuNSwwLDEsMCwuNS41LjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var state = {
  clientsList: [],
  keywordSearchClient: '',
  selectedClient: null,
  isError: null,
  errorMessage: 'Please try again!',
  clientId: null,
  clientName: '',
  isValidToken: false,
  loginEmail: '',
  isResetPasswordSuccess: false,
  isSubmitted: false,
  allowLogin: true,
  showCaptcha: false,
  siteKey: '',
  listAM: [],
  googleAPIKey: '',
  resetPassToken: '',
  submissionMessage: '',
  changeOrderMessage: '',
  isCheckedNotification: true,
  addOns: '',
  userList: [],
  managerView: '',
  recentClientsList: [],
  isLoading: false,
  validators: [],
  isLoadingStaffing: false,
  totalClients: 0
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = plugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);



// TODO rewrite this plugin
function plugin(Vue, options) {
  if (options && options.constructor !== Object) {
    console.warn('Options must be a object');
    return;
  }
  if (!options) {
    options = {};
  }

  plugin.installed = true;

  // http://izitoast.marcelodolce.com/#Options
  var defaultOptions = {
    zindex: 99999,
    layout: 1,
    balloon: false,
    close: true,
    closeOnEscape: false,
    rtl: false,
    position: 'bottomRight',
    timeout: 3000,
    animateInside: true,
    drag: true,
    pauseOnHover: true,
    resetOnHover: false,
    transitionIn: 'fadeInUp',
    transitionOut: 'fadeOut',
    transitionInMobile: 'fadeInUp',
    transitionOutMobile: 'fadeOutDown',
    buttons: {},
    inputs: {},
    onOpening: function onOpening() {},
    onOpened: function onOpened() {},
    onClosing: function onClosing() {},
    onClosed: function onClosed() {}
  };

  __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.settings(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultOptions, options));

  Object.defineProperty(Vue.prototype, '$toast', {
    get: function get() {
      return toasts;
    }
  });

  var toasts = new Vue({
    _izi: __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a,
    _checkParams: function _checkParams(message, title, options) {
      if (!message || message.constructor !== String) {
        console.warn('Message must be a string');
      }
      if (title && title.constructor !== String) {
        console.warn('Title must be a string');
      }
    },
    _checkEventNames: function _checkEventNames(eventName) {
      if (!eventName || eventName.constructor !== String) {
        console.warn('Event Name must be a string');
      }
      if (eventName !== 'iziToast-open' && eventName !== 'iziToast-close') {
        console.warn('Event Name has only two possible values: iziToast-open or iziToast-close');
      }
    },

    methods: {
      show: function show(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.$options._checkParams(message, title, options);
        this.$options._izi.show(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options, { message: message, title: title }));
      },
      hide: function hide() {
        var toast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (toast && toast.constructor !== String) toast = document.querySelector(toast);
        if (!toast || toast.constructor !== HTMLDivElement) toast = document.querySelector('.iziToast');
        if (options && options.constructor !== Object) {
          console.warn('Options must be a object');
        }
        this.$options._izi.hide(options, toast);
      },
      progress: function progress(toast) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

        if (toast && toast.constructor !== String) toast = document.querySelector(toast);
        if (!toast || toast.constructor !== HTMLDivElement) toast = document.querySelector('.iziToast');
        if (options && options.constructor !== Object) {
          console.warn('Options must be a object');
        }
        if (callback && callback.constructor !== Function) {
          console.warn('Callback must be a function');
        }

        return this.$options._izi.progress(toast, options, callback);
      },
      destroy: function destroy() {
        this.$options._izi.destroy();
      },
      info: function info(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.$options._checkParams(message, title, options);
        this.$options._izi.info(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options, { message: message, title: title }));
      },
      success: function success(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.$options._checkParams(message, title, options);
        this.$options._izi.success(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options, { message: message, title: title }));
      },
      warning: function warning(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.$options._checkParams(message, title, options);
        this.$options._izi.warning(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options, { message: message, title: title }));
      },
      error: function error(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.$options._checkParams(message, title, options);
        this.$options._izi.error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options, { message: message, title: title }));
      },
      question: function question(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.$options._checkParams(message, title, options);
        this.$options._izi.question(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options, { message: message, title: title }));
      },
      on: function on(eventName, callback) {
        this.$options._checkEventNames(eventName);
        if (!callback || callback.constructor !== Function) {
          console.warn('Callback must be a function');
        }
        document.addEventListener(eventName, callback);
      },
      off: function off(eventName) {
        this.$options._checkEventNames(eventName);
        document.removeEventListener(eventName);
      }
    }
  });
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var state = {
  currentEvent: null,
  totalApprovedEvents: 0,
  listApprovedEvent: [],
  listEvent: [],
  listSingleEvent: [],
  listEventGroup: [],
  sort: {
    type: 'dateTime',
    reverse: false
  },
  countTotalEvent: [],
  countClientEvent: [],
  userId: 0,
  expandId: -1,
  listEventStatus: [],
  indexOfItemModifying: -1,
  listEventRelated: [],
  relatedItemInfo: [], // array info status & count event in status
  showRelatedEvents: false,
  listBackup: [],
  columnWidth: {
    eventName: {
      pre: null,
      next: 'prefDate',
      size: 0,
      show: true
    },
    prefDate: {
      pre: 'eventName',
      next: 'projPart',
      size: 0,
      show: true
    },
    projPart: {
      pre: 'prefDate',
      next: 'fullAddress',
      size: 0,
      show: true
    },
    fullAddress: {
      pre: 'projPart',
      next: 'building',
      size: 0,
      show: true
    },
    building: {
      pre: 'fullAddress',
      next: 'eventLocation',
      size: 0,
      show: true
    },
    eventLocation: {
      pre: 'building',
      next: 'startTime',
      size: 0,
      show: true
    },
    startTime: {
      pre: 'eventLocation',
      next: 'duration',
      size: 0,
      show: true
    },
    duration: {
      pre: 'startTime',
      next: 'endTime',
      size: 0,
      show: true
    },
    endTime: {
      pre: 'duration',
      next: 'timeZone',
      size: 0,
      show: true
    },
    timeZone: {
      pre: 'endTime',
      next: 'contactName',
      size: 0,
      show: true
    },
    contactName: {
      pre: 'timeZone',
      next: 'action',
      size: 0,
      show: true
    },
    action: {
      pre: 'contactName',
      next: null,
      size: 0,
      show: true
    }
  },
  listOnSiteContact: [],
  flagCreateEvent: false,
  submitAllEventSuccess: true,
  messageError: '',
  lockIds: {
    eventIds: [],
    userIds: []
  },
  errorCodes: null,
  isLoading: false,
  histories: [],
  columnTableUserWidth: {
    firstName: {
      pre: null,
      next: 'lastName',
      size: 0,
      show: true
    },
    lastName: {
      pre: 'firstName',
      next: 'email',
      size: 0,
      show: true
    },
    email: {
      pre: 'lastName',
      next: 'phone',
      size: 0,
      show: true
    },
    phone: {
      pre: 'email',
      next: 'clientAccount',
      size: 0,
      show: true
    },
    clientAccount: {
      pre: 'email',
      next: 'role',
      size: 0,
      show: true
    },
    role: {
      pre: 'clientAccount',
      next: 'payRates',
      size: 0,
      show: true
    },
    status: {
      pre: 'role',
      next: 'payRates',
      size: 0,
      show: true
    },
    payRates: {
      pre: 'status',
      next: 'address',
      size: 0,
      show: true
    },
    address: {
      pre: 'payRates',
      next: 'action',
      size: 0,
      show: true
    },
    action: {
      pre: 'role',
      next: null,
      size: 0,
      show: true
    }
  },
  columnTableStaffingWidth: {
    firstName: {
      pre: null,
      next: 'lastName',
      size: 0,
      show: true
    },
    lastName: {
      pre: 'firstName',
      next: 'email',
      size: 0,
      show: true
    },
    email: {
      pre: 'lastName',
      next: 'phoneNumber',
      size: 0,
      show: true
    },
    phoneNumber: {
      pre: 'email',
      next: 'role',
      size: 0,
      show: true
    },
    role: {
      pre: 'phoneNumber',
      next: 'payRates',
      size: 0,
      show: true
    },
    events: {
      pre: 'role',
      next: 'actions',
      size: 0,
      show: true
    },
    payRates: {
      pre: 'events',
      next: 'address',
      size: 0,
      show: true
    },
    address: {
      pre: 'payRates',
      next: 'events',
      size: 0,
      show: true
    },
    actions: {
      pre: 'events',
      next: null,
      size: 0,
      show: true
    }
  },
  isUpdating: false,
  isLoadingModal: false,
  isLoadingParticipant: false,
  listApprovedEventBackup: [],
  datesHasData: [],
  lockedDates: [],
  dateRangeHasData: [],
  eventDetailId: 0,
  eventDetailChangeOrder: {},
  eventDetailHistory: [],
  isLoadingEventDetailHistory: true,
  staffList: [],
  staffLead: [],
  staffScreener: [],
  staffConcierge: [],
  openEventStaffModal: '',
  staffDetail: [], // This is used to stored staff detail when open the modal. Purpose: when navigating from event detail to staff modal
  manageEventReports: [],
  sliderValue: {
    begin: '0',
    end: '0'
  },
  keywordSearchEvent: '',
  colTableEmailHistories: {
    sentDate: {
      pre: null,
      next: 'emailTemplate',
      size: 0,
      show: true
    },
    emailTemplate: {
      pre: 'sentDate',
      next: 'relatedEvent',
      size: 0,
      show: true
    },
    relatedEvent: {
      pre: 'emailTemplate',
      next: 'recipients',
      size: 0,
      show: true
    },
    recipients: {
      pre: 'relatedEvent',
      next: 'actions',
      size: 0,
      show: true
    },
    actions: {
      pre: 'recipients',
      next: null,
      size: 0,
      show: true
    }
  },
  zIndex: 999,
  isDownloading: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(432);
module.exports = __webpack_require__(1079);


/***/ }),
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pretty_checkbox_vue__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pretty_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pretty_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pretty_checkbox_vue_radio__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pretty_checkbox_vue_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pretty_checkbox_vue_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_sweetalert2__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__aws_amplify_auth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_css_style_css__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__static_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_customstyle_less__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_customstyle_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_customstyle_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_izitoast_dist_css_iziToast_min_css__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_izitoast_dist_css_iziToast_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_izitoast_dist_css_iziToast_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_izi_toast__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__plugins_VueIziToast__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_scroll_loader__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_scroll_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_scroll_loader__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// load (Polyfill) EventSource, in case browser does not support it...





















// import CKEditor from 'ckeditor';
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced












// import './utils/bing-map-api-helper';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default.a, { dialog: true });
// Vue.use(CKEditor);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_pretty_checkbox_vue_radio___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr___default.a, {
  defaultPosition: 'toast-top-right',
  defaultType: 'success',
  defaultTimeout: 2000
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26__plugins_VueIziToast__["a" /* default */], {
  progressBar: false,
  position: 'topRight',
  animateInside: false,
  overlayColor: 'rgba(0, 0, 0, 0.3)',
  drag: false,
  messageColor: '#fff'
});

__WEBPACK_IMPORTED_MODULE_17__aws_amplify_auth__["a" /* default */].configure({
  userPoolId: {"oauth":{"domain":"prod-pool-002.auth.us-west-2.amazoncognito.com","scope":["phone","email","profile","openid","aws.cognito.signin.user.admin"],"redirectSignIn":"https://connectwell.adurolife.com/oauth2-login-success","redirectSignOut":"https://connectwell.adurolife.com","responseType":"code"},"userPoolId":"us-west-2_kGtfi23uu","userPoolWebClientId":"4p2h7bjc3kpsdcakrcop6vuehm"}.userPoolId,
  userPoolWebClientId: {"oauth":{"domain":"prod-pool-002.auth.us-west-2.amazoncognito.com","scope":["phone","email","profile","openid","aws.cognito.signin.user.admin"],"redirectSignIn":"https://connectwell.adurolife.com/oauth2-login-success","redirectSignOut":"https://connectwell.adurolife.com","responseType":"code"},"userPoolId":"us-west-2_kGtfi23uu","userPoolWebClientId":"4p2h7bjc3kpsdcakrcop6vuehm"}.userPoolWebClientId,
  oauth: {"oauth":{"domain":"prod-pool-002.auth.us-west-2.amazoncognito.com","scope":["phone","email","profile","openid","aws.cognito.signin.user.admin"],"redirectSignIn":"https://connectwell.adurolife.com/oauth2-login-success","redirectSignOut":"https://connectwell.adurolife.com","responseType":"code"},"userPoolId":"us-west-2_kGtfi23uu","userPoolWebClientId":"4p2h7bjc3kpsdcakrcop6vuehm"}.oauth
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_vue_scroll_loader___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_pretty_checkbox_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.silent = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_analytics___default.a, {
  id: 'UA-116747746-1',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  autoTracking: {
    pageViewOnLoad: true
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('date', function (date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('yyyy-MM-dd');
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('dateFormatMMDDYY', function (date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('MM/DD/YYYY');
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('dateFormatMMMM', function (date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date, 'MM/DD/YYYY').format('MMMM D YYYY');
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('templateName', function (value) {
  var result = '';
  switch (value) {
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].day30:
      result = '30 Day Reminder';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].day60:
      result = '60 Day Reminder';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].day7:
      result = 'Tracking';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].thankyou:
      result = 'Thank You';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].tracking:
      result = 'Tracking';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].eventConfirmation:
      result = 'Event Confirmation';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].notReminded:
      result = 'No Email Sent';
      break;
    case __WEBPACK_IMPORTED_MODULE_27__store_constants_emailTemplateType__["a" /* default */].cancellation:
      result = 'Cancellation';
      break;
    default:
      break;
  }
  return result;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$toastOpt = __WEBPACK_IMPORTED_MODULE_25__utils_izi_toast__["a" /* default */];
var url = 'https://www.bing.com/api/maps/mapcontrol?key=' + "Ar_FhdhaM7LiIgc9_BOy53TC5iqFSbEzKsemsRGvA5ug9bfGtV57wDNdQFuV1gsG";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].loadScript(url);

/* eslint-disable no-new */
Object(__WEBPACK_IMPORTED_MODULE_13_vue_analytics__["onAnalyticsReady"])().then(function () {
  new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] },
    store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */]
  });
});

function addCkPlugin() {
  window.CKEDITOR.plugins.add('eventTags', {
    requires: ['richcombo'], // , 'styles' ],
    init: function init(editor) {
      window.CKEDITOR.dtd.$removeEmpty['span'] = true;
      var config = editor.config;
      // let lang = editor.lang.format;

      // Gets the list of tags from the settings.
      var tags = config.emailTags; // new Array();

      // Create style objects for all defined styles.
      function styleItem(color) {
        // style to display on dropdown list
        return '<span style="">' + color + '</span>';
      }

      var acfRules = 'span{color}';

      editor.ui.addRichCombo('eventTags', {
        label: 'Insert Field',
        title: 'Insert Field',
        voiceLabel: 'Insert Field',
        className: 'cke_format',
        multiSelect: false,
        allowedContent: acfRules,
        requiredContent: acfRules,
        panel: {
          css: [window.CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
          multiSelect: false
        },

        init: function init() {
          this.startGroup('Insert Field');
          // show tags to drop down
          for (var thisTag in tags) {
            if (tags[thisTag].name === '[survey_bio_result_url]') {
              var tagFormat = '<span class="email-tag" contenteditable="false"><a href="tag_name" contenteditable="false" style="cursor: pointer; text-decoration: underline;">tag_name</a></span>';
              this.add(tagFormat.replace(/tag_name/g, tags[thisTag].name), styleItem(tags[thisTag].description), tags[thisTag].description);
            } else {
              var _tagFormat = '<span class="email-tag" contenteditable="false">tag_name</span>';
              this.add(_tagFormat.replace('tag_name', tags[thisTag].name), styleItem(tags[thisTag].description), tags[thisTag].description);
            }
          }
        },
        onClick: function onClick(value) {
          editor.focus();
          editor.fire('saveSnapshot');
          var newElement = window.CKEDITOR.dom.element.createFromHtml(value, editor.document);
          editor.insertElement(newElement);
          editor.fire('saveSnapshot');
        }
      });
    }
  });
};

addCkPlugin();

/***/ }),
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 476,
	"./af.js": 476,
	"./ar": 477,
	"./ar-dz": 478,
	"./ar-dz.js": 478,
	"./ar-kw": 479,
	"./ar-kw.js": 479,
	"./ar-ly": 480,
	"./ar-ly.js": 480,
	"./ar-ma": 481,
	"./ar-ma.js": 481,
	"./ar-sa": 482,
	"./ar-sa.js": 482,
	"./ar-tn": 483,
	"./ar-tn.js": 483,
	"./ar.js": 477,
	"./az": 484,
	"./az.js": 484,
	"./be": 485,
	"./be.js": 485,
	"./bg": 486,
	"./bg.js": 486,
	"./bm": 487,
	"./bm.js": 487,
	"./bn": 488,
	"./bn-bd": 489,
	"./bn-bd.js": 489,
	"./bn.js": 488,
	"./bo": 490,
	"./bo.js": 490,
	"./br": 491,
	"./br.js": 491,
	"./bs": 492,
	"./bs.js": 492,
	"./ca": 493,
	"./ca.js": 493,
	"./cs": 494,
	"./cs.js": 494,
	"./cv": 495,
	"./cv.js": 495,
	"./cy": 496,
	"./cy.js": 496,
	"./da": 497,
	"./da.js": 497,
	"./de": 498,
	"./de-at": 499,
	"./de-at.js": 499,
	"./de-ch": 500,
	"./de-ch.js": 500,
	"./de.js": 498,
	"./dv": 501,
	"./dv.js": 501,
	"./el": 502,
	"./el.js": 502,
	"./en-au": 503,
	"./en-au.js": 503,
	"./en-ca": 504,
	"./en-ca.js": 504,
	"./en-gb": 505,
	"./en-gb.js": 505,
	"./en-ie": 506,
	"./en-ie.js": 506,
	"./en-il": 507,
	"./en-il.js": 507,
	"./en-in": 508,
	"./en-in.js": 508,
	"./en-nz": 509,
	"./en-nz.js": 509,
	"./en-sg": 510,
	"./en-sg.js": 510,
	"./eo": 511,
	"./eo.js": 511,
	"./es": 512,
	"./es-do": 513,
	"./es-do.js": 513,
	"./es-mx": 514,
	"./es-mx.js": 514,
	"./es-us": 515,
	"./es-us.js": 515,
	"./es.js": 512,
	"./et": 516,
	"./et.js": 516,
	"./eu": 517,
	"./eu.js": 517,
	"./fa": 518,
	"./fa.js": 518,
	"./fi": 519,
	"./fi.js": 519,
	"./fil": 520,
	"./fil.js": 520,
	"./fo": 521,
	"./fo.js": 521,
	"./fr": 522,
	"./fr-ca": 523,
	"./fr-ca.js": 523,
	"./fr-ch": 524,
	"./fr-ch.js": 524,
	"./fr.js": 522,
	"./fy": 525,
	"./fy.js": 525,
	"./ga": 526,
	"./ga.js": 526,
	"./gd": 527,
	"./gd.js": 527,
	"./gl": 528,
	"./gl.js": 528,
	"./gom-deva": 529,
	"./gom-deva.js": 529,
	"./gom-latn": 530,
	"./gom-latn.js": 530,
	"./gu": 531,
	"./gu.js": 531,
	"./he": 532,
	"./he.js": 532,
	"./hi": 533,
	"./hi.js": 533,
	"./hr": 534,
	"./hr.js": 534,
	"./hu": 535,
	"./hu.js": 535,
	"./hy-am": 536,
	"./hy-am.js": 536,
	"./id": 537,
	"./id.js": 537,
	"./is": 538,
	"./is.js": 538,
	"./it": 539,
	"./it-ch": 540,
	"./it-ch.js": 540,
	"./it.js": 539,
	"./ja": 541,
	"./ja.js": 541,
	"./jv": 542,
	"./jv.js": 542,
	"./ka": 543,
	"./ka.js": 543,
	"./kk": 544,
	"./kk.js": 544,
	"./km": 545,
	"./km.js": 545,
	"./kn": 546,
	"./kn.js": 546,
	"./ko": 547,
	"./ko.js": 547,
	"./ku": 548,
	"./ku.js": 548,
	"./ky": 549,
	"./ky.js": 549,
	"./lb": 550,
	"./lb.js": 550,
	"./lo": 551,
	"./lo.js": 551,
	"./lt": 552,
	"./lt.js": 552,
	"./lv": 553,
	"./lv.js": 553,
	"./me": 554,
	"./me.js": 554,
	"./mi": 555,
	"./mi.js": 555,
	"./mk": 556,
	"./mk.js": 556,
	"./ml": 557,
	"./ml.js": 557,
	"./mn": 558,
	"./mn.js": 558,
	"./mr": 559,
	"./mr.js": 559,
	"./ms": 560,
	"./ms-my": 561,
	"./ms-my.js": 561,
	"./ms.js": 560,
	"./mt": 562,
	"./mt.js": 562,
	"./my": 563,
	"./my.js": 563,
	"./nb": 564,
	"./nb.js": 564,
	"./ne": 565,
	"./ne.js": 565,
	"./nl": 566,
	"./nl-be": 567,
	"./nl-be.js": 567,
	"./nl.js": 566,
	"./nn": 568,
	"./nn.js": 568,
	"./oc-lnc": 569,
	"./oc-lnc.js": 569,
	"./pa-in": 570,
	"./pa-in.js": 570,
	"./pl": 571,
	"./pl.js": 571,
	"./pt": 572,
	"./pt-br": 573,
	"./pt-br.js": 573,
	"./pt.js": 572,
	"./ro": 574,
	"./ro.js": 574,
	"./ru": 575,
	"./ru.js": 575,
	"./sd": 576,
	"./sd.js": 576,
	"./se": 577,
	"./se.js": 577,
	"./si": 578,
	"./si.js": 578,
	"./sk": 579,
	"./sk.js": 579,
	"./sl": 580,
	"./sl.js": 580,
	"./sq": 581,
	"./sq.js": 581,
	"./sr": 582,
	"./sr-cyrl": 583,
	"./sr-cyrl.js": 583,
	"./sr.js": 582,
	"./ss": 584,
	"./ss.js": 584,
	"./sv": 585,
	"./sv.js": 585,
	"./sw": 586,
	"./sw.js": 586,
	"./ta": 587,
	"./ta.js": 587,
	"./te": 588,
	"./te.js": 588,
	"./tet": 589,
	"./tet.js": 589,
	"./tg": 590,
	"./tg.js": 590,
	"./th": 591,
	"./th.js": 591,
	"./tk": 592,
	"./tk.js": 592,
	"./tl-ph": 593,
	"./tl-ph.js": 593,
	"./tlh": 594,
	"./tlh.js": 594,
	"./tr": 595,
	"./tr.js": 595,
	"./tzl": 596,
	"./tzl.js": 596,
	"./tzm": 597,
	"./tzm-latn": 598,
	"./tzm-latn.js": 598,
	"./tzm.js": 597,
	"./ug-cn": 599,
	"./ug-cn.js": 599,
	"./uk": 600,
	"./uk.js": 600,
	"./ur": 601,
	"./ur.js": 601,
	"./uz": 602,
	"./uz-latn": 603,
	"./uz-latn.js": 603,
	"./uz.js": 602,
	"./vi": 604,
	"./vi.js": 604,
	"./x-pseudo": 605,
	"./x-pseudo.js": 605,
	"./yo": 606,
	"./yo.js": 606,
	"./zh-cn": 607,
	"./zh-cn.js": 607,
	"./zh-hk": 608,
	"./zh-hk.js": 608,
	"./zh-mo": 609,
	"./zh-mo.js": 609,
	"./zh-tw": 610,
	"./zh-tw.js": 610
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;

/***/ }),
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b132472_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1163);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1133)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b132472_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b132472", Component.options)
  } else {
    hotAPI.reload("data-v-7b132472", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1134);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("41b805dd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7b132472\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7b132472\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* OVERIDE GENERAL STYLES\n*/\n/**\n* DEFINE VARIABLES\n*/\n.caption-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.label-text {\n  color: #626262;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.label-text-2 {\n  color: #8E8E8E;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.body-text,\n.email-histories-page .histories-page-body .participant-table-container .search-section .input {\n  color: #424242;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.h4-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.h3-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n}\n.h2-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.h1-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.button-text,\n.ap-btn {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n.value-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.tab-header .type {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 6px;\n  line-height: 48px;\n  margin-right: 24px;\n}\n.tab-header .type:hover {\n  cursor: pointer;\n  color: #606060;\n}\n.tab-header .type:focus {\n  border: 2px solid rgba(0, 164, 214, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 14px 24px;\n}\n.tab-header .type.active {\n  border-bottom: 3px solid #1674CD;\n  color: #1674CD;\n}\n.ap-checkbox-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-indicator {\n  width: 24px;\n  height: 24px;\n  top: 0;\n  border: 1px solid #b9b9b9;\n  background-color: transparent;\n}\n.ap-checkbox-group .custom-control-description {\n  margin-left: 1rem;\n}\n.ap-checkbox-group .custom-checkbox {\n  margin-top: 16px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label {\n  cursor: pointer;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before,\n.ap-checkbox-group .custom-checkbox .custom-control-label::after {\n  top: 0;\n  height: 24px;\n  width: 24px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: #1674CD;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-control-label {\n  cursor: pointer;\n}\n.ap-radio-group .custom-control-label::after {\n  background-size: 95%;\n}\n.ap-radio-group .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-radio-group .custom-control-label::before,\n.ap-radio-group .custom-control-label::after {\n  top: 0;\n  height: 25px;\n  width: 25px;\n}\n.ap-radio-group .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio {\n  margin-bottom: 24px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label {\n  font-size: 16px;\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label span {\n  padding-left: 0;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: transparent;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2300A4D6'/%3E%3C/svg%3E\");\n}\n.ap-input-wrapper {\n  position: relative;\n}\n.ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .title-field {\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper {\n  position: relative;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 24px;\n  height: 24px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-error-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E83001;\n  background-color: #E83001;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-success-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #68B814;\n  background-color: #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-warning-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E89819;\n  background-color: #E89819;\n}\n.ap-field-input-wrapper .message-field {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.ap-field-input-wrapper .message-field.success {\n  color: #68B814;\n}\n.ap-field-input-wrapper .message-field.error {\n  color: #E83001;\n}\n.ap-field-input-wrapper .message-field.warning {\n  color: #E89819;\n}\n.ap-dropdown {\n  width: 300px;\n  font-size: 16px;\n}\n.ap-dropdown .ap-dropdown-btn {\n  width: 100%;\n}\n.ap-dropdown .ap-dropdown-btn.btn-group > .btn:first-child {\n  border: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 44px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #ffffff;\n  width: inherit;\n  padding: 10px 16px;\n  font-size: 16px;\n  text-align: left;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary::after {\n  display: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:hover {\n  border: 1px solid #7B7B7B;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:focus {\n  border: 2px solid rgba(32, 170, 233, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text.active {\n  color: #1D1D1D;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper .icon-dropdown {\n  width: 13px;\n  height: 18px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper:hover {\n  cursor: pointer;\n}\n.ap-dropdown .dropdown-menu {\n  width: inherit;\n  width: 100%;\n  border-radius: 4px;\n  background-color: #FFF;\n  margin-top: 8px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 8px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item {\n  height: inherit;\n  padding: 0px 0px 0 16px;\n  color: #1D1D1D;\n  line-height: 24px;\n  border: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:hover {\n  background-color: #F5F5F5 !important;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:focus {\n  background-color: unset;\n  outline: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item .ap-item-wrapper {\n  height: 44px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #E6E6E6;\n  padding: 12px 0 9px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:last-child .ap-item-wrapper {\n  border: none;\n}\n.dropdown-section {\n  height: 500px;\n  margin-top: 64px;\n}\n.dropdown-section .section-title {\n  color: #1D1D1D;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  margin-bottom: 40px;\n}\n.pretty.p-default input:checked ~ .state label:after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn {\n  height: 26px;\n}\n.custom-radio-btn input:checked ~ .state label {\n  font-weight: 600;\n  color: #00A4D6;\n}\n.custom-radio-btn input:checked ~ .state label::after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn input:checked ~ .state label::before {\n  border-color: #00A4D6;\n}\n.custom-radio-btn .state label {\n  height: 26px;\n  margin-left: 16px;\n  font-size: 16px;\n  color: #606060;\n  line-height: 26px;\n  letter-spacing: -0.04px;\n}\n.custom-radio-btn .state label::after {\n  width: 25px;\n  height: 25px;\n  bottom: 0;\n  top: unset;\n}\n.custom-radio-btn .state label::before {\n  width: 25px;\n  height: 25px;\n  border-color: #b9b9b9;\n  bottom: 0;\n  top: unset;\n}\n.ap-btn {\n  padding: 12px 32px;\n  border: 1px solid #1674CD;\n  border-radius: 4px;\n  background: none;\n}\n.ap-btn.compact {\n  padding: 6px 24px;\n}\n.ap-btn.primary {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.primary:focus {\n  background-color: #1674CD;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.primary:hover {\n  background-color: #1674CD;\n}\n.ap-btn.primary:active {\n  background-color: #00526A;\n  outline: none;\n}\n.ap-btn.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.primary:disabled:hover {\n  background-color: #1674CD;\n}\n.ap-btn.secondary {\n  background-color: white;\n  color: #1674CD;\n}\n.ap-btn.secondary:hover {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.secondary:focus {\n  background-color: #FFF;\n  color: #1674CD;\n}\n.ap-btn.secondary:active {\n  background-color: #00526A;\n  color: #FFF;\n}\n.ap-btn.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.secondary:disabled:hover {\n  background-color: transparent;\n  color: #1674CD;\n}\n.ap-btn.tertiary {\n  background-color: #AAA7A4;\n  color: #FFF;\n  border: 1px solid #AAA7A4;\n}\n.ap-btn.tertiary:hover {\n  background-color: #67615C;\n}\n.ap-btn.tertiary:active {\n  background-color: #463E37;\n}\n.ap-btn.tertiary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.tertiary:disabled:hover {\n  background-color: #AAA7A4;\n}\n.ap-btn.destructive {\n  background-color: #FF3400;\n  color: #FFF;\n  border: none;\n}\n.ap-btn.destructive:focus {\n  background-color: #FF3400;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.destructive:hover {\n  background-color: #B22520;\n}\n.ap-btn.destructive:active {\n  background-color: #631412;\n}\n.ap-btn.destructive:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.destructive:disabled:hover {\n  background-color: #FF3400;\n}\n.ap-btn-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ap-btn-icon .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  margin-right: 8px;\n  color: #FFF;\n}\n.ap-btn-icon-only {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px;\n}\n.ap-btn-icon-only.compact {\n  padding: 5px;\n}\n.ap-btn-icon-only .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  color: #FFF;\n}\n.background,\n.card-rest-background,\n.card-lift-background,\n.modal-background,\n.list-dialogues-background,\n.alert-background,\n.iziToast-wrapper .iziToast {\n  border-radius: 4px;\n  background-color: #FFF;\n}\n.header-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.banner-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.card-rest-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.card-lift-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.list-dialogues-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-background,\n.iziToast-wrapper .iziToast {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-icon,\n.alert-icon-checked,\n.alert-icon-info,\n.alert-icon-warning,\n.alert-icon-error {\n  width: 24px;\n  height: 24px;\n  color: #FFF;\n  background-color: #FFF;\n}\n.alert-icon-checked {\n  background: url('/static/img/down-o-white.svg') no-repeat center;\n}\n.alert-icon-info {\n  background: url('/static/img/status-info-outline-white.svg') no-repeat center;\n}\n.alert-icon-warning {\n  background: url('/static/img/status-warning-outline-white.svg') no-repeat center;\n}\n.alert-icon-error {\n  background: url('/static/img/icon-field-error-white.svg') no-repeat center;\n}\n.iziToast-wrapper .iziToast {\n  min-height: 45px;\n  min-width: 283px;\n  padding: 5px 40px 5px 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body {\n  min-height: 35px;\n  margin-left: 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child {\n  background: #FFF;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child:hover {\n  background: #e6e6e6;\n}\n.iziToast-wrapper .iziToast > .iziToast-texts {\n  margin-top: 9px;\n}\n.iziToast-wrapper .iziToast > .iziToast-close {\n  top: 50%;\n  right: 10px;\n  margin-top: -7px;\n  width: 14px;\n  height: 14px;\n  background: url('/static/img/ic_close.png') center center no-repeat;\n  background-size: cover;\n  opacity: 1;\n}\n.iziToast-wrapper .iziToast:after {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.manage-related-events-container {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.manage-related-events-container .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container {\n  font-family: 'Open Sans', sans-serif;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header {\n  margin-top: 24px;\n  padding: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header .modal-title {\n  color: #1D1D1D;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  border: none;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section {\n  margin-top: 20px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title .count-related-event,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title .count-related-event {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  line-height: 30px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper {\n  width: 60%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .input-search-event,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .input-search-event {\n  height: 42px;\n  border-radius: 3px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .search-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .search-icon {\n  position: absolute;\n  right: 12px;\n  top: 10px;\n  z-index: 2;\n  height: 22px;\n  width: 22px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container {\n  background-color: #f5f5f5;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-top: 16px;\n  padding-bottom: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events {\n  border-radius: 4px;\n  margin-top: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name {\n  width: 15%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name .field-value,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name .field-value {\n  margin-left: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-address,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-address {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-contact {\n  width: 17%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-email,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-email {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-date,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-date {\n  width: 10%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action {\n  width: 8%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 16px;\n  border-left: 1px solid #b9b9b9;\n  width: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name {\n  margin-left: 16px;\n  color: #8E8E8E;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper {\n  color: #8E8E8E;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon {\n  vertical-align: middle;\n  width: 12px;\n  height: 12px;\n  color: #8E8E8E;\n  margin-top: -10px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body {\n  max-height: 316px;\n  min-height: 200px;\n  overflow-y: auto;\n  margin-top: 16px;\n  padding-top: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  height: 56px;\n  margin: 0px 5px 16px 5px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value {\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 56px;\n  padding-left: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added {\n  color: #8E8E8E;\n  font-size: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn {\n  font-size: 12px;\n  padding: 0 12px;\n}\n.manage-related-events-container .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 32px;\n}\n.manage-related-events-container .group-btn .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n  text-transform: none;\n}\n.manage-related-events-container .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.manage-related-events-container .list-events {\n  background-color: #FCFCFC;\n  border: 1px solid #E6E6E6;\n  margin-top: 1rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.2rem;\n}\n.manage-related-events-container .list-events .selected-text {\n  color: #8E8E8E;\n}\n.manage-related-events-container .list-events .icon-add-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-add-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-add-wrapper .icon-add {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .icon-close-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-close-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-close-wrapper .icon-close {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .list-container {\n  margin: 0 0 1.4rem 0;\n}\n.manage-related-events-container .list-events .list-group-container {\n  margin: 3rem 0;\n}\n.manage-related-events-container .list-events .list-header,\n.manage-related-events-container .list-events .list-content,\n.manage-related-events-container .list-events .list-ca {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-header .column,\n.manage-related-events-container .list-events .list-content .column,\n.manage-related-events-container .list-events .list-ca .column {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column,\n.manage-related-events-container .list-events .list-content .column .container-column,\n.manage-related-events-container .list-events .list-ca .column .container-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manage-related-events-container .list-events .list-header .column .container-column p,\n.manage-related-events-container .list-events .list-content .column .container-column p,\n.manage-related-events-container .list-events .list-ca .column .container-column p {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button,\n.manage-related-events-container .list-events .list-content .column .container-column button,\n.manage-related-events-container .list-events .list-ca .column .container-column button {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button img,\n.manage-related-events-container .list-events .list-content .column .container-column button img,\n.manage-related-events-container .list-events .list-ca .column .container-column button img {\n  height: 0.6rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-header,\n.manage-related-events-container .list-events .list-content .column .container-column .text-header,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-header {\n  font-weight: 600;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-icon,\n.manage-related-events-container .list-events .list-content .column .container-column .text-icon,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-not-live,\n.manage-related-events-container .list-events .list-content .column .container-column .text-not-live,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-not-live {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manage-related-events-container .list-events .list-header .column .border-seperate,\n.manage-related-events-container .list-events .list-content .column .border-seperate,\n.manage-related-events-container .list-events .list-ca .column .border-seperate {\n  border-right: 1px solid #B9B9B9;\n}\n.manage-related-events-container .list-events .list-header .column.width-10,\n.manage-related-events-container .list-events .list-content .column.width-10,\n.manage-related-events-container .list-events .list-ca .column.width-10 {\n  width: 10%;\n}\n.manage-related-events-container .list-events .list-header .column.width-20,\n.manage-related-events-container .list-events .list-content .column.width-20,\n.manage-related-events-container .list-events .list-ca .column.width-20 {\n  width: 20%;\n}\n.manage-related-events-container .list-events .list-header .column.width-30,\n.manage-related-events-container .list-events .list-content .column.width-30,\n.manage-related-events-container .list-events .list-ca .column.width-30 {\n  width: 30%;\n}\n.manage-related-events-container .list-events .list-content,\n.manage-related-events-container .list-events .list-ca {\n  background: #fff;\n}\n.manage-related-events-container .list-events .list-content .column,\n.manage-related-events-container .list-events .list-ca .column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-content .column .container-column,\n.manage-related-events-container .list-events .list-ca .column .container-column {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .list-events .list-content .column .container-column img,\n.manage-related-events-container .list-events .list-ca .column .container-column img {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .list-content .column:last-child,\n.manage-related-events-container .list-events .list-ca .column:last-child {\n  padding: 0 1rem;\n}\n.manage-related-events-container .list-events .list-content {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manage-related-events-container .list-events .list-ca {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manage-related-events-container .list-events .container-ca {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manage-related-events-container .list-events .container-text {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manage-related-events-container .list-events .container-text b {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .container-text .seperate {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manage-related-events-container .list-events .load-more {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .list-events .load-more span {\n  position: absolute;\n}\n.manage-related-events-container .list-events .load-more button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.client-contact-email-page {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n  padding: 2rem;\n}\n.client-contact-email-page .header-email-page {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .header-email-page p {\n  font-weight: 600;\n  font-size: 1.5em;\n  color: #1D1D1D;\n  margin: 0;\n}\n.client-contact-email-page .header-email-page .icon-close {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.client-contact-email-page .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper {\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event {\n  margin-top: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn {\n  margin-bottom: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn .event-count {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn label {\n  font-size: 1em;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item .event-name:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  width: 8%;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-send {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  width: 8%;\n  margin-left: 1rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.client-contact-email-page .recipients-section .list-email-recipient,\n.client-contact-email-page .cc-section .list-email-recipient,\n.client-contact-email-page .email-template-wrapper .list-email-recipient {\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper {\n  position: relative;\n  margin: .5rem;\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 5px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input {\n  border: none;\n  background-color: #FFF;\n  border-radius: 5px;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to {\n  padding: 16px;\n  overflow: auto;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-wrapper {\n  margin-top: 30px;\n}\n.client-contact-email-page .recipients-wrapper .recipients-section .list-email-send-to {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .cc-section .list-email-send-to {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .text-mar-bot {\n  margin-bottom: 1.5rem;\n}\n.client-contact-email-page .text-send-email {\n  margin: 2rem 0 1em 0;\n  font-weight: 600;\n}\n.client-contact-email-page .send-email-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .participant-emails {\n  padding: 0 1.2% 0 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper .text-subject {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  padding: 0.3rem 0.6rem;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn {\n  margin-right: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text {\n  font-weight: normal;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn label {\n  font-size: 1em;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container {\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.client-contact-email-page .group-btn .ap-btn {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.client-contact-email-page .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-body {\n  padding: 24px;\n}\n.modal-body .description {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper {\n  padding: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper {\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .body-text {\n  color: #1D1D1D;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .ap-input-wrapper .input {\n  color: #000;\n  font-size: 16px;\n  line-height: 20px;\n  padding: 12px 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-cancell-all-appointment {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.modal-cancell-all-appointment .modal-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n  border: 0;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button {\n  float: right;\n  font-size: 20px;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button:hover {\n  cursor: pointer;\n}\n.modal-cancell-all-appointment .modal-body {\n  margin-top: 1rem !important;\n}\n.modal-cancell-all-appointment .modal-body p {\n  font-size: 1.7em;\n  font-weight: 600;\n}\n.modal-cancell-all-appointment .modal-body .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 3rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes,\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-weight: 600;\n  font-size: 16px;\n  width: 5rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes .text-primary,\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no .text-primary {\n  width: 1rem;\n  height: 1rem;\n}\n.add-participant-modal .participant-info {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .title-field {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .field-input {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n  width: 100%;\n  padding: 12px 16px;\n  height: unset;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .error-message {\n  color: #FF3400;\n  font-size: 12px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .email-employee-container {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .select-more-services {\n  padding: 24px 16px 0;\n}\n.add-participant-modal .participant-info .select-more-services .title-field {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .select-more-services .add-more-services-checkbox {\n  margin-top: 8px;\n}\n.add-participant-modal .btn-add-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.add-participant-modal .btn-add-container .btn-cancel {\n  margin-right: 24px;\n}\n.add-participant-modal .btn-add-container .btn-add-participant {\n  padding: 12px 32px;\n}\n.bulk-create-events {\n  padding: 2rem 2.5rem;\n}\n.bulk-create-events .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #1674CD;\n}\n.bulk-create-events .bulk-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .bulk-title p {\n  font-weight: 600;\n  font-size: 24px;\n  margin-bottom: 0;\n}\n.bulk-create-events .bulk-title .btn-bulk {\n  font-weight: 600;\n  color: #1674CD;\n  background: #FFFFFF;\n  border: 1px solid #b9b9b9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 1rem;\n  font-size: 16px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bulk-create-events .bulk-title .btn-bulk img,\n.bulk-create-events .bulk-title .btn-bulk .spinner-border {\n  margin-right: .7rem;\n}\n.bulk-create-events .upload-file {\n  margin-top: 2rem;\n}\n.bulk-create-events .upload-file .dropzone-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 3rem;\n  border: 2px dashed #ccc;\n  border-radius: 15px;\n}\n.bulk-create-events .upload-file .dropzone-container img {\n  height: 6rem;\n  width: 7rem;\n}\n.bulk-create-events .upload-file .dropzone-container .text-csv {\n  font-size: 1.1em;\n  margin: 1.5rem 0;\n  color: #B9B9B9;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop {\n  font-size: 2.4em;\n  font-weight: 500;\n  color: #000000;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop a {\n  color: #1674CD;\n  -webkit-text-decoration: revert;\n          text-decoration: revert;\n}\n.bulk-create-events hr {\n  margin: 2rem 0;\n}\n.bulk-create-events .submission-history {\n  min-height: 40vh;\n}\n.bulk-create-events .submission-history p {\n  font-size: 1.2em;\n  font-weight: 600;\n}\n.bulk-create-events .submission-history table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.bulk-create-events .submission-history table th,\n.bulk-create-events .submission-history table td {\n  border: 1px solid #e6e6e6;\n  padding: 1rem;\n}\n.bulk-create-events .submission-history table th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: left;\n  background-color: #FCFCFC;\n  color: #585858;\n  white-space: nowrap;\n}\n.bulk-create-events .submission-history table td {\n  color: #1D1D1D;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history table td a {\n  color: #1674CD;\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .pagination-container {\n  margin-top: 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .submission-history .pagination-container .total-text {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history .pagination-container .page-item {\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .textPass {\n  color: #0FAA55;\n}\n.bulk-create-events .submission-history .textFailed {\n  color: #E61C0A;\n}\n.bulk-create-events .submission-history .blink-text {\n  -webkit-animation: blinker 1s linear infinite;\n          animation: blinker 1s linear infinite;\n}\n.bulk-create-events .submission-history .blink-text .spinner-border {\n  margin-right: 0.5rem;\n}\n@-webkit-keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n@keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n.draft-events-modal {\n  padding: 2rem;\n}\n.draft-events-modal .add-on-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .add-on-wrapper p {\n  margin: 0;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 0.85em;\n}\n.draft-events-modal .add-on-wrapper .event-add-on {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input[type=checkbox] {\n  width: 0;\n  visibility: hidden;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 1px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.draft-events-modal .add-on-wrapper .event-add-on label:active:after {\n  width: 15px;\n}\n.draft-events-modal .header-modal {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .header-modal .container-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 20%;\n}\n.draft-events-modal .header-modal .container-title .draft-event {\n  color: #1D1D1D;\n  font-weight: 600;\n  font-size: 1.7em;\n  white-space: nowrap;\n  margin: 0;\n}\n.draft-events-modal .header-modal .modal-close {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.draft-events-modal .header-modal .modal-close:hover {\n  cursor: pointer;\n}\n.draft-events-modal .header-modal .modal-close .icon-close {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.draft-events-modal .text-title {\n  font-size: 1.2em;\n  font-weight: 600;\n  margin: 1.5rem 0 0 0;\n}\n.draft-events-modal .field-input {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.draft-events-modal .field-input label {\n  color: #1D1D1D;\n  font-size: 0.9em;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 16px;\n}\n.draft-events-modal .field-input input {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2rem;\n  padding: 0.4rem 0.6rem;\n  width: 100%;\n}\n.draft-events-modal .field-input .require-askterisk {\n  color: #ff0000;\n  position: absolute;\n  font-size: 1.5em;\n}\n.draft-events-modal .field-input select {\n  width: 30%;\n  border-radius: 5px;\n}\n.draft-events-modal .field-input .text-error {\n  color: #ff0000;\n  font-size: 0.9em;\n  margin-top: .3rem;\n}\n.draft-events-modal .field-input .border-error {\n  border-color: #ff0000;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags {\n  height: 2rem;\n  min-height: auto;\n  border: 1px solid #b9b9b9;\n  padding: 0.4rem 0.5rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags input {\n  width: 80% !important;\n  margin: 0;\n  border: 0;\n  padding: 0 !important;\n  font-size: 13px;\n  height: 0rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__placeholder {\n  margin: 0;\n}\n.draft-events-modal .field-input .field-contact .multiselect__select::before {\n  content: none;\n}\n.draft-events-modal .field-input .field-contact .contact-name,\n.draft-events-modal .field-input .field-contact p {\n  margin-bottom: 0.2rem;\n}\n.draft-events-modal .field-input .field-contact .contact-name {\n  text-transform: capitalize;\n}\n.draft-events-modal .field-input .field-contact .multiselect__content-wrapper {\n  min-height: 3rem;\n}\n.draft-events-modal .field-input .log-error,\n.draft-events-modal .field-input .icon-alert,\n.draft-events-modal .field-input .text-alert {\n  padding: 0;\n  margin-top: 0.3rem;\n}\n.draft-events-modal .field-input .icon-alert {\n  color: #0080a5;\n}\n.draft-events-modal .field-input:first-child,\n.draft-events-modal .add-on-wrapper:first-child {\n  padding-left: 0;\n}\n.draft-events-modal .field-input:last-child,\n.draft-events-modal .add-on-wrapper:last-child {\n  padding-right: 0;\n}\n.draft-events-modal .row {\n  margin: 1.3rem 0 0 0;\n}\n.draft-events-modal .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 5rem;\n}\n.draft-events-modal .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit,\n.draft-events-modal .btn-container .btn-right-container .btn-save {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit {\n  margin-right: 1rem;\n}\n.draft-events-modal .btn-container .btn-right-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.draft-events-modal .text-toggle-on {\n  color: #1674CD;\n}\n.draft-events-modal .greyOut {\n  color: #AAA7A4;\n}\n.modal-submit-drafts .main-content {\n  padding: 2rem;\n}\n.modal-submit-drafts .main-content .text-question {\n  color: #1D1D1D;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5em;\n  line-height: 32px;\n}\n.modal-submit-drafts .main-content .text-description {\n  font-weight: normal;\n  font-size: 1em;\n  color: #1D1D1D;\n}\n.modal-submit-drafts .main-content .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel,\n.modal-submit-drafts .main-content .btn-container .btn-submit {\n  padding: .2rem 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1em;\n  line-height: 24px;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  margin-right: 2rem;\n  color: #1674CD;\n}\n.modal-submit-drafts .main-content .btn-container .btn-submit {\n  color: #FFFFFF;\n  background: #1674CD;\n  border-radius: 4px;\n  border: 0;\n}\n.modal-submit-drafts .main-content .btn-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.table-events-plan {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.email-histories-page {\n  font-family: 'Open Sans', sans-serif;\n}\n.email-histories-page .hisories-page-header {\n  background-color: #FFF;\n  padding-top: 16px;\n  border-bottom: 1px solid #E6E6E6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper {\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name .text {\n  color: #E6E6E6;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  padding-bottom: 10px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name.active .text {\n  color: #00A4D6;\n  border-bottom: 3px solid #00A4D6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name + .tab-name {\n  margin-left: 50px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper {\n  padding-bottom: 16px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body {\n  height: calc(100vh - 146px);\n}\n.email-histories-page .histories-page-body .ems-table {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section {\n  margin-top: 24px;\n  width: 50%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section .input {\n  color: #000;\n  padding: 12px 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-participant-container {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header {\n  margin-top: 24px;\n  padding: 12px 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header .ems-header-column:first-child .content {\n  padding-left: 25px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row {\n  height: 58px;\n  padding: 12px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .action-text {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 0;\n  padding-left: 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value:first-child {\n  padding-left: 40px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value.resend-btn-wrapper {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-right: 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value .resend-btn {\n  padding: 6px 24px;\n}\n.email-histories-page .histories-page-body .histories-table-container {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row {\n  height: 56px;\n  padding: 20px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row .action-text {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-history-details-container {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.email-history-details-container .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-history-details-body {\n  padding-bottom: 112px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper {\n  margin-top: 40px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type {\n  margin-top: 16px;\n  color: #606060;\n  font-size: 16px;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn {\n  margin-bottom: 16px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn .event-count {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item .event-name:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient,\n.email-history-details-container .cc-section .list-email-recipient,\n.email-history-details-container .email-template-wrapper .list-email-recipient {\n  margin-top: 16px;\n  border-radius: 4px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper {\n  position: relative;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input {\n  border: none;\n  border-bottom: 1px solid #b9b9b9;\n  background-color: #FFF;\n  border-radius: 4px 4px 0 0;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to {\n  overflow: auto;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date {\n  min-width: 110px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-wrapper {\n  margin-top: 30px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .template-value {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn {\n  margin-right: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text {\n  font-weight: normal;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_top {\n  display: none !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents {\n  padding: 2px !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents iframe {\n  margin: 0 !important;\n  padding: -20px !important;\n}\n.email-history-details-container .email-template-wrapper .email-body-section {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content {\n  height: 416px;\n  padding: 16px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  overflow: auto;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_top,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_bottom {\n  display: none;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient {\n  margin-top: 8px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.email-history-details-container .group-btn .ap-btn {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.email-history-details-container .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-body {\n  padding: 24px;\n}\n.modal-body .description {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.mfa-container .mfa-box {\n  padding: 32px;\n}\n.mfa-container .mfa-box-title {\n  margin-bottom: 16px;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 40px;\n  color: #424242;\n  text-transform: uppercase;\n}\n.mfa-container .mfa-box-title.has-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.mfa-container .mfa-paragraph {\n  margin-bottom: 16px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1d1d1d;\n}\n.mfa-container .btn-group-author {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 32px;\n}\n.mfa-container .btn-group-author .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.mfa-container .btn-group-author .btn + .btn {\n  margin-left: 16px;\n}\n.mfa-container .ad-support-link {\n  margin-top: 32px;\n  text-align: center;\n  font-size: 16px;\n  color: #1d1d1d;\n}\n.mfa-container .ad-support-link .awp-link {\n  color: #00A4D6;\n}\n.mfa-container .field-input-wrapper .input-wrapper .icon-wrapper {\n  top: 50%;\n  margin-top: -12px;\n}\n.authorization-container {\n  margin-top: 40px;\n}\n.authorization-container .form-content {\n  padding-bottom: 35px;\n}\n.authorization-container .form-content .nav-tab {\n  margin: 30px 0 25px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  margin-right: 24px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view:hover {\n  cursor: pointer;\n}\n.authorization-container .form-content .nav-tab .btn-router-view.selected {\n  color: #00A4D6;\n}\n.authorization-container .form-content .authorization-from {\n  padding: 32px;\n}\n.authorization-container .text-enter-code-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 16px;\n}\n.authorization-container .text-enter-code-container .enter {\n  color: #1D1D1D;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n.authorization-container .text-enter-code-container .code {\n  color: #D92C27;\n}\n.authorization-container .mfa-description {\n  text-align: center;\n  margin-top: 24px;\n  color: #1D1D1D;\n}\n.authorization-container .mfa-description .text-code-expire {\n  margin-top: 24px;\n}\n.authorization-container .mfa-input-code {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 88px;\n}\n.authorization-container .mfa-input-code .mfa-input {\n  text-align: center;\n  border: none;\n  background-color: #f5f5f5;\n}\n.authorization-container .mfa-input-code .btn-continue-wrapper {\n  margin-top: 64px;\n}\n.authorization-container .mfa-input-code .text-send-new-code {\n  margin-top: 24px;\n  color: #00A4D6;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n}\n.authorization-container .img-content .castlight-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.authorization-container .img-content .castlight-row .castlight-title {\n  color: #424242;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-right: 16px;\n}\n.authorization-container .img-content .castlight-row .img-castlight {\n  height: 56.1px;\n  width: 166px;\n}\n.participant-header-column .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.participant-header-column .content:hover {\n  cursor: pointer;\n}\n.participant-header-column .caption-text {\n  font-weight: bold;\n}\n.participant-header-column .icon-sort {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.participant-header-column .non-sort {\n  background: url(" + __webpack_require__(229) + ") center no-repeat;\n}\n.participant-header-column .sort-up {\n  background: url(" + __webpack_require__(230) + ") center no-repeat;\n}\n.participant-header-column .sort-down {\n  background: url(" + __webpack_require__(231) + ") center no-repeat;\n}\n@-webkit-keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.spinner-container {\n  position: relative;\n  margin: 0 auto;\n}\n.spinner-container .spinner-inner {\n  border: 1px solid #B9B9B9;\n  border-top-color: #00A4D6;\n  -webkit-animation: spinner .6s linear infinite;\n          animation: spinner .6s linear infinite;\n  border-radius: 50%;\n}\n.event-completed-report-card {\n  background-color: #FFF;\n  width: 270px;\n  margin-top: 24px;\n}\n.event-completed-report-card .spinner-loading {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.event-completed-report-card .top-card {\n  padding: 16px 10px;\n}\n.event-completed-report-card .top-card .event-name {\n  text-align: center;\n  font-weight: bold;\n  color: #1D1D1D;\n}\n.event-completed-report-card .top-card .expected-screened {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .top-card .expected-screened .expected,\n.event-completed-report-card .top-card .expected-screened .screened {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .top-card .expected-screened .expected .value,\n.event-completed-report-card .top-card .expected-screened .screened .value {\n  color: #0095D9;\n}\n.event-completed-report-card .bottom-card {\n  border-top: 1px solid #E6E6E6;\n  background-color: #FCFCFC;\n  border-radius: 0 0 4px 4px;\n  padding: 8px 10px 16px;\n}\n.event-completed-report-card .bottom-card .projected-scheduled {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected,\n.event-completed-report-card .bottom-card .projected-scheduled .screened {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected .value {\n  color: #5FA813;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .screened .value {\n  color: #444444;\n}\n.event-item-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  padding: 0 2rem;\n  height: 35px;\n  z-index: 0;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top: solid 1px #d4d4d4;\n}\n.event-item-icon-underline-color-grey {\n  border: 2px solid #9b9b9b;\n}\n.event-item-icon-underline-color-blue {\n  border: 2px solid #00A4D6;\n}\n.event-item-icon-underline-color-red {\n  border: 2px solid #a42022;\n}\n.event-item-icon-underline-color-green {\n  border: 2px solid #417505;\n}\n.event-item-icon-underline-color-brow {\n  border: 2px solid #463e38;\n}\n.event-item-icon-underline {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 14px;\n  margin-top: 4px;\n}\n.event-item-icon-amount {\n  font-family: \"Open Sans\", sans-serif;\n  text-align: center;\n  margin: 2px 0 0 5px;\n  height: 25px;\n  width: 14px;\n  color: #201D1A;\n  font-size: 12px;\n  line-height: 25px;\n}\n.event-item-icon-component {\n  background-color: #ffffff;\n  float: left;\n  margin: 5px 0 0 3px;\n  width: 65px;\n  padding: 0 3px 0 3px;\n}\n.event-item-icon {\n  height: 25px;\n  width: 25px;\n  color: #2d2827;\n}\n.no-margin-left-right {\n  margin: 5px 0 0 0;\n}\n.icon-footer {\n  width: 25px;\n  height: 25px;\n  background-color: #2d2827;\n}\n.icon-footer.icon-draft {\n  -webkit-mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  background: url(" + __webpack_require__(62) + ");\n}\n.icon-footer.icon-needs-review {\n  -webkit-mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  background: url(" + __webpack_require__(63) + ");\n}\n.icon-footer.icon-submitted {\n  -webkit-mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  background: url(" + __webpack_require__(64) + ");\n}\n.icon-footer.icon-approved {\n  -webkit-mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  background: url(" + __webpack_require__(65) + ");\n}\n.search-session {\n  height: 124px;\n  padding-top: 35px;\n  padding-left: 24px;\n}\n.search-session .placeholder-italic {\n  margin-top: 10px;\n  border: 1px solid #9b9b9b;\n  padding: 3px 15px;\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  border-radius: 3px;\n  background-color: #FFF;\n  z-index: 1;\n}\n.search-session .search-icon {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 998;\n  color: #00A4D6;\n  width: 25px;\n  height: 25px;\n}\n.search-session .search-icon:hover {\n  cursor: pointer;\n  color: #00A4D6;\n}\n.search-session .btn-create-client {\n  position: relative;\n  width: 150px;\n}\n.search-session .btn-create-client .icon-add-client {\n  z-index: 999;\n  color: #FFF;\n  background-color: #0080a5;\n  width: 27px;\n  height: 27px;\n  border-radius: 15px;\n  margin-top: 17px;\n  display: inline-block;\n}\n.search-session .btn-create-client .btn-text {\n  display: inline-block;\n  position: absolute;\n  top: 18px;\n  left: 35px;\n  cursor: pointer;\n}\n.search-icon {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.event-items-management {\n  padding: 24px 12px;\n}\n.event-items-management .section-name {\n  height: 16px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 0 12px 0;\n}\n.event-items-management .client-card-list-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.event-items-management .client-card-list-wrapper .event-item {\n  margin: 12px;\n}\n.event-item {\n  height: 180px;\n  width: 290px;\n  border-radius: 4px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  top: 0;\n  -webkit-transition: top .25s;\n  transition: top .25s;\n  -webkit-transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n          transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n}\n.event-item:hover {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  top: -10px;\n}\n.event-item:hover .delete-client-button {\n  display: block;\n}\n.event-item.noTransition:hover {\n  -webkit-transition: none;\n  transition: none;\n}\n.event-item .delete-client-button {\n  /*display: none;*/\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  height: 24px;\n  width: 24px;\n  z-index: 1;\n}\n.event-item .delete-client-button:hover {\n  background-color: #f5f5f5;\n}\n.event-item .delete-client-button .icon-delete {\n  height: 24px;\n  width: 24px;\n  background: url(" + __webpack_require__(232) + ");\n}\n.event-item .event-item-custom-message {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  color: #3caae9;\n  z-index: 999;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon.icon-gear {\n  -webkit-mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  background: url(" + __webpack_require__(233) + ");\n}\n.event-item .event-item-header {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  position: absolute;\n  height: 145px;\n  overflow: visible;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  padding: 0 24px;\n}\n.event-item .event-item-header .wrapper-event-item-name {\n  height: 45px;\n}\n.event-item .event-item-header .wrapper-event-item-name .event-item-name {\n  font-family: 'Open Sans', sans-serif;\n  max-width: 216px;\n  width: 291px;\n  color: #20AAE9;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto 10px;\n  max-height: 100%;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.event-item .event-item-header .event-item-role {\n  margin: 4px;\n}\n.event-item .event-item-header .event-item-role .event-manager .event-item-role-text-em {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 18px;\n  color: #424242;\n  text-align: center;\n  width: 100%;\n  border: none;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown {\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .btn-group.btn:first-child {\n  font-weight: 600;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 24px;\n  padding: 4px 10px;\n  font-weight: 400;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  font-weight: unset;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  font-size: 14px;\n  line-height: 16px;\n}\n.event-item .event-item-header .event-item-role .multiselect {\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n  margin: 10px auto 0;\n  text-align: center;\n  width: 100%;\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am.multiselect {\n  min-height: 0;\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags {\n  border: none;\n  padding: 0;\n  min-height: unset;\n  height: unset;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags .multiselect__single {\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__select {\n  display: none;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am {\n  position: relative;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input {\n  border-radius: 3px;\n  color: #9b9b9b;\n  text-align: center;\n  border: none;\n  font-size: 14px;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input:hover {\n  cursor: pointer;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__content-wrapper {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.event-item-name {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto;\n}\n.event-item-role-icon {\n  height: 12px;\n  width: 11px;\n  color: #0080a5;\n  position: absolute;\n  width: auto;\n  float: right;\n}\n.manageWrapper .search-container {\n  padding: 1.5rem;\n  background: #FFFFFF;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .search-container .manage-header p {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .title {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .item {\n  width: 23rem;\n}\n.manageWrapper .search-container .manage-header button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1.1em;\n  padding: 8px 24px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .multiselect,\n.manageWrapper .search-container .manage-header .multiselect__input,\n.manageWrapper .search-container .manage-header .multiselect__single {\n  font-size: 14px;\n}\n.manageWrapper .search-container .text-manage-events {\n  color: #1D1D1D;\n  font-size: 1.1em;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter {\n  margin-top: 2rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .search-container .container-filter .filter-date-range {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 23rem;\n  margin-right: 1.5rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.3rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-date-range,\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear {\n  font-size: 12px;\n  margin: 0;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear {\n  color: #1674CD;\n  opacity: 0.6;\n  cursor: pointer;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter p {\n  margin: 0;\n  padding: 0 0.5rem;\n  font-size: 12px;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter input {\n  border-radius: 3px;\n  border: 1px solid #9b9b9b;\n  height: 2.2rem;\n  padding: 0.7rem;\n}\n.manageWrapper .search-container .container-filter .search-events p {\n  margin-bottom: .3rem;\n  font-size: 12px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group {\n  border-radius: 4px;\n  border: 1px solid #9b9b9b;\n  width: 20rem;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group input {\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  height: 100%;\n  border-radius: 3px;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button {\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button .search-icon {\n  color: #000;\n}\n.manageWrapper .search-container .container-filter .total-count {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n      -ms-flex-flow: column-reverse;\n          flex-flow: column-reverse;\n  margin-left: auto;\n  font-size: 14px;\n  font-weight: 600;\n}\n.manageWrapper .list-events {\n  padding: 1.5rem;\n}\n.manageWrapper .list-events .list-container {\n  margin: 2rem 0;\n}\n.manageWrapper .list-events .list-group-container {\n  margin: 3rem 0;\n}\n.manageWrapper .list-events .list-header,\n.manageWrapper .list-events .list-content,\n.manageWrapper .list-events .list-ca {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-header .column,\n.manageWrapper .list-events .list-content .column,\n.manageWrapper .list-events .list-ca .column {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-header .column .container-column,\n.manageWrapper .list-events .list-content .column .container-column,\n.manageWrapper .list-events .list-ca .column .container-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manageWrapper .list-events .list-header .column .container-column .live-click,\n.manageWrapper .list-events .list-content .column .container-column .live-click,\n.manageWrapper .list-events .list-ca .column .container-column .live-click {\n  cursor: pointer;\n}\n.manageWrapper .list-events .list-header .column .container-column p,\n.manageWrapper .list-events .list-content .column .container-column p,\n.manageWrapper .list-events .list-ca .column .container-column p {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manageWrapper .list-events .list-header .column .container-column button,\n.manageWrapper .list-events .list-content .column .container-column button,\n.manageWrapper .list-events .list-ca .column .container-column button {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .list-events .list-header .column .container-column button img,\n.manageWrapper .list-events .list-content .column .container-column button img,\n.manageWrapper .list-events .list-ca .column .container-column button img {\n  height: 0.6rem;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-header,\n.manageWrapper .list-events .list-content .column .container-column .text-header,\n.manageWrapper .list-events .list-ca .column .container-column .text-header {\n  font-weight: 600;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-icon,\n.manageWrapper .list-events .list-content .column .container-column .text-icon,\n.manageWrapper .list-events .list-ca .column .container-column .text-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-not-live,\n.manageWrapper .list-events .list-content .column .container-column .text-not-live,\n.manageWrapper .list-events .list-ca .column .container-column .text-not-live {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manageWrapper .list-events .list-header .column .border-seperate,\n.manageWrapper .list-events .list-content .column .border-seperate,\n.manageWrapper .list-events .list-ca .column .border-seperate {\n  border-right: 1px solid #B9B9B9;\n}\n.manageWrapper .list-events .list-header .column.event-date,\n.manageWrapper .list-events .list-content .column.event-date,\n.manageWrapper .list-events .list-ca .column.event-date {\n  width: 14.28%;\n}\n.manageWrapper .list-events .list-header .column.w-2,\n.manageWrapper .list-events .list-content .column.w-2,\n.manageWrapper .list-events .list-ca .column.w-2 {\n  width: 2%;\n}\n.manageWrapper .list-events .list-header .column.w-12,\n.manageWrapper .list-events .list-content .column.w-12,\n.manageWrapper .list-events .list-ca .column.w-12 {\n  width: 12%;\n}\n.manageWrapper .list-events .list-header .column.w-14,\n.manageWrapper .list-events .list-content .column.w-14,\n.manageWrapper .list-events .list-ca .column.w-14 {\n  width: 14%;\n}\n.manageWrapper .list-events .list-header .column.w-16,\n.manageWrapper .list-events .list-content .column.w-16,\n.manageWrapper .list-events .list-ca .column.w-16 {\n  width: 16%;\n}\n.manageWrapper .list-events .list-header.green-line,\n.manageWrapper .list-events .list-content.green-line,\n.manageWrapper .list-events .list-ca.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-header.green-line,\n.manageWrapper .list-events .list-content.green-line,\n.manageWrapper .list-events .list-ca.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-content,\n.manageWrapper .list-events .list-ca {\n  background: #fff;\n}\n.manageWrapper .list-events .list-content .column,\n.manageWrapper .list-events .list-ca .column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-content .column .container-column,\n.manageWrapper .list-events .list-ca .column .container-column {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manageWrapper .list-events .list-content .column .container-column img,\n.manageWrapper .list-events .list-ca .column .container-column img {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .list-content .column:last-child,\n.manageWrapper .list-events .list-ca .column:last-child {\n  padding: 1rem 1rem 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-content {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manageWrapper .list-events .list-ca {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manageWrapper .list-events .container-ca {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .list-events .container-ca .list-group-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.manageWrapper .list-events .container-ca .list-group-row.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .container-text {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manageWrapper .list-events .container-text b {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .container-text .seperate {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manageWrapper .list-events .load-more {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manageWrapper .list-events .load-more span {\n  position: absolute;\n}\n.manageWrapper .list-events .load-more button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.manageWrapper .footer {\n  background: white;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  bottom: 0;\n  left: 96px;\n  right: 0;\n  padding: 0.8rem 1.5rem;\n}\n.manageWrapper .footer .ap-btn {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.custom-modal .modal-title {\n  height: 32px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.custom-modal .configure-scheduler {\n  border-radius: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 6px 24px;\n  margin-left: 16px;\n}\n.custom-modal .label {\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.custom-modal .modal-header {\n  padding-left: 0;\n  width: 100%;\n  margin: 0  !important;\n  border-bottom: none !important;\n}\n.custom-modal .modal-header .modal-header-text {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 27px;\n}\n.custom-modal .modal-header .modal-header-text-edit {\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .input-client-name {\n  border: none;\n  height: 20px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  margin-top: 8px;\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .save-client-name-btn.btn {\n  float: right;\n  margin-left: 15px;\n  background-color: #0080A5;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-modal .modal-close-img {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.custom-modal .modal-box .main-content {\n  padding: 60px 60px 20px 40px;\n}\n.custom-modal .modal-box .overlay {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.custom-modal .modal-box .isLoading {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n}\n.custom-modal .modal-box .noDisplay {\n  display: none!important;\n}\n.custom-modal .modal-body {\n  font-family: 'Open Sans', sans-serif;\n  margin-top: 60px;\n}\n.custom-modal .modal-body.main-content {\n  margin: 0;\n  width: 100%;\n  padding: 5rem 0 0 0;\n}\n.custom-modal .add-on {\n  margin-top: 112px;\n}\n.custom-modal .add-on .title {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .add-on .description {\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .add-on .add-on-item {\n  width: 250px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 12px;\n}\n.custom-modal .add-on .add-on-item .text {\n  position: absolute;\n  left: 40px;\n  white-space: nowrap;\n}\n.custom-modal .add-on .add-on-item label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .add-on .add-on-item input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .add-on .add-on-item label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .add-on .add-on-item input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .add-on .add-on-item input:disabled + label {\n  background: #babfc0;\n  border: 1.5px solid #fff;\n}\n.custom-modal .add-on .add-on-item input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .add-on .add-on-item label:active:after {\n  width: 15px;\n}\n.custom-modal .secondary-am {\n  margin-top: 74px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .secondary-am .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .secondary-am .description {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .secondary-am .pick {\n  margin-top: 4px;\n  font-size: 14px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags {\n  border: 1px solid #9B9B9B;\n  height: auto  !important;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag {\n  background: #41b883;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 0 0.5rem 0 0;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {\n  margin-top: 3px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:hover {\n  background: #0092B4;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon:after {\n  color: #fff;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content {\n  margin: 7px auto;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content li.multiselect__element:last-child {\n  border-bottom: none;\n}\n.custom-modal .reseller-status {\n  margin-top: 72px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .reseller-status .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .reseller-status .description {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .reseller-status .reseller-toggle {\n  margin-top: 15px;\n}\n.custom-modal .reseller-status .reseller-toggle input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .reseller-status .reseller-toggle label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .reseller-status .reseller-toggle label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .reseller-status .reseller-toggle label:active:after {\n  width: 15px;\n}\n.custom-modal .reseller-status .read-only {\n  margin-top: 15px;\n}\n.custom-modal .last-child-pick {\n  position: relative;\n  margin-top: 15px;\n  height: 250px;\n}\n.button-view {\n  position: relative;\n}\n.button-view .btn-expand {\n  background: url(" + __webpack_require__(234) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-duplicate {\n  background: url(" + __webpack_require__(235) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-delete {\n  background: url(" + __webpack_require__(236) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status {\n  background: url(" + __webpack_require__(237) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status:disabled {\n  background: url(" + __webpack_require__(238) + ") no-repeat !important;\n}\n.button-view .btn-status-dropdown .dropdown-toggle::after {\n  display: none;\n}\n.button-view .btn-status-dropdown .dropdown-menu {\n  border-radius: 10px;\n  padding: 10px 0;\n  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  background: #FCFCFC;\n}\n.button-view .btn-status-dropdown button {\n  width: 100%;\n  height: 100%;\n}\n.button-view .btn-status-dropdown ul {\n  border-radius: 10px;\n}\n.button-view .btn-status-dropdown ul li a {\n  padding: 10px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.button-view .wrapper-list {\n  position: absolute;\n  left: -450%;\n  top: 16px;\n  z-index: 999;\n  cursor: pointer;\n}\n.button-view .wrapper-list .icon-information-black {\n  width: 27px;\n  height: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .icon-information-black {\n    background: url(" + __webpack_require__(38) + ");\n}\n}\n.button-view .wrapper-list .status-icon-black {\n  height: 27px;\n  width: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(31) + ") no-repeat center;\n  mask: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.button-view .wrapper-list .status-icon-black {\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .status-icon-black {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n.dashboard-manager .isLoading {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n  padding: 12rem 0;\n}\n.dashboard-manager .pagination-container {\n  margin-top: 1.5rem;\n  padding: 24px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.dashboard-manager .pagination-container .total-text {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.dashboard-manager .pagination-container .page-item {\n  cursor: pointer;\n}\n.global-setting-page-container {\n  padding: 24px;\n  background-color: #FFF;\n}\n.global-setting-page-container .staff-management-container {\n  padding: 24px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table {\n  margin-top: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header {\n  margin-top: 16px;\n  padding: 12px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header .col-mileage-rate {\n  padding-left: 40px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row {\n  padding: 12px 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .field-value {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn {\n  padding: 4px;\n  background-color: #1674CD;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn + .ap-btn {\n  margin-left: 8px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn .icon {\n  height: 24px;\n  width: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .edit-btn .icon {\n  background: url(" + __webpack_require__(153) + ") no-repeat center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .delete-btn .icon {\n  background: url(" + __webpack_require__(154) + ") no-repeat center;\n}\nbody {\n  font-family: 'Open Sans', sans-serif;\n}\n.body {\n  width: 90%;\n  margin: 10px auto;\n  height: auto;\n  text-align: center;\n  background-color: #FFF;\n  font-family: 'Open Sans', sans-serif;\n  min-width: 1024px;\n}\n.main .container-fluid {\n  padding: 0;\n}\na:hover {\n  text-decoration: none !important;\n}\n.v--modal {\n  -webkit-box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n          box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n}\n/**\n * CUSTOM STYLES\n */\n.has-error {\n  border: solid 1px red !important;\n}\n.line-copy-2 {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 63px;\n  width: 2px;\n  border-left: 10px solid #0080a5;\n}\n.content-header {\n  height: 29px;\n  width: 137px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  position: absolute;\n  margin: 25px 0 0 15px;\n}\n.content-body {\n  height: 19px;\n  color: #231F20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  position: absolute;\n  margin: 65px 0 0 15px;\n}\n.subHeader {\n  height: 100px;\n  width: 100%;\n  background-color: #FFF;\n}\n.header {\n  height: 70px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.header-card {\n  height: 46px;\n  width: 100%;\n  color: #FFF;\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 50px;\n}\n.content-dashboard-card {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 19px;\n}\n.wellmetrics-event-ma {\n  height: 29px;\n  width: 341px;\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n}\n.user-name {\n  height: 24px;\n  width: 94px;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n}\n.user-type {\n  height: 20px;\n  width: 78px;\n  color: #9b9b9b;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 300;\n  line-height: 20px;\n  text-align: center;\n}\n.shadow {\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.overview {\n  width: 100%;\n  height: 65px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 80px;\n  text-align: center;\n}\n.events {\n  height: 18px;\n  width: 47px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.bottomLine {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 80%;\n  border: 1px solid #FFF;\n  opacity: 0.5;\n  margin-top: 7px;\n  float: right;\n  margin-bottom: -5px;\n}\n.newEventForm {\n  padding: 20px;\n  margin: 20px;\n}\n.nopadding {\n  padding: 0 !important;\n}\n.noMargin {\n  margin-left: 0;\n  margin-right: 0;\n}\n.paddingTop27px {\n  padding-top: 27px;\n}\n.padding-left-20px {\n  padding-left: 20px;\n}\n.noPaddingLeft {\n  padding-left: 0;\n}\n.noPaddingRight {\n  padding-right: 0;\n}\n.margin-bottom-8px {\n  margin-bottom: 8px;\n}\n.margin-top-15px {\n  margin-top: 15px;\n}\n.margin-top-16px {\n  margin-top: 16px;\n}\n.margin-top-25px {\n  margin-top: 25px;\n}\n.margin-bottom-5px {\n  margin-bottom: 5px;\n}\n.margin-top-20px {\n  margin-top: 20px;\n}\n.margin-top-44px {\n  margin-top: 44px;\n}\n.margin-top-40px {\n  margin-top: 40px;\n}\n.margin-top-10px {\n  margin-top: 10px;\n}\n.margin-top-5px {\n  margin-top: 5px;\n}\n.margin-bottom-10px {\n  margin-bottom: 10px;\n}\n.padding-left-40px {\n  padding-left: 40px !important;\n}\n.padding-left-27px {\n  padding-left: 27px !important;\n}\n.padding-left-3px {\n  padding-left: 3px;\n}\n.padding-left-19px {\n  padding-left: 19px;\n}\n.clear-both {\n  clear: both;\n}\n.h2-title {\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.h4-title {\n  color: #0080A5;\n  font-family: Arquitecta, sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.no-select {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                   supported by Chrome and Opera */\n}\n.phoneAndEmail {\n  height: 34px;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  border-radius: 3px;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0 0 0 13px;\n  font-size: 14px;\n  color: #000;\n}\n.calendarCustom {\n  width: 300px;\n  border: none;\n  margin-right: 13px;\n}\n.outer-container {\n  position: relative;\n  float: left;\n  left: 50%;\n}\n.outer-container .inner-container {\n  position: relative;\n  float: left;\n  left: -50%;\n}\n::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #b9b9b9;\n}\n:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #b9b9b9;\n}\n::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #b9b9b9;\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #b9b9b9;\n}\n:-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #b9b9b9;\n}\n::placeholder {\n  /* Most modern browsers support this now. */\n  color: #b9b9b9;\n}\n.modal-body-user-info .multiselect__tags {\n  border: 1px solid #9B9B9B;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag {\n  background: #0092B4;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {\n  margin-top: 3px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:hover {\n  background: #0092B4;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon:after {\n  color: #fff;\n}\n.modal-body-user-info .multiselect__content-wrapper {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content {\n  margin: 7px auto;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content li.multiselect__element:last-child {\n  border-bottom: none;\n}\n.custom-toggle input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-toggle label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-toggle label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-toggle input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-toggle input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-toggle label:active:after {\n  width: 15px;\n}\n.display-none-something {\n  display: none !important;\n}\n.ems_confirm {\n  padding: 24px;\n}\n.ems_confirm .swal2-header {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.ems_confirm .swal2-header .ems_alert_title {\n  height: 40px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.ems_confirm .swal2-content .ems_alert_des {\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  font-weight: 400;\n}\n.ems_confirm .swal2-actions {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: unset;\n  margin-top: 45px;\n}\n.ems_confirm .swal2-actions .ems_alert_cancel {\n  border: 1px solid #00A4D6 !important;\n  color: #00A4D6 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.block {\n  background-color: #FF3400 !important;\n  border-left-color: #FF3400 !important;\n  border-right-color: #FF3400 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.open {\n  background-color: #00A4D6 !important;\n  border-left-color: #00A4D6 !important;\n  border-right-color: #00A4D6 !important;\n}\n.default-message {\n  color: #b9b9b9 !important;\n}\n.max-width-100 {\n  max-width: 100% !important;\n}\n.always-show {\n  display: block !important;\n  opacity: 1 !important;\n}\n.selected-staffing-item {\n  background-color: #e6e6e6 !important;\n}\n.un-selected-staffing-item {\n  background-color: #FFFFFF !important;\n}\n.form-control:disabled {\n  background-color: #FFFFFF;\n  opacity: 1;\n}\n.clear-both {\n  clear: both !important;\n}\n.action-btn {\n  height: 36px;\n  margin-left: 8px;\n}\n.action-btn:hover {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue .btn-text {\n  color: #FFF;\n}\n.action-btn.btn-white {\n  background-color: #f5f5f5;\n  color: #00A4D6;\n  border: solid 1px #00A4D6;\n}\n.action-btn.btn-white .btn-text {\n  color: #00A4D6;\n}\n.action-btn .btn-text {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.no-border {\n  border: none !important;\n}\n.opacity-04 {\n  opacity: 0.4;\n}\n.opacity-06 {\n  opacity: 0.6;\n}\n.field-input-wrapper {\n  margin-top: 24px;\n}\n.field-input-wrapper .attr-name {\n  color: #424242;\n  font-size: 16px;\n}\n.field-input-wrapper .message {\n  margin-top: 5px;\n  font-size: 16px;\n}\n.field-input-wrapper .message.error {\n  color: #E83001;\n}\n.field-input-wrapper .message.success {\n  color: #5FA813;\n}\n.field-input-wrapper .input-wrapper {\n  position: relative;\n}\n.field-input-wrapper .input-wrapper .input {\n  height: 48px;\n  margin-top: 5px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  line-height: 24px;\n  width: 100%;\n  padding-left: 10px;\n  font-size: 16px;\n}\n.field-input-wrapper .input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.field-input-wrapper .input-wrapper .input.success {\n  border: 1px solid #5FA813;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper {\n  position: absolute;\n  top: 16px;\n  right: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background-color: #3caae9;\n  background: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(239) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .help {\n  display: inline-block;\n  margin-top: 5px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.field-input-wrapper .help.is-danger {\n  color: #E83001;\n}\n.margin-side {\n  padding: 0 24px;\n}\n.remove-margin-side {\n  margin: 0 -24px;\n}\n.common-margin-left {\n  margin-left: 24px;\n}\n.v--modal-overlay {\n  z-index: 1020;\n}\n.icon-back {\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.icon-back {\n    background: url(" + __webpack_require__(92) + ");\n}\n}\n.common-card {\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.common-card .v--modal-box {\n  padding: 24px;\n}\n.common-card .v--modal-box .modal-close-img {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.common-card .v--modal-box .modal-close-img .icon-close {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.common-card .v--modal-box .modal-close-img .icon-close {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.common-card .v--modal-box .modal-close-img .icon-close:hover {\n  cursor: pointer;\n}\n.common-card .v--modal-box .modal-body {\n  margin-top: 16px;\n}\n.common-card .v--modal-box .modal-footer {\n  margin-top: 40px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.common-card .v--modal-box .modal-header,\n.common-card .v--modal-box .modal-body,\n.common-card .v--modal-box .modal-footer {\n  padding: 0;\n  border-bottom: none;\n  border-top: none;\n}\n.push-right {\n  float: right;\n}\n.remove-icon {\n  margin-left: 16px;\n  margin-top: 2px;\n  width: 27px;\n  height: 27px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.remove-icon {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.remove-icon:hover {\n  cursor: pointer;\n}\n.cke_chrome,\n.cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.cke_chrome .cke_inner,\n.cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_top,\n.cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_bottom,\n.cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.header-left-side {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.header-left-side .header-middle {\n  margin-left: 24px;\n}\n.custom-multiselect {\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper {\n  border: none;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  font-family: 'Open Sans', sans-serif;\n  z-index: 999;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content {\n  margin-top: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  padding-left: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element:hover {\n  background-color: #F5F5F5;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  min-height: 34px;\n  color: #231F20;\n  border-bottom: 1px solid #E6e6e6;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__tags {\n  border-color: #B9b9b9;\n  border-radius: 4px;\n  padding-left: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  color: #231F20;\n  height: 43px;\n}\n.custom-multiselect .multiselect .multiselect__tags:hover {\n  border-color: #B7B7B7;\n  color: #231F20;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input {\n  font-size: 14px;\n  margin-bottom: 0;\n  padding: 0;\n  height: 16px;\n  line-height: unset;\n  min-height: unset;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::-webkit-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::-moz-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input:-ms-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::placeholder {\n  color: #606060;\n}\n.ems-row {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.ems-row .field-value {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 0 16px;\n}\n.ems-table-header {\n  width: 100%;\n  height: 48px;\n  padding: 16px 0px;\n}\n.ems-table-header .ems-header-col {\n  float: left;\n  text-transform: uppercase;\n}\n.ems-table-header .ems-header-col .content {\n  padding-left: 16px;\n}\n.ems-table-header .ems-header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.ems-table-header .ems-header-col .header-container {\n  position: relative;\n}\n.ems-table-header .ems-header-col .crop {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n  overflow: hidden;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.ems-table-header .ems-header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n.event-container .app-body .main {\n  padding-bottom: 0;\n}\n.client-card-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.disable-button {\n  pointer-events: none;\n}\n.dt-row .MicrosoftMap .as_container_search {\n  left: 18%;\n  margin-top: 35px;\n}\n.dt-row .MicrosoftMap .as_container ul {\n  padding: 0 0 8px 0;\n}\n.dt-row .MicrosoftMap .as_container ul li {\n  border-top: 1px solid #e6e6e6;\n}\n.text-value .MicrosoftMap .as_container_search {\n  left: 10px;\n  margin-top: 0;\n}\n.address-input-bing {\n  height: 25px;\n  margin-top: 16px;\n  border: none;\n  outline: none;\n  padding-right: 15px;\n}\n.center-content {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.center-content .img-red-logo {\n  height: 64px;\n  width: 64px;\n}\n.center-content .form-wrapper {\n  padding: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content {\n  margin-top: 16px;\n  margin-bottom: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content #desc-reset-pass {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email-title {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email {\n  margin-top: 4px;\n}\n.center-content .form-wrapper .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.center-content .form-wrapper .button-content .btn-cancel {\n  margin-right: 16px;\n}\n.password-check-list {\n  margin-top: 24px;\n}\n.password-check-list .password-at-least {\n  color: #1d1d1d;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.password-check-list .indicators-password .indicator-item {\n  line-height: 16px;\n  font-size: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin-top: 8px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper {\n  height: 16px;\n  width: 16px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-reach {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(240) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-unreach {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(241) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .text {\n  margin-left: 8px;\n  letter-spacing: 0.1px;\n  color: #1d1d1d;\n}\n/* Hide HTML5 Up and Down arrows. */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n.multiselect--active {\n  z-index: 1000;\n}\n.ap-modal .modal-content {\n  min-height: 100%;\n  height: auto;\n  border: 1px solid #E6E6E6;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.ap-modal .modal-backdrop.show {\n  opacity: 0.3;\n}\n.ems-header-column {\n  position: relative;\n}\n.ems-header-column .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.ems-header-column .content .icon-sort {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.ems-header-column .non-sort {\n  background: url(" + __webpack_require__(242) + ") center no-repeat;\n}\n.ems-header-column .sort-up {\n  background: url(" + __webpack_require__(243) + ") center no-repeat;\n}\n.ems-header-column .sort-down {\n  background: url(" + __webpack_require__(244) + ") center no-repeat;\n}\n.ems-header-column .resize-line {\n  position: absolute;\n  width: 1px;\n  height: 16px;\n  right: 1px;\n  top: 0;\n  background-color: #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ems-header-column .resize-line:hover {\n  cursor: col-resize;\n}\n.ems-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ems-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ems-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ems-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.infinite-status-prompt {\n  display: none;\n}\n.toast-container > .toast-info {\n  background-color: #0080a5 !important;\n}\n.toast-container > .toast-error {\n  background-color: #FF3400 !important;\n}\n.toast-container > .toast-success {\n  background-color: #68B814 !important;\n}\n.toast-container > .toast-warning {\n  background-color: #E89819 !important;\n}\n.margin-top-24px {\n  margin-top: 24px;\n}\n.multiple-select-work-group {\n  position: relative;\n  height: 30px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect {\n  min-height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags {\n  min-height: 30px;\n  padding: 0 40px 0 8px;\n  border: none;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input {\n  color: #9b9b9b;\n  margin-bottom: 0;\n  min-height: 30px;\n  text-align: left;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input:hover {\n  cursor: pointer;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__placeholder {\n  margin-top: 5px;\n  margin-bottom: 0;\n  padding-top: 0;\n  color: #585858;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__single {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__select {\n  height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__content-wrapper {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1135 */,
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_css_helper__ = __webpack_require__(360);

//
//
//
//
//




// import Auth from '@aws-amplify/auth';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__utils_css_helper__["a" /* default */].customColorForUI();
    // before send request
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.interceptors.request.use(function (config) {
      var token = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.token);
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token.replace('Bearer ', '');
        config.headers['Content-Type'] = 'application/json';
      }
      return config;
    }, function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
    // after receive response
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response && error.response.status === 401) {
        // remove all local storage
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.userId);
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.token);
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role);
        // redirect to login
        _this.$router.push('/login');

        //        console.log('this.$modal=', this.$modal);
        //        this.$modal.show('dialog', {
        //          title: globalMessage.dialog.unAuthorizedToken.title,
        //          text: globalMessage.dialog.unAuthorizedToken.msg,
        //          buttons: [
        //            { title: globalMessage.common.yes,
        //              handler: () => {
        //                this.$modal.hide('dialog');
        //                this.$router.push('/login');
        //              }
        //            }
        //          ]
        //        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      }
    });
  }
});

/***/ }),
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-view")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b132472", esExports)
  }
}

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_authorization_login_Oauth2LoginSuccess_vue__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Full_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Event_vue__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_manager_Dashboard_vue__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_manager_DashboardManager_vue__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_manager_EventsManager_vue__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_manager_Calendar_vue__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_manager_PlanAndApprove_vue__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_manager_ManageApproved_vue__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_event_ManageEventDetail_vue__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_schedulerConfig_SchedulerConfiguration_vue__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_managerDashboard_ManagerDashboard_vue__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_email_ManageEmail_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_email_EmailHistoriesManagement_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_event_ManageRelatedEvents_vue__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_email_EmailHistoryDetails_vue__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_authorization_ResetPassword_vue__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_authorization_UpdatePassword_vue__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_dashboard_Dashboard_vue__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Drafts_vue__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Archived_vue__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Approved_vue__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Review_vue__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Submitted_vue__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Deleted_vue__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_authorization_mfa_EnterAuthorizationCode_vue__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_authorization_ImportUser_vue__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_manager_clientView_Dashboard_vue__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_manager_clientView_Manage_vue__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_manager_clientView_Plan_vue__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_manager_clientView_Reports_vue__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_manager_userManagement_UserManagement_vue__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_manager_globalSettings_GlobalSettings_vue__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_manager_staffing_StaffingSection_vue__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_staffing_EventStaffingDetail_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_eventManagement_reports_UpcommingReport_vue__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_eventManagement_reports_CompletedReport_vue__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__aws_amplify_auth__ = __webpack_require__(157);







/**
 * Import container
 */
// Users


// Managers














/**
 * Import Reset Password
 */



/**
 * Import Views
 */
// Users








// import Login from '../components/authorization/login/Login.vue';


// Client View













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  routes: [{
    path: '/',
    meta: { requiresAuth: true },
    redirect: '/login'
  }, {
    path: '/login',
    // component: Login,
    beforeEnter: function beforeEnter() {
      __WEBPACK_IMPORTED_MODULE_41__aws_amplify_auth__["a" /* default */].federatedSignIn();
    },
    meta: { requiresAuth: false }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].oauth2LoginSuccess,
    name: 'Oauth2LoginSuccess',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_4__components_authorization_login_Oauth2LoginSuccess_vue__["a" /* default */]
  }, {
    path: '/login/mfa',
    component: __WEBPACK_IMPORTED_MODULE_29__components_authorization_mfa_EnterAuthorizationCode_vue__["a" /* default */]
  }, {
    path: '/reset-password',
    component: __WEBPACK_IMPORTED_MODULE_20__components_authorization_ResetPassword_vue__["a" /* default */],
    meta: { requiresAuth: false }
  }, {
    path: '/import',
    component: __WEBPACK_IMPORTED_MODULE_30__components_authorization_ImportUser_vue__["a" /* default */],
    meta: {
      requiresAuth: true,
      deniedRoles: [__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.unknown, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.accountManager]
    }
  }, {
    path: '/update-password/:token',
    component: __WEBPACK_IMPORTED_MODULE_21__components_authorization_UpdatePassword_vue__["a" /* default */],
    meta: { requiresAuth: false }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.path,
    name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.name,
    component: __WEBPACK_IMPORTED_MODULE_15__views_managerDashboard_ManagerDashboard_vue__["a" /* default */],
    redirect: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.dashboard.path,
    children: [{
      path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.dashboard.path,
      name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.dashboard.name,
      component: __WEBPACK_IMPORTED_MODULE_31__views_manager_clientView_Dashboard_vue__["a" /* default */]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.manage.path,
      name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.manage.name,
      component: __WEBPACK_IMPORTED_MODULE_32__views_manager_clientView_Manage_vue__["a" /* default */]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.plan.path,
      name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.plan.name,
      component: __WEBPACK_IMPORTED_MODULE_33__views_manager_clientView_Plan_vue__["a" /* default */]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.path,
      name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.name,
      component: __WEBPACK_IMPORTED_MODULE_34__views_manager_clientView_Reports_vue__["a" /* default */],
      redirect: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.children.upcoming.path,
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.children.completed.path,
        name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.children.completed.name,
        component: __WEBPACK_IMPORTED_MODULE_40__components_eventManagement_reports_CompletedReport_vue__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.children.upcoming.path,
        name: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].clientDashboard.children.reports.children.upcoming.name,
        component: __WEBPACK_IMPORTED_MODULE_39__components_eventManagement_reports_UpcommingReport_vue__["a" /* default */]
      }]
    }]
  }, {
    path: '/user',
    name: 'user',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_5__containers_Full_vue__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'userDashboard',
      component: __WEBPACK_IMPORTED_MODULE_22__views_dashboard_Dashboard_vue__["a" /* default */]
    }, {
      path: 'events',
      name: 'userEvent',
      redirect: 'drafts',
      component: __WEBPACK_IMPORTED_MODULE_23__views_Drafts_vue__["a" /* default */]
    }, {
      path: 'drafts',
      name: 'userDrafts',
      component: __WEBPACK_IMPORTED_MODULE_23__views_Drafts_vue__["a" /* default */]
    }, {
      path: 'submitted',
      name: 'userSubmitted',
      component: __WEBPACK_IMPORTED_MODULE_27__views_Submitted_vue__["a" /* default */]
    }, {
      path: 'review',
      name: 'userReview',
      component: __WEBPACK_IMPORTED_MODULE_26__views_Review_vue__["a" /* default */]
    }, {
      path: 'approved',
      name: 'userApproved',
      component: __WEBPACK_IMPORTED_MODULE_25__views_Approved_vue__["a" /* default */]
    }, {
      path: 'archived',
      name: 'userArchived',
      component: __WEBPACK_IMPORTED_MODULE_24__views_Archived_vue__["a" /* default */]
    }, {
      path: 'deleted',
      name: 'userDeleted',
      component: __WEBPACK_IMPORTED_MODULE_28__views_Deleted_vue__["a" /* default */]
    }, {
      path: 'drafts/:eventId',
      name: 'userDraftsEventId',
      component: __WEBPACK_IMPORTED_MODULE_23__views_Drafts_vue__["a" /* default */]
    }, {
      path: 'submitted/:eventId',
      name: 'userSubmittedEventId',
      component: __WEBPACK_IMPORTED_MODULE_27__views_Submitted_vue__["a" /* default */]
    }, {
      path: 'review/:eventId',
      name: 'userReviewEventId',
      component: __WEBPACK_IMPORTED_MODULE_26__views_Review_vue__["a" /* default */]
    }, {
      path: 'approved/:eventId',
      name: 'userApprovedEventId',
      component: __WEBPACK_IMPORTED_MODULE_25__views_Approved_vue__["a" /* default */]
    }, {
      path: 'archived/:eventId',
      name: 'userArchivedEventId',
      component: __WEBPACK_IMPORTED_MODULE_24__views_Archived_vue__["a" /* default */]
    }]
  }, {
    path: '/manager',
    name: 'manager',
    redirect: 'manager/dashboard',
    meta: {
      requiresAuth: false,
      deniedRoles: [__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.unknown]
    },
    component: __WEBPACK_IMPORTED_MODULE_7__containers_manager_Dashboard_vue__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'ManagerDashboard',
      component: __WEBPACK_IMPORTED_MODULE_8__views_manager_DashboardManager_vue__["a" /* default */]
    }, {
      path: 'calendar',
      name: 'ManagerCalendar',
      component: __WEBPACK_IMPORTED_MODULE_10__views_manager_Calendar_vue__["a" /* default */]
    }, {
      path: 'events',
      name: 'ManagerEvent',
      component: __WEBPACK_IMPORTED_MODULE_9__views_manager_EventsManager_vue__["a" /* default */]
    }, {
      path: 'plan-and-approve',
      name: 'PlanAndApprove',
      component: __WEBPACK_IMPORTED_MODULE_11__views_manager_PlanAndApprove_vue__["a" /* default */]
    }, {
      path: 'manage',
      name: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.manageApprovedDashboard,
      component: __WEBPACK_IMPORTED_MODULE_12__views_manager_ManageApproved_vue__["a" /* default */]
    }, {
      path: 'staffing',
      name: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.staffing,
      component: __WEBPACK_IMPORTED_MODULE_37__views_manager_staffing_StaffingSection_vue__["a" /* default */]
    }, {
      path: 'setting',
      name: 'globalSettings',
      component: __WEBPACK_IMPORTED_MODULE_36__views_manager_globalSettings_GlobalSettings_vue__["a" /* default */]
    }, {
      path: 'users',
      name: 'managerUsers',
      component: __WEBPACK_IMPORTED_MODULE_35__views_manager_userManagement_UserManagement_vue__["a" /* default */]
    }]
  }, {
    path: '/event/:eventId',
    name: 'EventContainer',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_6__containers_Event_vue__["a" /* default */],
    redirect: 'event/:eventId/details',
    children: [{
      path: 'details',
      name: 'ManageEventDetail',
      component: __WEBPACK_IMPORTED_MODULE_13__views_event_ManageEventDetail_vue__["a" /* default */]
    }, {
      path: 'email-histories',
      name: 'EmailHistoriesManagement',
      component: __WEBPACK_IMPORTED_MODULE_17__views_email_EmailHistoriesManagement_vue__["a" /* default */]
    }, {
      path: 'email',
      name: 'ManageEmail',
      component: __WEBPACK_IMPORTED_MODULE_16__views_email_ManageEmail_vue__["a" /* default */]
    }, {
      path: 'email-history-details/:id',
      name: 'EmailHistoryDetailsManagement',
      component: __WEBPACK_IMPORTED_MODULE_19__views_email_EmailHistoryDetails_vue__["a" /* default */]
    }, {
      path: 'staffing',
      name: 'EventStaffingDetail',
      component: __WEBPACK_IMPORTED_MODULE_38__views_staffing_EventStaffingDetail_vue__["a" /* default */]
    }, {
      path: 'related-events',
      name: 'ManageRelatedEvent',
      component: __WEBPACK_IMPORTED_MODULE_18__views_event_ManageRelatedEvents_vue__["a" /* default */]
    }]
  }, {
    path: '/scheduler-config/:clientId',
    name: 'SchedulerConfiguration',
    component: __WEBPACK_IMPORTED_MODULE_14__views_schedulerConfig_SchedulerConfiguration_vue__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    __WEBPACK_IMPORTED_MODULE_41__aws_amplify_auth__["a" /* default */].currentAuthenticatedUser().then(function () {
      if (to.matched.some(function (record) {
        return record.meta.deniedRoles && record.meta.deniedRoles.indexOf(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role)) >= 0;
      })) {
        next();
      } else {
        next({ path: '/login', query: { redirect: to.fullPath } });
      }
    }).catch(function () {
      next({ path: '/login', query: { redirect: to.fullPath } });
    });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 1165 */,
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Oauth2LoginSuccess_vue__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1b8edca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Oauth2LoginSuccess_vue__ = __webpack_require__(1272);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Oauth2LoginSuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1b8edca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Oauth2LoginSuccess_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/login/Oauth2LoginSuccess.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Oauth2LoginSuccess.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c1b8edca", Component.options)
  } else {
    hotAPI.reload("data-v-c1b8edca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_auth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_oauth2_constants__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_constants__ = __webpack_require__(83);

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Oauth2LoginSuccess',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    createUserIfNotExist: __WEBPACK_IMPORTED_MODULE_4__store_modules_oauth2_constants__["a" /* CREATE_USER_IF_NOT_EXIST */]
  })),
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__["e" /* Hub */].listen('auth', function (data) {
      if (data.payload.event === 'signIn') {
        __WEBPACK_IMPORTED_MODULE_1__aws_amplify_auth__["a" /* default */].currentAuthenticatedUser().then(function (user) {
          _this.createUserIfNotExist({ idToken: user.getSignInUserSession().getIdToken().getJwtToken() }, { skipAuthen: true }).then(function (response) {
            var role = response.role;
            // Save all info to local storage
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.userId, response.userId);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.role, response.role);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.userName, response.userName);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.googleAPIKey, response.googleAPIKey);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.addOns, response.addOns);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.isBingMap, response.useBingMap);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.isShiftboardEnabled, response.isShiftboardEnabled);
            if ([__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.accountManager, __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.eventManager, __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.admin].indexOf(response.role) < 0) {
              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.clientId, response.clientId);
            } else {
              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.clientId, 0);
            }

            if ([__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.client].indexOf(response.role) < 0) {
              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.clientName, 'CHOOSE CLIENT');
            } else {
              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.clientName, response.clientName);
              // state.clientName = response.clientName;
            }
            if ([__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.clientManager, __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.accountManager, __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.eventManager, __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.admin].indexOf(role) >= 0) {
              _this.$toast.success('Login successful', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
              _this.$router.push('/manager');
              // this.$router.replace(constants.routeDirect.managerDashboard);
            } else if (__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].USER_ROLE.client === role) {
              _this.$toast.success('Login successful', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
              // this.$router.replace(constants.routeDirect.clientDashboard);
              _this.$router.push({
                name: __WEBPACK_IMPORTED_MODULE_6__router_constants__["a" /* default */].clientDashboard.name,
                params: {
                  clientId: response.clientId
                }
              });
            } else {
              _this.$toast.error('You do NOT have permission to login', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
              __WEBPACK_IMPORTED_MODULE_1__aws_amplify_auth__["a" /* default */].signOut().then(function () {
                console.log('logout');
              }).catch(function (error) {
                return console.log('error', error);
              });
              _this.doLogout().then(function () {
                _this.disconnetWM();
                return _this.$router.go('/login');
              });
            }
          });
          // this.$router.push('/afterAuth');
        }).catch(function () {
          return console.log('Not signed in');
        });
      } else {
        console.log('ELSE');
      }
    });
  }
});

/***/ }),
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect"},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics"},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService"},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService"}}

/***/ }),
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"Sc":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sh":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"output":{"shape":"Sj"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Su"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sj"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sz"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Su"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sg"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"LoginsToRemove":{"shape":"Sv"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sj"},"output":{"shape":"Sj"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"Su":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sv"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"map","key":{},"value":{}},"S1b":{"type":"map","key":{},"value":{}},"S1d":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */
/***/ (function(module, exports) {

module.exports = {"_from":"@aws-amplify/core@^1.2.4","_id":"@aws-amplify/core@1.3.3","_inBundle":false,"_integrity":"sha512-NyJii+PvZ1Sb1j7w1XWJpRr9nDjB60bjb+FspCRAWjdwlxgVgpCQdhXE4F4teUtLUd22Po2boxLkyhKnuI0jwg==","_location":"/@aws-amplify/core","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"@aws-amplify/core@^1.2.4","name":"@aws-amplify/core","escapedName":"@aws-amplify%2fcore","scope":"@aws-amplify","rawSpec":"^1.2.4","saveSpec":null,"fetchSpec":"^1.2.4"},"_requiredBy":["#DEV:/","/@aws-amplify/auth","/@aws-amplify/cache"],"_resolved":"https://registry.npmjs.org/@aws-amplify/core/-/core-1.3.3.tgz","_shasum":"bdc7a84d31845c7d23e4bd3079cdd6502569f525","_spec":"@aws-amplify/core@^1.2.4","_where":"/home/ems-frontend/cms","author":{"name":"Amazon Web Services"},"bugs":{"url":"https://github.com/aws/aws-amplify/issues"},"bundleDependencies":false,"dependencies":{"aws-sdk":"2.518.0","url":"^0.11.0"},"deprecated":false,"description":"Core category of aws-amplify","devDependencies":{"find":"^0.2.7","prepend-file":"^1.3.1","prettier":"^1.7.4","typescript":"^3.2.2"},"gitHead":"4f1eaade7017d4af91dcee049cadd7501c6db836","homepage":"https://aws-amplify.github.io/","jest":{"globals":{"ts-jest":{"diagnostics":false,"tsConfig":{"lib":["es5","es2015","dom","esnext.asynciterable","es2017.object"],"allowJs":true}}},"transform":{"^.+\\.(js|jsx|ts|tsx)$":"ts-jest"},"testRegex":"(/__tests__/.*|\\.(test|spec))\\.(tsx?|jsx?)$","moduleFileExtensions":["ts","tsx","js","json","jsx"],"testEnvironment":"jsdom","coverageThreshold":{"global":{"branches":0,"functions":0,"lines":0,"statements":0}},"testURL":"http://localhost/","coveragePathIgnorePatterns":["/node_modules/"]},"license":"Apache-2.0","main":"./index.js","module":"./lib-esm/index.js","name":"@aws-amplify/core","publishConfig":{"access":"public"},"react-native":{"./lib/ClientDevice":"./lib/ClientDevice/reactnative.js","./lib/RNComponents":"./lib/RNComponents/reactnative.js","./lib/StorageHelper":"./lib/StorageHelper/reactnative.js"},"repository":{"type":"git","url":"git+https://github.com/aws-amplify/amplify-js.git"},"scripts":{"build":"npm run clean && npm run build:esm && npm run build:cjs","build-with-test":"npm test && npm run build","build:cjs":"node ./build es5 && webpack && webpack --config ./webpack.config.dev.js","build:esm":"node ./build es6","clean":"rimraf lib-esm lib dist","format":"echo \"Not implemented\"","lint":"tslint 'src/**/*.ts'","test":"tslint 'src/**/*.ts' && jest -w 1 --coverage"},"typings":"./lib-esm/index.d.ts","version":"1.3.3"}

/***/ }),
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-secondary",
          staticStyle: { width: "5rem", height: "5rem" },
          attrs: { role: "status" }
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c1b8edca", esExports)
  }
}

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8174f406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(1590);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1274)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8174f406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/containers/Full.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Full.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8174f406", Component.options)
  } else {
    hotAPI.reload("data-v-8174f406", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1275);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("07bcfccc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8174f406\",\"scoped\":false,\"hasInlineConfig\":false}!./vue-multiselect.min.css", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8174f406\",\"scoped\":false,\"hasInlineConfig\":false}!./vue-multiselect.min.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\nfieldset[disabled] .multiselect{pointer-events:none\n}\n.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block\n}\n.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;-webkit-box-shadow:0 0 0 1px transparent;box-shadow:0 0 0 1px transparent\n}\n.multiselect__spinner:before{-webkit-animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite\n}\n.multiselect__spinner:after{-webkit-animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite\n}\n.multiselect__loading-enter-active,.multiselect__loading-leave-active{-webkit-transition:opacity .4s ease-in-out;transition:opacity .4s ease-in-out;opacity:1\n}\n.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0\n}\n.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation\n}\n.multiselect{-webkit-box-sizing:content-box;box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e\n}\n.multiselect *{-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.multiselect:focus{outline:none\n}\n.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6\n}\n.multiselect--active{z-index:50\n}\n.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0\n}\n.multiselect--active .multiselect__select{-webkit-transform:rotate(180deg);transform:rotate(180deg)\n}\n.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0\n}\n.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;-webkit-transition:border .1s ease;transition:border .1s ease;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:8px;vertical-align:top\n}\n.multiselect__input:-ms-input-placeholder{color:#35495e\n}\n.multiselect__input::-webkit-input-placeholder{color:#35495e\n}\n.multiselect__input::-moz-placeholder{color:#35495e\n}\n.multiselect__input::placeholder{color:#35495e\n}\n.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto\n}\n.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf\n}\n.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none\n}\n.multiselect__single{padding-left:5px;margin-bottom:8px\n}\n.multiselect__tags-wrap{display:inline\n}\n.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px\n}\n.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis\n}\n.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;-webkit-transition:all .2s ease;transition:all .2s ease;border-radius:5px\n}\n.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px\n}\n.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e\n}\n.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff\n}\n.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8\n}\n.multiselect__current,.multiselect__select{line-height:16px;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer\n}\n.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease, -webkit-transform .2s ease\n}\n.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"\n}\n.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px\n}\n.multiselect--active .multiselect__placeholder{display:none\n}\n.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch\n}\n.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top\n}\n.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8\n}\n.multiselect__content::webkit-scrollbar{display:none\n}\n.multiselect__element{display:block\n}\n.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap\n}\n.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px\n}\n.multiselect__option--highlight{background:#41b883;outline:none;color:#fff\n}\n.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff\n}\n.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700\n}\n.multiselect__option--selected:after{content:attr(data-selected);color:silver\n}\n.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff\n}\n.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff\n}\n.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6\n}\n.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none\n}\n.multiselect__option--group{background:#ededed;color:#35495e\n}\n.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff\n}\n.multiselect__option--group.multiselect__option--highlight:after{background:#35495e\n}\n.multiselect__option--disabled.multiselect__option--highlight{background:#dedede\n}\n.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff\n}\n.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff\n}\n.multiselect-enter-active,.multiselect-leave-active{-webkit-transition:all .15s ease;transition:all .15s ease\n}\n.multiselect-enter,.multiselect-leave-active{opacity:0\n}\n.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top\n}\n[dir=rtl] .multiselect{text-align:right\n}\n[dir=rtl] .multiselect__select{right:auto;left:1px\n}\n[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px\n}\n[dir=rtl] .multiselect__content{text-align:right\n}\n[dir=rtl] .multiselect__option:after{right:auto;left:0\n}\n[dir=rtl] .multiselect__clear{right:auto;left:12px\n}\n[dir=rtl] .multiselect__spinner{right:auto;left:1px\n}\n@-webkit-keyframes spinning{\n0%{-webkit-transform:rotate(0);transform:rotate(0)\n}\nto{-webkit-transform:rotate(2turn);transform:rotate(2turn)\n}\n}\n@keyframes spinning{\n0%{-webkit-transform:rotate(0);transform:rotate(0)\n}\nto{-webkit-transform:rotate(2turn);transform:rotate(2turn)\n}\n}", ""]);

// exports


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DashCards__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dash__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_Modal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_FaqModal__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_AddonsModal__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_HistoryModal__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_ModalChangeOrderDetail__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modal_ModalInfo__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal_ModalEditEventDetail_vue__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_commons__ = __webpack_require__(262);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_10__components_commons__["e" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_10__components_commons__["h" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_10__components_commons__["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_10__components_commons__["d" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_10__components_commons__["b" /* Breadcrumb */],
    DashCard: __WEBPACK_IMPORTED_MODULE_1__components_DashCards__["a" /* default */],
    EventModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_Modal__["a" /* default */],
    FaqModal: __WEBPACK_IMPORTED_MODULE_4__components_modal_FaqModal__["a" /* default */],
    AddonsModal: __WEBPACK_IMPORTED_MODULE_5__components_modal_AddonsModal__["a" /* default */],
    HistoryModal: __WEBPACK_IMPORTED_MODULE_6__components_modal_HistoryModal__["a" /* default */],
    ModalChangeOrderDetail: __WEBPACK_IMPORTED_MODULE_7__components_modal_ModalChangeOrderDetail__["a" /* default */],
    ModalInfo: __WEBPACK_IMPORTED_MODULE_8__components_modal_ModalInfo__["a" /* default */],
    ModalEditEventDetail: __WEBPACK_IMPORTED_MODULE_9__components_modal_ModalEditEventDetail_vue__["a" /* default */]
  },
  data: function data() {
    return {
      userRole: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].userRole,
      userName: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].userName,
      dashCards: __WEBPACK_IMPORTED_MODULE_2__dash__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('ACTION_GET_EVENT_COUNT');
  }
});

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1278);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7d025797", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-22bba277\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DashCards.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-22bba277\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DashCards.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.dash-card[data-v-22bba277] {\n  height: 260px;\n  float: left;\n}\n.dash-card .rectangle[data-v-22bba277] {\n  height: 220px;\n  width: 351px;\n  border-radius: 3px;\n  background-color: #ffffff;\n  margin: 20px;\n  -webkit-box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.dash-card .rectangle[data-v-22bba277]:hover {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  margin-top: 17px;\n  margin-bottom: 23px;\n  -webkit-transition: all 120ms cubic-bezier(0.59, 0, 0.445, 0.995);\n  transition: all 120ms cubic-bezier(0.59, 0, 0.445, 0.995);\n}\n.dash-card .rectangle .dash-card-content .dash-card-number[data-v-22bba277] {\n  font-size: 5em;\n  text-align: center;\n  color: #231f20;\n  margin-top: 20px;\n}\n.alignTextMarginLeft[data-v-22bba277] {\n  margin-left: 15px;\n  cursor: pointer;\n}\n.borderRadius[data-v-22bba277] {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  height: 46px;\n}\n.paddingTop7px[data-v-22bba277] {\n  padding-top: 7px;\n}\n.content-dashboard-card[data-v-22bba277]:hover {\n  color: #231f20;\n}\n.paddingTop5px[data-v-22bba277] {\n  padding-top: 5px;\n}\n.header-card[data-v-22bba277]:hover {\n  color: #ffffff;\n}\n", ""]);

// exports


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeader',
  props: {
    dashItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS'
  })),
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    _vm._l(_vm.dashItems, function(item, index) {
      return _c("div", { staticClass: "dash-card" }, [
        _c(
          "div",
          { staticClass: "rectangle" },
          [
            [
              _c("router-link", { attrs: { to: item.url } }, [
                _c(
                  "div",
                  {
                    staticClass: "borderRadius",
                    style: { backgroundColor: item.color }
                  },
                  [
                    _c("div", { staticClass: "paddingTop5px" }, [
                      _c(
                        "a",
                        {
                          staticClass: " header-card alignTextMarginLeft",
                          attrs: { href: item.url }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div")
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dash-card-content" }, [
                  _c("div", { staticClass: "paddingTop7px" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "content-dashboard-card alignTextMarginLeft",
                        attrs: { href: item.url }
                      },
                      [_vm._v(_vm._s(item.description))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dash-card-number" }, [
                    _vm._v(_vm._s(_vm.countEventByStatus(item.eventStatus)))
                  ])
                ])
              ])
            ]
          ],
          2
        )
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22bba277", esExports)
  }
}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1282);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b6cfe764", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-59073bd1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-59073bd1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.event-modal {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n.event-modal.modal-change-order-detail .v--modal-box {\n  overflow-y: scroll;\n}\n.event-modal .modal-header {\n  padding: 0;\n  border: 0;\n  border-bottom: 1px solid #c2cfd6;\n  width: 85%;\n  margin: 0 auto;\n}\n.event-modal .modal-header .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #E6E6E6;\n}\n.event-modal .modal-header .modal-header-text {\n  margin-top: 50px;\n  height: 29px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.event-modal .modal-header .modal-header-change-order-text {\n  margin-top: 25px;\n  margin-left: 25px;\n  height: 29px;\n  width: auto;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.event-modal .modal-header .modal-header-line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #e6e6e6;\n}\n.event-modal .modal-body {\n  height: auto;\n  width: 85%;\n  margin: 0 auto;\n  padding: 20px 0 0 0;\n}\n.event-modal .modal-body .modal-body-text {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.event-modal .modal-body .modal-body-text-li {\n  margin-top: 20px;\n}\n.event-modal .modal-body-changeOrderDetail .modal-body-changeOrderDetail-text {\n  margin-top: 25px;\n  margin-left: 25px;\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 14px;\n}\n.event-modal .modal-body-changeOrderDetail .modal-body-changeOrderDetail-event-detail {\n  margin: 26px 0 0 0;\n}\n.event-modal .modal-footer {\n  /*position: absolute;*/\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  float: right;\n  border: 0;\n}\n.event-modal .modal-footer .modal-btn-left {\n  border-radius: 4px;\n  margin-left: 15px;\n  margin-bottom: 50px;\n  margin-top: 30px;\n}\n.event-modal .modal-footer .modal-btn-left .modal-btn-left-text {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  text-transform: uppercase;\n}\n.event-modal .modal-footer .modal-btn-right {\n  border-radius: 4px;\n  margin-right: 50px;\n  margin-bottom: 50px;\n  margin-top: 30px;\n}\n.event-modal .modal-footer .modal-btn-right .modal-btn-right-text {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  text-transform: uppercase;\n}\n", ""]);

// exports


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddClientModal__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResetPasswordModal__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuggestChanges__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChangeOrder__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangeSubmitted__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmitEventModal__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ApproveEvent__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DeleteEvent__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SubmitAllEventEmptyFieldsError__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SubmitAllEvent90DaysError__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SubmitAllEventEmptyFieldsAnd90DaysError__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EventTimeInvalid__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalBodyWithErrorCodes__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UserInfo__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalInfoBody__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ForceUserResetPassword__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__globalSettings_AddValidator__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__MoveEvent__ = __webpack_require__(1430);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















var _ = __webpack_require__(32);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    SuggestChanges: __WEBPACK_IMPORTED_MODULE_6__SuggestChanges__["a" /* default */], // belong with submitted
    ChangeOrder: __WEBPACK_IMPORTED_MODULE_7__ChangeOrder__["a" /* default */], // belong  with approved
    ChangeSubmitted: __WEBPACK_IMPORTED_MODULE_8__ChangeSubmitted__["a" /* default */],
    SubmitEventModal: __WEBPACK_IMPORTED_MODULE_9__SubmitEventModal__["a" /* default */], // belong with drafts
    ApproveEvent: __WEBPACK_IMPORTED_MODULE_10__ApproveEvent__["a" /* default */],
    DeleteEvent: __WEBPACK_IMPORTED_MODULE_11__DeleteEvent__["a" /* default */],
    SubmitAllEventEmptyFieldsError: __WEBPACK_IMPORTED_MODULE_12__SubmitAllEventEmptyFieldsError__["a" /* default */],
    EventTimeInvalid: __WEBPACK_IMPORTED_MODULE_15__EventTimeInvalid__["a" /* default */],
    ModalInfoBody: __WEBPACK_IMPORTED_MODULE_18__ModalInfoBody__["a" /* default */],
    SubmitAllEvent90DaysError: __WEBPACK_IMPORTED_MODULE_13__SubmitAllEvent90DaysError__["a" /* default */],
    SubmitAllEventEmptyFieldsAnd90DaysError: __WEBPACK_IMPORTED_MODULE_14__SubmitAllEventEmptyFieldsAnd90DaysError__["a" /* default */],
    ModalBodyWithErrorCodes: __WEBPACK_IMPORTED_MODULE_16__ModalBodyWithErrorCodes__["a" /* default */],
    AddClient: __WEBPACK_IMPORTED_MODULE_4__AddClientModal__["a" /* default */],
    UserInfo: __WEBPACK_IMPORTED_MODULE_17__UserInfo__["a" /* default */],
    ResetPasswordModal: __WEBPACK_IMPORTED_MODULE_5__ResetPasswordModal__["a" /* default */],
    MoveEvent: __WEBPACK_IMPORTED_MODULE_23__MoveEvent__["a" /* default */],
    ForceUserResetPassword: __WEBPACK_IMPORTED_MODULE_19__ForceUserResetPassword__["a" /* default */],
    AddValidator: __WEBPACK_IMPORTED_MODULE_20__globalSettings_AddValidator__["a" /* default */]
  },
  data: function data() {
    return {
      actionTypes: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction,
      modalData: {},
      actionData: {},
      isCancel: false,
      modalBodies: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalBodies,
      clientInfo: {
        clientName: '',
        firstName: '',
        lastName: '',
        email: '',
        errorMessage: ''
      },
      resetPasswordInfo: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        userId: null
      },
      dataBackup: null,
      disableButtonRight: false,
      moveEventData: {
        eventId: '',
        eventName: '',
        updateStatus: ''
      },
      modalDataValid: true,
      userId: '',
      validatorInfo: {},
      callback: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.clientInfo = {
        clientName: '',
        firstName: '',
        lastName: '',
        email: '',
        errorMessage: '',
        isDisable: false
      };
      this.resetPasswordInfo = {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        userId: null
      };
      this.isCancel = true;
      this.$modal.hide('eventModal');
      this.disableButtonRight = false;
    },
    beforeOpen: function beforeOpen(event) {
      console.log('modal', event.params);
      this.modalData = __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
      this.callback = event.params.callback;
      this.dataBackup = _.cloneDeep(event.params.data);
      if (event.params.action === this.actionTypes.createUser) {
        this.actionData = {
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          client: null,
          role: ''
        };
      }
      if (event.params.action === this.actionTypes.moveEvent) {
        this.moveEventData = event.params.data;
      }
      if (event.params.action === this.actionTypes.forceUserResetPassword) {
        this.userId = this.actionData.id;
      }
      if (event.params.action === this.actionTypes.addClient) {
        this.clientInfo = {
          clientName: '',
          firstName: '',
          lastName: '',
          email: '',
          errorMessage: ''
        };
      }
      if (event.params.action === this.actionTypes.createValidator) {
        this.validatorInfo = {
          name: '',
          field: ''
        };
      }
      if (event.params.action === this.actionTypes.editValidator) {
        this.validatorInfo = event.params.data;
      }
    },
    btnAction: function btnAction() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var modalData, actionTypes, role, event, _event, data, isClosedModal, _data, body, _data2, _body, _data3, _body2;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                modalData = _this.modalData;
                actionTypes = __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction;
                // submit event => event move to Submitted folder

                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.submitEvent) {
                  if (_this.actionData.id === null || _this.actionData.id === undefined) {
                    // submit all event
                    _this.submitAllEvent();
                  } else {
                    role = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.role);

                    if (role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.eventManager || role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.admin) {
                      event = _.cloneDeep(_this.actionData);

                      event.isChangeOrder = false;
                      _this.approveEvent(event);
                    }
                    // else {
                    //   let event = _.cloneDeep(this.actionData);
                    //   event.status = consts.eventStatus.submitted.toUpperCase();
                    //   this.submitEvent(event);
                    // }
                  }
                }
                // delete event
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.deleteEvent) {
                  _this.callback ? _this.callback() : _this.deleteEvent(_this.actionData);
                }
                // change order => event move from Approved to Drafts
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.changeOrder) {
                  _event = {};

                  if (_this.actionData.eventDetail) {
                    _event = _.cloneDeep(_this.actionData.eventDetail);
                  } else {
                    _event = _.cloneDeep(_this.actionData);
                  }
                  data = {
                    action: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.changeOrderDetail,
                    data: _event
                  };

                  _this.$modal.show('ModalChangeOrder', data);
                }
                // false => close Modal, true => stay in modal
                isClosedModal = false;
                // add client

                if (!(_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.addClient)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this.addClient(_this.clientInfo).then(function (response) {
                  if (response && response.message) {
                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('error', response.message ? response.message : 'Unsuccessfully adding new client', '');
                    isClosedModal = true;
                  } else {
                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('info', 'Successfully adding new client', '');
                    isClosedModal = false;
                  }
                  _this.setMessageError('');
                });

              case 9:
                if (!(_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.createUser)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return _this.$children[0].$children[0].validateData().then(function () {
                  if (!_this.actionData.modalDataValid) {
                    isClosedModal = true;
                    return;
                  }
                  _this.actionData.client = {
                    id: _this.actionData.clientId,
                    clientName: _this.actionData.clientName
                  };
                  _this.createUser(_this.actionData);
                  isClosedModal = false;
                });

              case 12:
                if (!(_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.editUser)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return _this.$children[0].$children[0].validateData().then(function () {
                  if (!_this.actionData.modalDataValid) {
                    isClosedModal = true;
                    return;
                  }
                  var data = _this.actionData;
                  var body = {
                    id: data.id,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    role: data.role,
                    phoneNumber: data.phoneNumber,
                    email: data.email,
                    client: {
                      id: data.role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.client ? data.client.id : 0,
                      clientName: data.role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.client ? data.client.clientName : ''
                    }
                  };
                  _this.editUser(body);
                  isClosedModal = false;
                });

              case 15:

                // create validator
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.createValidator) {
                  _data = _this.validatorInfo;
                  body = {
                    name: _data.name,
                    field: _data.field
                  };

                  _this.createValidator(body).then(function (response) {
                    if (response.message === null) {
                      _this.getAllValidatorAfterUpdateOrCreate();
                    }
                  });
                }

                // update validator
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.editValidator) {
                  _data2 = _this.actionData;
                  _body = {
                    id: _data2.id,
                    name: _data2.name,
                    field: _data2.field
                  };

                  _this.updateValidator(_body).then(function (response) {
                    if (response.message === null) {
                      _this.getAllValidatorAfterUpdateOrCreate();
                    }
                  });
                }

                // delete validator
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.deleteValidator) {
                  _data3 = _this.actionData;

                  _this.deleteValidator(_data3.id).then(function (response) {
                    if (response.message === null) {
                      _this.getAllValidatorAfterUpdateOrCreate();
                    }
                  });
                }

                // move event
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.moveEvent) {
                  _this.moveEvent({ eventId: _this.moveEventData.eventId, status: _this.moveEventData.updateStatus.toUpperCase() });
                }

                // delete user
                if (modalData.modalAction === actionTypes.deleteUser) {
                  _this.deleteUser({ id: _this.actionData.id }).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('success', 'Delete user successfully', '');
                  }, function () {
                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('error', 'Internal server error.', '');
                  });
                }

                // EM or Admin forces user to reset password
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.forceUserResetPassword) {
                  _this.forceResetPassword(_this.userId);
                }

                // Delete Client
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.deleteClient) {
                  _body2 = {
                    id: _this.actionData.id
                  };

                  _this.deleteClient(_body2).then(function (response) {
                    _this.$toast.success('Client ' + _this.actionData.clientName + ' has been deleted.', '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
                    setTimeout(function () {
                      window.location.reload();
                    }, 2000);
                  }).catch(function () {
                    _this.$toast.success('Can not delete client ' + _this.actionData.clientName, '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optError));
                  });
                }

                // Reset password
                if (_this.modalData.modalAction === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.resetPassword) {
                  _this.resetPassword(_this.resetPasswordInfo).then(function (response) {
                    if (response && response.message) {
                      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('error', response.message, '');
                      isClosedModal = true;
                    } else {
                      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('success', 'Change password successful', '');
                      isClosedModal = false;
                    }
                    _this.setMessageError('');
                    if (!isClosedModal) {
                      _this.$modal.hide('eventModal');
                    }
                  });
                } else {
                  _this.isCancel = false;
                  if (_this.modalData.modalAction !== _this.actionTypes.eventDurationRestricted) {
                    _this.setExpandId({ id: -1, isExpand: false });
                  }
                  _this.setMessageError('');
                  if (!isClosedModal) {
                    _this.$modal.hide('eventModal');
                  }
                }

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_22_vuex__["b" /* mapActions */])({
    addClient: 'ACTION_ADD_CLIENT',
    submitEvent: 'ACTION_SUBMIT_EVENT',
    approveEvent: 'ACTION_APPROVE_EVENT',
    suggestChanges: 'ACTION_SUGGEST_CHANGES',
    deleteEvent: 'ACTION_DELETE_EVENT',
    submitAllEvent: 'ACTION_SUBMIT_ALL_EVENT',
    setExpandId: 'ACTION_SET_EXPAND_ID',
    setMessageError: 'ACTION_SET_MESSAGE_ERROR',
    createUser: 'ACTION_CREATE_USER',
    editUser: 'ACTION_EDIT_USER',
    resetPassword: 'ACTION_CHANGE_PASSWORD',
    moveEvent: 'ACTION_CHANGE_EVENT_STATUS',
    deleteUser: 'ACTION_ACTION_DELETE_USER',
    forceResetPassword: 'ACTION_FORCE_RESET_PASSWORD',
    createValidator: 'ACTION_CREATE_VALIDATOR',
    updateValidator: 'ACTION_UPDATE_VALIDATOR',
    getAllValidatorAfterUpdateOrCreate: 'ACTION_GET_ALL_VALIDATORS',
    deleteValidator: 'ACTION_DELETE_VALIDATOR',
    deleteClient: 'ACTION_DELETE_CLIENT'
  }), {
    beforeClose: function beforeClose() {
      var data = this.dataBackup;
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          this.actionData[key] = data[key];
        }
      }
    },
    setDisableButtonRight: function setDisableButtonRight(isDisable) {
      this.disableButtonRight = isDisable;
    }
  }),
  computed: {
    calculateHeight: function calculateHeight() {
      if (this.modalData.modalAction === this.actionTypes.deleteEvent) {
        return 290;
      }
      return 'auto';
    },
    isChangeOrder: function isChangeOrder() {
      return this.modalData.modalAction === this.actionTypes.changeOrder;
    },
    isDeleteModal: function isDeleteModal() {
      return this.modalData.modalAction === this.actionTypes.deleteEvent;
    },
    showModalBodyMessage: function showModalBodyMessage() {},
    bodyMessage: function bodyMessage() {
      var actionTypes = this.actionTypes;
      var modalData = this.modalData;
      var modalBodies = this.modalBodies;
      if (modalData.modalAction === actionTypes.eventNameNotUnique) {
        return modalBodies.eventNameNotUnique;
      }
      if (modalData.modalAction === actionTypes.someFieldsBlank) {
        return modalBodies.someFieldsBlank;
      }
      if (modalData.modalAction === actionTypes.eventDurationRestricted) {
        return modalBodies.eventDurationRestricted;
      }
      if (modalData.modalAction === actionTypes.readOnly) {
        return modalBodies.readOnly;
      }
      if (modalData.modalAction === actionTypes.deleteUser) {
        return modalBodies.deleteUser;
      }
      if (modalData.modalAction === actionTypes.deleteValidator) {
        return modalBodies.deleteValidator;
      }
      if (modalData.modalAction === actionTypes.emailIsNotValid) {
        return modalBodies.emailIsNotValid;
      }
      if (modalData.modalAction === actionTypes.deleteClient) {
        var result = _.cloneDeep(modalBodies.deleteClient);
        result[0] = result[0].replace('{clientName}', this.actionData.clientName);
        return result;
      }
    },
    bodyMessageWithErrorCode: function bodyMessageWithErrorCode() {
      var messages = [];
      var data = this.actionData;
      for (var prop in data) {
        if (data[prop]) {
          var temp = __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalBodies[prop][0];
          messages.push(temp);
        }
      }
      return messages;
    }
  }
});

/***/ }),
/* 1284 */,
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddClientModal_vue__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba04e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddClientModal_vue__ = __webpack_require__(1289);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1286)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddClientModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba04e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddClientModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/AddClientModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AddClientModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9ba04e66", Component.options)
  } else {
    hotAPI.reload("data-v-9ba04e66", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1287);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7260ee16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9ba04e66\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddClientModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9ba04e66\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddClientModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.modal-body-user-info {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  margin-bottom: 60px;\n}\n.modal-body-user-info .description {\n  line-height: 14px;\n}\n.modal-body-user-info .input {\n  height: 38px;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  padding-left: 12px;\n}\n.modal-body-user-info .name {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .name .last-name {\n  margin-left: 40px;\n}\n.modal-body-user-info .name .last-name .input {\n  width: 275px;\n}\n.modal-body-user-info .name .first-name .input {\n  width: 275px;\n}\n.modal-body-user-info .email {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .email .input {\n  width: 590px;\n}\n.modal-body-user-info .errorBackground {\n  background-color: #FEE2E2;\n  width: 588px;\n  margin-top: 1px;\n}\n.modal-body-user-info .errorDetail {\n  height: 17px;\n  width: 108px;\n  color: #803939;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 17px;\n  text-align: right;\n  margin-left: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-client-body-modal',
  data: function data() {
    return {};
  },

  props: {
    clientInfo: {
      type: Object,
      default: {}
    }
  },
  methods: {
    isEmail: function isEmail() {
      if (this.clientInfo.email === '') {
        this.$emit('disableBtnRight', true);
        return true;
      }
      var isValidEmail = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].validateEmail(this.clientInfo.email);
      this.$emit('disableBtnRight', !isValidEmail);
      return isValidEmail;
    }
  },
  watch: {
    clientInfo: {
      handler: function handler() {
        if (this.clientInfo.email) {
          this.isEmail(this.clientInfo.email);
        }
      },
      deep: true
    }
  },
  created: function created() {
    this.$emit('disableBtnRight', true);
  }
});

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-user-info" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v("\n    Add a new client by entering the information below.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Client name:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clientInfo.clientName,
              expression: "clientInfo.clientName"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "Client name" },
          domProps: { value: _vm.clientInfo.clientName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clientInfo, "clientName", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name row" }, [
      _c("div", { staticClass: "first-name" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("Client contact first name:")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clientInfo.firstName,
                expression: "clientInfo.firstName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "First Name" },
            domProps: { value: _vm.clientInfo.firstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.clientInfo, "firstName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "last-name" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("Client contact last name:")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clientInfo.lastName,
                expression: "clientInfo.lastName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "Last Name" },
            domProps: { value: _vm.clientInfo.lastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.clientInfo, "lastName", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [
        _vm._v("Client contact's email address:")
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clientInfo.email,
              expression: "clientInfo.email"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "E.g. hannah_welch@gmail.com" },
          domProps: { value: _vm.clientInfo.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clientInfo, "email", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      !_vm.isEmail()
        ? _c("div", { staticClass: "errorBackground" }, [
            _c("span", { staticClass: "errorDetail" }, [
              _vm._v("Invalid email format.")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ba04e66", esExports)
  }
}

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordModal_vue__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2268234f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordModal_vue__ = __webpack_require__(1355);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1291)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2268234f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ResetPasswordModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResetPasswordModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2268234f", Component.options)
  } else {
    hotAPI.reload("data-v-2268234f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1292);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0338b370", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2268234f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ResetPasswordModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2268234f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ResetPasswordModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.modal-body-reset-password {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  margin-bottom: 60px;\n}\n.modal-body-reset-password .description {\n  line-height: 14px;\n}\n.modal-body-reset-password .input {\n  height: 38px;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  padding-left: 12px;\n}\n.modal-body-reset-password .name {\n  margin: 30px 0 0 0;\n}\n.modal-body-reset-password .name .last-name {\n  margin-left: 40px;\n}\n.modal-body-reset-password .name .last-name .input {\n  width: 275px;\n}\n.modal-body-reset-password .name .first-name .input {\n  width: 275px;\n}\n.modal-body-reset-password .field-wrapper {\n  margin: 30px 0 0 0;\n}\n.modal-body-reset-password .field-wrapper .input {\n  width: 590px;\n}\n.modal-body-reset-password .errorBackground {\n  width: 588px;\n  height: 21px;\n  margin-top: 1px;\n}\n.modal-body-reset-password .errorDetail {\n  height: 17px;\n  width: 108px;\n  color: #803939;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 17px;\n  text-align: right;\n  margin-left: 5px;\n}\n.modal-body-reset-password .errorBackgroundColor {\n  background-color: #FEE2E2;\n}\n", ""]);

// exports


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validator__ = __webpack_require__(372);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reset-password-body-modal',
  data: function data() {
    return {
      validatedFields: [],
      isPasswordContainsNumber: true,
      passwordError: [],
      passwordCheckList: {
        length: false,
        lowerCaseChars: false,
        upperCaseChars: false,
        numbers: false,
        specialChars: false
      }
    };
  },

  props: {
    resetPasswordInfo: {
      type: Object,
      default: {}
    }
  },
  computed: {
    hiddenIconPasswordIndicator: function hiddenIconPasswordIndicator() {
      return {
        visibility: this.resetPasswordInfo.newPassword === '' ? 'hidden' : 'visible'
      };
    }
  },
  methods: {
    validateInput: function validateInput(field) {
      var _this = this;

      if (!this.validatedFields.includes(field)) {
        this.validatedFields.push(field);
      }

      this.$validator.validate().then(function (result) {
        var summary = __WEBPACK_IMPORTED_MODULE_2__utils_validator__["a" /* default */].isPasswordValid(_this.resetPasswordInfo.newPassword).summary;
        _this.$emit('disableBtnRight', !(summary && result));
      });
      // this.passwordCheckList = validator.isPasswordValid(this.resetPasswordInfo.newPassword);
    }
  },
  created: function created() {
    this.$emit('disableBtnRight', true);
  },

  watch: {
    'resetPasswordInfo.newPassword': {
      handler: function handler() {
        this.passwordCheckList = __WEBPACK_IMPORTED_MODULE_2__utils_validator__["a" /* default */].isPasswordValid(this.resetPasswordInfo.newPassword).detail;
      }
    }
  }
});

/***/ }),
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-reset-password" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v("\n    Reset password by entering the information below.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Current password:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.resetPasswordInfo.oldPassword,
              expression: "resetPasswordInfo.oldPassword"
            }
          ],
          staticClass: "input",
          attrs: {
            "data-vv-as": "old password",
            name: "oldPassword",
            type: "password"
          },
          domProps: { value: _vm.resetPasswordInfo.oldPassword },
          on: {
            blur: function($event) {
              _vm.validateInput("oldPassword")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.resetPasswordInfo,
                "oldPassword",
                $event.target.value
              )
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "errorBackground",
          class: {
            errorBackgroundColor:
              _vm.errors.has("oldPassword") &&
              _vm.validatedFields.includes("oldPassword")
          }
        },
        [
          _vm.validatedFields.includes("oldPassword")
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("oldPassword"),
                      expression: "errors.has('oldPassword')"
                    }
                  ],
                  staticClass: "errorDetail"
                },
                [_vm._v(_vm._s(_vm.errors.first("oldPassword")))]
              )
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "text" }, [_vm._v("New Password:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.resetPasswordInfo.newPassword,
              expression: "resetPasswordInfo.newPassword"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "input",
          attrs: {
            "data-vv-as": "new password",
            name: "newPassword",
            type: "password"
          },
          domProps: { value: _vm.resetPasswordInfo.newPassword },
          on: {
            blur: function($event) {
              _vm.validateInput("newPassword")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.resetPasswordInfo,
                "newPassword",
                $event.target.value
              )
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "errorBackground",
          class: {
            errorBackgroundColor:
              (_vm.errors.has("newPassword") &&
                _vm.validatedFields.includes("newPassword")) ||
              !_vm.isPasswordContainsNumber
          }
        },
        [
          _vm.validatedFields.includes("newPassword")
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.first("newPassword"),
                      expression: "errors.first('newPassword')"
                    }
                  ],
                  staticClass: "errorDetail"
                },
                [_vm._v(_vm._s(_vm.errors.first("newPassword")))]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isPasswordContainsNumber && !_vm.errors.has("newPassword")
            ? _c("span", { staticClass: "errorDetail" }, [
                _vm._v("The New password must contains at least 1 digit")
              ])
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Confirm New Password:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.resetPasswordInfo.repeatPassword,
              expression: "resetPasswordInfo.repeatPassword"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: {
                required: true,
                confirmed: _vm.resetPasswordInfo.newPassword
              },
              expression:
                "{ required: true, confirmed: resetPasswordInfo.newPassword }"
            }
          ],
          staticClass: "input",
          attrs: {
            type: "password",
            "data-vv-as": "confirm password",
            name: "repeatPassword"
          },
          domProps: { value: _vm.resetPasswordInfo.repeatPassword },
          on: {
            blur: function($event) {
              _vm.validateInput("repeatPassword")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.resetPasswordInfo,
                "repeatPassword",
                $event.target.value
              )
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "errorBackground",
          class: {
            errorBackgroundColor:
              _vm.errors.has("repeatPassword") &&
              _vm.validatedFields.includes("repeatPassword")
          }
        },
        [
          _vm.validatedFields.includes("repeatPassword")
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("repeatPassword"),
                      expression: "errors.has('repeatPassword')"
                    }
                  ],
                  staticClass: "errorDetail"
                },
                [_vm._v(_vm._s(_vm.errors.first("repeatPassword")))]
              )
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "password-check-list" }, [
      _c("div", { staticClass: "password-at-least" }, [
        _vm._v("Password must have at least:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicators-password row" }, [
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.length
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v("8 characters ")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.lowerCaseChars
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v("4 lowercase letters (a-z)")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.upperCaseChars
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v("1 uppercase letter (A-Z)")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.numbers
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v("2 numbers (0-9)")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "indicator-item col-lg-6" }, [
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              style: _vm.hiddenIconPasswordIndicator
            },
            [
              _vm.passwordCheckList.specialChars
                ? _c("div", { staticClass: "icon-reach" })
                : _c("div", { staticClass: "icon-unreach" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v("1 special character")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2268234f", esExports)
  }
}

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuggestChanges_vue__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c455a2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SuggestChanges_vue__ = __webpack_require__(1360);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1357)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuggestChanges_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c455a2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SuggestChanges_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/SuggestChanges.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SuggestChanges.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c455a2b", Component.options)
  } else {
    hotAPI.reload("data-v-1c455a2b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5b83f352", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1c455a2b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SuggestChanges.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1c455a2b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SuggestChanges.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'suggest-changes-body-modal'
});

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "By submitting, you are agreeing that all the details of this event are accurate."
        )
      ]),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("The event will be sent to the client for their approval.")
      ]),
      _c("br"),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c455a2b", esExports)
  }
}

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeOrder_vue__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9626dbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeOrder_vue__ = __webpack_require__(1365);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1362)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9626dbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeOrder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ChangeOrder.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChangeOrder.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b9626dbc", Component.options)
  } else {
    hotAPI.reload("data-v-b9626dbc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2fc56f98", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9626dbc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeOrder.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9626dbc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeOrder.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.modal-event-name {\n  font-weight: 600;\n  color: #0080a5;\n}\n.custom-message {\n  max-height: 400px;\n  overflow-y: auto;\n}\n", ""]);

// exports


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-order-body-modal',
  props: {
    itemName: {
      type: String
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showCustomMessage: function showCustomMessage() {
      var message = this.getMessage;
      return message !== '' && message !== null;
    },
    customMessage: function customMessage() {
      return this.getMessage;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getMessage: 'GETTER_GET_CHANGE_ORDER_MESSAGE'
  }))
});

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.showCustomMessage
      ? _c("div", { staticClass: "modal-body-text" }, [
          _vm._v("You are requesting to change "),
          _c("span", { staticClass: "modal-event-name" }, [
            _vm._v(_vm._s(_vm.itemName))
          ]),
          _vm._v(" after it's been approved. Upon submitting, you agree:")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showCustomMessage
      ? _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body-text modal-body-text-li" }, [
            _vm._v(
              "Continuing to the next screen to change your event will NOT charge you. Submitting your changes will."
            )
          ])
        ])
      : _c(
          "div",
          {
            staticClass: "custom-message modal-body-text",
            domProps: { innerHTML: _vm._s(_vm.customMessage) }
          },
          [_vm._v(_vm._s(_vm.customMessage))]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", { staticClass: "modal-body-text modal-body-text-li" }, [
        _vm._v(
          "To accept your request to change the event must go through approval again"
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "modal-body-text modal-body-text-li" }, [
        _vm._v(
          "That we cannot guarantee your event will be approved for your requested change"
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "modal-body-text modal-body-text-li" }, [
        _vm._v(
          "\n          To pay the fee associated with your contract with ADURO (review for details)\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b9626dbc", esExports)
  }
}

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeSubmitted_vue__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_545d8e4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeSubmitted_vue__ = __webpack_require__(1370);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1367)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeSubmitted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_545d8e4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeSubmitted_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ChangeSubmitted.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChangeSubmitted.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-545d8e4f", Component.options)
  } else {
    hotAPI.reload("data-v-545d8e4f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1368);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a44af254", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-545d8e4f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeSubmitted.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-545d8e4f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeSubmitted.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-submitted-body-modal'
});

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("The changes to your event have been requested.")
      ]),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("ADURO will now review the event for approval.")
      ]),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-545d8e4f", esExports)
  }
}

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitEventModal_vue__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee170212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitEventModal_vue__ = __webpack_require__(1375);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1372)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitEventModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee170212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitEventModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/SubmitEventModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubmitEventModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ee170212", Component.options)
  } else {
    hotAPI.reload("data-v-ee170212", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("215c43ac", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ee170212\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitEventModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ee170212\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitEventModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.modal-event-name {\n  font-weight: 600;\n  color: #0080a5;\n}\n.custom-message {\n  max-height: 300px;\n  overflow-y: auto;\n}\n", ""]);

// exports


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import consts from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submit-event-body-modal',
  props: {
    itemName: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showCustomMessage: function showCustomMessage() {
      var message = this.getMessage;
      return message !== '' && message !== null;
    },
    customMessage: function customMessage() {
      return this.getMessage;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getMessage: 'GETTER_GET_SUBMISSION_MESSAGE'
  }))
});

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", [
    _c("br"),
    _vm._v(" "),
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v(
        "You are submitting " +
          _vm._s(_vm.itemName == "all event" ? "" : "event ") +
          " "
      ),
      _c("span", { staticClass: "modal-event-name" }, [
        _vm._v(_vm._s(_vm.itemName == "all event" ? "all event" : _vm.itemName))
      ]),
      _vm._v(" for approval.")
    ]),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    !_vm.showCustomMessage
      ? _c("div", [
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By submitting this event to ADURO you are agreeing all of the information is accurate\n    and if approved, ADURO will schedule the event."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "If the event is not approved, ADURO will send the event with changes or suggestions\n    back to you."
            )
          ])
        ])
      : _c("div", {
          staticClass: "custom-message modal-body-text",
          domProps: { innerHTML: _vm._s(_vm.customMessage) }
        }),
    _vm._v(" "),
    _c("br"),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee170212", esExports)
  }
}

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveEvent_vue__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220d98d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveEvent_vue__ = __webpack_require__(1380);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1377)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220d98d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveEvent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ApproveEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ApproveEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-220d98d9", Component.options)
  } else {
    hotAPI.reload("data-v-220d98d9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("76e6ab2a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-220d98d9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApproveEvent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-220d98d9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApproveEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-submitted-body-modal'
});

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("Do you want to approve the event?")
      ]),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("CLIENT will be notified that the event was approved.")
      ]),
      _c("br"),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-220d98d9", esExports)
  }
}

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteEvent_vue__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a72725a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteEvent_vue__ = __webpack_require__(1385);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1382)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a72725a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteEvent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/DeleteEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeleteEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a72725a", Component.options)
  } else {
    hotAPI.reload("data-v-0a72725a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1383);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7cc88138", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0a72725a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeleteEvent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0a72725a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DeleteEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delete-body-modal'
});

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "You are about to delete an event. If you choose to continue, you cannot recover your event."
        )
      ]),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("Are you sure you want to continue?")
      ]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a72725a", esExports)
  }
}

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitAllEventEmptyFieldsError_vue__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2655ec9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitAllEventEmptyFieldsError_vue__ = __webpack_require__(1390);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1387)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitAllEventEmptyFieldsError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2655ec9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitAllEventEmptyFieldsError_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/SubmitAllEventEmptyFieldsError.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubmitAllEventEmptyFieldsError.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2655ec9f", Component.options)
  } else {
    hotAPI.reload("data-v-2655ec9f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1388);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0a89ec1e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2655ec9f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitAllEventEmptyFieldsError.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2655ec9f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitAllEventEmptyFieldsError.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submit-all-body-modal'
});

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "Unable to submit some events due to incomplete information. Please fill in required information and continue submitting."
        )
      ]),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("All completed events have been submitted.")
      ]),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2655ec9f", esExports)
  }
}

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitAllEvent90DaysError_vue__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3250e526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitAllEvent90DaysError_vue__ = __webpack_require__(1395);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1392)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitAllEvent90DaysError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3250e526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitAllEvent90DaysError_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/SubmitAllEvent90DaysError.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubmitAllEvent90DaysError.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3250e526", Component.options)
  } else {
    hotAPI.reload("data-v-3250e526", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1393);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("49dfcb4e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3250e526\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitAllEvent90DaysError.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3250e526\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitAllEvent90DaysError.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submit-all-body-modal'
});

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "Normal event scheduling requires 90 days notice, please choose a date that meets these requirements or contact ADURO for assistance scheduling an event sooner."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3250e526", esExports)
  }
}

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitAllEventEmptyFieldsAnd90DaysError_vue__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c4af48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitAllEventEmptyFieldsAnd90DaysError_vue__ = __webpack_require__(1400);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1397)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubmitAllEventEmptyFieldsAnd90DaysError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c4af48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubmitAllEventEmptyFieldsAnd90DaysError_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/SubmitAllEventEmptyFieldsAnd90DaysError.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubmitAllEventEmptyFieldsAnd90DaysError.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55c4af48", Component.options)
  } else {
    hotAPI.reload("data-v-55c4af48", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3cd8abd4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-55c4af48\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitAllEventEmptyFieldsAnd90DaysError.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-55c4af48\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubmitAllEventEmptyFieldsAnd90DaysError.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submit-all-body-modal'
});

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", [_vm._v("Unable to submit some events. Please check for")]),
      _c("br"),
      _vm._v(" "),
      _c("ul", [
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Incomplete information. Please fill in required information and continue submitting"
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Events requested within 90 days. Normal event scheduling requires advanced notice of 90 days. Please choose dates that meet these requirements or contact ADURO for assistance."
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("All completed events have been submitted.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55c4af48", esExports)
  }
}

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventTimeInvalid_vue__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2507508_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventTimeInvalid_vue__ = __webpack_require__(1405);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1402)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventTimeInvalid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2507508_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventTimeInvalid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/EventTimeInvalid.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventTimeInvalid.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b2507508", Component.options)
  } else {
    hotAPI.reload("data-v-b2507508", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1403);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("443f359f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b2507508\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventTimeInvalid.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b2507508\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventTimeInvalid.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-submitted-body-modal'
});

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "Normal event scheduling requires 90 days notice, please choose a date that meets these requirements or contact ADURO for assistance scheduling an event sooner."
        )
      ]),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b2507508", esExports)
  }
}

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBodyWithErrorCodes_vue__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77914b57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBodyWithErrorCodes_vue__ = __webpack_require__(1410);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1407)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBodyWithErrorCodes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77914b57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBodyWithErrorCodes_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalBodyWithErrorCodes.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalBodyWithErrorCodes.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77914b57", Component.options)
  } else {
    hotAPI.reload("data-v-77914b57", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("02979409", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-77914b57\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalBodyWithErrorCodes.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-77914b57\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalBodyWithErrorCodes.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.modal-body li {\n  list-style-type: disc;\n}\n", ""]);

// exports


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-body-show-error-for-submit-all',
  props: {
    messages: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", [
    _c("span", [_vm._v("Unable to submit some events. Please check for")]),
    _c("br"),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.messages, function(message) {
        return _c("li", { staticClass: "modal-body-text" }, [
          _vm._v(_vm._s(message))
        ])
      })
    ),
    _vm._v(" "),
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v("All completed events have been submitted.")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77914b57", esExports)
  }
}

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce69e6b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__ = __webpack_require__(1415);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1412)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce69e6b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/UserInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ce69e6b6", Component.options)
  } else {
    hotAPI.reload("data-v-ce69e6b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d0a2f6c6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ce69e6b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInfo.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ce69e6b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.modal-body-user-info {\n  color: #231F20;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n}\n.modal-body-user-info .description {\n  line-height: 14px;\n}\n.modal-body-user-info .input {\n  height: 38px;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  padding-left: 12px;\n}\n.modal-body-user-info .name {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .name .last-name {\n  margin-left: 40px;\n}\n.modal-body-user-info .name .last-name .input {\n  width: 275px;\n}\n.modal-body-user-info .name .first-name .input {\n  width: 275px;\n}\n.modal-body-user-info .email {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .email .input {\n  width: 590px;\n}\n.modal-body-user-info .phone {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .phone .input {\n  width: 590px;\n}\n.modal-body-user-info .role-client {\n  margin: 30px 0 0 0;\n  height: 150px;\n}\n.modal-body-user-info .role-client .role .input {\n  padding: 0;\n  width: 275px;\n}\n.modal-body-user-info .role-client .role .multiselect {\n  min-height: 38px;\n}\n.modal-body-user-info .role-client .role .multiselect__tags {\n  border: none;\n  min-height: 38px;\n}\n.modal-body-user-info .role-client .role .multiselect__content-wrapper {\n  background-color: none;\n  background: none;\n}\n.modal-body-user-info .role-client .role .multiselect__content-wrapper .multiselect__element:last-child {\n  border-bottom: none;\n}\n.modal-body-user-info .role-client .client {\n  margin-left: 40px;\n}\n.modal-body-user-info .role-client .client .input {\n  padding: 0;\n  width: 275px;\n}\n.modal-body-user-info .role-client .client .multiselect {\n  min-height: 38px;\n}\n.modal-body-user-info .role-client .client .multiselect__tags {\n  border: none;\n  min-height: 38px;\n}\n.modal-body-user-info .role-client .client .multiselect__content-wrapper {\n  background-color: none;\n  background: none;\n}\n.modal-body-user-info .role-client .client .multiselect__content-wrapper .multiselect__element:last-child {\n  border-bottom: none;\n}\n", ""]);

// exports


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'body-modal-user-info',
  props: {
    userInfo: {
      type: Object,
      default: {
        id: -1,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        clientAccount: {},
        role: {}
      }
    },
    modalAction: {
      type: String,
      default: ''
    },
    disableBtnRight: {
      type: Boolean,
      default: false
    },
    modalDataValid: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  data: function data() {
    return {
      listUserRole: [{
        name: 'eventManager',
        text: 'Event Manager',
        role: 'EVENT_MANAGER'
      }, {
        name: 'accountManager',
        text: 'Account Manager',
        role: 'ACCOUNT_MANAGER'
      }, {
        name: 'staff',
        text: 'Staff',
        role: 'STAFF'
      }],
      showClientList: false,
      role: {},
      clientAccount: {},
      actionTypes: __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalAction
    };
  },

  directives: { 'the-mask': __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__["mask"] },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    clientList: 'GETTERS_CLIENT_LIST'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    selectRole: function selectRole(selectedOption) {
      this.showClientList = selectedOption.role.toLowerCase() === __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.client.toLowerCase();
      this.userInfo.role = selectedOption.role;
      this.userInfo.clientId = selectedOption.role.toLowerCase() !== __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.client.toLowerCase() ? 0 : '';
      // this.validateData();
    },
    selectClient: function selectClient(selectedOption) {
      this.userInfo.client = selectedOption;
      this.userInfo.clientId = selectedOption.id;
      this.userInfo.clientName = selectedOption.clientName;
      // this.validateData();
    },

    validateData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$validator.validate().then(function (result) {
                  if (!result) {
                    _this.userInfo.modalDataValid = false;
                    var errors = _this.errors;
                    if (errors.count() === 1 && errors.firstRule('email')) {
                      _this.showModalInfo(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalAction.emailMustBeAValid);
                    } else {
                      _this.showModalInfo(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalAction.someFieldsBlank);
                    }
                  } else {
                    if (_this.userInfo.role === '' || _this.userInfo.clientId === '') {
                      _this.showModalInfo(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalAction.someFieldsBlank);
                      _this.userInfo.modalDataValid = false;
                    } else {
                      _this.userInfo.modalDataValid = true;
                    }
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validateData() {
        return _ref.apply(this, arguments);
      }

      return validateData;
    }(),
    showModalInfo: function showModalInfo(modalType) {
      var modalData = {
        action: modalType,
        data: null
      };
      this.$modal.show('modalInfo', modalData);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({})),
  created: function created() {
    var _this2 = this;

    var userRole = this.userInfo.role === __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.clientManager ? __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.client : this.userInfo.role;
    if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.admin) {
      var adminObj = {
        name: 'admin',
        text: 'Admin',
        role: 'ADMIN'
      };
      this.listUserRole.push(adminObj);
    }
    this.listUserRole.forEach(function (element) {
      if (element.role.toLowerCase() === userRole.toLowerCase()) {
        _this2.role = element;
        if (userRole.toLowerCase() === __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.client.toLowerCase()) {
          _this2.showClientList = true;
          _this2.clientAccount = _this2.userInfo.client;
        }
      }
    });
    // this.$on('validateDataOnUserModal', this.validateData())
    this.userInfo.modalDataValid = true;
    if (this.modalAction === this.actionTypes.createUser) {
      this.userInfo.client = '';
    }
  }
});

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-user-info" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.modalAction == _vm.actionTypes.createUser
              ? "Add a new user"
              : "Edit a user"
          ) +
          " by entering the information below.\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name row" }, [
      _c("div", { staticClass: "first-name" }, [
        _c("div", { staticClass: "text" }, [_vm._v("First name:")]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userInfo.firstName,
                expression: "userInfo.firstName"
              }
            ],
            staticClass: "input",
            attrs: {
              type: "text",
              name: "firstName",
              placeholder: "First Name"
            },
            domProps: { value: _vm.userInfo.firstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userInfo, "firstName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "last-name" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Last name:")]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userInfo.lastName,
                expression: "userInfo.lastName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", name: "lastName", placeholder: "Last Name" },
            domProps: { value: _vm.userInfo.lastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userInfo, "lastName", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Email address:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userInfo.email,
              expression: "userInfo.email"
            }
          ],
          staticClass: "input",
          attrs: {
            name: "email",
            type: "text",
            placeholder: "E.g. hannah_welch@gmail.com"
          },
          domProps: { value: _vm.userInfo.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userInfo, "email", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "phone" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Phone:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "the-mask",
              rawName: "v-the-mask",
              value: "+1(###)-###-####",
              expression: "'+1(###)-###-####'"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userInfo.phoneNumber,
              expression: "userInfo.phoneNumber"
            }
          ],
          staticClass: "input",
          attrs: {
            name: "phone",
            type: "text",
            placeholder: "+1(###)-###-####"
          },
          domProps: { value: _vm.userInfo.phoneNumber },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userInfo, "phoneNumber", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row role-client" }, [
      _c("div", { staticClass: "role" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Role:")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("Multiselect", {
              staticClass: "input",
              attrs: {
                label: "text",
                options: _vm.listUserRole,
                "track-by": "name",
                searchable: false,
                "close-on-select": true,
                "show-labels": false,
                placeholder: "Choose a role",
                openDirection: "below"
              },
              on: { select: _vm.selectRole },
              model: {
                value: _vm.role,
                callback: function($$v) {
                  _vm.role = $$v
                },
                expression: "role"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.showClientList
        ? _c("div", { staticClass: "client" }, [
            _c("div", { staticClass: "text" }, [_vm._v("Client:")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("multiselect", {
                  staticClass: "input",
                  attrs: {
                    options: _vm.clientList,
                    placeholder: "Choose the client for this client",
                    label: "clientName",
                    openDirection: "below",
                    multiple: false,
                    "close-on-select": true,
                    "hide-selected": true,
                    "track-by": "id",
                    "allow-empty": true,
                    "show-labels": false,
                    "max-height": 174
                  },
                  on: { select: _vm.selectClient },
                  model: {
                    value: _vm.clientAccount,
                    callback: function($$v) {
                      _vm.clientAccount = $$v
                    },
                    expression: "clientAccount"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce69e6b6", esExports)
  }
}

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("689db869", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fb61a61\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalInfoBody.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fb61a61\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalInfoBody.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-body-show-info',
  props: {
    messages: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    [
      _vm._l(_vm.messages, function(message) {
        return [
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(_vm._s(message))
          ]),
          _c("br")
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3fb61a61", esExports)
  }
}

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForceUserResetPassword_vue__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f2ff40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ForceUserResetPassword_vue__ = __webpack_require__(1424);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1421)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForceUserResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f2ff40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ForceUserResetPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ForceUserResetPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ForceUserResetPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d5f2ff40", Component.options)
  } else {
    hotAPI.reload("data-v-d5f2ff40", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1422);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2cb91eb3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d5f2ff40\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForceUserResetPassword.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d5f2ff40\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForceUserResetPassword.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'force-reset-password-modal',
  props: {
    userId: ''
  }
});

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "Are you sure you want to force this user to reset their password?"
        )
      ]),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d5f2ff40", esExports)
  }
}

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddValidator_vue__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6ccc1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddValidator_vue__ = __webpack_require__(1429);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1426)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddValidator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6ccc1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddValidator_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/globalSettings/AddValidator.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AddValidator.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f6ccc1e", Component.options)
  } else {
    hotAPI.reload("data-v-4f6ccc1e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1427);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("569168c4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f6ccc1e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddValidator.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f6ccc1e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddValidator.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.modal-body-user-info {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  margin-bottom: 60px;\n}\n.modal-body-user-info .description {\n  line-height: 14px;\n}\n.modal-body-user-info .input {\n  height: 38px;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  padding-left: 12px;\n}\n.modal-body-user-info .name {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .name .last-name {\n  margin-left: 40px;\n}\n.modal-body-user-info .name .last-name .input {\n  width: 275px;\n}\n.modal-body-user-info .name .first-name .input {\n  width: 275px;\n}\n.modal-body-user-info .email {\n  margin: 30px 0 0 0;\n}\n.modal-body-user-info .email .input {\n  width: 590px;\n}\n.modal-body-user-info .errorBackground {\n  background-color: #FEE2E2;\n  width: 588px;\n  margin-top: 1px;\n}\n.modal-body-user-info .errorDetail {\n  height: 17px;\n  width: 108px;\n  color: #803939;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 17px;\n  text-align: right;\n  margin-left: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex';
// import consts from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-client-body-modal',
  data: function data() {
    return {};
  },

  props: {
    validatorInfo: {
      type: Object,
      default: {}
    }
  },
  methods: {},
  watch: {
    clientInfo: {
      handler: function handler() {
        if (this.clientInfo.email) {
          this.isEmail(this.clientInfo.email);
        }
      },
      deep: true
    }
  },
  created: function created() {
    this.$emit('disableBtnRight', true);
  }
});

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-user-info" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v("\n    Add a new validator by entering the information below.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Name:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.validatorInfo.name,
              expression: "validatorInfo.name"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "Name" },
          domProps: { value: _vm.validatorInfo.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.validatorInfo, "name", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name row" }, [
      _c("div", { staticClass: "first-name" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Field:")]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.validatorInfo.field,
                expression: "validatorInfo.field"
              }
            ],
            staticClass: "input",
            attrs: {
              type: "text",
              placeholder: "enum.validator.field.last_name",
              disabled: true
            },
            domProps: { value: _vm.validatorInfo.field },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.validatorInfo, "field", $event.target.value)
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f6ccc1e", esExports)
  }
}

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoveEvent_vue__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24432e6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MoveEvent_vue__ = __webpack_require__(1434);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1431)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoveEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24432e6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MoveEvent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/MoveEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MoveEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24432e6d", Component.options)
  } else {
    hotAPI.reload("data-v-24432e6d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1432);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6263cacd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-24432e6d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MoveEvent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-24432e6d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MoveEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.event-name {\n  color: #0080A5;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.event-status {\n  font-weight: bold;\n  text-transform: capitalize;\n}\n", ""]);

// exports


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-action-modal',
  props: {
    moveEventData: {
      type: Object,
      default: {}
    }
  }
});

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", [
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v("You are about to move "),
      _c("span", { staticClass: "event-name" }, [
        _vm._v(_vm._s(_vm.moveEventData.eventName))
      ]),
      _vm._v(" to "),
      _c("span", { staticClass: "event-status" }, [
        _vm._v(_vm._s(_vm.moveEventData.updateStatus))
      ])
    ]),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v(
        "If this client has email notifications on, they will recieve an email regarding the move."
      )
    ]),
    _vm._v(" "),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24432e6d", esExports)
  }
}

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal",
      class: {
        "v--modal-box v--modal": _vm.isChangeOrder,
        "modal-delete": _vm.isDeleteModal
      },
      attrs: { name: "eventModal", height: _vm.calculateHeight, width: 700 },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v(_vm._s(_vm.modalData.title))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.modalData.modalAction == _vm.actionTypes.suggestChanges ||
          _vm.modalData.modalAction == _vm.actionTypes.reviewSuggestChanges
            ? _c("SuggestChanges")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.showInfo
            ? _c("ChangeSubmitted")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.submitEvent ||
          _vm.modalData.modalAction == _vm.actionTypes.reviewResubmit
            ? _c("SubmitEventModal", {
                attrs: { itemName: _vm.actionData.eventName }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.changeOrder
            ? _c("ChangeOrder", {
                attrs: { itemName: _vm.actionData.eventName }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.approveEvent
            ? _c("ApproveEvent")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.deleteEvent
            ? _c("DeleteEvent")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.someEmptyFields
            ? _c("SubmitAllEventEmptyFieldsError")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.lessThan90Days
            ? _c("SubmitAllEvent90DaysError")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction ==
          _vm.actionTypes.someEmptyFieldsOrLessThan90Days
            ? _c("SubmitAllEventEmptyFieldsAnd90DaysError")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.eventPrefDateInvalid
            ? _c("EventTimeInvalid")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.eventNameNotUnique ||
          _vm.modalData.modalAction == _vm.actionTypes.someFieldsBlank ||
          _vm.modalData.modalAction ==
            _vm.actionTypes.eventDurationRestricted ||
          _vm.modalData.modalAction == _vm.actionTypes.readOnly ||
          _vm.modalData.modalAction == _vm.actionTypes.deleteUser ||
          _vm.modalData.modalAction == _vm.actionTypes.deleteValidator ||
          _vm.modalData.modalAction == _vm.actionTypes.emailIsNotValid ||
          _vm.modalData.modalAction == _vm.actionTypes.deleteClient
            ? _c("ModalInfoBody", { attrs: { messages: _vm.bodyMessage } })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.submitAllError
            ? _c("ModalBodyWithErrorCodes", {
                attrs: { messages: _vm.bodyMessageWithErrorCode }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.addClient
            ? _c("AddClient", {
                attrs: { clientInfo: _vm.clientInfo },
                on: { disableBtnRight: _vm.setDisableButtonRight }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.createUser ||
          _vm.modalData.modalAction == _vm.actionTypes.editUser
            ? _c("UserInfo", {
                attrs: {
                  modalAction: _vm.modalData.modalAction,
                  userInfo: _vm.actionData,
                  modalDataValid: _vm.modalDataValid
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.resetPassword
            ? _c("ResetPasswordModal", {
                attrs: { resetPasswordInfo: _vm.resetPasswordInfo },
                on: { disableBtnRight: _vm.setDisableButtonRight }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.moveEvent
            ? _c("MoveEvent", { attrs: { moveEventData: _vm.moveEventData } })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.forceUserResetPassword
            ? _c("ForceUserResetPassword", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.createValidator ||
          _vm.modalData.modalAction == _vm.actionTypes.editValidator
            ? _c("AddValidator", {
                attrs: { validatorInfo: _vm.validatorInfo }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _vm.modalData.btnLeft != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-left ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.hideModal()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnLeft) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.btnRight != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-right ap-btn primary",
                  attrs: { disabled: _vm.disableButtonRight },
                  on: {
                    click: function($event) {
                      _vm.btnAction()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnRight) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59073bd1", esExports)
  }
}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1437);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6f0af755", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0496e3c3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FaqModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0496e3c3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FaqModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.faq-modal[data-v-0496e3c3] {\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.event-modal[data-v-0496e3c3] {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n.event-modal .modal-close-button[data-v-0496e3c3] {\n  float: right;\n  font-size: 20px;\n}\n.event-modal .modal-close-button[data-v-0496e3c3]:hover {\n  cursor: pointer;\n}\n.event-modal .modal-header[data-v-0496e3c3] {\n  border: 0;\n  width: 100%;\n  padding: 0 65px;\n  margin: 0 auto;\n}\n.event-modal .modal-header .line[data-v-0496e3c3] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #E6E6E6;\n}\n.event-modal .modal-header .modal-header-text[data-v-0496e3c3] {\n  margin-top: 50px;\n  height: 40px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 30px;\n  text-transform: uppercase;\n  border-bottom: 1px solid #c2cfd6;\n  width: 80%;\n}\n.event-modal .modal-header .modal-header-change-order-text[data-v-0496e3c3] {\n  margin-top: 25px;\n  margin-left: 25px;\n  height: 29px;\n  width: auto;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.event-modal .modal-header .modal-header-line[data-v-0496e3c3] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #e6e6e6;\n}\n.event-modal .modal-header .modal-close-img[data-v-0496e3c3] {\n  position: absolute;\n  right: 17px;\n  top: 17px;\n}\n.event-modal .modal-header .modal-close-img[data-v-0496e3c3]:hover {\n  cursor: pointer;\n}\n.event-modal .modal-body[data-v-0496e3c3] {\n  height: auto;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 65px 25px 65px;\n}\n.event-modal .modal-body .faq-section[data-v-0496e3c3] {\n  padding: 20px 0;\n  border-bottom: solid 1px #e6e6e6;\n}\n.event-modal .modal-body .faq-section[data-v-0496e3c3]:last-child {\n  border-bottom: none;\n}\n.event-modal .modal-body .faq-section .modal-body-title[data-v-0496e3c3] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 50px;\n}\n.event-modal .modal-body .faq-section .modal-body-sub-title[data-v-0496e3c3] {\n  font-weight: 600;\n}\n.event-modal .modal-body .faq-section .modal-body-text[data-v-0496e3c3] {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n}\n", ""]);

// exports


/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {},
  data: function data() {
    return {
      isHoverClose: false
    };
  },

  methods: {
    hideModal: function hideModal() {
      this.$modal.hide('faqModal');
    }
  },
  computed: {}
});

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal faq-modal",
      attrs: {
        name: "faqModal",
        width: "90%",
        height: "auto",
        scrollable: true
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v("BIOMETRIC EVENT INFORMATION AND POLICIES")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(136),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(137),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("Standard Biometric Event")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "A standard biometric event includes: Finger Stick Blood Draw testing for Total Cholesterol, LDL, HDL, Trig and Blood Glucose. Wellmetrics testing for Blood Pressure, Heart Rate, Body Mass Index (BMI), Waist to Height Ratio (WtHR). If you require services outside of these standard options, please indicate in the custom event notes. "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v('Definition of an "Event":')
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v("• Each event subject to Event minimum billing stipulations")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Multiple shifts at one location on any single day that are separated by 2 or more hours are considered separate Events"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Events on multiple days in one location are considered a separate Event"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Each location at same day events is considered a separate Event"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Events are a minimum of 4 hours in one day.  Additional fees may be incurred if events are less than 4 hours in duration, or greater then 8 hours."
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("Policy Information")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Cancelling or Rescheduling an Event")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Events cancelled or rescheduled 31 days or more prior to an event will not incur any administrative fees."
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Events cancelled or rescheduled 14 to 30 days prior to an event will be charged and billed for 50% the rate of the event, as well as any direct, non-refundable travel expenses already purchased.  Events cancelled less than 14 days prior to event date will be charged and billed for 100% the rate of the event, as well as any direct, non-refundable travel expenses already purchased."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("ADURO Event Weather Policy")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "In the case of inclement weather, it is the responsibility of the client to cancel the event. ADURO will make every reasonable effort to continue on with an event until notified by the client. If an Event is cancelled by the client due to inclement weather, the client is responsible for all non-refundable costs (such as Lead travel). ADURO reserves the right to cancel an event due to safety concerns related to the weather at any time. ADURO will make every reasonable effort to rescheduled a cancelled event within 30 days of original date.  The Client will not incur any cancellation or rescheduling fees due to weather."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Service Changes to an Event")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Allowable service changes made within 30 days of the scheduled event are not guaranteed and will incur a $250 service fee per change if accepted.  Allowable service changes include a change in the times of the event, an increase in the number of projected participation, or a change of location within the same metro area.  Changes made outside of 30 days do not incur a fee.  Changes will not be accepted within 15 days of the event. To request service changes to an event, please complete the Change Order Form and submit it to the Event Manager."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Events in Remote Locations")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Locations more than 60 miles from an international airport will incur additional fees including travel expenses for all staff members (rental car, hotel and per diem).  An ADURO Event Manager will notify client if and when additional expenses will be charged when draft of SOF is received."
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Events requiring more than 7 screening stations: Any event that requires more than 7 screening stations will require 2 Event Leads. Screening stations are determined based on event duration and projected participation."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Deposit and Final Billing")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "A deposit will be billed out at 50% of the projected participation to confirm each Event.  Deposit payment due upon receipt of deposit invoice. Final billing per event will be whichever is the greater:  1) Actual participation  OR  2) $2,500 site minimum  OR  3) 80% of the expected participation (may not apply to all, see contract for specific details). Biometrics final invoices will include actual travel expenses for the Event Lead(s) (air fare, hotel, auto, per diem)."
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0496e3c3", esExports)
  }
}

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddonsModal_vue__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424c45de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddonsModal_vue__ = __webpack_require__(1444);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1441)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-424c45de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddonsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424c45de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddonsModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/AddonsModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AddonsModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-424c45de", Component.options)
  } else {
    hotAPI.reload("data-v-424c45de", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1442);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("11c11704", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-424c45de\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddonsModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-424c45de\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddonsModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.faq-modal[data-v-424c45de] {\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.event-modal[data-v-424c45de] {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n.event-modal .modal-close-button[data-v-424c45de] {\n  float: right;\n  font-size: 20px;\n}\n.event-modal .modal-close-button[data-v-424c45de]:hover {\n  cursor: pointer;\n}\n.event-modal .modal-header[data-v-424c45de] {\n  border: 0;\n  width: 100%;\n  padding: 0 65px;\n  margin: 0 auto;\n}\n.event-modal .modal-header .line[data-v-424c45de] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #E6E6E6;\n}\n.event-modal .modal-header .modal-header-text[data-v-424c45de] {\n  margin-top: 50px;\n  height: 40px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 30px;\n  text-transform: uppercase;\n  border-bottom: 1px solid #c2cfd6;\n  width: 80%;\n}\n.event-modal .modal-header .modal-header-change-order-text[data-v-424c45de] {\n  margin-top: 25px;\n  margin-left: 25px;\n  height: 29px;\n  width: auto;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.event-modal .modal-header .modal-header-line[data-v-424c45de] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #e6e6e6;\n}\n.event-modal .modal-header .modal-close-img[data-v-424c45de] {\n  position: absolute;\n  right: 17px;\n  top: 17px;\n}\n.event-modal .modal-header .modal-close-img[data-v-424c45de]:hover {\n  cursor: pointer;\n}\n.event-modal .modal-body[data-v-424c45de] {\n  height: auto;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 65px 25px 65px;\n}\n.event-modal .modal-body .faq-section[data-v-424c45de] {\n  padding: 20px 0;\n  border-bottom: solid 1px #e6e6e6;\n}\n.event-modal .modal-body .faq-section[data-v-424c45de]:last-child {\n  border-bottom: none;\n}\n.event-modal .modal-body .faq-section .modal-body-title[data-v-424c45de] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 50px;\n}\n.event-modal .modal-body .faq-section .modal-body-sub-title[data-v-424c45de] {\n  font-weight: 600;\n}\n.event-modal .modal-body .faq-section .modal-body-text[data-v-424c45de] {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n}\n", ""]);

// exports


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {},
  data: function data() {
    return {
      isHoverClose: false
    };
  },

  methods: {
    hideModal: function hideModal() {
      this.$modal.hide('addonsModal');
    }
  },
  computed: {}
});

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal faq-modal",
      attrs: {
        name: "addonsModal",
        width: "900px",
        height: "auto",
        scrollable: true
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v("ADD ONS AND POLICIES")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(136),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(137),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("What are Add Ons?")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "These are custom additions that are not included in our Standard Events. Please refer to your contract for billing details, as minimums and additional fees may apply."
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("Descriptions")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Venipuncture")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By request ADURO will partner with a 3rd party vendor to provide onsite events utilizing the venipuncture method to collect the blood sample. The samples will be transported to an off-site laboratory for processing and results will be sent to ADURO to be uploaded into the platform. Participants will NOT receive a hard copy of their test results from the blood draw. Participants will receive a scorecard with their body composition results."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Cotinine")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "The iScreen OFD is an oral fluid screening test that can be included at an onsite event to screen for tobacco use. The staff will administer this test an obtain results within 10 minutes. The iScreen device detects up to 1- 2 days after nicotine use. These results will be entered the ConnectWell technology during the onsite event and transferred into the platform."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Well Being Assessment (WBA) Station")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By request, ADURO can provide the optional WBA station occurs after the Program Concierge station. This prevents delays in screening event flow and helps maintain the 15-minute appointment timeline. The WBA is accessed inside of each participant’s platform account; therefore, the participants must be able to log into their account without assistance during the onsite event. It can take up to 20 minutes for a participant to complete the WBA.  For events with WBA stations, ADURO provides and set up a station with tablets. The station itself is unmanned and ADURO is unable to provide technical support."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Flu Shots")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By request ADURO will partner with a 3rd party vendor to provide flu shots at an additional station"
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Paper Scheduler")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "The ADURO Event Manager will provide a “paper” appointment scheduler template for participants to sign up for a screening. The template will be created based on the number of expected participants and duration of event. each appointment is 15 minutes in length. The template cannot be altered without the approval of the Event Manager. It is the responsibility of the client to provide the completed schedule of appointments to the Event Lead on the day of event.  ADURO will be unable to provide appointment confirmations, reminders or participation reports when paper schedulers are used. An event cannot include a combination of paper and online registrations. Customers can either have a paper or online registration process per event."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Small Site Model")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Onsite biometric screening events where ADURO will perform the following tests using the Finger Stick method; Total cholesterol, HDL, LDL, triglycerides and glucose and the following physical tests: blood pressure, heart rate and BMI (or equivalent body composition test).  The participant will leave with an unidentified scorecard with all their values. This service includes access to the online appointment scheduler, dedicated Event Manager and same day results transfer into the platform utilizing our ConnectWell technology.  For Small Site, one person (an Event Lead) is sent to the event to screen all participants, so the projected participation is limited to what one person can accomplish within 8 hours or less.  One person can screen 4 people per hour, with a max of 32 participants in 8 hours.  Any event can be Small Site as long as it meets these criteria."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Small Site Concierge")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Program Concierge is not an included service with the Small Site model but can be purchased as a buy-up option, in which case we would send an additional person to run the Concierge station (two people total)."
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-424c45de", esExports)
  }
}

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0be4305c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c76d03f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c76d03f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.right-modal {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n  padding-top: 0;\n  padding-bottom: 0 !important;\n}\n.right-modal .modal-close-button {\n  float: right;\n  font-size: 20px;\n}\n.right-modal .modal-close-button:hover {\n  cursor: pointer;\n}\n.right-modal .modal-header {\n  border: 0;\n  width: 100%;\n  margin: 0 auto;\n}\n.right-modal .modal-header .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #E6E6E6;\n}\n.right-modal .modal-header .modal-header-text {\n  margin-top: 50px;\n  color: #231f20;\n  font-weight: bold;\n  text-transform: capitalize;\n  border-bottom: 1px solid #c2cfd6;\n  width: 80%;\n  height: 27px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  line-height: 27px;\n  padding-bottom: 35px;\n}\n.right-modal .modal-header .modal-header-change-order-text {\n  margin-top: 25px;\n  margin-left: 25px;\n  height: 29px;\n  width: auto;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.right-modal .modal-header .modal-header-line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #e6e6e6;\n}\n.right-modal .modal-header .modal-close-img {\n  position: absolute;\n  right: 17px;\n  top: 17px;\n}\n.right-modal .modal-header .modal-close-img:hover {\n  cursor: pointer;\n}\n.right-modal .modal-body {\n  height: auto;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 60px 25px 40px;\n}\n.right-modal .modal-body .history-section {\n  padding: 20px 0;\n}\n.right-modal .modal-body .history-section:last-child {\n  border-bottom: none;\n}\n.right-modal .modal-body .history-section .modal-body-title {\n  font-family: 'Open Sans', sans-serif;\n  height: 22px;\n  color: #231F20;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  float: left;\n}\n.right-modal .modal-body .history-section .modal-body-time {\n  float: left;\n  margin-left: 8px;\n}\n.right-modal .modal-body .history-section .modal-body-collapse-btn {\n  height: 35px;\n  width: 117px;\n  border-radius: 4px;\n  background-color: #E6E6E6;\n  padding: 0 10px;\n  line-height: 35px;\n  margin-top: 10px;\n}\n.right-modal .modal-body .history-section .modal-body-collapse-btn:hover {\n  cursor: pointer;\n}\n.right-modal .modal-body .history-section .modal-body-collapse-btn .fa-icon {\n  padding-top: 5px;\n}\n.right-modal .modal-body .history-section .modal-body-table {\n  margin-top: 15px;\n}\n.right-modal .modal-body .history-section .modal-body-table .table th {\n  background-color: #e6e6e6;\n  border-color: #e6e6e6;\n  border-bottom: solid 1px #e6e6e6;\n  width: 99px;\n  color: #231F20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n}\n.right-modal .modal-body .history-section .modal-body-table .table td {\n  border-color: #e6e6e6;\n}\n.right-modal .modal-body .history-section .modal-body-comments {\n  color: #231F20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n}\n.right-modal .modal-body .history-section .modal-body-sub-title {\n  font-weight: 600;\n}\n.right-modal .modal-body .history-section .modal-body-text {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n}\n.right-modal .fade-enter-active,\n.right-modal .fade-leave-active {\n  -webkit-transition: opacity .3s;\n  transition: opacity .3s;\n}\n.right-modal .fade-enter,\n.right-modal .fade-leave-to {\n  opacity: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HistoryModalSection__ = __webpack_require__(1448);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    HistoryModalSection: __WEBPACK_IMPORTED_MODULE_2__HistoryModalSection__["a" /* default */]
  },
  data: function data() {
    return {
      isHoverClose: false,
      isExpanded: false
    };
  },

  methods: {
    hideModal: function hideModal() {
      this.$modal.hide('historyModal');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getEventHistory: 'GETTERS_GET_EVENT_HISTORY'
  }))
});

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryModalSection_vue__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c26260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryModalSection_vue__ = __webpack_require__(1456);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1449)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12c26260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryModalSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c26260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryModalSection_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/HistoryModalSection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HistoryModalSection.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-12c26260", Component.options)
  } else {
    hotAPI.reload("data-v-12c26260", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1450);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8435bbd6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-12c26260\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryModalSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-12c26260\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryModalSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.fade-enter-active[data-v-12c26260],\n.fade-leave-active[data-v-12c26260] {\n  -webkit-transition: opacity .3s;\n  transition: opacity .3s;\n}\n.fade-enter[data-v-12c26260],\n.fade-leave-to[data-v-12c26260] {\n  opacity: 0;\n}\n.border-bottom[data-v-12c26260] {\n  width: 80%;\n  background-color: #e6e6e6;\n  height: 1px;\n  margin-top: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_chevron_right__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_chevron_down__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('formatLastUpdate', function (value) {
  if (value) {
    var time = new Date(value);
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(String(time)).format('h:mm A MM/DD/YYYY');
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      isExpanded: false
    };
  },

  props: {
    history: {
      type: Object,
      default: {}
    }
  },
  methods: {},
  computed: {}
});

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1453);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2813b56d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5c836d4e\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./Icon.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5c836d4e\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./Icon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.fa-icon {\n  display: inline-block;\n  fill: currentColor;\n}\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n.fa-spin {\n  -webkit-animation: fa-spin 1s 0s infinite linear;\n          animation: fa-spin 1s 0s infinite linear;\n}\n.fa-inverse {\n  color: #fff;\n}\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n@-webkit-keyframes fa-spin {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes fa-spin {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n", ""]);

// exports


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: _vm.clazz,
      style: _vm.style,
      attrs: {
        version: "1.1",
        role: _vm.label ? "img" : "presentation",
        "aria-label": _vm.label,
        x: _vm.x,
        y: _vm.y,
        width: _vm.width,
        height: _vm.height,
        viewBox: _vm.box
      }
    },
    [
      _vm._t("default", [
        _vm.icon && _vm.icon.paths
          ? _vm._l(_vm.icon.paths, function(path) {
              return _c("path", _vm._b({}, "path", path, false))
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.icon && _vm.icon.polygons
          ? _vm._l(_vm.icon.polygons, function(polygon) {
              return _c("polygon", _vm._b({}, "polygon", polygon, false))
            })
          : _vm._e(),
        _vm._v("\b\n    "),
        _vm.icon && _vm.icon.raw
          ? [_c("g", { domProps: { innerHTML: _vm._s(_vm.icon.raw) } })]
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c836d4e", esExports)
  }
}

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "history-section" },
    [
      _c("div", { staticClass: "modal-body-title" }, [
        _vm._v(_vm._s(_vm.history.userName))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body-time" }, [
        _vm._v(_vm._s(_vm._f("formatLastUpdate")(_vm.history.timeModified)))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-body-collapse-btn",
          on: {
            click: function($event) {
              _vm.isExpanded = !_vm.isExpanded
            }
          }
        },
        [
          _vm.isExpanded
            ? _c("Icon", {
                staticClass: "event-icon",
                attrs: { name: "chevron-right" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isExpanded
            ? _c("Icon", {
                staticClass: "event-icon",
                attrs: { name: "chevron-down" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.history.fieldsChangeCount) + " changes")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isExpanded
          ? _c("div", [
              _c(
                "div",
                { staticClass: "modal-body-table" },
                [
                  _c("b-table", {
                    staticClass: "modal-table",
                    attrs: {
                      striped: "",
                      outlined: "",
                      small: "",
                      bordered: "",
                      hover: "",
                      items: _vm.history.items
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body-comments" }, [
                _vm._v(_vm._s(_vm.history.additionalComment))
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "border-bottom" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12c26260", esExports)
  }
}

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal right-modal",
      attrs: {
        name: "historyModal",
        width: "50%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minHeight: 900
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v("Change History")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(136),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(137),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        _vm._l(_vm.getEventHistory, function(history) {
          return _c(
            "div",
            [_c("HistoryModalSection", { attrs: { history: history } })],
            1
          )
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c76d03f6", esExports)
  }
}

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datatable_DataTable__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      actionTypes: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].modalAction,
      modalData: {},
      actionData: {}
    };
  },

  methods: {
    hideModal: function hideModal() {
      this.$modal.hide('ModalChangeOrder');
    },
    beforeOpen: function beforeOpen(event) {
      this.modalData = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    beforeClose: function beforeClose() {
      // this.$modal.show('eventModal', modalData);
    }
  },
  computed: {}
});

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0739620c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8605342\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8605342\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.datatable {\n  font-size: 14px;\n  margin: 15px 0px 15px 0;\n  /* FOR IE */\n}\n.datatable .dt-list-status {\n  height: 37px;\n  background-color: #f5f5f5;\n}\n.datatable .dt-list-status .btn-status {\n  height: 37px;\n  width: 37px;\n  float: left;\n  vertical-align: middle;\n  display: grid;\n  padding: 8px 0;\n}\n.datatable .dt-list-status .btn-status:hover {\n  cursor: pointer;\n  background-color: #FFF;\n}\n.datatable .dt-list-status .btn-status.active {\n  background-color: #FFF;\n}\n.datatable .dt-list-status .btn-status.active .line {\n  background-color: #000;\n}\n.datatable .dt-list-status .btn-status .line {\n  width: 18px;\n  background: #b9b9b9;\n  height: 3px;\n  margin: 0 auto;\n}\n.datatable .dt-list-status .btn-status .scrunch {\n  height: 2px;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n.datatable .dt-list-status .btn-status .line {\n    margin-bottom: 3px;\n}\n}\n.datatable .dt-content {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.datatable .dt-content .dt-header {\n  font-size: 12px;\n  height: 40px;\n  line-height: 16px;\n  background-color: #606060;\n  font-family: \"Open Sans\", sans-serif;\n  letter-spacing: 0.1px;\n  padding-top: 12px;\n  color: #FFF;\n}\n.datatable .dt-content .dt-header .header-col {\n  float: left;\n  height: 16px;\n  overflow: hidden;\n  padding-left: 10px;\n  text-transform: uppercase;\n  word-break: break-all;\n}\n.datatable .dt-content .dt-header .header-col:hover {\n  cursor: pointer;\n}\n.datatable .dt-content .dt-header .header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.datatable .dt-content .dt-header .col-event-name {\n  padding-left: 30px;\n}\n.datatable .dt-content .dt-body {\n  clear: both;\n  background-color: #f5f5f5;\n}\n.datatable .dt-content .dt-body.scrunch .dt-row-detail {\n  height: 40px;\n}\n.datatable .dt-content .dt-body.scrunch .dt-row-detail .body-col-address-bing {\n  height: 200px;\n}\n.datatable .dt-content .dt-body.scrunch .dt-row-detail .body-col {\n  height: 40px;\n  line-height: 40px;\n}\n.datatable .dt-content .dt-body .dt-row {\n  /*max-width: 100%;*/\n}\n.datatable .dt-content .dt-body .dt-row-detail {\n  max-width: 100%;\n  height: 56px;\n  border-radius: 1px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  margin-top: 1px;\n  /*&.active {\n          background-color: @white;\n          .data-table-row-edit-mode-text {\n            background-color: @white;\n            .multiselect__input {\n              background-color: @white;\n            }\n            .display-time {\n              background-color: @white;\n              width: 100%;\n              padding: 0;\n              border: none;\n            }\n          }\n          .col-contact {\n            background-color: @white;\n            // margin-left: 5px;\n            .multiselect__input {\n              background-color: @white;\n            }\n          }\n        }\n        &:hover {\n          background-color: @grey-5;\n          box-shadow: 0 3px 6px 0 @grey-5;\n          .data-table-row-edit-mode-text {\n            background-color: @grey-5;\n            .multiselect__input {\n              background-color: @grey-5;\n            }\n            .display-time {\n              background-color: @grey-5;\n            }\n          }\n          .col-contact {\n            background-color: @grey-5;\n            .multiselect__tags {\n              background-color: @grey-5;\n            }\n            .multiselect__single {\n              background-color: @grey-5;\n            }\n            .multiselect__input {\n              background-color: @grey-5;\n            }\n          }\n        }*/\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col {\n  float: left;\n  height: 50px;\n  line-height: 50px;\n  padding-left: 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n  font-size: 12px;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .address-error {\n  border: 1px solid #D92C27;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .address-error-message {\n  position: relative;\n  bottom: 16px;\n  font-size: x-small;\n  color: #D92C27;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .icon-wrapper {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  background-color: #00A4D6;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col.overflow-show {\n  overflow: visible;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col.overflow-show .data-table-row-edit-mode-text {\n  z-index: unset;\n  width: 100%;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col.overflow-show .data-table-row-edit-mode-text .display-time {\n  background-color: #f5f5f5;\n  width: 100% !important;\n  padding: 0 !important;\n  border: none !important;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col.overflow-show .col-contact {\n  z-index: unset;\n  width: 100%;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .row-detail-icon {\n  vertical-align: middle;\n  margin-left: 2px;\n  margin-bottom: 2px;\n  color: #FFF;\n  background-color: #00A4D6;\n  padding: 3px;\n  border-radius: 6px;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .row-detail-icon:hover {\n  cursor: pointer;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .row-detail-icon-exclamation-circle {\n  height: 14px;\n  width: 14px;\n  border-radius: 6px;\n  padding: 0;\n  color: #0080a5;\n  background-color: #FFF;\n  overflow: visible;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .pref-date-body-col {\n  height: 100%;\n  color: #1D1D1D;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .pref-date-body-col.place-holder {\n  color: #8E8E8E;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .action-change-order {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n.datatable .dt-content .dt-body .dt-row-detail .body-col .action-change-order:hover {\n  cursor: pointer;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .event-icon {\n  vertical-align: middle;\n  margin-right: 5px;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .client-name {\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  height: 15px;\n  padding: 0;\n  margin-top: 10px;\n  line-height: 10px;\n  margin-left: 20px;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .col-end-time .place-holder {\n  color: #8E8E8E;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .name {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-top: -13px;\n  font-family: 'Open Sans', sans-serif;\n  height: 25px;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 25px;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .name .icon-expand {\n  width: 20px;\n  float: left;\n  margin-right: 8px;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .name .icon-expand:hover {\n  cursor: pointer;\n}\n.datatable .dt-content .dt-body .dt-row-detail .event-name .name input {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  margin-left: 4px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail {\n  clear: both;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-header {\n  text-transform: uppercase;\n  line-height: 34px;\n  padding: 0 10px;\n  height: 34px;\n  background-color: #606060;\n  color: #FFFFFF;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body {\n  background-color: #FFF;\n  padding: 20px 10px 15px 20px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .row-detail-icon-exclamation-circle {\n  height: 13px;\n  width: 13px;\n  border-radius: 6px;\n  padding: 0;\n  color: #0080a5;\n  background-color: #FFF;\n  overflow: visible;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .icon-alert {\n  padding: 2px 0px 0px 22px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .text-alert {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  padding: 0 20px 0 15px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field {\n  margin-top: 20px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field:first-child {\n  margin-top: 0;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field .text-label {\n  font-size: 12px;\n  text-transform: capitalize;\n  line-height: 18px;\n  font-family: 'Open Sans', sans-serif;\n  color: #1A1718;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field .text-label .label-address {\n  color: #b9b9b9;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field .text-value textarea {\n  width: 100%;\n  border-radius: 3px;\n  border: solid 1px #e6e6e6;\n  padding: 5px 10px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field .text-value textarea.custom-notes {\n  height: 55px;\n  padding-left: 14px;\n  color: #000;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .notes-field .text-value textarea.additional-comments {\n  height: 95px;\n  padding-left: 14px;\n  color: #000;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .text-contact {\n  margin-bottom: 20px;\n  margin-right: 10px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .text-contact .label {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  text-transform: capitalize;\n  line-height: 18px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .text-contact .contactName {\n  line-height: 31px;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .func-group button {\n  font-size: 14px;\n  height: 39px;\n  font-family: 'Open Sans', sans-serif;\n  text-transform: uppercase;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .func-group button .func-icon {\n  width: 18px;\n  height: 18px;\n  color: #FFF;\n  float: left;\n}\n.datatable .dt-content .dt-body .dt-row-item-detail .item-detail-body .func-group .grey-3 {\n  color: #b9b9b9;\n}\n.datatable .dt-content .header-col .header-container {\n  position: relative;\n}\n.datatable .dt-content .header-col .crop {\n  /*height: 37px;*/\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n}\n.datatable .dt-content .header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.datatable .dt-content .header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.datatable .dt-content .header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n}\n.datatable .dt-content .header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.datatable .dt-content .header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.datatable .dt-content .header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.datatable .dt-content .header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.datatable .dt-content .header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.datatable .dt-content .header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.datatable .dt-content .header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.datatable .dt-content .header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.datatable .dt-content .header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n.datatable .dt-content .small-text {\n  font-size: 10px;\n}\n.datatable .dt-content .small-text .small-text-margin .first-line {\n  position: absolute;\n  top: -5px;\n}\n.datatable .dt-content .small-text .small-text-margin .second-line {\n  position: absolute;\n  top: 8px;\n}\n.datatable .dt-content .small-text .small-text-margin .icon-section {\n  position: absolute;\n  top: 1px;\n  left: 50px;\n}\n", ""]);

// exports


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataTableRow__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DataTableRowEditMode__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DtPaging__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// const _ = require('lodash');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataTable',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__["a" /* default */],
    DataTableRow: __WEBPACK_IMPORTED_MODULE_7__DataTableRow__["a" /* default */],
    DataTableRowEditMode: __WEBPACK_IMPORTED_MODULE_8__DataTableRowEditMode__["a" /* default */],
    DtPaging: __WEBPACK_IMPORTED_MODULE_9__DtPaging__["a" /* default */]
  },
  data: function data() {
    return {
      scrunch: false,
      // START: paging
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '25',
        totalItems: this.totalItems,
        sortType: 'isChangeOrder',
        sortReverse: false
      },
      // END: paging
      arrStatus: [],
      resizing: false,
      messages: [], // TODO ws change later
      programId: null
    };
  },

  props: {
    eventStatus: {
      type: String,
      default: ''
    },
    viewMode: {
      type: String,
      default: 'Client'
    },
    editable: {
      type: Boolean,
      default: false
    },
    showOnModal: {
      type: Boolean,
      default: false
    },
    dataOnModal: {
      type: Object
    },
    editEventAdmin: {
      type: Boolean,
      default: false
    },
    parentEvent: {
      type: Array,
      default: []
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    allowEdit: function allowEdit() {
      this.editable = false;
    },
    totalItems: function totalItems() {
      return this.countEventByStatus(this.eventStatus);
    },
    listEventStatus: function listEventStatus() {
      return this.getListEvenStatus;
    },
    columnWidth: function columnWidth() {
      return this.getColumnWidth;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    getListEvent: 'GETTERS_LIST_EVENT',
    countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
    getListEvenStatus: 'GETTERS_LIST_EVENT_STATUS',
    showRelatedEvent: 'GETTERS_SHOW_RELATED_EVENT',
    getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH',
    getLockIds: 'GETTERS_GET_LOCK_IDS',
    getErrorCodes: 'GETTERS_ERROR_CODES',
    getLoading: 'GETTERS_IS_LOADING'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    changePagingOptions: function changePagingOptions(pagingObj) {
      this.pagingObj.currentPage = pagingObj.currentPage;
      this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
      this.pagingObj.totalItems = pagingObj.totalItems;
    },
    setSortOption: function setSortOption(sortType) {
      if (!this.resizing) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
      }
    },
    getListEventParams: function getListEventParams() {
      if (this.eventStatus === '') {
        this.arrStatus = this.getListEvenStatus;
      } else {
        this.arrStatus = [this.eventStatus.toUpperCase()];
      }
      return {
        userId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].LOCAL_STORE.userId)),
        status: this.arrStatus,
        options: this.pagingObj,
        clientId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].LOCAL_STORE.clientId)),
        programId: this.programId
      };
    },
    changeColumnWidth: function changeColumnWidth(colName, mouseDownEvent) {
      this.resizing = true;
      var vueApp = this;
      // get current mouse position
      var shiftX = mouseDownEvent.clientX;
      // header width
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      var maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      var newWidth = maxLeft;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      function onMouseMove(event) {
        // new position
        var bufferPx = event.clientX - shiftX;
        var newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && maxLeft - Math.abs(bufferPx) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2)
        });
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(function () {
          vueApp.resizing = false;
        }, 50);
      }
    },
    receiveOnlineGuest: function receiveOnlineGuest(frame) {
      // console.log(typeof JSON.parse(frame.body))
      console.log(frame.body);
      // this.setOnlineGuest(JSON.parse(frame.body))
    },
    isLocked: function isLocked(eventId) {
      return this.getLockIds.eventIds.indexOf(eventId.toString()) !== -1;
    },
    changeTableSrcollable: function changeTableSrcollable(isWidthPercent) {
      var _this = this;

      // if screen resolution < 1360px convert table to pixel
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = void 0;
      if (dtHeaderEl) {
        headerWidth = dtHeaderEl.getBoundingClientRect().width;
      }
      var arrCol = [{
        colName: 'eventName',
        newWidth: 150
      }, {
        colName: 'prefDate',
        newWidth: 110
      }, {
        colName: 'projPart',
        newWidth: 65
      }, {
        colName: 'fullAddress',
        newWidth: 330
      }, {
        colName: 'building',
        newWidth: 85
      }, {
        colName: 'eventLocation',
        newWidth: 85
      }, {
        colName: 'startTime',
        newWidth: 85
      }, {
        colName: 'duration',
        newWidth: 65
      }, {
        colName: 'endTime',
        newWidth: 85
      }, {
        colName: 'timeZone',
        newWidth: 50
      }, {
        colName: 'contactName',
        newWidth: 110
      }, {
        colName: 'action',
        newWidth: 120
      }];
      if (document.body.clientWidth < 1200) {
        var newHeaderWidth = 1200;
        var tbHeaderId = 'dt-header';
        var tbBodyId = 'dt-body';
        var _dtHeaderEl = document.getElementById(tbHeaderId);
        var dtBodyEl = document.getElementById(tbBodyId);
        _dtHeaderEl.style.width = '1200px';
        dtBodyEl.style.width = '1200px';
        arrCol.forEach(function (element) {
          _this.saveColumnWidth({
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: element.colName,
            newWidth: element.newWidth
          });
        });
      } else {
        var _tbHeaderId = 'dt-header';
        var _tbBodyId = 'dt-body';
        var _dtHeaderEl2 = document.getElementById(_tbHeaderId);
        var _dtBodyEl = document.getElementById(_tbBodyId);
        if (_dtHeaderEl2) {
          _dtHeaderEl2.style.width = 'unset';
        }
        if (_dtBodyEl) {
          _dtBodyEl.style.width = 'unset';
        }
        arrCol.forEach(function (element) {
          _this.mutationSetColWidth({
            colName: element.colName,
            newWidth: 0,
            isTableUser: false
          });
        });
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    getEventList: 'ACTION_GET_EVENT_LIST',
    saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH',
    resetColumnSize: 'ACTION_RESET_COLUMN_SIZE',
    lockEvent: 'ACTION_LOCK_EVENT',
    lockEventList: 'ACTION_LOCK_EVENT_LIST',
    removeEventFromUI: 'ACTION_REMOVE_EVENT_FROM_UI'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])({
    mutationSetColWidth: 'MUTATION_SAVE_COLUMN_WIDTH'
  })),
  beforeMount: function beforeMount() {
    if (this.showOnModal === false) {
      this.getEventList(this.getListEventParams());
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].LOCAL_STORE.pagingOptions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getListEventParams()));
    }
    // reset column size
    this.resetColumnSize();
  },
  mounted: function mounted() {
    var that = this;
    this.changeTableSrcollable();
    this.$root.$on('RELOAD_EVENT_LIST', function (programId) {
      that.programId = programId;
      that.getEventList(that.getListEventParams());
    });
  },
  created: function created() {
    var _this2 = this;

    var readOnly = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].LOCAL_STORE.readOnly);
    this.editable = !(readOnly === 'true');
    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_11_lodash__["debounce"](function (event) {
      if (document.body.clientWidth < 1200) {
        _this2.changeTableSrcollable();
      } else {
        _this2.changeTableSrcollable(true);
      }
    }, 100));
  },

  watch: {
    pagingObj: {
      handler: function handler() {
        this.getEventList(this.getListEventParams());
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].LOCAL_STORE.pagingOptions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getListEventParams()));
      },
      deep: true
    },
    listEventStatus: {
      handler: function handler() {
        if (!this.$store.getters.GETTERS_SHOW_RELATED_EVENT) {
          this.getEventList(this.getListEventParams());
        }
      }
    },
    eventStatus: {
      handler: function handler() {
        if (!this.$store.getters.GETTERS_SHOW_RELATED_EVENT) {
          this.getEventList(this.getListEventParams());
        }
        this.changeTableSrcollable();
      }
    },
    getErrorCodes: function getErrorCodes() {
      if (this.getErrorCodes !== null) {
        var modalData = {
          action: __WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].modalAction.submitAllError,
          data: this.getErrorCodes
        };
        this.$modal.show('eventModal', modalData);
      }
    }
  }
});

/***/ }),
/* 1462 */,
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1464);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5f48e03f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6bb6fa2b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTableRow.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6bb6fa2b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTableRow.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.v-select .selected-tag {\n  height: 0;\n  float: left;\n  line-height: 1.7em;\n  border-radius: 0;\n  border: none;\n}\n.v-select .dropdown-toggle {\n  width: 80px;\n  margin-top: 6px;\n  border-radius: 6px;\n  border: solid 1px #0080a5;\n  height: 30px;\n}\n.v-select > .dropdown-menu {\n  width: 25px;\n}\n.addressText {\n  width: 100%;\n  border-radius: 6px;\n  border: solid 1px #0080a5;\n  height: 30px;\n}\n.month-dropdown-item {\n  height: 176px;\n  display: inline-block;\n  overflow: scroll;\n}\n.dropdown-item {\n  width: 65px;\n}\n.new-event-dropdown-month {\n  width: 100%;\n  font-size: 17px;\n  max-height: 31px;\n  padding: 4px 0;\n  margin: -6px 0 0 0;\n  font-family: Arquitecta, sans-serif;\n}\n.new-event-dropdown-month > button {\n  width: 100%;\n  font-size: 17px !important;\n  max-height: 31px;\n  padding: 4px 0;\n  margin: -6px 0 0 0;\n}\n.icon-actions {\n  width: 25px;\n  height: 25px;\n  border-radius: 3px;\n  margin-left: -3px;\n  padding: 5px !important;\n}\n.notes-field .add-on-wrapper {\n  float: left;\n  height: 33px;\n  line-height: 31px;\n}\n.notes-field .add-on-wrapper .add-on-item .text {\n  color: #626262;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  display: inline;\n  margin-left: -10px;\n}\n.notes-field .add-on-wrapper .add-on-item .title {\n  margin-left: 8px !important;\n}\n.notes-field .add-on-wrapper .add-on-item .title.active {\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 16px;\n}\n.notes-field .add-on-wrapper .add-on-item input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.notes-field .add-on-wrapper .add-on-item label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.notes-field .add-on-wrapper .add-on-item label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.notes-field .add-on-wrapper .add-on-item input:checked + label {\n  background: #00A4D6;\n  border: 1.5px solid #00A4D6;\n}\n.notes-field .add-on-wrapper .add-on-item input:checked + label:after {\n  left: calc(100%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.notes-field .add-on-wrapper .add-on-item label:active:after {\n  width: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_exclamation_circle__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_arrow_circle_o_right__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_chevron_right__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_chevron_down__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_floppy_o__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_trash_o__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_repeat__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_exchange__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_angle_right__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_refresh__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RowStatus__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_vue_the_mask__ = __webpack_require__(187);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataTableRow',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default.a,
    RowStatus: __WEBPACK_IMPORTED_MODULE_16__RowStatus__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_17__utils_vue_the_mask__["a" /* TheMask */]
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    eventStatus: {
      type: String
    },
    item: {
      type: Object,
      default: null
    },
    viewMode: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    showOnModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCollapse: false,
      focusedColumn: '',
      listOptionPrefMonth: __WEBPACK_IMPORTED_MODULE_13__consts__["a" /* default */].listOptionPrefMonth,
      isSuggestChanges: false,
      iconNames: __WEBPACK_IMPORTED_MODULE_13__consts__["a" /* default */].iconNames,
      listEventStatus: __WEBPACK_IMPORTED_MODULE_13__consts__["a" /* default */].eventStatus,
      viewModes: __WEBPACK_IMPORTED_MODULE_13__consts__["a" /* default */].dataTableViewModes,
      isTrue: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    newPrefMonth: function newPrefMonth() {
      var time = __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.item.prefDate, 'MM/DD/YYYY');
      var str = time.format('MMM').toUpperCase();
      this.item.newPrefMonth = str;
      return str;
    },
    newPrefDate: function newPrefDate() {
      var time = __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.item.prefDate, 'MM/DD/YYYY');
      var str = time.format('DD') + '/' + time.format('YYYY');
      this.item.newPrefDate = str;
      return str;
    },
    expandId: function expandId() {
      return this.getExpandId;
    },
    showRelatedEvent: function showRelatedEvent() {
      return this.showRelatedEvents;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_15_vuex__["c" /* mapGetters */])({
    getExpandId: 'GETTERS_GET_EXPAND_ID',
    showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT'
  }), {
    accordionId: function accordionId() {
      return 'accordion-' + this.item.id;
    },
    eventName: function eventName() {
      if (this.item.eventName === undefined || this.item.eventName === '') {
        this.item.eventName = 'New Event';
      }
      return this.item.eventName;
    },
    calculateDuration: function calculateDuration() {
      if (this.item.projPart > 0 && this.item.projPart <= 32) {
        this.item.duration = 4;
      }
      if (this.item.projPart > 32 && this.item.projPart < 100) {
        this.item.duration = 4;
      }
      if (this.item.projPart >= 100 && this.item.projPart <= 140) {
        this.item.duration = 5;
      }
      if (this.item.projPart > 140 && this.item.projPart < 170) {
        this.item.duration = 6;
      }
      if (this.item.projPart >= 170 && this.item.projPart < 200) {
        this.item.duration = 7;
      }
      if (this.item.projPart >= 200) {
        this.item.duration = 8;
      }
      if (this.item.duration > 0) {
        return this.item.duration + ' HR';
      }
      return '';
    },
    enableNoteForProjPart: function enableNoteForProjPart() {
      return this.item.duration === 4 || this.item.duration === 8;
    },
    enableNoteForEventDuration: function enableNoteForEventDuration() {
      return this.item.duration === 4 || this.item.duration === 8;
    },
    calculateTimeEnd: function calculateTimeEnd() {
      var listStr = this.item.startTime.toString().split(':');
      if (listStr.length > 1) {
        var hour = Number(listStr[0]);
        hour += this.item.duration;
        if (hour > 23 || hour < 12) {
          this.item.endTime = hour % 12 + ':' + listStr[1] + ' AM';
        }
        if (hour > 12 && hour <= 23) {
          this.item.endTime = hour % 12 + ':' + listStr[1] + ' PM';
        }
        if (hour === 12) {
          this.item.endTime = 12 + ':' + listStr[1] + ' PM';
        }
      }
      return this.item.endTime;
    },
    enableIconProjPart: function enableIconProjPart() {
      return this.item.projPart > 0 && (this.item.projPart <= 32 || this.item.projPart >= 200);
    },
    disableIconContact: function disableIconContact() {
      // return this.item.contactName === '';
      return !(this.item.email !== '' && this.item.phone !== '');
    },
    calculateShippingAddress: function calculateShippingAddress() {
      if (this.item.shippingAddress === '') {
        this.item.shippingAddress = this.item.fullAddress;
      }
      return this.item.shippingAddress;
    },
    viewRelatedEvent: function viewRelatedEvent() {
      return this.showRelatedEvents;
    }
  }),
  methods: {
    setExpandId: function setExpandId(id) {
      this.showCollapse = true;
    }
  }
});

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1467);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("06fc0067", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-838bd2f2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RowStatus.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-838bd2f2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RowStatus.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n/**\n* OVERIDE GENERAL STYLES\n*/\n.caption-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.label-text {\n  color: #626262;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.label-text-2 {\n  color: #8E8E8E;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.body-text,\n.email-histories-page .histories-page-body .participant-table-container .search-section .input {\n  color: #424242;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.h4-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.h3-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n}\n.h2-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.h1-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.button-text,\n.ap-btn {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n.value-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.tab-header .type {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 6px;\n  line-height: 48px;\n  margin-right: 24px;\n}\n.tab-header .type:hover {\n  cursor: pointer;\n  color: #606060;\n}\n.tab-header .type:focus {\n  border: 2px solid rgba(0, 164, 214, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 14px 24px;\n}\n.tab-header .type.active {\n  border-bottom: 3px solid #1674CD;\n  color: #1674CD;\n}\n.ap-checkbox-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-indicator {\n  width: 24px;\n  height: 24px;\n  top: 0;\n  border: 1px solid #b9b9b9;\n  background-color: transparent;\n}\n.ap-checkbox-group .custom-control-description {\n  margin-left: 1rem;\n}\n.ap-checkbox-group .custom-checkbox {\n  margin-top: 16px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label {\n  cursor: pointer;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before,\n.ap-checkbox-group .custom-checkbox .custom-control-label::after {\n  top: 0;\n  height: 24px;\n  width: 24px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: #1674CD;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-control-label {\n  cursor: pointer;\n}\n.ap-radio-group .custom-control-label::after {\n  background-size: 95%;\n}\n.ap-radio-group .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-radio-group .custom-control-label::before,\n.ap-radio-group .custom-control-label::after {\n  top: 0;\n  height: 25px;\n  width: 25px;\n}\n.ap-radio-group .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio {\n  margin-bottom: 24px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label {\n  font-size: 16px;\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label span {\n  padding-left: 0;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: transparent;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2300A4D6'/%3E%3C/svg%3E\");\n}\n.ap-input-wrapper {\n  position: relative;\n}\n.ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .title-field {\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper {\n  position: relative;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 24px;\n  height: 24px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-error-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E83001;\n  background-color: #E83001;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-success-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #68B814;\n  background-color: #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-warning-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E89819;\n  background-color: #E89819;\n}\n.ap-field-input-wrapper .message-field {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.ap-field-input-wrapper .message-field.success {\n  color: #68B814;\n}\n.ap-field-input-wrapper .message-field.error {\n  color: #E83001;\n}\n.ap-field-input-wrapper .message-field.warning {\n  color: #E89819;\n}\n.ap-dropdown {\n  width: 300px;\n  font-size: 16px;\n}\n.ap-dropdown .ap-dropdown-btn {\n  width: 100%;\n}\n.ap-dropdown .ap-dropdown-btn.btn-group > .btn:first-child {\n  border: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 44px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #ffffff;\n  width: inherit;\n  padding: 10px 16px;\n  font-size: 16px;\n  text-align: left;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary::after {\n  display: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:hover {\n  border: 1px solid #7B7B7B;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:focus {\n  border: 2px solid rgba(32, 170, 233, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text.active {\n  color: #1D1D1D;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper .icon-dropdown {\n  width: 13px;\n  height: 18px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper:hover {\n  cursor: pointer;\n}\n.ap-dropdown .dropdown-menu {\n  width: inherit;\n  width: 100%;\n  border-radius: 4px;\n  background-color: #FFF;\n  margin-top: 8px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 8px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item {\n  height: inherit;\n  padding: 0px 0px 0 16px;\n  color: #1D1D1D;\n  line-height: 24px;\n  border: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:hover {\n  background-color: #F5F5F5 !important;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:focus {\n  background-color: unset;\n  outline: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item .ap-item-wrapper {\n  height: 44px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #E6E6E6;\n  padding: 12px 0 9px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:last-child .ap-item-wrapper {\n  border: none;\n}\n.dropdown-section {\n  height: 500px;\n  margin-top: 64px;\n}\n.dropdown-section .section-title {\n  color: #1D1D1D;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  margin-bottom: 40px;\n}\n.pretty.p-default input:checked ~ .state label:after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn {\n  height: 26px;\n}\n.custom-radio-btn input:checked ~ .state label {\n  font-weight: 600;\n  color: #00A4D6;\n}\n.custom-radio-btn input:checked ~ .state label::after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn input:checked ~ .state label::before {\n  border-color: #00A4D6;\n}\n.custom-radio-btn .state label {\n  height: 26px;\n  margin-left: 16px;\n  font-size: 16px;\n  color: #606060;\n  line-height: 26px;\n  letter-spacing: -0.04px;\n}\n.custom-radio-btn .state label::after {\n  width: 25px;\n  height: 25px;\n  bottom: 0;\n  top: unset;\n}\n.custom-radio-btn .state label::before {\n  width: 25px;\n  height: 25px;\n  border-color: #b9b9b9;\n  bottom: 0;\n  top: unset;\n}\n.ap-btn {\n  padding: 12px 32px;\n  border: 1px solid #1674CD;\n  border-radius: 4px;\n  background: none;\n}\n.ap-btn.compact {\n  padding: 6px 24px;\n}\n.ap-btn.primary {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.primary:focus {\n  background-color: #1674CD;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.primary:hover {\n  background-color: #1674CD;\n}\n.ap-btn.primary:active {\n  background-color: #00526A;\n  outline: none;\n}\n.ap-btn.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.primary:disabled:hover {\n  background-color: #1674CD;\n}\n.ap-btn.secondary {\n  background-color: white;\n  color: #1674CD;\n}\n.ap-btn.secondary:hover {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.secondary:focus {\n  background-color: #FFF;\n  color: #1674CD;\n}\n.ap-btn.secondary:active {\n  background-color: #00526A;\n  color: #FFF;\n}\n.ap-btn.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.secondary:disabled:hover {\n  background-color: transparent;\n  color: #1674CD;\n}\n.ap-btn.tertiary {\n  background-color: #AAA7A4;\n  color: #FFF;\n  border: 1px solid #AAA7A4;\n}\n.ap-btn.tertiary:hover {\n  background-color: #67615C;\n}\n.ap-btn.tertiary:active {\n  background-color: #463E37;\n}\n.ap-btn.tertiary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.tertiary:disabled:hover {\n  background-color: #AAA7A4;\n}\n.ap-btn.destructive {\n  background-color: #FF3400;\n  color: #FFF;\n  border: none;\n}\n.ap-btn.destructive:focus {\n  background-color: #FF3400;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.destructive:hover {\n  background-color: #B22520;\n}\n.ap-btn.destructive:active {\n  background-color: #631412;\n}\n.ap-btn.destructive:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.destructive:disabled:hover {\n  background-color: #FF3400;\n}\n.ap-btn-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ap-btn-icon .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  margin-right: 8px;\n  color: #FFF;\n}\n.ap-btn-icon-only {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px;\n}\n.ap-btn-icon-only.compact {\n  padding: 5px;\n}\n.ap-btn-icon-only .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  color: #FFF;\n}\n.background,\n.card-rest-background,\n.card-lift-background,\n.modal-background,\n.list-dialogues-background,\n.alert-background,\n.iziToast-wrapper .iziToast {\n  border-radius: 4px;\n  background-color: #FFF;\n}\n.header-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.banner-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.card-rest-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.card-lift-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.list-dialogues-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-background,\n.iziToast-wrapper .iziToast {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-icon,\n.alert-icon-checked,\n.alert-icon-info,\n.alert-icon-warning,\n.alert-icon-error {\n  width: 24px;\n  height: 24px;\n  color: #FFF;\n  background-color: #FFF;\n}\n.alert-icon-checked {\n  background: url('/static/img/down-o-white.svg') no-repeat center;\n}\n.alert-icon-info {\n  background: url('/static/img/status-info-outline-white.svg') no-repeat center;\n}\n.alert-icon-warning {\n  background: url('/static/img/status-warning-outline-white.svg') no-repeat center;\n}\n.alert-icon-error {\n  background: url('/static/img/icon-field-error-white.svg') no-repeat center;\n}\n.iziToast-wrapper .iziToast {\n  min-height: 45px;\n  min-width: 283px;\n  padding: 5px 40px 5px 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body {\n  min-height: 35px;\n  margin-left: 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child {\n  background: #FFF;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child:hover {\n  background: #e6e6e6;\n}\n.iziToast-wrapper .iziToast > .iziToast-texts {\n  margin-top: 9px;\n}\n.iziToast-wrapper .iziToast > .iziToast-close {\n  top: 50%;\n  right: 10px;\n  margin-top: -7px;\n  width: 14px;\n  height: 14px;\n  background: url('/static/img/ic_close.png') center center no-repeat;\n  background-size: cover;\n  opacity: 1;\n}\n.iziToast-wrapper .iziToast:after {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.manage-related-events-container {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.manage-related-events-container .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container {\n  font-family: 'Open Sans', sans-serif;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header {\n  margin-top: 24px;\n  padding: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header .modal-title {\n  color: #1D1D1D;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  border: none;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section {\n  margin-top: 20px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title .count-related-event,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title .count-related-event {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  line-height: 30px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper {\n  width: 60%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .input-search-event,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .input-search-event {\n  height: 42px;\n  border-radius: 3px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .search-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .search-icon {\n  position: absolute;\n  right: 12px;\n  top: 10px;\n  z-index: 2;\n  height: 22px;\n  width: 22px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container {\n  background-color: #f5f5f5;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-top: 16px;\n  padding-bottom: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events {\n  border-radius: 4px;\n  margin-top: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name {\n  width: 15%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name .field-value,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name .field-value {\n  margin-left: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-address,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-address {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-contact {\n  width: 17%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-email,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-email {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-date,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-date {\n  width: 10%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action {\n  width: 8%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 16px;\n  border-left: 1px solid #b9b9b9;\n  width: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name {\n  margin-left: 16px;\n  color: #8E8E8E;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper {\n  color: #8E8E8E;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon {\n  vertical-align: middle;\n  width: 12px;\n  height: 12px;\n  color: #8E8E8E;\n  margin-top: -10px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body {\n  max-height: 316px;\n  min-height: 200px;\n  overflow-y: auto;\n  margin-top: 16px;\n  padding-top: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  height: 56px;\n  margin: 0px 5px 16px 5px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value {\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 56px;\n  padding-left: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added {\n  color: #8E8E8E;\n  font-size: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn {\n  font-size: 12px;\n  padding: 0 12px;\n}\n.manage-related-events-container .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 32px;\n}\n.manage-related-events-container .group-btn .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n  text-transform: none;\n}\n.manage-related-events-container .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.manage-related-events-container .list-events {\n  background-color: #FCFCFC;\n  border: 1px solid #E6E6E6;\n  margin-top: 1rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.2rem;\n}\n.manage-related-events-container .list-events .selected-text {\n  color: #8E8E8E;\n}\n.manage-related-events-container .list-events .icon-add-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-add-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-add-wrapper .icon-add {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .icon-close-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-close-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-close-wrapper .icon-close {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .list-container {\n  margin: 0 0 1.4rem 0;\n}\n.manage-related-events-container .list-events .list-group-container {\n  margin: 3rem 0;\n}\n.manage-related-events-container .list-events .list-header,\n.manage-related-events-container .list-events .list-content,\n.manage-related-events-container .list-events .list-ca {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-header .column,\n.manage-related-events-container .list-events .list-content .column,\n.manage-related-events-container .list-events .list-ca .column {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column,\n.manage-related-events-container .list-events .list-content .column .container-column,\n.manage-related-events-container .list-events .list-ca .column .container-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manage-related-events-container .list-events .list-header .column .container-column p,\n.manage-related-events-container .list-events .list-content .column .container-column p,\n.manage-related-events-container .list-events .list-ca .column .container-column p {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button,\n.manage-related-events-container .list-events .list-content .column .container-column button,\n.manage-related-events-container .list-events .list-ca .column .container-column button {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button img,\n.manage-related-events-container .list-events .list-content .column .container-column button img,\n.manage-related-events-container .list-events .list-ca .column .container-column button img {\n  height: 0.6rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-header,\n.manage-related-events-container .list-events .list-content .column .container-column .text-header,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-header {\n  font-weight: 600;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-icon,\n.manage-related-events-container .list-events .list-content .column .container-column .text-icon,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-not-live,\n.manage-related-events-container .list-events .list-content .column .container-column .text-not-live,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-not-live {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manage-related-events-container .list-events .list-header .column .border-seperate,\n.manage-related-events-container .list-events .list-content .column .border-seperate,\n.manage-related-events-container .list-events .list-ca .column .border-seperate {\n  border-right: 1px solid #B9B9B9;\n}\n.manage-related-events-container .list-events .list-header .column.width-10,\n.manage-related-events-container .list-events .list-content .column.width-10,\n.manage-related-events-container .list-events .list-ca .column.width-10 {\n  width: 10%;\n}\n.manage-related-events-container .list-events .list-header .column.width-20,\n.manage-related-events-container .list-events .list-content .column.width-20,\n.manage-related-events-container .list-events .list-ca .column.width-20 {\n  width: 20%;\n}\n.manage-related-events-container .list-events .list-header .column.width-30,\n.manage-related-events-container .list-events .list-content .column.width-30,\n.manage-related-events-container .list-events .list-ca .column.width-30 {\n  width: 30%;\n}\n.manage-related-events-container .list-events .list-content,\n.manage-related-events-container .list-events .list-ca {\n  background: #fff;\n}\n.manage-related-events-container .list-events .list-content .column,\n.manage-related-events-container .list-events .list-ca .column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-content .column .container-column,\n.manage-related-events-container .list-events .list-ca .column .container-column {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .list-events .list-content .column .container-column img,\n.manage-related-events-container .list-events .list-ca .column .container-column img {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .list-content .column:last-child,\n.manage-related-events-container .list-events .list-ca .column:last-child {\n  padding: 0 1rem;\n}\n.manage-related-events-container .list-events .list-content {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manage-related-events-container .list-events .list-ca {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manage-related-events-container .list-events .container-ca {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manage-related-events-container .list-events .container-text {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manage-related-events-container .list-events .container-text b {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .container-text .seperate {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manage-related-events-container .list-events .load-more {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .list-events .load-more span {\n  position: absolute;\n}\n.manage-related-events-container .list-events .load-more button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.client-contact-email-page {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n  padding: 2rem;\n}\n.client-contact-email-page .header-email-page {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .header-email-page p {\n  font-weight: 600;\n  font-size: 1.5em;\n  color: #1D1D1D;\n  margin: 0;\n}\n.client-contact-email-page .header-email-page .icon-close {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.client-contact-email-page .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper {\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event {\n  margin-top: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn {\n  margin-bottom: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn .event-count {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn label {\n  font-size: 1em;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item .event-name:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  width: 8%;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-send {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  width: 8%;\n  margin-left: 1rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.client-contact-email-page .recipients-section .list-email-recipient,\n.client-contact-email-page .cc-section .list-email-recipient,\n.client-contact-email-page .email-template-wrapper .list-email-recipient {\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper {\n  position: relative;\n  margin: .5rem;\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 5px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input {\n  border: none;\n  background-color: #FFF;\n  border-radius: 5px;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to {\n  padding: 16px;\n  overflow: auto;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-wrapper {\n  margin-top: 30px;\n}\n.client-contact-email-page .recipients-wrapper .recipients-section .list-email-send-to {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .cc-section .list-email-send-to {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .text-mar-bot {\n  margin-bottom: 1.5rem;\n}\n.client-contact-email-page .text-send-email {\n  margin: 2rem 0 1em 0;\n  font-weight: 600;\n}\n.client-contact-email-page .send-email-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .participant-emails {\n  padding: 0 1.2% 0 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper .text-subject {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  padding: 0.3rem 0.6rem;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn {\n  margin-right: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text {\n  font-weight: normal;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn label {\n  font-size: 1em;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container {\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.client-contact-email-page .group-btn .ap-btn {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.client-contact-email-page .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-body {\n  padding: 24px;\n}\n.modal-body .description {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper {\n  padding: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper {\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .body-text {\n  color: #1D1D1D;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .ap-input-wrapper .input {\n  color: #000;\n  font-size: 16px;\n  line-height: 20px;\n  padding: 12px 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-cancell-all-appointment {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.modal-cancell-all-appointment .modal-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n  border: 0;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button {\n  float: right;\n  font-size: 20px;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button:hover {\n  cursor: pointer;\n}\n.modal-cancell-all-appointment .modal-body {\n  margin-top: 1rem !important;\n}\n.modal-cancell-all-appointment .modal-body p {\n  font-size: 1.7em;\n  font-weight: 600;\n}\n.modal-cancell-all-appointment .modal-body .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 3rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes,\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-weight: 600;\n  font-size: 16px;\n  width: 5rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes .text-primary,\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no .text-primary {\n  width: 1rem;\n  height: 1rem;\n}\n.add-participant-modal .participant-info {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .title-field {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .field-input {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n  width: 100%;\n  padding: 12px 16px;\n  height: unset;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .error-message {\n  color: #FF3400;\n  font-size: 12px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .email-employee-container {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .select-more-services {\n  padding: 24px 16px 0;\n}\n.add-participant-modal .participant-info .select-more-services .title-field {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .select-more-services .add-more-services-checkbox {\n  margin-top: 8px;\n}\n.add-participant-modal .btn-add-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.add-participant-modal .btn-add-container .btn-cancel {\n  margin-right: 24px;\n}\n.add-participant-modal .btn-add-container .btn-add-participant {\n  padding: 12px 32px;\n}\n.bulk-create-events {\n  padding: 2rem 2.5rem;\n}\n.bulk-create-events .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #1674CD;\n}\n.bulk-create-events .bulk-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .bulk-title p {\n  font-weight: 600;\n  font-size: 24px;\n  margin-bottom: 0;\n}\n.bulk-create-events .bulk-title .btn-bulk {\n  font-weight: 600;\n  color: #1674CD;\n  background: #FFFFFF;\n  border: 1px solid #b9b9b9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 1rem;\n  font-size: 16px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bulk-create-events .bulk-title .btn-bulk img,\n.bulk-create-events .bulk-title .btn-bulk .spinner-border {\n  margin-right: .7rem;\n}\n.bulk-create-events .upload-file {\n  margin-top: 2rem;\n}\n.bulk-create-events .upload-file .dropzone-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 3rem;\n  border: 2px dashed #ccc;\n  border-radius: 15px;\n}\n.bulk-create-events .upload-file .dropzone-container img {\n  height: 6rem;\n  width: 7rem;\n}\n.bulk-create-events .upload-file .dropzone-container .text-csv {\n  font-size: 1.1em;\n  margin: 1.5rem 0;\n  color: #B9B9B9;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop {\n  font-size: 2.4em;\n  font-weight: 500;\n  color: #000000;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop a {\n  color: #1674CD;\n  -webkit-text-decoration: revert;\n          text-decoration: revert;\n}\n.bulk-create-events hr {\n  margin: 2rem 0;\n}\n.bulk-create-events .submission-history {\n  min-height: 40vh;\n}\n.bulk-create-events .submission-history p {\n  font-size: 1.2em;\n  font-weight: 600;\n}\n.bulk-create-events .submission-history table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.bulk-create-events .submission-history table th,\n.bulk-create-events .submission-history table td {\n  border: 1px solid #e6e6e6;\n  padding: 1rem;\n}\n.bulk-create-events .submission-history table th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: left;\n  background-color: #FCFCFC;\n  color: #585858;\n  white-space: nowrap;\n}\n.bulk-create-events .submission-history table td {\n  color: #1D1D1D;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history table td a {\n  color: #1674CD;\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .pagination-container {\n  margin-top: 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .submission-history .pagination-container .total-text {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history .pagination-container .page-item {\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .textPass {\n  color: #0FAA55;\n}\n.bulk-create-events .submission-history .textFailed {\n  color: #E61C0A;\n}\n.bulk-create-events .submission-history .blink-text {\n  -webkit-animation: blinker 1s linear infinite;\n          animation: blinker 1s linear infinite;\n}\n.bulk-create-events .submission-history .blink-text .spinner-border {\n  margin-right: 0.5rem;\n}\n@-webkit-keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n@keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n.draft-events-modal {\n  padding: 2rem;\n}\n.draft-events-modal .add-on-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .add-on-wrapper p {\n  margin: 0;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 0.85em;\n}\n.draft-events-modal .add-on-wrapper .event-add-on {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input[type=checkbox] {\n  width: 0;\n  visibility: hidden;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 1px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.draft-events-modal .add-on-wrapper .event-add-on label:active:after {\n  width: 15px;\n}\n.draft-events-modal .header-modal {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .header-modal .container-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 20%;\n}\n.draft-events-modal .header-modal .container-title .draft-event {\n  color: #1D1D1D;\n  font-weight: 600;\n  font-size: 1.7em;\n  white-space: nowrap;\n  margin: 0;\n}\n.draft-events-modal .header-modal .modal-close {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.draft-events-modal .header-modal .modal-close:hover {\n  cursor: pointer;\n}\n.draft-events-modal .header-modal .modal-close .icon-close {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.draft-events-modal .text-title {\n  font-size: 1.2em;\n  font-weight: 600;\n  margin: 1.5rem 0 0 0;\n}\n.draft-events-modal .field-input {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.draft-events-modal .field-input label {\n  color: #1D1D1D;\n  font-size: 0.9em;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 16px;\n}\n.draft-events-modal .field-input input {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2rem;\n  padding: 0.4rem 0.6rem;\n  width: 100%;\n}\n.draft-events-modal .field-input .require-askterisk {\n  color: #ff0000;\n  position: absolute;\n  font-size: 1.5em;\n}\n.draft-events-modal .field-input select {\n  width: 30%;\n  border-radius: 5px;\n}\n.draft-events-modal .field-input .text-error {\n  color: #ff0000;\n  font-size: 0.9em;\n  margin-top: .3rem;\n}\n.draft-events-modal .field-input .border-error {\n  border-color: #ff0000;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags {\n  height: 2rem;\n  min-height: auto;\n  border: 1px solid #b9b9b9;\n  padding: 0.4rem 0.5rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags input {\n  width: 80% !important;\n  margin: 0;\n  border: 0;\n  padding: 0 !important;\n  font-size: 13px;\n  height: 0rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__placeholder {\n  margin: 0;\n}\n.draft-events-modal .field-input .field-contact .multiselect__select::before {\n  content: none;\n}\n.draft-events-modal .field-input .field-contact .contact-name,\n.draft-events-modal .field-input .field-contact p {\n  margin-bottom: 0.2rem;\n}\n.draft-events-modal .field-input .field-contact .contact-name {\n  text-transform: capitalize;\n}\n.draft-events-modal .field-input .field-contact .multiselect__content-wrapper {\n  min-height: 3rem;\n}\n.draft-events-modal .field-input .log-error,\n.draft-events-modal .field-input .icon-alert,\n.draft-events-modal .field-input .text-alert {\n  padding: 0;\n  margin-top: 0.3rem;\n}\n.draft-events-modal .field-input .icon-alert {\n  color: #0080a5;\n}\n.draft-events-modal .field-input:first-child,\n.draft-events-modal .add-on-wrapper:first-child {\n  padding-left: 0;\n}\n.draft-events-modal .field-input:last-child,\n.draft-events-modal .add-on-wrapper:last-child {\n  padding-right: 0;\n}\n.draft-events-modal .row {\n  margin: 1.3rem 0 0 0;\n}\n.draft-events-modal .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 5rem;\n}\n.draft-events-modal .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit,\n.draft-events-modal .btn-container .btn-right-container .btn-save {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit {\n  margin-right: 1rem;\n}\n.draft-events-modal .btn-container .btn-right-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.draft-events-modal .text-toggle-on {\n  color: #1674CD;\n}\n.draft-events-modal .greyOut {\n  color: #AAA7A4;\n}\n.modal-submit-drafts .main-content {\n  padding: 2rem;\n}\n.modal-submit-drafts .main-content .text-question {\n  color: #1D1D1D;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5em;\n  line-height: 32px;\n}\n.modal-submit-drafts .main-content .text-description {\n  font-weight: normal;\n  font-size: 1em;\n  color: #1D1D1D;\n}\n.modal-submit-drafts .main-content .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel,\n.modal-submit-drafts .main-content .btn-container .btn-submit {\n  padding: .2rem 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1em;\n  line-height: 24px;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  margin-right: 2rem;\n  color: #1674CD;\n}\n.modal-submit-drafts .main-content .btn-container .btn-submit {\n  color: #FFFFFF;\n  background: #1674CD;\n  border-radius: 4px;\n  border: 0;\n}\n.modal-submit-drafts .main-content .btn-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.table-events-plan {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.email-histories-page {\n  font-family: 'Open Sans', sans-serif;\n}\n.email-histories-page .hisories-page-header {\n  background-color: #FFF;\n  padding-top: 16px;\n  border-bottom: 1px solid #E6E6E6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper {\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name .text {\n  color: #E6E6E6;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  padding-bottom: 10px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name.active .text {\n  color: #00A4D6;\n  border-bottom: 3px solid #00A4D6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name + .tab-name {\n  margin-left: 50px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper {\n  padding-bottom: 16px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body {\n  height: calc(100vh - 146px);\n}\n.email-histories-page .histories-page-body .ems-table {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section {\n  margin-top: 24px;\n  width: 50%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section .input {\n  color: #000;\n  padding: 12px 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-participant-container {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header {\n  margin-top: 24px;\n  padding: 12px 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header .ems-header-column:first-child .content {\n  padding-left: 25px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row {\n  height: 58px;\n  padding: 12px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .action-text {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 0;\n  padding-left: 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value:first-child {\n  padding-left: 40px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value.resend-btn-wrapper {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-right: 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value .resend-btn {\n  padding: 6px 24px;\n}\n.email-histories-page .histories-page-body .histories-table-container {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row {\n  height: 56px;\n  padding: 20px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row .action-text {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-history-details-container {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.email-history-details-container .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-history-details-body {\n  padding-bottom: 112px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper {\n  margin-top: 40px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type {\n  margin-top: 16px;\n  color: #606060;\n  font-size: 16px;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn {\n  margin-bottom: 16px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn .event-count {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item .event-name:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient,\n.email-history-details-container .cc-section .list-email-recipient,\n.email-history-details-container .email-template-wrapper .list-email-recipient {\n  margin-top: 16px;\n  border-radius: 4px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper {\n  position: relative;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input {\n  border: none;\n  border-bottom: 1px solid #b9b9b9;\n  background-color: #FFF;\n  border-radius: 4px 4px 0 0;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to {\n  overflow: auto;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date {\n  min-width: 110px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-wrapper {\n  margin-top: 30px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .template-value {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn {\n  margin-right: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text {\n  font-weight: normal;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_top {\n  display: none !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents {\n  padding: 2px !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents iframe {\n  margin: 0 !important;\n  padding: -20px !important;\n}\n.email-history-details-container .email-template-wrapper .email-body-section {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content {\n  height: 416px;\n  padding: 16px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  overflow: auto;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_top,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_bottom {\n  display: none;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient {\n  margin-top: 8px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.email-history-details-container .group-btn .ap-btn {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.email-history-details-container .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-body {\n  padding: 24px;\n}\n.modal-body .description {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.mfa-container .mfa-box {\n  padding: 32px;\n}\n.mfa-container .mfa-box-title {\n  margin-bottom: 16px;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 40px;\n  color: #424242;\n  text-transform: uppercase;\n}\n.mfa-container .mfa-box-title.has-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.mfa-container .mfa-paragraph {\n  margin-bottom: 16px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1d1d1d;\n}\n.mfa-container .btn-group-author {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 32px;\n}\n.mfa-container .btn-group-author .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.mfa-container .btn-group-author .btn + .btn {\n  margin-left: 16px;\n}\n.mfa-container .ad-support-link {\n  margin-top: 32px;\n  text-align: center;\n  font-size: 16px;\n  color: #1d1d1d;\n}\n.mfa-container .ad-support-link .awp-link {\n  color: #00A4D6;\n}\n.mfa-container .field-input-wrapper .input-wrapper .icon-wrapper {\n  top: 50%;\n  margin-top: -12px;\n}\n.authorization-container {\n  margin-top: 40px;\n}\n.authorization-container .form-content {\n  padding-bottom: 35px;\n}\n.authorization-container .form-content .nav-tab {\n  margin: 30px 0 25px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  margin-right: 24px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view:hover {\n  cursor: pointer;\n}\n.authorization-container .form-content .nav-tab .btn-router-view.selected {\n  color: #00A4D6;\n}\n.authorization-container .form-content .authorization-from {\n  padding: 32px;\n}\n.authorization-container .text-enter-code-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 16px;\n}\n.authorization-container .text-enter-code-container .enter {\n  color: #1D1D1D;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n.authorization-container .text-enter-code-container .code {\n  color: #D92C27;\n}\n.authorization-container .mfa-description {\n  text-align: center;\n  margin-top: 24px;\n  color: #1D1D1D;\n}\n.authorization-container .mfa-description .text-code-expire {\n  margin-top: 24px;\n}\n.authorization-container .mfa-input-code {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 88px;\n}\n.authorization-container .mfa-input-code .mfa-input {\n  text-align: center;\n  border: none;\n  background-color: #f5f5f5;\n}\n.authorization-container .mfa-input-code .btn-continue-wrapper {\n  margin-top: 64px;\n}\n.authorization-container .mfa-input-code .text-send-new-code {\n  margin-top: 24px;\n  color: #00A4D6;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n}\n.authorization-container .img-content .castlight-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.authorization-container .img-content .castlight-row .castlight-title {\n  color: #424242;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-right: 16px;\n}\n.authorization-container .img-content .castlight-row .img-castlight {\n  height: 56.1px;\n  width: 166px;\n}\n.participant-header-column .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.participant-header-column .content:hover {\n  cursor: pointer;\n}\n.participant-header-column .caption-text {\n  font-weight: bold;\n}\n.participant-header-column .icon-sort {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.participant-header-column .non-sort {\n  background: url(" + __webpack_require__(229) + ") center no-repeat;\n}\n.participant-header-column .sort-up {\n  background: url(" + __webpack_require__(230) + ") center no-repeat;\n}\n.participant-header-column .sort-down {\n  background: url(" + __webpack_require__(231) + ") center no-repeat;\n}\n@-webkit-keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.spinner-container {\n  position: relative;\n  margin: 0 auto;\n}\n.spinner-container .spinner-inner {\n  border: 1px solid #B9B9B9;\n  border-top-color: #00A4D6;\n  -webkit-animation: spinner .6s linear infinite;\n          animation: spinner .6s linear infinite;\n  border-radius: 50%;\n}\n.event-completed-report-card {\n  background-color: #FFF;\n  width: 270px;\n  margin-top: 24px;\n}\n.event-completed-report-card .spinner-loading {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.event-completed-report-card .top-card {\n  padding: 16px 10px;\n}\n.event-completed-report-card .top-card .event-name {\n  text-align: center;\n  font-weight: bold;\n  color: #1D1D1D;\n}\n.event-completed-report-card .top-card .expected-screened {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .top-card .expected-screened .expected,\n.event-completed-report-card .top-card .expected-screened .screened {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .top-card .expected-screened .expected .value,\n.event-completed-report-card .top-card .expected-screened .screened .value {\n  color: #0095D9;\n}\n.event-completed-report-card .bottom-card {\n  border-top: 1px solid #E6E6E6;\n  background-color: #FCFCFC;\n  border-radius: 0 0 4px 4px;\n  padding: 8px 10px 16px;\n}\n.event-completed-report-card .bottom-card .projected-scheduled {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected,\n.event-completed-report-card .bottom-card .projected-scheduled .screened {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected .value {\n  color: #5FA813;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .screened .value {\n  color: #444444;\n}\n.event-item-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  padding: 0 2rem;\n  height: 35px;\n  z-index: 0;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top: solid 1px #d4d4d4;\n}\n.event-item-icon-underline-color-grey {\n  border: 2px solid #9b9b9b;\n}\n.event-item-icon-underline-color-blue {\n  border: 2px solid #00A4D6;\n}\n.event-item-icon-underline-color-red {\n  border: 2px solid #a42022;\n}\n.event-item-icon-underline-color-green {\n  border: 2px solid #417505;\n}\n.event-item-icon-underline-color-brow {\n  border: 2px solid #463e38;\n}\n.event-item-icon-underline {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 14px;\n  margin-top: 4px;\n}\n.event-item-icon-amount {\n  font-family: \"Open Sans\", sans-serif;\n  text-align: center;\n  margin: 2px 0 0 5px;\n  height: 25px;\n  width: 14px;\n  color: #201D1A;\n  font-size: 12px;\n  line-height: 25px;\n}\n.event-item-icon-component {\n  background-color: #ffffff;\n  float: left;\n  margin: 5px 0 0 3px;\n  width: 65px;\n  padding: 0 3px 0 3px;\n}\n.event-item-icon {\n  height: 25px;\n  width: 25px;\n  color: #2d2827;\n}\n.no-margin-left-right {\n  margin: 5px 0 0 0;\n}\n.icon-footer {\n  width: 25px;\n  height: 25px;\n  background-color: #2d2827;\n}\n.icon-footer.icon-draft {\n  -webkit-mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  background: url(" + __webpack_require__(62) + ");\n}\n.icon-footer.icon-needs-review {\n  -webkit-mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  background: url(" + __webpack_require__(63) + ");\n}\n.icon-footer.icon-submitted {\n  -webkit-mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  background: url(" + __webpack_require__(64) + ");\n}\n.icon-footer.icon-approved {\n  -webkit-mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  background: url(" + __webpack_require__(65) + ");\n}\n.search-session {\n  height: 124px;\n  padding-top: 35px;\n  padding-left: 24px;\n}\n.search-session .placeholder-italic {\n  margin-top: 10px;\n  border: 1px solid #9b9b9b;\n  padding: 3px 15px;\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  border-radius: 3px;\n  background-color: #FFF;\n  z-index: 1;\n}\n.search-session .search-icon {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 998;\n  color: #00A4D6;\n  width: 25px;\n  height: 25px;\n}\n.search-session .search-icon:hover {\n  cursor: pointer;\n  color: #00A4D6;\n}\n.search-session .btn-create-client {\n  position: relative;\n  width: 150px;\n}\n.search-session .btn-create-client .icon-add-client {\n  z-index: 999;\n  color: #FFF;\n  background-color: #0080a5;\n  width: 27px;\n  height: 27px;\n  border-radius: 15px;\n  margin-top: 17px;\n  display: inline-block;\n}\n.search-session .btn-create-client .btn-text {\n  display: inline-block;\n  position: absolute;\n  top: 18px;\n  left: 35px;\n  cursor: pointer;\n}\n.search-icon {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.event-items-management {\n  padding: 24px 12px;\n}\n.event-items-management .section-name {\n  height: 16px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 0 12px 0;\n}\n.event-items-management .client-card-list-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.event-items-management .client-card-list-wrapper .event-item {\n  margin: 12px;\n}\n.event-item {\n  height: 180px;\n  width: 290px;\n  border-radius: 4px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  top: 0;\n  -webkit-transition: top .25s;\n  transition: top .25s;\n  -webkit-transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n          transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n}\n.event-item:hover {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  top: -10px;\n}\n.event-item:hover .delete-client-button {\n  display: block;\n}\n.event-item.noTransition:hover {\n  -webkit-transition: none;\n  transition: none;\n}\n.event-item .delete-client-button {\n  /*display: none;*/\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  height: 24px;\n  width: 24px;\n  z-index: 1;\n}\n.event-item .delete-client-button:hover {\n  background-color: #f5f5f5;\n}\n.event-item .delete-client-button .icon-delete {\n  height: 24px;\n  width: 24px;\n  background: url(" + __webpack_require__(232) + ");\n}\n.event-item .event-item-custom-message {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  color: #3caae9;\n  z-index: 999;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon.icon-gear {\n  -webkit-mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  background: url(" + __webpack_require__(233) + ");\n}\n.event-item .event-item-header {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  position: absolute;\n  height: 145px;\n  overflow: visible;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  padding: 0 24px;\n}\n.event-item .event-item-header .wrapper-event-item-name {\n  height: 45px;\n}\n.event-item .event-item-header .wrapper-event-item-name .event-item-name {\n  font-family: 'Open Sans', sans-serif;\n  max-width: 216px;\n  width: 291px;\n  color: #20AAE9;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto 10px;\n  max-height: 100%;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.event-item .event-item-header .event-item-role {\n  margin: 4px;\n}\n.event-item .event-item-header .event-item-role .event-manager .event-item-role-text-em {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 18px;\n  color: #424242;\n  text-align: center;\n  width: 100%;\n  border: none;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown {\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .btn-group.btn:first-child {\n  font-weight: 600;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 24px;\n  padding: 4px 10px;\n  font-weight: 400;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  font-weight: unset;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  font-size: 14px;\n  line-height: 16px;\n}\n.event-item .event-item-header .event-item-role .multiselect {\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n  margin: 10px auto 0;\n  text-align: center;\n  width: 100%;\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am.multiselect {\n  min-height: 0;\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags {\n  border: none;\n  padding: 0;\n  min-height: unset;\n  height: unset;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags .multiselect__single {\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__select {\n  display: none;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am {\n  position: relative;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input {\n  border-radius: 3px;\n  color: #9b9b9b;\n  text-align: center;\n  border: none;\n  font-size: 14px;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input:hover {\n  cursor: pointer;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__content-wrapper {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.event-item-name {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto;\n}\n.event-item-role-icon {\n  height: 12px;\n  width: 11px;\n  color: #0080a5;\n  position: absolute;\n  width: auto;\n  float: right;\n}\n.manageWrapper .search-container {\n  padding: 1.5rem;\n  background: #FFFFFF;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .search-container .manage-header p {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .title {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .item {\n  width: 23rem;\n}\n.manageWrapper .search-container .manage-header button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1.1em;\n  padding: 8px 24px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .multiselect,\n.manageWrapper .search-container .manage-header .multiselect__input,\n.manageWrapper .search-container .manage-header .multiselect__single {\n  font-size: 14px;\n}\n.manageWrapper .search-container .text-manage-events {\n  color: #1D1D1D;\n  font-size: 1.1em;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter {\n  margin-top: 2rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .search-container .container-filter .filter-date-range {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 23rem;\n  margin-right: 1.5rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.3rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-date-range,\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear {\n  font-size: 12px;\n  margin: 0;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear {\n  color: #1674CD;\n  opacity: 0.6;\n  cursor: pointer;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter p {\n  margin: 0;\n  padding: 0 0.5rem;\n  font-size: 12px;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter input {\n  border-radius: 3px;\n  border: 1px solid #9b9b9b;\n  height: 2.2rem;\n  padding: 0.7rem;\n}\n.manageWrapper .search-container .container-filter .search-events p {\n  margin-bottom: .3rem;\n  font-size: 12px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group {\n  border-radius: 4px;\n  border: 1px solid #9b9b9b;\n  width: 20rem;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group input {\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  height: 100%;\n  border-radius: 3px;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button {\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button .search-icon {\n  color: #000;\n}\n.manageWrapper .search-container .container-filter .total-count {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n      -ms-flex-flow: column-reverse;\n          flex-flow: column-reverse;\n  margin-left: auto;\n  font-size: 14px;\n  font-weight: 600;\n}\n.manageWrapper .list-events {\n  padding: 1.5rem;\n}\n.manageWrapper .list-events .list-container {\n  margin: 2rem 0;\n}\n.manageWrapper .list-events .list-group-container {\n  margin: 3rem 0;\n}\n.manageWrapper .list-events .list-header,\n.manageWrapper .list-events .list-content,\n.manageWrapper .list-events .list-ca {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-header .column,\n.manageWrapper .list-events .list-content .column,\n.manageWrapper .list-events .list-ca .column {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-header .column .container-column,\n.manageWrapper .list-events .list-content .column .container-column,\n.manageWrapper .list-events .list-ca .column .container-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manageWrapper .list-events .list-header .column .container-column .live-click,\n.manageWrapper .list-events .list-content .column .container-column .live-click,\n.manageWrapper .list-events .list-ca .column .container-column .live-click {\n  cursor: pointer;\n}\n.manageWrapper .list-events .list-header .column .container-column p,\n.manageWrapper .list-events .list-content .column .container-column p,\n.manageWrapper .list-events .list-ca .column .container-column p {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manageWrapper .list-events .list-header .column .container-column button,\n.manageWrapper .list-events .list-content .column .container-column button,\n.manageWrapper .list-events .list-ca .column .container-column button {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .list-events .list-header .column .container-column button img,\n.manageWrapper .list-events .list-content .column .container-column button img,\n.manageWrapper .list-events .list-ca .column .container-column button img {\n  height: 0.6rem;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-header,\n.manageWrapper .list-events .list-content .column .container-column .text-header,\n.manageWrapper .list-events .list-ca .column .container-column .text-header {\n  font-weight: 600;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-icon,\n.manageWrapper .list-events .list-content .column .container-column .text-icon,\n.manageWrapper .list-events .list-ca .column .container-column .text-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-not-live,\n.manageWrapper .list-events .list-content .column .container-column .text-not-live,\n.manageWrapper .list-events .list-ca .column .container-column .text-not-live {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manageWrapper .list-events .list-header .column .border-seperate,\n.manageWrapper .list-events .list-content .column .border-seperate,\n.manageWrapper .list-events .list-ca .column .border-seperate {\n  border-right: 1px solid #B9B9B9;\n}\n.manageWrapper .list-events .list-header .column.event-date,\n.manageWrapper .list-events .list-content .column.event-date,\n.manageWrapper .list-events .list-ca .column.event-date {\n  width: 14.28%;\n}\n.manageWrapper .list-events .list-header .column.w-2,\n.manageWrapper .list-events .list-content .column.w-2,\n.manageWrapper .list-events .list-ca .column.w-2 {\n  width: 2%;\n}\n.manageWrapper .list-events .list-header .column.w-12,\n.manageWrapper .list-events .list-content .column.w-12,\n.manageWrapper .list-events .list-ca .column.w-12 {\n  width: 12%;\n}\n.manageWrapper .list-events .list-header .column.w-14,\n.manageWrapper .list-events .list-content .column.w-14,\n.manageWrapper .list-events .list-ca .column.w-14 {\n  width: 14%;\n}\n.manageWrapper .list-events .list-header .column.w-16,\n.manageWrapper .list-events .list-content .column.w-16,\n.manageWrapper .list-events .list-ca .column.w-16 {\n  width: 16%;\n}\n.manageWrapper .list-events .list-header.green-line,\n.manageWrapper .list-events .list-content.green-line,\n.manageWrapper .list-events .list-ca.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-header.green-line,\n.manageWrapper .list-events .list-content.green-line,\n.manageWrapper .list-events .list-ca.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-content,\n.manageWrapper .list-events .list-ca {\n  background: #fff;\n}\n.manageWrapper .list-events .list-content .column,\n.manageWrapper .list-events .list-ca .column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-content .column .container-column,\n.manageWrapper .list-events .list-ca .column .container-column {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manageWrapper .list-events .list-content .column .container-column img,\n.manageWrapper .list-events .list-ca .column .container-column img {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .list-content .column:last-child,\n.manageWrapper .list-events .list-ca .column:last-child {\n  padding: 1rem 1rem 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-content {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manageWrapper .list-events .list-ca {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manageWrapper .list-events .container-ca {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .list-events .container-ca .list-group-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.manageWrapper .list-events .container-ca .list-group-row.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .container-text {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manageWrapper .list-events .container-text b {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .container-text .seperate {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manageWrapper .list-events .load-more {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manageWrapper .list-events .load-more span {\n  position: absolute;\n}\n.manageWrapper .list-events .load-more button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.manageWrapper .footer {\n  background: white;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  bottom: 0;\n  left: 96px;\n  right: 0;\n  padding: 0.8rem 1.5rem;\n}\n.manageWrapper .footer .ap-btn {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.custom-modal .modal-title {\n  height: 32px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.custom-modal .configure-scheduler {\n  border-radius: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 6px 24px;\n  margin-left: 16px;\n}\n.custom-modal .label {\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.custom-modal .modal-header {\n  padding-left: 0;\n  width: 100%;\n  margin: 0  !important;\n  border-bottom: none !important;\n}\n.custom-modal .modal-header .modal-header-text {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 27px;\n}\n.custom-modal .modal-header .modal-header-text-edit {\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .input-client-name {\n  border: none;\n  height: 20px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  margin-top: 8px;\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .save-client-name-btn.btn {\n  float: right;\n  margin-left: 15px;\n  background-color: #0080A5;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-modal .modal-close-img {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.custom-modal .modal-box .main-content {\n  padding: 60px 60px 20px 40px;\n}\n.custom-modal .modal-box .overlay {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.custom-modal .modal-box .isLoading {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n}\n.custom-modal .modal-box .noDisplay {\n  display: none!important;\n}\n.custom-modal .modal-body {\n  font-family: 'Open Sans', sans-serif;\n  margin-top: 60px;\n}\n.custom-modal .modal-body.main-content {\n  margin: 0;\n  width: 100%;\n  padding: 5rem 0 0 0;\n}\n.custom-modal .add-on {\n  margin-top: 112px;\n}\n.custom-modal .add-on .title {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .add-on .description {\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .add-on .add-on-item {\n  width: 250px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 12px;\n}\n.custom-modal .add-on .add-on-item .text {\n  position: absolute;\n  left: 40px;\n  white-space: nowrap;\n}\n.custom-modal .add-on .add-on-item label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .add-on .add-on-item input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .add-on .add-on-item label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .add-on .add-on-item input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .add-on .add-on-item input:disabled + label {\n  background: #babfc0;\n  border: 1.5px solid #fff;\n}\n.custom-modal .add-on .add-on-item input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .add-on .add-on-item label:active:after {\n  width: 15px;\n}\n.custom-modal .secondary-am {\n  margin-top: 74px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .secondary-am .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .secondary-am .description {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .secondary-am .pick {\n  margin-top: 4px;\n  font-size: 14px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags {\n  border: 1px solid #9B9B9B;\n  height: auto  !important;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag {\n  background: #41b883;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 0 0.5rem 0 0;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {\n  margin-top: 3px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:hover {\n  background: #0092B4;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon:after {\n  color: #fff;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content {\n  margin: 7px auto;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content li.multiselect__element:last-child {\n  border-bottom: none;\n}\n.custom-modal .reseller-status {\n  margin-top: 72px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .reseller-status .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .reseller-status .description {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .reseller-status .reseller-toggle {\n  margin-top: 15px;\n}\n.custom-modal .reseller-status .reseller-toggle input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .reseller-status .reseller-toggle label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .reseller-status .reseller-toggle label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .reseller-status .reseller-toggle label:active:after {\n  width: 15px;\n}\n.custom-modal .reseller-status .read-only {\n  margin-top: 15px;\n}\n.custom-modal .last-child-pick {\n  position: relative;\n  margin-top: 15px;\n  height: 250px;\n}\n.button-view {\n  position: relative;\n}\n.button-view .btn-expand {\n  background: url(" + __webpack_require__(234) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-duplicate {\n  background: url(" + __webpack_require__(235) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-delete {\n  background: url(" + __webpack_require__(236) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status {\n  background: url(" + __webpack_require__(237) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status:disabled {\n  background: url(" + __webpack_require__(238) + ") no-repeat !important;\n}\n.button-view .btn-status-dropdown .dropdown-toggle::after {\n  display: none;\n}\n.button-view .btn-status-dropdown .dropdown-menu {\n  border-radius: 10px;\n  padding: 10px 0;\n  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  background: #FCFCFC;\n}\n.button-view .btn-status-dropdown button {\n  width: 100%;\n  height: 100%;\n}\n.button-view .btn-status-dropdown ul {\n  border-radius: 10px;\n}\n.button-view .btn-status-dropdown ul li a {\n  padding: 10px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.button-view .wrapper-list {\n  position: absolute;\n  left: -450%;\n  top: 16px;\n  z-index: 999;\n  cursor: pointer;\n}\n.button-view .wrapper-list .icon-information-black {\n  width: 27px;\n  height: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .icon-information-black {\n    background: url(" + __webpack_require__(38) + ");\n}\n}\n.button-view .wrapper-list .status-icon-black {\n  height: 27px;\n  width: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(31) + ") no-repeat center;\n  mask: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.button-view .wrapper-list .status-icon-black {\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .status-icon-black {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n.dashboard-manager .isLoading {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n  padding: 12rem 0;\n}\n.dashboard-manager .pagination-container {\n  margin-top: 1.5rem;\n  padding: 24px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.dashboard-manager .pagination-container .total-text {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.dashboard-manager .pagination-container .page-item {\n  cursor: pointer;\n}\n.global-setting-page-container {\n  padding: 24px;\n  background-color: #FFF;\n}\n.global-setting-page-container .staff-management-container {\n  padding: 24px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table {\n  margin-top: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header {\n  margin-top: 16px;\n  padding: 12px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header .col-mileage-rate {\n  padding-left: 40px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row {\n  padding: 12px 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .field-value {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn {\n  padding: 4px;\n  background-color: #1674CD;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn + .ap-btn {\n  margin-left: 8px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn .icon {\n  height: 24px;\n  width: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .edit-btn .icon {\n  background: url(" + __webpack_require__(153) + ") no-repeat center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .delete-btn .icon {\n  background: url(" + __webpack_require__(154) + ") no-repeat center;\n}\nbody {\n  font-family: 'Open Sans', sans-serif;\n}\n.body {\n  width: 90%;\n  margin: 10px auto;\n  height: auto;\n  text-align: center;\n  background-color: #FFF;\n  font-family: 'Open Sans', sans-serif;\n  min-width: 1024px;\n}\n.main .container-fluid {\n  padding: 0;\n}\na:hover {\n  text-decoration: none !important;\n}\n.v--modal {\n  -webkit-box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n          box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n}\n/**\n * CUSTOM STYLES\n */\n.has-error {\n  border: solid 1px red !important;\n}\n.line-copy-2 {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 63px;\n  width: 2px;\n  border-left: 10px solid #0080a5;\n}\n.content-header {\n  height: 29px;\n  width: 137px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  position: absolute;\n  margin: 25px 0 0 15px;\n}\n.content-body {\n  height: 19px;\n  color: #231F20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  position: absolute;\n  margin: 65px 0 0 15px;\n}\n.subHeader {\n  height: 100px;\n  width: 100%;\n  background-color: #FFF;\n}\n.header {\n  height: 70px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.header-card {\n  height: 46px;\n  width: 100%;\n  color: #FFF;\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 50px;\n}\n.content-dashboard-card {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 19px;\n}\n.wellmetrics-event-ma {\n  height: 29px;\n  width: 341px;\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n}\n.user-name {\n  height: 24px;\n  width: 94px;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n}\n.user-type {\n  height: 20px;\n  width: 78px;\n  color: #9b9b9b;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 300;\n  line-height: 20px;\n  text-align: center;\n}\n.shadow {\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.overview {\n  width: 100%;\n  height: 65px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 80px;\n  text-align: center;\n}\n.events {\n  height: 18px;\n  width: 47px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.bottomLine {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 80%;\n  border: 1px solid #FFF;\n  opacity: 0.5;\n  margin-top: 7px;\n  float: right;\n  margin-bottom: -5px;\n}\n.newEventForm {\n  padding: 20px;\n  margin: 20px;\n}\n.nopadding {\n  padding: 0 !important;\n}\n.noMargin {\n  margin-left: 0;\n  margin-right: 0;\n}\n.paddingTop27px {\n  padding-top: 27px;\n}\n.padding-left-20px {\n  padding-left: 20px;\n}\n.noPaddingLeft {\n  padding-left: 0;\n}\n.noPaddingRight {\n  padding-right: 0;\n}\n.margin-bottom-8px {\n  margin-bottom: 8px;\n}\n.margin-top-15px {\n  margin-top: 15px;\n}\n.margin-top-16px {\n  margin-top: 16px;\n}\n.margin-top-25px {\n  margin-top: 25px;\n}\n.margin-bottom-5px {\n  margin-bottom: 5px;\n}\n.margin-top-20px {\n  margin-top: 20px;\n}\n.margin-top-44px {\n  margin-top: 44px;\n}\n.margin-top-40px {\n  margin-top: 40px;\n}\n.margin-top-10px {\n  margin-top: 10px;\n}\n.margin-top-5px {\n  margin-top: 5px;\n}\n.margin-bottom-10px {\n  margin-bottom: 10px;\n}\n.padding-left-40px {\n  padding-left: 40px !important;\n}\n.padding-left-27px {\n  padding-left: 27px !important;\n}\n.padding-left-3px {\n  padding-left: 3px;\n}\n.padding-left-19px {\n  padding-left: 19px;\n}\n.clear-both {\n  clear: both;\n}\n.h2-title {\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.h4-title {\n  color: #0080A5;\n  font-family: Arquitecta, sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.no-select {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                   supported by Chrome and Opera */\n}\n.phoneAndEmail {\n  height: 34px;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  border-radius: 3px;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0 0 0 13px;\n  font-size: 14px;\n  color: #000;\n}\n.calendarCustom {\n  width: 300px;\n  border: none;\n  margin-right: 13px;\n}\n.outer-container {\n  position: relative;\n  float: left;\n  left: 50%;\n}\n.outer-container .inner-container {\n  position: relative;\n  float: left;\n  left: -50%;\n}\n::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #b9b9b9;\n}\n:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #b9b9b9;\n}\n::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #b9b9b9;\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #b9b9b9;\n}\n:-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #b9b9b9;\n}\n::placeholder {\n  /* Most modern browsers support this now. */\n  color: #b9b9b9;\n}\n.modal-body-user-info .multiselect__tags {\n  border: 1px solid #9B9B9B;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag {\n  background: #0092B4;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {\n  margin-top: 3px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:hover {\n  background: #0092B4;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon:after {\n  color: #fff;\n}\n.modal-body-user-info .multiselect__content-wrapper {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content {\n  margin: 7px auto;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content li.multiselect__element:last-child {\n  border-bottom: none;\n}\n.custom-toggle input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-toggle label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-toggle label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-toggle input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-toggle input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-toggle label:active:after {\n  width: 15px;\n}\n.display-none-something {\n  display: none !important;\n}\n.ems_confirm {\n  padding: 24px;\n}\n.ems_confirm .swal2-header {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.ems_confirm .swal2-header .ems_alert_title {\n  height: 40px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.ems_confirm .swal2-content .ems_alert_des {\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  font-weight: 400;\n}\n.ems_confirm .swal2-actions {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: unset;\n  margin-top: 45px;\n}\n.ems_confirm .swal2-actions .ems_alert_cancel {\n  border: 1px solid #00A4D6 !important;\n  color: #00A4D6 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.block {\n  background-color: #FF3400 !important;\n  border-left-color: #FF3400 !important;\n  border-right-color: #FF3400 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.open {\n  background-color: #00A4D6 !important;\n  border-left-color: #00A4D6 !important;\n  border-right-color: #00A4D6 !important;\n}\n.default-message {\n  color: #b9b9b9 !important;\n}\n.max-width-100 {\n  max-width: 100% !important;\n}\n.always-show {\n  display: block !important;\n  opacity: 1 !important;\n}\n.selected-staffing-item {\n  background-color: #e6e6e6 !important;\n}\n.un-selected-staffing-item {\n  background-color: #FFFFFF !important;\n}\n.form-control:disabled {\n  background-color: #FFFFFF;\n  opacity: 1;\n}\n.clear-both {\n  clear: both !important;\n}\n.action-btn {\n  height: 36px;\n  margin-left: 8px;\n}\n.action-btn:hover {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue .btn-text {\n  color: #FFF;\n}\n.action-btn.btn-white {\n  background-color: #f5f5f5;\n  color: #00A4D6;\n  border: solid 1px #00A4D6;\n}\n.action-btn.btn-white .btn-text {\n  color: #00A4D6;\n}\n.action-btn .btn-text {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.no-border {\n  border: none !important;\n}\n.opacity-04 {\n  opacity: 0.4;\n}\n.opacity-06 {\n  opacity: 0.6;\n}\n.field-input-wrapper {\n  margin-top: 24px;\n}\n.field-input-wrapper .attr-name {\n  color: #424242;\n  font-size: 16px;\n}\n.field-input-wrapper .message {\n  margin-top: 5px;\n  font-size: 16px;\n}\n.field-input-wrapper .message.error {\n  color: #E83001;\n}\n.field-input-wrapper .message.success {\n  color: #5FA813;\n}\n.field-input-wrapper .input-wrapper {\n  position: relative;\n}\n.field-input-wrapper .input-wrapper .input {\n  height: 48px;\n  margin-top: 5px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  line-height: 24px;\n  width: 100%;\n  padding-left: 10px;\n  font-size: 16px;\n}\n.field-input-wrapper .input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.field-input-wrapper .input-wrapper .input.success {\n  border: 1px solid #5FA813;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper {\n  position: absolute;\n  top: 16px;\n  right: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background-color: #3caae9;\n  background: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(239) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .help {\n  display: inline-block;\n  margin-top: 5px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.field-input-wrapper .help.is-danger {\n  color: #E83001;\n}\n.margin-side {\n  padding: 0 24px;\n}\n.remove-margin-side {\n  margin: 0 -24px;\n}\n.common-margin-left {\n  margin-left: 24px;\n}\n.v--modal-overlay {\n  z-index: 1020;\n}\n.icon-back {\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.icon-back {\n    background: url(" + __webpack_require__(92) + ");\n}\n}\n.common-card {\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.common-card .v--modal-box {\n  padding: 24px;\n}\n.common-card .v--modal-box .modal-close-img {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.common-card .v--modal-box .modal-close-img .icon-close {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.common-card .v--modal-box .modal-close-img .icon-close {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.common-card .v--modal-box .modal-close-img .icon-close:hover {\n  cursor: pointer;\n}\n.common-card .v--modal-box .modal-body {\n  margin-top: 16px;\n}\n.common-card .v--modal-box .modal-footer {\n  margin-top: 40px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.common-card .v--modal-box .modal-header,\n.common-card .v--modal-box .modal-body,\n.common-card .v--modal-box .modal-footer {\n  padding: 0;\n  border-bottom: none;\n  border-top: none;\n}\n.push-right {\n  float: right;\n}\n.remove-icon {\n  margin-left: 16px;\n  margin-top: 2px;\n  width: 27px;\n  height: 27px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.remove-icon {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.remove-icon:hover {\n  cursor: pointer;\n}\n.cke_chrome,\n.cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.cke_chrome .cke_inner,\n.cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_top,\n.cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_bottom,\n.cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.header-left-side {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.header-left-side .header-middle {\n  margin-left: 24px;\n}\n.custom-multiselect {\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper {\n  border: none;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  font-family: 'Open Sans', sans-serif;\n  z-index: 999;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content {\n  margin-top: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  padding-left: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element:hover {\n  background-color: #F5F5F5;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  min-height: 34px;\n  color: #231F20;\n  border-bottom: 1px solid #E6e6e6;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__tags {\n  border-color: #B9b9b9;\n  border-radius: 4px;\n  padding-left: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  color: #231F20;\n  height: 43px;\n}\n.custom-multiselect .multiselect .multiselect__tags:hover {\n  border-color: #B7B7B7;\n  color: #231F20;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input {\n  font-size: 14px;\n  margin-bottom: 0;\n  padding: 0;\n  height: 16px;\n  line-height: unset;\n  min-height: unset;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::-webkit-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::-moz-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input:-ms-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::placeholder {\n  color: #606060;\n}\n.ems-row {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.ems-row .field-value {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 0 16px;\n}\n.ems-table-header {\n  width: 100%;\n  height: 48px;\n  padding: 16px 0px;\n}\n.ems-table-header .ems-header-col {\n  float: left;\n  text-transform: uppercase;\n}\n.ems-table-header .ems-header-col .content {\n  padding-left: 16px;\n}\n.ems-table-header .ems-header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.ems-table-header .ems-header-col .header-container {\n  position: relative;\n}\n.ems-table-header .ems-header-col .crop {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n  overflow: hidden;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.ems-table-header .ems-header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n.event-container .app-body .main {\n  padding-bottom: 0;\n}\n.client-card-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.disable-button {\n  pointer-events: none;\n}\n.dt-row .MicrosoftMap .as_container_search {\n  left: 18%;\n  margin-top: 35px;\n}\n.dt-row .MicrosoftMap .as_container ul {\n  padding: 0 0 8px 0;\n}\n.dt-row .MicrosoftMap .as_container ul li {\n  border-top: 1px solid #e6e6e6;\n}\n.text-value .MicrosoftMap .as_container_search {\n  left: 10px;\n  margin-top: 0;\n}\n.address-input-bing {\n  height: 25px;\n  margin-top: 16px;\n  border: none;\n  outline: none;\n  padding-right: 15px;\n}\n.center-content {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.center-content .img-red-logo {\n  height: 64px;\n  width: 64px;\n}\n.center-content .form-wrapper {\n  padding: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content {\n  margin-top: 16px;\n  margin-bottom: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content #desc-reset-pass {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email-title {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email {\n  margin-top: 4px;\n}\n.center-content .form-wrapper .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.center-content .form-wrapper .button-content .btn-cancel {\n  margin-right: 16px;\n}\n.password-check-list {\n  margin-top: 24px;\n}\n.password-check-list .password-at-least {\n  color: #1d1d1d;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.password-check-list .indicators-password .indicator-item {\n  line-height: 16px;\n  font-size: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin-top: 8px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper {\n  height: 16px;\n  width: 16px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-reach {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(240) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-unreach {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(241) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .text {\n  margin-left: 8px;\n  letter-spacing: 0.1px;\n  color: #1d1d1d;\n}\n/* Hide HTML5 Up and Down arrows. */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n.multiselect--active {\n  z-index: 1000;\n}\n.ap-modal .modal-content {\n  min-height: 100%;\n  height: auto;\n  border: 1px solid #E6E6E6;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.ap-modal .modal-backdrop.show {\n  opacity: 0.3;\n}\n.ems-header-column {\n  position: relative;\n}\n.ems-header-column .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.ems-header-column .content .icon-sort {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.ems-header-column .non-sort {\n  background: url(" + __webpack_require__(242) + ") center no-repeat;\n}\n.ems-header-column .sort-up {\n  background: url(" + __webpack_require__(243) + ") center no-repeat;\n}\n.ems-header-column .sort-down {\n  background: url(" + __webpack_require__(244) + ") center no-repeat;\n}\n.ems-header-column .resize-line {\n  position: absolute;\n  width: 1px;\n  height: 16px;\n  right: 1px;\n  top: 0;\n  background-color: #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ems-header-column .resize-line:hover {\n  cursor: col-resize;\n}\n.ems-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ems-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ems-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ems-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.infinite-status-prompt {\n  display: none;\n}\n.toast-container > .toast-info {\n  background-color: #0080a5 !important;\n}\n.toast-container > .toast-error {\n  background-color: #FF3400 !important;\n}\n.toast-container > .toast-success {\n  background-color: #68B814 !important;\n}\n.toast-container > .toast-warning {\n  background-color: #E89819 !important;\n}\n.margin-top-24px {\n  margin-top: 24px;\n}\n.multiple-select-work-group {\n  position: relative;\n  height: 30px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect {\n  min-height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags {\n  min-height: 30px;\n  padding: 0 40px 0 8px;\n  border: none;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input {\n  color: #9b9b9b;\n  margin-bottom: 0;\n  min-height: 30px;\n  text-align: left;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input:hover {\n  cursor: pointer;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__placeholder {\n  margin-top: 5px;\n  margin-bottom: 0;\n  padding-top: 0;\n  color: #585858;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__single {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__select {\n  height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__content-wrapper {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.row-status {\n  color: #FFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 9px;\n  font-weight: bold;\n  line-height: 12px;\n  text-transform: uppercase;\n  padding: 2px 10px 2px 10px;\n  border-radius: 100px;\n}\n.row-status-color-grey {\n  background-color: #b9b9b9;\n}\n.row-status-color-light-blue {\n  background-color: #00A4D6;\n}\n.row-status-color-red {\n  background-color: #a42022;\n}\n.row-status-color-green {\n  background-color: #417505;\n}\n.row-status-color-brown {\n  background-color: #463e38;\n}\n", ""]);

// exports


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Row-Status',
  props: {
    eventStatus: {
      type: String
    }
  },
  data: function data() {
    return {
      rowStatus: {}
    };
  },

  computed: {
    calClass: function calClass() {
      var status = this.eventStatus.toLowerCase();
      if (status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.drafts.toLowerCase()) {
        return 'row-status-color-grey';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.submitted) {
        return 'row-status-color-light-blue';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.review) {
        return 'row-status-color-red';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.approved) {
        return 'row-status-color-green';
      }
      if (status === __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].eventStatus.archived) {
        return 'row-status-color-brown';
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("span", { staticClass: "row-status", class: _vm.calClass }, [
      _vm._v("\n    " + _vm._s(_vm.eventStatus) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-838bd2f2", esExports)
  }
}

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maskit;
function maskit(value, mask) {
  var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var tokens = arguments[3];

  value = value || '';
  mask = mask || '';
  var iMask = 0;
  var iValue = 0;
  var output = '';
  while (iMask < mask.length && iValue < value.length) {
    var cMask = mask[iMask];
    var masker = tokens[cMask];
    var cValue = value[iValue];
    if (masker && !masker.escape) {
      if (masker.pattern.test(cValue)) {
        output += masker.transform ? masker.transform(cValue) : cValue;
        iMask++;
      }
      iValue++;
    } else {
      if (masker && masker.escape) {
        iMask++; // take the next mask char and treat it as char
        cMask = mask[iMask];
      }
      if (masked) output += cMask;
      if (cValue === cMask) iValue++; // user typed the same char
      iMask++;
    }
  }

  // fix mask that ends with a char: (#)
  var restOutput = '';
  if (masked) {
    while (iMask < mask.length) {
      cMask = mask[iMask];
      if (tokens[cMask]) {
        restOutput = '';
        break;
      }
      restOutput += cMask;
      iMask++;
    }
  }

  return output + restOutput;
}

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicMask;
function dynamicMask(maskit, masks, tokens) {
  // masks = masks.sort((a, b) => a.length - b.length)
  return function (value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var i = 0;
    while (i < masks.length) {
      var currentMask = masks[i];
      i++;
      var nextMask = masks[i];
      if (!(nextMask && maskit(value, nextMask, true, tokens).length > currentMask.length)) {
        return maskit(value, currentMask, masked, tokens);
      }
    }
    return ''; // empty masks
  };
}

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999cc3f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__ = __webpack_require__(1474);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_999cc3f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/vue-the-mask/component.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] component.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-999cc3f6", Component.options)
  } else {
    hotAPI.reload("data-v-999cc3f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__masker__ = __webpack_require__(801);
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheMask',
  props: {
    value: [String, Number],
    mask: {
      type: [String, Array],
      required: true
    },
    masked: { // by default emits the value unformatted, change to true to format with the mask
      type: Boolean,
      default: false // raw
    },
    tokens: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__tokens___default.a;
      }
    }
  },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */] },
  data: function data() {
    return {
      lastValue: null, // avoid unecessary emit when has no change
      display: this.value
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue !== this.lastValue) {
        this.display = newValue;
      }
    },
    masked: function masked() {
      this.refresh(this.display);
    }
  },
  computed: {
    config: function config() {
      return {
        mask: this.mask,
        tokens: this.tokens,
        masked: this.masked
      };
    }
  },
  methods: {
    blurFunc: function blurFunc() {
      this.$emit('onTheMaskBlur', true);
    },
    onInput: function onInput(e) {
      if (e.isTrusted) return; // ignore native event
      this.refresh(e.target.value);
    },
    refresh: function refresh(value) {
      this.display = value;
      value = Object(__WEBPACK_IMPORTED_MODULE_2__masker__["a" /* default */])(value, this.mask, this.masked, this.tokens);
      if (value !== this.lastValue) {
        this.lastValue = value;
        this.$emit('input', value);
      }
    }
  }
});

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "mask",
        rawName: "v-mask",
        value: _vm.config,
        expression: "config"
      }
    ],
    attrs: { type: "text" },
    domProps: { value: _vm.display },
    on: {
      input: _vm.onInput,
      blur: function($event) {
        _vm.blurFunc()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-999cc3f6", esExports)
  }
}

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dt-row" },
    [
      _c(
        "div",
        {
          staticClass: "dt-row-detail",
          class:
            _vm.item.id === _vm.expandId || _vm.index % 2 == 0 ? "active" : null
        },
        [
          _c(
            "div",
            {
              staticClass: "body-col event-name",
              class: _vm.item.id != _vm.expandId ? "collapsed" : null,
              staticStyle: { width: "12%" },
              attrs: {
                block: "",
                "aria-controls": _vm.accordionId,
                "aria-expanded": _vm.item.id === _vm.expandId ? "true" : "false"
              },
              on: {
                click: function($event) {
                  _vm.setExpandId(_vm.item.id)
                  _vm.showCollapse = !_vm.showCollapse
                }
              }
            },
            [
              _c("div", { staticClass: "client-name" }, [
                _vm.viewMode != "Client"
                  ? _c("span", [_vm._v(_vm._s(_vm.item.clientName))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "name" },
                [
                  !_vm.showCollapse
                    ? _c("Icon", {
                        staticClass: "event-icon",
                        attrs: { name: "chevron-right" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCollapse
                    ? _c("Icon", {
                        staticClass: "event-icon",
                        attrs: { name: "chevron-down" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "icon-circle" },
                    [
                      _vm.item.isChangeOrder
                        ? _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle circle-red",
                            attrs: { name: "exclamation-circle" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.item.eventName || _vm.eventName))
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "body-col", staticStyle: { width: "9%" } },
            [
              _c("the-mask", {
                staticClass: "data-table-row-edit-mode-text",
                attrs: {
                  mask: "##/##/####",
                  value: _vm.item.prefDate || "",
                  masked: _vm.isTrue,
                  readonly: !_vm.editable
                },
                model: {
                  value: _vm.item.prefDate,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "prefDate", $$v)
                  },
                  expression: "item.prefDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "5%" } }, [
            _c(
              "div",
              { staticClass: "data-table-icon-circle" },
              [
                _vm.enableIconProjPart
                  ? _c("Icon", {
                      staticClass:
                        "row-detail-icon row-detail-icon-exclamation-circle",
                      attrs: { name: "exclamation-circle" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.projPart,
                  expression: "item.projPart"
                }
              ],
              staticClass:
                "data-table-row-edit-mode-text data-table-row-edit-mode-input-small",
              attrs: { placeholder: "100", readonly: !_vm.editable },
              domProps: { value: _vm.item.projPart },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "projPart", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "body-col", staticStyle: { width: "27%" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.item.fullAddress,
                    expression: "item.fullAddress"
                  }
                ],
                staticClass: "data-table-row-edit-mode-text",
                attrs: { placeholder: "Address", readonly: !_vm.editable },
                domProps: { value: _vm.item.fullAddress },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.item, "fullAddress", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "7%" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.eventLocation,
                  expression: "item.eventLocation"
                }
              ],
              staticClass: "data-table-row-edit-mode-text",
              attrs: { placeholder: "Building 3", readonly: !_vm.editable },
              domProps: { value: _vm.item.eventLocation },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "eventLocation", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "7%" } }, [
            _c("span", [_vm._v(_vm._s(_vm.item.startTime))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "5%" } }, [
            _c(
              "div",
              { staticClass: "data-table-icon-circle" },
              [
                _vm.enableIconProjPart
                  ? _c("Icon", {
                      staticClass:
                        "row-detail-icon row-detail-icon-exclamation-circle",
                      attrs: { name: "exclamation-circle" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.calculateDuration))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "7%" } }, [
            _c("span", {}, [_vm._v(_vm._s(_vm.calculateTimeEnd))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "4%" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.timeZone,
                  expression: "item.timeZone"
                }
              ],
              staticClass: "data-table-row-edit-mode-text",
              attrs: { placeholder: "EST", readonly: !_vm.editable },
              domProps: { value: _vm.item.timeZone },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "timeZone", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "9%" } }, [
            _c(
              "div",
              { staticClass: "data-table-icon-circle" },
              [
                _vm.disableIconContact
                  ? _c("Icon", {
                      staticClass:
                        "row-detail-icon row-detail-icon-exclamation-circle",
                      attrs: { name: "exclamation-circle" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.contactName,
                  expression: "item.contactName"
                }
              ],
              staticClass:
                "data-table-row-edit-mode-text data-table-input-contact-name",
              attrs: { placeholder: "Daniel", readonly: !_vm.editable },
              domProps: { value: _vm.item.contactName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item, "contactName", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-col", staticStyle: { width: "8%" } }, [
            _c(
              "div",
              [_c("RowStatus", { attrs: { eventStatus: _vm.item.status } })],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: _vm.accordionId, accordion: "datatable-accordion" },
          model: {
            value: _vm.showCollapse,
            callback: function($$v) {
              _vm.showCollapse = $$v
            },
            expression: "showCollapse"
          }
        },
        [
          _c("div", { staticClass: "dt-row-item-detail" }, [
            _c("div", { staticClass: "item-detail-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-2" }, [_vm._v("alerts")]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-7" }, [_vm._v("event notes")]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _vm._v("on site contact")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-detail-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-3" }, [
                  _c("ul", [
                    _vm.item.projPart < 33
                      ? _c("li", [
                          _vm._v(
                            "Events under 33 participants are flagged with small site message."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.projPart >= 200
                      ? _c("li", [
                          _vm._v(
                            "Your estimated participation is high. Break event into 2 days."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.disableIconContact
                      ? _c("li", [
                          _vm._v(
                            "Missing email and phone number for on site contact."
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6" }, [
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                shipping address\n                "
                      ),
                      _c("span", { staticClass: "grey-3" }, [
                        _vm._v("(if different than event address)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.shippingAddress,
                            expression: "item.shippingAddress"
                          }
                        ],
                        staticClass: "data-table-row-edit-mode-text",
                        attrs: {
                          placeholder: "Address",
                          readonly: !_vm.editable
                        },
                        domProps: { value: _vm.item.shippingAddress },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "shippingAddress",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                custom event notes\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.customEventNote,
                            expression: "item.customEventNote"
                          }
                        ],
                        staticClass: "custom-notes",
                        attrs: {
                          name: "custom-notes",
                          placeholder: "E.g. add ons, extra staff, etc",
                          readonly: !_vm.editable
                        },
                        domProps: { value: _vm.item.customEventNote },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "customEventNote",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                Additional comments\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.additionalComments,
                            expression: "item.additionalComments"
                          }
                        ],
                        staticClass: "additional-comments",
                        attrs: {
                          name: "additional-comments",
                          placeholder:
                            "E.g. instructions from client or change documentation",
                          readonly: !_vm.editable
                        },
                        domProps: { value: _vm.item.additionalComments },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "additionalComments",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "add-on-wrapper" }, [
                      _c("div", { staticClass: "add-on-item" }, [
                        _c("div", { staticClass: "text" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.isOnlineScheduler,
                                expression: "item.isOnlineScheduler"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "is-online-scheduler",
                              disabled: true
                            },
                            domProps: {
                              checked: Array.isArray(_vm.item.isOnlineScheduler)
                                ? _vm._i(_vm.item.isOnlineScheduler, null) > -1
                                : _vm.item.isOnlineScheduler
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.item.isOnlineScheduler,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.item,
                                        "isOnlineScheduler",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.item,
                                        "isOnlineScheduler",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.item, "isOnlineScheduler", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "is-online-scheduler" } },
                            [_vm._v("Toggle")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text title",
                            class: { active: _vm.item.isOnlineScheduler }
                          },
                          [_vm._v("Online Scheduler")]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _c("div", { staticClass: "text-contact" }, [
                    _c("span", [_vm._v(_vm._s(_vm.item.contactName))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-contact grey-3" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.email,
                          expression: "item.email"
                        }
                      ],
                      staticClass: "phoneAndEmail",
                      attrs: {
                        placeholder: "E.g. hannah_welch@gmail.com",
                        readonly: !_vm.editable
                      },
                      domProps: { value: _vm.item.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "email", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-contact grey-3" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "func-group" })
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bb6fa2b", esExports)
  }
}

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTableRowEditMode_vue__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e6e398_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTableRowEditMode_vue__ = __webpack_require__(1524);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1477)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTableRowEditMode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e6e398_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DataTableRowEditMode_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/DataTableRowEditMode.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DataTableRowEditMode.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65e6e398", Component.options)
  } else {
    hotAPI.reload("data-v-65e6e398", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1478);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("59af2020", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-65e6e398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTableRowEditMode.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-65e6e398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTableRowEditMode.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.caption-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.label-text,\n.col-contact .multiselect__tags .multiselect__placeholder,\n.col-contact .multiselect__tags .multiselect__input,\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option {\n  color: #626262;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.label-text-2 {\n  color: #8E8E8E;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.body-text {\n  color: #424242;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.h4-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.h3-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n}\n.h2-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.h1-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.button-text,\n.ap-btn {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n.value-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.tab-header .type {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 6px;\n  line-height: 48px;\n  margin-right: 24px;\n}\n.tab-header .type:hover {\n  cursor: pointer;\n  color: #606060;\n}\n.tab-header .type:focus {\n  border: 2px solid rgba(0, 164, 214, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 14px 24px;\n}\n.tab-header .type.active {\n  border-bottom: 3px solid #1674CD;\n  color: #1674CD;\n}\n.ap-checkbox-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-indicator {\n  width: 24px;\n  height: 24px;\n  top: 0;\n  border: 1px solid #b9b9b9;\n  background-color: transparent;\n}\n.ap-checkbox-group .custom-control-description {\n  margin-left: 1rem;\n}\n.ap-checkbox-group .custom-checkbox {\n  margin-top: 16px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label {\n  cursor: pointer;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before,\n.ap-checkbox-group .custom-checkbox .custom-control-label::after {\n  top: 0;\n  height: 24px;\n  width: 24px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: #1674CD;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-control-label {\n  cursor: pointer;\n}\n.ap-radio-group .custom-control-label::after {\n  background-size: 95%;\n}\n.ap-radio-group .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-radio-group .custom-control-label::before,\n.ap-radio-group .custom-control-label::after {\n  top: 0;\n  height: 25px;\n  width: 25px;\n}\n.ap-radio-group .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio {\n  margin-bottom: 24px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label {\n  font-size: 16px;\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label span {\n  padding-left: 0;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: transparent;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2300A4D6'/%3E%3C/svg%3E\");\n}\n.ap-input-wrapper {\n  position: relative;\n}\n.ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .title-field {\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper {\n  position: relative;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 24px;\n  height: 24px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-error-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E83001;\n  background-color: #E83001;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-success-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #68B814;\n  background-color: #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-warning-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E89819;\n  background-color: #E89819;\n}\n.ap-field-input-wrapper .message-field {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.ap-field-input-wrapper .message-field.success {\n  color: #68B814;\n}\n.ap-field-input-wrapper .message-field.error {\n  color: #E83001;\n}\n.ap-field-input-wrapper .message-field.warning {\n  color: #E89819;\n}\n.ap-dropdown {\n  width: 300px;\n  font-size: 16px;\n}\n.ap-dropdown .ap-dropdown-btn {\n  width: 100%;\n}\n.ap-dropdown .ap-dropdown-btn.btn-group > .btn:first-child {\n  border: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 44px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #ffffff;\n  width: inherit;\n  padding: 10px 16px;\n  font-size: 16px;\n  text-align: left;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary::after {\n  display: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:hover {\n  border: 1px solid #7B7B7B;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:focus {\n  border: 2px solid rgba(32, 170, 233, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text.active {\n  color: #1D1D1D;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper .icon-dropdown {\n  width: 13px;\n  height: 18px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper:hover {\n  cursor: pointer;\n}\n.ap-dropdown .dropdown-menu {\n  width: inherit;\n  width: 100%;\n  border-radius: 4px;\n  background-color: #FFF;\n  margin-top: 8px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 8px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item {\n  height: inherit;\n  padding: 0px 0px 0 16px;\n  color: #1D1D1D;\n  line-height: 24px;\n  border: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:hover {\n  background-color: #F5F5F5 !important;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:focus {\n  background-color: unset;\n  outline: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item .ap-item-wrapper {\n  height: 44px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #E6E6E6;\n  padding: 12px 0 9px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:last-child .ap-item-wrapper {\n  border: none;\n}\n.dropdown-section {\n  height: 500px;\n  margin-top: 64px;\n}\n.dropdown-section .section-title {\n  color: #1D1D1D;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  margin-bottom: 40px;\n}\n.pretty.p-default input:checked ~ .state label:after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn {\n  height: 26px;\n}\n.custom-radio-btn input:checked ~ .state label {\n  font-weight: 600;\n  color: #00A4D6;\n}\n.custom-radio-btn input:checked ~ .state label::after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn input:checked ~ .state label::before {\n  border-color: #00A4D6;\n}\n.custom-radio-btn .state label {\n  height: 26px;\n  margin-left: 16px;\n  font-size: 16px;\n  color: #606060;\n  line-height: 26px;\n  letter-spacing: -0.04px;\n}\n.custom-radio-btn .state label::after {\n  width: 25px;\n  height: 25px;\n  bottom: 0;\n  top: unset;\n}\n.custom-radio-btn .state label::before {\n  width: 25px;\n  height: 25px;\n  border-color: #b9b9b9;\n  bottom: 0;\n  top: unset;\n}\n.ap-btn {\n  padding: 12px 32px;\n  border: 1px solid #1674CD;\n  border-radius: 4px;\n  background: none;\n}\n.ap-btn.compact {\n  padding: 6px 24px;\n}\n.ap-btn.primary {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.primary:focus {\n  background-color: #1674CD;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.primary:hover {\n  background-color: #1674CD;\n}\n.ap-btn.primary:active {\n  background-color: #00526A;\n  outline: none;\n}\n.ap-btn.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.primary:disabled:hover {\n  background-color: #1674CD;\n}\n.ap-btn.secondary {\n  background-color: white;\n  color: #1674CD;\n}\n.ap-btn.secondary:hover {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.secondary:focus {\n  background-color: #FFF;\n  color: #1674CD;\n}\n.ap-btn.secondary:active {\n  background-color: #00526A;\n  color: #FFF;\n}\n.ap-btn.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.secondary:disabled:hover {\n  background-color: transparent;\n  color: #1674CD;\n}\n.ap-btn.tertiary {\n  background-color: #AAA7A4;\n  color: #FFF;\n  border: 1px solid #AAA7A4;\n}\n.ap-btn.tertiary:hover {\n  background-color: #67615C;\n}\n.ap-btn.tertiary:active {\n  background-color: #463E37;\n}\n.ap-btn.tertiary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.tertiary:disabled:hover {\n  background-color: #AAA7A4;\n}\n.ap-btn.destructive {\n  background-color: #FF3400;\n  color: #FFF;\n  border: none;\n}\n.ap-btn.destructive:focus {\n  background-color: #FF3400;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.destructive:hover {\n  background-color: #B22520;\n}\n.ap-btn.destructive:active {\n  background-color: #631412;\n}\n.ap-btn.destructive:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.destructive:disabled:hover {\n  background-color: #FF3400;\n}\n.ap-btn-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ap-btn-icon .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  margin-right: 8px;\n  color: #FFF;\n}\n.ap-btn-icon-only {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px;\n}\n.ap-btn-icon-only.compact {\n  padding: 5px;\n}\n.ap-btn-icon-only .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  color: #FFF;\n}\n.background,\n.card-rest-background,\n.card-lift-background,\n.modal-background,\n.list-dialogues-background,\n.alert-background,\n.iziToast-wrapper .iziToast {\n  border-radius: 4px;\n  background-color: #FFF;\n}\n.header-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.banner-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.card-rest-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.card-lift-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.list-dialogues-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-background,\n.iziToast-wrapper .iziToast {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-icon,\n.alert-icon-checked,\n.alert-icon-info,\n.alert-icon-warning,\n.alert-icon-error {\n  width: 24px;\n  height: 24px;\n  color: #FFF;\n  background-color: #FFF;\n}\n.alert-icon-checked {\n  background: url('/static/img/down-o-white.svg') no-repeat center;\n}\n.alert-icon-info {\n  background: url('/static/img/status-info-outline-white.svg') no-repeat center;\n}\n.alert-icon-warning {\n  background: url('/static/img/status-warning-outline-white.svg') no-repeat center;\n}\n.alert-icon-error {\n  background: url('/static/img/icon-field-error-white.svg') no-repeat center;\n}\n.iziToast-wrapper .iziToast {\n  min-height: 45px;\n  min-width: 283px;\n  padding: 5px 40px 5px 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body {\n  min-height: 35px;\n  margin-left: 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child {\n  background: #FFF;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child:hover {\n  background: #e6e6e6;\n}\n.iziToast-wrapper .iziToast > .iziToast-texts {\n  margin-top: 9px;\n}\n.iziToast-wrapper .iziToast > .iziToast-close {\n  top: 50%;\n  right: 10px;\n  margin-top: -7px;\n  width: 14px;\n  height: 14px;\n  background: url('/static/img/ic_close.png') center center no-repeat;\n  background-size: cover;\n  opacity: 1;\n}\n.iziToast-wrapper .iziToast:after {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.greyOut {\n  color: #AAA7A4;\n}\n.multiselect__content > .multiselect__element:first-child {\n  margin-top: 7px;\n}\n.icon-draft {\n  display: inline-block;\n  margin-left: -4px;\n  width: 24px;\n  height: 24px;\n  color: #606060;\n  background-color: #606060;\n  -webkit-mask: url(" + __webpack_require__(802) + ") no-repeat center;\n  mask: url(" + __webpack_require__(802) + ") no-repeat center;\n  background: url(" + __webpack_require__(1479) + ");\n}\n.icon-submitted {\n  display: inline-block;\n  margin-left: -2px;\n  width: 24px;\n  height: 24px;\n  color: #606060;\n  background-color: #606060;\n  -webkit-mask: url(" + __webpack_require__(803) + ") no-repeat center;\n  mask: url(" + __webpack_require__(803) + ") no-repeat center;\n  background: url(" + __webpack_require__(1480) + ");\n}\n.icon-review {\n  display: inline-block;\n  margin-left: -2px;\n  width: 24px;\n  height: 24px;\n  color: #606060;\n  background-color: #606060;\n  -webkit-mask: url(" + __webpack_require__(804) + ") no-repeat center;\n  mask: url(" + __webpack_require__(804) + ") no-repeat center;\n  background: url(" + __webpack_require__(1481) + ");\n}\n.icon-approved {\n  display: inline-block;\n  margin-left: -2px;\n  width: 24px;\n  height: 24px;\n  color: #606060;\n  background-color: #606060;\n  -webkit-mask: url(" + __webpack_require__(260) + ") no-repeat center;\n  mask: url(" + __webpack_require__(260) + ") no-repeat center;\n  background: url(" + __webpack_require__(386) + ");\n}\n.icon-archived {\n  display: inline-block;\n  margin-left: -2px;\n  width: 22px;\n  height: 22px;\n  color: #606060;\n  background-color: #606060;\n  -webkit-mask: url(" + __webpack_require__(805) + ") no-repeat center;\n  mask: url(" + __webpack_require__(805) + ") no-repeat center;\n  background: url(" + __webpack_require__(1482) + ");\n}\n/* This is beginning for button in each line of event */\n.icon-duplicate {\n  margin: 3.5px 3.5px;\n  width: 24px;\n  height: 24px;\n  background-color: #FFF;\n  -webkit-mask: url(" + __webpack_require__(806) + ") no-repeat center;\n  mask: url(" + __webpack_require__(806) + ") no-repeat center;\n  background: url(" + __webpack_require__(1483) + ");\n}\n.icon-delete {\n  margin: 3.5px 3.5px;\n  width: 24px;\n  height: 24px;\n  background-color: #FFF;\n  -webkit-mask: url(" + __webpack_require__(807) + ") no-repeat center;\n  mask: url(" + __webpack_require__(807) + ") no-repeat center;\n  background: url(" + __webpack_require__(1484) + ");\n}\n.icon-submit {\n  margin: 3.5px 3.5px;\n  width: 24px;\n  height: 24px;\n  background-color: #FFF;\n  -webkit-mask: url(" + __webpack_require__(808) + ") no-repeat center;\n  mask: url(" + __webpack_require__(808) + ") no-repeat center;\n  background: url(" + __webpack_require__(1485) + ");\n}\n/* This is end for button in each line of event */\n.col-contact {\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n  border: 0 solid #9b9b9b;\n  border-radius: 3px;\n  width: 100%;\n  background-color: #f5f5f5;\n  z-index: 0;\n  min-height: 0;\n}\n.col-contact .multiselect__select {\n  display: none;\n  width: 0;\n  height: 0;\n}\n.col-contact .multiselect__tags {\n  margin-top: 15px;\n  font-size: 14px;\n  line-height: 18px;\n  padding: 0;\n  min-height: 0;\n  border: none;\n  z-index: unset;\n}\n.col-contact .multiselect__tags .multiselect__placeholder {\n  color: #8E8E8E;\n}\n.col-contact .multiselect__tags .multiselect__input {\n  border: none;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n  margin: 0;\n  padding: 0;\n}\n.col-contact .multiselect__content-wrapper {\n  z-index: 99;\n  width: 300px;\n  left: -80px;\n  border: none;\n  border-radius: 3px;\n  margin-top: 5px;\n}\n.col-contact .multiselect__content-wrapper .multiselect__element {\n  padding: 0 0 0 0px;\n}\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option {\n  padding: 0px;\n  border-bottom: 1px solid #e6e6e6;\n}\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option .contact-detail {\n  height: 58px;\n  padding: 12px 20px;\n}\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option .contact-detail .contact-name-decoration {\n  text-transform: capitalize;\n}\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option--highlight::after {\n  content: '';\n}\n.col-contact .multiselect__content-wrapper .multiselect__element .multiselect__option--selected::after {\n  content: '';\n}\n.data-table-row-edit-mode-text {\n  font-family: 'Open Sans', sans-serif;\n  border: 0 solid #e6e6e6;\n  border-radius: 3px;\n  width: 100%;\n  min-height: 0;\n  z-index: unset;\n  height: 25px;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 25px;\n}\n.data-table-row-edit-mode-text .multiselect__select {\n  display: none;\n  width: 0;\n  height: 0;\n}\n.data-table-row-edit-mode-text .multiselect__tags {\n  margin-top: 15px;\n  font-size: 14px;\n  line-height: 18px;\n  padding: 0;\n  min-height: 0;\n  border: none;\n  z-index: unset;\n}\n.data-table-row-edit-mode-text .multiselect__tags .multiselect__input {\n  width: 100%;\n  border: none;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  background-color: #f5f5f5;\n  margin: 0;\n  padding: 0 0 0 0px;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper {\n  z-index: 99;\n  width: 86px;\n  padding: 0 0 7px 0;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element {\n  border-bottom: 1px solid #e6e6e6;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element:hover {\n  background-color: #f5f5f5;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element .multiselect__option {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element .multiselect__option--highlight::after {\n  content: '';\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element .multiselect__option--selected {\n  background: #FFF;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element .multiselect__option--selected::after {\n  content: '';\n}\n.data-table-row-edit-mode-text .multiselect__content-wrapper .multiselect__element .multiselect__option--selected:hover {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.data-table-row-edit-mode-input-time-start-active {\n  width: 137%;\n  margin-left: -10px;\n}\n.data-table-row-edit-mode-expand-input-right {\n  color: #9b9b9b;\n  font-size: 14px;\n  line-height: 18px;\n  width: 160px;\n  margin-right: 65px;\n  background-color: #FFF;\n}\n.icon-actions {\n  width: 25px;\n  height: 25px;\n  margin-left: -2px;\n}\n.exchange-icon {\n  border: 2px solid #FFF;\n  border-radius: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.func-icon-small {\n  position: relative;\n  top: 1px;\n  width: 16px;\n  height: 13px;\n}\n.data-table-icon-circle {\n  width: 16px;\n  height: 16px;\n  float: left;\n  margin-left: -8px;\n  display: none;\n  margin-top: 0px;\n}\n.data-table-row-edit-mode-input-small {\n  width: 90%;\n}\n.data-table-input-contact-name {\n  width: 93%;\n}\n.shipping-address {\n  height: 34px;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  border-radius: 3px;\n  padding-left: 14px;\n  color: #000;\n}\n.multiselect {\n  min-height: 0 !important;\n}\n.circle-red {\n  color: #a42022 !important;\n}\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n.li-red:before {\n  color: #a42022 !important;\n}\n.pac-container > .pac-item:first-child {\n  margin-top: 7px;\n  border-top: none;\n}\n.pac-container > .pac-item:last-child {\n  margin-bottom: 7px;\n}\n.pac-container {\n  border: 1px solid #e6e6e6;\n  border-radius: 3px;\n}\n.pac-container .pac-item {\n  padding: 0 0 0 20px;\n  height: 36px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n}\n.pac-container .pac-item:hover {\n  background-color: #f5f5f5;\n}\n.pac-container .pac-item .pac-icon {\n  display: none;\n}\n.hdpi.pac-logo:after {\n  background-image: none;\n  height: 0;\n}\n.address-input {\n  height: 18px;\n  margin-top: 16px;\n  padding: 0;\n}\n.padding-left-50 {\n  padding-left: 50px;\n}\n.padding-left-22 {\n  padding-left: 22px;\n}\n.event-add-on {\n  overflow: hidden;\n}\n.event-add-on .title {\n  margin-top: 20px;\n}\n.event-add-on .title .icon-add {\n  color: #fff;\n  background-color: #00A4D6;\n  border: 3px;\n  border-radius: 20px;\n  width: 16px;\n  height: 16px;\n  margin-left: 15px;\n}\n.event-add-on .title .text {\n  margin-left: 10px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.event-add-on .add-on-item {\n  width: 210px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 15px;\n  display: inline-block;\n}\n.event-add-on .add-on-item .text {\n  position: absolute;\n  left: 45px;\n}\n.event-add-on input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.event-add-on label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  left: 0px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.event-add-on label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.event-add-on input:checked + label {\n  background: #00A4D6;\n  border: 1.5px solid #00A4D6;\n}\n.event-add-on input:checked + label:after {\n  left: calc(100%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.event-add-on label:active:after {\n  width: 15px;\n}\n.hover-pointer:hover {\n  cursor: pointer;\n}\n.show-dropdown .place-holder .dropdown-toggle {\n  color: #8E8E8E;\n}\n.show-dropdown .dropdown-menu {\n  display: block;\n  min-width: 64%;\n  width: 100%;\n  height: 230px;\n  overflow-y: scroll;\n  top: 52px;\n}\n.show-dropdown .dropdown-menu > li > a {\n  height: 45px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  border-bottom: solid 1px #e6e6e6;\n  padding: 12px 0 9px;\n  margin-left: 5px;\n}\n.show-dropdown li.dropdown-toggle {\n  height: 100%;\n  min-width: 100%;\n  background-image: none;\n  color: #1D1D1D;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 16px;\n}\n.show-dropdown li.dropdown-toggle::after {\n  display: none;\n}\n.show-dropdown li.dropdown-toggle:hover {\n  background: #FFFFFF;\n}\n.show-dropdown .btn-group {\n  min-width: 100%;\n  margin: 0;\n}\n.show-dropdown span.caret {\n  display: none;\n}\n.show-dropdown-for-arrival-time {\n  margin-top: 6px;\n}\n.show-dropdown-for-arrival-time .dropdown-menu {\n  display: block;\n  min-width: 94px;\n  width: 100%;\n  height: 230px;\n  overflow-y: scroll;\n  top: 25px;\n}\n.show-dropdown-for-arrival-time .dropdown-menu > li > a {\n  height: 45px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  border-bottom: solid 1px #e6e6e6;\n  padding: 12px 0 9px;\n  margin-left: 5px;\n}\n.show-dropdown-for-arrival-time li.dropdown-toggle {\n  height: 100%;\n  min-width: 100%;\n  background-image: none;\n  color: #1D1D1D;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 16px;\n}\n.show-dropdown-for-arrival-time li.dropdown-toggle::after {\n  display: none;\n}\n.show-dropdown-for-arrival-time li.dropdown-toggle:hover {\n  background: #FFFFFF;\n}\n.show-dropdown-for-arrival-time .btn-group {\n  min-width: 100%;\n  margin: 0;\n}\n.show-dropdown-for-arrival-time span.caret {\n  top: 7px;\n  margin-left: 7px;\n}\n.notes-field .add-on-wrapper {\n  float: left;\n  height: 22px;\n  line-height: 22px;\n}\n.notes-field .add-on-wrapper .add-on-item .text {\n  color: #626262;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  display: inline;\n  margin-left: -10px;\n}\n.notes-field .add-on-wrapper .add-on-item .title {\n  margin-left: 8px !important;\n}\n.notes-field .add-on-wrapper .add-on-item .title.active {\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 16px;\n}\n.notes-field .add-on-wrapper .add-on-item input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.notes-field .add-on-wrapper .add-on-item label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.notes-field .add-on-wrapper .add-on-item label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n}\n.notes-field .add-on-wrapper .add-on-item input:checked + label {\n  background: #00A4D6;\n  border: 1.5px solid #00A4D6;\n}\n.notes-field .add-on-wrapper .add-on-item input:checked + label:after {\n  left: calc(100%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.notes-field .add-on-wrapper .add-on-item label:active:after {\n  width: 15px;\n}\n.notes-field .arrival-time {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.title-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 16px;\n}\n.overflow-show span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports


/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjA2MDYwIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMTwvdGl0bGU+PHBhdGggZD0iTTcuNSwxMGEuNS41LDAsMCwwLC41LjVoOGEuNS41LDAsMCwwLDAtMUg4QS41LjUsMCwwLDAsNy41LDEwWiIvPjxwYXRoIGQ9Ik0xOS40MSw1LjQxLDE2LjU5LDIuNTlBMiwyLDAsMCwwLDE1LjE3LDJINkEyLDIsMCwwLDAsNCw0VjIwYTIsMiwwLDAsMCwyLDJIMThhMiwyLDAsMCwwLDItMlY2LjgzQTIsMiwwLDAsMCwxOS40MSw1LjQxWm0tLjcuNzFhMSwxLDAsMCwxLC4yMy4zOEgxNmEuNS41LDAsMCwxLS41LS41VjMuMDZhMSwxLDAsMCwxLC4zOC4yM1pNMTksMjBhMSwxLDAsMCwxLTEsMUg2YTEsMSwwLDAsMS0xLTFWNEExLDEsMCwwLDEsNiwzaDguNVY2QTEuNSwxLjUsMCwwLDAsMTYsNy41aDNaIi8+PHBhdGggZD0iTTE2LDEzLjVIOGEuNS41LDAsMCwwLDAsMWg4YS41LjUsMCwwLDAsMC0xWiIvPjxwYXRoIGQ9Ik0xNiwxNy41SDhhLjUuNSwwLDAsMCwwLDFoOGEuNS41LDAsMCwwLDAtMVoiLz48L3N2Zz4="

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjA2MDYwIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMjwvdGl0bGU+PHBhdGggZD0iTTE2LjUsMTBhLjUuNSwwLDAsMC0uNS0uNUg4YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWg4QS41LjUsMCwwLDAsMTYuNSwxMFoiLz48cGF0aCBkPSJNMTIuNSwyMUg2LjM4QTEuMzksMS4zOSwwLDAsMSw1LDE5LjY0VjQuNDRBMS4zOSwxLjM5LDAsMCwxLDYuMzgsM0gxNC41VjZBMS41LDEuNSwwLDAsMCwxNiw3LjU0aDN2My44OGEuNS41LDAsMSwwLDEsMFY3LjEzYTIuNDUsMi40NSwwLDAsMC0uNjktMS43TDE2LjY2LDIuNzVBMi4zNCwyLjM0LDAsMCwwLDE1LDJINi4zOEEyLjQsMi40LDAsMCwwLDQsNC40NHYxNS4yQTIuMzksMi4zOSwwLDAsMCw2LjM4LDIySDEyLjVhLjUuNSwwLDAsMCwuNS0uNUEuNTEuNTEsMCwwLDAsMTIuNSwyMVptNi4wOS0xNC45YTEuMDksMS4wOSwwLDAsMSwuMjcuNEgxNmEuNS41LDAsMCwxLS41LS41VjMuMTVhMS40MywxLjQzLDAsMCwxLC40NC4zWiIvPjxwYXRoIGQ9Ik0xMywxNGEuNS41LDAsMCwwLS41LS41SDhhLjUuNSwwLDAsMC0uNS41LjUuNSwwLDAsMCwuNS41aDQuNUEuNS41LDAsMCwwLDEzLDE0WiIvPjxwYXRoIGQ9Ik04LDE3LjU0YS41LjUsMCwwLDAtLjUuNS41LjUsMCwwLDAsLjUuNWgzLjVBLjUuNSwwLDAsMCwxMiwxOGEuNS41LDAsMCwwLS41LS41WiIvPjxwYXRoIGQ9Ik0xOCwxM2E1LDUsMCwxLDAsNSw1QTUsNSwwLDAsMCwxOCwxM1ptMCw5YTQsNCwwLDEsMSw0LTRBNCw0LDAsMCwxLDE4LDIyWiIvPjxwYXRoIGQ9Ik0yMS4zNSwxNi42OWEuNDguNDgsMCwwLDAtLjcsMEwxNy41LDE5LjgzbC0xLjY1LTEuNjRhLjQ4LjQ4LDAsMCwwLS43LDAsLjUuNSwwLDAsMCwwLC43MWwyLDJhLjUxLjUxLDAsMCwwLC43LDBsMy41LTMuNUEuNS41LDAsMCwwLDIxLjM1LDE2LjY5WiIvPjwvc3ZnPg=="

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjA2MDYwIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyNTwvdGl0bGU+PHBhdGggZD0iTTIwLjE0LDNIMy44NkExLjg2LDEuODYsMCwwLDAsMiw0Ljg2VjcuMTRBMS44NSwxLjg1LDAsMCwwLDMsOC43OFYxOS4yMkExLjc4LDEuNzgsMCwwLDAsNC43OCwyMUgxOS4yMkExLjc4LDEuNzgsMCwwLDAsMjEsMTkuMjJWOC43OGExLjg1LDEuODUsMCwwLDAsMS0xLjY0VjQuODZBMS44NiwxLjg2LDAsMCwwLDIwLjE0LDNabS0uOTIsMTdINC43OEEuNzguNzgsMCwwLDEsNCwxOS4yMlY5SDIwVjE5LjIyQS43OC43OCwwLDAsMSwxOS4yMiwyMFpNMjEsNy4xNGEuODUuODUsMCwwLDEtLjg2Ljg2SDMuODZBLjg1Ljg1LDAsMCwxLDMsNy4xNFY0Ljg2QS44NS44NSwwLDAsMSwzLjg2LDRIMjAuMTRhLjg1Ljg1LDAsMCwxLC44Ni44NloiLz48cGF0aCBkPSJNMTUsMTFIOWEuNS41LDAsMCwxLDAtMWg2YS41LjUsMCwwLDEsMCwxWiIvPjwvc3ZnPg=="

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIGZpbGw9IiNmZmYiIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHRpdGxlPmNvcHlfZXhwb3J0PC90aXRsZT4KPHBhdGggZD0iTTE4LjcsNGgtOC4zQzkuNyw0LDkuMiw0LjQsOS4xLDVoOS42QzE4LjgsNSwxOSw1LjEsMTksNS4zYzAsMCwwLDAsMCwwdjExLjRjMCwwLjItMC4xLDAuMy0xLjMsMC4zSDE2djFoMS43CgljMC44LDAsMi4zLDAsMi4zLTEuM1Y1LjNDMjAsNC42LDE5LjQsNCwxOC43LDRDMTguNyw0LDE4LjcsNCwxOC43LDR6Ii8+CjxwYXRoIGQ9Ik0xMy43LDdDMTMuOCw3LDE0LDcuMSwxNCw3LjNjMCwwLDAsMCwwLDB2MTEuNGMwLDAuMi0wLjEsMC4zLTAuMywwLjNINS4zQzUuMSwxOSw1LDE4LjksNSwxOC43VjcuM0M1LDcuMiw1LjEsNyw1LjMsNwoJYzAsMCwwLDAsMCwwSDEzLjcgTTEzLjcsNkg1LjNDNC42LDYsNCw2LjYsNCw3LjNjMCwwLDAsMCwwLDB2MTEuNEM0LDE5LjQsNC42LDIwLDUuMywyMGg4LjNjMC43LDAsMS4zLTAuNiwxLjMtMS4zVjcuMwoJQzE1LDYuNiwxNC40LDYsMTMuNyw2QzEzLjcsNiwxMy43LDYsMTMuNyw2eiIvPgo8cGF0aCBkPSJNMTIuNSwxMGgtNkM2LjIsMTAsNiw5LjgsNiw5LjVTNi4yLDksNi41LDloNkMxMi44LDksMTMsOS4yLDEzLDkuNVMxMi44LDEwLDEyLjUsMTB6Ii8+CjxwYXRoIGQ9Ik0xMi41LDEzaC02QzYuMiwxMyw2LDEyLjgsNiwxMi41UzYuMiwxMiw2LjUsMTJoNmMwLjMsMCwwLjUsMC4yLDAuNSwwLjVTMTIuOCwxMywxMi41LDEzeiIvPgo8cGF0aCBkPSJNMTAuNSwxNmgtNEM2LjIsMTYsNiwxNS44LDYsMTUuNVM2LjIsMTUsNi41LDE1aDRjMC4zLDAsMC41LDAuMiwwLjUsMC41UzEwLjgsMTYsMTAuNSwxNnoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIGZpbGw9IiNmZmYiIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHRpdGxlPnRyYXNoX2V4cG9ydDwvdGl0bGU+CjxwYXRoIGQ9Ik0xOC41LDZIMTVWNC41QzE1LDQuMiwxNC44LDQsMTQuNSw0aC01QzkuMiw0LDksNC4yLDksNC41VjZINS41QzUuMiw2LjEsNSw2LjMsNS4xLDYuNkM1LjEsNi44LDUuMyw3LDUuNSw3SDYKCWMwLDAsMCwwLDAsMC4xbDEsMTJDNywxOS42LDcuNSwyMCw4LDIwaDhjMC41LDAsMS0wLjQsMS0wLjlsMS0xMmMwLDAsMCwwLDAtMC4xaDAuNWMwLjMsMC4xLDAuNS0wLjEsMC42LTAuNAoJQzE5LjIsNi4zLDE5LDYuMSwxOC43LDZDMTguNiw2LDE4LjYsNiwxOC41LDZMMTguNSw2eiBNMTAsNWg0djFoLTRWNXogTTE2LDE5SDhMNyw3aDEwTDE2LDE5eiIvPgo8L3N2Zz4K"

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmV4cG9ydDwvdGl0bGU+PHBhdGggZD0iTTE3LjUsMTYuNWEuNDcuNDcsMCwwLDEtLjM1LS4xNS40OC40OCwwLDAsMSwwLS43TDIwLjc5LDEyLDE3LjE1LDguMzVhLjQ5LjQ5LDAsMCwxLC43LS43bDQsNGEuNDguNDgsMCwwLDEsMCwuN2wtNCw0QS40Ny40NywwLDAsMSwxNy41LDE2LjVaIi8+PHBhdGggZD0iTTIxLDEyLjVIOWEuNS41LDAsMCwxLDAtMUgyMWEuNS41LDAsMCwxLDAsMVoiLz48cGF0aCBkPSJNMTAuNSwyMkgzYTEsMSwwLDAsMS0xLTFWM0ExLDEsMCwwLDEsMywyaDcuNWEuNS41LDAsMCwxLDAsMUgzVjIxaDcuNWEuNS41LDAsMCwxLDAsMVoiLz48L3N2Zz4="

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_exclamation_circle__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_arrow_circle_o_right__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_chevron_right__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_chevron_down__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_floppy_o__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_trash_o__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_repeat__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_exchange__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_angle_right__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_refresh__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_question_circle__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_files_o__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_plugin_load_script__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DataTableGroupBtn__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__RowStatus__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__RelatedEvent__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_vue_the_mask__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__commons_CalendarDatePickerDataTable__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_stateToAbbr_js__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_google_autocomplete__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_dropdowns__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_validator_js__ = __webpack_require__(372);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



































__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_19_axios___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_plugin_load_script__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataTableRowEditMode',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_17_vue_awesome_components_Icon__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_16_vue_multiselect___default.a,
    DataTableGroupBtn: __WEBPACK_IMPORTED_MODULE_24__DataTableGroupBtn__["a" /* default */],
    RowStatus: __WEBPACK_IMPORTED_MODULE_25__RowStatus__["a" /* default */],
    RelatedEvent: __WEBPACK_IMPORTED_MODULE_26__RelatedEvent__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_27__utils_vue_the_mask__["a" /* TheMask */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_30_vue_google_autocomplete__["a" /* default */],
    CalendarDatePickerDataTable: __WEBPACK_IMPORTED_MODULE_28__commons_CalendarDatePickerDataTable__["a" /* default */],
    dropdown: __WEBPACK_IMPORTED_MODULE_32_vue_dropdowns__["a" /* default */]
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    eventStatus: {
      type: String
    },
    item: {
      type: Object,
      default: {}
    },
    viewMode: {
      type: String,
      default: 'Client'
    },
    editable: {
      type: Boolean,
      default: false
    },
    showOnModal: {
      type: Boolean,
      default: false
    },
    editEventAdmin: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCollapse: false,
      focusedColumn: '',
      listOptionPrefMonth: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listOptionPrefMonth,
      isSuggestChanges: false,
      iconNames: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].iconNames,
      listEventStatus: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus,
      viewModes: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].dataTableViewModes,
      requiredPrefMonth: false,
      requiredPrefDate: false,
      requiredProjPart: false,
      requiredAddress: false,
      requiredLocation: false,
      requiredStartTime: false,
      requiredDuration: false,
      requiredContactName: false,
      requiredPhone: false,
      requiredEmail: false,
      listContact: [],
      instructions: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].instructions,
      eventFields: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].fields.event,
      isTrue: true,
      messageErrors: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].messageErrors,
      isLocked: false,
      isInSetPlace: false,
      disableDuration: false,
      showDateTimePicker: false,
      listTime: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listTime,
      selectedTime: {},
      selectedAddress: {},
      arrivalTime: { name: this.item.aduroArrivalTime },
      isAddressError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    selectedDate: function selectedDate() {
      return __WEBPACK_IMPORTED_MODULE_22_moment___default()(this.item.prefDate, 'MM/DD/YYYY');
    },
    newPrefDate: function newPrefDate() {
      var time = __WEBPACK_IMPORTED_MODULE_22_moment___default()(this.item.prefDate, 'MM/DD/YYYY');
      var str = time.format('DD') + '/' + time.format('YYYY');
      this.item.newPrefDate = str;
      return str;
    },
    expandId: function expandId() {
      return this.getExpandId;
    },
    showRelatedEvent: function showRelatedEvent() {
      return this.showRelatedEvents;
    },
    accordionId: function accordionId() {
      return 'accordion-' + this.item.index;
    },
    eventName: function eventName() {
      if (this.item.eventName === undefined || this.item.eventName === '') {
        this.item.eventName = 'New Event';
      }
      return this.item.eventName;
    },
    enableNoteForProjPart: function enableNoteForProjPart() {
      return this.item.duration === 4 || this.item.duration === 8;
    },
    enableNoteForEventDuration: function enableNoteForEventDuration() {
      return this.item.duration === 4 || this.item.duration === 8;
    },
    calculateTimeEnd: function calculateTimeEnd() {
      if (!this.item.startTime) {
        return 'End time';
      }
      var listStr = this.item.startTime.toString().split(/[\s:]/);
      if (listStr.length === 3) {
        var duration = Number(this.item.duration);
        var minute = Number(listStr[1]);
        var hour = Number(listStr[0]);
        var hourType = listStr[2];
        hour = hourType === 'AM' && (hour === 12 || hour === 0) ? 0 : hour;
        hour = hourType === 'PM' && (hour === 12 || hour === 0) ? 0 : hour;
        hour = hourType === 'AM' ? hour : hour + 12;
        hour += duration;
        minute = hour % 1 === 0.5 ? minute + 30 : minute;
        hour = hour % 1 === 0.5 ? hour - 0.5 : hour;
        hour = minute > 59 ? hour + 1 : hour;
        minute = minute > 59 ? minute % 60 : minute;
        if (hour >= 24) {
          hourType = 'AM';
          hour = hour % 12;
        } else {
          if (hour > 11) {
            // hour %= 12;
            /* We want to display 12 instead of 0 */
            hour = hour === 12 ? 12 : hour % 12;
            hourType = 'PM';
          } else {
            hourType = 'AM';
          }
        }
        var prefix = minute < 10 ? '0' : '';
        this.item.endTime = hour + ':' + prefix + minute + ' ' + hourType;
      } else {
        this.item.endTime = '';
      }
      return this.item.endTime;
    },
    enableIconProjPart: function enableIconProjPart() {
      return this.item.projPart > 0 && (this.item.projPart <= 32 || this.item.projPart > 200);
    },
    enableIconDuration: function enableIconDuration() {
      return this.item.duration < 4 || this.item.duration > 8;
    },
    disableIconContact: function disableIconContact() {
      // return this.item.contactName === '';
      return !(this.item.email !== '' && this.item.phone !== '' && this.item.contactName !== '');
    },
    calculateShippingAddress: function calculateShippingAddress() {
      if (this.item.shippingAddress === '') {
        this.item.shippingAddress = this.item.fullAddress;
      }
      return this.item.shippingAddress;
    },
    viewRelatedEvent: function viewRelatedEvent() {
      return this.showRelatedEvents;
    },
    projectPart: function projectPart() {
      return this.item.projPart;
    },
    isCreateByEM: function isCreateByEM() {
      // event create by && view by
      var a = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.eventManager;
      var b = this.item.createdBy && this.item.createdBy.toString() === localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.userId).toString();
      return a && b;
    },
    isEM: function isEM() {
      var role = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.role);
      return role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.eventManager || role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.admin;
    },
    columnWidth: function columnWidth() {
      return this.getColumnWidth;
    },
    onSiteContacts: function onSiteContacts() {
      return this.listOnSiteContact;
    },
    suggestChanges: function suggestChanges() {
      return this.isSuggestChanges && this.item.isSuggestChanges || false;
    },
    calculateDisableDuration: function calculateDisableDuration() {
      this.disableDuration = this.item.disableDuration;
    },
    isReadOnly: function isReadOnly() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.readOnly) === 'true';
    },
    isUsedBingMap: function isUsedBingMap() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.isBingMap) === 'true';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_23_vuex__["c" /* mapGetters */])({
    getExpandId: 'GETTERS_GET_EXPAND_ID',
    showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT',
    getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH',
    listOnSiteContact: 'GETTERS_LIST_ON_SITE_CONTACT',
    messageError: 'GETTERS_MESSAGE_ERROR',
    googleMapApiKey: 'GETTERS_GOOGLE_API_KEY',
    getLockIds: 'GETTERS_GET_LOCK_IDS',
    getErrorCodes: 'GETTERS_ERROR_CODES',
    currentClient: 'GETTER_GET_SELECTED_CLIENT',
    isLoading: 'GETTERS_IS_LOADING',
    isUpdating: 'GETTERS_IS_UPDATING'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    checkEmailValid: function checkEmailValid() {
      return __WEBPACK_IMPORTED_MODULE_33__utils_validator_js__["a" /* default */].isValidEmail(this.item.email);
    },
    disableAdditionalServices: function disableAdditionalServices(key) {
      if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.drafts || this.showOnModal) {
        if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.cotinine) {
          return this.item.additionalServices[7].isShow && this.item.additionalServices[7].value; // check order in constants
        }
        if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.tobaccoSelfAttestation) {
          return this.item.additionalServices[3].isShow && this.item.additionalServices[3].value; // check order in constants
        }
        if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
          return this.item.additionalServices[6].isShow && !this.item.additionalServices[6].value; // check order in constants
        }
      }
      return !(this.eventStatus === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.drafts || this.showOnModal);
    },
    setStartTime: function setStartTime(payload) {
      this.item.startTime = payload.name;
      var listStr = this.item.startTime.toString().split(/[\s:]/);
      var minute = listStr[1];
      var hour = Number(listStr[0]);
      var hourType = listStr[2];
      var arrivalTime = 0;

      if (hour > 0) {
        if (hour === 12 && hourType === 'PM') {
          hourType = 'AM';
        }
        arrivalTime = hour - 1;
      }

      var time = { name: arrivalTime + ':' + minute + ' ' + hourType };
      this.setAduroArrivalTime(time);
      this.updateEvent(this.item);
    },
    setAduroArrivalTime: function setAduroArrivalTime(payload) {
      this.item.aduroArrivalTime = payload.name;
      this.$refs['arrivalTime'].selectedOption = payload;
    },
    selectDate: function selectDate(dateStr) {
      this.item.prefDate = dateStr;
      this.updateEvent(this.item);
      // hide date picker after selected
      if (this.showDateTimePicker) {
        this.toggleShowDateTimePicker();
      }
    },
    setSelected: function setSelected(dateStr) {},
    setExpandId: function setExpandId() {
      if (this.item.id === 0) {
        return;
      }
      this.setExpandIdInState({ id: this.item.id, isExpand: false });
      if (this.showRelatedEvent) {
        this.restoreListEvent();
        this.setShowRelatedEvents(false);
      }
      this.showDateTimePicker = this.showDateTimePicker && this.item.id === this.expandId;
    },
    toggleShowDateTimePicker: function toggleShowDateTimePicker() {
      this.showDateTimePicker = !this.showDateTimePicker;
      if (!this.item.showCollapse) {
        this.setExpandId();
        this.item.showCollapse = this.item.id === this.expandId;
      }
    },
    toggleShowTimePicker: function toggleShowTimePicker() {
      if (!this.item.showCollapse) {
        this.setExpandId();
        this.item.showCollapse = this.item.id === this.expandId;
      }
    },
    duplicateEventClick: function duplicateEventClick() {
      if (this.isLocked) {
        return;
      }
      this.duplicateEvent({ item: this.item });
    },
    deleteEventClick: function deleteEventClick() {
      if (this.isLocked) {
        return;
      }
      // implement code
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.deleteEvent,
        data: this.item
      };
      this.$modal.show('eventModal', modalData);
    },
    submitEventClick: function submitEventClick() {
      this.$modal.show('DraftEventModal');
      // if (this.isReadOnly) {
      //   let modalData = {
      //     action: constants.modalAction.readOnly,
      //     data: null
      //   };
      //   this.$modal.show('eventModal', modalData);
      //   return;
      // }
      // if (this.isLocked) {
      //   return;
      // }
      // let result = this.validateModal();
      // let validDate = this.checkDateValid();

      // if (validDate) {
      //   let modalData = {
      //     action: constants.modalAction.eventPrefDateInvalid,
      //     data: null
      //   };
      //   this.$modal.show('eventModal', modalData);
      //   return;
      // }

      // let emailValid = this.checkEmailValid();
      // if (!emailValid) {
      //   let modalData = {
      //     action: constants.modalAction.emailIsNotValid,
      //     data: null
      //   };
      //   this.$modal.show('eventModal', modalData);
      //   return;
      // }

      // if (this.enableIconDuration === true && this.isEM === false) {
      //   this.item.showCollapse = !this.item.showCollapse;
      //   this.setExpandIdInState({id: this.item.id, isExpand: false});
      //   let modalData = {
      //     action: constants.modalAction.eventDurationRestricted,
      //     data: null
      //   };
      //   this.$modal.show('eventModal', modalData);
      //   return;
      // }
      // if (!result) {
      //   let modalData = {
      //     action: constants.modalAction.submitEvent,
      //     data: this.item
      //   };
      //   this.$modal.show('eventModal', modalData);
      // } else {
      //   let modalData = {
      //     action: constants.modalAction.someFieldsBlank,
      //     data: null
      //   };
      //   this.$modal.show('eventModal', modalData);
      // }
    },
    lockEvent: function lockEvent() {
      this.$emit('lockEvent', this.item.id, true);
    },
    unlockEvent: function unlockEvent() {
      this.$emit('unlockEvent', this.item.id, false);
    },
    modifyShippingAddress: function modifyShippingAddress(data, place) {
      this.item.shippingAddress = place.formatted_address;
    },
    setFocus: function setFocus(column) {
      this.focusedColumn = column;
    },
    unsetFocus: function unsetFocus(column) {
      this.focusedColumn = '';
      // save
      if (this.item[column] === '') {
        return;
      }
      this.saveEvent();
    },
    inputFullAddressFocus: function inputFullAddressFocus() {
      this.focusFullAddress = true;
    },
    getValue: function getValue(valObj) {
      var role = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.role);
      if (role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.eventManager || role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.admin) {
        this.item.fullAddress = valObj;
        if (!this.item.shippingAddress) {
          this.item.shippingAddress = this.item.fullAddress;
        }
        if (!this.isInSetPlace) {
          this.saveEvent();
        }
      }
    },
    setPlace: function setPlace(data, place) {
      var _this = this;

      this.isInSetPlace = true;
      this.setPlaceShippingAddress(place, true);
      this.item.fullAddress = place.formatted_address;
      var res = place && place.formatted_address.split(',');
      var resAdr = '';
      if (res.length > 3) {
        var temp = Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["trim"])(res[res.length - 2]).split(' ');
        resAdr = temp[0] + '-' + res[res.length - 3];
      }
      this.item.eventName = resAdr;
      // save address components
      var addressComponents = place.address_components;
      this.item.state = null;
      this.item.city = null;
      this.item.zipCode = null;
      for (var i = 0; i < addressComponents.length; i++) {
        var component = addressComponents[i];
        if (component.types.indexOf('sublocality_level_1') >= 0 || component.types.indexOf('sublocality') >= 0 || component.types.indexOf('locality') >= 0) {
          this.item.city = component.long_name;
        }
        if (component.types[0] === 'administrative_area_level_1') {
          this.item.state = component.short_name;
        }
        if (component.types[0] === 'postal_code') {
          this.item.zipCode = component.short_name;
        }
      }

      this.item.latitude = place.geometry.location.lat() || 0;
      this.item.longitude = place.geometry.location.lng() || 0;

      // get time zone
      var apiStr = 'https://maps.googleapis.com/maps/api/timezone/json';
      var req = __WEBPACK_IMPORTED_MODULE_18_vue__["default"].axios.create();
      req.get(apiStr, {
        params: {
          location: place.geometry.location.lat() + ',' + place.geometry.location.lng(),
          timestamp: '' + Math.round(new Date().getTime() / 1000),
          key: this.googleMapApiKey === '' ? localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
        }
      }).then(function (response) {
        if (response.data) {
          var _data = response.data;
          _this.item.timeZone = _this.getTimeZone(_data.timeZoneName);
          _this.item.timeZoneId = _data.timeZoneId;
          _this.saveEvent();
        } else {
          __WEBPACK_IMPORTED_MODULE_18_vue__["default"].prototype.$toastr('error', 'Error calling Google Maps API', '');
        }
        _this.isInSetPlace = false;
      });
    },
    getTimeZone: function getTimeZone(tzString) {
      if (tzString.length === 0) {
        return '';
      }
      var str = '';
      var index = 0;
      while (index >= 0) {
        str += tzString.substr(0, 1);
        index = tzString.indexOf(' ');
        tzString = tzString.substring(index + 1);
      }
      return str;
    },
    setPlaceShippingAddress: function setPlaceShippingAddress(place, isAddress) {
      var fieldName = this.eventFields.shippingAddress;
      var userFilled = this.item.userManualFilled;
      if (isAddress !== true) {
        this.item.userManualFilled = userFilled === '' ? fieldName : userFilled.concat(',' + fieldName);
        this.item.shippingAddress = place.formatted_address;
        this.saveEvent();
      } else {
        if (userFilled.indexOf(fieldName) === -1) {
          this.item.shippingAddress = place.formatted_address;
        }
      }
    },
    isAddressReadyToUpdate: function isAddressReadyToUpdate() {
      return !Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.latitude && this.item.longitude && this.item.city && this.item.state && this.item.zipCode && this.item.timeZoneId);
    },
    addressErrorMessage: function addressErrorMessage() {
      var generateAddress = [Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.latitude) ? 'Street Name' : '', Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.longitude) ? 'Number' : '', Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.city) ? 'City' : '', Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.state) ? 'State' : '', Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.zipCode) ? 'ZipCode' : '', Object(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(this.item.timeZoneId) ? 'TimeZoneId' : ''];
      var message = generateAddress.filter(function (item) {
        return item !== '';
      }).join(', ');
      return 'Please include ' + message;
    },
    saveEvent: function saveEvent(obj) {
      if (this.isLocked) {
        return;
      }
      this.item.index = this.index;
      // if (this.item.duration === null || this.item.duration === '' || this.item.duration === undefined) {
      //   this.calculateDuration();
      // }
      if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.drafts) {
        this.isAddressError = false;
        if (this.isAddressReadyToUpdate()) {
          this.updateEvent(this.item);
        } else {
          this.isAddressError = true;
        }
      }
      if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.review || this.eventStatus === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.submitted) {
        this.isSuggestChanges = true;
        this.item.isSuggestChanges = true;
      }
    },
    rowActionMiddleClick: function rowActionMiddleClick() {
      var role = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.role);
      if (this.eventStatus.toLowerCase() === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.submitted.toLowerCase() && role === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.eventManager) {
        this.setItemRelated(this.item);
        this.setExpandIdInState({ id: this.item.id, isExpand: false });
      }
    },
    btnChangeOrderClick: function btnChangeOrderClick() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.changeOrder,
        data: this.item
      };
      this.$modal.show('eventModal', modalData);
    },
    restoreEvent: function restoreEvent() {
      var prefDate = this.item.prefDate.split('/');
      var year = Number(prefDate.pop()) + 1;
      var newItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.item);
      newItem.prefDate = prefDate[0] + '/' + year;
      newItem.status = __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].eventStatus.drafts.toUpperCase();
      this.duplicateEvent({ item: newItem });
    },
    calculateDuration: function calculateDuration() {
      var projPart = this.item.projPart;
      var services = this.findAdditionalSercives(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel);
      if (services !== null && services.value === true) {
        if (projPart < 9) {
          this.item.duration = 4;
        }
        if (projPart > 8 && projPart < 17) {
          this.item.duration = 5;
        }
        if (projPart > 16 && projPart < 25) {
          this.item.duration = 6;
        }
        if (projPart > 24 && projPart < 29) {
          this.item.duration = 7;
        }
        if (projPart > 28) {
          this.item.duration = 8;
        }
      } else {
        var userFilled = this.item.userManualFilled;
        if (userFilled.indexOf(this.eventFields.duration) === -1) {
          if (projPart > 0 && projPart <= 32) {
            this.item.duration = 4;
          }
          if (projPart > 32 && projPart < 100) {
            this.item.duration = 4;
          }
          if (projPart >= 100 && projPart <= 140) {
            this.item.duration = 5;
          }
          if (projPart > 140 && projPart < 170) {
            this.item.duration = 6;
          }
          if (projPart >= 170 && projPart < 200) {
            this.item.duration = 7;
          }
          if (projPart >= 200) {
            this.item.duration = 8;
          }
        }
      }
    },
    findAdditionalSercives: function findAdditionalSercives(key) {
      var result = null;
      this.item.additionalServices.forEach(function (element) {
        if (element.key === key) {
          result = element;
        }
      });
      return result;
    },
    disableToggleSmallSiteModal: function disableToggleSmallSiteModal() {
      var _this2 = this;

      var item = this.item;
      item.additionalServices.forEach(function (addOn, index) {
        if (addOn.key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel || addOn.key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
          if (parseInt(item.projPart) < 34) {
            _this2.item.additionalServices[index].isShow = true;
            _this2.item.additionalServices[index].value = false;
            _this2.item.disableDuration = true;
            var obj = {
              eventId: _this2.item.id,
              key: _this2.item.additionalServices[index].key,
              isAdd: _this2.item.additionalServices[index].value,
              index: _this2.item.index
            };
            _this2.updateEventAddOns(obj); // save addon to database when changing participant
          } else {
            _this2.item.additionalServices[index].isShow = false;
            _this2.item.additionalServices[index].value = false;
            _this2.item.disableDuration = false;
            var _obj = {
              eventId: _this2.item.id,
              key: _this2.item.additionalServices[index].key,
              isAdd: _this2.item.additionalServices[index].value,
              index: _this2.item.index
            };
            _this2.updateEventAddOns(_obj); // save addon to database when changing participant
          }
        }
      });
    },
    changeTimeStart: function changeTimeStart() {
      if (!this.errors.has('start-time')) {
        this.item.startTime = this.item.timeStartModel;
        this.saveEvent();
      }
    },
    checkDateValid: function checkDateValid() {
      if (this.item.prefDate === null || this.item.prefDate.length !== 10) {
        return true;
      }
      var role = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.role);
      var isEMOrAdmin = role !== __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.eventManager && role !== __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].USER_ROLE.admin;
      var prefDate = __WEBPACK_IMPORTED_MODULE_22_moment___default()(this.item.prefDate, __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].dateTimeFotmat.usFormat);
      return (prefDate.format() === 'Invalid Date' || __WEBPACK_IMPORTED_MODULE_22_moment___default()().add(90, 'days').isSameOrAfter(prefDate)) && isEMOrAdmin;
    },
    validateModal: function validateModal() {
      // this.requiredPrefMonth = this.item.prefMonth === '' || this.item.prefMonth === null || this.item.prefMonth === undefined;
      this.requiredPrefDate = this.item.prefDate === '' || this.item.prefDate === null || this.item.prefDate === undefined;
      this.requiredProjPart = this.item.projPart <= 0 || this.item.projPart === '' || this.item.projPart === null || this.item.projPart === undefined;
      this.requiredAddress = this.item.fullAddress === '' || this.item.fullAddress === null || this.item.fullAddress === undefined;
      this.requiredStartTime = this.item.startTime === '' || this.item.startTime === null || this.item.startTime === undefined;
      this.requiredContactName = this.item.contactName === '' || this.item.contactName === null || this.item.contactName === undefined;
      this.requiredLocation = this.item.eventLocation === '' || this.item.eventLocation === null || this.item.eventLocation === undefined;
      this.requiredDuration = this.item.duration < 1 || this.item.duration === '' || this.item.duration === null || this.item.duration === undefined;
      this.requiredPhone = this.item.phone === '' || this.item.phone === null || this.item.phone === undefined;
      this.requiredEmail = this.item.email === '' || this.item.email === null || this.item.email === undefined;
      return this.requiredPrefDate || this.requiredProjPart || this.requiredAddress || this.requiredStartTime || this.requiredContactName || this.requiredLocation || this.requiredDuration || this.requiredPhone || this.requiredEmail;
    },
    selectOnSiteContact: function selectOnSiteContact(contact) {
      if (contact) {
        this.item.contactName = contact.contactName;
        this.item.phone = contact.contactPhone;
        this.item.email = contact.contactEmail;
      }
    },
    searchContact: function searchContact(keyword) {
      this.getListOnSiteContact(keyword.toLowerCase());
      var name = keyword || this.item.contactName;
      this.item.contact = {
        contactName: name,
        contactPhone: this.item.phone,
        contactEmail: this.item.email
      };
    },
    closeOnsiteContact: function closeOnsiteContact(value, id) {
      if (this.isLocked) {
        return;
      }
      if (!value) {
        value = {
          contactName: this.item.contactName,
          contactPhone: this.item.phone,
          contactEmail: this.item.email
        };
        this.item.contact = value;
        return;
      }
      this.item.contactName = value.contactName;
      this.unlockEvent();
      this.updateEvent(this.item);
    },
    durationBlur: function durationBlur(fieldName) {
      if (this.item.durationBackup === null || this.item.durationBackup === undefined || this.item.durationBackup === this.item.duration) {
        return;
      }
      var duration = parseFloat(this.item.duration);
      if (isNaN(this.item.duration) || duration % 0.5 !== 0) {
        __WEBPACK_IMPORTED_MODULE_18_vue__["default"].prototype.$toastr('error', 'Please enter duration in half hour increments', '');
        return;
      }
      this.item.duration = duration === 0.5 ? '0.5' : this.item.duration;
      var userFilled = this.item.userManualFilled;
      if (userFilled.indexOf(fieldName) === -1 && this.item.durationBackup !== this.item.duration) {
        this.item.userManualFilled = userFilled === '' ? fieldName : userFilled.concat(',' + fieldName);
      }
      this.saveEvent();
    },
    prefDateBlur: function prefDateBlur(field) {
      if (field === this.eventFields.prefDate) {
        var validDate = this.checkDateValid();
        if (validDate) {
          __WEBPACK_IMPORTED_MODULE_18_vue__["default"].prototype.$toastr('error', 'Please enter valid event date!', '');
          return;
        }
      }
      if (field === this.eventFields.timeStartModel) {
        var listStr = this.item.timeStartModel.toString().split(/[\s:]/);
        if (listStr[2] !== 'AM' && listStr[2] !== 'PM') {
          // => error format
          __WEBPACK_IMPORTED_MODULE_18_vue__["default"].prototype.$toastr('error', 'Please enter valid event time!', '');
          this.item.startTime = '';
          return;
        }
        this.item.startTime = this.item.timeStartModel;
      }
      this.saveEvent();
    },
    eventNameBlur: function eventNameBlur(fieldName) {
      if (this.item.eventName === null || this.item.eventName === '' || this.item.eventName === this.item.eventNameBackup) {
        this.item.eventName = this.item.eventNameBackup;
        return;
      }
      var userFilled = this.item.userManualFilled;
      if (userFilled.indexOf(fieldName) === -1) {
        this.item.userManualFilled = userFilled === '' ? fieldName : userFilled.concat(',' + fieldName);
      }
      this.updateEvent(this.item);
    },
    checkboxToggle: function checkboxToggle(key, value) {
      var _this3 = this;

      var obj = {
        eventId: this.item.id,
        key: key,
        isAdd: value,
        index: this.item.index
      };
      if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.paperScheduler) {
        this.item.isOnlineScheduler = !value;
      }
      if (this.item.id !== 0 && !this.showOnModal) {
        this.updateEventAddOns(obj).then(function () {
          _this3.$toastr('info', 'Update event successful', '');
          if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
            _this3.calculateDuration();
            _this3.updateEvent(_this3.item);
          }
          if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.cotinine) {
            _this3.updateEventAddOns({
              eventId: _this3.item.id,
              key: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.tobaccoSelfAttestation,
              isAdd: false,
              index: _this3.item.index
            }).then(function () {
              _this3.triggerSavingAddonForEvent();
            });
          }
          if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.tobaccoSelfAttestation) {
            _this3.updateEventAddOns({
              eventId: _this3.item.id,
              key: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.cotinine,
              isAdd: false,
              index: _this3.item.index
            }).then(function () {
              _this3.triggerSavingAddonForEvent();
            });
          }
        });
      } else {
        var addOns = '';
        this.item.additionalServices.forEach(function (addOn) {
          if (addOn.key === key && value || addOn.key !== key && addOn.value) {
            if (addOns !== '') addOns += ',';
            addOns += addOn.key;
          }
        });

        if (key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel && !value) {
          // turn off the smallSiteConcierge when Small site model is off
          if (addOns.indexOf('smallSiteConcierge') >= 0) {
            addOns = addOns.replace('smallSiteConcierge', '');
            this.disableToggleSmallSiteConcierge(this.item);
          }
        }
        this.item.addOns = addOns;
        this.updateEvent(this.item);
      }
    },
    disableToggleSmallSiteConcierge: function disableToggleSmallSiteConcierge(item) {
      var _this4 = this;

      item.additionalServices.forEach(function (addOn, index) {
        if (addOn.key === __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
          _this4.item.additionalServices[index].value = false;
        }
      });
    },
    openAddonsModal: function openAddonsModal() {
      this.$modal.show('addonsModal');
    },
    triggerSavingAddonForEvent: function triggerSavingAddonForEvent() {
      this.item.customEventNote += '.';
      this.item.customEventNote = this.item.customEventNote.slice(0, -1);
    },

    // START BING SECTION
    selectedAddressFromBing: function selectedAddressFromBing(obj) {
      var _this5 = this;

      var addressDetail = obj.address;
      var location = obj.location;
      this.item.fullAddress = addressDetail.formattedAddress;
      if (this.item.shippingAddress === '') {
        this.item.shippingAddress = this.item.fullAddress;
      }
      if (!addressDetail.adminDistrict || !addressDetail.locality || !addressDetail.postalCode) {
        this.getFullAddressWithNoAdminAndPostalCode(addressDetail.formattedAddress).then(function (address) {
          if (address) {
            addressDetail = address;
          } else {
            _this5.$toast.success('Please enter a complete address including city and state or zip code', '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optError));
          }
          _this5.item.state = addressDetail.adminDistrict;
          _this5.getAddressInfoForEvent(addressDetail, location);
        });
        return;
      }
      this.item.state = Object(__WEBPACK_IMPORTED_MODULE_29__utils_stateToAbbr_js__["a" /* abbrState */])(addressDetail.adminDistrict, 'abbr');
      this.getAddressInfoForEvent(addressDetail, location);
    },
    getAddressInfoForEvent: function getAddressInfoForEvent(addressDetail, location) {
      var _this6 = this;

      this.item.city = addressDetail.locality ? addressDetail.locality : '';
      this.item.eventName = this.item.state + '- ' + this.item.city;
      // get time zone
      this.item.zipCode = addressDetail.postalCode;
      this.item.latitude = location && location.latitude ? location.latitude : 0;
      this.item.longitude = location && location.longitude ? location.longitude : 0;
      var apiStr = void 0;
      if (location && location.latitude && location.longitude) {
        apiStr = 'https://dev.virtualearth.net/REST/v1/TimeZone/' + location.latitude + ',' + location.longitude;
      } else {
        apiStr = 'https://dev.virtualearth.net/REST/v1/TimeZone/query=' + this.item.city;
      }
      var req = __WEBPACK_IMPORTED_MODULE_18_vue__["default"].axios.create();
      req.get(apiStr, {
        params: {
          key: "Ar_FhdhaM7LiIgc9_BOy53TC5iqFSbEzKsemsRGvA5ug9bfGtV57wDNdQFuV1gsG" // this.googleMapApiKey === '' ? localStorage.getItem(constants.LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
        }
      }).then(function (response) {
        if (response.data && response.data.resourceSets[0].resources[0]) {
          var data = response.data.resourceSets[0].resources[0].timeZone;
          _this6.item.timeZone = data.abbreviation;
          _this6.item.timeZoneId = data.ianaTimeZoneId;
          _this6.saveEvent();
        } else {
          __WEBPACK_IMPORTED_MODULE_18_vue__["default"].prototype.$toastr('error', 'Error calling Bing Maps API', '');
        }
        _this6.isInSetPlace = false;
      });
    },
    selectedShippingAddressFromBing: function selectedShippingAddressFromBing(obj) {
      var addressDetail = obj.address;
      this.item.shippingAddress = addressDetail.formattedAddress;
    },
    onLoadBingSuggest: function onLoadBingSuggest() {
      console.log('load bing suggest');
      var options = { maxResults: 5 };
      new window.Microsoft.Maps.AutosuggestManager(options).attachAutosuggest('#searchBox-' + this.showOnModal + '-' + this.item.index, '#searchBoxContainer-' + this.item.index, this.selectedAddressFromBing);
      new window.Microsoft.Maps.AutosuggestManager(options).attachAutosuggest('#searchBoxForShippingAddress-' + this.showOnModal + '-' + this.item.index, '#searchBoxForShippingAddressContainer-' + this.item.index, this.selectedShippingAddressFromBing);
    },
    onErrorBingSuggest: function onErrorBingSuggest(message) {
      console.log('printoutPanel', message);
    },
    getFullAddressWithNoAdminAndPostalCode: function getFullAddressWithNoAdminAndPostalCode(address) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        // let vm = this;
        var map = new window.Microsoft.Maps.Map(document.getElementById('myMap'), {
          credentials: "Ar_FhdhaM7LiIgc9_BOy53TC5iqFSbEzKsemsRGvA5ug9bfGtV57wDNdQFuV1gsG"
        });
        var searchManager = new window.Microsoft.Maps.Search.SearchManager(map);
        var requestOptions = {
          where: address,
          callback: function callback(answer, userData) {
            if (answer && answer.results.length > 0) {
              resolve(answer.results[0].address);
              return;
            }
            resolve(null);
          },
          errorCallback: function errorCallback(e) {
            console.log('geocodeError=', e);
          }
        };
        searchManager.geocode(requestOptions);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_23_vuex__["b" /* mapActions */])({
    updateEvent: 'ACTION_UPDATE_EVENT',
    duplicateEvent: 'ACTION_DUPLICATE_EVENT',
    setExpandIdInState: 'ACTION_SET_EXPAND_ID',
    setItemRelated: 'ACTION_SET_ITEM_RELATED',
    restoreListEvent: 'ACTION_RESTORE_LIST_EVENT',
    setShowRelatedEvents: 'ACTION_SET_SHOW_RELATED_EVENT',
    getListOnSiteContact: 'ACTION_GET_LIST_ON_SITE_CONTACT',
    updateEventAddOns: 'ACTION_UPDATE_EVENT_ADD_ON'
  })),
  mounted: function mounted() {
    if (this.isUsedBingMap) {
      if (window.Microsoft.Maps.AutosuggestManager == null) {
        window.Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
          callback: this.onLoadBingSuggest,
          errorCallback: this.onErrorBingSuggest
        });
      } else {
        this.onLoadBingSuggest();
      }
    }
    this.item.index = this.index;
    if (this.showOnModal === true) {
      this.item.showCollapse = this.showOnModal;
    }
  },
  created: function created() {
    // computed locked
    var index = this.getLockIds.eventIds.indexOf(this.item.id.toString());
    this.isLocked = index !== -1 ? this.getLockIds.userIds[index] !== localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.userId) : false;
  },

  watch: {
    viewRelatedEvent: function viewRelatedEvent() {
      this.item.showCollapse = this.viewRelatedEvent;
    },
    projectPart: function projectPart() {
      this.disableToggleSmallSiteModal();
      this.calculateDuration();
    },
    getExpandId: function getExpandId() {
      if (this.getExpandId === -1) {
        this.item.showCollapse = false;
      }
      if (this.item.id !== this.getExpandId) {
        this.showDateTimePicker = false;
      }
    },
    messageError: function messageError() {
      if (this.messageError === this.messageErrors.notUniqueName) {
        var modalData = {
          action: __WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].modalAction.eventNameNotUnique,
          data: null
        };
        this.$modal.show('eventModal', modalData);
      }
    },
    listOnSiteContact: function listOnSiteContact() {
      var element = this.$el.querySelector('.col-contact .multiselect__content-wrapper');
      if (this.listOnSiteContact && this.listOnSiteContact.length > 0) {
        element.style.border = '1px solid #e6e6e6';
        element.style.padding = '0 0 7px 0';
      } else {
        element.style.border = 'none';
        element.style.padding = '0 0 0px 0';
      }
    },
    getLockIds: {
      handler: function handler() {
        var index = this.getLockIds.eventIds.indexOf(this.item.id.toString());
        this.isLocked = index !== -1 ? this.getLockIds.userIds[index] !== localStorage.getItem(__WEBPACK_IMPORTED_MODULE_21__consts__["a" /* default */].LOCAL_STORE.userId) : false;
      },
      deep: true
    },
    item: {
      handler: function handler() {
        this.disableDuration = this.item.disableDuration;
      },
      deep: true
    },
    'item.additionalComments': {
      handler: function handler(newValue, oldValue) {
        if (newValue.length > 1000) {
          this.item.additionalComments = oldValue;
        }
      }
    }
  }
});

/***/ }),
/* 1487 */,
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("358a5a08", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6849885c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTableGroupBtn.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6849885c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DataTableGroupBtn.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.dt-group-btn {\n  margin: 15px 0 0 5px;\n}\n.dt-group-btn .dt-group-btn-func .last-action {\n  text-transform: uppercase;\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  padding-top: 22px;\n}\n.dt-group-btn .dt-group-btn-func .last-action:hover {\n  cursor: pointer;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action {\n  text-align: right;\n  padding-right: 25px;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .dt-group-btn-func-btn-left {\n  height: 37px;\n  width: auto;\n  border: 1px solid #0080a5;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .dt-group-btn-func-btn-left .dt-group-btn-func-btn-left-text {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .dt-group-btn-func-btn-right {\n  height: 37px;\n  width: auto;\n  border-radius: 4px;\n  background-color: #00A4D6;\n  margin-left: 10px;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .dt-group-btn-func-btn-right .dt-group-btn-func-btn-right-text {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  margin-top: 1px;\n  margin-left: 25px;\n  margin-right: 3px;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .dt-group-btn-func-btn-right .dt-group-btn-func-btn-right-text-width {\n  line-height: 17px;\n  margin: 0 0 0 32px;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .dt-group-btn-func-btn-right .no-margin-left {\n  margin-left: 0;\n}\n.dt-group-btn .dt-group-btn-func .grp-button-action .oval-background {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 2px solid #ffffff;\n  border-radius: 50px;\n  width: 25px;\n  height: 25px;\n  margin-right: 7px;\n  float: left;\n  margin-top: -3px;\n}\n.dt-group-btn .button-action-container .outer {\n  display: table;\n  height: 100%;\n  float: right;\n}\n.dt-group-btn .button-action-container .outer .middle {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dt-group-btn .button-action-container .outer .middle .inner {\n  margin-left: auto;\n  margin-right: auto;\n  font-size: 45px;\n  line-height: 30px;\n  text-align: center;\n  position: relative;\n}\n.dt-group-btn .button-action-container .outer .middle .inner .admin-func-icon {\n  height: 30px;\n  width: 24px;\n  color: #00A4D6;\n}\n.dt-group-btn .button-action-container .outer .middle .inner .admin-func-icon:hover {\n  cursor: pointer;\n}\n.dt-group-btn .button-action-container .outer .middle .inner ul.action-panel {\n  list-style: none;\n  font-size: 15px;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 0;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  position: absolute;\n  bottom: 5px;\n  right: 20px;\n  width: 255px;\n}\n.dt-group-btn .button-action-container .outer .middle .inner ul.action-panel li {\n  padding-left: 10px;\n  border-bottom: solid 1px #E6E6E6;\n}\n.dt-group-btn .button-action-container .outer .middle .inner ul.action-panel li:last-child {\n  border-bottom: none;\n}\n.dt-group-btn .button-action-container .outer .middle .inner ul.action-panel li:hover {\n  cursor: pointer;\n  background-color: #F5F5F5;\n}\n.dt-group-btn .button-action-container .outer .middle .inner ul.action-panel li .semi-bold {\n  font-weight: 500;\n}\n", ""]);

// exports


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_arrow_circle_o_right__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_ellipsis_v__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _ = __webpack_require__(32);

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].filter('formatLastUpdate', function (value) {
  if (value) {
    var time = new Date(value);
    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(String(time)).format('h:mm A MM/DD/YYYY');
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DtGroupBtn',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      isShowAction: false,
      groupButtonFunc: {},
      userRole: '',
      isCircle: false
    };
  },

  props: {
    item: {
      type: Object,
      default: {}
    },
    eventStatus: {
      type: String,
      default: ''
    },
    isSuggestChanges: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      default: 'Client'
    },
    showOnModal: {
      type: Boolean,
      default: false
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    editEventAdmin: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    btnRightText: function btnRightText() {
      if (this.isSuggestChanges === false) {
        return this.showRelatedEvent ? this.groupButtonFunc.btnRightRelated : this.groupButtonFunc.btnRight;
      }
      return this.groupButtonFunc.btnRight;
    },
    isEnableBtnLeft: function isEnableBtnLeft() {
      return !!(this.groupButtonFunc.btnLeft !== '' && this.isEnableBtnRight);
    },
    isAdminButton: function isAdminButton() {
      return this.userRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin;
    },
    isEnableBtnRight: function isEnableBtnRight() {
      var getRole = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.role);
      if (this.groupButtonFunc.btnRight !== '' && this.groupButtonFunc.btnRight !== undefined) {
        if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.drafts) {
          return true;
        }
        if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.submitted) {
          return getRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.eventManager || getRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin;
        }
      }
      if (this.groupButtonFunc.btnRight !== '' && this.groupButtonFunc.btnRight !== undefined) {
        return true;
      }
      return this.showOnModal === true;
    },
    lastUpdateText: function lastUpdateText() {
      return this.groupButtonFunc.lastUpdateText || '';
    },
    funcBtnIcon: function funcBtnIcon() {
      return this.groupButtonFunc.funcBtnIcon || '';
    },
    showGrpBtn: function showGrpBtn() {
      var readOnly = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.readOnly) === 'true';
      // let isClientManager = localStorage.getItem(constants.USER_ROLE.readOnly) === constants.USER_ROLE.clientManager;
      var isDrafts = this.eventStatus.toLowerCase() === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.drafts.toLowerCase();
      return isDrafts || !readOnly;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])({
    showRelatedEvent: 'GETTERS_SHOW_RELATED_EVENT'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    btnLeftClick: function btnLeftClick() {
      if (this.groupButtonFunc.action === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.editEvent) {
        this.$modal.hide('ModalEditEvent');
      } else {
        this.setExpandId({ id: -1, isExpand: false });
        if (this.showRelatedEvent === true) {
          this.restoreListEvent();
          this.setShowRelatedEvents(false);
        }
      }
    },
    dispatchFunc: function dispatchFunc() {
      // Go to event
      if (this.userRole !== __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.client && this.viewMode !== 'Client') {
        var clientItem = {
          id: this.item.clientId,
          clientName: this.item.clientName
        };
        this.selectClient(clientItem);
        this.$router.push({
          name: __WEBPACK_IMPORTED_MODULE_7__router_constants__["a" /* default */].clientDashboard.name,
          params: {
            clientId: clientItem.id
          }
        });
        return;
      }
      // save event
      if (this.groupButtonFunc.action === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.saveEvent && !this.isLocked) {
        this.updateEvent(this.item);
        this.setExpandId({ id: -1, isExpand: false });
      }
      // Approve event
      if (this.groupButtonFunc.action === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.approveEvent) {
        if (!this.showRelatedEvent) {
          this.setItemRelated(this.item);
        } else {
          // for show approve modal
          var modalData = {
            action: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.approveEvent,
            data: this.item
          };
          this.$modal.show('eventModal', modalData);
        }
      }
      // Change order event, event move from Approved folder => Drafts folder
      if (this.groupButtonFunc.action === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.changeOrderDetail) {
        if (this.item.additionalComments === '') {
          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$toastr('error', 'Additional Comments is required!', '');
          return;
        }
        this.item.status = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.drafts.toUpperCase();
        this.item.isChangeOrder = true;
        if (this.item.projPart >= 34) {
          this.item.addOns = this.item.addOns.replace('smallSiteModel', '');
          this.item.addOns = this.item.addOns.replace('smallSiteConcierge', '');
        }
        this.submitEvent(this.item);
        var _modalData = {
          action: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.showInfo,
          data: null
        };
        this.$modal.show('eventModal', _modalData);
        this.$modal.hide('ModalChangeOrder');
      }
      if (this.groupButtonFunc.action === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.editEvent) {
        this.updateEvent(this.item);
        this.$modal.hide('ModalEditEvent');
      }
    },
    showHistory: function showHistory() {
      var getRole = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.role);
      var role = getRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin || getRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.eventManager;
      if (this.item.status !== __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.drafts.toUpperCase() && role) {
        this.getEventHistory(this.item.id);
        this.$modal.show('historyModal');
      }
    },
    moveEvent: function moveEvent(eventId, eventName, eventStatus) {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.moveEvent,
        data: {
          eventId: eventId,
          eventName: eventName,
          updateStatus: eventStatus
        }
      };
      this.$modal.show('eventModal', modalData);
    },
    deleteEventClick: function deleteEventClick() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.deleteEvent,
        data: this.item
      };
      this.$modal.show('eventModal', modalData);
    },
    editEvent: function editEvent() {
      var event = _.cloneDeep(this.item);

      var data = {
        action: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction.editEvent,
        data: event
      };
      this.$modal.show('ModalEditEvent', data);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])({
    submitEvent: 'ACTION_SUBMIT_EVENT',
    updateEvent: 'ACTION_UPDATE_EVENT',
    resetExpandId: 'ACTION_RESET_EXPAND_ID',
    setItemRelated: 'ACTION_SET_ITEM_RELATED',
    setListBack: 'ACTION_SET_LIST_BACK',
    setExpandId: 'ACTION_SET_EXPAND_ID',
    selectClient: 'ACTION_SELECT_CLIENT',
    restoreListEvent: 'ACTION_RESTORE_LIST_EVENT',
    setShowRelatedEvents: 'ACTION_SET_SHOW_RELATED_EVENT',
    getEventHistory: 'ACTION_GET_EVENT_HISTORY'
  })),
  mounted: function mounted() {
    if (this.editEventAdmin) {
      this.groupButtonFunc = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES.editEventAdmin;
      return;
    }
    if (this.showOnModal) {
      this.groupButtonFunc = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES.changeOrderDetail;
      return;
    }
    this.userRole = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.role);
    if (this.userRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.eventManager || this.userRole === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin) {
      // EM button
      if (this.viewMode !== 'Client') {
        // View in mode manager => Go to event
        this.groupButtonFunc = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES.eventManager.magagerOverview;
      } else {
        // view in mode client = Suggest changes, Approve
        if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.drafts) {
          this.groupButtonFunc = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus];
        }
        if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.submitted) {
          this.groupButtonFunc = this.isSuggestChanges ? __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].suggestChanges : __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].approve;
        }
      }
    } else {
      // AM or Client
      if (this.viewMode !== 'Client') {
        // View in mode manager => Go to event
        this.groupButtonFunc = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES.eventManager.magagerOverview;
      } else {
        if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.drafts) {
          this.groupButtonFunc = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus];
        }
        if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.review) {
          this.groupButtonFunc = this.isSuggestChanges ? __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].suggestChanges : __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].resubmit;
        }
      }
    }
  },
  watch: {
    isSuggestChanges: function isSuggestChanges() {
      if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.submitted) {
        this.groupButtonFunc = this.isSuggestChanges ? __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].suggestChanges : __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].resubmit;
      }
      if (this.eventStatus === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.submitted) {
        this.groupButtonFunc = this.isSuggestChanges ? __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].suggestChanges : __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].EVENT_TYPES[this.eventStatus].approve;
      }
    },
    groupButtonFunc: {
      handler: function handler(groupButtonFunc) {
        this.isCircle = this.groupButtonFunc.btnRightIcon === 'angle-right';
      },
      deep: true
    }
  }
});

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-group-btn" }, [
    _c("div", { staticClass: "dt-group-btn-func row" }, [
      _c(
        "div",
        {
          staticClass: "last-action col-md-6",
          on: {
            click: function($event) {
              _vm.showHistory()
            }
          }
        },
        [
          _vm.item.lastModifiedByUserName
            ? _c("span", [
                _vm._v(
                  "Last " +
                    _vm._s(_vm.lastUpdateText) +
                    " by " +
                    _vm._s(_vm.item.lastModifiedByUserName) +
                    " at " +
                    _vm._s(_vm._f("formatLastUpdate")(_vm.item.lastModifiedAt))
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showGrpBtn
        ? _c("div", { staticClass: "grp-button-action col-md-6" }, [
            _c("div", { staticClass: "button-action-container" }, [
              _c(
                "div",
                { staticClass: "outer" },
                [
                  _vm.isAdminButton
                    ? _c("div", { staticClass: "middle" }, [
                        _c(
                          "div",
                          {
                            staticClass: "inner",
                            on: {
                              click: function($event) {
                                _vm.isShowAction = true
                              },
                              mouseleave: function($event) {
                                _vm.isShowAction = false
                              }
                            }
                          },
                          [
                            _c("Icon", {
                              staticClass: "admin-func-icon",
                              attrs: { name: "ellipsis-v" }
                            }),
                            _vm._v(" "),
                            _vm.isShowAction
                              ? _c("ul", { staticClass: "action-panel" }, [
                                  _c(
                                    "li",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.editEvent()
                                        }
                                      }
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _vm.eventStatus != "drafts"
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.moveEvent(
                                                _vm.item.id,
                                                _vm.item.eventName,
                                                "Drafts"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("Move to "),
                                          _c(
                                            "span",
                                            { staticClass: "semi-bold" },
                                            [_vm._v("Drafts")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.eventStatus != "submitted"
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.moveEvent(
                                                _vm.item.id,
                                                _vm.item.eventName,
                                                "Submitted"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("Move to "),
                                          _c(
                                            "span",
                                            { staticClass: "semi-bold" },
                                            [_vm._v("Submitted to ADURO")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.eventStatus != "review"
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.moveEvent(
                                                _vm.item.id,
                                                _vm.item.eventName,
                                                "Review"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("Move to "),
                                          _c(
                                            "span",
                                            { staticClass: "semi-bold" },
                                            [_vm._v("Needs Review")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.eventStatus != "approved"
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.moveEvent(
                                                _vm.item.id,
                                                _vm.item.eventName,
                                                "Approved"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("Move to "),
                                          _c(
                                            "span",
                                            { staticClass: "semi-bold" },
                                            [_vm._v("Approved")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.eventStatus != "archived"
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.moveEvent(
                                                _vm.item.id,
                                                _vm.item.eventName,
                                                "Archived"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("Move to "),
                                          _c(
                                            "span",
                                            { staticClass: "semi-bold" },
                                            [_vm._v("Archived")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.eventStatus != "deleted"
                                    ? _c(
                                        "li",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.deleteEventClick()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "semi-bold" },
                                            [_vm._v("Delete event")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEnableBtnLeft
                    ? _c(
                        "b-button",
                        {
                          staticClass: "dt-group-btn-func-btn-left",
                          on: {
                            click: function($event) {
                              _vm.btnLeftClick()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "dt-group-btn-func-btn-left-text" },
                            [_vm._v(_vm._s(_vm.groupButtonFunc.btnLeft))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEnableBtnRight || _vm.isLocked
                    ? _c(
                        "b-button",
                        {
                          staticClass: "dt-group-btn-func-btn-right",
                          on: {
                            click: function($event) {
                              _vm.dispatchFunc()
                            }
                          }
                        },
                        [
                          _vm.isCircle
                            ? _c(
                                "div",
                                { staticClass: "oval-background" },
                                [
                                  _vm.groupButtonFunc.btnRightIcon != ""
                                    ? _c("Icon", {
                                        staticClass: "func-icon",
                                        attrs: {
                                          name: _vm.groupButtonFunc.btnRightIcon
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isCircle
                            ? _c(
                                "span",
                                [
                                  _vm.groupButtonFunc.btnRightIcon != ""
                                    ? _c("Icon", {
                                        staticClass: "func-icon",
                                        attrs: {
                                          name: _vm.groupButtonFunc.btnRightIcon
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isCircle && !_vm.showRelatedEvent
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dt-group-btn-func-btn-right-text dt-group-btn-func-btn-right-text-width"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.btnRightText) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isCircle && _vm.showRelatedEvent
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dt-group-btn-func-btn-right-text"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.btnRightText) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isCircle
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dt-group-btn-func-btn-right-text",
                                  class: {
                                    "no-margin-left":
                                      _vm.btnRightText === "Request Change" ||
                                      _vm.btnRightText === "Go to event" ||
                                      _vm.btnRightText === "Save"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.btnRightText) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6849885c", esExports)
  }
}

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedEvent_vue__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f16dac38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedEvent_vue__ = __webpack_require__(1508);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1493)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f16dac38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f16dac38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedEvent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/RelatedEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RelatedEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f16dac38", Component.options)
  } else {
    hotAPI.reload("data-v-f16dac38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1494);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("46405cc4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f16dac38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RelatedEvent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f16dac38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RelatedEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n/**\n* OVERIDE GENERAL STYLES\n*/\n.caption-text[data-v-f16dac38] {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.label-text[data-v-f16dac38] {\n  color: #626262;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.label-text-2[data-v-f16dac38] {\n  color: #8E8E8E;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.body-text[data-v-f16dac38],\n.email-histories-page .histories-page-body .participant-table-container .search-section .input[data-v-f16dac38] {\n  color: #424242;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.h4-text[data-v-f16dac38] {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.h3-text[data-v-f16dac38] {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n}\n.h2-text[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.h1-text[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.button-text[data-v-f16dac38],\n.ap-btn[data-v-f16dac38] {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n.value-text[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.tab-header .type[data-v-f16dac38] {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 6px;\n  line-height: 48px;\n  margin-right: 24px;\n}\n.tab-header .type[data-v-f16dac38]:hover {\n  cursor: pointer;\n  color: #606060;\n}\n.tab-header .type[data-v-f16dac38]:focus {\n  border: 2px solid rgba(0, 164, 214, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 14px 24px;\n}\n.tab-header .type.active[data-v-f16dac38] {\n  border-bottom: 3px solid #1674CD;\n  color: #1674CD;\n}\n.ap-checkbox-group[data-v-f16dac38] {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label[data-v-f16dac38] {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-indicator[data-v-f16dac38] {\n  width: 24px;\n  height: 24px;\n  top: 0;\n  border: 1px solid #b9b9b9;\n  background-color: transparent;\n}\n.ap-checkbox-group .custom-control-description[data-v-f16dac38] {\n  margin-left: 1rem;\n}\n.ap-checkbox-group .custom-checkbox[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label[data-v-f16dac38] {\n  cursor: pointer;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label[data-v-f16dac38]::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label[data-v-f16dac38]::before,\n.ap-checkbox-group .custom-checkbox .custom-control-label[data-v-f16dac38]::after {\n  top: 0;\n  height: 24px;\n  width: 24px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label span[data-v-f16dac38] {\n  padding-left: 11.5px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-input:checked ~ .custom-control-label[data-v-f16dac38]:before {\n  background-color: #1674CD;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group[data-v-f16dac38] {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-control-label[data-v-f16dac38] {\n  cursor: pointer;\n}\n.ap-radio-group .custom-control-label[data-v-f16dac38]::after {\n  background-size: 95%;\n}\n.ap-radio-group .custom-control-label[data-v-f16dac38]::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-radio-group .custom-control-label[data-v-f16dac38]::before,\n.ap-radio-group .custom-control-label[data-v-f16dac38]::after {\n  top: 0;\n  height: 25px;\n  width: 25px;\n}\n.ap-radio-group .custom-control-label span[data-v-f16dac38] {\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio[data-v-f16dac38] {\n  margin-bottom: 24px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label[data-v-f16dac38] {\n  font-size: 16px;\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label span[data-v-f16dac38] {\n  padding-left: 0;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label[data-v-f16dac38] {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label[data-v-f16dac38]:before {\n  background-color: transparent;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label[data-v-f16dac38]::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2300A4D6'/%3E%3C/svg%3E\");\n}\n.ap-input-wrapper[data-v-f16dac38] {\n  position: relative;\n}\n.ap-input-wrapper .input[data-v-f16dac38] {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-input-wrapper .input.error[data-v-f16dac38] {\n  border: 1px solid #FF3400;\n}\n.ap-input-wrapper .input.success[data-v-f16dac38] {\n  border: 1px solid #68B814;\n}\n.ap-input-wrapper .input.warning[data-v-f16dac38] {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .title-field[data-v-f16dac38] {\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper[data-v-f16dac38] {\n  position: relative;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input[data-v-f16dac38] {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.error[data-v-f16dac38] {\n  border: 1px solid #FF3400;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.success[data-v-f16dac38] {\n  border: 1px solid #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.warning[data-v-f16dac38] {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field[data-v-f16dac38] {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 24px;\n  height: 24px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-error-field[data-v-f16dac38] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E83001;\n  background-color: #E83001;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-success-field[data-v-f16dac38] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #68B814;\n  background-color: #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-warning-field[data-v-f16dac38] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E89819;\n  background-color: #E89819;\n}\n.ap-field-input-wrapper .message-field[data-v-f16dac38] {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.ap-field-input-wrapper .message-field.success[data-v-f16dac38] {\n  color: #68B814;\n}\n.ap-field-input-wrapper .message-field.error[data-v-f16dac38] {\n  color: #E83001;\n}\n.ap-field-input-wrapper .message-field.warning[data-v-f16dac38] {\n  color: #E89819;\n}\n.ap-dropdown[data-v-f16dac38] {\n  width: 300px;\n  font-size: 16px;\n}\n.ap-dropdown .ap-dropdown-btn[data-v-f16dac38] {\n  width: 100%;\n}\n.ap-dropdown .ap-dropdown-btn.btn-group > .btn[data-v-f16dac38]:first-child {\n  border: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary[data-v-f16dac38] {\n  height: 44px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #ffffff;\n  width: inherit;\n  padding: 10px 16px;\n  font-size: 16px;\n  text-align: left;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary[data-v-f16dac38]::after {\n  display: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary[data-v-f16dac38]:hover {\n  border: 1px solid #7B7B7B;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary[data-v-f16dac38]:focus {\n  border: 2px solid rgba(32, 170, 233, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text[data-v-f16dac38] {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text.active[data-v-f16dac38] {\n  color: #1D1D1D;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper .icon-dropdown[data-v-f16dac38] {\n  width: 13px;\n  height: 18px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.ap-dropdown .dropdown-menu[data-v-f16dac38] {\n  width: inherit;\n  width: 100%;\n  border-radius: 4px;\n  background-color: #FFF;\n  margin-top: 8px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 8px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item[data-v-f16dac38] {\n  height: inherit;\n  padding: 0px 0px 0 16px;\n  color: #1D1D1D;\n  line-height: 24px;\n  border: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item[data-v-f16dac38]:hover {\n  background-color: #F5F5F5 !important;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item[data-v-f16dac38]:focus {\n  background-color: unset;\n  outline: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item .ap-item-wrapper[data-v-f16dac38] {\n  height: 44px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #E6E6E6;\n  padding: 12px 0 9px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:last-child .ap-item-wrapper[data-v-f16dac38] {\n  border: none;\n}\n.dropdown-section[data-v-f16dac38] {\n  height: 500px;\n  margin-top: 64px;\n}\n.dropdown-section .section-title[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  margin-bottom: 40px;\n}\n.pretty.p-default input:checked ~ .state label[data-v-f16dac38]:after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn[data-v-f16dac38] {\n  height: 26px;\n}\n.custom-radio-btn input:checked ~ .state label[data-v-f16dac38] {\n  font-weight: 600;\n  color: #00A4D6;\n}\n.custom-radio-btn input:checked ~ .state label[data-v-f16dac38]::after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn input:checked ~ .state label[data-v-f16dac38]::before {\n  border-color: #00A4D6;\n}\n.custom-radio-btn .state label[data-v-f16dac38] {\n  height: 26px;\n  margin-left: 16px;\n  font-size: 16px;\n  color: #606060;\n  line-height: 26px;\n  letter-spacing: -0.04px;\n}\n.custom-radio-btn .state label[data-v-f16dac38]::after {\n  width: 25px;\n  height: 25px;\n  bottom: 0;\n  top: unset;\n}\n.custom-radio-btn .state label[data-v-f16dac38]::before {\n  width: 25px;\n  height: 25px;\n  border-color: #b9b9b9;\n  bottom: 0;\n  top: unset;\n}\n.ap-btn[data-v-f16dac38] {\n  padding: 12px 32px;\n  border: 1px solid #1674CD;\n  border-radius: 4px;\n  background: none;\n}\n.ap-btn.compact[data-v-f16dac38] {\n  padding: 6px 24px;\n}\n.ap-btn.primary[data-v-f16dac38] {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.primary[data-v-f16dac38]:focus {\n  background-color: #1674CD;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.primary[data-v-f16dac38]:hover {\n  background-color: #1674CD;\n}\n.ap-btn.primary[data-v-f16dac38]:active {\n  background-color: #00526A;\n  outline: none;\n}\n.ap-btn.primary[data-v-f16dac38]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.primary[data-v-f16dac38]:disabled:hover {\n  background-color: #1674CD;\n}\n.ap-btn.secondary[data-v-f16dac38] {\n  background-color: white;\n  color: #1674CD;\n}\n.ap-btn.secondary[data-v-f16dac38]:hover {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.secondary[data-v-f16dac38]:focus {\n  background-color: #FFF;\n  color: #1674CD;\n}\n.ap-btn.secondary[data-v-f16dac38]:active {\n  background-color: #00526A;\n  color: #FFF;\n}\n.ap-btn.secondary[data-v-f16dac38]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.secondary[data-v-f16dac38]:disabled:hover {\n  background-color: transparent;\n  color: #1674CD;\n}\n.ap-btn.tertiary[data-v-f16dac38] {\n  background-color: #AAA7A4;\n  color: #FFF;\n  border: 1px solid #AAA7A4;\n}\n.ap-btn.tertiary[data-v-f16dac38]:hover {\n  background-color: #67615C;\n}\n.ap-btn.tertiary[data-v-f16dac38]:active {\n  background-color: #463E37;\n}\n.ap-btn.tertiary[data-v-f16dac38]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.tertiary[data-v-f16dac38]:disabled:hover {\n  background-color: #AAA7A4;\n}\n.ap-btn.destructive[data-v-f16dac38] {\n  background-color: #FF3400;\n  color: #FFF;\n  border: none;\n}\n.ap-btn.destructive[data-v-f16dac38]:focus {\n  background-color: #FF3400;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.destructive[data-v-f16dac38]:hover {\n  background-color: #B22520;\n}\n.ap-btn.destructive[data-v-f16dac38]:active {\n  background-color: #631412;\n}\n.ap-btn.destructive[data-v-f16dac38]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.destructive[data-v-f16dac38]:disabled:hover {\n  background-color: #FF3400;\n}\n.ap-btn-icon[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ap-btn-icon .btn-left-icon[data-v-f16dac38] {\n  height: 20px;\n  width: 18px;\n  margin-right: 8px;\n  color: #FFF;\n}\n.ap-btn-icon-only[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px;\n}\n.ap-btn-icon-only.compact[data-v-f16dac38] {\n  padding: 5px;\n}\n.ap-btn-icon-only .btn-left-icon[data-v-f16dac38] {\n  height: 20px;\n  width: 18px;\n  color: #FFF;\n}\n.background[data-v-f16dac38],\n.card-rest-background[data-v-f16dac38],\n.card-lift-background[data-v-f16dac38],\n.modal-background[data-v-f16dac38],\n.list-dialogues-background[data-v-f16dac38],\n.alert-background[data-v-f16dac38],\n.iziToast-wrapper .iziToast[data-v-f16dac38] {\n  border-radius: 4px;\n  background-color: #FFF;\n}\n.header-background[data-v-f16dac38] {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.banner-background[data-v-f16dac38] {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.card-rest-background[data-v-f16dac38] {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.card-lift-background[data-v-f16dac38] {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-background[data-v-f16dac38] {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.list-dialogues-background[data-v-f16dac38] {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-background[data-v-f16dac38],\n.iziToast-wrapper .iziToast[data-v-f16dac38] {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-icon[data-v-f16dac38],\n.alert-icon-checked[data-v-f16dac38],\n.alert-icon-info[data-v-f16dac38],\n.alert-icon-warning[data-v-f16dac38],\n.alert-icon-error[data-v-f16dac38] {\n  width: 24px;\n  height: 24px;\n  color: #FFF;\n  background-color: #FFF;\n}\n.alert-icon-checked[data-v-f16dac38] {\n  background: url('/static/img/down-o-white.svg') no-repeat center;\n}\n.alert-icon-info[data-v-f16dac38] {\n  background: url('/static/img/status-info-outline-white.svg') no-repeat center;\n}\n.alert-icon-warning[data-v-f16dac38] {\n  background: url('/static/img/status-warning-outline-white.svg') no-repeat center;\n}\n.alert-icon-error[data-v-f16dac38] {\n  background: url('/static/img/icon-field-error-white.svg') no-repeat center;\n}\n.iziToast-wrapper .iziToast[data-v-f16dac38] {\n  min-height: 45px;\n  min-width: 283px;\n  padding: 5px 40px 5px 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body[data-v-f16dac38] {\n  min-height: 35px;\n  margin-left: 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child[data-v-f16dac38] {\n  background: #FFF;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child[data-v-f16dac38]:hover {\n  background: #e6e6e6;\n}\n.iziToast-wrapper .iziToast > .iziToast-texts[data-v-f16dac38] {\n  margin-top: 9px;\n}\n.iziToast-wrapper .iziToast > .iziToast-close[data-v-f16dac38] {\n  top: 50%;\n  right: 10px;\n  margin-top: -7px;\n  width: 14px;\n  height: 14px;\n  background: url('/static/img/ic_close.png') center center no-repeat;\n  background-size: cover;\n  opacity: 1;\n}\n.iziToast-wrapper .iziToast[data-v-f16dac38]:after {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.manage-related-events-container[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.manage-related-events-container .btn-back-wrapper[data-v-f16dac38] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back[data-v-f16dac38] {\n  height: 24px;\n  width: 24px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img[data-v-f16dac38] {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close[data-v-f16dac38] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header[data-v-f16dac38] {\n  margin-top: 24px;\n  padding: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header .modal-title[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  border: none;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section[data-v-f16dac38] {\n  margin-top: 20px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title .count-related-event[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title .count-related-event[data-v-f16dac38] {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  line-height: 30px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper[data-v-f16dac38] {\n  width: 60%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .input-search-event[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .input-search-event[data-v-f16dac38] {\n  height: 42px;\n  border-radius: 3px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .search-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .search-icon[data-v-f16dac38] {\n  position: absolute;\n  right: 12px;\n  top: 10px;\n  z-index: 2;\n  height: 22px;\n  width: 22px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container[data-v-f16dac38] {\n  background-color: #f5f5f5;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-top: 16px;\n  padding-bottom: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events[data-v-f16dac38] {\n  border-radius: 4px;\n  margin-top: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name[data-v-f16dac38] {\n  width: 15%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name .field-value[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name .field-value[data-v-f16dac38] {\n  margin-left: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-address[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-address[data-v-f16dac38] {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-contact[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-contact[data-v-f16dac38] {\n  width: 17%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-email[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-email[data-v-f16dac38] {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-date[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-date[data-v-f16dac38] {\n  width: 10%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action[data-v-f16dac38] {\n  width: 8%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper[data-v-f16dac38] {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper[data-v-f16dac38] {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 16px;\n  border-left: 1px solid #b9b9b9;\n  width: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line[data-v-f16dac38]:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name[data-v-f16dac38] {\n  margin-left: 16px;\n  color: #8E8E8E;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper[data-v-f16dac38] {\n  color: #8E8E8E;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon[data-v-f16dac38] {\n  vertical-align: middle;\n  width: 12px;\n  height: 12px;\n  color: #8E8E8E;\n  margin-top: -10px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body[data-v-f16dac38] {\n  max-height: 316px;\n  min-height: 200px;\n  overflow-y: auto;\n  margin-top: 16px;\n  padding-top: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item[data-v-f16dac38] {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  height: 56px;\n  margin: 0px 5px 16px 5px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 56px;\n  padding-left: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added[data-v-f16dac38] {\n  color: #8E8E8E;\n  font-size: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn[data-v-f16dac38],\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn[data-v-f16dac38] {\n  font-size: 12px;\n  padding: 0 12px;\n}\n.manage-related-events-container .group-btn[data-v-f16dac38] {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 32px;\n}\n.manage-related-events-container .group-btn .ap-btn[data-v-f16dac38] {\n  font-size: 16px;\n  padding: 6px 24px;\n  text-transform: none;\n}\n.manage-related-events-container .group-btn .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.manage-related-events-container .list-events[data-v-f16dac38] {\n  background-color: #FCFCFC;\n  border: 1px solid #E6E6E6;\n  margin-top: 1rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.2rem;\n}\n.manage-related-events-container .list-events .selected-text[data-v-f16dac38] {\n  color: #8E8E8E;\n}\n.manage-related-events-container .list-events .icon-add-wrapper[data-v-f16dac38] {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-add-wrapper[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-add-wrapper .icon-add[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .icon-close-wrapper[data-v-f16dac38] {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-close-wrapper[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-close-wrapper .icon-close[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .list-container[data-v-f16dac38] {\n  margin: 0 0 1.4rem 0;\n}\n.manage-related-events-container .list-events .list-group-container[data-v-f16dac38] {\n  margin: 3rem 0;\n}\n.manage-related-events-container .list-events .list-header[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-header .column[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column[data-v-f16dac38] {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manage-related-events-container .list-events .list-header .column .container-column p[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column p[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column p[data-v-f16dac38] {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column button[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column button[data-v-f16dac38] {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button img[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column button img[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column button img[data-v-f16dac38] {\n  height: 0.6rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-header[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column .text-header[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column .text-header[data-v-f16dac38] {\n  font-weight: 600;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-icon[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column .text-icon[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column .text-icon[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-not-live[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .container-column .text-not-live[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column .text-not-live[data-v-f16dac38] {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manage-related-events-container .list-events .list-header .column .border-seperate[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column .border-seperate[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .border-seperate[data-v-f16dac38] {\n  border-right: 1px solid #B9B9B9;\n}\n.manage-related-events-container .list-events .list-header .column.width-10[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column.width-10[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column.width-10[data-v-f16dac38] {\n  width: 10%;\n}\n.manage-related-events-container .list-events .list-header .column.width-20[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column.width-20[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column.width-20[data-v-f16dac38] {\n  width: 20%;\n}\n.manage-related-events-container .list-events .list-header .column.width-30[data-v-f16dac38],\n.manage-related-events-container .list-events .list-content .column.width-30[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column.width-30[data-v-f16dac38] {\n  width: 30%;\n}\n.manage-related-events-container .list-events .list-content[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca[data-v-f16dac38] {\n  background: #fff;\n}\n.manage-related-events-container .list-events .list-content .column[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-content .column .container-column[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column[data-v-f16dac38] {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .list-events .list-content .column .container-column img[data-v-f16dac38],\n.manage-related-events-container .list-events .list-ca .column .container-column img[data-v-f16dac38] {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .list-content .column[data-v-f16dac38]:last-child,\n.manage-related-events-container .list-events .list-ca .column[data-v-f16dac38]:last-child {\n  padding: 0 1rem;\n}\n.manage-related-events-container .list-events .list-content[data-v-f16dac38] {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manage-related-events-container .list-events .list-ca[data-v-f16dac38] {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manage-related-events-container .list-events .container-ca[data-v-f16dac38] {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manage-related-events-container .list-events .container-text[data-v-f16dac38] {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manage-related-events-container .list-events .container-text b[data-v-f16dac38] {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .container-text .seperate[data-v-f16dac38] {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manage-related-events-container .list-events .load-more[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .list-events .load-more span[data-v-f16dac38] {\n  position: absolute;\n}\n.manage-related-events-container .list-events .load-more button[data-v-f16dac38] {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.client-contact-email-page[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n  padding: 2rem;\n}\n.client-contact-email-page .header-email-page[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .header-email-page p[data-v-f16dac38] {\n  font-weight: 600;\n  font-size: 1.5em;\n  color: #1D1D1D;\n  margin: 0;\n}\n.client-contact-email-page .header-email-page .icon-close[data-v-f16dac38] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.client-contact-email-page .btn-back-wrapper[data-v-f16dac38] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back[data-v-f16dac38] {\n  height: 24px;\n  width: 24px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper[data-v-f16dac38] {\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn[data-v-f16dac38] {\n  margin-bottom: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn .event-count[data-v-f16dac38] {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn label[data-v-f16dac38] {\n  font-size: 1em;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events[data-v-f16dac38] {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item[data-v-f16dac38] {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item .event-name[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .btn-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-cancel[data-v-f16dac38] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  width: 8%;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-send[data-v-f16dac38] {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  width: 8%;\n  margin-left: 1rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .spinner-border[data-v-f16dac38] {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.client-contact-email-page .recipients-section .list-email-recipient[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient[data-v-f16dac38] {\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper[data-v-f16dac38] {\n  position: relative;\n  margin: .5rem;\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 5px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38] {\n  border: none;\n  background-color: #FFF;\n  border-radius: 5px;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-webkit-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-webkit-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-moz-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-moz-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]:-ms-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]:-ms-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38] {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38]:hover,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38]:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to[data-v-f16dac38] {\n  padding: 16px;\n  overflow: auto;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item[data-v-f16dac38] {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon[data-v-f16dac38] {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item[data-v-f16dac38] {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .history-left[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date[data-v-f16dac38] {\n  min-width: 110px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38],\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38] {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38]:hover,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38]:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-wrapper[data-v-f16dac38] {\n  margin-top: 30px;\n}\n.client-contact-email-page .recipients-wrapper .recipients-section .list-email-send-to[data-v-f16dac38] {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .cc-section .list-email-send-to[data-v-f16dac38] {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .text-mar-bot[data-v-f16dac38] {\n  margin-bottom: 1.5rem;\n}\n.client-contact-email-page .text-send-email[data-v-f16dac38] {\n  margin: 2rem 0 1em 0;\n  font-weight: 600;\n}\n.client-contact-email-page .send-email-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .participant-emails[data-v-f16dac38] {\n  padding: 0 1.2% 0 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .list-email-send-to[data-v-f16dac38] {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all[data-v-f16dac38] {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title[data-v-f16dac38] {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .line[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date[data-v-f16dac38] {\n  min-width: 110px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template[data-v-f16dac38] {\n  min-width: 150px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text[data-v-f16dac38] {\n  padding: 0 16px;\n  color: #8E8E8E;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text .sort-icon[data-v-f16dac38] {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper .text-subject[data-v-f16dac38] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  padding: 0.3rem 0.6rem;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn[data-v-f16dac38] {\n  margin-right: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text[data-v-f16dac38] {\n  font-weight: normal;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn label[data-v-f16dac38] {\n  font-size: 1em;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke[data-v-f16dac38] {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner[data-v-f16dac38] {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top[data-v-f16dac38] {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom[data-v-f16dac38],\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom[data-v-f16dac38] {\n  border-radius: 0 0 4px 4px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to[data-v-f16dac38] {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all[data-v-f16dac38] {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title[data-v-f16dac38] {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date[data-v-f16dac38] {\n  min-width: 110px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template[data-v-f16dac38] {\n  min-width: 150px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text[data-v-f16dac38] {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon[data-v-f16dac38] {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .group-btn[data-v-f16dac38] {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.client-contact-email-page .group-btn .ap-btn[data-v-f16dac38] {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.client-contact-email-page .group-btn .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.modal-body[data-v-f16dac38] {\n  padding: 24px;\n}\n.modal-body .description[data-v-f16dac38] {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container[data-v-f16dac38] {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn[data-v-f16dac38] {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper[data-v-f16dac38] {\n  padding: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .body-text[data-v-f16dac38] {\n  color: #1D1D1D;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .ap-input-wrapper .input[data-v-f16dac38] {\n  color: #000;\n  font-size: 16px;\n  line-height: 20px;\n  padding: 12px 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.modal-cancell-all-appointment[data-v-f16dac38] {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.modal-cancell-all-appointment .modal-header[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n  border: 0;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button[data-v-f16dac38] {\n  float: right;\n  font-size: 20px;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.modal-cancell-all-appointment .modal-body[data-v-f16dac38] {\n  margin-top: 1rem !important;\n}\n.modal-cancell-all-appointment .modal-body p[data-v-f16dac38] {\n  font-size: 1.7em;\n  font-weight: 600;\n}\n.modal-cancell-all-appointment .modal-body .btn-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 3rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes[data-v-f16dac38],\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no[data-v-f16dac38] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-weight: 600;\n  font-size: 16px;\n  width: 5rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes .text-primary[data-v-f16dac38],\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no .text-primary[data-v-f16dac38] {\n  width: 1rem;\n  height: 1rem;\n}\n.add-participant-modal .participant-info[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .title-field[data-v-f16dac38] {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .field-input[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n  width: 100%;\n  padding: 12px 16px;\n  height: unset;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .error-message[data-v-f16dac38] {\n  color: #FF3400;\n  font-size: 12px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .email-employee-container[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .select-more-services[data-v-f16dac38] {\n  padding: 24px 16px 0;\n}\n.add-participant-modal .participant-info .select-more-services .title-field[data-v-f16dac38] {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .select-more-services .add-more-services-checkbox[data-v-f16dac38] {\n  margin-top: 8px;\n}\n.add-participant-modal .btn-add-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.add-participant-modal .btn-add-container .btn-cancel[data-v-f16dac38] {\n  margin-right: 24px;\n}\n.add-participant-modal .btn-add-container .btn-add-participant[data-v-f16dac38] {\n  padding: 12px 32px;\n}\n.bulk-create-events[data-v-f16dac38] {\n  padding: 2rem 2.5rem;\n}\n.bulk-create-events .spinner-border[data-v-f16dac38] {\n  width: 1rem;\n  height: 1rem;\n  color: #1674CD;\n}\n.bulk-create-events .bulk-title[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .bulk-title p[data-v-f16dac38] {\n  font-weight: 600;\n  font-size: 24px;\n  margin-bottom: 0;\n}\n.bulk-create-events .bulk-title .btn-bulk[data-v-f16dac38] {\n  font-weight: 600;\n  color: #1674CD;\n  background: #FFFFFF;\n  border: 1px solid #b9b9b9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 1rem;\n  font-size: 16px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bulk-create-events .bulk-title .btn-bulk img[data-v-f16dac38],\n.bulk-create-events .bulk-title .btn-bulk .spinner-border[data-v-f16dac38] {\n  margin-right: .7rem;\n}\n.bulk-create-events .upload-file[data-v-f16dac38] {\n  margin-top: 2rem;\n}\n.bulk-create-events .upload-file .dropzone-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 3rem;\n  border: 2px dashed #ccc;\n  border-radius: 15px;\n}\n.bulk-create-events .upload-file .dropzone-container img[data-v-f16dac38] {\n  height: 6rem;\n  width: 7rem;\n}\n.bulk-create-events .upload-file .dropzone-container .text-csv[data-v-f16dac38] {\n  font-size: 1.1em;\n  margin: 1.5rem 0;\n  color: #B9B9B9;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop[data-v-f16dac38] {\n  font-size: 2.4em;\n  font-weight: 500;\n  color: #000000;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop a[data-v-f16dac38] {\n  color: #1674CD;\n  -webkit-text-decoration: revert;\n          text-decoration: revert;\n}\n.bulk-create-events hr[data-v-f16dac38] {\n  margin: 2rem 0;\n}\n.bulk-create-events .submission-history[data-v-f16dac38] {\n  min-height: 40vh;\n}\n.bulk-create-events .submission-history p[data-v-f16dac38] {\n  font-size: 1.2em;\n  font-weight: 600;\n}\n.bulk-create-events .submission-history table[data-v-f16dac38] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.bulk-create-events .submission-history table th[data-v-f16dac38],\n.bulk-create-events .submission-history table td[data-v-f16dac38] {\n  border: 1px solid #e6e6e6;\n  padding: 1rem;\n}\n.bulk-create-events .submission-history table th[data-v-f16dac38] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: left;\n  background-color: #FCFCFC;\n  color: #585858;\n  white-space: nowrap;\n}\n.bulk-create-events .submission-history table td[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history table td a[data-v-f16dac38] {\n  color: #1674CD;\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .pagination-container[data-v-f16dac38] {\n  margin-top: 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .submission-history .pagination-container .total-text[data-v-f16dac38] {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history .pagination-container .page-item[data-v-f16dac38] {\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .textPass[data-v-f16dac38] {\n  color: #0FAA55;\n}\n.bulk-create-events .submission-history .textFailed[data-v-f16dac38] {\n  color: #E61C0A;\n}\n.bulk-create-events .submission-history .blink-text[data-v-f16dac38] {\n  -webkit-animation: blinker-data-v-f16dac38 1s linear infinite;\n          animation: blinker-data-v-f16dac38 1s linear infinite;\n}\n.bulk-create-events .submission-history .blink-text .spinner-border[data-v-f16dac38] {\n  margin-right: 0.5rem;\n}\n@-webkit-keyframes blinker-data-v-f16dac38 {\n50% {\n    opacity: 0;\n}\n}\n@keyframes blinker-data-v-f16dac38 {\n50% {\n    opacity: 0;\n}\n}\n.draft-events-modal[data-v-f16dac38] {\n  padding: 2rem;\n}\n.draft-events-modal .add-on-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .add-on-wrapper p[data-v-f16dac38] {\n  margin: 0;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 0.85em;\n}\n.draft-events-modal .add-on-wrapper .event-add-on[data-v-f16dac38] {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input[type=checkbox][data-v-f16dac38] {\n  width: 0;\n  visibility: hidden;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label[data-v-f16dac38] {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 1px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label[data-v-f16dac38]:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label[data-v-f16dac38] {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label[data-v-f16dac38]:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.draft-events-modal .add-on-wrapper .event-add-on label[data-v-f16dac38]:active:after {\n  width: 15px;\n}\n.draft-events-modal .header-modal[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .header-modal .container-title[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 20%;\n}\n.draft-events-modal .header-modal .container-title .draft-event[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-weight: 600;\n  font-size: 1.7em;\n  white-space: nowrap;\n  margin: 0;\n}\n.draft-events-modal .header-modal .modal-close[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.draft-events-modal .header-modal .modal-close[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.draft-events-modal .header-modal .modal-close .icon-close[data-v-f16dac38] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.draft-events-modal .text-title[data-v-f16dac38] {\n  font-size: 1.2em;\n  font-weight: 600;\n  margin: 1.5rem 0 0 0;\n}\n.draft-events-modal .field-input[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.draft-events-modal .field-input label[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 0.9em;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 16px;\n}\n.draft-events-modal .field-input input[data-v-f16dac38] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2rem;\n  padding: 0.4rem 0.6rem;\n  width: 100%;\n}\n.draft-events-modal .field-input .require-askterisk[data-v-f16dac38] {\n  color: #ff0000;\n  position: absolute;\n  font-size: 1.5em;\n}\n.draft-events-modal .field-input select[data-v-f16dac38] {\n  width: 30%;\n  border-radius: 5px;\n}\n.draft-events-modal .field-input .text-error[data-v-f16dac38] {\n  color: #ff0000;\n  font-size: 0.9em;\n  margin-top: .3rem;\n}\n.draft-events-modal .field-input .border-error[data-v-f16dac38] {\n  border-color: #ff0000;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags[data-v-f16dac38] {\n  height: 2rem;\n  min-height: auto;\n  border: 1px solid #b9b9b9;\n  padding: 0.4rem 0.5rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags input[data-v-f16dac38] {\n  width: 80% !important;\n  margin: 0;\n  border: 0;\n  padding: 0 !important;\n  font-size: 13px;\n  height: 0rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__placeholder[data-v-f16dac38] {\n  margin: 0;\n}\n.draft-events-modal .field-input .field-contact .multiselect__select[data-v-f16dac38]::before {\n  content: none;\n}\n.draft-events-modal .field-input .field-contact .contact-name[data-v-f16dac38],\n.draft-events-modal .field-input .field-contact p[data-v-f16dac38] {\n  margin-bottom: 0.2rem;\n}\n.draft-events-modal .field-input .field-contact .contact-name[data-v-f16dac38] {\n  text-transform: capitalize;\n}\n.draft-events-modal .field-input .field-contact .multiselect__content-wrapper[data-v-f16dac38] {\n  min-height: 3rem;\n}\n.draft-events-modal .field-input .log-error[data-v-f16dac38],\n.draft-events-modal .field-input .icon-alert[data-v-f16dac38],\n.draft-events-modal .field-input .text-alert[data-v-f16dac38] {\n  padding: 0;\n  margin-top: 0.3rem;\n}\n.draft-events-modal .field-input .icon-alert[data-v-f16dac38] {\n  color: #0080a5;\n}\n.draft-events-modal .field-input[data-v-f16dac38]:first-child,\n.draft-events-modal .add-on-wrapper[data-v-f16dac38]:first-child {\n  padding-left: 0;\n}\n.draft-events-modal .field-input[data-v-f16dac38]:last-child,\n.draft-events-modal .add-on-wrapper[data-v-f16dac38]:last-child {\n  padding-right: 0;\n}\n.draft-events-modal .row[data-v-f16dac38] {\n  margin: 1.3rem 0 0 0;\n}\n.draft-events-modal .btn-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 5rem;\n}\n.draft-events-modal .btn-container .btn-cancel[data-v-f16dac38] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit[data-v-f16dac38],\n.draft-events-modal .btn-container .btn-right-container .btn-save[data-v-f16dac38] {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit[data-v-f16dac38] {\n  margin-right: 1rem;\n}\n.draft-events-modal .btn-container .btn-right-container .spinner-border[data-v-f16dac38] {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.draft-events-modal .text-toggle-on[data-v-f16dac38] {\n  color: #1674CD;\n}\n.draft-events-modal .greyOut[data-v-f16dac38] {\n  color: #AAA7A4;\n}\n.modal-submit-drafts .main-content[data-v-f16dac38] {\n  padding: 2rem;\n}\n.modal-submit-drafts .main-content .text-question[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5em;\n  line-height: 32px;\n}\n.modal-submit-drafts .main-content .text-description[data-v-f16dac38] {\n  font-weight: normal;\n  font-size: 1em;\n  color: #1D1D1D;\n}\n.modal-submit-drafts .main-content .btn-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel[data-v-f16dac38],\n.modal-submit-drafts .main-content .btn-container .btn-submit[data-v-f16dac38] {\n  padding: .2rem 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1em;\n  line-height: 24px;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel[data-v-f16dac38] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  margin-right: 2rem;\n  color: #1674CD;\n}\n.modal-submit-drafts .main-content .btn-container .btn-submit[data-v-f16dac38] {\n  color: #FFFFFF;\n  background: #1674CD;\n  border-radius: 4px;\n  border: 0;\n}\n.modal-submit-drafts .main-content .btn-container .spinner-border[data-v-f16dac38] {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.table-events-plan[data-v-f16dac38] {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.email-histories-page[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n}\n.email-histories-page .hisories-page-header[data-v-f16dac38] {\n  background-color: #FFF;\n  padding-top: 16px;\n  border-bottom: 1px solid #E6E6E6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper[data-v-f16dac38] {\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name .text[data-v-f16dac38] {\n  color: #E6E6E6;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  padding-bottom: 10px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name.active .text[data-v-f16dac38] {\n  color: #00A4D6;\n  border-bottom: 3px solid #00A4D6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name + .tab-name[data-v-f16dac38] {\n  margin-left: 50px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper[data-v-f16dac38] {\n  padding-bottom: 16px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back[data-v-f16dac38] {\n  height: 24px;\n  width: 24px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body[data-v-f16dac38] {\n  height: calc(100vh - 146px);\n}\n.email-histories-page .histories-page-body .ems-table[data-v-f16dac38] {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container[data-v-f16dac38] {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section[data-v-f16dac38] {\n  margin-top: 24px;\n  width: 50%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section .input[data-v-f16dac38] {\n  color: #000;\n  padding: 12px 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-participant-container[data-v-f16dac38] {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header[data-v-f16dac38] {\n  margin-top: 24px;\n  padding: 12px 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header .ems-header-column:first-child .content[data-v-f16dac38] {\n  padding-left: 25px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body[data-v-f16dac38] {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row[data-v-f16dac38] {\n  height: 58px;\n  padding: 12px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .action-text[data-v-f16dac38] {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value[data-v-f16dac38] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 0;\n  padding-left: 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value[data-v-f16dac38]:first-child {\n  padding-left: 40px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value.resend-btn-wrapper[data-v-f16dac38] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-right: 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value .resend-btn[data-v-f16dac38] {\n  padding: 6px 24px;\n}\n.email-histories-page .histories-page-body .histories-table-container[data-v-f16dac38] {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body[data-v-f16dac38] {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row[data-v-f16dac38] {\n  height: 56px;\n  padding: 20px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row .action-text[data-v-f16dac38] {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-history-details-container[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.email-history-details-container .btn-back-wrapper[data-v-f16dac38] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back[data-v-f16dac38] {\n  height: 24px;\n  width: 24px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-history-details-body[data-v-f16dac38] {\n  padding-bottom: 112px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type[data-v-f16dac38] {\n  margin-top: 16px;\n  color: #606060;\n  font-size: 16px;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn[data-v-f16dac38] {\n  margin-bottom: 16px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn .event-count[data-v-f16dac38] {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events[data-v-f16dac38] {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item[data-v-f16dac38] {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item .event-name[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient[data-v-f16dac38] {\n  margin-top: 16px;\n  border-radius: 4px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper[data-v-f16dac38] {\n  position: relative;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38] {\n  border: none;\n  border-bottom: 1px solid #b9b9b9;\n  background-color: #FFF;\n  border-radius: 4px 4px 0 0;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-webkit-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-webkit-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-moz-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-moz-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]:-ms-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]:-ms-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input[data-v-f16dac38]::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38] {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38]:hover,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38]:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to[data-v-f16dac38] {\n  overflow: auto;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item[data-v-f16dac38] {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon[data-v-f16dac38] {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item[data-v-f16dac38] {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .history-left[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date[data-v-f16dac38] {\n  min-width: 110px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38],\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38] {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38]:hover,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38]:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-wrapper[data-v-f16dac38] {\n  margin-top: 30px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .template-value[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn[data-v-f16dac38] {\n  margin-right: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text[data-v-f16dac38] {\n  font-weight: normal;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_top[data-v-f16dac38] {\n  display: none !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents[data-v-f16dac38] {\n  padding: 2px !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents iframe[data-v-f16dac38] {\n  margin: 0 !important;\n  padding: -20px !important;\n}\n.email-history-details-container .email-template-wrapper .email-body-section[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content[data-v-f16dac38] {\n  height: 416px;\n  padding: 16px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  overflow: auto;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_top[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_bottom[data-v-f16dac38] {\n  display: none;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke[data-v-f16dac38] {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner[data-v-f16dac38] {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top[data-v-f16dac38] {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom[data-v-f16dac38],\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom[data-v-f16dac38] {\n  border-radius: 0 0 4px 4px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to[data-v-f16dac38] {\n  height: 160px;\n  padding: 8px 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all[data-v-f16dac38] {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient[data-v-f16dac38] {\n  margin-top: 8px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title[data-v-f16dac38] {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date[data-v-f16dac38] {\n  min-width: 110px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template[data-v-f16dac38] {\n  min-width: 150px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text[data-v-f16dac38] {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon[data-v-f16dac38] {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .group-btn[data-v-f16dac38] {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.email-history-details-container .group-btn .ap-btn[data-v-f16dac38] {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.email-history-details-container .group-btn .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.modal-body[data-v-f16dac38] {\n  padding: 24px;\n}\n.modal-body .description[data-v-f16dac38] {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container[data-v-f16dac38] {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn[data-v-f16dac38] {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.mfa-container .mfa-box[data-v-f16dac38] {\n  padding: 32px;\n}\n.mfa-container .mfa-box-title[data-v-f16dac38] {\n  margin-bottom: 16px;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 40px;\n  color: #424242;\n  text-transform: uppercase;\n}\n.mfa-container .mfa-box-title.has-btn[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.mfa-container .mfa-paragraph[data-v-f16dac38] {\n  margin-bottom: 16px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1d1d1d;\n}\n.mfa-container .btn-group-author[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 32px;\n}\n.mfa-container .btn-group-author .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.mfa-container .btn-group-author .btn + .btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.mfa-container .ad-support-link[data-v-f16dac38] {\n  margin-top: 32px;\n  text-align: center;\n  font-size: 16px;\n  color: #1d1d1d;\n}\n.mfa-container .ad-support-link .awp-link[data-v-f16dac38] {\n  color: #00A4D6;\n}\n.mfa-container .field-input-wrapper .input-wrapper .icon-wrapper[data-v-f16dac38] {\n  top: 50%;\n  margin-top: -12px;\n}\n.authorization-container[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.authorization-container .form-content[data-v-f16dac38] {\n  padding-bottom: 35px;\n}\n.authorization-container .form-content .nav-tab[data-v-f16dac38] {\n  margin: 30px 0 25px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view[data-v-f16dac38] {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  margin-right: 24px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.authorization-container .form-content .nav-tab .btn-router-view.selected[data-v-f16dac38] {\n  color: #00A4D6;\n}\n.authorization-container .form-content .authorization-from[data-v-f16dac38] {\n  padding: 32px;\n}\n.authorization-container .text-enter-code-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 16px;\n}\n.authorization-container .text-enter-code-container .enter[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n.authorization-container .text-enter-code-container .code[data-v-f16dac38] {\n  color: #D92C27;\n}\n.authorization-container .mfa-description[data-v-f16dac38] {\n  text-align: center;\n  margin-top: 24px;\n  color: #1D1D1D;\n}\n.authorization-container .mfa-description .text-code-expire[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.authorization-container .mfa-input-code[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 88px;\n}\n.authorization-container .mfa-input-code .mfa-input[data-v-f16dac38] {\n  text-align: center;\n  border: none;\n  background-color: #f5f5f5;\n}\n.authorization-container .mfa-input-code .btn-continue-wrapper[data-v-f16dac38] {\n  margin-top: 64px;\n}\n.authorization-container .mfa-input-code .text-send-new-code[data-v-f16dac38] {\n  margin-top: 24px;\n  color: #00A4D6;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n}\n.authorization-container .img-content .castlight-row[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.authorization-container .img-content .castlight-row .castlight-title[data-v-f16dac38] {\n  color: #424242;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-right: 16px;\n}\n.authorization-container .img-content .castlight-row .img-castlight[data-v-f16dac38] {\n  height: 56.1px;\n  width: 166px;\n}\n.participant-header-column .content[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.participant-header-column .content[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.participant-header-column .caption-text[data-v-f16dac38] {\n  font-weight: bold;\n}\n.participant-header-column .icon-sort[data-v-f16dac38] {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.participant-header-column .non-sort[data-v-f16dac38] {\n  background: url(" + __webpack_require__(229) + ") center no-repeat;\n}\n.participant-header-column .sort-up[data-v-f16dac38] {\n  background: url(" + __webpack_require__(230) + ") center no-repeat;\n}\n.participant-header-column .sort-down[data-v-f16dac38] {\n  background: url(" + __webpack_require__(231) + ") center no-repeat;\n}\n@-webkit-keyframes spinner-data-v-f16dac38 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-f16dac38 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.spinner-container[data-v-f16dac38] {\n  position: relative;\n  margin: 0 auto;\n}\n.spinner-container .spinner-inner[data-v-f16dac38] {\n  border: 1px solid #B9B9B9;\n  border-top-color: #00A4D6;\n  -webkit-animation: spinner-data-v-f16dac38 .6s linear infinite;\n          animation: spinner-data-v-f16dac38 .6s linear infinite;\n  border-radius: 50%;\n}\n.event-completed-report-card[data-v-f16dac38] {\n  background-color: #FFF;\n  width: 270px;\n  margin-top: 24px;\n}\n.event-completed-report-card .spinner-loading[data-v-f16dac38] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.event-completed-report-card .top-card[data-v-f16dac38] {\n  padding: 16px 10px;\n}\n.event-completed-report-card .top-card .event-name[data-v-f16dac38] {\n  text-align: center;\n  font-weight: bold;\n  color: #1D1D1D;\n}\n.event-completed-report-card .top-card .expected-screened[data-v-f16dac38] {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .top-card .expected-screened .expected[data-v-f16dac38],\n.event-completed-report-card .top-card .expected-screened .screened[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .top-card .expected-screened .expected .value[data-v-f16dac38],\n.event-completed-report-card .top-card .expected-screened .screened .value[data-v-f16dac38] {\n  color: #0095D9;\n}\n.event-completed-report-card .bottom-card[data-v-f16dac38] {\n  border-top: 1px solid #E6E6E6;\n  background-color: #FCFCFC;\n  border-radius: 0 0 4px 4px;\n  padding: 8px 10px 16px;\n}\n.event-completed-report-card .bottom-card .projected-scheduled[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected[data-v-f16dac38],\n.event-completed-report-card .bottom-card .projected-scheduled .screened[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected .value[data-v-f16dac38] {\n  color: #5FA813;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .screened .value[data-v-f16dac38] {\n  color: #444444;\n}\n.event-item-footer[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  padding: 0 2rem;\n  height: 35px;\n  z-index: 0;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top: solid 1px #d4d4d4;\n}\n.event-item-icon-underline-color-grey[data-v-f16dac38] {\n  border: 2px solid #9b9b9b;\n}\n.event-item-icon-underline-color-blue[data-v-f16dac38] {\n  border: 2px solid #00A4D6;\n}\n.event-item-icon-underline-color-red[data-v-f16dac38] {\n  border: 2px solid #a42022;\n}\n.event-item-icon-underline-color-green[data-v-f16dac38] {\n  border: 2px solid #417505;\n}\n.event-item-icon-underline-color-brow[data-v-f16dac38] {\n  border: 2px solid #463e38;\n}\n.event-item-icon-underline[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 14px;\n  margin-top: 4px;\n}\n.event-item-icon-amount[data-v-f16dac38] {\n  font-family: \"Open Sans\", sans-serif;\n  text-align: center;\n  margin: 2px 0 0 5px;\n  height: 25px;\n  width: 14px;\n  color: #201D1A;\n  font-size: 12px;\n  line-height: 25px;\n}\n.event-item-icon-component[data-v-f16dac38] {\n  background-color: #ffffff;\n  float: left;\n  margin: 5px 0 0 3px;\n  width: 65px;\n  padding: 0 3px 0 3px;\n}\n.event-item-icon[data-v-f16dac38] {\n  height: 25px;\n  width: 25px;\n  color: #2d2827;\n}\n.no-margin-left-right[data-v-f16dac38] {\n  margin: 5px 0 0 0;\n}\n.icon-footer[data-v-f16dac38] {\n  width: 25px;\n  height: 25px;\n  background-color: #2d2827;\n}\n.icon-footer.icon-draft[data-v-f16dac38] {\n  -webkit-mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  background: url(" + __webpack_require__(62) + ");\n}\n.icon-footer.icon-needs-review[data-v-f16dac38] {\n  -webkit-mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  background: url(" + __webpack_require__(63) + ");\n}\n.icon-footer.icon-submitted[data-v-f16dac38] {\n  -webkit-mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  background: url(" + __webpack_require__(64) + ");\n}\n.icon-footer.icon-approved[data-v-f16dac38] {\n  -webkit-mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  background: url(" + __webpack_require__(65) + ");\n}\n.search-session[data-v-f16dac38] {\n  height: 124px;\n  padding-top: 35px;\n  padding-left: 24px;\n}\n.search-session .placeholder-italic[data-v-f16dac38] {\n  margin-top: 10px;\n  border: 1px solid #9b9b9b;\n  padding: 3px 15px;\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  border-radius: 3px;\n  background-color: #FFF;\n  z-index: 1;\n}\n.search-session .search-icon[data-v-f16dac38] {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 998;\n  color: #00A4D6;\n  width: 25px;\n  height: 25px;\n}\n.search-session .search-icon[data-v-f16dac38]:hover {\n  cursor: pointer;\n  color: #00A4D6;\n}\n.search-session .btn-create-client[data-v-f16dac38] {\n  position: relative;\n  width: 150px;\n}\n.search-session .btn-create-client .icon-add-client[data-v-f16dac38] {\n  z-index: 999;\n  color: #FFF;\n  background-color: #0080a5;\n  width: 27px;\n  height: 27px;\n  border-radius: 15px;\n  margin-top: 17px;\n  display: inline-block;\n}\n.search-session .btn-create-client .btn-text[data-v-f16dac38] {\n  display: inline-block;\n  position: absolute;\n  top: 18px;\n  left: 35px;\n  cursor: pointer;\n}\n.search-icon[data-v-f16dac38] {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.event-items-management[data-v-f16dac38] {\n  padding: 24px 12px;\n}\n.event-items-management .section-name[data-v-f16dac38] {\n  height: 16px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 0 12px 0;\n}\n.event-items-management .client-card-list-wrapper[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.event-items-management .client-card-list-wrapper .event-item[data-v-f16dac38] {\n  margin: 12px;\n}\n.event-item[data-v-f16dac38] {\n  height: 180px;\n  width: 290px;\n  border-radius: 4px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  top: 0;\n  -webkit-transition: top .25s;\n  transition: top .25s;\n  -webkit-transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n          transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n}\n.event-item[data-v-f16dac38]:hover {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  top: -10px;\n}\n.event-item:hover .delete-client-button[data-v-f16dac38] {\n  display: block;\n}\n.event-item.noTransition[data-v-f16dac38]:hover {\n  -webkit-transition: none;\n  transition: none;\n}\n.event-item .delete-client-button[data-v-f16dac38] {\n  /*display: none;*/\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  height: 24px;\n  width: 24px;\n  z-index: 1;\n}\n.event-item .delete-client-button[data-v-f16dac38]:hover {\n  background-color: #f5f5f5;\n}\n.event-item .delete-client-button .icon-delete[data-v-f16dac38] {\n  height: 24px;\n  width: 24px;\n  background: url(" + __webpack_require__(232) + ");\n}\n.event-item .event-item-custom-message[data-v-f16dac38] {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  color: #3caae9;\n  z-index: 999;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon[data-v-f16dac38] {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon.icon-gear[data-v-f16dac38] {\n  -webkit-mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  background: url(" + __webpack_require__(233) + ");\n}\n.event-item .event-item-header[data-v-f16dac38] {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  position: absolute;\n  height: 145px;\n  overflow: visible;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  padding: 0 24px;\n}\n.event-item .event-item-header .wrapper-event-item-name[data-v-f16dac38] {\n  height: 45px;\n}\n.event-item .event-item-header .wrapper-event-item-name .event-item-name[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n  max-width: 216px;\n  width: 291px;\n  color: #20AAE9;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto 10px;\n  max-height: 100%;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.event-item .event-item-header .event-item-role[data-v-f16dac38] {\n  margin: 4px;\n}\n.event-item .event-item-header .event-item-role .event-manager .event-item-role-text-em[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 18px;\n  color: #424242;\n  text-align: center;\n  width: 100%;\n  border: none;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown[data-v-f16dac38] {\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .btn-group.btn[data-v-f16dac38]:first-child {\n  font-weight: 600;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary[data-v-f16dac38] {\n  height: 24px;\n  padding: 4px 10px;\n  font-weight: 400;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content[data-v-f16dac38] {\n  font-weight: unset;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text[data-v-f16dac38] {\n  font-size: 14px;\n  line-height: 16px;\n}\n.event-item .event-item-header .event-item-role .multiselect[data-v-f16dac38] {\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am[data-v-f16dac38] {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n  margin: 10px auto 0;\n  text-align: center;\n  width: 100%;\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am.multiselect[data-v-f16dac38] {\n  min-height: 0;\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags[data-v-f16dac38] {\n  border: none;\n  padding: 0;\n  min-height: unset;\n  height: unset;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags .multiselect__single[data-v-f16dac38] {\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__select[data-v-f16dac38] {\n  display: none;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am[data-v-f16dac38] {\n  position: relative;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input[data-v-f16dac38] {\n  border-radius: 3px;\n  color: #9b9b9b;\n  text-align: center;\n  border: none;\n  font-size: 14px;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__content-wrapper[data-v-f16dac38] {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.event-item-name[data-v-f16dac38] {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto;\n}\n.event-item-role-icon[data-v-f16dac38] {\n  height: 12px;\n  width: 11px;\n  color: #0080a5;\n  position: absolute;\n  width: auto;\n  float: right;\n}\n.manageWrapper .search-container[data-v-f16dac38] {\n  padding: 1.5rem;\n  background: #FFFFFF;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .search-container .manage-header p[data-v-f16dac38] {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .title[data-v-f16dac38] {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .item[data-v-f16dac38] {\n  width: 23rem;\n}\n.manageWrapper .search-container .manage-header button[data-v-f16dac38] {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1.1em;\n  padding: 8px 24px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .multiselect[data-v-f16dac38],\n.manageWrapper .search-container .manage-header .multiselect__input[data-v-f16dac38],\n.manageWrapper .search-container .manage-header .multiselect__single[data-v-f16dac38] {\n  font-size: 14px;\n}\n.manageWrapper .search-container .text-manage-events[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 1.1em;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter[data-v-f16dac38] {\n  margin-top: 2rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .search-container .container-filter .filter-date-range[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 23rem;\n  margin-right: 1.5rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.3rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-date-range[data-v-f16dac38],\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear[data-v-f16dac38] {\n  font-size: 12px;\n  margin: 0;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear[data-v-f16dac38] {\n  color: #1674CD;\n  opacity: 0.6;\n  cursor: pointer;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter p[data-v-f16dac38] {\n  margin: 0;\n  padding: 0 0.5rem;\n  font-size: 12px;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter input[data-v-f16dac38] {\n  border-radius: 3px;\n  border: 1px solid #9b9b9b;\n  height: 2.2rem;\n  padding: 0.7rem;\n}\n.manageWrapper .search-container .container-filter .search-events p[data-v-f16dac38] {\n  margin-bottom: .3rem;\n  font-size: 12px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group[data-v-f16dac38] {\n  border-radius: 4px;\n  border: 1px solid #9b9b9b;\n  width: 20rem;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group input[data-v-f16dac38] {\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  height: 100%;\n  border-radius: 3px;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button[data-v-f16dac38] {\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button .search-icon[data-v-f16dac38] {\n  color: #000;\n}\n.manageWrapper .search-container .container-filter .total-count[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n      -ms-flex-flow: column-reverse;\n          flex-flow: column-reverse;\n  margin-left: auto;\n  font-size: 14px;\n  font-weight: 600;\n}\n.manageWrapper .list-events[data-v-f16dac38] {\n  padding: 1.5rem;\n}\n.manageWrapper .list-events .list-container[data-v-f16dac38] {\n  margin: 2rem 0;\n}\n.manageWrapper .list-events .list-group-container[data-v-f16dac38] {\n  margin: 3rem 0;\n}\n.manageWrapper .list-events .list-header[data-v-f16dac38],\n.manageWrapper .list-events .list-content[data-v-f16dac38],\n.manageWrapper .list-events .list-ca[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-header .column[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column[data-v-f16dac38] {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-header .column .container-column[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manageWrapper .list-events .list-header .column .container-column .live-click[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column .live-click[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column .live-click[data-v-f16dac38] {\n  cursor: pointer;\n}\n.manageWrapper .list-events .list-header .column .container-column p[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column p[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column p[data-v-f16dac38] {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manageWrapper .list-events .list-header .column .container-column button[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column button[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column button[data-v-f16dac38] {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .list-events .list-header .column .container-column button img[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column button img[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column button img[data-v-f16dac38] {\n  height: 0.6rem;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-header[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column .text-header[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column .text-header[data-v-f16dac38] {\n  font-weight: 600;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-icon[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column .text-icon[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column .text-icon[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-not-live[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .container-column .text-not-live[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column .text-not-live[data-v-f16dac38] {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manageWrapper .list-events .list-header .column .border-seperate[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column .border-seperate[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .border-seperate[data-v-f16dac38] {\n  border-right: 1px solid #B9B9B9;\n}\n.manageWrapper .list-events .list-header .column.event-date[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column.event-date[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column.event-date[data-v-f16dac38] {\n  width: 14.28%;\n}\n.manageWrapper .list-events .list-header .column.w-2[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column.w-2[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column.w-2[data-v-f16dac38] {\n  width: 2%;\n}\n.manageWrapper .list-events .list-header .column.w-12[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column.w-12[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column.w-12[data-v-f16dac38] {\n  width: 12%;\n}\n.manageWrapper .list-events .list-header .column.w-14[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column.w-14[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column.w-14[data-v-f16dac38] {\n  width: 14%;\n}\n.manageWrapper .list-events .list-header .column.w-16[data-v-f16dac38],\n.manageWrapper .list-events .list-content .column.w-16[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column.w-16[data-v-f16dac38] {\n  width: 16%;\n}\n.manageWrapper .list-events .list-header.green-line[data-v-f16dac38],\n.manageWrapper .list-events .list-content.green-line[data-v-f16dac38],\n.manageWrapper .list-events .list-ca.green-line[data-v-f16dac38] {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-header.green-line[data-v-f16dac38],\n.manageWrapper .list-events .list-content.green-line[data-v-f16dac38],\n.manageWrapper .list-events .list-ca.green-line[data-v-f16dac38] {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-content[data-v-f16dac38],\n.manageWrapper .list-events .list-ca[data-v-f16dac38] {\n  background: #fff;\n}\n.manageWrapper .list-events .list-content .column[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-content .column .container-column[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column[data-v-f16dac38] {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manageWrapper .list-events .list-content .column .container-column img[data-v-f16dac38],\n.manageWrapper .list-events .list-ca .column .container-column img[data-v-f16dac38] {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .list-content .column[data-v-f16dac38]:last-child,\n.manageWrapper .list-events .list-ca .column[data-v-f16dac38]:last-child {\n  padding: 1rem 1rem 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-content[data-v-f16dac38] {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manageWrapper .list-events .list-ca[data-v-f16dac38] {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manageWrapper .list-events .container-ca[data-v-f16dac38] {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .list-events .container-ca .list-group-row[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.manageWrapper .list-events .container-ca .list-group-row.green-line[data-v-f16dac38] {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .container-text[data-v-f16dac38] {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manageWrapper .list-events .container-text b[data-v-f16dac38] {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .container-text .seperate[data-v-f16dac38] {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manageWrapper .list-events .load-more[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manageWrapper .list-events .load-more span[data-v-f16dac38] {\n  position: absolute;\n}\n.manageWrapper .list-events .load-more button[data-v-f16dac38] {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.manageWrapper .footer[data-v-f16dac38] {\n  background: white;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  bottom: 0;\n  left: 96px;\n  right: 0;\n  padding: 0.8rem 1.5rem;\n}\n.manageWrapper .footer .ap-btn[data-v-f16dac38] {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.custom-modal .modal-title[data-v-f16dac38] {\n  height: 32px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.custom-modal .configure-scheduler[data-v-f16dac38] {\n  border-radius: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 6px 24px;\n  margin-left: 16px;\n}\n.custom-modal .label[data-v-f16dac38] {\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.custom-modal .modal-header[data-v-f16dac38] {\n  padding-left: 0;\n  width: 100%;\n  margin: 0  !important;\n  border-bottom: none !important;\n}\n.custom-modal .modal-header .modal-header-text[data-v-f16dac38] {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 27px;\n}\n.custom-modal .modal-header .modal-header-text-edit[data-v-f16dac38] {\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .input-client-name[data-v-f16dac38] {\n  border: none;\n  height: 20px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  margin-top: 8px;\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .save-client-name-btn.btn[data-v-f16dac38] {\n  float: right;\n  margin-left: 15px;\n  background-color: #0080A5;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-modal .modal-close-img[data-v-f16dac38] {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.custom-modal .modal-box .main-content[data-v-f16dac38] {\n  padding: 60px 60px 20px 40px;\n}\n.custom-modal .modal-box .overlay[data-v-f16dac38] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.custom-modal .modal-box .isLoading[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n}\n.custom-modal .modal-box .noDisplay[data-v-f16dac38] {\n  display: none!important;\n}\n.custom-modal .modal-body[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n  margin-top: 60px;\n}\n.custom-modal .modal-body.main-content[data-v-f16dac38] {\n  margin: 0;\n  width: 100%;\n  padding: 5rem 0 0 0;\n}\n.custom-modal .add-on[data-v-f16dac38] {\n  margin-top: 112px;\n}\n.custom-modal .add-on .title[data-v-f16dac38] {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .add-on .description[data-v-f16dac38] {\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .add-on .add-on-item[data-v-f16dac38] {\n  width: 250px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 12px;\n}\n.custom-modal .add-on .add-on-item .text[data-v-f16dac38] {\n  position: absolute;\n  left: 40px;\n  white-space: nowrap;\n}\n.custom-modal .add-on .add-on-item label[data-v-f16dac38] {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .add-on .add-on-item input[type=checkbox][data-v-f16dac38] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .add-on .add-on-item label[data-v-f16dac38]:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .add-on .add-on-item input:checked + label[data-v-f16dac38] {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .add-on .add-on-item input:disabled + label[data-v-f16dac38] {\n  background: #babfc0;\n  border: 1.5px solid #fff;\n}\n.custom-modal .add-on .add-on-item input:checked + label[data-v-f16dac38]:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .add-on .add-on-item label[data-v-f16dac38]:active:after {\n  width: 15px;\n}\n.custom-modal .secondary-am[data-v-f16dac38] {\n  margin-top: 74px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .secondary-am .title[data-v-f16dac38] {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .secondary-am .description[data-v-f16dac38] {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .secondary-am .pick[data-v-f16dac38] {\n  margin-top: 4px;\n  font-size: 14px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags[data-v-f16dac38] {\n  border: 1px solid #9B9B9B;\n  height: auto  !important;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag[data-v-f16dac38] {\n  background: #41b883;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 0 0.5rem 0 0;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon[data-v-f16dac38] {\n  margin-top: 3px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon[data-v-f16dac38]:hover {\n  background: #0092B4;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon[data-v-f16dac38]:after {\n  color: #fff;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper[data-v-f16dac38] {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content[data-v-f16dac38] {\n  margin: 7px auto;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element[data-v-f16dac38] {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option[data-v-f16dac38] {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight[data-v-f16dac38] {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content li.multiselect__element[data-v-f16dac38]:last-child {\n  border-bottom: none;\n}\n.custom-modal .reseller-status[data-v-f16dac38] {\n  margin-top: 72px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .reseller-status .title[data-v-f16dac38] {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .reseller-status .description[data-v-f16dac38] {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .reseller-status .reseller-toggle[data-v-f16dac38] {\n  margin-top: 15px;\n}\n.custom-modal .reseller-status .reseller-toggle input[type=checkbox][data-v-f16dac38] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .reseller-status .reseller-toggle label[data-v-f16dac38] {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .reseller-status .reseller-toggle label[data-v-f16dac38]:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label[data-v-f16dac38] {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label[data-v-f16dac38]:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .reseller-status .reseller-toggle label[data-v-f16dac38]:active:after {\n  width: 15px;\n}\n.custom-modal .reseller-status .read-only[data-v-f16dac38] {\n  margin-top: 15px;\n}\n.custom-modal .last-child-pick[data-v-f16dac38] {\n  position: relative;\n  margin-top: 15px;\n  height: 250px;\n}\n.button-view[data-v-f16dac38] {\n  position: relative;\n}\n.button-view .btn-expand[data-v-f16dac38] {\n  background: url(" + __webpack_require__(234) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-duplicate[data-v-f16dac38] {\n  background: url(" + __webpack_require__(235) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-delete[data-v-f16dac38] {\n  background: url(" + __webpack_require__(236) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status[data-v-f16dac38] {\n  background: url(" + __webpack_require__(237) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status[data-v-f16dac38]:disabled {\n  background: url(" + __webpack_require__(238) + ") no-repeat !important;\n}\n.button-view .btn-status-dropdown .dropdown-toggle[data-v-f16dac38]::after {\n  display: none;\n}\n.button-view .btn-status-dropdown .dropdown-menu[data-v-f16dac38] {\n  border-radius: 10px;\n  padding: 10px 0;\n  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  background: #FCFCFC;\n}\n.button-view .btn-status-dropdown button[data-v-f16dac38] {\n  width: 100%;\n  height: 100%;\n}\n.button-view .btn-status-dropdown ul[data-v-f16dac38] {\n  border-radius: 10px;\n}\n.button-view .btn-status-dropdown ul li a[data-v-f16dac38] {\n  padding: 10px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.button-view .wrapper-list[data-v-f16dac38] {\n  position: absolute;\n  left: -450%;\n  top: 16px;\n  z-index: 999;\n  cursor: pointer;\n}\n.button-view .wrapper-list .icon-information-black[data-v-f16dac38] {\n  width: 27px;\n  height: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .icon-information-black[data-v-f16dac38] {\n    background: url(" + __webpack_require__(38) + ");\n}\n}\n.button-view .wrapper-list .status-icon-black[data-v-f16dac38] {\n  height: 27px;\n  width: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(31) + ") no-repeat center;\n  mask: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.button-view .wrapper-list .status-icon-black[data-v-f16dac38] {\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .status-icon-black[data-v-f16dac38] {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n.dashboard-manager .isLoading[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n  padding: 12rem 0;\n}\n.dashboard-manager .pagination-container[data-v-f16dac38] {\n  margin-top: 1.5rem;\n  padding: 24px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.dashboard-manager .pagination-container .total-text[data-v-f16dac38] {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.dashboard-manager .pagination-container .page-item[data-v-f16dac38] {\n  cursor: pointer;\n}\n.global-setting-page-container[data-v-f16dac38] {\n  padding: 24px;\n  background-color: #FFF;\n}\n.global-setting-page-container .staff-management-container[data-v-f16dac38] {\n  padding: 24px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header[data-v-f16dac38] {\n  margin-top: 16px;\n  padding: 12px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header .col-mileage-rate[data-v-f16dac38] {\n  padding-left: 40px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row[data-v-f16dac38] {\n  padding: 12px 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .field-value[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn[data-v-f16dac38] {\n  padding: 4px;\n  background-color: #1674CD;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 8px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn .icon[data-v-f16dac38] {\n  height: 24px;\n  width: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .edit-btn .icon[data-v-f16dac38] {\n  background: url(" + __webpack_require__(153) + ") no-repeat center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .delete-btn .icon[data-v-f16dac38] {\n  background: url(" + __webpack_require__(154) + ") no-repeat center;\n}\nbody[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n}\n.body[data-v-f16dac38] {\n  width: 90%;\n  margin: 10px auto;\n  height: auto;\n  text-align: center;\n  background-color: #FFF;\n  font-family: 'Open Sans', sans-serif;\n  min-width: 1024px;\n}\n.main .container-fluid[data-v-f16dac38] {\n  padding: 0;\n}\na[data-v-f16dac38]:hover {\n  text-decoration: none !important;\n}\n.v--modal[data-v-f16dac38] {\n  -webkit-box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n          box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n}\n/**\n * CUSTOM STYLES\n */\n.has-error[data-v-f16dac38] {\n  border: solid 1px red !important;\n}\n.line-copy-2[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 63px;\n  width: 2px;\n  border-left: 10px solid #0080a5;\n}\n.content-header[data-v-f16dac38] {\n  height: 29px;\n  width: 137px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  position: absolute;\n  margin: 25px 0 0 15px;\n}\n.content-body[data-v-f16dac38] {\n  height: 19px;\n  color: #231F20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  position: absolute;\n  margin: 65px 0 0 15px;\n}\n.subHeader[data-v-f16dac38] {\n  height: 100px;\n  width: 100%;\n  background-color: #FFF;\n}\n.header[data-v-f16dac38] {\n  height: 70px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.header-card[data-v-f16dac38] {\n  height: 46px;\n  width: 100%;\n  color: #FFF;\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 50px;\n}\n.content-dashboard-card[data-v-f16dac38] {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 19px;\n}\n.wellmetrics-event-ma[data-v-f16dac38] {\n  height: 29px;\n  width: 341px;\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n}\n.user-name[data-v-f16dac38] {\n  height: 24px;\n  width: 94px;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n}\n.user-type[data-v-f16dac38] {\n  height: 20px;\n  width: 78px;\n  color: #9b9b9b;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 300;\n  line-height: 20px;\n  text-align: center;\n}\n.shadow[data-v-f16dac38] {\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.overview[data-v-f16dac38] {\n  width: 100%;\n  height: 65px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 80px;\n  text-align: center;\n}\n.events[data-v-f16dac38] {\n  height: 18px;\n  width: 47px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.bottomLine[data-v-f16dac38] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 80%;\n  border: 1px solid #FFF;\n  opacity: 0.5;\n  margin-top: 7px;\n  float: right;\n  margin-bottom: -5px;\n}\n.newEventForm[data-v-f16dac38] {\n  padding: 20px;\n  margin: 20px;\n}\n.nopadding[data-v-f16dac38] {\n  padding: 0 !important;\n}\n.noMargin[data-v-f16dac38] {\n  margin-left: 0;\n  margin-right: 0;\n}\n.paddingTop27px[data-v-f16dac38] {\n  padding-top: 27px;\n}\n.padding-left-20px[data-v-f16dac38] {\n  padding-left: 20px;\n}\n.noPaddingLeft[data-v-f16dac38] {\n  padding-left: 0;\n}\n.noPaddingRight[data-v-f16dac38] {\n  padding-right: 0;\n}\n.margin-bottom-8px[data-v-f16dac38] {\n  margin-bottom: 8px;\n}\n.margin-top-15px[data-v-f16dac38] {\n  margin-top: 15px;\n}\n.margin-top-16px[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.margin-top-25px[data-v-f16dac38] {\n  margin-top: 25px;\n}\n.margin-bottom-5px[data-v-f16dac38] {\n  margin-bottom: 5px;\n}\n.margin-top-20px[data-v-f16dac38] {\n  margin-top: 20px;\n}\n.margin-top-44px[data-v-f16dac38] {\n  margin-top: 44px;\n}\n.margin-top-40px[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.margin-top-10px[data-v-f16dac38] {\n  margin-top: 10px;\n}\n.margin-top-5px[data-v-f16dac38] {\n  margin-top: 5px;\n}\n.margin-bottom-10px[data-v-f16dac38] {\n  margin-bottom: 10px;\n}\n.padding-left-40px[data-v-f16dac38] {\n  padding-left: 40px !important;\n}\n.padding-left-27px[data-v-f16dac38] {\n  padding-left: 27px !important;\n}\n.padding-left-3px[data-v-f16dac38] {\n  padding-left: 3px;\n}\n.padding-left-19px[data-v-f16dac38] {\n  padding-left: 19px;\n}\n.clear-both[data-v-f16dac38] {\n  clear: both;\n}\n.h2-title[data-v-f16dac38] {\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.h4-title[data-v-f16dac38] {\n  color: #0080A5;\n  font-family: Arquitecta, sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.no-select[data-v-f16dac38] {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                   supported by Chrome and Opera */\n}\n.phoneAndEmail[data-v-f16dac38] {\n  height: 34px;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  border-radius: 3px;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0 0 0 13px;\n  font-size: 14px;\n  color: #000;\n}\n.calendarCustom[data-v-f16dac38] {\n  width: 300px;\n  border: none;\n  margin-right: 13px;\n}\n.outer-container[data-v-f16dac38] {\n  position: relative;\n  float: left;\n  left: 50%;\n}\n.outer-container .inner-container[data-v-f16dac38] {\n  position: relative;\n  float: left;\n  left: -50%;\n}\n[data-v-f16dac38]::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #b9b9b9;\n}\n[data-v-f16dac38]:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #b9b9b9;\n}\n[data-v-f16dac38]::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #b9b9b9;\n}\n[data-v-f16dac38]:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #b9b9b9;\n}\n[data-v-f16dac38]:-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #b9b9b9;\n}\n[data-v-f16dac38]::placeholder {\n  /* Most modern browsers support this now. */\n  color: #b9b9b9;\n}\n.modal-body-user-info .multiselect__tags[data-v-f16dac38] {\n  border: 1px solid #9B9B9B;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag[data-v-f16dac38] {\n  background: #0092B4;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon[data-v-f16dac38] {\n  margin-top: 3px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon[data-v-f16dac38]:hover {\n  background: #0092B4;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon[data-v-f16dac38]:after {\n  color: #fff;\n}\n.modal-body-user-info .multiselect__content-wrapper[data-v-f16dac38] {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content[data-v-f16dac38] {\n  margin: 7px auto;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element[data-v-f16dac38] {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option[data-v-f16dac38] {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight[data-v-f16dac38] {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content li.multiselect__element[data-v-f16dac38]:last-child {\n  border-bottom: none;\n}\n.custom-toggle input[type=checkbox][data-v-f16dac38] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-toggle label[data-v-f16dac38] {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-toggle label[data-v-f16dac38]:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-toggle input:checked + label[data-v-f16dac38] {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-toggle input:checked + label[data-v-f16dac38]:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-toggle label[data-v-f16dac38]:active:after {\n  width: 15px;\n}\n.display-none-something[data-v-f16dac38] {\n  display: none !important;\n}\n.ems_confirm[data-v-f16dac38] {\n  padding: 24px;\n}\n.ems_confirm .swal2-header[data-v-f16dac38] {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.ems_confirm .swal2-header .ems_alert_title[data-v-f16dac38] {\n  height: 40px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.ems_confirm .swal2-content .ems_alert_des[data-v-f16dac38] {\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  font-weight: 400;\n}\n.ems_confirm .swal2-actions[data-v-f16dac38] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: unset;\n  margin-top: 45px;\n}\n.ems_confirm .swal2-actions .ems_alert_cancel[data-v-f16dac38] {\n  border: 1px solid #00A4D6 !important;\n  color: #00A4D6 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.block[data-v-f16dac38] {\n  background-color: #FF3400 !important;\n  border-left-color: #FF3400 !important;\n  border-right-color: #FF3400 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.open[data-v-f16dac38] {\n  background-color: #00A4D6 !important;\n  border-left-color: #00A4D6 !important;\n  border-right-color: #00A4D6 !important;\n}\n.default-message[data-v-f16dac38] {\n  color: #b9b9b9 !important;\n}\n.max-width-100[data-v-f16dac38] {\n  max-width: 100% !important;\n}\n.always-show[data-v-f16dac38] {\n  display: block !important;\n  opacity: 1 !important;\n}\n.selected-staffing-item[data-v-f16dac38] {\n  background-color: #e6e6e6 !important;\n}\n.un-selected-staffing-item[data-v-f16dac38] {\n  background-color: #FFFFFF !important;\n}\n.form-control[data-v-f16dac38]:disabled {\n  background-color: #FFFFFF;\n  opacity: 1;\n}\n.clear-both[data-v-f16dac38] {\n  clear: both !important;\n}\n.action-btn[data-v-f16dac38] {\n  height: 36px;\n  margin-left: 8px;\n}\n.action-btn[data-v-f16dac38]:hover {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue[data-v-f16dac38] {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue .btn-text[data-v-f16dac38] {\n  color: #FFF;\n}\n.action-btn.btn-white[data-v-f16dac38] {\n  background-color: #f5f5f5;\n  color: #00A4D6;\n  border: solid 1px #00A4D6;\n}\n.action-btn.btn-white .btn-text[data-v-f16dac38] {\n  color: #00A4D6;\n}\n.action-btn .btn-text[data-v-f16dac38] {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.no-border[data-v-f16dac38] {\n  border: none !important;\n}\n.opacity-04[data-v-f16dac38] {\n  opacity: 0.4;\n}\n.opacity-06[data-v-f16dac38] {\n  opacity: 0.6;\n}\n.field-input-wrapper[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.field-input-wrapper .attr-name[data-v-f16dac38] {\n  color: #424242;\n  font-size: 16px;\n}\n.field-input-wrapper .message[data-v-f16dac38] {\n  margin-top: 5px;\n  font-size: 16px;\n}\n.field-input-wrapper .message.error[data-v-f16dac38] {\n  color: #E83001;\n}\n.field-input-wrapper .message.success[data-v-f16dac38] {\n  color: #5FA813;\n}\n.field-input-wrapper .input-wrapper[data-v-f16dac38] {\n  position: relative;\n}\n.field-input-wrapper .input-wrapper .input[data-v-f16dac38] {\n  height: 48px;\n  margin-top: 5px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  line-height: 24px;\n  width: 100%;\n  padding-left: 10px;\n  font-size: 16px;\n}\n.field-input-wrapper .input-wrapper .input.error[data-v-f16dac38] {\n  border: 1px solid #FF3400;\n}\n.field-input-wrapper .input-wrapper .input.success[data-v-f16dac38] {\n  border: 1px solid #5FA813;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper[data-v-f16dac38] {\n  position: absolute;\n  top: 16px;\n  right: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search[data-v-f16dac38] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background-color: #3caae9;\n  background: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey[data-v-f16dac38] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(239) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .help[data-v-f16dac38] {\n  display: inline-block;\n  margin-top: 5px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.field-input-wrapper .help.is-danger[data-v-f16dac38] {\n  color: #E83001;\n}\n.margin-side[data-v-f16dac38] {\n  padding: 0 24px;\n}\n.remove-margin-side[data-v-f16dac38] {\n  margin: 0 -24px;\n}\n.common-margin-left[data-v-f16dac38] {\n  margin-left: 24px;\n}\n.v--modal-overlay[data-v-f16dac38] {\n  z-index: 1020;\n}\n.icon-back[data-v-f16dac38] {\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.icon-back[data-v-f16dac38] {\n    background: url(" + __webpack_require__(92) + ");\n}\n}\n.common-card[data-v-f16dac38] {\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.common-card .v--modal-box[data-v-f16dac38] {\n  padding: 24px;\n}\n.common-card .v--modal-box .modal-close-img[data-v-f16dac38] {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.common-card .v--modal-box .modal-close-img .icon-close[data-v-f16dac38] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.common-card .v--modal-box .modal-close-img .icon-close[data-v-f16dac38] {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.common-card .v--modal-box .modal-close-img .icon-close[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.common-card .v--modal-box .modal-body[data-v-f16dac38] {\n  margin-top: 16px;\n}\n.common-card .v--modal-box .modal-footer[data-v-f16dac38] {\n  margin-top: 40px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn[data-v-f16dac38] {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn + .ap-btn[data-v-f16dac38] {\n  margin-left: 16px;\n}\n.common-card .v--modal-box .modal-header[data-v-f16dac38],\n.common-card .v--modal-box .modal-body[data-v-f16dac38],\n.common-card .v--modal-box .modal-footer[data-v-f16dac38] {\n  padding: 0;\n  border-bottom: none;\n  border-top: none;\n}\n.push-right[data-v-f16dac38] {\n  float: right;\n}\n.remove-icon[data-v-f16dac38] {\n  margin-left: 16px;\n  margin-top: 2px;\n  width: 27px;\n  height: 27px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.remove-icon[data-v-f16dac38] {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.remove-icon[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.cke_chrome[data-v-f16dac38],\n.cke[data-v-f16dac38] {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.cke_chrome .cke_inner[data-v-f16dac38],\n.cke .cke_inner[data-v-f16dac38] {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_top[data-v-f16dac38],\n.cke .cke_inner .cke_top[data-v-f16dac38] {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_bottom[data-v-f16dac38],\n.cke .cke_inner .cke_bottom[data-v-f16dac38] {\n  border-radius: 0 0 4px 4px;\n}\n.header-left-side[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.header-left-side .header-middle[data-v-f16dac38] {\n  margin-left: 24px;\n}\n.custom-multiselect[data-v-f16dac38] {\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper[data-v-f16dac38] {\n  border: none;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  font-family: 'Open Sans', sans-serif;\n  z-index: 999;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content[data-v-f16dac38] {\n  margin-top: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element[data-v-f16dac38] {\n  padding-left: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element[data-v-f16dac38]:hover {\n  background-color: #F5F5F5;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option[data-v-f16dac38] {\n  min-height: 34px;\n  color: #231F20;\n  border-bottom: 1px solid #E6e6e6;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight[data-v-f16dac38] {\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__tags[data-v-f16dac38] {\n  border-color: #B9b9b9;\n  border-radius: 4px;\n  padding-left: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  color: #231F20;\n  height: 43px;\n}\n.custom-multiselect .multiselect .multiselect__tags[data-v-f16dac38]:hover {\n  border-color: #B7B7B7;\n  color: #231F20;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input[data-v-f16dac38] {\n  font-size: 14px;\n  margin-bottom: 0;\n  padding: 0;\n  height: 16px;\n  line-height: unset;\n  min-height: unset;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input[data-v-f16dac38]::-webkit-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input[data-v-f16dac38]::-moz-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input[data-v-f16dac38]:-ms-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input[data-v-f16dac38]::placeholder {\n  color: #606060;\n}\n.ems-row[data-v-f16dac38] {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.ems-row .field-value[data-v-f16dac38] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 0 16px;\n}\n.ems-table-header[data-v-f16dac38] {\n  width: 100%;\n  height: 48px;\n  padding: 16px 0px;\n}\n.ems-table-header .ems-header-col[data-v-f16dac38] {\n  float: left;\n  text-transform: uppercase;\n}\n.ems-table-header .ems-header-col .content[data-v-f16dac38] {\n  padding-left: 16px;\n}\n.ems-table-header .ems-header-col .sort-icon[data-v-f16dac38] {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.ems-table-header .ems-header-col .header-container[data-v-f16dac38] {\n  position: relative;\n}\n.ems-table-header .ems-header-col .crop[data-v-f16dac38] {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n  overflow: hidden;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-line[data-v-f16dac38] {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-line[data-v-f16dac38] {\n  border-color: #b9b9b9;\n}\n.ems-table-header .ems-header-col .crop .crop-top-line[data-v-f16dac38] {\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-line[data-v-f16dac38] {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-left-line[data-v-f16dac38] {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-right-line[data-v-f16dac38] {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-corner[data-v-f16dac38] {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop .crop-top-left-corner[data-v-f16dac38] {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-top-right-corner[data-v-f16dac38] {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-left-corner[data-v-f16dac38] {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-right-corner[data-v-f16dac38] {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-corner[data-v-f16dac38] {\n  opacity: 1;\n}\n.event-container .app-body .main[data-v-f16dac38] {\n  padding-bottom: 0;\n}\n.client-card-container[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.disable-button[data-v-f16dac38] {\n  pointer-events: none;\n}\n.dt-row .MicrosoftMap .as_container_search[data-v-f16dac38] {\n  left: 18%;\n  margin-top: 35px;\n}\n.dt-row .MicrosoftMap .as_container ul[data-v-f16dac38] {\n  padding: 0 0 8px 0;\n}\n.dt-row .MicrosoftMap .as_container ul li[data-v-f16dac38] {\n  border-top: 1px solid #e6e6e6;\n}\n.text-value .MicrosoftMap .as_container_search[data-v-f16dac38] {\n  left: 10px;\n  margin-top: 0;\n}\n.address-input-bing[data-v-f16dac38] {\n  height: 25px;\n  margin-top: 16px;\n  border: none;\n  outline: none;\n  padding-right: 15px;\n}\n.center-content[data-v-f16dac38] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.center-content .img-red-logo[data-v-f16dac38] {\n  height: 64px;\n  width: 64px;\n}\n.center-content .form-wrapper[data-v-f16dac38] {\n  padding: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content[data-v-f16dac38] {\n  margin-top: 16px;\n  margin-bottom: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content #desc-reset-pass[data-v-f16dac38] {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email-title[data-v-f16dac38] {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email[data-v-f16dac38] {\n  margin-top: 4px;\n}\n.center-content .form-wrapper .button-content[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.center-content .form-wrapper .button-content .btn-cancel[data-v-f16dac38] {\n  margin-right: 16px;\n}\n.password-check-list[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.password-check-list .password-at-least[data-v-f16dac38] {\n  color: #1d1d1d;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.password-check-list .indicators-password .indicator-item[data-v-f16dac38] {\n  line-height: 16px;\n  font-size: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin-top: 8px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-reach[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(240) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-unreach[data-v-f16dac38] {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(241) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .text[data-v-f16dac38] {\n  margin-left: 8px;\n  letter-spacing: 0.1px;\n  color: #1d1d1d;\n}\n/* Hide HTML5 Up and Down arrows. */\ninput[type=\"number\"][data-v-f16dac38]::-webkit-outer-spin-button,\ninput[type=\"number\"][data-v-f16dac38]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"][data-v-f16dac38] {\n  -moz-appearance: textfield;\n}\n.multiselect--active[data-v-f16dac38] {\n  z-index: 1000;\n}\n.ap-modal .modal-content[data-v-f16dac38] {\n  min-height: 100%;\n  height: auto;\n  border: 1px solid #E6E6E6;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.ap-modal .modal-backdrop.show[data-v-f16dac38] {\n  opacity: 0.3;\n}\n.ems-header-column[data-v-f16dac38] {\n  position: relative;\n}\n.ems-header-column .content[data-v-f16dac38] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.ems-header-column .content .icon-sort[data-v-f16dac38] {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.ems-header-column .non-sort[data-v-f16dac38] {\n  background: url(" + __webpack_require__(242) + ") center no-repeat;\n}\n.ems-header-column .sort-up[data-v-f16dac38] {\n  background: url(" + __webpack_require__(243) + ") center no-repeat;\n}\n.ems-header-column .sort-down[data-v-f16dac38] {\n  background: url(" + __webpack_require__(244) + ") center no-repeat;\n}\n.ems-header-column .resize-line[data-v-f16dac38] {\n  position: absolute;\n  width: 1px;\n  height: 16px;\n  right: 1px;\n  top: 0;\n  background-color: #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ems-header-column .resize-line[data-v-f16dac38]:hover {\n  cursor: col-resize;\n}\n.ems-input-wrapper .input[data-v-f16dac38] {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ems-input-wrapper .input.error[data-v-f16dac38] {\n  border: 1px solid #FF3400;\n}\n.ems-input-wrapper .input.success[data-v-f16dac38] {\n  border: 1px solid #68B814;\n}\n.ems-input-wrapper .input.warning[data-v-f16dac38] {\n  border: 1px solid #E89819;\n}\n.infinite-status-prompt[data-v-f16dac38] {\n  display: none;\n}\n.toast-container > .toast-info[data-v-f16dac38] {\n  background-color: #0080a5 !important;\n}\n.toast-container > .toast-error[data-v-f16dac38] {\n  background-color: #FF3400 !important;\n}\n.toast-container > .toast-success[data-v-f16dac38] {\n  background-color: #68B814 !important;\n}\n.toast-container > .toast-warning[data-v-f16dac38] {\n  background-color: #E89819 !important;\n}\n.margin-top-24px[data-v-f16dac38] {\n  margin-top: 24px;\n}\n.multiple-select-work-group[data-v-f16dac38] {\n  position: relative;\n  height: 30px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect[data-v-f16dac38] {\n  min-height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags[data-v-f16dac38] {\n  min-height: 30px;\n  padding: 0 40px 0 8px;\n  border: none;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input[data-v-f16dac38] {\n  color: #9b9b9b;\n  margin-bottom: 0;\n  min-height: 30px;\n  text-align: left;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input[data-v-f16dac38]:hover {\n  cursor: pointer;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__placeholder[data-v-f16dac38] {\n  margin-top: 5px;\n  margin-bottom: 0;\n  padding-top: 0;\n  color: #585858;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__single[data-v-f16dac38] {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__select[data-v-f16dac38] {\n  height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__content-wrapper[data-v-f16dac38] {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.related-events-component[data-v-f16dac38] {\n  margin-top: 10px;\n  background-color: #E6E6E6;\n}\n.related-events-component .related-events-header[data-v-f16dac38] {\n  height: 18px;\n  color: #231F20;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  line-height: 18px;\n}\n.related-events-component .related-events-header .header-number[data-v-f16dac38] {\n  margin-left: 25px;\n}\n.related-events-component .related-events-header .more-margin-left[data-v-f16dac38] {\n  margin-left: 50px;\n}\n.related-events-component .related-events-body[data-v-f16dac38] {\n  margin-top: 70px;\n}\n.related-events-component .related-events-body .other-events-header[data-v-f16dac38] {\n  height: 100px;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-left[data-v-f16dac38] {\n  float: left;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-left .other-events-title[data-v-f16dac38] {\n  height: 29px;\n  color: #231F20;\n  font-family: Arquitecta;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-left .other-event-description[data-v-f16dac38] {\n  margin-top: 16px;\n  width: 330px;\n  color: #231F20;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  line-height: 18px;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right[data-v-f16dac38] {\n  float: right;\n  height: 95px;\n  width: 652px;\n  background-color: #3D6274;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right .other-related-events-info[data-v-f16dac38] {\n  width: 366px;\n  float: left;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right .other-related-events-info .text-related-info[data-v-f16dac38] {\n  margin: 20px 0 0 20px;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right .other-related-events-selection[data-v-f16dac38] {\n  float: right;\n  width: 286px;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right .other-related-events-selection .menu-item[data-v-f16dac38] {\n  float: right;\n  width: 114px;\n  color: #FFF;\n  margin-right: 20px;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right .other-related-events-selection .menu-item a[data-v-f16dac38] {\n  display: block;\n  color: #FFF;\n}\n.related-events-component .related-events-body .other-events-header .other-events-header-right .other-related-events-selection .menu-item[data-v-f16dac38]:hover {\n  color: #FFF !important;\n  background: #20a8d8 !important;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_relatedEvents_EventStatusSelection__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableRelatedEvents__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'related-event',
  components: {
    EventStatusSelection: __WEBPACK_IMPORTED_MODULE_2__components_relatedEvents_EventStatusSelection__["a" /* default */],
    TableRelatedEvents: __WEBPACK_IMPORTED_MODULE_3__TableRelatedEvents__["a" /* default */]
  },
  props: {
    item: {
      type: Object
    }
  },
  data: function data() {
    return {
      viewMode: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].dataTableViewModes
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    listEventStatus: function listEventStatus() {
      return this.getListEventStatus;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    getListEventStatus: 'GETTERS_LIST_EVENT_STATUS'
  }), {
    calScreeners: function calScreeners() {
      if (this.item.addOns.indexOf(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) >= 0 || this.item.addOns.indexOf(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) >= 0) {
        return 0;
      }
      return Math.ceil(this.item.projPart / this.item.duration / 4);
    },
    calCoaches: function calCoaches() {
      if (this.item.addOns.indexOf(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) >= 0) {
        return 1;
      }
      return Math.ceil(this.calScreeners / 3);
    },
    calLeads: function calLeads() {
      console.log('LEAD = ', this.item.addOns);
      if (this.item.addOns.indexOf(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) >= 0) {
        return 1;
      }
      return Math.ceil(this.calScreeners / 7);
    },
    countSubmitted: function countSubmitted() {
      if (!this.item.relatedInfo) {
        return 0;
      }
      var arr = this.item.relatedInfo.filter(function (item) {
        return item.status.toLowerCase() === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].eventStatus.submitted.toLowerCase();
      });
      return arr.length > 0 ? arr[0].countTotal : 0;
    },
    countApproved: function countApproved() {
      if (!this.item.relatedInfo) {
        return 0;
      }
      var arr = this.item.relatedInfo.filter(function (item) {
        return item.status.toLowerCase() === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].eventStatus.approved.toLowerCase();
      });
      return arr.length > 0 ? arr[0].countTotal : 0;
    },
    selectItems: function selectItems() {
      return [{
        eventStatus: 'approved',
        name: 'Approved',
        url: '',
        icon: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].iconNames.calendar,
        lineColor: 'line-green',
        routeTitle: 'Approved',
        count: this.countApproved
      }, {
        eventStatus: 'submitted',
        name: 'Submitted to ADURO',
        url: '',
        icon: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].iconNames.inbox,
        lineColor: 'line-blue',
        routeTitle: 'Submitted to ADURO',
        count: this.countSubmitted
      }];
    }
  }),
  watch: {
    listEventStatus: {
      handler: function handler() {}
    }
  },
  methods: {}
});

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventStatusSelection_vue__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441e2b35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventStatusSelection_vue__ = __webpack_require__(1500);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1497)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-441e2b35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventStatusSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441e2b35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventStatusSelection_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/relatedEvents/EventStatusSelection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventStatusSelection.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-441e2b35", Component.options)
  } else {
    hotAPI.reload("data-v-441e2b35", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2e1af693", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-441e2b35\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventStatusSelection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-441e2b35\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventStatusSelection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.active[data-v-441e2b35] {\n  color: #231f20 !important;\n  background: #ffffff;\n}\n.nav-item-m[data-v-441e2b35] {\n  font-size: 13px;\n  line-height: 12px;\n  text-align: center;\n  position: relative;\n  height: 95px;\n  padding-top: 15px;\n}\n.nav-item-m .nav-icon[data-v-441e2b35] {\n  font-family: FontAwesome;\n  font-size: 14px;\n  line-height: 14px;\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  margin: 0px;\n}\n.nav-item-m .nav-text[data-v-441e2b35] {\n  text-align: left;\n  height: 24px;\n  line-height: 15px;\n  margin-left: 20px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n}\n.nav-item-m .nav-text .company-name[data-v-441e2b35] {\n  margin: 0 0 0 33px;\n}\n.nav-item-m .nav-number[data-v-441e2b35] {\n  height: 38px;\n  width: 42px;\n  font-size: 36px;\n  line-height: 49px;\n  position: absolute;\n  bottom: 14px;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n}\n.nav-item-m .nav-underline[data-v-441e2b35] {\n  height: 5px;\n  width: 76px;\n  bottom: 0;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.nav-item-m .line-white[data-v-441e2b35] {\n  background-color: #e6e6e6;\n}\n.nav-item-m .line-blue[data-v-441e2b35] {\n  background-color: #00A4D6;\n}\n.nav-item-m .line-red[data-v-441e2b35] {\n  background-color: #a42022;\n}\n.nav-item-m .line-green[data-v-441e2b35] {\n  background-color: #417505;\n}\n.nav-item-m .line-brown[data-v-441e2b35] {\n  background-color: #463e38;\n}\n", ""]);

// exports


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_area_chart__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_plus_circle__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_file_text_o__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_calendar_check_o__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_inbox__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_eye__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_archive__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigatorItem',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    item: {
      type: Object
    }
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    number: function number() {
      return this.showRelatedEvents ? this.item.count : this.countEventByStatus(this.item.eventStatus);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])({
    countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
    showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    navigatorItemClick: function navigatorItemClick() {
      // add to list status
      this.setListEventStatus(this.item.eventStatus);
      this.isActive = !this.isActive;
      if (!this.$store.getters.GETTERS_SHOW_RELATED_EVENT) {
        this.$router.push(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].routeDirect.managerEvents);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])({
    setListEventStatus: 'ACTION_SET_LIST_EVENT_STATUS'
  }))
});

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-item-m",
      class: { active: _vm.isActive },
      attrs: { align: "center" },
      on: {
        click: function($event) {
          _vm.navigatorItemClick()
        }
      }
    },
    [
      _c("div", {}, [
        _c(
          "div",
          {},
          [
            _c("Icon", {
              staticClass: "nav-icon",
              attrs: { name: _vm.item.icon }
            }),
            _vm._v(" "),
            _vm.item.eventStatus != "submitted"
              ? _c("a", { staticClass: "nav-text" }, [
                  _vm._v(_vm._s(_vm.item.name))
                ])
              : _c("a", { staticClass: "nav-text" }, [
                  _vm._v(_vm._s(_vm.item.name) + " \n        "),
                  _c("div", { staticClass: "company-name" }, [
                    _vm._v(_vm._s(_vm.item.companyName))
                  ])
                ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-number" }, [_vm._v(_vm._s(_vm.number))]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-underline", class: _vm.item.lineColor })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-441e2b35", esExports)
  }
}

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRelatedEvents_vue__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b00a92a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableRelatedEvents_vue__ = __webpack_require__(1507);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRelatedEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b00a92a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableRelatedEvents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/TableRelatedEvents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TableRelatedEvents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b00a92a", Component.options)
  } else {
    hotAPI.reload("data-v-4b00a92a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DataTableRow__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DtPaging__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tableRelatedEvent',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    DataTableRow: __WEBPACK_IMPORTED_MODULE_6__DataTableRow__["a" /* default */],
    DtPaging: __WEBPACK_IMPORTED_MODULE_7__DtPaging__["a" /* default */]
  },
  data: function data() {
    return {
      scrunch: false,
      // START: paging
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '1000',
        totalItems: this.totalItems,
        sortType: 'eventLocation',
        sortReverse: false
      },
      // END: paging
      arrStatus: []
    };
  },

  props: {
    eventStatus: {
      type: String,
      default: ''
    },
    viewMode: {
      type: String,
      default: 'Related'
    },
    editable: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: Number
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    events: function events() {
      return this.getEventsRelated;
    },
    totalItems: function totalItems() {
      return this.countEventByStatus(this.eventStatus);
    },
    listEventStatus: function listEventStatus() {
      return this.getListEvenStatus;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    getListEvent: 'GETTERS_LIST_EVENT',
    countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
    getListEvenStatus: 'GETTERS_LIST_EVENT_STATUS',
    getEventsRelated: 'GETTERS_LIST_EVENT_RELATED'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    changePagingOptions: function changePagingOptions(pagingObj) {
      this.pagingObj.currentPage = pagingObj.currentPage;
      this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
      this.pagingObj.totalItems = pagingObj.totalItems;
    },
    setSortOption: function setSortOption(sortType) {
      this.pagingObj.sortType = sortType;
      this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
    },
    getListEventParams: function getListEventParams() {
      if (this.eventStatus === '') {
        this.arrStatus = this.getListEvenStatus;
      } else {
        this.arrStatus = [this.eventStatus.toUpperCase()];
      }
      return {
        userId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts__["a" /* default */].LOCAL_STORE.userId)),
        status: this.arrStatus,
        options: this.pagingObj,
        clientId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts__["a" /* default */].LOCAL_STORE.clientId))
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    getEventList: 'ACTION_GET_EVENT_LIST',
    actionGetEventsRelated: 'ACTION_GET_EVENT_RELATED'
  })),
  watch: {
    pagingObj: {
      handler: function handler() {
        this.getEventList(this.getListEventParams());
      },
      deep: true
    },
    listEventStatus: {
      handler: function handler() {
        var params = {
          eventId: this.eventId,
          status: this.listEventStatus,
          options: this.pagingObj
        };
        this.actionGetEventsRelated(params);
      }
    }
  }
});

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1504);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("ed2f4742", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-17e9ccf1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DtPaging.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-17e9ccf1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DtPaging.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n/**\n* OVERIDE GENERAL STYLES\n*/\n.caption-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.label-text {\n  color: #626262;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.label-text-2 {\n  color: #8E8E8E;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.body-text,\n.email-histories-page .histories-page-body .participant-table-container .search-section .input {\n  color: #424242;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.h4-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.h3-text {\n  color: #444444;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n}\n.h2-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.h1-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.button-text,\n.ap-btn {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n.value-text {\n  color: #1D1D1D;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  line-height: 16px;\n}\n.tab-header .type {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 6px;\n  line-height: 48px;\n  margin-right: 24px;\n}\n.tab-header .type:hover {\n  cursor: pointer;\n  color: #606060;\n}\n.tab-header .type:focus {\n  border: 2px solid rgba(0, 164, 214, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 14px 24px;\n}\n.tab-header .type.active {\n  border-bottom: 3px solid #1674CD;\n  color: #1674CD;\n}\n.ap-checkbox-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-checkbox-group .custom-control-indicator {\n  width: 24px;\n  height: 24px;\n  top: 0;\n  border: 1px solid #b9b9b9;\n  background-color: transparent;\n}\n.ap-checkbox-group .custom-control-description {\n  margin-left: 1rem;\n}\n.ap-checkbox-group .custom-checkbox {\n  margin-top: 16px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label {\n  cursor: pointer;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label::before,\n.ap-checkbox-group .custom-checkbox .custom-control-label::after {\n  top: 0;\n  height: 24px;\n  width: 24px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-checkbox-group .custom-checkbox .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: #1674CD;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-control-label {\n  cursor: pointer;\n}\n.ap-radio-group .custom-control-label::after {\n  background-size: 95%;\n}\n.ap-radio-group .custom-control-label::before {\n  background-color: transparent;\n  border: 1px solid #B9B9B9;\n}\n.ap-radio-group .custom-control-label::before,\n.ap-radio-group .custom-control-label::after {\n  top: 0;\n  height: 25px;\n  width: 25px;\n}\n.ap-radio-group .custom-control-label span {\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio {\n  margin-bottom: 24px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label {\n  font-size: 16px;\n  padding-left: 11.5px;\n}\n.ap-radio-group.custom-controls-stacked .custom-radio .custom-control-label span {\n  padding-left: 0;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label {\n  color: #1674CD;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label:before {\n  background-color: transparent;\n  border: 1px solid #1674CD;\n}\n.ap-radio-group .custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%2300A4D6'/%3E%3C/svg%3E\");\n}\n.ap-input-wrapper {\n  position: relative;\n}\n.ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .title-field {\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper {\n  position: relative;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field {\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 24px;\n  height: 24px;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-error-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E83001;\n  background-color: #E83001;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-success-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #68B814;\n  background-color: #68B814;\n}\n.ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field .icon-warning-field {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #E89819;\n  background-color: #E89819;\n}\n.ap-field-input-wrapper .message-field {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.ap-field-input-wrapper .message-field.success {\n  color: #68B814;\n}\n.ap-field-input-wrapper .message-field.error {\n  color: #E83001;\n}\n.ap-field-input-wrapper .message-field.warning {\n  color: #E89819;\n}\n.ap-dropdown {\n  width: 300px;\n  font-size: 16px;\n}\n.ap-dropdown .ap-dropdown-btn {\n  width: 100%;\n}\n.ap-dropdown .ap-dropdown-btn.btn-group > .btn:first-child {\n  border: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 44px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #ffffff;\n  width: inherit;\n  padding: 10px 16px;\n  font-size: 16px;\n  text-align: left;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary::after {\n  display: none;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:hover {\n  border: 1px solid #7B7B7B;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary:focus {\n  border: 2px solid rgba(32, 170, 233, 0.5);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text.active {\n  color: #1D1D1D;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper .icon-dropdown {\n  width: 13px;\n  height: 18px;\n}\n.ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .icon-dropdown-wrapper:hover {\n  cursor: pointer;\n}\n.ap-dropdown .dropdown-menu {\n  width: inherit;\n  width: 100%;\n  border-radius: 4px;\n  background-color: #FFF;\n  margin-top: 8px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 8px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item {\n  height: inherit;\n  padding: 0px 0px 0 16px;\n  color: #1D1D1D;\n  line-height: 24px;\n  border: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:hover {\n  background-color: #F5F5F5 !important;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:focus {\n  background-color: unset;\n  outline: none;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item .ap-item-wrapper {\n  height: 44px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #E6E6E6;\n  padding: 12px 0 9px;\n}\n.ap-dropdown .dropdown-menu .ap-dropdown-menu .dropdown-item:last-child .ap-item-wrapper {\n  border: none;\n}\n.dropdown-section {\n  height: 500px;\n  margin-top: 64px;\n}\n.dropdown-section .section-title {\n  color: #1D1D1D;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  margin-bottom: 40px;\n}\n.pretty.p-default input:checked ~ .state label:after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn {\n  height: 26px;\n}\n.custom-radio-btn input:checked ~ .state label {\n  font-weight: 600;\n  color: #00A4D6;\n}\n.custom-radio-btn input:checked ~ .state label::after {\n  background-color: #00A4D6 !important;\n}\n.custom-radio-btn input:checked ~ .state label::before {\n  border-color: #00A4D6;\n}\n.custom-radio-btn .state label {\n  height: 26px;\n  margin-left: 16px;\n  font-size: 16px;\n  color: #606060;\n  line-height: 26px;\n  letter-spacing: -0.04px;\n}\n.custom-radio-btn .state label::after {\n  width: 25px;\n  height: 25px;\n  bottom: 0;\n  top: unset;\n}\n.custom-radio-btn .state label::before {\n  width: 25px;\n  height: 25px;\n  border-color: #b9b9b9;\n  bottom: 0;\n  top: unset;\n}\n.ap-btn {\n  padding: 12px 32px;\n  border: 1px solid #1674CD;\n  border-radius: 4px;\n  background: none;\n}\n.ap-btn.compact {\n  padding: 6px 24px;\n}\n.ap-btn.primary {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.primary:focus {\n  background-color: #1674CD;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.primary:hover {\n  background-color: #1674CD;\n}\n.ap-btn.primary:active {\n  background-color: #00526A;\n  outline: none;\n}\n.ap-btn.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.primary:disabled:hover {\n  background-color: #1674CD;\n}\n.ap-btn.secondary {\n  background-color: white;\n  color: #1674CD;\n}\n.ap-btn.secondary:hover {\n  background-color: #1674CD;\n  color: #FFF;\n}\n.ap-btn.secondary:focus {\n  background-color: #FFF;\n  color: #1674CD;\n}\n.ap-btn.secondary:active {\n  background-color: #00526A;\n  color: #FFF;\n}\n.ap-btn.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.secondary:disabled:hover {\n  background-color: transparent;\n  color: #1674CD;\n}\n.ap-btn.tertiary {\n  background-color: #AAA7A4;\n  color: #FFF;\n  border: 1px solid #AAA7A4;\n}\n.ap-btn.tertiary:hover {\n  background-color: #67615C;\n}\n.ap-btn.tertiary:active {\n  background-color: #463E37;\n}\n.ap-btn.tertiary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.tertiary:disabled:hover {\n  background-color: #AAA7A4;\n}\n.ap-btn.destructive {\n  background-color: #FF3400;\n  color: #FFF;\n  border: none;\n}\n.ap-btn.destructive:focus {\n  background-color: #FF3400;\n  outline: 2px solid rgba(0, 164, 214, 0.5);\n}\n.ap-btn.destructive:hover {\n  background-color: #B22520;\n}\n.ap-btn.destructive:active {\n  background-color: #631412;\n}\n.ap-btn.destructive:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ap-btn.destructive:disabled:hover {\n  background-color: #FF3400;\n}\n.ap-btn-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ap-btn-icon .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  margin-right: 8px;\n  color: #FFF;\n}\n.ap-btn-icon-only {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px;\n}\n.ap-btn-icon-only.compact {\n  padding: 5px;\n}\n.ap-btn-icon-only .btn-left-icon {\n  height: 20px;\n  width: 18px;\n  color: #FFF;\n}\n.background,\n.card-rest-background,\n.card-lift-background,\n.modal-background,\n.list-dialogues-background,\n.alert-background,\n.iziToast-wrapper .iziToast {\n  border-radius: 4px;\n  background-color: #FFF;\n}\n.header-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.banner-background {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 4px 1px rgba(0, 0, 0, 0.05);\n}\n.card-rest-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.card-lift-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 4px 3px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.list-dialogues-background {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-background,\n.iziToast-wrapper .iziToast {\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.alert-icon,\n.alert-icon-checked,\n.alert-icon-info,\n.alert-icon-warning,\n.alert-icon-error {\n  width: 24px;\n  height: 24px;\n  color: #FFF;\n  background-color: #FFF;\n}\n.alert-icon-checked {\n  background: url('/static/img/down-o-white.svg') no-repeat center;\n}\n.alert-icon-info {\n  background: url('/static/img/status-info-outline-white.svg') no-repeat center;\n}\n.alert-icon-warning {\n  background: url('/static/img/status-warning-outline-white.svg') no-repeat center;\n}\n.alert-icon-error {\n  background: url('/static/img/icon-field-error-white.svg') no-repeat center;\n}\n.iziToast-wrapper .iziToast {\n  min-height: 45px;\n  min-width: 283px;\n  padding: 5px 40px 5px 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body {\n  min-height: 35px;\n  margin-left: 5px;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child {\n  background: #FFF;\n}\n.iziToast-wrapper .iziToast > .iziToast-body .iziToast-buttons-child:hover {\n  background: #e6e6e6;\n}\n.iziToast-wrapper .iziToast > .iziToast-texts {\n  margin-top: 9px;\n}\n.iziToast-wrapper .iziToast > .iziToast-close {\n  top: 50%;\n  right: 10px;\n  margin-top: -7px;\n  width: 14px;\n  height: 14px;\n  background: url('/static/img/ic_close.png') center center no-repeat;\n  background-size: cover;\n  opacity: 1;\n}\n.iziToast-wrapper .iziToast:after {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.manage-related-events-container {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.manage-related-events-container .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.manage-related-events-container .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container {\n  font-family: 'Open Sans', sans-serif;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-close-img .icon-close:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header {\n  margin-top: 24px;\n  padding: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .modal-header .modal-title {\n  color: #1D1D1D;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  border: none;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section {\n  margin-top: 20px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .section-title .count-related-event,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .section-title .count-related-event {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  line-height: 30px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper {\n  width: 60%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .input-search-event,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .input-search-event {\n  height: 42px;\n  border-radius: 3px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .field-input-wrapper .input-wrapper .search-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .field-input-wrapper .input-wrapper .search-icon {\n  position: absolute;\n  right: 12px;\n  top: 10px;\n  z-index: 2;\n  height: 22px;\n  width: 22px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container {\n  background-color: #f5f5f5;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-top: 16px;\n  padding-bottom: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events {\n  border-radius: 4px;\n  margin-top: 24px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name {\n  width: 15%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-name .field-value,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-name .field-value {\n  margin-left: 0;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-address,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-address {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-contact {\n  width: 17%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-email,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-email {\n  width: 25%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-date,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-date {\n  width: 10%;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action {\n  width: 8%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-add-wrapper .icon-add {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .col-action .icon-close-wrapper .icon-close {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 16px;\n  border-left: 1px solid #b9b9b9;\n  width: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .line:hover,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .line:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .field-name {\n  margin-left: 16px;\n  color: #8E8E8E;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper {\n  color: #8E8E8E;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-name .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-address .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-contact .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-email .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-date .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-header .col-action .field-name-wrapper .sort-icon-wrapper .sort-icon {\n  vertical-align: middle;\n  width: 12px;\n  height: 12px;\n  color: #8E8E8E;\n  margin-top: -10px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body {\n  max-height: 316px;\n  min-height: 200px;\n  overflow-y: auto;\n  margin-top: 16px;\n  padding-top: 2px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  height: 56px;\n  margin: 0px 5px 16px 5px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value {\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 56px;\n  padding-left: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .added {\n  color: #8E8E8E;\n  font-size: 12px;\n}\n.manage-related-events-container .modal-manage-related-event-container .choose-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn,\n.manage-related-events-container .modal-manage-related-event-container .added-events-section .table-container .table-related-events .table-body .list-event-item .list-event-item-content .field-value .ap-btn {\n  font-size: 12px;\n  padding: 0 12px;\n}\n.manage-related-events-container .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 32px;\n}\n.manage-related-events-container .group-btn .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n  text-transform: none;\n}\n.manage-related-events-container .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.manage-related-events-container .list-events {\n  background-color: #FCFCFC;\n  border: 1px solid #E6E6E6;\n  margin-top: 1rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.2rem;\n}\n.manage-related-events-container .list-events .selected-text {\n  color: #8E8E8E;\n}\n.manage-related-events-container .list-events .icon-add-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-add-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-add-wrapper .icon-add {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(111) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .icon-close-wrapper {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  background-color: #FFF;\n  height: 32px;\n  width: 32px;\n  padding: 7px;\n}\n.manage-related-events-container .list-events .icon-close-wrapper:hover {\n  cursor: pointer;\n}\n.manage-related-events-container .list-events .icon-close-wrapper .icon-close {\n  height: 16px;\n  width: 16px;\n  background: url(" + __webpack_require__(112) + ") no-repeat center;\n}\n.manage-related-events-container .list-events .list-container {\n  margin: 0 0 1.4rem 0;\n}\n.manage-related-events-container .list-events .list-group-container {\n  margin: 3rem 0;\n}\n.manage-related-events-container .list-events .list-header,\n.manage-related-events-container .list-events .list-content,\n.manage-related-events-container .list-events .list-ca {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-header .column,\n.manage-related-events-container .list-events .list-content .column,\n.manage-related-events-container .list-events .list-ca .column {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column,\n.manage-related-events-container .list-events .list-content .column .container-column,\n.manage-related-events-container .list-events .list-ca .column .container-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manage-related-events-container .list-events .list-header .column .container-column p,\n.manage-related-events-container .list-events .list-content .column .container-column p,\n.manage-related-events-container .list-events .list-ca .column .container-column p {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button,\n.manage-related-events-container .list-events .list-content .column .container-column button,\n.manage-related-events-container .list-events .list-ca .column .container-column button {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manage-related-events-container .list-events .list-header .column .container-column button img,\n.manage-related-events-container .list-events .list-content .column .container-column button img,\n.manage-related-events-container .list-events .list-ca .column .container-column button img {\n  height: 0.6rem;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-header,\n.manage-related-events-container .list-events .list-content .column .container-column .text-header,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-header {\n  font-weight: 600;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-icon,\n.manage-related-events-container .list-events .list-content .column .container-column .text-icon,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manage-related-events-container .list-events .list-header .column .container-column .text-not-live,\n.manage-related-events-container .list-events .list-content .column .container-column .text-not-live,\n.manage-related-events-container .list-events .list-ca .column .container-column .text-not-live {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manage-related-events-container .list-events .list-header .column .border-seperate,\n.manage-related-events-container .list-events .list-content .column .border-seperate,\n.manage-related-events-container .list-events .list-ca .column .border-seperate {\n  border-right: 1px solid #B9B9B9;\n}\n.manage-related-events-container .list-events .list-header .column.width-10,\n.manage-related-events-container .list-events .list-content .column.width-10,\n.manage-related-events-container .list-events .list-ca .column.width-10 {\n  width: 10%;\n}\n.manage-related-events-container .list-events .list-header .column.width-20,\n.manage-related-events-container .list-events .list-content .column.width-20,\n.manage-related-events-container .list-events .list-ca .column.width-20 {\n  width: 20%;\n}\n.manage-related-events-container .list-events .list-header .column.width-30,\n.manage-related-events-container .list-events .list-content .column.width-30,\n.manage-related-events-container .list-events .list-ca .column.width-30 {\n  width: 30%;\n}\n.manage-related-events-container .list-events .list-content,\n.manage-related-events-container .list-events .list-ca {\n  background: #fff;\n}\n.manage-related-events-container .list-events .list-content .column,\n.manage-related-events-container .list-events .list-ca .column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manage-related-events-container .list-events .list-content .column .container-column,\n.manage-related-events-container .list-events .list-ca .column .container-column {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manage-related-events-container .list-events .list-content .column .container-column img,\n.manage-related-events-container .list-events .list-ca .column .container-column img {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .list-content .column:last-child,\n.manage-related-events-container .list-events .list-ca .column:last-child {\n  padding: 0 1rem;\n}\n.manage-related-events-container .list-events .list-content {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manage-related-events-container .list-events .list-ca {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manage-related-events-container .list-events .container-ca {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manage-related-events-container .list-events .container-text {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manage-related-events-container .list-events .container-text b {\n  margin-right: 0.5rem;\n}\n.manage-related-events-container .list-events .container-text .seperate {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manage-related-events-container .list-events .load-more {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manage-related-events-container .list-events .load-more span {\n  position: absolute;\n}\n.manage-related-events-container .list-events .load-more button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.client-contact-email-page {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n  padding: 2rem;\n}\n.client-contact-email-page .header-email-page {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .header-email-page p {\n  font-weight: 600;\n  font-size: 1.5em;\n  color: #1D1D1D;\n  margin: 0;\n}\n.client-contact-email-page .header-email-page .icon-close {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.client-contact-email-page .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.client-contact-email-page .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper {\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event {\n  margin-top: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn {\n  margin-bottom: 16px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn .event-count {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .select-type-event .custom-radio-btn label {\n  font-size: 1em;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.client-contact-email-page .client-contact-email-body .choose-event-wrapper .group-related-events .related-event-item .event-name:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .client-contact-email-body .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  width: 8%;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .btn-send {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  width: 8%;\n  margin-left: 1rem;\n}\n.client-contact-email-page .client-contact-email-body .btn-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.client-contact-email-page .recipients-section .list-email-recipient,\n.client-contact-email-page .cc-section .list-email-recipient,\n.client-contact-email-page .email-template-wrapper .list-email-recipient {\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper {\n  position: relative;\n  margin: .5rem;\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 5px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input {\n  border: none;\n  background-color: #FFF;\n  border-radius: 5px;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.client-contact-email-page .recipients-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.client-contact-email-page .cc-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to {\n  padding: 16px;\n  overflow: auto;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.client-contact-email-page .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.client-contact-email-page .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.client-contact-email-page .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .recipients-wrapper {\n  margin-top: 30px;\n}\n.client-contact-email-page .recipients-wrapper .recipients-section .list-email-send-to {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .cc-section .list-email-send-to {\n  height: 196px;\n}\n.client-contact-email-page .recipients-wrapper .text-mar-bot {\n  margin-bottom: 1.5rem;\n}\n.client-contact-email-page .text-send-email {\n  margin: 2rem 0 1em 0;\n  font-weight: 600;\n}\n.client-contact-email-page .send-email-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .participant-emails {\n  padding: 0 1.2% 0 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .send-email-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .email-template:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.client-contact-email-page .send-email-container .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.client-contact-email-page .send-email-container .text-entry-field-wrapper .text-subject {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  padding: 0.3rem 0.6rem;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn {\n  margin-right: 40px;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text {\n  font-weight: normal;\n}\n.client-contact-email-page .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn label {\n  font-size: 1em;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container {\n  margin-top: 16px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom,\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template:hover {\n  cursor: pointer;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.client-contact-email-page .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.client-contact-email-page .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.client-contact-email-page .group-btn .ap-btn {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.client-contact-email-page .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-body {\n  padding: 24px;\n}\n.modal-body .description {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper {\n  padding: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper {\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .body-text {\n  color: #1D1D1D;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .ap-field-input-wrapper .ap-input-wrapper .input {\n  color: #000;\n  font-size: 16px;\n  line-height: 20px;\n  padding: 12px 16px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.edit-mileage-rate-modal .modal-mileage-rate-wrapper .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-cancell-all-appointment {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.modal-cancell-all-appointment .modal-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n  border: 0;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button {\n  float: right;\n  font-size: 20px;\n}\n.modal-cancell-all-appointment .modal-header .modal-close-button:hover {\n  cursor: pointer;\n}\n.modal-cancell-all-appointment .modal-body {\n  margin-top: 1rem !important;\n}\n.modal-cancell-all-appointment .modal-body p {\n  font-size: 1.7em;\n  font-weight: 600;\n}\n.modal-cancell-all-appointment .modal-body .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 3rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes,\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-weight: 600;\n  font-size: 16px;\n  width: 5rem;\n}\n.modal-cancell-all-appointment .modal-body .btn-container .btn-yes .text-primary,\n.modal-cancell-all-appointment .modal-body .btn-container .btn-no .text-primary {\n  width: 1rem;\n  height: 1rem;\n}\n.add-participant-modal .participant-info {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .title-field {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .field-input {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n  width: 100%;\n  padding: 12px 16px;\n  height: unset;\n}\n.add-participant-modal .participant-info .ap-field-input-wrapper .error-message {\n  color: #FF3400;\n  font-size: 12px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .email-employee-container {\n  margin-top: 24px;\n}\n.add-participant-modal .participant-info .select-more-services {\n  padding: 24px 16px 0;\n}\n.add-participant-modal .participant-info .select-more-services .title-field {\n  font-size: 16px;\n  line-height: 24px;\n}\n.add-participant-modal .participant-info .select-more-services .add-more-services-checkbox {\n  margin-top: 8px;\n}\n.add-participant-modal .btn-add-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.add-participant-modal .btn-add-container .btn-cancel {\n  margin-right: 24px;\n}\n.add-participant-modal .btn-add-container .btn-add-participant {\n  padding: 12px 32px;\n}\n.bulk-create-events {\n  padding: 2rem 2.5rem;\n}\n.bulk-create-events .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #1674CD;\n}\n.bulk-create-events .bulk-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .bulk-title p {\n  font-weight: 600;\n  font-size: 24px;\n  margin-bottom: 0;\n}\n.bulk-create-events .bulk-title .btn-bulk {\n  font-weight: 600;\n  color: #1674CD;\n  background: #FFFFFF;\n  border: 1px solid #b9b9b9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 1rem;\n  font-size: 16px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bulk-create-events .bulk-title .btn-bulk img,\n.bulk-create-events .bulk-title .btn-bulk .spinner-border {\n  margin-right: .7rem;\n}\n.bulk-create-events .upload-file {\n  margin-top: 2rem;\n}\n.bulk-create-events .upload-file .dropzone-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 3rem;\n  border: 2px dashed #ccc;\n  border-radius: 15px;\n}\n.bulk-create-events .upload-file .dropzone-container img {\n  height: 6rem;\n  width: 7rem;\n}\n.bulk-create-events .upload-file .dropzone-container .text-csv {\n  font-size: 1.1em;\n  margin: 1.5rem 0;\n  color: #B9B9B9;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop {\n  font-size: 2.4em;\n  font-weight: 500;\n  color: #000000;\n}\n.bulk-create-events .upload-file .dropzone-container .text-drop a {\n  color: #1674CD;\n  -webkit-text-decoration: revert;\n          text-decoration: revert;\n}\n.bulk-create-events hr {\n  margin: 2rem 0;\n}\n.bulk-create-events .submission-history {\n  min-height: 40vh;\n}\n.bulk-create-events .submission-history p {\n  font-size: 1.2em;\n  font-weight: 600;\n}\n.bulk-create-events .submission-history table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.bulk-create-events .submission-history table th,\n.bulk-create-events .submission-history table td {\n  border: 1px solid #e6e6e6;\n  padding: 1rem;\n}\n.bulk-create-events .submission-history table th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: left;\n  background-color: #FCFCFC;\n  color: #585858;\n  white-space: nowrap;\n}\n.bulk-create-events .submission-history table td {\n  color: #1D1D1D;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history table td a {\n  color: #1674CD;\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .pagination-container {\n  margin-top: 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.bulk-create-events .submission-history .pagination-container .total-text {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.bulk-create-events .submission-history .pagination-container .page-item {\n  cursor: pointer;\n}\n.bulk-create-events .submission-history .textPass {\n  color: #0FAA55;\n}\n.bulk-create-events .submission-history .textFailed {\n  color: #E61C0A;\n}\n.bulk-create-events .submission-history .blink-text {\n  -webkit-animation: blinker 1s linear infinite;\n          animation: blinker 1s linear infinite;\n}\n.bulk-create-events .submission-history .blink-text .spinner-border {\n  margin-right: 0.5rem;\n}\n@-webkit-keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n@keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n.draft-events-modal {\n  padding: 2rem;\n}\n.draft-events-modal .add-on-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .add-on-wrapper p {\n  margin: 0;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 0.85em;\n}\n.draft-events-modal .add-on-wrapper .event-add-on {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input[type=checkbox] {\n  width: 0;\n  visibility: hidden;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 1px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.draft-events-modal .add-on-wrapper .event-add-on label:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.draft-events-modal .add-on-wrapper .event-add-on input:checked + label:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.draft-events-modal .add-on-wrapper .event-add-on label:active:after {\n  width: 15px;\n}\n.draft-events-modal .header-modal {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.draft-events-modal .header-modal .container-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 20%;\n}\n.draft-events-modal .header-modal .container-title .draft-event {\n  color: #1D1D1D;\n  font-weight: 600;\n  font-size: 1.7em;\n  white-space: nowrap;\n  margin: 0;\n}\n.draft-events-modal .header-modal .modal-close {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.draft-events-modal .header-modal .modal-close:hover {\n  cursor: pointer;\n}\n.draft-events-modal .header-modal .modal-close .icon-close {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.draft-events-modal .text-title {\n  font-size: 1.2em;\n  font-weight: 600;\n  margin: 1.5rem 0 0 0;\n}\n.draft-events-modal .field-input {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.draft-events-modal .field-input label {\n  color: #1D1D1D;\n  font-size: 0.9em;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 16px;\n}\n.draft-events-modal .field-input input {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  height: 2rem;\n  padding: 0.4rem 0.6rem;\n  width: 100%;\n}\n.draft-events-modal .field-input .require-askterisk {\n  color: #ff0000;\n  position: absolute;\n  font-size: 1.5em;\n}\n.draft-events-modal .field-input select {\n  width: 30%;\n  border-radius: 5px;\n}\n.draft-events-modal .field-input .text-error {\n  color: #ff0000;\n  font-size: 0.9em;\n  margin-top: .3rem;\n}\n.draft-events-modal .field-input .border-error {\n  border-color: #ff0000;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags {\n  height: 2rem;\n  min-height: auto;\n  border: 1px solid #b9b9b9;\n  padding: 0.4rem 0.5rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__tags input {\n  width: 80% !important;\n  margin: 0;\n  border: 0;\n  padding: 0 !important;\n  font-size: 13px;\n  height: 0rem;\n}\n.draft-events-modal .field-input .field-contact .multiselect__placeholder {\n  margin: 0;\n}\n.draft-events-modal .field-input .field-contact .multiselect__select::before {\n  content: none;\n}\n.draft-events-modal .field-input .field-contact .contact-name,\n.draft-events-modal .field-input .field-contact p {\n  margin-bottom: 0.2rem;\n}\n.draft-events-modal .field-input .field-contact .contact-name {\n  text-transform: capitalize;\n}\n.draft-events-modal .field-input .field-contact .multiselect__content-wrapper {\n  min-height: 3rem;\n}\n.draft-events-modal .field-input .log-error,\n.draft-events-modal .field-input .icon-alert,\n.draft-events-modal .field-input .text-alert {\n  padding: 0;\n  margin-top: 0.3rem;\n}\n.draft-events-modal .field-input .icon-alert {\n  color: #0080a5;\n}\n.draft-events-modal .field-input:first-child,\n.draft-events-modal .add-on-wrapper:first-child {\n  padding-left: 0;\n}\n.draft-events-modal .field-input:last-child,\n.draft-events-modal .add-on-wrapper:last-child {\n  padding-right: 0;\n}\n.draft-events-modal .row {\n  margin: 1.3rem 0 0 0;\n}\n.draft-events-modal .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 5rem;\n}\n.draft-events-modal .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  color: #1674CD;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit,\n.draft-events-modal .btn-container .btn-right-container .btn-save {\n  background: #1674CD;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 1em;\n  font-style: normal;\n  font-weight: 600;\n  border: 0;\n  padding: 0.5rem 1.4rem;\n}\n.draft-events-modal .btn-container .btn-right-container .btn-submit {\n  margin-right: 1rem;\n}\n.draft-events-modal .btn-container .btn-right-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.draft-events-modal .text-toggle-on {\n  color: #1674CD;\n}\n.draft-events-modal .greyOut {\n  color: #AAA7A4;\n}\n.modal-submit-drafts .main-content {\n  padding: 2rem;\n}\n.modal-submit-drafts .main-content .text-question {\n  color: #1D1D1D;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5em;\n  line-height: 32px;\n}\n.modal-submit-drafts .main-content .text-description {\n  font-weight: normal;\n  font-size: 1em;\n  color: #1D1D1D;\n}\n.modal-submit-drafts .main-content .btn-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 2rem;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel,\n.modal-submit-drafts .main-content .btn-container .btn-submit {\n  padding: .2rem 1.5rem;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1em;\n  line-height: 24px;\n}\n.modal-submit-drafts .main-content .btn-container .btn-cancel {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  margin-right: 2rem;\n  color: #1674CD;\n}\n.modal-submit-drafts .main-content .btn-container .btn-submit {\n  color: #FFFFFF;\n  background: #1674CD;\n  border-radius: 4px;\n  border: 0;\n}\n.modal-submit-drafts .main-content .btn-container .spinner-border {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.table-events-plan {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.email-histories-page {\n  font-family: 'Open Sans', sans-serif;\n}\n.email-histories-page .hisories-page-header {\n  background-color: #FFF;\n  padding-top: 16px;\n  border-bottom: 1px solid #E6E6E6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper {\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name .text {\n  color: #E6E6E6;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  padding-bottom: 10px;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name.active .text {\n  color: #00A4D6;\n  border-bottom: 3px solid #00A4D6;\n}\n.email-histories-page .hisories-page-header .tab-wrapper .tab-name + .tab-name {\n  margin-left: 50px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper {\n  padding-bottom: 16px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.email-histories-page .hisories-page-header .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body {\n  height: calc(100vh - 146px);\n}\n.email-histories-page .histories-page-body .ems-table {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container {\n  height: 100%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section {\n  margin-top: 24px;\n  width: 50%;\n}\n.email-histories-page .histories-page-body .participant-table-container .search-section .input {\n  color: #000;\n  padding: 12px 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-participant-container {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header {\n  margin-top: 24px;\n  padding: 12px 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .table-header .ems-header-column:first-child .content {\n  padding-left: 25px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row {\n  height: 58px;\n  padding: 12px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .action-text {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 0;\n  padding-left: 15px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value:first-child {\n  padding-left: 40px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value.resend-btn-wrapper {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-right: 16px;\n}\n.email-histories-page .histories-page-body .participant-table-container .ems-table-body .ems-row .field-value .resend-btn {\n  padding: 6px 24px;\n}\n.email-histories-page .histories-page-body .histories-table-container {\n  height: calc(100% - 60px);\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body {\n  height: inherit;\n  padding: 0 2px;\n  overflow-y: auto;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row {\n  height: 56px;\n  padding: 20px 0px;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-histories-page .histories-page-body .histories-table-container .ems-table-body .ems-row .action-text {\n  color: #00A4D6;\n  text-align: right;\n  cursor: pointer;\n}\n.email-history-details-container {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #FFF;\n}\n.email-history-details-container .btn-back-wrapper {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back {\n  height: 24px;\n  width: 24px;\n}\n.email-history-details-container .btn-back-wrapper .icon-back:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-history-details-body {\n  padding-bottom: 112px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper {\n  margin-top: 40px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type {\n  margin-top: 16px;\n  color: #606060;\n  font-size: 16px;\n  letter-spacing: -0.04px;\n  line-height: 24px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn {\n  margin-bottom: 16px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .event-type .custom-radio-btn .event-count {\n  color: #9D9D9D;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-left: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events {\n  border: 1px solid #9b9b9b;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n  height: 80px;\n  padding: 8px;\n  margin-top: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item {\n  width: 33.33%;\n  height: 16px;\n  float: left;\n  margin-bottom: 8px;\n}\n.email-history-details-container .email-history-details-body .choose-event-wrapper .group-related-events .related-event-item .event-name:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient,\n.email-history-details-container .cc-section .list-email-recipient,\n.email-history-details-container .email-template-wrapper .list-email-recipient {\n  margin-top: 16px;\n  border-radius: 4px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper {\n  position: relative;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input {\n  border: none;\n  border-bottom: 1px solid #b9b9b9;\n  background-color: #FFF;\n  border-radius: 4px 4px 0 0;\n  height: 44px;\n  width: 100%;\n  padding-left: 12px;\n  font-size: 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-webkit-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::-moz-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input:-ms-input-placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .ap-input::placeholder,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .ap-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  opacity: 0.3;\n  color: #000;\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon {\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(113) + ");\n}\n.email-history-details-container .recipients-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.email-history-details-container .cc-section .list-email-recipient .ap-input-wrapper .add-icon:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .ap-input-wrapper .add-icon:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to {\n  overflow: auto;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item {\n  border: 1px solid #8E8E8E;\n  border-radius: 24px;\n  background-color: #FFF;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  margin-right: 16px;\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .email-item .remove-icon,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .email-item .remove-icon {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item {\n  color: #424242;\n  font-size: 12px;\n  margin: 8px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 16px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .history-left,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .history-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .sent-date,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .sent-date {\n  min-width: 110px;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail {\n  color: #00A4D6;\n  overflow: hidden;\n  text-transform: capitalize;\n}\n.email-history-details-container .recipients-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.email-history-details-container .cc-section .list-email-recipient .list-email-send-to .history-item .view-detail:hover,\n.email-history-details-container .email-template-wrapper .list-email-recipient .list-email-send-to .history-item .view-detail:hover {\n  cursor: pointer;\n}\n.email-history-details-container .recipients-wrapper {\n  margin-top: 30px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .template-value {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn {\n  margin-right: 40px;\n}\n.email-history-details-container .email-template-wrapper .choose-email-template .group-radio-button .custom-radio-btn .label-text {\n  font-weight: normal;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_top {\n  display: none !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents {\n  padding: 2px !important;\n}\n.email-history-details-container .email-template-wrapper .ck-for-email-history-detail .cke_contents iframe {\n  margin: 0 !important;\n  padding: -20px !important;\n}\n.email-history-details-container .email-template-wrapper .email-body-section {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container {\n  margin-top: 16px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content {\n  height: 416px;\n  padding: 16px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  overflow: auto;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_top,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content #cke_1_bottom {\n  display: none;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_top,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke_chrome .cke_inner .cke_bottom,\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .email-body-content .cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-send-to {\n  height: 160px;\n  padding: 8px 0;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper {\n  margin-top: 40px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all {\n  color: #00A4D6;\n  text-transform: capitalize;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .email-history-wrapper .email-history-text-wrapper .view-all:hover {\n  cursor: pointer;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient {\n  margin-top: 8px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title {\n  border-bottom: 1px solid #B9B9B9;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-left: 1px solid #B9B9B9;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .sent-date {\n  min-width: 110px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .email-template {\n  min-width: 150px;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text {\n  padding: 0 16px;\n  color: #8E8E8E;\n}\n.email-history-details-container .email-template-wrapper .email-body-section .email-body-container .reply-and-history-section .list-email-recipient .email-history-title .caption-text .sort-icon {\n  width: 12px;\n  height: 12px;\n}\n.email-history-details-container .group-btn {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 64px;\n}\n.email-history-details-container .group-btn .ap-btn {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.email-history-details-container .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.modal-body {\n  padding: 24px;\n}\n.modal-body .description {\n  margin-top: 16px;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.modal-body .grp-btn-container {\n  margin-top: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.modal-body .grp-btn-container .ap-btn {\n  font-size: 16px;\n  padding: 6px 24px;\n}\n.modal-body .grp-btn-container .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.mfa-container .mfa-box {\n  padding: 32px;\n}\n.mfa-container .mfa-box-title {\n  margin-bottom: 16px;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 40px;\n  color: #424242;\n  text-transform: uppercase;\n}\n.mfa-container .mfa-box-title.has-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.mfa-container .mfa-paragraph {\n  margin-bottom: 16px;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1d1d1d;\n}\n.mfa-container .btn-group-author {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 32px;\n}\n.mfa-container .btn-group-author .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.mfa-container .btn-group-author .btn + .btn {\n  margin-left: 16px;\n}\n.mfa-container .ad-support-link {\n  margin-top: 32px;\n  text-align: center;\n  font-size: 16px;\n  color: #1d1d1d;\n}\n.mfa-container .ad-support-link .awp-link {\n  color: #00A4D6;\n}\n.mfa-container .field-input-wrapper .input-wrapper .icon-wrapper {\n  top: 50%;\n  margin-top: -12px;\n}\n.authorization-container {\n  margin-top: 40px;\n}\n.authorization-container .form-content {\n  padding-bottom: 35px;\n}\n.authorization-container .form-content .nav-tab {\n  margin: 30px 0 25px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view {\n  color: #B9B9B9;\n  font-size: 16px;\n  font-weight: 600;\n  margin-right: 24px;\n}\n.authorization-container .form-content .nav-tab .btn-router-view:hover {\n  cursor: pointer;\n}\n.authorization-container .form-content .nav-tab .btn-router-view.selected {\n  color: #00A4D6;\n}\n.authorization-container .form-content .authorization-from {\n  padding: 32px;\n}\n.authorization-container .text-enter-code-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 16px;\n}\n.authorization-container .text-enter-code-container .enter {\n  color: #1D1D1D;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n.authorization-container .text-enter-code-container .code {\n  color: #D92C27;\n}\n.authorization-container .mfa-description {\n  text-align: center;\n  margin-top: 24px;\n  color: #1D1D1D;\n}\n.authorization-container .mfa-description .text-code-expire {\n  margin-top: 24px;\n}\n.authorization-container .mfa-input-code {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 88px;\n}\n.authorization-container .mfa-input-code .mfa-input {\n  text-align: center;\n  border: none;\n  background-color: #f5f5f5;\n}\n.authorization-container .mfa-input-code .btn-continue-wrapper {\n  margin-top: 64px;\n}\n.authorization-container .mfa-input-code .text-send-new-code {\n  margin-top: 24px;\n  color: #00A4D6;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  cursor: pointer;\n}\n.authorization-container .img-content .castlight-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.authorization-container .img-content .castlight-row .castlight-title {\n  color: #424242;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-right: 16px;\n}\n.authorization-container .img-content .castlight-row .img-castlight {\n  height: 56.1px;\n  width: 166px;\n}\n.participant-header-column .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.participant-header-column .content:hover {\n  cursor: pointer;\n}\n.participant-header-column .caption-text {\n  font-weight: bold;\n}\n.participant-header-column .icon-sort {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.participant-header-column .non-sort {\n  background: url(" + __webpack_require__(229) + ") center no-repeat;\n}\n.participant-header-column .sort-up {\n  background: url(" + __webpack_require__(230) + ") center no-repeat;\n}\n.participant-header-column .sort-down {\n  background: url(" + __webpack_require__(231) + ") center no-repeat;\n}\n@-webkit-keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.spinner-container {\n  position: relative;\n  margin: 0 auto;\n}\n.spinner-container .spinner-inner {\n  border: 1px solid #B9B9B9;\n  border-top-color: #00A4D6;\n  -webkit-animation: spinner .6s linear infinite;\n          animation: spinner .6s linear infinite;\n  border-radius: 50%;\n}\n.event-completed-report-card {\n  background-color: #FFF;\n  width: 270px;\n  margin-top: 24px;\n}\n.event-completed-report-card .spinner-loading {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.event-completed-report-card .top-card {\n  padding: 16px 10px;\n}\n.event-completed-report-card .top-card .event-name {\n  text-align: center;\n  font-weight: bold;\n  color: #1D1D1D;\n}\n.event-completed-report-card .top-card .expected-screened {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .top-card .expected-screened .expected,\n.event-completed-report-card .top-card .expected-screened .screened {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .top-card .expected-screened .expected .value,\n.event-completed-report-card .top-card .expected-screened .screened .value {\n  color: #0095D9;\n}\n.event-completed-report-card .bottom-card {\n  border-top: 1px solid #E6E6E6;\n  background-color: #FCFCFC;\n  border-radius: 0 0 4px 4px;\n  padding: 8px 10px 16px;\n}\n.event-completed-report-card .bottom-card .projected-scheduled {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected,\n.event-completed-report-card .bottom-card .projected-scheduled .screened {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 50%;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .projected .value {\n  color: #5FA813;\n}\n.event-completed-report-card .bottom-card .projected-scheduled .screened .value {\n  color: #444444;\n}\n.event-item-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  padding: 0 2rem;\n  height: 35px;\n  z-index: 0;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top: solid 1px #d4d4d4;\n}\n.event-item-icon-underline-color-grey {\n  border: 2px solid #9b9b9b;\n}\n.event-item-icon-underline-color-blue {\n  border: 2px solid #00A4D6;\n}\n.event-item-icon-underline-color-red {\n  border: 2px solid #a42022;\n}\n.event-item-icon-underline-color-green {\n  border: 2px solid #417505;\n}\n.event-item-icon-underline-color-brow {\n  border: 2px solid #463e38;\n}\n.event-item-icon-underline {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 14px;\n  margin-top: 4px;\n}\n.event-item-icon-amount {\n  font-family: \"Open Sans\", sans-serif;\n  text-align: center;\n  margin: 2px 0 0 5px;\n  height: 25px;\n  width: 14px;\n  color: #201D1A;\n  font-size: 12px;\n  line-height: 25px;\n}\n.event-item-icon-component {\n  background-color: #ffffff;\n  float: left;\n  margin: 5px 0 0 3px;\n  width: 65px;\n  padding: 0 3px 0 3px;\n}\n.event-item-icon {\n  height: 25px;\n  width: 25px;\n  color: #2d2827;\n}\n.no-margin-left-right {\n  margin: 5px 0 0 0;\n}\n.icon-footer {\n  width: 25px;\n  height: 25px;\n  background-color: #2d2827;\n}\n.icon-footer.icon-draft {\n  -webkit-mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  mask: url(" + __webpack_require__(62) + ") no-repeat center;\n  background: url(" + __webpack_require__(62) + ");\n}\n.icon-footer.icon-needs-review {\n  -webkit-mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  mask: url(" + __webpack_require__(63) + ") no-repeat center;\n  background: url(" + __webpack_require__(63) + ");\n}\n.icon-footer.icon-submitted {\n  -webkit-mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  mask: url(" + __webpack_require__(64) + ") no-repeat center;\n  background: url(" + __webpack_require__(64) + ");\n}\n.icon-footer.icon-approved {\n  -webkit-mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  mask: url(" + __webpack_require__(65) + ") no-repeat center;\n  background: url(" + __webpack_require__(65) + ");\n}\n.search-session {\n  height: 124px;\n  padding-top: 35px;\n  padding-left: 24px;\n}\n.search-session .placeholder-italic {\n  margin-top: 10px;\n  border: 1px solid #9b9b9b;\n  padding: 3px 15px;\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  border-radius: 3px;\n  background-color: #FFF;\n  z-index: 1;\n}\n.search-session .search-icon {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 998;\n  color: #00A4D6;\n  width: 25px;\n  height: 25px;\n}\n.search-session .search-icon:hover {\n  cursor: pointer;\n  color: #00A4D6;\n}\n.search-session .btn-create-client {\n  position: relative;\n  width: 150px;\n}\n.search-session .btn-create-client .icon-add-client {\n  z-index: 999;\n  color: #FFF;\n  background-color: #0080a5;\n  width: 27px;\n  height: 27px;\n  border-radius: 15px;\n  margin-top: 17px;\n  display: inline-block;\n}\n.search-session .btn-create-client .btn-text {\n  display: inline-block;\n  position: absolute;\n  top: 18px;\n  left: 35px;\n  cursor: pointer;\n}\n.search-icon {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.event-items-management {\n  padding: 24px 12px;\n}\n.event-items-management .section-name {\n  height: 16px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 0 12px 0;\n}\n.event-items-management .client-card-list-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.event-items-management .client-card-list-wrapper .event-item {\n  margin: 12px;\n}\n.event-item {\n  height: 180px;\n  width: 290px;\n  border-radius: 4px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  top: 0;\n  -webkit-transition: top .25s;\n  transition: top .25s;\n  -webkit-transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n          transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n}\n.event-item:hover {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  top: -10px;\n}\n.event-item:hover .delete-client-button {\n  display: block;\n}\n.event-item.noTransition:hover {\n  -webkit-transition: none;\n  transition: none;\n}\n.event-item .delete-client-button {\n  /*display: none;*/\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  height: 24px;\n  width: 24px;\n  z-index: 1;\n}\n.event-item .delete-client-button:hover {\n  background-color: #f5f5f5;\n}\n.event-item .delete-client-button .icon-delete {\n  height: 24px;\n  width: 24px;\n  background: url(" + __webpack_require__(232) + ");\n}\n.event-item .event-item-custom-message {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  color: #3caae9;\n  z-index: 999;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n}\n.event-item .event-item-custom-message .event-item-custom-message-icon.icon-gear {\n  -webkit-mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  background: url(" + __webpack_require__(233) + ");\n}\n.event-item .event-item-header {\n  -webkit-box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 6px 4px 1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  position: absolute;\n  height: 145px;\n  overflow: visible;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  padding: 0 24px;\n}\n.event-item .event-item-header .wrapper-event-item-name {\n  height: 45px;\n}\n.event-item .event-item-header .wrapper-event-item-name .event-item-name {\n  font-family: 'Open Sans', sans-serif;\n  max-width: 216px;\n  width: 291px;\n  color: #20AAE9;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto 10px;\n  max-height: 100%;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.event-item .event-item-header .event-item-role {\n  margin: 4px;\n}\n.event-item .event-item-header .event-item-role .event-manager .event-item-role-text-em {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 18px;\n  color: #424242;\n  text-align: center;\n  width: 100%;\n  border: none;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown {\n  width: 100%;\n  font-size: 12px;\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .btn-group.btn:first-child {\n  font-weight: 600;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary {\n  height: 24px;\n  padding: 4px 10px;\n  font-weight: 400;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content {\n  font-weight: unset;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.event-item .event-item-header .event-item-role .event-manager .ap-dropdown .ap-dropdown-btn .btn-secondary .button-content .text {\n  font-size: 14px;\n  line-height: 16px;\n}\n.event-item .event-item-header .event-item-role .multiselect {\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n  margin: 10px auto 0;\n  text-align: center;\n  width: 100%;\n  min-height: 0;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am.multiselect {\n  min-height: 0;\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags {\n  border: none;\n  padding: 0;\n  min-height: unset;\n  height: unset;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__tags .multiselect__single {\n  text-align: center;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiselect__select {\n  display: none;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am {\n  position: relative;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input {\n  border-radius: 3px;\n  color: #9b9b9b;\n  text-align: center;\n  border: none;\n  font-size: 14px;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__input:hover {\n  cursor: pointer;\n}\n.event-item .event-item-header .event-item-role .event-item-role-text-am .multiple-select-am .multiselect__content-wrapper {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.event-item-name {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 25px auto;\n}\n.event-item-role-icon {\n  height: 12px;\n  width: 11px;\n  color: #0080a5;\n  position: absolute;\n  width: auto;\n  float: right;\n}\n.manageWrapper .search-container {\n  padding: 1.5rem;\n  background: #FFFFFF;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .search-container .manage-header p {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .title {\n  font-size: 2em;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .item {\n  width: 23rem;\n}\n.manageWrapper .search-container .manage-header button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1.1em;\n  padding: 8px 24px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .manage-header .multiselect,\n.manageWrapper .search-container .manage-header .multiselect__input,\n.manageWrapper .search-container .manage-header .multiselect__single {\n  font-size: 14px;\n}\n.manageWrapper .search-container .text-manage-events {\n  color: #1D1D1D;\n  font-size: 1.1em;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter {\n  margin-top: 2rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .search-container .container-filter .filter-date-range {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 23rem;\n  margin-right: 1.5rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.3rem;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-date-range,\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear {\n  font-size: 12px;\n  margin: 0;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .text-container .text-clear {\n  color: #1674CD;\n  opacity: 0.6;\n  cursor: pointer;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter p {\n  margin: 0;\n  padding: 0 0.5rem;\n  font-size: 12px;\n  font-weight: 400;\n}\n.manageWrapper .search-container .container-filter .filter-date-range .field-filter input {\n  border-radius: 3px;\n  border: 1px solid #9b9b9b;\n  height: 2.2rem;\n  padding: 0.7rem;\n}\n.manageWrapper .search-container .container-filter .search-events p {\n  margin-bottom: .3rem;\n  font-size: 12px;\n  font-weight: 600;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group {\n  border-radius: 4px;\n  border: 1px solid #9b9b9b;\n  width: 20rem;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group input {\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  height: 100%;\n  border-radius: 3px;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button {\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .search-container .container-filter .search-events .search-events-group button .search-icon {\n  color: #000;\n}\n.manageWrapper .search-container .container-filter .total-count {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n      -ms-flex-flow: column-reverse;\n          flex-flow: column-reverse;\n  margin-left: auto;\n  font-size: 14px;\n  font-weight: 600;\n}\n.manageWrapper .list-events {\n  padding: 1.5rem;\n}\n.manageWrapper .list-events .list-container {\n  margin: 2rem 0;\n}\n.manageWrapper .list-events .list-group-container {\n  margin: 3rem 0;\n}\n.manageWrapper .list-events .list-header,\n.manageWrapper .list-events .list-content,\n.manageWrapper .list-events .list-ca {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-header .column,\n.manageWrapper .list-events .list-content .column,\n.manageWrapper .list-events .list-ca .column {\n  padding: 1rem 0 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-header .column .container-column,\n.manageWrapper .list-events .list-content .column .container-column,\n.manageWrapper .list-events .list-ca .column .container-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.manageWrapper .list-events .list-header .column .container-column .live-click,\n.manageWrapper .list-events .list-content .column .container-column .live-click,\n.manageWrapper .list-events .list-ca .column .container-column .live-click {\n  cursor: pointer;\n}\n.manageWrapper .list-events .list-header .column .container-column p,\n.manageWrapper .list-events .list-content .column .container-column p,\n.manageWrapper .list-events .list-ca .column .container-column p {\n  margin: 0 0.5rem 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.manageWrapper .list-events .list-header .column .container-column button,\n.manageWrapper .list-events .list-content .column .container-column button,\n.manageWrapper .list-events .list-ca .column .container-column button {\n  padding: 0;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.manageWrapper .list-events .list-header .column .container-column button img,\n.manageWrapper .list-events .list-content .column .container-column button img,\n.manageWrapper .list-events .list-ca .column .container-column button img {\n  height: 0.6rem;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-header,\n.manageWrapper .list-events .list-content .column .container-column .text-header,\n.manageWrapper .list-events .list-ca .column .container-column .text-header {\n  font-weight: 600;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-icon,\n.manageWrapper .list-events .list-content .column .container-column .text-icon,\n.manageWrapper .list-events .list-ca .column .container-column .text-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.manageWrapper .list-events .list-header .column .container-column .text-not-live,\n.manageWrapper .list-events .list-content .column .container-column .text-not-live,\n.manageWrapper .list-events .list-ca .column .container-column .text-not-live {\n  color: #585858;\n  font-size: 0.9em;\n}\n.manageWrapper .list-events .list-header .column .border-seperate,\n.manageWrapper .list-events .list-content .column .border-seperate,\n.manageWrapper .list-events .list-ca .column .border-seperate {\n  border-right: 1px solid #B9B9B9;\n}\n.manageWrapper .list-events .list-header .column.event-date,\n.manageWrapper .list-events .list-content .column.event-date,\n.manageWrapper .list-events .list-ca .column.event-date {\n  width: 14.28%;\n}\n.manageWrapper .list-events .list-header .column.w-2,\n.manageWrapper .list-events .list-content .column.w-2,\n.manageWrapper .list-events .list-ca .column.w-2 {\n  width: 2%;\n}\n.manageWrapper .list-events .list-header .column.w-12,\n.manageWrapper .list-events .list-content .column.w-12,\n.manageWrapper .list-events .list-ca .column.w-12 {\n  width: 12%;\n}\n.manageWrapper .list-events .list-header .column.w-14,\n.manageWrapper .list-events .list-content .column.w-14,\n.manageWrapper .list-events .list-ca .column.w-14 {\n  width: 14%;\n}\n.manageWrapper .list-events .list-header .column.w-16,\n.manageWrapper .list-events .list-content .column.w-16,\n.manageWrapper .list-events .list-ca .column.w-16 {\n  width: 16%;\n}\n.manageWrapper .list-events .list-header.green-line,\n.manageWrapper .list-events .list-content.green-line,\n.manageWrapper .list-events .list-ca.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-header.green-line,\n.manageWrapper .list-events .list-content.green-line,\n.manageWrapper .list-events .list-ca.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .list-content,\n.manageWrapper .list-events .list-ca {\n  background: #fff;\n}\n.manageWrapper .list-events .list-content .column,\n.manageWrapper .list-events .list-ca .column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .list-events .list-content .column .container-column,\n.manageWrapper .list-events .list-ca .column .container-column {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.manageWrapper .list-events .list-content .column .container-column img,\n.manageWrapper .list-events .list-ca .column .container-column img {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .list-content .column:last-child,\n.manageWrapper .list-events .list-ca .column:last-child {\n  padding: 1rem 1rem 1rem 1.5rem;\n}\n.manageWrapper .list-events .list-content {\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  border-radius: 4px;\n}\n.manageWrapper .list-events .list-ca {\n  border-bottom: 1px solid #E6E6E6;\n}\n.manageWrapper .list-events .container-ca {\n  border-left: 5px solid #1674CD;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n}\n.manageWrapper .list-events .container-ca .list-group-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.manageWrapper .list-events .container-ca .list-group-row.green-line {\n  color: #4DA75F;\n}\n.manageWrapper .list-events .container-text {\n  background: #1674CD;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: .2rem 0.4rem;\n  color: #fff;\n  font-size: 0.9em;\n  margin-top: 2rem;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.manageWrapper .list-events .container-text b {\n  margin-right: 0.5rem;\n}\n.manageWrapper .list-events .container-text .seperate {\n  border-left: 1px solid #B9B9B9;\n  width: 1px;\n  height: 10px;\n  margin: 0 0.5rem;\n}\n.manageWrapper .list-events .load-more {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manageWrapper .list-events .load-more span {\n  position: absolute;\n}\n.manageWrapper .list-events .load-more button {\n  background: #FFFFFF;\n  color: #1674CD;\n  border-color: #B9B9B9;\n  font-size: 1em;\n  padding: 8px 24px;\n}\n.manageWrapper .footer {\n  background: white;\n  -webkit-box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n          box-shadow: 0px -2px 2px rgba(29, 29, 29, 0.04), -2px 0px 2px rgba(29, 29, 29, 0.04), 2px 0px 2px rgba(29, 29, 29, 0.04), 0px 4px 6px rgba(29, 29, 29, 0.08);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  bottom: 0;\n  left: 96px;\n  right: 0;\n  padding: 0.8rem 1.5rem;\n}\n.manageWrapper .footer .ap-btn {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.custom-modal .modal-title {\n  height: 32px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.custom-modal .configure-scheduler {\n  border-radius: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 6px 24px;\n  margin-left: 16px;\n}\n.custom-modal .label {\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.custom-modal .modal-header {\n  padding-left: 0;\n  width: 100%;\n  margin: 0  !important;\n  border-bottom: none !important;\n}\n.custom-modal .modal-header .modal-header-text {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 27px;\n}\n.custom-modal .modal-header .modal-header-text-edit {\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .input-client-name {\n  border: none;\n  height: 20px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  margin-top: 8px;\n  width: 100%;\n}\n.custom-modal .modal-header .modal-header-text-edit .save-client-name-btn.btn {\n  float: right;\n  margin-left: 15px;\n  background-color: #0080A5;\n  border-radius: 4px;\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-modal .modal-close-img {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.custom-modal .modal-box .main-content {\n  padding: 60px 60px 20px 40px;\n}\n.custom-modal .modal-box .overlay {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.custom-modal .modal-box .isLoading {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n}\n.custom-modal .modal-box .noDisplay {\n  display: none!important;\n}\n.custom-modal .modal-body {\n  font-family: 'Open Sans', sans-serif;\n  margin-top: 60px;\n}\n.custom-modal .modal-body.main-content {\n  margin: 0;\n  width: 100%;\n  padding: 5rem 0 0 0;\n}\n.custom-modal .add-on {\n  margin-top: 112px;\n}\n.custom-modal .add-on .title {\n  color: #231F20;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .add-on .description {\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .add-on .add-on-item {\n  width: 250px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 12px;\n}\n.custom-modal .add-on .add-on-item .text {\n  position: absolute;\n  left: 40px;\n  white-space: nowrap;\n}\n.custom-modal .add-on .add-on-item label {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .add-on .add-on-item input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .add-on .add-on-item label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .add-on .add-on-item input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .add-on .add-on-item input:disabled + label {\n  background: #babfc0;\n  border: 1.5px solid #fff;\n}\n.custom-modal .add-on .add-on-item input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .add-on .add-on-item label:active:after {\n  width: 15px;\n}\n.custom-modal .secondary-am {\n  margin-top: 74px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .secondary-am .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .secondary-am .description {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .secondary-am .pick {\n  margin-top: 4px;\n  font-size: 14px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags {\n  border: 1px solid #9B9B9B;\n  height: auto  !important;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag {\n  background: #41b883;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 0 0.5rem 0 0;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {\n  margin-top: 3px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:hover {\n  background: #0092B4;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon:after {\n  color: #fff;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content {\n  margin: 7px auto;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.custom-modal .secondary-am .pick .input-second-am .multiselect__content-wrapper .multiselect__content li.multiselect__element:last-child {\n  border-bottom: none;\n}\n.custom-modal .reseller-status {\n  margin-top: 72px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #231F20;\n}\n.custom-modal .reseller-status .title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.custom-modal .reseller-status .description {\n  margin-top: 8px;\n  height: 24px;\n  width: 790px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .reseller-status .reseller-toggle {\n  margin-top: 15px;\n}\n.custom-modal .reseller-status .reseller-toggle input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .reseller-status .reseller-toggle label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .reseller-status .reseller-toggle label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-modal .reseller-status .reseller-toggle input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-modal .reseller-status .reseller-toggle label:active:after {\n  width: 15px;\n}\n.custom-modal .reseller-status .read-only {\n  margin-top: 15px;\n}\n.custom-modal .last-child-pick {\n  position: relative;\n  margin-top: 15px;\n  height: 250px;\n}\n.button-view {\n  position: relative;\n}\n.button-view .btn-expand {\n  background: url(" + __webpack_require__(234) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-duplicate {\n  background: url(" + __webpack_require__(235) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-delete {\n  background: url(" + __webpack_require__(236) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status {\n  background: url(" + __webpack_require__(237) + ") no-repeat !important;\n  height: 2rem;\n  width: 2rem;\n}\n.button-view .btn-status:disabled {\n  background: url(" + __webpack_require__(238) + ") no-repeat !important;\n}\n.button-view .btn-status-dropdown .dropdown-toggle::after {\n  display: none;\n}\n.button-view .btn-status-dropdown .dropdown-menu {\n  border-radius: 10px;\n  padding: 10px 0;\n  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  background: #FCFCFC;\n}\n.button-view .btn-status-dropdown button {\n  width: 100%;\n  height: 100%;\n}\n.button-view .btn-status-dropdown ul {\n  border-radius: 10px;\n}\n.button-view .btn-status-dropdown ul li a {\n  padding: 10px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.button-view .wrapper-list {\n  position: absolute;\n  left: -450%;\n  top: 16px;\n  z-index: 999;\n  cursor: pointer;\n}\n.button-view .wrapper-list .icon-information-black {\n  width: 27px;\n  height: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .icon-information-black {\n    background: url(" + __webpack_require__(38) + ");\n}\n}\n.button-view .wrapper-list .status-icon-black {\n  height: 27px;\n  width: 27px;\n  margin-right: 10px;\n  background-color: #000;\n  -webkit-mask: url(" + __webpack_require__(31) + ") no-repeat center;\n  mask: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.button-view .wrapper-list .status-icon-black {\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.button-view .wrapper-list .status-icon-black {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n.dashboard-manager .isLoading {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #606060;\n  padding: 12rem 0;\n}\n.dashboard-manager .pagination-container {\n  margin-top: 1.5rem;\n  padding: 24px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.dashboard-manager .pagination-container .total-text {\n  color: #1D1D1D;\n  margin-right: 2rem;\n  font-weight: 500;\n}\n.dashboard-manager .pagination-container .page-item {\n  cursor: pointer;\n}\n.global-setting-page-container {\n  padding: 24px;\n  background-color: #FFF;\n}\n.global-setting-page-container .staff-management-container {\n  padding: 24px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table {\n  margin-top: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header {\n  margin-top: 16px;\n  padding: 12px 0;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .table-header .col-mileage-rate {\n  padding-left: 40px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row {\n  padding: 12px 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .field-value {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn {\n  padding: 4px;\n  background-color: #1674CD;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn + .ap-btn {\n  margin-left: 8px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .ap-btn .icon {\n  height: 24px;\n  width: 24px;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .edit-btn .icon {\n  background: url(" + __webpack_require__(153) + ") no-repeat center;\n}\n.global-setting-page-container .staff-management-container .staff-management-settings-container .global-rate-of-pay-table .list-staff-settings .ems-row .group-action-btn .delete-btn .icon {\n  background: url(" + __webpack_require__(154) + ") no-repeat center;\n}\nbody {\n  font-family: 'Open Sans', sans-serif;\n}\n.body {\n  width: 90%;\n  margin: 10px auto;\n  height: auto;\n  text-align: center;\n  background-color: #FFF;\n  font-family: 'Open Sans', sans-serif;\n  min-width: 1024px;\n}\n.main .container-fluid {\n  padding: 0;\n}\na:hover {\n  text-decoration: none !important;\n}\n.v--modal {\n  -webkit-box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n          box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.15) !important;\n}\n/**\n * CUSTOM STYLES\n */\n.has-error {\n  border: solid 1px red !important;\n}\n.line-copy-2 {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 63px;\n  width: 2px;\n  border-left: 10px solid #0080a5;\n}\n.content-header {\n  height: 29px;\n  width: 137px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  position: absolute;\n  margin: 25px 0 0 15px;\n}\n.content-body {\n  height: 19px;\n  color: #231F20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  position: absolute;\n  margin: 65px 0 0 15px;\n}\n.subHeader {\n  height: 100px;\n  width: 100%;\n  background-color: #FFF;\n}\n.header {\n  height: 70px;\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.header-card {\n  height: 46px;\n  width: 100%;\n  color: #FFF;\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 50px;\n}\n.content-dashboard-card {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 19px;\n}\n.wellmetrics-event-ma {\n  height: 29px;\n  width: 341px;\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n}\n.user-name {\n  height: 24px;\n  width: 94px;\n  color: #000;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n}\n.user-type {\n  height: 20px;\n  width: 78px;\n  color: #9b9b9b;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 300;\n  line-height: 20px;\n  text-align: center;\n}\n.shadow {\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n}\n.overview {\n  width: 100%;\n  height: 65px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 80px;\n  text-align: center;\n}\n.events {\n  height: 18px;\n  width: 47px;\n  opacity: 0.8;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n.bottomLine {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  width: 80%;\n  border: 1px solid #FFF;\n  opacity: 0.5;\n  margin-top: 7px;\n  float: right;\n  margin-bottom: -5px;\n}\n.newEventForm {\n  padding: 20px;\n  margin: 20px;\n}\n.nopadding {\n  padding: 0 !important;\n}\n.noMargin {\n  margin-left: 0;\n  margin-right: 0;\n}\n.paddingTop27px {\n  padding-top: 27px;\n}\n.padding-left-20px {\n  padding-left: 20px;\n}\n.noPaddingLeft {\n  padding-left: 0;\n}\n.noPaddingRight {\n  padding-right: 0;\n}\n.margin-bottom-8px {\n  margin-bottom: 8px;\n}\n.margin-top-15px {\n  margin-top: 15px;\n}\n.margin-top-16px {\n  margin-top: 16px;\n}\n.margin-top-25px {\n  margin-top: 25px;\n}\n.margin-bottom-5px {\n  margin-bottom: 5px;\n}\n.margin-top-20px {\n  margin-top: 20px;\n}\n.margin-top-44px {\n  margin-top: 44px;\n}\n.margin-top-40px {\n  margin-top: 40px;\n}\n.margin-top-10px {\n  margin-top: 10px;\n}\n.margin-top-5px {\n  margin-top: 5px;\n}\n.margin-bottom-10px {\n  margin-bottom: 10px;\n}\n.padding-left-40px {\n  padding-left: 40px !important;\n}\n.padding-left-27px {\n  padding-left: 27px !important;\n}\n.padding-left-3px {\n  padding-left: 3px;\n}\n.padding-left-19px {\n  padding-left: 19px;\n}\n.clear-both {\n  clear: both;\n}\n.h2-title {\n  color: #000;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.h4-title {\n  color: #0080A5;\n  font-family: Arquitecta, sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.no-select {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                   supported by Chrome and Opera */\n}\n.phoneAndEmail {\n  height: 34px;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  border-radius: 3px;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0 0 0 13px;\n  font-size: 14px;\n  color: #000;\n}\n.calendarCustom {\n  width: 300px;\n  border: none;\n  margin-right: 13px;\n}\n.outer-container {\n  position: relative;\n  float: left;\n  left: 50%;\n}\n.outer-container .inner-container {\n  position: relative;\n  float: left;\n  left: -50%;\n}\n::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #b9b9b9;\n}\n:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: #b9b9b9;\n}\n::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: #b9b9b9;\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #b9b9b9;\n}\n:-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #b9b9b9;\n}\n::placeholder {\n  /* Most modern browsers support this now. */\n  color: #b9b9b9;\n}\n.modal-body-user-info .multiselect__tags {\n  border: 1px solid #9B9B9B;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag {\n  background: #0092B4;\n  color: #fff;\n  height: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {\n  margin-top: 3px;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:hover {\n  background: #0092B4;\n}\n.modal-body-user-info .multiselect__tags .multiselect__tags-wrap .multiselect__tag-icon:after {\n  color: #fff;\n}\n.modal-body-user-info .multiselect__content-wrapper {\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content {\n  margin: 7px auto;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  border-bottom: 1px solid #E6E6E6;\n  border-bottom-left-radius: 10px;\n  height: 41px;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  padding-left: 20px;\n  background: #fff;\n  font-weight: unset;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  color: #000;\n  background-color: #f5f5f5;\n}\n.modal-body-user-info .multiselect__content-wrapper .multiselect__content li.multiselect__element:last-child {\n  border-bottom: none;\n}\n.custom-toggle input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.custom-toggle label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 4px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-toggle label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.custom-toggle input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.custom-toggle input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.custom-toggle label:active:after {\n  width: 15px;\n}\n.display-none-something {\n  display: none !important;\n}\n.ems_confirm {\n  padding: 24px;\n}\n.ems_confirm .swal2-header {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.ems_confirm .swal2-header .ems_alert_title {\n  height: 40px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.ems_confirm .swal2-content .ems_alert_des {\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  font-weight: 400;\n}\n.ems_confirm .swal2-actions {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: unset;\n  margin-top: 45px;\n}\n.ems_confirm .swal2-actions .ems_alert_cancel {\n  border: 1px solid #00A4D6 !important;\n  color: #00A4D6 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.block {\n  background-color: #FF3400 !important;\n  border-left-color: #FF3400 !important;\n  border-right-color: #FF3400 !important;\n}\n.ems_confirm .swal2-actions .ems_alert_confirm.open {\n  background-color: #00A4D6 !important;\n  border-left-color: #00A4D6 !important;\n  border-right-color: #00A4D6 !important;\n}\n.default-message {\n  color: #b9b9b9 !important;\n}\n.max-width-100 {\n  max-width: 100% !important;\n}\n.always-show {\n  display: block !important;\n  opacity: 1 !important;\n}\n.selected-staffing-item {\n  background-color: #e6e6e6 !important;\n}\n.un-selected-staffing-item {\n  background-color: #FFFFFF !important;\n}\n.form-control:disabled {\n  background-color: #FFFFFF;\n  opacity: 1;\n}\n.clear-both {\n  clear: both !important;\n}\n.action-btn {\n  height: 36px;\n  margin-left: 8px;\n}\n.action-btn:hover {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue {\n  background-color: #00A4D6;\n  border-color: #00A4D6;\n}\n.action-btn.btn-blue .btn-text {\n  color: #FFF;\n}\n.action-btn.btn-white {\n  background-color: #f5f5f5;\n  color: #00A4D6;\n  border: solid 1px #00A4D6;\n}\n.action-btn.btn-white .btn-text {\n  color: #00A4D6;\n}\n.action-btn .btn-text {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.no-border {\n  border: none !important;\n}\n.opacity-04 {\n  opacity: 0.4;\n}\n.opacity-06 {\n  opacity: 0.6;\n}\n.field-input-wrapper {\n  margin-top: 24px;\n}\n.field-input-wrapper .attr-name {\n  color: #424242;\n  font-size: 16px;\n}\n.field-input-wrapper .message {\n  margin-top: 5px;\n  font-size: 16px;\n}\n.field-input-wrapper .message.error {\n  color: #E83001;\n}\n.field-input-wrapper .message.success {\n  color: #5FA813;\n}\n.field-input-wrapper .input-wrapper {\n  position: relative;\n}\n.field-input-wrapper .input-wrapper .input {\n  height: 48px;\n  margin-top: 5px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  line-height: 24px;\n  width: 100%;\n  padding-left: 10px;\n  font-size: 16px;\n}\n.field-input-wrapper .input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.field-input-wrapper .input-wrapper .input.success {\n  border: 1px solid #5FA813;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper {\n  position: absolute;\n  top: 16px;\n  right: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background-color: #3caae9;\n  background: url(" + __webpack_require__(27) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(239) + ") no-repeat center;\n}\n.field-input-wrapper .input-wrapper .icon-wrapper .icon-search-grey:hover {\n  cursor: pointer;\n}\n.field-input-wrapper .help {\n  display: inline-block;\n  margin-top: 5px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.field-input-wrapper .help.is-danger {\n  color: #E83001;\n}\n.margin-side {\n  padding: 0 24px;\n}\n.remove-margin-side {\n  margin: 0 -24px;\n}\n.common-margin-left {\n  margin-left: 24px;\n}\n.v--modal-overlay {\n  z-index: 1020;\n}\n.icon-back {\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.icon-back {\n    background: url(" + __webpack_require__(92) + ");\n}\n}\n.common-card {\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.common-card .v--modal-box {\n  padding: 24px;\n}\n.common-card .v--modal-box .modal-close-img {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n.common-card .v--modal-box .modal-close-img .icon-close {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.common-card .v--modal-box .modal-close-img .icon-close {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.common-card .v--modal-box .modal-close-img .icon-close:hover {\n  cursor: pointer;\n}\n.common-card .v--modal-box .modal-body {\n  margin-top: 16px;\n}\n.common-card .v--modal-box .modal-footer {\n  margin-top: 40px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.common-card .v--modal-box .modal-footer .group-btn .ap-btn + .ap-btn {\n  margin-left: 16px;\n}\n.common-card .v--modal-box .modal-header,\n.common-card .v--modal-box .modal-body,\n.common-card .v--modal-box .modal-footer {\n  padding: 0;\n  border-bottom: none;\n  border-top: none;\n}\n.push-right {\n  float: right;\n}\n.remove-icon {\n  margin-left: 16px;\n  margin-top: 2px;\n  width: 27px;\n  height: 27px;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(23) + ") no-repeat center;\n  mask: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.remove-icon {\n    background: url(" + __webpack_require__(23) + ") no-repeat center;\n}\n}\n.remove-icon:hover {\n  cursor: pointer;\n}\n.cke_chrome,\n.cke {\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n}\n.cke_chrome .cke_inner,\n.cke .cke_inner {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_top,\n.cke .cke_inner .cke_top {\n  border-radius: 4px 4px 0 0;\n}\n.cke_chrome .cke_inner .cke_bottom,\n.cke .cke_inner .cke_bottom {\n  border-radius: 0 0 4px 4px;\n}\n.header-left-side {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.header-left-side .header-middle {\n  margin-left: 24px;\n}\n.custom-multiselect {\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper {\n  border: none;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  font-family: 'Open Sans', sans-serif;\n  z-index: 999;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content {\n  margin-top: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element {\n  padding-left: 8px;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element:hover {\n  background-color: #F5F5F5;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option {\n  min-height: 34px;\n  color: #231F20;\n  border-bottom: 1px solid #E6e6e6;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--highlight {\n  background-color: transparent;\n}\n.custom-multiselect .multiselect .multiselect__tags {\n  border-color: #B9b9b9;\n  border-radius: 4px;\n  padding-left: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  color: #231F20;\n  height: 43px;\n}\n.custom-multiselect .multiselect .multiselect__tags:hover {\n  border-color: #B7B7B7;\n  color: #231F20;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input {\n  font-size: 14px;\n  margin-bottom: 0;\n  padding: 0;\n  height: 16px;\n  line-height: unset;\n  min-height: unset;\n  font-family: 'Open Sans', sans-serif;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::-webkit-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::-moz-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input:-ms-input-placeholder {\n  color: #606060;\n}\n.custom-multiselect .multiselect .multiselect__tags .multiselect__input::placeholder {\n  color: #606060;\n}\n.ems-row {\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.ems-row .field-value {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 0 16px;\n}\n.ems-table-header {\n  width: 100%;\n  height: 48px;\n  padding: 16px 0px;\n}\n.ems-table-header .ems-header-col {\n  float: left;\n  text-transform: uppercase;\n}\n.ems-table-header .ems-header-col .content {\n  padding-left: 16px;\n}\n.ems-table-header .ems-header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.ems-table-header .ems-header-col .header-container {\n  position: relative;\n}\n.ems-table-header .ems-header-col .crop {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n  overflow: hidden;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.ems-table-header .ems-header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n  height: 16px;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.ems-table-header .ems-header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.ems-table-header .ems-header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.ems-table-header .ems-header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n.event-container .app-body .main {\n  padding-bottom: 0;\n}\n.client-card-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.disable-button {\n  pointer-events: none;\n}\n.dt-row .MicrosoftMap .as_container_search {\n  left: 18%;\n  margin-top: 35px;\n}\n.dt-row .MicrosoftMap .as_container ul {\n  padding: 0 0 8px 0;\n}\n.dt-row .MicrosoftMap .as_container ul li {\n  border-top: 1px solid #e6e6e6;\n}\n.text-value .MicrosoftMap .as_container_search {\n  left: 10px;\n  margin-top: 0;\n}\n.address-input-bing {\n  height: 25px;\n  margin-top: 16px;\n  border: none;\n  outline: none;\n  padding-right: 15px;\n}\n.center-content {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.center-content .img-red-logo {\n  height: 64px;\n  width: 64px;\n}\n.center-content .form-wrapper {\n  padding: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content {\n  margin-top: 16px;\n  margin-bottom: 32px;\n}\n.center-content .form-wrapper .desc-reset-pass-content #desc-reset-pass {\n  color: #1D1D1D;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email-title {\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.center-content .form-wrapper .input-email {\n  margin-top: 4px;\n}\n.center-content .form-wrapper .button-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n.center-content .form-wrapper .button-content .btn-cancel {\n  margin-right: 16px;\n}\n.password-check-list {\n  margin-top: 24px;\n}\n.password-check-list .password-at-least {\n  color: #1d1d1d;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.password-check-list .indicators-password .indicator-item {\n  line-height: 16px;\n  font-size: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin-top: 8px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper {\n  height: 16px;\n  width: 16px;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-reach {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(240) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .icon-wrapper .icon-unreach {\n  height: 16px;\n  width: 16px;\n  background-image: url(" + __webpack_require__(241) + ");\n  background-repeat: no-repeat;\n}\n.password-check-list .indicators-password .indicator-item .text {\n  margin-left: 8px;\n  letter-spacing: 0.1px;\n  color: #1d1d1d;\n}\n/* Hide HTML5 Up and Down arrows. */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n.multiselect--active {\n  z-index: 1000;\n}\n.ap-modal .modal-content {\n  min-height: 100%;\n  height: auto;\n  border: 1px solid #E6E6E6;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n}\n.ap-modal .modal-backdrop.show {\n  opacity: 0.3;\n}\n.ems-header-column {\n  position: relative;\n}\n.ems-header-column .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.ems-header-column .content .icon-sort {\n  margin-top: 2px;\n  margin-left: 8px;\n  height: 12px;\n  width: 12px;\n}\n.ems-header-column .non-sort {\n  background: url(" + __webpack_require__(242) + ") center no-repeat;\n}\n.ems-header-column .sort-up {\n  background: url(" + __webpack_require__(243) + ") center no-repeat;\n}\n.ems-header-column .sort-down {\n  background: url(" + __webpack_require__(244) + ") center no-repeat;\n}\n.ems-header-column .resize-line {\n  position: absolute;\n  width: 1px;\n  height: 16px;\n  right: 1px;\n  top: 0;\n  background-color: #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ems-header-column .resize-line:hover {\n  cursor: col-resize;\n}\n.ems-input-wrapper .input {\n  height: 32px;\n  margin-top: 4px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  width: 100%;\n  padding-left: 16px;\n  color: #424242;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ems-input-wrapper .input.error {\n  border: 1px solid #FF3400;\n}\n.ems-input-wrapper .input.success {\n  border: 1px solid #68B814;\n}\n.ems-input-wrapper .input.warning {\n  border: 1px solid #E89819;\n}\n.infinite-status-prompt {\n  display: none;\n}\n.toast-container > .toast-info {\n  background-color: #0080a5 !important;\n}\n.toast-container > .toast-error {\n  background-color: #FF3400 !important;\n}\n.toast-container > .toast-success {\n  background-color: #68B814 !important;\n}\n.toast-container > .toast-warning {\n  background-color: #E89819 !important;\n}\n.margin-top-24px {\n  margin-top: 24px;\n}\n.multiple-select-work-group {\n  position: relative;\n  height: 30px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #FFF;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect {\n  min-height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags {\n  min-height: 30px;\n  padding: 0 40px 0 8px;\n  border: none;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input {\n  color: #9b9b9b;\n  margin-bottom: 0;\n  min-height: 30px;\n  text-align: left;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__input:hover {\n  cursor: pointer;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__placeholder {\n  margin-top: 5px;\n  margin-bottom: 0;\n  padding-top: 0;\n  color: #585858;\n}\n.multiple-select-work-group.multiselect .multiselect__tags .multiselect__single {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n.multiple-select-work-group.multiselect .multiselect__select {\n  height: 30px;\n}\n.multiple-select-work-group.multiselect .multiselect__content-wrapper {\n  border: 1px solid #E6e6e6;\n  border-radius: 4px;\n  margin: 0;\n}\n.dt-paging .item-per-page {\n  float: left;\n}\n.dt-paging .item-per-page .text {\n  float: left;\n}\n.dt-paging .item-per-page .select {\n  float: left;\n}\n.dt-paging .item-per-page .selected-tag {\n  padding: 0 5px !important;\n}\n.dt-paging .item-per-page .dropdown-toggle {\n  width: 60px !important;\n  background-color: #FFF;\n  margin-top: 0;\n}\n.dt-paging .item-per-page .dropdown-toggle:after {\n  position: absolute;\n  right: 5px;\n  top: 10px;\n}\n.dt-paging .item-per-page.show-all .dropdown-toggle {\n  width: 115px !important;\n}\n.dt-paging .item-per-page .dropdown-menu {\n  height: 120px;\n}\n.dt-paging .item-per-page .text {\n  line-height: 30px;\n  padding: 0 5px;\n}\n.dt-paging .item-per-page .open-indicator {\n  position: absolute;\n  top: 12px;\n  bottom: unset;\n}\n.dt-paging .item-per-page .open .open-indicator {\n  top: 15px;\n}\n.dt-paging .select-page-number {\n  width: 300px;\n  margin: 10px auto;\n}\n.dt-paging .select-page-number .page-item a {\n  color: #0080a5;\n}\n.dt-paging .select-page-number .page-item.active a {\n  color: #FFF;\n  border-color: #0080a5;\n  background-color: #0080a5;\n}\n", ""]);

// exports


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DtPaging',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: String,
      default: '25'
    },
    totalItems: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pagingObj: {
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
        totalItems: this.totalItems
      }
    };
  },

  computed: {},
  watch: {
    pagingObj: {
      handler: function handler(newPagingObj) {
        // emit data to parent
        this.$emit('CHANGE_PAGING_OPTIONS', newPagingObj);
      },

      deep: true
    }
  }
});

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-paging" }, [
    _c(
      "div",
      {
        staticClass: "item-per-page",
        class: _vm.pagingObj.itemsPerPage == "SHOW ALL" ? "show-all" : null
      },
      [
        _c("v-select", {
          staticClass: "select",
          attrs: { options: ["25", "50", "SHOW ALL"], searchable: false },
          model: {
            value: _vm.pagingObj.itemsPerPage,
            callback: function($$v) {
              _vm.$set(_vm.pagingObj, "itemsPerPage", $$v)
            },
            expression: "pagingObj.itemsPerPage"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "text" }, [_vm._v(" events on pages.")])
      ],
      1
    ),
    _vm._v(" "),
    _vm.itemsPerPage / _vm.totalItems <= 1
      ? _c(
          "div",
          { staticClass: "select-page-number" },
          [
            _c("b-pagination", {
              attrs: {
                size: "md",
                "total-rows": _vm.totalItems,
                "per-page":
                  _vm.pagingObj.itemsPerPage == "SHOW ALL"
                    ? 10000
                    : parseInt(_vm.pagingObj.itemsPerPage)
              },
              model: {
                value: _vm.pagingObj.currentPage,
                callback: function($$v) {
                  _vm.$set(_vm.pagingObj, "currentPage", $$v)
                },
                expression: "pagingObj.currentPage"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17e9ccf1", esExports)
  }
}

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "datatable" }, [
    _c("div", { staticClass: "dt-list-status" }, [
      _c(
        "div",
        {
          staticClass: "btn-status",
          class: _vm.scrunch ? "active" : null,
          on: {
            click: function($event) {
              _vm.scrunch = !_vm.scrunch
            }
          }
        },
        [
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-status",
          class: !_vm.scrunch ? "active" : null,
          on: {
            click: function($event) {
              _vm.scrunch = !_vm.scrunch
            }
          }
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "line" })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dt-header" }, [
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "13%" },
          on: {
            click: function($event) {
              _vm.setSortOption("name")
            }
          }
        },
        [
          _vm._v("name\n      "),
          this.pagingObj.sortType != "name"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "name" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "name" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "9%" },
          on: {
            click: function($event) {
              _vm.setSortOption("prefDate")
            }
          }
        },
        [
          _vm._v("PREF DATE\n      "),
          this.pagingObj.sortType != "prefDate"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "prefDate" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "prefDate" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "6%" },
          on: {
            click: function($event) {
              _vm.setSortOption("projPart")
            }
          }
        },
        [
          _vm._v("PROJ PART\n      "),
          this.pagingObj.sortType != "projPart"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "projPart" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "projPart" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "16%" },
          on: {
            click: function($event) {
              _vm.setSortOption("fullAddress")
            }
          }
        },
        [
          _vm._v("FULL ADDRESS\n      "),
          this.pagingObj.sortType != "fullAddress"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "fullAddress" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "fullAddress" &&
          !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "8%" },
          on: {
            click: function($event) {
              _vm.setSortOption("eventLocation")
            }
          }
        },
        [
          _vm._v("LOCATION\n      "),
          this.pagingObj.sortType != "eventLocation"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "eventLocation" &&
          this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "eventLocation" &&
          !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "9%" },
          on: {
            click: function($event) {
              _vm.setSortOption("start")
            }
          }
        },
        [
          _vm._v("start\n      "),
          this.pagingObj.sortType != "start"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "start" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "start" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "6%" },
          on: {
            click: function($event) {
              _vm.setSortOption("dur")
            }
          }
        },
        [
          _vm._v("dur\n      "),
          this.pagingObj.sortType != "dur"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "dur" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "dur" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "8%" },
          on: {
            click: function($event) {
              _vm.setSortOption("end")
            }
          }
        },
        [
          _vm._v("end\n      "),
          this.pagingObj.sortType != "end"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "end" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "end" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "6%" },
          on: {
            click: function($event) {
              _vm.setSortOption("tz")
            }
          }
        },
        [
          _vm._v("tz\n      "),
          this.pagingObj.sortType != "tz"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "tz" && this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "tz" && !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          staticStyle: { width: "10%" },
          on: {
            click: function($event) {
              _vm.setSortOption("onSiteContact")
            }
          }
        },
        [
          _vm._v("ON SITE CONTACT\n      "),
          this.pagingObj.sortType != "onSiteContact"
            ? _c("Icon", { staticClass: "sort-icon", attrs: { name: "sort" } })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "onSiteContact" &&
          this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-up" }
              })
            : _vm._e(),
          _vm._v(" "),
          this.pagingObj.sortType == "onSiteContact" &&
          !this.pagingObj.sortReverse
            ? _c("Icon", {
                staticClass: "sort-icon",
                attrs: { name: "sort-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "header-col", staticStyle: { width: "9%" } }, [
        _vm._v(_vm._s("status"))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dt-body", class: _vm.scrunch ? "scrunch" : null },
      [
        _vm._l(_vm.events, function(itemNewEvent, index) {
          return [
            _c("DataTableRow", {
              key: index,
              attrs: {
                editable: _vm.editable,
                viewMode: _vm.viewMode,
                eventStatus: _vm.eventStatus,
                index: index,
                item: itemNewEvent
              }
            })
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b00a92a", esExports)
  }
}

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "related-events-component" }, [
    _c("div", { staticClass: "related-events-header" }, [
      _c("span", [
        _vm._v("\n      Event staffing based on expected participation\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-number more-margin-left" }, [
        _vm._v("\n      Screeners: " + _vm._s(_vm.calScreeners) + "\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-number" }, [
        _vm._v("\n      Coaches: " + _vm._s(_vm.calCoaches) + "\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-number" }, [
        _vm._v("\n      Leads: " + _vm._s(_vm.calLeads) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "related-events-body" }, [
      _c("div", { staticClass: "other-events-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "other-events-header-right" }, [
          _c("div", { staticClass: "other-related-events-info" }, [
            _c("div", { staticClass: "text-related-info" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.countApproved) +
                    " approved events on this date in " +
                    _vm._s(_vm.item.state)
                )
              ]),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.countSubmitted) +
                    " total approved events on this date"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "other-related-events-selection" },
            [
              _vm._l(_vm.selectItems, function(item) {
                return [
                  _c("EventStatusSelection", {
                    staticClass: "menu-item",
                    attrs: { item: item }
                  })
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "other-events-body" },
        [
          _c("TableRelatedEvents", {
            staticClass: "modal-body-changeOrderDetail-event-detail",
            attrs: { editable: false, eventId: _vm.item.id }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "other-events-header-left" }, [
      _c("span", { staticClass: "other-events-title" }, [
        _vm._v("Other event")
      ]),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "other-event-description" }, [
        _c("span", [
          _vm._v(
            "Events pending approval and approved on this day that might impact this one."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f16dac38", esExports)
  }
}

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarDatePickerDataTable_vue__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb9a709_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarDatePickerDataTable_vue__ = __webpack_require__(1516);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1510)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fb9a709"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarDatePickerDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb9a709_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarDatePickerDataTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/CalendarDatePickerDataTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalendarDatePickerDataTable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6fb9a709", Component.options)
  } else {
    hotAPI.reload("data-v-6fb9a709", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2d7904d7", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6fb9a709\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDatePickerDataTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6fb9a709\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDatePickerDataTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\nul[data-v-6fb9a709] {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.date-picker[data-v-6fb9a709] {\n  position: relative;\n  height: 285px;\n}\n.input-wrapper[data-v-6fb9a709] {\n  border: 1px solid #D2D2D2;\n  border-radius: 2px;\n  vertical-align: middle;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 6px 10px 6px 4px;\n  height: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.input[data-v-6fb9a709] {\n  height: 20px;\n  width: 100%;\n  font-size: inherit;\n  padding-left: 4px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n}\n.cancel-btn[data-v-6fb9a709] {\n  height: 14px;\n  width: 14px;\n}\n.date-panel[data-v-6fb9a709] {\n  position: absolute;\n  z-index: 5000;\n  border: 1px solid #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 285px;\n  padding: 5px 10px 10px;\n  background-color: #fff;\n  /*transform: translateY(-250px);*/\n  /*&.edit {*/\n  /*transform: translateY(-250px);*/\n  /*}*/\n}\n.panel-header[data-v-6fb9a709] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  border-bottom: 2px solid #FBFBFB;\n  height: 50px;\n}\n.arrow-left[data-v-6fb9a709],\n.arrow-right[data-v-6fb9a709] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  font-size: 20px;\n  line-height: 2;\n  background-color: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.year-range[data-v-6fb9a709] {\n  font-size: 20px;\n  line-height: 2;\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.year-month-box[data-v-6fb9a709] {\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.type-year[data-v-6fb9a709],\n.type-month[data-v-6fb9a709],\n.date-list[data-v-6fb9a709] {\n  background-color: #fff;\n}\n.date-list[data-v-6fb9a709] {\n  background-color: #ffffff;\n}\n.year-box[data-v-6fb9a709],\n.month-box[data-v-6fb9a709] {\n  -webkit-transition: all ease .1s;\n  transition: all ease .1s;\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n  font-size: 15px;\n  line-height: 2;\n  cursor: pointer;\n  background-color: #fff;\n}\n.year-list[data-v-6fb9a709],\n.month-list[data-v-6fb9a709] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.year-list li[data-v-6fb9a709],\n.month-list li[data-v-6fb9a709] {\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  cursor: pointer;\n  text-align: center;\n  font-size: 20px;\n  width: 33%;\n  padding: 10px 0;\n}\n.year-list li[data-v-6fb9a709]:hover,\n.month-list li[data-v-6fb9a709]:hover {\n  background-color: #6ac1c9;\n  color: #fff;\n}\n.year-list li.selected[data-v-6fb9a709],\n.month-list li.selected[data-v-6fb9a709] {\n  background-color: #0097a7;\n  color: #fff;\n}\n.year-list li.invalid[data-v-6fb9a709],\n.month-list li.invalid[data-v-6fb9a709] {\n  cursor: not-allowed;\n  color: #D2D2D2;\n}\n.date-list[data-v-6fb9a709] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.date-list .valid[data-v-6fb9a709]:hover {\n  background-color: #eee;\n}\n.date-list li[data-v-6fb9a709] {\n  -webkit-transition: all ease .1s;\n  transition: all ease .1s;\n  cursor: pointer;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #fff;\n  position: relative;\n  margin: 2px;\n}\n.date-list li[data-v-6fb9a709]:not(.firstItem) {\n  margin-left: 5px;\n}\n.date-list li .message[data-v-6fb9a709] {\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n  position: relative;\n  height: 30px;\n}\n.date-list li .message.selected .bg[data-v-6fb9a709] {\n  /*background-color: #ff281c;*/\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n}\n.date-list li .message.selected span[data-v-6fb9a709] {\n  color: #151b1e;\n}\n.date-list li .message:not(.selected) .bg[data-v-6fb9a709] {\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n}\n.date-list li .message:not(.selected):hover .bg[data-v-6fb9a709] {\n  background-color: #d8d8d8;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  opacity: .6;\n}\n.date-list li .message:not(.selected):hover span[data-v-6fb9a709] {\n  color: #151b1e;\n}\n.date-list li .message.blocked[data-v-6fb9a709] {\n  background-color: #FF3400;\n  color: #fff;\n}\n.date-list li .message .bg[data-v-6fb9a709] {\n  height: 30px;\n  width: 100%;\n  -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.date-list li .message span[data-v-6fb9a709] {\n  position: absolute;\n  z-index: 20;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n.date-list li.invalid[data-v-6fb9a709] {\n  cursor: not-allowed;\n  color: #D2D2D2;\n}\n.weeks[data-v-6fb9a709] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.weeks li[data-v-6fb9a709] {\n  font-weight: normal;\n}\n.weeks[data-v-6fb9a709],\n.date-list[data-v-6fb9a709] {\n  width: 100%;\n  text-align: center;\n}\n.weeks li[data-v-6fb9a709],\n.date-list li[data-v-6fb9a709] {\n  font-family: \"Open Sans\", sans-serif;\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  line-height: 30px;\n}\n.weeks .preMonth[data-v-6fb9a709],\n.date-list .preMonth[data-v-6fb9a709],\n.weeks .nextMonth[data-v-6fb9a709],\n.date-list .nextMonth[data-v-6fb9a709] {\n  color: #D2D2D2;\n}\n.date-list li[data-v-6fb9a709] {\n  color: #151b1e;\n}\n.date-list .preMonth[data-v-6fb9a709],\n.date-list .nextMonth[data-v-6fb9a709] {\n  color: #D2D2D2;\n}\n.date-list .had-event[data-v-6fb9a709] {\n  height: 4px;\n  width: 4px;\n  background-color: #68B814;\n  position: absolute;\n  right: 2px;\n  top: 2px;\n}\n.toggle-enter[data-v-6fb9a709],\n.toggle-leave-active[data-v-6fb9a709] {\n  opacity: 0;\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n}\n.toggle-enter-active[data-v-6fb9a709],\n.toggle-leave-active[data-v-6fb9a709] {\n  -webkit-transition: all ease .2s;\n  transition: all ease .2s;\n}\n.fade-enter[data-v-6fb9a709],\n.fade-leave-active[data-v-6fb9a709] {\n  opacity: 0;\n  -webkit-transform: scale3d(0, 0, 0);\n          transform: scale3d(0, 0, 0);\n}\n.fade-enter-active[data-v-6fb9a709],\n.fade-leave-active[data-v-6fb9a709] {\n  -webkit-transition: all ease .1s;\n  transition: all ease .1s;\n}\n.arrow-icon[data-v-6fb9a709] {\n  height: 30px;\n  width: 30px;\n  line-height: 30px;\n  border-radius: 50%;\n}\n.arrow-icon .left-icon[data-v-6fb9a709] {\n  z-index: 7;\n  width: 24px;\n  height: 24px;\n  background-color: #00A4D6;\n  color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(394) + ");\n}\n.arrow-icon .right-icon[data-v-6fb9a709] {\n  z-index: 7;\n  width: 24px;\n  height: 24px;\n  background-color: #00A4D6;\n  color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(95) + ") no-repeat center;\n  mask: url(" + __webpack_require__(95) + ") no-repeat center;\n  background: url(" + __webpack_require__(395) + ");\n}\n.arrow-right .arrow-icon[data-v-6fb9a709] {\n  float: right;\n}\n", ""]);

// exports


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_calendar__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_times__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-throw-literal,key-spacing,space-before-function-paren,space-before-blocks,operator-linebreak,keyword-spacing,padded-blocks,one-var,no-unneeded-ternary,object-property-newline,no-duplicate-case,comma-spacing,semi */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'calendar-date-picker-data-table',
  data: function data() {
    var now = new Date();
    var startDate = void 0,
        endDate = void 0;
    if (this.range) {
      startDate = this.value[0] ? new Date(this.value[0]) : now;
      endDate = this.value[1] ? new Date(this.value[1]) : now;
    } else {
      startDate = endDate = this.value ? new Date(this.value) : now;
    }
    return {
      showCancel: false,
      panelState: true,
      panelType: 'date',
      coordinates: {},
      year: endDate.getFullYear(),
      month: endDate.getMonth(),
      date: endDate.getDate(),
      tmpYear: endDate.getFullYear(),
      tmpMonth: endDate.getMonth(),
      tmpStartYear: startDate.getFullYear(),
      tmpStartMonth: startDate.getMonth(),
      tmpStartDate: startDate.getDate(),
      tmpEndYear: endDate.getFullYear(),
      tmpEndMonth: endDate.getMonth(),
      tmpEndDate: endDate.getDate(),
      minYear: Number,
      minMonth: Number,
      minDate: Number,
      maxYear: Number,
      maxMonth: Number,
      maxDate: Number,
      yearList: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 12 }, function (value, index) {
        return new Date().getFullYear() + index;
      }),
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      weekList: [0, 1, 2, 3, 4, 5, 6],
      rangeStart: false,
      dateEnum: {
        month: 0,
        day: 1,
        year: 2
      },
      startDate: '',
      endDate: ''
    };
  },

  props: {
    language: { default: 'en' },
    min: { default: '01/01/2016' },
    max: { default: '31/12/2035' },
    value: {
      type: [String, Array],
      default: ''
    },
    range: {
      type: Boolean,
      default: false
    },
    metaData: {
      type: Object,
      default: null
    },
    showLeft: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    edit: {
      type: Boolean,
      default: false
    },
    lockedDates: {
      type: Array,
      default: []
    },
    selectedDate: {
      type: Object,
      default: __WEBPACK_IMPORTED_MODULE_4_moment___default()()
    },
    dateRangeHasData: {
      type: Array,
      default: []
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */]
  },
  methods: {
    togglePanel: function togglePanel() {
      this.panelState = !this.panelState;
      this.rangeStart = false;
    },
    isSelected: function isSelected(type, item) {
      switch (type) {
        case 'year':
          if (!this.range) return item === this.tmpYear;
          return new Date(item, 0).getTime() >= new Date(this.tmpStartYear, 0).getTime() && new Date(item, 0).getTime() <= new Date(this.tmpEndYear, 0).getTime();
        case 'month':
          if (!this.range) return item === this.tmpMonth && this.year === this.tmpYear;
          return new Date(this.tmpYear, item).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth).getTime() && new Date(this.tmpYear, item).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth).getTime();
        case 'date':
          return item.string === this.selectedDate.format('MM/DD/YYYY');
      }
    },
    chType: function chType(type) {
      this.panelType = type;
    },
    chYearRange: function chYearRange(next) {
      if (next) {
        this.yearList = this.yearList.map(function (i) {
          return i + 12;
        });
      } else {
        this.yearList = this.yearList.map(function (i) {
          return i - 12;
        });
      }
    },
    prevMonthPreview: function prevMonthPreview() {
      this.tmpMonth = this.tmpMonth === 0 ? 0 : this.tmpMonth - 1;
    },
    nextMonthPreview: function nextMonthPreview() {
      this.tmpMonth = this.tmpMonth === 11 ? 11 : this.tmpMonth + 1;
    },
    selectYear: function selectYear(year) {
      if (this.validateYear(year)) return;
      this.tmpYear = year;
      this.panelType = 'month';
    },
    selectMonth: function selectMonth(month) {
      if (this.validateMonth(month)) return;
      this.tmpMonth = month;
      this.panelType = 'date';
    },
    selectDate: function selectDate(date) {
      var _this = this;

      setTimeout(function () {
        if (_this.validateDate(date)) return;
        if (date.previousMonth) {
          if (_this.tmpMonth === 0) {
            _this.year -= 1;
            _this.tmpYear -= 1;
            _this.month = _this.tmpMonth = 11;
          } else {
            _this.month = _this.tmpMonth - 1;
            _this.tmpMonth -= 1;
          }
        } else if (date.nextMonth) {
          if (_this.tmpMonth === 11) {
            _this.year += 1;
            _this.tmpYear += 1;
            _this.month = _this.tmpMonth = 0;
          } else {
            _this.month = _this.tmpMonth + 1;
            _this.tmpMonth += 1;
          }
        }
        if (!_this.range) {
          _this.year = _this.tmpYear;
          _this.month = _this.tmpMonth;
          _this.date = date.value;
          var value = ('0' + (_this.month + 1)).slice(-2) + '/' + ('0' + _this.date).slice(-2) + '/' + _this.tmpYear;
          if (_this.metaData) {
            _this.metaData.value = value;
            _this.$emit('EVENT_GET_ROW_ITEM', _this.metaData);
          }
          _this.$emit('input', value);
          // this.panelState = false
        } else if (_this.range && !_this.rangeStart) {

          _this.tmpEndYear = _this.tmpStartYear = _this.tmpYear;
          _this.tmpEndMonth = _this.tmpStartMonth = _this.tmpMonth;
          _this.tmpEndDate = _this.tmpStartDate = date.value;

          _this.rangeStart = true;
        } else if (_this.range && _this.rangeStart) {

          _this.tmpEndYear = _this.tmpYear;
          _this.tmpEndMonth = _this.tmpMonth;
          _this.tmpEndDate = date.value;

          var d1 = new Date(_this.tmpStartYear, _this.tmpStartMonth, _this.tmpStartDate).getTime(),
              d2 = new Date(_this.tmpEndYear, _this.tmpEndMonth, _this.tmpEndDate).getTime();
          if (d1 > d2) {
            var tmpY = void 0,
                tmpM = void 0,
                tmpD = void 0;
            tmpY = _this.tmpEndYear;
            tmpM = _this.tmpEndMonth;
            tmpD = _this.tmpEndDate;

            _this.tmpEndYear = _this.tmpStartYear;
            _this.tmpEndMonth = _this.tmpStartMonth;
            _this.tmpEndDate = _this.tmpStartDate;

            _this.tmpStartYear = tmpY;
            _this.tmpStartMonth = tmpM;
            _this.tmpStartDate = tmpD;
          }
          var RangeStart = ('0' + (_this.tmpStartMonth + 1)).slice(-2) + '/' + ('0' + _this.tmpStartDate).slice(-2) + '/' + _this.tmpStartYear;
          var RangeEnd = ('0' + (_this.tmpEndMonth + 1)).slice(-2) + '/' + ('0' + _this.tmpEndDate).slice(-2) + '/' + _this.tmpEndYear;

          var _value = [RangeStart, RangeEnd];
          if (_this.metaData) {
            _this.metaData.value = _value;
            _this.$emit('EVENT_GET_ROW_ITEM', _this.metaData);
          }
          _this.$emit('input', _value);

          _this.rangeStart = false;
          // this.panelState = false;
        }

        _this.$emit('selectDate', date.string);
      }, 0);
    },
    validateYear: function validateYear(year) {
      return year > this.maxYear || year < this.minYear;
    },
    validateMonth: function validateMonth(month) {
      return !(new Date(this.tmpYear, month).getTime() >= new Date(this.minYear, this.minMonth - 1).getTime() && new Date(this.tmpYear, month).getTime() <= new Date(this.maxYear, this.maxMonth - 1).getTime());
    },
    validateDate: function validateDate(date) {
      var mon = this.tmpMonth;
      if (date.previousMonth) {
        mon -= 1;
      } else if (date.nextMonth) {
        mon += 1;
      }
      return !(new Date(this.tmpYear, mon, date.value).getTime() >= new Date(this.minYear, this.minMonth - 1, this.minDate).getTime() && new Date(this.tmpYear, mon, date.value).getTime() <= new Date(this.maxYear, this.maxMonth - 1, this.maxDate).getTime());
    },
    close: function close(e) {
      if (!this.$el.contains(e.target)) {
        // this.panelState = false;
        this.rangeStart = false;
      }
    },
    clear: function clear() {
      this.$emit('input', this.range ? ['', ''] : '');
    },
    setToday: function setToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      var today = {
        currentMonth: true,
        string: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('MM/DD/YYYY'),
        value: __WEBPACK_IMPORTED_MODULE_4_moment___default()().date()
      };
      this.selectDate(today);
      var startDate = void 0;
      var endDate = void 0;
      startDate = endDate = this.value ? new Date(this.value) : new Date();
      this.year = endDate.getFullYear();
      this.month = endDate.getMonth();
      this.date = endDate.getDate();
      this.tmpYear = endDate.getFullYear();
      this.tmpMonth = endDate.getMonth();
      this.tmpStartYear = startDate.getFullYear();
      this.tmpStartMonth = startDate.getMonth();
      this.tmpStartDate = startDate.getDate();
      this.tmpEndYear = endDate.getFullYear();
      this.tmpEndMonth = endDate.getMonth();
      this.tmpEndDate = endDate.getDate();
    },
    drawThisMonth: function drawThisMonth() {
      var _this2 = this;

      var currentMonthLength = new Date(this.tmpYear, this.tmpMonth + 1, 0).getDate();
      var dateList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: currentMonthLength }, function (val, index) {
        return {
          currentMonth: true,
          value: index + 1,
          string: ('0' + (_this2.tmpMonth + 1)).slice(-2) + '/' + ('0' + (index + 1)).slice(-2) + '/' + _this2.tmpYear
        };
      });
      var startDay = new Date(this.tmpYear, this.tmpMonth, 1).getDay();
      var previousMongthLength = new Date(this.tmpYear, this.tmpMonth, 0).getDate();

      for (var i = 0, len = startDay; i < len; i++) {
        dateList = [{
          previousMonth: true,
          value: previousMongthLength - i,
          string: ('0' + (this.tmpMonth === 0 ? 12 : this.tmpMonth)).slice(-2) + '/' + ('0' + (previousMongthLength - i)).slice(-2) + '/' + (this.tmpMonth === 0 ? this.tmpYear - 1 : this.tmpYear)
        }].concat(dateList);
      }
      for (var _i = dateList.length, item = 1; _i < 42; _i++, item++) {
        dateList[dateList.length] = {
          nextMonth: true,
          value: item,
          string: ('0' + (this.tmpMonth === 11 ? 1 : this.tmpMonth + 2)).slice(-2) + '/' + ('0' + item).slice(-2) + '/' + (this.tmpMonth === 11 ? this.tmpYear + 1 : this.tmpYear)
        };
      }
      this.startDate = dateList[0].string;
      this.endDate = dateList[dateList.length - 1].string;
      this.$emit('getDateRangeHasData', {
        startDate: dateList[0].string,
        endDate: dateList[dateList.length - 1].string
      });
      return dateList;
    }
  },
  watch: {
    min: function min(v) {
      var minArr = v.split('/');
      this.minYear = Number(minArr[this.dateEnum.year]);
      this.minMonth = Number(minArr[this.dateEnum.month]);
      this.minDate = Number(minArr[this.dateEnum.day]);
    },
    max: function max(v) {
      var maxArr = v.split('/');
      this.maxYear = Number(maxArr[this.dateEnum.year]);
      this.maxMonth = Number(maxArr[this.dateEnum.month]);
      this.maxDate = Number(maxArr[this.dateEnum.day]);
    },
    range: function range(newVal, oldVal) {
      if (newVal === oldVal) return;
      if (newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'String') {
        this.$emit('input', ['', '']);
      }
      if (!newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'Array') {
        this.$emit('input', '');
      }
    },
    dateList: function dateList() {
      this.$emit('getDateRangeHasData', {
        startDate: this.startDate,
        endDate: this.endDate
      });
    }
  },
  computed: {
    dateList: function dateList() {
      return this.drawThisMonth();
    }
  },
  filters: {
    week: function week(item, lang) {
      switch (lang) {
        case 'en':
          return { 0: 'Su', 1: 'Mo', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sa' }[item];
        default:
          return item;
      }
    },
    month: function month(item, lang) {
      switch (lang) {
        case 'en':
          return {
            1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
            7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December'
          }[item];
        default:
          return item;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.placeholder) {
      this.$emit('input', this.placeholder);
    }
    this.$nextTick(function () {
      if (_this3.showLeft) {
        _this3.coordinates = { left: '0', top: window.getComputedStyle(_this3.$el.children[0]).offsetHeight + 4 + 'px' };
      } else if (_this3.$el.parentNode.offsetWidth + _this3.$el.parentNode.offsetLeft - _this3.$el.offsetLeft <= 300) {
        _this3.coordinates = { right: '0', top: window.getComputedStyle(_this3.$el.children[0]).offsetHeight + 4 + 'px' };
      } else {
        _this3.coordinates = { left: '0', top: window.getComputedStyle(_this3.$el.children[0]).offsetHeight + 4 + 'px' };
      }
      var minArr = _this3.min.split('/');
      _this3.minYear = Number(minArr[_this3.dateEnum.year]);
      _this3.minMonth = Number(minArr[_this3.dateEnum.month]);
      _this3.minDate = Number(minArr[_this3.dateEnum.day]);

      var maxArr = _this3.max.split('/');
      _this3.maxYear = Number(maxArr[_this3.dateEnum.year]);
      _this3.maxMonth = Number(maxArr[_this3.dateEnum.month]);
      _this3.maxDate = Number(maxArr[_this3.dateEnum.day]);

      if (_this3.range) {
        if (Object.prototype.toString.call(_this3.value).slice(8, -1) !== 'Array') {
          throw new Error('Binding value must be an array in range mode.');
        }
        if (_this3.value.length) {
          var rangeStart = _this3.value[0].split('/');
          var rangeEnd = _this3.value[1].split('/');
          _this3.tmpStartYear = Number(rangeStart[_this3.dateEnum.year]);
          _this3.tmpStartMonth = Number(rangeStart[_this3.dateEnum.month]) - 1;
          _this3.tmpStartDate = Number(rangeStart[_this3.dateEnum.day]);

          _this3.tmpEndYear = Number(rangeEnd[_this3.dateEnum.year]);
          _this3.tmpEndMonth = Number(rangeEnd[_this3.dateEnum.month]) - 1;
          _this3.tmpEndDate = Number(rangeEnd[_this3.dateEnum.day]);
        } else {
          _this3.$emit('input', ['', '']);
        }
      }
      //        if (!this.value) {
      //          this.$emit('input', '')
      //        }
      window.addEventListener('click', _this3.close);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('click', this.close);
  },
  created: function created() {
    this.$bus.$on('set-today', this.setToday);
  }
});

/***/ }),
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-picker" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.panelState,
            expression: "panelState"
          }
        ],
        staticClass: "date-panel",
        class: { edit: _vm.edit },
        style: _vm.coordinates
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType !== "year",
                expression: "panelType !== 'year'"
              }
            ],
            staticClass: "panel-header"
          },
          [
            _c(
              "div",
              {
                staticClass: "arrow-left",
                on: {
                  click: function($event) {
                    _vm.prevMonthPreview()
                  }
                }
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "year-month-box" }, [
              _c(
                "div",
                {
                  staticClass: "month-box",
                  on: {
                    click: function($event) {
                      _vm.chType("month")
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("month")(_vm.tmpMonth + 1, _vm.language))
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "year-box",
                domProps: { textContent: _vm._s(_vm.tmpYear) },
                on: {
                  click: function($event) {
                    _vm.chType("year")
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "arrow-right",
                on: {
                  click: function($event) {
                    _vm.nextMonthPreview()
                  }
                }
              },
              [_vm._m(1)]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "year",
                expression: "panelType === 'year'"
              }
            ],
            staticClass: "panel-header"
          },
          [
            _c(
              "div",
              {
                staticClass: "arrow-left",
                on: {
                  click: function($event) {
                    _vm.chYearRange(0)
                  }
                }
              },
              [_vm._m(2)]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "year-range" }, [
              _c("span", {
                domProps: { textContent: _vm._s(_vm.yearList[0]) }
              }),
              _vm._v(" - "),
              _c("span", {
                domProps: {
                  textContent: _vm._s(_vm.yearList[_vm.yearList.length - 1])
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "arrow-right",
                on: {
                  click: function($event) {
                    _vm.chYearRange(1)
                  }
                }
              },
              [_vm._m(3)]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "year",
                expression: "panelType === 'year'"
              }
            ],
            staticClass: "type-year"
          },
          [
            _c(
              "ul",
              { staticClass: "year-list" },
              _vm._l(_vm.yearList, function(item) {
                return _c("li", {
                  class: {
                    selected: _vm.isSelected("year", item),
                    invalid: _vm.validateYear(item)
                  },
                  domProps: { textContent: _vm._s(item) },
                  on: {
                    click: function($event) {
                      _vm.selectYear(item)
                    }
                  }
                })
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "month",
                expression: "panelType === 'month'"
              }
            ],
            staticClass: "type-month"
          },
          [
            _c(
              "ul",
              { staticClass: "month-list" },
              _vm._l(_vm.monthList, function(item, index) {
                return _c(
                  "li",
                  {
                    class: {
                      selected: _vm.isSelected("month", index),
                      invalid: _vm.validateMonth(index)
                    },
                    on: {
                      click: function($event) {
                        _vm.selectMonth(index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("month")(item, _vm.language)) +
                        "\n        "
                    )
                  ]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "date",
                expression: "panelType === 'date'"
              }
            ],
            staticClass: "type-date"
          },
          [
            _c(
              "ul",
              { staticClass: "weeks" },
              _vm._l(_vm.weekList, function(item) {
                return _c("li", [
                  _vm._v(_vm._s(_vm._f("week")(item, _vm.language)))
                ])
              })
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "date-list" },
              _vm._l(_vm.dateList, function(item, index) {
                return _c(
                  "li",
                  {
                    class: {
                      preMonth: item.previousMonth,
                      nextMonth: item.nextMonth,
                      invalid: _vm.validateDate(item),
                      firstItem: index % 7 === 0
                    },
                    on: {
                      click: function($event) {
                        _vm.selectDate(item)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "message",
                        class: {
                          selected: _vm.isSelected("date", item),
                          blocked: _vm.lockedDates.indexOf(item.string) >= 0
                        }
                      },
                      [
                        _vm.dateRangeHasData.indexOf(item.string) >= 0
                          ? _c("div", { staticClass: "had-event" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "bg" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { textContent: _vm._s(item.value) }
                        })
                      ]
                    )
                  ]
                )
              })
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "left-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "right-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "left-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "right-icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6fb9a709", esExports)
  }
}

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = abbrState;
function abbrState(input, to) {
  var states = [['Arizona', 'AZ'], ['Alabama', 'AL'], ['Alaska', 'AK'], ['Arkansas', 'AR'], ['California', 'CA'], ['Colorado', 'CO'], ['Connecticut', 'CT'], ['Delaware', 'DE'], ['District Of Columbia', 'DC'], ['Florida', 'FL'], ['Georgia', 'GA'], ['Hawaii', 'HI'], ['Idaho', 'ID'], ['Illinois', 'IL'], ['Indiana', 'IN'], ['Iowa', 'IA'], ['Kansas', 'KS'], ['Kentucky', 'KY'], ['Louisiana', 'LA'], ['Maine', 'ME'], ['Maryland', 'MD'], ['Massachusetts', 'MA'], ['Michigan', 'MI'], ['Minnesota', 'MN'], ['Mississippi', 'MS'], ['Missouri', 'MO'], ['Montana', 'MT'], ['Nebraska', 'NE'], ['Nevada', 'NV'], ['New Hampshire', 'NH'], ['New Jersey', 'NJ'], ['New Mexico', 'NM'], ['New York', 'NY'], ['North Carolina', 'NC'], ['North Dakota', 'ND'], ['Ohio', 'OH'], ['Oklahoma', 'OK'], ['Oregon', 'OR'], ['Pennsylvania', 'PA'], ['Rhode Island', 'RI'], ['South Carolina', 'SC'], ['South Dakota', 'SD'], ['Tennessee', 'TN'], ['Texas', 'TX'], ['Utah', 'UT'], ['Vermont', 'VT'], ['Virginia', 'VA'], ['Washington', 'WA'], ['West Virginia', 'WV'], ['Wisconsin', 'WI'], ['Wyoming', 'WY']];

  if (to === 'abbr') {
    input = input.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    for (var i = 0; i < states.length; i++) {
      if (states[i][0] === input) {
        return states[i][1];
      }
    }
  } else if (to === 'name') {
    input = input.toUpperCase();
    for (var _i = 0; _i < states.length; _i++) {
      if (states[_i][1] === input) {
        return states[_i][0];
      }
    }
  }
}

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'VueGoogleAutocomplete',

  props: {
    id: {
      type: String,
      required: true
    },

    classname: String,

    placeholder: {
      type: String,
      default: 'Start typing'
    },

    types: {
      type: String,
      default: 'address'
    },

    country: {
      type: [String, Array],
      default: null
    },

    enableGeolocation: {
      type: Boolean,
      default: false
    },

    item: {
      type: Object
    },

    disable: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      /**
       * The Autocomplete object.
       *
       * @type {Autocomplete}
       * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
       */
      autocomplete: null,

      /**
       * Autocomplete input text
       * @type {String}
       */
      //        autocompleteText: '',

      isInPlaceChanged: false
    };
  },

  computed: {
    autocompleteText: function autocompleteText() {
      return this.id.indexOf('shipping_') >= 0 ? this.item && this.item.shippingAddress : this.item && this.item.fullAddress || '';
    }
  },

  watch: {
    autocompleteText: function autocompleteText(newVal, oldVal) {
      this.$emit('inputChange', { newVal: newVal, oldVal: oldVal });
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (this.disable) {
      return;
    }

    var options = {};

    if (this.types) {
      options.types = [this.types];
    }

    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }

    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

    this.autocomplete.addListener('place_changed', function () {

      _this.isInPlaceChanged = true;

      var place = _this.autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        _this.$emit('no-results-found', place);
        _this.isInPlaceChanged = false;
        return;
      }

      var addressComponents = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      };

      var returnData = {};

      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];

          if (addressComponents[addressType]) {
            var val = place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }

        returnData['latitude'] = place.geometry.location.lat();
        returnData['longitude'] = place.geometry.location.lng();

        // return returnData object and PlaceResult object
        _this.$emit('placechanged', returnData, place, _this.id);

        // update autocompleteText then emit change event
        _this.autocompleteText = document.getElementById(_this.id).value;
        // this.onChange();
      }
    });
  },

  methods: {
    /**
     * When the input gets focus
     */
    onFocus: function onFocus() {
      this.geolocate();
      this.$emit('focus');
    },


    /**
     * When the input loses focus
     */
    onBlur: function onBlur() {
      this.$emit('blur');
    },


    /**
     * When the input got changed
     */
    onChange: function onChange() {
      var _this2 = this;

      setTimeout(function () {
        if (!_this2.isInPlaceChanged) {
          _this2.$emit('change', document.getElementById(_this2.id).value);
        }
        _this2.isInPlaceChanged = false;
      }, 400);
    },


    /**
     * When a key gets pressed
     * @param  {Event} event A keypress event
     */
    onKeyPress: function onKeyPress(event) {
      this.$emit('keypress', event);
    },


    /**
     * Clear the input
     */
    clear: function clear() {
      this.autocompleteText = '';
    },


    /**
     * Focus the input
     */
    focus: function focus() {
      this.$refs.autocomplete.focus();
    },


    /**
     * Blur the input
     */
    blur: function blur() {
      this.$refs.autocomplete.blur();
    },


    /**
     * Update the value of the input
     * @param  {String} value
     */
    update: function update(value) {
      this.autocompleteText = value;
    },


    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate: function geolocate() {
      var _this3 = this;

      if (this.enableGeolocation) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            _this3.autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    }
  }
};

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "autocomplete",
    class: _vm.classname,
    attrs: {
      type: "text",
      id: _vm.id,
      placeholder: _vm.placeholder,
      disable: _vm.disable
    },
    domProps: { value: _vm.autocompleteText },
    on: {
      focus: function($event) {
        _vm.onFocus()
      },
      blur: function($event) {
        _vm.onBlur()
      },
      change: _vm.onChange,
      keypress: _vm.onKeyPress
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-520c1b11", esExports)
  }
}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1521);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("42728757", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f55ba174\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0!./Dropdown.vue", function() {
     var newContent = require("!!../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f55ba174\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0!./Dropdown.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.btn-group {\n  min-width: 160px;\n  height: 40px;\n  position: relative;\n  margin: 10px 1px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group a:hover {\n  text-decoration: none;\n}\n.dropdown-toggle {\n  color: #636b6f;\n  min-width: 160px;\n  padding: 10px 20px 10px 10px;\n  text-transform: none;\n  font-weight: 300;\n  margin-bottom: 7px;\n  border: 0;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#009688), to(#009688)), -webkit-gradient(linear, left top, left bottom, from(#D2D2D2), to(#D2D2D2));\n  background-image: linear-gradient(#009688, #009688), linear-gradient(#D2D2D2, #D2D2D2);\n  background-size: 0 2px, 100% 1px;\n  background-repeat: no-repeat;\n  background-position: center bottom, center calc(100% - 1px);\n  background-color: transparent;\n  -webkit-transition: background 0s ease-out;\n  transition: background 0s ease-out;\n  float: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.dropdown-toggle:hover {\n  background: #e1e1e1;\n  cursor: pointer;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  list-style: none;\n  font-size: 14px;\n  text-align: left;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n}\n.dropdown-menu > li > a {\n  padding: 10px 30px;\n  display: block;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.6;\n  color: #333333;\n  white-space: nowrap;\n  text-decoration: none;\n}\n.dropdown-menu > li > a:hover {\n  background: #efefef;\n  color: #409FCB;\n}\n.dropdown-menu > li {\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n  margin: 0;\n}\n.caret {\n  width: 0;\n  position: absolute;\n  top: 19px;\n  height: 0;\n  margin-left: -24px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n  right: 10px;\n}\nli {\n    list-style: none;\n}\n", ""]);

// exports


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            selectedOption: {
                name: ''
            },
            showMenu: false,
            placeholderText: 'Please select an item'
        };
    },

    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
        placeholder: [String],
        closeOnOutsideClick: {
            type: [Boolean],
            default: true
        }
    },

    mounted: function mounted() {
        this.selectedOption = this.selected;
        if (this.placeholder) {
            this.placeholderText = this.placeholder;
        }

        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.clickHandler);
        }
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('click', this.clickHandler);
    },


    methods: {
        updateOption: function updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu: function toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        clickHandler: function clickHandler(event) {
            var target = event.target;
            var $el = this.$el;


            if (!$el.contains(target)) {
                this.showMenu = false;
            }
        }
    }
});

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "btn-group" }, [
    _vm.selectedOption.name !== undefined
      ? _c(
          "li",
          {
            staticClass: "dropdown-toggle",
            on: {
              click: function($event) {
                _vm.toggleMenu()
              }
            }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.selectedOption.name) + "\n      "),
            _c("span", { staticClass: "caret" })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedOption.name === undefined
      ? _c(
          "li",
          {
            staticClass: "dropdown-toggle dropdown-toggle-placeholder",
            on: {
              click: function($event) {
                _vm.toggleMenu()
              }
            }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.placeholderText) + "\n      "),
            _c("span", { staticClass: "caret" })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showMenu
      ? _c(
          "ul",
          { staticClass: "dropdown-menu" },
          _vm._l(_vm.options, function(option, idx) {
            return _c("li", { key: idx }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function($event) {
                      _vm.updateOption(option)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(option.name) +
                      "\n            "
                  )
                ]
              )
            ])
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f55ba174", esExports)
  }
}

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dt-row" },
    [
      _c(
        "div",
        {
          staticClass: "dt-row-detail active",
          attrs: { id: "searchBoxContainer-" + _vm.item.index }
        },
        [
          _vm.columnWidth.eventName.show
            ? _c(
                "div",
                {
                  staticClass: "body-col event-name",
                  style: {
                    width: _vm.columnWidth.eventName.size
                      ? _vm.columnWidth.eventName.size + "px"
                      : "12%"
                  },
                  attrs: { block: "" }
                },
                [
                  _c("div", { staticClass: "client-name" }, [
                    _vm.viewMode != "Client"
                      ? _c("span", [_vm._v(_vm._s(_vm.item.clientName))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _c(
                      "div",
                      {
                        staticClass: "icon-expand",
                        class: _vm.item.id != _vm.expandId ? "collapsed" : null,
                        attrs: {
                          "aria-controls": _vm.accordionId,
                          "aria-expanded":
                            _vm.item.id === _vm.expandId ? "true" : "false"
                        },
                        on: {
                          click: function($event) {
                            _vm.setExpandId()
                            _vm.item.showCollapse = !_vm.item.showCollapse
                          }
                        }
                      },
                      [
                        _vm.item.status === "DRAFTS"
                          ? _c("div", { staticClass: "icon-draft" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.status === "SUBMITTED"
                          ? _c("div", { staticClass: "icon-submitted" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.status === "REVIEW"
                          ? _c("div", { staticClass: "icon-review" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.status === "APPROVED"
                          ? _c("div", { staticClass: "icon-approved" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.status === "ARCHIVED"
                          ? _c("div", { staticClass: "icon-archived" })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "icon-circle" },
                      [
                        _vm.item.isChangeOrder
                          ? _c("Icon", {
                              staticClass:
                                "row-detail-icon row-detail-icon-exclamation-circle circle-red",
                              attrs: { name: "exclamation-circle" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isEM &&
                    _vm.eventStatus.toLowerCase() ==
                      _vm.listEventStatus.approved
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.eventName,
                              expression: "item.eventName"
                            }
                          ],
                          staticClass:
                            "data-table-row-edit-mode-text data-table-row-edit-mode-input-small",
                          attrs: { disabled: _vm.isLocked },
                          domProps: { value: _vm.item.eventName },
                          on: {
                            blur: function($event) {
                              _vm.eventNameBlur(_vm.eventFields.eventName)
                              _vm.unlockEvent()
                            },
                            focus: function($event) {
                              _vm.lockEvent()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "eventName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", { staticClass: "event-name-no-edit" }, [
                          _vm._v(_vm._s(_vm.item.eventName || _vm.eventName))
                        ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.columnWidth.prefDate.show
            ? _c(
                "div",
                {
                  staticClass: "body-col overflow-show",
                  style: {
                    width: _vm.columnWidth.prefDate.size
                      ? _vm.columnWidth.prefDate.size + "px"
                      : "9%"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "data-table-icon-circle",
                      style: _vm.requiredPrefDate ? { display: "block" } : ""
                    },
                    [
                      _vm.requiredPrefDate
                        ? _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "pref-date-body-col label-text",
                      class: { "place-holder": !_vm.item.prefDate },
                      on: {
                        click: function($event) {
                          _vm.toggleShowDateTimePicker()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.item.prefDate ? _vm.item.prefDate : "MM/DD/YYYY"
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showDateTimePicker
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            position: "absolute",
                            right: "206px",
                            top: "64px"
                          }
                        },
                        [
                          _c("CalendarDatePickerDataTable", {
                            attrs: {
                              showLeft: true,
                              lockedDates: _vm.lockedDates,
                              dateRangeHasData: _vm.dateRangeHasData,
                              selectedDate: _vm.selectedDate,
                              value: _vm.item.prefDate,
                              disabled:
                                !_vm.editable || _vm.isLocked || _vm.isUpdating
                            },
                            on: {
                              getDateRangeHasData: _vm.getDateRangeHasData,
                              input: _vm.selectDate,
                              selectDate: _vm.setSelected
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.columnWidth.projPart.show
            ? _c(
                "div",
                {
                  staticClass: "body-col",
                  style: {
                    width: _vm.columnWidth.projPart.size
                      ? _vm.columnWidth.projPart.size + "px"
                      : "5%"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "data-table-icon-circle",
                      style:
                        (_vm.enableIconProjPart && !_vm.isCreateByEM) ||
                        _vm.requiredProjPart
                          ? { display: "block" }
                          : ""
                    },
                    [
                      (_vm.enableIconProjPart && !_vm.isCreateByEM) ||
                      _vm.requiredProjPart
                        ? _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.projPart,
                        expression: "item.projPart"
                      }
                    ],
                    staticClass:
                      "data-table-row-edit-mode-text data-table-row-edit-mode-input-small",
                    attrs: {
                      placeholder: "100",
                      type: "number",
                      disabled: !_vm.editable || _vm.isLocked || _vm.isUpdating
                    },
                    domProps: { value: _vm.item.projPart },
                    on: {
                      blur: function($event) {
                        _vm.unlockEvent()
                        _vm.saveEvent()
                      },
                      focus: function($event) {
                        _vm.lockEvent()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "projPart", $event.target.value)
                      }
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.columnWidth.fullAddress.show
            ? _c(
                "div",
                {
                  staticClass: "body-col body-col-address-bing",
                  style: {
                    width: _vm.columnWidth.fullAddress.size
                      ? _vm.columnWidth.fullAddress.size + "px"
                      : "19%"
                  }
                },
                [
                  _vm.requiredAddress
                    ? _c(
                        "div",
                        {
                          staticClass: "data-table-icon-circle",
                          style: _vm.requiredAddress ? { display: "block" } : ""
                        },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isUsedBingMap
                    ? _c("vue-google-autocomplete", {
                        style: _vm.requiredAddress
                          ? { "margin-left": "5px" }
                          : "",
                        attrs: {
                          name: "address-input",
                          id: "map_" + _vm.index + "-" + _vm.showOnModal,
                          classname:
                            "form-control data-table-row-edit-mode-text address-input" +
                            (_vm.isAddressError ? " address-error" : ""),
                          placeholder: "Address",
                          country: ["us"],
                          item: _vm.item,
                          disabled:
                            !_vm.editable || _vm.isLocked || _vm.isUpdating
                        },
                        on: {
                          placechanged: _vm.setPlace,
                          blur: function($event) {
                            _vm.unlockEvent()
                          },
                          focus: function($event) {
                            _vm.lockEvent()
                          },
                          change: _vm.getValue
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUsedBingMap
                    ? _c("div", [
                        _c("label", {
                          attrs: {
                            for:
                              "searchBox-" +
                              _vm.showOnModal +
                              "-" +
                              _vm.item.index
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.fullAddress,
                              expression: "item.fullAddress"
                            }
                          ],
                          staticClass:
                            "address-input-bing data-table-row-edit-mode-text",
                          attrs: {
                            type: "text",
                            id:
                              "searchBox-" +
                              _vm.showOnModal +
                              "-" +
                              _vm.item.index,
                            placeholder: "Address",
                            disabled:
                              !_vm.editable || _vm.isLocked || _vm.isUpdating
                          },
                          domProps: { value: _vm.item.fullAddress },
                          on: {
                            blur: function($event) {
                              _vm.unlockEvent()
                            },
                            focus: function($event) {
                              _vm.lockEvent()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "fullAddress",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAddressError
                    ? _c("span", { staticClass: "address-error-message" }, [
                        _vm._v(_vm._s(_vm.addressErrorMessage()))
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.columnWidth.building.show
            ? _c(
                "div",
                {
                  staticClass: "body-col",
                  style: {
                    width: _vm.columnWidth.building.size
                      ? _vm.columnWidth.building.size + "px"
                      : "7%"
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.building,
                        expression: "item.building"
                      }
                    ],
                    staticClass: "data-table-row-edit-mode-text",
                    attrs: {
                      placeholder: "Building",
                      disabled: !_vm.editable || _vm.isLocked || _vm.isUpdating
                    },
                    domProps: { value: _vm.item.building },
                    on: {
                      blur: function($event) {
                        _vm.unlockEvent()
                        _vm.saveEvent()
                      },
                      focus: function($event) {
                        _vm.lockEvent()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "building", $event.target.value)
                      }
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.columnWidth.eventLocation.show
            ? _c(
                "div",
                {
                  staticClass: "body-col",
                  style: {
                    width: _vm.columnWidth.eventLocation.size
                      ? _vm.columnWidth.eventLocation.size + "px"
                      : "7%"
                  }
                },
                [
                  _vm.requiredLocation
                    ? _c(
                        "div",
                        {
                          staticClass: "data-table-icon-circle",
                          style: _vm.requiredLocation
                            ? { display: "block" }
                            : ""
                        },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.eventLocation,
                        expression: "item.eventLocation"
                      }
                    ],
                    staticClass: "data-table-row-edit-mode-text",
                    attrs: {
                      placeholder: "Location",
                      disabled: !_vm.editable || _vm.isLocked || _vm.isUpdating
                    },
                    domProps: { value: _vm.item.eventLocation },
                    on: {
                      blur: function($event) {
                        _vm.unlockEvent()
                        _vm.saveEvent()
                      },
                      focus: function($event) {
                        _vm.lockEvent()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "eventLocation", $event.target.value)
                      }
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body-col overflow-show show-dropdown",
              style: {
                width: _vm.columnWidth.startTime.size
                  ? _vm.columnWidth.startTime.size + "px"
                  : "7%"
              },
              on: {
                click: function($event) {
                  _vm.toggleShowTimePicker()
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "data-table-icon-circle",
                  style: _vm.requiredStartTime ? { display: "block" } : ""
                },
                [
                  _vm.requiredStartTime
                    ? _c("Icon", {
                        staticClass:
                          "row-detail-icon row-detail-icon-exclamation-circle",
                        attrs: { name: "exclamation-circle" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.editable
                ? [
                    _c("dropdown", {
                      staticClass: "label-text",
                      class: { "place-holder": !_vm.item.startTime },
                      attrs: {
                        options: _vm.listTime,
                        selected: {
                          name: _vm.item.startTime
                            ? _vm.item.startTime
                            : undefined
                        },
                        placeholder: "Start time"
                      },
                      on: { updateOption: _vm.setStartTime }
                    })
                  ]
                : [_c("span", [_vm._v(_vm._s(_vm.item.startTime))])]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body-col",
              style: {
                width: _vm.columnWidth.duration.size
                  ? _vm.columnWidth.duration.size + "px"
                  : "5%",
                "padding-right": _vm.item.duration.length > 2 ? "5px" : "10px"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "data-table-icon-circle",
                  style:
                    (_vm.enableIconDuration && !_vm.isCreateByEM) ||
                    _vm.requiredDuration
                      ? { display: "block" }
                      : ""
                },
                [
                  (_vm.enableIconDuration && !_vm.isCreateByEM) ||
                  _vm.requiredDuration
                    ? _c("Icon", {
                        staticClass:
                          "row-detail-icon row-detail-icon-exclamation-circle",
                        attrs: { name: "exclamation-circle" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isEM
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.duration,
                        expression: "item.duration"
                      }
                    ],
                    staticClass: "data-table-row-edit-mode-text",
                    style:
                      _vm.item.duration.length > 2
                        ? { width: "22px" }
                        : { width: "15px" },
                    attrs: {
                      placeholder: "0",
                      type: "number",
                      step: "any",
                      disabled: !_vm.editable || _vm.isLocked || _vm.isUpdating
                    },
                    domProps: { value: _vm.item.duration },
                    on: {
                      blur: function($event) {
                        _vm.unlockEvent()
                        _vm.durationBlur(_vm.eventFields.duration)
                      },
                      focus: function($event) {
                        _vm.lockEvent()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "duration", $event.target.value)
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.duration,
                        expression: "item.duration"
                      }
                    ],
                    staticClass: "data-table-row-edit-mode-text",
                    style:
                      _vm.item.duration.length > 2
                        ? { width: "22px" }
                        : { width: "15px" },
                    attrs: {
                      placeholder: "0",
                      type: "number",
                      step: "any",
                      disabled:
                        !_vm.editable || _vm.isLocked || _vm.disableDuration
                    },
                    domProps: { value: _vm.item.duration },
                    on: {
                      blur: function($event) {
                        _vm.unlockEvent()
                        _vm.durationBlur(_vm.eventFields.duration)
                      },
                      focus: function($event) {
                        _vm.lockEvent()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "duration", $event.target.value)
                      }
                    }
                  }),
              _vm._v(" "),
              _vm.item.duration > 0
                ? _c("span", { staticStyle: { "margin-left": "-3px" } }, [
                    _vm._v("HR")
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body-col col-end-time",
              style: {
                width: _vm.columnWidth.endTime.size
                  ? _vm.columnWidth.endTime.size + "px"
                  : "7%"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "label-text",
                  class: { "place-holder": !_vm.item.startTime }
                },
                [_vm._v(_vm._s(_vm.calculateTimeEnd))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body-col",
              style: {
                width: _vm.columnWidth.timeZone.size
                  ? _vm.columnWidth.timeZone.size + "px"
                  : "4%"
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.item.timeZone,
                    expression: "item.timeZone"
                  }
                ],
                staticClass: "data-table-row-edit-mode-text",
                attrs: {
                  placeholder: "EST",
                  disabled: !_vm.editable || _vm.isLocked || _vm.isUpdating
                },
                domProps: { value: _vm.item.timeZone },
                on: {
                  blur: function($event) {
                    _vm.unlockEvent()
                    _vm.saveEvent()
                  },
                  focus: function($event) {
                    _vm.lockEvent()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.item, "timeZone", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body-col overflow-show",
              style: {
                width: _vm.columnWidth.contactName.size
                  ? _vm.columnWidth.contactName.size + "px"
                  : "9%"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "data-table-icon-circle",
                  style:
                    (_vm.disableIconContact && !_vm.isCreateByEM) ||
                    _vm.requiredContactName
                      ? { display: "block" }
                      : ""
                },
                [
                  (_vm.disableIconContact && !_vm.isCreateByEM) ||
                  _vm.requiredContactName
                    ? _c("Icon", {
                        staticClass:
                          "row-detail-icon row-detail-icon-exclamation-circle",
                        attrs: { name: "exclamation-circle" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.editable || !_vm.isLocked
                ? _c("multiselect", {
                    staticClass: "col-contact",
                    style:
                      (_vm.disableIconContact && !_vm.isCreateByEM) ||
                      _vm.requiredContactName
                        ? { "margin-left": "8px" }
                        : "",
                    attrs: {
                      options: _vm.onSiteContacts,
                      placeholder: "Select contact",
                      value: _vm.item.contactName,
                      label: "contactName",
                      "allow-empty": true,
                      "show-no-results": false,
                      searchable: !_vm.isLocked,
                      "show-labels": false
                    },
                    on: {
                      open: function($event) {
                        _vm.lockEvent()
                      },
                      "search-change": _vm.searchContact,
                      input: _vm.selectOnSiteContact,
                      close: _vm.closeOnsiteContact
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "contact-detail" }, [
                              _c("span", {
                                staticClass: "contact-name-decoration",
                                domProps: {
                                  innerHTML: _vm._s(
                                    props.option.contactNameDecoration
                                  )
                                }
                              }),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      props.option.contactEmail
                                        ? props.option.contactEmail
                                        : "N/A"
                                    ) +
                                    " ,\n              " +
                                    _vm._s(
                                      props.option.contactPhone
                                        ? props.option.contactPhone
                                        : "N/A"
                                    )
                                )
                              ])
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.item.contact,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "contact", $$v)
                      },
                      expression: "item.contact"
                    }
                  })
                : [_c("span", [_vm._v(_vm._s(_vm.item.contactName))])]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body-col",
              style: {
                width: _vm.columnWidth.action.size
                  ? _vm.columnWidth.action.size + "px"
                  : "9%"
              }
            },
            [
              _vm.viewMode === "Client"
                ? _c("div", [
                    !_vm.item.showCollapse &&
                    _vm.eventStatus == _vm.listEventStatus.drafts
                      ? _c("div", [
                          _c("div", { staticClass: "icon-wrapper" }, [
                            _c("div", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.bottom",
                                  modifiers: { hover: true, bottom: true }
                                }
                              ],
                              staticClass: "icon-delete",
                              attrs: {
                                title: _vm.instructions.delete,
                                name: _vm.iconNames.trashO
                              },
                              on: {
                                click: function($event) {
                                  _vm.deleteEventClick()
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-wrapper" }, [
                            _c("div", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.bottom",
                                  modifiers: { hover: true, bottom: true }
                                }
                              ],
                              staticClass: "icon-duplicate",
                              attrs: {
                                title: _vm.instructions.duplicated,
                                name: _vm.iconNames.repeat
                              },
                              on: {
                                click: function($event) {
                                  _vm.duplicateEventClick()
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-wrapper" }, [
                            _c("div", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.bottom",
                                  modifiers: { hover: true, bottom: true }
                                }
                              ],
                              staticClass: "icon-submit",
                              attrs: {
                                title: _vm.instructions.submit,
                                name: _vm.iconNames.chevronRight
                              },
                              on: {
                                click: function($event) {
                                  _vm.submitEventClick()
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.item.showCollapse &&
                    (_vm.eventStatus == _vm.listEventStatus.submitted ||
                      _vm.eventStatus == _vm.listEventStatus.review)
                      ? _c("div", [
                          _c(
                            "span",
                            { style: { visibility: "hidden" } },
                            [
                              _c("Icon", {
                                staticClass:
                                  "row-detail-icon fa-fw icon-actions",
                                attrs: { name: _vm.iconNames.repeat }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isEM
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.rowActionMiddleClick()
                                    }
                                  }
                                },
                                [
                                  _c("Icon", {
                                    staticClass:
                                      "row-detail-icon fa-fw icon-actions",
                                    attrs: { name: _vm.iconNames.chevronRight }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.eventStatus == _vm.listEventStatus.approved &&
                    !_vm.isReadOnly
                      ? _c("div", [
                          _c(
                            "span",
                            {
                              staticClass: "action-change-order",
                              on: {
                                click: function($event) {
                                  _vm.btnChangeOrderClick()
                                }
                              }
                            },
                            [_vm._v("\n            Change Order\n          ")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.item.showCollapse &&
                    _vm.eventStatus == _vm.listEventStatus.archived
                      ? _c("div", [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.deleteEventClick()
                                }
                              }
                            },
                            [
                              _c("Icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.bottom",
                                    modifiers: { hover: true, bottom: true }
                                  }
                                ],
                                staticClass:
                                  "row-detail-icon fa-fw icon-actions",
                                attrs: {
                                  title: _vm.instructions.delete,
                                  name: _vm.iconNames.trashO
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.restoreEvent()
                                }
                              }
                            },
                            [
                              _c("Icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.bottom",
                                    modifiers: { hover: true, bottom: true }
                                  }
                                ],
                                staticClass:
                                  "row-detail-icon fa-fw icon-actions",
                                attrs: {
                                  title: _vm.instructions.restoreToDrafts,
                                  name: _vm.iconNames.refresh
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    [
                      _c("RowStatus", {
                        attrs: { eventStatus: _vm.item.status }
                      })
                    ],
                    1
                  )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: _vm.accordionId, accordion: "datatable-accordion" },
          model: {
            value: _vm.item.showCollapse,
            callback: function($$v) {
              _vm.$set(_vm.item, "showCollapse", $$v)
            },
            expression: "item.showCollapse"
          }
        },
        [
          _c("div", { staticClass: "dt-row-item-detail" }, [
            _c("div", { staticClass: "item-detail-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-3 padding-left-50" }, [
                  _vm._v("alerts")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-4 padding-left-22" }, [
                  _vm._v("event notes")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _vm._v("on site contact")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-2" }, [
                  _vm._v("add on services")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-detail-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-3" }, [
                  _vm.item.isChangeOrder
                    ? _c("div", { staticClass: "row li-red" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-1 icon-alert" },
                          [
                            _c("Icon", {
                              staticClass:
                                "row-detail-icon row-detail-icon-exclamation-circle circle-red",
                              attrs: { name: "exclamation-circle" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-11 text-alert" }, [
                          _c("span", { staticClass: "alert-note" }, [
                            _vm._v(
                              "This item approved as a change order. Check change notes and contract details."
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.projPart < 33 && !_vm.isCreateByEM
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-1 icon-alert" },
                          [
                            _c("Icon", {
                              staticClass:
                                "row-detail-icon row-detail-icon-exclamation-circle",
                              attrs: { name: "exclamation-circle" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-11 text-alert" }, [
                          _c("span", { staticClass: "alert-note" }, [
                            _vm._v(
                              "Your estimated participation is low. Consider using small site event."
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.projPart > 200 && !_vm.isCreateByEM
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-1 icon-alert" },
                          [
                            _c("Icon", {
                              staticClass:
                                "row-detail-icon row-detail-icon-exclamation-circle",
                              attrs: { name: "exclamation-circle" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-11 text-alert" }, [
                          _c("span", { staticClass: "alert-note" }, [
                            _vm._v(
                              "Your estimated participation is high. Break event into 2 days."
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.disableIconContact && !_vm.isCreateByEM
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-1 icon-alert" },
                          [
                            _c("Icon", {
                              staticClass:
                                "row-detail-icon row-detail-icon-exclamation-circle",
                              attrs: { name: "exclamation-circle" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-11 text-alert" }, [
                          _c("span", { staticClass: "alert-note" }, [
                            _vm._v(
                              "Missing (email, phone number, email and phone number) for on site contact."
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableIconDuration
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-1 icon-alert" },
                          [
                            _c("Icon", {
                              staticClass:
                                "row-detail-icon row-detail-icon-exclamation-circle",
                              attrs: { name: "exclamation-circle" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-11 text-alert" }, [
                          _c("span", { staticClass: "alert-note" }, [
                            _vm._v(
                              "Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO."
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-4" }, [
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                shipping address\n                "
                      ),
                      _c("span", { staticClass: "grey-3 label-address" }, [
                        _vm._v("(if different than event address)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-value" },
                      [
                        !_vm.isUsedBingMap
                          ? _c("vue-google-autocomplete", {
                              attrs: {
                                name: "shipping-address",
                                id:
                                  "shipping_" +
                                  _vm.index +
                                  "-" +
                                  _vm.showOnModal,
                                classname:
                                  "additional-comments shipping-address",
                                placeholder: "Shipping address",
                                country: ["us"],
                                item: _vm.item,
                                disabled:
                                  !_vm.editable ||
                                  _vm.isLocked ||
                                  _vm.isUpdating
                              },
                              on: {
                                placechanged: _vm.modifyShippingAddress,
                                blur: function($event) {
                                  _vm.unlockEvent()
                                },
                                focus: function($event) {
                                  _vm.lockEvent()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isUsedBingMap
                          ? _c(
                              "div",
                              {
                                attrs: {
                                  id:
                                    "searchBoxForShippingAddressContainer-" +
                                    _vm.item.index
                                }
                              },
                              [
                                _c("label", {
                                  attrs: {
                                    for:
                                      "searchBoxForShippingAddress-" +
                                      _vm.showOnModal +
                                      "-" +
                                      _vm.item.index
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.item.shippingAddress,
                                      expression: "item.shippingAddress"
                                    }
                                  ],
                                  staticClass:
                                    "additional-comments shipping-address",
                                  attrs: {
                                    type: "text",
                                    id:
                                      "searchBoxForShippingAddress-" +
                                      _vm.showOnModal +
                                      "-" +
                                      _vm.item.index,
                                    placeholder: "Shipping address",
                                    disabled:
                                      !_vm.editable ||
                                      _vm.isLocked ||
                                      _vm.isUpdating
                                  },
                                  domProps: { value: _vm.item.shippingAddress },
                                  on: {
                                    blur: function($event) {
                                      _vm.unlockEvent()
                                    },
                                    focus: function($event) {
                                      _vm.lockEvent()
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.item,
                                        "shippingAddress",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                custom event notes\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.customEventNote,
                            expression: "item.customEventNote"
                          }
                        ],
                        staticClass: "custom-notes",
                        attrs: {
                          name: "custom-notes",
                          placeholder: "E.g. add ons, extra staff, etc",
                          disabled:
                            !_vm.editable || _vm.isLocked || _vm.isUpdating
                        },
                        domProps: { value: _vm.item.customEventNote },
                        on: {
                          blur: function($event) {
                            _vm.unlockEvent()
                          },
                          focus: function($event) {
                            _vm.lockEvent()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "customEventNote",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                Additional comments (" +
                          _vm._s(
                            _vm.item.additionalComments
                              ? _vm.item.additionalComments.length
                              : 0
                          ) +
                          "/1000)\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.additionalComments,
                            expression: "item.additionalComments"
                          }
                        ],
                        staticClass: "additional-comments",
                        attrs: {
                          name: "additional-comments",
                          placeholder:
                            "E.g. instructions from client or change documentation",
                          disabled:
                            !_vm.editable || _vm.isLocked || _vm.isUpdating
                        },
                        domProps: { value: _vm.item.additionalComments },
                        on: {
                          blur: function($event) {
                            _vm.unlockEvent()
                          },
                          focus: function($event) {
                            _vm.lockEvent()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "additionalComments",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                On Site Instructions\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.onsiteInstruction,
                            expression: "item.onsiteInstruction"
                          }
                        ],
                        staticClass: "additional-comments shipping-address",
                        domProps: { value: _vm.item.onsiteInstruction },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "onsiteInstruction",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notes-field" }, [
                    _c("div", { staticClass: "text-label" }, [
                      _vm._v(
                        "\n                Parking Information\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.parkingInformation,
                            expression: "item.parkingInformation"
                          }
                        ],
                        staticClass: "additional-comments shipping-address",
                        domProps: { value: _vm.item.parkingInformation },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "parkingInformation",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "arrival-time" }, [
                      _c("div", { staticClass: "text-label" }, [
                        _vm._v("ADURO Arrival Time:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "show-dropdown-for-arrival-time" },
                        [
                          _vm.editable
                            ? [
                                _c("dropdown", {
                                  ref: "arrivalTime",
                                  attrs: {
                                    options: _vm.listTime,
                                    selected: _vm.arrivalTime,
                                    placeholder: "Set Time"
                                  },
                                  on: { updateOption: _vm.setAduroArrivalTime }
                                })
                              ]
                            : [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.item.aduroArrivalTime))
                                ])
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "add-on-wrapper" }, [
                      _c("div", { staticClass: "add-on-item" }, [
                        _c("div", { staticClass: "text" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.isOnlineScheduler,
                                expression: "item.isOnlineScheduler"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "is-online-scheduler",
                              disabled:
                                !_vm.editable || _vm.isLocked || _vm.isUpdating
                            },
                            domProps: {
                              checked: Array.isArray(_vm.item.isOnlineScheduler)
                                ? _vm._i(_vm.item.isOnlineScheduler, null) > -1
                                : _vm.item.isOnlineScheduler
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.item.isOnlineScheduler,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.item,
                                        "isOnlineScheduler",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.item,
                                        "isOnlineScheduler",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.item, "isOnlineScheduler", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "is-online-scheduler" } },
                            [_vm._v("Toggle")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text title",
                            class: { active: _vm.item.isOnlineScheduler }
                          },
                          [_vm._v("Online Scheduler")]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _c("div", { staticClass: "text-contact grey-3" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("Name")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "contactName" }, [
                      _vm._v(_vm._s(_vm.item.contactName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-contact grey-3" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.email,
                            expression: "item.email"
                          }
                        ],
                        staticClass: "phoneAndEmail",
                        attrs: {
                          placeholder: "E.g. hannah_welch@gmail.com",
                          disabled:
                            !_vm.editable || _vm.isLocked || _vm.isUpdating
                        },
                        domProps: { value: _vm.item.email },
                        on: {
                          blur: function($event) {
                            _vm.unlockEvent()
                            _vm.checkEmailValid()
                          },
                          focus: function($event) {
                            _vm.lockEvent()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.item, "email", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-contact grey-3" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("Phone")]),
                      _vm._v(" "),
                      _c("the-mask", {
                        staticClass: "phoneAndEmail",
                        attrs: {
                          mask: "(###) ###-####",
                          masked: _vm.isTrue,
                          placeholder: "(123) 123-1234",
                          disabled:
                            !_vm.editable || _vm.isLocked || _vm.isUpdating
                        },
                        on: {
                          onTheMaskBlur: function($event) {
                            _vm.unlockEvent()
                            _vm.prefDateBlur(_vm.eventFields.phone)
                          }
                        },
                        nativeOn: {
                          focus: function($event) {
                            _vm.lockEvent()
                          }
                        },
                        model: {
                          value: _vm.item.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "phone", $$v)
                          },
                          expression: "item.phone"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-2" }, [
                  _c("div", { staticClass: "event-add-on" }, [
                    _c(
                      "div",
                      { staticClass: "add-on-item-wrapper" },
                      _vm._l(_vm.item.additionalServices, function(
                        itemAddOn,
                        index
                      ) {
                        return itemAddOn.isShow
                          ? _c(
                              "div",
                              { key: index, staticClass: "add-on-item" },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.bottom",
                                        modifiers: { hover: true, bottom: true }
                                      }
                                    ],
                                    staticClass: "text",
                                    class: _vm.disableAdditionalServices(
                                      itemAddOn.key
                                    )
                                      ? "greyOut"
                                      : null,
                                    attrs: { title: itemAddOn.text }
                                  },
                                  [_vm._v(_vm._s(itemAddOn.text))]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: itemAddOn.value,
                                      expression: "itemAddOn.value"
                                    }
                                  ],
                                  class: _vm.disableAdditionalServices(
                                    itemAddOn.key
                                  )
                                    ? "greyOut"
                                    : null,
                                  attrs: {
                                    type: "checkbox",
                                    id:
                                      itemAddOn.key +
                                      "_" +
                                      _vm.item.id +
                                      "_" +
                                      _vm.showOnModal,
                                    disabled: _vm.disableAdditionalServices(
                                      itemAddOn.key
                                    )
                                  },
                                  domProps: {
                                    checked: Array.isArray(itemAddOn.value)
                                      ? _vm._i(itemAddOn.value, null) > -1
                                      : itemAddOn.value
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = itemAddOn.value,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                itemAddOn,
                                                "value",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                itemAddOn,
                                                "value",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(itemAddOn, "value", $$c)
                                        }
                                      },
                                      function($event) {
                                        _vm.checkboxToggle(
                                          itemAddOn.key,
                                          itemAddOn.value
                                        )
                                      }
                                    ]
                                  }
                                }),
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for:
                                        itemAddOn.key +
                                        "_" +
                                        _vm.item.id +
                                        "_" +
                                        _vm.showOnModal
                                    }
                                  },
                                  [_vm._v("Toggle")]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "func-group" },
                [
                  _c("DataTableGroupBtn", {
                    attrs: {
                      isLocked: _vm.isLocked,
                      showOnModal: _vm.showOnModal,
                      editEventAdmin: _vm.editEventAdmin,
                      viewMode: _vm.viewMode,
                      eventStatus: _vm.eventStatus,
                      item: _vm.item,
                      isSuggestChanges: _vm.suggestChanges
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "related-event" },
            [
              _vm.showRelatedEvent
                ? _c("RelatedEvent", { attrs: { item: _vm.item } })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65e6e398", esExports)
  }
}

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "datatable table-events-plan" }, [
    _c(
      "div",
      {
        staticClass: "dt-content",
        class:
          _vm.getListEvent.length === 0 && !_vm.showOnModal
            ? "opacity-04"
            : null
      },
      [
        _c("div", { staticClass: "dt-header", attrs: { id: "dt-header" } }, [
          _c(
            "div",
            {
              staticClass: "header-col col-event-name",
              style: {
                width: _vm.columnWidth.eventName.size
                  ? _vm.columnWidth.eventName.size + "px"
                  : "12%"
              },
              attrs: { id: "eventName" },
              on: {
                click: function($event) {
                  _vm.setSortOption("eventNameSorting")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("eventName", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              name\n              "),
                      this.pagingObj.sortType != "eventNameSorting"
                        ? _c("Icon", {
                            staticClass: "sort-icon ",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "eventNameSorting" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "eventNameSorting" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.prefDate.size
                  ? _vm.columnWidth.prefDate.size + "px"
                  : "9%"
              },
              attrs: { id: "prefDate" },
              on: {
                click: function($event) {
                  _vm.setSortOption("prefDate")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("prefDate", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "content no-select" }, [
                    _vm._v("\n              DATE\n              "),
                    _c(
                      "span",
                      [
                        this.pagingObj.sortType != "prefDate"
                          ? _c("Icon", {
                              staticClass: "sort-icon sort-icon-small-text",
                              attrs: { name: "sort" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        this.pagingObj.sortType == "prefDate" &&
                        this.pagingObj.sortReverse
                          ? _c("Icon", {
                              staticClass: "sort-icon sort-icon-small-text",
                              attrs: { name: "sort-up" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        this.pagingObj.sortType == "prefDate" &&
                        !this.pagingObj.sortReverse
                          ? _c("Icon", {
                              staticClass: "sort-icon sort-icon-small-text",
                              attrs: { name: "sort-down" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.projPart.size
                  ? _vm.columnWidth.projPart.size + "px"
                  : "5%"
              },
              attrs: { id: "projPart" },
              on: {
                click: function($event) {
                  _vm.setSortOption("projPart")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("projPart", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              PART\n                "),
                      this.pagingObj.sortType != "projPart"
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "projPart" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "projPart" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.fullAddress.size
                  ? _vm.columnWidth.fullAddress.size + "px"
                  : "19%"
              },
              attrs: { id: "fullAddress" },
              on: {
                click: function($event) {
                  _vm.setSortOption("fullAddress")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("fullAddress", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              FULL ADDRESS\n              "),
                      this.pagingObj.sortType != "fullAddress"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "fullAddress" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "fullAddress" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.building.size
                  ? _vm.columnWidth.building.size + "px"
                  : "7%"
              },
              attrs: { id: "building" },
              on: {
                click: function($event) {
                  _vm.setSortOption("building")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("building", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              Building\n              "),
                      this.pagingObj.sortType != "building"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "building" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "building" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.eventLocation.size
                  ? _vm.columnWidth.eventLocation.size + "px"
                  : "7%"
              },
              attrs: { id: "eventLocation" },
              on: {
                click: function($event) {
                  _vm.setSortOption("eventLocation")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("eventLocation", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select small-text-margin" },
                    [
                      _vm._v("\n              LOCATION\n              "),
                      this.pagingObj.sortType != "eventLocation"
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "eventLocation" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "eventLocation" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.startTime.size
                  ? _vm.columnWidth.startTime.size + "px"
                  : "7%"
              },
              attrs: { id: "startTime" },
              on: {
                click: function($event) {
                  _vm.setSortOption("startTime")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("startTime", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              start\n              "),
                      this.pagingObj.sortType != "startTime"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "startTime" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "startTime" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.duration.size
                  ? _vm.columnWidth.duration.size + "px"
                  : "5%"
              },
              attrs: { id: "duration" },
              on: {
                click: function($event) {
                  _vm.setSortOption("duration")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("duration", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              dur\n              "),
                      this.pagingObj.sortType != "duration"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "duration" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "duration" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.endTime.size
                  ? _vm.columnWidth.endTime.size + "px"
                  : "7%"
              },
              attrs: { id: "endTime" },
              on: {
                click: function($event) {
                  _vm.setSortOption("endTime")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("endTime", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              end\n              "),
                      this.pagingObj.sortType != "endTime"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "endTime" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "endTime" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.timeZone.size
                  ? _vm.columnWidth.timeZone.size + "px"
                  : "4%"
              },
              attrs: { id: "timeZone" },
              on: {
                click: function($event) {
                  _vm.setSortOption("timeZone")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("timeZone", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select" },
                    [
                      _vm._v("\n              tz\n              "),
                      this.pagingObj.sortType != "timeZone"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "timeZone" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "timeZone" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.contactName.size
                  ? _vm.columnWidth.contactName.size + "px"
                  : "9%"
              },
              attrs: { id: "contactName" },
              on: {
                click: function($event) {
                  _vm.setSortOption("contactName")
                }
              }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", {
                    staticClass: "crop-line crop-right-line",
                    on: {
                      mousedown: function($event) {
                        _vm.changeColumnWidth("contactName", $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content no-select small-text-margin" },
                    [
                      _vm._v("\n              CONTACT\n                "),
                      this.pagingObj.sortType != "contactName"
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "contactName" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "contactName" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon sort-icon-small-text ",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-col",
              style: {
                width: _vm.columnWidth.action.size
                  ? _vm.columnWidth.action.size + "px"
                  : "9%"
              },
              attrs: { id: "action" }
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "crop" }, [
                  _c("div", { staticClass: "content no-select" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.viewMode === "Client" ? "" : "") +
                        "\n            "
                    )
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dt-body",
            class: _vm.scrunch ? "scrunch" : null,
            attrs: { id: "dt-body" }
          },
          [
            (_vm.getListEvent.length !== 0 || _vm.showOnModal) &&
            !_vm.getLoading
              ? _c(
                  "div",
                  _vm._l(_vm.parentEvent, function(itemNewEvent, index) {
                    return _c(
                      "div",
                      { key: itemNewEvent.id },
                      [
                        _c("DataTableRowEditMode", {
                          key: index,
                          attrs: {
                            showOnModal: _vm.showOnModal,
                            editable: _vm.editable,
                            viewMode: _vm.viewMode,
                            editEventAdmin: _vm.editEventAdmin,
                            eventStatus: _vm.eventStatus,
                            index: index,
                            item: itemNewEvent
                          }
                        })
                      ],
                      1
                    )
                  })
                )
              : _vm._e()
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.getListEvent.length !== 0 && !_vm.showOnModal
      ? _c("div", { staticClass: "dt-footer" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticStyle: { position: "relative", width: "1px", height: "1px" },
      attrs: { id: "myMap" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d8605342", esExports)
  }
}

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal modal-change-order-detail",
      attrs: {
        name: "ModalChangeOrder",
        width: 1300,
        height: 670,
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", { staticClass: "modal-header-change-order-text" }, [
          _vm._v(_vm._s(_vm.modalData.title))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body-changeOrderDetail" },
        [
          _c("div", { staticClass: "modal-header-line" }),
          _vm._v(" "),
          _c("a", [
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "modal-body-changeOrderDetail-text" }, [
              _vm._v(
                "Requesting changes will charge you based on contract rates. Cancelling will not."
              )
            ])
          ]),
          _c("br"),
          _vm._v(" "),
          _c("DataTable", {
            staticClass: "modal-body-changeOrderDetail-event-detail",
            attrs: {
              editable: true,
              showOnModal: true,
              parentEvent: [_vm.actionData]
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79eb3b64", esExports)
  }
}

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b5ad72e8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05e88dc2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalInfo.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05e88dc2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.event-modal {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n.event-modal.modal-change-order-detail .v--modal-box {\n  overflow-y: scroll;\n}\n.event-modal .modal-header {\n  padding: 0;\n  border: 0;\n  border-bottom: 1px solid #c2cfd6;\n  width: 85%;\n  margin: 0 auto;\n}\n.event-modal .modal-header .line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #E6E6E6;\n}\n.event-modal .modal-header .modal-header-text {\n  margin-top: 50px;\n  height: 29px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.event-modal .modal-header .modal-header-change-order-text {\n  margin-top: 25px;\n  margin-left: 25px;\n  height: 29px;\n  width: auto;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.event-modal .modal-header .modal-header-line {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #e6e6e6;\n}\n.event-modal .modal-body {\n  height: auto;\n  width: 85%;\n  margin: 0 auto;\n  padding: 20px 0 0 0;\n}\n.event-modal .modal-body .modal-body-text {\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n  font-size: 16px;\n  line-height: 24px;\n}\n.event-modal .modal-body-changeOrderDetail .modal-body-changeOrderDetail-text {\n  margin-top: 25px;\n  margin-left: 25px;\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 14px;\n}\n.event-modal .modal-body-changeOrderDetail .modal-body-changeOrderDetail-event-detail {\n  margin: 26px 0 0 0;\n}\n.event-modal .modal-footer {\n  /*position: absolute;*/\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  float: right;\n  border: 0;\n}\n.event-modal .modal-footer .modal-btn-left {\n  border-radius: 4px;\n  margin-left: 15px;\n  margin-bottom: 50px;\n  margin-top: 30px;\n}\n.event-modal .modal-footer .modal-btn-left .modal-btn-left-text {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  text-transform: uppercase;\n}\n.event-modal .modal-footer .modal-btn-right {\n  border-radius: 4px;\n  margin-right: 50px;\n  margin-bottom: 50px;\n  margin-top: 30px;\n}\n.event-modal .modal-footer .modal-btn-right .modal-btn-right-text {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  text-transform: uppercase;\n}\n", ""]);

// exports


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalInfoBody__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';



// const _ = require('lodash');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    ModalInfoBody: __WEBPACK_IMPORTED_MODULE_3__ModalInfoBody__["a" /* default */]
  },
  data: function data() {
    return {
      actionTypes: __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalAction,
      modalData: {},
      actionData: {},
      isCancel: false,
      modalBodies: __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalBodies
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.$emit('CLOSE_MODAL_INFO', false);
      this.$modal.hide('modalInfo');
    },
    beforeOpen: function beforeOpen(event) {
      this.modalData = __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    btnAction: function btnAction() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$modal.hide('modalInfo');
                _this.$emit('CLOSE_MODAL_INFO', true);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({}), {
    beforeClose: function beforeClose() {}
  }),
  computed: {
    calculateHeight: function calculateHeight() {
      if (this.modalData.modalAction === this.actionTypes.deleteEvent) {
        return 290;
      }
      return 'auto';
    },
    isChangeOrder: function isChangeOrder() {
      return this.modalData.modalAction === this.actionTypes.changeOrder;
    },
    isDeleteModal: function isDeleteModal() {
      return this.modalData.modalAction === this.actionTypes.deleteEvent;
    },
    bodyMessage: function bodyMessage() {
      if (this.modalData.modalAction === this.actionTypes.eventNameNotUnique) {
        return this.modalBodies.eventNameNotUnique;
      }
      if (this.modalData.modalAction === this.actionTypes.someFieldsBlank) {
        return this.modalBodies.someFieldsBlank;
      }
      if (this.modalData.modalAction === this.actionTypes.eventDurationRestricted) {
        return this.modalBodies.eventDurationRestricted;
      }
      if (this.modalData.modalAction === this.actionTypes.readOnly) {
        return this.modalBodies.readOnly;
      }
      if (this.modalData.modalAction === this.actionTypes.emailMustBeAValid) {
        return this.modalBodies.emailMustBeAValid;
      }
      if (this.modalData.modalAction === this.actionTypes.modalAlertChangeEmailTemplate) {
        return this.modalBodies.modalAlertChangeEmailTemplate;
      }
      if (this.modalData.modalAction === this.actionTypes.modalCancelEmail) {
        return this.modalBodies.modalCancelEmail;
      }
    },
    showModalBody: function showModalBody() {
      var actionTypes = this.actionTypes;
      var listModal = [actionTypes.eventNameNotUnique, actionTypes.someFieldsBlank, actionTypes.eventDurationRestricted, actionTypes.readOnly, actionTypes.emailMustBeAValid, actionTypes.modalCancelEmail, actionTypes.modalAlertChangeEmailTemplate];
      return listModal.indexOf(this.modalData.modalAction) >= 0;
    },
    bodyMessageWithErrorCode: function bodyMessageWithErrorCode() {
      var messages = [];
      var data = this.actionData;
      for (var prop in data) {
        if (data[prop]) {
          var temp = __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].modalBodies[prop][0];
          messages.push(temp);
        }
      }
      return messages;
    }
  }
});

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal",
      class: {
        "v--modal-box v--modal": _vm.isChangeOrder,
        "modal-delete": _vm.isDeleteModal
      },
      attrs: { name: "modalInfo", height: _vm.calculateHeight, width: 700 },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v(_vm._s(_vm.modalData.title))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.showModalBody
            ? _c("ModalInfoBody", { attrs: { messages: _vm.bodyMessage } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _vm.modalData.btnLeft != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-left ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.hideModal()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnLeft) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.btnRight != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-right ap-btn primary",
                  on: {
                    click: function($event) {
                      _vm.btnAction()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnRight) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05e88dc2", esExports)
  }
}

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditEventDetail_vue__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a136a80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditEventDetail_vue__ = __webpack_require__(1533);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditEventDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a136a80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditEventDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalEditEventDetail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalEditEventDetail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a136a80", Component.options)
  } else {
    hotAPI.reload("data-v-3a136a80", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datatable_DataTable__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      actionTypes: __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].modalAction,
      modalData: {},
      actionData: {}
    };
  },

  methods: {
    hideModal: function hideModal() {
      this.$modal.hide('ModalEditEvent');
    },
    beforeOpen: function beforeOpen(event) {
      this.modalData = __WEBPACK_IMPORTED_MODULE_0__consts__["a" /* default */].mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    beforeClose: function beforeClose() {
      // this.$modal.show('eventModal', modalData);
    }
  },
  computed: {}
});

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal modal-change-order-detail",
      attrs: {
        name: "ModalEditEvent",
        width: 1300,
        height: 670,
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", { staticClass: "modal-header-change-order-text" }, [
          _vm._v(_vm._s(_vm.modalData.title))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body-changeOrderDetail" },
        [
          _c("div", { staticClass: "modal-header-line" }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("DataTable", {
            staticClass: "modal-body-changeOrderDetail-event-detail",
            attrs: {
              editable: true,
              showOnModal: true,
              editEventAdmin: true,
              dataOnModal: _vm.actionData
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a136a80", esExports)
  }
}

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495588d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(1536);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495588d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Aside.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Aside.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-495588d7", Component.options)
  } else {
    hotAPI.reload("data-v-495588d7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside'
});

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "aside-menu" })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-495588d7", esExports)
  }
}

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d26c874_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(1539);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d26c874_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Breadcrumb.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Breadcrumb.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d26c874", Component.options)
  } else {
    hotAPI.reload("data-v-0d26c874", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "breadcrumb" },
    _vm._l(_vm.list, function(item, index) {
      return _c(
        "li",
        { staticClass: "breadcrumb-item" },
        [
          _vm.isLast(index)
            ? _c("span", { staticClass: "active" }, [
                _vm._v(_vm._s(_vm.showName(item)))
              ])
            : _c("router-link", { attrs: { to: item.path } }, [
                _vm._v(_vm._s(_vm.showName(item)))
              ])
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d26c874", esExports)
  }
}

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6711dbe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(1542);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6711dbe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Callout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Callout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6711dbe2", Component.options)
  } else {
    hotAPI.reload("data-v-6711dbe2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classList }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6711dbe2", esExports)
  }
}

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1701568c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(1545);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1701568c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1701568c", Component.options)
  } else {
    hotAPI.reload("data-v-1701568c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "app-footer" }, [
    _vm._v("\n  © 2019 Copyright. v.2.0\n  ")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1701568c", esExports)
  }
}

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3833ba7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1551);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1547)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3833ba7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3833ba7e", Component.options)
  } else {
    hotAPI.reload("data-v-3833ba7e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4fffc981", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3833ba7e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3833ba7e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.main-container {\n  float: left;\n  position: relative;\n  /*left: 50%;*/\n}\n.fixer-container {\n  float: left;\n  position: relative;\n  /*left: -50%;*/\n}\n.fixer-container .display-inline-div {\n  display: inline-block;\n}\n.fixer-container .float-right {\n  float: right;\n}\n.header-icon {\n  float: left;\n  height: 25px;\n  width: 20px;\n  text-align: center;\n  margin: 8px 15px;\n}\n.header-icon:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.header-icon .header-sub-icon {\n  height: 25px;\n  width: 20px;\n}\n.header-icon .icon-users {\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(1549) + ");\n}\n@media screen and (min-width: 764px) {\n.app-header {\n    height: 70px;\n}\n.app-header .header-left-image {\n    max-width: 140px;\n    height: 70px;\n}\n.app-header .col-md-5 {\n    min-width: 400px;\n}\n.app-header .col-md-5 .header-dropdown {\n    width: 220px;\n}\n.app-header .col-md-3 {\n    max-width: 240px;\n}\n.app-header .col-md-3 .nameDisplay {\n    padding-right: 25px;\n}\n}\n@media screen and (min-width: 720px) and (max-width: 763px) {\n.app-header {\n    height: 70px;\n}\n.app-header .header-left-image {\n    max-width: 140px;\n    height: 70px;\n}\n.app-header .col-md-5 {\n    min-width: 400px;\n}\n.app-header .col-md-5 .header-dropdown {\n    width: 220px;\n}\n.app-header .col-md-3 {\n    max-width: 198px;\n}\n.app-header .col-md-3 .nameDisplay {\n    padding-right: 25px;\n}\n}\n@media screen and (max-width: 720px) {\n.app-header {\n    height: 70px;\n}\n.app-header .header-left-image {\n    max-width: 140px;\n    height: 70px;\n}\n.app-header .col-md-5 {\n    min-width: 400px;\n}\n.app-header .col-md-5 .header-dropdown {\n    width: 220px;\n}\n.app-header .col-md-3 {\n    max-width: 190px;\n}\n.app-header .col-md-3 .nameDisplay {\n    padding-right: 25px;\n}\n}\n.header-left-image {\n  width: auto;\n  min-width: 130px;\n  height: 70px;\n}\n.header-dropdown {\n  margin-bottom: 12px;\n  height: 100px;\n  float: left;\n}\n.header-middle {\n  width: auto;\n  margin-top: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n/* FOR CHROME */\n@supports (-webkit-appearance:none) {\n.header-middle-managing {\n    height: 29px;\n    margin: 6px 10px 4px 0;\n    float: left;\n}\n}\n/* FOR IE */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n.header-middle-managing {\n    height: 29px;\n    width: 10px;\n    margin: 6px 130px 4px 0;\n    float: left;\n}\n.header-middle-managing-client {\n    height: 29px;\n    width: 470px;\n    margin: 6px 130px 4px 0;\n    float: left;\n}\n.header-dropdown {\n    width: 250px;\n    float: left;\n}\n}\n/* FOR FIREFOX */\n_:-moz-tree-row(hover),\n.header-middle-managing {\n  height: 29px;\n  margin: 6px 10px 4px 0;\n  float: left;\n}\n.header-middle-text {\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.align-center {\n  text-align: right;\n  /* FOR FIREFOX */\n  /* FOR CHROME */\n  /* FOR IE */\n}\n.align-center _:-moz-tree-row(hover),\n.align-center .dropdown-item,\n.align-center .dropdown-toggle,\n.align-center .dropdown-menu,\n.align-center .b-dropdown {\n  width: 240px;\n  height: 39px;\n}\n@supports (-webkit-appearance:none) {\n.align-center .dropdown-item,\n  .align-center .dropdown-toggle,\n  .align-center .dropdown-menu,\n  .align-center .b-dropdown {\n    width: 250px;\n    height: 39px;\n    float: left;\n}\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n.align-center .dropdown-item,\n  .align-center .dropdown-toggle,\n  .align-center .dropdown-menu,\n  .align-center .b-dropdown {\n    width: 240px;\n    height: 39px;\n}\n}\n.manageText {\n  float: right;\n  width: 60px;\n}\n.btn-dropdown {\n  height: 39px;\n  border: 1px solid #0080a5;\n  border-radius: 3px;\n  background-color: #ffffff;\n}\n.btn-group > .btn:first-child {\n  background-color: #ffffff;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  border: solid 1px #0080a5;\n}\n.header-right-text {\n  text-align: right;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 5px;\n}\n.nameDisplay {\n  padding: 0px 35px 0 0;\n  position: relative;\n}\n.nameDisplay:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.nameDisplay:hover .user-action-panel {\n  display: block;\n}\n.nameDisplay .header-right-position {\n  color: #7b7b7b;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: right;\n  width: 100px;\n  text-transform: capitalize;\n}\n.nameDisplay .user-action-icon {\n  position: absolute;\n  right: 10px;\n  top: 15px;\n}\n.nameDisplay .user-action-panel {\n  position: absolute;\n  right: 0;\n  z-index: 999;\n  top: 44px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n}\n.nameDisplay .user-action-panel ul {\n  width: 250px;\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.nameDisplay .user-action-panel ul li {\n  height: 35px;\n  width: 100%;\n  text-align: left;\n  margin: 10px 0;\n  line-height: 35px;\n  padding-left: 10px;\n  color: #231f20;\n}\n.nameDisplay .user-action-panel ul li:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.nameDisplay .user-action-panel ul li input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.nameDisplay .user-action-panel ul li label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 30px;\n  height: 15px;\n  background: grey;\n  border-radius: 15px;\n  position: relative;\n  top: 11px;\n  left: 5px;\n}\n.nameDisplay .user-action-panel ul li label:after {\n  content: '';\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 15px;\n  height: 13px;\n  background: #fff;\n  border-radius: 15px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.nameDisplay .user-action-panel ul li input:checked + label {\n  background: #0080A5;\n}\n.nameDisplay .user-action-panel ul li input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.nameDisplay .user-action-panel ul li label:active:after {\n  width: 15px;\n}\n.header-right-name {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100px;\n}\n.dropdown-menu {\n  border: none;\n}\n.btn .dropdown-toggle .btn-secondary {\n  padding: 7px 5px 0 7px;\n  color: #231f20;\n}\n.b-dropdown .dropdown-item:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.b-dropdown .dropdown-item:hover {\n  -webkit-box-shadow: inset 0 0 400px 110px #f5f5f5;\n          box-shadow: inset 0 0 400px 110px #f5f5f5;\n  background-color: #f5f5f5;\n}\n.dropdown-item {\n  background-color: #ffffff !important;\n  color: #231f20 !important;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: 'Open Sans', sans-serif;\n  border: none;\n  padding: 0;\n}\n.dropdown-item:focus {\n  outline: none;\n}\n.btn-group > .btn:first-child {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 10px;\n  text-align: left;\n}\n.header-dropdown-items > .dropdown-item:first-child {\n  margin-top: 7px;\n}\n.header-dropdown-items > .dropdown-item:last-child > .wrapper-item {\n  border-bottom: none;\n}\n.header-dropdown-items {\n  max-height: 203px;\n  overflow-y: scroll;\n  width: 250px;\n  min-width: 220px;\n  border-radius: 3px;\n  margin: -2px 0 0 0;\n  border: 1px solid #e6e6e6;\n  padding-bottom: 7px;\n  background-color: #fff;\n}\n.header-dropdown-items .dropdown-item-sub .wrapper-item {\n  border-bottom: 1px solid #f5f5f5;\n  height: 100%;\n  margin: 0 0 0 10px;\n  padding: 10px 0 0 10px;\n  font-family: 'Open Sans', sans-serif;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.app-header.navbar {\n  padding-right: 0;\n  height: 70px;\n}\n.app-header.navbar .navbar-brand {\n  width: 140px;\n  height: 69px;\n  padding: unset;\n  margin-right: unset;\n  border-bottom: none;\n  background-size: cover;\n}\n.app-header.navbar .dropdown-item {\n  width: 100%;\n}\n.header-middle-export-to-excel-text {\n  height: 28px;\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 14px;\n  display: inline-block;\n  margin-left: 10px;\n  margin-top: 6px;\n  float: left;\n  text-align: left;\n}\n.header-middle-export-to-excel-text:hover {\n  cursor: pointer;\n}\n.btn-logout {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #ffffff;\n  color: #0080a5;\n  height: 40px;\n  border-color: #0080a5;\n  float: right;\n}\n.dropdown-toggle::after {\n  margin-top: 7px;\n  position: absolute;\n  right: 5px;\n  top: 10px;\n  color: #0080a5;\n}\n.nav-link,\n.navbar .dropdown-toggle {\n  padding: 5px 0 0 10px;\n}\n.icon-settings {\n  width: 27px;\n  height: 27px;\n  color: #231f20;\n  background-color: #231f20;\n  -webkit-mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  mask: url(" + __webpack_require__(42) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.icon-settings {\n    background: url(" + __webpack_require__(42) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.icon-settings {\n    background: url(" + __webpack_require__(42) + ") no-repeat center;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNC4wNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDAxMDA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5lZGl0cHJvZmlsZTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTIsM0E0LDQsMCwxLDEsOCw3YTQsNCwwLDAsMSw0LTRtMC0xYTUsNSwwLDEsMCw1LDUsNSw1LDAsMCwwLTUtNVoiLz48cGF0aCBkPSJNMTcuODIsMTIuNTNsMS40MiwxLjQxTDE1LjE2LDE4bC0yLjEyLjcuNzEtMi4xMiw0LjA3LTQuMDdtMC0xLjQyLTUsNC45NS0xLjEsMy4zYS41LjUsMCwwLDAsLjQ3LjY2LjQ1LjQ1LDAsMCwwLC4xNiwwbDMuMy0xLjEsNC45NS01LTIuODMtMi44M1oiLz48cGF0aCBkPSJNMTkuOTQsMTAuODJhMSwxLDAsMCwxLC43MS4yOSwxLDEsMCwwLDEsMCwxLjQybC0uNzEuNy0xLjQxLTEuNDEuNzEtLjcxYTEsMSwwLDAsMSwuNy0uMjltMC0xYTIsMiwwLDAsMC0xLjQxLjU4bC0uNzEuNzEtLjcxLjcxLjcxLjcxLDEuNDIsMS40MS43LjcxLjcxLS43MS43MS0uNzFhMiwyLDAsMCwwLTEuNDItMy40MVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00LjUsMjJhLjUuNSwwLDAsMS0uNS0uNSw4LDgsMCwwLDEsOC04LDcuODYsNy44NiwwLDAsMSwyLjY1LjQ2LjUuNSwwLDAsMSwuMzEuNjMuNS41LDAsMCwxLS42NC4zMSw2LjkxLDYuOTEsMCwwLDAtMi4zMi0uNCw3LDcsMCwwLDAtNyw3QS41LjUsMCwwLDEsNC41LDIyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjUsMjJhLjUuNSwwLDAsMS0uNS0uNSw3LDcsMCwwLDAtMS41OC00LjQyLjUuNSwwLDAsMSwuNzgtLjY0QTgsOCwwLDAsMSwyMCwyMS41Mi41LjUsMCwwLDEsMTkuNSwyMloiLz48L3N2Zz4="

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-app-header',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      dropdownTitle: 'CHOOSE CLIENT',
      isShowUserAction: false,
      isReceiveEmail: true,
      listUserRole: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showBtnManageUser: function showBtnManageUser() {
      return this.getUserRole === this.listUserRole.admin || this.getUserRole === this.listUserRole.eventManager;
    },
    isShiftboardEnabled: function isShiftboardEnabled() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.isShiftboardEnabled) === 'true';
    },
    getUserRole: function getUserRole() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role);
    },
    userName: function userName() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.userName) || '';
    },
    userRole: function userRole() {
      return (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role).replace('_', ' ') || '').toLowerCase();
    },
    clientNameForClient: function clientNameForClient() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName);
    },
    isClientName: function isClientName() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client;
    },
    midleText: function midleText() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client ? 'WellMetrics Event Planner' : __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].headerManaging;
    },
    disableDropdown: function disableDropdown() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client;
    },
    getAllClient: function getAllClient() {
      return this.getClientsName;
    },
    enableExportExcel: function enableExportExcel() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.eventManager || localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.accountManager || localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.clientManager;
    },
    enableExportExcelForClient: function enableExportExcelForClient() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getClientsName: 'GETTERS_CLIENT_LIST',
    getEmailNotification: 'GETTER_GET_EMAIL_NOTIFICATION'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    dropdownItemClick: function dropdownItemClick(item) {
      var _this = this;

      this.selectClient(item);
      this.setListEventStatus('');
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.addOns, item.addOns);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.readOnly, item.userManageReadOnly);
      this.dropdownTitle = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName) || 'CHOOSE CLIENT';
      var element = document.querySelector('.animated');
      element.classList.remove('fadeIn');
      setTimeout(function () {
        // this.$router.push(consts.routeDirect.clientDashboard);
        _this.$router.push({
          name: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.name,
          params: {
            clientId: item.id
          }
        });
        _this.$bus.$emit('resetGetData');
        element.classList.add('fadeIn');
      }, 500);
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__["a" /* default */].signOut().then(function () {
        console.log('logout');
      }).catch(function (error) {
        return console.log('error', error);
      });
      this.doLogout().then(function () {
        _this2.disconnetWM();
        // this.$router.push('/login');
        return _this2.$router.go('/login');
      });
    },
    syncClientsAndProgramsClick: function syncClientsAndProgramsClick() {
      var _this3 = this;

      this.syncClientsAndPrograms().then(function (result) {
        _this3.$toast.success('Clients and Programs are syncing...', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optInfo));
      });
    },
    syncEventsClick: function syncEventsClick() {
      var _this4 = this;

      this.syncEvents().then(function (result) {
        _this4.$toast.success('Syncing events', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.$toastOpt.optInfo));
      });
    },
    syncStaffsClick: function syncStaffsClick() {
      var _this5 = this;

      this.syncStaffs().then(function (result) {
        _this5.$toast.success('Getting staffs...', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optInfo));
      });
    },
    syncBiometricOrdersClick: function syncBiometricOrdersClick() {
      var _this6 = this;

      this.syncBiometricOrders().then(function (result) {
        _this6.$toast.success('Sending Order...', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this6.$toastOpt.optInfo));
      });
    },
    syncUsersStatusClick: function syncUsersStatusClick() {
      var _this7 = this;

      this.syncUsersStatus().then(function (result) {
        _this7.$toast.success('Syncing users status...', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this7.$toastOpt.optInfo));
      });
    },
    syncShiftBoardBasicDataClick: function syncShiftBoardBasicDataClick() {
      var _this8 = this;

      this.syncShiftBoardBasicData().then(function (response) {
        _this8.$toast.success('Syncing users status...', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this8.$toastOpt.optInfo));
      }).catch(function (err) {
        console.log('error=', err);
        _this8.$toast.success('syncing ShiftBoard Basic data error', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this8.$toastOpt.optError));
      });
    },
    resetPassword: function resetPassword() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.resetPassword,
        data: null
      };
      this.$modal.show('eventModal', modalData);
    },
    resetSelectedClient: function resetSelectedClient() {
      if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client) {
        this.$router.push({
          name: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.name,
          params: {
            clientId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId)
          }
        });
      } else {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId, 0);
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName, 'CHOOSE CLIENT');
        this.dropdownTitle = 'CHOOSE CLIENT';
        this.$router.replace(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].iconHomeForManager);
      }
    },
    openFaqModal: function openFaqModal() {
      this.$modal.show('faqModal');
    },
    openGlobalSettings: function openGlobalSettings() {
      this.$router.replace({
        name: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.globalSettings
      });
    },
    manageUser: function manageUser() {
      this.$router.replace({
        name: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.managerUsers
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    selectClient: 'ACTION_SELECT_CLIENT',
    setListEventStatus: 'ACTION_SET_LIST_EVENT_STATUS',
    exportToExcelClick: 'ACTION_EXPORT_TO_EXCEL',
    doLogout: 'ACTION_DO_LOGOUT',
    getClients: 'ACTION_GET_CLIENTS',
    changeNotification: 'ACTION_CHANGE_NOTIFICATION',
    syncClientsAndPrograms: 'ACTION_SYNCS_CLIENTS_PROGRAMS',
    syncStaffs: 'ACTION_SYNCS_STAFFS',
    syncEvents: 'ACTION_SYNCS_EVENTS',
    syncBiometricOrders: 'ACTION_SYNCS_ORDERS',
    syncUsersStatus: 'ACTION_SYNCS_USER_STATUS',
    syncShiftBoardBasicData: 'ACTION_SYNC_SHIFTBOARD_BASE_DATA'
  })),
  beforeMount: function beforeMount() {
    this.getClients();
    this.dropdownTitle = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName) || 'CHOOSE CLIENT';
  },
  mounted: function mounted() {
    this.isReceiveEmail = this.getEmailNotification;
  },

  watch: {
    isReceiveEmail: {
      handler: function handler() {
        this.changeNotification(this.isReceiveEmail);
      }
    }
  }
});

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "app-header navbar", attrs: { id: "app-header" } },
    [
      _c("div", { staticClass: "header-left-side" }, [
        _c(
          "div",
          {
            staticClass: "header-left-image noPaddingLeft noPaddingRight",
            on: {
              click: function($event) {
                _vm.resetSelectedClient()
              }
            }
          },
          [_c("b-link", { staticClass: "navbar-brand" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "header-middle align-center noPaddingLeft noPaddingRight"
          },
          [
            _c("div", { staticClass: "main-container" }, [
              _c("div", { staticClass: "fixer-container" }, [
                _c(
                  "div",
                  { staticClass: "display-inline-div custom-multiselect" },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.getAllClient,
                        placeholder: "Choose Client",
                        label: "clientName",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": true,
                        "show-labels": false,
                        disabled: _vm.disableDropdown
                      },
                      on: { select: _vm.dropdownItemClick },
                      model: {
                        value: _vm.dropdownTitle,
                        callback: function($$v) {
                          _vm.dropdownTitle = $$v
                        },
                        expression: "dropdownTitle"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "display-inline-div float-right header-icon",
                    on: {
                      click: function($event) {
                        _vm.exportToExcelClick()
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      staticClass: "header-sub-icon",
                      attrs: { name: "file-excel-o" }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-right-text noPaddingRight noPaddingLeft" },
        [
          _c("div", { staticClass: "header-icon" }, [
            _c("div", {
              staticClass: "icon-settings",
              on: {
                click: function($event) {
                  _vm.openGlobalSettings()
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.showBtnManageUser
            ? _c("div", { staticClass: "header-icon" }, [
                _c("div", {
                  staticClass: "icon-users",
                  on: {
                    click: function($event) {
                      _vm.manageUser()
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nameDisplay",
              on: {
                click: function($event) {
                  _vm.isShowUserAction = true
                },
                mouseleave: function($event) {
                  _vm.isShowUserAction = false
                }
              }
            },
            [
              _c("div", { staticClass: "header-right-name" }, [
                _vm._v(_vm._s(_vm.userName))
              ]),
              _vm._v(" "),
              !_vm.isClientName
                ? _c("div", { staticClass: "header-right-position" }, [
                    _vm._v(_vm._s(_vm.userRole))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isClientName
                ? _c("div", { staticClass: "header-right-position" }, [
                    _vm._v(_vm._s(_vm.clientNameForClient))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-action-icon" },
                [_c("Icon", { attrs: { name: "sort-down" } })],
                1
              ),
              _vm._v(" "),
              _vm.isShowUserAction
                ? _c("div", { staticClass: "user-action-panel" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.logout()
                            }
                          }
                        },
                        [_vm._v("Logout")]
                      ),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v("Email notification: "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isReceiveEmail,
                              expression: "isReceiveEmail"
                            }
                          ],
                          attrs: { type: "checkbox", id: "switch" },
                          domProps: {
                            checked: Array.isArray(_vm.isReceiveEmail)
                              ? _vm._i(_vm.isReceiveEmail, null) > -1
                              : _vm.isReceiveEmail
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isReceiveEmail,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isReceiveEmail = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isReceiveEmail = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isReceiveEmail = $$c
                              }
                            }
                          }
                        }),
                        _c("label", { attrs: { for: "switch" } }, [
                          _vm._v("Toggle")
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.userRole === "admin"
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  _vm.syncClientsAndProgramsClick()
                                }
                              }
                            },
                            [_vm._v("Sync Clients & Programs")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userRole === "admin"
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  _vm.syncStaffsClick()
                                }
                              }
                            },
                            [_vm._v("Sync Staffs")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userRole === "admin"
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  _vm.syncEventsClick()
                                }
                              }
                            },
                            [_vm._v("Post Events")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userRole === "admin"
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  _vm.syncBiometricOrdersClick()
                                }
                              }
                            },
                            [_vm._v("Sync Biometric Orders")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userRole === "admin"
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  _vm.syncUsersStatusClick()
                                }
                              }
                            },
                            [_vm._v("Sync Users Status")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userRole === "admin"
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function($event) {
                                  _vm.syncShiftBoardBasicDataClick()
                                }
                              }
                            },
                            [_vm._v("Sync Shiftboard Base Data")]
                          )
                        : _vm._e()
                    ])
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3833ba7e", esExports)
  }
}

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71d3f73b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1561);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71d3f73b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71d3f73b", Component.options)
  } else {
    hotAPI.reload("data-v-71d3f73b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4c9238bd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71d3f73b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71d3f73b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.nav-link {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavIcons__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  data: function data() {
    return {};
  },

  components: {
    SidebarNavIcons: __WEBPACK_IMPORTED_MODULE_2__SidebarNavIcons__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    listSideBar: function listSideBar() {
      var drafts = this.countUnreadEventByStatus('drafts');
      var submitted = this.countUnreadEventByStatus('submitted');
      var review = this.countUnreadEventByStatus('review');
      var approved = this.countUnreadEventByStatus('approved');
      var archived = this.countUnreadEventByStatus('archived');
      var deleted = this.countUnreadEventByStatus('deleted');
      var data = [{
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.dashboard,
        url: '/user/dashboard',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.areaChart,
        overview: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.overview,
        notifyNumber: 0
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.newEvent,
        url: '/user/events',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.plusCircle,
        overview: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.events,
        line: 'ok',
        notifyNumber: 0
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.draft,
        url: '/user/drafts',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.fileText,
        notifyNumber: drafts
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.submitted,
        url: '/user/submitted',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.inbox,
        notifyNumber: submitted,
        eventStatus: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.submitted
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.review,
        url: '/user/review',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.eye,
        notifyNumber: review,
        eventStatus: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.review
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.approved,
        url: '/user/approved',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.calendar,
        notifyNumber: approved
      }, {
        name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.archived,
        url: '/user/archived',
        icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.archive,
        notifyNumber: archived
      }];
      if (localStorage.getItem('sof_role') === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin) {
        var deleteData = {
          name: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].sideBarItemNames.deleted,
          url: '/user/deleted',
          icon: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].iconNames.deleted,
          notifyNumber: deleted
        };
        data.push(deleteData);
      }
      return data;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    countUnreadEventByStatus: 'GETTERS_COUNT_UNREAD_EVENT_BY_STATUS'
  })),
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d1023736", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bfa3c92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarNavIcons.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bfa3c92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarNavIcons.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.nav-item[data-v-7bfa3c92] {\n  height: 70px;\n  position: relative;\n}\n.nav-item .nav-link[data-v-7bfa3c92] {\n  height: 70px;\n  padding: 0px 0 0 0 !important;\n}\n.nav-item .nav-link .text-section[data-v-7bfa3c92] {\n  margin-top: -5px;\n}\n.nav-item .nav-link .nav-ellipsis[data-v-7bfa3c92] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100px;\n}\n.nav-item .active .nav-font-size-small[data-v-7bfa3c92] {\n  color: #231f20;\n}\n.nav-item .active .nav-font-size-big[data-v-7bfa3c92] {\n  color: #231f20;\n}\n.wrapper-notify-number[data-v-7bfa3c92] {\n  width: 17px;\n  height: 17px;\n  background: #ffffff;\n  border-color: #3c6275;\n  border-radius: 8px;\n  text-align: center;\n  position: absolute;\n  top: 0%;\n  right: 34%;\n  border: 0.5px solid #3c6275;\n  margin-top: 5px;\n}\n.fa-stack[data-count][data-v-7bfa3c92]:after {\n  content: attr(data-count);\n  font-size: 9px;\n  line-height: .75em;\n  color: grey;\n  text-align: center;\n  top: 5px;\n  color: #3c6275;\n  position: absolute;\n}\n.fa-stack[data-v-7bfa3c92]::after {\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.small-notify-number[data-v-7bfa3c92]::after {\n  left: 5px;\n}\n.big-notify-number[data-v-7bfa3c92]::after {\n  left: 3px;\n}\n.icon-size[data-v-7bfa3c92] {\n  height: 26px;\n  width: 26px;\n  margin: 0px 0 0 0;\n}\n.nav-font-size-big[data-v-7bfa3c92] {\n  font-size: 12px;\n  margin-top: -6px;\n}\n.nav-font-size-small[data-v-7bfa3c92] {\n  font-size: 10px;\n  height: 14px;\n  width: 76px;\n  font-family: 'Open Sans', sans-serif;\n  line-height: 14px;\n  text-align: center;\n}\n.sidebar .nav .nav-item .nav-link [class^=\"icon-\"][data-v-7bfa3c92] {\n  margin-top: 13px;\n}\n.sidebar .nav .nav-item .nav-link[data-v-7bfa3c92] {\n  width: 112px;\n  border-left: 5px solid #3d6274;\n}\n.sidebar .nav .nav-item .nav-link[data-v-7bfa3c92]:hover {\n  border-left: 5px solid #20a8d8;\n}\n.sidebar .nav .nav-item .nav-link.active[data-v-7bfa3c92] {\n  border-left: 5px solid #0080A5;\n}\n.sidebar .nav .nav-item .nav-item-margin[data-v-7bfa3c92] {\n  margin-top: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_area_chart__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_plus_circle__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_file_text_o__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_calendar_check_o__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_inbox__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_eye__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_archive__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_trash__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    notifyNumber: {
      type: Number,
      default: 0
    },
    eventStatus: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      class1: 'small-notify-number',
      class2: 'big-notify-number',
      class3: 'sidebar-item-new-event'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    renderClass: function renderClass() {
      return this.notifyNumber < 10 ? this.class1 : this.class2;
    },
    renderCssItemNewEvent: function renderCssItemNewEvent() {
      if (this.name === 'New Event') {
        return this.class3;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])({
    getClientName: 'GETTERS_GET_CLIENT_NAME'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])({
    btnCreateNewEventOnSideBar: 'CREATE_EVENT_FLAG'
  }), {
    newEventClick: function newEventClick() {
      var _this = this;

      this.btnCreateNewEventOnSideBar(true).then(function () {
        _this.$router.replace(__WEBPACK_IMPORTED_MODULE_10__consts__["a" /* default */].routeDirect.userDrafts);
      });
    }
  })
});

/***/ }),
/* 1559 */,
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-item",
      class: _vm.name != "Dashboard" ? "nav-item-margin" : "",
      attrs: { align: "center" }
    },
    [
      this.name != "New Event"
        ? _c(
            "router-link",
            { staticClass: "nav-link", attrs: { to: _vm.url } },
            [
              _c("Icon", {
                staticClass: "icon-size",
                attrs: { name: _vm.icon }
              }),
              _vm._v(" "),
              _vm.notifyNumber > 0
                ? _c("div", { staticClass: "wrapper-notify-number" }, [
                    _c("span", {
                      staticClass: "fa-stack",
                      class: _vm.renderClass,
                      attrs: { "data-count": _vm.notifyNumber }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    _vm.eventStatus == "review" ||
                    _vm.eventStatus == "submitted"
                      ? "text-section"
                      : null
                },
                [
                  _vm.eventStatus !== "review" &&
                  _vm.eventStatus !== "submitted"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _c("br"),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("div", { staticClass: "nav-font-size-big" }, [
                        _vm._v("ADURO")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c(
                        "div",
                        { staticClass: "nav-font-size-big nav-ellipsis" },
                        [_vm._v(_vm._s(_vm.getClientName))]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "nav-item",
              on: {
                click: function($event) {
                  _vm.newEventClick()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "nav-link" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: _vm.icon }
                  }),
                  _vm._v(" "),
                  _vm.notifyNumber > 0
                    ? _c("div", { staticClass: "wrapper-notify-number" }, [
                        _c("span", {
                          staticClass: "fa-stack",
                          class: _vm.renderClass,
                          attrs: { "data-count": _vm.notifyNumber }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.eventStatus !== "review" &&
                  _vm.eventStatus !== "submitted"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _c("br"),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v("ADURO")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v(_vm._s(_vm.getClientName))
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7bfa3c92", esExports)
  }
}

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar" }, [
    _c("nav", { staticClass: "sidebar-nav" }, [
      _c("div", { attrs: { slot: "header" }, slot: "header" }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "nav" },
        _vm._l(_vm.listSideBar, function(item, index) {
          return _c(
            "li",
            { staticClass: "nav-item" },
            [
              item.line ? _c("div", { staticClass: "bottomLine" }) : _vm._e(),
              _vm._v(" "),
              item.overview
                ? _c("div", { staticClass: "overview" }, [
                    _vm._v(_vm._s(item.overview))
                  ])
                : _vm._e(),
              _vm._v(" "),
              [
                _c("SidebarNavIcons", {
                  attrs: {
                    name: item.name,
                    url: item.url,
                    icon: item.icon,
                    notifyNumber: item.notifyNumber,
                    eventStatus: item.eventStatus
                  }
                })
              ]
            ],
            2
          )
        })
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71d3f73b", esExports)
  }
}

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4bc38b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(1564);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4bc38b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Switch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Switch.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a4bc38b6", Component.options)
  } else {
    hotAPI.reload("data-v-a4bc38b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.classList },
    [
      _c("input", {
        staticClass: "switch-input",
        attrs: { type: "checkbox" },
        domProps: { value: _vm.value, checked: _vm.isChecked },
        on: { change: _vm.handleChange }
      }),
      _vm._v(" "),
      _vm.isOn
        ? [
            _c("span", {
              staticClass: "switch-label",
              attrs: { "data-on": _vm.on, "data-off": _vm.off }
            })
          ]
        : [_c("span", { staticClass: "switch-label" })],
      _vm._v(" "),
      _c("span", { staticClass: "switch-handle" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a4bc38b6", esExports)
  }
}

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigator_vue__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d866af6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__ = __webpack_require__(1574);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1566)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d866af6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d866af6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Navigator.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Navigator.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d866af6", Component.options)
  } else {
    hotAPI.reload("data-v-6d866af6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("619d39c9", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d866af6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navigator.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d866af6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navigator.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.navigator-container[data-v-6d866af6] {\n  background-color: #3d6274;\n  padding-left: 35px;\n}\n.navigator-container .title-dashboard[data-v-6d866af6] {\n  color: #FFFFFF;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  margin-top: 25px;\n  margin-bottom: 15px;\n}\n.navigator-container ul.menu-list[data-v-6d866af6] {\n  height: 30px;\n  background-color: #3d6274;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.navigator-container ul.menu-list li.menu-item[data-v-6d866af6] {\n  float: left;\n  margin: 0 50px 0 0;\n  color: #ffffff;\n  padding-bottom: 7px;\n  border-bottom: solid 3px #3d6274;\n}\n.navigator-container ul.menu-list li.menu-item a[data-v-6d866af6] {\n  display: block;\n  color: #ffffff;\n}\n.navigator-container ul.menu-list li.menu-item.active[data-v-6d866af6] {\n  border-bottom: solid 3px #00A4D6;\n  color: #00A4D6;\n}\n.navigator-container ul.menu-list li.menu-item[data-v-6d866af6]:hover {\n  border-bottom: solid 3px #00A4D6;\n  color: #00A4D6;\n  cursor: pointer;\n}\n.title-container .title-text[data-v-6d866af6] {\n  margin-top: 30px;\n}\n@media screen and (max-width: 800px) {\nul.menu-list li.menu-item[data-v-6d866af6]:first-child {\n    margin-left: 0;\n}\n}\n.navigator-header[data-v-6d866af6] {\n  padding: 0 0 0 15px;\n}\n.no-margin-left-right-for-header[data-v-6d866af6] {\n  margin-right: 0;\n}\n.no-padding-right[data-v-6d866af6] {\n  padding-right: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorItem__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigator',
  components: {
    NavigatorItem: __WEBPACK_IMPORTED_MODULE_1__NavigatorItem__["a" /* default */]
  },
  props: {
    navItems: {
      type: Array,
      default: []
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    clickItem: function clickItem(item) {
      var _this = this;

      this.navItems.forEach(function (element, index) {
        _this.navItems[index].active = element.text === item.text;
      });
      this.$router.push({ name: item.viewName });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    getEventCountByClientId: 'ACTION_GET_EVENT_COUNT_BY_CLIENT'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    getClientListId: 'GETTERS_CLIENT_LIST_ID'
  })),
  created: function created() {
    var _this2 = this;

    this.navItems.forEach(function (element, index) {
      _this2.navItems[index].active = element.viewName === _this2.$router.currentRoute.name;
    });
  },

  watch: {
    getClientListId: {
      handler: function handler() {
        this.getEventCountByClientId(this.getClientListId);
      }
    }
  }
});

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigatorItem_vue__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e40dacae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavigatorItem_vue__ = __webpack_require__(1573);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1570)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e40dacae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigatorItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e40dacae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavigatorItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/NavigatorItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NavigatorItem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e40dacae", Component.options)
  } else {
    hotAPI.reload("data-v-e40dacae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("ffc72498", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e40dacae\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NavigatorItem.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e40dacae\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NavigatorItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.active[data-v-e40dacae] {\n  color: #231f20 !important;\n  background: #ffffff;\n}\n.nav-item-m[data-v-e40dacae] {\n  font-size: 13px;\n  line-height: 12px;\n  text-align: center;\n  position: relative;\n  padding-top: 15px;\n}\n.nav-item-m .nav-icon[data-v-e40dacae] {\n  font-family: FontAwesome, sans-serif;\n  font-size: 14px;\n  line-height: 14px;\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  margin: 0px;\n}\n.nav-item-m .nav-text[data-v-e40dacae] {\n  text-align: left;\n  height: 24px;\n  line-height: 15px;\n  margin-left: 20px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n}\n.nav-item-m .nav-text .company-name[data-v-e40dacae] {\n  margin: 0 0 0 33px;\n}\n.nav-item-m .nav-number[data-v-e40dacae] {\n  height: 38px;\n  width: 42px;\n  font-size: 36px;\n  line-height: 49px;\n  position: absolute;\n  bottom: 14px;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n}\n.nav-item-m .nav-underline[data-v-e40dacae] {\n  height: 5px;\n  width: 76px;\n  bottom: 0;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.nav-item-m .line-white[data-v-e40dacae] {\n  background-color: #e6e6e6;\n}\n.nav-item-m .line-blue[data-v-e40dacae] {\n  background-color: #00A4D6;\n}\n.nav-item-m .line-red[data-v-e40dacae] {\n  background-color: #a42022;\n}\n.nav-item-m .line-green[data-v-e40dacae] {\n  background-color: #417505;\n}\n.nav-item-m .line-brown[data-v-e40dacae] {\n  background-color: #463e38;\n}\n", ""]);

// exports


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_area_chart__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_plus_circle__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_file_text_o__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_calendar_check_o__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_inbox__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_eye__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_archive__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);

//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigatorItem',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    item: {
      type: Object
    }
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    number: function number() {
      return this.showRelatedEvents ? this.item.count : this.countEventByStatus(this.item.eventStatus);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])({
    countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
    showRelatedEvents: 'GETTERS_SHOW_RELATED_EVENT'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])({
    setListEventStatus: 'ACTION_SET_LIST_EVENT_STATUS'
  }))
});

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-item-m",
      class: { active: _vm.isActive },
      attrs: { align: "center" },
      on: {
        click: function($event) {
          _vm.navigatorItemClick()
        }
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.item.text) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e40dacae", esExports)
  }
}

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row no-margin-left-right-for-header" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 no-padding-right navigator-container" },
        [
          _c("div", { staticClass: "title-dashboard title-text pl-0" }, [
            _vm._v("Dashboard")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "menu-list" },
            _vm._l(_vm.navItems, function(item, index) {
              return !item.overview
                ? _c(
                    "li",
                    {
                      key: item.url,
                      staticClass: "menu-item",
                      class: { active: item.active },
                      on: {
                        click: function($event) {
                          _vm.clickItem(item)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(item.text) + "\n        ")]
                  )
                : _vm._e()
            })
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d866af6", esExports)
  }
}

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSession_vue__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6344196d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSession_vue__ = __webpack_require__(1577);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSession_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6344196d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSession_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/SearchSession.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SearchSession.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6344196d", Component.options)
  } else {
    hotAPI.reload("data-v-6344196d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_plus_circle__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchSession',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    onSearchText: Function
  },
  data: function data() {
    return {
      textSearch: ''
    };
  },

  methods: {
    onSearchClients: function onSearchClients() {
      this.onSearchText(this.textSearch);
    }
  }
});

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-session bg-white" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-4 col-md-4 col-sm-6" },
        [
          _c(
            "b-input-group",
            [
              _c("b-form-input", {
                staticClass: "placeholder-italic",
                attrs: {
                  type: "text",
                  placeholder: "Search by client or people",
                  formatter: _vm.format
                },
                on: { change: _vm.onSearchClients },
                model: {
                  value: _vm.textSearch,
                  callback: function($$v) {
                    _vm.textSearch = $$v
                  },
                  expression: "textSearch"
                }
              }),
              _vm._v(" "),
              _c("Icon", {
                staticClass: "search-icon",
                attrs: { name: "search" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "search-icon" })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6344196d", esExports)
  }
}

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientCardsManagement_vue__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a084cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientCardsManagement_vue__ = __webpack_require__(1589);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientCardsManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a084cda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientCardsManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/ClientCardsManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClientCardsManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a084cda", Component.options)
  } else {
    hotAPI.reload("data-v-5a084cda", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClientCard__ = __webpack_require__(1580);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-items-management',
  components: {
    ClientCard: __WEBPACK_IMPORTED_MODULE_0__ClientCard__["a" /* default */]
  },
  props: {
    clients: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listEM: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientCard_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_020621ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientCard_vue__ = __webpack_require__(1588);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_020621ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientCard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/ClientCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClientCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-020621ec", Component.options)
  } else {
    hotAPI.reload("data-v-020621ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_pencil__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_cog__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientCardFooter__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'client-card',
  components: {
    ClientCardFooter: __WEBPACK_IMPORTED_MODULE_4__ClientCardFooter__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  props: {
    client: {
      type: Object,
      default: {}
    },
    isNoTrans: {
      type: Boolean,
      default: false
    },
    isClear: {
      type: Boolean,
      default: false
    },
    listEM: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      roleIcon: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].iconNames.pencil,
      selectedAm: {},
      listEM: [],
      emName: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    gotoUserView: function gotoUserView() {
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.clientId, this.client.id);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.clientName, this.client.clientName);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.addOns, this.client.addOns);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.readOnly, this.client.userManageReadOnly);
      this.updateClientName(this.client.clientName);
      this.$router.push({
        name: __WEBPACK_IMPORTED_MODULE_7__router_constants__["a" /* default */].clientDashboard.name,
        params: {
          clientId: this.client.id
        }
      });
    },
    isEventManager: function isEventManager() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].USER_ROLE.eventManager;
    },
    isAdminRole: function isAdminRole() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].USER_ROLE.admin;
    },
    isClientManager: function isClientManager() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].USER_ROLE.clientManager;
    },
    selectAm: function selectAm(item) {
      if (item !== null) {
        // update AM for client
        this.selectedAm = item;
        var client = {
          clientId: this.client.id,
          clientName: this.client.clientName,
          userId: this.selectedAm.id,
          eventManagerName: this.client.eventManagerName
        };
        this.updateClient(client); // @param clientId, Event Manager Name, Account managerID
      }
    },
    eventManagerNameChange: function eventManagerNameChange() {
      var client = {
        clientId: this.client.id,
        clientName: this.client.clientName,
        userId: this.selectedAm.id,
        eventManagerName: this.client.eventManagerName
      };
      this.updateClient(client);
    },
    openModal: function openModal() {
      this.$modal.show('customMessageModal', this.client.id);
    },
    deleteClientClick: function deleteClientClick() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].modalAction.deleteClient,
        data: this.client
      };
      this.$modal.show('eventModal', modalData);
    },
    dropdownItemClick: function dropdownItemClick(item) {
      this.client = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.client, {
        clientId: this.client.id,
        eventManagerId: item.id,
        eventManagerName: item.firstName + ' ' + item.lastName
      });
      this.updateClient(this.client);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])({
    updateClient: 'ACTION_UPDATE_CLIENT',
    updateClientName: 'ACTION_UPDATE_CLIENT_NAME',
    deleteClientApi: 'ACTION_DELETE_CLIENT'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isEM: function isEM() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].USER_ROLE.eventManager || localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].USER_ROLE.admin;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])({
    getListAM: 'GETTERS_GET_LIST_AM'
  }), {
    listAM: function listAM() {
      return this.getListAM;
    },
    getEMName: function getEMName() {
      return this.listEM.find();
    }
  }),
  mounted: function mounted() {
    this.selectedAm = {
      id: this.client.managedBy,
      name: this.client.managerName
    };
  }
});

/***/ }),
/* 1582 */,
/* 1583 */,
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientCardFooter_vue__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e54ec1b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientCardFooter_vue__ = __webpack_require__(1587);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientCardFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e54ec1b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientCardFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/ClientCardFooter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClientCardFooter.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e54ec1b2", Component.options)
  } else {
    hotAPI.reload("data-v-e54ec1b2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_home__ = __webpack_require__(1586);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-item-footer',
  props: {
    client: Object
  }
});

/***/ }),
/* 1586 */,
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-item-footer" }, [
    _c(
      "div",
      { staticClass: "event-item-icon-component no-margin-left-right row" },
      [
        _c("div", { staticClass: "icon-footer icon-draft" }),
        _vm._v(" "),
        _c("div", { staticClass: "event-item-icon-amount" }, [
          _vm._v(_vm._s(_vm.client.drafts))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-item-icon-component row" }, [
      _c("div", { staticClass: "icon-footer icon-submitted" }),
      _vm._v(" "),
      _c("div", { staticClass: "event-item-icon-amount" }, [
        _vm._v(" " + _vm._s(_vm.client.archived))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "event-item-icon-component row" }, [
      _c("div", { staticClass: "icon-footer icon-approved" }),
      _vm._v(" "),
      _c("div", { staticClass: "event-item-icon-amount" }, [
        _vm._v(_vm._s(_vm.client.approved))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e54ec1b2", esExports)
  }
}

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-item",
      class: { noTransition: _vm.isNoTrans, "clear-both": _vm.isClear }
    },
    [
      _vm.isEM
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.bottom",
                  modifiers: { hover: true, bottom: true }
                }
              ],
              staticClass: "event-item-custom-message",
              attrs: { title: "More details" },
              on: {
                click: function($event) {
                  _vm.openModal()
                }
              }
            },
            [
              _c("div", {
                staticClass: "event-item-custom-message-icon icon-gear"
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdminRole()
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.bottom",
                  modifiers: { hover: true, bottom: true }
                }
              ],
              staticClass: "delete-client-button",
              attrs: { title: "Delete" },
              on: {
                click: function($event) {
                  _vm.deleteClientClick()
                }
              }
            },
            [_c("div", { staticClass: "icon-delete" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "event-item-header" }, [
        _c("div", { staticClass: "wrapper-event-item-name" }, [
          _c(
            "div",
            {
              staticClass: "event-item-name",
              on: {
                click: function($event) {
                  _vm.gotoUserView()
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.client.clientName))])]
          )
        ]),
        _vm._v(" "),
        !_vm.isClientManager()
          ? _c("div", { staticClass: "event-item-role" }, [
              _c(
                "div",
                { staticClass: "event-manager" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "ap-dropdown", attrs: { vertical: "" } },
                    [
                      _c(
                        "b-dropdown",
                        {
                          directives: [
                            {
                              name: "modal",
                              rawName: "v-modal",
                              value: _vm.client.eventManagerId,
                              expression: "client.eventManagerId"
                            }
                          ],
                          staticClass: "ap-dropdown-btn",
                          attrs: {
                            "no-caret": "",
                            disabled: !(
                              _vm.isEventManager() || _vm.isAdminRole()
                            )
                          }
                        },
                        [
                          _c("template", { slot: "button-content" }, [
                            _c("div", { staticClass: "button-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "text",
                                  class: { active: _vm.emName != "" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.client.eventManagerName || "Choose EM"
                                    )
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ap-dropdown-menu" },
                            _vm._l(_vm.listEM, function(item) {
                              return _c(
                                "b-dropdown-item",
                                {
                                  key: item,
                                  staticClass: "ap-dropdown-item",
                                  attrs: { value: item.id },
                                  on: {
                                    click: function($event) {
                                      _vm.dropdownItemClick(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ap-item-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ap-item-content" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.firstName +
                                                " " +
                                                item.lastName
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "event-item-role-text-am custom-multiselect" },
                [
                  _c("multiselect", {
                    staticClass: "multiple-select-am",
                    attrs: {
                      options: _vm.listAM,
                      label: "name",
                      placeholder: "Choose AM",
                      "show-no-results": false,
                      "allow-empty": false,
                      "show-labels": false,
                      "max-height": 100,
                      disabled: !(_vm.isEventManager() || _vm.isAdminRole())
                    },
                    on: { input: _vm.selectAm },
                    model: {
                      value: _vm.selectedAm,
                      callback: function($$v) {
                        _vm.selectedAm = $$v
                      },
                      expression: "selectedAm"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("ClientCardFooter", { attrs: { client: _vm.client } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-020621ec", esExports)
  }
}

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-items-management" }, [
    _c(
      "div",
      { staticClass: "client-card-list-wrapper" },
      _vm._l(_vm.clients, function(client, index) {
        return _c("ClientCard", {
          key: client.id,
          attrs: {
            listEM: _vm.listEM,
            client: client,
            isNoTrans: index % 4 == 3,
            isClear: index % 4 == 0
          }
        })
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a084cda", esExports)
  }
}

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("AppHeader", {
        attrs: { userName: "userName", userRole: _vm.userRole }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-body" },
        [
          _c("Sidebar"),
          _vm._v(" "),
          _c("main", { staticClass: "main" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [_c("router-view")],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("AppFooter"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("FaqModal"),
      _vm._v(" "),
      _c("AddonsModal"),
      _vm._v(" "),
      _c("HistoryModal"),
      _vm._v(" "),
      _c("ModalChangeOrderDetail"),
      _vm._v(" "),
      _c("ModalInfo"),
      _vm._v(" "),
      _c("ModalEditEventDetail")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8174f406", esExports)
  }
}

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc407ac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(1593);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc407ac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/containers/Event.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Event.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dc407ac8", Component.options)
  } else {
    hotAPI.reload("data-v-dc407ac8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-container',
  components: {},
  fields: {},
  data: function data() {
    return {};
  },

  computed: {},
  props: [],
  mounted: function mounted() {}
});

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app event-container" }, [
    _c("div", { staticClass: "app-body" }, [
      _c("main", { staticClass: "main" }, [
        _c("div", { staticClass: "container-fluid" }, [_c("router-view")], 1)
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dc407ac8", esExports)
  }
}

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a64098_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1734);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a64098_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/containers/manager/Dashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-95a64098", Component.options)
  } else {
    hotAPI.reload("data-v-95a64098", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_FaqModal__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_CustomMessageModal__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_event_EventDetailModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_Modal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modal_ModalInfo__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_email_ManageEmail__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_email_EmailHistoriesManagement__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_staffing_EventStaffingDetail__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_commons__ = __webpack_require__(262);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'managerDashboard',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_13__components_commons__["e" /* Header */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_13__components_commons__["d" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_13__components_commons__["b" /* Breadcrumb */],
    Navigator: __WEBPACK_IMPORTED_MODULE_13__components_commons__["f" /* Navigator */],
    ClientCardsManagement: __WEBPACK_IMPORTED_MODULE_13__components_commons__["c" /* ClientCardsManagement */],
    SearchSession: __WEBPACK_IMPORTED_MODULE_13__components_commons__["g" /* SearchSession */],
    FaqModal: __WEBPACK_IMPORTED_MODULE_4__components_modal_FaqModal__["a" /* default */],
    CustomMessageModal: __WEBPACK_IMPORTED_MODULE_5__components_modal_CustomMessageModal__["a" /* default */],
    EventModal: __WEBPACK_IMPORTED_MODULE_7__components_modal_Modal__["a" /* default */],
    ModalInfo: __WEBPACK_IMPORTED_MODULE_8__components_modal_ModalInfo__["a" /* default */],
    EventDetailModal: __WEBPACK_IMPORTED_MODULE_6__components_modal_event_EventDetailModal__["a" /* default */],
    ManageEmailModal: __WEBPACK_IMPORTED_MODULE_9__views_email_ManageEmail__["a" /* default */],
    EmailHistoriesManagement: __WEBPACK_IMPORTED_MODULE_10__views_email_EmailHistoriesManagement__["a" /* default */],
    EventStaffingDetail: __WEBPACK_IMPORTED_MODULE_11__views_staffing_EventStaffingDetail__["a" /* default */]
  },
  fields: {
    name: { label: 'Person Full name', sortable: true },
    age: { label: 'Person age', sortable: true, 'class': 'text-center' },
    isActive: { label: 'is Active' },
    actions: { label: 'Actions' }
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_1__nav__["a" /* default */].managerDashboardNav,
      eventItems: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */].eventItems,
      dropdownItems: __WEBPACK_IMPORTED_MODULE_1__nav__["a" /* default */].dropdownItems
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showNavigator: function showNavigator() {
      var view = this.getManagerView;
      return view === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.managerEvent || view === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.managerDashboard || view === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.planAndApprove || view === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.staffing || view === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.manageApprovedDashboard;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapGetters */])({
    getManagerView: 'GETTER_GET_MANAGER_VIEW'
  })),
  props: ['routeTitle'],
  mounted: function mounted() {
    this.$store.dispatch('ACTION_GET_EVENT_COUNT');
    this.$store.dispatch('ACTION_SET_SHOW_RELATED_EVENT', false);
    this.$store.dispatch('ACTION_RESTART_LIST_EVENT_STATUS', []);
    this.$store.dispatch('ACTION_RESET_SEARCH_CLIENTS');
  }
});

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomMessageSectionSubmission__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomMessageSectionChangeOrder__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfigureSchedulerModal__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ModalChangeToggleVaccines__ = __webpack_require__(821);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    ConfigureSchedulerModal: __WEBPACK_IMPORTED_MODULE_8__ConfigureSchedulerModal__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    CustomMessageSectionSubmission: __WEBPACK_IMPORTED_MODULE_4__CustomMessageSectionSubmission__["a" /* default */],
    CustomMessageSectionChangeOrder: __WEBPACK_IMPORTED_MODULE_5__CustomMessageSectionChangeOrder__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    ModalChangeToggleVaccines: __WEBPACK_IMPORTED_MODULE_9__ModalChangeToggleVaccines__["a" /* default */]
  },
  data: function data() {
    return {
      isHoverClose: false,
      isExpanded: false,
      submissionMessage: '',
      changeOrderMessage: '',
      clientName: '',
      bIsSaveClientName: false,
      clientId: '',
      addOns: [{
        key: 'venipuncture',
        text: 'Venipuncture',
        value: false
      }, {
        key: 'cotinine',
        text: 'Cotinine',
        value: false
      }, {
        key: 'wbaStation',
        text: 'WBA Station',
        value: false
      }, {
        key: 'fluShots',
        text: 'Vaccines (Flu Shots/Covid-19 Vaccines)',
        value: false
      }, {
        key: 'paperScheduler',
        text: 'Paper Scheduler',
        value: false
      }, {
        key: 'smallSiteModel',
        text: 'Micro Site Model',
        value: false
      }, {
        key: 'smallSiteConcierge',
        text: 'Micro Site Concierge',
        value: false
      }, {
        key: 'tobaccoSelfAttestation',
        text: 'Tobacco Self Attestation',
        value: false
      }, {
        key: 'isUseSalesforce',
        text: 'Salesforce Sync (turn off for Shiftboard Sync)',
        value: false
      }],
      listSecondaryAM: [],
      secondaryAMSelected: [],
      listSubClient: [],
      subClientSelected: [],
      resellerToggle: false,
      managedByClientId: null,
      readOnlyToggle: false,
      selectedValidators: [],
      textTurnOffVaccineConfirmation: 'Are you sure you want to change the Vaccine Toggle from "ON" to "OFF"?',
      textTurnOffVaccineConfirmationDescription: ['All scheduled vaccine related events and slots will be cancelled.', 'Members with scheduled vaccine related appointments will receive a cancellation email.'],
      modalVaccineChangeConfirmationName: 'modalVaccineChangeConfirmationName',
      isLoading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    openSchedulerConfig: function openSchedulerConfig() {
      this.$modal.show('configureSchedulerModal', { clientId: this.clientId });
    },
    hideModal: function hideModal() {
      this.$modal.hide('customMessageModal');
    },
    beforeOpen: function beforeOpen(client) {
      var _this = this;

      this.isLoading = true;
      this.getClient(client.params).then(function (response) {
        var result = response.data.data;
        _this.clientName = result.clientName || '';
        _this.clientId = result.id || '';
        _this.submissionMessage = result.submissionMessage || __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].defaultModalMessage.submissionMessage;
        _this.changeOrderMessage = result.changeOrderMessage || __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].defaultModalMessage.changeOrderMessage;
        // Binding data for Additional services
        if (result && result.addOns) {
          var arrAddOns = result.addOns.split(',');
          _this.addOns.forEach(function (addOn) {
            addOn.value = false;
          });
          _this.addOns.forEach(function (element) {
            arrAddOns.forEach(function (ele) {
              if (ele === element.key) {
                element.value = true;
              }
            });
          });
        }
        // Binding data for Secondary AM
        var listAM = _this.listAM;
        var secondaryAMSelected = [];
        var listSecondaryAM = [];
        if (listAM !== null) {
          listAM.forEach(function (element) {
            if (element.id !== result.managedBy) {
              element['name'] = element.firstName + ' ' + element.lastName;
              listSecondaryAM.push(element);
            }
          });
        }
        if (result && result.secondaryAMList) {
          result.secondaryAMList.forEach(function (element) {
            element['name'] = element.firstName + ' ' + element.lastName;
            secondaryAMSelected.push(element);
          });
        }
        _this.secondaryAMSelected = secondaryAMSelected;
        _this.listSecondaryAM = listSecondaryAM;
        // Binding data for Reseller
        var listSubClient = [];
        var subClientSelected = [];
        _this.resellerToggle = result && result.isResellerCheck;
        if (result && result.unAssignedClients) {
          result.unAssignedClients.forEach(function (element) {
            listSubClient.push(element);
          });
        }
        if (result && result.subClients) {
          result.subClients.forEach(function (element) {
            listSubClient.push(element);
            subClientSelected.push(element);
          });
        }
        _this.listSubClient = listSubClient;
        _this.subClientSelected = subClientSelected;
        _this.managedByClientId = result.managedByClientId || null;
        _this.readOnlyToggle = result && result.readOnly;
        _this.getAllValidators();
        _this.getValidatorsByClientId(result.id).then(function (response) {
          _this.selectedValidators = response.validators;
        });
      }).finally(function () {
        _this.isLoading = false;
      });
    },
    beforeClose: function beforeClose() {
      // this.secondaryAMSelected = [];
      // this.subClientSelected = [];
      // this.listSecondaryAM = [];
      // this.listSubClient = [];
      // this.resellerToggle = false;
      this.getClients();
    },
    callSaveMessage: function callSaveMessage(updateObj) {
      var _this2 = this;

      this.updateMessage({
        type: updateObj.type,
        content: updateObj.content,
        clientId: this.clientId
      }).then(function () {
        _this2.getClients();
      });
    },
    checkboxToggle: function checkboxToggle(key, value) {
      var obj = {
        clientId: this.clientId,
        key: key,
        isAdd: value
      };
      if (key === 'fluShots' && !value) {
        this.$modal.show(this.modalVaccineChangeConfirmationName, obj);
        return;
      }
      this.processUpdateAddons(obj);
    },
    selectSecondaryAM: function selectSecondaryAM(selectedOption) {
      var obj = {
        clientId: this.clientId,
        user: selectedOption,
        isAdd: true
      };
      this.updateSecondaryAM(obj);
    },
    removeAM: function removeAM(removedOption) {
      var obj = {
        clientId: this.clientId,
        user: removedOption,
        isAdd: false
      };
      this.updateSecondaryAM(obj);
    },
    addValidators: function addValidators(value) {
      var _this3 = this;

      var obj = {
        clientId: this.clientId,
        validatorId: value.id,
        isAdd: true
      };
      this.updateValidatorsToClient(obj).then(function (response) {
        _this3.selectedValidators = response.validators;
      });
    },
    removeValidators: function removeValidators(value) {
      var _this4 = this;

      var obj = {
        clientId: this.clientId,
        validatorId: value.id,
        isAdd: false
      };
      this.updateValidatorsToClient(obj).then(function (response) {
        _this4.selectedValidators = response.validators;
      });
    },
    resellerToggleCheck: function resellerToggleCheck(value) {
      var obj = {
        clientManager: this.clientId,
        isReseller: value
      };
      this.updateSubClient(obj);
    },
    selectSubClient: function selectSubClient(selectedOption) {
      var obj = {
        clientManager: this.clientId,
        subClient: selectedOption.clientId
      };
      this.updateSubClient(obj).then(function () {});
    },
    removeSubClient: function removeSubClient(removedOption) {
      var obj = {
        clientManager: this.clientId,
        subClient: removedOption.clientId
      };
      this.updateSubClient(obj).then(function () {});
    },
    readOnlyToggleCheck: function readOnlyToggleCheck(value) {
      var obj = {
        id: this.clientId,
        readOnly: value
      };
      this.updateReadOnly(obj);
    },
    readOnlyTaggingValidators: function readOnlyTaggingValidators(item) {
      return ['firstName', 'lastName', 'employeeId', 'cardCode', 'email'].includes(item.frontEndField);
    },
    processUpdateAddons: function processUpdateAddons(obj) {
      var _this5 = this;

      this.updateAddOn(obj).then(function (rs) {
        if (rs.message) {
          var currentAddOn = _this5.addOns.find(function (addOn) {
            return addOn.key === obj.key;
          });
          currentAddOn.value = !obj.isAdd;
        } else {
          _this5.$modal.hide(_this5.modalVaccineChangeConfirmationName);
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    updateMessage: 'ACTION_UPDATE_MESSAGE',
    updateAddOn: 'UPDATE_ADD_ON',
    getClients: 'ACTION_GET_CLIENTS',
    updateSecondaryAM: 'ACTION_UPDATE_SECONDARY_AM',
    updateSubClient: 'ACTION_UPDATE_SUB_CLIENT',
    updateReadOnly: 'ACTION_UPDATE_READ_ONLY',
    saveClientName: 'ACTION_SAVE_CLIENT_NAME',
    updateValidatorsToClient: 'ACTION_UPDATE_VALIDATORS_TO_CLIENT',
    getAllValidators: 'ACTION_GET_ALL_VALIDATORS',
    getValidatorsByClientId: 'ACTION_GET_VALIDATORS_BY_CLIENT_ID',
    getClient: 'ACTION_GET_CLIENT'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])({
    setIsLoading: 'MUTATION_SET_IS_LOADING'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isAdminUser: function isAdminUser() {
      return this.getUserRole === __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].USER_ROLE.admin;
    },
    getUserRole: function getUserRole() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.role);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    getCustomMessage: 'GETTERS_GET_EVENT_HISTORY',
    listAM: 'GETTERS_GET_LIST_AM',
    listValidators: 'GETTER_GET_VALIDATOR_LIST'
  }))
});

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomMessageSectionSubmission_vue__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_859f0632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomMessageSectionSubmission_vue__ = __webpack_require__(1601);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1598)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomMessageSectionSubmission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_859f0632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomMessageSectionSubmission_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/CustomMessageSectionSubmission.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CustomMessageSectionSubmission.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-859f0632", Component.options)
  } else {
    hotAPI.reload("data-v-859f0632", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1599);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("68caf636", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-859f0632\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CustomMessageSectionSubmission.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-859f0632\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CustomMessageSectionSubmission.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.body-custom-item .item-title {\n  height: 20px;\n  color: #444444;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n}\n.body-custom-item .item-subtitle {\n  height: 24px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 10px;\n}\n.body-custom-item .item-subtitle .blue {\n  color: #0080a5;\n  font-weight: 600;\n}\n.body-custom-item .item-body-detail {\n  margin-top: 5px;\n  border: solid 1px #cccccc;\n  border-radius: 5px;\n  font-family: 'Open Sans', sans-serif;\n}\n.body-custom-item .quillWrapper {\n  border: none;\n  font-family: 'Open Sans', sans-serif;\n}\n.body-custom-item .ql-toolbar.ql-snow {\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n.body-custom-item .ql-container.ql-snow {\n  border-bottom: none;\n  border-right: none;\n  border-left: none;\n}\n.body-custom-item .grp-button-action {\n  margin-top: 8px;\n}\n.body-custom-item .grp-button-action .item-reset-btn {\n  background-color: #AAA7A4;\n  float: left;\n}\n.body-custom-item .grp-button-action .item-reset-btn span {\n  color: #FFFFFF;\n  font-size: 16px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n  letter-spacing: 0.1px;\n  font-weight: 600;\n}\n.body-custom-item .grp-button-action .item-cancel-btn {\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n  background-color: #FFF;\n  float: right;\n}\n.body-custom-item .grp-button-action .item-cancel-btn span {\n  font-weight: 600;\n  color: #00A4D6;\n  font-size: 16px;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.body-custom-item .grp-button-action .item-save-btn {\n  background-color: #00A4D6;\n  float: right;\n  margin-left: 16px;\n}\n.body-custom-item .grp-button-action .item-save-btn svg {\n  color: #FFFFFF;\n  font-size: 18px;\n  line-height: 18px;\n}\n.body-custom-item .grp-button-action .item-save-btn span {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_file_text_o__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_editor__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_1_vue2_editor__["a" /* VueEditor */]
  },
  data: function data() {
    return {
      canSave: true,
      message: '',
      isDefault: false
    };
  },

  props: {
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    saveMessage: function saveMessage(type) {
      this.$emit('UPDATE_MESSAGE', {
        type: type,
        content: this.message
      });
    },
    hideModal: function hideModal() {
      this.$modal.hide('customMessageModal');
    },
    resetMessage: function resetMessage() {
      this.message = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].defaultModalMessage.submissionMessage;
      this.saveMessage('SUBMISSION');
    }
  },
  computed: {},
  mounted: function mounted() {
    this.message = this.content;
  },

  watch: {
    message: {
      handler: function handler() {
        if (this.message === '<p><br></p>') {
          this.canSave = false;
        } else {
          this.canSave = true;
        }
        if (this.message === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].defaultModalMessage.submissionMessage) {
          this.isDefault = true;
        } else {
          this.isDefault = false;
        }
      }
    }
  }
});

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body-custom-item" }, [
    _c("div", { staticClass: "item-title" }, [
      _vm._v("\n    Event submission message\n  ")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "item-body-detail" },
      [
        _c("vue-editor", {
          class: _vm.isDefault ? "default-message" : null,
          attrs: { id: "submission-message" },
          model: {
            value: _vm.message,
            callback: function($$v) {
              _vm.message = $$v
            },
            expression: "message"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grp-button-action" },
      [
        _c(
          "b-button",
          {
            staticClass: "item-reset-btn",
            on: {
              click: function($event) {
                _vm.resetMessage()
              }
            }
          },
          [
            _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
              _vm._v("RESET MESSAGE")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "item-save-btn dt-group-btn-func-btn-right",
            attrs: { disabled: !_vm.canSave },
            on: {
              click: function($event) {
                _vm.saveMessage("SUBMISSION")
              }
            }
          },
          [
            _c("Icon", { attrs: { name: "file-text-o" } }),
            _vm._v(" "),
            _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
              _vm._v("SAVE MESSAGE")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "item-cancel-btn",
            on: {
              click: function($event) {
                _vm.hideModal()
              }
            }
          },
          [
            _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
              _vm._v("CANCEL")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-subtitle" }, [
      _vm._v("\n    You are submitting event "),
      _c("span", { staticClass: "blue" }, [_vm._v("(Event name here)")]),
      _vm._v(" for approval.\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-859f0632", esExports)
  }
}

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomMessageSectionChangeOrder_vue__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c22bf1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomMessageSectionChangeOrder_vue__ = __webpack_require__(1606);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1603)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomMessageSectionChangeOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c22bf1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CustomMessageSectionChangeOrder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/CustomMessageSectionChangeOrder.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CustomMessageSectionChangeOrder.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c22bf1a", Component.options)
  } else {
    hotAPI.reload("data-v-3c22bf1a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8cddabee", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c22bf1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CustomMessageSectionChangeOrder.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c22bf1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CustomMessageSectionChangeOrder.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_file_text_o__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_editor__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_1_vue2_editor__["a" /* VueEditor */]
  },
  data: function data() {
    return {
      canSave: true,
      message: '',
      isDefault: true
    };
  },

  props: {
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    saveMessage: function saveMessage(type) {
      this.$emit('UPDATE_MESSAGE', {
        type: type,
        content: this.message
      });
    },
    hideModal: function hideModal() {
      this.$modal.hide('customMessageModal');
    },
    resetMessage: function resetMessage() {
      this.message = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].defaultModalMessage.changeOrderMessage;
      this.saveMessage('CHANGE_ORDER');
    }
  },
  computed: {},
  mounted: function mounted() {
    this.message = this.content;
  },

  watch: {
    message: {
      handler: function handler() {
        if (this.message === '<p><br></p>') {
          this.canSave = false;
        }
        if (this.message === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].defaultModalMessage.changeOrderMessage) {
          this.isDefault = true;
        } else {
          this.isDefault = false;
        }
      }
    }
  }
});

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body-custom-item", staticStyle: { "margin-top": "112px" } },
    [
      _c("div", { staticClass: "item-title" }, [
        _vm._v("\n    Change order message\n  ")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item-body-detail" },
        [
          _c("vue-editor", {
            class: _vm.isDefault ? "default-message" : null,
            attrs: { id: "change-order-message" },
            model: {
              value: _vm.message,
              callback: function($$v) {
                _vm.message = $$v
              },
              expression: "message"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grp-button-action" },
        [
          _c(
            "b-button",
            {
              staticClass: "item-reset-btn",
              on: {
                click: function($event) {
                  _vm.resetMessage()
                }
              }
            },
            [
              _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
                _vm._v("RESET MESSAGE")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "item-save-btn dt-group-btn-func-btn-right",
              attrs: { disabled: !_vm.canSave },
              on: {
                click: function($event) {
                  _vm.saveMessage("CHANGE_ORDER")
                }
              }
            },
            [
              _c("Icon", { attrs: { name: "file-text-o" } }),
              _vm._v(" "),
              _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
                _vm._v("SAVE MESSAGE")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "item-cancel-btn",
              on: {
                click: function($event) {
                  _vm.hideModal()
                }
              }
            },
            [
              _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
                _vm._v("CANCEL")
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-subtitle" }, [
      _vm._v("\n    You are requesting to change "),
      _c("span", { staticClass: "blue" }, [_vm._v("(Event name here)")]),
      _vm._v(" after it’s been approved.\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c22bf1a", esExports)
  }
}

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfigureSchedulerModal_vue__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4703dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConfigureSchedulerModal_vue__ = __webpack_require__(1656);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1608)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b4703dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfigureSchedulerModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4703dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConfigureSchedulerModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ConfigureSchedulerModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConfigureSchedulerModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b4703dc", Component.options)
  } else {
    hotAPI.reload("data-v-1b4703dc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6e235b39", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1b4703dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfigureSchedulerModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1b4703dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfigureSchedulerModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.icon-close[data-v-1b4703dc] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: #1D1D1D url(" + __webpack_require__(15) + ");\n}\n.custom-modal[data-v-1b4703dc] {\n  background: rgba(0, 0, 0, 0.4);\n  font-family: 'Open Sans', sans-serif;\n  color: #1D1D1D;\n}\n.custom-modal .modal-padding[data-v-1b4703dc] {\n  padding: 24px;\n  min-height: 100vh;\n}\n.custom-modal .modal-padding .icon-close[data-v-1b4703dc] {\n  display: block;\n}\n.custom-modal .modal-padding .ap-btn[data-v-1b4703dc] {\n  text-transform: capitalize;\n  padding: 4px 24px;\n}\n.custom-modal .modal-padding .align-right-item[data-v-1b4703dc] {\n  text-align: right;\n}\n.custom-modal .modal-padding .page-title[data-v-1b4703dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.custom-modal .modal-padding .page-title .toggle-live[data-v-1b4703dc] {\n  margin-left: 24px;\n}\n.custom-modal .modal-padding .text-entry-field-wrapper .text-entry-title[data-v-1b4703dc] {\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 28px;\n  text-transform: capitalize;\n}\n.custom-modal .modal-padding .text-entry-field-wrapper .text-input[data-v-1b4703dc] {\n  height: 32px;\n  width: 100%;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n.custom-modal .modal-padding .text-entry-field-wrapper .text-input[data-v-1b4703dc]::-webkit-input-placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .modal-padding .text-entry-field-wrapper .text-input[data-v-1b4703dc]::-moz-placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .modal-padding .text-entry-field-wrapper .text-input[data-v-1b4703dc]:-ms-input-placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .modal-padding .text-entry-field-wrapper .text-input[data-v-1b4703dc]::placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .modal-padding .scheduler-config[data-v-1b4703dc] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.custom-modal .modal-padding .align-inline[data-v-1b4703dc] {\n  display: inline-block;\n}\n.custom-modal .modal-padding .textarea-wrapper[data-v-1b4703dc] {\n  height: 140px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n}\n.custom-modal .modal-padding .multiselect__tags[data-v-1b4703dc] {\n  font-size: 12px;\n}\n.custom-modal .title[data-v-1b4703dc] {\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 24px;\n  text-transform: none;\n}\n.custom-modal .group-btn[data-v-1b4703dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 40px;\n}\n.custom-modal .isLoading[data-v-1b4703dc] {\n  display: block;\n  text-align: center;\n  color: #606060;\n  height: 100%;\n}\n.custom-modal .noDisplay[data-v-1b4703dc] {\n  display: none!important;\n}\n.custom-modal .overlay[data-v-1b4703dc] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.custom-modal .spinner-align[data-v-1b4703dc] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.custom-modal .image-preview[data-v-1b4703dc] {\n  width: 350px;\n  height: auto;\n  margin-bottom: 15px;\n}\n.custom-modal .image-preview .preview[data-v-1b4703dc] {\n  max-width: 100%;\n  max-height: 200px;\n}\n.custom-modal .loading-btn[data-v-1b4703dc] {\n  width: 15px;\n}\n.custom-modal .email-head-text[data-v-1b4703dc] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 32px;\n  margin-top: 20px;\n}\n.custom-modal .alert-icon-red-error[data-v-1b4703dc] {\n  width: 24px;\n  height: 24px;\n  color: #ffffff;\n  background: #ffffff url(" + __webpack_require__(817) + ") no-repeat center;\n}\n.custom-modal .display-space-between[data-v-1b4703dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 4px;\n}\n.custom-modal .display-flex-end[data-v-1b4703dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.custom-modal .error-text-color[data-v-1b4703dc] {\n  color: #FF3400;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-left: 8px;\n}\n.custom-modal .branded-url-error[data-v-1b4703dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.custom-modal .sf-program-id-error[data-v-1b4703dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modal_patient_PatientDetailModal__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eventManagement_eventDetail_StaffManagement__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_ckeditor2__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commons_Toggle__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__preview_SchedulerPreview__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_css_helper__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commons_Popup__ = __webpack_require__(820);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["a" /* default */]);

var dict = {
  custom: {
    hpsf: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    },
    labcorp: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    },
    htk: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    },
    brandedURL: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'configureSchedulerModal',
  components: {
    Toggle: __WEBPACK_IMPORTED_MODULE_16__commons_Toggle__["a" /* default */],
    VueSlider: __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__["a" /* default */],
    PatientDetailModal: __WEBPACK_IMPORTED_MODULE_10__components_modal_patient_PatientDetailModal__["a" /* default */],
    ScrollTop: __WEBPACK_IMPORTED_MODULE_11__components_utils_ScrollTop__["a" /* default */],
    StaffManagement: __WEBPACK_IMPORTED_MODULE_12__components_eventManagement_eventDetail_StaffManagement__["a" /* default */],
    VueCkeditor: __WEBPACK_IMPORTED_MODULE_13_vue_ckeditor2__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default.a,
    SchedulerPreview: __WEBPACK_IMPORTED_MODULE_17__preview_SchedulerPreview__["a" /* default */],
    Popup: __WEBPACK_IMPORTED_MODULE_20__commons_Popup__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      clientId: 0,
      dropdowntitle: [],
      screenerDropdowntitle: [],
      phlebotomistDropdowntitle: [],
      allWorkGroups: [],
      configurations: {
        allowBookFluShot: false,
        allowBookForSpouse: false,
        confirmationEmailTemplate: {
          body: '',
          emailSubject: null,
          templateType: ''
        },
        cancellationEmailTemplate: {
          body: ''
        },
        reminderEmailTemplate: {
          body: ''
        },
        reminderSpouseEmailTemplate: {
          body: ''
        },
        confirmationSpouseEmailTemplate: {
          body: ''
        },
        cancellationSpouseEmailTemplate: {
          body: ''
        },
        biometricResultEmailTemplate: {
          body: ''
        },
        spouseLabel: '',
        landingTopText: '',
        landingBottomText: '',
        landingThankYouText: '',
        liveTestUser: false
      },
      imageData: '',
      isLoading: false,
      eventSchedulerList: [],
      config: {
        toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'tools', items: ['Maximize'] }],
        height: 300,
        toolbarCanCollapse: true,
        allowedContent: true,
        toolbarStartupExpanded: false
      },
      configEmail: {
        // config for editor of email fields
        toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'tools', items: ['Maximize'] }, { name: 'Event Fields', items: ['eventTags'] }, { name: 'document', items: ['Source'] }],
        height: 300,
        fullPage: true, // allow content contains html/body/head tags
        autoGrow_onStartup: true,
        toolbarCanCollapse: true,
        allowedContent: true,
        toolbarStartupExpanded: true,
        extraPlugins: 'eventTags',
        emailTags: []
      },
      cache: {
        configurations: {}
      },
      emailTemplate: {
        body: '',
        emailSubject: '',
        templateType: ''
      },
      enableBookVaccineAtClient: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.$modal.hide('configureSchedulerModal');
    },
    beforeOpen: function beforeOpen(params) {
      var _this = this;

      this.$validator.localize('en', dict); // This is used to overwrite the default error message
      this.clientId = params.params.clientId;

      this.isLoading = true;
      this.actionGetClientSchedulerConfig(this.clientId).then(function (response) {
        if (!response.errors) {
          _this.configurations = response.configurations || {};
          localStorage.setItem('SchedulerConfigurations', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this.configurations));
          __WEBPACK_IMPORTED_MODULE_18__utils_css_helper__["a" /* default */].customColorForUI();
          _this.cache.configurations = __WEBPACK_IMPORTED_MODULE_19_lodash___default.a.cloneDeep(_this.configurations);
          _this.imageData = _this.configurations.logoFullUrl ? "https://resources.adurolife.com/cw/prod2/api/v1" + '/' + _this.configurations.logoFullUrl : '';
          _this.allWorkGroups = response.sbWorkGroupDtos;
          _this.dropdowntitle = response.sbWorkGroupDtos.find(function (x) {
            return x.id === _this.configurations.sbWorkGroupId;
          });
          _this.screenerDropdowntitle = response.sbWorkGroupDtos.find(function (x) {
            return x.id === _this.configurations.sbScreenerWorkGroupId;
          });
          _this.phlebotomistDropdowntitle = response.sbWorkGroupDtos.find(function (x) {
            return x.id === _this.configurations.sbPhlebotomistWorkGroupId;
          });
          _this.emailTemplate = _this.configurations.emailTemplateDtoList[0];
          _this.actionGetClient(_this.clientId).then(function (clientResponse) {
            var client = clientResponse.data.data;
            if (client && client.addOns && client.addOns.includes(__WEBPACK_IMPORTED_MODULE_15__consts__["a" /* default */].listAdditionalServicesKey.fluShots)) {
              _this.enableBookVaccineAtClient = true;
            }
          });
        } else {
          _this.$toast.success(response.errors, '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optError));
        }
      }).finally(function () {
        _this.isLoading = false;
      });
    },
    onCancel: function onCancel() {
      this.configurations = __WEBPACK_IMPORTED_MODULE_19_lodash___default.a.cloneDeep(this.cache.configurations);
    },
    previewFiles: function previewFiles() {
      this.logo = this.$refs.logo.files;
    },
    isUsedBingMap: function isUsedBingMap() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_15__consts__["a" /* default */].LOCAL_STORE.isBingMap) === 'true';
    },

    removeImage: function removeImage(e) {
      this.logo = null;
      this.imageData = '';
      this.configurations.logoFullUrl = null;
      this.configurations.logoUrl = null;
      this.configurations.logoThumbFullUrl = null;
    },
    previewImage: function previewImage(event) {
      var _this2 = this;

      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        if (input.files[0].size > 1020 * 300) {
          // 300KB
          this.$toast.success('File size must be less than 300Kb', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
          return;
        }
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = function (e) {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          _this2.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
        this.logo = input.files[0];
      }
    },
    dropdownItemClick: function dropdownItemClick(item) {
      this.dropdownTitle = item;
      this.configurations.sbWorkGroupId = item.id;
    },
    screenerDropdownItemClick: function screenerDropdownItemClick(item) {
      this.screenerDropdownTitle = item;
      this.configurations.sbScreenerWorkGroupId = item.id;
    },
    phlebotomistDropdownItemClick: function phlebotomistDropdownItemClick(item) {
      this.phlebotomistDropdownTitle = item;
      this.configurations.sbPhlebotomistWorkGroupId = item.id;
    },
    preventSave: function preventSave(event) {
      var excludeIds = ['save-configure-scheduler'];
      if (excludeIds.includes(event.target.id)) {
        return false;
      }

      var types = ['input', 'button', 'span', 'label', 'multiselect'];
      if (types.includes(event.target.tagName.toLowerCase())) {
        return true;
      }
      var classes = ['multiselect', 'multiselect__select', 'multiselect__tags', 'cke_path_item', 'cke_combo_button', 'cke_button', 'cke_toolbox_collapser', 'multiselect__select'];
      return classes.find(function (e) {
        return event.target.classList.contains(e);
      });
    },
    onSave: function onSave(event) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.preventSave(event)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!_this3.isLoading) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return _this3.checkValidFields();

              case 6:
                if (!_context.sent) {
                  _context.next = 8;
                  break;
                }

                _this3.$modal.show('saveConfigurationsModal');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    checkValidFields: function checkValidFields() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$validator.validate();

              case 2:
                if (!(_this4.errors.items.length > 0)) {
                  _context2.next = 5;
                  break;
                }

                if (_this4.errors.items[0].rule === 'required') {
                  _this4.$toast.success('The field is blank, please enter a URL', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this4.$toastOpt.optError));
                } else {
                  _this4.$toast.success('Please enter a valid URL', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this4.$toastOpt.optError));
                }
                return _context2.abrupt('return', false);

              case 5:
                return _context2.abrupt('return', true);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    saveConfigurations: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isLoading = true;
                if (!this.logo || this.isUsedBingMap()) {
                  this.actionSaveConfigurations(this.configurations).then(function (responseSaveConfigs) {
                    if (!responseSaveConfigs.message) {
                      _this5.configurations = responseSaveConfigs.configurations;
                      _this5.cache.configurations = __WEBPACK_IMPORTED_MODULE_19_lodash___default.a.cloneDeep(_this5.configurations);
                      _this5.$toast.success('Saved configurations!', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optSuccess));
                    } else {
                      _this5.$toast.success(responseSaveConfigs.message, '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optError));
                    }
                    _this5.isLoading = false;
                  });
                } else {
                  this.actionUploadLogo({ clientId: this.clientId, imageFile: this.logo }).then(function (response) {
                    if (!response.message) {
                      _this5.actionGetClientSchedulerConfig(_this5.clientId).then(function (newConfigs) {
                        if (!newConfigs.message) {
                          _this5.configurations.logoUrl = newConfigs.configurations.logoUrl;
                          _this5.configurations.logoThumbFullUrl = newConfigs.configurations.logoThumbFullUrl;
                          _this5.configurations.logoFullUrl = newConfigs.configurations.logoFullUrl;
                          _this5.actionSaveConfigurations(_this5.configurations).then(function (responseSaveConfigs) {
                            if (!responseSaveConfigs.message) {
                              _this5.configurations = newConfigs.configurations;
                              _this5.cache.configurations = __WEBPACK_IMPORTED_MODULE_19_lodash___default.a.cloneDeep(_this5.configurations);
                              _this5.$toast.success('Saved configurations!', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optSuccess));
                            } else {
                              _this5.$toast.success(responseSaveConfigs.message, '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optError));
                            }
                            _this5.isLoading = false;
                          });
                        } else {
                          _this5.$toast.success(newConfigs.message, '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optError));
                        }
                        _this5.isLoading = false;
                      });
                    } else {
                      _this5.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optError));
                    }
                    _this5.isLoading = false;
                  });
                }
                localStorage.setItem('SchedulerConfigurations', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.configurations));
                __WEBPACK_IMPORTED_MODULE_18__utils_css_helper__["a" /* default */].customColorForUI();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function saveConfigurations() {
        return _ref.apply(this, arguments);
      }

      return saveConfigurations;
    }(),
    updateClientEventSchedulerStatus: function updateClientEventSchedulerStatus() {
      var _this6 = this;

      this.actionUpdateClientEventSchedulerStatus({
        clientId: this.clientId,
        events: this.eventSchedulerList
      }).then(function (response) {
        if (!response.message) {
          _this6.eventSchedulerList = response.events;
        } else {
          _this6.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this6.$toastOpt.optError));
        }
      });
    },
    handleOpenSchedulerPreview: function handleOpenSchedulerPreview() {
      var config = JSON.parse(localStorage.getItem('SchedulerConfigurations'));
      this.$modal.show('schedulerPreviewModal', {
        allowBookFluShot: config.allowBookFluShot,
        allowBookForSpouse: config.allowBookForSpouse,
        spouseLabel: config.spouseLabel,
        landingTopText: config.landingTopText,
        landingBottomText: config.landingBottomText,
        landingThankYouText: config.landingThankYouText
      });
    },
    onSelectTemplate: function onSelectTemplate(item) {
      this.emailTemplate = item;
    },
    onChangeTemplate: function onChangeTemplate(e) {
      var _this7 = this;

      this.configurations.emailTemplateDtoList.forEach(function (element, index) {
        if (element.templateType === _this7.emailTemplate.templateType) {
          _this7.configurations.emailTemplateDtoList[index] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, element, {
            body: _this7.emailTemplate.body,
            emailSubject: _this7.emailTemplate.emailSubject
          });
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    actionGetClientSchedulerConfig: 'ACTION_GET_CLIENT_SCHEDULER_CONFIG',
    actionGetEmailTags: 'ACTION_GET_EMAIL_TAGS',
    actionSaveConfigurations: 'ACTION_SAVE_CONFIGURATIONS',
    actionUploadLogo: 'ACTION_UPLOAD_LOGO',
    getClientEventSchedulerStatus: 'ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS',
    actionUpdateClientEventSchedulerStatus: 'ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS',
    actionGetClient: 'ACTION_GET_CLIENT'
  })),
  created: function created() {
    var _this8 = this;

    this.actionGetEmailTags().then(function (response) {
      _this8.configEmail.emailTags = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;

          if (!tag.useResetPassTemplate) {
            _this8.configEmail.emailTags.push(tag);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    getIsLoading: 'GETTER_IS_LOADING_MODAL'
  }))
});

/***/ }),
/* 1611 */,
/* 1612 */,
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0b1f84e0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0687cf26\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PatientDetailModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0687cf26\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PatientDetailModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.custom-modal .modal-padding[data-v-0687cf26] {\n  padding: 26px 24px 30px 24px;\n}\n.custom-modal .modal-padding .modal-close-img[data-v-0687cf26] {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer;\n}\n.custom-modal .modal-padding .modal-close-img .icon-close[data-v-0687cf26] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  background: url(" + __webpack_require__(23) + ");\n}\n.custom-modal .modal-padding .title[data-v-0687cf26] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n.custom-modal .modal-padding .text[data-v-0687cf26] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  height: 45px;\n}\n", ""]);

// exports


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import constant from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'patientDetailModal',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      patientDetail: {
        type: Object,
        default: {}
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.$modal.hide('patientDetailModal');
    },
    beforeOpen: function beforeOpen(patientDetail) {
      this.patientDetail = patientDetail.params;
    },
    beforeClose: function beforeClose() {}
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    // getEventById: 'ACTION_GET_EVENT_BY_ID'
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])({
    //  setIsLoading: 'MUTATION_SET_IS_LOADING'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    getIsLoadingModal: 'GETTER_IS_LOADING_MODAL'
  }))
});

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "patientDetailModal",
        width: "605px",
        height: "auto",
        scrollable: true,
        clickToClose: false
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-padding" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              }
            }
          },
          [_c("div", { staticClass: "icon-close" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "title" }, [_vm._v("details")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "text" }, [
              _vm._v(
                "Name: " +
                  _vm._s(_vm.patientDetail.firstName) +
                  " " +
                  _vm._s(_vm.patientDetail.lastName)
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Email address: " + _vm._s(_vm.patientDetail.email))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Employer ID: " + _vm._s(_vm.patientDetail.employerId))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Signed up: " + _vm._s(_vm.patientDetail.signedUpAt))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Email reminders sent:")
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0687cf26", esExports)
  }
}

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("e19398a6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cc39b020\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScrollTop.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cc39b020\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScrollTop.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n#scrollTopBtn[data-v-cc39b020] {\n  position: relative;\n  bottom: 0;\n  /* left: 0px; */\n  top: 9px;\n  right: 27px;\n  z-index: 99;\n  border: none;\n  cursor: pointer;\n  width: 27px;\n  height: 27px;\n}\n#scrollTopBtn .icon-up[data-v-cc39b020] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(818) + ") no-repeat center;\n  mask: url(" + __webpack_require__(818) + ") no-repeat center;\n  background: url(" + __webpack_require__(1619) + ");\n}\n/*#scrollTopBtn:hover {\n  background-color: #555; !* Add a dark-grey background on hover *!\n}*/\n", ""]);

// exports


/***/ }),
/* 1619 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4wNCAyNCI+PHRpdGxlPnVwLW88L3RpdGxlPjxwYXRoIGQ9Ik0xMiwzYTksOSwwLDEsMS05LDksOSw5LDAsMCwxLDktOW0wLTFBMTAsMTAsMCwxLDAsMjIsMTIsMTAsMTAsMCwwLDAsMTIsMloiLz48cGF0aCBkPSJNMTYsMTMuNWEuNTEuNTEsMCwwLDEtLjM2LS4xNUwxMiw5LjcxLDguMzcsMTMuMzVhLjUuNSwwLDAsMS0uNzEsMCwuNS41LDAsMCwxLDAtLjdsNC00YS41LjUsMCwwLDEsLjcxLDBsNCw0YS41LjUsMCwwLDEtLjM1Ljg1WiIvPjwvc3ZnPg=="

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  var ele = document.getElementById('scrollTopBtn');
  if (!ele) {
    return;
  }
  if (document.body.scrollTop > 180 || document.documentElement.scrollTop > 180) {
    document.getElementById('scrollTopBtn').style.display = 'block';
  } else {
    document.getElementById('scrollTopBtn').style.display = 'none';
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scrollTop',
  methods: {
    // When the user clicks on the button, scroll to the top of the document
    topFunction: function topFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }
});

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "scrollTopBtn" },
      on: {
        click: function($event) {
          _vm.topFunction()
        }
      }
    },
    [_c("div", { staticClass: "icon-up" })]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cc39b020", esExports)
  }
}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6fb84be1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-55e80233\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffManagement.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-55e80233\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.staff-management-item[data-v-55e80233] {\n  font-family: 'Open Sans', sans-serif;\n}\n.staff-management-item .staff-function[data-v-55e80233] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media only screen and (max-width: 992px) {\n.staff-management-item .staff-function[data-v-55e80233] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n.staff-management-item .staff-function .staff-title[data-v-55e80233] {\n  margin-right: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.staff-management-item .staff-function .staff-title .lead[data-v-55e80233] {\n  color: #444444;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 32px;\n  text-transform: capitalize;\n}\n.staff-management-item .staff-function .staff-title .staff-filled[data-v-55e80233] {\n  color: #424242;\n  font-size: 16px;\n  line-height: 32px;\n  margin-left: 16px;\n}\n.staff-management-item .staff-function .group-btn .ap-btn[data-v-55e80233] {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.staff-management-item .staff-function .group-btn .ap-btn + .ap-btn[data-v-55e80233] {\n  margin-left: 8px;\n}\n.staff-management-item .staff-assign-slot[data-v-55e80233] {\n  margin-top: 14px;\n}\n.staff-management-item .staff-assign-slot .assign-slots[data-v-55e80233] {\n  float: left;\n  margin-bottom: 8px;\n  margin-right: 8px;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container[data-v-55e80233] {\n  position: relative;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-overlay[data-v-55e80233] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: black;\n  opacity: 0.3;\n  z-index: 5;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content[data-v-55e80233] {\n  height: 204px;\n  width: 396px;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);\n  position: absolute;\n  z-index: 6;\n  padding: 24px;\n  top: 38px;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content.rightModal[data-v-55e80233] {\n  right: 0;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content .modal-staff-title[data-v-55e80233] {\n  height: 40px;\n  width: 250px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content .modal-staff-search-box[data-v-55e80233] {\n  /*height: 42px;*/\n  /*border-radius: 3px;*/\n  /*background-color: #882121;*/\n  margin-top: 24px;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content .modal-staff-btn-fnc[data-v-55e80233] {\n  height: 32px;\n  margin-top: 17px;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content .modal-staff-btn-fnc .unassign[data-v-55e80233] {\n  background-color: #FF3400;\n  height: 100%;\n  float: right;\n  cursor: pointer;\n}\n.staff-management-item .staff-assign-slot .assign-slots .modal-staff-container .modal-staff-content .modal-staff-btn-fnc .assign[data-v-55e80233] {\n  background-color: #00A4D6;\n  height: 100%;\n  float: right;\n  margin-left: 8px;\n  cursor: pointer;\n}\n.staff-management-item .label[data-v-55e80233] {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.staff-management-item .icon-close[data-v-55e80233] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  background: url(" + __webpack_require__(23) + ");\n  position: absolute;\n  right: 16px;\n  top: 16px;\n}\n.staff-management-item .icon-close[data-v-55e80233]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-detail-staff-management',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  props: {
    staffRole: {
      type: String,
      default: ''
    },
    eventId: {
      type: String,
      default: ''
    },
    maxValueStaff: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      selectedStaff: null,
      availableStaffList: [],
      isDisable: false
    };
  },
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addOrRemoveStaff: function addOrRemoveStaff(role, isAdd) {
      this.$emit('add-remove-staff', {
        eventStaffRole: role,
        addStaff: isAdd,
        addStaffScreener: true
      });
    },
    assignStaff: function assignStaff(isAssign) {
      var _this = this;

      if (!this.selectedStaff) {
        this.$toastr('error', 'Please choose one staff to assign!', '');
        return;
      }
      var data = {
        eventId: this.eventId,
        staffId: this.selectedStaff.id,
        assigned: isAssign,
        role: this.staffRole
      };
      this.actionAssignStaff(data).then(function (response) {
        if (!response.message) {
          _this.$toastr('success', 'Successful!', '');
          _this.setOpenAssignModal('');
          _this.$emit('assign-successful');
          _this.actionGetAllAvailableStaffs({
            eventId: _this.eventId,
            role: _this.staffRole,
            searchString: ''
          }).then(function (response) {
            _this.availableStaffList = response.listStaff || [];
          });
        } else {
          _this.$toastr('error', response.message, '');
        }
      });
    },
    setOpenAssignModal: function setOpenAssignModal(key) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (index > this.getterGetStaffAssignList(this.staffRole).length) {
        return;
      }
      this.selectedStaff = this.getterGetStaffAssignList(this.staffRole)[index] || {};
      this.saveAssignStaffModalKey(key);
    },
    getOffset: function getOffset(el) {
      var rect = el.getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      };
    },
    isRightModal: function isRightModal(key) {
      if (key) {
        var dtHeaderEl = document.getElementById('staffing-section');
        var headerWidth = dtHeaderEl.getBoundingClientRect().width;
        var buttonEl = document.getElementById(key);
        var offsetX = this.getOffset(buttonEl).left;
        return headerWidth - offsetX < 400;
      }
    },
    getStaffAssignName: function getStaffAssignName(index) {
      var assignedStaffList = this.getterGetStaffAssignList(this.staffRole);
      return assignedStaffList && assignedStaffList[index] && assignedStaffList[index].fullName || 'assign';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    actionGetAllAvailableStaffs: 'ACTION_GET_ALL_AVAILABLE_STAFFS',
    actionAssignStaff: 'ACTION_ASSIGN_STAFF'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    saveAssignStaffModalKey: 'MUTATION_SAVE_ASSIGN_STAFF_MODAL_KEY'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getterOpenEventStaffModal: 'GETTER_GET_OPEN_ASSIGN_STAFF_MODAL',
    getterGetStaffAssignList: 'GETTER_GET_STAFF_ASSIGN_LIST'
  })),
  mounted: function mounted() {
    var _this2 = this;

    this.eventId = this.$route.params.eventId;
    if (this.eventId) {
      this.actionGetAllAvailableStaffs({
        eventId: this.eventId,
        role: this.staffRole,
        searchString: ''
      }).then(function (response) {
        _this2.availableStaffList = response.listStaff || [];
      });
    }
    this.isDisable = true; // process.env.IS_BING_MAP;
  }
});

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "staff-management-item" }, [
    _c("div", { staticClass: "staff-function" }, [
      _c("div", {}, [
        _c("div", { staticClass: "staff-title" }, [
          _c("div", { staticClass: "lead" }, [_vm._v(_vm._s(_vm.staffRole))]),
          _vm._v(" "),
          _c("div", { staticClass: "staff-filled" }, [
            _vm._v(
              _vm._s(_vm.getterGetStaffAssignList(_vm.staffRole).length) +
                "/" +
                _vm._s(_vm.maxValueStaff) +
                " staff filled"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-btn" }, [
        _c(
          "button",
          {
            staticClass: "ap-btn primary",
            on: {
              click: function($event) {
                _vm.addOrRemoveStaff(_vm.staffRole, true)
              }
            }
          },
          [_vm._v("Add")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "ap-btn destructive",
            attrs: {
              disabled:
                _vm.getterGetStaffAssignList(_vm.staffRole).length >=
                _vm.maxValueStaff
            },
            on: {
              click: function($event) {
                _vm.addOrRemoveStaff(_vm.staffRole, false)
              }
            }
          },
          [_vm._v("Remove")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "staff-assign-slot" },
      _vm._l(_vm.maxValueStaff, function(slot, index) {
        return _c("div", { key: index, staticClass: "assign-slots" }, [
          _c(
            "button",
            {
              staticClass: "ap-btn compact",
              class: {
                secondary: _vm.getStaffAssignName(index) != "assign",
                tertiary: _vm.getStaffAssignName(index) == "assign",
                disabled:
                  index > _vm.getterGetStaffAssignList(_vm.staffRole).length
              },
              attrs: {
                disabled:
                  index > _vm.getterGetStaffAssignList(_vm.staffRole).length ||
                  _vm.isDisable,
                id: _vm.staffRole + "_" + index
              },
              on: {
                click: function($event) {
                  _vm.setOpenAssignModal(_vm.staffRole + "_" + index, index)
                }
              }
            },
            [_vm._v(_vm._s(_vm.getStaffAssignName(index)))]
          ),
          _vm._v(" "),
          _vm.getterOpenEventStaffModal == _vm.staffRole + "_" + index
            ? _c("div", { staticClass: "modal-staff-container" }, [
                _c("div", {
                  staticClass: "modal-staff-overlay",
                  on: {
                    click: function($event) {
                      _vm.setOpenAssignModal("")
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-staff-content",
                    class: {
                      rightModal: _vm.isRightModal(_vm.staffRole + "_" + index)
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-close",
                      on: {
                        click: function($event) {
                          _vm.setOpenAssignModal("")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-staff-title" }, [
                      _vm._v("assign staff")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-staff-search-box" },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.availableStaffList,
                            placeholder: "Find staff member",
                            label: "fullName",
                            openDirection: "below",
                            multiple: false,
                            "close-on-select": true,
                            "hide-selected": true,
                            "track-by": "id",
                            "allow-empty": true,
                            "show-labels": false
                          },
                          model: {
                            value: _vm.selectedStaff,
                            callback: function($$v) {
                              _vm.selectedStaff = $$v
                            },
                            expression: "selectedStaff"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-staff-btn-fnc" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn assign",
                          on: {
                            click: function($event) {
                              _vm.assignStaff(true)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("assign")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn unassign",
                          on: {
                            click: function($event) {
                              _vm.assignStaff(false)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("unassign")
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55e80233", esExports)
  }
}

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toggle_vue__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0f45076_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__ = __webpack_require__(1630);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1627)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0f45076"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0f45076_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/Toggle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Toggle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e0f45076", Component.options)
  } else {
    hotAPI.reload("data-v-e0f45076", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1628);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4c5bece8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e0f45076\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Toggle.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e0f45076\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Toggle.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.toggle-wrapper[data-v-e0f45076] {\n  float: left;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 4px;\n}\n.toggle-wrapper .text[data-v-e0f45076] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n}\n.toggle-wrapper .text.online-text[data-v-e0f45076] {\n  color: #1674cd;\n}\n.toggle-wrapper .toggle[data-v-e0f45076] {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.toggle-wrapper .toggle input[type=checkbox][data-v-e0f45076] {\n  width: 0;\n  visibility: hidden;\n}\n.toggle-wrapper .toggle label[data-v-e0f45076] {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 3px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1) !important;\n  margin-bottom: 0;\n}\n.toggle-wrapper .toggle label[data-v-e0f45076]:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.toggle-wrapper .toggle input:checked + label[data-v-e0f45076] {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.toggle-wrapper .toggle input:checked + label[data-v-e0f45076]:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.toggle-wrapper .toggle label[data-v-e0f45076]:active:after {\n  width: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//


var id = 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toggle',
  components: {},
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    text: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  beforeCreate: function beforeCreate() {
    this.id = (id++).toString();
  },
  data: function data() {
    return {};
  },

  getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({})),
  computed: {}
});

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toggle-wrapper" }, [
    _c("div", { staticClass: "toggle" }, [
      _c("input", {
        attrs: {
          type: "checkbox",
          id: "is-live-" + _vm.id,
          disabled: _vm.disabled
        },
        domProps: { checked: _vm.checked },
        on: {
          change: function($event) {
            _vm.$emit("change", $event.target.checked)
          }
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "is-live-" + _vm.id } }, [_vm._v("Toggle")])
    ]),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "text",
        class: { "online-text": _vm.checked, "opacity-06": _vm.disabled }
      },
      [_vm._v(_vm._s(_vm.text))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e0f45076", esExports)
  }
}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("17105fc2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5cc93c00\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreview.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5cc93c00\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreview.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.overlay[data-v-5cc93c00] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0);\n  z-index: 999;\n  cursor: pointer;\n  overflow: scroll;\n  padding: 0 25px;\n}\n.overlay .title[data-v-5cc93c00] {\n  padding: 10px 5px;\n}\n.icon-back-wrapper[data-v-5cc93c00] {\n  padding-top: 24px;\n}\n.icon-back-wrapper .icon-back[data-v-5cc93c00] {\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(92) + ");\n}\n.icon-back-wrapper .icon-back[data-v-5cc93c00]:hover {\n  cursor: pointer;\n}\n.carousel-preview-scheduler[data-v-5cc93c00] {\n  padding: 0 40px;\n}\n.carousel-preview-scheduler .carousel-preview-item[data-v-5cc93c00] {\n  padding-top: 10px;\n}\n.carousel-preview-scheduler .carousel-nav-prev[data-v-5cc93c00],\n.carousel-preview-scheduler .carousel-nav-next[data-v-5cc93c00] {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n  display: block;\n  border: 0;\n  cursor: pointer;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n}\n.carousel-preview-scheduler .carousel-nav-prev[data-v-5cc93c00]:hover,\n.carousel-preview-scheduler .carousel-nav-next[data-v-5cc93c00]:hover {\n  cursor: pointer;\n}\n.carousel-preview-scheduler .carousel-nav-prev[data-v-5cc93c00] {\n  left: 5px;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(29) + ");\n}\n.carousel-preview-scheduler .carousel-nav-next[data-v-5cc93c00] {\n  right: 5px;\n  -webkit-mask: url(" + __webpack_require__(95) + ") no-repeat center;\n  mask: url(" + __webpack_require__(95) + ") no-repeat center;\n  background: url(" + __webpack_require__(95) + ");\n}\n", ""]);

// exports


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SchedulerPreviewMyInfoPage__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchedulerPreviewMyAppointmentPage__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchedulerPreviewSelectLocationPage__ = __webpack_require__(1646);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'schedulerPreviewModal',
  components: {
    SchedulerPreviewMyInfoPage: __WEBPACK_IMPORTED_MODULE_0__SchedulerPreviewMyInfoPage__["a" /* default */],
    SchedulerPreviewMyAppointmentPage: __WEBPACK_IMPORTED_MODULE_1__SchedulerPreviewMyAppointmentPage__["a" /* default */],
    SchedulerPreviewSelectLocationPage: __WEBPACK_IMPORTED_MODULE_2__SchedulerPreviewSelectLocationPage__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      allowBookFluShot: false,
      allowBookForSpouse: false,
      spouseLabel: '',
      landingTopText: '',
      landingBottomText: '',
      landingThankYouText: '',
      currentIndex: 1,
      carouselLength: 3
    };
  },

  methods: {
    beforeOpen: function beforeOpen(params) {
      this.allowBookFluShot = params.params.allowBookFluShot;
      this.allowBookForSpouse = params.params.allowBookForSpouse;
      this.spouseLabel = params.params.spouseLabel;
      this.landingTopText = params.params.landingTopText;
      this.landingBottomText = params.params.landingBottomText;
      this.landingThankYouText = params.params.landingThankYouText;
    },
    beforeClose: function beforeClose() {},
    hideModal: function hideModal() {
      this.$modal.hide('schedulerPreviewModal');
    },
    carouselPrevClick: function carouselPrevClick() {
      this.currentIndex -= 1;
      if (this.currentIndex < 1) {
        this.currentIndex = this.carouselLength;
      }
    },
    carouselNextClick: function carouselNextClick() {
      this.currentIndex += 1;
      if (this.currentIndex > this.carouselLength) {
        this.currentIndex = 1;
      }
    }
  }
});

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreviewMyInfoPage_vue__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2209c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreviewMyInfoPage_vue__ = __webpack_require__(1638);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1635)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d2209c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreviewMyInfoPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2209c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreviewMyInfoPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/preview/SchedulerPreviewMyInfoPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SchedulerPreviewMyInfoPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d2209c9", Component.options)
  } else {
    hotAPI.reload("data-v-3d2209c9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6ada8bd6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d2209c9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreviewMyInfoPage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d2209c9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreviewMyInfoPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.app-header[data-v-3d2209c9] {\n  background-color: white;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  margin-top: 24px;\n  height: auto;\n  padding: 24px 48px;\n  width: 100%;\n  overflow: auto;\n}\n.bread-crumb[data-v-3d2209c9] {\n  padding: 8px 0 8px 48px;\n  width: 810px;\n  margin: auto;\n}\n.bread-crumb .list-item-container[data-v-3d2209c9] {\n  padding: 0;\n  margin: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.bread-crumb .list-item-container .list-item[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 16px;\n  opacity: 1;\n  white-space: nowrap;\n}\n.bread-crumb .list-item-container .list-item .step-name-breadcrumb[data-v-3d2209c9]:hover {\n  cursor: pointer;\n}\n.bread-crumb .list-item-container .list-item .arrow-icon[data-v-3d2209c9] {\n  margin-left: 8px;\n  -ms-flex-item-align: center;\n      align-self: center;\n  width: 16px;\n  height: 16px;\n  background: url(" + __webpack_require__(95) + ") no-repeat center;\n}\n.bread-crumb .list-item-container .list-item.pass[data-v-3d2209c9] {\n  opacity: 1;\n  font-weight: bold;\n}\n.bread-crumb .list-item-container .list-item.pass .step-name-breadcrumb[data-v-3d2209c9] {\n  color: red;\n}\n.bread-crumb .list-item-container .list-item.current[data-v-3d2209c9] {\n  opacity: 1;\n  font-weight: bold;\n}\n.my-information-container[data-v-3d2209c9] {\n  padding: 24px 40px 48px 40px;\n  width: 810px;\n  margin: auto;\n}\n.my-information-container .my-info-card[data-v-3d2209c9] {\n  margin-top: 24px;\n  padding: 24px;\n}\n.my-information-container .my-info-card .field-wrapper[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.my-information-container .my-info-card .field-wrapper .require-field-icon[data-v-3d2209c9] {\n  color: red;\n  padding-left: 5px;\n}\n.my-information-container .my-info-card .card-header-container[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.my-information-container .my-info-card .card-header-container .body-text[data-v-3d2209c9] {\n  line-height: 28px;\n}\n.my-information-container .my-info-card .card-header-container .card-sub-title[data-v-3d2209c9] {\n  margin-left: 16px;\n}\n@include media-breakpoint-down(sm) {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n.card-sub-title {\n    margin-left: 0;\n}\n}\n.my-information-container .check-box-responsive[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.my-information-container .check-box-responsive .body-text[data-v-3d2209c9] {\n  line-height: 24px;\n}\n.my-information-container .text-box-responsive .name-input-wrapper[data-v-3d2209c9] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.my-information-container .text-box-responsive .name-input-wrapper input[data-v-3d2209c9] {\n  min-height: 48px;\n  border-radius: 4px;\n  border: 1px solid #B9B9B9;\n  padding: 12px 16px;\n}\n@include media-breakpoint-down(xs) {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.my-information-container .text-box-responsive .email-input-wrapper[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.my-information-container .text-box-responsive .email-input-wrapper input[data-v-3d2209c9] {\n  height: 48px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  padding: 12px 16px;\n}\n.my-information-container .text-box-responsive .birthday-input-wrapper[data-v-3d2209c9] {\n  position: relative;\n}\n.my-information-container .text-box-responsive .birthday-input-wrapper input[data-v-3d2209c9] {\n  height: 48px;\n  width: 100%;\n  padding: 8px;\n  color: black;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n}\n.my-information-container .text-box-responsive .employee-input-wrapper .employee-id-input[data-v-3d2209c9] {\n  position: relative;\n}\n.my-information-container .text-box-responsive .employee-input-wrapper .employee-id-input .character-s[data-v-3d2209c9] {\n  top: 30px;\n  right: 16px;\n  position: absolute;\n}\n.my-information-container .select-button-container[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-right: -24px;\n}\n.my-information-container .select-button-container .select-button[data-v-3d2209c9] {\n  padding: 12px 32px;\n  border-radius: 4px;\n  background-color: #9D001D;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.my-information-container .select-button-container .accessibility-container[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  float: right;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.my-information-container .select-button-container .select-button-detail[data-v-3d2209c9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 24px;\n}\n@include media-breakpoint-down(xs) {\n  margin-right: 0;\n}\n.my-information-container .field-display-wrapper .ap-checkbox-group[data-v-3d2209c9] {\n  line-height: 8px !important;\n}\n.my-information-container .field-display-wrapper .input[data-v-3d2209c9] {\n  width: 100%;\n  height: 48px;\n  border: 1px solid black;\n  border-radius: 4px;\n  padding: 12px 16px;\n}\n.my-information-container .checkbox-container .custom-checkbox[data-v-3d2209c9] :nth-child(2) {\n  padding-top: 3px;\n  padding-left: 10px;\n}\n.my-information-container .checkbox-container .custom-checkbox[data-v-3d2209c9] :nth-child(2)::before,\n.my-information-container .checkbox-container .custom-checkbox[data-v-3d2209c9] :nth-child(2)::after {\n  height: 24px;\n  width: 24px;\n  border-radius: unset;\n}\n.h5-text[data-v-3d2209c9] {\n  color: #424242;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: .17px;\n  line-height: 28px;\n  text-transform: capitalize;\n}\n", ""]);

// exports


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'schedulerPreviewMyInfoPage',
  components: {},
  props: {
    hasFluShot: {
      type: Number,
      default: 0
    },
    hasSpousal: {
      type: Boolean,
      default: false
    },
    spouseLabel: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      screenBoxStatus: false,
      fluBoxStatus: false,
      spousalBoxStatus: false,
      arrayStep: ['Select services', 'Select location', 'Select event', 'Select time', 'Review and Confirm']
    };
  },

  methods: {}
});

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-header" }, [
      _c("div", { staticClass: "bread-crumb" }, [
        _c(
          "ul",
          { staticClass: "list-item-container" },
          _vm._l(_vm.arrayStep, function(item, index) {
            return _c("li", { key: item, staticClass: "list-item" }, [
              _c(
                "a",
                {
                  staticClass:
                    "step-name-breadcrumb body-text scheduler-text-custom-color",
                  style: {
                    "font-weight":
                      item === "Select services" ? "bold" : "normal"
                  },
                  attrs: { href: "javascript:void(0)" }
                },
                [_vm._v("\n            " + _vm._s(item) + "\n          ")]
              ),
              _vm._v(" "),
              index != _vm.arrayStep.length - 1
                ? _c("div", {
                    staticClass: "arrow-icon",
                    attrs: { role: "navigation" }
                  })
                : _vm._e()
            ])
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "my-information-container" }, [
      _c(
        "h1",
        {
          ref: "focusTab",
          staticClass: "h1-text step-name",
          attrs: { tabindex: "0" }
        },
        [_vm._v("Select Services")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "body-text margin-top-10px" }, [
        _vm._v(
          "Welcome to the ADURO WellMetrics scheduling tool. Before you begin to schedule, we need to know some information about you. Your selections will determine which events are available for you. You can edit this information later."
        )
      ]),
      _vm._v(" "),
      _vm.hasFluShot
        ? _c(
            "div",
            {
              staticClass:
                "my-info-card common-card margin-top-24px scheduler-card-responsive"
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-box-responsive margin-top-24px" },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-container" },
                    [
                      _c(
                        "b-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group body-text scheduler-checkbox-group-custom",
                          style: {
                            "font-weight": _vm.screenBoxStatus
                              ? "bold"
                              : "normal"
                          },
                          attrs: { id: "checkbox-1" },
                          model: {
                            value: _vm.screenBoxStatus,
                            callback: function($$v) {
                              _vm.screenBoxStatus = $$v
                            },
                            expression: "screenBoxStatus"
                          }
                        },
                        [
                          _vm._v(
                            "\n            I want to get a biometric screening\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-box-responsive margin-top-16px" },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group body-text scheduler-checkbox-group-custom",
                          style: {
                            "font-weight": _vm.fluBoxStatus ? "bold" : "normal"
                          },
                          attrs: { id: "checkbox-2" },
                          model: {
                            value: _vm.fluBoxStatus,
                            callback: function($$v) {
                              _vm.fluBoxStatus = $$v
                            },
                            expression: "fluBoxStatus"
                          }
                        },
                        [
                          _vm._v(
                            "\n            I want to get a flu shot\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasSpousal
        ? _c(
            "div",
            {
              staticClass:
                "my-info-card common-card margin-top-24px scheduler-card-responsive"
            },
            [
              _c("div", { staticClass: "card-header-container" }, [
                _c("h2", { staticClass: "h5-text", attrs: { tabindex: "0" } }, [
                  _vm._v(_vm._s(_vm.spouseLabel) + " Information")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "body-text margin-top-10px" }, [
                _vm._v(
                  "\n        If you have a " +
                    _vm._s(_vm.spouseLabel) +
                    ", you can also schedule appointments for them. If your " +
                    _vm._s(_vm.spouseLabel) +
                    " is also an employee at your company, please have them schedule their own appointment or come with you as a walk-in appointment (additional wait time may apply).\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-box-responsive margin-top-24px" },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group body-text scheduler-checkbox-group-custom",
                          style: {
                            "font-weight":
                              _vm.spousalBoxStatus === "accepted"
                                ? "bold"
                                : "normal"
                          },
                          attrs: { id: "checkbox-3" },
                          model: {
                            value: _vm.spousalBoxStatus,
                            callback: function($$v) {
                              _vm.spousalBoxStatus = $$v
                            },
                            expression: "spousalBoxStatus"
                          }
                        },
                        [
                          _vm._v(
                            "\n            I will be bringing my " +
                              _vm._s(_vm.spouseLabel) +
                              " to this event\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.spousalBoxStatus
                ? _c("div", { staticClass: "set-height-including-calendar" }, [
                    _c("div", { staticClass: "text-box-responsive" }, [
                      _c("div", { staticClass: "row name-input-wrapper" }, [
                        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "field-display-wrapper margin-top-16px"
                            },
                            [
                              _c("div", { staticClass: "field-wrapper" }, [
                                _c(
                                  "div",
                                  { attrs: { id: "firstNameElement" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                        attrs: { for: "inputFirstName" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      First Name\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "firstName",
                                      staticClass: "input",
                                      attrs: {
                                        id: "inputFirstName",
                                        role: "textbox",
                                        type: "text",
                                        name: "firstName",
                                        placeholder: "First name",
                                        disabled: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "require-field-icon",
                                    attrs: {
                                      "aria-label":
                                        "* field denotes as Mandatory fields."
                                    }
                                  },
                                  [_vm._v("*")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "error-display",
                                  class: {
                                    noDisplay:
                                      _vm.spousalBoxStatus === "not_accepted"
                                  },
                                  attrs: { id: "firstNameError" }
                                },
                                [
                                  _vm.errors.has("firstName")
                                    ? _c("div", {
                                        staticClass: "alert-icon-red-error",
                                        attrs: { "aria-label": "Error icon" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "error-text-color" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("firstName"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "field-display-wrapper margin-top-16px"
                            },
                            [
                              _c("div", { staticClass: "field-wrapper" }, [
                                _c(
                                  "div",
                                  { attrs: { id: "lastNameElement" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                        attrs: { for: "inputLastName" }
                                      },
                                      [_vm._v("Last Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "lastName",
                                      staticClass: "input",
                                      attrs: {
                                        id: "inputLastName",
                                        role: "textbox",
                                        type: "text",
                                        name: "lastName",
                                        placeholder: "Last name",
                                        disabled: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "require-field-icon",
                                    attrs: {
                                      "aria-label":
                                        "* field denotes as Mandatory fields."
                                    }
                                  },
                                  [_vm._v("*")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "error-display",
                                  class: {
                                    noDisplay:
                                      _vm.spousalBoxStatus === "not_accepted"
                                  },
                                  attrs: { id: "lastNameError" }
                                },
                                [
                                  _vm.errors.has("lastName")
                                    ? _c("div", {
                                        staticClass: "alert-icon-red-error",
                                        attrs: { "aria-label": "Error icon" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "error-text-color" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("lastName"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6 col-xs-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "email-input-wrapper field-display-wrapper"
                            },
                            [
                              _c("div", { staticClass: "field-wrapper" }, [
                                _c("div", { attrs: { id: "emailElement" } }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                      attrs: { for: "inputSpouseEmail" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Email\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "email",
                                    staticClass: "input",
                                    attrs: {
                                      id: "inputSpouseEmail",
                                      role: "textbox",
                                      type: "email",
                                      name: "email",
                                      placeholder: "Email",
                                      disabled: ""
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "require-field-icon",
                                    attrs: {
                                      "aria-label":
                                        "* field denotes as Mandatory fields."
                                    }
                                  },
                                  [_vm._v("*")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 col-xs-12" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6 col-xs-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "birthday-input-wrapper field-display-wrapper"
                                },
                                [
                                  _c("div", { staticClass: "field-wrapper" }, [
                                    _c(
                                      "div",
                                      {
                                        ref: "dob1",
                                        attrs: { id: "dobElement" }
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "ap-checkbox-group scheduler-checkbox-group-custom margin-top-16px",
                                            staticStyle: {
                                              "min-width": "228px"
                                            },
                                            attrs: {
                                              "aria-label":
                                                "Enter Spouce Birth Date using format MM/DD/YYYY"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          Spouse Birth Date\n                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          ref: "dob",
                                          staticClass: "input",
                                          attrs: {
                                            id: "picker-component-container",
                                            role: "textbox",
                                            name: "dob",
                                            placeholder: "Birth date",
                                            disabled: ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "require-field-icon",
                                        attrs: {
                                          "aria-label":
                                            "* field denotes as Mandatory fields."
                                        }
                                      },
                                      [_vm._v("*")]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header-container" }, [
      _c(
        "h2",
        {
          staticClass: "h5-text",
          attrs: {
            "aria-label":
              "Event Information please select at least one of the follwoing options to continue",
            role: "Heading",
            tabindex: "0"
          }
        },
        [_vm._v("Event Information")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "body-text card-sub-title" }, [
        _vm._v("Select all that apply, please select at least one option."),
        _c(
          "span",
          {
            staticClass: "require-field-icon",
            staticStyle: { color: "red", "padding-left": "5px" }
          },
          [_vm._v("*")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "select-button-container margin-top-24px" },
      [
        _c(
          "button",
          {
            staticClass:
              "select-button ap-btn scheduler-button-custom-color button-text-white",
            attrs: { "aria-label": "Select location", role: "button" }
          },
          [_vm._v("\n        SELECT LOCATION\n      ")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d2209c9", esExports)
  }
}

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreviewMyAppointmentPage_vue__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7015e692_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreviewMyAppointmentPage_vue__ = __webpack_require__(1645);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1640)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7015e692"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreviewMyAppointmentPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7015e692_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreviewMyAppointmentPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/preview/SchedulerPreviewMyAppointmentPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SchedulerPreviewMyAppointmentPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7015e692", Component.options)
  } else {
    hotAPI.reload("data-v-7015e692", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1948309d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7015e692\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreviewMyAppointmentPage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7015e692\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreviewMyAppointmentPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.app-header[data-v-7015e692] {\n  background-color: white;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  margin-top: 24px;\n  height: auto;\n  padding: 28px 48px;\n  width: 100%;\n  overflow: auto;\n}\n.bread-crumb[data-v-7015e692] {\n  padding: 8px 0 8px 48px;\n  width: 810px;\n  margin: auto;\n}\n.my-appointment-page[data-v-7015e692] {\n  padding: 24px 40px;\n  width: 810px;\n  margin: auto;\n}\n.my-appointment-page .my-appointment-info[data-v-7015e692] {\n  margin-top: 20px;\n}\n.my-appointment-page .my-appointment-info .map-wrapper[data-v-7015e692] {\n  min-height: 120px;\n  height: 300px;\n}\n.my-appointment-page .my-appointment-info .map-wrapper .map-auto-detection[data-v-7015e692] {\n  width: 100%;\n  height: 100%;\n}\n.my-appointment-page .my-appointment-info .map-wrapper .map-auto-detection img[data-v-7015e692] {\n  width: 100%;\n  height: 100%;\n}\n.my-appointment-page .my-appointment-info .map-wrapper .map-auto-detection #tileCanvasId[data-v-7015e692] {\n  border-radius: 4px 4px 0 0;\n}\n.my-appointment-page .my-appointment-info .appointment-info[data-v-7015e692] {\n  margin-top: 24px;\n  padding-left: 40px;\n  padding-bottom: 25px;\n}\n.my-appointment-page .my-appointment-info .appointment-info .client-info .calender-wrapper[data-v-7015e692] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.my-appointment-page .my-appointment-info .appointment-info .client-info .calender-wrapper .calendar-icon[data-v-7015e692] {\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(1642) + ") no-repeat center;\n  margin-right: 16px;\n}\n.my-appointment-page .my-appointment-info .appointment-info .client-info .type-flushot[data-v-7015e692] {\n  color: black;\n}\n.my-appointment-page .my-appointment-info .appointment-info .event-info[data-v-7015e692] {\n  margin-top: 24px;\n}\n.my-appointment-page .my-appointment-info .appointment-info .event-info .date-wrapper[data-v-7015e692] {\n  margin-left: 40px;\n}\n.my-appointment-page .my-appointment-info .appointment-info .event-info .time-wrapper .time-slots[data-v-7015e692] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  text-transform: capitalize;\n}\n.my-appointment-page .my-appointment-info .appointment-info .event-info .room-location-wrapper[data-v-7015e692] {\n  margin-top: 24px;\n}\n.my-appointment-page .my-appointment-info .appointment-info .event-info .room-location-wrapper .location-wrapper[data-v-7015e692] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.my-appointment-page .my-appointment-info .appointment-info .event-info .room-location-wrapper .location-wrapper .location-icon[data-v-7015e692] {\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n  background: url(" + __webpack_require__(1643) + ") no-repeat center;\n}\n.my-appointment-page .my-appointment-info .appointment-info .title-text[data-v-7015e692] {\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.my-appointment-page .my-appointment-info .appointment-info .field-value[data-v-7015e692] {\n  margin-top: 8px;\n  color: black;\n}\n.my-appointment-page .my-appointment-info .group-button[data-v-7015e692] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: -24px;\n  position: relative;\n}\n.my-appointment-page .my-appointment-info .group-button .reschedule-btn[data-v-7015e692] {\n  padding: 12px 32px;\n  margin-left: 24px;\n}\n.my-appointment-page .my-appointment-info .group-button .cancel-btn[data-v-7015e692] {\n  padding: 12px 32px;\n}\n.my-appointment-page .my-appointment-info .group-button-for-small[data-v-7015e692] {\n  display: none;\n}\n@include media-breakpoint-down(sm) {\n.time-wrapper .time-slots {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.time-wrapper .time-slots .space {\n    display: none;\n}\n}\n@include media-breakpoint-down(xs) {\n.map-wrapper {\n    margin: -16px -16px 0;\n}\n.appointment-info .time-wrapper,\n  .appointment-info .room-wrapper {\n    margin-left: 40px;\n    margin-top: 16px;\n}\n.appointment-info .time-wrapper .time-slots {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.appointment-info .time-wrapper .time-slots .space {\n    display: none;\n}\n.group-button {\n    display: none;\n}\n.group-button-for-small {\n    display: block;\n    margin-top: 24px;\n}\n.group-button-for-small .reschedule-btn {\n    width: 100%;\n}\n.group-button-for-small .cancel-btn {\n    width: 100%;\n    margin-top: 16px;\n}\n}\n.more-information[data-v-7015e692] {\n  padding: 20px;\n  width: 730px;\n  margin: auto;\n  margin-bottom: 55px;\n}\n", ""]);

// exports


/***/ }),
/* 1642 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmNhbGVuZGFyPC90aXRsZT48cGF0aCBkPSJNMjAuNSw1YS41LjUsMCwwLDEsLjUuNXYxNWEuNS41LDAsMCwxLS41LjVIMy41YS41LjUsMCwwLDEtLjUtLjVWNS41QS41LjUsMCwwLDEsMy41LDVoMTdtMC0xSDMuNUExLjUsMS41LDAsMCwwLDIsNS41djE1QTEuNSwxLjUsMCwwLDAsMy41LDIyaDE3QTEuNSwxLjUsMCwwLDAsMjIsMjAuNVY1LjVBMS41LDEuNSwwLDAsMCwyMC41LDRaIi8+PHBhdGggZD0iTTIwLjUsNWEuNS41LDAsMCwxLC41LjVWOUgzVjUuNUEuNS41LDAsMCwxLDMuNSw1aDE3bTAtMUgzLjVBMS41LDEuNSwwLDAsMCwyLDUuNVYxMEgyMlY1LjVBMS41LDEuNSwwLDAsMCwyMC41LDRaIi8+PHBhdGggZD0iTTE2LjUsN2EuNS41LDAsMCwxLS41LS41di00YS41LjUsMCwwLDEsMSwwdjRBLjUuNSwwLDAsMSwxNi41LDdaIi8+PHBhdGggZD0iTTcuNSw3QS41LjUsMCwwLDEsNyw2LjV2LTRhLjUuNSwwLDAsMSwxLDB2NEEuNS41LDAsMCwxLDcuNSw3WiIvPjwvc3ZnPg=="

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNC4wNCI+PHRpdGxlPmRpc3RhbmNlPC90aXRsZT48cGF0aCBkPSJNMTIsMTJhMywzLDAsMSwxLDMtM0EzLDMsMCwwLDEsMTIsMTJabTAtNWEyLDIsMCwxLDAsMiwyQTIsMiwwLDAsMCwxMiw3WiIvPjxwYXRoIGQ9Ik0xMiwyMmgtLjI0bC0uMTctLjJDMTAuOTIsMjEsNSwxMy40OCw1LDlBNyw3LDAsMCwxLDE5LDljMCw0LjQ2LTUuOTIsMTItNi42LDEyLjc5bC0uMTUuMTlaTTEyLDNBNiw2LDAsMCwwLDYsOWMwLDMuNjQsNC42Miw5LjksNiwxMS42OSwxLjM4LTEuNzksNi04LDYtMTEuNjlBNiw2LDAsMCwwLDEyLDNaIi8+PC9zdmc+"

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'schedulerPreviewMyAppointmentPage',
  components: {},
  props: {
    landingThankYouText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imgSrc: '../../../../static/img/googleMapPreview.png',
      arrayStep: [],
      event: {
        companyName: 'Company Name',
        prefDate: '01/01/2021',
        hasSpouse: false,
        timeSlot: '6:00AM',
        eventLocation: 'Event Location',
        building: 'Event Building',
        fullAddress: 'Event Full Address'
      }
    };
  },

  methods: {}
});

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-header" }, [
      _c("div", { staticClass: "bread-crumb" }, [
        _c(
          "ul",
          { staticClass: "list-item-container" },
          _vm._l(_vm.arrayStep, function(item, index) {
            return _c("li", { key: item, staticClass: "list-item" }, [
              _c(
                "a",
                {
                  staticClass:
                    "step-name-breadcrumb body-text scheduler-text-custom-color",
                  attrs: { href: "javascript:void(0)" }
                },
                [_vm._v(_vm._s(item))]
              ),
              _vm._v(" "),
              index != _vm.arrayStep.length - 1
                ? _c("div", {
                    staticClass: "arrow-icon",
                    attrs: { role: "navigation" }
                  })
                : _vm._e()
            ])
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "animated fadeIn my-appointment-page body-content" },
      [
        _c("div", [
          _c(
            "h1",
            {
              ref: "focusTab",
              staticClass: "step-name h1-text",
              attrs: { tabindex: "0" }
            },
            [_vm._v("My Appointments")]
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "my-appointment-info common-card scheduler-card-responsive"
                },
                [
                  _c("div", { staticClass: "map-wrapper" }, [
                    _c("div", { staticClass: "map-auto-detection" }, [
                      _c("img", { attrs: { src: _vm.imgSrc } })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("div", { staticClass: "appointment-info" }, [
                        _c("div", { staticClass: "client-info" }, [
                          _c("div", { staticClass: "calender-wrapper" }, [
                            _c("div", {
                              staticClass: "calendar-icon",
                              attrs: { "aria-label": "Event icon" }
                            }),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "title-text label-text scheduler-text-custom-color"
                                },
                                [_vm._v("Event")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "client-name field-value body-text"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.event.companyName) +
                                      " Event " +
                                      _vm._s(_vm.event.prefDate)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "body-text type-flushot"
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-info" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                              _c("div", { staticClass: "date-wrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "title-text label-text scheduler-text-custom-color"
                                  },
                                  [_vm._v("Date")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "field-value body-text" },
                                  [_vm._v(_vm._s(_vm.event.prefDate))]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                              _c("div", { staticClass: "time-wrapper" }, [
                                _vm.event.hasSpouse
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "title-text label-text scheduler-text-custom-color"
                                        },
                                        [_vm._v("Time")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value body-text time-slots"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                "Myself - " + _vm.event.timeSlot
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "space" }, [
                                            _vm._v(", ")
                                          ]),
                                          _vm._v(" "),
                                          _c("div")
                                        ]
                                      )
                                    ])
                                  : _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "title-text label-text scheduler-text-custom-color"
                                        },
                                        [_vm._v("Time")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "field-value body-text"
                                        },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(_vm.event.timeSlot) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "room-location-wrapper" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                                _c("div", { staticClass: "location-wrapper" }, [
                                  _c("div", {
                                    staticClass: "location-icon",
                                    attrs: { "aria-label": "Location icon" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "title-text label-text scheduler-text-custom-color"
                                      },
                                      [_vm._v("Location")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "field-value body-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.building
                                              ? _vm.event.building + ", "
                                              : ""
                                          ) + _vm._s(_vm.event.fullAddress)
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                                _c("div", { staticClass: "room-wrapper" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "title-text label-text scheduler-text-custom-color"
                                    },
                                    [_vm._v("Room")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "field-value body-text" },
                                    [
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(_vm.event.eventLocation) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.landingThankYouText !== ""
      ? _c(
          "div",
          {
            staticClass:
              "more-information common-card scheduler-card-responsive margin-top-24px"
          },
          [
            _c("div", {
              staticClass: "body-text",
              domProps: { innerHTML: _vm._s(_vm.landingThankYouText) }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-button" }, [
      _c(
        "button",
        {
          staticClass:
            "ap-btn scheduler-button-custom-color secondary-custom cancel-btn",
          attrs: { role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Cancel")])]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "ap-btn scheduler-button-custom-color reschedule-btn",
          attrs: { role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Reschedule")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-button-for-small" }, [
      _c(
        "button",
        {
          staticClass: "ap-btn scheduler-button-custom-color reschedule-btn",
          attrs: { id: "rescheduleApptBtn", role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Reschedule")])]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "ap-btn scheduler-button-custom-color secondary-custom cancel-btn",
          attrs: { id: "cancelApptBtn", role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Cancel")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7015e692", esExports)
  }
}

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreviewSelectLocationPage_vue__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e900720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreviewSelectLocationPage_vue__ = __webpack_require__(1650);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1647)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e900720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerPreviewSelectLocationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e900720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerPreviewSelectLocationPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/preview/SchedulerPreviewSelectLocationPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SchedulerPreviewSelectLocationPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e900720", Component.options)
  } else {
    hotAPI.reload("data-v-0e900720", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("89472142", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0e900720\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreviewSelectLocationPage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0e900720\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerPreviewSelectLocationPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.app-header[data-v-0e900720] {\n  background-color: white;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  margin-top: 24px;\n  height: auto;\n  padding: 24px 48px;\n  width: 100%;\n  overflow: auto;\n}\n.bread-crumb[data-v-0e900720] {\n  padding: 8px 0 8px 48px;\n  width: 810px;\n  margin: auto;\n}\n.bread-crumb .list-item-container[data-v-0e900720] {\n  padding: 0;\n  margin: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.bread-crumb .list-item-container .list-item[data-v-0e900720] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 16px;\n  opacity: 1;\n  white-space: nowrap;\n}\n.bread-crumb .list-item-container .list-item .step-name-breadcrumb[data-v-0e900720]:hover {\n  cursor: pointer;\n}\n.bread-crumb .list-item-container .list-item .arrow-icon[data-v-0e900720] {\n  margin-left: 8px;\n  -ms-flex-item-align: center;\n      align-self: center;\n  width: 16px;\n  height: 16px;\n  background: url(" + __webpack_require__(95) + ") no-repeat center;\n}\n.bread-crumb .list-item-container .list-item.pass[data-v-0e900720] {\n  opacity: 1;\n  font-weight: bold;\n}\n.bread-crumb .list-item-container .list-item.pass .step-name-breadcrumb[data-v-0e900720] {\n  color: red;\n}\n.bread-crumb .list-item-container .list-item.current[data-v-0e900720] {\n  opacity: 1;\n  font-weight: bold;\n}\n.h5-text[data-v-0e900720] {\n  color: #424242;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: .17px;\n  line-height: 28px;\n  text-transform: capitalize;\n}\n.select-location-container[data-v-0e900720] {\n  padding: 24px 40px 48px 40px;\n  width: 810px;\n  margin: auto;\n}\n.select-location-container .common-card[data-v-0e900720] {\n  padding: 24px;\n}\n.select-location-container .field-wrapper[data-v-0e900720] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.select-location-container .field-wrapper .require-field-icon[data-v-0e900720] {\n  padding-left: 5px;\n  color: red;\n}\n.select-location-container .find-nearest-event-card[data-v-0e900720] {\n  margin: 24px -24px 0;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event[data-v-0e900720] {\n  margin-top: 24px;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event .input-zip-code-container[data-v-0e900720],\n.select-location-container .find-nearest-event-card .find-nearest-event .btn-find-container-left[data-v-0e900720] {\n  margin-top: 16px;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event .btn-find-container-left .btn-find[data-v-0e900720] {\n  padding: 12px 32px;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event .input-zip-code-container[data-v-0e900720] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event .input-zip-code-container .ap-field-input-wrapper .ap-input-wrapper input[type=number][data-v-0e900720]::-webkit-inner-spin-button,\n.select-location-container .find-nearest-event-card .find-nearest-event .input-zip-code-container .ap-field-input-wrapper .ap-input-wrapper input[type=number][data-v-0e900720]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event .input-zip-code-container .ap-field-input-wrapper .ap-input-wrapper .input[data-v-0e900720] {\n  margin-top: 0;\n  padding: 12px 16px;\n  height: unset;\n  color: black;\n  font-size: 16px;\n  line-height: 24px;\n  width: 110px;\n}\n.select-location-container .find-nearest-event-card .find-nearest-event .input-zip-code-container .btn-find[data-v-0e900720] {\n  margin-left: 24px;\n  padding: 12px 32px;\n  line-height: 24px;\n}\n.select-location-container .full-list-of-locations-container[data-v-0e900720] {\n  margin: 24px -24px 0;\n}\n.select-location-container .full-list-of-locations-container .loading-container[data-v-0e900720] {\n  margin-top: 24px;\n}\n.select-location-container .full-list-of-locations-container .title-list-of-locations-wrapper[data-v-0e900720] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.select-location-container .full-list-of-locations-container .title-list-of-locations-wrapper .spouse-screening-flushot-container[data-v-0e900720] {\n  -ms-flex-item-align: center;\n      align-self: center;\n}\n.select-location-container .full-list-of-locations-container .text-availability-of-locations[data-v-0e900720] {\n  margin-top: 8px;\n  color: black;\n}\n@include media-breakpoint-down(xs) {\n  margin: 24px 0 0;\n}\n@include media-breakpoint-down(sm) {\n.title-list-of-locations-wrapper {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n}\n.title-list-of-locations-wrapper .spouse-screening-flushot-container {\n    margin-top: 24px;\n    -ms-flex-item-align: unset;\n        align-self: unset;\n}\n}\n.select-location-container .full-list-of-locations-container .list-of-locations[data-v-0e900720] {\n  margin-top: 24px;\n}\n.select-location-container .full-list-of-locations-container .list-of-locations .list-item a[data-v-0e900720] {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 16px;\n  word-wrap: break-word;\n}\n.select-location-container .full-list-of-locations-container .list-of-locations .list-item a[data-v-0e900720]:hover {\n  cursor: pointer;\n}\n.select-location-container .full-list-of-locations-container .list-of-locations .list-item a[data-v-0e900720]:focus {\n  text-decoration: underline;\n}\n.select-location-container .more-information-card-container[data-v-0e900720] {\n  margin: 24px -24px 0;\n}\n@include media-breakpoint-down(xs) {\n  margin: 24px 0 0;\n}\n.select-location-container .more-information-card-container .description[data-v-0e900720] {\n  margin-top: 16px;\n}\n.select-location-container .supports-section[data-v-0e900720] {\n  margin-top: 24px;\n  margin-bottom: 48px;\n}\n@include media-breakpoint-down(xs) {\n  padding-left: 16px;\n}\n.select-location-container .supports-section .forgot-appointment-time[data-v-0e900720] {\n  color: red;\n}\n.select-location-container .supports-section .forgot-appointment-time[data-v-0e900720]:hover {\n  cursor: pointer;\n}\n.select-location-container .supports-section .right-side[data-v-0e900720] {\n  text-align: right;\n}\n@include media-breakpoint-down(sm) {\n  text-align: left;\n  margin-top: 24px;\n}\n.select-location-container .supports-section .right-side .discover-alternative[data-v-0e900720] {\n  color: red;\n  margin-top: 8px;\n}\n.select-location-container .supports-section .right-side .discover-alternative[data-v-0e900720]:hover {\n  cursor: pointer;\n}\n.select-location-container .full-event-text[data-v-0e900720] {\n  color: #6E6E6E;\n  font-family: \"Open Sans\", serif;\n  font-size: 16px;\n  letter-spacing: 0.1px;\n  line-height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'schedulerPreviewSelectLocationPage',
  components: {},
  props: {
    landingTopText: {
      type: String,
      default: ''
    },
    landingBottomText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dataToDisplay: '',
      listOfLocations: [{ state: 'Ny', city: 'New  York', available: true }],
      arrayStep: ['Select services', 'Select location', 'Select event', 'Select time', 'Review and Confirm']
    };
  },

  methods: {}
});

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-header" }, [
      _c("div", { staticClass: "bread-crumb" }, [
        _c(
          "ul",
          { staticClass: "list-item-container" },
          _vm._l(_vm.arrayStep, function(item, index) {
            return _c("li", { key: item, staticClass: "list-item" }, [
              _c(
                "a",
                {
                  staticClass:
                    "step-name-breadcrumb body-text scheduler-text-custom-color",
                  style: {
                    "font-weight":
                      item === "Select location" ? "bold" : "normal"
                  },
                  attrs: { href: "javascript:void(0)" }
                },
                [_vm._v("\n            " + _vm._s(item) + "\n          ")]
              ),
              _vm._v(" "),
              index != _vm.arrayStep.length - 1
                ? _c("div", {
                    staticClass: "arrow-icon",
                    attrs: { role: "navigation" }
                  })
                : _vm._e()
            ])
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "select-location-container" }, [
      _c(
        "h1",
        {
          ref: "focusTab",
          staticClass: "h1-text step-name",
          attrs: { tabindex: "0" }
        },
        [_vm._v("Select Location")]
      ),
      _vm._v(" "),
      _vm.landingTopText !== ""
        ? _c(
            "div",
            {
              staticClass:
                "more-information common-card scheduler-card-responsive margin-top-24px"
            },
            [
              _c("div", {
                staticClass: "body-text",
                domProps: { innerHTML: _vm._s(_vm.landingTopText) }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "common-card find-nearest-event-card scheduler-card-responsive"
        },
        [
          _c("div", { staticClass: "title-box h5-text" }, [
            _vm._v("Find Nearest Event")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "find-nearest-event row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 col-xs-12 field-zipcode-container" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "input-zip-code-container" }, [
                  _c("div", { staticClass: "ap-field-input-wrapper" }, [
                    _c("div", { staticClass: "ap-input-wrapper" }, [
                      _c("input", {
                        ref: "inputZipCodeText",
                        staticClass: "input",
                        attrs: {
                          "aria-label":
                            "Enter your zip code using the keyboard",
                          id: "inputZipCode",
                          "aria-labelledby": "zipCodeError inputZipCode",
                          size: "5",
                          role: "textbox",
                          type: "number",
                          placeholder: "Ex: 98052",
                          disabled: ""
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "full-list-of-locations-container common-card scheduler-card-responsive"
        },
        [
          _c("div", { staticClass: "title-list-of-locations-wrapper" }, [
            _c("div", { staticClass: "title-box h5-text" }, [
              _vm._v("\n          Full list of Locations\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "spouse-screening-flushot-container" }, [
              _c("div", { staticClass: "spouse-screening-flushot-checkbox" }, [
                _c("div", { staticClass: "bringing-spouse-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "spouse-checkbox checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group scheduler-checkbox-group-custom"
                        },
                        [_vm._v("Bringing spouse")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "biometric-screening-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "screening-checkbox checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group scheduler-checkbox-group-custom"
                        },
                        [_vm._v("Biometric screening")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flu-shot-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "flu-shot-checkbox checkbox-container" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group scheduler-checkbox-group-custom"
                        },
                        [_vm._v("Flu shot")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-availability-of-locations label-text" },
            [
              _vm._v(
                "Availability of locations are dependent biometric screening, and flu shot selections"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-of-locations row" },
            [
              _vm._l(_vm.listOfLocations, function(l) {
                return [
                  _c("div", { staticClass: "col-md-3 list-item" }, [
                    _c(
                      "a",
                      {
                        key: l.id,
                        staticClass:
                          "display-inline scheduler-text-custom-color",
                        attrs: { href: "javascript:void(0)", tabindex: "0" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(l.state + " - " + l.city) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !l.available
                      ? _c(
                          "p",
                          { staticClass: "full-event-text display-inline" },
                          [_vm._v("- All events are full")]
                        )
                      : _vm._e()
                  ])
                ]
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.landingBottomText !== ""
        ? _c(
            "div",
            {
              staticClass:
                "more-information common-card scheduler-card-responsive margin-top-24px"
            },
            [
              _c("div", {
                staticClass: "body-text",
                domProps: { innerHTML: _vm._s(_vm.landingBottomText) }
              })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 col-xs-12" }, [
      _c("div", { staticClass: "body-text" }, [
        _vm._v("Automatically determine my location")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-find-container-left" }, [
        _c(
          "button",
          {
            staticClass: "ap-btn error btn-find scheduler-button-custom-color",
            attrs: {
              "aria-label": "Button find Automatically determine my location",
              role: "button"
            }
          },
          [_vm._v("Find")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-wrapper" }, [
      _c("div", { staticClass: "body-text" }, [_vm._v("Zip code")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "require-field-icon",
          attrs: { "aria-label": "* field denotes as Mandatory fields." }
        },
        [_vm._v("*")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c(
        "button",
        {
          staticClass: "ap-btn error btn-find scheduler-button-custom-color",
          attrs: { role: "button" }
        },
        [_vm._v("Find")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e900720", esExports)
  }
}

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "schedulerPreviewModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "overlay" }, [
        _c(
          "div",
          { staticClass: "icon-back-wrapper", on: { click: _vm.hideModal } },
          [_c("div", { staticClass: "icon-back" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title h2-text" }, [
          _vm._v("\n      Scheduler Preview\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "carousel-preview-scheduler" },
          [
            _c(
              "b-button",
              {
                staticClass: "carousel-nav-prev carousel-icon",
                on: { click: _vm.carouselPrevClick }
              },
              [_vm._v("Previous")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "carousel-nav-next carousel-icon",
                on: { click: _vm.carouselNextClick }
              },
              [_vm._v("Next")]
            ),
            _vm._v(" "),
            _vm.currentIndex === 1
              ? _c(
                  "div",
                  { staticClass: "carousel-preview-item" },
                  [
                    _c("div", { staticClass: "h3-text" }, [
                      _vm._v("\n          My Information Section\n        ")
                    ]),
                    _vm._v(" "),
                    _c("SchedulerPreviewMyInfoPage", {
                      attrs: {
                        hasFluShot: _vm.allowBookFluShot,
                        hasSpousal: _vm.allowBookForSpouse,
                        spouseLabel: _vm.spouseLabel
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentIndex === 2
              ? _c(
                  "div",
                  { staticClass: "carousel-preview-item" },
                  [
                    _c("div", { staticClass: "h3-text" }, [
                      _vm._v("\n          Select Location Section\n        ")
                    ]),
                    _vm._v(" "),
                    _c("SchedulerPreviewSelectLocationPage", {
                      attrs: {
                        landingTopText: _vm.landingTopText,
                        landingBottomText: _vm.landingBottomText
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentIndex === 3
              ? _c(
                  "div",
                  { staticClass: "carousel-preview-item" },
                  [
                    _c("div", { staticClass: "h3-text" }, [
                      _vm._v("\n          My Appointment Section\n        ")
                    ]),
                    _vm._v(" "),
                    _c("SchedulerPreviewMyAppointmentPage", {
                      attrs: { landingThankYouText: _vm.landingThankYouText }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cc93c00", esExports)
  }
}

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1653);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("64955232", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2c874b6a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Popup.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2c874b6a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Popup.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.popup-modal[data-v-2c874b6a] {\n  margin: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n.popup-modal.modal-change-order-detail .v--modal-box[data-v-2c874b6a] {\n  overflow-y: scroll;\n}\n.popup-modal .modal-header[data-v-2c874b6a] {\n  padding: 0;\n  border: 0;\n  width: 85%;\n  margin: 0 auto;\n}\n.popup-modal .modal-header .line[data-v-2c874b6a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #E6E6E6;\n}\n.popup-modal .modal-header .modal-header-text[data-v-2c874b6a] {\n  margin-top: 50px;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: none;\n}\n.popup-modal .modal-header .modal-header-change-order-text[data-v-2c874b6a] {\n  margin-top: 25px;\n  margin-left: 25px;\n  height: 29px;\n  width: auto;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n}\n.popup-modal .modal-header .modal-header-line[data-v-2c874b6a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 3px;\n  width: 593px;\n  border: 1px solid #e6e6e6;\n}\n.popup-modal .modal-body[data-v-2c874b6a] {\n  height: auto;\n  width: 85%;\n  margin: 0 auto;\n  padding: 20px 0 0 0;\n}\n.popup-modal .modal-body .modal-body-text[data-v-2c874b6a] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.popup-modal .modal-body .modal-body-text-li[data-v-2c874b6a] {\n  margin-top: 20px;\n}\n.popup-modal .modal-body-changeOrderDetail .modal-body-changeOrderDetail-text[data-v-2c874b6a] {\n  margin-top: 25px;\n  margin-left: 25px;\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 14px;\n}\n.popup-modal .modal-body-changeOrderDetail .modal-body-changeOrderDetail-event-detail[data-v-2c874b6a] {\n  margin: 26px 0 0 0;\n}\n.popup-modal .modal-footer[data-v-2c874b6a] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  float: right;\n  border: 0;\n}\n.popup-modal .modal-footer .modal-btn-left[data-v-2c874b6a] {\n  border-radius: 4px;\n  margin-left: 15px;\n  margin-bottom: 50px;\n  margin-top: 30px;\n  text-transform: none;\n}\n.popup-modal .modal-footer .modal-btn-left .modal-btn-left-text[data-v-2c874b6a] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n}\n.popup-modal .modal-footer .modal-btn-right[data-v-2c874b6a] {\n  border-radius: 4px;\n  margin-right: 50px;\n  margin-bottom: 50px;\n  margin-top: 30px;\n  text-transform: none;\n}\n.popup-modal .modal-footer .modal-btn-right .modal-btn-right-text[data-v-2c874b6a] {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n}\n", ""]);

// exports


/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'cancelText', 'submitText'],
  data: function data() {
    return {
      cancelText: this.cancelText,
      okText: this.okText
    };
  },

  methods: {
    hideModal: function hideModal() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$emit('onCancel');

              case 2:
                _this.$modal.hide(_this.name);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    btnAction: function btnAction() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$emit('onSubmit');

              case 2:
                _this2.$modal.hide(_this2.name);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: {}
});

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { staticClass: "popup-modal", attrs: { name: _vm.name, width: 700 } },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._t("header", [_vm._v("Header")])], 2)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("a", [
          _c(
            "span",
            { staticClass: "modal-body-text" },
            [_vm._t("body", [_vm._v("Body")])],
            2
          ),
          _vm._v(" "),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _c(
            "b-button",
            {
              staticClass: "modal-btn-left ap-btn secondary",
              on: {
                click: function($event) {
                  _vm.hideModal()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.cancelText || "Cancel") + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "modal-btn-right ap-btn primary",
              on: {
                click: function($event) {
                  _vm.btnAction()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.submitText || "Submit") + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c874b6a", esExports)
  }
}

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "custom-modal",
          attrs: {
            name: "configureSchedulerModal",
            width: "75%",
            height: "auto",
            scrollable: true,
            pivotX: 1.0,
            minWidth: 900,
            minHeight: 900,
            clickToClose: true
          },
          on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
        },
        [
          _c(
            "div",
            {
              staticClass: "overlay",
              class: { isLoading: _vm.isLoading, noDisplay: !_vm.isLoading }
            },
            [
              _c(
                "div",
                { staticClass: "spinner-align" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: "spinner", scale: "5", pulse: "" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "div",
                { staticClass: "modal-padding", on: { click: _vm.onSave } },
                [
                  _c("div", { staticClass: "page-title" }, [
                    _c("div", { staticClass: "col-md-6 noPaddingLeft" }, [
                      _c("span", { staticClass: "h2-text" }, [
                        _vm._v(
                          _vm._s(_vm.configurations.clientName) +
                            "'s - Configure Scheduler"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 noPaddingRight align-right-item"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "modal-close-img",
                            on: { click: _vm.hideModal }
                          },
                          [_c("span", { staticClass: "icon-close" })]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-4" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "ap-btn secondary",
                          on: {
                            click: function($event) {
                              _vm.handleOpenSchedulerPreview()
                            }
                          }
                        },
                        [_vm._v("Preview Scheduler")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "float-right" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Online Scheduler" },
                            model: {
                              value: _vm.configurations.live,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "live", $$v)
                              },
                              expression: "configurations.live"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "float-right" },
                        [
                          _c("Toggle", {
                            attrs: {
                              text: "Online Scheduler for Test Accounts"
                            },
                            model: {
                              value: _vm.configurations.liveTestUser,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "liveTestUser",
                                  $$v
                                )
                              },
                              expression: "configurations.liveTestUser"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "scheduler mt-4" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Scheduler name")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configurations.name,
                                expression: "configurations.name"
                              }
                            ],
                            staticClass: "text-input",
                            attrs: { placeholder: "Enter your scheduler name" },
                            domProps: { value: _vm.configurations.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col text-entry-field-wrapper" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "text-entry-title" },
                                  [_vm._v("URL Hyperlink Color")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.configurations.urlHyperlinkColor,
                                      expression:
                                        "configurations.urlHyperlinkColor"
                                    }
                                  ],
                                  staticClass: "text-input",
                                  attrs: { placeholder: "Enter a HEX code" },
                                  domProps: {
                                    value: _vm.configurations.urlHyperlinkColor
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.configurations,
                                        "urlHyperlinkColor",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col text-entry-field-wrapper" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "text-entry-title" },
                                  [_vm._v("Branded URL")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.configurations.brandedURL,
                                      expression: "configurations.brandedURL"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|url:require_protocol",
                                      expression:
                                        "'required|url:require_protocol'"
                                    }
                                  ],
                                  staticClass: "text-input",
                                  attrs: {
                                    name: "brandedURL",
                                    placeholder: "Branded URL"
                                  },
                                  domProps: {
                                    value: _vm.configurations.brandedURL
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.configurations,
                                        "brandedURL",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "branded-url-error" },
                                  [
                                    _vm.errors.has("brandedURL")
                                      ? _c("div", {
                                          staticClass: "alert-icon-red-error"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "error-text-color" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("brandedURL"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row mt-3 flex-column align-items-end" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6 text-entry-field-wrapper" },
                          [
                            _c("span", { staticClass: "text-entry-title" }, [
                              _vm._v("ShiftBoard Lead WorkGroup")
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              staticClass: "multiple-select-work-group",
                              attrs: {
                                options: _vm.allWorkGroups,
                                placeholder: "Choose Lead WorkGroup",
                                label: "name",
                                openDirection: "below",
                                multiple: false,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "id",
                                "allow-empty": false,
                                "show-labels": false,
                                disabled: false
                              },
                              on: { select: _vm.dropdownItemClick },
                              model: {
                                value: _vm.dropdowntitle,
                                callback: function($$v) {
                                  _vm.dropdowntitle = $$v
                                },
                                expression: "dropdowntitle"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-entry-title" }, [
                              _vm._v("ShiftBoard Screener WorkGroup")
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              staticClass: "multiple-select-work-group",
                              attrs: {
                                options: _vm.allWorkGroups,
                                placeholder: "Choose Screener WorkGroup",
                                label: "name",
                                openDirection: "below",
                                multiple: false,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "id",
                                "allow-empty": false,
                                "show-labels": false,
                                disabled: false
                              },
                              on: { select: _vm.screenerDropdownItemClick },
                              model: {
                                value: _vm.screenerDropdowntitle,
                                callback: function($$v) {
                                  _vm.screenerDropdowntitle = $$v
                                },
                                expression: "screenerDropdowntitle"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-entry-title" }, [
                              _vm._v("ShiftBoard Phlebotomist WorkGroup")
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              staticClass: "multiple-select-work-group",
                              attrs: {
                                options: _vm.allWorkGroups,
                                placeholder: "Choose Phlebotomist WorkGroup",
                                label: "name",
                                openDirection: "below",
                                multiple: false,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "id",
                                "allow-empty": false,
                                "show-labels": false,
                                disabled: false
                              },
                              on: { select: _vm.phlebotomistDropdownItemClick },
                              model: {
                                value: _vm.phlebotomistDropdowntitle,
                                callback: function($$v) {
                                  _vm.phlebotomistDropdowntitle = $$v
                                },
                                expression: "phlebotomistDropdowntitle"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Landing Page Top Text")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.config },
                            model: {
                              value: _vm.configurations.landingTopText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "landingTopText",
                                  $$v
                                )
                              },
                              expression: "configurations.landingTopText"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Landing Page Bottom Text")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.config },
                            model: {
                              value: _vm.configurations.landingBottomText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "landingBottomText",
                                  $$v
                                )
                              },
                              expression: "configurations.landingBottomText"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Thank you page text")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.config },
                            model: {
                              value: _vm.configurations.landingThankYouText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "landingThankYouText",
                                  $$v
                                )
                              },
                              expression: "configurations.landingThankYouText"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mt-4 mb-4" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "configurations" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Configurations")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Allow walk-ins" },
                            model: {
                              value: _vm.configurations.allowWithoutLimeade,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowWithoutLimeade",
                                  $$v
                                )
                              },
                              expression: "configurations.allowWithoutLimeade"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Spouse appointment" },
                            model: {
                              value: _vm.configurations.allowBookForSpouse,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowBookForSpouse",
                                  $$v
                                )
                              },
                              expression: "configurations.allowBookForSpouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Participant Survey" },
                            model: {
                              value:
                                _vm.configurations.allowSendParticipantSurvey,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowSendParticipantSurvey",
                                  $$v
                                )
                              },
                              expression:
                                "configurations.allowSendParticipantSurvey"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-entry-field-wrapper" },
                        [
                          _c("Toggle", {
                            attrs: {
                              text:
                                "Vaccine Appointment (Flu shots/Covid Vaccines)",
                              disabled: !_vm.enableBookVaccineAtClient
                            },
                            model: {
                              value: _vm.configurations.allowBookFluShot,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowBookFluShot",
                                  $$v
                                )
                              },
                              expression: "configurations.allowBookFluShot"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-entry-field-wrapper" },
                        [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-entry-title display-flex-end",
                                class: {
                                  "opacity-06": !_vm.configurations
                                    .allowBookForSpouse
                                }
                              },
                              [
                                _c("span", [_vm._v("Spouse Label")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "display-space-between",
                                    class: {
                                      noDisplay: !_vm.configurations
                                        .allowBookForSpouse
                                    }
                                  },
                                  [
                                    _vm.errors.has("spouse")
                                      ? _c("span", {
                                          staticClass: "alert-icon-red-error"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "error-text-color" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("Spouse"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.configurations.spouseLabel,
                                  expression: "configurations.spouseLabel"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "text-input",
                              class: {
                                "opacity-06": !_vm.configurations
                                  .allowBookForSpouse
                              },
                              attrs: {
                                disabled: !_vm.configurations
                                  .allowBookForSpouse,
                                name: "Spouse",
                                placeholder: "Enter Spouse Label"
                              },
                              domProps: {
                                value: _vm.configurations.spouseLabel
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.configurations,
                                    "spouseLabel",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-entry-field-wrapper" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-entry-title",
                              class: {
                                "opacity-06": !_vm.configurations
                                  .allowSendParticipantSurvey
                              }
                            },
                            [_vm._v("Biometrics Survey URL")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.configurations.surveyBiometricResultUrl,
                                expression:
                                  "configurations.surveyBiometricResultUrl"
                              }
                            ],
                            staticClass: "text-input",
                            class: {
                              "opacity-06": !_vm.configurations
                                .allowSendParticipantSurvey
                            },
                            attrs: {
                              value: "configurations.surveyBiometricResultUrl",
                              disabled: !_vm.configurations
                                .allowSendParticipantSurvey,
                              placeholder: "Enter Biometrics Survey Link"
                            },
                            domProps: {
                              value: _vm.configurations.surveyBiometricResultUrl
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "surveyBiometricResultUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "ZenDesk" },
                            model: {
                              value: _vm.configurations.zendeskConfiguration,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "zendeskConfiguration",
                                  $$v
                                )
                              },
                              expression: "configurations.zendeskConfiguration"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Multiple Screenings Per Year" },
                            model: {
                              value:
                                _vm.configurations.multipleScreeningsPerYear,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "multipleScreeningsPerYear",
                                  $$v
                                )
                              },
                              expression:
                                "configurations.multipleScreeningsPerYear"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Screening Related SMS" },
                            model: {
                              value: _vm.configurations.enableSMSReminder,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "enableSMSReminder",
                                  $$v
                                )
                              },
                              expression: "configurations.enableSMSReminder"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "HPSF" },
                            model: {
                              value: _vm.configurations.hpsf,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "hpsf", $$v)
                              },
                              expression: "configurations.hpsf"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Labcorp" },
                            model: {
                              value: _vm.configurations.labCorp,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "labCorp", $$v)
                              },
                              expression: "configurations.labCorp"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Home Test Kit" },
                            model: {
                              value: _vm.configurations.htk,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "htk", $$v)
                              },
                              expression: "configurations.htk"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "text-entry-field-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text-entry-title display-flex-end",
                              class: { "opacity-06": !_vm.configurations.hpsf }
                            },
                            [
                              _c("span", [_vm._v("HPSF URL")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "display-space-between",
                                  class: { noDisplay: !_vm.configurations.hpsf }
                                },
                                [
                                  _vm.errors.has("hpsf")
                                    ? _c("span", {
                                        staticClass: "alert-icon-red-error"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "error-text-color" },
                                    [_vm._v(_vm._s(_vm.errors.first("hpsf")))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configurations.hpsfUrl,
                                expression: "configurations.hpsfUrl"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|url:require_protocol",
                                expression: "'required|url:require_protocol'"
                              }
                            ],
                            staticClass: "text-input",
                            class: { "opacity-06": !_vm.configurations.hpsf },
                            attrs: {
                              disabled: !_vm.configurations.hpsf,
                              name: "hpsf",
                              placeholder: "Enter HPSF URL"
                            },
                            domProps: { value: _vm.configurations.hpsfUrl },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "hpsfUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "text-entry-field-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text-entry-title display-flex-end",
                              class: { "opacity-06": !_vm.configurations.htk }
                            },
                            [
                              _c("span", [_vm._v("Home Test Kit URL")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "display-space-between",
                                  class: { noDisplay: !_vm.configurations.htk }
                                },
                                [
                                  _vm.errors.has("htk")
                                    ? _c("span", {
                                        staticClass: "alert-icon-red-error"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "error-text-color" },
                                    [_vm._v(_vm._s(_vm.errors.first("htk")))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configurations.htkUrl,
                                expression: "configurations.htkUrl"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|url:require_protocol",
                                expression: "'required|url:require_protocol'"
                              }
                            ],
                            staticClass: "text-input",
                            class: { "opacity-06": !_vm.configurations.htk },
                            attrs: {
                              disabled: !_vm.configurations.htk,
                              name: "htk",
                              placeholder: "Enter Home Test Kit URL"
                            },
                            domProps: { value: _vm.configurations.htkUrl },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "htkUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "SignUp Email" },
                            model: {
                              value: _vm.configurations.enableSignupEmail,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "enableSignupEmail",
                                  $$v
                                )
                              },
                              expression: "configurations.enableSignupEmail"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mt-4 mb-4" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "participant-emails" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("Participant & Spouse Emails")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-8 text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Participant Email Template")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.configurations.emailTemplateDtoList,
                              placeholder: "Choose Email Type",
                              label: "templateTypeName",
                              openDirection: "below",
                              "allow-empty": false,
                              "show-labels": false
                            },
                            on: { select: _vm.onSelectTemplate },
                            model: {
                              value: _vm.emailTemplate,
                              callback: function($$v) {
                                _vm.emailTemplate = $$v
                              },
                              expression: "emailTemplate"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-8 text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Subject Line")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.configEmail },
                            on: { input: _vm.onChangeTemplate },
                            model: {
                              value: _vm.emailTemplate.emailSubject,
                              callback: function($$v) {
                                _vm.$set(_vm.emailTemplate, "emailSubject", $$v)
                              },
                              expression: "emailTemplate.emailSubject"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Email body")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.configEmail },
                            on: { input: _vm.onChangeTemplate },
                            model: {
                              value: _vm.emailTemplate.body,
                              callback: function($$v) {
                                _vm.$set(_vm.emailTemplate, "body", $$v)
                              },
                              expression: "emailTemplate.body"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-top-44px group-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn primary ml-3",
                        class: { "opacity-04": _vm.isLoading },
                        attrs: {
                          id: "save-configure-scheduler",
                          disabled: _vm.isLoading
                        },
                        on: { click: _vm.onSave }
                      },
                      [_vm._v("Save")]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("SchedulerPreview")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "saveConfigurationsModal",
            "cancel-text": "Cancel",
            "submit-text": "Save"
          },
          on: { onSubmit: _vm.saveConfigurations }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure to save these configurations?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v(
              "Changing client level shiftboard teams assignment will overwrite all event level shiftboard teams assignments listed under this client."
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b4703dc", esExports)
  }
}

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalChangeToggleVaccines',
  props: {
    onCheckToggleOnOff: Function,
    loadingCovidSelect: {
      type: Boolean,
      default: false
    },
    addOns: {
      type: Array,
      default: []
    },
    nameModal: String,
    textQuestion: String,
    textDescription: String,
    listTextDescription: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      obj: null
    };
  },

  methods: {
    beforeOpen: function beforeOpen(params) {
      if (!params.params) return;
      this.obj = params.params;
      this.loadingCovidSelect = false;
    },
    beforeClose: function beforeClose() {
      this.onCancelToggle();
    },
    onCancel: function onCancel() {
      this.onCancelToggle();
      this.$modal.hide(this.nameModal);
    },
    onSubmit: function onSubmit() {
      this.loadingCovidSelect = true;
      this.onCheckToggleOnOff(this.obj);
    },
    onCancelToggle: function onCancelToggle() {
      if (this.loadingCovidSelect) return;
      var addOn = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.addOns, { 'key': this.obj.key });
      addOn.value = !this.obj.isAdd;
    }
  }
});

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-submit-drafts",
      attrs: {
        name: _vm.nameModal,
        width: "30%",
        height: "auto",
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "modal-header border-0 justify-content-end pb-0" },
        [
          _c(
            "div",
            {
              staticClass: "modal-close-img",
              on: {
                click: function($event) {
                  _vm.onCancel()
                },
                mouseover: function($event) {
                  _vm.isHoverClose = true
                },
                mouseleave: function($event) {
                  _vm.isHoverClose = false
                }
              }
            },
            [
              !_vm.isHoverClose
                ? _c("img", {
                    attrs: {
                      src: __webpack_require__(136),
                      alt: "close"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isHoverClose
                ? _c("img", {
                    attrs: {
                      src: __webpack_require__(137),
                      alt: "close"
                    }
                  })
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("p", { staticClass: "text-question" }, [
          _vm._v(_vm._s(_vm.textQuestion))
        ]),
        _vm._v(" "),
        _vm.listTextDescription.length == 0
          ? _c("p", { staticClass: "text-description" }, [
              _c("b", [_vm._v(_vm._s(_vm.textDescription))])
            ])
          : _c("p", { staticClass: "text-description" }, [
              _c(
                "ul",
                _vm._l(_vm.listTextDescription, function(item, index) {
                  return _c("li", { key: index }, [
                    _c("b", [_vm._v(_vm._s(item))])
                  ])
                })
              )
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-submit",
                attrs: { disabled: _vm.loadingCovidSelect },
                on: { click: _vm.onSubmit }
              },
              [
                _vm.loadingCovidSelect ? _c("b-spinner") : _vm._e(),
                _vm._v("\n        Yes\n      ")
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cca9f9da", esExports)
  }
}

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "event-modal right-modal custom-modal",
          attrs: {
            name: "customMessageModal",
            width: "50%",
            height: "auto",
            scrollable: true,
            pivotX: 1.0,
            minHeight: 900
          },
          on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
        },
        [
          _c("div", { staticClass: "modal-box" }, [
            _c(
              "div",
              {
                staticClass: "overlay",
                class: { isLoading: _vm.isLoading, noDisplay: !_vm.isLoading }
              },
              [
                _c(
                  "div",
                  { staticClass: "spinner-align" },
                  [
                    _c("Icon", {
                      staticClass: "icon-size",
                      attrs: { name: "spinner", scale: "5", pulse: "" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            !_vm.isLoading
              ? _c("div", { staticClass: "main-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "modal-close-img",
                      on: {
                        click: function($event) {
                          _vm.hideModal()
                        },
                        mouseover: function($event) {
                          _vm.isHoverClose = true
                        },
                        mouseleave: function($event) {
                          _vm.isHoverClose = false
                        }
                      }
                    },
                    [
                      !_vm.isHoverClose
                        ? _c("img", {
                            attrs: {
                              src: __webpack_require__(136),
                              alt: "close"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isHoverClose
                        ? _c("img", {
                            attrs: {
                              src: __webpack_require__(137),
                              alt: "close"
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Client Details")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "configure-scheduler ap-btn secondary",
                      on: {
                        click: function($event) {
                          _vm.openSchedulerConfig()
                        }
                      }
                    },
                    [_vm._v("\n        CONFIGURE SCHEDULER\n      ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "div",
                      { staticClass: "modal-header-text-edit" },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.clientName,
                              expression: "clientName"
                            }
                          ],
                          staticClass: "input-client-name",
                          domProps: { value: _vm.clientName },
                          on: {
                            keyup: function($event) {
                              _vm.bIsSaveClientName = true
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.clientName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.bIsSaveClientName
                          ? _c(
                              "b-button",
                              {
                                staticClass: "save-client-name-btn",
                                on: {
                                  click: function($event) {
                                    _vm.saveClientName({
                                      clientId: _vm.clientId,
                                      clientName: _vm.clientName
                                    })
                                  }
                                }
                              },
                              [
                                _c("Icon", { attrs: { name: "file-save-o" } }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "dt-group-btn-func-btn-left-text"
                                  },
                                  [_vm._v("SAVE")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body main-content" },
                    [
                      _c("CustomMessageSectionSubmission", {
                        attrs: { content: _vm.submissionMessage },
                        on: { UPDATE_MESSAGE: _vm.callSaveMessage }
                      }),
                      _vm._v(" "),
                      _c("CustomMessageSectionChangeOrder", {
                        attrs: { content: _vm.changeOrderMessage },
                        on: { UPDATE_MESSAGE: _vm.callSaveMessage }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-on" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("\n          Add-on configuration\n        ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          "\n          Toggle availability of add-on services this client can select when requesting a new event.\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.addOns, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "add-on-item" },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(_vm._s(item.text))
                            ]),
                            _vm._v(" "),
                            item.key === "fluShots"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: item.key,
                                    disabled: !_vm.isAdminUser
                                  },
                                  domProps: {
                                    checked: Array.isArray(item.value)
                                      ? _vm._i(item.value, null) > -1
                                      : item.value
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = item.value,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(item, "value", $$c)
                                        }
                                      },
                                      function($event) {
                                        _vm.checkboxToggle(item.key, item.value)
                                      }
                                    ]
                                  }
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  attrs: { type: "checkbox", id: item.key },
                                  domProps: {
                                    checked: Array.isArray(item.value)
                                      ? _vm._i(item.value, null) > -1
                                      : item.value
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = item.value,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                item,
                                                "value",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(item, "value", $$c)
                                        }
                                      },
                                      function($event) {
                                        _vm.checkboxToggle(item.key, item.value)
                                      }
                                    ]
                                  }
                                }),
                            _c("label", { attrs: { for: item.key } }, [
                              _vm._v("Toggle")
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "secondary-am" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n          Secondary Account Manager\n        ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n          Assign a secondary account manager.\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pick custom-multiselect" },
                      [
                        _c("multiselect", {
                          staticClass: "input-second-am",
                          attrs: {
                            options: _vm.listSecondaryAM,
                            placeholder: "Secondary account manager",
                            label: "name",
                            openDirection: "below",
                            multiple: true,
                            "close-on-select": true,
                            "hide-selected": true,
                            "track-by": "id",
                            "allow-empty": true,
                            "show-labels": false
                          },
                          on: {
                            select: _vm.selectSecondaryAM,
                            remove: _vm.removeAM
                          },
                          model: {
                            value: _vm.secondaryAMSelected,
                            callback: function($$v) {
                              _vm.secondaryAMSelected = $$v
                            },
                            expression: "secondaryAMSelected"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "reseller-status" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n            Reseller Status\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n            Toggle client status as a reseller and assign subclients.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "reseller-toggle" }, [
                      _c("span", { staticClass: "text" }, [_vm._v("Reseller")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resellerToggle,
                            expression: "resellerToggle"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "reseller",
                          disabled: _vm.managedByClientId != null
                        },
                        domProps: {
                          checked: Array.isArray(_vm.resellerToggle)
                            ? _vm._i(_vm.resellerToggle, null) > -1
                            : _vm.resellerToggle
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.resellerToggle,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.resellerToggle = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.resellerToggle = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.resellerToggle = $$c
                              }
                            },
                            function($event) {
                              _vm.resellerToggleCheck(_vm.resellerToggle)
                            }
                          ]
                        }
                      }),
                      _c("label", { attrs: { for: "reseller" } }, [
                        _vm._v("Toggle")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.resellerToggle
                      ? _c("div", { staticClass: "read-only custom-toggle" }, [
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Read Only")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.readOnlyToggle,
                                expression: "readOnlyToggle"
                              }
                            ],
                            attrs: { type: "checkbox", id: "readOnly" },
                            domProps: {
                              checked: Array.isArray(_vm.readOnlyToggle)
                                ? _vm._i(_vm.readOnlyToggle, null) > -1
                                : _vm.readOnlyToggle
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.readOnlyToggle,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.readOnlyToggle = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.readOnlyToggle = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.readOnlyToggle = $$c
                                  }
                                },
                                function($event) {
                                  _vm.readOnlyToggleCheck(_vm.readOnlyToggle)
                                }
                              ]
                            }
                          }),
                          _c("label", { attrs: { for: "readOnly" } }, [
                            _vm._v("Toggle")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pick custom-multiselect" },
                      [
                        _vm.resellerToggle
                          ? _c("multiselect", {
                              staticClass: "input-second-am",
                              attrs: {
                                options: _vm.listSubClient,
                                placeholder: "Search for client to add",
                                label: "clientName",
                                openDirection: "below",
                                "show-no-results": false,
                                multiple: true,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "clientId",
                                "allow-empty": true,
                                "show-labels": false
                              },
                              on: {
                                select: _vm.selectSubClient,
                                remove: _vm.removeSubClient
                              },
                              model: {
                                value: _vm.subClientSelected,
                                callback: function($$v) {
                                  _vm.subClientSelected = $$v
                                },
                                expression: "subClientSelected"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "secondary-am" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n            Validators\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        "\n            Assign Validators for clients.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "pick last-child-pick custom-multiselect"
                      },
                      [
                        _c("multiselect", {
                          staticClass: "input-second-am",
                          attrs: {
                            options: _vm.listValidators,
                            placeholder: "Choose or select validators",
                            label: "name",
                            openDirection: "below",
                            multiple: true,
                            "close-on-select": true,
                            "hide-selected": true,
                            "track-by": "id",
                            "allow-empty": true,
                            "show-labels": false
                          },
                          on: { select: _vm.addValidators },
                          scopedSlots: _vm._u([
                            {
                              key: "tag",
                              fn: function(props) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "multiselect__tag" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(props.option.name))
                                      ]),
                                      _vm._v(" "),
                                      !_vm.readOnlyTaggingValidators(
                                        props.option
                                      )
                                        ? _c("i", {
                                            staticClass:
                                              "multiselect__tag-icon",
                                            attrs: {
                                              "aria-hidden": "true",
                                              tabindex: "1"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.removeValidators(
                                                  props.option
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.selectedValidators,
                            callback: function($$v) {
                              _vm.selectedValidators = $$v
                            },
                            expression: "selectedValidators"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("ConfigureSchedulerModal"),
      _vm._v(" "),
      _c("ModalChangeToggleVaccines", {
        attrs: {
          onCheckToggleOnOff: _vm.processUpdateAddons,
          addOns: _vm.addOns,
          nameModal: _vm.modalVaccineChangeConfirmationName,
          textQuestion: _vm.textTurnOffVaccineConfirmation,
          listTextDescription: _vm.textTurnOffVaccineConfirmationDescription
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42cf7a83", esExports)
  }
}

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("cbc2fd48", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-43cb2843\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventDetailModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-43cb2843\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventDetailModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.custom-modal[data-v-43cb2843] {\n  background: rgba(0, 0, 0, 0.4);\n}\n.custom-modal .modal-padding[data-v-43cb2843] {\n  padding: 24px 40px 20px 40px;\n  min-height: 100vh;\n}\n.custom-modal .icon-back[data-v-43cb2843] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(92) + ");\n}\n.custom-modal .icon-align[data-v-43cb2843] {\n  margin-bottom: 10px;\n  padding-left: 8px;\n  margin-top: 24px;\n}\n.custom-modal .icon-align[data-v-43cb2843]:hover {\n  cursor: pointer;\n}\n.custom-modal .series-related-events-section .related-events-top[data-v-43cb2843] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: -10px;\n}\n.custom-modal .series-related-events-section .related-events-top .related-events-top-left[data-v-43cb2843] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.custom-modal .series-related-events-section .related-events-top .related-events-top-left .related-events-title[data-v-43cb2843] {\n  color: #626262;\n  font-size: 16px;\n  font-weight: bold;\n}\n.custom-modal .series-related-events-section .related-events-top .related-events-top-left .related-event-count[data-v-43cb2843] {\n  color: #9D9D9D;\n  font-size: 12px;\n  margin-left: 8px;\n  font-weight: normal;\n  text-transform: uppercase;\n}\n.custom-modal .series-related-events-section .related-events-top .button-containers[data-v-43cb2843] {\n  margin-left: 12px;\n}\n.custom-modal .series-related-events-section .related-events-top .button-containers .btn-left[data-v-43cb2843] {\n  padding: 6px 24px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.custom-modal .series-related-events-section .related-events-top .button-containers .btn-right[data-v-43cb2843] {\n  height: 24px;\n  padding: 0 12px;\n  font-size: 12px;\n}\n.custom-modal .series-related-events-section .related-event-container .related-event-item[data-v-43cb2843] {\n  height: 32px;\n  padding: 8px;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n.custom-modal .series-related-events-section .related-event-container .related-event-item .event-name[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .series-related-events-section .related-event-container .related-event-item[data-v-43cb2843]:hover {\n  cursor: pointer;\n}\n.custom-modal .series-related-events-section .related-event-container .main-event[data-v-43cb2843] {\n  background: #e6e6e6;\n}\n.custom-modal .series-related-events-section .btn-add-related-container[data-v-43cb2843] {\n  margin-top: 8px;\n}\n.custom-modal .series-related-events-section .btn-add-related-container .btn-add-related[data-v-43cb2843] {\n  font-size: 12px;\n  padding: 6px 12px;\n}\n.custom-modal .event-detail-header .wrapper-participant[data-v-43cb2843] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-items: flex-end;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  text-align: right;\n}\n.custom-modal .event-detail-header .wrapper-multi-select .multi-select-text[data-v-43cb2843] {\n  padding: 0;\n  width: 275px;\n}\n.custom-modal .event-detail-header .wrapper-multi-select .multiselect[data-v-43cb2843] {\n  min-height: 38px;\n}\n.custom-modal .event-detail-header .wrapper-multi-select .multiselect__tags[data-v-43cb2843] {\n  border: none;\n  min-height: 38px;\n}\n.custom-modal .event-detail-header .wrapper-multi-select .multiselect__content-wrapper .multiselect__element[data-v-43cb2843]:last-child {\n  border-bottom: none;\n}\n.custom-modal .event-detail-header .event-details[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.custom-modal .event-detail-header .client-name[data-v-43cb2843] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n  line-height: 28px;\n}\n.custom-modal .event-detail-header .event-name[data-v-43cb2843] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  float: right;\n  clear: both;\n}\n.custom-modal .event-detail-header .map[data-v-43cb2843] {\n  height: 200px;\n  width: 100%;\n  border: 1px solid #424242;\n}\n.custom-modal .modal-close-img[data-v-43cb2843] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.custom-modal .modal-close-img[data-v-43cb2843]:hover {\n  cursor: pointer;\n}\n.custom-modal .modal-close-img .icon-close[data-v-43cb2843] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.custom-modal .event-detail-body[data-v-43cb2843] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.custom-modal .event-detail-body textarea[data-v-43cb2843],\n.custom-modal .event-detail-body input[data-v-43cb2843] {\n  padding: 4px;\n  width: 90%;\n}\n.custom-modal .event-detail-body .email-text[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .event-detail-body .col-md-3[data-v-43cb2843]:nth-child(4n + 1) {\n  padding-left: 0;\n}\n.custom-modal .event-detail-body .col-md-3[data-v-43cb2843]:nth-child(4n) {\n  padding-right: 0;\n}\n.custom-modal .event-detail-body .col-md-4[data-v-43cb2843]:nth-child(3n + 1) {\n  padding-left: 0;\n}\n.custom-modal .event-detail-body .col-md-4[data-v-43cb2843]:nth-child(3n) {\n  padding-right: 0;\n}\n.custom-modal .event-detail-body .view-history-text[data-v-43cb2843] {\n  color: #1674cd;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 24px;\n  cursor: pointer;\n  margin-left: 16px;\n}\n.custom-modal .event-detail-body .staff-header[data-v-43cb2843] {\n  color: #626262;\n  font-size: 16px;\n  font-weight: bold;\n}\n.custom-modal .event-detail-body .staffing-edit-btn .ap-btn[data-v-43cb2843] {\n  padding: 4px 24px;\n  text-transform: none;\n  border: 1px solid #B9B9B9;\n  font-size: 16px;\n}\n.custom-modal .event-detail-body .staffing-edit-btn .ap-btn.secondary[data-v-43cb2843] {\n  color: #1674cd;\n}\n.custom-modal .event-detail-body .staffing-edit-btn .ap-btn.secondary[data-v-43cb2843]:hover {\n  background-color: #1674cd;\n  color: #ffffff;\n}\n.custom-modal .event-detail-body .staffing-edit-btn .ap-btn.secondary[data-v-43cb2843]:disabled {\n  opacity: 1;\n  background: #b9b9b9;\n  color: white;\n}\n.custom-modal .event-detail-body .staffing-edit-btn .spinner-border[data-v-43cb2843] {\n  width: 1rem;\n  height: 1rem;\n  color: #fff;\n}\n.custom-modal .event-detail-body .text[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .event-detail-body .text.online-text[data-v-43cb2843] {\n  color: #1674cd;\n}\n.custom-modal .event-detail-body .number[data-v-43cb2843] {\n  width: 177px;\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .event-detail-body .group-btn-manage-detail[data-v-43cb2843] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.custom-modal .event-detail-body .group-btn-manage-detail .icon-email-wrapper[data-v-43cb2843] {\n  width: 32px;\n  height: 32px;\n  background-color: #00A4D6;\n  padding: 4px;\n  border-radius: 4px;\n}\n.custom-modal .event-detail-body .group-btn-manage-detail .icon-email-wrapper[data-v-43cb2843]:hover {\n  cursor: pointer;\n}\n.custom-modal .event-detail-body .group-btn-manage-detail .icon-email-wrapper .icon-email[data-v-43cb2843] {\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(822) + ");\n}\n.custom-modal .event-detail-body .group-btn-manage-detail .ap-btn[data-v-43cb2843] {\n  padding: 6px 17px;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n}\n.custom-modal .event-detail-body .group-btn-manage-detail .btn-left[data-v-43cb2843] {\n  margin-right: 8px;\n}\n.custom-modal .event-detail-body .manage-detail[data-v-43cb2843] {\n  height: 32px;\n  width: 184px;\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n  float: right;\n}\n.custom-modal .event-detail-body .manage-detail .manage-text[data-v-43cb2843] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.custom-modal .event-detail-body .btn-request-change[data-v-43cb2843] {\n  min-width: 215px;\n}\n.custom-modal .event-detail-body .request-change[data-v-43cb2843] {\n  height: 32px;\n  width: 184px;\n  background-color: #AAA7A4;\n  border-radius: 4px;\n}\n.custom-modal .event-detail-body .request-change .request-text[data-v-43cb2843] {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  text-transform: uppercase;\n}\n.custom-modal .event-detail-body .wrapper-text-number[data-v-43cb2843] {\n  margin-right: 24px;\n}\n.custom-modal .event-detail-body .liner[data-v-43cb2843] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n.custom-modal .event-detail-body .liner-for-staff[data-v-43cb2843] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  margin-top: 22px;\n  margin-bottom: 18px;\n}\n.custom-modal .event-detail-body .event-information[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.custom-modal .event-detail-body .event-title[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  text-transform: none;\n  margin-top: 14px;\n}\n.custom-modal .event-detail-body .event-info[data-v-43cb2843] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.custom-modal .event-detail-body .shipping-notes[data-v-43cb2843] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .event-detail-body .input-shipping-notes[data-v-43cb2843] {\n  height: 78px;\n  width: 402px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n}\n.custom-modal .event-detail-body .on-site-instruction[data-v-43cb2843] {\n  height: 63px;\n  width: 184px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .event-detail-body .tracking-number[data-v-43cb2843] {\n  height: 31px;\n  width: 402px;\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n  text-transform: uppercase;\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n}\n.custom-modal .event-detail-body .supplies-tracking-status[data-v-43cb2843] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .event-detail-body .wrapper-text[data-v-43cb2843] {\n  padding: 8px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n}\n.custom-modal .event-detail-body .textError[data-v-43cb2843] {\n  color: #E93000;\n}\n.custom-modal .event-detail-body .history-table-container[data-v-43cb2843] {\n  width: 100%;\n}\n.custom-modal .add-on-wrapper[data-v-43cb2843] {\n  float: left;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 4px;\n}\n.custom-modal .add-on-wrapper .title[data-v-43cb2843] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.custom-modal .add-on-wrapper .event-add-on[data-v-43cb2843] {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.custom-modal .add-on-wrapper .event-add-on .title[data-v-43cb2843] {\n  margin-top: 20px;\n}\n.custom-modal .add-on-wrapper .event-add-on .title .icon-add[data-v-43cb2843] {\n  color: #fff;\n  background-color: #00A4D6;\n  border: 3px;\n  border-radius: 20px;\n  width: 16px;\n  height: 16px;\n  margin-left: 15px;\n}\n.custom-modal .add-on-wrapper .event-add-on .title .text[data-v-43cb2843] {\n  margin-left: 10px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.custom-modal .add-on-wrapper .event-add-on .add-on-item[data-v-43cb2843] {\n  width: 210px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 15px;\n  display: inline-block;\n}\n.custom-modal .add-on-wrapper .event-add-on .add-on-item .text[data-v-43cb2843] {\n  position: absolute;\n  left: 45px;\n}\n.custom-modal .add-on-wrapper .event-add-on input[type=checkbox][data-v-43cb2843] {\n  width: 0;\n  visibility: hidden;\n}\n.custom-modal .add-on-wrapper .event-add-on label[data-v-43cb2843] {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 1px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.custom-modal .add-on-wrapper .event-add-on label[data-v-43cb2843]:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.custom-modal .add-on-wrapper .event-add-on input:checked + label[data-v-43cb2843] {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.custom-modal .add-on-wrapper .event-add-on input:checked + label[data-v-43cb2843]:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.custom-modal .add-on-wrapper .event-add-on label[data-v-43cb2843]:active:after {\n  width: 15px;\n}\n.oval[data-v-43cb2843] {\n  height: 8px;\n  width: 8px;\n  display: inline-block;\n  border-radius: 3px;\n  margin-left: 0;\n}\n.oval.oval-red[data-v-43cb2843] {\n  background-color: #E93000;\n}\n.oval.oval-green[data-v-43cb2843] {\n  background-color: #68B814;\n}\n.oval.oval-orange[data-v-43cb2843] {\n  background-color: #FFA71B;\n}\n.oval.ovalSilver[data-v-43cb2843] {\n  background-color: #D8D8D8;\n}\n.oval.margin-left-8px[data-v-43cb2843] {\n  margin-left: 8px;\n}\n.isLoading[data-v-43cb2843] {\n  display: block;\n  text-align: center;\n  color: #606060;\n  height: 100%;\n}\n.noDisplay[data-v-43cb2843] {\n  display: none;\n}\n.display-inline[data-v-43cb2843] {\n  display: inline;\n}\n.padding-top-5px[data-v-43cb2843] {\n  padding-top: 5px;\n}\n.overlay[data-v-43cb2843] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.spinner-align[data-v-43cb2843] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.align-right-item[data-v-43cb2843] {\n  text-align: right;\n}\n.btn-add-second-contact[data-v-43cb2843] {\n  background-color: rgba(47, 114, 214, 0.8);\n  font-size: 16px;\n  height: 32px;\n  width: 32px;\n  border-radius: 50%;\n  position: relative;\n  border: none;\n}\n.btn-add-second-contact[data-v-43cb2843]:after,\n.btn-add-second-contact[data-v-43cb2843]:before {\n  content: \"\";\n  display: block;\n  background-color: #ffffff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.btn-add-second-contact[data-v-43cb2843]:before {\n  height: 1em;\n  width: 0.2em;\n}\n.btn-add-second-contact[data-v-43cb2843]:after {\n  height: 0.2em;\n  width: 1em;\n}\n", ""]);

// exports


/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_dropdowns__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_google_autocomplete__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RelatedEventsModal__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ModalChangeToggleVaccines__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalChangeTimeEvent__ = __webpack_require__(1670);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'eventDetailModal',
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_10_vue_slider_component___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a,
    VueDropdown: __WEBPACK_IMPORTED_MODULE_6_vue_dropdowns__["a" /* default */],
    VueSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a,
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_13_vue_google_autocomplete__["a" /* default */],
    RelatedEventsModal: __WEBPACK_IMPORTED_MODULE_14__RelatedEventsModal__["a" /* default */],
    ModalChangeToggleVaccines: __WEBPACK_IMPORTED_MODULE_15__ModalChangeToggleVaccines__["a" /* default */],
    ModalChangeTimeEvent: __WEBPACK_IMPORTED_MODULE_16__ModalChangeTimeEvent__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      editing: false,
      event: {
        relatedEvents: []
      },
      shippingStatus: '',
      program: '',
      listTime: __WEBPACK_IMPORTED_MODULE_11__consts__["a" /* default */].listTime,
      addOns: __WEBPACK_IMPORTED_MODULE_11__consts__["a" /* default */].addOns,
      changeHistoryTableFields: [{
        key: 'fieldName',
        text: 'Field Name',
        value: false
      }, {
        key: 'updatedBy',
        text: 'Updated By',
        value: false
      }, {
        key: 'oldValue',
        text: 'Old Value',
        value: false
      }, {
        key: 'newValue',
        text: 'New Value',
        value: false
      }, {
        key: 'timeModified',
        text: 'Time',
        value: false
      }],
      onChangeEventLive: null,
      onChangeEvent: null,
      loadingCovidSelect: false,
      oldStartTime: null,
      oldEndTime: null,
      textQuestionToggleRemoved: 'Are you sure you want to remove vaccine add-on? All vaccine-related appointments within this event will be canceled.',
      textDescriptionToggleRemoved: 'Members will receive a cancellation email.',
      textQuestionToggleSwitch: 'Are you sure you want to change the Flu/Covid Vaccines event type/add-on?',
      textDescriptionToggleSwitch: 'All scheduled vaccine-related appointments under this event will be automatically switched to this new event vaccine type - ',
      nameModalRemmoved: 'modalChangeToggleVaccinesTypeRemoved',
      nameModalSwitch: 'modalChangeToggleVaccinesSwitched',
      loadingUpdate: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.$modal.hide('eventDetailModal');
    },
    beforeOpen: function beforeOpen(params) {
      this.onChangeEventLive = params.params.onChangeEventLive;
      this.onChangeEvent = params.params.onChangeEvent;
      this.loadEvent(params.params.eventId);
    },
    beforeClose: function beforeClose() {
      this.createNewEventClick();
    },
    opened: function opened() {
      this.updateNextZIndex('eventDetailModal');
    },
    preventSave: function preventSave(event) {
      if (event.target.classList.contains('btn-save')) {
        return false;
      }
      var classes = ['cell', 'day', 'selected', 'prev', 'up', 'next', 'blank'];
      if (classes.find(function (e) {
        return event.target.classList.contains(e);
      })) {
        return true;
      }
      var types = ['input', 'button', 'textarea', 'select', 'label', 'span'];
      return types.includes(event.target.tagName.toLowerCase());
    },
    isParticipantValid: function isParticipantValid() {
      if (this.event.numParticipant > this.event.projPart) {
        this.$toastr('error', 'Total Participants must be greater or equal number of current participants', '');
        return false;
      }
      return true;
    },
    onSave: function onSave(event) {
      if (!this.editing) return;
      if (this.preventSave(event)) return;
      if (!this.checkTimeGreater(this.event.startTime, this.event.endTime)) return;
      if (!this.isParticipantValid()) return;
      if (this.oldStartTime !== this.event.startTime || this.oldEndTime !== this.event.endTime) {
        this.$modal.show('modalChangeTimeEvent');
        return;
      }
      this.onUpdateEventAction();
    },
    onEdit: function onEdit() {
      if (this.isReadOnly) return;
      this.editing = true;
    },
    updateIsLiveEvent: function updateIsLiveEvent(type) {
      var _this = this;

      var isCheck = false;
      switch (type) {
        case 'LIVE':
          isCheck = this.event.isLive;
          break;
        case 'ONLINE_SCHEDULER':
          isCheck = this.event.isOnlineScheduler;
          break;
        default:
          break;
      }
      this.actionUpdateIsLiveEvent({
        eventId: this.event.id,
        isCheck: isCheck || false,
        onlineType: type
      }).then(function (response) {
        _this.onChangeEventLive(isCheck);
        if (response.message) {
          _this.$toastr('error', response.message, '');
        } else {
          _this.$toastr('success', 'Update event successful!', '');
        }
      });
    },
    onViewMailHistory: function onViewMailHistory() {
      this.$modal.show('EmailHistoriesManagementModal', { eventId: this.event.id });
    },
    onManageRelatedEvent: function onManageRelatedEvent() {
      this.$modal.show('relatedEventsModal', this.event);
    },
    onManageEmail: function onManageEmail() {
      this.$modal.hide('manageEmailModal');
      this.$modal.show('manageEmailModal', {
        eventId: this.event.id,
        isManageDetails: true
      });

      this.updateNextZIndex('manageEmailModal');
    },
    onManageEventStaffingDetail: function onManageEventStaffingDetail() {
      var params = {
        eventId: this.event.id,
        routerName: this.$route.name,
        eventName: this.event.eventName
      };
      this.$modal.show('eventStaffingDetailModal', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, { onChangeEventDetail: this.onChangeEventDetail }));
    },
    generatePackingSlipBtn: function generatePackingSlipBtn() {
      this.generatePackingSlip(this.event.id);
    },
    relatedEventItemClick: function relatedEventItemClick(eventId) {
      this.loadEvent(eventId);
    },
    loadEvent: function loadEvent(eventId) {
      var _this2 = this;

      this.editing = false;
      this.eventId = eventId;
      this.shippingStatus = '';
      this.actionGetEventById(this.eventId).then(function (response) {
        _this2.event = response.event;
        _this2.event.endTime = _this2.addTimeWithDuration(response.event.startTime, response.event.duration);
        _this2.oldStartTime = response.event.startTime;
        _this2.oldEndTime = response.event.endTime;
        if (response.message === null) {
          // reset and update add ons
          var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__consts__["a" /* default */].LOCAL_STORE.addOns);
          var arrAddOns = strAddOns.split(',');

          _this2.addOns.forEach(function (addOn) {
            addOn.value = false;addOn.isShow = false;
          });
          _this2.addOns.forEach(function (addOn) {
            if (_this2.event.addOns.includes(addOn.key)) {
              addOn.value = true;
            }
            arrAddOns.forEach(function (ele) {
              if (ele === addOn.key) {
                addOn.isShow = true;
              }
            });
          });

          // get shipping status
          if (_this2.event && _this2.event.trackingNumber) {
            _this2.actionGetTrackingStatus({ eventId: _this2.eventId, trackingNumber: _this2.event.trackingNumber }).then(function (res) {
              _this2.shippingStatus = res && res.shippingStatus && res.shippingStatus.trackingStatusDescription || '';
            });
          }

          // get event change history
          if (_this2.event.id && _this2.event.status !== 'DRAFTS') {
            _this2.actionGetEventHistory(_this2.event.id);
          }
        }

        _this2.$store.commit('MUTATION_SET_CURRENT_EVENT', _this2.event);
      });
    },
    minutes: function minutes() {
      var range = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.range(0, 60);
      return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(range, function (value) {
        return (value > 9 ? '' : '0') + value;
      });
    },
    formatTime: function formatTime(hour, minute, period) {
      return hour + ':' + minute + ' ' + period;
    },
    parseTime: function parseTime(time) {
      if (!time) {
        return { hour: '', minute: '', period: 'AM' };
      }

      var period = time.split(' ')[1];
      var fullTime = time.split(' ')[0].split(':');

      return {
        hour: fullTime[0],
        minute: fullTime[1],
        period: period
      };
    },
    checkboxToggle: function checkboxToggle(item) {
      var obj = {
        clientId: this.event.clientId,
        eventId: this.event.id,
        key: item.key,
        isAdd: item.value
      };
      var covidAndFlushotAddons = __WEBPACK_IMPORTED_MODULE_11__consts__["a" /* default */].addOns.slice(7, 10).map(function (addOn) {
        return addOn.key;
      });
      if (covidAndFlushotAddons.includes(item.key)) {
        if (this.addOns.slice(7, 10).every(function (x) {
          return x.value === false;
        })) {
          this.$modal.show(this.nameModalRemmoved, obj);
          return;
        }
        if (this.addOns.slice(7, 10).find(function (x) {
          return x.key === item.key;
        }) && this.addOns.slice(7, 10).some(function (x) {
          return x.key !== item.key && x.value === true;
        })) {
          this.newTextDescriptionToggleSwitch = this.textDescriptionToggleSwitch + item.text;
          this.$modal.show(this.nameModalSwitch, obj);
          return;
        }
      }
      // if (this.addOns.slice(7, 10).every(x => x.value === false)) {
      //   this.$modal.show(this.nameModalRemmoved, obj);
      //   return;
      // }
      // if (this.addOns.slice(7, 10).find(x => x.key === item.key) && this.addOns.slice(7, 10).some(x => x.key !== item.key && x.value === true)) {
      //   this.newTextDescriptionToggleSwitch = this.textDescriptionToggleSwitch + item.text;
      //   this.$modal.show(this.nameModalSwitch, obj);
      //   return;
      // }
      this.onCheckToggleOnOff(obj);
    },
    setPlace: function setPlace(data, place) {
      var _this3 = this;

      this.event.fullAddress = place.formatted_address;
      var req = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].axios.create();
      req.get('https://maps.googleapis.com/maps/api/timezone/json', {
        params: {
          location: place.geometry.location.lat() + ',' + place.geometry.location.lng(),
          timestamp: '' + Math.round(new Date().getTime() / 1000),
          key: this.googleMapApiKey === '' ? localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__consts__["a" /* default */].LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
        }
      }).then(function (response) {
        if (response.data) {
          _this3.event.timeZone = _this3.getTimeZone(response.data.timeZoneName);
        } else {
          __WEBPACK_IMPORTED_MODULE_9_vue__["default"].prototype.$toastr('error', 'Error calling Google Maps API', '');
        }
        _this3.isInSetPlace = false;
      });
    },
    setPlaceShipping: function setPlaceShipping(data, place) {
      this.event.shippingAddress = place.formatted_address;
    },
    getTimeZone: function getTimeZone(tzString) {
      if (tzString.length === 0) {
        return '';
      }
      var str = '';
      var index = 0;
      while (index >= 0) {
        str += tzString.substr(0, 1);
        index = tzString.indexOf(' ');
        tzString = tzString.substring(index + 1);
      }
      return str;
    },
    onChangeDuration: function onChangeDuration() {
      this.event.endTime = this.addTimeWithDuration(this.event.startTime, this.event.duration);
      this.event.startTime = this.subtractTimeWithDuration(this.event.endTime, this.event.duration);
    },
    onChangeStartTime: function onChangeStartTime() {
      if (!this.checkTimeGreater(this.event.startTime, this.event.endTime)) return;
      this.event.endTime = this.addTimeWithDuration(this.event.startTime, this.event.duration);
      this.event.duration = this.calculateDuration(this.event.startTime, this.event.endTime);
    },
    onChangeEndTime: function onChangeEndTime() {
      if (!this.checkTimeGreater(this.event.startTime, this.event.endTime)) return;
      this.event.startTime = this.subtractTimeWithDuration(this.event.endTime, this.event.duration);
      this.event.duration = this.calculateDuration(this.event.startTime, this.event.endTime);
    },
    checkTimeGreater: function checkTimeGreater(startTime, endTime) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(startTime, 'h:mm A').isBefore(__WEBPACK_IMPORTED_MODULE_12_moment___default()(endTime, 'h:mm A'));
    },
    calculateDuration: function calculateDuration(startTime, endTime) {
      var start = __WEBPACK_IMPORTED_MODULE_12_moment___default()([__WEBPACK_IMPORTED_MODULE_12_moment___default()(startTime, 'h:mm A').hour(), __WEBPACK_IMPORTED_MODULE_12_moment___default()(startTime, 'h:mm A').minutes(), '00'], 'HH:mm:ss');
      var end = __WEBPACK_IMPORTED_MODULE_12_moment___default()([__WEBPACK_IMPORTED_MODULE_12_moment___default()(endTime, 'h:mm A').hour(), __WEBPACK_IMPORTED_MODULE_12_moment___default()(endTime, 'h:mm A').minutes(), '00'], 'HH:mm:ss');
      return __WEBPACK_IMPORTED_MODULE_12_moment___default.a.duration(end.diff(start)).asHours();
    },
    addTimeWithDuration: function addTimeWithDuration(time, duration) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(time, 'h:mm A').add(duration, 'hours').format('h:mm A');
    },
    subtractTimeWithDuration: function subtractTimeWithDuration(time, duration) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(time, 'h:mm A').subtract(duration, 'hours').format('h:mm A');
    },
    onChangeEventDetail: function onChangeEventDetail(item) {
      this.event.maxStaffLead = item.maxStaffLead;
      this.event.maxStaffConcierge = item.maxStaffConcierge;
      this.event.maxStaffScreener = item.maxStaffScreener;
      this.onChangeEvent(this.event);
    },
    onCheckToggleOnOff: function onCheckToggleOnOff(obj) {
      var _this4 = this;

      var addOn = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(this.addOns, { 'key': obj.key });
      this.updateAddOn(obj).then(function () {
        _this4.event.addOns = _this4.addOns.filter(function (e) {
          return e.value === true;
        }).map(function (e) {
          return e.key;
        }).join(',');
        if (_this4.addOns.slice(7, 10).find(function (x) {
          return x.key === obj.key;
        })) {
          _this4.addOns.slice(7, 10).forEach(function (element) {
            if (obj.key !== element.key) {
              element.value = false;
            }
          });
        }
        _this4.$modal.hide(_this4.nameModalRemmoved);
        _this4.$modal.hide(_this4.nameModalSwitch);
        _this4.loadingCovidSelect = false;
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].prototype.$toastr('success', 'Update event successful');
      }).catch(function () {
        addOn.value = !obj.isAdd;
      });
    },
    onUpdateEventAction: function onUpdateEventAction() {
      var _this5 = this;

      this.loadingUpdate = true;
      this.updateEventAction(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.event, { prefDate: __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.event.prefDate).format('MM/DD/YYYY') })).then(function (response) {
        _this5.editing = false;
        _this5.loadingUpdate = false;
        _this5.oldStartTime = _this5.event.startTime;
        _this5.oldEndTime = _this5.event.endTime;
        _this5.$modal.hide('modalChangeTimeEvent');
        _this5.onChangeEvent(_this5.event);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    actionGetEventById: 'ACTION_GET_EVENT_BY_ID',
    actionGetTrackingStatus: 'ACTION_GET_TRACKING_STATUS',
    actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT',
    actionGetEventHistory: 'ACTION_GET_EVENT_DETAIL_HISTORY',
    generatePackingSlip: 'ACTION_GENERATE_PACKING_SLIP',
    updateAddOn: 'ACTION_UPDATE_EVENT_ADD_ON',
    createNewEventClick: 'ACTION_CREATE_NEW_EVENT',
    updateEventAction: 'ACTION_UPDATE_EVENT',
    updateNextZIndex: 'ACTION_UPDATE_NEXT_ZINDEX'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
    setIsLoading: 'MUTATION_SET_IS_LOADING'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    arrayDuration: function arrayDuration() {
      var range = [];
      for (var i = 1; i <= 24; i += 0.5) {
        range.push(i);
      }
      return range;
    },
    textErrorEndTime: function textErrorEndTime() {
      var beginningTime = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.event.startTime, 'h:mm A');
      var endTime = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.event.endTime, 'h:mm A');
      if (!beginningTime.isBefore(endTime)) {
        return 'The end time must be greater than the start time';
      }
      return null;
    },
    isReadOnly: function isReadOnly() {
      return this.event.status === 'ARCHIVED';
    },

    showAddSecondContactButton: function showAddSecondContactButton() {
      return this.event.contactName && !this.editing && !this.event.secondContactName;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    getIsLoadingModal: 'GETTER_IS_LOADING_MODAL',
    getEventForChangeOrderModal: 'GETTER_GET_EVENT_FOR_CHANGE_ORDER',
    googleMapApiKey: 'GETTERS_GOOGLE_API_KEY',
    getEventDetailHistory: 'GETTERS_GET_EVENT_DETAIL_HISTORY',
    getIsLoadingEventDetailHistory: 'GETTERS_GET_IS_LOADING_EVENT_DETAIL_HISTORY'
  }))
});

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedEventsModal_vue__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6623d6ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedEventsModal_vue__ = __webpack_require__(1669);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1664)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6623d6ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedEventsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6623d6ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedEventsModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/event/RelatedEventsModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RelatedEventsModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6623d6ec", Component.options)
  } else {
    hotAPI.reload("data-v-6623d6ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("61738c7a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6623d6ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RelatedEventsModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6623d6ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RelatedEventsModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.custom-modal[data-v-6623d6ec] {\n  background: rgba(0, 0, 0, 0.4);\n}\n.custom-modal .modal-padding[data-v-6623d6ec] {\n  padding-top: 24px;\n  min-height: 100vh;\n}\n.custom-modal .modal-close-img[data-v-6623d6ec] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.custom-modal .modal-close-img[data-v-6623d6ec]:hover {\n  cursor: pointer;\n}\n.custom-modal .modal-close-img .icon-close[data-v-6623d6ec] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n", ""]);

// exports


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_events_ManageRelatedEvents__ = __webpack_require__(823);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'relatedEventsModal',
  components: {
    ManageRelatedEvents: __WEBPACK_IMPORTED_MODULE_3__components_events_ManageRelatedEvents__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      relatedEvents: [],
      currentEvent: null,
      eventId: -1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.$modal.hide('relatedEventsModal');
    },
    beforeOpen: function beforeOpen(params) {
      this.currentEvent = params.params;
      this.eventId = this.currentEvent.id;
      this.relatedEvents = this.currentEvent.relatedEvents;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    addOrRemoveRelatedEvents: 'ACTION_ADD_REMOVE_RELATED_EVENTS'
  }))
});

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-client-body-modal',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      eventsAvailable: [],
      groupName: null,
      textSearch: '',
      isSearchLoading: false,
      disableBtnSave: false,
      cache: {
        relatedEvents: null,
        eventsAvailable: null,
        groupName: null
      }
    };
  },

  props: {
    relatedEvents: {
      type: Array,
      default: []
    },
    currentEvent: null,
    eventId: {
      type: Number,
      default: 0
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.resetData();
      this.$modal.hide('relatedEventsModal');
    },
    onSort: function onSort() {},
    onCancel: function onCancel() {
      this.resetData();
    },
    resetData: function resetData() {
      this.relatedEvents = this.cache.relatedEvents || this.relatedEvents;
      this.eventsAvailable = this.cache.eventsAvailable || this.eventsAvailable;
      this.groupName = this.cache.groupName || this.groupName;
    },
    cacheData: function cacheData() {
      this.cache.relatedEvents = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.relatedEvents);
      this.cache.eventsAvailable = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.eventsAvailable);
      this.cache.groupName = this.groupName;
    },
    clearCacheData: function clearCacheData() {
      this.cache.relatedEvents = null;
      this.cache.eventsAvailable = null;
      this.cache.groupName = null;
    },
    addEventRelated: function addEventRelated(event) {
      var index = this.eventsAvailable.indexOf(event);
      if (index >= 0) {
        this.cacheData();
        this.eventsAvailable[index].relatedStatus = true;
        this.relatedEvents.push(event);
      }
    },
    removeEventRelated: function removeEventRelated(event) {
      var index = this.relatedEvents.indexOf(event);
      if (index >= 0) {
        this.cacheData();
        this.relatedEvents.splice(index, 1);
        var ind = this.eventsAvailable.findIndex(function (element) {
          return element.id === event.id;
        });
        if (ind >= 0) {
          this.eventsAvailable[ind].relatedStatus = false;
        } else {
          event.relatedStatus = false;
          this.eventsAvailable.push(event);
        }
      }
    },
    saveRelatedEvents: function saveRelatedEvents() {
      var _this = this;

      this.disableBtnSave = true;
      var listRelatedEventIds = this.relatedEvents.map(function (e) {
        return e.id;
      });

      var params = {
        eventId: this.eventId,
        relatedEventsId: listRelatedEventIds,
        groupName: this.groupName
      };

      this.addOrRemoveRelatedEvents(params).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          var groupId;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  groupId = _this.currentEvent.eventGroupId || _this.currentEvent.id;
                  _context.next = 3;
                  return _this.$store.commit('MUTATION_SET_CURRENT_RELATED_EVENTS', _this.relatedEvents);

                case 3:
                  _context.next = 5;
                  return _this.$store.commit('MUTATION_UPDATE_EVENT_GROUP', {
                    groupId: groupId,
                    groupName: _this.groupName,
                    data: response.relatedEventDto
                  });

                case 5:

                  _this.$toastr('success', 'Save related events successful!', '');
                  _this.clearCacheData();
                  _this.disableBtnSave = false;

                case 8:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    searchRelatedEvents: 'ACTION_SEARCH_RELATED_EVENTS',
    addOrRemoveRelatedEvents: 'ACTION_ADD_REMOVE_RELATED_EVENTS'
  })),
  watch: {
    textSearch: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function (newValue, oldValue) {
      var _this2 = this;

      if (newValue === oldValue) return;
      this.searchRelatedEvents({ eventId: this.eventId, searchString: this.textSearch }).then(function (response) {
        _this2.eventsAvailable = response.eventShortList;
      });
    }, 500)
  },
  created: function created() {
    var _this3 = this;

    this.isSearchLoading = true;
    this.relatedEvents = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.relatedEvents);
    this.groupName = this.currentEvent.eventGroupName || this.currentEvent.eventName;

    this.searchRelatedEvents({ eventId: this.eventId, searchString: null }).then(function (response) {
      _this3.eventsAvailable = response.eventShortList;
      _this3.isSearchLoading = false;
    });
  }
});

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-manage-related-event-container" }, [
    _c("div", { staticClass: "choose-events-section" }, [
      _c("div", { staticClass: "section-title h4-text" }, [
        _vm._v("Find Events")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field-input-wrapper mt-2" }, [
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "b-input-group",
              [
                _c("b-form-input", {
                  staticClass: "placeholder-italic input-search-event",
                  class: { marginTop6px: _vm.fixElement },
                  attrs: {
                    type: "text",
                    placeholder: "Search for events",
                    formatter: _vm.format
                  },
                  model: {
                    value: _vm.textSearch,
                    callback: function($$v) {
                      _vm.textSearch = $$v
                    },
                    expression: "textSearch"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "search-icon" })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-events remove-margin-side margin-side" }, [
        _c("div", { staticClass: "list-header mb-3" }, [
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-30" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Shipping Address")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Onsite Contact")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _vm.isSearchLoading
          ? _c(
              "div",
              { staticClass: "list-loading d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Spinning" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSearchLoading
          ? _c(
              "div",
              _vm._l(_vm.eventsAvailable, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "list-container" },
                  [
                    _c("div", { staticClass: "list-content" }, [
                      _c("div", { staticClass: "column width-20" }, [
                        _c(
                          "div",
                          { staticClass: "container-column border-seperate" },
                          [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-20" }, [
                        _c(
                          "div",
                          { staticClass: "container-column border-seperate" },
                          [_c("p", [_vm._v(_vm._s(item.eventName))])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-30" }, [
                        _c(
                          "div",
                          { staticClass: "container-column border-seperate" },
                          [
                            _c("div", { staticClass: "text-icon" }, [
                              _c("p", [_vm._v(_vm._s(item.shippingAddress))])
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-20" }, [
                        _c("div", { staticClass: "container-column" }, [
                          _c("div", { staticClass: "text-icon" }, [
                            _c("p", [_vm._v(_vm._s(item.contactName))])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-10" }, [
                        _c("div", { staticClass: "container-column" }, [
                          item.relatedStatus
                            ? _c("div", { staticClass: "added" }, [
                                _vm._v("Added")
                              ])
                            : _c(
                                "div",
                                {
                                  staticClass: "icon-add-wrapper",
                                  on: {
                                    click: function($event) {
                                      _vm.addEventRelated(item)
                                    }
                                  }
                                },
                                [_c("div", { staticClass: "icon-add" })]
                              )
                        ])
                      ])
                    ])
                  ]
                )
              })
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "added-events-section" }, [
      _c("div", { staticClass: "section-title h4-text" }, [
        _vm._v("\n      Related Events\n      "),
        _vm.relatedEvents.length >= 0
          ? _c("span", { staticClass: "ml-1" }, [
              _vm._v("(" + _vm._s(_vm.relatedEvents.length + 1) + ")")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-title h5-text mt-3" }, [
        _vm._v("\n      Related Events Title\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field-input-wrapper mt-2" }, [
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "b-input-group",
              [
                _c("b-form-input", {
                  staticClass: "placeholder-italic input-search-event",
                  class: { marginTop6px: _vm.fixElement },
                  attrs: {
                    type: "text",
                    placeholder:
                      "Enter the title for your group of related events",
                    formatter: _vm.format
                  },
                  model: {
                    value: _vm.groupName,
                    callback: function($$v) {
                      _vm.groupName = $$v
                    },
                    expression: "groupName"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-events remove-margin-side margin-side" }, [
        _c("div", { staticClass: "list-header mb-3" }, [
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-30" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Shipping Address")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Onsite Contact")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(84),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            [
              _c("div", { staticClass: "list-container" }, [
                _c("div", { staticClass: "list-content" }, [
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(_vm.currentEvent.prefDate))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(_vm.currentEvent.eventName))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-30" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [
                        _c("p", [
                          _vm._v(_vm._s(_vm.currentEvent.shippingAddress))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c("div", { staticClass: "container-column" }, [
                      _c("p", [_vm._v(_vm._s(_vm.currentEvent.contactName))])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ])
            ],
            _vm._v(" "),
            _vm._l(_vm.relatedEvents, function(item, index) {
              return _c("div", { key: index, staticClass: "list-container" }, [
                _c("div", { staticClass: "list-content" }, [
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(item.eventName))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-30" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [
                        _c("div", { staticClass: "text-icon" }, [
                          _c("p", [_vm._v(_vm._s(item.shippingAddress))])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c("div", { staticClass: "container-column" }, [
                      _c("div", { staticClass: "text-icon" }, [
                        _c("p", [_vm._v(_vm._s(item.contactName))])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-10" }, [
                    _c("div", { staticClass: "container-column" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-close-wrapper",
                          on: {
                            click: function($event) {
                              _vm.removeEventRelated(item)
                            }
                          }
                        },
                        [_c("div", { staticClass: "icon-close" })]
                      )
                    ])
                  ])
                ])
              ])
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "group-btn" }, [
      _c(
        "button",
        {
          staticClass: "ap-btn primary",
          attrs: { disabled: _vm.disableBtnSave },
          on: { click: _vm.saveRelatedEvents }
        },
        [_vm._v("Save")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column width-10" }, [
      _c("div", { staticClass: "container-column" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column width-10" }, [
      _c("div", { staticClass: "container-column" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column width-10" }, [
      _c("div", { staticClass: "container-column" }, [
        _c("p", { staticClass: "selected-text" }, [_vm._v("Selected Event")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65072ff3", esExports)
  }
}

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "relatedEventsModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        "pivot-y": 0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "modal-padding" }, [
        _c(
          "div",
          { staticClass: "manage-related-events-container margin-side" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 page-title h2-text" }, [
                _vm._v("Manage Related Events")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 noPaddingRight align-right-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-close-img",
                      on: { click: _vm.hideModal }
                    },
                    [_c("div", { staticClass: "icon-close" })]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.eventId
              ? _c("ManageRelatedEvents", {
                  attrs: {
                    relatedEvents: _vm.relatedEvents,
                    currentEvent: _vm.currentEvent,
                    eventId: _vm.eventId
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6623d6ec", esExports)
  }
}

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeTimeEvent_vue__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6a0b9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeTimeEvent_vue__ = __webpack_require__(1672);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeTimeEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6a0b9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeTimeEvent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalChangeTimeEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalChangeTimeEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c6a0b9c", Component.options)
  } else {
    hotAPI.reload("data-v-0c6a0b9c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalChangeTimeEvent',
  props: {
    onUpdateEventAction: Function,
    loading: Boolean
  },
  methods: {
    onCancel: function onCancel() {
      this.$modal.hide('modalChangeTimeEvent');
    },
    onSubmit: function onSubmit() {
      this.onUpdateEventAction();
    }
  }
});

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-submit-drafts",
      attrs: {
        name: "modalChangeTimeEvent",
        width: "35%",
        height: "auto",
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "modal-header border-0 justify-content-end pb-0" },
        [
          _c(
            "div",
            {
              staticClass: "modal-close-img",
              on: {
                click: function($event) {
                  _vm.onCancel()
                },
                mouseover: function($event) {
                  _vm.isHoverClose = true
                },
                mouseleave: function($event) {
                  _vm.isHoverClose = false
                }
              }
            },
            [
              !_vm.isHoverClose
                ? _c("img", {
                    staticClass: "cursor-pointer",
                    attrs: {
                      src: __webpack_require__(136),
                      alt: "close"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isHoverClose
                ? _c("img", {
                    staticClass: "cursor-pointer",
                    attrs: {
                      src: __webpack_require__(137),
                      alt: "close"
                    }
                  })
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("p", { staticClass: "text-question" }, [
          _vm._v(
            "Are you sure you want to change event start/end time? All scheduled appointments within this event will be canceled."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-description" }, [
          _c("b", [_vm._v("Members will receive a cancellation email.")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-submit",
                attrs: { disabled: _vm.loading },
                on: { click: _vm.onSubmit }
              },
              [
                _vm.loading ? _c("b-spinner") : _vm._e(),
                _vm._v("\n        Submit\n      ")
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c6a0b9c", esExports)
  }
}

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "custom-modal",
          attrs: {
            name: "eventDetailModal",
            id: "eventDetailModal",
            width: "75%",
            height: "auto",
            scrollable: true,
            pivotX: 1.0,
            minWidth: 900,
            minHeight: 900,
            clickToClose: true
          },
          on: {
            "before-open": _vm.beforeOpen,
            "before-close": _vm.beforeClose,
            opened: _vm.opened
          }
        },
        [
          _c(
            "div",
            { staticClass: "detail-modal", on: { click: _vm.onSave } },
            [
              _c(
                "div",
                {
                  staticClass: "overlay",
                  class: {
                    isLoading: _vm.getIsLoadingModal,
                    noDisplay: !_vm.getIsLoadingModal
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "spinner-align" },
                    [
                      _c("Icon", {
                        staticClass: "icon-size",
                        attrs: { name: "spinner", scale: "5", pulse: "" }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.getIsLoadingModal
                ? _c("div", { staticClass: "modal-padding" }, [
                    _c("div", { staticClass: "event-detail-header row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-6 noPaddingLeft d-flex" },
                        [
                          _c(
                            "span",
                            { staticClass: "event-details text-nowrap" },
                            [_vm._v(_vm._s(_vm.event.eventName))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "add-on-wrapper ml-5" }, [
                            _c("div", { staticClass: "event-add-on" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.event.isLive,
                                    expression: "event.isLive"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled: _vm.isReadOnly,
                                  id: "is-live"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.event.isLive)
                                    ? _vm._i(_vm.event.isLive, null) > -1
                                    : _vm.event.isLive
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.event.isLive,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.event,
                                              "isLive",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.event,
                                              "isLive",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.event, "isLive", $$c)
                                      }
                                    },
                                    function($event) {
                                      _vm.updateIsLiveEvent("LIVE")
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "is-live" } }, [
                                _vm._v("Toggle")
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                class: { "online-text": _vm.event.isLive }
                              },
                              [_vm._v("Live")]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 noPaddingRight align-right-item"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "modal-close-img",
                              on: { click: _vm.hideModal }
                            },
                            [_c("div", { staticClass: "icon-close" })]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-24px" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 event-information noPaddingLeft"
                          },
                          [
                            _vm._v(
                              "\n            Event information\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 event-information noPaddingRight align-right-item"
                          },
                          [
                            _c("div", { staticClass: "staffing-edit-btn" }, [
                              _vm.editing
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "ap-btn secondary btn-save",
                                      attrs: { disabled: _vm.loadingUpdate },
                                      on: { click: _vm.onSave }
                                    },
                                    [
                                      _vm.loadingUpdate
                                        ? _c("b-spinner")
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                Save\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "ap-btn secondary",
                                      attrs: { disabled: _vm.isReadOnly },
                                      on: { click: _vm.onEdit }
                                    },
                                    [_vm._v("Edit")]
                                  )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Event Name")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.eventName,
                                      expression: "event.eventName"
                                    }
                                  ],
                                  domProps: { value: _vm.event.eventName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "eventName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.eventName))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Date")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            [
                              _vm.editing
                                ? _c("date-picker", {
                                    attrs: { format: "MMMM d, yyyy" },
                                    model: {
                                      value: _vm.event.prefDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.event, "prefDate", $$v)
                                      },
                                      expression: "event.prefDate"
                                    }
                                  })
                                : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormatMMMM")(
                                          _vm.event.prefDate
                                        )
                                      )
                                    )
                                  ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Client")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm._v(_vm._s(_vm.event.clientName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Custom Event Notes")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.customEventNote,
                                      expression: "event.customEventNote"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.customEventNote
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "customEventNote",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.customEventNote))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Address")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            [
                              _vm.editing
                                ? _c("vue-google-autocomplete", {
                                    attrs: {
                                      name: "address-input",
                                      id: "map_address",
                                      classname: _vm.form - _vm.control,
                                      placeholder: "Address",
                                      country: ["us"],
                                      item: _vm.event
                                    },
                                    on: { placechanged: _vm.setPlace }
                                  })
                                : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                    _vm._v(_vm._s(_vm.event.fullAddress))
                                  ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Time and Duration")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info show-dropdown" },
                            [
                              _c("table", [
                                _c("tr", [
                                  _c("td", [_vm._v("Start: ")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editing
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.event.startTime,
                                                expression: "event.startTime"
                                              }
                                            ],
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.event,
                                                    "startTime",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                _vm.onChangeStartTime
                                              ]
                                            }
                                          },
                                          _vm._l(_vm.listTime, function(time) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: time.name }
                                              },
                                              [_vm._v(_vm._s(time.name))]
                                            )
                                          })
                                        )
                                      : _c(
                                          "span",
                                          { on: { dblclick: _vm.onEdit } },
                                          [_vm._v(_vm._s(_vm.event.startTime))]
                                        )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [_vm._v("End: ")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editing
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.event.endTime,
                                                expression: "event.endTime"
                                              }
                                            ],
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.event,
                                                    "endTime",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                _vm.onChangeEndTime
                                              ]
                                            }
                                          },
                                          _vm._l(_vm.listTime, function(time) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: time.name }
                                              },
                                              [_vm._v(_vm._s(time.name))]
                                            )
                                          })
                                        )
                                      : _c(
                                          "span",
                                          { on: { dblclick: _vm.onEdit } },
                                          [_vm._v(_vm._s(_vm.event.endTime))]
                                        )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [_vm._v("Duration: ")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.editing
                                        ? [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.event.duration,
                                                    expression: "event.duration"
                                                  }
                                                ],
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        _vm.event,
                                                        "duration",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    _vm.onChangeDuration
                                                  ]
                                                }
                                              },
                                              _vm._l(
                                                _vm.arrayDuration,
                                                function(n) {
                                                  return _c(
                                                    "option",
                                                    { domProps: { value: n } },
                                                    [_vm._v(_vm._s(n))]
                                                  )
                                                }
                                              )
                                            )
                                          ]
                                        : _c(
                                            "span",
                                            { on: { dblclick: _vm.onEdit } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.event.duration) +
                                                  " HR"
                                              )
                                            ]
                                          )
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [_vm._v("Time zone: ")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.event.timeZone) +
                                        "\n                  "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.textErrorEndTime
                                ? _c("p", { staticClass: "textError" }, [
                                    _vm._v(_vm._s(_vm.textErrorEndTime))
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Program")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm._v(_vm._s(_vm.event.programName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("On Site Instructions")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.onsiteInstruction,
                                      expression: "event.onsiteInstruction"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.onsiteInstruction
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "onsiteInstruction",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.onsiteInstruction))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Building/Suite")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.building,
                                      expression: "event.building"
                                    }
                                  ],
                                  domProps: { value: _vm.event.building },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "building",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.building))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("ADURO Arrival Time")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.event.aduroArrivalTime,
                                        expression: "event.aduroArrivalTime"
                                      }
                                    ],
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.event,
                                          "aduroArrivalTime",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(_vm.listTime, function(time) {
                                    return _c(
                                      "option",
                                      { domProps: { value: time.name } },
                                      [_vm._v(_vm._s(time.name))]
                                    )
                                  })
                                )
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.aduroArrivalTime))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("On Site Contact")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            [
                              _vm.editing
                                ? [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.contactName,
                                          expression: "event.contactName"
                                        }
                                      ],
                                      staticClass: "mb-1",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Contact Name"
                                      },
                                      domProps: {
                                        value: _vm.event.contactName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.event,
                                            "contactName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.email,
                                          expression: "event.email"
                                        }
                                      ],
                                      staticClass: "mb-1",
                                      attrs: {
                                        type: "email",
                                        placeholder: "Contact Email"
                                      },
                                      domProps: { value: _vm.event.email },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.event,
                                            "email",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.phone,
                                          expression: "event.phone"
                                        }
                                      ],
                                      staticClass: "mb-1",
                                      attrs: {
                                        type: "tel",
                                        placeholder: "Contact Phone"
                                      },
                                      domProps: { value: _vm.event.phone },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.event,
                                            "phone",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("br")
                                  ]
                                : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.event.contactName) +
                                        "\n            "
                                    )
                                  ])
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Parking Instructions")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.parkingInformation,
                                      expression: "event.parkingInformation"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.parkingInformation
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "parkingInformation",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.parkingInformation))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Location")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.eventLocation,
                                      expression: "event.eventLocation"
                                    }
                                  ],
                                  domProps: { value: _vm.event.eventLocation },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "eventLocation",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.eventLocation))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Total Participants")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.projPart,
                                      expression: "event.projPart"
                                    }
                                  ],
                                  domProps: { value: _vm.event.projPart },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "projPart",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.projPart))
                                ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "event-title margin-top-16px" },
                            [_vm._v("Participation")]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _c("div", { staticClass: "oval oval-red" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.event.numParticipant) +
                                  "/" +
                                  _vm._s(_vm.event.projPart) +
                                  " participants"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Add-ons")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            _vm._l(_vm.addOns.slice(0, 7), function(
                              item,
                              index
                            ) {
                              return item.isShow
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "add-on-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "event-add-on mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.value,
                                                expression: "item.value"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              disabled: _vm.isReadOnly,
                                              id: item.key
                                            },
                                            domProps: {
                                              checked: Array.isArray(item.value)
                                                ? _vm._i(item.value, null) > -1
                                                : item.value
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = item.value,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(item, "value", $$c)
                                                  }
                                                },
                                                function($event) {
                                                  _vm.checkboxToggle(item)
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: item.key } },
                                            [_vm._v("Toggle")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text" }, [
                                        _vm._v(_vm._s(item.text))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            })
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "event-info" },
                            _vm._l(_vm.addOns.slice(7, 10), function(
                              item,
                              index
                            ) {
                              return item.isShow
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "add-on-wrapper"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "event-add-on mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.value,
                                                expression: "item.value"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              disabled: _vm.isReadOnly,
                                              id: item.key
                                            },
                                            domProps: {
                                              checked: Array.isArray(item.value)
                                                ? _vm._i(item.value, null) > -1
                                                : item.value
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = item.value,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(item, "value", $$c)
                                                  }
                                                },
                                                function($event) {
                                                  _vm.checkboxToggle(item)
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: item.key } },
                                            [_vm._v("Toggle")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text" }, [
                                        _vm._v(_vm._s(item.text))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            })
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingLeft"
                        },
                        [_vm._v("\n            On Site Contacts\n          ")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.event.contactName
                      ? _c("div", { staticClass: "event-detail-body row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-4 margin-top-16px" },
                            [
                              _c("div", { staticClass: "wrapper-text" }, [
                                _c("div", { staticClass: "event-info" }, [
                                  _vm._v(_vm._s(_vm.event.contactName))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "event-info" }, [
                                  _vm._v(_vm._s(_vm.event.email))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "event-info" }, [
                                  _vm._v(_vm._s(_vm.event.phone))
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4 margin-top-16px" },
                            [
                              _vm.showAddSecondContactButton
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "paddingTop27px" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-add-second-contact",
                                            attrs: {
                                              title:
                                                "Add secondary on site contacts"
                                            },
                                            on: { click: _vm.onEdit }
                                          },
                                          [_vm._v("+")]
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _vm.editing
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "event-info" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.event
                                                        .secondContactName,
                                                    expression:
                                                      "event.secondContactName"
                                                  }
                                                ],
                                                staticClass: "mb-1",
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    "Enter Secondary On Site Contact's Name"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.event.secondContactName
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.event,
                                                      "secondContactName",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.event.secondEmail,
                                                    expression:
                                                      "event.secondEmail"
                                                  }
                                                ],
                                                staticClass: "mb-1",
                                                attrs: {
                                                  type: "email",
                                                  placeholder:
                                                    "Enter Secondary On Site Contact's Email"
                                                },
                                                domProps: {
                                                  value: _vm.event.secondEmail
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.event,
                                                      "secondEmail",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.event.secondPhone,
                                                    expression:
                                                      "event.secondPhone"
                                                  }
                                                ],
                                                staticClass: "mb-1",
                                                attrs: {
                                                  type: "tel",
                                                  placeholder:
                                                    "Enter Secondary On Site Contact's Phone"
                                                },
                                                domProps: {
                                                  value: _vm.event.secondPhone
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.event,
                                                      "secondPhone",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("br")
                                            ]
                                          )
                                        ]
                                      : _c(
                                          "div",
                                          { staticClass: "wrapper-text" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "event-info",
                                                on: { dblclick: _vm.onEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.event.secondContactName
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "event-info",
                                                on: { dblclick: _vm.onEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.event.secondEmail)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "event-info",
                                                on: { dblclick: _vm.onEdit }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.event.secondPhone)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                  ]
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingLeft"
                        },
                        [
                          _c("span", [_vm._v("Email")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "view-history-text",
                              on: { click: _vm.onViewMailHistory }
                            },
                            [_vm._v("View History")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                        },
                        [
                          _c("div", { staticClass: "staffing-edit-btn" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ap-btn secondary",
                                attrs: { disabled: _vm.isReadOnly },
                                on: { click: _vm.onManageEmail }
                              },
                              [_vm._v("Email Client")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-12 email-text noPaddingLeft" },
                          [
                            _vm._v(
                              "\n            Last Email Sent: " +
                                _vm._s(
                                  _vm._f("templateName")(
                                    _vm.event.emailReminderStatus
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-9 event-information noPaddingLeft"
                        },
                        [
                          _vm._v(
                            "\n            Staff & Slot Management\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-3 noPaddingRight noPaddingLeft align-right-item"
                        },
                        [
                          _c("div", { staticClass: "staffing-edit-btn" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ap-btn secondary",
                                attrs: { disabled: _vm.isReadOnly },
                                on: { click: _vm.onManageEventStaffingDetail }
                              },
                              [_vm._v("Manage")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-12 noPaddingLeft" }, [
                          _c(
                            "div",
                            {
                              staticClass: "wrapper-text-number display-inline"
                            },
                            [
                              _c("div", { staticClass: "oval oval-red" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "number" }, [
                                _vm._v(
                                  _vm._s(_vm.event.numStaffLead) +
                                    "/" +
                                    _vm._s(_vm.event.maxStaffLead) +
                                    " Leads"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "wrapper-text-number display-inline"
                            },
                            [
                              _c("div", {
                                staticClass: "oval oval-red margin-left-8px"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "number" }, [
                                _vm._v(
                                  _vm._s(_vm.event.numStaffConcierge) +
                                    "/" +
                                    _vm._s(_vm.event.maxStaffConcierge) +
                                    " Phlebotomists"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "wrapper-text-number display-inline"
                            },
                            [
                              _c("div", {
                                staticClass: "oval oval-red margin-left-8px"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "number" }, [
                                _vm._v(
                                  _vm._s(_vm.event.numStaffScreener) +
                                    "/" +
                                    _vm._s(_vm.event.maxStaffScreener) +
                                    " Screeners"
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingLeft"
                        },
                        [_vm._v("\n            Shipping\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-6 event-information noPaddingRight noPaddingLeft align-right-item"
                        },
                        [
                          _c("div", { staticClass: "staffing-edit-btn" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ap-btn secondary",
                                attrs: { disabled: _vm.isReadOnly },
                                on: {
                                  click: function($event) {
                                    _vm.generatePackingSlipBtn()
                                  }
                                }
                              },
                              [_vm._v("Generate Packing Slip")]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-detail-body row margin-top-16px" },
                      [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Address")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.shippingAddress,
                                      expression: "event.shippingAddress"
                                    }
                                  ],
                                  domProps: {
                                    value: _vm.event.shippingAddress
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "shippingAddress",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.shippingAddress))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Supplies Tracking")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "supplies-tracking-status margin-bottom-10px"
                            },
                            [
                              _c("div", {
                                staticClass: "oval",
                                class:
                                  _vm.shippingStatus !== ""
                                    ? "oval-green"
                                    : "oval-red"
                              }),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(
                                  _vm._s(
                                    _vm.event.trackingNumber !== ""
                                      ? _vm.shippingStatus !== ""
                                        ? _vm.shippingStatus
                                        : "Shipping info not entered"
                                      : "Shipping info not entered"
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Tracking Number")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.trackingNumber,
                                      expression: "event.trackingNumber"
                                    }
                                  ],
                                  domProps: { value: _vm.event.trackingNumber },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "trackingNumber",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.trackingNumber))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("span", { staticClass: "event-title" }, [
                            _vm._v("Shipping Note")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-info" }, [
                            _vm.editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.shippingNote,
                                      expression: "event.shippingNote"
                                    }
                                  ],
                                  domProps: { value: _vm.event.shippingNote },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.event,
                                        "shippingNote",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("span", { on: { dblclick: _vm.onEdit } }, [
                                  _vm._v(_vm._s(_vm.event.shippingNote))
                                ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-detail-body row" }, [
                      _c("div", { staticClass: "col-md-12 liner" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "series-related-events-section" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "related-events-top event-detail-body row"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 event-information noPaddingLeft"
                              },
                              [
                                _vm._v(
                                  "\n              Related Events\n              "
                                ),
                                !_vm.event.relatedEvents.length
                                  ? _c("span", [_vm._v("(0)")])
                                  : _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.event.relatedEvents.length + 1
                                          ) +
                                          ")"
                                      )
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "staffing-edit-btn" },
                                  [
                                    !_vm.event.relatedEvents.length
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-add-related ap-btn secondary",
                                            on: {
                                              click: _vm.onManageRelatedEvent
                                            }
                                          },
                                          [_vm._v("Create Related Events")]
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-add-related ap-btn secondary",
                                            attrs: { disabled: _vm.isReadOnly },
                                            on: {
                                              click: _vm.onManageRelatedEvent
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Manage Related Events\n                "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "related-event-container event-detail-body row"
                          },
                          [
                            _vm.event.relatedEvents.length > 0
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 margin-top-16px" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "related-event-item main-event"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "event-name",
                                              on: {
                                                click: function($event) {
                                                  _vm.relatedEventItemClick(
                                                    _vm.event.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.event.eventName)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.event.relatedEvents, function(reEvent) {
                              return _c(
                                "div",
                                { staticClass: "col-md-3 margin-top-16px" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "related-event-item" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "event-name",
                                          on: {
                                            click: function($event) {
                                              _vm.relatedEventItemClick(
                                                reEvent.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(reEvent.eventName))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.event.status !== "DRAFTS"
                      ? _c("div", [
                          _c("div", { staticClass: "event-detail-body row" }, [
                            _c("div", { staticClass: "col-md-12 liner" })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "event-detail-body row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 event-information noPaddingLeft"
                              },
                              [
                                _vm._v(
                                  "\n              Change History (" +
                                    _vm._s(_vm.getEventDetailHistory.length) +
                                    ")\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "event-detail-body row margin-top-16px"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "history-table-container" },
                                [
                                  _vm.getIsLoadingEventDetailHistory
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "list-loading d-flex justify-content-center"
                                        },
                                        [
                                          _c("b-spinner", {
                                            attrs: {
                                              variant: "primary",
                                              label: "Spinning"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _vm.getEventDetailHistory.length > 0
                                            ? _c("b-table", {
                                                attrs: {
                                                  fields:
                                                    _vm.changeHistoryTableFields,
                                                  "no-border-collapse": "",
                                                  bordered: "",
                                                  hover: "",
                                                  "head-variant": "light",
                                                  items:
                                                    _vm.getEventDetailHistory
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "cell(fieldName)",
                                                    fn: function(row) {
                                                      return [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              row.item.fieldName
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-center"
                                                },
                                                [_vm._v("No history found.")]
                                              )
                                        ],
                                        1
                                      )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("RelatedEventsModal"),
      _vm._v(" "),
      _c("ModalChangeToggleVaccines", {
        attrs: {
          onCheckToggleOnOff: _vm.onCheckToggleOnOff,
          loadingCovidSelect: _vm.loadingCovidSelect,
          addOns: _vm.addOns,
          nameModal: _vm.nameModalRemmoved,
          textQuestion: _vm.textQuestionToggleRemoved,
          textDescription: _vm.textDescriptionToggleRemoved
        }
      }),
      _vm._v(" "),
      _c("ModalChangeToggleVaccines", {
        attrs: {
          onCheckToggleOnOff: _vm.onCheckToggleOnOff,
          loadingCovidSelect: _vm.loadingCovidSelect,
          addOns: _vm.addOns,
          nameModal: _vm.nameModalSwitch,
          textQuestion: _vm.textQuestionToggleSwitch,
          textDescription: _vm.newTextDescriptionToggleSwitch
        }
      }),
      _vm._v(" "),
      _c("ModalChangeTimeEvent", {
        attrs: {
          onUpdateEventAction: _vm.onUpdateEventAction,
          loading: _vm.loadingUpdate
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43cb2843", esExports)
  }
}

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a08af760", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eb29f698\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManageEmail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eb29f698\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManageEmail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_events_ClientContactEmail__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_ModalInfo__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_constants_emailTemplateType__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client-Manage-Email-Page',
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a,
    ClientContactEmail: __WEBPACK_IMPORTED_MODULE_2__components_events_ClientContactEmail__["a" /* default */],
    ModalInfo: __WEBPACK_IMPORTED_MODULE_3__components_modal_ModalInfo__["a" /* default */]
  },
  data: function data() {
    return {
      emailType: {
        value: ['0', '0'],
        width: '182px',
        tooltip: false,
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        dotSize: 8,
        interval: 7,
        formatter: '{value}',
        overlapFormatter: '{value1} ~ {value2}',
        data: ['0', '7', '30', '60'],
        piecewiseStyle: {
          backgroundColor: 'transparent',
          visibility: 'visible',
          width: '15px',
          height: '15px'
        },
        piecewiseActiveStyle: {
          backgroundColor: '#00A4D6'
        },
        processStyle: {
          backgroundColor: '#00A4D6'
        }
      },
      eventId: null,
      event: {
        relatedEvents: []
      },
      emailTemplateType: __WEBPACK_IMPORTED_MODULE_5__store_constants_emailTemplateType__["a" /* default */].day60,
      singleEvent: true,
      listEmailSendTo: [],
      listEmailCC: [],
      replyEmail: '',
      body: '',
      isManageDetails: false,
      isChange: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    beforeOpen: function beforeOpen(params) {
      var _this = this;

      if (params.params && params.params.eventId) {
        this.eventId = params.params.eventId;
        this.isManageDetails = params.params.isManageDetails;
        this.getEventById(params.params.eventId).then(function (response) {
          if (response.message === null) {
            _this.event = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.event, { relatedEvents: response.event.relatedEvents.filter(function (x) {
                return x.status.toLowerCase() !== __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].eventStatus.archived;
              }) });
          }
        });
      }
      this.$bus.$on('changeEditor', this.changeIsEditor);
    },
    beforeClose: function beforeClose() {
      this.eventId = null;
      this.event = { relatedEvents: [] };
      this.emailTemplateType = __WEBPACK_IMPORTED_MODULE_5__store_constants_emailTemplateType__["a" /* default */].day60;
      this.replyEmail = '';
      this.listEmailSendTo = [];
      this.listEmailCC = [];
    },
    opened: function opened() {
      this.updateNextZIndex('manageEmailModal');
    },
    changeIsEditor: function changeIsEditor() {
      this.isChange = true;
    },
    closeModalCancelEmail: function closeModalCancelEmail(isCancelEmail) {
      if (isCancelEmail) {
        this.backToPreviousPage();
      }
    },
    backToPreviousPage: function backToPreviousPage() {
      if (this.isManageDetails) {
        this.$modal.hide('manageEmailModal');
        return;
      }
      this.$router.push({ name: 'ManageApprovedDashboard', params: { eventId: this.eventId, textSearch: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.searchEventString), filter: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.filterEventString), sort: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.sortEventString), dateSliderValue: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.dateRangeEvent) } });
    },
    cancelClick: function cancelClick() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].modalAction.modalCancelEmail,
        data: null
      };
      if (this.isChange) {
        this.$modal.show('modalInfo', modalData);
      } else {
        if (this.isManageDetails) {
          this.$modal.hide('manageEmailModal');
          return;
        }
        this.$router.push({ name: 'ManageApprovedDashboard', params: { eventId: this.eventId, textSearch: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.searchEventString), filter: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.filterEventString), sort: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.sortEventString), dateSliderValue: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.dateRangeEvent) } });
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    getEventById: 'ACTION_GET_EVENT_BY_ID',
    getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
    updateNextZIndex: 'ACTION_UPDATE_NEXT_ZINDEX'
  })),
  mounted: function mounted() {}
});

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientContactEmail_vue__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e811757a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientContactEmail_vue__ = __webpack_require__(1682);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientContactEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e811757a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientContactEmail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/events/ClientContactEmail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClientContactEmail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e811757a", Component.options)
  } else {
    hotAPI.reload("data-v-e811757a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_ckeditor2__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_ModalChangeEmailTemplate__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_array_helper__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_izi_toast__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'client-contact-email-body',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    PrettyRadio: __WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio___default.a,
    VueCkeditor: __WEBPACK_IMPORTED_MODULE_5_vue_ckeditor2__["a" /* default */],
    ModalChangeEmailTemplate: __WEBPACK_IMPORTED_MODULE_6__components_modal_ModalChangeEmailTemplate__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_12_vue_multiselect___default.a
  },
  data: function data() {
    return {
      reg: new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'),
      listEmailCC: [],
      listEmailSendTo: [],
      listReplyEmails: '',
      listHistory: [],
      replyEmail: '',
      ccEmail: '',
      recipientEmail: '',
      selectedTemplate: __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60,
      emailTemplates: [],
      emailTemplateConsts: __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */],
      body: '',
      isSingleEvent: true,
      config: {
        toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'links', items: ['Link', 'Unlink'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'insert', items: ['Image', 'Table'] }, { name: 'tools', items: ['Maximize'] }, { name: 'editing', items: ['Scayt'] }, { name: 'document', items: ['Source'] }],
        height: 220,
        allowedContent: true
      },
      isChangedEditor: false,
      selectedTemplateOldValue: __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60,
      sortReverse: false,
      emailTemplate: {
        body: '',
        emailSubject: '',
        templateType: ''
      },
      isSendLoading: false
    };
  },

  computed: {},
  filters: {},
  props: {
    event: {
      type: Object,
      default: {}
    },
    eventId: {
      type: Number
    },
    isChange: {
      type: Boolean
    },
    cancelClick: {
      type: Function
    },
    backToPreviousPage: {
      type: Function
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setSortOption: function setSortOption(field) {
      this.sortReverse = !this.sortReverse;
      this.listHistory.sort(__WEBPACK_IMPORTED_MODULE_9__utils_array_helper__["a" /* default */].sortFunction(field, this.sortReverse));
    },
    closeModalChangeMailTemplate: function closeModalChangeMailTemplate(changeTemplate) {
      if (changeTemplate) {
        this.setSelectedTemplate();
        this.isChangedEditor = false;
      } else {
        this.selectedTemplate = this.selectedTemplateOldValue;
      }
    },
    relatedEventItemClick: function relatedEventItemClick(eventId) {
      this.$modal.hide('eventDetailModal');
      this.$modal.show('eventDetailModal', { eventId: eventId });
      this.updateNextZIndex('eventDetailModal');
    },
    addReplyEmailGoTo: function addReplyEmailGoTo() {
      if (this.replyEmail === '' || !this.isValidEmail(this.replyEmail)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].prototype.$toast.success('Invalid email', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__utils_izi_toast__["a" /* default */].optError));
        return;
      }
      this.listReplyEmails = this.replyEmail;
      this.replyEmail = '';
    },
    addRecipientTo: function addRecipientTo() {
      if (this.recipientEmail === '' || !this.isValidEmail(this.recipientEmail)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].prototype.$toast.success('Invalid email', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__utils_izi_toast__["a" /* default */].optError));
        return;
      }
      var index = this.listEmailSendTo.indexOf(this.recipientEmail);
      if (index < 0) {
        // verify valid email
        this.listEmailSendTo.push(this.recipientEmail);
        this.recipientEmail = '';
      } else {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].prototype.$toast.success('The email already exist', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__utils_izi_toast__["a" /* default */].optError));
      }
    },
    addRecipientCC: function addRecipientCC() {
      if (this.ccEmail === '' || !this.isValidEmail(this.ccEmail)) {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].prototype.$toast.success('Invalid email', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__utils_izi_toast__["a" /* default */].optError));
        return;
      }
      var index = this.listEmailCC.indexOf(this.ccEmail);
      if (index < 0) {
        this.listEmailCC.push(this.ccEmail);
        this.ccEmail = '';
      } else {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].prototype.$toast.success('The email already exist', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__utils_izi_toast__["a" /* default */].optError));
      }
    },
    ckEditorFocus: function ckEditorFocus(e) {
      this.isChangedEditor = true;
      this.$bus.$emit('changeEditor');
    },
    getEmailTemplate: function getEmailTemplate(isSingleEvent, isDefault) {
      var _this = this;

      this.getDefaultEmailTemplate({
        eventId: this.eventId || this.$route.params.eventId,
        isSingleEvent: isSingleEvent
      }).then(function (response) {
        _this.emailTemplates = response.templates;
        _this.emailTemplate = _this.emailTemplates[0];
        if (isDefault) {
          _this.selectedTemplate = __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60;
        }
        _this.setSelectedTemplate(isSingleEvent, false);
      });
    },
    setSelectedTemplate: function setSelectedTemplate() {
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60) {
        this.body = this.emailTemplates[0].body;
      }
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day30) {
        this.body = this.emailTemplates[1].body;
      }
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day7) {
        this.body = this.emailTemplates[2].body;
      }
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].thankyou) {
        this.body = this.emailTemplates[3].body;
      }
      this.selectedTemplateOldValue = this.selectedTemplate;
    },
    removeRecipientReply: function removeRecipientReply(email) {
      var index = this.listReplyEmails.indexOf(email);
      if (index >= 0) {
        this.listReplyEmails = '';
      }
    },
    removeRecipient: function removeRecipient(email) {
      var index = this.listEmailSendTo.indexOf(email);
      if (index >= 0) {
        this.listEmailSendTo.splice(index, 1);
      }
    },
    removeRecipientCC: function removeRecipientCC(email) {
      var index = this.listEmailCC.indexOf(email);
      if (index >= 0) {
        this.listEmailCC.splice(index, 1);
      }
    },
    goToEmailHistoryDetails: function goToEmailHistoryDetails(id) {
      // GO to email detail
      this.$router.push({ name: 'EmailHistoryDetailsManagement',
        params: {
          id: id,
          eventId: this.eventId
        }
      });
    },
    isValidEmail: function isValidEmail(email) {
      return email && email.length && this.reg.test(String(email).toLowerCase());
    },
    viewAllMailHistories: function viewAllMailHistories() {
      this.$router.push({ name: 'EmailHistoriesManagement', params: { eventId: this.eventId } });
    },
    onCancel: function onCancel() {
      this.cancelClick();
    },
    onSelectEmailTemplate: function onSelectEmailTemplate(item) {
      this.emailTemplate = item;
    },
    addEmailToList: function addEmailToList(email, list) {
      if (this.isValidEmail(email) && list.indexOf(email) < 0) {
        list.push(email);
      }
    },
    addEventEmailsToList: function addEventEmailsToList(event, list) {
      this.addEmailToList(event.email, list);
      this.addEmailToList(event.secondEmail, list);
    },
    sendEmailClick: function sendEmailClick() {
      var _this2 = this;

      this.isSendLoading = true;
      var params = {
        eventId: this.eventId,
        isSingleEvent: this.isSingleEvent,
        recipients: this.listEmailSendTo,
        additionalRecipients: this.listEmailCC,
        replyTo: this.listReplyEmails,
        emailTemplateType: this.emailTemplate.templateType,
        emailSubject: this.emailTemplate.emailSubject,
        body: this.emailTemplate.body
      };
      this.sendOnSiteContactEmail(params).then(function (response) {
        _this2.isSendLoading = false;
        _this2.$toast.success('Email sent successfully!', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optSuccess, {
          onClosed: _this2.backToPreviousPage
        }));
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
    sendOnSiteContactEmail: 'ACTION_SEND_ON_SITE_CONTACT_EMAIL',
    updateNextZIndex: 'ACTION_UPDATE_NEXT_ZINDEX'
  })),
  watch: {
    isSingleEvent: function isSingleEvent(oldVal, newVal) {
      var _this3 = this;

      this.listEmailSendTo = [];
      this.addEventEmailsToList(this.event, this.listEmailSendTo);

      if (!this.isSingleEvent) {
        this.event.relatedEvents.forEach(function (element) {
          _this3.addEventEmailsToList(element, _this3.listEmailSendTo);
        });
      }
      this.getEmailTemplate(this.isSingleEvent, false);
    },
    'event.id': function eventId() {
      var _this4 = this;

      this.event.relatedEvents.unshift(this.event);
      if (this.isSingleEvent) {
        this.listEmailSendTo = [];
        this.addEventEmailsToList(this.event, this.listEmailSendTo);
      } else {
        this.event.relatedEvents.forEach(function (element) {
          _this4.addEventEmailsToList(element, _this4.listEmailSendTo);
        });
      }

      if (this.event.emailHistories) {
        this.event.emailHistories.forEach(function (element) {
          _this4.listHistory.push({
            id: element.id,
            time: element.lastModifiedAt,
            template: element.templateType
          });
        });
      }
    },
    selectedTemplate: function selectedTemplate(newVal, oldVal) {
      if (this.selectedTemplate === this.selectedTemplateOldValue && this.isChangedEditor) {
        return;
      }
      this.selectedTemplateOldValue = oldVal;
      if (!this.isChangedEditor) {
        this.setSelectedTemplate();
        return;
      }
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].modalAction.modalAlertChangeEmailTemplate,
        data: null
      };
      this.$modal.show('modalChangeEmailTemplate', modalData);
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmailTemplate(true, true);
  }
});

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeEmailTemplate_vue__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638f3405_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeEmailTemplate_vue__ = __webpack_require__(1681);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalChangeEmailTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638f3405_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalChangeEmailTemplate_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalChangeEmailTemplate.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalChangeEmailTemplate.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-638f3405", Component.options)
  } else {
    hotAPI.reload("data-v-638f3405", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {},
  data: function data() {
    return {
      actionTypes: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalAction,
      modalData: {},
      actionData: {},
      isCancel: false,
      modalBodies: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].modalBodies
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.$emit('CLOSE_MODAL_CHANGE_TEMPLATE_ACTION', false);
      this.$modal.hide('modalChangeEmailTemplate');
    },
    beforeOpen: function beforeOpen(event) {
      this.modalData = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    btnAction: function btnAction() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$modal.hide('modalChangeEmailTemplate');
                _this.$emit('CLOSE_MODAL_CHANGE_TEMPLATE_ACTION', true);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({}), {
    beforeClose: function beforeClose() {}
  }),
  computed: {}
});

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "common-card modal-change-email-template",
      class: {},
      attrs: { name: "modalChangeEmailTemplate", height: "auto", width: 600 },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-close-img",
          on: {
            click: function($event) {
              _vm.hideModal()
            }
          }
        },
        [_c("div", { staticClass: "icon-close" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text h1-text" }, [
          _c("span", [_vm._v("CHANGE TEMPLATE")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body body-text" }, [
        _vm._v(
          "\n    Changing your email template will erase any changs you have made. Are you sure you want to change your email template?\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer group-btn" },
        [
          _vm.modalData.btnLeft != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-left ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.hideModal()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnLeft) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.btnRight != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-right ap-btn primary",
                  on: {
                    click: function($event) {
                      _vm.btnAction()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnRight) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-638f3405", esExports)
  }
}

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-contact-email-body" },
    [
      _c("div", { staticClass: "choose-event-wrapper row" }, [
        _c("div", { staticClass: "col-md-3" }, [
          _c("div", { staticClass: "h3-text" }, [_vm._v("Event Type")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-type-event" },
            [
              _c(
                "pretty-radio",
                {
                  staticClass: "custom-radio-btn p-default p-round text-label",
                  attrs: { name: "isSingleEvent", value: true },
                  model: {
                    value: _vm.isSingleEvent,
                    callback: function($$v) {
                      _vm.isSingleEvent = $$v
                    },
                    expression: "isSingleEvent"
                  }
                },
                [_vm._v("This single event")]
              ),
              _vm._v(" "),
              _c(
                "pretty-radio",
                {
                  staticClass: "custom-radio-btn p-default p-round text-label",
                  attrs: { name: "isSingleEvent", value: false },
                  model: {
                    value: _vm.isSingleEvent,
                    callback: function($$v) {
                      _vm.isSingleEvent = $$v
                    },
                    expression: "isSingleEvent"
                  }
                },
                [
                  _vm._v("Related Events "),
                  _vm.event.relatedEvents.length > 0
                    ? _c("span", { staticClass: "event-count" }, [
                        _vm._v(
                          "(" + _vm._s(_vm.event.relatedEvents.length) + ")"
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-9" }, [
          _c("div", { staticClass: "h3-text" }, [_vm._v("Events")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "group-related-events" },
            [
              _vm.isSingleEvent == true
                ? _c("div", { staticClass: "related-event-item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "event-name",
                        on: {
                          click: function($event) {
                            _vm.relatedEventItemClick(_vm.event.id)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.event.eventName))]
                    )
                  ])
                : _vm._l(_vm.event.relatedEvents, function(reEvent) {
                    return _c(
                      "div",
                      { key: reEvent.id, staticClass: "related-event-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "event-name",
                            on: {
                              click: function($event) {
                                _vm.relatedEventItemClick(reEvent.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(reEvent.eventName))]
                        )
                      ]
                    )
                  })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "recipients-wrapper row" }, [
        _c("div", { staticClass: "recipients-section col-md-6" }, [
          _c("div", { staticClass: "h3-text text-mar-bot" }, [
            _vm._v("Recipients")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-email-recipient" }, [
            _c("div", { staticClass: "ap-input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.recipientEmail,
                    expression: "recipientEmail"
                  }
                ],
                staticClass: "ap-input",
                attrs: { type: "text", placeholder: "Enter email address" },
                domProps: { value: _vm.recipientEmail },
                on: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addRecipientTo($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.recipientEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "add-icon",
                on: { click: _vm.addRecipientTo }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-email-send-to" },
              _vm._l(_vm.listEmailSendTo, function(e) {
                return _c("div", { key: e, staticClass: "email-item" }, [
                  _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "remove-icon",
                    on: {
                      click: function($event) {
                        _vm.removeRecipient(e)
                      }
                    }
                  })
                ])
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cc-section col-md-6" }, [
          _c("div", { staticClass: "h3-text text-mar-bot" }, [
            _vm._v("Additional Recipients (CC)")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-email-recipient" }, [
            _c("div", { staticClass: "ap-input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ccEmail,
                    expression: "ccEmail"
                  }
                ],
                staticClass: "ap-input",
                attrs: { type: "text", placeholder: "Enter email address" },
                domProps: { value: _vm.ccEmail },
                on: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addRecipientCC($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.ccEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "add-icon",
                on: { click: _vm.addRecipientCC }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-email-send-to" },
              _vm._l(_vm.listEmailCC, function(e) {
                return _c("div", { key: e, staticClass: "email-item" }, [
                  _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "remove-icon",
                    on: {
                      click: function($event) {
                        _vm.removeRecipientCC(e)
                      }
                    }
                  })
                ])
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "h3-text text-send-email" }, [
        _vm._v("Send Email")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "send-email-container" }, [
        _c("div", { staticClass: "col-6 participant-emails" }, [
          _c(
            "div",
            { staticClass: "text-entry-field-wrapper w-100" },
            [
              _c("span", { staticClass: "text-entry-title" }, [
                _vm._v("Email Template")
              ]),
              _vm._v(" "),
              _c("multiselect", {
                staticClass: "multiple-select-work-group",
                attrs: {
                  options: _vm.emailTemplates,
                  placeholder: "Choose Email Type",
                  label: "templateTypeName",
                  openDirection: "below",
                  "allow-empty": false,
                  "show-labels": false
                },
                on: { select: _vm.onSelectEmailTemplate },
                model: {
                  value: _vm.emailTemplate,
                  callback: function($$v) {
                    _vm.emailTemplate = $$v
                  },
                  expression: "emailTemplate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-entry-field-wrapper mt-3 w-100" }, [
            _c("span", { staticClass: "text-entry-title" }, [
              _vm._v("Subject Line")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.emailTemplate.emailSubject,
                  expression: "emailTemplate.emailSubject"
                }
              ],
              staticClass: "text-subject",
              attrs: { type: "text", placeholder: "Enter email subject line" },
              domProps: { value: _vm.emailTemplate.emailSubject },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.emailTemplate,
                    "emailSubject",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-entry-field-wrapper mt-3" },
            [
              _c("span", { staticClass: "text-entry-title" }, [
                _vm._v("Email body")
              ]),
              _vm._v(" "),
              _c("vue-ckeditor", {
                attrs: { config: _vm.config },
                on: { input: _vm.onChangeTemplate },
                model: {
                  value: _vm.emailTemplate.body,
                  callback: function($$v) {
                    _vm.$set(_vm.emailTemplate, "body", $$v)
                  },
                  expression: "emailTemplate.body"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "email-template-wrapper" }, [
            _c("div", { staticClass: "reply-and-history-section w-100" }, [
              _c("div", { staticClass: "reply-emails-wrapper" }, [
                _c("div", { staticClass: "text-entry-title" }, [
                  _vm._v("Reply emails go to:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-email-recipient" }, [
                  _c("div", { staticClass: "ap-input-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.replyEmail,
                          expression: "replyEmail"
                        }
                      ],
                      staticClass: "ap-input",
                      attrs: {
                        type: "text",
                        placeholder: "Enter email address"
                      },
                      domProps: { value: _vm.replyEmail },
                      on: {
                        keyup: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.addReplyEmailGoTo($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.replyEmail = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "add-icon",
                      on: { click: _vm.addReplyEmailGoTo }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "list-email-send-to" }, [
                    _vm.listReplyEmails != ""
                      ? _c("div", { staticClass: "email-item" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(_vm.listReplyEmails))
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "remove-icon",
                            on: {
                              click: function($event) {
                                _vm.removeRecipientReply(_vm.listReplyEmails)
                              }
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-history-wrapper" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "list-email-recipient" }, [
                  _c("div", { staticClass: "email-history-title col-md-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "caption-text sent-date col-md-5",
                          on: {
                            click: function($event) {
                              _vm.setSortOption("time")
                            }
                          }
                        },
                        [
                          _vm._v("Sent Date\n                    "),
                          _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "caption-text email-template col-md-5",
                          on: {
                            click: function($event) {
                              _vm.setSortOption("template")
                            }
                          }
                        },
                        [
                          _vm._v("Email Template\n                    "),
                          _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "list-email-send-to" },
                    _vm._l(_vm.listHistory, function(h) {
                      return _c(
                        "div",
                        { key: h, staticClass: "history-item" },
                        [
                          _c("div", { staticClass: "history-left" }, [
                            _c("div", { staticClass: "sent-date" }, [
                              _vm._v(_vm._s(_vm._f("dateFormatMMDDYY")(h.time)))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "email-template" }, [
                              _vm._v(_vm._s(_vm._f("templateName")(h.template)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "view-detail",
                              on: {
                                click: function($event) {
                                  _vm.goToEmailHistoryDetails(h.id)
                                }
                              }
                            },
                            [_vm._v("View details")]
                          )
                        ]
                      )
                    })
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-container" },
        [
          _c(
            "b-button",
            { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btn-send",
              attrs: { disabled: _vm.isSendLoading },
              on: { click: _vm.sendEmailClick }
            },
            [
              _vm.isSendLoading
                ? _c("b-spinner", { attrs: { variant: "primary" } })
                : _vm._e(),
              _vm._v("\n      Send\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ModalChangeEmailTemplate", {
        on: {
          CLOSE_MODAL_CHANGE_TEMPLATE_ACTION: _vm.closeModalChangeMailTemplate
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email-history-text-wrapper" }, [
      _c("div", { staticClass: "email-history-text text-entry-title" }, [
        _vm._v("Email History")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e811757a", esExports)
  }
}

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "manageEmailModal",
        id: "manageEmailModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: {
        "before-open": _vm.beforeOpen,
        "before-close": _vm.beforeClose,
        opened: _vm.opened
      }
    },
    [
      _c(
        "div",
        { staticClass: "client-contact-email-page" },
        [
          _c("div", { staticClass: "header-email-page" }, [
            _c("p", [_vm._v("Email Client")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon-close",
              on: {
                click: function($event) {
                  _vm.cancelClick()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("ClientContactEmail", {
                attrs: {
                  eventId: _vm.eventId,
                  event: _vm.event,
                  singleEvent: _vm.singleEvent,
                  isChange: _vm.isChange,
                  emailTemplateType: _vm.emailTemplateType,
                  replyEmail: _vm.replyEmail,
                  listEmailCC: _vm.listEmailCC,
                  listEmailSendTo: _vm.listEmailSendTo,
                  body: _vm.body,
                  cancelClick: _vm.cancelClick,
                  backToPreviousPage: _vm.backToPreviousPage
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("ModalInfo", {
            on: { CLOSE_MODAL_INFO: _vm.closeModalCancelEmail }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb29f698", esExports)
  }
}

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6337381c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-478c16ac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoriesManagement.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-478c16ac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoriesManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_events_EmailHistoriesHeader__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_emailHistory_constants__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constants__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array_helper__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_commons_HeaderColumnEMS__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_commons_Spinner__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import emailTemplateConsts from '@/store/constants/emailTemplateType';
// import consts from '../../_consts';







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Email-Histories-Management-Page',
  components: {
    EmailHistoriesHeader: __WEBPACK_IMPORTED_MODULE_2__components_events_EmailHistoriesHeader__["a" /* default */],
    HeaderColumnEMS: __WEBPACK_IMPORTED_MODULE_8__components_commons_HeaderColumnEMS__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_9__components_commons_Spinner__["a" /* default */]
  },
  data: function data() {
    return {
      eventId: null,
      event: {},
      histories: [],
      isParticipantTab: false,
      participantColsHeader: [{
        displayName: 'Last Sent Date',
        internalName: 'lastModifiedAt',
        showIcon: true,
        className: ['col-md-2'],
        width: '16.67%%'
      }, {
        displayName: 'Email Template',
        internalName: 'templateType',
        showIcon: true,
        className: ['col-md-2'],
        width: '16.67%%'
      }, {
        displayName: 'First Name',
        internalName: 'firstName',
        showIcon: true,
        className: ['col-md-2'],
        width: '16.67%%'
      }, {
        displayName: 'Last Name',
        internalName: 'lastName',
        showIcon: true,
        className: ['col-md-2'],
        width: '16.67%%'
      }, {
        displayName: 'Email',
        internalName: 'recipients',
        showIcon: true,
        className: ['col-md-2'],
        width: '16.67%%'
      }, {
        displayName: '',
        showIcon: true,
        className: ['col-md-2'],
        width: '16.67%%'
      }],
      sortObject: {
        fieldName: '',
        reverse: false
      },
      pagingOption: {
        pageNum: 1,
        pageSize: 10,
        sortType: null,
        sortReverse: false
      },
      keyword: ''
    };
  },

  filters: {
    filterRelatedEventsName: function filterRelatedEventsName(listRelatedEvents) {
      var result = '';
      listRelatedEvents.forEach(function (index, element) {});
      return result;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    columnWidth: 'GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    beforeOpen: function beforeOpen(params) {
      if (params.params && params.params.eventId) {
        this.eventId = params.params.eventId;
        this.isManageDetails = params.params.isManageDetails;
      }
    },
    goToEventDetails: function goToEventDetails(historyId) {
      this.$router.push({ name: 'EmailHistoryDetailsManagement', params: { id: historyId } });
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.pagingOption.pageNum++;
      this.getData(true).then(function (res) {
        // debugger;
        if (res && (_this.pagingOption.pageNum + 1) * _this.pagingOption.pageSize >= res.total) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    cancelClick: function cancelClick() {
      this.$modal.hide('EmailHistoriesManagementModal');
    },
    handleChangeTableClick: function handleChangeTableClick(isParticipantTab) {
      this.isParticipantTab = isParticipantTab;
      this.pagingOption = {
        pageNum: 1,
        pageSize: 10,
        sortType: null,
        sortReverse: false
      };
      this.histories = [];
      this.getData();
    },
    handleResendEmail: function handleResendEmail(historyEmail) {
      var _this2 = this;

      this.resendEmail(historyEmail.id).then(function (response) {}).catch(function (err) {
        console.log('error=', err);
        _this2.$toast.success('Resend email failure.', '', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optError));
      });
    },
    getData: function getData() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var params = {
          params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            isParticipant: _this3.isParticipantTab,
            eventId: _this3.eventId,
            keyword: _this3.keyword
          }, _this3.pagingOption)
        };
        _this3.getEventHistoriesById(params).then(function (response) {
          if (response.message === null) {
            response.historyList.forEach(function (element) {
              _this3.histories.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, element, {
                id: element.id,
                time: element.lastModifiedAt,
                template: element.templateType,
                relatedEvents: element.relatedEvents.map(function (r) {
                  return r.eventName;
                }),
                recipients: element.recipients.replace(',', ', ')
              }));
            });
            _this3.histories.sort(function (a, b) {
              return a.time - b.time;
            });
          }
          resolve(response);
        });
      });
    },
    handleSortChange: function handleSortChange(sortObj) {
      this.sortObject.reverse = sortObj.fieldName === this.sortObject.fieldName ? !this.sortObject.reverse : false;
      this.sortObject.fieldName = sortObj.fieldName;
      var type = __WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].getMappingObjectType(sortObj.fieldName);
      // this.histories.sort(arrHelper.sortFunction(sortObj.fieldName, this.sortObject.reverse, type));
      this.histories.sort(__WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].sortFunction(sortObj.fieldName, this.sortObject.reverse, type));
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getEventHistoriesById: 'ACTION_GET_EVENT_HISTORIES_BY_ID',
    getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
    sendOnSiteContactEmail: 'ACTION_SEND_ON_SITE_CONTACT_EMAIL'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(__WEBPACK_IMPORTED_MODULE_6__store_constants__["a" /* default */].store.EMAIL_HISTORY, {
    resendEmail: [__WEBPACK_IMPORTED_MODULE_5__store_modules_emailHistory_constants__["a" /* default */].ACTION_RESEND_EMAIL]
  })),
  created: function created() {
    var _this4 = this;

    this.$bus.$on('CHANGE_EMAIL_HISTORY_SORT', function (sortOption) {
      _this4.histories.sort(__WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].sortFunction(sortOption.sortType, sortOption.sortReverse));
    });
  },
  mounted: function mounted() {},

  watch: {
    keyword: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.histories = [];
      this.pagingOption.pageNum = 1;
      this.getData();
    }, 300)
  }
});

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoriesHeader_vue__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7c94c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoriesHeader_vue__ = __webpack_require__(1691);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1688)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoriesHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7c94c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoriesHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/events/EmailHistoriesHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmailHistoriesHeader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c7c94c2", Component.options)
  } else {
    hotAPI.reload("data-v-4c7c94c2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1689);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("63f3ad50", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c7c94c2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoriesHeader.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c7c94c2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoriesHeader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts_js__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-header',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      pagingObj: {
        sortType: '',
        sortReverse: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    columnWidth: 'GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setSortOption: function setSortOption(sortType) {
      this.pagingObj.sortType = sortType;
      this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
      this.$bus.$emit('CHANGE_EMAIL_HISTORY_SORT', this.pagingObj);
    },

    changeColumnWidth: function changeColumnWidth(colName, mouseDownEvent) {
      var _this = this;

      this.resizing = true;
      var vueApp = this;
      // get current mouse position
      var shiftX = mouseDownEvent.clientX;
      // header width
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      var maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      var newWidth = maxLeft;
      if (this.columnWidth.sentDate.size === 0) {
        __WEBPACK_IMPORTED_MODULE_7__consts_js__["a" /* default */].defaultColumnEmailHistories.forEach(function (element) {
          var el = document.getElementById(element.colName);
          var elWidth = el.getBoundingClientRect().width;
          var objResize = {
            headerWidth: headerWidth,
            colName: element.colName,
            newWidth: elWidth
          };
          _this.mutationSaveWidthTableEmailHitories(objResize);
        });
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      var newHeaderWidth = 0;
      function onMouseMove(event) {
        // new position
        var bufferPx = event.clientX - shiftX;
        newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && maxLeft - Math.abs(bufferPx) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.mutationSaveWidthTableEmailHitories({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2)
        });

        var dtHeaderEl = document.getElementById('dt-header');
        var dtBodyEl = document.getElementById('ems-table-body');
        dtHeaderEl.style.width = newHeaderWidth + 'px';
        dtBodyEl.style.width = newHeaderWidth + 'px';
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(function () {
          vueApp.resizing = false;
        }, 50);
      }
    },
    saveDefaultColumnWidth: function saveDefaultColumnWidth(isWidthPercent) {
      var _this2 = this;

      var dtHeaderEl = document.getElementById('dt-header');
      var dtBodyEl = document.getElementById('ems-table-body');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      var newHeaderWidth = headerWidth < 1000 ? 1000 : headerWidth;

      if (isWidthPercent) {
        dtHeaderEl.style.width = 'unset';
        dtBodyEl.style.width = 'unset';
      } else {
        dtHeaderEl.style.width = '950px';
        dtBodyEl.style.width = '950px';
      }
      __WEBPACK_IMPORTED_MODULE_7__consts_js__["a" /* default */].defaultColumnEmailHistories.forEach(function (element) {
        var objResize = {
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: element.colName,
          newWidth: isWidthPercent ? 0 : element.size,
          isWidthPercent: isWidthPercent
        };
        _this2.mutationSaveWidthTableEmailHitories(objResize);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({}), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])({
    mutationSaveWidthTableEmailHitories: 'MUTATION_SAVE_COLUMN_WIDTH_TABLE_EMAIL_HISTORIES'
  })),
  mounted: function mounted() {
    if (document.body.clientWidth < 1000) {
      this.saveDefaultColumnWidth();
    }
  },
  created: function created() {
    var _this3 = this;

    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_6_lodash__["debounce"](function (event) {
      if (document.body.clientWidth < 1000) {
        _this3.saveDefaultColumnWidth();
      } else {
        _this3.saveDefaultColumnWidth(true);
      }
    }, 100));
  }
});

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ems-table-header", attrs: { id: "dt-header" } },
    [
      _c(
        "div",
        {
          staticClass: "ems-header-col",
          style: {
            width: _vm.columnWidth.sentDate.size
              ? _vm.columnWidth.sentDate.size + "px"
              : "13%"
          },
          attrs: { id: "sentDate" }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("sentDate", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "content no-select label-text-2 padding-left-40px",
                  on: {
                    click: function($event) {
                      _vm.setSortOption("time")
                    }
                  }
                },
                [
                  _vm._v("\n          SENT DATE\n          "),
                  this.pagingObj.sortType != "time"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "time" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "time" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ems-header-col",
          style: {
            width: _vm.columnWidth.emailTemplate.size
              ? _vm.columnWidth.emailTemplate.size + "px"
              : "17%"
          },
          attrs: { id: "emailTemplate" }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("emailTemplate", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content no-select label-text-2",
                  on: {
                    click: function($event) {
                      _vm.setSortOption("template")
                    }
                  }
                },
                [
                  _vm._v("\n          EMAIL TEMPLATE\n          "),
                  _c(
                    "span",
                    [
                      this.pagingObj.sortType != "template"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "template" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "template" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ems-header-col",
          style: {
            width: _vm.columnWidth.relatedEvent.size
              ? _vm.columnWidth.relatedEvent.size + "px"
              : "28%"
          },
          attrs: { id: "relatedEvent" }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("relatedEvent", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content no-select label-text-2",
                  on: {
                    click: function($event) {
                      _vm.setSortOption("relatedEvents")
                    }
                  }
                },
                [
                  _vm._v("\n          RELATED EVENT\n          "),
                  this.pagingObj.sortType != "relatedEvents"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "relatedEvents" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "relatedEvents" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ems-header-col",
          style: {
            width: _vm.columnWidth.recipients.size
              ? _vm.columnWidth.recipients.size + "px"
              : "28%"
          },
          attrs: { id: "recipients" }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("recipients", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content no-select label-text-2",
                  on: {
                    click: function($event) {
                      _vm.setSortOption("recipients")
                    }
                  }
                },
                [
                  _vm._v("\n          RECIPIENTS\n          "),
                  this.pagingObj.sortType != "recipients"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "recipients" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "recipients" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ems-header-col",
          style: {
            width: _vm.columnWidth.actions.size
              ? _vm.columnWidth.actions.size + "px"
              : "14%"
          },
          attrs: { id: "actions" }
        },
        [_vm._m(0)]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "crop" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c7c94c2", esExports)
  }
}

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderColumnEMS_vue__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a180732_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderColumnEMS_vue__ = __webpack_require__(1694);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderColumnEMS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a180732_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderColumnEMS_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/HeaderColumnEMS.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HeaderColumnEMS.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a180732", Component.options)
  } else {
    hotAPI.reload("data-v-4a180732", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

// import routerConstants from '@/router/constants';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header-column',
  props: {
    headerObject: {
      type: Object,
      required: true
    },
    sortObject: {
      type: Object,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showResizeLine: {
      type: Boolean,
      default: true
    },
    styleObject: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      urlConsts: '',
      sortReverse: false
    };
  },

  methods: {
    hanleClick: function hanleClick() {
      this.sortReverse = !this.sortReverse;
      var sortOption = {
        fieldName: this.headerObject.internalName,
        sortReverse: this.sortReverse
      };
      this.$emit('CHANGE_SORT_OPTION', sortOption);
    }
  },
  computed: {
    getIconSort: function getIconSort() {
      var iconName = 'sort-solid.svg';
      if (this.sortObject.fieldName === this.headerObject.internalName) {
        iconName = this.sortObject.reverse ? 'sort-up-solid.svg' : 'sort-down-solid.svg';
      }
      return 'url(\'/static/images/' + iconName + '\') no-repeat center';
    },
    getIconClassName: function getIconClassName() {
      var className = 'non-sort';
      if (this.sortObject.fieldName === this.headerObject.internalName) {
        className = this.sortObject.reverse ? 'sort-up' : 'sort-down';
      }
      return className;
    }
  }
});

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ems-header-column field-col", style: _vm.styleObject },
    [
      _c("div", { staticClass: "content", on: { click: _vm.hanleClick } }, [
        _c("div", { staticClass: "label-text-2" }, [
          _vm._v(_vm._s(_vm.headerObject.displayName))
        ]),
        _vm._v(" "),
        _vm.showIcon
          ? _c("div", {
              staticClass: "icon-sort",
              class: [_vm.getIconClassName]
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showResizeLine ? _c("div", { staticClass: "resize-line" }) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a180732", esExports)
  }
}

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-spinner',
  props: {
    size: {
      type: Number,
      default: 50
    },
    borderSize: {
      type: Number,
      default: 5
    },
    borderColor: {
      type: String,
      default: '#b9b9b9'
    },
    borderTopColor: {
      type: String,
      default: '#00A4D6'
    }
  }
});

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spinner-container",
      style: { width: _vm.size + "px", height: _vm.size + "px" }
    },
    [
      _c("div", {
        staticClass: "spinner-inner",
        style: {
          width: _vm.size + "px",
          height: _vm.size + "px",
          borderWidth: _vm.borderSize + "px",
          borderColor: _vm.borderColor,
          borderTopColor: _vm.borderTopColor
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2db4f778", esExports)
  }
}

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "EmailHistoriesManagementModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "email-histories-page" }, [
        _c("div", { staticClass: "hisories-page-header margin-side" }, [
          _c("div", { staticClass: "btn-back-wrapper" }, [
            _c("div", {
              staticClass: "btn-back icon-back",
              on: { click: _vm.cancelClick }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-title h2-text" }, [
            _vm._v("Email History")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab-wrapper" }, [
            _c(
              "a",
              {
                staticClass: "tab-name",
                class: { active: !_vm.isParticipantTab },
                attrs: { href: "javascript: void(0);" },
                on: {
                  click: function($event) {
                    _vm.handleChangeTableClick(false)
                  }
                }
              },
              [_c("span", { staticClass: "text" }, [_vm._v("On Site Contact")])]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "tab-name",
                class: { active: _vm.isParticipantTab },
                attrs: { href: "javascript: void(0);" },
                on: {
                  click: function($event) {
                    _vm.handleChangeTableClick(true)
                  }
                }
              },
              [_c("span", { staticClass: "text" }, [_vm._v("Participant")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "histories-page-body" }, [
          _c("div", { staticClass: "ems-table margin-side" }, [
            _vm.isParticipantTab
              ? _c("div", { staticClass: "participant-table-container" }, [
                  _c(
                    "div",
                    { staticClass: "search-section ems-input-wrapper" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.keyword,
                            expression: "keyword"
                          }
                        ],
                        staticClass: "input",
                        attrs: { placeholder: "Search for emails" },
                        domProps: { value: _vm.keyword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.keyword = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-participant-container" }, [
                    _c("div", { staticClass: "table-header" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm._l(_vm.participantColsHeader, function(
                            col,
                            index
                          ) {
                            return [
                              _c("HeaderColumnEMS", {
                                class: col.className,
                                attrs: {
                                  headerObject: col,
                                  showResizeLine:
                                    index + 1 !=
                                    _vm.participantColsHeader.length,
                                  showIcon:
                                    index + 1 !=
                                    _vm.participantColsHeader.length,
                                  sortObject: _vm.sortObject,
                                  styleObject: {
                                    width: _vm.columnWidth.emailTemplate.size
                                      ? _vm.columnWidth.emailTemplate.size +
                                        "px"
                                      : _vm.participantColsHeader.width
                                  }
                                },
                                on: { CHANGE_SORT_OPTION: _vm.handleSortChange }
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ems-table-body" },
                      [
                        _vm._l(_vm.histories, function(h) {
                          return _c("div", { staticClass: "ems-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("dateFormatMMDDYY")(h.time))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("templateName")(h.template))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [_vm._v(_vm._s(h.firstName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [_vm._v(_vm._s(h.lastName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [_vm._v(_vm._s(h.recipients))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "field-value value-text resend-btn-wrapper",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [
                                h.template != "CANCELLATION"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "ap-btn secondary resend-btn",
                                        on: {
                                          click: function($event) {
                                            _vm.handleResendEmail(h)
                                          }
                                        }
                                      },
                                      [_vm._v("Resend")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c(
                          "infinite-loading",
                          {
                            attrs: { distance: 100 },
                            on: { infinite: _vm.infiniteHandler }
                          },
                          [
                            _c("Spinner", {
                              attrs: { slot: "spinner" },
                              slot: "spinner"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-more" },
                              slot: "no-more"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-results" },
                              slot: "no-results"
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ])
              : _c(
                  "div",
                  { staticClass: "histories-table-container" },
                  [
                    _c("EmailHistoriesHeader"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ems-table-body",
                        attrs: { id: "ems-table-body" }
                      },
                      [
                        _vm._l(_vm.histories, function(h) {
                          return _c(
                            "div",
                            { key: h.id, staticClass: "ems-row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "field-value value-text padding-left-40px",
                                  style: {
                                    width: _vm.columnWidth.sentDate.size
                                      ? _vm.columnWidth.sentDate.size + "px"
                                      : "13%"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("dateFormatMMDDYY")(h.time))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.emailTemplate.size
                                      ? _vm.columnWidth.emailTemplate.size +
                                        "px"
                                      : "17%"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("templateName")(h.template))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.relatedEvent.size
                                      ? _vm.columnWidth.relatedEvent.size + "px"
                                      : "28%"
                                  }
                                },
                                [_vm._v(_vm._s(h.relatedEvents.join(", ")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.recipients.size
                                      ? _vm.columnWidth.recipients.size + "px"
                                      : "28%"
                                  }
                                },
                                [_vm._v(_vm._s(h.recipients))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.actions.size
                                      ? _vm.columnWidth.actions.size + "px"
                                      : "14%",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "action-text",
                                      on: {
                                        click: function($event) {
                                          _vm.goToEventDetails(h.id)
                                        }
                                      }
                                    },
                                    [_vm._v("View Details")]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "infinite-loading",
                          {
                            attrs: { distance: 100 },
                            on: { infinite: _vm.infiniteHandler }
                          },
                          [
                            _c("Spinner", {
                              attrs: { slot: "spinner" },
                              slot: "spinner"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-more" },
                              slot: "no-more"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-results" },
                              slot: "no-results"
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-478c16ac", esExports)
  }
}

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1699);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("c3223450", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0871f9c0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventStaffingDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0871f9c0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventStaffingDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.custom-modal[data-v-0871f9c0] {\n  background: rgba(0, 0, 0, 0.4);\n  min-height: 100vh;\n}\n.custom-modal .modal-padding[data-v-0871f9c0] {\n  padding-top: 24px;\n  min-height: 100vh;\n}\n.custom-modal .modal-close-img[data-v-0871f9c0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.custom-modal .modal-close-img[data-v-0871f9c0]:hover {\n  cursor: pointer;\n}\n.custom-modal .modal-close-img .icon-close[data-v-0871f9c0] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.custom-modal .icon-back[data-v-0871f9c0] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(92) + ");\n}\n.custom-modal .icon-back[data-v-0871f9c0]:hover {\n  cursor: pointer;\n}\n.custom-modal .icon-align[data-v-0871f9c0] {\n  margin-top: 24px;\n  margin-bottom: 10px;\n  padding-left: 8px;\n}\n.custom-modal .staffing-section[data-v-0871f9c0] {\n  padding-left: 30px;\n  margin-bottom: 50px;\n}\n.custom-modal .staffing-section .duration-slide-container .duration-slide[data-v-0871f9c0] {\n  width: 184px;\n  padding: 0 12px;\n}\n.custom-modal .staffing-section .duration-slide-container .change-duration-button[data-v-0871f9c0] {\n  padding: 6px 24px;\n  margin-left: 30px;\n  background: #ffffff;\n  color: #1674cd;\n  border: 1px solid #b9b9b9;\n  opacity: 0.7;\n}\n.custom-modal .staffing-section .btn-cancel[data-v-0871f9c0] {\n  padding: 6px 24px;\n  background: #ffffff;\n  color: #1674cd;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  opacity: 0.7;\n  margin-top: 6px;\n}\n.custom-modal .staffing-section .time-management-container[data-v-0871f9c0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  padding: 0 0.7rem;\n}\n.custom-modal .staffing-section .group-btn .ap-btn[data-v-0871f9c0] {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.custom-modal .staffing-section .group-btn .ap-btn + .ap-btn[data-v-0871f9c0] {\n  margin-left: 8px;\n}\n.custom-modal .staffing-section .slots-configuration[data-v-0871f9c0] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.custom-modal .staffing-section .seperate-name[data-v-0871f9c0] {\n  border-left: 1.5px solid #B9B9B9;\n  height: 20px;\n  margin: 0 1rem;\n  top: 5px;\n}\n.custom-modal .staffing-section .time-slots[data-v-0871f9c0] {\n  color: #444444;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n  line-height: 28px;\n  margin-top: 40px;\n  margin-right: 35px;\n}\n.custom-modal .staffing-section .staffing-title[data-v-0871f9c0] {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-top: 20px;\n  margin-bottom: 15px;\n}\n.custom-modal .staffing-section .label[data-v-0871f9c0] {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  text-transform: uppercase;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.custom-modal .staffing-section .add[data-v-0871f9c0] {\n  height: 32px;\n  width: 83px;\n  background-color: #00A4D6;\n  border-radius: 4px;\n  display: inline-block;\n  cursor: pointer;\n}\n.custom-modal .staffing-section .remove[data-v-0871f9c0] {\n  height: 32px;\n  width: 114px;\n  background-color: #FF3400;\n  border-radius: 4px;\n  display: inline-block;\n  margin-left: 4px;\n  cursor: pointer;\n}\n.custom-modal .staffing-section .screeners-label[data-v-0871f9c0] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.custom-modal .staffing-section .screener-number[data-v-0871f9c0] {\n  display: inline-block;\n  width: 106px;\n}\n.custom-modal .staffing-section .screener-wrapper[data-v-0871f9c0] {\n  background-color: #ffffff;\n  width: 1023px;\n  border-radius: 4px;\n}\n.custom-modal .isLoading[data-v-0871f9c0] {\n  display: block;\n  text-align: center;\n  color: #606060;\n  height: 100%;\n}\n.custom-modal .noDisplay[data-v-0871f9c0] {\n  display: none;\n}\n.custom-modal .overlay[data-v-0871f9c0] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.custom-modal .spinner-align[data-v-0871f9c0] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.custom-modal .text-entry-field-wrapper .text-entry-title[data-v-0871f9c0] {\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 28px;\n  text-transform: capitalize;\n}\n.custom-modal .text-entry-field-wrapper .text-input[data-v-0871f9c0] {\n  height: 32px;\n  width: 100%;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n.custom-modal .text-entry-field-wrapper .text-input[data-v-0871f9c0]::-webkit-input-placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .text-entry-field-wrapper .text-input[data-v-0871f9c0]::-moz-placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .text-entry-field-wrapper .text-input[data-v-0871f9c0]:-ms-input-placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n.custom-modal .text-entry-field-wrapper .text-input[data-v-0871f9c0]::placeholder {\n  font-size: 12px;\n  color: #585858;\n}\n", ""]);

// exports


/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_eventManagement_eventDetail_StaffManagement__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_patient_PatientDetailModal__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_slots_SlotsTable__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_commons_Spinner__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal_ModalCancellAllAppointment__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import consts from '../../_consts';











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-staffing-detail',
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */],
    PatientDetailModal: __WEBPACK_IMPORTED_MODULE_6__components_modal_patient_PatientDetailModal__["a" /* default */],
    ScrollTop: __WEBPACK_IMPORTED_MODULE_4__components_utils_ScrollTop__["a" /* default */],
    StaffManagement: __WEBPACK_IMPORTED_MODULE_5__components_eventManagement_eventDetail_StaffManagement__["a" /* default */],
    SlotsTable: __WEBPACK_IMPORTED_MODULE_7__components_slots_SlotsTable__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_8__components_commons_Spinner__["a" /* default */],
    ModalCancellAllAppointment: __WEBPACK_IMPORTED_MODULE_9__components_modal_ModalCancellAllAppointment__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      historyRouter: null,
      event: {},
      eventDetail: {},
      duration: {
        value: 15,
        width: 'auto',
        dotSize: 15,
        tooltip: false,
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        data: [5, 15, 20],
        piecewiseStyle: {
          backgroundColor: 'transparent', // #00A4D6
          visibility: 'visible',
          width: '15px',
          height: '15px'
        },
        piecewiseActiveStyle: {
          backgroundColor: 'transparent',
          width: '15px',
          height: '15px',
          visibility: 'visible'
        },
        processStyle: {
          'backgroundColor': 'transparent'
        }
      },
      numberColumn: 0,
      startColumn: 0,
      numberShowColumn: 0,
      selectedItemIds: [],
      selectedItems: [],
      selectedRows: [],
      selectedColumns: [],
      eventId: 0,
      maxStaffLead: 0,
      maxStaffConcierge: 0,
      maxStaffScreener: 0,
      isLoading: true,
      eventName: null,
      maxAppointmentPerslot: 0,
      onChangeEventDetail: null,
      isLoadingAppointment: true,
      shiftboard: {
        leadTitle: null,
        screenerTitle: null,
        phlebotomistTitle: null,
        workgroups: []
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    beforeOpen: function beforeOpen(params) {
      var _this = this;

      var eventId = params.params.eventId;
      this.eventName = params.params.eventName;
      this.eventId = eventId;
      this.historyRouter = params.routerName;
      this.onChangeEventDetail = params.params.onChangeEventDetail;
      // get Event Staffs
      this.getEventStaff(eventId).then(function (response) {
        _this.maxStaffLead = response.maxStaffLead;
        _this.maxStaffConcierge = response.maxStaffConcierge;
        _this.maxStaffScreener = response.maxStaffScreener;
        _this.maxAppointmentPerslot = response.maxAppointmentPerslot;
      });

      this.getEventDetailsById();
    },
    beforeClose: function beforeClose() {},
    onShiftboardDropdown: function onShiftboardDropdown(item, role) {
      switch (role) {
        case 'lead':
          this.shiftboard.leadTitle = item;
          this.event.sbWorkgroupId = item.id;
          break;
        case 'screener':
          this.shiftboard.screenerTitle = item;
          this.event.sbScreenerWorkgroupId = item.id;
          break;
        case 'phlebotomist':
          this.shiftboard.phlebotomistTitle = item;
          this.event.sbPhlebotomistWorkgroupId = item.id;
          break;
      }
      this.updateEventShiftboard({ eventId: this.event.id, workgroupId: item.id, role: role });
    },
    requestReloadTableStaffing: function requestReloadTableStaffing() {
      this.getEventDetailsById();
    },
    updateEventStaffingGroups: function updateEventStaffingGroups(obj) {
      this.maxAppointmentPerslot = obj.maxAppointmentPerslot;
      this.eventDetail.eventSlotGroups = obj.eventSlotGroups;
      this.eventDetail.numStaffs = obj.numStaffs;
      // this.renderEventStaffing(this.eventDetail);
      this.$refs.updateSlots.renderEventStaffing(this.eventDetail);
    },
    back: function back() {
      this.$modal.hide('eventStaffingDetailModal');
    },
    getValue: function getValue(name) {
      var _this2 = this;

      var slider = this.$refs[name];
      var eventId = this.$route.params.eventId || null;
      var body = {
        duration: slider.getValue(),
        blocked: null,
        eventId: eventId
      };
      this.changeDuration(body).then(function (response) {
        if (response.message === null) {
          // this.renderEventStaffing(response);
          _this2.$refs.updateSlots.renderEventStaffing(response);
          _this2.$refs.updateSlotsFluShot.renderEventStaffing(response);
        } else {
          _this2.$toastr('error', 'Unsuccessfully getting duration!', '');
        }
      });
    },
    updateStaffMaxValueToParent: function updateStaffMaxValueToParent(obj) {
      // this function is used to update the max value staff of each role from child component.
      switch (obj.role) {
        case 'screener':
          this.maxStaffScreener = obj.staff;
          break;
        case 'lead':
          this.maxStaffLead = obj.staff;
          break;
        case 'concierge':
          this.maxStaffConcierge = obj.staff;
          break;
      }
    },
    getEventDetailsById: function getEventDetailsById() {
      var _this3 = this;

      this.isLoading = true;
      this.getEventById(this.eventId).then(function (response) {
        _this3.event = response.event;
        _this3.getEventStaffingById();
        _this3.getSBWorkgroups().then(function (response) {
          _this3.shiftboard.workgroups = response;
          _this3.shiftboard.leadTitle = response.find(function (x) {
            return x.id === _this3.event.sbWorkgroupId;
          });
          _this3.shiftboard.screenerTitle = response.find(function (x) {
            return x.id === _this3.event.sbScreenerWorkgroupId;
          });
          _this3.shiftboard.phlebotomistTitle = response.find(function (x) {
            return x.id === _this3.event.sbPhlebotomistWorkgroupId;
          });
        });
      }).catch(function () {
        _this3.isLoading = false;
      });
    },
    addOrRemoveStaff: function addOrRemoveStaff(params) {
      var _this4 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        eventId: this.eventId
      }, params);
      this.addOrRemove(data).then(function (response) {
        if (response.message === null) {
          _this4.updateStaffMaxValueToParent({
            staff: response.maxStaff,
            role: params.eventStaffRole
          });
          if (response.eventStaffRole === 'screener') {
            _this4.updateEventStaffingGroups({
              numStaffs: response.maxStaff || 0,
              eventSlotGroups: response.eventSlotGroups || [],
              maxAppointmentPerslot: response.eventSlotGroups[0].eventSlots.length
            });
          }
          _this4.onChangeEventDetail({
            maxStaffLead: _this4.maxStaffLead,
            maxStaffConcierge: _this4.maxStaffConcierge,
            maxStaffScreener: _this4.maxStaffScreener
          });
        }
      });
    },
    getEventStaffingById: function getEventStaffingById() {
      var _this5 = this;

      this.isLoadingAppointment = true;
      this.getEventStaffing(this.eventId).then(function (res) {
        if (res.message === null) {
          // store boolean: if can add participant or not
          localStorage.setItem('IS_ADDED_PARTICIPANT', res.allowWithoutLimeade);
          _this5.eventDetail = res;
          setTimeout(function () {
            if (_this5.$refs.updateSlots) {
              _this5.$refs.updateSlots.renderEventStaffing(_this5.eventDetail);
            }

            if (_this5.eventDetail.eventSlotGroupsFLuShotOnly && _this5.eventDetail.eventSlotGroupsFLuShotOnly.length && _this5.$refs.updateSlotsFluShot) {
              _this5.$refs.updateSlotsFluShot.renderEventStaffing(_this5.eventDetail);
            }
          }, 1000);
        }
      }).finally(function () {
        _this5.isLoadingAppointment = false;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    changeDuration: 'ACTION_CHANGE_DURATION',
    getEventById: 'ACTION_GET_EVENT_BY_ID',
    getEventStaffing: 'ACTION_GET_EVENT_STAFFING',
    updateEventStaffing: 'ACTION_BLOCK_OPEN_STAFFING',
    getEventStaff: 'ACTION_GET_EVENT_STAFF',
    clearSlot: 'ACTION_CLEAR_SLOT',
    addOrRemove: 'ACTION_ADD_STAFF_SLOT',
    getSBWorkgroups: 'ACTION_GET_SB_WORKGROUPS',
    updateEventShiftboard: 'ACTION_UPDATE_EVENT_SHIFTBOARD'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setIsLoading: 'MUTATION_SET_IS_LOADING'
  }), {
    onCancelAllAppointments: function onCancelAllAppointments() {
      this.$modal.show('modalCancellAllAppointment');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getStaffingDuration: function getStaffingDuration() {
      return this.event.staffingDuration;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getIsLoading: 'GETTER_IS_LOADING_MODAL',
    getInfoForMaxVale: 'GETTER_GET_EVENT_FOR_CHANGE_ORDER'
  }))
});

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlotsTable_vue__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_150c0a9d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SlotsTable_vue__ = __webpack_require__(1727);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1702)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-150c0a9d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlotsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_150c0a9d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SlotsTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/slots/SlotsTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SlotsTable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-150c0a9d", Component.options)
  } else {
    hotAPI.reload("data-v-150c0a9d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1703);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6eb21b07", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-150c0a9d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SlotsTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-150c0a9d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SlotsTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.table-slots-container .number-slots-container[data-v-150c0a9d] {\n  background-color: #f5f5f5;\n}\n.table-slots-container .number-slots-defautl[data-v-150c0a9d] {\n  padding: 0;\n}\n.table-slots-container .number-slots-defautl .for-screening[data-v-150c0a9d] {\n  margin-top: 24px;\n  height: 36px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0;\n}\n.table-slots-container .number-slots-defautl .for-screening .btn-add[data-v-150c0a9d],\n.table-slots-container .number-slots-defautl .for-screening .btn-minus[data-v-150c0a9d] {\n  background: #FFFFFF;\n  border: 1px solid #B9B9B9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  margin-left: 1rem;\n}\n.table-slots-container .number-slots-defautl .for-screening .btn-add[data-v-150c0a9d] {\n  margin-right: 5.5rem;\n}\n.table-slots-container .number-slots-defautl .for-flu-shot[data-v-150c0a9d] {\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #f5f5f5;\n}\n.table-slots-container .number-slots-defautl .for-flu-shot .ap-field-input-wrapper[data-v-150c0a9d] {\n  margin-left: 24px;\n}\n.table-slots-container .number-slots-defautl .for-flu-shot .ap-field-input-wrapper .ap-input-wrapper .input[data-v-150c0a9d] {\n  height: 32px;\n  width: 72px;\n  color: #1D1D1D;\n}\n.table-slots-container .number-slots-defautl .for-flu-shot .ap-field-input-wrapper .ap-input-wrapper .icon-wrapper-field[data-v-150c0a9d] {\n  background: url('/static/img/sort-solid.svg') center no-repeat;\n  right: 8px;\n}\n.background-color-table[data-v-150c0a9d] {\n  background-color: #F5F5F5;\n}\n.background-color-table .space-between-row[data-v-150c0a9d] {\n  margin-top: 24px;\n  margin-bottom: 15px;\n}\n.background-color-table .group-btn .ap-btn[data-v-150c0a9d] {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 6px 24px;\n}\n.background-color-table .group-btn .ap-btn + .ap-btn[data-v-150c0a9d] {\n  margin-left: 16px;\n}\n.background-color-table .block-open-wrapper[data-v-150c0a9d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.background-color-table .block-all[data-v-150c0a9d] {\n  height: 32px;\n  width: 133px;\n  background-color: #FF3400;\n  border-radius: 4px;\n  display: inline-block;\n  cursor: pointer;\n}\n.background-color-table .open-all[data-v-150c0a9d] {\n  height: 32px;\n  width: 125px;\n  background-color: #00A4D6;\n  border-radius: 4px;\n  display: inline-block;\n  margin-left: 4px;\n  cursor: pointer;\n}\n.background-color-table .title-header[data-v-150c0a9d] {\n  color: #444444;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n  line-height: 28px;\n}\n.background-color-table .screeners-label[data-v-150c0a9d] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.background-color-table .time-slot-right[data-v-150c0a9d] {\n  text-align: right;\n  padding-right: 5px;\n}\n.background-color-table .screener-table[data-v-150c0a9d] {\n  margin-top: 15px;\n}\n.background-color-table .screener-table .s-header .s-header-wrapper[data-v-150c0a9d] {\n  width: 100%;\n}\n.background-color-table .screener-table .s-header .icon-wrapper[data-v-150c0a9d] {\n  border: solid 1px #00A4D6;\n  position: absolute;\n  border-radius: 10px;\n  /*top: -5px;*/\n}\n.background-color-table .screener-table .s-header .icon-wrapper[data-v-150c0a9d]:hover {\n  cursor: pointer;\n}\n.background-color-table .screener-table .s-header .icon-wrapper.left[data-v-150c0a9d] {\n  left: 50px;\n}\n.background-color-table .screener-table .s-header .icon-wrapper.right[data-v-150c0a9d] {\n  right: 60px;\n}\n.background-color-table .screener-table .s-header .icon-wrapper .left-icon[data-v-150c0a9d] {\n  z-index: 7;\n  width: 17px;\n  height: 17px;\n  background: url(" + __webpack_require__(394) + ");\n}\n.background-color-table .screener-table .s-header .icon-wrapper .right-icon[data-v-150c0a9d] {\n  z-index: 7;\n  width: 17px;\n  height: 17px;\n  background: url(" + __webpack_require__(395) + ");\n}\n.background-color-table .screener-table .s-header .s-header-column[data-v-150c0a9d] {\n  float: left;\n  width: 81px;\n  height: 17px;\n  color: #626262;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 17px;\n  margin-right: 24px;\n}\n.background-color-table .screener-table .s-header .s-header-column:hover .staffing-select-column[data-v-150c0a9d] {\n  display: block;\n}\n.background-color-table .screener-table .s-header .s-header-column .staffing-select-column[data-v-150c0a9d] {\n  float: left;\n  height: 24px;\n  width: 24px;\n  margin-top: -4px;\n  display: none;\n}\n.background-color-table .screener-table .s-body[data-v-150c0a9d] {\n  margin-top: 8px;\n}\n.background-color-table .screener-table .s-body .s-body-row .row-wrapper[data-v-150c0a9d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.background-color-table .screener-table .s-body .s-body-row .row-wrapper .time-wrapper[data-v-150c0a9d] {\n  position: relative;\n  margin-right: 25px;\n  text-align: right;\n}\n.background-color-table .screener-table .s-body .s-body-row .s-body-time[data-v-150c0a9d] {\n  line-height: 33px;\n  min-width: 53px;\n}\n.background-color-table .screener-table .s-body .s-body-row .staffing-select-row[data-v-150c0a9d] {\n  position: absolute;\n  right: -42px;\n  top: 5px;\n}\n.background-color-table .screener-table .s-body .s-body-row .staffing-select-row label[data-v-150c0a9d] {\n  opacity: 0;\n}\n.background-color-table .screener-table .s-body .s-body-row .staffing-select-row label[data-v-150c0a9d]:hover {\n  opacity: 1;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper[data-v-150c0a9d] {\n  background-color: #FFF;\n  height: 33px;\n  border-bottom: solid 1px #F5F5F5;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item[data-v-150c0a9d] {\n  float: left;\n  width: 81px;\n  height: 32px;\n  color: #626262;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 17px;\n  margin-right: 24px;\n  padding: 8px 0;\n  position: relative;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item:hover .action-btn[data-v-150c0a9d] {\n  display: block;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item:hover .bullet[data-v-150c0a9d] {\n  display: none;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item:hover .staffing-check[data-v-150c0a9d] {\n  display: block;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item:hover .text[data-v-150c0a9d] {\n  padding-left: 24px;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .staffing-check[data-v-150c0a9d] {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  display: none;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .text[data-v-150c0a9d] {\n  height: 17px;\n  color: #626262;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 17px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 62px;\n  padding-left: 8px;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .bullet[data-v-150c0a9d] {\n  height: 8px;\n  width: 8px;\n  float: left;\n  margin-top: 5px;\n  border-radius: 4px;\n  margin-right: 2px;\n  margin-left: 6px;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .bullet.green[data-v-150c0a9d] {\n  background-color: #68B814;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .bullet.red[data-v-150c0a9d] {\n  background-color: #f43406;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .bullet.grey[data-v-150c0a9d] {\n  background-color: #aaa7a4;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .action-btn[data-v-150c0a9d] {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  right: -21px;\n  top: 5px;\n  padding: 3px;\n  border-radius: 4px;\n  display: none;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .action-btn[data-v-150c0a9d]:hover {\n  cursor: pointer;\n  background: #e5e5e5;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .action-btn:hover ul.action-menu[data-v-150c0a9d] {\n  display: block;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item .action-btn .dot[data-v-150c0a9d] {\n  width: 4px;\n  height: 4px;\n  background: #8e8e8e;\n  margin: 1.5px auto;\n  border-radius: 2px;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item ul.action-menu[data-v-150c0a9d] {\n  -webkit-padding-start: 0;\n  list-style: none;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  position: absolute;\n  top: 23px;\n  right: 0;\n  width: 111px;\n  display: none;\n  z-index: 999;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item ul.action-menu li[data-v-150c0a9d] {\n  height: 32px;\n  background-color: #F5F5F5;\n  line-height: 32px;\n  padding-left: 8px;\n}\n.background-color-table .screener-table .s-body .s-body-wrapper .s-body-item ul.action-menu li[data-v-150c0a9d]:hover {\n  cursor: pointer;\n  background-color: #ededed;\n}\n.background-color-table .screener-table .s-container[data-v-150c0a9d] {\n  /*overflow: hidden;*/\n  height: 20px;\n}\n.background-color-table .screener-table .s-container.last-row[data-v-150c0a9d] {\n  padding-bottom: 65px;\n}\n", ""]);

// exports


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_patient_AddParticipantModal_vue__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_patient_PatientDetailModal__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_patient_SearchParticipantModal_vue__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var tableScreenerName = 'Screeners';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-slots',
  components: {
    AddParticipantModal: __WEBPACK_IMPORTED_MODULE_1__components_modal_patient_AddParticipantModal_vue__["a" /* default */],
    PatientDetailModal: __WEBPACK_IMPORTED_MODULE_2__components_modal_patient_PatientDetailModal__["a" /* default */],
    SearchParticipantModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_patient_SearchParticipantModal_vue__["a" /* default */]
  },
  props: {
    eventDetail: {
      required: true
    },
    eventId: 0,
    addOns: '',
    title: '',
    maxValueStaff: 0,
    fluShot: null
  },
  data: function data() {
    return {
      selectedItems: [],
      selectedItemIds: [],
      selectedRows: [],
      selectedColumns: [],
      numberColumn: 0,
      startColumn: 0,
      numberShowColumn: 0,
      slotsGroup: {},
      maxParticipantPerSlot: 0,
      numberSlotCustom: 1,
      participant: {
        firstName: '',
        lastName: '',
        email: '',
        employeeId: '',
        hasBiometric: false,
        hasFluShot: 0
      },
      fromBiometric: true,
      isCovidVaccine: false,
      isCovidFluShots: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    updateEventStaffing: 'ACTION_BLOCK_OPEN_STAFFING',
    clearSlot: 'ACTION_CLEAR_SLOT',
    updateMaxNumberFluShot: 'UPDATE_MAX_NUMBER_FLU_SHOT'
  }), {
    requestUpdateTable: function requestUpdateTable() {
      this.$emit('RELOAD_TABLE_STAFFING');
    },
    updateCustomSlotFluShot: function updateCustomSlotFluShot() {
      var _this = this;

      if (isNaN(this.eventDetail.maxParticipantPerSlot)) {
        this.$toast.success('Slots is not a number.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
        return;
      }
      var body = {
        eventId: this.eventId,
        maxParticipantPerFluShot: this.eventDetail.maxParticipantPerSlot
      };
      this.updateMaxNumberFluShot(body).then(function (response) {
        _this.$toast.success('Update successfully', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
        response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.eventDetail, {
          eventSlotGroupsFLuShotOnly: response.eventSlotGroupsFLuShotOnly,
          maxParticipantPerSlot: _this.eventDetail.maxParticipantPerSlot
        });
        _this.renderEventStaffing(response);
      }).catch(function (e) {
        console.log(e);
      });
    },
    blockOpenStaffing: function blockOpenStaffing(isBlock) {
      var _this2 = this;

      var body = [];
      this.selectedItems.forEach(function (item) {
        body.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          status: isBlock ? 'BLOCKED' : 'OPEN'
        }));
      });
      this.updateEventStaffing(body).then(function (response) {
        if (response.message === null) {
          _this2.$toast.success('Update successfully', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optSuccess));
          _this2.selectedItems.forEach(function (item) {
            item.status = isBlock ? 'BLOCKED' : 'OPEN';
          });
        } else {
          _this2.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optError));
        }
      });
    },
    renderEventStaffing: function renderEventStaffing(eventDetail) {
      this.selectedItems = [];
      this.selectedItemIds = [];
      this.selectedRows = [];
      this.selectedColumns = [];
      this.eventDetail = eventDetail;
      var containerElm = document.getElementById('s-container-' + this.title);
      if (!containerElm) {
        return;
      }
      var width = containerElm.offsetWidth;
      // 105 = width of screener staffing cell
      this.numberColumn = 0;
      this.slotsGroup = [];
      this.numberShowColumn = Math.floor((width - 80) / 105);
      if (this.eventDetail.eventSlotGroups.length && this.title === 'Screeners') {
        this.numberColumn = this.eventDetail.eventSlotGroups[0].eventSlots.length;
        this.slotsGroup = this.eventDetail.eventSlotGroups;
      } else if (this.eventDetail.eventSlotGroupsFLuShotOnly && this.eventDetail.eventSlotGroupsFLuShotOnly.length && this.title === 'Slots') {
        this.numberColumn = this.eventDetail.eventSlotGroupsFLuShotOnly[0].eventSlots.length; // this.eventDetail.eventSlotGroupsFLuShotOnly[0].eventSlots.length;
        this.slotsGroup = this.eventDetail.eventSlotGroupsFLuShotOnly;
        // Flu Shot/Covid Shot Slots Management
        if (this.addOns !== undefined) {
          if (this.addOns.includes('covidVaccine')) {
            this.isCovidVaccine = true;
          } else if (this.addOns.includes('covidFluShots')) {
            this.isCovidFluShots = true;
          }
        }
      }
    },
    blockOpenThisStaffing: function blockOpenThisStaffing(eventSlot) {
      this.selectedItems = [];
      this.selectedItemIds = [];
      var isBlock = eventSlot.status !== 'BLOCKED';
      this.toggleSelect(eventSlot);
      this.blockOpenStaffing(isBlock);
    },
    toggleSelect: function toggleSelect(eventSlot) {
      var index = this.selectedItemIds.indexOf(eventSlot.id + '-' + eventSlot.screenerNumber);
      if (index < 0) {
        this.selectedItemIds.push(eventSlot.id + '-' + eventSlot.screenerNumber);
      } else {
        this.selectedItemIds.splice(index, 1);
      }
      index = this.selectedItems.indexOf(eventSlot);
      if (index < 0) {
        this.selectedItems.push(eventSlot);
      } else {
        this.selectedItems.splice(index, 1);
      }
    },
    clearSingleSlot: function clearSingleSlot(updateObj) {
      var _this3 = this;

      this.requestUpdateTable();
      this.clearSlot(updateObj.eventSlot).then(function (response) {
        if (response.message) {
          _this3.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optError));
        } else {
          if (response.eventSlotDto.fluShot) {
            _this3.eventDetail.eventSlotGroupsFLuShotOnly[updateObj.index.time].eventSlots[updateObj.index.slot] = response.eventSlotDto || [];
          } else {
            _this3.eventDetail.eventSlotGroups[updateObj.index.time].eventSlots[updateObj.index.slot] = response.eventSlotDto || [];
          }

          _this3.renderEventStaffing(_this3.eventDetail);
          _this3.$toast.success('Removed successfully', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optSuccess));
          // No need pop-up to show
          // this.$toastr('success', 'Update event successful!', '');
        }
      });
    },
    showPatientDetails: function showPatientDetails(patientDetail) {
      if (patientDetail !== null && patientDetail !== undefined) {
        this.$modal.show('patientDetailModal', patientDetail);
      }
    },
    addParticipant: function addParticipant(slot) {
      var fromBiometric = this.title === tableScreenerName;
      slot = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        isEdit: false,
        fromBiometric: fromBiometric,
        hasFluShot: 0,
        hasBiometric: false
      }, slot);
      // this.$modal.show('modalAddParticipant', slot);
      this.$modal.show('modalSearchParticipant', { eventId: this.eventId, participant: slot, eventDetail: this.eventDetail, fluShot: this.fluShot });
    },
    editParticipant: function editParticipant(slot) {
      // this.participant = {...slot};
      // this.fromBiometric = false;
      slot = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        isEdit: true
      }, slot);
      // this.$modal.show('modalAddParticipant', slot);
      this.$modal.show('modalAddParticipant', { eventId: this.eventId, slot: slot, eventDetail: this.eventDetail });
    },
    toggleSelectRow: function toggleSelectRow(index, eventSlots) {
      var indexRow = this.selectedRows.indexOf(index);
      if (indexRow < 0) {
        this.selectedRows.push(index);
        this.toggleAddRow(true, eventSlots);
      } else {
        this.selectedRows.splice(indexRow, 1);
        this.toggleAddRow(false, eventSlots);
      }
    },
    toggleSelectColumn: function toggleSelectColumn(index, eventSlotGroups) {
      var indexColumn = this.selectedColumns.indexOf(index);
      if (indexColumn < 0) {
        this.selectedColumns.push(index);
        this.toggleAddColumn(true, index, eventSlotGroups);
      } else {
        this.selectedColumns.splice(indexColumn, 1);
        this.toggleAddColumn(false, index, eventSlotGroups);
      }
    },
    toggleAddColumn: function toggleAddColumn(isAdd, indexColumn, eventSlotGroups) {
      var _this4 = this;

      if (isAdd) {
        eventSlotGroups.forEach(function (item) {
          var eventSlots = item.eventSlots;
          var selectedItem = eventSlots[indexColumn];
          if (!selectedItem) {
            return;
          }
          var index = _this4.selectedItemIds.indexOf(selectedItem.id + '-' + selectedItem.screenerNumber);
          if (index < 0) {
            _this4.selectedItemIds.push(selectedItem.id + '-' + selectedItem.screenerNumber);
          }
          index = _this4.selectedItems.indexOf(selectedItem);
          if (index < 0) {
            _this4.selectedItems.push(selectedItem);
          }
        });
      } else {
        eventSlotGroups.forEach(function (item) {
          var eventSlots = item.eventSlots;
          var selectedItem = eventSlots[indexColumn];
          if (!selectedItem) {
            return;
          }
          var index = _this4.selectedItemIds.indexOf(selectedItem.id + '-' + selectedItem.screenerNumber);
          if (index >= 0) {
            _this4.selectedItemIds.splice(index, 1);
          }
          index = _this4.selectedItems.indexOf(selectedItem);
          if (index >= 0) {
            _this4.selectedItems.push(selectedItem);
          }
        });
      }
    },
    toggleAddRow: function toggleAddRow(isAdd, eventSlots) {
      var _this5 = this;

      if (isAdd) {
        eventSlots.forEach(function (item) {
          var index = _this5.selectedItemIds.indexOf(item.id + '-' + item.screenerNumber);
          if (index < 0) {
            _this5.selectedItemIds.push(item.id + '-' + item.screenerNumber);
          }
          index = _this5.selectedItems.indexOf(item);
          if (index < 0) {
            _this5.selectedItems.push(item);
          }
        });
      } else {
        eventSlots.forEach(function (item) {
          var index = _this5.selectedItemIds.indexOf(item.id + '-' + item.screenerNumber);
          if (index >= 0) {
            _this5.selectedItemIds.splice(index, 1);
          }
          index = _this5.selectedItems.indexOf(item);
          if (index >= 0) {
            _this5.selectedItems.splice(index, 1);
          }
        });
      }
    },
    moveLeft: function moveLeft() {
      this.startColumn--;
      if (this.startColumn < 0) {
        this.startColumn = 0;
      }
    },
    moveRight: function moveRight() {
      if (this.startColumn + this.numberShowColumn < this.numberColumn) {
        this.startColumn++;
      }
    },
    onAddOrRemoveScreener: function onAddOrRemoveScreener(value) {
      this.$emit('add-remove-staff', {
        eventStaffRole: 'screener',
        addStaff: value,
        addStaffScreener: false
      });
    }
  }),
  computed: {},
  mounted: function mounted() {}
});

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddParticipantModal_vue__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272443d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddParticipantModal_vue__ = __webpack_require__(1714);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1706)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-272443d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddParticipantModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272443d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AddParticipantModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/patient/AddParticipantModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AddParticipantModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-272443d6", Component.options)
  } else {
    hotAPI.reload("data-v-272443d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1707);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b8c21334", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-272443d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddParticipantModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-272443d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddParticipantModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.custom-modal .modal-padding[data-v-272443d6] {\n  padding: 26px 24px 30px 24px;\n}\n.custom-modal .modal-padding .modal-close-img[data-v-272443d6] {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer;\n}\n.custom-modal .modal-padding .modal-close-img .icon-close[data-v-272443d6] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  background: url(" + __webpack_require__(23) + ");\n}\n.custom-modal .modal-padding .first-name-and-last-name-text-box[data-v-272443d6] {\n  height: 48px;\n  width: 266px;\n  border: 1px solid #8E8E8E;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0);\n}\n.custom-modal .modal-padding .email-text-box[data-v-272443d6] {\n  height: 48px;\n  width: 369px;\n  border: 1px solid #8E8E8E;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0);\n}\n.custom-modal .modal-padding .employee-text-box[data-v-272443d6] {\n  height: 48px;\n  width: 162px;\n  border: 1px solid #8E8E8E;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0);\n}\n.custom-modal .modal-padding .title[data-v-272443d6] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n.custom-modal .modal-padding .text[data-v-272443d6] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  height: 45px;\n}\n", ""]);

// exports


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validators_ValidatorField_vue__ = __webpack_require__(1709);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// const _ = require('lodash');
// import constant from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modalAddParticipant',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    Validator: __WEBPACK_IMPORTED_MODULE_6__validators_ValidatorField_vue__["a" /* default */]
  },
  props: {
    requestUpdateTable: {
      type: Function
    }
  },
  data: function data() {
    return {
      slot: {},
      eventDetail: {},
      participant: {
        firstName: '',
        lastName: '',
        email: '',
        dob: '',
        employeeId: '',
        gender: '',
        hasBiometric: false,
        hasFluShot: 0
      },
      fromBiometric: true,
      isEdit: false,
      validators: {},
      isValid: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    onClickChild: function onClickChild(data) {
      this.isValid = data.isValid;
      this.participant = data;
    },
    hideModal: function hideModal() {
      if (this.participant) {
        // this.slot.eventParticipants = {};
      }
      this.$modal.hide('modalAddParticipant');
    },
    beforeOpen: function beforeOpen(obj) {
      var _this = this;

      var data = obj.params;
      this.slot = data.slot;
      this.eventDetail = data.eventDetail;
      this.isEdit = this.slot.isEdit;
      this.fromBiometric = this.slot.fromBiometric;
      this.participant.hasBiometric = this.slot.hasBiometric;
      this.participant.hasFluShot = this.slot.hasFluShot;
      this.getValidatorsByEventId(data.eventId).then(function (response) {
        _this.validators = response.validators;
      });
      if (this.slot.eventParticipants && this.slot.eventParticipants.length > 0) {
        var part = this.slot.eventParticipants[0];
        this.participant = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, part);
      }
    },
    beforeClose: function beforeClose() {
      this.participant = {};
    },
    addOrEditParticipant: function addOrEditParticipant() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var that, i, body;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this2;
                i = 0;

              case 2:
                if (!(i < that.$refs.formValidation.length)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return that.$refs.formValidation[i].validateData().then(function (result) {
                  if (!result) {
                    that.isValid = result;
                  }
                });

              case 5:
                i++;
                _context.next = 2;
                break;

              case 8:
                if (that.isValid) {
                  // check if all fields are not empty
                  if (that.slot.eventParticipants === null) {
                    that.slot.eventParticipants = [that.participant];
                  } else {
                    that.slot.eventParticipants[0] = that.participant;
                  }
                  body = {
                    slotId: that.slot.id,
                    eventId: that.slot.eventId,
                    hasBiometric: that.participant.hasBiometric === true,
                    hasFluShot: that.participant.hasFluShot,
                    eventParticipant: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, that.participant),
                    isUpdating: _this2.isEdit
                  };

                  that.addParticipant(body).then(function (response) {
                    // that.updateSlot(response);
                    if (!(response.statusCodes === 'BAD_REQUEST') && !response.message) {
                      _this2.$toast.success('Successfully adding participant.', '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optSuccess));
                      _this2.$modal.hide('modalAddParticipant');
                      that.requestUpdateTable();
                    } else {
                      _this2.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optError));
                    }
                  });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    updateSlot: function updateSlot(res) {
      // this function may not be used in the future
      if (res.message !== null) {
        this.slot.eventParticipants = {};
        this.$toast.success(res.message, '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
      } else {
        var slotDto = res.eventSlotDto;
        this.slot.eventParticipants = slotDto.eventParticipants;
        this.slot.status = slotDto.status;
        this.slot.numParticipant = slotDto.numParticipant;
        this.$toast.success('Successfully adding participant.', '', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optSuccess));
        this.$modal.hide('modalAddParticipant');
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    addParticipant: 'ACTION_ADD_PARTICIPANT',
    getValidatorsByEventId: 'ACTION_GET_VALIDATORS_BY_EVENT_ID'
  }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])({})),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    getIsLoadingModal: 'GETTER_IS_LOADING_MODAL'
  }))
});

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidatorField_vue__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f9e1b08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ValidatorField_vue__ = __webpack_require__(1713);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1710)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f9e1b08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidatorField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f9e1b08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ValidatorField_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/validators/ValidatorField.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ValidatorField.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9f9e1b08", Component.options)
  } else {
    hotAPI.reload("data-v-9f9e1b08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("84b042d2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9f9e1b08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ValidatorField.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9f9e1b08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ValidatorField.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import constant from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'validator-field',
  components: {},
  props: {
    validator: {},
    participant: {}
  },
  data: function data() {
    return {
      firstName: ''
    };
  },

  directives: { 'the-mask': __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["mask"] },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    blurFunc: function blurFunc() {
      var _this = this;

      this.$validator.validate().then(function (result) {
        if (!result) {
          _this.participant.isValid = false;
          _this.$emit('clicked', _this.participant);
          return;
        }
        _this.participant.isValid = true;
        _this.$emit('clicked', _this.participant);
      });
    },
    validateData: function validateData() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$validator.validate().then(function (valid) {
          resolve(valid);
        });
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({}), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({})),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({}))
});

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ap-field-input-wrapper" }, [
    _c("div", { staticClass: "title-field" }, [
      _vm._v(_vm._s(_vm.validator.name))
    ]),
    _vm._v(" "),
    _vm.validator.name !== "Email" &&
    _vm.validator.name !== "Phone" &&
    _vm.validator.name !== "Card Code"
      ? _c("div", { staticClass: "ap-input-wrapper" }, [
          _vm.validator.type === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.participant[_vm.validator.frontEndField],
                    expression: "participant[validator.frontEndField]"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "input field-input",
                attrs: {
                  "data-vv-as": _vm.validator.name,
                  name: _vm.validator.frontEndField,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(
                    _vm.participant[_vm.validator.frontEndField]
                  )
                    ? _vm._i(
                        _vm.participant[_vm.validator.frontEndField],
                        null
                      ) > -1
                    : _vm.participant[_vm.validator.frontEndField]
                },
                on: {
                  blur: function($event) {
                    _vm.blurFunc()
                  },
                  change: function($event) {
                    var $$a = _vm.participant[_vm.validator.frontEndField],
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.participant,
                            _vm.validator.frontEndField,
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.participant,
                            _vm.validator.frontEndField,
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(
                        _vm.participant,
                        _vm.validator.frontEndField,
                        $$c
                      )
                    }
                  }
                }
              })
            : _vm.validator.type === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.participant[_vm.validator.frontEndField],
                    expression: "participant[validator.frontEndField]"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "input field-input",
                attrs: {
                  "data-vv-as": _vm.validator.name,
                  name: _vm.validator.frontEndField,
                  type: "radio"
                },
                domProps: {
                  checked: _vm._q(
                    _vm.participant[_vm.validator.frontEndField],
                    null
                  )
                },
                on: {
                  blur: function($event) {
                    _vm.blurFunc()
                  },
                  change: function($event) {
                    _vm.$set(_vm.participant, _vm.validator.frontEndField, null)
                  }
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.participant[_vm.validator.frontEndField],
                    expression: "participant[validator.frontEndField]"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "input field-input",
                attrs: {
                  "data-vv-as": _vm.validator.name,
                  name: _vm.validator.frontEndField,
                  type: _vm.validator.type
                },
                domProps: {
                  value: _vm.participant[_vm.validator.frontEndField]
                },
                on: {
                  blur: function($event) {
                    _vm.blurFunc()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.participant,
                      _vm.validator.frontEndField,
                      $event.target.value
                    )
                  }
                }
              })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name !== "Email" &&
    _vm.validator.name !== "Phone" &&
    _vm.validator.name !== "Card Code"
      ? _c("div", { staticClass: "error-message" }, [
          _vm._v(_vm._s(_vm.errors.first(_vm.validator.frontEndField)))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name === "Email"
      ? _c("div", { staticClass: "ap-input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.participant[_vm.validator.frontEndField],
                expression: "participant[validator.frontEndField]"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|email",
                expression: "'required|email'"
              }
            ],
            staticClass: "input field-input",
            attrs: {
              type: "text",
              "data-vv-as": "email",
              name: _vm.validator.frontEndField,
              placeholder: "sample@email.com"
            },
            domProps: { value: _vm.participant[_vm.validator.frontEndField] },
            on: {
              blur: function($event) {
                _vm.blurFunc()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.participant,
                  _vm.validator.frontEndField,
                  $event.target.value
                )
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name === "Email"
      ? _c("div", { staticClass: "error-message" }, [
          _vm._v(_vm._s(_vm.errors.first(_vm.validator.frontEndField)))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name === "Card Code"
      ? _c("div", { staticClass: "ap-input-wrapper" }, [
          _vm.validator.type === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.participant[_vm.validator.frontEndField],
                    expression: "participant[validator.frontEndField]"
                  },
                  { name: "validate", rawName: "v-validate" }
                ],
                staticClass: "input field-input",
                attrs: {
                  "data-vv-as": _vm.validator.name,
                  name: _vm.validator.frontEndField,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(
                    _vm.participant[_vm.validator.frontEndField]
                  )
                    ? _vm._i(
                        _vm.participant[_vm.validator.frontEndField],
                        null
                      ) > -1
                    : _vm.participant[_vm.validator.frontEndField]
                },
                on: {
                  blur: function($event) {
                    _vm.blurFunc()
                  },
                  change: function($event) {
                    var $$a = _vm.participant[_vm.validator.frontEndField],
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.participant,
                            _vm.validator.frontEndField,
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.participant,
                            _vm.validator.frontEndField,
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(
                        _vm.participant,
                        _vm.validator.frontEndField,
                        $$c
                      )
                    }
                  }
                }
              })
            : _vm.validator.type === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.participant[_vm.validator.frontEndField],
                    expression: "participant[validator.frontEndField]"
                  },
                  { name: "validate", rawName: "v-validate" }
                ],
                staticClass: "input field-input",
                attrs: {
                  "data-vv-as": _vm.validator.name,
                  name: _vm.validator.frontEndField,
                  type: "radio"
                },
                domProps: {
                  checked: _vm._q(
                    _vm.participant[_vm.validator.frontEndField],
                    null
                  )
                },
                on: {
                  blur: function($event) {
                    _vm.blurFunc()
                  },
                  change: function($event) {
                    _vm.$set(_vm.participant, _vm.validator.frontEndField, null)
                  }
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.participant[_vm.validator.frontEndField],
                    expression: "participant[validator.frontEndField]"
                  },
                  { name: "validate", rawName: "v-validate" }
                ],
                staticClass: "input field-input",
                attrs: {
                  "data-vv-as": _vm.validator.name,
                  name: _vm.validator.frontEndField,
                  type: _vm.validator.type
                },
                domProps: {
                  value: _vm.participant[_vm.validator.frontEndField]
                },
                on: {
                  blur: function($event) {
                    _vm.blurFunc()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.participant,
                      _vm.validator.frontEndField,
                      $event.target.value
                    )
                  }
                }
              })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name === "Email"
      ? _c("div", { staticClass: "error-message" }, [
          _vm._v(_vm._s(_vm.errors.first(_vm.validator.frontEndField)))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name === "Phone"
      ? _c("div", { staticClass: "ap-input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "the-mask",
                rawName: "v-the-mask",
                value: "+1(###)-###-####",
                expression: "'+1(###)-###-####'"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.participant[_vm.validator.frontEndField],
                expression: "participant[validator.frontEndField]"
              }
            ],
            staticClass: "input field-input",
            attrs: {
              name: "phone",
              type: "text",
              placeholder: "+1(###)-###-####"
            },
            domProps: { value: _vm.participant[_vm.validator.frontEndField] },
            on: {
              blur: function($event) {
                _vm.blurFunc()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.participant,
                  _vm.validator.frontEndField,
                  $event.target.value
                )
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validator.name === "Phone"
      ? _c("div", { staticClass: "error-message" }, [
          _vm._v(_vm._s(_vm.errors.first(_vm.validator.frontEndField)))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9f9e1b08", esExports)
  }
}

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal add-participant-modal",
      attrs: {
        name: "modalAddParticipant",
        width: "605px",
        height: "auto",
        scrollable: true,
        clickToClose: false
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "modal-padding" },
        [
          _c(
            "div",
            {
              staticClass: "modal-close-img",
              on: {
                click: function($event) {
                  _vm.hideModal()
                }
              }
            },
            [_c("div", { staticClass: "icon-close" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("add participant")]),
          _vm._v(" "),
          _vm._l(_vm.validators, function(validator, index) {
            return _c("div", { staticClass: "participant-info" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("Validator", {
                      ref: "formValidation",
                      refInFor: true,
                      attrs: {
                        validator: validator,
                        participant: _vm.participant
                      },
                      on: { clicked: _vm.onClickChild }
                    })
                  ],
                  1
                )
              ])
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "btn-add-container" }, [
            _c(
              "button",
              {
                staticClass: "ap-btn secondary btn-cancel",
                on: { click: _vm.hideModal }
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ap-btn primary btn-add-participant",
                attrs: { disabled: !_vm.isValid },
                on: { click: _vm.addOrEditParticipant }
              },
              [_vm._v(_vm._s(_vm.isEdit ? "Update" : "Add"))]
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-272443d6", esExports)
  }
}

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchParticipantModal_vue__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cbc7750_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SearchParticipantModal_vue__ = __webpack_require__(1726);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1716)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cbc7750"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchParticipantModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cbc7750_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SearchParticipantModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/patient/SearchParticipantModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SearchParticipantModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1cbc7750", Component.options)
  } else {
    hotAPI.reload("data-v-1cbc7750", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5e3383b2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1cbc7750\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SearchParticipantModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1cbc7750\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SearchParticipantModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.custom-modal .modal-padding[data-v-1cbc7750] {\n  padding: 26px 24px 30px 24px;\n}\n.custom-modal .modal-padding .modal-close-img[data-v-1cbc7750] {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer;\n}\n.custom-modal .modal-padding .modal-close-img .icon-close[data-v-1cbc7750] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  mask: url(" + __webpack_require__(118) + ") no-repeat center;\n  background: url(" + __webpack_require__(23) + ");\n}\n.custom-modal .modal-padding .first-name-and-last-name-text-box[data-v-1cbc7750] {\n  height: 48px;\n  width: 266px;\n  border: 1px solid #8E8E8E;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0);\n}\n.custom-modal .modal-padding .email-text-box[data-v-1cbc7750] {\n  height: 48px;\n  width: 369px;\n  border: 1px solid #8E8E8E;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0);\n}\n.custom-modal .modal-padding .employee-text-box[data-v-1cbc7750] {\n  height: 48px;\n  width: 162px;\n  border: 1px solid #8E8E8E;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0);\n}\n.custom-modal .modal-padding .title[data-v-1cbc7750] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n.custom-modal .modal-padding .text[data-v-1cbc7750] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  height: 45px;\n}\n.custom-modal .modal-padding .placeholder-italic[data-v-1cbc7750] {\n  width: 100%;\n  border: 1px solid #9b9b9b;\n  padding: 3px 15px;\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  border-radius: 3px;\n  background-color: #ffffff;\n}\n.custom-modal .modal-padding .search-icon[data-v-1cbc7750] {\n  width: 26px;\n  height: 26px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  position: absolute;\n  z-index: 999;\n  right: 26px;\n  top: 9px;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.custom-modal .modal-padding .btn-add-container[data-v-1cbc7750] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.custom-modal .modal-padding .btn-add-participant[data-v-1cbc7750] {\n  text-transform: uppercase;\n}\n.custom-modal .modal-padding .display-text[data-v-1cbc7750] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.custom-modal .employee-list-container[data-v-1cbc7750] {\n  padding-top: 24px;\n  padding-bottom: 40px;\n  margin-left: -16px;\n  margin-right: -16px;\n}\n.custom-modal .employee-list-container .list-header[data-v-1cbc7750] {\n  padding: 16px;\n  border-bottom: 1px solid #E6E6E6;\n}\n.custom-modal .employee-list-container .list-header .field-col[data-v-1cbc7750] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.custom-modal .employee-list-container .list-header .field-col .caption-text[data-v-1cbc7750] {\n  color: #D92C27;\n  font-weight: bold;\n  letter-spacing: 0.1px;\n}\n.custom-modal .employee-list-container .list-header .field-col .sort-icon[data-v-1cbc7750] {\n  margin-top: 8px;\n}\n.custom-modal .employee-list-container .list-participant-row .not-found-participant-checked-in[data-v-1cbc7750] {\n  color: #1D1D1D;\n  margin-left: 16px;\n}\n.custom-modal .employee-list-container .list-participant-row .not-found-participant-checked-in .search-text[data-v-1cbc7750] {\n  font-weight: bold;\n}\n.custom-modal .spinner-loading[data-v-1cbc7750] {\n  padding-top: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_commons_HeaderColumn_vue__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParticipantTableInfo_vue__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_loading_constants__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_commons_Spinner_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var _ = __webpack_require__(32);
// import constant from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modalSearchParticipant',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__["a" /* default */],
    HeaderColumn: __WEBPACK_IMPORTED_MODULE_1__components_commons_HeaderColumn_vue__["a" /* default */],
    ParticipantTableInfo: __WEBPACK_IMPORTED_MODULE_2__ParticipantTableInfo_vue__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_commons_Spinner_vue__["a" /* default */]
  },
  props: {
    requestUpdateTable: {
      type: Function
    }
  },
  data: function data() {
    return {
      eventDetail: {},
      eventId: 0,
      participant: {},
      searchText: '',
      slot: {},
      loadingConstants: __WEBPACK_IMPORTED_MODULE_3__store_loading_constants__["a" /* default */],
      arrHeaderObj: [{
        internalName: 'fullName',
        displayName: 'NAME'
      }, {
        internalName: 'email',
        displayName: 'EMAIL'
      }, {
        internalName: 'employeeId',
        displayName: 'EMPLOYEE ID'
      }],
      sortObject: {
        fieldName: '',
        reverse: false
      },
      filledSlots: [],
      isEnableButton: false,
      isShowingText: false,
      isFoundParticipant: false,
      fromBiometric: false,
      fluShot: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    hideModal: function hideModal() {
      this.searchText = '';
      this.isFoundParticipant = false;
      this.filledSlots = [];
      this.$modal.hide('modalSearchParticipant');
    },
    beforeOpen: function beforeOpen(obj) {
      this.eventDetail = obj.params.eventDetail;
      this.eventId = obj.params.eventId;
      this.slot = obj.params.participant;
      this.fromBiometric = this.slot.fromBiometric;
      this.slot.hasFluShot = 0;
      this.slot.hasBiometric = false;
      this.isEnableButton = localStorage.getItem('IS_ADDED_PARTICIPANT');
      this.fluShot = obj.params.fluShot;
    },
    beforeClose: function beforeClose() {},
    getParticipant: function getParticipant(keyword) {
      var _this = this;

      var params = {
        params: {
          eventId: this.eventId,
          searchString: keyword && keyword.length >= 0 ? keyword : this.searchText
        }
      };
      this.searchParticipant(params).then(function (response) {
        _this.isShowingText = true;
        if (response && (response.statusCode === 'BAD_REQUEST' || response.statusCode === 'NOT_FOUND')) {
          // return if there is message found
          _this.isFoundParticipant = false;
          _this.filledSlots = [];
          return;
        }
        _this.isFoundParticipant = true;
        response.filledSlots.forEach(function (el) {
          el.fullName = el.firstName + ' ' + el.lastName;
        });
        _this.filledSlots = response.filledSlots;
        // this.resetSortObject();
      }).catch(function (error) {
        console.log('error=', error);
      });
    },
    addNewParticipant: function addNewParticipant() {
      this.searchText = '';
      this.isFoundParticipant = false;
      this.filledSlots = [];
      this.$modal.hide('modalSearchParticipant');
      var body = {
        eventId: this.eventId,
        slot: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.slot, {
          hasFluShot: this.slot.hasFluShot ? this.fluShot : 0
        }),
        eventDetail: this.eventDetail
      };
      this.$modal.show('modalAddParticipant', body);
    },
    resetSortObject: function resetSortObject() {
      this.sortObject = {
        fieldName: '',
        reverse: false
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])({
    addParticipant: 'ACTION_ADD_PARTICIPANT',
    searchParticipant: 'ACTION_SEARCH_PARTICIPANT'
  }), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapMutations */])({})),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
    getIsLoadingParticipant: 'GETTER_IS_LOADING_PARTICIPANT'
  })),
  watch: {
    searchText: _.debounce(function () {
      var keyword = this.searchText.trim();
      if (keyword.length >= 2 || keyword.length === 0) {
        this.getParticipant(keyword);
      }
    }, 700)
  }
});

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

// import routerConstants from '@/router/constants';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header-column',
  props: {
    headerObject: {
      type: Object,
      required: true
    },
    sortObject: {
      type: Object,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      urlConsts: ''
    };
  },

  methods: {
    handleClick: function handleClick() {
      var sortOption = {
        fieldName: this.headerObject.internalName
      };
      this.$emit('CHANGE_SORT_OPTION', sortOption);
    }
  },
  computed: {
    getIconSort: function getIconSort() {
      var iconName = 'sort-solid.svg';
      if (this.sortObject.fieldName === this.headerObject.internalName) {
        iconName = this.sortObject.reverse ? 'sort-up-solid.svg' : 'sort-down-solid.svg';
      }
      return 'url(\'/static/images/' + iconName + '\') no-repeat center';
    },
    getIconClassName: function getIconClassName() {
      var className = 'non-sort';
      if (this.sortObject.fieldName === this.headerObject.internalName) {
        className = this.sortObject.reverse ? 'sort-up' : 'sort-down';
      }
      return className;
    }
  }
});

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "participant-header-column field-col" }, [
    _c("div", { staticClass: "content", on: { click: _vm.handleClick } }, [
      _c("div", { staticClass: "caption-text" }, [
        _vm._v(_vm._s(_vm.headerObject.displayName))
      ]),
      _vm._v(" "),
      _vm.showIcon
        ? _c("div", { staticClass: "icon-sort", class: [_vm.getIconClassName] })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8bd26b18", esExports)
  }
}

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipantTableInfo_vue__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b55cea02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipantTableInfo_vue__ = __webpack_require__(1725);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1722)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b55cea02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipantTableInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b55cea02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipantTableInfo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/patient/ParticipantTableInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ParticipantTableInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b55cea02", Component.options)
  } else {
    hotAPI.reload("data-v-b55cea02", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1723);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("37a4f05e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b55cea02\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ParticipantTableInfo.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b55cea02\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ParticipantTableInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.participant-info-row[data-v-b55cea02] {\n  padding: 0 16px;\n  border-bottom: 1px solid #E6E6E6;\n  background-color: white;\n}\n.participant-info-row .field-value[data-v-b55cea02] {\n  color: #1D1D1D;\n  height: 72px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.participant-info-row .field-email-wrapper .field-email[data-v-b55cea02] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n}\n.participant-info-row .add-participant[data-v-b55cea02] {\n  width: 83px;\n  height: 32px;\n  margin-top: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import constant from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'patientDetail',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    participant: {},
    slot: {},
    requestUpdateTable: {
      type: Function
    },
    fluShot: 0
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addParticipantBtn: function addParticipantBtn() {
      var _this = this;

      if (this.slot.eventParticipants === null) {
        this.slot.eventParticipants = [this.participant];
      } else {
        this.slot.eventParticipants[0] = this.participant;
      }
      var body = {
        slotId: this.slot.id,
        eventId: this.slot.eventId,
        hasBiometric: this.slot.hasBiometric === true,
        hasFluShot: this.slot.hasFluShot ? this.fluShot : 0,
        eventParticipant: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.participant)
      };
      this.addParticipant(body).then(function (response) {
        _this.updateSlot(response);
        if (response.statusCodes !== 'BAD_REQUEST' && !response.message) {
          _this.requestUpdateTable();
        }
      });
    },
    updateSlot: function updateSlot(res) {
      if (res.message !== null) {
        this.slot.eventParticipants = {};
        this.$toast.success(res.message, '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
      } else {
        var slotDto = res.eventSlotDto;
        this.slot.eventParticipants = slotDto.eventParticipants;
        this.slot.status = slotDto.status;
        this.slot.numParticipant = slotDto.numParticipant;
        this.$toast.success('Successfully adding participant.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optSuccess));
        this.$modal.hide('modalSearchParticipant');
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    addParticipant: 'ACTION_ADD_PARTICIPANT'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    //  setIsLoading: 'MUTATION_SET_IS_LOADING'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getIsLoadingModal: 'GETTER_IS_LOADING_MODAL'
  }))
});

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "participant-info-row" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "field-value body-text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.participant.firstName) +
              " " +
              _vm._s(_vm.participant.lastName) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "div",
          { staticClass: "field-value body-text field-email-wrapper" },
          [
            _c("div", { staticClass: "field-email" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.participant.email) + "\n        "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "field-value body-text" }, [
          _vm._v("\n        " + _vm._s(_vm.participant.employeeId) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [
        _c("div", {}, [
          _c(
            "button",
            {
              staticClass: "ap-btn primary add-participant",
              on: { click: _vm.addParticipantBtn }
            },
            [_vm._v("ADD")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b55cea02", esExports)
  }
}

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal add-participant-modal",
      attrs: {
        name: "modalSearchParticipant",
        width: "605px",
        height: "auto",
        scrollable: true,
        clickToClose: false
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-padding" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              }
            }
          },
          [_c("div", { staticClass: "icon-close" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("add participant")]),
        _vm._v(" "),
        _c("div", { staticClass: "participant-info" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "title-field" }, [
                _vm._v("Search for existing participant")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "checkbox-container" },
                [
                  !_vm.fromBiometric
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group add-more-services-checkbox",
                          model: {
                            value: _vm.slot.hasBiometric,
                            callback: function($$v) {
                              _vm.$set(_vm.slot, "hasBiometric", $$v)
                            },
                            expression: "slot.hasBiometric"
                          }
                        },
                        [_vm._v("Add biometric screening")]
                      )
                    : _vm.fromBiometric &&
                      _vm.eventDetail.eventSlotGroupsFLuShotOnly.length > 0
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group add-more-services-checkbox",
                          model: {
                            value: _vm.slot.hasFluShot,
                            callback: function($$v) {
                              _vm.$set(_vm.slot, "hasFluShot", $$v)
                            },
                            expression: "slot.hasFluShot"
                          }
                        },
                        [
                          _vm.fluShot == 1
                            ? [_vm._v("Add flu shot")]
                            : _vm.fluShot == 2
                            ? [_vm._v("Add Covid Vaccine")]
                            : [_vm._v("Add Covid & Flu Shot")]
                        ],
                        2
                      )
                    : _c("span")
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText"
                  }
                ],
                staticClass: "placeholder-italic",
                attrs: {
                  placeholder: "Search by first name, last name or email"
                },
                domProps: { value: _vm.searchText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchText = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "search-icon" })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.getIsLoadingParticipant === _vm.loadingConstants.LOADING
          ? _c("div", { staticClass: "spinner-loading" }, [_c("Spinner")], 1)
          : _c("div", [
              _vm.filledSlots.length > 0
                ? _c("div", [
                    _c("div", { staticClass: "employee-list-container" }, [
                      _c("div", { staticClass: "list-header" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-3" },
                            [
                              _c("HeaderColumn", {
                                attrs: {
                                  headerObject: _vm.arrHeaderObj[0],
                                  sortObject: _vm.sortObject
                                },
                                on: {
                                  CHANGE_SORT_OPTION: _vm.handleChangeSortOption
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4" },
                            [
                              _c("HeaderColumn", {
                                attrs: {
                                  headerObject: _vm.arrHeaderObj[1],
                                  sortObject: _vm.sortObject
                                },
                                on: {
                                  CHANGE_SORT_OPTION: _vm.handleChangeSortOption
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-3" },
                            [
                              _c("HeaderColumn", {
                                attrs: {
                                  headerObject: _vm.arrHeaderObj[2],
                                  sortObject: _vm.sortObject
                                },
                                on: {
                                  CHANGE_SORT_OPTION: _vm.handleChangeSortOption
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("div", { staticClass: "field-col" }, [
                              _c("div", {
                                staticClass: "caption-text label-text"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-participant-row" }, [
                        _c(
                          "div",
                          [
                            _vm._l(_vm.filledSlots, function(p, index) {
                              return [
                                _c("ParticipantTableInfo", {
                                  key: index,
                                  attrs: {
                                    slot: _vm.slot,
                                    requestUpdateTable: _vm.requestUpdateTable,
                                    eventId: _vm.eventId,
                                    participant: p,
                                    fluShot: _vm.fluShot
                                  },
                                  slot: _vm.slot
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
        _vm._v(" "),
        _vm.isShowingText &&
        _vm.searchText &&
        _vm.getIsLoadingParticipant === _vm.loadingConstants.LOADED
          ? _c("div", { staticClass: "btn-add-container" }, [
              _vm.isEnableButton
                ? _c("div", { staticClass: "display-text" }, [
                    !_vm.isFoundParticipant
                      ? _c("div", [
                          _vm._v(
                            '\n          "' +
                              _vm._s(_vm.searchText) +
                              '" could not be found.'
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          You can create and add a participant to the slot.\n        "
                          )
                        ])
                      : _c("div", { staticClass: "display-text" }, [
                          _vm._v(
                            "\n          If the participant you are looking for is not listed."
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          You can create and add a new participant.\n        "
                          )
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "margin-top-24px" }, [
                      _c(
                        "button",
                        {
                          staticClass: "ap-btn primary btn-add-participant",
                          on: {
                            click: function($event) {
                              _vm.addNewParticipant()
                            }
                          }
                        },
                        [_vm._v("Create & Add Participant")]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "display-text" }, [
                    _vm._v(
                      '\n        "' +
                        _vm._s(_vm.searchText) +
                        '" could not be found.'
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        Please contact your HR representative to add the participant.\n      "
                    )
                  ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cbc7750", esExports)
  }
}

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-slots-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "row paddingTop27px margin-top-25px background-color-table"
        },
        [
          _c("div", { staticClass: "col-md-5" }, [
            _vm.title === "Screeners"
              ? _c("div", { staticClass: "title-header" }, [
                  _vm._v("Biometric Screening")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title === "Slots"
              ? _c("div", { staticClass: "title-header" }, [
                  _vm.fluShot === 1
                    ? _c("div", [_vm._v("Flu Shot")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fluShot === 2
                    ? _c("div", [_vm._v("Covid Vaccine")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fluShot === 3
                    ? _c("div", [_vm._v("Covid & Flu Shots")])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "block-open-wrapper group-btn" }, [
              _c(
                "button",
                {
                  staticClass: "ap-btn destructive",
                  on: {
                    click: function($event) {
                      _vm.blockOpenStaffing(true)
                    }
                  }
                },
                [_vm._v("Block all")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ap-btn primary",
                  on: {
                    click: function($event) {
                      _vm.blockOpenStaffing(false)
                    }
                  }
                },
                [_vm._v("Open all")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row number-slots-container" }, [
        _c("div", { staticClass: "col-md-12 number-slots-defautl" }, [
          _vm.title == "Screeners"
            ? _c("div", { staticClass: "col-md-12 for-screening body-text" }, [
                _c("p", { staticClass: "col-md-5" }, [
                  _vm._v("Screener Station (" + _vm._s(_vm.maxValueStaff) + ")")
                ]),
                _vm._v(" "),
                _vm.title == "Screeners"
                  ? _c(
                      "div",
                      { staticClass: "col-md-6 d-flex justify-content-end" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-minus",
                            on: {
                              click: function($event) {
                                _vm.onAddOrRemoveScreener(false)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: __webpack_require__(1728),
                                alt: "minus"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-add",
                            on: {
                              click: function($event) {
                                _vm.onAddOrRemoveScreener(true)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: __webpack_require__(1729),
                                alt: "add"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-1" })
              ])
            : _c("div", { staticClass: " col-md-12 for-flu-shot" }, [
                _c("div", { staticClass: "slots-count body-text" }, [
                  _vm._v(
                    "Slots (" +
                      _vm._s(_vm.eventDetail.maxParticipantPerSlot) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ap-field-input-wrapper" }, [
                  _c("div", { staticClass: "ap-input-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.eventDetail.maxParticipantPerSlot,
                          expression: "eventDetail.maxParticipantPerSlot"
                        }
                      ],
                      staticClass: "input body-text",
                      domProps: {
                        value: _vm.eventDetail.maxParticipantPerSlot
                      },
                      on: {
                        blur: _vm.updateCustomSlotFluShot,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.eventDetail,
                            "maxParticipantPerSlot",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row background-color-table" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "screener-table" }, [
            _c("div", { staticClass: "s-header" }, [
              _c("div", { staticClass: "s-header-wrapper" }, [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "s-container",
                      attrs: { id: "s-container-" + _vm.title }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "s-wrapper" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "icon-wrapper left",
                              on: {
                                click: function($event) {
                                  _vm.moveLeft()
                                }
                              }
                            },
                            [_c("div", { staticClass: "left-icon" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "icon-wrapper right",
                              on: {
                                click: function($event) {
                                  _vm.moveRight()
                                }
                              }
                            },
                            [_c("div", { staticClass: "right-icon" })]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticStyle: {
                              "min-width": "80px",
                              width: "80px",
                              float: "left",
                              height: "1px"
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.numberColumn, function(
                            slotHeaderNumber,
                            index
                          ) {
                            return slotHeaderNumber > _vm.startColumn &&
                              slotHeaderNumber <=
                                _vm.startColumn + _vm.numberShowColumn
                              ? _c("div", { staticClass: "s-header-column" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "staffing-select-column",
                                      class:
                                        _vm.selectedColumns.indexOf(index) >= 0
                                          ? "always-show"
                                          : null
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "custom-checkbox custom-control"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              type: "checkbox",
                                              autocomplete: "off"
                                            },
                                            domProps: {
                                              checked:
                                                _vm.selectedColumns.indexOf(
                                                  index
                                                ) >= 0
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.toggleSelectColumn(
                                                  index,
                                                  _vm.slotsGroup
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "custom-control-indicator",
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "custom-control-description"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(slotHeaderNumber) +
                                      "\n                  "
                                  )
                                ])
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "s-body" },
              _vm._l(_vm.slotsGroup, function(slotGroup, indexTime) {
                return _c("div", { staticClass: "s-body-row" }, [
                  _c("div", { staticClass: "row-wrapper" }, [
                    _c("div", { staticClass: "time-wrapper" }, [
                      _c("div", { staticClass: "s-body-time label-text" }, [
                        _c("span", {}, [_vm._v(_vm._s(slotGroup.timeString))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "staffing-select-row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "custom-checkbox custom-control",
                            class:
                              _vm.selectedRows.indexOf(indexTime) >= 0
                                ? "always-show"
                                : null
                          },
                          [
                            _c("input", {
                              staticClass: "custom-control-input",
                              attrs: { type: "checkbox", autocomplete: "off" },
                              domProps: {
                                checked:
                                  _vm.selectedRows.indexOf(indexTime) >= 0
                              },
                              on: {
                                click: function($event) {
                                  _vm.toggleSelectRow(
                                    indexTime,
                                    slotGroup.eventSlots
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "custom-control-indicator",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "custom-control-description"
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "slot-wrapper" }, [
                      _c("div", { staticClass: "s-container" }, [
                        _c(
                          "div",
                          {
                            staticClass: "s-wrapper s-body-wrapper",
                            class:
                              _vm.selectedRows.indexOf(indexTime) >= 0
                                ? "selected-staffing-item"
                                : null
                          },
                          _vm._l(slotGroup.eventSlots, function(
                            eventSlot,
                            indexSlot
                          ) {
                            return indexSlot >= _vm.startColumn &&
                              indexSlot < _vm.startColumn + _vm.numberShowColumn
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "s-body-item",
                                    class:
                                      _vm.selectedItemIds.indexOf(
                                        eventSlot.id +
                                          "-" +
                                          eventSlot.screenerNumber
                                      ) >= 0
                                        ? "selected-staffing-item"
                                        : "un-selected-staffing-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "staffing-check",
                                        class:
                                          _vm.selectedItemIds.indexOf(
                                            eventSlot.id +
                                              "-" +
                                              eventSlot.screenerNumber
                                          ) >= 0
                                            ? "always-show"
                                            : null
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "custom-checkbox custom-control"
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                type: "checkbox",
                                                autocomplete: "off"
                                              },
                                              domProps: {
                                                value: eventSlot.id,
                                                checked:
                                                  _vm.selectedItemIds.indexOf(
                                                    eventSlot.id +
                                                      "-" +
                                                      eventSlot.screenerNumber
                                                  ) >= 0
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.toggleSelect(eventSlot)
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "custom-control-indicator",
                                              attrs: { "aria-hidden": "true" }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "custom-control-description"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    eventSlot.eventParticipants != null &&
                                    eventSlot.eventParticipants.length
                                      ? _c("div", {
                                          staticClass: "bullet green"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.eventParticipants != null &&
                                    eventSlot.eventParticipants.length
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                eventSlot.eventParticipants[0]
                                                  .firstName
                                              ) +
                                              " " +
                                              _vm._s(
                                                eventSlot.eventParticipants[0]
                                                  .lastName
                                              ) +
                                              "\n                      "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "OPEN"
                                      ? _c("div", {
                                          staticClass: "bullet grey"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "OPEN"
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(_vm._s(eventSlot.status))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "BLOCKED"
                                      ? _c("div", { staticClass: "bullet red" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    eventSlot.status == "BLOCKED"
                                      ? _c("div", { staticClass: "text" }, [
                                          _vm._v(_vm._s(eventSlot.status))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "action-btn" }, [
                                      _c("div", { staticClass: "dot" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "dot" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "dot" }),
                                      _vm._v(" "),
                                      _c("ul", { staticClass: "action-menu" }, [
                                        eventSlot.status !== "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.blockOpenThisStaffing(
                                                      eventSlot
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      eventSlot.status ===
                                                        "BLOCKED"
                                                        ? "Open"
                                                        : "Block"
                                                    ) +
                                                    " slot\n                          "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.status === "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.clearSingleSlot({
                                                      eventSlot: eventSlot,
                                                      index: {
                                                        time: indexTime,
                                                        slot: indexSlot
                                                      }
                                                    })
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            Clear slot\n                          "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.eventParticipants == null ||
                                        eventSlot.eventParticipants.length === 0
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.showPatientDetails()
                                                  }
                                                }
                                              },
                                              [_vm._v("Details")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.eventParticipants != null &&
                                        eventSlot.eventParticipants.length
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.showPatientDetails(
                                                      eventSlot
                                                        .eventParticipants[0]
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Details")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.status !== "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.addParticipant(
                                                      eventSlot
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Add Participant")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        eventSlot.status === "BOOKED"
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.editParticipant(
                                                      eventSlot
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Edit Participant")]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e()
                          })
                        )
                      ])
                    ])
                  ])
                ])
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("PatientDetailModal"),
      _vm._v(" "),
      _c("AddParticipantModal", {
        attrs: { requestUpdateTable: _vm.requestUpdateTable }
      }),
      _vm._v(" "),
      _c("SearchParticipantModal", {
        attrs: { requestUpdateTable: _vm.requestUpdateTable }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-150c0a9d", esExports)
  }
}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDE2IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxLjUiIHJ4PSIwLjc1IiBmaWxsPSIjRTYxQzBBIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjI1IDcuMjVIOC43NVYwLjc1QzguNzUgMC41NTEwODggOC42NzA5OCAwLjM2MDMyMiA4LjUzMDMzIDAuMjE5NjdDOC4zODk2OCAwLjA3OTAxNzUgOC4xOTg5MSAwIDggMEM3LjgwMTA5IDAgNy42MTAzMiAwLjA3OTAxNzUgNy40Njk2NyAwLjIxOTY3QzcuMzI5MDIgMC4zNjAzMjIgNy4yNSAwLjU1MTA4OCA3LjI1IDAuNzVWNy4yNUgwLjc1QzAuNTUxMDg4IDcuMjUgMC4zNjAzMjIgNy4zMjkwMiAwLjIxOTY3IDcuNDY5NjdDMC4wNzkwMTc1IDcuNjEwMzIgMCA3LjgwMTA5IDAgOEMwIDguMTk4OTEgMC4wNzkwMTc1IDguMzg5NjggMC4yMTk2NyA4LjUzMDMzQzAuMzYwMzIyIDguNjcwOTggMC41NTEwODggOC43NSAwLjc1IDguNzVINy4yNVYxNS4yNUM3LjI1IDE1LjQ0ODkgNy4zMjkwMiAxNS42Mzk3IDcuNDY5NjcgMTUuNzgwM0M3LjYxMDMyIDE1LjkyMSA3LjgwMTA5IDE2IDggMTZDOC4xOTg5MSAxNiA4LjM4OTY4IDE1LjkyMSA4LjUzMDMzIDE1Ljc4MDNDOC42NzA5OCAxNS42Mzk3IDguNzUgMTUuNDQ4OSA4Ljc1IDE1LjI1VjguNzVIMTUuMjVDMTUuNDQ4OSA4Ljc1IDE1LjYzOTcgOC42NzA5OCAxNS43ODAzIDguNTMwMzNDMTUuOTIxIDguMzg5NjggMTYgOC4xOTg5MSAxNiA4QzE2IDcuODAxMDkgMTUuOTIxIDcuNjEwMzIgMTUuNzgwMyA3LjQ2OTY3QzE1LjYzOTcgNy4zMjkwMiAxNS40NDg5IDcuMjUgMTUuMjUgNy4yNVoiIGZpbGw9IiMxNjc0Q0QiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCancellAllAppointment_vue__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121007ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCancellAllAppointment_vue__ = __webpack_require__(1732);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCancellAllAppointment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121007ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCancellAllAppointment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalCancellAllAppointment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalCancellAllAppointment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-121007ef", Component.options)
  } else {
    hotAPI.reload("data-v-121007ef", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalCancellAllAppointment',
  components: {},
  props: {
    eventId: {
      type: Number,
      default: null
    },
    getEventStaffingById: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onYes: function onYes() {
      var _this = this;

      this.loading = true;
      this.cancelAllAppiontment(this.eventId).then(function (response) {
        _this.loading = false;
        _this.$modal.hide('modalCancellAllAppointment');
        if (response.message) {
          _this.$toastr('error', response.message, '');
        } else {
          _this.$toastr('success', 'Cancel all appointments successful!', '');
          _this.getEventStaffingById();
        }
      }).catch(function (response) {
        this.$toastr('error', response.message, '');
      }).finally(function () {
        _this.loadMoreLoading = false;
      });
    },
    onNo: function onNo() {
      this.$modal.hide('modalCancellAllAppointment');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    cancelAllAppiontment: 'ACTION_CANCEL_ALL_APPOINTMENTS'
  }))
});

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-cancell-all-appointment",
      attrs: {
        name: "modalCancellAllAppointment",
        width: "25%",
        height: "auto",
        scrollable: true
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(136),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: __webpack_require__(137),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("p", [_vm._v("Are you sure you want to cancel all appointments?")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-yes",
                on: {
                  click: function($event) {
                    _vm.onYes()
                  }
                }
              },
              [
                _vm.loading
                  ? _c("b-spinner", { attrs: { variant: "primary" } })
                  : _vm._e(),
                _vm._v("\n        Yes\n      ")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-no",
                on: {
                  click: function($event) {
                    _vm.onNo()
                  }
                }
              },
              [_vm._v("\n        No\n      ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-121007ef", esExports)
  }
}

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "eventStaffingDetailModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "event-detail" },
        [
          _c(
            "div",
            {
              staticClass: "overlay",
              class: {
                isLoading: _vm.getIsLoading,
                noDisplay: !_vm.getIsLoading
              }
            },
            [
              _c(
                "div",
                { staticClass: "spinner-align" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: "spinner", scale: "5", pulse: "" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.getIsLoading
            ? _c(
                "div",
                {
                  staticClass: "staffing-section margin-side modal-padding",
                  attrs: { id: "staffing-section" }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 page-title h2-text" }, [
                      _c("span", [_vm._v("Staff & Slot Management")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "seperate-name" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.eventName))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 noPaddingRight align-right-item"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "modal-close-img",
                            on: {
                              click: function($event) {
                                _vm.back()
                              }
                            }
                          },
                          [_c("div", { staticClass: "icon-close" })]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        { staticClass: "row time-management-container" },
                        [
                          _c("div", { staticClass: "time-slots" }, [
                            _vm._v("\n            Time Management\n          ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "ap-btn btn-cancel",
                              on: {
                                click: function($event) {
                                  _vm.onCancelAllAppointments()
                                }
                              }
                            },
                            [_vm._v("Cancel All Appointments")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "duration-slide-container" }, [
                        _c("div", { staticClass: "staffing-title" }, [
                          _vm._v("\n            slot duration\n          ")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "duration-slide" },
                            [
                              _c(
                                "vue-slider",
                                _vm._b(
                                  {
                                    ref: "slider",
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.getValue("slider")
                                      }
                                    },
                                    model: {
                                      value: _vm.getStaffingDuration,
                                      callback: function($$v) {
                                        _vm.getStaffingDuration = $$v
                                      },
                                      expression: "getStaffingDuration"
                                    }
                                  },
                                  "vue-slider",
                                  _vm.duration,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "ap-btn tertiary change-duration-button"
                            },
                            [_vm._v("change duration")]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col text-entry-field-wrapper" }, [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("ShiftBoard Lead WorkGroup")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.shiftboard.workgroups,
                              placeholder: "Choose Lead WorkGroup",
                              label: "name",
                              openDirection: "below",
                              multiple: false,
                              "close-on-select": true,
                              "hide-selected": true,
                              "track-by": "id",
                              "allow-empty": false,
                              "show-labels": false,
                              disabled: false
                            },
                            on: {
                              select: function($event) {
                                _vm.onShiftboardDropdown($event, "lead")
                              }
                            },
                            model: {
                              value: _vm.shiftboard.leadTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.shiftboard, "leadTitle", $$v)
                              },
                              expression: "shiftboard.leadTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("ShiftBoard Screener WorkGroup")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.shiftboard.workgroups,
                              placeholder: "Choose Screener WorkGroup",
                              label: "name",
                              openDirection: "below",
                              multiple: false,
                              "close-on-select": true,
                              "hide-selected": true,
                              "track-by": "id",
                              "allow-empty": false,
                              "show-labels": false,
                              disabled: false
                            },
                            on: {
                              select: function($event) {
                                _vm.onShiftboardDropdown($event, "screener")
                              }
                            },
                            model: {
                              value: _vm.shiftboard.screenerTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.shiftboard, "screenerTitle", $$v)
                              },
                              expression: "shiftboard.screenerTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("ShiftBoard Phlebotomist WorkGroup")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.shiftboard.workgroups,
                              placeholder: "Choose Phlebotomist WorkGroup",
                              label: "name",
                              openDirection: "below",
                              multiple: false,
                              "close-on-select": true,
                              "hide-selected": true,
                              "track-by": "id",
                              "allow-empty": false,
                              "show-labels": false,
                              disabled: false
                            },
                            on: {
                              select: function($event) {
                                _vm.onShiftboardDropdown($event, "phlebotomist")
                              }
                            },
                            model: {
                              value: _vm.shiftboard.phlebotomistTitle,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.shiftboard,
                                  "phlebotomistTitle",
                                  $$v
                                )
                              },
                              expression: "shiftboard.phlebotomistTitle"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12 time-slots" }, [
                      _vm._v("\n          Staff Management\n        ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row staff-management-container" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("StaffManagement", {
                          attrs: {
                            maxValueStaff: _vm.maxStaffLead || 0,
                            eventId: _vm.eventId,
                            staffRole: "lead"
                          },
                          on: {
                            "assign-successful": function($event) {
                              _vm.getEventStaff(_vm.eventId)
                            },
                            "add-remove-staff": _vm.addOrRemoveStaff
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("StaffManagement", {
                          attrs: {
                            maxValueStaff: _vm.maxStaffConcierge || 0,
                            eventId: _vm.eventId,
                            staffRole: "phlebotomist"
                          },
                          on: {
                            "assign-successful": function($event) {
                              _vm.getEventStaff(_vm.eventId)
                            },
                            "add-remove-staff": _vm.addOrRemoveStaff
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12 margin-top-25px" },
                      [
                        _c("StaffManagement", {
                          attrs: {
                            maxValueStaff: _vm.maxStaffScreener || 0,
                            eventId: _vm.eventId,
                            staffRole: "screener"
                          },
                          on: {
                            "assign-successful": function($event) {
                              _vm.getEventStaff(_vm.eventId)
                            },
                            "add-remove-staff": _vm.addOrRemoveStaff
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isLoadingAppointment
                    ? _c("div", {}, [_c("Spinner")], 1)
                    : _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            class: _vm.event.fluShot ? "col-md-6" : "col-md-12"
                          },
                          [
                            _vm.eventDetail
                              ? _c("SlotsTable", {
                                  ref: "updateSlots",
                                  attrs: {
                                    title: "Screeners",
                                    eventDetail: _vm.eventDetail,
                                    eventId: _vm.eventId,
                                    addOns: _vm.event.addOns,
                                    maxValueStaff: _vm.maxAppointmentPerslot,
                                    fluShot: _vm.event.fluShot
                                  },
                                  on: {
                                    updateSlots: _vm.renderEventStaffing,
                                    RELOAD_TABLE_STAFFING:
                                      _vm.requestReloadTableStaffing,
                                    "add-remove-staff": _vm.addOrRemoveStaff
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.event.fluShot !== -1
                          ? _c(
                              "div",
                              { staticClass: "col-md-6" },
                              [
                                _c("SlotsTable", {
                                  ref: "updateSlotsFluShot",
                                  attrs: {
                                    title: "Slots",
                                    eventDetail: _vm.eventDetail,
                                    eventId: _vm.eventId,
                                    addOns: _vm.event.addOns,
                                    fluShot: _vm.event.fluShot
                                  },
                                  on: {
                                    RELOAD_TABLE_STAFFING:
                                      _vm.requestReloadTableStaffing
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("PatientDetailModal"),
          _vm._v(" "),
          _c("ScrollTop"),
          _vm._v(" "),
          _c("ModalCancellAllAppointment", {
            attrs: {
              eventId: _vm.eventId,
              getEventStaffingById: _vm.getEventStaffingById
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0871f9c0", esExports)
  }
}

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("AppHeader", { attrs: { dropdownItems: _vm.dropdownItems } }),
      _vm._v(" "),
      _vm.showNavigator
        ? _c("Navigator", {
            attrs: { title: _vm.routeTitle, navItems: _vm.nav }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app-body" }, [
        _c("main", { staticClass: "main" }, [
          _c("div", { staticClass: "container-fluid" }, [_c("router-view")], 1)
        ])
      ]),
      _vm._v(" "),
      _c("AppFooter"),
      _vm._v(" "),
      _c("FaqModal"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("CustomMessageModal"),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ModalInfo"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement"),
      _vm._v(" "),
      _c("EventStaffingDetail")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-95a64098", esExports)
  }
}

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardManager_vue__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38d9fc4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardManager_vue__ = __webpack_require__(1737);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38d9fc4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardManager_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/DashboardManager.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DashboardManager.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38d9fc4a", Component.options)
  } else {
    hotAPI.reload("data-v-38d9fc4a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_commons__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manage-client-view',
  components: {
    ScrollTop: __WEBPACK_IMPORTED_MODULE_2__components_utils_ScrollTop__["a" /* default */],
    ClientCardsManagement: __WEBPACK_IMPORTED_MODULE_3__components_commons__["c" /* ClientCardsManagement */],
    SearchSession: __WEBPACK_IMPORTED_MODULE_3__components_commons__["g" /* SearchSession */],
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_1__nav__["a" /* default */].managerNav,
      currentPage: 1,
      totalRows: 0,
      itemsPerPage: 10,
      clients: null,
      isLoading: false,
      searchString: '',
      listEM: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onChangePagination: function onChangePagination(page) {
      this.currentPage = page;
      this.onGetClientsPaging();
    },
    onSearchText: function onSearchText(textSearch) {
      this.searchString = textSearch;
      this.currentPage = 1;
      this.onGetClientsPaging();
    },
    onGetClientsPaging: function onGetClientsPaging() {
      var _this = this;

      this.isLoading = true;
      this.callApiGetClientsPaging({
        pageNum: this.currentPage - 1,
        pageSize: this.itemsPerPage,
        searchString: this.searchString
      }).then(function (response) {
        _this.totalRows = response.totalClients;
        _this.clients = response.clients;
      }).finally(function () {
        _this.isLoading = false;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    getAllAM: 'ACTION_GET_LIST_AM',
    callApiGetClientsPaging: 'ACTION_GET_CLIENTS_PAGING',
    getListEM: 'ACTION_GET_LIST_EM'
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])({
    setManagerView: 'MUTATION_SET_MANAGER_VIEW'
  })),
  beforeMount: function beforeMount() {
    this.onGetClientsPaging();
    this.$store.dispatch('ACTION_GET_EVENT_COUNT', true);
    this.getAllAM();
  },
  created: function created() {
    var _this2 = this;

    this.getListEM().then(function (response) {
      _this2.listEM = response.userProfiles;
    });
    this.setManagerView(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].viewNames.managerDashboard);
  }
});

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn dashboard-manager" },
    [
      _c("ScrollTop"),
      _vm._v(" "),
      _c("SearchSession", { attrs: { onSearchText: _vm.onSearchText } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "client-card-container" },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "isLoading" }, [
                _c(
                  "div",
                  { staticClass: "spinner-align" },
                  [
                    _c("Icon", {
                      staticClass: "icon-size",
                      attrs: { name: "spinner", scale: "5", pulse: "" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c("ClientCardsManagement", {
                attrs: { clients: _vm.clients, listEM: _vm.listEM }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("p", { staticClass: "total-text" }, [
            _vm._v(_vm._s(_vm.totalRows) + " Clients")
          ]),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.itemsPerPage,
              pills: "",
              "first-number": true,
              "last-number": true
            },
            on: { change: _vm.onChangePagination },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38d9fc4a", esExports)
  }
}

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsManager_vue__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee2803c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventsManager_vue__ = __webpack_require__(1742);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1739)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee2803c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventsManager_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/EventsManager.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventsManager.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bee2803c", Component.options)
  } else {
    hotAPI.reload("data-v-bee2803c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1740);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4d8810f4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bee2803c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventsManager.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bee2803c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventsManager.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_commons__ = __webpack_require__(262);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'events-manager',
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__components_datatable_DataTable__["a" /* default */],
    Navigator: __WEBPACK_IMPORTED_MODULE_3__components_commons__["f" /* Navigator */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].managerNav
    };
  },
  created: function created() {
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.managerEvent);
  }
});

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [_c("DataTable", { attrs: { viewMode: "EM" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bee2803c", esExports)
  }
}

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44118e20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(1756);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1744)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44118e20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/Calendar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Calendar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44118e20", Component.options)
  } else {
    hotAPI.reload("data-v-44118e20", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1745);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("58b1ee17", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-44118e20\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Calendar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-44118e20\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Calendar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.calendar-manager .date-selected {\n  height: 96px;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n  padding: 15px 24px;\n}\n.calendar-manager .date-selected .text {\n  height: 16px;\n  color: #444444;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.calendar-manager .date-selected .month-day {\n  height: 32px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n  text-transform: capitalize;\n  float: left;\n}\n.calendar-manager .date-selected .month-day .year {\n  height: 32px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.calendar-manager .date-selected .date-status {\n  height: 22px;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 22px;\n  float: left;\n  margin-top: 5px;\n  padding: 1px 10px;\n  text-transform: uppercase;\n  color: #FFF;\n  border-radius: 10px;\n  margin-left: 8px;\n}\n.calendar-manager .date-selected .date-status.open {\n  background-color: #68B814;\n}\n.calendar-manager .date-selected .date-status.blocked {\n  background-color: #FF3400;\n}\n.calendar-manager .date-selected .btn-packing-slip-wrapper {\n  border-radius: 4px;\n  display: inline-block;\n  margin-left: 20px;\n  padding: 6px 24px;\n}\n.calendar-manager .date-selected .btn-packing-slip-wrapper .label {\n  color: #FFF;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.calendar-manager .text-header {\n  color: #444444;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 70px;\n  height: 60px;\n}\n.calendar-manager .text-header .today-btn {\n  border-radius: 4px;\n  position: absolute;\n  top: 20px;\n  right: 0;\n  text-transform: uppercase;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  padding: 6px 24px;\n}\n.calendar-manager .text-header .today-btn:hover {\n  cursor: pointer;\n}\n.calendar-manager .text-content {\n  height: 16px;\n  color: #626262;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.calendar-manager .calendar-and-event-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding: 12px 24px;\n}\n.calendar-manager .calendar-and-event-container .left-side {\n  width: 320px;\n}\n.calendar-manager .calendar-and-event-container .left-side .date-picker .date-panel {\n  position: relative;\n}\n.calendar-manager .calendar-and-event-container .left-side .action-btn-panel {\n  padding: 8px 0;\n}\n.calendar-manager .calendar-and-event-container .left-side .action-btn-panel .action-btn {\n  border-radius: 4px;\n  float: right;\n  color: #FFFFFF;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  text-align: center;\n  text-transform: uppercase;\n  padding: 6px 24px;\n}\n.calendar-manager .calendar-and-event-container .right-side {\n  padding-left: 24px;\n}\n.calendar-manager .calendar-and-event-container .right-side .cheetah-digital {\n  height: 16px;\n  width: 110px;\n  color: #626262;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 11px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.calendar-manager .calendar-and-event-container .right-side .event-cards-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 0 -12px;\n}\n.calendar-manager .calendar-and-event-container .right-side .event-cards-wrapper .event-card-container {\n  margin: 12px;\n}\n.overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 167px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n  cursor: pointer;\n}\n.isLoading {\n  display: block;\n  text-align: center;\n  color: #606060;\n}\n.noDisplay {\n  display: none;\n}\n.spinner-align {\n  position: absolute;\n  top: 33%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n", ""]);

// exports


/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_commons_CalendarDatePicker_vue__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_eventManagement_manage_EventCard__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_spinner__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'calendar-manager',
  components: {
    CalendarDatePicker: __WEBPACK_IMPORTED_MODULE_1__components_commons_CalendarDatePicker_vue__["a" /* default */],
    EventCard: __WEBPACK_IMPORTED_MODULE_3__components_eventManagement_manage_EventCard__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      today: __WEBPACK_IMPORTED_MODULE_4_moment___default()(),
      selectedDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()()
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    selectDate: function selectDate(selectedDate) {
      this.getDateHasData(selectedDate);
      this.today = __WEBPACK_IMPORTED_MODULE_4_moment___default()(selectedDate, 'MM/DD/YYYY');
    },
    setToday: function setToday() {
      this.today = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      this.setSelected(this.selectedDate.format('MM/DD/YYYY'));
      this.$bus.$emit('set-today');
    },
    setSelected: function setSelected(dateStr) {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(dateStr, 'MM/DD/YYYY');
      var body = {
        noOfDates: null, // 100 is represent for 60+, can be any number which is bigger than 60
        selectedDate: dateStr,
        changeFilter: true
      };
      this.getEventByDate(body).then(function (response) {
        if (response.message !== null || response.message !== '') {
          console.log('Events by selected date: ', response.approvedEvents);
          console.log('Total Event found: ', response.totalEvents);
        } else {
          console.log(response.message);
        }
      });
    },
    openSelectedDate: function openSelectedDate() {
      var _this = this;

      this.$swal({
        title: "<div class='ems_alert_title'>open date</div>",
        html: "<div class='ems_alert_des'>Opening this date will allow clients to sign up for biometric events on this day.</div>",
        confirmButtonColor: '#0080A5',
        confirmButtonText: 'OPEN DATE',
        showCancelButton: true,
        cancelButtonColor: '#fff',
        cancelButtonText: 'CANCEL',
        buttonsStyling: true,
        reverseButtons: true,
        confirmButtonClass: 'ems_alert_confirm open',
        cancelButtonClass: 'ems_alert_cancel',
        customClass: 'ems_confirm',
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 605
      }).then(function (result) {
        if (result.value) {
          _this.openDate(_this.selectedDate.format('MM/DD/YYYY')).then(function (res) {
            console.log('open date res:', res);
          });
        }
      });
    },
    blockSelectedDate: function blockSelectedDate() {
      var _this2 = this;

      this.$swal({
        title: "<div class='ems_alert_title'>block date</div>",
        html: "<div class='ems_alert_des'>Blocking this date will not allow any further clients to sign up for biometric events on this day.<br /><br />Clients that have already signed up will not be affected.<br /><br />You can undo this at any time.</div>",
        confirmButtonColor: '#FF3400',
        confirmButtonText: 'BLOCK DATE',
        showCancelButton: true,
        cancelButtonColor: '#fff',
        cancelButtonText: 'CANCEL',
        buttonsStyling: true,
        reverseButtons: true,
        confirmButtonClass: 'ems_alert_confirm block',
        cancelButtonClass: 'ems_alert_cancel',
        customClass: 'ems_confirm',
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 605
      }).then(function (result) {
        if (result.value) {
          _this2.blockDate(_this2.selectedDate.format('MM/DD/YYYY')).then(function (res) {
            console.log('block date res:', res);
          });
        }
      });
    },
    downloadPackingSlip: function downloadPackingSlip() {
      var _this3 = this;

      this.getURLForPackingSlip().then(function (response) {
        if (response.message === null) {
          _this3.downloadPackingSlipExcel(response.data).then(function (response) {
            // console.log(response);
          });
        } else {
          _this3.$toast.error(response.message, '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optError));
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    getDateHasData: 'ACTION_GET_DATE_HAS_DATA',
    getDateRangeHasData: 'ACTION_GET_DATE_RANGE_HAS_DATA',
    getLockedDate: 'ACTION_LOCKED_DATE',
    blockDate: 'ACTION_BLOCK_DATE',
    openDate: 'ACTION_OPEN_DATE',
    getEventByDate: 'ACTION_GET_EVENTS_BY_DATES',
    getURLForPackingSlip: 'ACTION_GET_URL_FOR_PACKING_SLIP',
    downloadPackingSlipExcel: 'ACTION_DOWNLOAD_PACKING_SLIP'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    getLoading: 'GETTERS_IS_LOADING',
    getEvents: 'GETTERS_EVENTS_BY_DATES',
    getTotalApprovedEvents: 'GETTERS_TOTAL_EVENTS',
    datesHasData: 'GETTERS_DATES_HAS_DATA',
    lockedDates: 'GETTERS_LOCKED_DATES',
    dateRangeHasData: 'GETTERS_DATE_RANGE_HAS_DATA'
  })),
  mounted: function mounted() {
    this.getDateHasData(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('MM/DD/YYYY'));
    this.getLockedDate();
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].viewNames.staffing);
  }
});

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarDatePicker_vue__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7944c7ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarDatePicker_vue__ = __webpack_require__(1751);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1748)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7944c7ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7944c7ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarDatePicker_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/CalendarDatePicker.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalendarDatePicker.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7944c7ab", Component.options)
  } else {
    hotAPI.reload("data-v-7944c7ab", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1749);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5617e2ac", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7944c7ab\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDatePicker.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7944c7ab\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDatePicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\nul[data-v-7944c7ab] {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.date-picker[data-v-7944c7ab] {\n  position: relative;\n  height: 320px;\n}\n.input-wrapper[data-v-7944c7ab] {\n  border: 1px solid #D2D2D2;\n  border-radius: 2px;\n  vertical-align: middle;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 6px 10px 6px 4px;\n  height: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.input[data-v-7944c7ab] {\n  height: 20px;\n  width: 100%;\n  font-size: inherit;\n  padding-left: 4px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n}\n.cancel-btn[data-v-7944c7ab] {\n  height: 14px;\n  width: 14px;\n}\n.date-panel[data-v-7944c7ab] {\n  position: absolute;\n  z-index: 5000;\n  border: 1px solid #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 320px;\n  padding: 5px 10px 10px;\n  background-color: #fff;\n  /*transform: translateY(-250px);*/\n  /*&.edit {*/\n  /*transform: translateY(-250px);*/\n  /*}*/\n}\n.panel-header[data-v-7944c7ab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  border-bottom: 2px solid #FBFBFB;\n  height: 50px;\n}\n.arrow-left[data-v-7944c7ab],\n.arrow-right[data-v-7944c7ab] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  font-size: 20px;\n  line-height: 2;\n  background-color: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.year-range[data-v-7944c7ab] {\n  font-size: 20px;\n  line-height: 2;\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.year-month-box[data-v-7944c7ab] {\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.type-year[data-v-7944c7ab],\n.type-month[data-v-7944c7ab],\n.date-list[data-v-7944c7ab] {\n  background-color: #fff;\n}\n.date-list[data-v-7944c7ab] {\n  background-color: #ffffff;\n}\n.year-box[data-v-7944c7ab],\n.month-box[data-v-7944c7ab] {\n  -webkit-transition: all ease .1s;\n  transition: all ease .1s;\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n  font-size: 15px;\n  line-height: 2;\n  cursor: pointer;\n  background-color: #fff;\n}\n.year-list[data-v-7944c7ab],\n.month-list[data-v-7944c7ab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.year-list li[data-v-7944c7ab],\n.month-list li[data-v-7944c7ab] {\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  cursor: pointer;\n  text-align: center;\n  font-size: 20px;\n  width: 33%;\n  padding: 10px 0;\n}\n.year-list li[data-v-7944c7ab]:hover,\n.month-list li[data-v-7944c7ab]:hover {\n  background-color: #6ac1c9;\n  color: #fff;\n}\n.year-list li.selected[data-v-7944c7ab],\n.month-list li.selected[data-v-7944c7ab] {\n  background-color: #0097a7;\n  color: #fff;\n}\n.year-list li.invalid[data-v-7944c7ab],\n.month-list li.invalid[data-v-7944c7ab] {\n  cursor: not-allowed;\n  color: #D2D2D2;\n}\n.date-list[data-v-7944c7ab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.date-list .valid[data-v-7944c7ab]:hover {\n  background-color: #eee;\n}\n.date-list li[data-v-7944c7ab] {\n  -webkit-transition: all ease .1s;\n  transition: all ease .1s;\n  cursor: pointer;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #fff;\n  position: relative;\n  margin: 2px;\n}\n.date-list li[data-v-7944c7ab]:not(.firstItem) {\n  margin-left: 10px;\n}\n.date-list li .message[data-v-7944c7ab] {\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n  position: relative;\n  height: 30px;\n}\n.date-list li .message.selected .bg[data-v-7944c7ab] {\n  /*background-color: #ff281c;*/\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n}\n.date-list li .message.selected span[data-v-7944c7ab] {\n  color: #151b1e;\n}\n.date-list li .message:not(.selected) .bg[data-v-7944c7ab] {\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  opacity: 0;\n}\n.date-list li .message:not(.selected):hover .bg[data-v-7944c7ab] {\n  background-color: #d8d8d8;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  opacity: .6;\n}\n.date-list li .message:not(.selected):hover span[data-v-7944c7ab] {\n  color: #151b1e;\n}\n.date-list li .message.blocked[data-v-7944c7ab] {\n  background-color: #FF3400;\n  color: #fff;\n}\n.date-list li .message .bg[data-v-7944c7ab] {\n  height: 30px;\n  width: 100%;\n  -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.date-list li .message span[data-v-7944c7ab] {\n  position: absolute;\n  z-index: 20;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n.date-list li.invalid[data-v-7944c7ab] {\n  cursor: not-allowed;\n  color: #D2D2D2;\n}\n.weeks[data-v-7944c7ab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.weeks li[data-v-7944c7ab] {\n  font-weight: normal;\n}\n.weeks[data-v-7944c7ab],\n.date-list[data-v-7944c7ab] {\n  width: 100%;\n  text-align: center;\n}\n.weeks li[data-v-7944c7ab],\n.date-list li[data-v-7944c7ab] {\n  font-family: \"Open Sans\", sans-serif;\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  line-height: 30px;\n}\n.weeks .preMonth[data-v-7944c7ab],\n.date-list .preMonth[data-v-7944c7ab],\n.weeks .nextMonth[data-v-7944c7ab],\n.date-list .nextMonth[data-v-7944c7ab] {\n  color: #D2D2D2;\n}\n.date-list li[data-v-7944c7ab] {\n  color: #151b1e;\n}\n.date-list .preMonth[data-v-7944c7ab],\n.date-list .nextMonth[data-v-7944c7ab] {\n  color: #D2D2D2;\n}\n.date-list .had-event[data-v-7944c7ab] {\n  height: 4px;\n  width: 4px;\n  background-color: #68B814;\n  position: absolute;\n  right: 2px;\n  top: 2px;\n}\n.toggle-enter[data-v-7944c7ab],\n.toggle-leave-active[data-v-7944c7ab] {\n  opacity: 0;\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n}\n.toggle-enter-active[data-v-7944c7ab],\n.toggle-leave-active[data-v-7944c7ab] {\n  -webkit-transition: all ease .2s;\n  transition: all ease .2s;\n}\n.fade-enter[data-v-7944c7ab],\n.fade-leave-active[data-v-7944c7ab] {\n  opacity: 0;\n  -webkit-transform: scale3d(0, 0, 0);\n          transform: scale3d(0, 0, 0);\n}\n.fade-enter-active[data-v-7944c7ab],\n.fade-leave-active[data-v-7944c7ab] {\n  -webkit-transition: all ease .1s;\n  transition: all ease .1s;\n}\n.arrow-icon[data-v-7944c7ab] {\n  height: 30px;\n  width: 30px;\n  line-height: 30px;\n  border-radius: 50%;\n}\n.arrow-icon .left-icon[data-v-7944c7ab] {\n  z-index: 7;\n  width: 24px;\n  height: 24px;\n  background-color: #00A4D6;\n  color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(394) + ");\n}\n.arrow-icon .right-icon[data-v-7944c7ab] {\n  z-index: 7;\n  width: 24px;\n  height: 24px;\n  background-color: #00A4D6;\n  color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(95) + ") no-repeat center;\n  mask: url(" + __webpack_require__(95) + ") no-repeat center;\n  background: url(" + __webpack_require__(395) + ");\n}\n.arrow-right .arrow-icon[data-v-7944c7ab] {\n  float: right;\n}\n", ""]);

// exports


/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_calendar__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_times__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-throw-liter
al,key-spacing,space-before-function-paren,space-before-blocks,operator-linebreak,keyword-spacing,padded-blocks,one-var,no-unneeded-ternary,object-property-newline,no-duplicate-case,comma-spacing,semi */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'calendar-date-picker',
  data: function data() {
    var now = new Date();
    var startDate = void 0,
        endDate = void 0;
    if (this.range) {
      startDate = this.value[0] ? new Date(this.value[0]) : now;
      endDate = this.value[1] ? new Date(this.value[1]) : now;
    } else {
      startDate = endDate = this.value ? new Date(this.value) : now;
    }
    return {
      showCancel: false,
      panelState: true,
      panelType: 'date',
      coordinates: {},
      year: endDate.getFullYear(),
      month: endDate.getMonth(),
      date: endDate.getDate(),
      tmpYear: endDate.getFullYear(),
      tmpMonth: endDate.getMonth(),
      tmpStartYear: startDate.getFullYear(),
      tmpStartMonth: startDate.getMonth(),
      tmpStartDate: startDate.getDate(),
      tmpEndYear: endDate.getFullYear(),
      tmpEndMonth: endDate.getMonth(),
      tmpEndDate: endDate.getDate(),
      minYear: Number,
      minMonth: Number,
      minDate: Number,
      maxYear: Number,
      maxMonth: Number,
      maxDate: Number,
      yearList: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 12 }, function (value, index) {
        return new Date().getFullYear() + index;
      }),
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      weekList: [0, 1, 2, 3, 4, 5, 6],
      rangeStart: false,
      dateEnum: {
        month: 0,
        day: 1,
        year: 2
      },
      startDate: '',
      endDate: ''
    };
  },

  props: {
    language: { default: 'en' },
    min: { default: '01/01/2016' },
    max: { default: '31/12/2035' },
    value: {
      type: [String, Array],
      default: ''
    },
    range: {
      type: Boolean,
      default: false
    },
    metaData: {
      type: Object,
      default: null
    },
    showLeft: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    edit: {
      type: Boolean,
      default: false
    },
    datesHasData: {
      type: Array,
      default: []
    },
    lockedDates: {
      type: Array,
      default: []
    },
    selectedDate: {
      type: Object,
      default: __WEBPACK_IMPORTED_MODULE_4_moment___default()()
    },
    dateRangeHasData: {
      type: Array,
      default: []
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */]
  },
  methods: {
    togglePanel: function togglePanel() {
      this.panelState = !this.panelState;
      this.rangeStart = false;
    },
    isSelected: function isSelected(type, item) {
      switch (type) {
        case 'year':
          if (!this.range) return item === this.tmpYear;
          return new Date(item, 0).getTime() >= new Date(this.tmpStartYear, 0).getTime() && new Date(item, 0).getTime() <= new Date(this.tmpEndYear, 0).getTime();
        case 'month':
          if (!this.range) return item === this.tmpMonth && this.year === this.tmpYear;
          return new Date(this.tmpYear, item).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth).getTime() && new Date(this.tmpYear, item).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth).getTime();
        case 'date':
          return item.string === this.selectedDate.format('MM/DD/YYYY');
      }
    },
    chType: function chType(type) {
      this.panelType = type;
    },
    chYearRange: function chYearRange(next) {
      if (next) {
        this.yearList = this.yearList.map(function (i) {
          return i + 12;
        });
      } else {
        this.yearList = this.yearList.map(function (i) {
          return i - 12;
        });
      }
    },
    prevMonthPreview: function prevMonthPreview() {
      this.tmpMonth--;
      if (this.tmpMonth < 0) {
        this.tmpMonth = 11;
        this.tmpYear--;
      }
    },
    nextMonthPreview: function nextMonthPreview() {
      this.tmpMonth++;
      if (this.tmpMonth >= 12) {
        this.tmpMonth = 0;
        this.tmpYear++;
      }
    },
    selectYear: function selectYear(year) {
      if (this.validateYear(year)) return;
      this.tmpYear = year;
      this.panelType = 'date';
    },
    selectMonth: function selectMonth(month) {
      if (this.validateMonth(month)) return;
      this.tmpMonth = month;
      this.panelType = 'date';
    },
    selectDate: function selectDate(date) {
      var _this = this;

      setTimeout(function () {
        if (_this.validateDate(date)) return;
        if (date.previousMonth) {
          if (_this.tmpMonth === 0) {
            _this.year -= 1;
            _this.tmpYear -= 1;
            _this.month = _this.tmpMonth = 11;
          } else {
            _this.month = _this.tmpMonth - 1;
            _this.tmpMonth -= 1;
          }
        } else if (date.nextMonth) {
          if (_this.tmpMonth === 11) {
            _this.year += 1;
            _this.tmpYear += 1;
            _this.month = _this.tmpMonth = 0;
          } else {
            _this.month = _this.tmpMonth + 1;
            _this.tmpMonth += 1;
          }
        }
        if (!_this.range) {
          _this.year = _this.tmpYear;
          _this.month = _this.tmpMonth;
          _this.date = date.value;
          var value = ('0' + (_this.month + 1)).slice(-2) + '/' + ('0' + _this.date).slice(-2) + '/' + _this.tmpYear;
          if (_this.metaData) {
            _this.metaData.value = value;
            _this.$emit('EVENT_GET_ROW_ITEM', _this.metaData);
          }
          _this.$emit('input', value);
          // this.panelState = false
        } else if (_this.range && !_this.rangeStart) {

          _this.tmpEndYear = _this.tmpStartYear = _this.tmpYear;
          _this.tmpEndMonth = _this.tmpStartMonth = _this.tmpMonth;
          _this.tmpEndDate = _this.tmpStartDate = date.value;

          _this.rangeStart = true;
        } else if (_this.range && _this.rangeStart) {

          _this.tmpEndYear = _this.tmpYear;
          _this.tmpEndMonth = _this.tmpMonth;
          _this.tmpEndDate = date.value;

          var d1 = new Date(_this.tmpStartYear, _this.tmpStartMonth, _this.tmpStartDate).getTime(),
              d2 = new Date(_this.tmpEndYear, _this.tmpEndMonth, _this.tmpEndDate).getTime();
          if (d1 > d2) {
            var tmpY = void 0,
                tmpM = void 0,
                tmpD = void 0;
            tmpY = _this.tmpEndYear;
            tmpM = _this.tmpEndMonth;
            tmpD = _this.tmpEndDate;

            _this.tmpEndYear = _this.tmpStartYear;
            _this.tmpEndMonth = _this.tmpStartMonth;
            _this.tmpEndDate = _this.tmpStartDate;

            _this.tmpStartYear = tmpY;
            _this.tmpStartMonth = tmpM;
            _this.tmpStartDate = tmpD;
          }
          var RangeStart = ('0' + (_this.tmpStartMonth + 1)).slice(-2) + '/' + ('0' + _this.tmpStartDate).slice(-2) + '/' + _this.tmpStartYear;
          var RangeEnd = ('0' + (_this.tmpEndMonth + 1)).slice(-2) + '/' + ('0' + _this.tmpEndDate).slice(-2) + '/' + _this.tmpEndYear;

          var _value = [RangeStart, RangeEnd];
          if (_this.metaData) {
            _this.metaData.value = _value;
            _this.$emit('EVENT_GET_ROW_ITEM', _this.metaData);
          }
          _this.$emit('input', _value);

          _this.rangeStart = false;
          // this.panelState = false;
        }

        _this.$emit('selectDate', date.string);
      }, 0);
    },
    validateYear: function validateYear(year) {
      return year > this.maxYear || year < this.minYear;
    },
    validateMonth: function validateMonth(month) {
      return !(new Date(this.tmpYear, month).getTime() >= new Date(this.minYear, this.minMonth - 1).getTime() && new Date(this.tmpYear, month).getTime() <= new Date(this.maxYear, this.maxMonth - 1).getTime());
    },
    validateDate: function validateDate(date) {
      var mon = this.tmpMonth;
      if (date.previousMonth) {
        mon -= 1;
      } else if (date.nextMonth) {
        mon += 1;
      }
      return !(new Date(this.tmpYear, mon, date.value).getTime() >= new Date(this.minYear, this.minMonth - 1, this.minDate).getTime() && new Date(this.tmpYear, mon, date.value).getTime() <= new Date(this.maxYear, this.maxMonth - 1, this.maxDate).getTime());
    },
    close: function close(e) {
      if (!this.$el.contains(e.target)) {
        // this.panelState = false;
        this.rangeStart = false;
      }
    },
    clear: function clear() {
      this.$emit('input', this.range ? ['', ''] : '');
    },
    setToday: function setToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      var today = {
        currentMonth: true,
        string: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('MM/DD/YYYY'),
        value: __WEBPACK_IMPORTED_MODULE_4_moment___default()().date()
      };
      this.selectDate(today);
      var startDate = void 0;
      var endDate = void 0;
      startDate = endDate = this.value ? new Date(this.value) : new Date();
      this.year = endDate.getFullYear();
      this.month = endDate.getMonth();
      this.date = endDate.getDate();
      this.tmpYear = endDate.getFullYear();
      this.tmpMonth = endDate.getMonth();
      this.tmpStartYear = startDate.getFullYear();
      this.tmpStartMonth = startDate.getMonth();
      this.tmpStartDate = startDate.getDate();
      this.tmpEndYear = endDate.getFullYear();
      this.tmpEndMonth = endDate.getMonth();
      this.tmpEndDate = endDate.getDate();
    },
    drawThisMonth: function drawThisMonth() {
      var _this2 = this;

      var currentMonthLength = new Date(this.tmpYear, this.tmpMonth + 1, 0).getDate();
      var dateList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: currentMonthLength }, function (val, index) {
        return {
          currentMonth: true,
          value: index + 1,
          string: ('0' + (_this2.tmpMonth + 1)).slice(-2) + '/' + ('0' + (index + 1)).slice(-2) + '/' + _this2.tmpYear
        };
      });
      var startDay = new Date(this.tmpYear, this.tmpMonth, 1).getDay();
      var previousMongthLength = new Date(this.tmpYear, this.tmpMonth, 0).getDate();

      for (var i = 0, len = startDay; i < len; i++) {
        dateList = [{
          previousMonth: true,
          value: previousMongthLength - i,
          string: ('0' + (this.tmpMonth === 0 ? 12 : this.tmpMonth)).slice(-2) + '/' + ('0' + (previousMongthLength - i)).slice(-2) + '/' + (this.tmpMonth === 0 ? this.tmpYear - 1 : this.tmpYear)
        }].concat(dateList);
      }
      for (var _i = dateList.length, item = 1; _i < 42; _i++, item++) {
        dateList[dateList.length] = {
          nextMonth: true,
          value: item,
          string: ('0' + (this.tmpMonth === 11 ? 1 : this.tmpMonth + 2)).slice(-2) + '/' + ('0' + item).slice(-2) + '/' + (this.tmpMonth === 11 ? this.tmpYear + 1 : this.tmpYear)
        };
      }
      this.startDate = dateList[0].string;
      this.endDate = dateList[dateList.length - 1].string;
      this.$emit('getDateRangeHasData', {
        startDate: dateList[0].string,
        endDate: dateList[dateList.length - 1].string
      });
      return dateList;
    }
  },
  watch: {
    min: function min(v) {
      var minArr = v.split('/');
      this.minYear = Number(minArr[this.dateEnum.year]);
      this.minMonth = Number(minArr[this.dateEnum.month]);
      this.minDate = Number(minArr[this.dateEnum.day]);
    },
    max: function max(v) {
      var maxArr = v.split('/');
      this.maxYear = Number(maxArr[this.dateEnum.year]);
      this.maxMonth = Number(maxArr[this.dateEnum.month]);
      this.maxDate = Number(maxArr[this.dateEnum.day]);
    },
    range: function range(newVal, oldVal) {
      if (newVal === oldVal) return;
      if (newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'String') {
        this.$emit('input', ['', '']);
      }
      if (!newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'Array') {
        this.$emit('input', '');
      }
    },
    dateList: function dateList() {
      this.$emit('getDateRangeHasData', {
        startDate: this.startDate,
        endDate: this.endDate
      });
    }
  },
  computed: {
    dateList: function dateList() {
      return this.drawThisMonth();
    }
  },
  filters: {
    week: function week(item, lang) {
      switch (lang) {
        case 'en':
          return { 0: 'Su', 1: 'Mo', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sa' }[item];
        default:
          return item;
      }
    },
    month: function month(item, lang) {
      switch (lang) {
        case 'en':
          return {
            1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
            7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December'
          }[item];
        default:
          return item;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.placeholder) {
      this.$emit('input', this.placeholder);
    }
    this.$nextTick(function () {
      if (_this3.showLeft) {
        _this3.coordinates = { left: '0', top: window.getComputedStyle(_this3.$el.children[0]).offsetHeight + 4 + 'px' };
      } else if (_this3.$el.parentNode.offsetWidth + _this3.$el.parentNode.offsetLeft - _this3.$el.offsetLeft <= 300) {
        _this3.coordinates = { right: '0', top: window.getComputedStyle(_this3.$el.children[0]).offsetHeight + 4 + 'px' };
      } else {
        _this3.coordinates = { left: '0', top: window.getComputedStyle(_this3.$el.children[0]).offsetHeight + 4 + 'px' };
      }
      var minArr = _this3.min.split('/');
      _this3.minYear = Number(minArr[_this3.dateEnum.year]);
      _this3.minMonth = Number(minArr[_this3.dateEnum.month]);
      _this3.minDate = Number(minArr[_this3.dateEnum.day]);

      var maxArr = _this3.max.split('/');
      _this3.maxYear = Number(maxArr[_this3.dateEnum.year]);
      _this3.maxMonth = Number(maxArr[_this3.dateEnum.month]);
      _this3.maxDate = Number(maxArr[_this3.dateEnum.day]);

      if (_this3.range) {
        if (Object.prototype.toString.call(_this3.value).slice(8, -1) !== 'Array') {
          throw new Error('Binding value must be an array in range mode.');
        }
        if (_this3.value.length) {
          var rangeStart = _this3.value[0].split('/');
          var rangeEnd = _this3.value[1].split('/');
          _this3.tmpStartYear = Number(rangeStart[_this3.dateEnum.year]);
          _this3.tmpStartMonth = Number(rangeStart[_this3.dateEnum.month]) - 1;
          _this3.tmpStartDate = Number(rangeStart[_this3.dateEnum.day]);

          _this3.tmpEndYear = Number(rangeEnd[_this3.dateEnum.year]);
          _this3.tmpEndMonth = Number(rangeEnd[_this3.dateEnum.month]) - 1;
          _this3.tmpEndDate = Number(rangeEnd[_this3.dateEnum.day]);
        } else {
          _this3.$emit('input', ['', '']);
        }
      }
      //        if (!this.value) {
      //          this.$emit('input', '')
      //        }
      window.addEventListener('click', _this3.close);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('click', this.close);
  },
  created: function created() {
    this.$bus.$on('set-today', this.setToday);
  }
});

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-picker" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.panelState,
            expression: "panelState"
          }
        ],
        staticClass: "date-panel",
        class: { edit: _vm.edit },
        style: _vm.coordinates
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType !== "year",
                expression: "panelType !== 'year'"
              }
            ],
            staticClass: "panel-header"
          },
          [
            _c(
              "div",
              {
                staticClass: "arrow-left",
                on: {
                  click: function($event) {
                    _vm.prevMonthPreview()
                  }
                }
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "year-month-box" }, [
              _c(
                "div",
                {
                  staticClass: "month-box",
                  on: {
                    click: function($event) {
                      _vm.chType("month")
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("month")(_vm.tmpMonth + 1, _vm.language))
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "year-box",
                domProps: { textContent: _vm._s(_vm.tmpYear) },
                on: {
                  click: function($event) {
                    _vm.chType("year")
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "arrow-right",
                on: {
                  click: function($event) {
                    _vm.nextMonthPreview()
                  }
                }
              },
              [_vm._m(1)]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "year",
                expression: "panelType === 'year'"
              }
            ],
            staticClass: "panel-header"
          },
          [
            _c(
              "div",
              {
                staticClass: "arrow-left",
                on: {
                  click: function($event) {
                    _vm.chYearRange(0)
                  }
                }
              },
              [_vm._m(2)]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "year-range" }, [
              _c("span", {
                domProps: { textContent: _vm._s(_vm.yearList[0]) }
              }),
              _vm._v(" - "),
              _c("span", {
                domProps: {
                  textContent: _vm._s(_vm.yearList[_vm.yearList.length - 1])
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "arrow-right",
                on: {
                  click: function($event) {
                    _vm.chYearRange(1)
                  }
                }
              },
              [_vm._m(3)]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "year",
                expression: "panelType === 'year'"
              }
            ],
            staticClass: "type-year"
          },
          [
            _c(
              "ul",
              { staticClass: "year-list" },
              _vm._l(_vm.yearList, function(item) {
                return _c("li", {
                  class: {
                    selected: _vm.isSelected("year", item),
                    invalid: _vm.validateYear(item)
                  },
                  domProps: { textContent: _vm._s(item) },
                  on: {
                    click: function($event) {
                      _vm.selectYear(item)
                    }
                  }
                })
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "month",
                expression: "panelType === 'month'"
              }
            ],
            staticClass: "type-month"
          },
          [
            _c(
              "ul",
              { staticClass: "month-list" },
              _vm._l(_vm.monthList, function(item, index) {
                return _c(
                  "li",
                  {
                    class: {
                      selected: _vm.isSelected("month", index),
                      invalid: _vm.validateMonth(index)
                    },
                    on: {
                      click: function($event) {
                        _vm.selectMonth(index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("month")(item, _vm.language)) +
                        "\n        "
                    )
                  ]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelType === "date",
                expression: "panelType === 'date'"
              }
            ],
            staticClass: "type-date"
          },
          [
            _c(
              "ul",
              { staticClass: "weeks" },
              _vm._l(_vm.weekList, function(item) {
                return _c("li", [
                  _vm._v(_vm._s(_vm._f("week")(item, _vm.language)))
                ])
              })
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "date-list" },
              _vm._l(_vm.dateList, function(item, index) {
                return _c(
                  "li",
                  {
                    class: {
                      preMonth: item.previousMonth,
                      nextMonth: item.nextMonth,
                      invalid: _vm.validateDate(item),
                      firstItem: index % 7 === 0
                    },
                    on: {
                      click: function($event) {
                        _vm.selectDate(item)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "message",
                        class: {
                          selected: _vm.isSelected("date", item),
                          blocked: _vm.lockedDates.indexOf(item.string) >= 0
                        }
                      },
                      [
                        _vm.dateRangeHasData.indexOf(item.string) >= 0
                          ? _c("div", { staticClass: "had-event" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "bg" }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { textContent: _vm._s(item.value) }
                        })
                      ]
                    )
                  ]
                )
              })
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "left-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "right-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "left-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-icon" }, [
      _c("div", { staticClass: "right-icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7944c7ab", esExports)
  }
}

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1753);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6e58a3d6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47ae53c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventCard.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47ae53c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.event-card-container[data-v-47ae53c8] {\n  width: 291px;\n  border-radius: 4px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  top: 0;\n  -webkit-transition: top .25s;\n  transition: top .25s;\n  -webkit-transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n          transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);\n}\n.event-card-container[data-v-47ae53c8]:hover {\n  cursor: pointer;\n  top: -10px;\n}\n.event-card-container:hover .part-one .part-one-detail .part-one-event-name[data-v-47ae53c8] {\n  max-width: calc(100% - 36px);\n}\n.event-card-container:hover .part-one .approve-icon[data-v-47ae53c8] {\n  width: 28px;\n  height: 28px;\n  -webkit-transform: scale(1.2);\n          transform: scale(1.2);\n  -webkit-transition: -webkit-transform .25s;\n  transition: -webkit-transform .25s;\n  transition: transform .25s;\n  transition: transform .25s, -webkit-transform .25s;\n}\n.event-card-container:hover.noTransition[data-v-47ae53c8]:hover {\n  -webkit-transition: none;\n  transition: none;\n}\n.event-card-container .part-one[data-v-47ae53c8] {\n  width: 291px;\n  position: relative;\n}\n.event-card-container .part-two[data-v-47ae53c8] {\n  width: 291px;\n  border-radius: 0 0 4px 4px;\n  background-color: #F5F5F5;\n  border-top: 1px solid #E6E6E6;\n  padding-top: 7px;\n  padding-bottom: 8px;\n}\n.event-card-container .part-two-detail[data-v-47ae53c8] {\n  padding-bottom: 1px;\n}\n.event-card-container .approve-icon[data-v-47ae53c8] {\n  height: 25px;\n  width: 25px;\n  background-color: #606060;\n  -webkit-mask: url(" + __webpack_require__(260) + ") no-repeat center;\n  mask: url(" + __webpack_require__(260) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.event-card-container .approve-icon[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(386) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.event-card-container .approve-icon[data-v-47ae53c8] {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(386) + ") no-repeat center;\n}\n}\n.event-card-container .wrapper-menu[data-v-47ae53c8] {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 50px;\n  height: 24px;\n}\n.event-card-container .wrapper-menu .wrapper-more-icon[data-v-47ae53c8] {\n  height: 24px;\n  width: 24px;\n  background-color: #2FBEFF;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  -webkit-mask: url(" + __webpack_require__(828) + ") no-repeat center;\n  mask: url(" + __webpack_require__(828) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.event-card-container .wrapper-menu .wrapper-more-icon[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(829) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.event-card-container .wrapper-menu .wrapper-more-icon[data-v-47ae53c8] {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(829) + ") no-repeat center;\n}\n}\n.event-card-container .wrapper-menu .wrapper-status-icon[data-v-47ae53c8] {\n  width: 24px;\n  height: 24px;\n  background-color: #2FBEFF;\n  -webkit-mask: url(" + __webpack_require__(31) + ") no-repeat center;\n  mask: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.event-card-container .wrapper-menu .wrapper-status-icon[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.event-card-container .wrapper-menu .wrapper-status-icon[data-v-47ae53c8] {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n.event-card-container .wrapper-list[data-v-47ae53c8] {\n  position: absolute;\n  height: 200px;\n  left: 100%;\n  top: 16px;\n  z-index: 999;\n  cursor: pointer;\n  width: 230px;\n}\n.event-card-container .status-icon-black[data-v-47ae53c8] {\n  height: 27px;\n  width: 27px;\n  margin-right: 10px;\n  background-color: #231f20;\n  -webkit-mask: url(" + __webpack_require__(31) + ") no-repeat center;\n  mask: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.event-card-container .status-icon-black[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.event-card-container .status-icon-black[data-v-47ae53c8] {\n    /* Microsoft EdgeV13&14 CSS styles go here */\n    background: url(" + __webpack_require__(31) + ") no-repeat center;\n}\n}\n.event-card-container .icon-settings[data-v-47ae53c8] {\n  width: 27px;\n  height: 27px;\n  margin-right: 10px;\n  color: #231f20;\n  background-color: #231f20;\n  -webkit-mask: url(" + __webpack_require__(42) + ") no-repeat center;\n  mask: url(" + __webpack_require__(42) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.event-card-container .icon-settings[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(42) + ") no-repeat center;\n}\n}\n@supports (-ms-ime-align: auto) {\n.event-card-container .icon-settings[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(42) + ") no-repeat center;\n}\n}\n.event-card-container .icon-information-black[data-v-47ae53c8] {\n  width: 27px;\n  height: 27px;\n  margin-right: 10px;\n  background-color: #231f20;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n}\n@supports (-ms-ime-align: auto) {\n.event-card-container .icon-information-black[data-v-47ae53c8] {\n    background: url(" + __webpack_require__(38) + ");\n}\n}\n.event-card-container .justify-content-between[data-v-47ae53c8] {\n  -webkit-box-pack: left !important;\n      -ms-flex-pack: left !important;\n          justify-content: left !important;\n}\n.event-card-container .part-one-detail[data-v-47ae53c8] {\n  width: 100%;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 16px;\n}\n.event-card-container .part-one-icon[data-v-47ae53c8] {\n  width: 24px;\n}\n.event-card-container .part-one-event-name[data-v-47ae53c8] {\n  margin-left: 8px;\n  max-width: calc(100% - 32px);\n}\n.event-card-container .part-one-event-name-text[data-v-47ae53c8] {\n  font-size: 16px;\n  color: black;\n}\n.event-card-container .part-one-number[data-v-47ae53c8] {\n  width: 49px;\n  display: inline-block;\n  position: relative;\n  top: -5px;\n}\n.event-card-container .part-one-pref-date[data-v-47ae53c8] {\n  font-size: 16px;\n  color: black;\n  font-weight: 600;\n}\n.event-card-container .mask-green[data-v-47ae53c8] {\n  height: 24px;\n  width: 49px;\n  border: 1px solid #5EA913;\n  border-radius: 12px;\n}\n.event-card-container .mask-red[data-v-47ae53c8] {\n  height: 24px;\n  width: 49px;\n  border: 1px solid #E93000;\n  border-radius: 12px;\n}\n.event-card-container .mask-orange[data-v-47ae53c8] {\n  height: 24px;\n  width: 56px;\n  border: 1px solid #E99819;\n  border-radius: 12px;\n}\n.event-card-container .number[data-v-47ae53c8] {\n  height: 16px;\n  /* width: 50%; */\n  color: #5EA913;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  /* margin-left: 8px; */\n  display: table;\n  padding-top: 3px;\n  /* margin-top: 10px; */\n  margin: auto;\n}\n.event-card-container .supplies-status[data-v-47ae53c8] {\n  height: 16px;\n  color: #424242;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 16px;\n  display: inline-block;\n  text-transform: lowercase;\n}\n.event-card-container .supplies-status[data-v-47ae53c8]:first-letter {\n  text-transform: uppercase;\n}\n.event-card-container .oval[data-v-47ae53c8] {\n  height: 8px;\n  width: 8px;\n  display: inline-block;\n  border-radius: 3px;\n  margin-left: 16px;\n  margin-right: 3px;\n}\n.event-card-container .oval.oval-red[data-v-47ae53c8] {\n  background-color: #E93000;\n}\n.event-card-container .oval.oval-green[data-v-47ae53c8] {\n  background-color: #68B814;\n}\n.event-card-container .oval.oval-orange[data-v-47ae53c8] {\n  background-color: #FFA71B;\n}\n", ""]);

// exports


/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants_emailTemplateType__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_onclick_outside__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_onclick_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_onclick_outside__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manage-view',
  components: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_4_onclick_outside___default.a
  },
  props: {
    event: {
      type: Object,
      default: {}
    },
    isNoTrans: {
      type: Boolean,
      default: false
    },
    isChangeOrder: {
      type: Boolean,
      default: false
    },
    isFromClientDashboardView: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      emailTemplateConsts: __WEBPACK_IMPORTED_MODULE_2__store_constants_emailTemplateType__["a" /* default */],
      isAdminOrEMView: false,
      isOpenMenu: false,
      isLive: false
    };
  },
  created: function created() {
    var isView = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.role);
    this.isAdminOrEMView = isView === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].USER_ROLE.admin || isView === __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].USER_ROLE.eventManager;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    openModal: function openModal() {
      localStorage.setItem('isFromClientDashboardView', this.isFromClientDashboardView);
      localStorage.setItem('isFromStaff', false);
      var params = {
        eventId: this.event.id,
        isChangeOrder: this.isChangeOrder,
        onChangeEvent: this.onChangeEvent
      };
      this.$modal.show('eventDetailModal', params);
    },
    openMenu: function openMenu() {
      if (!this.isOpenMenu) {
        this.isOpenMenu = true;
      } else {
        this.isOpenMenu = false;
      }
    },
    closeMenu: function closeMenu() {
      this.isOpenMenu = false;
    },
    updateIsLiveEvent: function updateIsLiveEvent(type) {
      var _this = this;

      var isCheck = void 0;
      switch (type) {
        case 'LIVE':
          isCheck = !this.isLive;
          break;
        case 'ONLINE_SCHEDULER':
          isCheck = this.event.isOnlineScheduler;
          break;
        default:
          isCheck = false;
      }
      this.actionUpdateIsLiveEvent({
        eventId: this.event.id,
        isCheck: isCheck || false,
        onlineType: type
      }).then(function (response) {
        if (response.message) {
          _this.$toastr('error', response.message, '');
        } else {
          _this.isLive = response.event.isLive;
          _this.$toastr('success', 'Update event successful!', '');
        }
      });
    },
    onChangeEvent: function onChangeEvent(event) {
      this.event.maxStaffLead = event.maxStaffLead;
      this.event.maxStaffConcierge = event.maxStaffConcierge;
      this.event.maxStaffScreener = event.maxStaffScreener;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getEventById: 'ACTION_GET_EVENT_BY_ID',
    actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getLoading: 'GETTERS_IS_LOADING'
  })),
  mounted: function mounted() {
    this.isLive = this.event.isLive;
  }
});

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-card-container",
      class: _vm.isNoTrans ? "noTransition" : null
    },
    [
      _c(
        "div",
        { staticClass: "part-one" },
        [
          _c("div", { staticClass: "part-one-detail" }, [
            _c("div", { staticClass: "approve-icon part-one-icon" }),
            _vm._v(" "),
            _c("div", { staticClass: "part-one-event-name" }, [
              _c("div", { staticClass: "part-one-pref-date" }, [
                _vm._v(_vm._s(_vm.event.prefDate))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "part-one-event-name-text" }, [
                _vm._v(_vm._s(_vm.event.eventName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper-menu" }, [
              _vm.isLive
                ? _c("div", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.bottom",
                        modifiers: { hover: true, bottom: true }
                      }
                    ],
                    staticClass: "wrapper-status-icon",
                    attrs: { title: "This event is live" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover.bottom",
                    modifiers: { hover: true, bottom: true }
                  }
                ],
                staticClass: "wrapper-more-icon",
                attrs: { title: "More" },
                on: {
                  click: function($event) {
                    _vm.openMenu()
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("click-outside", { attrs: { handler: _vm.closeMenu } }, [
            _vm.isOpenMenu
              ? _c(
                  "div",
                  { staticClass: "wrapper-list" },
                  [
                    _c(
                      "b-list-group",
                      [
                        _c(
                          "b-list-group-item",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                            on: {
                              click: function($event) {
                                _vm.openModal()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass: "icon-information-black"
                            }),
                            _vm._v(" "),
                            _c("div", [_vm._v("Event details")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-list-group-item",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                            on: {
                              click: function($event) {
                                _vm.updateIsLiveEvent("LIVE")
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "status-icon-black" }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Make event " +
                                  _vm._s(_vm.isLive ? "un-live" : "live")
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "part-two" }, [
        _vm.event.trackingStatus !== "Shipping info not entered"
          ? _c("div", { class: { partTwoDetail: _vm.isAdminOrEMView } }, [
              _c("div", { staticClass: "oval oval-green" }),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(_vm._s(_vm.event.trackingStatus))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.event.trackingStatus === "Shipping info not entered"
          ? _c("div", { class: { partTwoDetail: _vm.isAdminOrEMView } }, [
              _c("div", { staticClass: "oval oval-red" }),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(_vm._s(_vm.event.trackingStatus))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdminOrEMView
          ? _c("div", { staticClass: "part-two-detail" }, [
              _c("div", { staticClass: "oval oval-green" }),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(
                  "Staffed for " +
                    _vm._s(
                      _vm.event.numStaffScreener +
                        _vm.event.numStaffLead +
                        _vm.event.numStaffConcierge
                    ) +
                    "/" +
                    _vm._s(
                      _vm.event.maxStaffScreener +
                        _vm.event.maxStaffLead +
                        _vm.event.maxStaffConcierge
                    )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdminOrEMView
          ? _c("div", [
              _vm.event.emailReminderStatus ===
              _vm.emailTemplateConsts.notReminded
                ? _c("div", { staticClass: "oval oval-red" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.emailReminderStatus !==
                _vm.emailTemplateConsts.notReminded &&
              _vm.event.emailReminderStatus !== _vm.emailTemplateConsts.thankyou
                ? _c("div", { staticClass: "oval oval-orange" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.emailReminderStatus === _vm.emailTemplateConsts.thankyou
                ? _c("div", { staticClass: "oval oval-green" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(
                  "Last Email Sent: " +
                    _vm._s(
                      _vm._f("templateName")(_vm.event.emailReminderStatus)
                    )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdminOrEMView
          ? _c("div", [
              _vm.event.maxParticipant === 0 ||
              _vm.event.numParticipant < _vm.event.maxParticipant / 2
                ? _c("div", { staticClass: "oval oval-red" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.maxParticipant > 0 &&
              _vm.event.numParticipant >= _vm.event.maxParticipant / 2 &&
              _vm.event.numParticipant < _vm.event.maxParticipant
                ? _c("div", { staticClass: "oval oval-orange" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.maxParticipant > 0 &&
              _vm.event.numParticipant >= _vm.event.maxParticipant
                ? _c("div", { staticClass: "oval oval-green" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(
                  "Participants Signups: " +
                    _vm._s(_vm.event.numParticipant) +
                    "/" +
                    _vm._s(_vm.event.maxParticipant)
                )
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47ae53c8", esExports)
  }
}

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn calendar-manager" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "date-selected" }, [
          _c("div", { staticClass: "text" }, [_vm._v("Date selected")]),
          _vm._v(" "),
          _c("div", { staticClass: "month-day" }, [
            _vm._v(
              _vm._s(_vm.today.format("MMMM")) +
                " " +
                _vm._s(_vm.today.date()) +
                " "
            ),
            _c("span", { staticClass: "year" }, [
              _vm._v(_vm._s(_vm.today.year()))
            ])
          ]),
          _vm._v(" "),
          _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) < 0
            ? _c("div", { staticClass: "date-status open" }, [_vm._v("open")])
            : _vm._e(),
          _vm._v(" "),
          _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) >= 0
            ? _c("div", { staticClass: "date-status blocked" }, [
                _vm._v("blocked")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-packing-slip-wrapper ap-btn primary",
              on: {
                click: function($event) {
                  _vm.downloadPackingSlip()
                }
              }
            },
            [_vm._v("\n          Create Packing Slip\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "calendar-and-event-container" }, [
      _c("div", { staticClass: "left-side" }, [
        _c(
          "div",
          [
            _c("div", { staticClass: "text-header" }, [
              _vm._v("\n            Calendar\n            "),
              _c(
                "button",
                {
                  staticClass: "today-btn ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.setToday()
                    }
                  }
                },
                [_vm._v("today")]
              )
            ]),
            _vm._v(" "),
            _c("CalendarDatePicker", {
              attrs: {
                showLeft: true,
                datesHasData: _vm.datesHasData,
                lockedDates: _vm.lockedDates,
                selectedDate: _vm.selectedDate,
                dateRangeHasData: _vm.dateRangeHasData
              },
              on: {
                input: _vm.selectDate,
                selectDate: _vm.setSelected,
                getDateRangeHasData: _vm.getDateRangeHasData
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "action-btn-panel" }, [
              _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) >= 0
                ? _c(
                    "button",
                    {
                      staticClass: "action-btn open ap-btn primary",
                      on: {
                        click: function($event) {
                          _vm.openSelectedDate()
                        }
                      }
                    },
                    [_vm._v("open date\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) < 0
                ? _c(
                    "button",
                    {
                      staticClass: "action-btn block ap-btn destructive",
                      on: {
                        click: function($event) {
                          _vm.blockSelectedDate()
                        }
                      }
                    },
                    [_vm._v("block date\n            ")]
                  )
                : _vm._e()
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right-side" }, [
        _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass: "overlay",
                class: { isLoading: _vm.getLoading, noDisplay: !_vm.getLoading }
              },
              [
                _c(
                  "div",
                  { staticClass: "spinner-align" },
                  [
                    _c("Icon", {
                      staticClass: "icon-size",
                      attrs: { name: "spinner", scale: "5", pulse: "" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-header" }, [_vm._v("Events")]),
            _vm._v(" "),
            _vm.getTotalApprovedEvents == 0
              ? _c("div", { staticClass: "text-content" }, [
                  _vm._v(
                    "\n          No events found for the date selected\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.getEvents, function(item, index) {
              return [
                _c("div", { staticClass: "cheetah-digital" }, [
                  _c("span", [_vm._v(_vm._s(item.clientName))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "event-cards-wrapper" },
                  _vm._l(item.events, function(event, index) {
                    return _c("EventCard", {
                      key: index,
                      attrs: { event: event, isNoTrans: index % 3 == 2 }
                    })
                  })
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clear-both" })
              ]
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44118e20", esExports)
  }
}

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanAndApprove_vue__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6581373e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanAndApprove_vue__ = __webpack_require__(1778);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1758)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanAndApprove_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6581373e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanAndApprove_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/PlanAndApprove.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PlanAndApprove.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6581373e", Component.options)
  } else {
    hotAPI.reload("data-v-6581373e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1759);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0dede5f3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6581373e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PlanAndApprove.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6581373e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PlanAndApprove.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.isLoading {\n  display: block;\n  text-align: center;\n  color: #606060;\n}\n.noDisplay {\n  display: none;\n}\n.event-row-wrapper {\n  margin: 8px 0px;\n}\n.icon-size {\n  width: 100px;\n  height: 100px;\n}\n.plan-and-approve-container .table-event-container {\n  background-color: #f5f5f5;\n  overflow: auto;\n}\n.plan-and-approve-container .table-event-container .fix-position-top {\n  -webkit-transition: all 0.7s;\n  transition: all 0.7s;\n}\n", ""]);

// exports


/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_commons_EventStatusSelection__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_datatable_EventRow__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_datatable_TableHeader__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_spinner__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import nav from '../../_nav';






/* Register component with one of 2 methods */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plan-and-approve',
  components: {
    EventStatusSelection: __WEBPACK_IMPORTED_MODULE_1__components_commons_EventStatusSelection__["a" /* default */],
    EventRow: __WEBPACK_IMPORTED_MODULE_2__components_datatable_EventRow__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__["a" /* default */],
    TableHeader: __WEBPACK_IMPORTED_MODULE_5__components_datatable_TableHeader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getHeightOfComp: function getHeightOfComp() {
      return 127;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    getListEvent: 'GETTERS_LIST_EVENT',
    getLoading: 'GETTERS_IS_LOADING'
  })),
  data: function data() {
    return {
      fixElement: false
    };
  },

  methods: {
    handleScroll: function handleScroll() {
      this.fixElement = window.scrollY >= 180;
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].viewNames.planAndApprove);
  }
});

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventStatusSelection_vue__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0692e671_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventStatusSelection_vue__ = __webpack_require__(1771);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1762)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventStatusSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0692e671_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventStatusSelection_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/EventStatusSelection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventStatusSelection.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0692e671", Component.options)
  } else {
    hotAPI.reload("data-v-0692e671", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1763);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("75b9b396", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0692e671\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventStatusSelection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0692e671\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventStatusSelection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.event-status-selection {\n  background-color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  color: #1A1718;\n  padding-top: 15px;\n  width: 100%;\n}\n.event-status-selection .table-header-fix-position {\n  background-color: #f5f5f5;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.event-status-selection.event-status-selection-fix-top {\n  -webkit-transition: top 0.2s ease-in;\n  transition: top 0.2s ease-in;\n  padding-top: 0;\n  height: 89px;\n  position: fixed;\n  top: -20px;\n  z-index: 1000;\n}\n.event-status-selection .scrollIcon {\n  position: absolute;\n  top: 20;\n  right: 0;\n}\n.event-status-selection .display-none-something {\n  display: none;\n}\n.event-status-selection .title {\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  height: 20px;\n  text-transform: uppercase;\n}\n.event-status-selection .list-status-fix-top {\n  height: 44px !important;\n}\n.event-status-selection .list-status {\n  margin-top: 5px;\n  margin-left: 0;\n  margin-right: 0;\n  height: 53px;\n}\n.event-status-selection .list-status .list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.event-status-selection .list-status .list .item {\n  float: left;\n  width: 100px;\n}\n.event-status-selection .list-status .list .item .status {\n  font-size: 12px;\n  color: #626262;\n}\n.event-status-selection .list-status .list .item .count {\n  font-size: 16px;\n  font-weight: bold;\n}\n.event-status-selection .list-status .active-wrapper {\n  border-color: #085269 !important;\n  background-color: #085269;\n}\n.event-status-selection .list-status .icon-wrapper {\n  border: solid 1px #00A4D6;\n  border-radius: 3px;\n  width: 32px;\n  height: 32px;\n  margin-top: 5px;\n  position: relative;\n  text-align: center;\n}\n.event-status-selection .list-status .icon-wrapper:hover {\n  cursor: pointer;\n}\n.event-status-selection .list-status .icon-wrapper .icon-filter {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(164) + ") no-repeat center;\n  mask: url(" + __webpack_require__(164) + ") no-repeat center;\n  background: url(" + __webpack_require__(405) + ");\n}\n.event-status-selection .list-status .icon-wrapper .active {\n  color: #ffffff;\n  background-color: #ffffff;\n}\n.event-status-selection .list-status .icon-wrapper .active.icon-filter {\n  /*-webkit-mask: unset;*/\n  /*mask: unset;*/\n  background: url(" + __webpack_require__(1764) + ");\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel {\n  list-style: none;\n  font-size: 12px;\n  line-height: 26px;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 0;\n  border-radius: 3px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  position: absolute;\n  top: 32px;\n  left: 0;\n  width: 200px;\n  z-index: 9999;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel .title {\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  color: #1A1718;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li {\n  /* On mouse-over, add a grey background color */\n  /* When the checkbox is checked, add a blue background */\n  /* Show the checkmark when checked */\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li:last-child {\n  border-bottom: none;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .checkbox-active {\n  color: #00A4D6 !important;\n  font-weight: bold;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 0px;\n  color: #626262;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  left: 0;\n  bottom: 6px;\n  width: 16px;\n  height: 16px;\n  z-index: 10;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox .checkmark {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #FFFFFF;\n  border: solid 1px #b9b9b9;\n  z-index: 1;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox .checkmark::after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox input:checked ~ .checkmark {\n  background-color: #00A4D6;\n  color: #00A4D6;\n  border: none;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox input:checked ~ .checkmark:after {\n  display: block;\n}\n.event-status-selection .list-status .icon-wrapper ul.action-panel li .input-checkbox ~ .checkmark:after {\n  color: #00A4D6;\n}\n", ""]);

// exports


/***/ }),
/* 1764 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmZpbHRlcjwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMjJhMS41MiwxLjUyLDAsMCwxLS43NC0uMkExLjUsMS41LDAsMCwxLDksMjAuNDhWMTEuNzZMMi40Miw3LjA2QTEsMSwwLDAsMSwyLDYuMjRWMy41QTEuNSwxLjUsMCwwLDEsMy41LDJoMTdBMS41LDEuNSwwLDAsMSwyMiwzLjVWNi4yNGExLDEsMCwwLDEtLjQyLjgyTDE1LDExLjc2djYuOTJBMS41MSwxLjUxLDAsMCwxLDE0LjI3LDIwbC0zLDEuOEExLjUyLDEuNTIsMCwwLDEsMTAuNSwyMlpNMy41LDNhLjUuNSwwLDAsMC0uNS41VjYuMjRsNi41OCw0LjdhMSwxLDAsMCwxLC40Mi44MnY4LjcyYS41LjUsMCwwLDAsLjI1LjQ0LjUuNSwwLDAsMCwuNTEsMGwzLTEuOGEuNS41LDAsMCwwLC4yNC0uNDNWMTEuNzZhMSwxLDAsMCwxLC40Mi0uODJMMjEsNi4yNFYzLjVhLjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_filter__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datatable_TableHeader__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ScrollTop__ = __webpack_require__(100);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-status-selection',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    TableHeader: __WEBPACK_IMPORTED_MODULE_4__datatable_TableHeader__["a" /* default */],
    ScrollTop: __WEBPACK_IMPORTED_MODULE_6__utils_ScrollTop__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      listEventStatus: [{
        text: 'Drafts',
        count: 200,
        isCheck: false
      }, {
        text: 'Submitted',
        count: 0,
        isCheck: false
      }, {
        text: 'Review',
        count: 100,
        isCheck: false
      }, {
        text: 'Approved',
        count: 101,
        isCheck: false
      }, {
        text: 'Archived',
        count: 1,
        isCheck: false
      }],
      isShowAction: false,
      fixElementChild: false,
      listChecked: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    selectStatus: function selectStatus(item) {},
    handleScroll: function handleScroll() {
      this.fixElementChild = window.scrollY >= 180;
    },

    getListEventParams: function getListEventParams(statuses) {
      return {
        userId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.userId)),
        status: statuses,
        options: [],
        clientId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.clientId))
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getEventsByStatuses: 'ACTION_GET_EVENT_LIST',
    getEventCountByClientId: 'ACTION_GET_EVENT_COUNT_BY_CLIENT'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS'
  })),
  mounted: function mounted() {},
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    this.listChecked = [];
    this.getEventCountByClientId().then(function () {});
  },

  watch: {
    listEventStatus: {
      handler: function handler(val, oldVal) {
        var _this = this;

        this.listChecked = [];
        val.forEach(function (item) {
          if (item.isCheck) {
            _this.listChecked.push(item.text.toUpperCase());
          }
        });
        this.getEventsByStatuses(this.getListEventParams(this.listChecked));
      },
      deep: true
    }
  }
});

/***/ }),
/* 1766 */,
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("512c0f2e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f9d3a054\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableHeader.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f9d3a054\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableHeader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.table-header {\n  color: #8E8E8E;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  height: 40px;\n  padding: 12px 0px;\n}\n.table-header .dt-header .text-center {\n  text-align: center;\n}\n.table-header .dt-header .header-col {\n  float: left;\n  overflow: hidden;\n  padding-left: 8px;\n  text-transform: uppercase;\n  word-break: break-all;\n}\n.table-header .dt-header .header-col .content {\n  height: 16px;\n}\n.table-header .dt-header .header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.table-header .dt-header .header-col .header-container {\n  position: relative;\n}\n.table-header .dt-header .header-col .crop {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n}\n.table-header .dt-header .header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-header .dt-header .header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.table-header .dt-header .header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n  height: 16px;\n}\n.table-header .dt-header .header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.table-header .dt-header .header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-header .dt-header .header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-header .dt-header .header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-header .dt-header .header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.table-header .dt-header .header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.table-header .dt-header .header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.table-header .dt-header .header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.table-header .dt-header .header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n", ""]);

// exports


/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '../../_consts';






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-header',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '25',
        totalItems: this.totalItems,
        sortType: 'isChangeOrder',
        sortReverse: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setSortOption: function setSortOption(sortType) {
      var fieldType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.pagingObj.sortType = sortType;
      this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
      this.sortByFieldName({
        fieldName: sortType,
        isReverse: this.pagingObj.sortReverse,
        fieldType: fieldType
      });
    },
    changeColumnWidth: function changeColumnWidth(colName, mouseDownEvent) {
      this.resizing = true;
      var vueApp = this;
      // get current mouse position
      var shiftX = mouseDownEvent.clientX;
      // header width
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      var maxLeft = this.getColumnWidth[colName].size ? this.getColumnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      var newWidth = maxLeft;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      function onMouseMove(event) {
        // new position
        var bufferPx = event.clientX - shiftX;
        var newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && maxLeft - Math.abs(bufferPx) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2)
        });
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(function () {
          vueApp.resizing = false;
        }, 50);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH'
  }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])({
    sortByFieldName: 'MUTATION_SORT_EVENT_BY_FIELD_NAME'
  })),
  mounted: function mounted() {}
});

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-header" }, [
    _c("div", { staticClass: "dt-header", attrs: { id: "dt-header" } }, [
      _c(
        "div",
        {
          staticClass: "header-col text-center",
          style: {
            width: _vm.getColumnWidth.eventName.size
              ? _vm.getColumnWidth.eventName.size + "px"
              : "12%"
          },
          attrs: { id: "eventName" },
          on: {
            click: function($event) {
              _vm.setSortOption("eventName")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("eventName", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            name\n            "),
                  this.pagingObj.sortType != "eventName"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "eventName" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "eventName" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.projPart.size
              ? _vm.getColumnWidth.projPart.size + "px"
              : "6%"
          },
          attrs: { id: "projPart" },
          on: {
            click: function($event) {
              _vm.setSortOption("projPart", 1)
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("projPart", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "content no-select" }, [
                _vm._v("\n            PART\n            "),
                _c(
                  "span",
                  [
                    this.pagingObj.sortType != "projPart"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "projPart" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "projPart" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.fullAddress.size
              ? _vm.getColumnWidth.fullAddress.size + "px"
              : "26%"
          },
          attrs: { id: "fullAddress" },
          on: {
            click: function($event) {
              _vm.setSortOption("fullAddress")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("fullAddress", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            FULL ADDRESS\n            "),
                  this.pagingObj.sortType != "fullAddress"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "fullAddress" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "fullAddress" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.eventLocation.size
              ? _vm.getColumnWidth.eventLocation.size + "px"
              : "8%"
          },
          attrs: { id: "eventLocation" },
          on: {
            click: function($event) {
              _vm.setSortOption("eventLocation")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("eventLocation", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            LOCATION\n            "),
                  this.pagingObj.sortType != "eventLocation"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "eventLocation" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "eventLocation" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.startTime.size
              ? _vm.getColumnWidth.startTime.size + "px"
              : "7%"
          },
          attrs: { id: "startTime" },
          on: {
            click: function($event) {
              _vm.setSortOption("startTime")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("startTime", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            start\n            "),
                  this.pagingObj.sortType != "startTime"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "startTime" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "startTime" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.duration.size
              ? _vm.getColumnWidth.duration.size + "px"
              : "5%"
          },
          attrs: { id: "duration" },
          on: {
            click: function($event) {
              _vm.setSortOption("duration")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("duration", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            dur\n            "),
                  this.pagingObj.sortType != "duration"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "duration" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "duration" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.endTime.size
              ? _vm.getColumnWidth.endTime.size + "px"
              : "7%"
          },
          attrs: { id: "endTime" },
          on: {
            click: function($event) {
              _vm.setSortOption("endTime")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("endTime", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            end\n            "),
                  this.pagingObj.sortType != "endTime"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "endTime" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "endTime" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.timeZone.size
              ? _vm.getColumnWidth.timeZone.size + "px"
              : "4%"
          },
          attrs: { id: "timeZone" },
          on: {
            click: function($event) {
              _vm.setSortOption("timeZone")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("timeZone", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            tz\n            "),
                  this.pagingObj.sortType != "timeZone"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "timeZone" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "timeZone" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.contactName.size
              ? _vm.getColumnWidth.contactName.size + "px"
              : "9%"
          },
          attrs: { id: "contactName" },
          on: {
            click: function($event) {
              _vm.setSortOption("contactName")
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c("div", {
                staticClass: "crop-line crop-right-line",
                on: {
                  mousedown: function($event) {
                    _vm.changeColumnWidth("contactName", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            CONTACT\n            "),
                  this.pagingObj.sortType != "contactName"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "contactName" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "contactName" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-col",
          style: {
            width: _vm.getColumnWidth.prefDate.size
              ? _vm.getColumnWidth.prefDate.size + "px"
              : "11%"
          },
          attrs: { id: "prefDate" },
          on: {
            click: function($event) {
              _vm.setSortOption("prefDate", 2)
            }
          }
        },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "crop" }, [
              _c(
                "div",
                { staticClass: "content no-select" },
                [
                  _vm._v("\n            DATE\n            "),
                  this.pagingObj.sortType != "prefDate"
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "prefDate" &&
                  this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-up" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  this.pagingObj.sortType == "prefDate" &&
                  !this.pagingObj.sortReverse
                    ? _c("Icon", {
                        staticClass: "sort-icon",
                        attrs: { name: "sort-down" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f9d3a054", esExports)
  }
}

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-status-selection",
      class: { "event-status-selection-fix-top": _vm.fixElementChild }
    },
    [
      _c(
        "div",
        {
          staticClass: "title margin-side",
          class: { "display-none-something": false }
        },
        [_vm._v("Event Status")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "list-status margin-side row",
          class: { "list-status-fix-top": _vm.fixElementChild }
        },
        [
          _c(
            "ul",
            { staticClass: "list" },
            _vm._l(_vm.listEventStatus, function(item) {
              return _c("li", { key: item.text, staticClass: "item" }, [
                _c("div", { staticClass: "status" }, [
                  _vm._v("\n          " + _vm._s(item.text) + "\n        ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "count" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.countEventByStatus(item.text)) +
                      "\n        "
                  )
                ])
              ])
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "icon-wrapper",
              class: { "active-wrapper": _vm.isShowAction },
              on: {
                click: function($event) {
                  _vm.isShowAction = true
                },
                mouseleave: function($event) {
                  _vm.isShowAction = false
                }
              }
            },
            [
              _c("Icon", {
                staticClass: "icon-filter",
                class: { active: _vm.isShowAction },
                attrs: { name: "filter" }
              }),
              _vm._v(" "),
              _vm.isShowAction
                ? _c(
                    "ul",
                    { staticClass: "action-panel" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("Display")]),
                      _vm._v(" "),
                      _vm._l(_vm.listEventStatus, function(item) {
                        return _c("li", { key: item.text }, [
                          _c(
                            "div",
                            {
                              staticClass: "input-checkbox",
                              class: { "checkbox-active": item.isCheck }
                            },
                            [
                              _vm._v(_vm._s(item.text) + "\n            "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.isCheck,
                                    expression: "item.isCheck"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(item.isCheck)
                                    ? _vm._i(item.isCheck, null) > -1
                                    : item.isCheck
                                },
                                on: {
                                  click: function($event) {
                                    _vm.selectStatus(item)
                                  },
                                  change: function($event) {
                                    var $$a = item.isCheck,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "isCheck",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "isCheck",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "isCheck", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "checkmark" })
                            ]
                          )
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "display-none-something": !_vm.fixElementChild,
                scrollIcon: _vm.fixElementChild
              }
            },
            [_c("ScrollTop")],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.fixElementChild
        ? _c("TableHeader", { staticClass: "table-header-fix-position" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0692e671", esExports)
  }
}

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventRow_vue__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_633b0795_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventRow_vue__ = __webpack_require__(1777);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1773)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_633b0795_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/datatable/EventRow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventRow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-633b0795", Component.options)
  } else {
    hotAPI.reload("data-v-633b0795", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1774);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("e5bca6de", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-633b0795\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventRow.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-633b0795\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventRow.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.openContent {\n  height: 348px !important;\n  -webkit-transition: height ease 0.5s;\n  transition: height ease 0.5s;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.openContent .dt-row-item-detail {\n  clear: both;\n}\n.openContent .dt-row-item-detail .item-detail-header {\n  text-transform: uppercase;\n  font-size: 12px;\n  line-height: 16px;\n  border-bottom: solid 1px #7b7b7b;\n  height: 34px;\n  background-color: #606060;\n  font-family: \"Open Sans\", serif;\n  color: #ffffff;\n  letter-spacing: 0.1px;\n}\n.openContent .dt-row-item-detail .item-detail-body {\n  background-color: #ffffff;\n  padding: 20px 10px 15px 20px;\n  height: 314px;\n}\n.openContent .dt-row-item-detail .item-detail-body .row-detail-icon-exclamation-circle {\n  height: 14px;\n  width: 14px;\n  border-radius: 6px;\n  padding: 0;\n  color: #0080a5;\n  background-color: #ffffff;\n  overflow: visible;\n}\n.openContent .dt-row-item-detail .item-detail-body .icon-alert {\n  padding: 2px 0 0 22px;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-alert {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  padding: 0 20px 0 15px;\n  color: #626262;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field {\n  margin-top: 20px;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field:first-child {\n  margin-top: 0;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-label {\n  font-size: 12px;\n  text-transform: capitalize;\n  line-height: 18px;\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-label .label-address {\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value .shipping-address {\n  width: 100%;\n  border: solid 1px #b9b9b9;\n  border-radius: 4px;\n  height: 32px;\n  font-size: 12px;\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n  padding-left: 16px;\n  background-color: #ffffff;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value textarea {\n  width: 100%;\n  border-radius: 4px;\n  border: solid 1px #b9b9b9;\n  padding: 5px 10px;\n  background-color: #ffffff;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value textarea.custom-notes {\n  height: 55px;\n  padding-left: 14px;\n  color: #231f20;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value textarea.additional-comments {\n  height: 58px;\n  padding-left: 14px;\n  font-size: 12px;\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact {\n  margin-bottom: 20px;\n  margin-right: 10px;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact .phoneAndEmail {\n  height: 32px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0 0 0 13px;\n  font-size: 12px;\n  color: #424242;\n  background-color: #ffffff;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact .label {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  text-transform: capitalize;\n  line-height: 18px;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact .contactName {\n  line-height: 31px;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-off-text {\n  color: #e6e6e6 !important;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-off-checkbox {\n  border: 1.5px solid rgba(0, 0, 0, 0.02) !important;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-off-checkbox:after {\n  border: 1.5px solid rgba(0, 0, 0, 0.02) !important;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item {\n  margin-left: 0;\n  margin-top: 8px;\n  height: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item .text {\n  color: #626262;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  display: inline;\n  margin-left: 8px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item label:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item input:checked + label {\n  background: #0080A5;\n  border: 1.5px solid #0080A5;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item input:checked + label:after {\n  left: calc(100%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item label:active:after {\n  width: 15px;\n}\n.openContent .dt-row-item-detail .item-detail-body .func-group button {\n  font-size: 14px;\n  height: 39px;\n  font-family: 'Open Sans', sans-serif;\n  text-transform: uppercase;\n}\n.openContent .dt-row-item-detail .item-detail-body .func-group button .func-icon {\n  width: 18px;\n  height: 18px;\n  color: #ffffff;\n  float: left;\n}\n.openContent .dt-row-item-detail .item-detail-body .func-group .grey-3 {\n  color: #b9b9b9;\n}\n.displayNone {\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: height ease 0.5s;\n  transition: height ease 0.5s;\n}\n.event-row {\n  height: 56px;\n  background-color: #ffffff;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  position: relative;\n}\n.event-row .column {\n  float: left;\n}\n.event-row .column .content {\n  padding: 20px 0 0 8px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.event-row .column .content.column-name {\n  padding: 12px 0 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n}\n.event-row .column .content .info .client-name {\n  color: #9D9D9D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.event-row .column .content .info .event-name {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.event-row .column .content .icon-status {\n  width: 24px;\n  float: left;\n  margin-top: 4px;\n  margin-right: 8px;\n}\n.event-row .column .content .icon-status .calendar-checked-icon {\n  z-index: 7;\n  width: 24px;\n  height: 24px;\n  background-color: #606060;\n  color: #606060;\n  -webkit-mask: url(" + __webpack_require__(832) + ") no-repeat center;\n  mask: url(" + __webpack_require__(832) + ") no-repeat center;\n  background: url(" + __webpack_require__(1775) + ") no-repeat center;\n}\n.event-row .btn-func {\n  position: absolute;\n  right: 0;\n  top: 20px;\n}\n.event-row .btn-func .icon-btn-func {\n  width: 24px;\n  height: 24px;\n  color: #8E8E8E;\n}\n.li-red:before {\n  color: #a42022 !important;\n}\n.padding-left-71 {\n  padding-left: 71px;\n}\n.padding-left-27 {\n  padding-left: 27px;\n}\n.padding-top-9px {\n  padding-top: 9px;\n}\n", ""]);

// exports


/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjA2MDYwIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyNDwvdGl0bGU+PHBhdGggZD0iTTIwLDRIMTYuNVYzYS41LjUsMCwwLDAtMSwwVjRoLTdWM2EuNS41LDAsMCwwLTEsMFY0SDRBMiwyLDAsMCwwLDIsNlYxOGEyLDIsMCwwLDAsMiwySDIwYTIsMiwwLDAsMCwyLTJWNkEyLDIsMCwwLDAsMjAsNFpNNCw1SDcuNVY2YS41LjUsMCwwLDAsMSwwVjVoN1Y2YS41LjUsMCwwLDAsMSwwVjVIMjBhMSwxLDAsMCwxLDEsMVY3LjE1SDNWNkExLDEsMCwwLDEsNCw1Wk0yMCwxOUg0YTEsMSwwLDAsMS0xLTFWOC4xNUgyMVYxOEExLDEsMCwwLDEsMjAsMTlaIi8+PHBhdGggZD0iTTE0LjY1LDExLjY1LDExLjUsMTQuNzksOS44NSwxMy4xNWEuNDkuNDksMCwwLDAtLjcuN2wyLDJhLjQ5LjQ5LDAsMCwwLC4zNS4xNS40Ny40NywwLDAsMCwuMzUtLjE1bDMuNS0zLjVhLjQ5LjQ5LDAsMCwwLS43LS43WiIvPjwvc3ZnPg=="

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_ellipsis_v__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_google_autocomplete__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_vue_the_mask__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DataTableGroupBtn__ = __webpack_require__(811);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import constants from '../../_consts';







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-row',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_4_vue_google_autocomplete__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_5__utils_vue_the_mask__["a" /* TheMask */],
    DataTableGroupBtn: __WEBPACK_IMPORTED_MODULE_6__DataTableGroupBtn__["a" /* default */]
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    item: {
      type: Object,
      default: []
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isDisplay: false,
      editable: false,
      isLocked: false,
      showOnModal: false,
      editEventAdmin: false,
      viewMode: false,
      suggestChanges: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getId: 'GETTERS_GET_EXPAND_ID',
    getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH'
  }), {
    enableIconDuration: function enableIconDuration() {
      return this.item.duration < 4 || this.item.duration > 8;
    },
    disableIconContact: function disableIconContact() {
      return !(this.item.email !== '' && this.item.phone !== '' && this.item.contactName !== '');
    },
    disableAdditionalServices: function disableAdditionalServices() {
      return true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setExpandId: function setExpandId(id) {
      this.setIdToState(id);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    setIdToState: 'MUTATION_SET_EXPAND_ID'
  })),
  mounted: function mounted() {}
});

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "event-row",
        on: {
          click: function($event) {
            _vm.setExpandId(_vm.item.id)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.eventName.size != 0
                  ? _vm.getColumnWidth.eventName.size + "px"
                  : "12%"
            }
          },
          [
            _c("div", { staticClass: "content column-name" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "client-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.item.clientName) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "event-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.item.eventName) +
                      "\n          "
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.projPart.size != 0
                  ? _vm.getColumnWidth.projPart.size + "px"
                  : "6%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.projPart) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.fullAddress.size != 0
                  ? _vm.getColumnWidth.fullAddress.size + "px"
                  : "26%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.fullAddress) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.eventLocation.size != 0
                  ? _vm.getColumnWidth.eventLocation.size + "px"
                  : "8%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.eventLocation) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.startTime.size != 0
                  ? _vm.getColumnWidth.startTime.size + "px"
                  : "7%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.startTime) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.duration.size != 0
                  ? _vm.getColumnWidth.duration.size + "px"
                  : "5%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.duration) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.endTime.size != 0
                  ? _vm.getColumnWidth.endTime.size + "px"
                  : "7%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.endTime) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.timeZone.size != 0
                  ? _vm.getColumnWidth.timeZone.size + "px"
                  : "4%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.timeZone) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.contactName.size != 0
                  ? _vm.getColumnWidth.contactName.size + "px"
                  : "9%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.contactName))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.prefDate.size != 0
                  ? _vm.getColumnWidth.action.size + "px"
                  : "11%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.prefDate) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-func" },
          [
            _c("Icon", {
              staticClass: "icon-btn-func",
              attrs: { name: "ellipsis-v" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "displayNone",
        class: { openContent: _vm.item.id == _vm.getId }
      },
      [
        _c("div", { staticClass: "dt-row-item-detail" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "item-detail-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _vm.item.isChangeOrder
                  ? _c("div", { staticClass: "row li-red" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle circle-red",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.projPart < 33
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(3)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.projPart > 200
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(4)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.disableIconContact
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(5)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.enableIconDuration
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(6)
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c("div", { staticClass: "notes-field" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-value" },
                    [
                      _c("vue-google-autocomplete", {
                        attrs: {
                          name: "shipping-address",
                          id: "shipping_" + _vm.index,
                          classname: "additional-comments shipping-address",
                          country: ["us"],
                          item: _vm.item,
                          disabled: !_vm.editable
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notes-field" }, [
                  _c("div", { staticClass: "text-label" }, [
                    _vm._v(
                      "\n                  Additional comments\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-value" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.additionalComments,
                          expression: "item.additionalComments"
                        }
                      ],
                      staticClass: "additional-comments",
                      attrs: {
                        name: "additional-comments",
                        disabled: !_vm.editable
                      },
                      domProps: { value: _vm.item.additionalComments },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.item,
                            "additionalComments",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c("div", { staticClass: "text-contact grey-3" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contactName" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.contactName,
                          expression: "item.contactName"
                        }
                      ],
                      staticClass: "phoneAndEmail",
                      attrs: {
                        placeholder: "Contact name",
                        disabled: !_vm.editable
                      },
                      domProps: { value: _vm.item.contactName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "contactName", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-contact grey-3" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.email,
                          expression: "item.email"
                        }
                      ],
                      staticClass: "phoneAndEmail",
                      attrs: {
                        placeholder: "E.g. hannah_welch@gmail.com",
                        disabled: !_vm.editable
                      },
                      domProps: { value: _vm.item.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "email", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-contact grey-3" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("Phone")]),
                    _vm._v(" "),
                    _c("the-mask", {
                      staticClass: "phoneAndEmail",
                      attrs: {
                        mask: "(###) ###-####",
                        masked: _vm.isTrue,
                        placeholder: "(123) 123-1234",
                        disabled: !_vm.editable
                      },
                      model: {
                        value: _vm.item.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.item, "phone", $$v)
                        },
                        expression: "item.phone"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-on-wrapper col-sm-2" },
                _vm._l(_vm.item.additionalServices, function(itemAddOn, index) {
                  return _c("div", { key: index, staticClass: "add-on-item" }, [
                    _c("div", {}, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: itemAddOn.value,
                            expression: "itemAddOn.value"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: itemAddOn.key + "_" + _vm.item.id,
                          disabled: _vm.disableAdditionalServices
                        },
                        domProps: {
                          checked: Array.isArray(itemAddOn.value)
                            ? _vm._i(itemAddOn.value, null) > -1
                            : itemAddOn.value
                        },
                        on: {
                          change: function($event) {
                            var $$a = itemAddOn.value,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    itemAddOn,
                                    "value",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    itemAddOn,
                                    "value",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(itemAddOn, "value", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          class: { "add-on-off-checkbox": !itemAddOn.isShow },
                          attrs: { for: itemAddOn.key + "_" + _vm.item.id }
                        },
                        [_vm._v("Toggle")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text",
                        class: { "add-on-off-text": !itemAddOn.isShow }
                      },
                      [_vm._v(_vm._s(itemAddOn.text))]
                    )
                  ])
                })
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "func-group" },
              [
                _c("DataTableGroupBtn", {
                  attrs: {
                    isLocked: _vm.isLocked,
                    showOnModal: _vm.showOnModal,
                    editEventAdmin: _vm.editEventAdmin,
                    viewMode: _vm.viewMode,
                    eventStatus: _vm.eventStatus,
                    item: _vm.item,
                    isSuggestChanges: _vm.suggestChanges
                  }
                })
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-status" }, [
      _c("div", { staticClass: "calendar-checked-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-detail-header" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-3 padding-left-71 padding-top-9px" }, [
          _vm._v("alerts")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4 padding-left-27 padding-top-9px" }, [
          _vm._v("event notes")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 padding-top-9px" }, [
          _vm._v("on site contact")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2 padding-top-9px" }, [
          _vm._v("add on services")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "This item approved as a change order. Check change notes and contract details."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "Your estimated participation is low. Consider using small site event."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v("Your estimated participation is high. Break event into 2 days.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "Missing (email, phone number, email and phone number) for on site contact."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-label" }, [
      _vm._v("\n                  shipping address\n                  "),
      _c("span", { staticClass: "grey-3 label-address" }, [
        _vm._v("(if different)")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-633b0795", esExports)
  }
}

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn plan-and-approve-container" },
    [
      _c("EventStatusSelection"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-event-container margin-side" },
        [
          _c("TableHeader"),
          _vm._v(" "),
          _c(
            "div",
            {
              style: { "padding-top": _vm.fixElement ? "55px" : 0 },
              attrs: { id: "dt-body" }
            },
            [
              _vm._l(_vm.getListEvent, function(item, index) {
                return [
                  _c("EventRow", {
                    key: item,
                    staticClass: "event-row-wrapper",
                    attrs: { item: item, index: index }
                  })
                ]
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: { isLoading: _vm.getLoading, noDisplay: !_vm.getLoading } },
        [
          _c("Icon", {
            staticClass: "icon-size",
            attrs: { name: "spinner", scale: "5", pulse: "" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6581373e", esExports)
  }
}

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageApproved_vue__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0b510c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageApproved_vue__ = __webpack_require__(1794);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1780)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageApproved_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0b510c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageApproved_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/ManageApproved.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManageApproved.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0b510c4", Component.options)
  } else {
    hotAPI.reload("data-v-c0b510c4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1781);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1f1d5538", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0b510c4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManageApproved.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0b510c4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManageApproved.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.fix-element-to-top{\n  position: fixed;\n  top: 0;\n  z-index: 1000;\n  height: 54px;\n}\n", ""]);

// exports


/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_subHeaders_SubHeaderManageApprovedDashBoard__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_manage_Manage__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manage-approved',
  components: {
    Manage: __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_manage_Manage__["a" /* default */],
    SubHeaderManageApprovedDashBoard: __WEBPACK_IMPORTED_MODULE_1__components_subHeaders_SubHeaderManageApprovedDashBoard__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getHeightOfComp: function getHeightOfComp() {
      return 54;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    getLoading: 'GETTERS_IS_LOADING'
  })),
  data: function data() {
    return {
      fixElement: false,
      sliderValue: ['0', '60+'],
      dataSort: ['dateTime'],
      dataFilter: ['APPROVED'],
      textSearch: this.$route.params.textSearch || '',
      listEventByClients: []
    };
  },

  methods: {
    handleScroll: function handleScroll() {
      this.fixElement = window.scrollY >= 180;
    },
    handleSliderChangeValue: function handleSliderChangeValue(data) {
      this.sliderValue = data;
    },
    handleChangeDataSort: function handleChangeDataSort(data) {
      this.dataSort = data;
    },
    handleChangeDataFilter: function handleChangeDataFilter(data) {
      this.dataFilter = data;
    },
    handleTextSearchChange: function handleTextSearchChange(textSearch) {
      this.textSearch = textSearch;
    }
  },
  created: function created() {
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].viewNames.manageApprovedDashboard);
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.textSearch = this.$route.params.textSearch || '';
    if (this.$route.params.filter) {
      this.dataFilter = this.$route.params.filter.split(',');
    }
    if (this.$route.params.sort) {
      this.dataSort = this.$route.params.sort.split(',');
    }
    if (this.$route.params.dateSliderValue) {
      var ar = this.$route.params.dateSliderValue.split(',');
      this.sliderValue = ar;
    }
  }
});

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderManageApprovedDashBoard_vue__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81f8fd0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderManageApprovedDashBoard_vue__ = __webpack_require__(1788);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1784)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81f8fd0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderManageApprovedDashBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81f8fd0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderManageApprovedDashBoard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderManageApprovedDashBoard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderManageApprovedDashBoard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-81f8fd0c", Component.options)
  } else {
    hotAPI.reload("data-v-81f8fd0c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1785);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("52dcc1de", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-81f8fd0c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderManageApprovedDashBoard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-81f8fd0c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderManageApprovedDashBoard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.paddingLeft9px[data-v-81f8fd0c] {\n  padding-left: 9px;\n}\n.backgroundColor[data-v-81f8fd0c] {\n  background-color: #f5f5f5 !important;\n}\n.subHeader[data-v-81f8fd0c] {\n  /*height: 96px;*/\n  background-color: #ffffff;\n  z-index: 1000;\n}\n.subHeader .sub-header-container[data-v-81f8fd0c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.subHeader .sub-header-container .search-input[data-v-81f8fd0c] {\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  line-height: 16px;\n  color: #1d1d1d;\n  padding-left: 12px;\n}\n.subHeader .title[data-v-81f8fd0c] {\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  height: 20px;\n  text-transform: uppercase;\n}\n.subHeader .marginTop10px[data-v-81f8fd0c] {\n  margin-top: 10px;\n}\n.subHeader .dateOut[data-v-81f8fd0c] {\n  position: relative;\n  top: -15px;\n}\n.subHeader .paddingLeft19px[data-v-81f8fd0c] {\n  padding-left: 19px !important;\n}\n.subHeader .active-wrapper[data-v-81f8fd0c] {\n  border-color: #085269 !important;\n  background-color: #085269;\n}\n.subHeader .icon-wrapper[data-v-81f8fd0c] {\n  border: solid 1px #00A4D6;\n  border-radius: 3px;\n  width: 32px;\n  height: 32px;\n  position: relative;\n  text-align: center;\n}\n.subHeader .icon-wrapper[data-v-81f8fd0c]:hover {\n  cursor: pointer;\n}\n.subHeader .icon-wrapper.marginTop11px[data-v-81f8fd0c] {\n  margin-top: 11px;\n}\n.subHeader .icon-wrapper .icon-filter[data-v-81f8fd0c] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(833) + ") no-repeat center;\n  mask: url(" + __webpack_require__(833) + ") no-repeat center;\n  background: url(" + __webpack_require__(1786) + ");\n}\n.subHeader .icon-wrapper .icon-sort[data-v-81f8fd0c] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(164) + ") no-repeat center;\n  mask: url(" + __webpack_require__(164) + ") no-repeat center;\n  background: url(" + __webpack_require__(405) + ");\n}\n.subHeader .icon-wrapper .active[data-v-81f8fd0c] {\n  color: #ffffff;\n  background-color: #ffffff;\n}\n.subHeader .icon-wrapper ul.action-panel[data-v-81f8fd0c] {\n  list-style: none;\n  font-size: 12px;\n  line-height: 26px;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 0;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  position: absolute;\n  top: 32px;\n  left: 0;\n  width: 200px;\n  z-index: 9999;\n}\n.subHeader .icon-wrapper ul.action-panel .title[data-v-81f8fd0c] {\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  color: #1A1718;\n}\n.subHeader .icon-wrapper ul.action-panel li[data-v-81f8fd0c] {\n  /* On mouse-over, add a grey background color */\n  /* When the checkbox is checked, add a blue background */\n  /* Show the checkmark when checked */\n}\n.subHeader .icon-wrapper ul.action-panel li[data-v-81f8fd0c]:last-child {\n  border-bottom: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .checkbox-active[data-v-81f8fd0c] {\n  color: #00A4D6 !important;\n  font-weight: bold;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox[data-v-81f8fd0c] {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 0;\n  color: #626262;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox input[data-v-81f8fd0c] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  left: 0;\n  bottom: 6px;\n  width: 16px;\n  height: 16px;\n  z-index: 10;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox .checkmark[data-v-81f8fd0c] {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #FFFFFF;\n  border: solid 1px #b9b9b9;\n  z-index: 1;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox .checkmark[data-v-81f8fd0c]::after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox input:checked ~ .checkmark[data-v-81f8fd0c] {\n  background-color: #00A4D6;\n  color: #00A4D6;\n  border: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox input:checked ~ .checkmark[data-v-81f8fd0c]:after {\n  display: block;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox ~ .checkmark[data-v-81f8fd0c]:after {\n  color: #00A4D6;\n}\n.subHeader .group-button-sub-header[data-v-81f8fd0c] {\n  float: right;\n  top: 120px;\n  margin: 65px 30px 0 0;\n}\n.subHeader .placeholder-italic[data-v-81f8fd0c] {\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  width: 496px;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.subHeader .search-icon[data-v-81f8fd0c] {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 999;\n  color: #00A4D6;\n  width: 20px;\n  height: 25px;\n}\n.subHeader .search-icon[data-v-81f8fd0c]:hover {\n  cursor: pointer;\n  color: #00A4D6;\n}\n.subHeader .content-header[data-v-81f8fd0c] {\n  width: 250px;\n}\n.subHeader .float-left[data-v-81f8fd0c] {\n  float: left;\n}\n.subHeader .float-right[data-v-81f8fd0c] {\n  float: right;\n}\n.subHeader .label[data-v-81f8fd0c] {\n  height: 16px;\n  width: 77.8px;\n  color: #444444;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.subHeader .search-icon[data-v-81f8fd0c] {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.subHeader .upIcon[data-v-81f8fd0c] {\n  float: right;\n}\n.subHeader .scrollIcon[data-v-81f8fd0c] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.subHeader .display-none-something[data-v-81f8fd0c] {\n  display: none;\n}\n.subHeader .marginTop6px[data-v-81f8fd0c] {\n  margin-top: 6px;\n}\n", ""]);

// exports


/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmZpbHRlcjwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMjJhMS41MiwxLjUyLDAsMCwxLS43NC0uMkExLjUsMS41LDAsMCwxLDksMjAuNDhWMTEuNzZMMi40Miw3LjA2QTEsMSwwLDAsMSwyLDYuMjRWMy41QTEuNSwxLjUsMCwwLDEsMy41LDJoMTdBMS41LDEuNSwwLDAsMSwyMiwzLjVWNi4yNGExLDEsMCwwLDEtLjQyLjgyTDE1LDExLjc2djYuOTJBMS41MSwxLjUxLDAsMCwxLDE0LjI3LDIwbC0zLDEuOEExLjUyLDEuNTIsMCwwLDEsMTAuNSwyMlpNMy41LDNhLjUuNSwwLDAsMC0uNS41VjYuMjRsNi41OCw0LjdhMSwxLDAsMCwxLC40Mi44MnY4LjcyYS41LjUsMCwwLDAsLjI1LjQ0LjUuNSwwLDAsMCwuNTEsMGwzLTEuOGEuNS41LDAsMCwwLC4yNC0uNDNWMTEuNzZhMSwxLDAsMCwxLC40Mi0uODJMMjEsNi4yNFYzLjVhLjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderManageApprovedDashboard',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    handleBlurSearchText: function handleBlurSearchText() {
      // this.$emit('TEXT_SEARCH_CHANGE', this.textSearch);
    },
    getValue: function getValue(name) {},
    saveSearchInfo: function saveSearchInfo() {
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.sortEventString, this.listChecked);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.filterEventString, this.listFiltered);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.searchEventString, this.textSearch);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.dateRangeEvent, this.datesOut.value);
    },
    selectStatus: function selectStatus(item) {
      this.listChecked = [item.key];
      // get events by date
      this.$emit('CHANGE_FILTER_OPTION', this.listChecked);
      this.saveSearchInfo();
    },
    selectStatusFilter: function selectStatusFilter(item) {
      this.listFiltered = [item.key];
      // get events by date
      this.$emit('CHANGE_FILTER_STATUS_OPTION', this.listFiltered);
      this.saveSearchInfo();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getEventsByDates: 'ACTION_GET_EVENTS_BY_DATES'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    searchApprovedEvent: 'MUTATION_SEARCH_APPROVED_EVENT',
    saveSlideOutValues: 'MUTATION_SAVE_SLIDER_VALUE_REPORTS'
  })),
  watch: {
    textSearch: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      var keyword = this.textSearch.trim().toLowerCase();
      if (keyword.length >= 2 || keyword.length === 0) {
        this.$emit('TEXT_SEARCH_CHANGE', keyword);
        this.saveSearchInfo();
      }
    }, 700),
    'datesOut.value': __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      this.$emit('SLIDER_CHANGE_VALUE', this.datesOut.value);
      this.saveSearchInfo();
    }, 300),
    sliderValue: function sliderValue() {
      this.datesOut.value = this.sliderValue;
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    VueSlider: __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a,
    ScrollTop: __WEBPACK_IMPORTED_MODULE_5__utils_ScrollTop__["a" /* default */]
  },
  props: {
    fixElement: {
      type: Boolean,
      default: false
    },
    isBackground: {
      type: Boolean,
      default: false
    },
    textSearch: {
      type: String,
      default: ''
    },
    listChecked: {
      type: Array,
      default: ['dateTime']
    },
    listFiltered: {
      type: Array,
      default: ['APPROVED']
    },
    sliderValue: {
      type: Array,
      default: ['0', '60+']
    }
  },
  data: function data() {
    return {
      listEventStatus: [{
        text: 'Participation',
        count: 200,
        isCheck: false,
        key: 'projPart'
      }, {
        text: 'Date',
        count: 0,
        isCheck: false,
        key: 'dateTime'
      }, {
        text: 'Supplies status',
        count: 100,
        isCheck: false,
        key: 'suppliesStatus'
      }, {
        text: 'State',
        count: 100,
        isCheck: false,
        key: 'state'
      }, {
        text: 'City',
        count: 100,
        isCheck: false,
        key: 'city'
      }],
      listEventStatusFilter: [{
        text: 'Drafts',
        count: 200,
        isCheck: false,
        key: 'DRAFTS'
      }, {
        text: 'Submitted',
        count: 0,
        isCheck: false,
        key: 'SUBMITTED'
      }, {
        text: 'Review',
        count: 100,
        isCheck: false,
        key: 'REVIEW'
      }, {
        text: 'Approved',
        count: 100,
        isCheck: false,
        key: 'APPROVED'
      }, {
        text: 'Archived',
        count: 100,
        isCheck: false,
        key: 'ARCHIVED'
      }, {
        text: 'Deleted',
        count: 100,
        isCheck: false,
        key: 'DELETED'
      }],
      datesOut: {
        value: ['0', '60+'],
        width: '182px',
        tooltip: false,
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        dotSize: 8,
        interval: 7,
        formatter: '{value}',
        overlapFormatter: '{value1} ~ {value2}',
        data: ['0', '7', '14', '30', '60', '60+'],
        piecewiseStyle: {
          backgroundColor: 'transparent',
          visibility: 'visible',
          width: '15px',
          height: '15px'
        },
        piecewiseActiveStyle: {
          backgroundColor: '#00A4D6'
        },
        processStyle: {
          backgroundColor: '#00A4D6'
        }
      },
      isShowAction: false,
      isShowFilter: false,
      listChecked: [],
      textSearch: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getSlideOutValues: 'GETTER_GET_SLIDER_VALUE_REPORTS'
  }))
});

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subHeader", class: { backgroundColor: _vm.isBackground } },
    [
      _c(
        "div",
        { staticClass: "noMargin", class: { paddingTop27px: !_vm.fixElement } },
        [
          _c(
            "div",
            {
              staticClass: "sub-header-container",
              class: { "padding-left-20px": !_vm.isBackground }
            },
            [
              _c("div", { staticClass: "noPaddingRight" }, [
                !_vm.fixElement
                  ? _c("div", { staticClass: "dateOut" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("DATES OUT")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { class: { marginTop10px: _vm.fixElement } },
                  [
                    _c(
                      "vue-slider",
                      _vm._b(
                        {
                          ref: "slider",
                          nativeOn: {
                            click: function($event) {
                              _vm.getValue("slider")
                            }
                          },
                          model: {
                            value: _vm.datesOut.value,
                            callback: function($$v) {
                              _vm.$set(_vm.datesOut, "value", $$v)
                            },
                            expression: "datesOut.value"
                          }
                        },
                        "vue-slider",
                        _vm.datesOut,
                        false
                      )
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "common-margin-left" },
                [
                  _c("b-input-group", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.textSearch,
                          expression: "textSearch"
                        }
                      ],
                      staticClass: "search-input placeholder-italic",
                      class: { marginTop6px: _vm.fixElement },
                      attrs: {
                        type: "text",
                        placeholder: "Search by event info"
                      },
                      domProps: { value: _vm.textSearch },
                      on: {
                        blur: _vm.handleBlurSearchText,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.textSearch = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-icon" })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "common-margin-left" }, [
                _c(
                  "div",
                  {
                    staticClass: "icon-wrapper marginTop6px",
                    class: {
                      "active-wrapper": _vm.isShowAction,
                      marginTop11px: _vm.fixElement
                    },
                    on: {
                      click: function($event) {
                        _vm.isShowAction = true
                      },
                      mouseleave: function($event) {
                        _vm.isShowAction = false
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      staticClass: "icon-sort",
                      class: { active: _vm.isShowAction },
                      attrs: { name: "filter" }
                    }),
                    _vm._v(" "),
                    _vm.isShowAction
                      ? _c(
                          "ul",
                          { staticClass: "action-panel" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("Display")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.listEventStatus, function(item) {
                              return _c("li", { key: item.text }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-checkbox",
                                    class: { "checkbox-active": item.isCheck }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.text) + "\n                "
                                    ),
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.listChecked.indexOf(item.key) >= 0
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.selectStatus(item)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "checkmark" })
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "common-margin-left" }, [
                _c(
                  "div",
                  {
                    staticClass: "icon-wrapper marginTop6px",
                    class: {
                      "active-wrapper": _vm.isShowFilter,
                      marginTop11px: _vm.fixElement
                    },
                    on: {
                      click: function($event) {
                        _vm.isShowFilter = true
                      },
                      mouseleave: function($event) {
                        _vm.isShowFilter = false
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      staticClass: "icon-filter",
                      class: { active: _vm.isShowFilter },
                      attrs: { name: "filter" }
                    }),
                    _vm._v(" "),
                    _vm.isShowFilter
                      ? _c(
                          "ul",
                          { staticClass: "action-panel" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("Display")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.listEventStatusFilter, function(item) {
                              return _c("li", { key: item.text }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-checkbox",
                                    class: { "checkbox-active": item.isCheck }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.text) + "\n                "
                                    ),
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.listFiltered.indexOf(item.key) >=
                                          0
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.selectStatusFilter(item)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "checkmark" })
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "upIcon",
                    class: {
                      "display-none-something": !_vm.fixElement,
                      scrollIcon: _vm.fixElement
                    }
                  },
                  [_c("ScrollTop")],
                  1
                )
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81f8fd0c", esExports)
  }
}

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c00da7fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__ = __webpack_require__(1793);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1790)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c00da7fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c00da7fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/manage/Manage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Manage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c00da7fa", Component.options)
  } else {
    hotAPI.reload("data-v-c00da7fa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1791);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("60a09868", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c00da7fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Manage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c00da7fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Manage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.main-page-manage-events-view-manager[data-v-c00da7fa] {\n  padding: 24px;\n  height: calc(100vh - 280px);\n  overflow-y: auto;\n}\n.main-page-manage-events-view-manager .list-event-manage-by-date-container[data-v-c00da7fa] {\n  height: 100%;\n  max-width: 100%;\n}\n.events-found[data-v-c00da7fa] {\n  height: 16px;\n  width: 120px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  margin-bottom: 22px;\n}\n.cheetah-digital[data-v-c00da7fa] {\n  height: 16px;\n  color: #626262;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 16px;\n  max-width: 290px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.event-cards-wrapper[data-v-c00da7fa] {\n  margin: 0 -12px;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.event-cards-wrapper .event-card-container[data-v-c00da7fa] {\n  margin: 12px;\n}\n.isLoading[data-v-c00da7fa] {\n  display: block;\n  text-align: center;\n  color: #606060;\n}\n.noDisplay[data-v-c00da7fa] {\n  display: none;\n}\n.overlay[data-v-c00da7fa] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.text[data-v-c00da7fa] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n", ""]);

// exports


/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventCard__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_spinner__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_commons_Spinner__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* Register component with one of 2 methods */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manage-view',
  components: {
    EventCard: __WEBPACK_IMPORTED_MODULE_3__EventCard__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_6_vue_infinite_loading___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_7__components_commons_Spinner__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      var vm = this;
      var params = {
        changeFilter: this.changeFilter
      };
      this.getData(params).then(function (res) {
        _this.changeFilter = false;
        if (res && vm.pagingObj.currentPage * vm.pagingObj.itemsPerPage > vm.getTotal) {
          $state.complete();
          _this.textPlus = '';
        } else {
          _this.textPlus = '+';
          $state.loaded();
        }
        vm.pagingObj.currentPage++;
      });
    },
    getData: function getData(params) {
      var _this2 = this;

      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          // set limit Begin date range
          noBeginDates: vm.dateOut[0],
          noEndDates: vm.dateOut[1],
          selectedDate: null,
          clientId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId),
          keyword: _this2.textSearch,
          currentPage: vm.pagingObj.currentPage,
          itemsPerPage: vm.pagingObj.itemsPerPage,
          sortType: vm.sortBy[0],
          status: vm.filterBy[0]
        }, params);
        vm.getEventsByDates(body).then(function (response) {
          if (vm.pagingObj.currentPage * vm.pagingObj.itemsPerPage > vm.getTotal) {
            _this2.textPlus = '';
          } else {
            _this2.textPlus = '+';
          }
          resolve(response);
        });
      });
    },
    resetPagingOption: function resetPagingOption() {
      this.pagingObj.currentPage = 1;
      this.pagingObj.itemsPerPage = 10;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])({
    getEventsByDates: 'ACTION_GET_EVENTS_BY_DATES'
  }), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapMutations */])({
    setListEventApproved: 'MUTATION_SET_APPROVED_EVENTS'
  })),
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    dateOut: {
      type: Array,
      default: function _default() {
        return ['0', '60+'];
      }
    },
    filterBy: {
      type: Array,
      default: function _default() {
        return ['APPROVED'];
      }
    },
    sortBy: {
      type: Array,
      default: function _default() {
        return ['dateTime'];
      }
    },
    textSearch: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])({
    getEvents: 'GETTERS_EVENTS_BY_DATES',
    getTotal: 'GETTERS_TOTAL_EVENTS'
  })),
  data: function data() {
    return {
      pagingObj: {
        currentPage: 1,
        itemsPerPage: 10
      },
      textPlus: '',
      changeFilter: false
    };
  },
  created: function created() {
    // this.getData();
    this.setListEventApproved({ changeFilter: true, approvedEvents: [] });
  },
  mounted: function mounted() {
    if (this.$route.params && this.$route.params.eventId) {
      var params = {
        eventId: this.$route.params.eventId,
        isChangeOrder: this.isChangeOrder
      };
      this.$modal.show('eventDetailModal', params);
    }
  },

  watch: {
    textSearch: {
      handler: function handler(val, oldVal) {
        this.changeFilter = true;
        this.resetPagingOption();
        this.$refs.infiniteLoading.stateChanger.reset();
        var params = {
          changeFilter: true
        };
        this.getData(params);
      }
    },
    dateOut: {
      handler: function handler(val, oldVal) {
        if (val[0] === oldVal[0] && val[1] === oldVal[1]) {
          return;
        }
        this.changeFilter = true;
        this.resetPagingOption();
        this.$refs.infiniteLoading.stateChanger.reset();
        var params = {
          changeFilter: true
        };
        this.getData(params);
      },
      deep: true
    },
    sortBy: {
      handler: function handler(val, oldVal) {
        if (val[0] === oldVal[0]) {
          return;
        }
        this.changeFilter = true;
        this.resetPagingOption();
        this.$refs.infiniteLoading.stateChanger.reset();
        var params = {
          changeFilter: true
        };
        this.getData(params);
      },
      deep: true
    },
    filterBy: {
      handler: function handler(val, oldVal) {
        if (val[0] === oldVal[0]) {
          return;
        }
        this.changeFilter = true;
        this.resetPagingOption();
        this.$refs.infiniteLoading.stateChanger.reset();
        var params = {
          changeFilter: true
        };
        this.getData(params);
      },
      deep: true
    }
  }
});

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-page-manage-events-view-manager" }, [
    _c("div", { staticClass: "events-found marginLeft24px" }, [
      _vm._v(_vm._s(_vm.getTotal || 0) + _vm._s(_vm.textPlus) + " EVENTS FOUND")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list-event-manage-by-date-container" },
      [
        _vm._l(_vm.getEvents, function(item, index) {
          return _c("div", [
            _c("div", { staticClass: "cheetah-digital marginLeft24px" }, [
              _c("span", [_vm._v(_vm._s(item.clientName))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-cards-wrapper" },
              _vm._l(item.events, function(event, index) {
                return _c("EventCard", {
                  key: index,
                  attrs: { event: event, isNoTrans: index % 3 == 2 }
                })
              })
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clear-both" })
          ])
        }),
        _vm._v(" "),
        _c(
          "infinite-loading",
          {
            ref: "infiniteLoading",
            attrs: { distance: 100 },
            on: { infinite: _vm.infiniteHandler }
          },
          [
            _c("Spinner", { attrs: { slot: "spinner" }, slot: "spinner" }),
            _vm._v(" "),
            _c("div", {
              staticClass: "infinite-status-prompt",
              attrs: { slot: "no-more" },
              slot: "no-more"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "infinite-status-prompt",
              attrs: { slot: "no-results" },
              slot: "no-results"
            })
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c00da7fa", esExports)
  }
}

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderManageApprovedDashBoard", {
        class: { "fix-element-to-top": _vm.fixElement },
        attrs: {
          fixElement: _vm.fixElement,
          pagingObj: _vm.pagingObj,
          eventStatus: _vm.tableType,
          sliderValue: _vm.sliderValue,
          textSearch: _vm.textSearch,
          listChecked: _vm.dataSort,
          "list-filtered": _vm.dataFilter
        },
        on: {
          TEXT_SEARCH_CHANGE: _vm.handleTextSearchChange,
          CHANGE_FILTER_OPTION: _vm.handleChangeDataSort,
          CHANGE_FILTER_STATUS_OPTION: _vm.handleChangeDataFilter,
          SLIDER_CHANGE_VALUE: _vm.handleSliderChangeValue
        }
      }),
      _vm._v(" "),
      _c("div", {
        style: { height: _vm.fixElement ? _vm.getHeightOfComp + "px" : "0px" }
      }),
      _vm._v(" "),
      _c("Manage", {
        ref: "listEventByClients",
        attrs: {
          loading: _vm.getLoading,
          dateOut: _vm.sliderValue,
          filterBy: _vm.dataFilter,
          sortBy: _vm.dataSort,
          textSearch: _vm.textSearch
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0b510c4", esExports)
  }
}

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageEventDetail_vue__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e919a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageEventDetail_vue__ = __webpack_require__(1799);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1796)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13e919a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageEventDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e919a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageEventDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/event/ManageEventDetail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManageEventDetail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13e919a1", Component.options)
  } else {
    hotAPI.reload("data-v-13e919a1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1797);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a35d049a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-13e919a1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManageEventDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-13e919a1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManageEventDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.manage-event-detail-container[data-v-13e919a1] {\n  background: #ffffff;\n}\n.manage-event-detail-container .modal-padding[data-v-13e919a1] {\n  padding: 24px 40px 20px 40px;\n}\n.manage-event-detail-container .icon-back[data-v-13e919a1] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(92) + ");\n}\n.manage-event-detail-container .icon-align[data-v-13e919a1] {\n  margin-bottom: 10px;\n  padding-left: 8px;\n  margin-top: 24px;\n}\n.manage-event-detail-container .icon-align[data-v-13e919a1]:hover {\n  cursor: pointer;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top[data-v-13e919a1] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: -10px;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top .related-events-top-left[data-v-13e919a1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top .related-events-top-left .related-events-title[data-v-13e919a1] {\n  color: #626262;\n  font-size: 16px;\n  font-weight: bold;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top .related-events-top-left .related-event-count[data-v-13e919a1] {\n  color: #9D9D9D;\n  font-size: 12px;\n  margin-left: 8px;\n  font-weight: normal;\n  text-transform: uppercase;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top .button-containers[data-v-13e919a1] {\n  margin-left: 12px;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top .button-containers .btn-left[data-v-13e919a1] {\n  padding: 6px 24px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.manage-event-detail-container .series-related-events-section .related-events-top .button-containers .btn-right[data-v-13e919a1] {\n  height: 24px;\n  padding: 0 12px;\n  font-size: 12px;\n}\n.manage-event-detail-container .series-related-events-section .related-event-container .related-event-item[data-v-13e919a1] {\n  height: 32px;\n  padding: 8px;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n.manage-event-detail-container .series-related-events-section .related-event-container .related-event-item .event-name[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .series-related-events-section .related-event-container .related-event-item[data-v-13e919a1]:hover {\n  cursor: pointer;\n  background-color: #b9b9b9;\n}\n.manage-event-detail-container .series-related-events-section .btn-add-related-container[data-v-13e919a1] {\n  margin-top: 8px;\n}\n.manage-event-detail-container .series-related-events-section .btn-add-related-container .btn-add-related[data-v-13e919a1] {\n  font-size: 12px;\n  padding: 6px 12px;\n}\n.manage-event-detail-container .event-detail-header .wrapper-participant[data-v-13e919a1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-items: flex-end;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  text-align: right;\n}\n.manage-event-detail-container .event-detail-header .wrapper-multi-select .multi-select-text[data-v-13e919a1] {\n  padding: 0;\n  width: 275px;\n}\n.manage-event-detail-container .event-detail-header .wrapper-multi-select .multiselect[data-v-13e919a1] {\n  min-height: 38px;\n}\n.manage-event-detail-container .event-detail-header .wrapper-multi-select .multiselect__tags[data-v-13e919a1] {\n  border: none;\n  min-height: 38px;\n}\n.manage-event-detail-container .event-detail-header .wrapper-multi-select .multiselect__content-wrapper .multiselect__element[data-v-13e919a1]:last-child {\n  border-bottom: none;\n}\n.manage-event-detail-container .event-detail-header .event-details[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.manage-event-detail-container .event-detail-header .client-name[data-v-13e919a1] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n  line-height: 28px;\n}\n.manage-event-detail-container .event-detail-header .event-name[data-v-13e919a1] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  float: right;\n  clear: both;\n}\n.manage-event-detail-container .event-detail-header .map[data-v-13e919a1] {\n  height: 200px;\n  width: 100%;\n  border: 1px solid #424242;\n}\n.manage-event-detail-container .modal-close-img[data-v-13e919a1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.manage-event-detail-container .modal-close-img[data-v-13e919a1]:hover {\n  cursor: pointer;\n}\n.manage-event-detail-container .modal-close-img .icon-close[data-v-13e919a1] {\n  margin: 1.5px 1.5px;\n  width: 16px;\n  height: 16px;\n  color: #1D1D1D;\n  background-color: #1D1D1D;\n  -webkit-mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  mask: url(" + __webpack_require__(15) + ") no-repeat center;\n  background: url(" + __webpack_require__(15) + ");\n}\n.manage-event-detail-container .event-detail-body[data-v-13e919a1] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.manage-event-detail-container .event-detail-body .email-text[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .col-md-3[data-v-13e919a1]:nth-child(4n + 1) {\n  padding-left: 0;\n}\n.manage-event-detail-container .event-detail-body .col-md-3[data-v-13e919a1]:nth-child(4n) {\n  padding-right: 0;\n}\n.manage-event-detail-container .event-detail-body .col-md-4[data-v-13e919a1]:nth-child(3n + 1) {\n  padding-left: 0;\n}\n.manage-event-detail-container .event-detail-body .col-md-4[data-v-13e919a1]:nth-child(3n) {\n  padding-right: 0;\n}\n.manage-event-detail-container .event-detail-body .view-history-text[data-v-13e919a1] {\n  color: #1674cd;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 24px;\n  cursor: pointer;\n  margin-left: 16px;\n}\n.manage-event-detail-container .event-detail-body .staff-header[data-v-13e919a1] {\n  color: #626262;\n  font-size: 16px;\n  font-weight: bold;\n}\n.manage-event-detail-container .event-detail-body .staffing-edit-btn .ap-btn[data-v-13e919a1] {\n  padding: 4px 24px;\n  text-transform: none;\n  border: 1px solid #B9B9B9;\n  font-size: 16px;\n}\n.manage-event-detail-container .event-detail-body .staffing-edit-btn .ap-btn.secondary[data-v-13e919a1] {\n  color: #1674cd;\n}\n.manage-event-detail-container .event-detail-body .staffing-edit-btn .ap-btn.secondary[data-v-13e919a1]:hover {\n  background-color: #1674cd;\n  color: #ffffff;\n}\n.manage-event-detail-container .event-detail-body textarea[data-v-13e919a1] {\n  width: 100%;\n}\n.manage-event-detail-container .event-detail-body .text[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .text.online-text[data-v-13e919a1] {\n  color: #1674cd;\n}\n.manage-event-detail-container .event-detail-body .number[data-v-13e919a1] {\n  width: 177px;\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .group-btn-manage-detail[data-v-13e919a1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.manage-event-detail-container .event-detail-body .group-btn-manage-detail .icon-email-wrapper[data-v-13e919a1] {\n  width: 32px;\n  height: 32px;\n  background-color: #00A4D6;\n  padding: 4px;\n  border-radius: 4px;\n}\n.manage-event-detail-container .event-detail-body .group-btn-manage-detail .icon-email-wrapper[data-v-13e919a1]:hover {\n  cursor: pointer;\n}\n.manage-event-detail-container .event-detail-body .group-btn-manage-detail .icon-email-wrapper .icon-email[data-v-13e919a1] {\n  width: 24px;\n  height: 24px;\n  background: url(" + __webpack_require__(822) + ");\n}\n.manage-event-detail-container .event-detail-body .group-btn-manage-detail .ap-btn[data-v-13e919a1] {\n  padding: 6px 17px;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n}\n.manage-event-detail-container .event-detail-body .group-btn-manage-detail .btn-left[data-v-13e919a1] {\n  margin-right: 8px;\n}\n.manage-event-detail-container .event-detail-body .manage-detail[data-v-13e919a1] {\n  height: 32px;\n  width: 184px;\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n  float: right;\n}\n.manage-event-detail-container .event-detail-body .manage-detail .manage-text[data-v-13e919a1] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.manage-event-detail-container .event-detail-body .btn-request-change[data-v-13e919a1] {\n  min-width: 215px;\n}\n.manage-event-detail-container .event-detail-body .request-change[data-v-13e919a1] {\n  height: 32px;\n  width: 184px;\n  background-color: #AAA7A4;\n  border-radius: 4px;\n}\n.manage-event-detail-container .event-detail-body .request-change .request-text[data-v-13e919a1] {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  text-transform: uppercase;\n}\n.manage-event-detail-container .event-detail-body .wrapper-text-number[data-v-13e919a1] {\n  margin-right: 24px;\n}\n.manage-event-detail-container .event-detail-body .liner[data-v-13e919a1] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n.manage-event-detail-container .event-detail-body .liner-for-staff[data-v-13e919a1] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  margin-top: 22px;\n  margin-bottom: 18px;\n}\n.manage-event-detail-container .event-detail-body .event-information[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.manage-event-detail-container .event-detail-body .event-title[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  text-transform: none;\n  margin-top: 14px;\n}\n.manage-event-detail-container .event-detail-body .event-info[data-v-13e919a1] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n}\n.manage-event-detail-container .event-detail-body .shipping-notes[data-v-13e919a1] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .input-shipping-notes[data-v-13e919a1] {\n  height: 78px;\n  width: 402px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n}\n.manage-event-detail-container .event-detail-body .on-site-instruction[data-v-13e919a1] {\n  height: 63px;\n  width: 184px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .tracking-number[data-v-13e919a1] {\n  height: 31px;\n  width: 402px;\n  border-radius: 4px;\n  border: 1px solid #b9b9b9;\n  text-transform: uppercase;\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n}\n.manage-event-detail-container .event-detail-body .supplies-tracking-status[data-v-13e919a1] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper[data-v-13e919a1] {\n  float: left;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 4px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .title[data-v-13e919a1] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on[data-v-13e919a1] {\n  overflow: hidden;\n  margin-right: 8px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on .title[data-v-13e919a1] {\n  margin-top: 20px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on .title .icon-add[data-v-13e919a1] {\n  color: #fff;\n  background-color: #00A4D6;\n  border: 3px;\n  border-radius: 20px;\n  width: 16px;\n  height: 16px;\n  margin-left: 15px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on .title .text[data-v-13e919a1] {\n  margin-left: 10px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on .add-on-item[data-v-13e919a1] {\n  width: 210px;\n  position: relative;\n  margin-left: 0;\n  margin-top: 15px;\n  display: inline-block;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on .add-on-item .text[data-v-13e919a1] {\n  position: absolute;\n  left: 45px;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on input[type=checkbox][data-v-13e919a1] {\n  width: 0;\n  visibility: hidden;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on label[data-v-13e919a1] {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 16px;\n  background: #fff;\n  border-radius: 24px;\n  position: relative;\n  top: 1px;\n  left: 0px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on label[data-v-13e919a1]:after {\n  content: '';\n  position: absolute;\n  top: -0.7px;\n  left: -0.7px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 24px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on input:checked + label[data-v-13e919a1] {\n  background: #1674cd;\n  border: 2px solid #1674cd;\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on input:checked + label[data-v-13e919a1]:after {\n  left: calc(104%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.manage-event-detail-container .event-detail-body .add-on-wrapper .event-add-on label[data-v-13e919a1]:active:after {\n  width: 15px;\n}\n.manage-event-detail-container .event-detail-body .wrapper-text[data-v-13e919a1] {\n  padding: 8px;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n}\n.oval[data-v-13e919a1] {\n  height: 8px;\n  width: 8px;\n  display: inline-block;\n  border-radius: 3px;\n  margin-left: 0;\n  margin-right: 8px;\n}\n.oval.oval-red[data-v-13e919a1] {\n  background-color: #E93000;\n}\n.oval.oval-green[data-v-13e919a1] {\n  background-color: #68B814;\n}\n.oval.oval-orange[data-v-13e919a1] {\n  background-color: #FFA71B;\n}\n.oval.ovalSilver[data-v-13e919a1] {\n  background-color: #D8D8D8;\n}\n.oval.margin-left-8px[data-v-13e919a1] {\n  margin-left: 8px;\n}\n.isLoading[data-v-13e919a1] {\n  display: block;\n  text-align: center;\n  color: #606060;\n  height: 100%;\n}\n.noDisplay[data-v-13e919a1] {\n  display: none;\n}\n.display-inline[data-v-13e919a1] {\n  display: inline;\n}\n.padding-top-5px[data-v-13e919a1] {\n  padding-top: 5px;\n}\n.overlay[data-v-13e919a1] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.spinner-align[data-v-13e919a1] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.align-right-item[data-v-13e919a1] {\n  text-align: right;\n}\n", ""]);

// exports


/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_constants_emailTemplateType__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_dropdowns__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_select__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(19);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-detail-view',
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a,
    VueDropdown: __WEBPACK_IMPORTED_MODULE_7_vue_dropdowns__["a" /* default */],
    VueSelect: __WEBPACK_IMPORTED_MODULE_8_vue_select___default.a
  },
  props: {},
  data: function data() {
    return {
      editing: true,
      event: {
        relatedEvents: []
      },
      shippingStatus: '',
      trackingNumber: '',
      program: '',
      emailTemplateConsts: __WEBPACK_IMPORTED_MODULE_5__store_constants_emailTemplateType__["a" /* default */],
      addOnsServices: '',
      listTime: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].listTime,
      startTime: {
        hour: '',
        minute: '',
        period: 'AM'
      },
      endTime: {
        hour: '',
        minute: '',
        period: 'AM'
      },
      aduroArrivalTime: {
        hour: '',
        minute: '',
        period: 'AM'
      },
      addOns: [{
        key: 'venipuncture',
        text: 'Venipuncture',
        value: false
      }, {
        key: 'cotinine',
        text: 'Cotinine',
        value: false
      }, {
        key: 'wbaStation',
        text: 'WBA Station',
        value: false
      }, {
        key: 'fluShots',
        text: 'Flu Shots',
        value: false
      }, {
        key: 'paperScheduler',
        text: 'Paper Scheduler',
        value: false
      }, {
        key: 'smallSiteModel',
        text: 'Small Site Model',
        value: false
      }, {
        key: 'smallSiteConcierge',
        text: 'Small Site Concierge',
        value: false
      }, {
        key: 'tobaccoSelfAttestation',
        text: 'Tobacco Self Attestation',
        value: false
      }]
    };
  },
  created: function created() {
    // this.$store.dispatch('ACTION_GET_ALL_USERS');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    back: function back() {
      var isFromStaff = localStorage.getItem('isFromStaff');
      var isFromClientDashboardView = localStorage.getItem('isFromClientDashboardView');
      if (isFromStaff === true || isFromStaff === 'true') {
        localStorage.setItem('isFromStaff', false);
        this.$router.push({ name: 'StaffingSection', params: { detail: this.getStaffDetail } });
      } else if (isFromClientDashboardView === true || isFromClientDashboardView === 'true') {
        localStorage.setItem('isFromClientDashboardView', false);
        this.$router.push({ name: 'ManagerDashboardView' });
        this.$bus.$emit('resetGetData', this.eventId);
      } else {
        if (this.historyRouter) {
          this.$router.push({ name: this.historyRouter, params: { eventId: this.eventId } });
          return;
        }

        this.$router.push({ name: 'ManageApprovedDashboard', params: { eventId: this.eventId, textSearch: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.searchEventString), filter: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.filterEventString), sort: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.sortEventString), dateSliderValue: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].LOCAL_STORE.dateRangeEvent) } });
      }
    },
    onSave: function onSave() {
      this.editing = false;
      this.updateEventAction(this.event);
    },
    onEdit: function onEdit() {
      this.editing = true;
    },
    updateIsLiveEvent: function updateIsLiveEvent(type) {
      var _this = this;

      var isCheck = false;
      switch (type) {
        case 'LIVE':
          isCheck = this.event.isLive;
          break;
        case 'ONLINE_SCHEDULER':
          isCheck = this.event.isOnlineScheduler;
          break;
        default:
          isCheck = false;
      }
      this.actionUpdateIsLiveEvent({
        eventId: this.event.id,
        isCheck: isCheck || false,
        onlineType: type
      }).then(function (response) {
        if (response.message) {
          _this.$toastr('error', response.message, '');
        } else {
          _this.$toastr('success', 'Update event successful!', '');
        }
      });
    },
    getTrackingStatus: function getTrackingStatus() {
      var _this2 = this;

      if (!this.event.id || !this.trackingNumber) {
        return;
      }
      this.actionGetTrackingStatus({ eventId: this.event.id, trackingNumber: this.trackingNumber }).then(function (response) {
        _this2.shippingStatus = response && response.shippingStatus && response.shippingStatus.trackingStatusDescription || '';
      });
    },
    viewAllMailHistories: function viewAllMailHistories() {
      this.$router.push({ name: 'EmailHistoriesManagement', params: { eventId: this.event.id } });
    },
    manageRelatedEvent: function manageRelatedEvent() {
      var data = {
        eventId: this.event.id,
        relatedEvents: this.event.relatedEvents,
        routerName: this.$route.name
      };
      this.$router.push({ name: 'ManageRelatedEvent', params: data, query: data.eventId });
    },
    manageEmail: function manageEmail() {
      var eventId = this.event.id;
      this.setIsLoading(true); // set loading = true
      this.$router.push({
        name: 'ManageEmail',
        params: {
          eventId: eventId,
          isManageDetails: true
        }
      });
    },
    manageEventStaffingDetail: function manageEventStaffingDetail() {
      var data = {
        eventId: this.event.id,
        routerName: this.$route.name
      };
      this.$router.push({ name: 'EventStaffingDetail', params: data });
    },
    generatePackingSlipBtn: function generatePackingSlipBtn() {
      this.generatePackingSlip(this.event.id);
    },
    relatedEventItemClick: function relatedEventItemClick(eventId) {
      var url = window.location.origin + '/event/' + eventId;
      window.open(url, '_blank');
    },
    minutes: function minutes() {
      var range = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.range(0, 60);
      return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(range, function (value) {
        return (value > 9 ? '' : '0') + value;
      });
    },
    formatTime: function formatTime(hour, minute, period) {
      return hour + ':' + minute + ' ' + period;
    },
    parseTime: function parseTime(time) {
      if (!time) {
        return { hour: '', minute: '', period: 'AM' };
      }

      var period = time.split(' ')[1];
      var fullTime = time.split(' ')[0].split(':');

      return {
        hour: fullTime[0],
        minute: fullTime[1],
        period: period
      };
    },
    checkboxToggle: function checkboxToggle(key, value) {
      var obj = {
        clientId: this.event.clientId,
        eventId: this.event.id,
        key: key,
        isAdd: value
      };

      var addOn = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(this.addOns, { 'key': key });
      this.updateAddOn(obj).then(function () {
        __WEBPACK_IMPORTED_MODULE_10_vue__["default"].prototype.$toastr('success', 'Update event successful');
      }).catch(function () {
        addOn.value = !value;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    getEventById: 'ACTION_GET_EVENT_BY_ID',
    actionGetTrackingStatus: 'ACTION_GET_TRACKING_STATUS',
    actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT',
    generatePackingSlip: 'ACTION_GENERATE_PACKING_SLIP',
    updateAddOn: 'ACTION_UPDATE_EVENT_ADD_ON',
    updateEventAction: 'ACTION_UPDATE_EVENT'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
    setIsLoading: 'MUTATION_SET_IS_LOADING'
  })),
  computed: {},
  mounted: function mounted() {
    var _this3 = this;

    this.historyRouter = this.$route.params.routerName;
    var eventId = this.$route.params.eventId;
    this.eventId = eventId;
    // get event
    // reset shipping status
    this.trackingNumber = null;
    this.shippingStatus = '';
    this.getEventById(eventId).then(function (response) {
      var event = response.event;
      _this3.startTime = _this3.parseTime(event.startTime);
      _this3.endTime = _this3.parseTime(event.endTime);
      _this3.aduroArrivalTime = _this3.parseTime(event.aduroArrivalTime);

      if (response.message === null) {
        _this3.event = event;

        // get add ons
        _this3.addOns.forEach(function (addOn) {
          if (_this3.event.addOns.includes(addOn.key)) {
            addOn.value = true;
          }
        });

        // get shipping status
        if (_this3.event && _this3.event.trackingNumber) {
          _this3.trackingNumber = _this3.event.trackingNumber;
          _this3.actionGetTrackingStatus({ eventId: eventId, trackingNumber: _this3.event.trackingNumber }).then(function (response) {
            _this3.shippingStatus = response && response.shippingStatus && response.shippingStatus.trackingStatusDescription || '';
          });
        }
      }
    });
  }
});

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manage-event-detail-container" }, [
    _c(
      "div",
      {
        staticClass: "overlay",
        class: { isLoading: _vm.getIsLoading, noDisplay: !_vm.getIsLoading }
      },
      [
        _c(
          "div",
          { staticClass: "spinner-align" },
          [
            _c("Icon", {
              staticClass: "icon-size",
              attrs: { name: "spinner", scale: "5", pulse: "" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    !_vm.getIsLoading
      ? _c(
          "div",
          { staticClass: "event-detail-wrapper margin-side modal-padding" },
          [
            _c("div", { staticClass: "event-detail-header row" }, [
              _c("div", { staticClass: "col-md-6 noPaddingLeft" }, [
                _c("span", { staticClass: "event-details" }, [
                  _vm._v(_vm._s(_vm.event.eventName))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 noPaddingRight align-right-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-close-img",
                      on: {
                        click: function($event) {
                          _vm.back()
                        }
                      }
                    },
                    [_c("div", { staticClass: "icon-close" })]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-24px" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-6 event-information noPaddingLeft" },
                  [_vm._v("\n          Event information\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-6 event-information noPaddingRight align-right-item"
                  },
                  [
                    _c("div", { staticClass: "staffing-edit-btn" }, [
                      _vm.editing
                        ? _c(
                            "button",
                            {
                              staticClass: "ap-btn secondary",
                              on: { click: _vm.onSave }
                            },
                            [_vm._v("Save")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "ap-btn secondary",
                              on: { click: _vm.onEdit }
                            },
                            [_vm._v("Edit")]
                          )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Event Name")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.eventName,
                              expression: "event.eventName"
                            }
                          ],
                          domProps: { value: _vm.event.eventName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "eventName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.eventName))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [_vm._v("Date")]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "event-info" },
                    [
                      _vm.editing
                        ? _c("date-picker", {
                            attrs: {
                              value: _vm.event.prefDate,
                              format: "MMMM d, yyyy"
                            }
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatMMMM")(_vm.event.prefDate)
                              )
                            )
                          ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Client")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm._v(_vm._s(_vm.event.clientName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Custom Event Notes")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.customEventNote,
                              expression: "event.customEventNote"
                            }
                          ],
                          domProps: { value: _vm.event.customEventNote },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "customEventNote",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.customEventNote))])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Address")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.fullAddress,
                              expression: "event.fullAddress"
                            }
                          ],
                          domProps: { value: _vm.event.fullAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "fullAddress",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.fullAddress))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Time and Duration")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info show-dropdown" }, [
                    _c("table", [
                      _c("tr", [
                        _c("td", [_vm._v("Start: ")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.editing
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.startTime,
                                      expression: "event.startTime"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.event,
                                        "startTime",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.listTime, function(time) {
                                  return _c(
                                    "option",
                                    { domProps: { value: time.name } },
                                    [_vm._v(_vm._s(time.name))]
                                  )
                                })
                              )
                            : _c("span", [_vm._v(_vm._s(_vm.event.startTime))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("End: ")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.editing
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.event.endTime,
                                      expression: "event.endTime"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.event,
                                        "endTime",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.listTime, function(time) {
                                  return _c(
                                    "option",
                                    { domProps: { value: time.name } },
                                    [_vm._v(_vm._s(time.name))]
                                  )
                                })
                              )
                            : _c("span", [_vm._v(_vm._s(_vm.event.endTime))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Duration: ")]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _vm.editing
                              ? [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.event.duration,
                                          expression: "event.duration"
                                        }
                                      ],
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.event,
                                            "duration",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(24, function(n) {
                                      return _c(
                                        "option",
                                        { domProps: { value: n } },
                                        [_vm._v(_vm._s(n))]
                                      )
                                    })
                                  )
                                ]
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.event.duration))
                                ]),
                            _vm._v("\n                  HR\n                ")
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v("Time zone: ")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.event.timeZone) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Program")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm._v(_vm._s(_vm.event.eventName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("On Site Instructions")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.onsiteInstruction,
                              expression: "event.onsiteInstruction"
                            }
                          ],
                          domProps: { value: _vm.event.onsiteInstruction },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "onsiteInstruction",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [
                          _vm._v(_vm._s(_vm.event.onsiteInstruction))
                        ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Building/Suite")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.building,
                              expression: "event.building"
                            }
                          ],
                          domProps: { value: _vm.event.building },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "building",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.building))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("ADURO Arrival Time")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.event.aduroArrivalTime,
                                expression: "event.aduroArrivalTime"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.event,
                                  "aduroArrivalTime",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          _vm._l(_vm.listTime, function(time) {
                            return _c(
                              "option",
                              { domProps: { value: time.name } },
                              [_vm._v(_vm._s(time.name))]
                            )
                          })
                        )
                      : _c("span", [_vm._v(_vm._s(_vm.event.aduroArrivalTime))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("On Site Contact")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm._v(_vm._s(_vm.event.contactName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Parking Instructions")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.parkingInformation,
                              expression: "event.parkingInformation"
                            }
                          ],
                          domProps: { value: _vm.event.parkingInformation },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "parkingInformation",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [
                          _vm._v(_vm._s(_vm.event.parkingInformation))
                        ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Location")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.eventLocation,
                              expression: "event.eventLocation"
                            }
                          ],
                          domProps: { value: _vm.event.eventLocation },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "eventLocation",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.eventLocation))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Participation")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _c("div", { staticClass: "oval oval-red" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.event.numParticipant) +
                          "/" +
                          _vm._s(_vm.event.maxParticipant) +
                          " participants"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Add-ons")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "event-info" },
                    _vm._l(_vm.addOns, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "add-on-wrapper" },
                        [
                          _c("div", { staticClass: "event-add-on mb-1" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.value,
                                  expression: "item.value"
                                }
                              ],
                              attrs: { type: "checkbox", id: item.key },
                              domProps: {
                                checked: Array.isArray(item.value)
                                  ? _vm._i(item.value, null) > -1
                                  : item.value
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = item.value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "value", $$c)
                                    }
                                  },
                                  function($event) {
                                    _vm.checkboxToggle(item.key, item.value)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: item.key } }, [
                              _vm._v("Toggle")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(item.text))
                          ])
                        ]
                      )
                    })
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("div", { staticClass: "add-on-wrapper" }, [
                    _c("div", { staticClass: "event-add-on" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.event.isLive,
                            expression: "event.isLive"
                          }
                        ],
                        attrs: { type: "checkbox", id: "is-live" },
                        domProps: {
                          checked: Array.isArray(_vm.event.isLive)
                            ? _vm._i(_vm.event.isLive, null) > -1
                            : _vm.event.isLive
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.event.isLive,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.event,
                                      "isLive",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.event,
                                      "isLive",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.event, "isLive", $$c)
                              }
                            },
                            function($event) {
                              _vm.updateIsLiveEvent("LIVE")
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "is-live" } }, [
                        _vm._v("Toggle")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text",
                        class: { "online-text": _vm.event.isLive }
                      },
                      [_vm._v("Live")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm.event.contactName
              ? _c("div", { staticClass: "event-detail-body row" }, [
                  _c("div", { staticClass: "col-md-4 margin-top-16px" }, [
                    _c("div", { staticClass: "wrapper-text" }, [
                      _c("div", { staticClass: "event-info" }, [
                        _vm._v(_vm._s(_vm.event.contactName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-info" }, [
                        _vm._v(_vm._s(_vm.event.email))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-info" }, [
                        _vm._v(_vm._s(_vm.event.phone))
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "event-detail-body row" }, [
              _c(
                "div",
                { staticClass: "col-md-6 event-information noPaddingLeft" },
                [
                  _c("span", [_vm._v("Email")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "view-history-text",
                      on: { click: _vm.viewAllMailHistories }
                    },
                    [_vm._v("View History")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                },
                [
                  _c("div", { staticClass: "staffing-edit-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn secondary",
                        on: { click: _vm.manageEmail }
                      },
                      [_vm._v("Email Client")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c(
                  "div",
                  { staticClass: "col-md-12 email-text noPaddingLeft" },
                  [
                    _vm._v(
                      "\n          Last Email Sent: " +
                        _vm._s(
                          _vm._f("templateName")(_vm.event.emailReminderStatus)
                        ) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "event-detail-body row" }, [
              _c(
                "div",
                { staticClass: "col-md-9 event-information noPaddingLeft" },
                [_vm._v("\n          Staff & Slot Management\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 noPaddingRight noPaddingLeft align-right-item"
                },
                [
                  _c("div", { staticClass: "staffing-edit-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn secondary",
                        on: { click: _vm.manageEventStaffingDetail }
                      },
                      [_vm._v("Manage")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-12 noPaddingLeft" }, [
                  _c(
                    "div",
                    { staticClass: "wrapper-text-number display-inline" },
                    [
                      _c("div", { staticClass: "oval oval-red" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.event.numStaffLead) +
                            "/" +
                            _vm._s(_vm.event.maxStaffLead) +
                            " Leads"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wrapper-text-number display-inline" },
                    [
                      _c("div", {
                        staticClass: "oval oval-red margin-left-8px"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.event.numStaffConcierge) +
                            "/" +
                            _vm._s(_vm.event.maxStaffConcierge) +
                            " Concierge"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wrapper-text-number display-inline" },
                    [
                      _c("div", {
                        staticClass: "oval oval-red margin-left-8px"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.event.numStaffScreener) +
                            "/" +
                            _vm._s(_vm.event.maxStaffScreener) +
                            " Screeners"
                        )
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "event-detail-body row" }, [
              _c(
                "div",
                { staticClass: "col-md-6 event-information noPaddingLeft" },
                [_vm._v("\n          Shipping\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 event-information noPaddingRight noPaddingLeft align-right-item"
                },
                [
                  _c("div", { staticClass: "staffing-edit-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn secondary",
                        on: {
                          click: function($event) {
                            _vm.generatePackingSlipBtn()
                          }
                        }
                      },
                      [_vm._v("Generate Packing Slip")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-detail-body row margin-top-16px" },
              [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Address")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.shippingAddress,
                              expression: "event.shippingAddress"
                            }
                          ],
                          domProps: { value: _vm.event.shippingAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "shippingAddress",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.shippingAddress))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Supplies Tracking")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "supplies-tracking-status margin-bottom-10px"
                    },
                    [
                      _c("div", {
                        staticClass: "oval",
                        class:
                          _vm.shippingStatus !== "" ? "oval-green" : "oval-red"
                      }),
                      _vm._v(" "),
                      _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            _vm.trackingNumber !== ""
                              ? _vm.shippingStatus !== ""
                                ? _vm.shippingStatus
                                : "Shipping info not entered"
                              : "Shipping info not entered"
                          )
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Tracking Number")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.trackingNumber,
                              expression: "event.trackingNumber"
                            }
                          ],
                          domProps: { value: _vm.event.trackingNumber },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "trackingNumber",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.trackingNumber))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("span", { staticClass: "event-title" }, [
                    _vm._v("Shipping Note")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-info" }, [
                    _vm.editing
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.event.shippingNote,
                              expression: "event.shippingNote"
                            }
                          ],
                          domProps: { value: _vm.event.shippingNote },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.event,
                                "shippingNote",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("span", [_vm._v(_vm._s(_vm.event.shippingNote))])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "series-related-events-section" }, [
              _c(
                "div",
                { staticClass: "related-events-top event-detail-body row" },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-6 event-information noPaddingLeft" },
                    [
                      _vm._v("\n            Related Events\n            "),
                      _c("span", [
                        _vm._v(
                          "(" + _vm._s(_vm.event.relatedEvents.length) + ")"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-6 noPaddingRight noPaddingLeft align-right-item"
                    },
                    [
                      _c("div", { staticClass: "staffing-edit-btn" }, [
                        _vm.event.relatedEvents.length == 0
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-add-related ap-btn secondary",
                                on: { click: _vm.manageRelatedEvent }
                              },
                              [_vm._v("Create Related Events")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn-add-related ap-btn secondary",
                                on: { click: _vm.manageRelatedEvent }
                              },
                              [_vm._v("Manage Related Events")]
                            )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "related-event-container event-detail-body row"
                },
                _vm._l(_vm.event.relatedEvents, function(reEvent) {
                  return _c(
                    "div",
                    { staticClass: "col-md-3 margin-top-16px" },
                    [
                      _c("div", { staticClass: "related-event-item" }, [
                        _c(
                          "div",
                          {
                            staticClass: "event-name",
                            on: {
                              click: function($event) {
                                _vm.relatedEventItemClick(reEvent.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(reEvent.eventName))]
                        )
                      ])
                    ]
                  )
                })
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-6 event-information noPaddingLeft" }, [
        _vm._v("\n          On Site Contacts\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-detail-body row" }, [
      _c("div", { staticClass: "col-md-12 liner" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13e919a1", esExports)
  }
}

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerConfiguration_vue__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7700ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerConfiguration_vue__ = __webpack_require__(1804);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1801)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d7700ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchedulerConfiguration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7700ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SchedulerConfiguration_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/schedulerConfig/SchedulerConfiguration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SchedulerConfiguration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d7700ad", Component.options)
  } else {
    hotAPI.reload("data-v-3d7700ad", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1802);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("e3d51db4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d7700ad\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerConfiguration.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d7700ad\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SchedulerConfiguration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.general-wrapper[data-v-3d7700ad] {\n  background-color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n}\n.general-wrapper .scheduler-config-wrapper[data-v-3d7700ad] {\n  background-color: #ffffff;\n}\n.general-wrapper .scheduler-config-wrapper .icon-back-wrapper[data-v-3d7700ad] {\n  padding-top: 24px;\n}\n.general-wrapper .scheduler-config-wrapper .icon-back-wrapper .icon-back[data-v-3d7700ad] {\n  width: 27px;\n  height: 27px;\n  color: #b9b9b9;\n  background-color: #b9b9b9;\n  -webkit-mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  mask: url(" + __webpack_require__(29) + ") no-repeat center;\n  background: url(" + __webpack_require__(92) + ");\n}\n.general-wrapper .scheduler-config-wrapper .icon-back-wrapper .icon-back[data-v-3d7700ad]:hover {\n  cursor: pointer;\n}\n.general-wrapper .scheduler-config-wrapper .page-title[data-v-3d7700ad] {\n  margin-top: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.general-wrapper .scheduler-config-wrapper .page-title .toggle-live[data-v-3d7700ad] {\n  margin-left: 24px;\n}\n.general-wrapper .scheduler-config-wrapper .text-entry-field-wrapper .text-entry-title[data-v-3d7700ad] {\n  color: #424242;\n  font-size: 12px;\n  line-height: 28px;\n}\n.general-wrapper .scheduler-config-wrapper .text-entry-field-wrapper .text-input[data-v-3d7700ad] {\n  height: 32px;\n  width: 100%;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-limeade-sso-container .toggle-on-off[data-v-3d7700ad] {\n  display: inline-block;\n  margin-right: 24px;\n  margin-top: 16px;\n}\n.general-wrapper .scheduler-config-wrapper .scheduler-config[data-v-3d7700ad] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.general-wrapper .scheduler-config-wrapper .align-inline[data-v-3d7700ad] {\n  display: inline-block;\n}\n.general-wrapper .scheduler-config-wrapper .textarea-wrapper[data-v-3d7700ad] {\n  height: 140px;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n}\n.general-wrapper .scheduler-config-wrapper .logo[data-v-3d7700ad] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.general-wrapper .scheduler-config-wrapper .remove-button[data-v-3d7700ad] {\n  padding: 7px 24px;\n}\n.general-wrapper .scheduler-config-wrapper .upload-button-wrapper[data-v-3d7700ad] {\n  display: inline-block;\n  background-color: #00A4D6;\n  border-radius: 4px;\n  position: relative;\n  padding: 6px 24px;\n}\n.general-wrapper .scheduler-config-wrapper .upload-button-wrapper .upload-avatar[data-v-3d7700ad] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  max-height: 100%;\n}\n.general-wrapper .scheduler-config-wrapper .upload-button-wrapper .custom-file-input[data-v-3d7700ad] {\n  width: 114px;\n  min-width: 0;\n}\n.general-wrapper .scheduler-config-wrapper .upload-button-wrapper .custom-file-input[data-v-3d7700ad]:hover {\n  cursor: pointer;\n}\n.general-wrapper .scheduler-config-wrapper .upload-button-wrapper .upload-button-text[data-v-3d7700ad] {\n  color: #FFFFFF;\n  text-transform: uppercase;\n  font-size: 16px;\n  font-weight: 600;\n}\n.general-wrapper .scheduler-config-wrapper .upload-button-wrapper input[data-v-3d7700ad]:invalid {\n  border-color: #FF3400;\n}\n.general-wrapper .scheduler-config-wrapper .hpsf-labcorp-htk[data-v-3d7700ad] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.general-wrapper .scheduler-config-wrapper .align-right-buttons[data-v-3d7700ad] {\n  text-align: right;\n}\n.general-wrapper .scheduler-config-wrapper .cancel-button[data-v-3d7700ad] {\n  height: 32px;\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n}\n.general-wrapper .scheduler-config-wrapper .cancel-button .label[data-v-3d7700ad] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  text-transform: uppercase;\n}\n.general-wrapper .scheduler-config-wrapper .save-button[data-v-3d7700ad] {\n  height: 32px;\n  background-color: #00A4D6;\n  border-radius: 4px;\n}\n.general-wrapper .scheduler-config-wrapper .save-button .label[data-v-3d7700ad] {\n  color: #ffffff;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  cursor: pointer;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  float: left;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  text-transform: uppercase;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off .text-entry-title[data-v-3d7700ad] {\n  margin-left: 8px;\n  color: #626262;\n  font-size: 12px;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off input[type=checkbox][data-v-3d7700ad] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off label[data-v-3d7700ad] {\n  float: left;\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #fff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  left: 0;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off label[data-v-3d7700ad]:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off input.checked + label[data-v-3d7700ad] {\n  background: #00A4D6;\n  border: 1.5px solid #00A4D6;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off input.checked + label[data-v-3d7700ad]:after {\n  left: calc(100%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off label[data-v-3d7700ad]:active:after {\n  width: 15px;\n}\n.general-wrapper .scheduler-config-wrapper .toggle-on-off .active[data-v-3d7700ad] {\n  color: #00A4D6;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 16px;\n}\n.general-wrapper .event-list .title[data-v-3d7700ad] {\n  height: 28px;\n  color: #444444;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0.17px;\n  line-height: 28px;\n  text-transform: capitalize;\n  margin-top: 40px;\n}\n.general-wrapper .event-list .list-event[data-v-3d7700ad] {\n  height: auto;\n  border: 1px solid #B9B9B9;\n  border-radius: 4px;\n  margin: 16px 0 0 0;\n  padding: 16px;\n}\n.general-wrapper .event-list .list-event .list-event-item[data-v-3d7700ad] {\n  line-height: 22px;\n  padding: 5px 0;\n}\n.general-wrapper .event-list .list-event .list-event-item .event-name[data-v-3d7700ad] {\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  float: left;\n  max-width: 220px;\n}\n.general-wrapper .group-btn[data-v-3d7700ad] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 40px;\n}\n.general-wrapper .group-btn .ap-btn[data-v-3d7700ad] {\n  font-size: 14px;\n  padding: 6px 24px;\n}\n.general-wrapper .group-btn .ap-btn + .ap-btn[data-v-3d7700ad] {\n  margin-left: 16px;\n}\n.isLoading[data-v-3d7700ad] {\n  display: block;\n  text-align: center;\n  color: #606060;\n  height: 100%;\n}\n.noDisplay[data-v-3d7700ad] {\n  display: none!important;\n}\n.overlay[data-v-3d7700ad] {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  cursor: pointer;\n}\n.spinner-align[data-v-3d7700ad] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.image-preview[data-v-3d7700ad] {\n  width: 350px;\n  height: auto;\n  margin-bottom: 15px;\n}\n.image-preview .preview[data-v-3d7700ad] {\n  max-width: 100%;\n  max-height: 200px;\n}\n.loading-btn[data-v-3d7700ad] {\n  width: 15px;\n}\n.email-head-text[data-v-3d7700ad] {\n  color: #424242;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 32px;\n  margin-top: 20px;\n}\n.alert-icon-red-error[data-v-3d7700ad] {\n  width: 24px;\n  height: 24px;\n  color: #ffffff;\n  background-color: #ffffff;\n  background: url(" + __webpack_require__(817) + ") no-repeat center;\n}\n.display-space-between[data-v-3d7700ad] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 4px;\n}\n.display-flex-end[data-v-3d7700ad] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.error-text-color[data-v-3d7700ad] {\n  color: #FF3400;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-left: 8px;\n}\n.branded-url-error[data-v-3d7700ad] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.sf-program-id-error[data-v-3d7700ad] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports


/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modal_patient_PatientDetailModal__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modal_preview_SchedulerPreview__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eventManagement_eventDetail_StaffManagement__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_ckeditor2__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vee_validate__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_css_helper__ = __webpack_require__(360);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import consts from '../../_consts';














__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vee_validate__["a" /* default */]);

var dict = {
  custom: {
    hpsf: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    },
    labcorp: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    },
    htk: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    },
    brandedURL: {
      required: 'The field is blank, please enter a URL',
      url: 'Please enter a valid URL'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-detail-view',
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_components_Icon__["a" /* default */],
    PatientDetailModal: __WEBPACK_IMPORTED_MODULE_10__components_modal_patient_PatientDetailModal__["a" /* default */],
    SchedulerPreview: __WEBPACK_IMPORTED_MODULE_11__components_modal_preview_SchedulerPreview__["a" /* default */],
    ScrollTop: __WEBPACK_IMPORTED_MODULE_12__components_utils_ScrollTop__["a" /* default */],
    StaffManagement: __WEBPACK_IMPORTED_MODULE_13__components_eventManagement_eventDetail_StaffManagement__["a" /* default */],
    VueCkeditor: __WEBPACK_IMPORTED_MODULE_14_vue_ckeditor2__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      clientId: 0,
      dropdowntitle: {},
      screenerDropdowntitle: {},
      phlebotomistDropdowntitle: {},
      allWorkGroups: [],
      configurations: {
        allowBookFluShot: false,
        allowBookForSpouse: false,
        confirmationEmailTemplate: {
          body: ''
        },
        cancellationEmailTemplate: {
          body: ''
        },
        reminderEmailTemplate: {
          body: ''
        },
        reminderSpouseEmailTemplate: {
          body: ''
        },
        confirmationSpouseEmailTemplate: {
          body: ''
        },
        cancellationSpouseEmailTemplate: {
          body: ''
        },
        biometricResultEmailTemplate: {
          body: ''
        },
        spouseLabel: '',
        landingTopText: '',
        landingBottomText: '',
        landingThankYouText: ''
      },
      imageData: '',
      isLoading: false,
      eventSchedulerList: [],
      config: {
        toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'tools', items: ['Maximize'] }],
        height: 300,
        toolbarCanCollapse: true,
        allowedContent: true,
        toolbarStartupExpanded: false
      },
      configEmail: {
        // config for editor of email fields
        toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'tools', items: ['Maximize'] }, { name: 'Event Fields', items: ['eventTags'] }, { name: 'document', items: ['Source'] }],
        height: 300,
        fullPage: true, // allow content contains html/body/head tags
        autoGrow_onStartup: true,
        toolbarCanCollapse: true,
        allowedContent: true,
        toolbarStartupExpanded: true,
        extraPlugins: 'eventTags',
        emailTags: []
      }
    };
  },
  created: function created() {
    var _this = this;

    // Get available tags to show on dropdown list of ckeditor
    this.actionGetEmailTags().then(function (response) {
      _this.configEmail.emailTags = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(response.tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;

          if (!tag.useResetPassTemplate) {
            _this.configEmail.emailTags.push(tag);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    handleOpenSchedulerPreview: function handleOpenSchedulerPreview() {
      var config = JSON.parse(localStorage.getItem('SchedulerConfigurations'));
      this.$modal.show('schedulerPreviewModal', {
        allowBookFluShot: config.allowBookFluShot,
        allowBookForSpouse: config.allowBookForSpouse,
        spouseLabel: config.spouseLabel,
        landingTopText: config.landingTopText,
        landingBottomText: config.landingBottomText,
        landingThankYouText: config.landingThankYouText
      });
    },
    back: function back() {
      this.$router.push({ name: 'ManagerDashboard' });
    },
    previewFiles: function previewFiles() {
      this.logo = this.$refs.logo.files;
    },
    isUsedBingMap: function isUsedBingMap() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_16__consts__["a" /* default */].LOCAL_STORE.isBingMap) === 'true';
    },

    removeImage: function removeImage(e) {
      this.logo = null;
      this.imageData = '';
      this.configurations.logoFullUrl = null;
      this.configurations.logoUrl = null;
      this.configurations.logoThumbFullUrl = null;
    },
    previewImage: function previewImage(event) {
      var _this2 = this;

      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        if (input.files[0].size > 1020 * 300) {
          // 300KB
          this.$toast.success('File size must be less than 300Kb', '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
          return;
        }
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = function (e) {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          _this2.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
        this.logo = input.files[0];
      }
    },
    dropdownItemClick: function dropdownItemClick(item) {
      this.dropdownTitle = item;
      this.configurations.sbWorkGroupId = item.id;
    },
    screenerDropdownItemClick: function screenerDropdownItemClick(item) {
      this.screenerDropdownTitle = item;
      this.configurations.sbScreenerWorkGroupId = item.id;
    },
    phlebotomistDropdownItemClick: function phlebotomistDropdownItemClick(item) {
      this.phlebotomistDropdownTitle = item;
      this.configurations.sbPhlebotomistWorkGroupId = item.id;
    },

    saveConfigurations: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this3 = this;

        var isValid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isLoading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                // start - check if HPSF, labcorp or HTK is on, text box must not be empty
                isValid = false;
                _context.next = 5;
                return this.$validator.validate().then(function (result) {
                  isValid = result;
                });

              case 5:
                if (this.errors.items.length > 0) {
                  if (this.errors.items[0].rule === 'required') {
                    this.$toast.success('The field is blank, please enter a URL', '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
                  } else {
                    this.$toast.success('Please enter a valid URL', '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
                  }
                }

                if (isValid) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:
                // End

                this.$swal({
                  title: "<div class='ems_alert_title'>Configure Scheduler</div>",
                  html: "<div class='ems_alert_des'>Are you sure to save these configurations?</div>",
                  confirmButtonColor: '#0080A5',
                  confirmButtonText: 'SAVE',
                  showCancelButton: true,
                  cancelButtonColor: '#fff',
                  cancelButtonText: 'CANCEL',
                  buttonsStyling: true,
                  reverseButtons: true,
                  confirmButtonClass: 'ems_alert_confirm open',
                  cancelButtonClass: 'ems_alert_cancel',
                  customClass: 'ems_confirm',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  width: 605
                }).then(function (result) {
                  if (result.value) {
                    _this3.isLoading = true;
                    if (!_this3.logo || _this3.isUsedBingMap()) {
                      _this3.actionSaveConfigurations(_this3.configurations).then(function (responseSaveConfigs) {
                        if (!responseSaveConfigs.message) {
                          _this3.configurations = responseSaveConfigs.configurations;
                          _this3.$toast.success('Saved configurations!', '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optSuccess));
                          _this3.updateClientEventSchedulerStatus();
                        } else {
                          _this3.$toast.success(responseSaveConfigs.message, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optError));
                        }
                        _this3.isLoading = false;
                      });
                    } else {
                      _this3.actionUploadLogo({ clientId: _this3.clientId, imageFile: _this3.logo }).then(function (response) {
                        if (!response.message) {
                          _this3.actionGetClientSchedulerConfig(_this3.clientId).then(function (newConfigs) {
                            if (!newConfigs.message) {
                              _this3.configurations.logoUrl = newConfigs.configurations.logoUrl;
                              _this3.configurations.logoThumbFullUrl = newConfigs.configurations.logoThumbFullUrl;
                              _this3.configurations.logoFullUrl = newConfigs.configurations.logoFullUrl;
                              _this3.actionSaveConfigurations(_this3.configurations).then(function (responseSaveConfigs) {
                                if (!responseSaveConfigs.message) {
                                  _this3.configurations = newConfigs.configurations;
                                  _this3.$toast.success('Saved configurations!', '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optSuccess));
                                  _this3.updateClientEventSchedulerStatus();
                                } else {
                                  _this3.$toast.success(responseSaveConfigs.message, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optError));
                                }
                                _this3.isLoading = false;
                              });
                            } else {
                              _this3.$toast.success(newConfigs.message, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optError));
                              _this3.isLoading = false;
                            }
                          });
                        } else {
                          _this3.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optError));
                          _this3.isLoading = false;
                        }
                      });
                    }
                    localStorage.setItem('SchedulerConfigurations', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this3.configurations));
                    __WEBPACK_IMPORTED_MODULE_17__utils_css_helper__["a" /* default */].customColorForUI();
                  }
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveConfigurations() {
        return _ref.apply(this, arguments);
      }

      return saveConfigurations;
    }(),
    updateClientEventSchedulerStatus: function updateClientEventSchedulerStatus() {
      var _this4 = this;

      this.actionUpdateClientEventSchedulerStatus({
        clientId: this.clientId,
        events: this.eventSchedulerList
      }).then(function (response) {
        if (!response.message) {
          _this4.eventSchedulerList = response.events;
        } else {
          _this4.$toast.success(response.message, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this4.$toastOpt.optError));
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    actionGetClientSchedulerConfig: 'ACTION_GET_CLIENT_SCHEDULER_CONFIG',
    actionGetEmailTags: 'ACTION_GET_EMAIL_TAGS',
    actionSaveConfigurations: 'ACTION_SAVE_CONFIGURATIONS',
    actionUploadLogo: 'ACTION_UPLOAD_LOGO',
    getClientEventSchedulerStatus: 'ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS',
    actionUpdateClientEventSchedulerStatus: 'ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    getIsLoading: 'GETTER_IS_LOADING_MODAL'
  })),
  mounted: function mounted() {
    var _this5 = this;

    this.$validator.localize('en', dict); // This is used to overwrite the default error message
    this.clientId = this.$route.params.clientId;
    this.actionGetClientSchedulerConfig(this.clientId).then(function (response) {
      if (!response.errors) {
        _this5.configurations = response.configurations || {};
        localStorage.setItem('SchedulerConfigurations', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this5.configurations));
        _this5.imageData = _this5.configurations.logoFullUrl ? "https://resources.adurolife.com/cw/prod2/api/v1" + '/' + _this5.configurations.logoFullUrl : '';
        // call api to get event scheduler list
        _this5.getClientEventSchedulerStatus(_this5.clientId).then(function (response) {
          _this5.eventSchedulerList = response.events || [];
        });
        _this5.allWorkGroups = response.sbWorkGroupDtos;
        _this5.dropdowntitle = response.sbWorkGroupDtos.find(function (x) {
          return x.id === _this5.configurations.sbWorkGroupId;
        });
        _this5.screenerDropdowntitle = response.sbWorkGroupDtos.find(function (x) {
          return x.id === _this5.configurations.sbScreenerWorkGroupId;
        });
        _this5.phlebotomistDropdowntitle = response.sbWorkGroupDtos.find(function (x) {
          return x.id === _this5.configurations.sbPhlebotomistWorkGroupId;
        });
      } else {
        _this5.$toast.success(response.errors, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this5.$toastOpt.optError));
      }
    });
  }
});

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-wrapper margin-side" },
    [
      _c(
        "div",
        {
          staticClass: "overlay",
          class: { isLoading: _vm.getIsLoading, noDisplay: !_vm.getIsLoading }
        },
        [
          _c(
            "div",
            { staticClass: "spinner-align" },
            [
              _c("Icon", {
                staticClass: "icon-size",
                attrs: { name: "spinner", scale: "5", pulse: "" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.getIsLoading
        ? _c(
            "div",
            { staticClass: "scheduler-config-wrapper" },
            [
              _c("div", { staticClass: "icon-back-wrapper" }, [
                _c("div", {
                  staticClass: "icon-back",
                  on: {
                    click: function($event) {
                      _vm.back()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "page-title" }, [
                _c("div", { staticClass: "h2-text" }, [
                  _vm._v("\n        Configure Scheduler\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "toggle-live toggle-on-off" }, [
                  _c("input", {
                    class: { checked: _vm.configurations.live },
                    attrs: { type: "checkbox", id: "live" }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      attrs: { for: "live" },
                      on: {
                        click: function($event) {
                          _vm.configurations.live = !_vm.configurations.live
                        }
                      }
                    },
                    [_vm._v("Live")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-entry-title align-inline",
                      class: { active: _vm.configurations.live }
                    },
                    [_vm._v("Live")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  on: {
                    click: function($event) {
                      _vm.handleOpenSchedulerPreview()
                    }
                  }
                },
                [_vm._v("Preview")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Scheduler name")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.name,
                          expression: "configurations.name"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Scheduler URL")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.schedulerUrl,
                          expression: "configurations.schedulerUrl"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.schedulerUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "schedulerUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-2 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("URL Hyperlink Color")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.urlHyperlinkColor,
                          expression: "configurations.urlHyperlinkColor"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.urlHyperlinkColor },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "urlHyperlinkColor",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-2 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Branded URL")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.brandedURL,
                          expression: "configurations.brandedURL"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      attrs: { name: "brandedURL" },
                      domProps: { value: _vm.configurations.brandedURL },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "brandedURL",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "branded-url-error" }, [
                      _vm.errors.has("brandedURL")
                        ? _c("div", { staticClass: "alert-icon-red-error" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "error-text-color" }, [
                        _vm._v(_vm._s(_vm.errors.first("brandedURL")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Brand Name")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.brandName,
                          expression: "configurations.brandName"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.brandName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "brandName",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Survey Biometric Result URL")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.surveyBiometricResultUrl,
                          expression: "configurations.surveyBiometricResultUrl"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: {
                        value: _vm.configurations.surveyBiometricResultUrl
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "surveyBiometricResultUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("ShiftBoard Lead WorkGroup")
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "multiple-select-work-group",
                      attrs: {
                        options: _vm.allWorkGroups,
                        placeholder: "Choose WorkGroup",
                        label: "name",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": false,
                        "show-labels": false,
                        disabled: false
                      },
                      on: { select: _vm.dropdownItemClick },
                      model: {
                        value: _vm.dropdowntitle,
                        callback: function($$v) {
                          _vm.dropdowntitle = $$v
                        },
                        expression: "dropdowntitle"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("ShiftBoard Screener WorkGroup")
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "multiple-select-work-group",
                      attrs: {
                        options: _vm.allWorkGroups,
                        placeholder: "Choose Screener WorkGroup",
                        label: "name",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": false,
                        "show-labels": false,
                        disabled: false
                      },
                      on: { select: _vm.screenerDropdownItemClick },
                      model: {
                        value: _vm.screenerDropdowntitle,
                        callback: function($$v) {
                          _vm.screenerDropdowntitle = $$v
                        },
                        expression: "screenerDropdowntitle"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("ShiftBoard Phlebotomist WorkGroup")
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "multiple-select-work-group",
                      attrs: {
                        options: _vm.allWorkGroups,
                        placeholder: "Choose Phlebotomist WorkGroup",
                        label: "name",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": false,
                        "show-labels": false,
                        disabled: false
                      },
                      on: { select: _vm.phlebotomistDropdownItemClick },
                      model: {
                        value: _vm.phlebotomistDropdowntitle,
                        callback: function($$v) {
                          _vm.phlebotomistDropdowntitle = $$v
                        },
                        expression: "phlebotomistDropdowntitle"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "margin-top-24px toggle-limeade-sso-container" },
                [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: {
                        checked: _vm.configurations.allowWithoutLimeade
                      },
                      attrs: { type: "checkbox", id: "without_limeade_login" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "without_limeade_login" },
                        on: {
                          click: function($event) {
                            _vm.configurations.allowWithoutLimeade = !_vm
                              .configurations.allowWithoutLimeade
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: {
                          active: _vm.configurations.allowWithoutLimeade
                        }
                      },
                      [_vm._v("Allow walk-in checkin\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off " }, [
                    _c("input", {
                      class: { checked: _vm.configurations.allowBookFluShot },
                      attrs: { type: "checkbox", id: "allow_spouse" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "allow_spouse" },
                        on: {
                          click: function($event) {
                            _vm.configurations.allowBookFluShot = !_vm
                              .configurations.allowBookFluShot
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: { active: _vm.configurations.allowBookFluShot }
                      },
                      [_vm._v("Allow flu shot appointment\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: {
                        checked: _vm.configurations.zendeskConfiguration
                      },
                      attrs: { type: "checkbox", id: "is_display_zendesk" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "is_display_zendesk" },
                        on: {
                          click: function($event) {
                            _vm.configurations.zendeskConfiguration = !_vm
                              .configurations.zendeskConfiguration
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: {
                          active: _vm.configurations.zendeskConfiguration
                        }
                      },
                      [_vm._v("Allow ZenDesk\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: {
                        checked: _vm.configurations.multipleScreeningsPerYear
                      },
                      attrs: { type: "checkbox", id: "is_display_program_year" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "is_display_program_year" },
                        on: {
                          click: function($event) {
                            _vm.configurations.multipleScreeningsPerYear = !_vm
                              .configurations.multipleScreeningsPerYear
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: {
                          active: _vm.configurations.multipleScreeningsPerYear
                        }
                      },
                      [_vm._v("Allow multiple screenings per year\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.fluShotOnly },
                      attrs: { type: "checkbox", id: "flu_shot_only" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "flu_shot_only" },
                        on: {
                          click: function($event) {
                            _vm.configurations.fluShotOnly = !_vm.configurations
                              .fluShotOnly
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: { active: _vm.configurations.fluShotOnly }
                      },
                      [_vm._v("Allow flu shot only\n        ")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.allowBookForSpouse },
                      attrs: { type: "checkbox", id: "allow_flu_shot" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "allow_flu_shot" },
                        on: {
                          click: function($event) {
                            _vm.configurations.allowBookForSpouse = !_vm
                              .configurations.allowBookForSpouse
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: { active: _vm.configurations.allowBookForSpouse }
                      },
                      [_vm._v("\n            Spouse appointment\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: {
                          "opacity-06": !_vm.configurations.allowBookForSpouse
                        }
                      },
                      [
                        _c("div", [_vm._v("Spouse Label")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: {
                              noDisplay: !_vm.configurations.allowBookForSpouse
                            }
                          },
                          [
                            _vm.errors.has("spouse")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("Spouse")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.spouseLabel,
                          expression: "configurations.spouseLabel"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "text-input",
                      class: {
                        "opacity-06": !_vm.configurations.allowBookForSpouse
                      },
                      attrs: {
                        disabled: !_vm.configurations.allowBookForSpouse,
                        name: "Spouse"
                      },
                      domProps: { value: _vm.configurations.spouseLabel },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "spouseLabel",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" })
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "margin-top-40px toggle-limeade-sso-container"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Landing Page Top Text")
                    ]),
                    _vm._v(" "),
                    _c("vue-ckeditor", {
                      attrs: { config: _vm.config },
                      model: {
                        value: _vm.configurations.landingTopText,
                        callback: function($$v) {
                          _vm.$set(_vm.configurations, "landingTopText", $$v)
                        },
                        expression: "configurations.landingTopText"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Landing Page Bottom Text")
                    ]),
                    _vm._v(" "),
                    _c("vue-ckeditor", {
                      attrs: { config: _vm.config },
                      model: {
                        value: _vm.configurations.landingBottomText,
                        callback: function($$v) {
                          _vm.$set(_vm.configurations, "landingBottomText", $$v)
                        },
                        expression: "configurations.landingBottomText"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Thank you page text")
                    ]),
                    _vm._v(" "),
                    _c("vue-ckeditor", {
                      attrs: { config: _vm.config },
                      model: {
                        value: _vm.configurations.landingThankYouText,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.configurations,
                            "landingThankYouText",
                            $$v
                          )
                        },
                        expression: "configurations.landingThankYouText"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.hpsf },
                      attrs: { type: "checkbox", id: "hpsf" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "hpsf" },
                        on: {
                          click: function($event) {
                            _vm.configurations.hpsf = !_vm.configurations.hpsf
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hpsf-labcorp-htk align-inline padding-left-8px",
                        class: { active: _vm.configurations.hpsf }
                      },
                      [_vm._v("HPSF\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: { "opacity-06": !_vm.configurations.hpsf }
                      },
                      [
                        _c("div", [_vm._v("HPSF URL")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: { noDisplay: !_vm.configurations.hpsf }
                          },
                          [
                            _vm.errors.has("hpsf")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("hpsf")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.hpsfUrl,
                          expression: "configurations.hpsfUrl"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      class: { "opacity-06": !_vm.configurations.hpsf },
                      attrs: {
                        disabled: !_vm.configurations.hpsf,
                        name: "hpsf"
                      },
                      domProps: { value: _vm.configurations.hpsfUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "hpsfUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.labCorp },
                      attrs: { type: "checkbox", id: "labcorp" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "labcorp" },
                        on: {
                          click: function($event) {
                            _vm.configurations.labCorp = !_vm.configurations
                              .labCorp
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hpsf-labcorp-htk align-inline padding-left-8px",
                        class: { active: _vm.configurations.labCorp }
                      },
                      [_vm._v("\n            Labcorp\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: { "opacity-06": !_vm.configurations.labCorp }
                      },
                      [
                        _c("div", [_vm._v("Labcorp URL")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: { noDisplay: !_vm.configurations.labCorp }
                          },
                          [
                            _vm.errors.has("labcorp")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("labcorp")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.labCorpUrl,
                          expression: "configurations.labCorpUrl"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      class: { "opacity-06": !_vm.configurations.labCorp },
                      attrs: {
                        disabled: !_vm.configurations.labCorp,
                        name: "labcorp"
                      },
                      domProps: { value: _vm.configurations.labCorpUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "labCorpUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.htk },
                      attrs: { type: "checkbox", id: "htk" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "htk" },
                        on: {
                          click: function($event) {
                            _vm.configurations.htk = !_vm.configurations.htk
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hpsf-labcorp-htk align-inline padding-left-8px",
                        class: { active: _vm.configurations.htk }
                      },
                      [_vm._v("HTK\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: { "opacity-06": !_vm.configurations.htk }
                      },
                      [
                        _c("div", [_vm._v("HTK URL")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: { noDisplay: !_vm.configurations.htk }
                          },
                          [
                            _vm.errors.has("htk")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("htk")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.htkUrl,
                          expression: "configurations.htkUrl"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      class: { "opacity-06": !_vm.configurations.htk },
                      attrs: { disabled: !_vm.configurations.htk, name: "htk" },
                      domProps: { value: _vm.configurations.htkUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "htkUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-40px" }, [
                _c("div", { staticClass: "logo" }, [
                  _vm._v("Logo "),
                  _vm.isUsedBingMap()
                    ? _c("span", [_vm._v("(Maximum size is 300KB)")])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.isUsedBingMap()
                ? _c("div", { staticClass: "margin-top-15px" }, [
                    _vm.imageData.length > 0
                      ? _c("div", { staticClass: "image-preview" }, [
                          _c("img", {
                            staticClass: "preview",
                            attrs: { src: _vm.imageData }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-button-wrapper" }, [
                      _c("span", { staticClass: "upload-button-text" }, [
                        _vm._v("upload")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        ref: "logo",
                        staticClass: "custom-file-input upload-avatar",
                        attrs: {
                          type: "file",
                          name: "imageFile",
                          id: "file",
                          accept: "image/*"
                        },
                        on: { change: _vm.previewImage }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.imageData.length > 0
                      ? _c(
                          "button",
                          {
                            staticClass: "ap-btn primary remove-button",
                            on: {
                              click: function($event) {
                                _vm.removeImage()
                              }
                            }
                          },
                          [_vm._v("remove")]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isUsedBingMap()
                ? _c("div", { staticClass: "margin-top-15px" }, [
                    _vm.configurations &&
                    _vm.configurations.logoUrl &&
                    _vm.configurations.logoUrl.length > 0
                      ? _c("div", { staticClass: "image-preview" }, [
                          _c("img", {
                            staticClass: "preview",
                            attrs: { src: _vm.configurations.logoUrl }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "event-list" }, [
                _c("div", { staticClass: "title" }, [_vm._v("events")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row list-event" },
                  _vm._l(_vm.eventSchedulerList, function(event) {
                    return _c(
                      "div",
                      { key: event, staticClass: "col-md-4 list-event-item" },
                      [
                        _c("div", { staticClass: "event-name" }, [
                          _vm._v(_vm._s(event.eventName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "toggle-on-off align-inline padding-left-19px"
                          },
                          [
                            _c("input", {
                              class: { checked: event.isOnlineScheduler },
                              attrs: {
                                type: "checkbox",
                                id: "event_" + event.id
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "event_" + event.id },
                                on: {
                                  click: function($event) {
                                    event.isOnlineScheduler = !event.isOnlineScheduler
                                  }
                                }
                              },
                              [_vm._v("Toggle")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-entry-title align-inline padding-left-3px",
                                class: { active: event.isOnlineScheduler }
                              },
                              [_vm._v("Online scheduler\n            ")]
                            )
                          ]
                        )
                      ]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Confirmation Email")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.confirmationEmailTemplate.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.confirmationEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.confirmationEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Confirmation Email for Spouse")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.confirmationSpouseEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations
                                  .confirmationSpouseEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.confirmationSpouseEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Cancellation Email To Participant")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.cancellationEmailTemplate.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.cancellationEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.cancellationEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Cancellation Email To Spouse")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.cancellationSpouseEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations
                                  .cancellationSpouseEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.cancellationSpouseEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Reminder Email To Participant")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.reminderEmailTemplate.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.reminderEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.reminderEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Reminder Email To Spouse")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.reminderSpouseEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.reminderSpouseEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.reminderSpouseEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Biometric Survey Email")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.biometricResultEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.biometricResultEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.biometricResultEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-44px group-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "ap-btn secondary",
                    on: {
                      click: function($event) {
                        _vm.back()
                      }
                    }
                  },
                  [_vm._v("\n        cancel\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ap-btn primary",
                    class: { "opacity-04": _vm.isLoading },
                    attrs: { disabled: _vm.isLoading },
                    on: {
                      click: function($event) {
                        _vm.saveConfigurations()
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PatientDetailModal"),
      _vm._v(" "),
      _c("SchedulerPreview")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-list" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Participant Emails")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d7700ad", esExports)
  }
}

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagerDashboard_vue__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15eac582_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManagerDashboard_vue__ = __webpack_require__(1828);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1806)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15eac582"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagerDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15eac582_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManagerDashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/managerDashboard/ManagerDashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManagerDashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15eac582", Component.options)
  } else {
    hotAPI.reload("data-v-15eac582", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1807);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5e460812", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-15eac582\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManagerDashboard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-15eac582\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManagerDashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.app-body[data-v-15eac582] {\n  min-height: 100vh;\n}\n", ""]);

// exports


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dash__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_eventManagement_sidebar_Sidebar_vue__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_eventManagement_header_Header_vue__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_FaqModal__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_constants__ = __webpack_require__(83);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_4__components_eventManagement_header_Header_vue__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__components_eventManagement_sidebar_Sidebar_vue__["a" /* default */],
    ScrollTop: __WEBPACK_IMPORTED_MODULE_5__components_utils_ScrollTop__["a" /* default */],
    FaqModal: __WEBPACK_IMPORTED_MODULE_6__components_modal_FaqModal__["a" /* default */]
  },
  data: function data() {
    return {
      dashboardCards: __WEBPACK_IMPORTED_MODULE_1__dash__["a" /* default */].items
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({})),
  created: function created() {
    var clientId = parseInt(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.clientId));
    if (clientId !== 0 && this.$route.params.clientId.toString() !== clientId.toString()) {
      this.$router.push({
        name: __WEBPACK_IMPORTED_MODULE_8__router_constants__["a" /* default */].clientDashboard.name,
        params: {
          clientId: clientId
        }
      });
    }
  }
});

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5740e3c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1822);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5740e3c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5740e3c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/sidebar/Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5740e3c6", Component.options)
  } else {
    hotAPI.reload("data-v-5740e3c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("07390c44", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5740e3c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5740e3c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.sidebar[data-v-5740e3c6] {\n  background-color: #006988;\n}\n", ""]);

// exports


/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavIcons__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_constants__ = __webpack_require__(83);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import consts from '../../../_consts';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  data: function data() {
    return {};
  },

  components: {
    SidebarNavIcons: __WEBPACK_IMPORTED_MODULE_2__SidebarNavIcons__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    listSideBar: function listSideBar() {
      return [{
        name: 'Dashboard',
        routerName: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.children.dashboard.name,
        icon: 'icon-dashboard'
      }, {
        name: 'Plan',
        routerName: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.children.plan.name,
        icon: 'icon-plan'
      }, {
        name: 'Manage',
        routerName: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.children.manage.name,
        icon: 'icon-manage'
      }, {
        name: 'Reports',
        routerName: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.children.reports.name,
        icon: 'icon-report'
      }];
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    countUnreadEventByStatus: 'GETTERS_COUNT_UNREAD_EVENT_BY_STATUS'
  })),
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavIcons_vue__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f9d174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavIcons_vue__ = __webpack_require__(1821);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1814)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20f9d174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavIcons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f9d174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavIcons_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/sidebar/SidebarNavIcons.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarNavIcons.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20f9d174", Component.options)
  } else {
    hotAPI.reload("data-v-20f9d174", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1815);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1254ba2a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-20f9d174\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarNavIcons.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-20f9d174\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarNavIcons.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.nav-item[data-v-20f9d174] {\n  height: 80px;\n  position: relative;\n}\n.nav-item .nav-link[data-v-20f9d174] {\n  height: 80px;\n  padding: 0 0 0 0 !important;\n}\n.nav-item .nav-link .text-section[data-v-20f9d174] {\n  margin-top: -5px;\n}\n.nav-item .nav-link .nav-ellipsis[data-v-20f9d174] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100px;\n}\n.nav-item .active .nav-font-size-small[data-v-20f9d174] {\n  color: #ffffff;\n}\n.nav-item .text[data-v-20f9d174] {\n  margin-bottom: 12px;\n}\n.nav-item .icon-dashboard[data-v-20f9d174] {\n  margin: 1.5px 1.5px;\n  width: 36px;\n  height: 36px;\n  color: #ffffff;\n  background-color: #ffffff;\n  -webkit-mask: url(" + __webpack_require__(834) + ") no-repeat center;\n  mask: url(" + __webpack_require__(834) + ") no-repeat center;\n  background: url(" + __webpack_require__(1816) + ");\n}\n.nav-item .icon-plan[data-v-20f9d174] {\n  margin: 1.5px 1.5px;\n  width: 36px;\n  height: 36px;\n  color: #ffffff;\n  background-color: #ffffff;\n  -webkit-mask: url(" + __webpack_require__(835) + ") no-repeat center;\n  mask: url(" + __webpack_require__(835) + ") no-repeat center;\n  background: url(" + __webpack_require__(1817) + ");\n}\n.nav-item .icon-manage[data-v-20f9d174] {\n  margin: 1.5px 1.5px;\n  width: 36px;\n  height: 36px;\n  color: #ffffff;\n  background-color: #ffffff;\n  -webkit-mask: url(" + __webpack_require__(836) + ") no-repeat center;\n  mask: url(" + __webpack_require__(836) + ") no-repeat center;\n  background: url(" + __webpack_require__(1818) + ");\n}\n.nav-item .icon-report[data-v-20f9d174] {\n  margin: 1.5px 1.5px;\n  width: 36px;\n  height: 36px;\n  color: #ffffff;\n  background-color: #ffffff;\n  -webkit-mask: url(" + __webpack_require__(837) + ") no-repeat center;\n  mask: url(" + __webpack_require__(837) + ") no-repeat center;\n  background: url(" + __webpack_require__(1819) + ");\n}\n.fa-stack[data-count][data-v-20f9d174]:after {\n  content: attr(data-count);\n  font-size: 9px;\n  line-height: .75em;\n  text-align: center;\n  top: 5px;\n  color: #3c6275;\n  position: absolute;\n}\n.fa-stack[data-v-20f9d174]::after {\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.small-notify-number[data-v-20f9d174]::after {\n  left: 5px;\n}\n.big-notify-number[data-v-20f9d174]::after {\n  left: 3px;\n}\n.icon-size[data-v-20f9d174] {\n  height: 26px;\n  width: 26px;\n  margin: 0 0 0 0;\n  background-color: transparent;\n}\n.nav-font-size-small[data-v-20f9d174] {\n  font-size: 12px;\n  font-family: 'Open Sans', sans-serif;\n  line-height: 14px;\n  text-align: center;\n}\n.sidebar .nav .nav-item .nav-link [class^=\"icon-\"][data-v-20f9d174] {\n  margin-top: 13px;\n}\n.sidebar .nav .nav-item .nav-link[data-v-20f9d174] {\n  width: 96px;\n  border-left: 5px solid #006988;\n}\n.sidebar .nav .nav-item .nav-link[data-v-20f9d174]:hover {\n  border-left: 5px solid #8BC5D6;\n}\n.sidebar .nav .nav-item .nav-link.active[data-v-20f9d174] {\n  color: #ffffff;\n  border-left: 5px solid #8BC5D6;\n  background-color: #194975;\n}\n.sidebar .nav .nav-item .nav-item-margin[data-v-20f9d174] {\n  margin-top: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAyMDwvdGl0bGU+PHBhdGggZD0iTTIwLDIySDIuNWEuNS41LDAsMCwxLS41LS41VjRBLjUuNSwwLDAsMSwzLDRWMjFIMjBhLjUuNSwwLDAsMSwwLDFaIi8+PHBhdGggZD0iTTE3LDdoMFYxOUg1VjEzbDUuMTQtNC41aDBWMTNhLjQ1LjQ1LDAsMCwwLC40Ni40My40Ny40NywwLDAsMCwuMzEtLjEyTDE3LDdtMC0xYTEsMSwwLDAsMC0uNzIuMzFsLTUuMTQsNS4zM1Y4LjVhMSwxLDAsMCwwLS42Mi0uOTMsMS4yMiwxLjIyLDAsMCwwLS4zOC0uMDcsMSwxLDAsMCwwLS42Ni4yNWwtNS4xNCw0LjVBMSwxLDAsMCwwLDQsMTN2NmExLDEsMCwwLDAsMSwxSDE3YTEsMSwwLDAsMCwxLTFWN2ExLDEsMCwwLDAtLjYzLS45M0ExLDEsMCwwLDAsMTcsNloiLz48L3N2Zz4="

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPk1hbmFnZSAtIGV4cG9ydDwvdGl0bGU+PGcgaWQ9IkxheWVyXzEiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggZD0iTTE3LDVIMTZWNGgxWk0xNSw1SDE0VjRoMVpNMTMsNUgxMlY0aDFaTTExLDVIMTBWNGgxWk05LDVIOFY0SDlaIi8+PHBhdGggZD0iTTE5LDVIMThWNGguNWEuNS41LDAsMCwxLC41LjVaIi8+PHBhdGggZD0iTTE5LDE1SDE4VjE0aDFabTAtMkgxOFYxMmgxWm0wLTJIMThWMTBoMVptMC0ySDE4VjhoMVptMC0ySDE4VjZoMVoiLz48cGF0aCBkPSJNMTguNSwxN0gxOFYxNmgxdi41QS41LjUsMCwwLDEsMTguNSwxN1oiLz48cGF0aCBkPSJNMTcsMTdIMTZWMTZoMVptLTIsMEgxNFYxNmgxWk05LDE3SDhWMTZIOVpNNywxN0g2VjE2SDdaIi8+PHBhdGggZD0iTTUsMTdINHYtLjVhLjUuNSwwLDAsMSwuNS0uNUg1WiIvPjxyZWN0IHg9IjQiIHk9IjE4IiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHBhdGggZD0iTTUsMjFINC41YS41LjUsMCwwLDEtLjUtLjVWMjBINVoiLz48cGF0aCBkPSJNMTUsMjFIMTRWMjBoMVptLTIsMEgxMlYyMGgxWm0tMiwwSDEwVjIwaDFaTTksMjFIOFYyMEg5Wk03LDIxSDZWMjBIN1oiLz48cGF0aCBkPSJNMTEuNSwxNi45NGEuNDYuNDYsMCwwLDEtLjM4LS4yTDEwLjY0LDE2Yy0xLjUtMi4zNi0yLjU4LTQuMDctMi41OC01LjYyYTMuNDQsMy40NCwwLDAsMSw2Ljg4LDBjMCwxLjU1LTEuMDgsMy4yNi0yLjU4LDUuNjJsLS40OC43N0EuNDYuNDYsMCwwLDEsMTEuNSwxNi45NFptMC05YTIuNTYsMi41NiwwLDAsMC0yLjU2LDIuNDFjMCwxLjI5LDEsMi45MSwyLjQ1LDUuMTVsLjExLjE3LjExLS4xN2MxLjQyLTIuMjQsMi40NS0zLjg2LDIuNDUtNS4xNUEyLjU2LDIuNTYsMCwwLDAsMTEuNSw3Ljk0Wm0wLDRhMS40NCwxLjQ0LDAsMSwxLDEuNDQtMS40NEExLjQzLDEuNDMsMCwwLDEsMTEuNSwxMS45NFptMC0yYS41Ni41NiwwLDEsMCwuNTYuNTZBLjU2LjU2LDAsMCwwLDExLjUsOS45NFoiLz48Y2lyY2xlIGN4PSI0LjUiIGN5PSI0LjUiIHI9IjEuNSIvPjxjaXJjbGUgY3g9IjE4LjUiIGN5PSIyMC41IiByPSIxLjUiLz48L2c+PC9zdmc+"

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmdyYXBoPC90aXRsZT48cGF0aCBkPSJNMjEuNSwyMkgyLjVhLjUuNSwwLDAsMSwwLTFoMTlhLjUuNSwwLDAsMSwwLDFaIi8+PHBhdGggZD0iTTEzLjUsM2EuNS41LDAsMCwxLC41LjV2MTRhLjUuNSwwLDAsMS0uNS41aC0zYS41LjUsMCwwLDEtLjUtLjVWMy41YS41LjUsMCwwLDEsLjUtLjVoM20wLTFoLTNBMS41LDEuNSwwLDAsMCw5LDMuNXYxNEExLjUsMS41LDAsMCwwLDEwLjUsMTloM0ExLjUsMS41LDAsMCwwLDE1LDE3LjVWMy41QTEuNSwxLjUsMCwwLDAsMTMuNSwyWiIvPjxwYXRoIGQ9Ik0yMC41LDdhLjUxLjUxLDAsMCwxLC41LjV2MTBhLjUxLjUxLDAsMCwxLS41LjVoLTJhLjUxLjUxLDAsMCwxLS41LS41VjcuNWEuNTEuNTEsMCwwLDEsLjUtLjVoMm0wLTFoLTJBMS41LDEuNSwwLDAsMCwxNyw3LjV2MTBBMS41LDEuNSwwLDAsMCwxOC41LDE5aDJBMS41LDEuNSwwLDAsMCwyMiwxNy41VjcuNUExLjUsMS41LDAsMCwwLDIwLjUsNloiLz48cGF0aCBkPSJNNS41LDExYS41MS41MSwwLDAsMSwuNS41djZhLjUxLjUxLDAsMCwxLS41LjVoLTJhLjUxLjUxLDAsMCwxLS41LS41di02YS41MS41MSwwLDAsMSwuNS0uNWgybTAtMWgtMkExLjUsMS41LDAsMCwwLDIsMTEuNXY2QTEuNSwxLjUsMCwwLDAsMy41LDE5aDJBMS41LDEuNSwwLDAsMCw3LDE3LjV2LTZBMS41LDEuNSwwLDAsMCw1LjUsMTBaIi8+PC9zdmc+"

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    },
    notifyNumber: {
      type: Number,
      default: 0
    },
    eventStatus: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      class1: 'small-notify-number',
      class2: 'big-notify-number',
      class3: 'sidebar-item-new-event'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    renderClass: function renderClass() {
      return this.notifyNumber < 10 ? this.class1 : this.class2;
    },
    renderCssItemNewEvent: function renderCssItemNewEvent() {
      if (this.name === 'New Event') {
        return this.class3;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    getClientName: 'GETTERS_GET_CLIENT_NAME'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    btnCreateNewEventOnSideBar: 'CREATE_EVENT_FLAG'
  }), {
    newEventClick: function newEventClick() {
      var _this = this;

      this.btnCreateNewEventOnSideBar(true).then(function () {
        _this.$router.replace(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].routeDirect.userDrafts);
      });
    }
  })
});

/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-item", attrs: { align: "center" } },
    [
      _c(
        "router-link",
        {
          staticClass: "nav-link",
          attrs: {
            to: {
              name: _vm.routerName,
              params: {
                clientId: _vm.$route.params.clientId
              }
            }
          }
        },
        [
          _c("div", { class: _vm.icon }),
          _vm._v(" "),
          _c("div", {}, [
            _c("span", { staticClass: "nav-font-size-small" }, [
              _vm._v(_vm._s(_vm.name))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20f9d174", esExports)
  }
}

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar" }, [
    _c("nav", { staticClass: "sidebar-nav" }, [
      _c("div", { attrs: { slot: "header" }, slot: "header" }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "nav" },
        _vm._l(_vm.listSideBar, function(item, index) {
          return _c(
            "li",
            { staticClass: "nav-item" },
            [
              [
                _c("SidebarNavIcons", {
                  attrs: {
                    name: item.name,
                    routerName: item.routerName,
                    icon: item.icon
                  }
                })
              ]
            ],
            2
          )
        })
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5740e3c6", esExports)
  }
}

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10970f03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1827);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1824)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10970f03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/header/Header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-10970f03", Component.options)
  } else {
    hotAPI.reload("data-v-10970f03", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1825);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4e6930bf", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10970f03\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10970f03\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.main-container {\n  float: left;\n  position: relative;\n}\n.fixer-container {\n  float: left;\n  position: relative;\n}\n.fixer-container .display-inline-div {\n  display: inline-block;\n}\n.fixer-container .float-right {\n  float: right;\n}\n.fixer-container .multiselect__option--highlight {\n  color: #231F20;\n  background-color: #F5F5F5;\n}\n.header-icon {\n  float: left;\n  height: 25px;\n  width: 20px;\n  text-align: center;\n  margin: 8px 15px;\n}\n.header-icon:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.header-icon .header-sub-icon {\n  height: 25px;\n  width: 20px;\n}\n@media screen and (min-width: 764px) {\n.app-header {\n    height: 70px;\n}\n.app-header .header-left-image {\n    max-width: 140px;\n    height: 70px;\n}\n.app-header .col-md-5 {\n    min-width: 400px;\n}\n.app-header .col-md-5 .header-dropdown {\n    width: 220px;\n}\n.app-header .col-md-3 {\n    max-width: 240px;\n}\n.app-header .col-md-3 .nameDisplay {\n    padding-right: 25px;\n}\n}\n@media screen and (min-width: 720px) and (max-width: 763px) {\n.app-header {\n    height: 70px;\n}\n.app-header .header-left-image {\n    max-width: 140px;\n    height: 70px;\n}\n.app-header .col-md-5 {\n    min-width: 400px;\n}\n.app-header .col-md-5 .header-dropdown {\n    width: 220px;\n}\n.app-header .col-md-3 {\n    max-width: 198px;\n}\n.app-header .col-md-3 .nameDisplay {\n    padding-right: 25px;\n}\n}\n@media screen and (max-width: 720px) {\n.app-header {\n    height: 70px;\n}\n.app-header .header-left-image {\n    max-width: 140px;\n    height: 70px;\n}\n.app-header .col-md-5 {\n    min-width: 400px;\n}\n.app-header .col-md-5 .header-dropdown {\n    width: 220px;\n}\n.app-header .col-md-3 {\n    max-width: 190px;\n}\n.app-header .col-md-3 .nameDisplay {\n    padding-right: 25px;\n}\n}\n.header-left-image {\n  width: auto;\n  min-width: 130px;\n  height: 70px;\n}\n.header-dropdown {\n  margin-bottom: 12px;\n  height: 100px;\n  float: left;\n}\n.header-middle {\n  width: auto;\n  margin-top: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n/* FOR CHROME */\n@supports (-webkit-appearance:none) {\n.header-middle-managing {\n    height: 29px;\n    margin: 6px 10px 4px 0;\n    float: left;\n}\n}\n/* FOR IE */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n.header-middle-managing {\n    height: 29px;\n    width: 10px;\n    margin: 6px 130px 4px 0;\n    float: left;\n}\n.header-middle-managing-client {\n    height: 29px;\n    width: 470px;\n    margin: 6px 130px 4px 0;\n    float: left;\n}\n.header-dropdown {\n    width: 250px;\n    float: left;\n}\n}\n/* FOR FIREFOX */\n_:-moz-tree-row(hover),\n.header-middle-managing {\n  height: 29px;\n  margin: 6px 10px 4px 0;\n  float: left;\n}\n.header-middle-text {\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  text-transform: uppercase;\n}\n.align-center {\n  text-align: right;\n  /* FOR FIREFOX */\n  /* FOR CHROME */\n  /* FOR IE */\n}\n.align-center _:-moz-tree-row(hover),\n.align-center .dropdown-item,\n.align-center .dropdown-toggle,\n.align-center .dropdown-menu,\n.align-center .b-dropdown {\n  width: 240px;\n  height: 39px;\n}\n@supports (-webkit-appearance:none) {\n.align-center .dropdown-item,\n  .align-center .dropdown-toggle,\n  .align-center .dropdown-menu,\n  .align-center .b-dropdown {\n    width: 250px;\n    height: 39px;\n    float: left;\n}\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n.align-center .dropdown-item,\n  .align-center .dropdown-toggle,\n  .align-center .dropdown-menu,\n  .align-center .b-dropdown {\n    width: 240px;\n    height: 39px;\n}\n}\n.manageText {\n  float: right;\n  width: 60px;\n}\n.btn-dropdown {\n  height: 39px;\n  border: 1px solid #0080a5;\n  border-radius: 3px;\n  background-color: #ffffff;\n}\n.btn-group > .btn:first-child {\n  background-color: #ffffff;\n  color: #231f20;\n  font-family: Arquitecta, sans-serif;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 29px;\n  border: solid 1px #0080a5;\n}\n.header-right-text {\n  text-align: right;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 5px;\n}\n.nameDisplay {\n  padding: 0px 35px 0 0;\n  position: relative;\n}\n.nameDisplay:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.nameDisplay:hover .user-action-panel {\n  display: block;\n}\n.nameDisplay .header-right-position {\n  color: #7b7b7b;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: right;\n  width: 100px;\n  text-transform: capitalize;\n}\n.nameDisplay .user-action-icon {\n  position: absolute;\n  right: 10px;\n  top: 15px;\n}\n.nameDisplay .user-action-panel {\n  position: absolute;\n  right: 0;\n  z-index: 999;\n  top: 44px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n}\n.nameDisplay .user-action-panel ul {\n  width: 250px;\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.nameDisplay .user-action-panel ul li {\n  height: 35px;\n  width: 100%;\n  text-align: left;\n  margin: 10px 0;\n  line-height: 35px;\n  padding-left: 10px;\n  color: #231f20;\n}\n.nameDisplay .user-action-panel ul li:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n.nameDisplay .user-action-panel ul li input[type=checkbox] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.nameDisplay .user-action-panel ul li label {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 30px;\n  height: 15px;\n  background: grey;\n  border-radius: 15px;\n  position: relative;\n  top: 11px;\n  left: 5px;\n}\n.nameDisplay .user-action-panel ul li label:after {\n  content: '';\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 15px;\n  height: 13px;\n  background: #fff;\n  border-radius: 15px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.nameDisplay .user-action-panel ul li input:checked + label {\n  background: #0080A5;\n}\n.nameDisplay .user-action-panel ul li input:checked + label:after {\n  left: calc(95%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.nameDisplay .user-action-panel ul li label:active:after {\n  width: 15px;\n}\n.header-right-name {\n  color: #231f20;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100px;\n}\n.dropdown-menu {\n  border: none;\n}\n.btn .dropdown-toggle .btn-secondary {\n  padding: 7px 5px 0 7px;\n  color: #231f20;\n}\n.b-dropdown .dropdown-item:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.b-dropdown .dropdown-item:hover {\n  -webkit-box-shadow: inset 0 0 400px 110px #f5f5f5;\n          box-shadow: inset 0 0 400px 110px #f5f5f5;\n  background-color: #f5f5f5;\n}\n.dropdown-item {\n  background-color: #ffffff !important;\n  color: #231f20 !important;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: 'Open Sans', sans-serif;\n  border: none;\n  padding: 0;\n}\n.dropdown-item:focus {\n  outline: none;\n}\n.btn-group > .btn:first-child {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 10px;\n  text-align: left;\n}\n.header-dropdown-items > .dropdown-item:first-child {\n  margin-top: 7px;\n}\n.header-dropdown-items > .dropdown-item:last-child > .wrapper-item {\n  border-bottom: none;\n}\n.header-dropdown-items {\n  max-height: 203px;\n  overflow-y: scroll;\n  width: 250px;\n  min-width: 220px;\n  border-radius: 3px;\n  margin: -2px 0 0 0;\n  border: 1px solid #e6e6e6;\n  padding-bottom: 7px;\n  background-color: #fff;\n}\n.header-dropdown-items .dropdown-item-sub .wrapper-item {\n  border-bottom: 1px solid #f5f5f5;\n  height: 100%;\n  margin: 0 0 0 10px;\n  padding: 10px 0 0 10px;\n  font-family: 'Open Sans', sans-serif;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.app-header.navbar {\n  padding-right: 0;\n  height: 70px;\n}\n.app-header.navbar .navbar-brand {\n  width: 140px;\n  height: 69px;\n  padding: unset;\n  margin-right: unset;\n  border-bottom: none;\n  background-size: cover;\n}\n.app-header.navbar .dropdown-item {\n  width: 100%;\n}\n.header-middle-export-to-excel-text {\n  height: 28px;\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 14px;\n  display: inline-block;\n  margin-left: 10px;\n  margin-top: 6px;\n  float: left;\n  text-align: left;\n}\n.header-middle-export-to-excel-text:hover {\n  cursor: pointer;\n}\n.btn-logout {\n  font-family: 'Open Sans', sans-serif;\n  background-color: #ffffff;\n  color: #0080a5;\n  height: 40px;\n  border-color: #0080a5;\n  float: right;\n}\n.dropdown-toggle::after {\n  margin-top: 7px;\n  position: absolute;\n  right: 5px;\n  top: 10px;\n  color: #0080a5;\n}\n.nav-link,\n.navbar .dropdown-toggle {\n  padding: 5px 0 0 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      dropdownTitle: {},
      isShowUserAction: false,
      isReceiveEmail: true,
      listUserRole: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getUserRole: function getUserRole() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role);
    },
    userName: function userName() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.userName) || '';
    },
    userRole: function userRole() {
      return (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role).replace('_', ' ') || '').toLowerCase();
    },
    clientNameForClient: function clientNameForClient() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName);
    },
    isClientRole: function isClientRole() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client;
    },
    getAllClient: function getAllClient() {
      return this.getClientsName;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getClientsName: 'GETTERS_CLIENT_LIST',
    getEmailNotification: 'GETTER_GET_EMAIL_NOTIFICATION'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    dropdownItemClick: function dropdownItemClick(item) {
      var _this = this;

      this.selectClient(item);
      this.setListEventStatus('');
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.addOns, item.addOns);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.readOnly, item.userManageReadOnly);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId, item.id);
      this.dropdownTitle = { clientName: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName) || 'CHOOSE CLIENT' };
      var element = document.querySelector('.animated');
      element.classList.remove('fadeIn');
      setTimeout(function () {
        // this.$router.push(consts.routeDirect.clientDashboard);
        _this.$router.push({
          name: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.name,
          params: {
            clientId: item.id
          }
        });
        _this.$bus.$emit('resetGetData');
        element.classList.add('fadeIn');
      }, 500);
    },
    logout: function logout() {
      var _this2 = this;

      // NOT USE
      __WEBPACK_IMPORTED_MODULE_6__aws_amplify_auth__["a" /* default */].signOut().then(function () {
        console.log('logout');
      }).catch(function (error) {
        return console.log('error', error);
      });
      this.doLogout().then(function () {
        _this2.disconnetWM();
        return _this2.$router.go('/login');
      });
    },
    resetPassword: function resetPassword() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.resetPassword,
        data: null
      };
      this.$modal.show('eventModal', modalData);
    },
    resetSelectedClient: function resetSelectedClient() {
      if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.client) {
        this.$router.push({
          name: __WEBPACK_IMPORTED_MODULE_3__router_constants__["a" /* default */].clientDashboard.name,
          params: {
            clientId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId)
          }
        });
      } else {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId, 0);
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName, 'CHOOSE CLIENT');
        this.dropdownTitle = { clientName: 'CHOOSE CLIENT' };
        this.$router.replace(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].iconHomeForManager);
      }
    },
    openFaqModal: function openFaqModal() {
      this.$modal.show('faqModal');
    },
    manageUser: function manageUser() {
      this.$router.replace({
        name: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].viewNames.managerUsers
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    selectClient: 'ACTION_SELECT_CLIENT',
    setListEventStatus: 'ACTION_SET_LIST_EVENT_STATUS',
    exportToExcelClick: 'ACTION_EXPORT_TO_EXCEL',
    doLogout: 'ACTION_DO_LOGOUT',
    getClients: 'ACTION_GET_CLIENTS',
    changeNotification: 'ACTION_CHANGE_NOTIFICATION'
  })),
  beforeMount: function beforeMount() {
    this.getClients();
    this.dropdownTitle = { clientName: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientName) || 'CHOOSE CLIENT' };
  },
  mounted: function mounted() {
    this.isReceiveEmail = this.getEmailNotification;
  },

  watch: {
    isReceiveEmail: {
      handler: function handler() {
        this.changeNotification(this.isReceiveEmail);
      }
    }
  }
});

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "app-header navbar", attrs: { id: "app-header" } },
    [
      _c("div", { staticClass: "header-left-side" }, [
        _c(
          "div",
          {
            staticClass: "header-left-image noPaddingLeft noPaddingRight",
            on: {
              click: function($event) {
                _vm.resetSelectedClient()
              }
            }
          },
          [_c("b-link", { staticClass: "navbar-brand" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "header-middle align-center noPaddingLeft noPaddingRight"
          },
          [
            _c("div", { staticClass: "main-container" }, [
              _c("div", { staticClass: "fixer-container" }, [
                _c(
                  "div",
                  { staticClass: "display-inline-div custom-multiselect" },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.getAllClient,
                        placeholder: "Choose Client",
                        label: "clientName",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "clientName",
                        "allow-empty": true,
                        "show-labels": false,
                        disabled: _vm.isClientRole
                      },
                      on: { select: _vm.dropdownItemClick },
                      model: {
                        value: _vm.dropdownTitle,
                        callback: function($$v) {
                          _vm.dropdownTitle = $$v
                        },
                        expression: "dropdownTitle"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "display-inline-div float-right header-icon",
                  on: {
                    click: function($event) {
                      _vm.exportToExcelClick()
                    }
                  }
                },
                [
                  _c("Icon", {
                    staticClass: "header-sub-icon",
                    attrs: { name: "file-excel-o" }
                  })
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-right-text noPaddingRight noPaddingLeft" },
        [
          _c(
            "div",
            {
              staticClass: "header-icon",
              on: {
                click: function($event) {
                  _vm.openFaqModal()
                }
              }
            },
            [
              _c("Icon", {
                staticClass: "header-sub-icon",
                attrs: { name: "question-circle-o" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nameDisplay",
              on: {
                click: function($event) {
                  _vm.isShowUserAction = true
                },
                mouseleave: function($event) {
                  _vm.isShowUserAction = false
                }
              }
            },
            [
              _c("div", { staticClass: "header-right-name" }, [
                _vm._v(_vm._s(_vm.userName))
              ]),
              _vm._v(" "),
              !_vm.isClientRole
                ? _c("div", { staticClass: "header-right-position" }, [
                    _vm._v(_vm._s(_vm.userRole))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isClientRole
                ? _c("div", { staticClass: "header-right-position" }, [
                    _vm._v(_vm._s(_vm.clientNameForClient))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-action-icon" },
                [_c("Icon", { attrs: { name: "sort-down" } })],
                1
              ),
              _vm._v(" "),
              _vm.isShowUserAction
                ? _c("div", { staticClass: "user-action-panel" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.logout()
                            }
                          }
                        },
                        [_vm._v("Logout")]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.resetPassword()
                            }
                          }
                        },
                        [_vm._v("Change Password")]
                      ),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v("Email notification: "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isReceiveEmail,
                              expression: "isReceiveEmail"
                            }
                          ],
                          attrs: { type: "checkbox", id: "switch" },
                          domProps: {
                            checked: Array.isArray(_vm.isReceiveEmail)
                              ? _vm._i(_vm.isReceiveEmail, null) > -1
                              : _vm.isReceiveEmail
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isReceiveEmail,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isReceiveEmail = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isReceiveEmail = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isReceiveEmail = $$c
                              }
                            }
                          }
                        }),
                        _c("label", { attrs: { for: "switch" } }, [
                          _vm._v("Toggle")
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10970f03", esExports)
  }
}

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("AppHeader"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-body" },
        [
          _c("Sidebar"),
          _vm._v(" "),
          _c("main", { staticClass: "main" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [_c("router-view")],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("ScrollTop"),
      _vm._v(" "),
      _c("FaqModal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15eac582", esExports)
  }
}

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRelatedEvents_vue__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596bc18c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRelatedEvents_vue__ = __webpack_require__(1831);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRelatedEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596bc18c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRelatedEvents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/event/ManageRelatedEvents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManageRelatedEvents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-596bc18c", Component.options)
  } else {
    hotAPI.reload("data-v-596bc18c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_events_ManageRelatedEvents__ = __webpack_require__(823);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-detail-view',
  components: {
    ManageRelatedEvents: __WEBPACK_IMPORTED_MODULE_2__components_events_ManageRelatedEvents__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      relatedEvents: [],
      currentEvent: null,
      eventId: -1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    btnBackClick: function btnBackClick() {
      this.$router.go(-1);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getEventById: 'ACTION_GET_EVENT_BY_ID'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({})),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  mounted: function mounted() {
    var _this = this;

    if (this.$route.params.relatedEvents) {
      this.relatedEvents = this.$route.params.relatedEvents;
      this.eventId = this.$route.params.eventId;
    } else {
      this.getEventById(this.$route.params.eventId).then(function (response) {
        if (response.message === null) {
          _this.currentEvent = response.event;
          _this.eventId = response.event.id;
          _this.relatedEvents = response.event.relatedEvents;
        }
      });
    }
  },
  created: function created() {}
});

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-related-events-container margin-side" },
    [
      _c("div", { staticClass: "btn-back-wrapper" }, [
        _c("div", {
          staticClass: "btn-back icon-back",
          on: { click: _vm.btnBackClick }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-title h2-text" }, [
        _vm._v("Manage Events")
      ]),
      _vm._v(" "),
      _vm.eventId !== -1
        ? _c("ManageRelatedEvents", {
            attrs: {
              relatedEvents: _vm.relatedEvents,
              currentEvent: _vm.currentEvent,
              eventId: _vm.eventId
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-596bc18c", esExports)
  }
}

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoryDetails_vue__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b33a6c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoryDetails_vue__ = __webpack_require__(1841);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1833)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoryDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b33a6c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoryDetails_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/email/EmailHistoryDetails.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmailHistoryDetails.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b33a6c7", Component.options)
  } else {
    hotAPI.reload("data-v-2b33a6c7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1834);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("752ac0fa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b33a6c7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoryDetails.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b33a6c7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoryDetails.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_events_EmailHistoryDetails__ = __webpack_require__(1836);

//
//
//
//
//
//
//
//
//
//
//
//


// import emailTemplateConsts from '@/store/constants/emailTemplateType';
// import consts from '../../_consts';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Email-History-Details-Page',
  components: {
    EmailHistoryDetails: __WEBPACK_IMPORTED_MODULE_2__components_events_EmailHistoryDetails__["a" /* default */]
  },
  data: function data() {
    return {
      id: null,
      histories: [],
      eventId: null,
      isManageHistories: false
    };
  },

  filters: {
    filterRelatedEventsName: function filterRelatedEventsName(listRelatedEvents) {
      var result = '';
      listRelatedEvents.forEach(function (index, element) {});
      return result;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    columnWidth: 'GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    goToEventDetails: function goToEventDetails(historyId) {},
    cancelClick: function cancelClick() {
      if (this.eventId) {
        this.$router.push({ name: 'EmailHistoriesManagement', params: { eventId: this.eventId } });
      } else {
        this.$router.push({ name: 'ManagerDashboard' });
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
    sendOnSiteContactEmail: 'ACTION_SEND_ON_SITE_CONTACT_EMAIL'
  })),
  mounted: function mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id;
      this.eventId = this.$route.params.eventId;
    }
  }
});

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoryDetails_vue__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444f447e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoryDetails_vue__ = __webpack_require__(1840);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1837)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailHistoryDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444f447e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmailHistoryDetails_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/events/EmailHistoryDetails.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmailHistoryDetails.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-444f447e", Component.options)
  } else {
    hotAPI.reload("data-v-444f447e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1838);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5081c706", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-444f447e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoryDetails.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-444f447e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmailHistoryDetails.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ckeditor2__ = __webpack_require__(191);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import ModalChangeEmailTemplate from '@/components/modal/ModalChangeEmailTemplate';
// import consts from '@/_consts';



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'email-history-details',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    PrettyRadio: __WEBPACK_IMPORTED_MODULE_3_pretty_checkbox_vue_radio___default.a,
    VueCkeditor: __WEBPACK_IMPORTED_MODULE_6_vue_ckeditor2__["a" /* default */]
  },
  data: function data() {
    return {
      listEmailCC: [],
      listEmailSendTo: [],
      listReplyEmails: '',
      listHistory: [],
      replyEmail: '',
      ccEmail: '',
      recipientEmail: '',
      selectedTemplate: __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60,
      emailTemplates: [],
      emailTemplateConsts: __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */],
      id: null,
      eventId: null,
      selectedTemplateOldValue: __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60,
      historyDetails: {
        relatedEvents: []
      },
      event: {},
      config: {
        toolbar: [],
        height: 400,
        allowedContent: true,
        readOnly: true,
        removePlugins: 'elementspath, toolbar',
        resize_enabled: false
      }
    };
  },

  computed: {},
  filters: {},
  props: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    closeModalChangeMailTemplate: function closeModalChangeMailTemplate(changeTemplate) {
      if (changeTemplate) {
        this.setSelectedTemplate();
      } else {
        this.selectedTemplate = this.selectedTemplateOldValue;
      }
    },
    relatedEventItemClick: function relatedEventItemClick(eventId) {
      var url = window.location.origin + '/#/event/' + eventId;
      window.open(url, '_blank');
    },
    addReplyEmailGoTo: function addReplyEmailGoTo() {
      if (this.replyEmail === '') {
        return;
      }
      this.listReplyEmails = this.replyEmail;
      this.replyEmail = '';
    },
    ckEditorFocus: function ckEditorFocus(e) {
      this.isChangedEditor = true;
    },
    getEmailTemplate: function getEmailTemplate(isSingleEvent, isDefault) {
      var _this = this;

      this.getDefaultEmailTemplate({
        eventId: this.eventId || this.$route.params.eventId,
        isSingleEvent: isSingleEvent
      }).then(function (response) {
        _this.emailTemplates = response.templates;
        if (isDefault) {
          _this.selectedTemplate = __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60;
        }
        _this.setSelectedTemplate(isSingleEvent, false);
      });
    },
    setSelectedTemplate: function setSelectedTemplate() {
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day60) {
        this.body = this.emailTemplates[0].body;
      }
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day30) {
        this.body = this.emailTemplates[1].body;
      }
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].day7) {
        this.body = this.emailTemplates[2].body;
      }
      if (this.selectedTemplate === __WEBPACK_IMPORTED_MODULE_4__store_constants_emailTemplateType__["a" /* default */].thankyou) {
        this.body = this.emailTemplates[3].body;
      }
      this.selectedTemplateOldValue = this.selectedTemplate;
    },
    removeRecipient: function removeRecipient(email) {
      var index = this.listEmailSendTo.indexOf(email);
      if (index >= 0) {
        this.listEmailSendTo.splice(index, 1);
      }
    },
    removeRecipientCC: function removeRecipientCC(email) {
      var index = this.listEmailCC.indexOf(email);
      if (index >= 0) {
        this.listEmailCC.splice(index, 1);
      }
    },
    goToEmailHistoryDetails: function goToEmailHistoryDetails(id) {
      // GO to email detail
      this.$router.push({ name: 'EmailHistoryDetailsManagement',
        params: {
          id: id,
          eventId: this.eventId
        }
      });
    },
    viewAllMailHistories: function viewAllMailHistories() {
      this.$router.push({ name: 'EmailHistoriesManagement', params: { eventId: this.eventId } });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getEmailHistoryDetails: 'ACTION_GET_EMAIL_HISTORY_DETAILS'
  })),
  watch: {},
  created: function created() {
    var _this2 = this;

    if (this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id;
      this.eventId = this.$route.params.eventId;
      this.getEmailHistoryDetails(this.id).then(function (response) {
        _this2.historyDetails = response.historyDetail;
        _this2.listEmailSendTo = response.historyDetail.recipients === '' ? [] : response.historyDetail.recipients.split(',');
        _this2.listEmailCC = response.historyDetail.additionalRecipients === '' ? [] : response.historyDetail.additionalRecipients.split(',');
        _this2.listReplyEmails = response.historyDetail.senderEmail === '' ? [] : response.historyDetail.senderEmail.split(',');
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-history-details-body" }, [
    _c("div", { staticClass: "choose-event-wrapper row" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Event Type")]),
        _vm._v(" "),
        _c("div", { staticClass: "event-type" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.historyDetails.singleEvent == true
                  ? "Single Event"
                  : "Related Event (" +
                      _vm.historyDetails.relatedEvents.length +
                      " events)"
              ) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5" }, [
        _c("div", { staticClass: "h4-text" }, [_vm._v("Events")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "group-related-events" },
          _vm._l(_vm.historyDetails.relatedEvents, function(reEvent) {
            return _c(
              "div",
              { key: reEvent.id, staticClass: "related-event-item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "event-name",
                    on: {
                      click: function($event) {
                        _vm.relatedEventItemClick(reEvent.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(reEvent.eventName))]
                )
              ]
            )
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recipients-wrapper row" }, [
      _c("div", { staticClass: "recipients-section col-md-8" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Recipients (To)")]),
        _vm._v(" "),
        _c("div", { staticClass: "list-email-recipient" }, [
          _c("div", { staticClass: "list-email-send-to" }, [
            _vm.listEmailSendTo.length == 0
              ? _c("div", { staticClass: "body-text" }, [
                  _vm._v("\n            N/A\n          ")
                ])
              : _c(
                  "div",
                  _vm._l(_vm.listEmailSendTo, function(e) {
                    return _c("div", { key: e, staticClass: "email-item" }, [
                      _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))])
                    ])
                  })
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cc-section col-md-4" }, [
        _c("div", { staticClass: "h3-text" }, [
          _vm._v("Additional Recipients (CC)")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-email-recipient" }, [
          _c("div", { staticClass: "list-email-send-to" }, [
            _vm.listEmailCC.length == 0
              ? _c("div", { staticClass: "body-text" }, [
                  _vm._v("\n            N/A\n          ")
                ])
              : _c(
                  "div",
                  _vm._l(_vm.listEmailCC, function(e) {
                    return _c("div", { key: e, staticClass: "email-item" }, [
                      _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))])
                    ])
                  })
                )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email-template-wrapper" }, [
      _c("div", { staticClass: "choose-email-template" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Email Template")]),
        _vm._v(" "),
        _c("div", { staticClass: "template-value body-text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("templateName")(_vm.historyDetails.templateType)) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "email-body-section" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Email Body")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row email-body-container ck-for-email-history-detail"
          },
          [
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c("vue-ckeditor", {
                  attrs: { config: _vm.config },
                  on: { focus: _vm.ckEditorFocus },
                  model: {
                    value: _vm.historyDetails.templateBody,
                    callback: function($$v) {
                      _vm.$set(_vm.historyDetails, "templateBody", $$v)
                    },
                    expression: "historyDetails.templateBody"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "reply-and-history-section col-md-4" }, [
              _c("div", { staticClass: "reply-emails-wrapper" }, [
                _c("div", { staticClass: "h4-text" }, [
                  _vm._v("Reply emails go to:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-email-recipient" }, [
                  _c("div", { staticClass: "list-email-send-to" }, [
                    _vm.listReplyEmails.length == 0
                      ? _c("div", { staticClass: "body-text" }, [_vm._v("N/A")])
                      : _c(
                          "div",
                          _vm._l(_vm.listReplyEmails, function(e) {
                            return _c(
                              "div",
                              { key: e, staticClass: "email-item" },
                              [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(_vm._s(e))
                                ])
                              ]
                            )
                          })
                        )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-444f447e", esExports)
  }
}

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-history-details-container margin-side" },
    [
      _c("div", { staticClass: "btn-back-wrapper" }, [
        _c("div", {
          staticClass: "btn-back icon-back",
          on: { click: _vm.cancelClick }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-title h2-text" }, [
        _vm._v("Email - Detailed View")
      ]),
      _vm._v(" "),
      _c("div", [_c("EmailHistoryDetails", { attrs: { id: _vm.id } })], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b33a6c7", esExports)
  }
}

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663b187a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(1850);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1843)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-663b187a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663b187a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/ResetPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResetPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-663b187a", Component.options)
  } else {
    hotAPI.reload("data-v-663b187a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1844);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2e294e3d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-663b187a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ResetPassword.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-663b187a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ResetPassword.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.loginContainer[data-v-663b187a] {\n  height: 100vh;\n  background-color: #0080a5;\n}\n.loginContainer .login-content[data-v-663b187a] {\n  position: absolute;\n  top: 25%;\n}\n.loginContainer .wellmetrics-event-pl[data-v-663b187a] {\n  height: 29px;\n  color: #ffffff;\n  font-family: Arquitecta, sans-serif;\n  font-size: 27px;\n  font-weight: bold;\n  width: 100%;\n  text-align: center;\n}\n.loginContainer .labelText[data-v-663b187a] {\n  margin-top: 10px;\n  width: 30%;\n}\n.loginContainer .subText[data-v-663b187a] {\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  color: #ffffff;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.loginContainer .formInput[data-v-663b187a] {\n  background-color: #ffffff;\n  height: 255px;\n  width: 575px;\n  border-radius: 5px;\n  padding: 55px 50px 35px 50px;\n  margin: auto;\n}\n.loginContainer .formInput .form-title[data-v-663b187a] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 0;\n}\n.loginContainer .inputText[data-v-663b187a] {\n  margin: 25px 0 0 0;\n}\n.loginContainer .inputText .input-wrapper[data-v-663b187a] {\n  width: 70%;\n}\n.loginContainer .inputText .input-wrapper label[data-v-663b187a] {\n  width: 100%;\n}\n.loginContainer .submitButton[data-v-663b187a] {\n  float: right;\n  margin-top: 15px;\n  background-color: #0080a5;\n  color: #ffffff;\n}\n.loginContainer .btn-reset-password[data-v-663b187a] {\n  float: right;\n  margin-top: 15px;\n  background-color: #0080a5;\n  color: #ffffff;\n  padding: 7px 25px 10px 25px;\n}\n.loginContainer .forgotPassword[data-v-663b187a] {\n  margin-top: 20px;\n}\n.loginContainer .loginContainer[data-v-663b187a] {\n  height: 100%;\n}\n.loginContainer .form-signin[data-v-663b187a] {\n  padding: 15px;\n  margin: 0 auto;\n}\n.loginContainer .footerForm[data-v-663b187a] {\n  margin-top: 25px;\n}\n.loginContainer .form-signin .form-signin-heading[data-v-663b187a],\n.loginContainer .form-signin .checkbox[data-v-663b187a] {\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 20px;\n}\n.loginContainer .form-signin .checkbox[data-v-663b187a] {\n  font-weight: normal;\n}\n.loginContainer .form-signin .form-control[data-v-663b187a] {\n  position: relative;\n  height: auto;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  font-size: 16px;\n  border-radius: 5px;\n  background-color: #ffffff;\n}\n.loginContainer .form-signin .form-control[data-v-663b187a]:focus {\n  z-index: 2;\n}\n.loginContainer .success-reset-password[data-v-663b187a] {\n  padding-top: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_LoginHeader__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resetPassword',
  components: {
    LoginHeader: __WEBPACK_IMPORTED_MODULE_1__login_LoginHeader__["a" /* default */]
  },
  data: function data() {
    return {
      email: null,
      submitData: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    getIsError: 'GETTERS_IS_ERROR',
    getErrorMessage: 'GETTERS_ERROR_MESSAGE',
    getIsResetPassword: 'GETTERS_IS_RESET_PASSWORD_SUCCESS',
    getIsSubmitted: 'GETTERS_IS_SUBMITTED'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    resetPassword: function resetPassword() {
      this.doResetPassword(this.email);
    },
    backToLoginPage: function backToLoginPage() {
      this.$router.push('/login');
      this.setIsRequestPasswordSuccess(false);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    setIsRequestPasswordSuccess: 'ACTION_SET_RESET_PASSWORD',
    doResetPassword: 'ACTION_RESET_PASSWORD'
  }))
});

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1847);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("585eb8db", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e30d620\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginHeader.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e30d620\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginHeader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n@media screen and (max-width: 610px) {\n.col-md-6 {\n    width: 260px;\n}\n}\n.header-left-image {\n  width: auto;\n  min-width: 103px;\n}\n.app-header.navbar .navbar-brand {\n  width: 135px;\n  height: 69px;\n  padding: unset;\n  margin-right: unset;\n  border-bottom: none;\n  background-size: cover;\n}\n", ""]);

// exports


/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-login-header',
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "app-header navbar", attrs: { id: "app-header" } },
    [
      _c(
        "div",
        { staticClass: "col-md-3 header-left-image" },
        [_c("b-link", { staticClass: "navbar-brand" })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e30d620", esExports)
  }
}

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loginContainer" },
    [
      _c("LoginHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "login-content outer-container" }, [
        _c(
          "form",
          {
            staticClass: "form-signin inner-container",
            attrs: { id: "form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.resetPassword(_vm.email)
              }
            }
          },
          [
            _c("div", { staticClass: "wellmetrics-event-pl" }, [
              _vm._v("WELLMETRICS EVENT PLANNER")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "subText" }, [
              _vm._v(
                "Create, request and schedule biometric screening events with ADURO"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formInput" }, [
              _c("div", [
                !_vm.getIsResetPassword
                  ? _c("div", { staticClass: "form-title" }, [
                      _vm._v(
                        "\n            Enter your email to reset your password.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getIsResetPassword
                  ? _c("div", { staticClass: "form-title" }, [
                      _vm._v(
                        "\n            A reset password has been requested. Check your email.\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row inputText" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    !_vm.getIsResetPassword
                      ? _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email,
                                expression: "email"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "email",
                              required: "",
                              autofocus: ""
                            },
                            domProps: { value: _vm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.email = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getIsResetPassword
                      ? _c("label", { staticClass: "success-reset-password" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.email) +
                              "\n              "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row footerForm" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-9 forgotPassword" },
                    [
                      !_vm.getIsResetPassword
                        ? _c("router-link", { attrs: { to: "/login" } }, [
                            _c("a", { attrs: { href: "#" } }, [
                              _vm._v("Back to Login")
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    !_vm.getIsResetPassword
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-reset-password",
                            attrs: {
                              type: "submit",
                              disabled: _vm.getIsSubmitted
                            }
                          },
                          [_vm._v("Reset password")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getIsResetPassword
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-reset-password",
                            on: {
                              click: function($event) {
                                _vm.backToLoginPage()
                              }
                            }
                          },
                          [_vm._v("Done")]
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.getIsError
                ? _c("div", { staticClass: "row text-center alert-danger" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getErrorMessage) +
                          "\n          "
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("Email address")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-663b187a", esExports)
  }
}

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdatePassword_vue__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1dee778_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UpdatePassword_vue__ = __webpack_require__(1855);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1852)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1dee778"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdatePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1dee778_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UpdatePassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/UpdatePassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UpdatePassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f1dee778", Component.options)
  } else {
    hotAPI.reload("data-v-f1dee778", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1853);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("f1ba21f0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f1dee778\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UpdatePassword.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f1dee778\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UpdatePassword.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.loginContainer[data-v-f1dee778] {\n  height: 100vh;\n  background-color: #0080a5;\n}\n.loginContainer .login-content[data-v-f1dee778] {\n  position: absolute;\n  top: 25%;\n}\n.loginContainer .wellmetrics-event-pl[data-v-f1dee778] {\n  height: 29px;\n  color: #ffffff;\n  font-family: Arquitecta, sans-serif;\n  font-size: 27px;\n  font-weight: bold;\n  width: 100%;\n  text-align: center;\n}\n.loginContainer .labelText[data-v-f1dee778] {\n  margin-top: 10px;\n  width: 30%;\n}\n.loginContainer .subText[data-v-f1dee778] {\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  color: #ffffff;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.loginContainer .formInput[data-v-f1dee778] {\n  background-color: #ffffff;\n  width: 575px;\n  border-radius: 5px;\n  padding: 55px 50px 35px 50px;\n  margin: auto;\n}\n.loginContainer .formInput .form-title[data-v-f1dee778] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 0;\n}\n.loginContainer .inputText[data-v-f1dee778] {\n  margin: 15px 0 0 0;\n}\n.loginContainer .inputText .input-wrapper[data-v-f1dee778] {\n  width: 70%;\n}\n.loginContainer .inputText .input-wrapper label[data-v-f1dee778] {\n  width: 100%;\n}\n.loginContainer .submitButton[data-v-f1dee778] {\n  float: right;\n  margin-top: 15px;\n  background-color: #0080a5;\n  color: #ffffff;\n}\n.loginContainer .btn-reset-password[data-v-f1dee778] {\n  float: right;\n  margin-top: 15px;\n  background-color: #0080a5;\n  color: #ffffff;\n  padding: 7px 25px 10px 25px;\n}\n.loginContainer .forgotPassword[data-v-f1dee778] {\n  margin-top: 20px;\n}\n.loginContainer .loginContainer[data-v-f1dee778] {\n  height: 100%;\n}\n.loginContainer .form-signin[data-v-f1dee778] {\n  padding: 15px;\n  margin: 0 auto;\n}\n.loginContainer .footerForm[data-v-f1dee778] {\n  margin-top: 0;\n}\n.loginContainer .form-signin .form-signin-heading[data-v-f1dee778],\n.loginContainer .form-signin .checkbox[data-v-f1dee778] {\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 20px;\n}\n.loginContainer .form-signin .checkbox[data-v-f1dee778] {\n  font-weight: normal;\n}\n.loginContainer .form-signin .form-control[data-v-f1dee778] {\n  position: relative;\n  height: auto;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  font-size: 16px;\n  border-radius: 5px;\n  background-color: #ffffff;\n}\n.loginContainer .form-signin .form-control[data-v-f1dee778]:focus {\n  z-index: 2;\n}\n.loginContainer .errorBackground[data-v-f1dee778] {\n  width: auto;\n  height: 21px;\n  margin-top: 1px;\n}\n.loginContainer .errorDetail[data-v-f1dee778] {\n  height: 17px;\n  width: 108px;\n  color: #803939;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 17px;\n  text-align: right;\n  margin-left: 5px;\n}\n.loginContainer .errorBackgroundColor[data-v-f1dee778] {\n  background-color: #FEE2E2;\n}\n", ""]);

// exports


/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_LoginHeader__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_validator__ = __webpack_require__(372);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'updatePassword',
  components: {
    LoginHeader: __WEBPACK_IMPORTED_MODULE_2__login_LoginHeader__["a" /* default */]
  },
  data: function data() {
    return {
      newPassword: null,
      reNewPassword: null,
      submitData: null,
      validatedFields: [],
      isPasswordContainsNumber: true,
      isDisabled: true,
      passwordCheckList: {
        length: false,
        lowerCaseChars: false,
        upperCaseChars: false,
        numbers: false,
        specialChars: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    token: function token() {
      return this.$route.params.token;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getValidToken: 'GETTERS_GET_VALID_TOKEN',
    getLoginEmail: 'GETTERS_GET_LOGIN_EMAIL'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    validateInput: function validateInput(field) {
      var _this = this;

      if (!this.validatedFields.includes(field)) {
        this.validatedFields.push(field);
      }
      var atLeastNumber = new RegExp(/\d/);
      this.$validator.validate().then(function (result) {
        if (_this.validatedFields.includes('newPassword')) {
          _this.isPasswordContainsNumber = atLeastNumber.test(_this.newPassword);
        } else {
          _this.isPasswordContainsNumber = true;
        }

        var pwRuleValidate = __WEBPACK_IMPORTED_MODULE_6__utils_validator__["a" /* default */].isPasswordValid(_this.newPassword);
        _this.passwordCheckList = pwRuleValidate.detail;

        if (result && pwRuleValidate.summary) {
          _this.isDisabled = !atLeastNumber.test(_this.reNewPassword);
        } else {
          _this.isDisabled = true;
        }
      });
    },

    updatePassword: function updatePassword() {
      var _this2 = this;

      if (this.newPassword !== this.reNewPassword) {
        this.$toastr('error', 'New password is NOT matched!', '');
      } else {
        var isForceResetPassword = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.isForceResetPassword) || false;
        var userId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.userId);
        this.doUpdatePassword({ newPassword: this.newPassword, token: this.token, isForceResetPassword: isForceResetPassword, userId: userId }).then(function () {
          if (_this2.getValidToken) {
            // login
            _this2.doLogin({ username: _this2.getLoginEmail, password: _this2.newPassword }).then(function () {
              _this2.$router.push('/login');
            });
          }
        });
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    doUpdatePassword: 'ACTION_UPDATE_PASSWORD',
    checkToken: 'ACTION_CHECK_TOKEN',
    doLogin: 'ACTION_DO_LOGIN'
  })),
  mounted: function mounted() {
    var _this3 = this;

    var isForceResetPassword = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.isForceResetPassword) === 'true';
    if (this.token !== 'force-reset-password') {
      this.checkToken(this.token).then(function () {
        if (!_this3.getValidToken && !isForceResetPassword) {
          _this3.$router.push('/login');
        }
      });
    }
  },

  watch: {
    'newPassword': {
      handler: function handler() {
        this.passwordCheckList = __WEBPACK_IMPORTED_MODULE_6__utils_validator__["a" /* default */].isPasswordValid(this.newPassword).detail;
      }
    }
  }
});

/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loginContainer" },
    [
      _c("LoginHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "login-content outer-container" }, [
        _c(
          "form",
          {
            staticClass: "form-signin inner-container",
            attrs: { id: "form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.updatePassword()
              }
            }
          },
          [
            _c("div", { staticClass: "wellmetrics-event-pl" }, [
              _vm._v("WELLMETRICS EVENT PLANNER")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "subText" }, [
              _vm._v(
                "Create, request and schedule biometric screening events with ADURO"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formInput" }, [
              _c("div", [
                _c("div", { staticClass: "form-title" }, [
                  _vm._v(
                    "\n            Enter your new password to reset.\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row inputText" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newPassword,
                            expression: "newPassword"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          "data-vv-as": "new password",
                          name: "newPassword"
                        },
                        domProps: { value: _vm.newPassword },
                        on: {
                          blur: function($event) {
                            _vm.validateInput("newPassword")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newPassword = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "errorBackground",
                        class: {
                          errorBackgroundColor:
                            (_vm.errors.has("newPassword") &&
                              _vm.validatedFields.includes("newPassword")) ||
                            !_vm.isPasswordContainsNumber
                        }
                      },
                      [
                        _vm.validatedFields.includes("newPassword")
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.first("newPassword"),
                                    expression: "errors.first('newPassword')"
                                  }
                                ],
                                staticClass: "errorDetail"
                              },
                              [_vm._v(_vm._s(_vm.errors.first("newPassword")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isPasswordContainsNumber &&
                        !_vm.errors.has("newPassword")
                          ? _c("span", { staticClass: "errorDetail" }, [
                              _vm._v(
                                "The New password must contains at least 1 digit"
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row inputText" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.reNewPassword,
                            expression: "reNewPassword"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              confirmed: _vm.newPassword
                            },
                            expression:
                              "{ required: true, confirmed: newPassword }"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          "data-vv-as": "password",
                          name: "repeatPassword"
                        },
                        domProps: { value: _vm.reNewPassword },
                        on: {
                          blur: function($event) {
                            _vm.validateInput("repeatPassword")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.reNewPassword = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "errorBackground",
                        class: {
                          errorBackgroundColor:
                            _vm.errors.has("repeatPassword") &&
                            _vm.validatedFields.includes("repeatPassword")
                        }
                      },
                      [
                        _vm.validatedFields.includes("repeatPassword")
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("repeatPassword"),
                                    expression: "errors.has('repeatPassword')"
                                  }
                                ],
                                staticClass: "errorDetail"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("repeatPassword"))
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "password-check-list" }, [
                  _c("div", { staticClass: "password-at-least" }, [
                    _vm._v("Password must have at least:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "indicators-password row" }, [
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.length
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("8 characters ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.lowerCaseChars
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("4 lowercase letters (a-z)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.upperCaseChars
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("1 uppercase letter (A-Z)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.numbers
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("2 numbers (0-9)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-item col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-wrapper",
                          style: _vm.hiddenIconPasswordIndicator
                        },
                        [
                          _vm.passwordCheckList.specialChars
                            ? _c("div", { staticClass: "icon-reach" })
                            : _c("div", { staticClass: "icon-unreach" })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("1 special character")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row footerForm" }, [
                  _c("div", { staticClass: "col-md-9 forgotPassword" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-reset-password",
                        attrs: { type: "submit", disabled: _vm.isDisabled }
                      },
                      [_vm._v("Update password")]
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("New password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("New password again")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f1dee778", esExports)
  }
}

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d349c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1865);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1857)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d349c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/dashboard/Dashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33d349c9", Component.options)
  } else {
    hotAPI.reload("data-v-33d349c9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1858);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d2ebbc34", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33d349c9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33d349c9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dash__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderDash__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DashCards__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_event_EventDetailModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_email_ManageEmail__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_email_EmailHistoriesManagement__ = __webpack_require__(193);

//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    SubHeaderDash: __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderDash__["a" /* default */],
    DashCards: __WEBPACK_IMPORTED_MODULE_3__components_DashCards__["a" /* default */],
    EventDetailModal: __WEBPACK_IMPORTED_MODULE_4__components_modal_event_EventDetailModal__["a" /* default */],
    ManageEmailModal: __WEBPACK_IMPORTED_MODULE_5__views_email_ManageEmail__["a" /* default */],
    EmailHistoriesManagement: __WEBPACK_IMPORTED_MODULE_7__views_email_EmailHistoriesManagement__["a" /* default */]
  },
  data: function data() {
    return {
      dashboardCards: __WEBPACK_IMPORTED_MODULE_1__dash__["a" /* default */].items
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    getEventCount: 'ACTION_GET_EVENT_COUNT'
  })),
  beforeMount: function beforeMount() {
    this.getEventCount();
  }
});

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderDash_vue__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617c1920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderDash_vue__ = __webpack_require__(1864);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1861)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderDash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617c1920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderDash_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderDash.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderDash.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-617c1920", Component.options)
  } else {
    hotAPI.reload("data-v-617c1920", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1862);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7f96af7e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-617c1920\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderDash.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-617c1920\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderDash.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderDash',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "subHeader" }, [
      _c("div", { staticClass: "content-header" }, [_vm._v("DASHBOARD")]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _vm._v("Quick stats about your events.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-617c1920", esExports)
  }
}

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderDash"),
      _vm._v(" "),
      _c("DashCards", { attrs: { dashItems: _vm.dashboardCards } }),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33d349c9", esExports)
  }
}

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drafts_vue__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287dfa9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Drafts_vue__ = __webpack_require__(1880);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1867)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drafts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287dfa9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Drafts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Drafts.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Drafts.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-287dfa9c", Component.options)
  } else {
    hotAPI.reload("data-v-287dfa9c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1868);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9fcea822", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-287dfa9c\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Drafts.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-287dfa9c\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Drafts.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.textHeader {\n  height: 17px;\n  width: 37px;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 10px;\n  line-height: 17px;\n}\ntbody {\n  background-color: #ffffff;\n}\n.table thead th {\n  height: 37px;\n  background-color: #231F20;\n}\ntable.b-table tfoot>tr>.sorting:after,\ntable.b-table tfoot>tr>.sorting:before,\ntable.b-table thead>tr>.sorting:after,\ntable.b-table thead>tr>.sorting:before {\n  background-color: #ffffff;\n}\ntable.b-table>tfoot>tr>.sorting:after,\ntable.b-table>thead>tr>.sorting:after {\n  background-color: #ffffff;\n}\n", ""]);

// exports


/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_subHeaders_SubHeaderDraft__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drafts',
  components: {
    SubHeaderDraft: __WEBPACK_IMPORTED_MODULE_3__components_subHeaders_SubHeaderDraft__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_4__components_datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].items,
      userRole: __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].currentUser.role,
      currentPage: 1,
      perPage: 5,
      totalRows: __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].items.length,
      pageOptions: [{ text: 5, value: 5 }, { text: 10, value: 10 }, { text: 15, value: 15 }],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      eventStatus: __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].EVENT_TYPES.drafts.text
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    enableSubHeaderDraft: function enableSubHeaderDraft() {
      var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.userRole === 'user' || enable === true) {
        return true;
      }
      return false;
    },
    editable: function editable() {
      // userRole = localStorage.getItem(consts.LOCAL_STORE.role);
      return true;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    getFlagCreateEvent: 'GETTERS_CREATE_EVENT_FLAG',
    submitAllEventSuccess: 'GETTERS_SUBMIT_ALL_EVENT_SUCCESS'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    details: function details(item, index, button) {
      this.modalDetails.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    },
    resetModal: function resetModal() {
      this.modalDetails.data = '';
      this.modalDetails.index = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    createNewEvent: 'ACTION_CREATE_NEW_EVENT',
    setShowModalSubmitAllEventSuccess: 'ACTION_SET_SUBMIT_ALL_EVENT_SUCCESS',
    setExpandId: 'ACTION_SET_EXPAND_ID'
  })),
  watch: {
    getFlagCreateEvent: {
      handler: function handler() {
        if (this.getFlagCreateEvent === true) {
          this.createNewEvent();
          this.setExpandId({ id: 0, isExpand: true });
        }
      },
      deep: true
    },
    submitAllEventSuccess: {
      handler: function handler() {
        if (this.submitAllEventSuccess === false) {
          var modalData = {
            action: __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].modalAction.submitAllEventError,
            data: null
          };
          this.$modal.show('eventModal', modalData);
          this.setShowModalSubmitAllEventSuccess(true);
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderDraft_vue__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ca3afa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderDraft_vue__ = __webpack_require__(1879);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1871)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderDraft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ca3afa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderDraft_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderDraft.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderDraft.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07ca3afa", Component.options)
  } else {
    hotAPI.reload("data-v-07ca3afa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2a72f044", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07ca3afa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderDraft.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07ca3afa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderDraft.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.group-button-sub-header {\n  float: right;\n  top: 120px;\n  margin: 65px 20px 0 0;\n}\n.float-left {\n  float: left;\n}\n.float-right {\n  float: right;\n}\n", ""]);

// exports


/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_ButtonCreateNewEvent__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_plus_circle__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_plus__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderDraft',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  },
  components: {
    ButtonCreateNewEvent: __WEBPACK_IMPORTED_MODULE_0__commons_ButtonCreateNewEvent__["a" /* default */]
  },
  data: function data() {
    return {
      btnCreateEvent: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].subHeaderBtn.createNewEvent,
      btnSubmitAllEvent: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].subHeaderBtn.submitAllEvent
    };
  }
});

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonCreateNewEvent_vue__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0e2c79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonCreateNewEvent_vue__ = __webpack_require__(1878);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1875)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonCreateNewEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0e2c79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonCreateNewEvent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/commons/ButtonCreateNewEvent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ButtonCreateNewEvent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b0e2c79", Component.options)
  } else {
    hotAPI.reload("data-v-4b0e2c79", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b03ad57c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b0e2c79\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonCreateNewEvent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b0e2c79\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonCreateNewEvent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.btn-new-event {\n  height: 26px;\n  margin-left: 15px;\n}\n.btn-new-event:hover {\n  cursor: pointer;\n}\n.btn-new-event .btn-new-event-wrapper-icon {\n  height: 25px;\n  width: 25px;\n  float: left;\n  border: 2px solid #0080a5;\n  border-radius: 50px ;\n  position: relative;\n  top: -3px;\n}\n.btn-new-event .btn-new-event-wrapper-icon .btn-new-event-icon {\n  color: #0080a5;\n  position: relative;\n  top: 2px;\n  right: -7px;\n}\n.btn-new-event .btn-new-event-wrapper-icon .new-event-icon {\n  top: 3px;\n  right: -4px;\n}\n.btn-new-event .btn-new-event-text {\n  height: 17px;\n  width: 68px;\n  font-size: 14px;\n  font-weight: 600;\n  top: -4px;\n  margin: 0 0 0 10px;\n}\n.btn-new-event .btn-new-event-text .span-btn-text {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_plus__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_angle_double_right__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'button-sub-header-right',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    btnClick: function btnClick() {
      if (this.item.name === __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].subHeaderBtn.createNewEvent.name) {
        this.createNewEventClick();
        this.setExpandId({ id: 0, isExpand: true });
      }
      if (this.item.name === __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].subHeaderBtn.submitAllEvent.name) {
        var modalData = {
          action: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].LOCAL_STORE.readOnly) === 'true' ? __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].modalAction.readOnly : __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].modalAction.submitEvent,
          data: { eventName: 'all event' }
        };
        this.$modal.show('eventModal', modalData);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    createNewEventClick: 'ACTION_CREATE_NEW_EVENT',
    setExpandId: 'ACTION_SET_EXPAND_ID'
  }))
});

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-new-event",
      on: {
        click: function($event) {
          _vm.btnClick()
        }
      }
    },
    [
      _c(
        "span",
        { staticClass: "btn-new-event-wrapper-icon" },
        [
          _c("Icon", {
            staticClass: "btn-new-event-icon",
            class: ["CreateEvent" == _vm.item.name ? "new-event-icon" : ""],
            attrs: { name: _vm.item.iconName }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("a", { staticClass: "btn-new-event-text" }, [
        _c("span", { staticClass: "span-btn-text" }, [
          _vm._v(_vm._s(_vm.item.btnText))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b0e2c79", esExports)
  }
}

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "subHeader" }, [
    _c("div", { staticClass: "content-header" }, [_vm._v("DRAFTS")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group-button-sub-header" },
      [
        _c("ButtonCreateNewEvent", {
          staticClass: "float-left",
          attrs: { item: _vm.btnSubmitAllEvent }
        }),
        _vm._v(" "),
        _c("ButtonCreateNewEvent", {
          staticClass: "float-right",
          attrs: { item: _vm.btnCreateEvent }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-body" }, [
      _c("a", [
        _vm._v(" Create new events and submit them to ADURO for approval. ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07ca3afa", esExports)
  }
}

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderDraft"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: { editable: _vm.editable, eventStatus: _vm.eventStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-287dfa9c", esExports)
  }
}

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archived_vue__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e549da2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Archived_vue__ = __webpack_require__(1890);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1882)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Archived_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e549da2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Archived_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Archived.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Archived.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e549da2", Component.options)
  } else {
    hotAPI.reload("data-v-7e549da2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1883);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2b2517d0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7e549da2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Archived.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7e549da2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Archived.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.textHeader {\n  height: 17px;\n  width: 37px;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 10px;\n  line-height: 17px;\n}\ntbody {\n  background-color: #ffffff;\n}\n.table thead th {\n  height: 37px;\n  background-color: #231F20;\n}\ntable.b-table tfoot>tr>.sorting:after,\ntable.b-table tfoot>tr>.sorting:before,\ntable.b-table thead>tr>.sorting:after,\ntable.b-table thead>tr>.sorting:before {\n  background-color: #ffffff;\n}\ntable.b-table>tfoot>tr>.sorting:after,\ntable.b-table>thead>tr>.sorting:after {\n  background-color: #ffffff;\n}\n", ""]);

// exports


/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderArchive__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__ = __webpack_require__(74);

//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'archived',
  components: {
    SubHeaderArchive: __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderArchive__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items,
      currentPage: 1,
      perPage: 5,
      totalRows: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items.length,
      pageOptions: [{ text: 5, value: 5 }, { text: 10, value: 10 }, { text: 15, value: 15 }],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' }
    };
  },

  methods: {
    details: function details(item, index, button) {
      this.modalDetails.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    },
    resetModal: function resetModal() {
      this.modalDetails.data = '';
      this.modalDetails.index = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
});

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderArchive_vue__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631b72b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderArchive_vue__ = __webpack_require__(1889);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1886)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderArchive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631b72b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderArchive_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderArchive.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderArchive.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-631b72b8", Component.options)
  } else {
    hotAPI.reload("data-v-631b72b8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1887);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0e4cf7b0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-631b72b8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderArchive.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-631b72b8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderArchive.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderArchive',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "subHeader" }, [
      _c("div", { staticClass: "content-header" }, [_vm._v("ARCHIVE")]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _vm._v("Events that have taken place are automatically moved here.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-631b72b8", esExports)
  }
}

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderArchive"),
      _vm._v(" "),
      _c("DataTable", { attrs: { eventStatus: "archived" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e549da2", esExports)
  }
}

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approved_vue__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138d4c12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Approved_vue__ = __webpack_require__(1900);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1892)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approved_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138d4c12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Approved_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Approved.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Approved.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-138d4c12", Component.options)
  } else {
    hotAPI.reload("data-v-138d4c12", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("573998d0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-138d4c12\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Approved.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-138d4c12\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Approved.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.textHeader {\n  height: 17px;\n  width: 37px;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 10px;\n  line-height: 17px;\n}\ntbody {\n  background-color: #ffffff;\n}\n.table thead th {\n  height: 37px;\n  background-color: #231F20;\n}\ntable.b-table tfoot>tr>.sorting:after,\ntable.b-table tfoot>tr>.sorting:before,\ntable.b-table thead>tr>.sorting:after,\ntable.b-table thead>tr>.sorting:before {\n  background-color: #ffffff;\n}\ntable.b-table>tfoot>tr>.sorting:after,\ntable.b-table>thead>tr>.sorting:after {\n  background-color: #ffffff;\n}\n.eventName {\n  height: 18px;\n  width: 106px;\n  color: #0080A5;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n}\n", ""]);

// exports


/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderApprove__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__ = __webpack_require__(74);

//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'approved',
  components: {
    SubHeaderApprove: __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderApprove__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items,
      isCollapsed: false,
      currentPage: 1,
      perPage: 5,
      totalRows: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items.length,
      pageOptions: [{ text: 5, value: 5 }, { text: 10, value: 10 }, { text: 15, value: 15 }],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' }
    };
  },

  methods: {
    details: function details(item, index, button) {
      this.modalDetails.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    },
    resetModal: function resetModal() {
      this.modalDetails.data = '';
      this.modalDetails.index = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleCollapse: function toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
});

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderApprove_vue__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ceba8a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderApprove_vue__ = __webpack_require__(1899);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1896)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderApprove_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ceba8a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderApprove_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderApprove.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderApprove.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8ceba8a2", Component.options)
  } else {
    hotAPI.reload("data-v-8ceba8a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1897);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("fe757198", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8ceba8a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderApprove.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8ceba8a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderApprove.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderApprove',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "subHeader" }, [
      _c("div", { staticClass: "content-header" }, [_vm._v("APPROVED")]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _vm._v("Events that have been approved and scheduled.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8ceba8a2", esExports)
  }
}

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderApprove"),
      _vm._v(" "),
      _c("DataTable", { attrs: { eventStatus: "approved" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-138d4c12", esExports)
  }
}

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d2c7d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__ = __webpack_require__(1910);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1902)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d2c7d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Review.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Review.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69d2c7d0", Component.options)
  } else {
    hotAPI.reload("data-v-69d2c7d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1903);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7bd7817c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69d2c7d0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Review.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69d2c7d0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Review.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.textHeader {\n  height: 17px;\n  width: 37px;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 10px;\n  line-height: 17px;\n}\ntbody {\n  background-color: #ffffff;\n}\n.table thead th {\n  height: 37px;\n  background-color: #231F20;\n}\ntable.b-table tfoot>tr>.sorting:after,\ntable.b-table tfoot>tr>.sorting:before,\ntable.b-table thead>tr>.sorting:after,\ntable.b-table thead>tr>.sorting:before {\n  background-color: #ffffff;\n}\ntable.b-table>tfoot>tr>.sorting:after,\ntable.b-table>thead>tr>.sorting:after {\n  background-color: #ffffff;\n}\n", ""]);

// exports


/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderReview__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'review',
  components: {
    SubHeaderReview: __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderReview__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items,
      currentPage: 1,
      perPage: 5,
      totalRows: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items.length,
      pageOptions: [{ text: 5, value: 5 }, { text: 10, value: 10 }, { text: 15, value: 15 }],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' }
    };
  },

  methods: {
    details: function details(item, index, button) {
      this.modalDetails.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    },
    resetModal: function resetModal() {
      this.modalDetails.data = '';
      this.modalDetails.index = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },
  computed: {
    editable: function editable() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.role) !== __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.eventManager && !(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.readOnly) === 'true');
    }
  }
});

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderReview_vue__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a42a866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderReview_vue__ = __webpack_require__(1909);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1906)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderReview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a42a866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderReview_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderReview.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderReview.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a42a866", Component.options)
  } else {
    hotAPI.reload("data-v-6a42a866", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1907);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("30ca312a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a42a866\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderReview.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a42a866\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderReview.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderReview',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "subHeader" }, [
      _c("div", { staticClass: "content-header" }, [_vm._v("REVIEW")]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _vm._v("Events ADURO has sent for approval.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a42a866", esExports)
  }
}

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderReview"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: { editable: _vm.editable, eventStatus: "review" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-69d2c7d0", esExports)
  }
}

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submitted_vue__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b145922a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Submitted_vue__ = __webpack_require__(1918);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submitted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b145922a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Submitted_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Submitted.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Submitted.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b145922a", Component.options)
  } else {
    hotAPI.reload("data-v-b145922a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderSubmission__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submitted',
  components: {
    SubHeaderSubmission: __WEBPACK_IMPORTED_MODULE_2__components_subHeaders_SubHeaderSubmission__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 5,
      totalRows: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */].items.length,
      pageOptions: [{ text: 5, value: 5 }, { text: 10, value: 10 }, { text: 15, value: 15 }],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      eventStatus: __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].eventStatus.submitted
    };
  },

  methods: {
    details: function details(item, index, button) {
      this.modalDetails.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    }
  },
  computed: {
    editable: function editable() {
      return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].USER_ROLE.eventManager;
    }
  }
});

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderSubmission_vue__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0878a75a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderSubmission_vue__ = __webpack_require__(1917);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1914)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderSubmission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0878a75a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderSubmission_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderSubmission.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderSubmission.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0878a75a", Component.options)
  } else {
    hotAPI.reload("data-v-0878a75a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1915);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9f057e7c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0878a75a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderSubmission.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0878a75a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderSubmission.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderSubmission',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "subHeader" }, [
      _c("div", { staticClass: "content-header" }, [_vm._v("APPROVAL")]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _vm._v("Review this event for approval.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0878a75a", esExports)
  }
}

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderSubmission"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: { editable: _vm.editable, eventStatus: _vm.eventStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b145922a", esExports)
  }
}

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deleted_vue__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a89509_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Deleted_vue__ = __webpack_require__(1926);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deleted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a89509_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Deleted_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Deleted.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Deleted.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06a89509", Component.options)
  } else {
    hotAPI.reload("data-v-06a89509", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_subHeaders_SubHeaderDeleted__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deleted',
  components: {
    SubHeaderDeleted: __WEBPACK_IMPORTED_MODULE_1__components_subHeaders_SubHeaderDeleted__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_2__components_datatable_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 5,
      totalRows: __WEBPACK_IMPORTED_MODULE_0__data__["a" /* default */].items.length,
      pageOptions: [{ text: 5, value: 5 }, { text: 10, value: 10 }, { text: 15, value: 15 }],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      eventStatus: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].eventStatus.deleted
    };
  },

  methods: {},
  computed: {
    editable: function editable() {
      return false;
    }
  }
});

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderDeleted_vue__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe127b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderDeleted_vue__ = __webpack_require__(1925);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1922)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderDeleted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe127b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderDeleted_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderDeleted.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderDeleted.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4cfe127b", Component.options)
  } else {
    hotAPI.reload("data-v-4cfe127b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1923);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4d1bd584", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4cfe127b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderDeleted.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4cfe127b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderDeleted.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderDeleted',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
});

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "subHeader" }, [
      _c("div", { staticClass: "content-header" }, [_vm._v("DELETED")]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [_vm._v("Deleted events")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4cfe127b", esExports)
  }
}

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderDeleted"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: { editable: _vm.editable, eventStatus: _vm.eventStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06a89509", esExports)
  }
}

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnterAuthorizationCode_vue__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587ea956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EnterAuthorizationCode_vue__ = __webpack_require__(1933);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnterAuthorizationCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587ea956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EnterAuthorizationCode_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/mfa/EnterAuthorizationCode.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EnterAuthorizationCode.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-587ea956", Component.options)
  } else {
    hotAPI.reload("data-v-587ea956", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_mfa_constants__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuthorizationSupportLink__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_censor__ = __webpack_require__(1932);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import constMFA from '@/store/modules/mfa/constants';
// import LoadingHeader from '@/components/app/LoadingHeader';
// import EnterAuthorCode from '../EnterAuthorCode';



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-enter-authorization-code',
  components: {
    // LoadingHeader,
    AuthorizationSupportLink: __WEBPACK_IMPORTED_MODULE_5__AuthorizationSupportLink__["a" /* default */]
    // EnterAuthorCode
  },
  props: {},
  data: function data() {
    return {
      mfaCode: '',
      isLoadingBtn: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    mfaTypeValue: function mfaTypeValue() {
      return this.mfaState.type === __WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].mfaType.text ? Object(__WEBPACK_IMPORTED_MODULE_6__utils_censor__["b" /* censorPhoneNumber */])(this.mfaState.mfaData.phone || '') : Object(__WEBPACK_IMPORTED_MODULE_6__utils_censor__["a" /* censorEmail */])(this.mfaState.mfaData.email || '');
    },
    mfaType: function mfaType() {
      return this.mfaState.type === __WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].mfaType.email ? 'email' : 'phone';
    },
    mfaTypeCheck: function mfaTypeCheck() {
      return this.mfaState.type === __WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].mfaType.email ? 'email' : 'text messages';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mfa', {
    mfaState: __WEBPACK_IMPORTED_MODULE_3__store_modules_mfa_constants__["a" /* default */].GETTER_MFA_DATA
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    submitMfaCodeClick: function submitMfaCodeClick() {
      var _this = this;

      if (this.mfaCode === '') {
        this.$toast.success('Please enter code below', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
        return;
      }
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        mfaType: this.mfaState.type,
        token: this.mfaCode,
        action: this.mfaState.flow
      }, this.mfaState.mfaData);
      this.submitMfaCode(data).then(function (response) {
        _this.saveUserProfile({
          data: response
        });
        _this.redirectUser();
      }).catch(function (error) {
        console.log(error);
        _this.$toast.success('Wrong token! Please try again', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optError));
      });
    },
    handleRequestNewCodeClick: function handleRequestNewCodeClick() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        mfaType: this.mfaState.type,
        token: this.mfaCode,
        action: this.mfaState.flow
      }, this.mfaState.mfaData);
      this.requestNewCode(data).then(function (response) {
        _this2.$toast.success('New code sent.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optSuccess));
      }).catch(function (error) {
        console.log(error);
        _this2.$toast.success('Server error!', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.$toastOpt.optError));
      });
    },

    // Navigate user view after login
    redirectUser: function redirectUser() {
      if ([__WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].USER_ROLE.clientManager, __WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].USER_ROLE.accountManager, __WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].USER_ROLE.eventManager, __WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].USER_ROLE.admin].indexOf(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].LOCAL_STORE.role)) >= 0) {
        this.$router.replace(__WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].routeDirect.managerDashboard);
      } else {
        this.$router.push({
          name: __WEBPACK_IMPORTED_MODULE_4__router_constants__["a" /* default */].clientDashboard.name,
          params: {
            clientId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].LOCAL_STORE.clientId)
          }
        });
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('mfa', {
    submitMfaCode: '' + __WEBPACK_IMPORTED_MODULE_3__store_modules_mfa_constants__["a" /* default */].ACTION_CONFIRM_LOGIN_MFA,
    requestNewCode: '' + __WEBPACK_IMPORTED_MODULE_3__store_modules_mfa_constants__["a" /* default */].ACTION_SEND_NEW_CODE_MFA
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    saveUserProfile: 'MUTATION_DO_LOGIN'
  })),
  created: function created() {
    var token = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts_js__["a" /* default */].LOCAL_STORE.token);
    if (token) {
      this.redirectUser();
    }
    if (this.mfaState.type === null) {
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthorizationSupportLink_vue__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5f6292_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AuthorizationSupportLink_vue__ = __webpack_require__(1931);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthorizationSupportLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5f6292_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AuthorizationSupportLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/mfa/AuthorizationSupportLink.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AuthorizationSupportLink.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f5f6292", Component.options)
  } else {
    hotAPI.reload("data-v-1f5f6292", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-authorization-support-link'
});

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "ad-support-link" }, [
      _vm._v("For additional help, please contact "),
      _c("a", { staticClass: "awp-link", attrs: { href: "#" } }, [
        _vm._v("ADURO Support.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f5f6292", esExports)
  }
}

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return censorEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return censorPhoneNumber; });
var censorWord = function censorWord(str) {
  return str[0] + '*'.repeat(str.length - 2) + str.slice(-1);
};

var censorEmail = function censorEmail(email) {
  var arr = email.split('@');
  return censorWord(arr[0]) + '@' + arr[1];
};

var censorPhoneNumber = function censorPhoneNumber(phoneNumber) {
  phoneNumber = phoneNumber.replace(/#|-()/g, '');
  return '***-***-' + phoneNumber.substr(phoneNumber.length - 4, 4);
};



/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn mfa-container" }, [
    _c("div", { staticClass: "loading-header-content" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "margin-side authorization-container",
        on: {
          keyup: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.submitMfaCodeClick($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "center-content row" },
          [
            _c("b-img", {
              staticClass: "img-red-logo",
              attrs: { src: "/static/img/ic-lock.svg" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "mfa-description body-text" }, [
          _c("div", [
            _vm._v(
              "We have sent you a one-time code via " +
                _vm._s(_vm.mfaType) +
                " to " +
                _vm._s(_vm.mfaTypeValue) +
                "."
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "Check your " +
                _vm._s(_vm.mfaTypeCheck) +
                " and enter the code below"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-code-expire" }, [
            _vm._v("Your code will expire after 10 minutes.")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mfa-input-code" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mfaCode,
                expression: "mfaCode"
              }
            ],
            staticClass: "h2-text mfa-input",
            attrs: { placeholder: "Enter Code Here", type: "number" },
            domProps: { value: _vm.mfaCode },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.mfaCode = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "btn-continue-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "ap-btn primary btn-continue",
                attrs: { disabled: _vm.mfaCode == "" },
                on: { click: _vm.submitMfaCodeClick }
              },
              [_vm._v("Continue")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-send-new-code body-text",
              on: { click: _vm.handleRequestNewCodeClick }
            },
            [_vm._v("Send New Code")]
          )
        ]),
        _vm._v(" "),
        _c("AuthorizationSupportLink")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-enter-code-container" }, [
      _c("div", { staticClass: "enter h2-text" }, [_vm._v("Enter")]),
      _vm._v(" "),
      _c("div", { staticClass: "code h1-text" }, [_vm._v("Code")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-587ea956", esExports)
  }
}

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportUser_vue__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6899660_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ImportUser_vue__ = __webpack_require__(1938);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1935)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6899660"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6899660_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ImportUser_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/authorization/ImportUser.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ImportUser.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f6899660", Component.options)
  } else {
    hotAPI.reload("data-v-f6899660", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("cba3aaf6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6899660\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ImportUser.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6899660\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ImportUser.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.loginContainer[data-v-f6899660] {\n  height: 100vh;\n  background-color: #0080a5;\n}\n.loginContainer .login-content[data-v-f6899660] {\n  position: absolute;\n  top: 25%;\n  left: 30%;\n}\n.loginContainer .wellmetrics-event-pl[data-v-f6899660] {\n  height: 29px;\n  color: #ffffff;\n  font-family: Arquitecta, sans-serif;\n  font-size: 27px;\n  font-weight: bold;\n  width: 100%;\n  text-align: center;\n}\n.loginContainer .labelText[data-v-f6899660] {\n  margin-top: 10px;\n  width: 30%;\n}\n.loginContainer .subText[data-v-f6899660] {\n  font-family: Arquitecta, sans-serif;\n  font-size: 14px;\n  color: #ffffff;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.loginContainer .formInput[data-v-f6899660] {\n  background-color: #ffffff;\n  height: 255px;\n  width: 575px;\n  border-radius: 5px;\n  padding: 55px 50px 35px 50px;\n  margin: auto;\n}\n.loginContainer .formInput .form-title[data-v-f6899660] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 0;\n}\n.loginContainer .inputText[data-v-f6899660] {\n  margin: 25px 0 0 0;\n}\n.loginContainer .inputText .input-wrapper[data-v-f6899660] {\n  width: 70%;\n}\n.loginContainer .inputText .input-wrapper label[data-v-f6899660] {\n  width: 100%;\n}\n.loginContainer .submitButton[data-v-f6899660] {\n  float: right;\n  margin-top: 15px;\n  background-color: #0080a5;\n  color: #ffffff;\n}\n.loginContainer .btn-reset-password[data-v-f6899660] {\n  float: right;\n  margin-top: 15px;\n  background-color: #0080a5;\n  color: #ffffff;\n  padding: 7px 25px 10px 25px;\n}\n.loginContainer .forgotPassword[data-v-f6899660] {\n  margin-top: 20px;\n}\n.loginContainer .loginContainer[data-v-f6899660] {\n  height: 100%;\n}\n.loginContainer .form-signin[data-v-f6899660] {\n  padding: 15px;\n  margin: 0 auto;\n}\n.loginContainer .footerForm[data-v-f6899660] {\n  margin-top: 25px;\n}\n.loginContainer .form-signin .form-signin-heading[data-v-f6899660],\n.loginContainer .form-signin .checkbox[data-v-f6899660] {\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 20px;\n}\n.loginContainer .form-signin .checkbox[data-v-f6899660] {\n  font-weight: normal;\n}\n.loginContainer .form-signin .form-control[data-v-f6899660] {\n  position: relative;\n  height: auto;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  font-size: 16px;\n  border-radius: 5px;\n  background-color: #ffffff;\n}\n.loginContainer .form-signin .form-control[data-v-f6899660]:focus {\n  z-index: 2;\n}\n.loginContainer .success-reset-password[data-v-f6899660] {\n  padding-top: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_LoginHeader__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'updatePassword',
  components: {
    LoginHeader: __WEBPACK_IMPORTED_MODULE_1__login_LoginHeader__["a" /* default */]
  },
  data: function data() {
    return {
      files: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    importUser: function importUser() {
      if (this.files.length !== 0) {
        this.uploadFile(this.files[0]);
      }
    },
    fileChange: function fileChange(event) {
      this.files = event.target.files || event.dataTransfer.files;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({ uploadFile: 'ACTION_UPLOAD_FILE' }))
});

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginContainer" }, [
    _c("div", { staticClass: "login-content outer-container" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.importUser()
            }
          }
        },
        [
          _c("div", { staticClass: "wellmetrics-event-pl" }, [
            _vm._v("WELLMETRICS EVENT PLANNER")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "subText" }, [
            _vm._v(
              "Create, request and schedule biometric screening events with ADURO"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "formInput" }, [
            _c("div", [
              _c("div", { staticClass: "form-title" }, [
                _vm._v(
                  "\n            Select file to import users to system.\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row inputText" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("input", {
                    attrs: { type: "file", name: "file" },
                    on: { change: _vm.fileChange }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("Please choose file")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row footerForm" }, [
      _c("input", { attrs: { type: "submit", value: "Upload" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f6899660", esExports)
  }
}

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d160712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1948);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1940)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d160712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/clientView/Dashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d160712", Component.options)
  } else {
    hotAPI.reload("data-v-4d160712", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1941);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("daaf914a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4d160712\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4d160712\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Dashboard_vue__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_event_EventDetailModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_ModalChangeOrderDetail__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__staffing_EventStaffingDetail__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_email_ManageEmail__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_email_EmailHistoriesManagement__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-dashboard-client-view',
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Dashboard_vue__["a" /* default */],
    EventDetailModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_event_EventDetailModal__["a" /* default */],
    ModalChangeOrderDetail: __WEBPACK_IMPORTED_MODULE_4__components_modal_ModalChangeOrderDetail__["a" /* default */],
    EventModal: __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal__["a" /* default */],
    EventStaffingDetail: __WEBPACK_IMPORTED_MODULE_6__staffing_EventStaffingDetail__["a" /* default */],
    ManageEmailModal: __WEBPACK_IMPORTED_MODULE_7__views_email_ManageEmail__["a" /* default */],
    EmailHistoriesManagement: __WEBPACK_IMPORTED_MODULE_8__views_email_EmailHistoriesManagement__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({})),
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},

  watch: {}
});

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f737d3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1947);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1944)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f737d3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f737d3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/main/Dashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f737d3a", Component.options)
  } else {
    hotAPI.reload("data-v-3f737d3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a86cca8a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f737d3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f737d3a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.dashboar-wrapper[data-v-3f737d3a] {\n  padding: 24px 16px 24px 16px;\n}\n.dashboar-wrapper .dashboard[data-v-3f737d3a] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.dashboar-wrapper .plan[data-v-3f737d3a] {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  margin-top: 32px;\n}\n.dashboar-wrapper .event-status[data-v-3f737d3a] {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-top: 16px;\n}\n.dashboar-wrapper .icon-information[data-v-3f737d3a] {\n  display: inline-block;\n  margin: 0 8px;\n  width: 24px;\n  height: 24px;\n  color: #b9b9b9;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  background: url(" + __webpack_require__(838) + ");\n}\n.dashboar-wrapper .text[data-v-3f737d3a] {\n  color: #626262;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n}\n.dashboar-wrapper .numbers[data-v-3f737d3a] {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n}\n.dashboar-wrapper .divider[data-v-3f737d3a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2px;\n  border: 1px solid #e6e6e6;\n  margin-top: 35px;\n}\n.dashboar-wrapper .graph[data-v-3f737d3a] {\n  margin-top: 20px;\n  height: 277px;\n  width: 270px;\n  display: inline-block;\n  border-radius: 4px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n  margin-right: 24px;\n}\n.dashboar-wrapper .event-cards-container[data-v-3f737d3a] {\n  margin: 24px -12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.dashboar-wrapper .event-cards-container .event-card-container[data-v-3f737d3a] {\n  margin: 12px;\n}\n", ""]);

// exports


/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventManagement_manage_EventCard__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-dashboard-clien-view',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    EventCard: __WEBPACK_IMPORTED_MODULE_3__eventManagement_manage_EventCard__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      isChangeOrder: false,
      events: {},
      drafts: 0,
      submitted: 0,
      review: 0,
      approved: 0,
      archived: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getAllData: function getAllData(eventId) {
      var _this = this;

      // reset count in case nothing is returned
      this.drafts = 0;
      this.submitted = 0;
      this.review = 0;
      this.approved = 0;
      this.archived = 0;
      var clientId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.clientId);
      this.getEventCount({ clientId: clientId }).then(function (response) {
        var total = response.countTotalEventsByClient[0].countEventsByStatus;
        total.forEach(function (tol) {
          if (tol.status === 'DRAFTS') {
            _this.drafts = tol.countTotal;
          } else if (tol.status === 'SUBMITTED') {
            _this.submitted = tol.countTotal;
          } else if (tol.status === 'REVIEW') {
            _this.review = tol.countTotal;
          } else if (tol.status === 'APPROVED') {
            _this.approved = tol.countTotal;
          } else if (tol.status === 'ARCHIVED') {
            _this.archived = tol.countTotal;
          }
        });
      });
      var body = {
        clientId: clientId,
        status: 'APPROVED'
      };
      this.getApprovedEventsByStatus(body).then(function (response) {
        _this.events = response.events;
        if (eventId) {
          _this.$modal.show('eventDetailModal', eventId);
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getEventCount: 'ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW',
    getApprovedEventsByStatus: 'ACTION_GET_EVENT_BY_STATUS',
    getClientConfigMessage: 'ACTION_GET_MESSAGE_MODAL'
  })),
  beforeMount: function beforeMount() {},

  mounted: function mounted() {
    this.isChangeOrder = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOCAL_STORE.role) === 'CLIENT';
    this.getAllData();
    this.getClientConfigMessage();
  },
  created: function created() {
    this.$bus.$on('resetGetData', this.getAllData);
  },

  watch: {}
});

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboar-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Drafts")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.drafts))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Submitted")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.submitted))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Review")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.review))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Approved")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.approved))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Archived")]),
        _vm._v(" "),
        _c("div", { staticClass: "numbers" }, [_vm._v(_vm._s(_vm.archived))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-7" })
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "event-cards-container" },
          [
            _vm.events.length === 0
              ? _c("div", { staticClass: "text" }, [
                  _vm._v("No approved events")
                ])
              : _vm._l(_vm.events, function(event, index) {
                  return _c("EventCard", {
                    key: index,
                    attrs: {
                      isChangeOrder: _vm.isChangeOrder,
                      event: event,
                      isNoTrans: index % 3 == 2,
                      isFromClientDashboardView: true
                    }
                  })
                })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 dashboard" }, [
        _vm._v("dashboard\n      "),
        _c("div", { staticClass: "icon-information" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row margin-bottom-8px" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "plan" }, [_vm._v("Plan")]),
        _vm._v(" "),
        _c("div", { staticClass: "event-status" }, [_vm._v("event status")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "divider" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "plan" }, [_vm._v("Manage")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "divider" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "plan" }, [_vm._v("Sign ups")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "graph" }, [_vm._v("Graph 1")]),
        _vm._v(" "),
        _c("div", { staticClass: "graph" }, [_vm._v("Graph 2")]),
        _vm._v(" "),
        _c("div", { staticClass: "graph" }, [_vm._v("Graph 3")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f737d3a", esExports)
  }
}

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Dashboard"),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("ModalChangeOrderDetail"),
      _vm._v(" "),
      _c("EventStaffingDetail"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d160712", esExports)
  }
}

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae946fdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__ = __webpack_require__(1956);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1950)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae946fdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae946fdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/clientView/Manage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Manage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ae946fdc", Component.options)
  } else {
    hotAPI.reload("data-v-ae946fdc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1951);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("54a50c78", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ae946fdc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Manage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ae946fdc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Manage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Manage_vue__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_event_EventDetailModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_ModalChangeOrderDetail__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_CustomMessageModal__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__staffing_EventStaffingDetail__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_email_ManageEmail__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_email_EmailHistoriesManagement__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-manage-client-view',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_10_vue_awesome_components_Icon__["a" /* default */],
    Manage: __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Manage_vue__["a" /* default */],
    EventDetailModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_event_EventDetailModal__["a" /* default */],
    EventModal: __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal__["a" /* default */],
    ModalChangeOrderDetail: __WEBPACK_IMPORTED_MODULE_5__components_modal_ModalChangeOrderDetail__["a" /* default */],
    CustomMessageModal: __WEBPACK_IMPORTED_MODULE_6__components_modal_CustomMessageModal__["a" /* default */],
    EventStaffingDetail: __WEBPACK_IMPORTED_MODULE_7__staffing_EventStaffingDetail__["a" /* default */],
    ManageEmailModal: __WEBPACK_IMPORTED_MODULE_8__views_email_ManageEmail__["a" /* default */],
    EmailHistoriesManagement: __WEBPACK_IMPORTED_MODULE_9__views_email_EmailHistoriesManagement__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({})),
  watch: {}
});

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22d493a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__ = __webpack_require__(1955);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22d493a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Manage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/main/Manage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Manage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22d493a2", Component.options)
  } else {
    hotAPI.reload("data-v-22d493a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manage-approve-event-client-view',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      startDate: '',
      endDate: '',
      keyword: '',
      programClientList: [],
      programClientSelected: {
        name: 'All Program',
        startDate: null,
        endDate: null,
        id: null
      },
      events: [],
      eventGroups: [],
      hideLoadMore: true,
      loadMoreLoading: false,
      currentPage: 1,
      itemsPerPage: 10,
      currentItemsPerPage: 10,
      loadingList: false,
      sortReverse: false,
      client: null,
      currentEventDetail: {},
      totalCountOfClient: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    onChange: function onChange() {
      this.getListEvents();
    },
    onSearch: function onSearch(event) {
      if (event.which === 13) {
        this.getListEvents();
      }
    },
    clearFilter: function clearFilter() {
      this.startDate = '';
      this.endDate = '';
      this.keyword = '';
      this.getListEvents();
    },
    onLoadMore: function onLoadMore() {
      var _this = this;

      var params = {
        noBeginDates: '0',
        noEndDates: 100,
        selectedDate: null,
        clientId: this.$route.params.clientId,
        keyword: this.keyword,
        currentPage: this.currentPage + 1,
        itemsPerPage: this.itemsPerPage,
        sortType: 'dateTime',
        eventStatusRequest: 'ALL',
        eventStatus: ['APPROVED', 'ARCHIVED'],
        requireReport: null,
        startDate: this.formatDate(this.startDate),
        endDate: this.formatDate(this.endDate),
        relatedEventInGroup: true,
        sortReverse: this.sortReverse
      };
      this.loadMoreLoading = true;
      this.getEventsByDates(params).then(function (res) {
        _this.formatEventAndGroup(res);
        _this.currentPage += 1;
        _this.currentItemsPerPage = _this.currentPage * _this.itemsPerPage;
      }).finally(function () {
        _this.loadMoreLoading = false;
      });
    },
    onSort: function onSort() {
      this.sortReverse = !this.sortReverse;
      this.$store.commit('MUTATION_SET_SORT_DATA', { type: this.sortType, reverse: this.sortReverse });
      this.getListEvents();
    },
    onManageClientSettings: function onManageClientSettings() {
      if (!this.client) return;
      this.$modal.show('customMessageModal', this.client.id);
    },
    getListEvents: function getListEvents() {
      var _this2 = this;

      var params = {
        noBeginDates: '0',
        noEndDates: 100,
        selectedDate: null,
        clientId: this.$route.params.clientId,
        keyword: this.keyword,
        currentPage: 1,
        itemsPerPage: this.isHasNoFilter() ? this.currentItemsPerPage : null,
        sortType: 'dateTime',
        eventStatusRequest: 'ALL',
        eventStatus: ['APPROVED', 'ARCHIVED'],
        requireReport: null,
        startDate: this.formatDate(this.startDate),
        endDate: this.formatDate(this.endDate),
        relatedEventInGroup: true,
        sortReverse: this.sortReverse
      };
      this.loadingList = true;
      this.events = [];
      this.eventGroups = [];
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.getEventsByDates(params).then(function (res) {
          _this2.formatEventAndGroup(res);
          resolve(res);
        }).finally(function () {
          _this2.loadingList = false;
          _this2.loadMoreLoading = false;
        });
      });
    },
    formatEventAndGroup: function formatEventAndGroup(response) {
      var _this3 = this;

      var eventRaw = response.approvedEvents != null ? response.approvedEvents[0].events : [];
      this.events = [];
      this.eventGroups = [];
      eventRaw.forEach(function (event) {
        if (event.countRelatedEvents && event.countRelatedEvents > 0) {
          _this3.eventGroups.push({
            id: event.eventGroupId,
            name: event.eventGroupName || event.eventName,
            minDateEventGroup: event.minDateEventGroup,
            maxDateEventGroup: event.maxDateEventGroup,
            totalCount: event.countRelatedEvents + 1, // relatedEvent + mainEvent
            data: [event].concat(event.relatedEvents),
            sortType: _this3.sortType,
            sortReverse: _this3.sortReverse
          });
        } else {
          _this3.events.push(event);
        }
      });
      this.hideLoadMore = response.totalEvents ? this.totalEvents() === response.totalEvents : true;
      this.$store.commit('MUTATION_SET_LIST_EVENT_GROUP', this.eventGroups);
      this.$store.commit('MUTATION_SET_LIST_SINGLE_EVENT', this.events);
    },
    totalEvents: function totalEvents() {
      var eventInGroupCount = 0;
      this.eventGroups.forEach(function (group) {
        eventInGroupCount += group.data.length;
      });
      return this.events.length + eventInGroupCount;
    },
    showLoadMoreBtn: function showLoadMoreBtn() {
      return !this.hideLoadMore && !this.loadMoreLoading && this.isHasNoFilter();
    },
    isHasNoFilter: function isHasNoFilter() {
      return this.startDate === '' && this.endDate === '' && this.keyword === '';
    },
    getClientInfo: function getClientInfo() {
      var _this4 = this;

      this.getClient(this.$route.params.clientId).then(function (response) {
        _this4.client = response.data.data;
      });
    },
    formatDate: function formatDate(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format('MM/DD/YYYY');
    },
    selectProgramItemClick: function selectProgramItemClick(item) {
      if (item !== this.programClientSelected) {
        this.programClientSelected = item;

        if (this.programClientSelected.startDate) {
          this.startDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.programClientSelected.startDate).format('YYYY-MM-DD');
        } else {
          this.startDate = null;
        }

        if (this.programClientSelected.endDate) {
          this.endDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.programClientSelected.endDate).format('YYYY-MM-DD');
        } else {
          this.endDate = null;
        }
        this.getListEvents();
      }
    },
    onEventDetails: function onEventDetails(event) {
      this.currentEventDetail = event;
      this.$modal.show('eventDetailModal', { eventId: this.currentEventDetail.id, onChangeEventLive: this.onChangeEventLive, onChangeEvent: this.onChangeEvent });
    },
    onMakeLive: function onMakeLive(event) {
      var _this5 = this;

      this.actionUpdateIsLiveEvent({
        eventId: event.id,
        isCheck: !event.isLive,
        onlineType: 'LIVE'
      }).then(function (response) {
        if (response.message) {
          _this5.$toastr('error', response.message, '');
        } else {
          event.isLive = response.event.isLive;
          _this5.$toastr('success', 'Update event successful!', '');
        }
      });
    },
    onChangeEventLive: function onChangeEventLive(isLive) {
      this.currentEventDetail.isLive = isLive;
    },
    onChangeEvent: function onChangeEvent(event) {
      this.currentEventDetail.isLive = event.isLive;
      this.currentEventDetail.eventName = event.eventName;
      this.currentEventDetail.prefDate = event.prefDate;
      this.currentEventDetail.trackingStatus = event.trackingStatus;
      this.currentEventDetail.fullAddress = event.fullAddress;
      this.currentEventDetail.maxStaffLead = event.maxStaffLead;
      this.currentEventDetail.maxStaffConcierge = event.maxStaffConcierge;
      this.currentEventDetail.maxStaffScreener = event.maxStaffScreener;
    },
    isShowArchivedEvent: function isShowArchivedEvent(event) {
      return event.status === 'ARCHIVED';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getEventsByDates: 'ACTION_GET_EVENTS_DATES',
    getClient: 'ACTION_GET_CLIENT',
    actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT',
    getProgramClientAction: 'ACTION_GET_PROGRAM_CLIENT'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getListEventGroup: 'GETTER_LIST_EVENT_GROUP',
    getListSingleEvent: 'GETTER_LIST_SINGLE_EVENT'
  })),
  created: function created() {
    var _this6 = this;

    this.clientId = this.$route.params.clientId;
    this.getClientInfo();
    this.getListEvents().then(function (res) {
      _this6.totalCountOfClient = res.totalEvents || 0;

      _this6.getProgramClientAction(_this6.clientId).then(function (response) {
        if (response.programPs.length > 0) {
          _this6.programClientSelected = null;
          _this6.programClientList = response.programPs;
          _this6.programClientList.unshift({
            name: 'All Program',
            startDate: null,
            endDate: null,
            id: null
          });
          for (var i = 0; i < response.programPs.length; i++) {
            if (response.programPs[i].status === 'Active') {
              _this6.programClientSelected = response.programPs[i];
              break;
            }
          }
          if (!_this6.programClientSelected) {
            _this6.programClientSelected = response.programPs[1];
          }
          _this6.startDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this6.programClientSelected.startDate).format('YYYY-MM-DD');
          _this6.endDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this6.programClientSelected.endDate).format('YYYY-MM-DD');
          _this6.getListEvents();
        }
      });
    });
  },

  watch: {}
});

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manageWrapper" }, [
    _c("div", { staticClass: "search-container" }, [
      _c(
        "div",
        {
          staticClass:
            "manage-header d-flex align-items-start justify-content-between"
        },
        [
          _c("div", { staticClass: "w-50 d-flex align-items-center" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Manage")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "item ml-2" },
              [
                _c("multiselect", {
                  staticClass: "content",
                  attrs: {
                    options: _vm.programClientList,
                    placeholder: _vm.programClientList
                      ? _vm.programClientSelected.name
                      : "Empty",
                    label: "name",
                    openDirection: "below",
                    multiple: false,
                    "close-on-select": true,
                    "hide-selected": true,
                    "track-by": "name",
                    "allow-empty": true,
                    "show-labels": false
                  },
                  on: { select: _vm.selectProgramItemClick },
                  model: {
                    value: _vm.programClientSelected,
                    callback: function($$v) {
                      _vm.programClientSelected = $$v
                    },
                    expression: "programClientSelected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("b-button", { on: { click: _vm.onManageClientSettings } }, [
            _vm._v("\n        Manage Client Settings\n      ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container-filter" }, [
        _c("div", { staticClass: "filter-date-range" }, [
          _c("div", { staticClass: "text-container" }, [
            _c("p", { staticClass: "text-date-range" }, [
              _vm._v("Filter by date range")
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-clear", on: { click: _vm.clearFilter } },
              [_vm._v("Clear Filters")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field-filter d-flex align-items-center" },
            [
              _c("b-form-input", {
                attrs: { type: "date", locale: "en-US" },
                on: {
                  keydown: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onChange($event)
                  }
                },
                model: {
                  value: _vm.startDate,
                  callback: function($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate"
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("to")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { type: "date", locale: "en-US" },
                on: {
                  keydown: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onChange($event)
                  }
                },
                model: {
                  value: _vm.endDate,
                  callback: function($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-events" },
          [
            _c("p", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "b-input-group",
              { staticClass: "search-events-group" },
              [
                _c("b-form-input", {
                  attrs: {
                    type: "text",
                    placeholder: "Search by event information"
                  },
                  nativeOn: {
                    keydown: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onSearch($event)
                    }
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  { on: { click: _vm.onChange } },
                  [
                    _c("Icon", {
                      staticClass: "search-icon",
                      attrs: { name: "search" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "total-count" }, [
          _vm._v(
            "\n        Event Count: " +
              _vm._s(_vm.totalEvents()) +
              "/" +
              _vm._s(_vm.totalCountOfClient) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "list-events" }, [
      _c("div", { staticClass: "list-header" }, [
        _c("div", { staticClass: "column event-date" }, [
          _c(
            "div",
            { staticClass: "container-column border-seperate" },
            [
              _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
              _vm._v(" "),
              _c("b-button", { on: { click: _vm.onSort } }, [
                _c("img", {
                  attrs: {
                    src: __webpack_require__(84),
                    alt: "icon"
                  }
                })
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm._m(6)
      ]),
      _vm._v(" "),
      _vm.loadingList
        ? _c(
            "div",
            { staticClass: "list-loading d-flex justify-content-center" },
            [
              _c("b-spinner", {
                attrs: { variant: "primary", label: "Spinning" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loadingList
        ? _c(
            "div",
            [
              _vm._l(_vm.getListSingleEvent, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "list-container" },
                  [
                    item.status === "APPROVED" || _vm.isShowArchivedEvent(item)
                      ? _c(
                          "div",
                          {
                            class:
                              "list-content " +
                              (_vm.isShowArchivedEvent(item)
                                ? "green-line"
                                : "")
                          },
                          [
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [_c("p", [_vm._v(_vm._s(item.eventName))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [
                                  _c("div", { staticClass: "text-icon" }, [
                                    _c("img", {
                                      attrs: {
                                        src: __webpack_require__(839),
                                        alt: "icon"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(_vm._s(item.trackingStatus))
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [
                                  _c("div", { staticClass: "text-icon" }, [
                                    _c("img", {
                                      attrs: {
                                        src: __webpack_require__(269),
                                        alt: "icon"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(item.numParticipant) +
                                          "/" +
                                          _vm._s(item.maxParticipant) +
                                          " Participants"
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [_c("p", [_vm._v(_vm._s(item.fullAddress))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [
                                  _c("div", { staticClass: "text-icon" }, [
                                    _c("img", {
                                      attrs: {
                                        src: __webpack_require__(269),
                                        alt: "icon"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          item.numStaffLead +
                                            item.numStaffConcierge +
                                            item.numStaffScreener
                                        ) +
                                          "/" +
                                          _vm._s(
                                            item.maxStaffLead +
                                              item.maxStaffConcierge +
                                              item.maxStaffScreener
                                          ) +
                                          " Staff"
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c("div", { staticClass: "container-column" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "live-click",
                                    on: {
                                      click: function($event) {
                                        _vm.onMakeLive(item)
                                      }
                                    }
                                  },
                                  [
                                    item.isLive
                                      ? _c(
                                          "div",
                                          { staticClass: "text-icon" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: __webpack_require__(840),
                                                alt: "icon"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v("Live")])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !item.isLive
                                      ? _c(
                                          "p",
                                          { staticClass: "text-not-live" },
                                          [_vm._v("Not Live")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _c("b-button", {
                                      staticClass: "btn-expand",
                                      on: {
                                        click: function($event) {
                                          _vm.onEventDetails(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "load-more" },
                [
                  _c("b-spinner", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loadMoreLoading,
                        expression: "loadMoreLoading"
                      }
                    ],
                    attrs: { variant: "primary", label: "Spinning" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.getListEventGroup, function(group) {
                  return _c(
                    "div",
                    { staticClass: "list-group-container" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "container-text d-flex align-items-center"
                        },
                        [
                          _c("b", [_vm._v(_vm._s(group.name) + ":")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(group.minDateEventGroup) +
                              " - " +
                              _vm._s(group.maxDateEventGroup) +
                              "\n            "
                          ),
                          _c("div", { staticClass: "seperate" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(group.data.length) +
                              "/" +
                              _vm._s(group.totalCount) +
                              " events\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(group.data, function(relatedEvent) {
                        return _c(
                          "div",
                          { staticClass: "list-ca container-ca" },
                          [
                            relatedEvent.status === "APPROVED" ||
                            _vm.isShowArchivedEvent(relatedEvent)
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "list-group-row " +
                                      (_vm.isShowArchivedEvent(relatedEvent)
                                        ? "green-line"
                                        : "")
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(relatedEvent.prefDate)
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(relatedEvent.eventName)
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "text-icon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: __webpack_require__(839),
                                                    alt: "icon"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      relatedEvent.trackingStatus
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "text-icon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: __webpack_require__(269),
                                                    alt: "icon"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      relatedEvent.numParticipant
                                                    ) +
                                                      "/" +
                                                      _vm._s(
                                                        relatedEvent.maxParticipant
                                                      ) +
                                                      " Participants"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(relatedEvent.fullAddress)
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "text-icon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: __webpack_require__(269),
                                                    alt: "icon"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      relatedEvent.numStaffLead +
                                                        relatedEvent.numStaffConcierge +
                                                        relatedEvent.numStaffScreener
                                                    ) +
                                                      "/" +
                                                      _vm._s(
                                                        relatedEvent.maxStaffLead +
                                                          relatedEvent.maxStaffConcierge +
                                                          relatedEvent.maxStaffScreener
                                                      ) +
                                                      " Staff"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "container-column" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "live-click",
                                                on: {
                                                  click: function($event) {
                                                    _vm.onMakeLive(relatedEvent)
                                                  }
                                                }
                                              },
                                              [
                                                relatedEvent.isLive
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "text-icon"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: __webpack_require__(840),
                                                            alt: "icon"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v("Live")
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !relatedEvent.isLive
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-not-live"
                                                      },
                                                      [_vm._v("Not Live")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "button-view" },
                                              [
                                                _c("b-button", {
                                                  staticClass: "btn-expand",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.onEventDetails(
                                                        relatedEvent
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "load-more" },
                [
                  _vm.showLoadMoreBtn()
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn btn-secondary",
                          on: { click: _vm.onLoadMore }
                        },
                        [_vm._v("\n          Load More\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadMoreLoading
                    ? _c("b-spinner", {
                        attrs: { variant: "primary", label: "Spinning" }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("p", { staticClass: "text-manage-events" }, [
          _vm._v("Manage your events that are approved and scheduled")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Supply Status")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Participant Signups")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Address")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Staffing")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Live")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22d493a2", esExports)
  }
}

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Manage"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ModalChangeOrderDetail"),
      _vm._v(" "),
      _c("CustomMessageModal"),
      _vm._v(" "),
      _c("EventStaffingDetail"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae946fdc", esExports)
  }
}

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731e55d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__ = __webpack_require__(1987);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1958)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731e55d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/clientView/Plan.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Plan.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-731e55d4", Component.options)
  } else {
    hotAPI.reload("data-v-731e55d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1959);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("74e1a9f9", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-731e55d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Plan.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-731e55d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Plan.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Plan_vue__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_Modal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_ModalChangeOrderDetail__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_HistoryModal__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_BulkCreateEvents__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_DraftEventModal__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modal_CustomMessageModal__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal_event_EventDetailModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_email_ManageEmail__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__staffing_EventStaffingDetail__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-plan-client-view',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__["a" /* default */],
    Plan: __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Plan_vue__["a" /* default */],
    EventModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_Modal__["a" /* default */],
    ModalChangeOrderDetail: __WEBPACK_IMPORTED_MODULE_4__components_modal_ModalChangeOrderDetail__["a" /* default */],
    HistoryModal: __WEBPACK_IMPORTED_MODULE_5__components_modal_HistoryModal__["a" /* default */],
    BulkCreateEvents: __WEBPACK_IMPORTED_MODULE_6__components_modal_BulkCreateEvents__["a" /* default */],
    DraftEventModal: __WEBPACK_IMPORTED_MODULE_7__components_modal_DraftEventModal__["a" /* default */],
    CustomMessageModal: __WEBPACK_IMPORTED_MODULE_8__components_modal_CustomMessageModal__["a" /* default */],
    EventDetailModal: __WEBPACK_IMPORTED_MODULE_9__components_modal_event_EventDetailModal__["a" /* default */],
    ManageEmailModal: __WEBPACK_IMPORTED_MODULE_10__views_email_ManageEmail__["a" /* default */],
    EventStaffingDetail: __WEBPACK_IMPORTED_MODULE_11__staffing_EventStaffingDetail__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({})),
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},

  watch: {}
});

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64bfa673_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__ = __webpack_require__(1965);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1962)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64bfa673"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64bfa673_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/main/Plan.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Plan.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-64bfa673", Component.options)
  } else {
    hotAPI.reload("data-v-64bfa673", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1963);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3c0ce725", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64bfa673\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Plan.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64bfa673\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Plan.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.manageWrapper .select-event-text[data-v-64bfa673] {\n  font-size: 1.1em;\n}\n.manageWrapper .list-events .list-container .list-content .proj-part[data-v-64bfa673] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-right: 14px;\n}\n.manageWrapper .ap-btn[data-v-64bfa673] {\n  text-transform: capitalize;\n  padding: 6px 24px;\n  margin-right: 16px;\n  font-size: 1.1em;\n}\n.manageWrapper .ap-btn.secondary[data-v-64bfa673] {\n  border-color: #b9b9b9;\n}\n.manageWrapper .grp-button-action .ap-btn[data-v-64bfa673] {\n  text-transform: capitalize;\n  padding: 6px 34px;\n}\n.manageWrapper .status-menu[data-v-64bfa673] {\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 600;\n  list-style: none;\n  line-height: 14px;\n  font-size: 1.1em;\n}\n.manageWrapper .status-menu li.status-menu-item[data-v-64bfa673] {\n  display: inline;\n  margin-right: 36px;\n  text-transform: capitalize;\n  padding-bottom: 10px;\n  color: #585858;\n}\n.manageWrapper .status-menu li.status-menu-item[data-v-64bfa673]:hover,\n.manageWrapper .status-menu li.status-menu-item.selected[data-v-64bfa673] {\n  color: #1D1D1D;\n  border-bottom: solid 4px #1674cd;\n  cursor: pointer;\n}\n.manageWrapper .no-event-found[data-v-64bfa673] {\n  text-align: center;\n  margin: 64px auto 0;\n}\n.manageWrapper .no-event-found .text[data-v-64bfa673] {\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.manageWrapper .no-event-found .event-found[data-v-64bfa673] {\n  color: #8E8E8E;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-top: 32px;\n}\n.manageWrapper .no-event-found .grp-button-action[data-v-64bfa673] {\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.manageWrapper .no-event-found .grp-button-action .item-submit-btn[data-v-64bfa673] {\n  border-radius: 4px;\n  float: right;\n  padding: 0.5% 2%;\n  margin-right: 16px;\n}\n.manageWrapper .no-event-found .grp-button-action .item-submit-btn span[data-v-64bfa673] {\n  font-weight: 600;\n  color: #00A4D6;\n  font-size: 16px;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.manageWrapper .no-event-found .grp-button-action .item-create-btn[data-v-64bfa673] {\n  margin-right: 16px;\n  float: right;\n  padding: 0.5% 3%;\n}\n.manageWrapper .no-event-found .grp-button-action .item-create-btn span[data-v-64bfa673] {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.manageWrapper .no-event-found .no-event-found[data-v-64bfa673] {\n  text-align: center;\n  margin: 64px auto 0;\n}\n.manageWrapper .no-event-found .no-event-found .text[data-v-64bfa673] {\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.manageWrapper .no-event-found .no-event-found .item-create-btn[data-v-64bfa673] {\n  background-color: #00A4D6;\n  margin-top: 16px;\n  padding: 6px 24px;\n}\n.manageWrapper .no-event-found .no-event-found .item-create-btn span[data-v-64bfa673] {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_users__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commons_Popup__ = __webpack_require__(820);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-plan-page',
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_15__commons_Popup__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_5__components_datatable_DataTable__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_14_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      message: 'Create new events and submit them to ADURO for approval.',
      tableType: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].eventStatus.drafts,
      consts: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */],
      totalDrafts: 0,
      totalSubmitted: 0,
      totalApproved: 0,
      totalArchived: 0,
      totalReview: 0,
      programClientList: [],
      programClientSelected: {
        name: 'All Program',
        startDate: '',
        endDate: '',
        id: null
      },
      client: null,
      loadingList: false,
      clientId: null,
      enableSelectEvents: false,
      selectedEvents: [],
      singleSelectedEvent: {
        id: null
      },
      userRole: null,
      sortType: null,
      sortReverse: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    programDate: function programDate() {
      return this.dateFormat(this.programClientSelected.startDate) + ' - ' + this.dateFormat(this.programClientSelected.endDate);
    },
    eventCountTotal: function eventCountTotal() {
      this.updateCount();
      var countTotal = this.getCountTotalEvents(this.tableType);
      if (countTotal !== this.getListEvent.length) {
        return this.getListEvent.length;
      }
      return countTotal;
    },
    events: function events() {
      var listEvent = this.getListEvent;
      listEvent.forEach(function (element, index) {
        element['additionalServices'] = __WEBPACK_IMPORTED_MODULE_12_lodash__["cloneDeep"](__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].addOns);
        element.disableDuration = false;
        var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.addOns);
        var arrAddOns = strAddOns.split(',');
        var arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
        var fields = __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].fields;
        element['additionalServices'].forEach(function (service) {
          arrAddOns.forEach(function (ele) {
            if (ele === service.key) {
              service.isShow = ele === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel ? parseInt(element[fields.event.projPart]) < 34 : true;
            }
          });
          arrOnOff.forEach(function (ele) {
            if (ele === service.key) {
              service.value = true;
              if (ele === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
                listEvent[index].disableDuration = parseInt(element.projPart) < 34;
              }
            }
          });
        });
      });
      return listEvent;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    getLoading: 'GETTERS_IS_LOADING',
    getListEvent: 'GETTERS_LIST_EVENT',
    getCountTotalEvents: 'GETTERS_COUNT_EVENT_BY_STATUS',
    isDownloading: 'GETTER_IS_DOWNLOADING'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    onManageClientSettings: function onManageClientSettings() {
      if (!this.client) return;
      this.$modal.show('customMessageModal', this.client.id);
    },
    onShowSubmitAll: function onShowSubmitAll() {
      this.$modal.show('submitAllPopup');
    },
    onSubmitAll: function onSubmitAll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingList = true;
                _context.next = 3;
                return _this.submitAllEvent();

              case 3:
                _context.next = 5;
                return _this.updateCount();

              case 5:
                _this.loadingList = false;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onShowSelectEvents: function onShowSelectEvents() {
      this.selectedEvents = [];
      this.enableSelectEvents = true;
    },
    onCancelSelectEvents: function onCancelSelectEvents() {
      this.enableSelectEvents = false;
    },
    onShowSubmitEvents: function onShowSubmitEvents() {
      this.$modal.show('submitEventsPopup');
    },
    onSubmitEvents: function onSubmitEvents() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.enableSelectEvents = false;
                _this2.loadingList = true;
                _context2.next = 4;
                return _this2.submitEvents({ clientId: _this2.clientId, eventIds: _this2.selectedEvents.map(function (e) {
                    return e.id;
                  }) });

              case 4:
                _context2.next = 6;
                return _this2.updateCount();

              case 6:
                _this2.loadingList = false;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    btnAddClick: function btnAddClick() {
      this.$modal.show('DraftEventModal');
    },
    selectProgramItemClick: function selectProgramItemClick(item) {
      if (item !== this.programClientSelected) {
        this.programClientSelected = item;
        this.$root.$emit('RELOAD_EVENT_LIST', this.programClientSelected.id);
      }
      this.updateCount();
      this.getEventList(this.getListEventParams());
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.pagingOptions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getListEventParams()));
    },
    dateFormat: function dateFormat(dateString) {
      return dateString ? __WEBPACK_IMPORTED_MODULE_13_moment___default()(dateString).format('MM/DD/YYYY') : '--';
    },
    resetCountStatus: function resetCountStatus() {
      this.totalDrafts = 0;
      this.totalSubmitted = 0;
      this.totalReview = 0;
      this.totalApproved = 0;
      this.totalArchived = 0;
    },
    updateCount: function updateCount() {
      var _this3 = this;

      return this.getEventCount({ clientId: this.clientId, programId: this.programClientSelected.id }).then(function (response) {
        _this3.resetCountStatus();
        if (!response.countTotalEventsByClient || response.countTotalEventsByClient.length <= 0) return;
        var total = response.countTotalEventsByClient[0].countEventsByStatus;
        total.forEach(function (tol) {
          if (tol.status === 'DRAFTS') {
            _this3.totalDrafts = tol.countTotal;
          } else if (tol.status === 'SUBMITTED') {
            _this3.totalSubmitted = tol.countTotal;
          } else if (tol.status === 'REVIEW') {
            _this3.totalReview = tol.countTotal;
          } else if (tol.status === 'APPROVED') {
            _this3.totalApproved = tol.countTotal;
          } else if (tol.status === 'ARCHIVED') {
            _this3.totalArchived = tol.countTotal;
          }
        });
      });
    },
    onShowBulkEvents: function onShowBulkEvents() {
      this.$modal.show('bulkCreateEventsModal');
    },

    getListEventParams: function getListEventParams() {
      return {
        userId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.userId)),
        status: [this.tableType.toUpperCase()],
        options: {
          sortType: this.sortType,
          sortReverse: this.sortReverse
        },
        clientId: this.clientId,
        programId: this.programClientSelected.id
      };
    },
    getClientInfo: function getClientInfo() {
      var _this4 = this;

      this.getClient(this.clientId).then(function (response) {
        _this4.client = response.data.data;
      });
    },
    onShowDuplicatePopup: function onShowDuplicatePopup(item) {
      this.selectedEvents = [item];
      this.$modal.show('duplicatePopup');
    },
    onDuplicate: function onDuplicate() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.duplicateEvent({
                  item: _this5.selectedEvents[0],
                  status: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].eventStatus.drafts.toUpperCase(),
                  isAddToList: _this5.tableType !== __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].eventStatus.drafts
                });

              case 2:
                _this5.updateCount();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    onDelete: function onDelete(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.$modal.show('eventModal', {
                  action: __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].modalAction.deleteEvent,
                  data: item,
                  callback: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return _this6.deleteEvent(item);

                            case 2:
                              _this6.updateCount();

                            case 3:
                            case 'end':
                              return _context4.stop();
                          }
                        }
                      }, _callee4, _this6);
                    }));

                    return function callback() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    onStatus: function onStatus(item) {
      if (item.status === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].eventStatus.archived.toUpperCase()) {
        this.selectedEvents = [item];
        this.$modal.show('moveToApprovedPopup');
      }
    },
    onDetails: function onDetails(item) {
      this.currentEventDetail = item;
      if (this.currentEventDetail.status.toLowerCase() === __WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].eventStatus.drafts.toLowerCase()) {
        this.$modal.show('DraftEventModal', this.currentEventDetail);
        return;
      }
      this.$modal.show('eventDetailModal', { eventId: item.id, onChangeEventLive: this.onChangeEventLive, onChangeEvent: this.onChangeEvent });
    },
    onChangeEventLive: function onChangeEventLive(isLive) {
      this.currentEventDetail.isLive = isLive;
    },
    onChangeEvent: function onChangeEvent(event) {
      this.currentEventDetail.isLive = event.isLive;
      this.currentEventDetail.eventName = event.eventName;
      this.currentEventDetail.prefDate = event.prefDate;
      this.currentEventDetail.trackingStatus = event.trackingStatus;
      this.currentEventDetail.fullAddress = event.fullAddress;
      this.currentEventDetail.maxStaffLead = event.maxStaffLead;
      this.currentEventDetail.maxStaffConcierge = event.maxStaffConcierge;
      this.currentEventDetail.maxStaffScreener = event.maxStaffScreener;
    },
    onSort: function onSort(sortType) {
      this.sortType = sortType;
      this.sortReverse = !this.sortReverse;
      this.getEventList(this.getListEventParams());
    },
    showApprovedToArchivedPopup: function showApprovedToArchivedPopup(item) {
      this.selectedEvents = [item];
      this.$modal.show('moveApprovedToArchivedPopup');
    },
    showApprovedToDraftsPopup: function showApprovedToDraftsPopup(item) {
      this.selectedEvents = [item];
      this.$modal.show('moveApprovedToDraftsPopup');
    },
    onChangeStatus: function onChangeStatus(status) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this7.changeEventStatus({
                  eventId: _this7.selectedEvents[0].id,
                  status: status
                });

              case 2:
                _this7.updateCount();

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    setExpandId: 'ACTION_SET_EXPAND_ID',
    getEventCount: 'ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW',
    getProgramClientAction: 'ACTION_GET_PROGRAM_CLIENT',
    getEventList: 'ACTION_GET_EVENT_LIST',
    getClient: 'ACTION_GET_CLIENT',
    duplicateEvent: 'ACTION_DUPLICATE_EVENT',
    deleteEvent: 'ACTION_DELETE_EVENT',
    submitAllEvent: 'ACTION_SUBMIT_ALL_EVENT',
    submitEvents: 'ACTION_SUBMIT_EVENTS',
    changeEventStatus: 'ACTION_CHANGE_EVENT_STATUS',
    exportParticipantReport: 'ACTION_EXPORT_PARTICIPANT_REPORT'
  })),
  created: function created() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this8.loadingList = true;
              _this8.clientId = _this8.$route.params.clientId;
              _this8.userRole = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.role);
              _context7.next = 5;
              return _this8.getClientInfo();

            case 5:
              _context7.next = 7;
              return _this8.updateCount();

            case 7:
              _context7.next = 9;
              return _this8.getProgramClientAction(_this8.clientId).then(function (response) {
                if (response.programPs.length > 0) {
                  _this8.programClientList = response.programPs;
                  _this8.programClientList.unshift({
                    name: 'All Program',
                    startDate: '',
                    endDate: '',
                    id: null
                  });
                  _this8.programClientSelected = response.programPs[0];
                }
              });

            case 9:
              _context7.next = 11;
              return _this8.getEventList(_this8.getListEventParams());

            case 11:
              _this8.loadingList = false;

              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.pagingOptions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.getListEventParams()));
              localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts__["a" /* default */].LOCAL_STORE.clientId, _this8.clientId);

            case 14:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this8);
    }))();
  },

  watch: {
    tableType: {
      handler: function handler() {
        var _this9 = this;

        this.loadingList = true;
        this.getEventList(this.getListEventParams()).then(function () {
          _this9.loadingList = false;
        });
      }
    }
  }
});

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manageWrapper" },
    [
      _c("div", { staticClass: "search-container pb-0" }, [
        _c(
          "div",
          {
            staticClass:
              "manage-header d-flex align-items-center justify-content-between"
          },
          [
            _c("div", { staticClass: "w-50 d-flex align-items-center" }, [
              _c("span", { staticClass: "title" }, [_vm._v("Plan")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "item ml-2" },
                [
                  _c("multiselect", {
                    staticClass: "content",
                    attrs: {
                      options: _vm.programClientList,
                      placeholder: _vm.programClientList
                        ? _vm.programClientSelected.name
                        : "Empty",
                      label: "name",
                      openDirection: "below",
                      multiple: false,
                      "close-on-select": true,
                      "hide-selected": true,
                      "track-by": "name",
                      "allow-empty": true,
                      "show-labels": false
                    },
                    on: { select: _vm.selectProgramItemClick },
                    model: {
                      value: _vm.programClientSelected,
                      callback: function($$v) {
                        _vm.programClientSelected = $$v
                      },
                      expression: "programClientSelected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "item ml-2" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Program Operation Date:")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label content" }, [
                  _vm._v(_vm._s(_vm.programDate))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "ml-5",
                    attrs: { disabled: _vm.isDownloading },
                    on: {
                      click: function($event) {
                        _vm.exportParticipantReport(
                          _vm.programClientSelected.id
                        )
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v("Download Participant Report")]),
                    _vm._v(" "),
                    _vm.isDownloading
                      ? _c("b-spinner", {
                          staticClass: "ml-1",
                          attrs: { small: "" }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "ml-3",
                    on: { click: _vm.onManageClientSettings }
                  },
                  [_vm._v("\n          Manage Client Settings\n        ")]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("p", { staticClass: "text-manage-events" }, [
              _vm._v(_vm._s(_vm.consts.planMessage[_vm.tableType]))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("ul", { staticClass: "status-menu pl-0" }, [
              _c(
                "li",
                {
                  staticClass: "status-menu-item",
                  class:
                    _vm.tableType === _vm.consts.eventStatus.drafts
                      ? "selected"
                      : null,
                  on: {
                    click: function($event) {
                      _vm.tableType = _vm.consts.eventStatus.drafts
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            drafts - " +
                      _vm._s(_vm.totalDrafts) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "status-menu-item",
                  class:
                    _vm.tableType === _vm.consts.eventStatus.approved
                      ? "selected"
                      : null,
                  on: {
                    click: function($event) {
                      _vm.tableType = _vm.consts.eventStatus.approved
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            approved - " +
                      _vm._s(_vm.totalApproved) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "status-menu-item",
                  class:
                    _vm.tableType === _vm.consts.eventStatus.archived
                      ? "selected"
                      : null,
                  on: {
                    click: function($event) {
                      _vm.tableType = _vm.consts.eventStatus.archived
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            archived - " +
                      _vm._s(_vm.totalArchived) +
                      "\n          "
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-events" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm.enableSelectEvents
              ? _c("div", { staticClass: "select-event-text" }, [
                  _c("span", [
                    _vm._v(
                      "Select multiple " +
                        _vm._s(_vm.tableType) +
                        " events to submit"
                    )
                  ])
                ])
              : _c("div", { staticClass: "grp-button-action" }, [
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c(
                        "button",
                        {
                          staticClass: "item-create-btn ap-btn primary",
                          attrs: { type: "button", disabled: _vm.getLoading },
                          on: {
                            click: function($event) {
                              _vm.btnAddClick()
                            }
                          }
                        },
                        [_vm._v("Create\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c(
                        "button",
                        {
                          staticClass: "item-submit-btn ap-btn secondary",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.getLoading || _vm.getListEvent.length === 0
                          },
                          on: { click: _vm.onShowSubmitAll }
                        },
                        [_vm._v("\n            Submit All\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "item-submit-btn ap-btn secondary",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.getLoading || _vm.getListEvent.length === 0
                      },
                      on: { click: _vm.onShowSelectEvents }
                    },
                    [_vm._v("\n            Select Events\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c(
                        "button",
                        {
                          staticClass: "item-submit-btn ap-btn secondary",
                          attrs: { type: "button", disabled: _vm.getLoading },
                          on: { click: _vm.onShowBulkEvents }
                        },
                        [_vm._v("\n            Bulk Create Events\n          ")]
                      )
                    : _vm._e()
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-header mt-4" }, [
          _vm.enableSelectEvents
            ? _c("div", { staticClass: "column w-2" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "column w-14" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.onSort("dateTime")
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: __webpack_require__(84),
                        alt: "icon"
                      }
                    })
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "column w-14" }, [
            _c(
              "div",
              { staticClass: "container-column justify-content-between" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Duplicate")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-header" }, [
                  _vm.tableType === _vm.consts.eventStatus.drafts
                    ? _c("span", [_vm._v("Delete")])
                    : _c("span", [_vm._v("Status")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-header" }, [_vm._v("Details")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.loadingList
          ? _c(
              "div",
              { staticClass: "list-loading d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Spinning" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingList
          ? _c(
              "div",
              [
                _vm._l(_vm.events, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "list-container" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "list-content",
                          attrs: { for: "select-event-check-" + index }
                        },
                        [
                          _vm.enableSelectEvents
                            ? _c("div", { staticClass: "column w-2" }, [
                                _c("div", { staticClass: "container-column" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEvents,
                                        expression: "selectedEvents"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "select-event-check-" + index
                                    },
                                    domProps: {
                                      value: item,
                                      checked: Array.isArray(_vm.selectedEvents)
                                        ? _vm._i(_vm.selectedEvents, item) > -1
                                        : _vm.selectedEvents
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.selectedEvents,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = item,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedEvents = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedEvents = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedEvents = $$c
                                        }
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.eventName))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-column border-seperate proj-part"
                              },
                              [_c("p", [_vm._v(_vm._s(item.projPart))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.fullAddress))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(item.startTime + "-" + item.endTime)
                                  )
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-column border-seperate"
                              },
                              [_c("p", [_vm._v(_vm._s(item.contactName))])]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column w-14" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-column justify-content-between"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _c("b-button", {
                                      staticClass: "btn-duplicate",
                                      on: {
                                        click: function($event) {
                                          _vm.onShowDuplicatePopup(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _vm.tableType ===
                                    _vm.consts.eventStatus.drafts
                                      ? [
                                          _c("b-button", {
                                            staticClass: "btn-delete",
                                            on: {
                                              click: function($event) {
                                                _vm.onDelete(item)
                                              }
                                            }
                                          })
                                        ]
                                      : [
                                          _c("div", [
                                            item.status === "ARCHIVED"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("b-button", {
                                                      staticClass: "btn-status",
                                                      attrs: {
                                                        disabled:
                                                          _vm.userRole !==
                                                          _vm.consts.USER_ROLE
                                                            .admin
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.onStatus(item)
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "b-dropdown",
                                                      {
                                                        staticClass:
                                                          "btn-status btn-status-dropdown",
                                                        attrs: {
                                                          disabled:
                                                            _vm.userRole !==
                                                            _vm.consts.USER_ROLE
                                                              .admin
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b-dropdown-item",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showApprovedToArchivedPopup(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Move to Archived Status"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-dropdown-item",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.showApprovedToDraftsPopup(
                                                                  item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Move to Draft Status"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                          ])
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _c("b-button", {
                                      staticClass: "btn-expand",
                                      on: {
                                        click: function($event) {
                                          _vm.onDetails(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "load-more" },
                  [
                    _c("b-spinner", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadMoreLoading,
                          expression: "loadMoreLoading"
                        }
                      ],
                      attrs: { variant: "primary", label: "Spinning" }
                    })
                  ],
                  1
                )
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.enableSelectEvents
        ? _c("div", { staticClass: "footer" }, [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "item-submit-btn ap-btn secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.onCancelSelectEvents }
                },
                [_vm._v("\n        Cancel\n      ")]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.selectedEvents.length) +
                    " " +
                    _vm._s(
                      _vm.selectedEvents.length === 1 ? "event" : "events"
                    ) +
                    " selected"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "item-create-btn ap-btn primary",
                  attrs: {
                    type: "button",
                    disabled: !_vm.selectedEvents.length
                  },
                  on: { click: _vm.onShowSubmitEvents }
                },
                [_vm._v("\n        Submit\n      ")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "submitAllPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: { onSubmit: _vm.onSubmitAll }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to submit your drafts?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("You are submitting "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.totalDrafts) +
                  " " +
                  _vm._s(_vm.totalDrafts === 1 ? "record" : "records")
              )
            ]),
            _vm._v(
              ".  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted."
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "submitEventsPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: { onSubmit: _vm.onSubmitEvents }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v(
              "Are you sure you want to submit your " +
                _vm._s(_vm.tableType) +
                "?"
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("You are submitting "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.selectedEvents.length) +
                  " " +
                  _vm._s(_vm.selectedEvents.length === 1 ? "record" : "records")
              )
            ]),
            _vm._v(
              ".  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted."
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "duplicatePopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: { onSubmit: _vm.onDuplicate }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to duplicate the selected events?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("You are submitting "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.selectedEvents.length) +
                  " " +
                  _vm._s(_vm.selectedEvents.length === 1 ? "record" : "records")
              )
            ]),
            _vm._v(
              ". Events will be created in draft status. You can manage the events in the ”draft” tab after duplicates are created."
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "moveToApprovedPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: {
            onSubmit: function($event) {
              _vm.onChangeStatus(_vm.consts.eventStatus.approved.toUpperCase())
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v(
              "Are you sure you want to change the selected event from Archived status back to Approved status？"
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("Event will be moved to Approved tab after submission.")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "moveApprovedToDraftsPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: {
            onSubmit: function($event) {
              _vm.onChangeStatus(_vm.consts.eventStatus.drafts.toUpperCase())
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to change the selected event from "),
            _c("u", [_vm._v("Approved")]),
            _vm._v(" status back to "),
            _c("u", [_vm._v("Draft")]),
            _vm._v(" status ?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v("Event will be moved to draft tab after submission.")
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "moveApprovedToArchivedPopup",
            "cancel-text": "Cancel",
            "submit-text": "Submit"
          },
          on: {
            onSubmit: function($event) {
              _vm.onChangeStatus(_vm.consts.eventStatus.archived.toUpperCase())
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure you want to change the selected event from "),
            _c("u", [_vm._v("Approved")]),
            _vm._v(" status to "),
            _c("u", [_vm._v("Archived")]),
            _vm._v(" status ?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v(
              "Event will be moved to Archived tab after submission. Archived events are not editable."
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Participant")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Address")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Time")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column w-14" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Onsite Contact")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64bfa673", esExports)
  }
}

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkCreateEvents_vue__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21ec141a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_BulkCreateEvents_vue__ = __webpack_require__(1973);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkCreateEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21ec141a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_BulkCreateEvents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/BulkCreateEvents.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BulkCreateEvents.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21ec141a", Component.options)
  } else {
    hotAPI.reload("data-v-21ec141a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemHistoryModal__ = __webpack_require__(1970);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BulkCreateEvents',
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    ItemHistoryModal: __WEBPACK_IMPORTED_MODULE_5__ItemHistoryModal__["a" /* default */]
  },
  data: function data() {
    return {
      historyHeader: ['Submission Date', 'Program', '# Events', 'File Name', 'Error Message', 'Pass/Fail'],
      dropzoneOptions: {
        url: 'http://localhost',
        includeStyling: false,
        previewsContainer: false,
        uploadMultiple: false,
        autoProcessQueue: false
      },
      downloadLoading: false,
      currentPage: 1,
      totalRows: 0,
      itemsPerPage: 10,
      clientId: null,
      histories: null,
      loadingHistories: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    beforeOpen: function beforeOpen() {
      this.clientId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].LOCAL_STORE.clientId);
      this.onGetHistories();
    },
    sendingFile: function sendingFile(file) {
      var _this = this;

      var formData = new FormData();
      formData.append('content', file);
      formData.append('clientId', this.clientId);
      this.uploadFileBulkCreateEvent(formData).then(function (response) {
        _this.currentPage = 1;
        _this.onGetHistories();
        if (response.message.toLowerCase().includes('duplicated')) {
          _this.$toast.error('Events failed to be processed because duplication was detected, please edit the CSV file and resubmit it', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optInfo));
          return;
        }
        if (response.message === '') {
          _this.$toast.success('Events are successfully uploaded and created', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optInfo));
          return;
        }
        _this.$toast.error(response.message, '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optInfo));
      });
    },
    onDownload: function onDownload() {
      var _this2 = this;

      this.downloadLoading = true;
      this.downloadBulkEventsTemplate().then(function (response) {
        var blob = new Blob([response], { type: 'text/csv' });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'EventsTemplate.csv';
        link.click();
        URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this2.downloadLoading = false;
      });
    },
    onChangePagination: function onChangePagination(page) {
      this.currentPage = page;
      this.onGetHistories();
    },
    onGetHistories: function onGetHistories() {
      var _this3 = this;

      this.loadingHistories = true;
      this.getUploadHistories({
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
        clientId: this.clientId
      }).then(function (response) {
        _this3.histories = response.histories;
        _this3.totalRows = response.totalUploaded;
      }).catch(function () {
        _this3.$toast.error('Events failed to be processed, please edit the CSV file and resubmit it', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.$toastOpt.optInfo));
      }).finally(function () {
        _this3.loadingHistories = false;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    downloadBulkEventsTemplate: 'ACTION_DOWNLOAD_BULK_EVENTS_TEMPLATE',
    uploadFileBulkCreateEvent: 'ACTION_UPLOAD_FILE_BULK_CREATE_EVENTS',
    getUploadHistories: 'ACTION_GET_UPLOAD_HISTORIES'
  })),
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getClientName: 'GETTERS_GET_CLIENT_NAME'
  }))
});

/***/ }),
/* 1968 */,
/* 1969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemHistoryModal_vue__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b38dd38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ItemHistoryModal_vue__ = __webpack_require__(1972);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemHistoryModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b38dd38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ItemHistoryModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ItemHistoryModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ItemHistoryModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b38dd38", Component.options)
  } else {
    hotAPI.reload("data-v-2b38dd38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'itemModal',
  props: {
    item: Object,
    clientId: String
  },
  data: function data() {
    return {
      loadingItem: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date);
    },
    onDownloadFileName: function onDownloadFileName(fileId, fileName) {
      var _this = this;

      this.loadingItem = true;
      this.downloadUploadedFile({
        fileId: fileId,
        clientId: this.clientId
      }).then(function (response) {
        var blob = new Blob([response], { type: 'text/csv' });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this.loadingItem = false;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    downloadUploadedFile: 'ACTION_DOWNLOAD_UPLOADED_FILE'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getClientName: 'GETTERS_GET_CLIENT_NAME'
  }))
});

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [
      _vm._v(_vm._s(_vm.moment(_vm.item.submitDate).format("MM/DD/YYYY")))
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.item.programName))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.item.numEvent))]),
    _vm._v(" "),
    _c("td", [
      _vm.loadingItem
        ? _c(
            "span",
            { staticClass: "blink-text" },
            [_c("b-spinner"), _vm._v("Downloading...")],
            1
          )
        : _vm._e(),
      !_vm.loadingItem
        ? _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.onDownloadFileName(_vm.item.fileId, _vm.item.fileName)
                }
              }
            },
            [_vm._v(_vm._s(_vm.item.fileName))]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.item.errorMessage))]),
    _vm._v(" "),
    _c(
      "td",
      {
        class: {
          textPass: _vm.item.result === "PASS",
          textFailed: _vm.item.result === "FAILED"
        }
      },
      [_vm._v(_vm._s(_vm.item.result))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b38dd38", esExports)
  }
}

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "bulk-create-events-modal",
      attrs: {
        name: "bulkCreateEventsModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "bulk-create-events" }, [
        _c("div", { staticClass: "bulk-title" }, [
          _c("p", [
            _vm._v(_vm._s(_vm.getClientName) + "  - Bulk Create Events")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-bulk",
              attrs: { disabled: _vm.downloadLoading },
              on: { click: _vm.onDownload }
            },
            [
              !_vm.downloadLoading
                ? _c("img", {
                    attrs: {
                      src: __webpack_require__(1974),
                      alt: "union"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.downloadLoading ? _c("b-spinner") : _vm._e(),
              _vm._v("\n        Download Template\n      ")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upload-file" },
          [
            _c(
              "vue-dropzone",
              {
                ref: "myVueDropzone",
                attrs: {
                  "include-styling": false,
                  useCustomSlot: true,
                  id: "dropzone",
                  options: _vm.dropzoneOptions
                },
                on: { "vdropzone-file-added": _vm.sendingFile }
              },
              [
                _c("div", { staticClass: "dropzone-container" }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(1975),
                      alt: "union"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-csv" }, [
                    _vm._v("CSV File Only")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-drop" }, [
                    _vm._v("Drag & drop to upload or "),
                    _c("a", { attrs: { href: "#" } }, [_vm._v("browse")])
                  ])
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "submission-history" }, [
          _c("p", [_vm._v("Submission History")]),
          _vm._v(" "),
          _c(
            "table",
            [
              _c(
                "tr",
                _vm._l(_vm.historyHeader, function(item) {
                  return _c("th", { key: item }, [_vm._v(_vm._s(item))])
                })
              ),
              _vm._v(" "),
              _vm.loadingHistories
                ? _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "6" } },
                      [_c("b-spinner", { attrs: { variant: "primary" } })],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.histories, function(itemHistory) {
                return !_vm.loadingHistories
                  ? _c("ItemHistoryModal", {
                      key: itemHistory.id,
                      attrs: { item: itemHistory, clientId: _vm.clientId }
                    })
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("p", { staticClass: "total-text" }, [
                _vm._v(_vm._s(_vm.totalRows) + " results")
              ]),
              _vm._v(" "),
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.itemsPerPage,
                  pills: "",
                  "first-number": true,
                  "last-number": true
                },
                on: { change: _vm.onChangePagination },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21ec141a", esExports)
  }
}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftEventModal_vue__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d78af58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DraftEventModal_vue__ = __webpack_require__(1986);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftEventModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d78af58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DraftEventModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/DraftEventModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DraftEventModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d78af58", Component.options)
  } else {
    hotAPI.reload("data-v-4d78af58", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_exclamation_circle__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_arrow_circle_o_right__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_chevron_right__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_chevron_down__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_floppy_o__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_trash_o__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_repeat__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_exchange__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_angle_right__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_refresh__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_question_circle__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_files_o__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuejs_datepicker__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_google_autocomplete__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_search__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_modal_ModalSubmitDrafts__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_events_OnSiteContactSearch_vue__ = __webpack_require__(1981);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DraftEventModal',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_14_vue_awesome_components_Icon__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_15_vuejs_datepicker___default.a,
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_16_vue_google_autocomplete__["a" /* default */],
    Vue: __WEBPACK_IMPORTED_MODULE_17_vue__["default"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_22_vue_multiselect___default.a,
    ModalSubmitDrafts: __WEBPACK_IMPORTED_MODULE_23__components_modal_ModalSubmitDrafts__["a" /* default */],
    OnSiteContactSearch: __WEBPACK_IMPORTED_MODULE_25__components_events_OnSiteContactSearch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      listTime: __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listTime,
      isAddressError: false,
      eventFields: __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].fields.event,
      loadingSaveDraft: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    beforeOpen: function beforeOpen(params) {
      var event = params.params || this.currentEvent;
      if (params.params != null) {
        this.currentEvent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.currentEvent, event);
      }
      var newAdditionalServices = __WEBPACK_IMPORTED_MODULE_24_lodash__["cloneDeep"](__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].addOns);
      var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].LOCAL_STORE.addOns);
      var arrAddOns = strAddOns.split(',');
      var arrOnOff = event.addOns === null ? [] : event.addOns.split(',');
      newAdditionalServices.forEach(function (service) {
        service.value = false;service.isShow = false;
      });
      newAdditionalServices.forEach(function (service) {
        arrAddOns.forEach(function (ele) {
          if (ele === service.key) {
            service.isShow = ele === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel ? event.projPart < 34 : true;
          }
        });
        arrOnOff.forEach(function (ele) {
          if (ele === service.key) {
            service.value = true;
            if (ele === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
              event.disableDuration = event.projPart < 34;
            }
          }
        });
      });
      this.currentEvent.additionalServices = newAdditionalServices;
    },
    beforeClose: function beforeClose() {
      this.createNewEventClick();
    },
    hideModal: function hideModal() {
      this.$modal.hide('DraftEventModal');
    },
    onChangTime: function onChangTime() {
      if (this.currentEvent.duration === 0 || !this.currentEvent.startTime) return;
      this.currentEvent.endTime = __WEBPACK_IMPORTED_MODULE_20_moment___default()(this.currentEvent.startTime, 'h:mm A').add(this.currentEvent.duration, 'hours').format('h:mm A');
    },
    setPlace: function setPlace(data, place) {
      var _this = this;

      this.resetFullAddress();
      this.currentEvent.fullAddress = place.formatted_address;

      var res = place && place.formatted_address.split(',');
      var resAdr = '';
      if (res.length > 3) {
        var temp = __WEBPACK_IMPORTED_MODULE_24_lodash__["trim"](res[res.length - 2]).split(' ');
        resAdr = temp[0] + '-' + res[res.length - 3];
      }
      this.currentEvent.eventName = resAdr;

      var addressComponents = place.address_components;
      for (var i = 0; i < addressComponents.length; i++) {
        var component = addressComponents[i];
        if (component.types.indexOf('sublocality_level_1') >= 0 || component.types.indexOf('sublocality') >= 0 || component.types.indexOf('locality') >= 0) {
          this.currentEvent.city = component.long_name;
        }
        if (component.types[0] === 'administrative_area_level_1') {
          this.currentEvent.state = component.short_name;
        }
        if (component.types[0] === 'postal_code') {
          this.currentEvent.zipCode = component.short_name;
        }
      }

      this.currentEvent.latitude = place.geometry.location.lat() || 0;
      this.currentEvent.longitude = place.geometry.location.lng() || 0;

      var req = __WEBPACK_IMPORTED_MODULE_17_vue__["default"].axios.create();
      req.get(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].googleApisMaps, {
        params: {
          location: place.geometry.location.lat() + ',' + place.geometry.location.lng(),
          timestamp: '' + Math.round(new Date().getTime() / 1000),
          key: this.googleMapApiKey === '' ? localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
        }
      }).then(function (response) {
        if (response.data) {
          _this.currentEvent.timeZone = _this.getTimeZone(response.data.timeZoneName);
          _this.currentEvent.timeZoneId = response.data.timeZoneId;
          _this.isAddressError = _this.isAddressReadyToUpdate();
        } else {
          _this.$toast.error('Error calling Google Maps API', '', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optInfo));
        }
      });
    },
    getTimeZone: function getTimeZone(tzString) {
      if (tzString.length === 0) {
        return '';
      }
      var str = '';
      var index = 0;
      while (index >= 0) {
        str += tzString.substr(0, 1);
        index = tzString.indexOf(' ');
        tzString = tzString.substring(index + 1);
      }
      return str;
    },
    checkboxToggle: function checkboxToggle(key, value) {
      var _this2 = this;

      var obj = {
        clientId: this.currentEvent.clientId,
        eventId: this.currentEvent.id,
        key: key,
        isAdd: value,
        index: this.currentEvent.index
      };
      if (this.currentEvent.id !== 0) {
        this.updateEventAddOns(obj).then(function (response) {
          _this2.currentEvent.addOns = response.data.addOns;
          _this2.$toastr('info', 'Update event successful', '');
          if (key === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
            _this2.calculateDuration();
            _this2.onUpdateEvent(_this2.currentEvent);
          }
          if (key === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.cotinine) {
            _this2.updateEventAddOns({
              eventId: _this2.currentEvent.id,
              key: __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.tobaccoSelfAttestation,
              isAdd: false,
              index: _this2.currentEvent.index
            }).then(function () {
              _this2.triggerSavingAddonForEvent();
            });
          }
          if (key === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.tobaccoSelfAttestation) {
            _this2.updateEventAddOns({
              eventId: _this2.currentEvent.id,
              key: __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.cotinine,
              isAdd: false,
              index: _this2.currentEvent.index
            }).then(function () {
              _this2.triggerSavingAddonForEvent();
            });
          }
          if (_this2.currentEvent.additionalServices.slice(7, 10).find(function (x) {
            return x.key === key;
          })) {
            _this2.currentEvent.additionalServices.slice(7, 10).forEach(function (element) {
              if (key !== element.key) {
                element.value = false;
              }
            });
          }
        });
      } else {
        this.currentEvent.addOns = this.currentEvent.additionalServices.filter(function (e) {
          return e.value === true;
        }).map(function (e) {
          return e.key;
        }).join(',');
        this.onUpdateEvent(this.currentEvent);
      }
    },
    preventSave: function preventSave(event) {
      var classes = ['cell', 'day', 'selected', 'prev', 'up', 'next', 'blank', 'btn-submit', 'btn-cancel', 'icon-close', 'btn-save'];
      if (classes.find(function (e) {
        return event.target.classList.contains(e);
      })) {
        return true;
      }
      var types = ['input', 'button', 'textarea', 'select', 'label', 'span'];
      return types.includes(event.target.tagName.toLowerCase());
    },
    onSaveDraft: function onSaveDraft(e) {
      if (this.preventSave(e)) return;
      this.onUpdateEvent(this.currentEvent);
    },
    onSave: function onSave() {
      this.loadingSaveDraft = true;
      this.onUpdateEvent(this.currentEvent);
    },
    onSubmit: function onSubmit() {
      this.$modal.show('ModalSubmitDrafts', this.currentEvent);
    },
    isAddressReadyToUpdate: function isAddressReadyToUpdate() {
      return __WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.latitude && this.currentEvent.longitude && this.currentEvent.city && this.currentEvent.state && this.currentEvent.zipCode && this.currentEvent.timeZoneId);
    },
    searchContact: function searchContact(keyword) {
      this.currentEvent.contactName = keyword;
      this.getListOnSiteContact(keyword.toLowerCase());
    },
    selectOnSiteContact: function selectOnSiteContact(contact) {
      if (contact) {
        this.currentEvent.contact = {
          contactName: contact.contactName,
          contactPhone: contact.contactPhone,
          contactEmail: contact.contactEmail
        };
        this.currentEvent.contactName = contact.contactName;
        this.currentEvent.phone = contact.contactPhone;
        this.currentEvent.email = contact.contactEmail;
      }
    },
    resetFullAddress: function resetFullAddress() {
      this.currentEvent.latitude = null;
      this.currentEvent.longitude = null;
      this.currentEvent.city = null;
      this.currentEvent.state = null;
      this.currentEvent.zipCode = null;
      this.currentEvent.timeZoneId = null;
    },
    onChangeDate: function onChangeDate(date) {
      this.currentEvent.prefDate = __WEBPACK_IMPORTED_MODULE_20_moment___default()(date).format('MM/DD/YYYY');
    },
    calculateDuration: function calculateDuration() {
      var projPart = this.currentEvent.projPart;
      var services = this.findAdditionalSercives(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel);
      if (services !== null && services.value === true) {
        if (projPart < 9) {
          this.currentEvent.duration = 4;
        }
        if (projPart > 8 && projPart < 17) {
          this.currentEvent.duration = 5;
        }
        if (projPart > 16 && projPart < 25) {
          this.currentEvent.duration = 6;
        }
        if (projPart > 24 && projPart < 29) {
          this.currentEvent.duration = 7;
        }
        if (projPart > 28) {
          this.currentEvent.duration = 8;
        }
      } else {
        var userFilled = this.currentEvent.userManualFilled;
        if (userFilled.indexOf(this.eventFields.duration) === -1) {
          if (projPart > 0 && projPart <= 32) {
            this.currentEvent.duration = 4;
          }
          if (projPart > 32 && projPart < 100) {
            this.currentEvent.duration = 4;
          }
          if (projPart >= 100 && projPart <= 140) {
            this.currentEvent.duration = 5;
          }
          if (projPart > 140 && projPart < 170) {
            this.currentEvent.duration = 6;
          }
          if (projPart >= 170 && projPart < 200) {
            this.currentEvent.duration = 7;
          }
          if (projPart >= 200) {
            this.currentEvent.duration = 8;
          }
        }
      }
    },
    findAdditionalSercives: function findAdditionalSercives(key) {
      var result = null;
      this.currentEvent.additionalServices.forEach(function (element) {
        if (element.key === key) {
          result = element;
        }
      });
      return result;
    },
    triggerSavingAddonForEvent: function triggerSavingAddonForEvent() {
      this.currentEvent.customEventNote += '.';
      this.currentEvent.customEventNote = this.currentEvent.customEventNote.slice(0, -1);
    },
    onUpdateEvent: function onUpdateEvent(event) {
      var _this3 = this;

      this.updateEvent(event).then(function () {}).finally(function () {
        if (_this3.loadingSaveDraft) {
          _this3.$modal.hide('DraftEventModal');
        }
        _this3.loadingSaveDraft = false;
      });
    },
    disableAdditionalServices: function disableAdditionalServices(key) {
      if (key === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.cotinine) {
        return this.currentEvent.additionalServices[6].isShow && this.currentEvent.additionalServices[6].value; // check order in consts
      }
      if (key === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.tobaccoSelfAttestation) {
        return this.currentEvent.additionalServices[2].isShow && this.currentEvent.additionalServices[2].value; // check order in consts
      }
      if (key === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
        return this.currentEvent.additionalServices[5].isShow && !this.currentEvent.additionalServices[5].value; // check order in consts
      }
    },
    updateIsLiveEvent: function updateIsLiveEvent(type) {
      var _this4 = this;

      var isCheck = false;
      switch (type) {
        case 'LIVE':
          isCheck = this.currentEvent.isLive;
          break;
        case 'ONLINE_SCHEDULER':
          isCheck = this.currentEvent.isOnlineScheduler;
          break;
        default:
          break;
      }
      this.actionUpdateIsLiveEvent({
        eventId: this.currentEvent.id,
        isCheck: isCheck || false,
        onlineType: type
      }).then(function (response) {
        if (response.message) {
          _this4.$toastr('error', response.message, '');
        } else {
          _this4.updateStateEvent(_this4.currentEvent);
          _this4.$toastr('success', 'Update event successful!', '');
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])({
    updateEvent: 'ACTION_UPDATE_EVENT',
    updateEventAddOns: 'ACTION_UPDATE_EVENT_ADD_ON',
    getListOnSiteContact: 'ACTION_GET_LIST_ON_SITE_CONTACT',
    createNewEventClick: 'ACTION_CREATE_NEW_EVENT',
    actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT'
  }), Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["d" /* mapMutations */])({
    updateStateEvent: 'MUTATION_UPDATE_EVENT'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    arrayDuration: function arrayDuration() {
      var range = [];
      for (var i = 1; i <= 24; i += 0.5) {
        range.push(i);
      }
      return range;
    },
    enableBtnSave: function enableBtnSave() {
      if (!this.currentEvent.prefDate || !this.currentEvent.maxStaffLead || this.currentEvent.maxStaffLead <= 0 || !this.currentEvent.projPart || this.currentEvent.projPart <= 0 || !this.currentEvent.fullAddress || !this.currentEvent.startTime || !this.currentEvent.duration || !this.currentEvent.contactName || !this.currentEvent.email || !this.currentEvent.phone || !this.currentEvent.aduroArrivalTime || this.isAddressError) return true;
      return false;
    },
    addressErrorMessage: function addressErrorMessage() {
      var generateAddress = [__WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.latitude) ? 'Number' : '', __WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.longitude) ? 'Street Name' : '', __WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.city) ? 'City' : '', __WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.state) ? 'State' : '', __WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.zipCode) ? 'ZipCode' : '', __WEBPACK_IMPORTED_MODULE_24_lodash__["isEmpty"](this.currentEvent.timeZoneId) ? 'TimeZoneId' : ''];
      var message = generateAddress.filter(function (item) {
        return item !== '';
      }).join(', ');
      return 'Require ' + message;
    },
    onSiteContacts: function onSiteContacts() {
      return this.listOnSiteContact;
    },
    enableIconDuration: function enableIconDuration() {
      return this.currentEvent.duration <= 0 || this.currentEvent.duration > 10;
    },
    isCreateByEM: function isCreateByEM() {
      var a = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].LOCAL_STORE.role) === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].USER_ROLE.eventManager;
      var b = this.currentEvent.createdBy && this.currentEvent.createdBy.toString() === localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].LOCAL_STORE.userId).toString();
      return a && b;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])({
    googleMapApiKey: 'GETTERS_GOOGLE_API_KEY',
    listOnSiteContact: 'GETTERS_LIST_ON_SITE_CONTACT',
    currentEvent: 'GETTER_CURRENT_EVENT'
  })),
  created: function created() {
    this.createNewEventClick();
  },

  watch: {
    'currentEvent.projPart': {
      handler: function handler() {
        var _this5 = this;

        var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].LOCAL_STORE.addOns);
        var arrAddOns = strAddOns.split(',');
        this.currentEvent.additionalServices.forEach(function (service) {
          arrAddOns.forEach(function (ele) {
            if (ele === service.key) {
              service.isShow = ele === __WEBPACK_IMPORTED_MODULE_18__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel ? _this5.currentEvent.projPart < 34 : true;
            }
          });
        });
      }
    }
  }
});

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalSubmitDrafts_vue__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae817aca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalSubmitDrafts_vue__ = __webpack_require__(1980);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalSubmitDrafts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae817aca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModalSubmitDrafts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/ModalSubmitDrafts.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ModalSubmitDrafts.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ae817aca", Component.options)
  } else {
    hotAPI.reload("data-v-ae817aca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalSubmitDrafts',
  props: {
    currentEvent: { type: Object }
  },
  data: function data() {
    return {
      loadingSubmit: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    onCancel: function onCancel() {
      this.$modal.hide('ModalSubmitDrafts');
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.loadingSubmit = true;
      this.updateEvent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.currentEvent, { status: 'APPROVED' })).then(function () {}).finally(function () {
        _this.$modal.hide('DraftEventModal');
        _this.loadingSubmit = false;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    getEventList: 'ACTION_GET_EVENT_LIST',
    updateEvent: 'ACTION_UPDATE_EVENT'
  }))
});

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-submit-drafts",
      attrs: {
        name: "ModalSubmitDrafts",
        width: "30%",
        height: "auto",
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("p", { staticClass: "text-question" }, [
          _vm._v("Are you sure you want to submit your drafts?")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-description" }, [
          _vm._v("You are submitting "),
          _c("b", [_vm._v(_vm._s(_vm.currentEvent.eventName) + ".")]),
          _vm._v(
            "  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted."
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              { staticClass: "btn-submit", on: { click: _vm.onSubmit } },
              [
                _vm.loadingSubmit ? _c("b-spinner") : _vm._e(),
                _vm._v("\n        Submit\n      ")
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae817aca", esExports)
  }
}

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnSiteContactSearch_vue__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5bbf14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_OnSiteContactSearch_vue__ = __webpack_require__(1985);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1982)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnSiteContactSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5bbf14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_OnSiteContactSearch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/events/OnSiteContactSearch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OnSiteContactSearch.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a5bbf14", Component.options)
  } else {
    hotAPI.reload("data-v-4a5bbf14", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("866a491a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a5bbf14\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OnSiteContactSearch.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a5bbf14\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OnSiteContactSearch.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.content-input {\n  width: 100%;\n  position: relative;\n}\n.content-input .ui-autocomplete {\n  border-color: #e0e0e0;\n  -webkit-box-shadow: 0 1px 6px -1px rgba(64, 64, 64, 0.4);\n          box-shadow: 0 1px 6px -1px rgba(64, 64, 64, 0.4);\n  position: absolute;\n  z-index: 1000;\n  top: 33px;\n  left: 0;\n  right: 0;\n  padding: 0;\n  list-style-type: none;\n  border-width: 1px;\n  border-style: solid;\n  border-top: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background: #fff;\n  display: none;\n  font-family: inherit;\n  line-height: 1.6;\n  margin: 0;\n  list-style-position: outside;\n}\n.content-input .ui-autocomplete .show-result {\n  max-height: 300px;\n  overflow: hidden;\n  overflow-y: scroll;\n}\n.content-input .ui-autocomplete.active {\n  display: block;\n}\n.content-input .ui-autocomplete .ui-menu-item {\n  border-bottom-color: #dfe5f0;\n  display: block;\n  overflow: auto;\n  font-size: 13px;\n  padding: 0;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n}\n.content-input .ui-autocomplete .ui-menu-item.item-found:hover {\n  cursor: pointer;\n  background-color: #e4eaf5;\n}\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .name {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group .email {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group .phone,\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group .email,\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group .age-group,\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group .address,\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group .membership {\n  color: #7e7e7e;\n  display: block;\n  font-size: 12px;\n}\n.content-input .ui-autocomplete .ui-menu-item .ui-item-result .info-container .info-group.info-end {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n.content-input .ui-autocomplete .ui-menu-item .person {\n  padding-left: 0;\n  margin-left: 8px;\n  overflow: auto;\n}\n.content-input .ui-autocomplete .ui-menu-item a {\n  line-height: 1.35;\n  position: relative;\n  display: block;\n  padding: 0.6em 0.75em;\n  text-decoration: none;\n}\n", ""]);

// exports


/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'on-site-contact-search',
  props: {
    placeholder: String,
    initialText: String,
    isRequired: {
      type: Boolean,
      default: false
    },
    enableClassBase: {
      type: Boolean,
      default: true
    },
    inputClass: Object,
    identity: {
      type: String,
      default: 'input-box'
    },
    onSiteContacts: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      text: '',
      is_show: true,
      typingTimer: null,
      doneTypingInterval: 300,
      is_read_initial_tex: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log('The one that got the ');
    document.addEventListener('click', function (evt) {
      var flyoutElement = document.getElementById(_this.identity);
      var targetElement = evt.target;
      do {
        if (targetElement === flyoutElement) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      _this.is_show = false;
    });

    if (this.initialText !== '') {
      this.is_show = false;
      this.text = this.initialText;
    }
  },

  methods: {
    onFocus: function onFocus() {
      if (this.initialText !== '' && !this.is_read_initial_tex) {
        this.is_read_initial_tex = true;
        return;
      }
      this.is_show = true;
    },
    onSelectItem: function onSelectItem(dato) {
      this.is_show = false;
      this.text = dato.contactName;
      this.$emit('itemselected', dato);
    },
    writeup: function writeup() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);
    },
    writedown: function writedown() {
      clearTimeout(this.typingTimer);
    },
    doneTyping: function doneTyping() {
      this.$emit('search', this.text);
    }
  },
  watch: {
    text: function text(val) {
      if (!this.is_read_initial_tex) {
        this.is_read_initial_tex = true;
      }
    }
  }
});

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "content-input": _vm.enableClassBase },
      attrs: { id: _vm.identity }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text"
          }
        ],
        staticClass: "input-txt",
        class: _vm.inputClass,
        attrs: {
          type: "text",
          required: _vm.isRequired,
          placeholder: _vm.placeholder
        },
        domProps: { value: _vm.text },
        on: {
          keydown: function($event) {
            _vm.writedown($event)
          },
          keyup: function($event) {
            _vm.writeup($event)
          },
          focus: function($event) {
            _vm.onFocus()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.text = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "ui-autocomplete",
          class: { active: _vm.text != "" && _vm.is_show }
        },
        [
          _vm.text != "" && _vm.is_show
            ? _c(
                "div",
                { staticClass: "show-result" },
                _vm._l(_vm.onSiteContacts, function(dato, idx) {
                  return _c(
                    "li",
                    { key: idx, staticClass: "ui-menu-item item-found" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "ui-item-result person",
                          attrs: { tabindex: "-1" },
                          on: {
                            click: function($event) {
                              _vm.onSelectItem(dato)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "info-container" }, [
                            _c(
                              "div",
                              { staticStyle: { "max-width": "150px" } },
                              [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(dato.contactName))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-group" }, [
                                  dato.contactPhone != undefined
                                    ? _c("span", { staticClass: "phone" }, [
                                        dato.contactPhone
                                          ? _c("span", [
                                              _vm._v(_vm._s(dato.contactPhone))
                                            ])
                                          : _c("span", [_vm._v("N/A")])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  dato.contactEmail != undefined
                                    ? _c("span", { staticClass: "email" }, [
                                        _vm._v(_vm._s(dato.contactEmail))
                                      ])
                                    : _c("span", [_vm._v("N/A")])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div")
                        ]
                      )
                    ]
                  )
                })
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a5bbf14", esExports)
  }
}

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "DraftEventModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "draft-events-modal", on: { click: _vm.onSaveDraft } },
        [
          _c("div", { staticClass: "header-modal" }, [
            _c("div", { staticClass: "container-title" }, [
              _c("p", { staticClass: "draft-event" }, [_vm._v("Draft Event")]),
              _vm._v(" "),
              _c("div", { staticClass: "add-on-wrapper" }, [
                _c("div", { staticClass: "event-add-on" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentEvent.isLive,
                        expression: "currentEvent.isLive"
                      }
                    ],
                    attrs: { type: "checkbox", id: "is-live" },
                    domProps: {
                      checked: Array.isArray(_vm.currentEvent.isLive)
                        ? _vm._i(_vm.currentEvent.isLive, null) > -1
                        : _vm.currentEvent.isLive
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.currentEvent.isLive,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.currentEvent,
                                  "isLive",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.currentEvent,
                                  "isLive",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.currentEvent, "isLive", $$c)
                          }
                        },
                        function($event) {
                          _vm.updateIsLiveEvent("LIVE")
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "is-live" } }, [_vm._v("Toggle")])
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { class: { "text-toggle-on": _vm.currentEvent.isLive } },
                  [_vm._v("Live")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-close", on: { click: _vm.hideModal } },
              [_c("div", { staticClass: "icon-close" })]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-title" }, [_vm._v("Event Information")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [_vm._v("Event Name")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.eventName,
                    expression: "currentEvent.eventName"
                  }
                ],
                attrs: { placeholder: "State - City #" },
                domProps: { value: _vm.currentEvent.eventName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentEvent, "eventName", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-3 field-input" },
              [
                _c("label", [
                  _vm._v("Date"),
                  _c("span", { staticClass: "require-askterisk" }, [
                    _vm._v("*")
                  ])
                ]),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: {
                    format: "MM/dd/yyyy",
                    placeholder: "MM/DD/YY",
                    value: _vm.currentEvent.prefDate
                  },
                  on: { selected: _vm.onChangeDate }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [
                _vm._v("Leads"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.maxStaffLead,
                    expression: "currentEvent.maxStaffLead"
                  }
                ],
                attrs: { placeholder: "# of leads" },
                domProps: { value: _vm.currentEvent.maxStaffLead },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.currentEvent,
                      "maxStaffLead",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _vm.currentEvent.maxStaffLead <= 0
                ? _c("div", { staticClass: "row log-error" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-1 icon-alert" },
                      [
                        _c("Icon", {
                          staticClass:
                            "row-detail-icon row-detail-icon-exclamation-circle",
                          attrs: { name: "exclamation-circle" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-11 text-alert" }, [
                      _c("span", { staticClass: "alert-note" }, [
                        _vm._v("The number of leads must be greater than 0")
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [
                _vm._v("Participation"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.projPart,
                    expression: "currentEvent.projPart"
                  }
                ],
                attrs: { placeholder: "# of expected participants" },
                domProps: { value: _vm.currentEvent.projPart },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentEvent, "projPart", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.currentEvent.projPart <= 0
                ? _c("div", { staticClass: "row log-error" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-1 icon-alert" },
                      [
                        _c("Icon", {
                          staticClass:
                            "row-detail-icon row-detail-icon-exclamation-circle",
                          attrs: { name: "exclamation-circle" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-11 text-alert" }, [
                      _c("span", { staticClass: "alert-note" }, [
                        _vm._v(
                          "The number of participants must be greater than 0"
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-title" }, [_vm._v("Address")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6 field-input" },
              [
                _c("label", [
                  _vm._v("Full Address"),
                  _c("span", { staticClass: "require-askterisk" }, [
                    _vm._v("*")
                  ])
                ]),
                _vm._v(" "),
                _c("vue-google-autocomplete", {
                  class: { "border-error": _vm.isAddressError },
                  attrs: {
                    name: "address-input",
                    id: "map_address",
                    country: ["us"],
                    item: _vm.currentEvent,
                    placeholder: "Enter full address"
                  },
                  on: { placechanged: _vm.setPlace }
                }),
                _vm._v(" "),
                _vm.isAddressError
                  ? _c("span", { staticClass: "text-error" }, [
                      _vm._v(_vm._s(_vm.addressErrorMessage))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [_vm._v("Building/Suite")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.building,
                    expression: "currentEvent.building"
                  }
                ],
                attrs: { placeholder: "Enter building name" },
                domProps: { value: _vm.currentEvent.building },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentEvent, "building", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [_vm._v("Location")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.eventLocation,
                    expression: "currentEvent.eventLocation"
                  }
                ],
                attrs: { placeholder: "Enter event room" },
                domProps: { value: _vm.currentEvent.eventLocation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.currentEvent,
                      "eventLocation",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-title" }, [_vm._v("Times")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [
                _vm._v("Start Time"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentEvent.startTime,
                      expression: "currentEvent.startTime"
                    }
                  ],
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.currentEvent,
                          "startTime",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      _vm.onChangTime
                    ]
                  }
                },
                _vm._l(_vm.listTime, function(time) {
                  return _c(
                    "option",
                    { key: time.name, domProps: { value: time.name } },
                    [_vm._v(_vm._s(time.name))]
                  )
                })
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [
                _vm._v("Duration"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.duration,
                    expression: "currentEvent.duration"
                  }
                ],
                attrs: { placeholder: "Enter duration" },
                domProps: { value: _vm.currentEvent.duration },
                on: {
                  blur: _vm.onChangTime,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentEvent, "duration", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.enableIconDuration
                ? _c("div", { staticClass: "row log-error" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-1 icon-alert" },
                      [
                        _c("Icon", {
                          staticClass:
                            "row-detail-icon row-detail-icon-exclamation-circle",
                          attrs: { name: "exclamation-circle" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-11 text-alert" }, [
                      _c("span", { staticClass: "alert-note" }, [
                        _vm._v(
                          "Standard events can only be submitted with durations between 0 - 10 hours. To request an event outside of this range please contact ADURO."
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [_vm._v("End Time")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.currentEvent.endTime))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [_vm._v("Time Zone")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.currentEvent.timeZone))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [
                _vm._v("Aduro Arrival Time"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentEvent.aduroArrivalTime,
                      expression: "currentEvent.aduroArrivalTime"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.currentEvent,
                        "aduroArrivalTime",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.listTime, function(time) {
                  return _c(
                    "option",
                    { key: time.name, domProps: { value: time.name } },
                    [_vm._v(_vm._s(time.name))]
                  )
                })
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-title" }, [_vm._v("On Site Contact")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-3 field-input" },
              [
                _c("label", [
                  _vm._v("Name"),
                  _c("span", { staticClass: "require-askterisk" }, [
                    _vm._v("*")
                  ])
                ]),
                _vm._v(" "),
                _c("on-site-contact-search", {
                  staticClass: "field-contact",
                  attrs: {
                    "initial-text": _vm.currentEvent.contactName,
                    "on-site-contacts": _vm.onSiteContacts,
                    placeholder: "Enter full name",
                    identity: "draft-onsite-contact"
                  },
                  on: {
                    search: _vm.searchContact,
                    itemselected: _vm.selectOnSiteContact
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 field-input" }, [
              _c("label", [
                _vm._v("Email"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.email,
                    expression: "currentEvent.email"
                  }
                ],
                attrs: { placeholder: "Enter email" },
                domProps: { value: _vm.currentEvent.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentEvent, "email", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 field-input" }, [
              _c("label", [
                _vm._v("Phone Number"),
                _c("span", { staticClass: "require-askterisk" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.phone,
                    expression: "currentEvent.phone"
                  }
                ],
                attrs: { placeholder: "Enter phone number" },
                domProps: { value: _vm.currentEvent.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentEvent, "phone", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-title" }, [_vm._v("Add On Services")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.currentEvent.additionalServices.slice(0, 3), function(
              item,
              index
            ) {
              return item.isShow
                ? _c(
                    "div",
                    { key: index, staticClass: "col-md-3 add-on-wrapper" },
                    [
                      _c("div", { staticClass: "event-add-on" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.value,
                              expression: "item.value"
                            }
                          ],
                          class: _vm.disableAdditionalServices(item.key)
                            ? "greyOut"
                            : null,
                          attrs: {
                            type: "checkbox",
                            id: item.key,
                            disabled: _vm.disableAdditionalServices(item.key)
                          },
                          domProps: {
                            checked: Array.isArray(item.value)
                              ? _vm._i(item.value, null) > -1
                              : item.value
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = item.value,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(item, "value", $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        item,
                                        "value",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(item, "value", $$c)
                                }
                              },
                              function($event) {
                                _vm.checkboxToggle(item.key, item.value)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: item.key } }, [
                          _vm._v("Toggle")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          class: {
                            "text-toggle-on": item.value,
                            greyOut: _vm.disableAdditionalServices(item.key)
                          }
                        },
                        [_vm._v(_vm._s(item.text))]
                      )
                    ]
                  )
                : _vm._e()
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.currentEvent.additionalServices.slice(3, 7), function(
              item,
              index
            ) {
              return item.isShow
                ? _c(
                    "div",
                    { key: index, staticClass: "col-md-3 add-on-wrapper" },
                    [
                      _c("div", { staticClass: "event-add-on" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.value,
                              expression: "item.value"
                            }
                          ],
                          attrs: { type: "checkbox", id: item.key },
                          domProps: {
                            checked: Array.isArray(item.value)
                              ? _vm._i(item.value, null) > -1
                              : item.value
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = item.value,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(item, "value", $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        item,
                                        "value",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(item, "value", $$c)
                                }
                              },
                              function($event) {
                                _vm.checkboxToggle(item.key, item.value)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: item.key } }, [
                          _vm._v("Toggle")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { class: { "text-toggle-on": item.value } }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ]
                  )
                : _vm._e()
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.currentEvent.additionalServices.slice(7, 10), function(
              item,
              index
            ) {
              return item.isShow
                ? _c(
                    "div",
                    { key: index, staticClass: "col-md-3 add-on-wrapper" },
                    [
                      _c("div", { staticClass: "event-add-on" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.value,
                              expression: "item.value"
                            }
                          ],
                          attrs: { type: "checkbox", id: item.key },
                          domProps: {
                            checked: Array.isArray(item.value)
                              ? _vm._i(item.value, null) > -1
                              : item.value
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = item.value,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(item, "value", $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        item,
                                        "value",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(item, "value", $$c)
                                }
                              },
                              function($event) {
                                _vm.checkboxToggle(item.key, item.value)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: item.key } }, [
                          _vm._v("Toggle")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { class: { "text-toggle-on": item.value } }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ]
                  )
                : _vm._e()
            })
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-title" }, [_vm._v("Event Notes")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 field-input" }, [
              _c("label", [
                _vm._v(
                  "Shipping Address - Enter if different than event address"
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.shippingAddress,
                    expression: "currentEvent.shippingAddress"
                  }
                ],
                attrs: { placeholder: "Enter shipping address" },
                domProps: { value: _vm.currentEvent.shippingAddress },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.currentEvent,
                      "shippingAddress",
                      $event.target.value
                    )
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 field-input" }, [
              _c("label", [_vm._v("Custom Event Notes")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.customEventNote,
                    expression: "currentEvent.customEventNote"
                  }
                ],
                attrs: { placeholder: "Enter event notes" },
                domProps: { value: _vm.currentEvent.customEventNote },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.currentEvent,
                      "customEventNote",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 field-input" }, [
              _c("label", [_vm._v("On Site Instructions")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.onsiteInstruction,
                    expression: "currentEvent.onsiteInstruction"
                  }
                ],
                attrs: { placeholder: "Enter On Site Instructions" },
                domProps: { value: _vm.currentEvent.onsiteInstruction },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.currentEvent,
                      "onsiteInstruction",
                      $event.target.value
                    )
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 field-input" }, [
              _c("label", [_vm._v("Parking Instructions")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentEvent.parkingInformation,
                    expression: "currentEvent.parkingInformation"
                  }
                ],
                attrs: { placeholder: "Enter Parking Instructions" },
                domProps: { value: _vm.currentEvent.parkingInformation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.currentEvent,
                      "parkingInformation",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "b-button",
                { staticClass: "btn-cancel", on: { click: _vm.hideModal } },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-right-container" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-submit",
                      attrs: { disabled: _vm.enableBtnSave },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("\n          Submit\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-save",
                      attrs: { disabled: _vm.enableBtnSave },
                      on: { click: _vm.onSave }
                    },
                    [
                      _vm.loadingSaveDraft ? _c("b-spinner") : _vm._e(),
                      _vm._v("\n          Save as Draft\n        ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("ModalSubmitDrafts", {
                attrs: { currentEvent: _vm.currentEvent }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d78af58", esExports)
  }
}

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Plan"),
      _vm._v(" "),
      _c("CustomMessageModal"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("ModalChangeOrderDetail"),
      _vm._v(" "),
      _c("HistoryModal"),
      _vm._v(" "),
      _c("BulkCreateEvents"),
      _vm._v(" "),
      _c("DraftEventModal"),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EventStaffingDetail")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-731e55d4", esExports)
  }
}

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a2ace2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__(2016);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1989)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a2ace2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/clientView/Reports.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Reports.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61a2ace2", Component.options)
  } else {
    hotAPI.reload("data-v-61a2ace2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1990);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("34c4888e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-61a2ace2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reports.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-61a2ace2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n", ""]);

// exports


/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Reports_vue__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//


// import consts from '../../../_consts';









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-report-page',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */],
    Reports: __WEBPACK_IMPORTED_MODULE_2__components_eventManagement_main_Reports_vue__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({})),
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},

  watch: {}
});

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507efb36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__(2015);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1993)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-507efb36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507efb36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/main/Reports.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Reports.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-507efb36", Component.options)
  } else {
    hotAPI.reload("data-v-507efb36", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1994);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8c40bc1c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-507efb36\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reports.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-507efb36\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.wrapper[data-v-507efb36] {\n  padding: 24px 16px 24px 16px;\n}\n.wrapper .container-header[data-v-507efb36] {\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 40px;\n  text-transform: uppercase;\n}\n.wrapper .icon-information[data-v-507efb36] {\n  display: inline-block;\n  margin: 0 8px;\n  width: 24px;\n  height: 24px;\n  color: #b9b9b9;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  mask: url(" + __webpack_require__(38) + ") no-repeat center;\n  background: url(" + __webpack_require__(838) + ");\n}\n.wrapper .status-menu[data-v-507efb36] {\n  color: #B9B9B9;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n  list-style: none;\n  -webkit-padding-start: 0;\n  margin-top: 18px;\n}\n.wrapper .status-menu li.status-menu-item[data-v-507efb36] {\n  display: inline;\n  margin-right: 49px;\n  text-transform: capitalize;\n  padding-bottom: 10px;\n}\n.wrapper .status-menu li.status-menu-item[data-v-507efb36]:hover,\n.wrapper .status-menu li.status-menu-item.selected[data-v-507efb36] {\n  color: #00A4D6;\n  border-bottom: solid 3px #00A4D6;\n  cursor: pointer;\n}\n.wrapper .status-message[data-v-507efb36] {\n  margin-top: 16px;\n  height: 24px;\n  color: #424242;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n}\n.wrapper .event-found[data-v-507efb36] {\n  color: #8E8E8E;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin-top: 32px;\n}\n.wrapper .grp-button-action[data-v-507efb36] {\n  margin-top: 16px;\n}\n.wrapper .grp-button-action .item-submit-btn[data-v-507efb36] {\n  border: 1px solid #00A4D6;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  float: right;\n  padding: 6px 24px;\n}\n.wrapper .grp-button-action .item-submit-btn span[data-v-507efb36] {\n  font-weight: 600;\n  color: #00A4D6;\n  font-size: 16px;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.wrapper .grp-button-action .item-create-btn[data-v-507efb36] {\n  background-color: #00A4D6;\n  margin-left: 16px;\n  float: right;\n  padding: 6px 24px;\n}\n.wrapper .grp-button-action .item-create-btn span[data-v-507efb36] {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.wrapper .no-event-found[data-v-507efb36] {\n  text-align: center;\n  margin: 64px auto 0;\n}\n.wrapper .no-event-found .text[data-v-507efb36] {\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.wrapper .no-event-found .item-create-btn[data-v-507efb36] {\n  background-color: #00A4D6;\n  margin-top: 16px;\n  padding: 6px 24px;\n}\n.wrapper .no-event-found .item-create-btn span[data-v-507efb36] {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  font-family: 'Open Sans', sans-serif;\n}\n.wrapper .bar-chart-color[data-v-507efb36] {\n  width: 10px;\n  height: 10px;\n  float: left;\n  line-height: 15px;\n  margin-top: 3px;\n}\n.wrapper .bar-chart-text[data-v-507efb36] {\n  float: left;\n  margin-left: 8px;\n  line-height: 15px;\n}\n.wrapper .label-wrapper[data-v-507efb36] {\n  height: 20px;\n  display: inline-block;\n}\n.event-chart-section[data-v-507efb36] {\n  margin-top: 41px;\n}\n", ""]);

// exports


/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_datatable_DataTable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subHeaders_SubHeaderManageReports__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reports_EventChart__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_datatable_DtPaging__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reports_EventBarChart__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_EventCompletedReportCard__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_file_excel_o__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_question_circle_o__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_users__ = __webpack_require__(98);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-report-main-view',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_2__components_datatable_DataTable__["a" /* default */],
    SubHeaderManageReports: __WEBPACK_IMPORTED_MODULE_5__subHeaders_SubHeaderManageReports__["a" /* default */],
    EventChart: __WEBPACK_IMPORTED_MODULE_6__reports_EventChart__["a" /* default */],
    DtPaging: __WEBPACK_IMPORTED_MODULE_7__components_datatable_DtPaging__["a" /* default */],
    EventBarChart: __WEBPACK_IMPORTED_MODULE_8__reports_EventBarChart__["a" /* default */],
    EventCompletedReportCard: __WEBPACK_IMPORTED_MODULE_9__commons_EventCompletedReportCard__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      message: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].reportMessage.upcoming,
      tableType: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].reportType.upcoming,
      consts: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */],
      sliderValue: ['0', '0'],
      dataFilter: ['dateTime'],
      textSearch: '',
      pagingObj: {
        currentPage: 1,
        itemsPerPage: 25,
        sortType: 'firstName',
        sortReverse: false,
        totalItems: 0
      },
      wrapperChart: {
        row1: {
          chartDataTable: ['Overall', 'Professionalism', 'Willingness to Recommend', 'Communication', 'Preparedness'],
          chartColors: ['#FF4040', '#A60000', '#FF7400', '#A64B00', '#CD0074']
        },
        row2: {
          chartDataTable: ['On-Time Start and Finish', 'Check-in Process', 'Professionalism - Coach', ' Professionalism - Screener', 'Professionalism - Lead'],
          chartColors: ['#E667AF', '#00CC00', '#008500', '#0F4DA8', '#052F6D']
        },
        row3: {
          chartDataTable: ['Scheduler Tool', 'Reporting', 'Participant Feedback', 'Data Transfer', 'Event Breakdown'],
          chartColors: ['#B1F100', '#D4F870', '#AF3BD4', '#E9FB00', '#F3FD72']
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getEventListReports: 'GETTER_GET_EVENT_LIST_REPORTS'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    handleTextSearchChange: function handleTextSearchChange(textSearch) {
      this.textSearch = textSearch;
      // this.reloadDataWithChangeFilterData();
    },
    handleSliderChangeValue: function handleSliderChangeValue(data) {
      this.sliderValue = data;
    },
    handleChangeDataFilter: function handleChangeDataFilter(data) {
      this.dataFilter = data;
    },
    navigateTab: function navigateTab(tab) {
      this.tableType = tab;
      var reportChildRouterName = __WEBPACK_IMPORTED_MODULE_10__router_constants__["a" /* default */].clientDashboard.children.reports.children;
      var routerName = tab === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].reportType.upcoming ? reportChildRouterName.upcoming.name : reportChildRouterName.completed.name;
      this.$router.push({
        name: routerName,
        params: {
          clientId: this.$route.params.clientId
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({})),
  created: function created() {
    this.tableType = __WEBPACK_IMPORTED_MODULE_10__router_constants__["a" /* default */].clientDashboard.children.reports.children.upcoming.name === this.$route.name ? __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].reportType.upcoming : __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].reportType.completed;
  }
});

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderManageReports_vue__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b11f8a08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderManageReports_vue__ = __webpack_require__(2000);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1997)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b11f8a08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderManageReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b11f8a08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderManageReports_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderManageReports.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderManageReports.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b11f8a08", Component.options)
  } else {
    hotAPI.reload("data-v-b11f8a08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6296ddf5", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b11f8a08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderManageReports.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b11f8a08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderManageReports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.paddingLeft9px[data-v-b11f8a08] {\n  padding-left: 9px;\n}\n.backgroundColor[data-v-b11f8a08] {\n  background-color: #f5f5f5 !important;\n}\n.subHeader[data-v-b11f8a08] {\n  /*height: 96px;*/\n  background-color: #f5f5f5;\n  z-index: 990;\n}\n.subHeader .filter-wrapper[data-v-b11f8a08] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n}\n.subHeader .filter-wrapper .scroll-up-wrapper[data-v-b11f8a08] {\n  position: absolute;\n  right: 20px;\n  width: 20px;\n  height: 20px;\n}\n.subHeader .filter-wrapper .date-out-wrapper[data-v-b11f8a08] {\n  max-width: 230px;\n}\n.subHeader .title[data-v-b11f8a08] {\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  height: 20px;\n  text-transform: uppercase;\n}\n.subHeader .marginTop10px[data-v-b11f8a08] {\n  margin-top: 10px;\n}\n.subHeader .dateOut[data-v-b11f8a08] {\n  position: relative;\n  top: -15px;\n}\n.subHeader .paddingLeft19px[data-v-b11f8a08] {\n  padding-left: 19px !important;\n}\n.subHeader .active-wrapper[data-v-b11f8a08] {\n  border-color: #085269 !important;\n  background-color: #085269;\n}\n.subHeader .icon-wrapper[data-v-b11f8a08] {\n  border: solid 1px #00A4D6;\n  border-radius: 3px;\n  width: 32px;\n  height: 32px;\n  position: relative;\n  text-align: center;\n  float: left;\n  margin-right: 16px;\n}\n.subHeader .icon-wrapper[data-v-b11f8a08]:hover {\n  cursor: pointer;\n}\n.subHeader .icon-wrapper.marginTop11px[data-v-b11f8a08] {\n  margin-top: 11px;\n}\n.subHeader .icon-wrapper .icon-filter[data-v-b11f8a08] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  -webkit-mask: url(" + __webpack_require__(164) + ") no-repeat center;\n  mask: url(" + __webpack_require__(164) + ") no-repeat center;\n  background: url(" + __webpack_require__(405) + ");\n}\n.subHeader .icon-wrapper .active[data-v-b11f8a08] {\n  color: #ffffff;\n  background-color: #ffffff;\n}\n.subHeader .icon-wrapper ul.action-panel[data-v-b11f8a08] {\n  list-style: none;\n  font-size: 12px;\n  line-height: 26px;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 0;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n  position: absolute;\n  top: 32px;\n  left: 0;\n  width: 215px;\n  z-index: 9999;\n}\n.subHeader .icon-wrapper ul.action-panel .title[data-v-b11f8a08] {\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  color: #1A1718;\n}\n.subHeader .icon-wrapper ul.action-panel li[data-v-b11f8a08] {\n  /* On mouse-over, add a grey background color */\n  /* When the checkbox is checked, add a blue background */\n  /* Show the checkmark when checked */\n}\n.subHeader .icon-wrapper ul.action-panel li[data-v-b11f8a08]:last-child {\n  border-bottom: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .checkbox-active[data-v-b11f8a08] {\n  color: #00A4D6 !important;\n  font-weight: bold;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox[data-v-b11f8a08] {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 0;\n  color: #626262;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox input[data-v-b11f8a08] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  left: 0;\n  bottom: 6px;\n  width: 16px;\n  height: 16px;\n  z-index: 10;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox .checkmark[data-v-b11f8a08] {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #FFFFFF;\n  border: solid 1px #b9b9b9;\n  z-index: 1;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox .checkmark[data-v-b11f8a08]::after {\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox input:checked ~ .checkmark[data-v-b11f8a08] {\n  background-color: #00A4D6;\n  color: #00A4D6;\n  border: none;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox input:checked ~ .checkmark[data-v-b11f8a08]:after {\n  display: block;\n}\n.subHeader .icon-wrapper ul.action-panel li .input-checkbox ~ .checkmark[data-v-b11f8a08]:after {\n  color: #00A4D6;\n}\n.subHeader .group-button-sub-header[data-v-b11f8a08] {\n  float: right;\n  top: 120px;\n  margin: 65px 30px 0 0;\n}\n.subHeader .placeholder-italic[data-v-b11f8a08] {\n  font-family: 'Open Sans', sans-serif;\n  color: #231f20;\n  border-radius: 4px;\n  z-index: unset;\n  background-color: #ffffff;\n  padding: 12px 16px;\n  font-size: 16px;\n  line-height: 20px;\n  height: 42px;\n}\n.subHeader .search-icon[data-v-b11f8a08] {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 999;\n  color: #00A4D6;\n  width: 20px;\n  height: 25px;\n}\n.subHeader .search-icon[data-v-b11f8a08]:hover {\n  cursor: pointer;\n  color: #00A4D6;\n}\n.subHeader .content-header[data-v-b11f8a08] {\n  width: 250px;\n}\n.subHeader .float-left[data-v-b11f8a08] {\n  float: left;\n}\n.subHeader .float-right[data-v-b11f8a08] {\n  float: right;\n}\n.subHeader .label[data-v-b11f8a08] {\n  height: 16px;\n  width: 77.8px;\n  color: #444444;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.subHeader .search-icon[data-v-b11f8a08] {\n  height: 25px;\n  width: 25px;\n  background-color: #3caae9;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.subHeader .upIcon[data-v-b11f8a08] {\n  float: right;\n}\n.subHeader .scrollIcon[data-v-b11f8a08] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.subHeader .display-none-something[data-v-b11f8a08] {\n  display: none;\n}\n.subHeader .marginTop6px[data-v-b11f8a08] {\n  margin-top: 6px;\n}\n.sorted-text[data-v-b11f8a08] {\n  height: 42px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 42px;\n  white-space: nowrap;\n}\n", ""]);

// exports


/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import consts from '../../_consts';






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderManageReports',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getValue: function getValue(name) {},
    selectStatus: function selectStatus(item) {
      this.listChecked = [item.key];
      this.selectedSortText = item.text;
      this.$emit('CHANGE_FILTER_OPTION', this.listChecked);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({}), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
    searchApprovedEvent: 'MUTATION_SEARCH_APPROVED_EVENT',
    mutationSaveManageEventReports: 'MUTATION_SAVE_MANAGE_EVENT_REPORTS',
    mutationGetSliderValueReports: 'MUTATION_SAVE_SLIDER_VALUE_REPORTS'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    getterGetSliderValueReports: 'GETTER_GET_SLIDER_VALUE_REPORTS'
  })),
  watch: {
    textSearch: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {
      var keyword = this.textSearch.trim().toLowerCase();
      if (keyword.length >= 2 || keyword.length === 0) {
        this.$emit('TEXT_SEARCH_CHANGE', keyword);
      }
    }, 700),
    pagingObj: {
      handler: function handler() {
        this.getValue('slider');
      },
      deep: true
    },
    eventStatus: {
      handler: function handler() {
        this.getValue('slider');
      },
      deep: true
    },
    'datesOut.value': __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {
      this.$emit('SLIDER_CHANGE_VALUE', this.datesOut.value);
    }, 300)
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */],
    VueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a,
    ScrollTop: __WEBPACK_IMPORTED_MODULE_4__utils_ScrollTop__["a" /* default */]
  },
  props: {
    fixElement: {
      type: Boolean,
      default: false
    },
    pagingObj: {
      type: Object,
      default: {}
    },
    eventStatus: {
      type: String,
      default: ''
    },
    sliderValue: {
      type: Array,
      required: true
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.datesOut.value[0] = this.getterGetSliderValueReports.noBeginDates || '0';
    this.datesOut.value[1] = this.getterGetSliderValueReports.noEndDates || '60+';
  },
  data: function data() {
    return {
      listEventStatus: [{
        text: 'Date (closest to farthest)',
        count: 200,
        isCheck: false,
        key: 'dateTime'
      }, {
        text: 'Event Name (alphabetical)',
        count: 0,
        isCheck: false,
        key: 'eventName'
      }, {
        text: 'Participation (most to least)',
        count: 100,
        isCheck: false,
        key: 'projPart'
      }, {
        text: 'City (alphabetical)',
        count: 100,
        isCheck: false,
        key: 'city'
      }, {
        text: 'State (alphabetical)',
        count: 100,
        isCheck: false,
        key: 'state'
      }],
      isShowAction: false,
      datesOut: {
        value: ['0', '0'],
        width: '182px',
        tooltip: false,
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        dotSize: 8,
        interval: 7,
        formatter: '{value}',
        overlapFormatter: '{value1} ~ {value2}',
        data: ['0', '7', '14', '30', '60', '60+'],
        piecewiseStyle: {
          backgroundColor: 'transparent',
          visibility: 'visible',
          width: '15px',
          height: '15px'
        },
        piecewiseActiveStyle: {
          backgroundColor: '#00A4D6'
        },
        processStyle: {
          backgroundColor: '#00A4D6'
        }
      },
      textSearch: '',
      listChecked: ['dateTime'],
      selectedSortText: 'Date (closest to farthest)'
    };
  }
});

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "subHeader", class: { backgroundColor: _vm.isBackground } },
    [
      _c(
        "div",
        { staticClass: "noMargin", class: { paddingTop27px: !_vm.fixElement } },
        [
          _c("div", { staticClass: "filter-wrapper row" }, [
            _vm.eventStatus == "upcoming"
              ? _c("div", { staticClass: "date-out-wrapper col-md-4" }, [
                  !_vm.fixElement
                    ? _c("div", { staticClass: "dateOut" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("DATES OUT")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: { marginTop10px: _vm.fixElement } },
                    [
                      _c(
                        "vue-slider",
                        _vm._b(
                          {
                            ref: "slider",
                            nativeOn: {
                              click: function($event) {
                                _vm.getValue("slider")
                              }
                            },
                            model: {
                              value: _vm.datesOut.value,
                              callback: function($$v) {
                                _vm.$set(_vm.datesOut, "value", $$v)
                              },
                              expression: "datesOut.value"
                            }
                          },
                          "vue-slider",
                          _vm.datesOut,
                          false
                        )
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-search-wrapper col-md-4" },
              [
                _c(
                  "b-input-group",
                  { staticClass: "ap-input-wrapper" },
                  [
                    _c("b-form-input", {
                      staticClass: "placeholder-italic input body-text",
                      class: { marginTop6px: _vm.fixElement },
                      attrs: {
                        type: "text",
                        placeholder: "Search by event info",
                        formatter: _vm.format
                      },
                      on: {
                        change: function($event) {
                          _vm.getValue("slider")
                        }
                      },
                      model: {
                        value: _vm.textSearch,
                        callback: function($$v) {
                          _vm.textSearch = $$v
                        },
                        expression: "textSearch"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-icon" })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4 filter-btn-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "icon-wrapper marginTop6px",
                  class: {
                    "active-wrapper": _vm.isShowAction,
                    marginTop11px: _vm.fixElement
                  },
                  on: {
                    click: function($event) {
                      _vm.isShowAction = true
                    },
                    mouseleave: function($event) {
                      _vm.isShowAction = false
                    }
                  }
                },
                [
                  _c("Icon", {
                    staticClass: "icon-filter",
                    class: { active: _vm.isShowAction },
                    attrs: { name: "filter" }
                  }),
                  _vm._v(" "),
                  _vm.isShowAction
                    ? _c(
                        "ul",
                        { staticClass: "action-panel" },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("Display")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.listEventStatus, function(item) {
                            return _c("li", { key: item.text }, [
                              _c(
                                "div",
                                {
                                  staticClass: "input-checkbox",
                                  class: { "checkbox-active": item.isCheck }
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.text) + "\n                "
                                  ),
                                  _c("input", {
                                    attrs: { type: "checkbox", title: "" },
                                    domProps: {
                                      checked:
                                        _vm.listChecked.indexOf(item.key) >= 0
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.selectStatus(item)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "checkmark" })
                                ]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sorted-text" }, [
                _vm._v("sort by "),
                _c("span", { staticStyle: { "font-weight": "600" } }, [
                  _vm._v(_vm._s(_vm.selectedSortText))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "scroll-up-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "upIcon",
                  class: {
                    "display-none-something": !_vm.fixElement,
                    scrollIcon: _vm.fixElement
                  }
                },
                [_c("ScrollTop")],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b11f8a08", esExports)
  }
}

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2002);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("ebd9df3c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-94099b20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventChart.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-94099b20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventChart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.event-chart[data-v-94099b20] {\n  padding: 16px 0 16px 16px;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n  height: 300px;\n  width: 270px;\n  float: left;\n  margin-top: 24px;\n}\n.event-chart .event-name[data-v-94099b20] {\n  height: 24px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.event-chart .event-date[data-v-94099b20] {\n  height: 16px;\n  color: #1D1D1D;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.event-chart .chart-data-type[data-v-94099b20] {\n  height: 24px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  position: absolute;\n  top: 0;\n  right: 8px;\n}\n.event-chart .event-info[data-v-94099b20] {\n  position: relative;\n  margin-bottom: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports


/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_chart__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bar_chart__ = __webpack_require__(844);

//
//
//
//
//
//
//
//
//
//
//
//




// import moment from 'moment';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-chart',
  components: {
    EventChart: __WEBPACK_IMPORTED_MODULE_2__event_chart__["a" /* default */],
    EventBarChart: __WEBPACK_IMPORTED_MODULE_3__event_bar_chart__["a" /* default */]
  },
  data: function data() {
    return {
      chartData: {
        labels: [],
        data: [],
        expectedValue: 0,
        startDate: '',
        endDate: ''
      },
      chartItemNumber: 0
    };
  },

  props: {
    eventItem: {
      type: Object,
      default: {}
    },
    reportType: {
      type: String,
      default: 'upcoming'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
  }), {
    beginDateOfWeek: function beginDateOfWeek(y, w) {
      var d = w * 7;
      return new Date(y, 0, d);
    },
    endDateOfWeek: function endDateOfWeek(y, w) {
      var d = w * 7;
      return new Date(y, 0, d);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.actionGetEventReportChart({ eventId: this.eventItem.id, reportType: this.reportType }).then(function (response) {
      if (response.message === null) {
        // console.log('actionGetEventReportChart:', response);
        var chartData = response.chartData || [];
        _this.chartData.expectedValue = response.expectedValue;

        // let startMonth = moment(response.startDate, 'MM/DD/YYYY').format('MMM');
        // let endMonth = moment(response.endDate, 'MM/DD/YYYY').format('MMM');
        chartData.forEach(function (item, index) {
          if (index === 0) {
            _this.chartData.labels.push('');
            _this.chartData.startDate = item.endDate;
          } else if (index === chartData.length - 1) {
            // if (chartData.length < 4) {

            //   this.chartData.labels.push('');
            //   this.chartData.data.push(0);
            //   this.chartData.data.push(0);
            // }
            // let endMonth = moment(this.endDateOfWeek(item.year, item.week)).format('MMM');
            _this.chartData.labels.push('');
            _this.chartData.endDate = item.endDate;
          } else {
            _this.chartData.labels.push('');
          }
          _this.chartData.data.push(item.sumToEndDate);
        });
        _this.chartData.data.push(null);
        // this.chartData.labels.push('');
        // console.log('actionGetEventReportChart:', this.chartData);
      } else {
        console.log('actionGetEventReportChart error:', response.message);
      }
    });
  }
});

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);




__WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.pluginService.register({
  afterDraw: function afterDraw(chart, easing) {
    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
      // var helpers = Chart.helpers;
      var expectedValue = chart.data.expectedValue;
      var data = chart.data.datasets[0].data;
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;
      // // console.log(chartArea.bottom);
      //
      // // console.log(chart.config.options.dataSize);
      ctx.save();
      ctx.strokeStyle = 'rgba(0, 0, 0)'; // chart.config.options.chartArea.backgroundColor;
      ctx.lineWidth = 2;
      ctx.setLineDash([7, 3]);
      if (data && data.length) {
        ctx.beginPath();
        var maxY = Math.max(expectedValue, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
        var maxVal = parseInt(maxY / 10 + 0.5) * 10 + Math.max(10, maxY * 0.1);
        var topLine = chartArea.bottom - (chartArea.bottom - chartArea.top) * expectedValue / maxVal;
        ctx.moveTo(chartArea.left - 10, topLine);
        ctx.lineTo(chartArea.right, topLine);
        ctx.stroke();

        // draw text expected
        ctx.font = '600 12px OpenSans';
        ctx.fillStyle = '#1D1D1D';
        ctx.textAlign = 'center';

        ctx.fillText('expected sign ups', (chartArea.right + chartArea.left) / 2, topLine - 20 < 0 ? topLine + 16 : topLine - 12);

        var topFooter = chartArea.bottom + 16;
        ctx.fillStyle = '#424242';
        ctx.textAlign = 'center';
        ctx.fillText(chart.data.startDate, chartArea.left / 2 + 25, topFooter);
        ctx.fillText(chart.data.endDate, chartArea.right - 15, topFooter);

        topFooter += 14;
        ctx.fillStyle = '#8E8E8E';
        ctx.fillText('Event Live', chartArea.left / 2 + 25, topFooter);
        ctx.fillText('Current Day', chartArea.right - 15, topFooter);
        // draw labels
      }
      ctx.restore();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["a" /* Line */],
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["c" /* mixins */].reactiveProp],
  props: {
    labels: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    },
    expectedValue: 0,
    startDate: '',
    endDate: ''
  },
  mounted: function mounted() {},

  watch: {
    data: {
      handler: function handler() {
        var maxValue = Math.max(this.expectedValue, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.data)));
        this.renderChart({
          // array data label from index 0, 1, ... =count

          labels: this.labels,
          expectedValue: this.expectedValue,
          startDate: this.startDate,
          endDate: this.endDate,
          datasets: [{
            label: '',
            // array data value at position 0, 1, 2...=count-1
            data: this.data,
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(139, 197, 213, 0.8)',
            pointBackgroundColor: 'rgba(139, 197, 213, 0.8)',
            pointBorderWidth: 1,
            pointRadius: 4,
            borderWidth: 3,
            pointHoverRadius: 20,
            showLine: true,

            lineTension: 0.1 // smooth line
            // steppedLine: true,
          }]
        }, {
          dataSize: this.data.length,
          chartArea: {
            backgroundColor: '#f5f5f5'
            // backgroundColor: '#ff0000'
          },
          layout: {
            padding: {
              left: 0,
              right: 30,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(66,66,66,1)',
                display: false,
                drawBorder: false
              },
              ticks: {
                padding: 15 // spacing with label
              }
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(221, 221, 221, 0.8)',
                display: true,
                drawBorder: false,
                zeroLineColor: 'rgba(221, 221, 221, 0.8)'
              },
              ticks: {
                padding: 5,
                min: 0,
                max: parseInt(maxValue / 10 + 0.5) * 10 + Math.max(10, maxValue * 0.1) // calculate max data value
              }
            }]
          },
          legend: {
            display: false // hide header
          },
          tooltips: {
            enabled: true
          },

          responsive: true,
          maintainAspectRatio: false
        });
      },
      deep: true
    }
  }
});

/***/ }),
/* 2005 */,
/* 2006 */,
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-chart" },
    [
      _c("div", { staticClass: "event-info" }, [
        _c("div", { staticClass: "event-name" }, [
          _vm._v(_vm._s(_vm.eventItem.eventName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "event-date" }, [
          _vm._v("Event Date: " + _vm._s(_vm.eventItem.prefDate))
        ])
      ]),
      _vm._v(" "),
      _c("EventChart", {
        attrs: {
          labels: _vm.chartData.labels,
          data: _vm.chartData.data,
          expectedValue: _vm.chartData.expectedValue,
          startDate: _vm.chartData.startDate,
          endDate: _vm.chartData.endDate,
          width: 254,
          height: 200
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-94099b20", esExports)
  }
}

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBarChart_vue__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3471d92e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventBarChart_vue__ = __webpack_require__(2012);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2009)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3471d92e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBarChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3471d92e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EventBarChart_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/reports/EventBarChart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EventBarChart.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3471d92e", Component.options)
  } else {
    hotAPI.reload("data-v-3471d92e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2010);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("06506cd1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3471d92e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventBarChart.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3471d92e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EventBarChart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.event-chart[data-v-3471d92e] {\n  padding: 12px 0 12px 16px;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n  height: 300px;\n  width: 270px;\n  float: left;\n  margin-right: 24px;\n  margin-bottom: 26px;\n}\n.event-chart .event-name[data-v-3471d92e] {\n  height: 24px;\n  color: #00A4D6;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.event-chart .event-date[data-v-3471d92e] {\n  height: 16px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n}\n.event-chart .chart-data-type[data-v-3471d92e] {\n  height: 24px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  position: absolute;\n  top: 0;\n  right: 8px;\n}\n.event-chart .event-info[data-v-3471d92e] {\n  position: relative;\n  margin-bottom: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bar_chart__ = __webpack_require__(844);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-bar-chart',
  components: {
    EventBarChart: __WEBPACK_IMPORTED_MODULE_2__event_bar_chart__["a" /* default */]
  },
  data: function data() {
    return {
      chartData: {
        labels: [],
        data: []
      },
      chartItemNumber: 0
    };
  },

  props: {
    eventItem: {
      type: Object,
      default: {}
    },
    reportType: {
      type: String,
      default: 'upcoming'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
  })),
  mounted: function mounted() {
    var _this = this;

    this.actionGetEventReportChart({ eventId: this.eventItem.id, reportType: this.reportType }).then(function (response) {
      // Todo remove dummy data after finish
      if (_this.chartData.labels.length === 0) {
        _this.chartData.labels = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        /* this.chartData.labels = ['Overall', 'Professionalism', 'Willingness to Recommend', 'Communication', 'Preparedness', 'On-Time Start and Finish', 'Check-in Process', 'Professionalism - Coach', ' Professionalism - Screener', 'Professionalism - Lead', 'Scheduler Tool', 'Reporting', 'Participant Feedback', 'Data Transfer', 'Event Breakdown']; */
      }
      if (_this.chartData.data.length === 0) {
        _this.chartData.data = [4, 3, 5, 3, 3, 3, 3.5, 4.5, 2.5, 2, 1, 3.7, 4.6, 2.8, 5];
      }
    });
  }
});

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-chart" },
    [
      _c("div", { staticClass: "event-info" }, [
        _c("div", { staticClass: "event-name" }, [
          _vm._v(_vm._s(_vm.eventItem.eventName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "event-date" }, [
          _vm._v(_vm._s(_vm.eventItem.prefDate))
        ])
      ]),
      _vm._v(" "),
      _c("EventBarChart", {
        attrs: {
          labels: _vm.chartData.labels,
          data: _vm.chartData.data,
          width: 254,
          height: 200
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3471d92e", esExports)
  }
}

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_commons_Spinner__ = __webpack_require__(163);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import routerConstants from '@/router/constants';



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-event-completed-report-card',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_commons_Spinner__["a" /* default */]
  },
  props: {
    eventInfo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      reportData: {},
      isLoading: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getData: function getData() {
      var _this = this;

      if (this.isLoading !== 1) {
        this.isLoading = 1;
        this.actionGetEventReportChart({ eventId: this.eventInfo.id, reportType: 'COMPLETED' }).then(function (response) {
          _this.reportData = response;
        }).finally(function () {
          _this.isLoading = 2;
        });
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
  })),
  computed: {},
  created: function created() {
    this.getData();
  },

  watch: {
    eventInfo: {
      handler: function handler(old, value) {
        this.getData();
      },
      deep: true
    }
  }
});

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-completed-report-card common-card" }, [
    _vm.isLoading === 1
      ? _c("div", { staticClass: "spinner-loading" }, [_c("Spinner")], 1)
      : _c("div", [
          _c("div", { staticClass: "top-card" }, [
            _c("div", { staticClass: "event-name body-text" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.eventInfo.eventName) + "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "expected-screened" }, [
              _c("div", { staticClass: "expected" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Expected")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h1-text" }, [
                  _vm._v(_vm._s(_vm.reportData.expectedValue))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "screened" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Screened")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h1-text" }, [
                  _vm._v(_vm._s(_vm.reportData.screened))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottom-card" }, [
            _c("div", { staticClass: "projected-scheduled" }, [
              _c("div", { staticClass: "projected" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Projected Accuracy")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h4-text" }, [
                  _vm._v(
                    _vm._s(parseFloat(_vm.reportData.filled).toFixed(0) + "%")
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "screened" }, [
                _c("div", { staticClass: "text value-text" }, [
                  _vm._v("Scheduled")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value h4-text" }, [
                  _vm._v(_vm._s(_vm.reportData.scheduled))
                ])
              ])
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-660535c6", esExports)
  }
}

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("ul", { staticClass: "status-menu" }, [
          _c(
            "li",
            {
              staticClass: "status-menu-item",
              class:
                _vm.tableType == _vm.consts.reportType.upcoming
                  ? "selected"
                  : null,
              on: {
                click: function($event) {
                  _vm.navigateTab(_vm.consts.reportType.upcoming)
                }
              }
            },
            [_vm._v("\n          upcoming\n        ")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "status-menu-item",
              class:
                _vm.tableType == _vm.consts.reportType.completed
                  ? "selected"
                  : null,
              on: {
                click: function($event) {
                  _vm.navigateTab(_vm.consts.reportType.completed)
                }
              }
            },
            [_vm._v("\n          completed\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row status-message" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.consts.reportMessage[_vm.tableType]) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {},
      [
        _c("SubHeaderManageReports", {
          attrs: {
            pagingObj: _vm.pagingObj,
            eventStatus: _vm.tableType,
            sliderValue: _vm.sliderValue,
            textSearch: _vm.textSearch
          },
          on: {
            TEXT_SEARCH_CHANGE: _vm.handleTextSearchChange,
            CHANGE_FILTER_OPTION: _vm.handleChangeDataFilter,
            SLIDER_CHANGE_VALUE: _vm.handleSliderChangeValue
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("router-view", {
          attrs: {
            reportType: _vm.tableType,
            dateOut: _vm.sliderValue,
            filterBy: _vm.dataFilter,
            textSearch: _vm.textSearch
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 container-header" }, [
        _vm._v("reports\n      "),
        _c("div", { staticClass: "icon-information" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-507efb36", esExports)
  }
}

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("Reports")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61a2ace2", esExports)
  }
}

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManagement_vue__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3c0b06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserManagement_vue__ = __webpack_require__(2042);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2018)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3c0b06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/userManagement/UserManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-da3c0b06", Component.options)
  } else {
    hotAPI.reload("data-v-da3c0b06", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2019);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b79f9c80", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-da3c0b06\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserManagement.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-da3c0b06\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_subHeaders_SubHeaderUserManagement__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_TableUsers__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-management-view',
  components: {
    TableUsers: __WEBPACK_IMPORTED_MODULE_2__components_users_TableUsers__["a" /* default */],
    SubHeaderUserManagement: __WEBPACK_IMPORTED_MODULE_1__components_subHeaders_SubHeaderUserManagement__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    isLoading: 'GETTER_GET_IS_LOADING'
  })),
  created: function created() {
    this.$store.dispatch('ACTION_GET_ALL_USERS');
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].viewNames.managerUsers);
  }
});

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderUserManagement_vue__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72de9e7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderUserManagement_vue__ = __webpack_require__(2030);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2022)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72de9e7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderUserManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72de9e7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderUserManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderUserManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderUserManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72de9e7c", Component.options)
  } else {
    hotAPI.reload("data-v-72de9e7c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1ac47690", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72de9e7c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderUserManagement.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72de9e7c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderUserManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.subHeader[data-v-72de9e7c] {\n  margin-top: 3px;\n}\n.group-button-sub-header[data-v-72de9e7c] {\n  float: right;\n  top: 120px;\n  margin: 65px 30px 0 0;\n}\n.content-header[data-v-72de9e7c] {\n  width: 250px;\n}\n.float-left[data-v-72de9e7c] {\n  float: left;\n}\n.float-right[data-v-72de9e7c] {\n  float: right;\n}\n", ""]);

// exports


/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubHeaderButton__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderUserManagement',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  },
  components: {
    SubHeaderButton: __WEBPACK_IMPORTED_MODULE_0__SubHeaderButton__["a" /* default */]
  },
  data: function data() {
    return {
      btnAddUser: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].subHeaderBtn.addUser
    };
  }
});

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderButton_vue__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb34980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderButton_vue__ = __webpack_require__(2029);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2026)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1eb34980"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb34980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderButton_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/SubHeaderButton.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderButton.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1eb34980", Component.options)
  } else {
    hotAPI.reload("data-v-1eb34980", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("43587006", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eb34980\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderButton.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eb34980\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.btn-new-event[data-v-1eb34980] {\n  height: 26px;\n  margin-left: 15px;\n}\n.btn-new-event[data-v-1eb34980]:hover {\n  cursor: pointer;\n}\n.btn-new-event .btn-new-event-wrapper-icon[data-v-1eb34980] {\n  height: 25px;\n  width: 25px;\n  float: left;\n  border: 2px solid #0080a5;\n  border-radius: 50px ;\n  position: relative;\n  top: -3px;\n}\n.btn-new-event .btn-new-event-wrapper-icon .btn-new-event-icon[data-v-1eb34980] {\n  color: #0080a5;\n  position: relative;\n  top: -1px;\n  right: -4px;\n}\n.btn-new-event .btn-new-event-wrapper-icon .new-event-icon[data-v-1eb34980] {\n  top: 3px;\n  right: -4px;\n}\n.btn-new-event .btn-new-event-text[data-v-1eb34980] {\n  height: 17px;\n  width: 68px;\n  font-size: 14px;\n  font-weight: 600;\n  top: -4px;\n  margin: 0 0 0 10px;\n}\n.btn-new-event .btn-new-event-text .span-btn-text[data-v-1eb34980] {\n  color: #0080a5;\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_plus__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_angle_double_right__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'button-sub-header-right',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    btnClick: function btnClick() {
      // Create User
      if (this.item.name === __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].subHeaderBtn.addUser.name) {
        var modalData = {
          action: __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].modalAction.createUser,
          data: null
        };
        this.$modal.show('eventModal', modalData);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({}))
});

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-new-event",
      on: {
        click: function($event) {
          _vm.btnClick()
        }
      }
    },
    [
      _c(
        "span",
        { staticClass: "btn-new-event-wrapper-icon" },
        [
          _c("Icon", {
            staticClass: "btn-new-event-icon",
            class: ["CreateEvent" == _vm.item.name ? "new-event-icon" : ""],
            attrs: { name: _vm.item.iconName }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("a", { staticClass: "btn-new-event-text" }, [
        _c("span", { staticClass: "span-btn-text" }, [
          _vm._v(_vm._s(_vm.item.btnText))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1eb34980", esExports)
  }
}

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "subHeader" }, [
    _c("div", { staticClass: "content-header" }, [_vm._v("USER MANAGEMENT")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group-button-sub-header" },
      [
        _c("SubHeaderButton", {
          staticClass: "float-right",
          attrs: { item: _vm.btnAddUser }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-body" }, [
      _c("a", [
        _vm._v(" Add users to the event planner tool and edit accounts.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72de9e7c", esExports)
  }
}

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableUsers_vue__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086463aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableUsers_vue__ = __webpack_require__(2041);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2032)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086463aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableUsers_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/users/TableUsers.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TableUsers.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-086463aa", Component.options)
  } else {
    hotAPI.reload("data-v-086463aa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("48502fa3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-086463aa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableUsers.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-086463aa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableUsers.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.table-users {\n  font-size: 14px;\n  margin: 15px 20px 15px 15px;\n}\n.table-users .dt-list-status {\n  height: 37px;\n  background-color: #f5f5f5;\n}\n.table-users .dt-list-status .btn-status {\n  height: 37px;\n  width: 37px;\n  float: left;\n  vertical-align: middle;\n  display: grid;\n  padding: 8px 0;\n}\n.table-users .dt-list-status .btn-status:hover {\n  cursor: pointer;\n  background-color: #ffffff;\n}\n.table-users .dt-list-status .btn-status.active {\n  background-color: #ffffff;\n}\n.table-users .dt-list-status .btn-status.active .line {\n  background-color: #231f20;\n}\n.table-users .dt-list-status .btn-status .line {\n  width: 18px;\n  background: #b9b9b9;\n  height: 3px;\n  margin: 0 auto;\n}\n.table-users .dt-list-status .btn-status .scrunch {\n  height: 2px;\n}\n.table-users .dt-content {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.table-users .dt-content .dt-header {\n  font-size: 12px;\n  height: 37px;\n  background-color: #231f20;\n  color: #ffffff;\n  line-height: 37px;\n  /*overflow: hidden;*/\n}\n.table-users .dt-content .dt-header .header-col {\n  float: left;\n  height: 37px;\n  overflow: hidden;\n  border-left: solid 1px #b9b9b9;\n  padding-left: 10px;\n  text-transform: uppercase;\n  word-break: break-all;\n}\n.table-users .dt-content .dt-header .header-col:hover {\n  cursor: pointer;\n}\n.table-users .dt-content .dt-header .header-col:last-child {\n  border-right: solid 1px #b9b9b9;\n}\n.table-users .dt-content .dt-header .header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.table-users .dt-content .dt-header .col-event-name {\n  padding-left: 30px;\n}\n.table-users .dt-content .dt-body {\n  clear: both;\n  background-color: #f5f5f5;\n}\n.table-users .dt-content .dt-body.scrunch .dt-row-user {\n  height: 40px;\n}\n.table-users .dt-content .dt-body.scrunch .dt-row-user .body-col {\n  height: 40px;\n}\n.table-users .dt-content .dt-body .dt-row {\n  /*max-width: 100%;*/\n}\n.table-users .dt-content .dt-body .dt-row-user {\n  height: 50px;\n}\n.table-users .dt-content .dt-body .dt-row-detail .body-col {\n  float: left;\n  height: 50px;\n  line-height: 50px;\n  padding: 0 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.table-users .dt-content .dt-body .dt-row-detail .body-col.overflow-show {\n  overflow: visible;\n}\n.table-users .dt-content .header-col .header-container {\n  position: relative;\n}\n.table-users .dt-content .header-col .crop {\n  height: 37px;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n}\n.table-users .dt-content .header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-users .dt-content .header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.table-users .dt-content .header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n}\n.table-users .dt-content .header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.table-users .dt-content .header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-users .dt-content .header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-users .dt-content .header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-users .dt-content .header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.table-users .dt-content .header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.table-users .dt-content .header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.table-users .dt-content .header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.table-users .dt-content .header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n.table-users .dt-content .small-text {\n  font-size: 10px;\n}\n.table-users .dt-content .small-text .small-text-margin .first-line {\n  position: absolute;\n  top: -5px;\n}\n.table-users .dt-content .small-text .small-text-margin .second-line {\n  position: absolute;\n  top: 8px;\n}\n.table-users .dt-content .small-text .small-text-margin .icon-section {\n  position: absolute;\n  top: 1px;\n  left: 50px;\n}\n.isLoading {\n  display: block;\n  text-align: center;\n  color: #606060;\n}\n.noDisplay {\n  display: none;\n}\n.spinnerWrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.overlay {\n  position: absolute;\n  width: 97.5%;\n  height: 62.5%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 99;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserRow__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consts__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import Vue from 'vue';

// import DtPaging from './DtPaging';

// const _ = require('lodash');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-users',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__["a" /* default */],
    UserRow: __WEBPACK_IMPORTED_MODULE_7__UserRow__["a" /* default */]
  },
  data: function data() {
    return {
      scrunch: false,
      // START: paging
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '25',
        totalItems: this.totalItems,
        sortType: 'isChangeOrder',
        sortReverse: false
      },
      // END: paging
      arrCol: [{
        colName: 'firstName',
        newWidth: 175
      }, {
        colName: 'lastName',
        newWidth: 175
      }, {
        colName: 'email',
        newWidth: 350
      }, {
        colName: 'clientAccount',
        newWidth: 175
      }, {
        colName: 'phone',
        newWidth: 175
      }, {
        colName: 'role',
        newWidth: 175
      }, {
        colName: 'status',
        newWidth: 175
      }, {
        colName: 'action',
        newWidth: 140
      }]
    };
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    users: function users() {
      if (this.userList) {
        return this.userList(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts__["a" /* default */].LOCAL_STORE.role));
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    userList: 'GETTER_GET_USER_LIST',
    userListForEM: 'GETTER_GET_USER_LIST_FOR_EM',
    columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    changePagingOptions: function changePagingOptions(pagingObj) {
      this.pagingObj.currentPage = pagingObj.currentPage;
      this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
      this.pagingObj.totalItems = pagingObj.totalItems;
    },
    setSortOption: function setSortOption(sortType) {
      if (!this.resizing) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
      }
    },
    changeColumnWidth: function changeColumnWidth(colName, mouseDownEvent) {
      this.resizing = true;
      var vueApp = this;
      // get current mouse position
      var shiftX = mouseDownEvent.clientX;
      // header width
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      var maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      var newWidth = maxLeft;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      function onMouseMove(event) {
        // new position
        var bufferPx = event.clientX - shiftX;
        var newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && maxLeft - Math.abs(bufferPx) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2),
          isTableUser: true
        }, true);
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(function () {
          vueApp.resizing = false;
        }, 50);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])({
    resetColumnWidth: 'MUTATION_RESET_COLUMN_SIZE'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    this.arrCol.forEach(function (element) {
      _this.resetColumnWidth(element.colName);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var dtHeaderEl = document.getElementById('dt-header');
    var headerWidth = dtHeaderEl.getBoundingClientRect().width;
    if (headerWidth < 1200) {
      var newHeaderWidth = 1200;
      this.arrCol.forEach(function (element) {
        _this2.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: element.colName,
          newWidth: element.newWidth,
          isTableUser: true
        });
      });
    }
  },

  watch: {
    pagingObj: {
      handler: function handler() {
        this.getEventList(this.getListEventParams());
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__consts__["a" /* default */].LOCAL_STORE.pagingOptions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getListEventParams()));
      },
      deep: true
    }
  }
});

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserRow_vue__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e3ce0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserRow_vue__ = __webpack_require__(2039);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2036)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20e3ce0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e3ce0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/users/UserRow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserRow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20e3ce0e", Component.options)
  } else {
    hotAPI.reload("data-v-20e3ce0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("ac7adc16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-20e3ce0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserRow.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-20e3ce0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserRow.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.dt-row-user[data-v-20e3ce0e] {\n  font-family: \"Open Sans\";\n  background-color: #ffffff;\n}\n.dt-row-user .active .body-col[data-v-20e3ce0e] {\n  background-color: #f5f5f5;\n}\n.dt-row-user .dt-row-detail .body-col[data-v-20e3ce0e] {\n  color: #231F20;\n  font-size: 14px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.dt-row-user .dt-row-detail .body-col.col-action .wrapper[data-v-20e3ce0e] {\n  margin-left: 4px;\n}\n.dt-row-user .dt-row-detail .body-col .wrapper[data-v-20e3ce0e] {\n  width: 24px;\n  background-color: #0080a5;\n  height: 24px;\n  margin-top: 5px;\n  border-radius: 4px;\n  position: relative;\n  display: inline-block;\n}\n.dt-row-user .dt-row-detail .body-col .wrapper .icon[data-v-20e3ce0e] {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  background-color: #0080a5;\n  color: #fff;\n  height: 20px;\n  width: 20px;\n  border-radius: 4px;\n}\n.dt-row-user .dt-row-detail .body-col .wrapper .icon[data-v-20e3ce0e]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserRow',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    userInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      instructions: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].instructions,
      iconNames: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].iconNames
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showRoleText: function showRoleText() {
      var roles = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE;
      var userRole = this.userInfo.role;
      if (userRole.toLowerCase() === roles.client.toLowerCase() || userRole.toLowerCase() === roles.clientManager.toLowerCase()) {
        return 'Client';
      }
      if (userRole.toLowerCase() === roles.accountManager.toLowerCase() || userRole.toLowerCase() === roles.secondaryAccountManager.toLowerCase()) {
        return 'AM';
      }
      if (userRole.toLowerCase() === roles.eventManager.toLowerCase()) {
        return 'EM';
      }
      if (userRole.toLowerCase() === roles.admin.toLowerCase()) {
        return 'Admin';
      }
      if (userRole.toLowerCase() === roles.staff.toLowerCase()) {
        return 'Staff';
      }
      return '';
    },
    clientName: function clientName() {
      return this.userInfo.client.id === 0 ? '' : this.userInfo.client.clientName;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
  })),
  methods: {
    editUserInfo: function editUserInfo() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.editUser,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    },
    deleteUser: function deleteUser() {
      if (this.userInfo.role === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE.admin) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toastr('error', 'Can not delete user with role Admin.', '');
        return;
      }
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.deleteUser,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    },
    forceUserResetPassword: function forceUserResetPassword() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.forceUserResetPassword,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    }
  }
});

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-row-user" }, [
    _c(
      "div",
      { staticClass: "dt-row-detail", class: { active: _vm.index % 2 == 1 } },
      [
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "12%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.firstName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "12%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.lastName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "22%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.email) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.clientAccount.size
                ? _vm.columnWidth.phone.size + "px"
                : "12%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.phoneNumber) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.clientAccount.size
                ? _vm.columnWidth.clientAccount.size + "px"
                : "10%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.clientName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.role.size
                ? _vm.columnWidth.role.size + "px"
                : "10%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.showRoleText) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.status.size
                ? _vm.columnWidth.status.size + "px"
                : "14%"
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.userInfo.status || "Account is not on Cognito") +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col col-action",
            style: {
              width: _vm.columnWidth.action.size
                ? _vm.columnWidth.action.size + "px"
                : "8%"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.editUserInfo()
                  }
                }
              },
              [
                _c(
                  "span",
                  [
                    _c("Icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true }
                        }
                      ],
                      staticClass: "icon",
                      attrs: { title: _vm.instructions.edit, name: "pencil" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.deleteUser()
                  }
                }
              },
              [
                _c(
                  "span",
                  [
                    _c("Icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true }
                        }
                      ],
                      staticClass: "icon",
                      attrs: {
                        title: _vm.instructions.delete,
                        name: _vm.iconNames.trashO
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.forceUserResetPassword()
                  }
                }
              },
              [
                _c("span", [
                  _c("img", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.bottom",
                        modifiers: { hover: true, bottom: true }
                      }
                    ],
                    staticClass: "icon",
                    attrs: {
                      src: __webpack_require__(2040),
                      title: _vm.instructions.forceResetPassword
                    }
                  })
                ])
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20e3ce0e", esExports)
  }
}

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NDAgNTEyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnVzZXItbG9jazwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzIwLDMyMGE2My4wOCw2My4wOCwwLDAsMSw4LjEtMzAuNWMtNC44LS41LTkuNS0xLjUtMTQuNS0xLjVIMjk2LjlhMTc0LjA4LDE3NC4wOCwwLDAsMS0xNDUuOCwwSDEzNC40QTEzNC40MywxMzQuNDMsMCwwLDAsMCw0MjIuNFY0NjRhNDgsNDgsMCwwLDAsNDgsNDhIMzI4LjlhNjMuNTQsNjMuNTQsMCwwLDEtOC45LTMyWm0tOTYtNjRBMTI4LDEyOCwwLDEsMCw5NiwxMjgsMTI4LDEyOCwwLDAsMCwyMjQsMjU2Wm0zODQsMzJINTc2VjI0MGE4MCw4MCwwLDAsMC0xNjAsMHY0OEgzODRhMzIsMzIsMCwwLDAtMzIsMzJWNDgwYTMyLDMyLDAsMCwwLDMyLDMySDYwOGEzMiwzMiwwLDAsMCwzMi0zMlYzMjBBMzIsMzIsMCwwLDAsNjA4LDI4OFptLTgwLDBINDY0VjI0MGEzMiwzMiwwLDAsMSw2NCwwWiIvPjwvc3ZnPg=="

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-users" }, [
    _c("div", { staticClass: "dt-list-status" }, [
      _c(
        "div",
        {
          staticClass: "btn-status",
          class: _vm.scrunch ? "active" : null,
          on: {
            click: function($event) {
              _vm.scrunch = !_vm.scrunch
            }
          }
        },
        [
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-status",
          class: !_vm.scrunch ? "active" : null,
          on: {
            click: function($event) {
              _vm.scrunch = !_vm.scrunch
            }
          }
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "line" })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dt-content" }, [
      _c("div", { staticClass: "dt-header", attrs: { id: "dt-header" } }, [
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "12%"
            },
            attrs: { id: "firstName" },
            on: {
              click: function($event) {
                _vm.setSortOption("firstName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("firstName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              First Name\n              "),
                    this.pagingObj.sortType != "startTime"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "startTime" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "startTime" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "12%"
            },
            attrs: { id: "lastName" },
            on: {
              click: function($event) {
                _vm.setSortOption("lastName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("lastName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Last Name\n              "),
                    this.pagingObj.sortType != "lastName"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "duration" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "duration" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "22%"
            },
            attrs: { id: "email" },
            on: {
              click: function($event) {
                _vm.setSortOption("email")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("email", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Email\n              "),
                    this.pagingObj.sortType != "endTime"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "endTime" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "endTime" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.phone.size
                ? _vm.columnWidth.phone.size + "px"
                : "12%"
            },
            attrs: { id: "phone" },
            on: {
              click: function($event) {
                _vm.setSortOption("phone")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("phone", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Phone\n              "),
                    this.pagingObj.sortType != "timeZone"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.clientAccount.size
                ? _vm.columnWidth.clientAccount.size + "px"
                : "10%"
            },
            attrs: { id: "clientAccount" },
            on: {
              click: function($event) {
                _vm.setSortOption("clientAccount")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("clientAccount", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              client account\n              "),
                    this.pagingObj.sortType != "timeZone"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.role.size
                ? _vm.columnWidth.role.size + "px"
                : "10%"
            },
            attrs: { id: "role" },
            on: {
              click: function($event) {
                _vm.setSortOption("role")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("role", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Role\n              "),
                    this.pagingObj.sortType != "timeZone"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.role.size
                ? _vm.columnWidth.role.size + "px"
                : "14%"
            },
            attrs: { id: "status" },
            on: {
              click: function($event) {
                _vm.setSortOption("role")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("role", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Status\n              "),
                    this.pagingObj.sortType != "status"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "timeZone" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.action.size
                ? _vm.columnWidth.action.size + "px"
                : "8%"
            },
            attrs: { id: "action" }
          },
          [_vm._m(0)]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dt-body",
          class: _vm.scrunch ? "scrunch" : null,
          attrs: { id: "dt-body" }
        },
        [
          _c(
            "div",
            {
              staticClass: "overlay",
              class: { isLoading: _vm.loading, noDisplay: !_vm.loading }
            },
            [
              _c(
                "div",
                { staticClass: "spinnerWrapper" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: "spinner", scale: "5", pulse: "" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.users, function(user, index) {
            return !_vm.loading
              ? [
                  _c("UserRow", {
                    key: index,
                    attrs: { userInfo: user, index: index }
                  })
                ]
              : _vm._e()
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dt-footer" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "crop" }, [
        _c("div", { staticClass: "content no-select" }, [
          _vm._v("\n              action\n            ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-086463aa", esExports)
  }
}

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderUserManagement"),
      _vm._v(" "),
      _c("TableUsers", { attrs: { loading: _vm.isLoading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-da3c0b06", esExports)
  }
}

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalSettings_vue__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08433b7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalSettings_vue__ = __webpack_require__(2078);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2044)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08433b7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalSettings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/globalSettings/GlobalSettings.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GlobalSettings.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-08433b7d", Component.options)
  } else {
    hotAPI.reload("data-v-08433b7d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7ddee126", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08433b7d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GlobalSettings.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08433b7d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GlobalSettings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_globalSettings_TableGlobalSetttings__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_globalSettings_StaffManagement__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_subHeaders_globalSettings_SubHeaderGlobalSettings__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ckeditor2__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'global-settings-view',
  components: {
    TableGloBalSettings: __WEBPACK_IMPORTED_MODULE_4__components_globalSettings_TableGlobalSetttings__["a" /* default */],
    SubHeader: __WEBPACK_IMPORTED_MODULE_6__components_subHeaders_globalSettings_SubHeaderGlobalSettings__["a" /* default */],
    StaffManagement: __WEBPACK_IMPORTED_MODULE_5__components_globalSettings_StaffManagement__["a" /* default */],
    VueCkeditor: __WEBPACK_IMPORTED_MODULE_7_vue_ckeditor2__["a" /* default */]
  },
  data: function data() {
    return {
      settings: {
        staffConfiguration: {},
        resetPasswordEmailTemplate: {},
        temporaryPasswordEmailTemplate: {}
      },
      configEmail: {
        // config for editor of email fields
        toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'tools', items: ['Maximize'] }, { name: 'Event Fields', items: ['eventTags'] }, { name: 'document', items: ['Source'] }],
        height: 300,
        fullPage: true, // allow content contains html/body/head tags
        autoGrow_onStartup: true,
        toolbarCanCollapse: true,
        allowedContent: true,
        toolbarStartupExpanded: true,
        extraPlugins: 'eventTags',
        emailTags: []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])({
    isLoading: 'GETTER_GET_IS_LOADING'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    saveData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$swal({
                  title: "<div class='ems_alert_title'>Email Template Confirmation</div>",
                  html: "<div class='ems_alert_des'>Are you sure to save these changes?</div>",
                  confirmButtonColor: '#0080A5',
                  confirmButtonText: 'SAVE',
                  showCancelButton: true,
                  cancelButtonColor: '#fff',
                  cancelButtonText: 'CANCEL',
                  buttonsStyling: true,
                  reverseButtons: true,
                  confirmButtonClass: 'ems_alert_confirm open',
                  cancelButtonClass: 'ems_alert_cancel',
                  customClass: 'ems_confirm',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  width: 605
                }).then(function (result) {
                  if (result.value) {
                    var templates = [_this.settings.resetPasswordEmailTemplate, _this.settings.temporaryPasswordEmailTemplate];
                    console.log('templates = ', templates);
                    _this.actionSaveTemplates(templates).then(function (responseSaveConfigs) {
                      if (!responseSaveConfigs.message) {
                        _this.$toast.success('Saved configurations!', '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
                      } else {
                        _this.$toast.success(responseSaveConfigs.message, '', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optError));
                      }
                      _this.isLoading = false;
                    });
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveData() {
        return _ref.apply(this, arguments);
      }

      return saveData;
    }()
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])({
    actionSaveTemplates: 'ACTION_SAVE_EMAIL_TEMPLATES',
    actionGetEmailTags: 'ACTION_GET_EMAIL_TAGS'
  })),
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('ACTION_GET_ALL_VALIDATORS').then(function (response) {
      _this2.settings = response;
    });
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_8__consts__["a" /* default */].viewNames.managerUsers);

    this.actionGetEmailTags().then(function (response) {
      _this2.configEmail.emailTags = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;

          if (tag.useResetPassTemplate) {
            _this2.configEmail.emailTags.push(tag);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
});

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableGlobalSetttings_vue__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220d121e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableGlobalSetttings_vue__ = __webpack_require__(2056);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2048)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableGlobalSetttings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220d121e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TableGlobalSetttings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/globalSettings/TableGlobalSetttings.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TableGlobalSetttings.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-220d121e", Component.options)
  } else {
    hotAPI.reload("data-v-220d121e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("fd37d2d6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-220d121e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableGlobalSetttings.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-220d121e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TableGlobalSetttings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.table-users {\n  font-size: 14px;\n  margin: 15px 0;\n}\n.table-users .dt-list-status {\n  height: 37px;\n  background-color: #f5f5f5;\n}\n.table-users .dt-list-status .btn-status {\n  height: 37px;\n  width: 37px;\n  float: left;\n  vertical-align: middle;\n  display: grid;\n  padding: 8px 0;\n}\n.table-users .dt-list-status .btn-status:hover {\n  cursor: pointer;\n  background-color: #ffffff;\n}\n.table-users .dt-list-status .btn-status.active {\n  background-color: #ffffff;\n}\n.table-users .dt-list-status .btn-status.active .line {\n  background-color: #231f20;\n}\n.table-users .dt-list-status .btn-status .line {\n  width: 18px;\n  background: #b9b9b9;\n  height: 3px;\n  margin: 0 auto;\n}\n.table-users .dt-list-status .btn-status .scrunch {\n  height: 2px;\n}\n.table-users .dt-content {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.table-users .dt-content .dt-header {\n  font-size: 12px;\n  height: 37px;\n  background-color: #231f20;\n  color: #ffffff;\n  line-height: 37px;\n  /*overflow: hidden;*/\n}\n.table-users .dt-content .dt-header .header-col {\n  float: left;\n  height: 37px;\n  overflow: hidden;\n  border-left: solid 1px #b9b9b9;\n  padding-left: 10px;\n  text-transform: uppercase;\n  word-break: break-all;\n}\n.table-users .dt-content .dt-header .header-col:hover {\n  cursor: pointer;\n}\n.table-users .dt-content .dt-header .header-col:last-child {\n  border-right: solid 1px #b9b9b9;\n}\n.table-users .dt-content .dt-header .header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.table-users .dt-content .dt-header .col-event-name {\n  padding-left: 30px;\n}\n.table-users .dt-content .dt-body {\n  clear: both;\n  background-color: #f5f5f5;\n}\n.table-users .dt-content .dt-body.scrunch .dt-row-user {\n  height: 40px;\n}\n.table-users .dt-content .dt-body.scrunch .dt-row-user .body-col {\n  height: 40px;\n}\n.table-users .dt-content .dt-body .dt-row {\n  /*max-width: 100%;*/\n}\n.table-users .dt-content .dt-body .dt-row-user {\n  height: 50px;\n}\n.table-users .dt-content .dt-body .dt-row-detail .body-col {\n  float: left;\n  height: 50px;\n  line-height: 50px;\n  padding: 0 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.table-users .dt-content .dt-body .dt-row-detail .body-col.overflow-show {\n  overflow: visible;\n}\n.table-users .dt-content .header-col .header-container {\n  position: relative;\n}\n.table-users .dt-content .header-col .crop {\n  height: 37px;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n}\n.table-users .dt-content .header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-users .dt-content .header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.table-users .dt-content .header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n}\n.table-users .dt-content .header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.table-users .dt-content .header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-users .dt-content .header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-users .dt-content .header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-users .dt-content .header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.table-users .dt-content .header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.table-users .dt-content .header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.table-users .dt-content .header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.table-users .dt-content .header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n.table-users .dt-content .small-text {\n  font-size: 10px;\n}\n.table-users .dt-content .small-text .small-text-margin .first-line {\n  position: absolute;\n  top: -5px;\n}\n.table-users .dt-content .small-text .small-text-margin .second-line {\n  position: absolute;\n  top: 8px;\n}\n.table-users .dt-content .small-text .small-text-margin .icon-section {\n  position: absolute;\n  top: 1px;\n  left: 50px;\n}\n.isLoading {\n  display: block;\n  text-align: center;\n  color: #606060;\n}\n.noDisplay {\n  display: none;\n}\n.spinnerWrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 50px;\n  color: white;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.overlay {\n  position: absolute;\n  width: 97.5%;\n  height: 62.5%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 99;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GlobalSettingsRow__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consts__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import Vue from 'vue';

// import DtPaging from './DtPaging';

// const _ = require('lodash');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-users',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__["a" /* default */],
    GlobalSettingsRow: __WEBPACK_IMPORTED_MODULE_7__GlobalSettingsRow__["a" /* default */]
  },
  data: function data() {
    return {
      scrunch: false,
      // START: paging
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '25',
        totalItems: this.totalItems,
        sortType: 'isChangeOrder',
        sortReverse: false
      },
      // END: paging
      arrCol: [{
        colName: 'firstName',
        newWidth: 205
      }, {
        colName: 'lastName',
        newWidth: 205
      }, {
        colName: 'email',
        newWidth: 410
      }, {
        colName: 'clientAccount',
        newWidth: 205
      }, {
        colName: 'role',
        newWidth: 205
      }, {
        colName: 'action',
        newWidth: 140
      }]
    };
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    validators: function validators() {
      return this.validatorList;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    validatorList: 'GETTER_GET_VALIDATOR_LIST',
    userList: 'GETTER_GET_USER_LIST',
    userListForEM: 'GETTER_GET_USER_LIST_FOR_EM',
    columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    changePagingOptions: function changePagingOptions(pagingObj) {
      this.pagingObj.currentPage = pagingObj.currentPage;
      this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
      this.pagingObj.totalItems = pagingObj.totalItems;
    },
    setSortOption: function setSortOption(sortType) {
      if (!this.resizing) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
      }
    },
    changeColumnWidth: function changeColumnWidth(colName, mouseDownEvent) {
      this.resizing = true;
      var vueApp = this;
      // get current mouse position
      var shiftX = mouseDownEvent.clientX;
      // header width
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      var maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      var newWidth = maxLeft;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      function onMouseMove(event) {
        // new position
        var bufferPx = event.clientX - shiftX;
        var newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && maxLeft - Math.abs(bufferPx) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2),
          isTableUser: true
        }, true);
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(function () {
          vueApp.resizing = false;
        }, 50);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])({
    resetColumnWidth: 'MUTATION_RESET_COLUMN_SIZE'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    this.arrCol.forEach(function (element) {
      _this.resetColumnWidth(element.colName);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var dtHeaderEl = document.getElementById('dt-header');
    var headerWidth = dtHeaderEl.getBoundingClientRect().width;
    if (headerWidth < 1200) {
      var newHeaderWidth = 1200;
      this.arrCol.forEach(function (element) {
        _this2.saveColumnWidth({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: element.colName,
          newWidth: element.newWidth,
          isTableUser: true
        });
      });
    }
  },

  watch: {
    pagingObj: {
      handler: function handler() {
        this.getEventList(this.getListEventParams());
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__consts__["a" /* default */].LOCAL_STORE.pagingOptions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getListEventParams()));
      },
      deep: true
    }
  }
});

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalSettingsRow_vue__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b9e456_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalSettingsRow_vue__ = __webpack_require__(2055);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2052)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0b9e456"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalSettingsRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b9e456_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalSettingsRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/globalSettings/GlobalSettingsRow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GlobalSettingsRow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0b9e456", Component.options)
  } else {
    hotAPI.reload("data-v-d0b9e456", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a45d04c0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d0b9e456\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GlobalSettingsRow.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d0b9e456\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GlobalSettingsRow.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.dt-row-user[data-v-d0b9e456] {\n  font-family: \"Open Sans\", serif;\n  background-color: #ffffff;\n}\n.dt-row-user .active .body-col[data-v-d0b9e456] {\n  background-color: #f5f5f5;\n}\n.dt-row-user .dt-row-detail .body-col[data-v-d0b9e456] {\n  color: #231F20;\n  font-size: 14px;\n}\n.dt-row-user .dt-row-detail .body-col .wrapper[data-v-d0b9e456] {\n  width: 24px;\n  background-color: #00A4D6;\n  height: 24px;\n  margin-top: 5px;\n  border-radius: 4px;\n  position: relative;\n  display: inline-block;\n}\n.dt-row-user .dt-row-detail .body-col .wrapper .icon[data-v-d0b9e456] {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  background-color: #00A4D6;\n  color: #fff;\n  height: 20px;\n  width: 20px;\n  border-radius: 4px;\n}\n.dt-row-user .dt-row-detail .body-col .wrapper .icon[data-v-d0b9e456]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserRow',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    validator: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      instructions: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].instructions,
      iconNames: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].iconNames
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showRoleText: function showRoleText() {
      var roles = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].USER_ROLE;
      var userRole = this.userInfo.role;
      if (userRole.toLowerCase() === roles.client.toLowerCase() || userRole.toLowerCase() === roles.clientManager.toLowerCase()) {
        return 'Client';
      }
      if (userRole.toLowerCase() === roles.accountManager.toLowerCase() || userRole.toLowerCase() === roles.secondaryAccountManager.toLowerCase()) {
        return 'AM';
      }
      if (userRole.toLowerCase() === roles.eventManager.toLowerCase()) {
        return 'EM';
      }
      if (userRole.toLowerCase() === roles.admin.toLowerCase()) {
        return 'Admin';
      }
      return '';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    columnWidth: 'GETTER_GET_COLUMN_TABLE_USER'
  })),
  methods: {
    editValidator: function editValidator() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.editValidator,
        data: this.validator
      };
      this.$modal.show('eventModal', modalData);
    },
    deleteValidator: function deleteValidator() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.deleteValidator,
        data: this.validator
      };
      this.$modal.show('eventModal', modalData);
    },
    forceUserResetPassword: function forceUserResetPassword() {
      var modalData = {
        action: __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].modalAction.forceUserResetPassword,
        data: this.userInfo
      };
      this.$modal.show('eventModal', modalData);
    }
  }
});

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-row-user" }, [
    _c(
      "div",
      { staticClass: "dt-row-detail", class: { active: _vm.index % 2 == 1 } },
      [
        _c("div", {
          staticClass: "body-col",
          style: {
            width: _vm.columnWidth.firstName.size
              ? _vm.columnWidth.firstName.size + "px"
              : "10%"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "35%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.validator.name) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "45%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.validator.field) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.action.size
                ? _vm.columnWidth.action.size + "px"
                : "10%"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.editValidator()
                  }
                }
              },
              [
                _c(
                  "span",
                  [
                    _c("Icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true }
                        }
                      ],
                      staticClass: "icon",
                      attrs: { title: _vm.instructions.edit, name: "pencil" }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d0b9e456", esExports)
  }
}

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-users" }, [
    _c("div", { staticClass: "dt-list-status" }, [
      _c(
        "div",
        {
          staticClass: "btn-status",
          class: _vm.scrunch ? "active" : null,
          on: {
            click: function($event) {
              _vm.scrunch = !_vm.scrunch
            }
          }
        },
        [
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" }),
          _vm._v(" "),
          _c("div", { staticClass: "line scrunch" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-status",
          class: !_vm.scrunch ? "active" : null,
          on: {
            click: function($event) {
              _vm.scrunch = !_vm.scrunch
            }
          }
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "line" })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dt-content" }, [
      _c("div", { staticClass: "dt-header", attrs: { id: "dt-header" } }, [
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "10%"
            },
            attrs: { id: "firstName" },
            on: {
              click: function($event) {
                _vm.setSortOption("firstName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("firstName", $event)
                    }
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "35%"
            },
            attrs: { id: "lastName" },
            on: {
              click: function($event) {
                _vm.setSortOption("lastName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("lastName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Name\n              "),
                    this.pagingObj.sortType != "lastName"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "duration" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "duration" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "45%"
            },
            attrs: { id: "email" },
            on: {
              click: function($event) {
                _vm.setSortOption("email")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("email", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              Field\n              "),
                    this.pagingObj.sortType != "endTime"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "endTime" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "endTime" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.action.size
                ? _vm.columnWidth.action.size + "px"
                : "10%"
            },
            attrs: { id: "action" }
          },
          [_vm._m(0)]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dt-body",
          class: _vm.scrunch ? "scrunch" : null,
          attrs: { id: "dt-body" }
        },
        [
          _c(
            "div",
            {
              staticClass: "overlay",
              class: { isLoading: _vm.loading, noDisplay: !_vm.loading }
            },
            [
              _c(
                "div",
                { staticClass: "spinnerWrapper" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: "spinner", scale: "5", pulse: "" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.validators, function(validator, index) {
            return !_vm.loading
              ? [
                  _c("GlobalSettingsRow", {
                    key: index,
                    attrs: { validator: validator, index: index }
                  })
                ]
              : _vm._e()
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dt-footer" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "crop" }, [
        _c("div", { staticClass: "content no-select" }, [
          _vm._v("\n              action\n            ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-220d121e", esExports)
  }
}

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffManagement_vue__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cc5678_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffManagement_vue__ = __webpack_require__(2067);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2058)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38cc5678"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cc5678_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/globalSettings/StaffManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StaffManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38cc5678", Component.options)
  } else {
    hotAPI.reload("data-v-38cc5678", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("02afb8bd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38cc5678\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffManagement.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38cc5678\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GlobalRateOfPay__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_globalSettings_EditMileageRateModal__ = __webpack_require__(847);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-staff-management-settings',
  components: {
    GlobalRateOfPay: __WEBPACK_IMPORTED_MODULE_0__GlobalRateOfPay__["a" /* default */],
    EditMileageRateModal: __WEBPACK_IMPORTED_MODULE_1__modal_globalSettings_EditMileageRateModal__["a" /* default */]
  },
  props: {
    staffSettings: {
      type: Object,
      required: true
    }
  },
  computed: {},
  methods: {}
});

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalRateOfPay_vue__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b81a1ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalRateOfPay_vue__ = __webpack_require__(2066);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalRateOfPay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b81a1ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalRateOfPay_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/globalSettings/GlobalRateOfPay.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GlobalRateOfPay.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b81a1ef", Component.options)
  } else {
    hotAPI.reload("data-v-5b81a1ef", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_HeaderColumn__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_constants__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_setting_constants__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal__ = __webpack_require__(2063);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import arrayHelper from '@/utils/array-helper';




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-table-rate-of-pay',
  components: {
    HeaderColumn: __WEBPACK_IMPORTED_MODULE_1__commons_HeaderColumn__["a" /* default */],
    EditMileageRateModal: __WEBPACK_IMPORTED_MODULE_5__modal__["a" /* EditMileageRateModal */]
  },
  props: {
    staffSettings: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      arrHeaderObj: [{
        internalName: 'mileageRate',
        displayName: 'Mileage Rate'
      }],
      sortObject: {
        fieldName: '',
        reverse: false
      },
      editting: false,
      valueBackup: {}
    };
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    handleChangeSortOption: function handleChangeSortOption(sortObj) {},
    handleEditSettingClick: function handleEditSettingClick() {
      this.valueBackup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.staffSettings);
      this.$refs.editMileageRateModal.show();
    },
    handleBlurInputValue: function handleBlurInputValue() {},
    handleCancelClick: function handleCancelClick() {
      this.$refs.editMileageRateModal.hide();
      this.staffSettings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.valueBackup);
    },
    handleSaveClick: function handleSaveClick() {
      var _this = this;

      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.staffSettings);
      this.updateStaffSetting(body).then(function (response) {
        if (response.statusCode === __WEBPACK_IMPORTED_MODULE_2__store_constants__["a" /* default */].statusCodes.OK) {
          _this.$toast.success('Successfully saved.', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$toastOpt.optSuccess));
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(__WEBPACK_IMPORTED_MODULE_2__store_constants__["a" /* default */].store.SETTING, {
    updateStaffSetting: '' + __WEBPACK_IMPORTED_MODULE_3__store_modules_setting_constants__["a" /* default */].ACTION_UPDATE_SETTINGS
  })),
  watch: {}
});

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalSettings_EditMileageRateModal__ = __webpack_require__(847);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__globalSettings_EditMileageRateModal__["a"]; });




/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import localStorageKeys from '@/utils/local-storage-keys';
// import storeConstants from '@/store/constants';
// import {mapActions} from 'vuex';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "edit-mileage-rate-modal",
  props: {
    staffConfig: {
      type: Object
    }
  },
  components: {},
  methods: {
    handleCancel: function handleCancel() {
      this.$refs.editMileageRateModal.hide();
    },
    handleComleteEventClick: function handleComleteEventClick() {}
  },
  created: function created() {}
});

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "editMileageRateModal",
      staticClass: "edit-mileage-rate-modal",
      attrs: {
        id: "editMileageRateModal",
        "hide-header": "",
        "hide-footer": ""
      }
    },
    [
      _c("div", { staticClass: "modal-mileage-rate-wrapper" }, [
        _c("div", {}, [_vm._v("Edit MILEAGE RATE")]),
        _vm._v(" "),
        _c("div", { staticClass: "ap-field-input-wrapper" }, [
          _c("div", { staticClass: "title-field" }, [_vm._v("MILEAGE RATE")]),
          _vm._v(" "),
          _c("div", { staticClass: "ap-input-wrapper" })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d88948cc", esExports)
  }
}

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staff-management-settings-container" },
    [
      _c("div", { staticClass: "global-rate-of-pay-table" }, [
        _c("div", { staticClass: "table-header" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("HeaderColumn", {
                  staticClass: "col-mileage-rate",
                  attrs: {
                    headerObject: _vm.arrHeaderObj[0],
                    sortObject: _vm.sortObject
                  },
                  on: { CHANGE_SORT_OPTION: _vm.handleChangeSortOption }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-staff-settings" }, [
          _c("div", { staticClass: "ems-row" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-10" }, [
                _vm.editting
                  ? _c("div", { staticClass: "input-currency field-value" }, [
                      _vm.staffSettingCurrency.type === "checkbox"
                        ? _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.staffSettings.value,
                                    expression: "staffSettings.value"
                                  }
                                ],
                                staticClass: "value-text",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.staffSettings.value
                                  )
                                    ? _vm._i(_vm.staffSettings.value, null) > -1
                                    : _vm.staffSettings.value
                                },
                                on: {
                                  blur: _vm.handleBlurInputValue,
                                  change: function($event) {
                                    var $$a = _vm.staffSettings.value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.staffSettings,
                                            "value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.staffSettings,
                                            "value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.staffSettings, "value", $$c)
                                    }
                                  }
                                }
                              },
                              "input",
                              _vm.staffSettingCurrency,
                              false
                            )
                          )
                        : _vm.staffSettingCurrency.type === "radio"
                        ? _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.staffSettings.value,
                                    expression: "staffSettings.value"
                                  }
                                ],
                                staticClass: "value-text",
                                attrs: { type: "radio" },
                                domProps: {
                                  checked: _vm._q(_vm.staffSettings.value, null)
                                },
                                on: {
                                  blur: _vm.handleBlurInputValue,
                                  change: function($event) {
                                    _vm.$set(_vm.staffSettings, "value", null)
                                  }
                                }
                              },
                              "input",
                              _vm.staffSettingCurrency,
                              false
                            )
                          )
                        : _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.staffSettings.value,
                                    expression: "staffSettings.value"
                                  }
                                ],
                                staticClass: "value-text",
                                attrs: { type: _vm.staffSettingCurrency.type },
                                domProps: { value: _vm.staffSettings.value },
                                on: {
                                  blur: _vm.handleBlurInputValue,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.staffSettings,
                                      "value",
                                      $event.target.value
                                    )
                                  }
                                }
                              },
                              "input",
                              _vm.staffSettingCurrency,
                              false
                            )
                          )
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "mileage-rate-value field-value value-text"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("staffSettingCurrency")(
                              _vm.staffSettings.value || 0
                            )
                          )
                        )
                      ]
                    )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [
                _c("div", { staticClass: "group-action-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ap-btn edit-btn",
                      on: { click: _vm.handleEditSettingClick }
                    },
                    [_c("div", { staticClass: "icon" })]
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "editMileageRateModal",
          staticClass: "ap-modal edit-mileage-rate-modal",
          attrs: {
            id: "editMileageRateModal",
            "hide-header": "",
            "hide-footer": ""
          }
        },
        [
          _c("div", { staticClass: "modal-mileage-rate-wrapper" }, [
            _c("div", { staticClass: "h2-text" }, [
              _vm._v("Edit Mileage Rate")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ap-field-input-wrapper" }, [
              _c("div", { staticClass: "body-text" }, [_vm._v("Mileage Rate")]),
              _vm._v(" "),
              _c("div", { staticClass: "ap-input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.staffSettings.value,
                      expression: "staffSettings.value"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "number" },
                  domProps: { value: _vm.staffSettings.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.staffSettings, "value", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group-btn margin-top-24px" }, [
                _c(
                  "button",
                  {
                    staticClass: "ap-btn secondary cancel-btn",
                    on: { click: _vm.handleCancelClick }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ap-btn primary save-btn",
                    on: { click: _vm.handleSaveClick }
                  },
                  [_vm._v("Save")]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "ap-btn delete-btn" }, [
      _c("div", { staticClass: "icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b81a1ef", esExports)
  }
}

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "staff-management-settings-container" }, [
    _c("div", { staticClass: "title-table-staff-setting h2-text" }, [
      _vm._v("Staff Management")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "global-rate-of-pay-table" },
      [_c("GlobalRateOfPay", { attrs: { staffSettings: _vm.staffSettings } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38cc5678", esExports)
  }
}

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderGlobalSettings_vue__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2c3699_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderGlobalSettings_vue__ = __webpack_require__(2077);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2069)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a2c3699"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderGlobalSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2c3699_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderGlobalSettings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/globalSettings/SubHeaderGlobalSettings.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderGlobalSettings.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a2c3699", Component.options)
  } else {
    hotAPI.reload("data-v-0a2c3699", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("cf48497e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0a2c3699\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderGlobalSettings.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0a2c3699\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderGlobalSettings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.header-table-validator[data-v-0a2c3699] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 40px;\n}\n.subHeader[data-v-0a2c3699] {\n  margin-top: 3px;\n}\n.content-header[data-v-0a2c3699] {\n  width: 250px;\n}\n.float-left[data-v-0a2c3699] {\n  float: left;\n}\n.float-right[data-v-0a2c3699] {\n  float: right;\n}\n", ""]);

// exports


/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalSettings_SubHeaderButton__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(9);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subHeaderUserManagement',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  },
  components: {
    SubHeaderButton: __WEBPACK_IMPORTED_MODULE_0__globalSettings_SubHeaderButton__["a" /* default */]
  },
  data: function data() {
    return {
      btnAddValidator: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* default */].subHeaderBtn.addValidator
    };
  }
});

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderButton_vue__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d35d1e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderButton_vue__ = __webpack_require__(2076);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2073)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d35d1e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubHeaderButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d35d1e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SubHeaderButton_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/subHeaders/globalSettings/SubHeaderButton.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubHeaderButton.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d35d1e5", Component.options)
  } else {
    hotAPI.reload("data-v-7d35d1e5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5492fbe4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d35d1e5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d35d1e5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SubHeaderButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.btn-new-event[data-v-7d35d1e5] {\n  height: 26px;\n  margin-left: 15px;\n}\n.btn-new-event[data-v-7d35d1e5]:hover {\n  cursor: pointer;\n}\n.btn-new-event .btn-new-event-wrapper-icon[data-v-7d35d1e5] {\n  height: 25px;\n  width: 25px;\n  float: left;\n  border: 2px solid #00A4D6;\n  border-radius: 50px ;\n  position: relative;\n  top: -3px;\n}\n.btn-new-event .btn-new-event-wrapper-icon .btn-new-event-icon[data-v-7d35d1e5] {\n  color: #00A4D6;\n  position: relative;\n  top: 3px;\n  right: -4px;\n}\n.btn-new-event .btn-new-event-wrapper-icon .new-event-icon[data-v-7d35d1e5] {\n  top: 3px;\n  right: -4px;\n}\n.btn-new-event .btn-new-event-text[data-v-7d35d1e5] {\n  height: 17px;\n  width: 68px;\n  font-size: 14px;\n  font-weight: 600;\n  top: -4px;\n  margin: 0 0 0 10px;\n}\n.btn-new-event .btn-new-event-text .span-btn-text[data-v-7d35d1e5] {\n  color: #00A4D6;\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_plus__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_angle_double_right__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'button-sub-header-right',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    btnClick: function btnClick() {
      // Create validator
      if (this.item.name === __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].subHeaderBtn.addValidator.name) {
        var modalData = {
          action: __WEBPACK_IMPORTED_MODULE_5__consts__["a" /* default */].modalAction.createValidator,
          data: null
        };
        this.$modal.show('eventModal', modalData);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({}))
});

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-new-event",
      on: {
        click: function($event) {
          _vm.btnClick()
        }
      }
    },
    [
      _c(
        "span",
        { staticClass: "btn-new-event-wrapper-icon" },
        [
          _c("Icon", {
            staticClass: "btn-new-event-icon",
            class: ["CreateEvent" == _vm.item.name ? "new-event-icon" : ""],
            attrs: { name: _vm.item.iconName }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("a", { staticClass: "btn-new-event-text" }, [
        _c("span", { staticClass: "span-btn-text" }, [
          _vm._v(_vm._s(_vm.item.btnText))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d35d1e5", esExports)
  }
}

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "header-table-validator" }, [
      _c("div", { staticClass: "h2-text title-table-validators" }, [
        _vm._v("Validators")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a2c3699", esExports)
  }
}

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn global-setting-page-container" },
    [
      _c("div", { staticClass: "h1-text" }, [_vm._v("SETTINGS")]),
      _vm._v(" "),
      _c("SubHeader"),
      _vm._v(" "),
      _c("TableGloBalSettings", { attrs: { loading: _vm.isLoading } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "staff-management-container" },
        [
          _c("StaffManagement", {
            attrs: { staffSettings: _vm.settings.staffConfiguration }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "h2-text margin-top-24px" }, [
        _vm._v("\n    Global Email Template\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.configEmail.emailTags.length
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("div", { staticClass: "h3-text margin-top-24px" }, [
                  _vm._v("Reset Password Email Template")
                ]),
                _vm._v(" "),
                _c("vue-ckeditor", {
                  attrs: { config: _vm.configEmail },
                  model: {
                    value: _vm.settings.resetPasswordEmailTemplate.body,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.settings.resetPasswordEmailTemplate,
                        "body",
                        $$v
                      )
                    },
                    expression: "settings.resetPasswordEmailTemplate.body"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.configEmail.emailTags.length
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("div", { staticClass: "h3-text margin-top-24px" }, [
                  _vm._v("Temporary Password Email Template")
                ]),
                _vm._v(" "),
                _c("vue-ckeditor", {
                  attrs: { config: _vm.configEmail },
                  model: {
                    value: _vm.settings.temporaryPasswordEmailTemplate.body,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.settings.temporaryPasswordEmailTemplate,
                        "body",
                        $$v
                      )
                    },
                    expression: "settings.temporaryPasswordEmailTemplate.body"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 margin-top-24px" }, [
          _c(
            "button",
            {
              staticClass: "ap-btn primary",
              on: {
                click: function($event) {
                  _vm.saveData()
                }
              }
            },
            [_vm._v("Save")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08433b7d", esExports)
  }
}

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffingSection_vue__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a5df18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffingSection_vue__ = __webpack_require__(2098);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2080)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33a5df18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffingSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a5df18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffingSection_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/manager/staffing/StaffingSection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StaffingSection.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33a5df18", Component.options)
  } else {
    hotAPI.reload("data-v-33a5df18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("12141cce", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33a5df18\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffingSection.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33a5df18\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffingSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.manage-staffing-page-container[data-v-33a5df18] {\n  height: calc(100vh - 231px);\n  overflow-y: hidden;\n}\n.manage-staffing-page-container .staffing-table[data-v-33a5df18] {\n  height: calc(100% - 124px);\n}\n.icon-size[data-v-33a5df18] {\n  width: 100px;\n  height: 100px;\n}\n.loading-staffing[data-v-33a5df18] {\n  clear: both;\n  padding-top: 30px;\n  text-align: center;\n}\n.noDisplay[data-v-33a5df18] {\n  display: none;\n}\n.table-title[data-v-33a5df18] {\n  height: 40px;\n  line-height: 20px;\n}\n.staffing-table[data-v-33a5df18] {\n  padding: 0 15px;\n  overflow-x: auto;\n}\n.event-row-wrapper[data-v-33a5df18] {\n  margin: 8px 0;\n}\n.search-session[data-v-33a5df18] {\n  height: 124px;\n  padding-top: 35px !important;\n  padding-left: 15px !important;\n}\n.search-session .placeholder-italic[data-v-33a5df18] {\n  margin-top: 10px;\n  border: 1px solid #9b9b9b;\n  padding: 3px 15px;\n  font-family: 'Open Sans', sans-serif;\n  height: 42px;\n  border-radius: 3px;\n  background-color: #ffffff;\n}\n.search-session .search-icon[data-v-33a5df18] {\n  width: 26px;\n  height: 26px;\n  color: #00A4D6;\n  background-color: #00A4D6;\n  position: absolute;\n  z-index: 999;\n  right: 10px;\n  top: 18px;\n  -webkit-mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  mask: url(" + __webpack_require__(27) + ") no-repeat center;\n  background: url(" + __webpack_require__(114) + ");\n}\n.search-session .btn-create-client[data-v-33a5df18] {\n  position: relative;\n  width: 150px;\n}\n.search-session .btn-create-client .icon-add-client[data-v-33a5df18] {\n  z-index: 999;\n  color: #ffffff;\n  background-color: #0080a5;\n  width: 27px;\n  height: 27px;\n  border-radius: 15px;\n  margin-top: 17px;\n  display: inline-block;\n}\n.search-session .btn-create-client .btn-text[data-v-33a5df18] {\n  display: inline-block;\n  position: absolute;\n  top: 18px;\n  left: 35px;\n}\n.search-session .btn-blue[data-v-33a5df18] {\n  margin-right: 15px;\n  margin-top: 20px;\n}\n.search-session .ap-btn[data-v-33a5df18] {\n  padding: 6px 24px;\n}\n.none-items[data-v-33a5df18] {\n  text-align: center;\n}\n.none-items .none-items-text[data-v-33a5df18] {\n  height: 16px;\n  color: #8E8E8E;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n  line-height: 16px;\n  text-transform: uppercase;\n  margin: 75px auto 15px;\n}\n.none-items .ap-btn[data-v-33a5df18] {\n  padding: 6px 24px;\n}\n", ""]);

// exports


/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_staffing_StaffingHeader__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_staffing_StaffingRow__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_ScrollTop__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_staff_StaffDetailModal__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_commons_Spinner__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_spinner__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_datatable_DtPaging__ = __webpack_require__(261);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import consts from '../../../_consts';



/* Register component with one of 2 methods */





var itemPerPage = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plan-and-approve',
  components: {
    StaffingHeader: __WEBPACK_IMPORTED_MODULE_3__components_staffing_StaffingHeader__["a" /* default */],
    StaffingRow: __WEBPACK_IMPORTED_MODULE_4__components_staffing_StaffingRow__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon__["a" /* default */],
    ScrollTop: __WEBPACK_IMPORTED_MODULE_5__components_utils_ScrollTop__["a" /* default */],
    DtPaging: __WEBPACK_IMPORTED_MODULE_14__components_datatable_DtPaging__["a" /* default */],
    StaffDetailModal: __WEBPACK_IMPORTED_MODULE_6__components_modal_staff_StaffDetailModal__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_8__components_commons_Spinner__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    getHeightOfComp: function getHeightOfComp() {
      return 127;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])({
    getListEvent: 'GETTERS_LIST_EVENT',
    getLoading: 'GETTERS_IS_LOADING_STAFFING',
    staffingList: 'GETTER_GET_STAFF_LIST'
  })),
  data: function data() {
    return {
      fixElement: false,
      keyword: '',
      pagingObj: {
        currentPage: 1,
        itemsPerPage: itemPerPage,
        sortType: 'firstName',
        sortReverse: false,
        totalItems: 0
      },
      staffList: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    infiniteHandler: function infiniteHandler($state) {
      var vm = this;
      this.getAllStaff().then(function (res) {
        if (res && vm.pagingObj.currentPage * vm.pagingObj.itemsPerPage > vm.staffList.length) {
          $state.complete();
        } else {
          $state.loaded();
        }
        vm.pagingObj.currentPage++;
      });
    },
    resetPagingOption: function resetPagingOption() {
      this.pagingObj.currentPage = 1;
      this.pagingObj.itemsPerPage = itemPerPage;
      this.setIdToState(-1);
    },
    changePagingOptions: function changePagingOptions(pagingObj) {
      this.resetPagingOption();
      this.staffList = [];
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    handleScroll: function handleScroll() {
      this.fixElement = window.scrollY >= 180;
    },
    getAllStaff: function getAllStaff(params) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var body = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          keyword: _this.keyword.toLowerCase(),
          currentPage: _this.pagingObj.currentPage,
          itemsPerPage: _this.pagingObj.itemsPerPage,
          sortType: _this.pagingObj.sortType,
          sortReverse: _this.pagingObj.sortReverse
        }, params);

        _this.getStaffList(body).then(function (response) {
          if (response) {
            var _staffList;

            (_staffList = _this.staffList).push.apply(_staffList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.listStaff));
            resolve(response);
          }
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    createNewTempStaff: function createNewTempStaff() {
      this.staffList = [{
        id: 0,
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        role: '',
        payRates: 0,
        address: '',
        events: '',
        isEditing: true
      }].concat(this.staffList || []);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])({
    getStaffList: 'ACTION_GET_STAFF_LIST'
  }), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapMutations */])({
    setIdToState: 'MUTATION_SET_EXPAND_ID',
    saveStaffList: 'MUTATION_SAVE_STAFF_LIST'
  })),
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', __WEBPACK_IMPORTED_MODULE_12__consts__["a" /* default */].viewNames.staffing);
    if (this.$route.params && this.$route.params.detail) {
      this.$modal.show('staffDetailModal', this.$route.params.detail);
    }
  },

  watch: {
    keyword: __WEBPACK_IMPORTED_MODULE_13_lodash__["debounce"](function () {
      this.changePagingOptions();
    }, 500)
  }
});

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffingHeader_vue__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1259bebc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffingHeader_vue__ = __webpack_require__(2087);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2084)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffingHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1259bebc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffingHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/staffing/StaffingHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StaffingHeader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1259bebc", Component.options)
  } else {
    hotAPI.reload("data-v-1259bebc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2085);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("750c9348", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1259bebc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffingHeader.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1259bebc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffingHeader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.table-header.table-staffing {\n  color: #8E8E8E;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.1px;\n}\n.table-header.table-staffing .dt-content .dt-header .text-center {\n  text-align: center;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col {\n  float: left;\n  text-transform: uppercase;\n  overflow: hidden;\n  height: 33px;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .content {\n  margin-top: 12px;\n  margin-left: 8px;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .sort-icon {\n  vertical-align: middle;\n  width: 6px;\n  height: 10px;\n  margin: 5px;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .header-container {\n  position: relative;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n  cursor: pointer;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-line {\n  position: absolute;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop:hover .crop-line {\n  border-color: #b9b9b9;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-top-line {\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #b9b9b9;\n  cursor: n-resize;\n  height: 16px;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-bottom-line {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  /* 5px for the mouse cursor update size */\n  border-bottom: 1px solid #b9b9b9;\n  cursor: s-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-left-line {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-left: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-right-line {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 5px;\n  /* 5px for the mouse cursor update size */\n  border-right: 1px solid #b9b9b9;\n  cursor: col-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-corner {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n  border: 1px solid #808080;\n  background: #FFF;\n  opacity: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-top-left-corner {\n  top: -3px;\n  left: -3px;\n  cursor: nw-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-top-right-corner {\n  top: -3px;\n  right: -3px;\n  cursor: ne-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-bottom-left-corner {\n  bottom: -3px;\n  left: -3px;\n  cursor: sw-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop .crop-bottom-right-corner {\n  bottom: -3px;\n  right: -3px;\n  cursor: se-resize;\n}\n.table-header.table-staffing .dt-content .dt-header .header-col .crop:hover .crop-corner {\n  opacity: 1;\n}\n", ""]);

// exports


/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_sort__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_sort_up__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_sort_down__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-header',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    pagingObj: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    columnWidth: 'GETTER_GET_COLUMN_TABLE_STAFFING'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setSortOption: function setSortOption(sortType) {
      if (!this.resizing) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
        this.$emit('CHANGE_PAGING_OPTIONS', this.pagingObj);
      }
    },

    changeColumnWidth: function changeColumnWidth(colName, mouseDownEvent) {
      this.resizing = true;
      var vueApp = this;
      // get current mouse position
      var shiftX = mouseDownEvent.clientX;
      // header width
      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = dtHeaderEl.getBoundingClientRect().width;
      // get maximum width
      var maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
      var newWidth = maxLeft;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      function onMouseMove(event) {
        // new position
        var bufferPx = event.clientX - shiftX;
        var newHeaderWidth = headerWidth + bufferPx;

        if (bufferPx < 0 && maxLeft - Math.abs(bufferPx) < 20) {
          newWidth = 20;
          newHeaderWidth = headerWidth - (maxLeft - 20);
        } else {
          newWidth = maxLeft + bufferPx;
        }

        // save data
        vueApp.saveColumnWidthStaffing({
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: colName,
          newWidth: newWidth.toFixed(2)
        }, true);
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        setTimeout(function () {
          vueApp.resizing = false;
        }, 50);
      }
    },
    saveDefaultColumnWidth: function saveDefaultColumnWidth(isWidthPercent) {
      var _this = this;

      var dtHeaderEl = document.getElementById('dt-header');
      var headerWidth = void 0;
      if (dtHeaderEl) {
        headerWidth = dtHeaderEl.getBoundingClientRect().width;
      }
      var arrCol = [{
        colName: 'firstName',
        newWidth: 140
      }, {
        colName: 'lastName',
        newWidth: 140
      }, {
        colName: 'email',
        newWidth: 160
      }, {
        colName: 'phoneNumber',
        newWidth: 140
      }, {
        colName: 'role',
        newWidth: 140
      }, {
        colName: 'events',
        newWidth: 140
      }, {
        colName: 'payRates',
        newWidth: 90
      }, {
        colName: 'address',
        newWidth: 160
      }, {
        colName: 'actions',
        newWidth: 140
      }];
      // let newHeaderWidth = isWidthPercent ? document.body.clientWidth - 30 : 1000;
      var newHeaderWidth = headerWidth < 1200 ? 1200 : headerWidth;
      arrCol.forEach(function (element) {
        var objResize = {
          headerWidth: headerWidth,
          newHeaderWidth: newHeaderWidth,
          colName: element.colName,
          newWidth: isWidthPercent ? 0 : element.newWidth,
          isWidthPercent: isWidthPercent
        };
        if (isWidthPercent) {
          _this.mutationSaveColumnWidthStaffing(objResize);
          var tbHeaderId = 'dt-header';
          var tbBodyId = 'dt-body';
          var _dtHeaderEl = document.getElementById(tbHeaderId);
          var dtBodyEl = document.getElementById(tbBodyId);
          if (_dtHeaderEl) {
            _dtHeaderEl.style.width = 'unset';
          }
          if (dtBodyEl) {
            dtBodyEl.style.width = 'unset';
          }
        } else {
          _this.saveColumnWidthStaffing(objResize);
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    saveColumnWidthStaffing: 'ACTION_SAVE_COLUMN_STAFFING_WIDTH'
  }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])({
    mutationSaveColumnWidthStaffing: 'MUTATION_SAVE_COLUMN_STAFFING_WIDTH'
  })),
  mounted: function mounted() {
    if (document.body.clientWidth < 1200) {
      this.saveDefaultColumnWidth();
    }
  },
  created: function created() {
    var _this2 = this;

    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_6_lodash__["debounce"](function (event) {
      if (document.body.clientWidth < 1200) {
        _this2.saveDefaultColumnWidth();
      } else {
        _this2.saveDefaultColumnWidth(true);
      }
    }, 100));
  }
});

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-header table-staffing" }, [
    _c("div", { staticClass: "dt-content" }, [
      _c("div", { staticClass: "dt-header", attrs: { id: "dt-header" } }, [
        _c(
          "div",
          {
            staticClass: "header-col padding-left-27px",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "10%"
            },
            attrs: { id: "firstName" },
            on: {
              click: function($event) {
                _vm.setSortOption("firstName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("firstName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              first name\n              "),
                    this.pagingObj.sortType != "firstName"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "firstName" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "firstName" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "10%"
            },
            attrs: { id: "lastName" },
            on: {
              click: function($event) {
                _vm.setSortOption("lastName")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("lastName", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "content no-select" }, [
                  _vm._v("\n              last name\n              "),
                  _c(
                    "span",
                    [
                      this.pagingObj.sortType != "lastName"
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "lastName" &&
                      this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-up" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.pagingObj.sortType == "lastName" &&
                      !this.pagingObj.sortReverse
                        ? _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "16%"
            },
            attrs: { id: "email" },
            on: {
              click: function($event) {
                _vm.setSortOption("email")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("email", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              email\n              "),
                    this.pagingObj.sortType != "email"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "email" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "email" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.phoneNumber.size
                ? _vm.columnWidth.phoneNumber.size + "px"
                : "8%"
            },
            attrs: { id: "phoneNumber" },
            on: {
              click: function($event) {
                _vm.setSortOption("phone")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("phoneNumber", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              phone number\n              "),
                    this.pagingObj.sortType != "phone"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "phone" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "phone" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.role.size
                ? _vm.columnWidth.role.size + "px"
                : "14%"
            },
            attrs: { id: "role" },
            on: {
              click: function($event) {
                _vm.setSortOption("role")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("role", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              role\n              "),
                    this.pagingObj.sortType != "role"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "role" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "role" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.events.size + "px"
                : "10%"
            },
            attrs: { id: "events" },
            on: {
              click: function($event) {
                _vm.setSortOption("events")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("events", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              events\n              "),
                    this.pagingObj.sortType != "events"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "events" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "events" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.payRates.size + "px"
                : "8%"
            },
            attrs: { id: "payRates" },
            on: {
              click: function($event) {
                _vm.setSortOption("payRates")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("payRates", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              hourly rate\n              "),
                    this.pagingObj.sortType != "payRates"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "payRates" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "payRates" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.address.size + "px"
                : "20%"
            },
            attrs: { id: "address" },
            on: {
              click: function($event) {
                _vm.setSortOption("address")
              }
            }
          },
          [
            _c("div", { staticClass: "header-container" }, [
              _c("div", { staticClass: "crop" }, [
                _c("div", {
                  staticClass: "crop-line crop-right-line",
                  on: {
                    mousedown: function($event) {
                      _vm.changeColumnWidth("address", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content no-select" },
                  [
                    _vm._v("\n              address\n              "),
                    this.pagingObj.sortType != "address"
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "address" &&
                    this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-up" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.pagingObj.sortType == "address" &&
                    !this.pagingObj.sortReverse
                      ? _c("Icon", {
                          staticClass: "sort-icon",
                          attrs: { name: "sort-down" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header-col",
            style: {
              width: _vm.columnWidth.actions.size
                ? _vm.columnWidth.actions.size + "px"
                : "4%"
            },
            attrs: { id: "actions" }
          },
          [_vm._m(0)]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "crop" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1259bebc", esExports)
  }
}

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffingRow_vue__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e3de95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffingRow_vue__ = __webpack_require__(2092);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2089)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07e3de95"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffingRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e3de95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffingRow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/staffing/StaffingRow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StaffingRow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07e3de95", Component.options)
  } else {
    hotAPI.reload("data-v-07e3de95", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2090);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9accbc86", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07e3de95\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffingRow.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07e3de95\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffingRow.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.map-wrapper[data-v-07e3de95] {\n  font-family: 'Open Sans', sans-serif;\n  border: 0 solid #e6e6e6;\n  border-radius: 3px;\n  width: 100%;\n  min-height: 0;\n  z-index: unset;\n  height: 19px;\n  color: #1D1D1D;\n  font-size: 12px;\n  line-height: 19px;\n}\n.event-row-wrapper[data-v-07e3de95] {\n  margin: 8px 0;\n}\n.event-row-wrapper:last-child .event-row .show-on-top[data-v-07e3de95] {\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n}\n.overlay-staff-row[data-v-07e3de95] {\n  position: absolute;\n  background: black;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 998;\n  opacity: 0.02;\n}\n.openContent[data-v-07e3de95] {\n  height: 50px !important;\n  -webkit-transition: height ease 0.5s;\n  transition: height ease 0.5s;\n}\n.openContent .dt-row-item-detail[data-v-07e3de95] {\n  clear: both;\n}\n.openContent .dt-row-item-detail .ap-btn[data-v-07e3de95] {\n  padding: 6px 24px;\n}\n.openContent .dt-row-item-detail .item-detail-header[data-v-07e3de95] {\n  text-transform: uppercase;\n  font-size: 12px;\n  line-height: 16px;\n  border-bottom: solid 1px #7b7b7b;\n  height: 34px;\n  background-color: #606060;\n  font-family: \"Open Sans\";\n  color: #ffffff;\n  letter-spacing: 0.1px;\n}\n.openContent .dt-row-item-detail .item-detail-body[data-v-07e3de95] {\n  background-color: #ffffff;\n  padding: 20px 10px 15px 20px;\n  height: 314px;\n}\n.openContent .dt-row-item-detail .item-detail-body .row-detail-icon-exclamation-circle[data-v-07e3de95] {\n  height: 14px;\n  width: 14px;\n  border-radius: 6px;\n  padding: 0;\n  color: #0080a5;\n  background-color: #ffffff;\n  overflow: visible;\n}\n.openContent .dt-row-item-detail .item-detail-body .icon-alert[data-v-07e3de95] {\n  padding: 2px 0 0 22px;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-alert[data-v-07e3de95] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  padding: 0 20px 0 15px;\n  color: #626262;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field[data-v-07e3de95] {\n  margin-top: 20px;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field[data-v-07e3de95]:first-child {\n  margin-top: 0;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-label[data-v-07e3de95] {\n  font-size: 12px;\n  text-transform: capitalize;\n  line-height: 18px;\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-label .label-address[data-v-07e3de95] {\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value .shipping-address[data-v-07e3de95] {\n  width: 100%;\n  border: solid 1px #b9b9b9;\n  border-radius: 4px;\n  height: 32px;\n  font-size: 12px;\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n  padding-left: 16px;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value textarea[data-v-07e3de95] {\n  width: 100%;\n  border-radius: 4px;\n  border: solid 1px #b9b9b9;\n  padding: 5px 10px;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value textarea.custom-notes[data-v-07e3de95] {\n  height: 55px;\n  padding-left: 14px;\n  color: #231f20;\n}\n.openContent .dt-row-item-detail .item-detail-body .notes-field .text-value textarea.additional-comments[data-v-07e3de95] {\n  height: 58px;\n  padding-left: 14px;\n  font-size: 12px;\n  font-family: 'Open Sans', sans-serif;\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact[data-v-07e3de95] {\n  margin-bottom: 20px;\n  margin-right: 10px;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact .phoneAndEmail[data-v-07e3de95] {\n  height: 32px;\n  width: 100%;\n  border: 1px solid #b9b9b9;\n  border-radius: 4px;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0 0 0 13px;\n  font-size: 12px;\n  color: #424242;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact .label[data-v-07e3de95] {\n  color: #1A1718;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  text-transform: capitalize;\n  line-height: 18px;\n}\n.openContent .dt-row-item-detail .item-detail-body .text-contact .contactName[data-v-07e3de95] {\n  line-height: 31px;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-off-text[data-v-07e3de95] {\n  color: #e6e6e6 !important;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-off-checkbox[data-v-07e3de95] {\n  border: 1.5px solid rgba(0, 0, 0, 0.02) !important;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-off-checkbox[data-v-07e3de95]:after {\n  border: 1.5px solid rgba(0, 0, 0, 0.02) !important;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item[data-v-07e3de95] {\n  margin-left: 0;\n  margin-top: 8px;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item .text[data-v-07e3de95] {\n  color: #626262;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  display: inline;\n  margin-left: 5px;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item input[type=checkbox][data-v-07e3de95] {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item label[data-v-07e3de95] {\n  cursor: pointer;\n  text-indent: -9999px;\n  width: 32px;\n  height: 18px;\n  background: #ffffff;\n  border-radius: 15.5px;\n  position: relative;\n  top: 1.5px;\n  left: 5px;\n  border: 1.5px solid rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item label[data-v-07e3de95]:after {\n  content: '';\n  position: absolute;\n  top: -0.5px;\n  left: -0.5px;\n  width: 16px;\n  height: 16px;\n  background: #ffffff;\n  border-radius: 15.5px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  border: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item input:checked + label[data-v-07e3de95] {\n  background: #0080a5;\n  border: 1.5px solid #0080a5;\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item input:checked + label[data-v-07e3de95]:after {\n  left: calc(100%);\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);\n}\n.openContent .dt-row-item-detail .item-detail-body .add-on-wrapper .add-on-item label[data-v-07e3de95]:active:after {\n  width: 15px;\n}\n.openContent .dt-row-item-detail .item-detail-body .func-group button[data-v-07e3de95] {\n  font-size: 14px;\n  height: 39px;\n  font-family: 'Open Sans', sans-serif;\n  text-transform: uppercase;\n}\n.openContent .dt-row-item-detail .item-detail-body .func-group button .func-icon[data-v-07e3de95] {\n  width: 18px;\n  height: 18px;\n  color: #ffffff;\n  float: left;\n}\n.openContent .dt-row-item-detail .item-detail-body .func-group .grey-3[data-v-07e3de95] {\n  color: #b9b9b9;\n}\n.displayNone[data-v-07e3de95] {\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: height ease 0.5s;\n  transition: height ease 0.5s;\n}\n.event-row[data-v-07e3de95] {\n  height: 56px;\n  background-color: #ffffff;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);\n  color: #1D1D1D;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  position: relative;\n}\n.event-row .column[data-v-07e3de95] {\n  float: left;\n  background-color: #ffffff;\n  border-radius: 4px;\n  height: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 8px;\n}\n.event-row .column.col-group-btn-action[data-v-07e3de95] {\n  padding: 0 0 0 8px;\n}\n.event-row .column .content.column-name[data-v-07e3de95] {\n  padding: 12px 0 0 8px;\n}\n.event-row .column .content.paddingTop5px[data-v-07e3de95] {\n  padding-top: 5px;\n}\n.event-row .column .content .input-staff[data-v-07e3de95] {\n  width: 100%;\n  max-width: 100%;\n  border: none;\n  color: #1D1D1D;\n  font-size: 12px;\n  background-color: #ffffff;\n}\n.event-row .column .content .input-staff[data-v-07e3de95]:disabled {\n  background-color: #ffffff;\n  color: #1D1D1D;\n  font-size: 12px;\n}\n.event-row .column .content .placeholder-color[data-v-07e3de95] {\n  color: #b9b9b9;\n}\n.event-row .btn-func .btn-func-item[data-v-07e3de95] {\n  float: left;\n  background-color: #00A4D6;\n  border-radius: 4px;\n  height: 32px;\n  width: 32px;\n  margin-left: 6px;\n}\n.event-row .btn-func .btn-func-item.btn-func-item[data-v-07e3de95]:first-child {\n  margin-left: 0;\n}\n.event-row .btn-func .btn-func-item .func-icon[data-v-07e3de95] {\n  width: 26px;\n  height: 26px;\n  margin: 4px auto;\n}\n.event-row .btn-func .btn-func-item .func-icon[data-v-07e3de95]:hover {\n  cursor: pointer;\n}\n.event-row .btn-func .btn-func-item .func-icon.icon-info[data-v-07e3de95] {\n  background: url(" + __webpack_require__(848) + ") no-repeat center;\n}\n.event-row .btn-func .btn-func-item .func-icon.icon-edit[data-v-07e3de95] {\n  background: url(" + __webpack_require__(153) + ") no-repeat center;\n}\n.event-row .btn-func .btn-func-item .func-icon.icon-delete[data-v-07e3de95] {\n  background: url(" + __webpack_require__(154) + ") no-repeat center;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.event-row .btn-func .btn-func-item .func-icon.icon-info[data-v-07e3de95] {\n    background: url(" + __webpack_require__(848) + ") no-repeat center;\n}\n.event-row .btn-func .btn-func-item .func-icon.icon-edit[data-v-07e3de95] {\n    background: url(" + __webpack_require__(153) + ") no-repeat center;\n}\n.event-row .btn-func .btn-func-item .func-icon.icon-delete[data-v-07e3de95] {\n    background: url(" + __webpack_require__(154) + ") no-repeat center;\n}\n}\n.event-row .select-role[data-v-07e3de95] {\n  text-transform: capitalize;\n  position: relative;\n  height: 56px;\n  /* &:hover {\n      cursor: pointer;\n    }*/\n}\n.event-row .role-selector[data-v-07e3de95] {\n  position: absolute;\n  width: 115px;\n  background: #ffffff;\n  padding: 16px;\n  z-index: 999;\n  border-radius: 4px;\n  line-height: 25px;\n  height: 112px;\n  -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);\n  margin-top: 28px;\n}\n.MicrosoftMap.as_container_search[data-v-07e3de95] {\n  width: 250px;\n}\n.li-red[data-v-07e3de95]:before {\n  color: #a42022 !important;\n}\n.padding-left-71[data-v-07e3de95] {\n  padding-left: 71px;\n}\n.padding-left-27[data-v-07e3de95] {\n  padding-left: 27px;\n}\n.padding-top-9px[data-v-07e3de95] {\n  padding-top: 9px;\n}\n", ""]);

// exports


/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_ellipsis_v__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_google_autocomplete__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_vue_the_mask__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_onclick_outside__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_onclick_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_onclick_outside__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import constants from '../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-row',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_4_vue_google_autocomplete__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_5__utils_vue_the_mask__["a" /* TheMask */],
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7_onclick_outside___default.a
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      checkedConcierge: false,
      checkedLead: false,
      checkedScreener: false,
      isLoading: false,
      isDisplay: false,
      editable: false,
      isLocked: false,
      showOnModal: false,
      editEventAdmin: false,
      viewMode: false,
      suggestChanges: false,
      isEditing: false,
      tempStaff: {},
      canSave: false,
      selectedRoles: [],
      roleOptions: [{ text: 'lead', value: 'lead' }, { text: 'screener', value: 'screener' }, { text: 'concierge', value: 'concierge' }],
      isSelectRole: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isUsedBingMap: function isUsedBingMap() {
      return false === 'true';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getExpandId: 'GETTERS_GET_EXPAND_ID',
    columnWidth: 'GETTER_GET_COLUMN_TABLE_STAFFING'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setEditStaff: function setEditStaff() {
      this.isEditing = true;
      this.tempStaff = __WEBPACK_IMPORTED_MODULE_6_lodash__["clone"](this.item);
      if (this.getExpandId !== this.item.id) {
        this.setIdToState(this.item.id);
      }
      if (this.isUsedBingMap) {
        window.Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
          callback: this.onLoadBingSuggest,
          errorCallback: this.onErrorBingSuggest
        });
      }
    },
    openStaffDetail: function openStaffDetail(item) {
      this.setStaffDetailForNavigation(item);
      this.$modal.show('staffDetailModal', item);
    },
    cancelSave: function cancelSave() {
      this.isEditing = false;
      this.item = __WEBPACK_IMPORTED_MODULE_6_lodash__["clone"](this.tempStaff);
      this.item.isEditing = false;
      this.setIdToState(this.item.id || 0);
      var roleString = this.item.role || '';
      this.selectedRoles = roleString.replace(/\s/g, '').split(',') || [];
    },
    saveStaff: function saveStaff() {
      var _this = this;

      if (!this.item.email.match(/\S+@\S+\.\S+/)) {
        this.$toastr('error', 'Email has invalid format!', '');
        return;
      }
      this.callApiCreateStaff(this.item).then(function (response) {
        if (!response.message) {
          _this.isEditing = false;
          _this.item.isEditing = false;
          _this.setIdToState(_this.item.id);
          // this.$emit('getListStaff');
        } else {
          _this.$toastr('error', response.message, '');
        }
      });
    },
    deleteStaff: function deleteStaff() {
      var _this2 = this;

      this.$swal({
        title: "<div class='ems_alert_title'>delete staff</div>",
        html: '<div class=\'ems_alert_des\'>Are you sure to delete?</div>',
        confirmButtonColor: '#0080A5',
        confirmButtonText: 'DELETE',
        showCancelButton: true,
        cancelButtonColor: '#fff',
        cancelButtonText: 'CANCEL',
        buttonsStyling: true,
        reverseButtons: true,
        confirmButtonClass: 'ems_alert_confirm open',
        cancelButtonClass: 'ems_alert_cancel',
        customClass: 'ems_confirm',
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 605
      }).then(function (result) {
        if (result.value) {
          if (_this2.item.id === 0) {
            _this2.$emit('getListStaff');
            return;
          }
          _this2.callApiDeleteStaff(_this2.item).then(function (response) {
            if (!response.message) {
              _this2.$emit('getListStaff');
            }
          });
        }
      });
    },
    showSelectRole: function showSelectRole() {
      this.isSelectRole = true;
      this.isEditing = true;
      this.tempStaff = __WEBPACK_IMPORTED_MODULE_6_lodash__["clone"](this.item);
      if (this.getExpandId !== this.item.id) {
        this.setIdToState(this.item.id);
      }
      var roleString = this.item.role || '';
      this.selectedRoles = roleString.length > 0 ? roleString.replace(/\s/g, '').split(',') : [];
    },
    getRolesShow: function getRolesShow() {
      return this.item.role ? this.item.role.replace(/,/g, ', ') : 'Select roles';
    },
    hideSelectRole: function hideSelectRole() {
      this.isSelectRole = false;
      this.item.role = this.selectedRoles.join(',');
    },
    toggleRole: function toggleRole(role) {
      console.log(role + ' -- item role: ' + this.item.role);
      var roleString = this.item.role || '';
      var roleArr = roleString.length > 0 ? roleString.replace(/\s/g, '').split(',') : [];
      var index = roleArr.indexOf(role);
      if (index >= 0) {
        roleArr.splice(index, 1);
      } else {
        roleArr.push(role);
      }
      this.item.role = roleArr.join(', ');
    },
    checkIsRole: function checkIsRole(role) {
      var checked = this.item && this.item.role && this.item.role.indexOf(role) >= 0;
      console.log(role + ' -- item check role: ' + this.item.role + ' ischeck:' + checked);
      return checked;
    },
    onLoadBingSuggest: function onLoadBingSuggest() {
      var _this3 = this;

      var options = { maxResults: 5 };
      setTimeout(function () {
        new window.Microsoft.Maps.AutosuggestManager(options).attachAutosuggest('#searchBoxStaff-' + _this3.index, '#searchBoxStaffContainer-' + _this3.index, _this3.selectedAddressFromBing);
      }, 1000);
    },
    onErrorBingSuggest: function onErrorBingSuggest(error) {
      console.log('error=', error);
    },

    // START BING MAP SECTION
    selectedAddressFromBing: function selectedAddressFromBing(obj) {
      var addressDetail = obj.address;
      if (!addressDetail.adminDistrict || !addressDetail.locality || !addressDetail.postalCode) {
        this.$toast.success('Please enter a complete address including city and state or zip code', '', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$toastOpt.optError));
        return;
      }
      this.item.address = addressDetail.formattedAddress;
    },

    // START GOOGLE MAP SECTION
    setPlace: function setPlace(data, place) {
      this.item.address = place.formatted_address;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    callApiCreateStaff: 'ACTION_CREATE_STAFF',
    callApiDeleteStaff: 'ACTION_DELETE_STAFF'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    setIdToState: 'MUTATION_SET_EXPAND_ID',
    setStaffDetailForNavigation: 'MUTATION_SET_STAFF_DETAIL'
  })),
  mounted: function mounted() {
    if (this.isUsedBingMap) {
      if (window.Microsoft.Maps.AutosuggestManager == null) {
        window.Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
          callback: this.onLoadBingSuggest,
          errorCallback: this.onErrorBingSuggest
        });
      } else {
        this.onLoadBingSuggest();
      }
    }
    this.canSave = this.item.firstName && this.item.lastName && this.item.email && this.item.phone && this.item.role && this.item.payRates && this.item.address;
    var roleString = this.item.role || '';
    this.selectedRoles = roleString.length > 0 ? roleString.replace(/\s/g, '').split(',') : [];
  },

  watch: {
    item: {
      handler: function handler(item) {
        this.canSave = this.item.firstName && this.item.lastName && this.item.email && this.item.phone && this.item.role && this.item.payRates && this.item.address;
      },

      deep: true
    }
  }
});

/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _vm.getExpandId != -1 && _vm.getExpandId != _vm.item.id
      ? _c("div", { staticClass: "overlay-staff-row" })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "event-row" },
      [
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "10%"
            }
          },
          [
            _c("div", { staticClass: "content padding-left-27px" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.firstName,
                        expression: "item.firstName"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "first name",
                      placeholder: "First Name"
                    },
                    domProps: { value: _vm.item.firstName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "firstName", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v(_vm._s(_vm.item.firstName))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "10%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.lastName,
                        expression: "item.lastName"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "last name",
                      placeholder: "Last Name"
                    },
                    domProps: { value: _vm.item.lastName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "lastName", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v(_vm._s(_vm.item.lastName))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "16%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.email,
                        expression: "item.email"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "email",
                      placeholder: "Email"
                    },
                    domProps: { value: _vm.item.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "email", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v(_vm._s(_vm.item.email))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.phoneNumber.size
                ? _vm.columnWidth.phoneNumber.size + "px"
                : "8%"
            }
          },
          [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("the-mask", {
                  staticClass: "input-staff",
                  class: {
                    "no-border": !(_vm.item.isEditing || _vm.isEditing)
                  },
                  attrs: {
                    mask: "(###) ###-####",
                    placeholder: "Phone Number",
                    disabled: !(_vm.item.isEditing || _vm.isEditing)
                  },
                  model: {
                    value: _vm.item.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.item, "phone", $$v)
                    },
                    expression: "item.phone"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("click-outside", { attrs: { handler: _vm.hideSelectRole } }, [
          _c(
            "div",
            {
              staticClass: "column select-role",
              style: {
                width: _vm.columnWidth.role.size
                  ? _vm.columnWidth.role.size + "px"
                  : "14%"
              }
            },
            [
              _c("div", { staticClass: "content" }, [
                _c("span", { class: { "placeholder-color": !_vm.item.role } }, [
                  _vm._v(_vm._s(_vm.getRolesShow()))
                ])
              ]),
              _vm._v(" "),
              _vm.isSelectRole
                ? _c(
                    "div",
                    { staticClass: "role-selector show-on-top" },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-form-checkbox-group",
                            {
                              attrs: { id: "checkboxes-role", name: "roles" },
                              model: {
                                value: _vm.selectedRoles,
                                callback: function($$v) {
                                  _vm.selectedRoles = $$v
                                },
                                expression: "selectedRoles"
                              }
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    id: _vm.item.id + "-lead",
                                    value: "lead"
                                  }
                                },
                                [_vm._v("Lead")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    id: _vm.item.id + "-screener",
                                    value: "screener"
                                  }
                                },
                                [_vm._v("Screener\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    id: _vm.item.id + "-concierge",
                                    value: "concierge"
                                  }
                                },
                                [_vm._v("Concierge\n              ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.events.size
                ? _vm.columnWidth.events.size + "px"
                : "10%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(_vm._s(_vm.item.totalEvents))])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.payRates.size
                ? _vm.columnWidth.payRates.size + "px"
                : "8%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm.item.isEditing || _vm.isEditing
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.payRates,
                        expression: "item.payRates"
                      }
                    ],
                    staticClass: "input-staff",
                    attrs: {
                      type: "text",
                      title: "Pay Rate",
                      placeholder: "Pay Rate"
                    },
                    domProps: { value: _vm.item.payRates },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "payRates", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !(_vm.item.isEditing || _vm.isEditing)
                ? _c("span", [_vm._v("$ " + _vm._s(_vm.item.payRates || 0))])
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width: _vm.columnWidth.address.size
                ? _vm.columnWidth.address.size + "px"
                : "20%"
            }
          },
          [
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm.isUsedBingMap && (_vm.item.isEditing || _vm.isEditing)
                  ? _c(
                      "div",
                      { attrs: { id: "searchBoxStaffContainer-" + _vm.index } },
                      [
                        _c("label", {
                          attrs: { for: "searchBoxStaff-" + _vm.index }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.address,
                              expression: "item.address"
                            }
                          ],
                          staticClass: "map-wrapper",
                          attrs: {
                            type: "text",
                            id: "searchBoxStaff-" + _vm.index,
                            placeholder: "Address"
                          },
                          domProps: { value: _vm.item.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.item, "address", $event.target.value)
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isUsedBingMap && (_vm.item.isEditing || _vm.isEditing)
                  ? _c("vue-google-autocomplete", {
                      attrs: {
                        name: "address-input",
                        id: "map_" + _vm.index,
                        classname: "map-wrapper",
                        placeholder: _vm.item.address || "Enter address",
                        country: ["us"],
                        item: _vm.item
                      },
                      on: { placechanged: _vm.setPlace, change: _vm.getValue }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !(_vm.item.isEditing || _vm.isEditing)
                  ? _c("span", [_vm._v(_vm._s(_vm.item.address))])
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column col-group-btn-action",
            style: {
              width: _vm.columnWidth.actions.size
                ? _vm.columnWidth.actions.size + "px"
                : "4%"
            }
          },
          [
            _c("div", { staticClass: "btn-func" }, [
              _c("div", { staticClass: "btn-func-item" }, [
                _c("div", {
                  staticClass: "func-icon icon-info",
                  on: {
                    click: function($event) {
                      _vm.openStaffDetail(_vm.item)
                    }
                  }
                })
              ])
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "displayNone",
        class: { openContent: _vm.item.id == _vm.getExpandId }
      },
      [
        _c("div", { staticClass: "dt-row-item-detail" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 text-right margin-top-10px" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "ap-btn secondary",
                    on: {
                      click: function($event) {
                        _vm.cancelSave()
                      }
                    }
                  },
                  [_vm._v("\n            cancel\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "ap-btn primary",
                    attrs: { disabled: !_vm.canSave },
                    on: {
                      click: function($event) {
                        _vm.saveStaff()
                      }
                    }
                  },
                  [_vm._v("\n            save\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07e3de95", esExports)
  }
}

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffDetailModal_vue__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b438a92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffDetailModal_vue__ = __webpack_require__(2097);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2094)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b438a92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaffDetailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b438a92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_StaffDetailModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/modal/staff/StaffDetailModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StaffDetailModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b438a92", Component.options)
  } else {
    hotAPI.reload("data-v-4b438a92", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2095);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("e416b124", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b438a92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffDetailModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b438a92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StaffDetailModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* DEFINE VARIABLES\n*/\n.staffDetailWrapper[data-v-4b438a92] {\n  background-color: #FFFFFF;\n  left: 70%;\n  height: 100vh;\n  margin: 24px;\n}\n.staffDetailWrapper .staff-name[data-v-4b438a92] {\n  color: #1D1D1D;\n  font-family: \"Open Sans\", serif;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 32px;\n}\n.staffDetailWrapper .label[data-v-4b438a92] {\n  color: #424242;\n  font-family: \"Open Sans\", serif;\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 24px;\n}\n.staffDetailWrapper .text-role[data-v-4b438a92] {\n  text-transform: capitalize;\n}\n.staffDetailWrapper .information[data-v-4b438a92] {\n  color: #1D1D1D;\n  font-family: \"Open Sans\", serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 8px;\n}\n.staffDetailWrapper .information.input-staff[data-v-4b438a92] {\n  border: none;\n}\n.staffDetailWrapper .information.input-staff[data-v-4b438a92]:disabled {\n  background-color: #ffffff;\n  color: #1D1D1D;\n}\n.staffDetailWrapper .event-link[data-v-4b438a92] {\n  color: #00A4D6;\n  font-family: \"Open Sans\", serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.1px;\n  line-height: 20px;\n  margin-top: 16px;\n  cursor: pointer;\n}\n.staffDetailWrapper .modal-close-img[data-v-4b438a92] {\n  float: right;\n}\n.staffDetailWrapper .modal-close-img .icon-close[data-v-4b438a92] {\n  margin: 1.5px 1.5px;\n  width: 27px;\n  height: 27px;\n  background: url(" + __webpack_require__(23) + ");\n}\n.staffDetailWrapper .modal-close-img .icon-close[data-v-4b438a92]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_vue_the_mask__ = __webpack_require__(187);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import constant from '../../../_consts';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    TheMask: __WEBPACK_IMPORTED_MODULE_2__utils_vue_the_mask__["a" /* TheMask */]
  },
  props: {},
  data: function data() {
    return {
      events: {
        type: Object,
        default: {}
      },
      isDisable: true,
      firstName: '',
      lastName: '',
      phone: '',
      role: '',
      eventList: {},
      totalEvents: 0,
      email: '',
      payRates: 0,
      address: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    goToEventDetail: function goToEventDetail(event) {
      var eventId = event.id;
      this.setIsLoading(true); // set loading = true
      localStorage.setItem('isFromStaff', true);
      this.$modal.hide('staffDetailModal');
      this.$router.push({ name: 'ManageEventDetail', params: { eventId: eventId } });
    },
    hideModal: function hideModal() {
      this.$modal.hide('staffDetailModal');
    },
    beforeOpen: function beforeOpen(detail) {
      var item = detail.params;
      this.firstName = item.firstName;
      this.lastName = item.lastName;
      this.phone = item.phone;
      this.role = item.role;
      this.eventList = item.eventList;
      this.totalEvents = item.totalEvents;
      this.email = item.email;
      this.payRates = item.payRates;
      this.address = item.address;
    },
    beforeClose: function beforeClose() {}
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({}), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setIsLoading: 'MUTATION_SET_IS_LOADING'
  })),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({}))
});

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "staffDetailModal",
        width: 443,
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minHeight: 900
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "staffDetailWrapper" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "staff-name" }, [
              _vm._v(_vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              {
                staticClass: "modal-close-img",
                on: {
                  click: function($event) {
                    _vm.hideModal()
                  }
                }
              },
              [_c("div", { staticClass: "icon-close" })]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "label" }, [_vm._v("FIRST NAME")]),
            _vm._v(" "),
            _c("div", { staticClass: "information" }, [
              _vm._v(_vm._s(_vm.firstName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "label" }, [_vm._v("LAST NAME")]),
            _vm._v(" "),
            _c("div", { staticClass: "information" }, [
              _vm._v(_vm._s(_vm.lastName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("EMAIL")]),
            _vm._v(" "),
            _c("div", { staticClass: "information" }, [
              _vm._v(_vm._s(_vm.email))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("PHONE NUMBER")]),
            _vm._v(" "),
            _c(
              "div",
              {},
              [
                _c("the-mask", {
                  staticClass: "information input-staff",
                  attrs: {
                    mask: "(###) ###-####",
                    masked: _vm.isDisable,
                    disabled: _vm.isDisable
                  },
                  model: {
                    value: _vm.phone,
                    callback: function($$v) {
                      _vm.phone = $$v
                    },
                    expression: "phone"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("ROLES")]),
            _vm._v(" "),
            _c("div", { staticClass: "information text-role" }, [
              _vm._v(_vm._s(_vm.role))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("HOURLY RATE")]),
            _vm._v(" "),
            _c("div", { staticClass: "information text-role" }, [
              _vm._v("$ " + _vm._s(_vm.payRates))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("ADDRESS")]),
            _vm._v(" "),
            _c("div", { staticClass: "information text-role" }, [
              _vm._v(_vm._s(_vm.address))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v("EVENT (" + _vm._s(_vm.totalEvents) + ")")
              ]),
              _vm._v(" "),
              _vm._l(_vm.eventList, function(event) {
                return _c(
                  "div",
                  {
                    staticClass: "event-link",
                    on: {
                      click: function($event) {
                        _vm.goToEventDetail(event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(event.eventName) + "\n        "
                    )
                  ]
                )
              })
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b438a92", esExports)
  }
}

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn manage-staffing-page-container" },
    [
      _c("div", { staticClass: "container-fluid search-session bg-white" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-sm-6" },
            [
              _c(
                "b-input-group",
                [
                  _c("b-form-input", {
                    staticClass: "placeholder-italic",
                    attrs: {
                      type: "text",
                      placeholder: "Search by staff name",
                      formatter: _vm.format
                    },
                    model: {
                      value: _vm.keyword,
                      callback: function($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "search-icon" })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 col-sm-6 text-right" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "staffing-table" }, [
        _vm.staffList.length !== 0
          ? _c(
              "div",
              { staticClass: "table-title" },
              [
                _c("StaffingHeader", {
                  attrs: { pagingObj: _vm.pagingObj },
                  on: { CHANGE_PAGING_OPTIONS: _vm.changePagingOptions }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "loading-staffing",
            class: { isLoading: _vm.getLoading, noDisplay: !_vm.getLoading }
          },
          [
            _c("Icon", {
              staticClass: "icon-size",
              attrs: { name: "spinner", scale: "5", pulse: "" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "dt-body" } },
          [
            _vm._l(_vm.staffList, function(item, index) {
              return _c("StaffingRow", {
                key: item,
                staticClass: "event-row-wrapper",
                attrs: { item: item, index: index },
                on: { getListStaff: _vm.getAllStaff }
              })
            }),
            _vm._v(" "),
            _c(
              "infinite-loading",
              {
                ref: "infiniteLoading",
                attrs: { distance: 100 },
                on: { infinite: _vm.infiniteHandler }
              },
              [
                _c("Spinner", { attrs: { slot: "spinner" }, slot: "spinner" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "infinite-status-prompt",
                  attrs: { slot: "no-more" },
                  slot: "no-more"
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "infinite-status-prompt",
                  attrs: { slot: "no-results" },
                  slot: "no-results"
                })
              ],
              1
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("ScrollTop"),
      _vm._v(" "),
      _c("StaffDetailModal", { attrs: { staffDetail: _vm.item } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33a5df18", esExports)
  }
}

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcommingReport_vue__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_825b2ada_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UpcommingReport_vue__ = __webpack_require__(2101);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcommingReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_825b2ada_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UpcommingReport_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/reports/UpcommingReport.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UpcommingReport.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-825b2ada", Component.options)
  } else {
    hotAPI.reload("data-v-825b2ada", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventChart__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-upcoming-report',
  components: {
    EventChart: __WEBPACK_IMPORTED_MODULE_2__EventChart__["a" /* default */]
  },
  data: function data() {
    return {
      reports: [],
      pagingObj: {
        currentPage: 0,
        itemsPerPage: 50
      }
    };
  },

  props: {
    reportType: {
      type: String,
      required: true
    },
    textSearch: {
      type: String,
      required: false
    },
    dateOut: {
      type: Array,
      default: function _default() {
        return ['0', '60+'];
      }
    },
    filterBy: {
      type: Array,
      default: function _default() {
        return ['dateTime'];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getEventListReports: 'GETTER_GET_EVENT_LIST_REPORTS'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getDataReport: function getDataReport(params) {
      var _this = this;

      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        noBeginDates: this.dateOut[0],
        noEndDates: this.dateOut[1],
        selectedDate: null,
        clientId: this.$route.params.clientId,
        keyword: this.textSearch,
        currentPage: this.pagingObj.currentPage || 1,
        itemsPerPage: this.pagingObj.itemsPerPage || 25,
        sortType: this.filterBy[0],
        eventStatus: 'upcoming',
        requireReport: true
      }, params);
      this.getEventsByDate(body).then(function (response) {
        if (response.message === null) {
          _this.reports = response.approvedEvents[0].events;
        } else {
          _this.reports = [];
        }
      });
    },
    getEvents: function getEvents() {}
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getEventsByDate: 'ACTION_GET_EVENTS_BY_DATES',
    actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
  })),
  created: function created() {
    var params = {
      noBeginDates: '0',
      noEndDates: '60+'
    };
    this.getDataReport(params);
  },

  watch: {
    dateOut: {
      handler: function handler(val, oldVal) {
        if (val[0] === oldVal[0] && val[1] === oldVal[1]) {
          return;
        }
        var params = {
          noBeginDates: val[0],
          noEndDates: val[1]
        };
        this.getDataReport(params);
      },
      deep: true
    },
    filterBy: {
      handler: function handler(val, oldVal) {
        if (val[0] === oldVal[0]) {
          return;
        }
        var params = {
          sortType: val[0]
        };
        this.getDataReport(params);
      },
      deep: true
    },
    textSearch: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
      var keyword = this.textSearch.trim().toLowerCase();
      if (keyword.length >= 2 || keyword.length === 0) {
        this.getDataReport({ keyword: keyword });
      }
    }, 700)
  }
});

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upcoming-event-report-container" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.reports, function(item) {
        return _c(
          "div",
          { staticClass: "col-md-6 col-lg-4" },
          [_c("EventChart", { key: item.id, attrs: { eventItem: item } })],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-825b2ada", esExports)
  }
}

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedReport_vue__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f64da83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedReport_vue__ = __webpack_require__(2104);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f64da83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedReport_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/eventManagement/reports/CompletedReport.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CompletedReport.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f64da83", Component.options)
  } else {
    hotAPI.reload("data-v-5f64da83", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_EventCompletedReportCard__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-completed-report',
  components: {
    EventCompletedReportCard: __WEBPACK_IMPORTED_MODULE_2__commons_EventCompletedReportCard__["a" /* default */]
  },
  data: function data() {
    return {
      reports: [],
      pagingObj: {
        currentPage: 0,
        itemsPerPage: 10
      }
    };
  },

  props: {
    reportType: {
      type: String,
      required: true
    },
    dateOut: {
      type: Array,
      default: function _default() {
        return ['0', '60+'];
      }
    },
    filterBy: {
      type: Array,
      default: function _default() {
        return ['dateTime'];
      }
    },
    textSearch: {
      type: String,
      required: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getEventListReports: 'GETTER_GET_EVENT_LIST_REPORTS'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getDataReport: function getDataReport(params) {
      var _this = this;

      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        noBeginDates: this.dateOut[0],
        noEndDates: this.dateOut[1],
        selectedDate: null,
        clientId: this.$route.params.clientId,
        keyword: this.textSearch,
        currentPage: this.pagingObj.currentPage || 1,
        itemsPerPage: this.pagingObj.itemsPerPage || 25,
        sortType: this.filterBy[0],
        eventStatus: 'completed',
        requireReport: true
      }, params);
      this.getEventsByDate(body).then(function (response) {
        if (response.message === null) {
          _this.reports = response.approvedEvents[0].events;
        } else {
          _this.reports = [];
        }
      });
    },
    getEvents: function getEvents() {}
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getEventsByDate: 'ACTION_GET_EVENTS_BY_DATES',
    actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
  })),
  created: function created() {
    var params = {
      noBeginDates: '0',
      noEndDates: '60+'
    };
    this.getDataReport(params);
  },

  watch: {
    filterBy: {
      handler: function handler(val, oldVal) {
        if (val[0] === oldVal[0]) {
          return;
        }
        var params = {
          sortType: val[0],
          noBeginDates: '0',
          noEndDates: '60+'
        };
        this.getDataReport(params);
      },
      deep: true
    },
    textSearch: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
      var keyword = this.textSearch.trim().toLowerCase();
      if (keyword.length >= 2 || keyword.length === 0) {
        this.getDataReport({ keyword: keyword });
      }
    }, 700)
  }
});

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upcoming-event-report-container" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.reports, function(item) {
        return _c(
          "div",
          { staticClass: "col-md-6 col-lg-4" },
          [_c("EventCompletedReportCard", { attrs: { eventInfo: item } })],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f64da83", esExports)
  }
}

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_clients_index__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_events_index__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_mfa_index__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_setting_index__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_emailHistory_index__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_oauth2__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_shiftboard__ = __webpack_require__(2136);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    clients: __WEBPACK_IMPORTED_MODULE_2__modules_clients_index__["a" /* default */],
    events: __WEBPACK_IMPORTED_MODULE_3__modules_events_index__["a" /* default */],
    mfa: __WEBPACK_IMPORTED_MODULE_4__modules_mfa_index__["a" /* default */],
    setting: __WEBPACK_IMPORTED_MODULE_5__modules_setting_index__["a" /* default */],
    emailHistory: __WEBPACK_IMPORTED_MODULE_6__modules_emailHistory_index__["a" /* default */],
    oauth2: __WEBPACK_IMPORTED_MODULE_7__modules_oauth2__["a" /* default */],
    shiftboard: __WEBPACK_IMPORTED_MODULE_8__modules_shiftboard__["a" /* default */]
  }
}));

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__states__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(2111);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_0__states__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var getters = {
  GETTERS_CLIENT_BY_ID: function GETTERS_CLIENT_BY_ID(state) {
    return function (id) {
      return state.clientsList.find(function (client) {
        return client.id === id;
      });
    };
  },
  GETTERS_CLIENT_LIST: function GETTERS_CLIENT_LIST(state) {
    return state.clientsList;
  },
  GETTERS_RECENT_CLIENT_LIST: function GETTERS_RECENT_CLIENT_LIST(state) {
    return state.recentClientsList.slice(0, 4);
  },
  GETTERS_CLIENT_LIST_ID: function GETTERS_CLIENT_LIST_ID(state) {
    var ids = [];
    state.clientsList.forEach(function (client) {
      ids.push(client.id);
    });
    return ids;
  },
  GETTERS_CLIENT_LIST_KEYWORD: function GETTERS_CLIENT_LIST_KEYWORD(state) {
    return state.clientsList.filter(function (client) {
      return client.clientName && client.clientName.toLowerCase().indexOf(state.keywordSearchClient.toLowerCase()) >= 0 || client.eventManagerName && client.eventManagerName.toLowerCase().indexOf(state.keywordSearchClient.toLowerCase()) >= 0 || client.managerName && client.managerName.toLowerCase().indexOf(state.keywordSearchClient.toLowerCase()) >= 0;
    });
  },
  GETTERS_KEYWORD_SEARCH_CLIENT: function GETTERS_KEYWORD_SEARCH_CLIENT(state) {
    return state.keywordSearchClient;
  },
  GETTERS_IS_ERROR: function GETTERS_IS_ERROR(state) {
    return state.isError;
  },
  GETTERS_ERROR_MESSAGE: function GETTERS_ERROR_MESSAGE(state) {
    return state.errorMessage;
  },
  GETTERS_GET_CLIENT_NAME: function GETTERS_GET_CLIENT_NAME(state) {
    return state.clientName || localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientName);
  },
  GETTERS_GET_VALID_TOKEN: function GETTERS_GET_VALID_TOKEN(state) {
    return state.isValidToken || false;
  },
  GETTERS_GET_LOGIN_EMAIL: function GETTERS_GET_LOGIN_EMAIL(state) {
    return state.loginEmail || '';
  },
  GETTERS_IS_RESET_PASSWORD_SUCCESS: function GETTERS_IS_RESET_PASSWORD_SUCCESS(state) {
    return state.isResetPasswordSuccess;
  },
  GETTERS_IS_SUBMITTED: function GETTERS_IS_SUBMITTED(state) {
    return state.isSubmitted;
  },
  GETTERS_SHOW_CAPTCHA: function GETTERS_SHOW_CAPTCHA(state) {
    return state.showCaptcha;
  },
  GETTERS_SITE_KEY: function GETTERS_SITE_KEY(state) {
    return state.siteKey;
  },
  GETTERS_GET_LIST_AM: function GETTERS_GET_LIST_AM(state) {
    return state.listAM;
  },
  GETTERS_GOOGLE_API_KEY: function GETTERS_GOOGLE_API_KEY(state) {
    return state.googleAPIKey;
  },
  GETTERS_TOKEN_RESET_PASSWORD: function GETTERS_TOKEN_RESET_PASSWORD(state) {
    return state.resetPassToken;
  },
  GETTERS_ALLOW_LOGIN: function GETTERS_ALLOW_LOGIN(state) {
    return state.allowLogin;
  },
  GETTER_GET_SUBMISSION_MESSAGE: function GETTER_GET_SUBMISSION_MESSAGE(state) {
    return state.submissionMessage;
  },
  GETTER_GET_CHANGE_ORDER_MESSAGE: function GETTER_GET_CHANGE_ORDER_MESSAGE(state) {
    return state.changeOrderMessage;
  },
  GETTER_GET_EMAIL_NOTIFICATION: function GETTER_GET_EMAIL_NOTIFICATION(state) {
    return state.isCheckedNotification;
  },
  GETTER_GET_SELECTED_CLIENT: function GETTER_GET_SELECTED_CLIENT(state) {
    return state.selectedClient;
  },
  // GETTER_GET_USER_LIST: (state) => clientId => {
  //   return (clientId === null || clientId === undefined) ? state.userList : state.userList.find(user => user.client.id === clientId);
  // }
  GETTER_GET_USER_LIST: function GETTER_GET_USER_LIST(state) {
    return function (role) {
      return role === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.eventManager ? state.userList.filter(function (user) {
        return user.role !== __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin;
      }) : state.userList;
    };
  },
  GETTER_GET_MANAGER_VIEW: function GETTER_GET_MANAGER_VIEW(state) {
    return state.managerView;
  },
  GETTER_GET_USER_LIST_FOR_EM: function GETTER_GET_USER_LIST_FOR_EM(state) {
    return state.userList.filter(function (user) {
      return user.role !== __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin;
    });
  },
  GETTER_GET_IS_LOADING: function GETTER_GET_IS_LOADING(state) {
    return state.isLoading;
  },
  GETTER_GET_VALIDATOR_LIST: function GETTER_GET_VALIDATOR_LIST(state) {
    return state.validators;
  },
  GETTERS_IS_LOADING_STAFFING: function GETTERS_IS_LOADING_STAFFING(state) {
    return state.isLoadingStaffing;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_api_call__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_request__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__states__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);





var _this = this;











__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5_axios___default.a);

var actions = {
  ACTION_DO_LOGIN: function ACTION_DO_LOGIN(_ref, user) {
    var commit = _ref.commit,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (state.showCaptcha) {
        if (!state.allowLogin) {
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Cannot login', '');
          resolve(null);
          return;
        }
      }
      var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.doLogin;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiStr, user).then(function (response) {
        if (response.data.message !== null) {
          if (response.data.noOfFailAttempts > 5) {
            state.allowLogin = state.showCaptcha;
            state.showCaptcha = true;
          }
          state.siteKey = __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].siteKey;
          if (response.data.message === __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].messageErrors.userDeleted) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', 'Your account is deleted. Please contact ADURO.', '');
          } else {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data.message, '');
          }
        } else {
          if (response.data.isFirstLogin) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Login at first time, please change password!', '');
            localStorage.setItem('isFirstLogin', true);
            state.resetPassToken = response.data.resetPassToken;
          } else {
            if (response.data.mfaType === null) {
              localStorage.removeItem('isFirstLogin');
              commit('MUTATION_DO_LOGIN', response);
            }
          }
          state.allowLogin = true;
        }
        resolve(response);
      }).catch(function (response) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data && response.data.message || 'Cannot log in!', '');
        state.loginError = true;
        state.allowLogin = false;
      });
    });
  },
  ACTION_DO_LOGOUT: function ACTION_DO_LOGOUT(_ref2) {
    var commit = _ref2.commit;

    commit('MUTATION_DO_LOGOUT');
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Logout', '');
  },
  ACTION_SELECT_CLIENT: function ACTION_SELECT_CLIENT(_ref3, itemSelected) {
    var commit = _ref3.commit;

    commit('MUTATION_SET_SELECT_CLIENT', itemSelected);
  },
  ACTION_GET_CLIENT: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref5, clientId) {
      var commit = _ref5.commit;
      var apiUrl, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getClient;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(apiUrl, {
                params: {
                  clientId: clientId
                }
              });

            case 3:
              response = _context.sent;
              return _context.abrupt('return', response);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function ACTION_GET_CLIENT(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }(),
  ACTION_GET_CLIENTS: function ACTION_GET_CLIENTS(_ref6) {
    var commit = _ref6.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getClients;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.get(apiStr, {
      params: {
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.userId)
      }
    }).then(function (response) {
      if (response.data.message !== null) {
        commit('MUTATION_SET_CLIENTS', []);
      } else {
        commit('MUTATION_SET_CLIENTS', response.data.clients);
        // save client recent activity
        var recentClients = __WEBPACK_IMPORTED_MODULE_11_lodash__["cloneDeep"](response.data.clients);
        recentClients.sort(function (a, b) {
          return b.lastUpdatedAt - a.lastUpdatedAt || 0;
        });
        commit('MUTATION_SET_RECENT_CLIENTS', recentClients);
      }
    }).catch(function (response) {
      console.log('Error:', response);
    });
  },
  ACTION_SYNCS_CLIENTS_PROGRAMS: function ACTION_SYNCS_CLIENTS_PROGRAMS(_ref7) {
    var commit = _ref7.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.syncClientsAndPrograms;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_ORDERS: function ACTION_SYNCS_ORDERS(_ref8) {
    var commit = _ref8.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.syncBiometricOrders;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_USER_STATUS: function ACTION_SYNCS_USER_STATUS(_ref9) {
    var commit = _ref9.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.syncUsersStatus;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_EVENTS: function ACTION_SYNCS_EVENTS(_ref10) {
    var commit = _ref10.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.syncEvents;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_STAFFS: function ACTION_SYNCS_STAFFS(_ref11) {
    var commit = _ref11.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.syncStaffs;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SEARCH_CLIENTS: function ACTION_SEARCH_CLIENTS(_ref12, keyword) {
    var commit = _ref12.commit;

    commit('MUTATION_SET_KEYWORD_SEARCH_CLIENTS', keyword);
  },
  ACTION_RESET_SEARCH_CLIENTS: function ACTION_RESET_SEARCH_CLIENTS(_ref13) {
    var commit = _ref13.commit;

    commit('MUTATION_RESET_SEARCH_CLIENTS');
  },
  ACTION_RESET_PASSWORD: function () {
    var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref15, email) {
      var commit = _ref15.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit('MUTATION_IS_RESET_PASSWORD_SUCCESS', false);
              commit('MUTATION_IS_SUBMITTED', true);
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.requestResetPassword;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.get(apiUrl, {
                params: {
                  email: email
                }
              }).then(function (response) {
                if (response.data.message !== null) {
                  commit('MUTATION_SET_ERROR', { isError: true, errorMessage: response.data.message });
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data.message, '');
                  commit('MUTATION_IS_RESET_PASSWORD_SUCCESS', false);
                } else {
                  commit('MUTATION_SET_ERROR', { isError: false, errorMessage: '' });
                  commit('MUTATION_IS_RESET_PASSWORD_SUCCESS', true);
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('success', 'A reset password email has been sent to ' + email, '');
                }
                commit('MUTATION_IS_SUBMITTED', false);
              }).catch(function (response) {
                console.log(response);
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response, '');
              });

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function ACTION_RESET_PASSWORD(_x3, _x4) {
      return _ref14.apply(this, arguments);
    };
  }(),
  ACTION_CHECK_TOKEN: function () {
    var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref17, token) {
      var commit = _ref17.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.checkToken;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.get(apiUrl, {
                params: {
                  token: token
                }
              }).then(function (response) {
                if (response.data.message !== null) {
                  commit('MUTATION_SET_TOKEN_VALID', false);
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data.message, '');
                } else {
                  commit('MUTATION_SET_TOKEN_VALID', true);
                }
              }).catch(function (response) {
                commit('MUTATION_SET_TOKEN_VALID', false);
                console.log(response);
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response, '');
              });

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function ACTION_CHECK_TOKEN(_x5, _x6) {
      return _ref16.apply(this, arguments);
    };
  }(),
  ACTION_UPDATE_PASSWORD: function () {
    var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref19, params) {
      var commit = _ref19.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.internalPasswordReset;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, {
                newPassword: params.newPassword,
                token: params.token,
                isForceResetPassword: params.isForceResetPassword,
                userId: params.userId
              }).then(function (response) {
                if (response.data.message !== null) {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data.message, '');
                  commit('MUTATION_SET_TOKEN_VALID', false);
                } else {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('success', 'Change password successful', '');
                  localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.isForceResetPassword);
                  commit('MUTATION_SET_TOKEN_VALID', true);
                  commit('MUTATION_SET_LOGIN_EMAIL', response.data.userProfile.email);
                }
              }).catch(function (response) {
                console.log(response);
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response, '');
              });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function ACTION_UPDATE_PASSWORD(_x7, _x8) {
      return _ref18.apply(this, arguments);
    };
  }(),
  ACTION_CHANGE_PASSWORD: function () {
    var _ref20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref21, obj) {
      var commit = _ref21.commit;
      var apiUrl, body;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.internalPasswordChange;
              body = {
                newPassword: obj.newPassword,
                oldPassword: obj.oldPassword,
                userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.userId)
              };
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
                  resolve(response);
                }, function (error) {
                  reject(error);
                });
              }));

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function ACTION_CHANGE_PASSWORD(_x9, _x10) {
      return _ref20.apply(this, arguments);
    };
  }(),
  ACTION_UPLOAD_FILE: function () {
    var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref23, data) {
      var commit = _ref23.commit;
      var apiUrl, formData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.importUser;
              formData = new FormData();

              formData.append('file', data);
              _context6.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, formData).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('success', response.data, '');
              });

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function ACTION_UPLOAD_FILE(_x11, _x12) {
      return _ref22.apply(this, arguments);
    };
  }(),
  ACTION_ALLOW_LOGIN: function ACTION_ALLOW_LOGIN(_ref24, obj) {
    var commit = _ref24.commit,
        state = _ref24.state;

    console.log('obj:', obj);
    commit('MUTATION_ALLOW_LOGIN', obj.isAllowed);
    if (!obj.isAllowed) {
      commit('MUTATION_SET_ERROR', obj.errObj);
    }
  },
  ACTION_GET_LIST_AM: function () {
    var _ref25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(_ref26) {
      var commit = _ref26.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getAllAM;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.get(apiUrl).then(function (response) {
                if (response.data.userProfiles !== null && response.data.userProfiles.length > 0) {
                  response.data.userProfiles.forEach(function (element) {
                    element.name = element.firstName + ' ' + element.lastName;
                  });
                  commit('MUTATION_SET_LIST_AM', response.data.userProfiles);
                } else {
                  commit('MUTATION_SET_LIST_AM', []);
                }
              }).catch(function (response) {
                console.log(response);
              });

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function ACTION_GET_LIST_AM(_x13) {
      return _ref25.apply(this, arguments);
    };
  }(),
  ACTION_UPDATE_CLIENT: function ACTION_UPDATE_CLIENT(_ref27, client) {
    var commit = _ref27.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateClient;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, client).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Update success', '');
        resolve(response);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  ACTION_UPDATE_CLIENT_NAME: function ACTION_UPDATE_CLIENT_NAME(_ref28, clientName) {
    var commit = _ref28.commit;

    __WEBPACK_IMPORTED_MODULE_10__states__["a" /* default */].clientName = clientName;
  },
  ACTION_VERIFY_RECAPTCHA: function ACTION_VERIFY_RECAPTCHA(_ref29, code) {
    var commit = _ref29.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.verifyRecaptcha;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, code).then(function (response) {
      var errObj = void 0;
      if (response.data) {
        commit('MUTATION_ALLOW_LOGIN', response.data);
        errObj = {
          isError: false,
          errorMessage: ''
        };
      } else {
        errObj = {
          isError: true,
          errorMessage: 'Captcha is invalid!'
        };
      }
      commit('MUTATION_SET_ERROR', errObj);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_UPDATE_MESSAGE: function () {
    var _ref30 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(_ref31, obj) {
      var commit = _ref31.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateMessage;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, obj).then(function (response) {
                if (response.data.message) {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data.message, '');
                } else {
                  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('success', 'Saved message successfully!', '');
                }
              }).catch(function (response) {
                console.log(response);
              });

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));

    return function ACTION_UPDATE_MESSAGE(_x14, _x15) {
      return _ref30.apply(this, arguments);
    };
  }(),
  UPDATE_ADD_ON: function () {
    var _ref32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(_ref33, obj) {
      var commit = _ref33.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateAddOn;
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
                  if (response.message) {
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.message, '');
                  } else {
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('success', 'Update add-on success!', '');
                    commit('MUTATION_UPDATE_ADDON_CLIENT', { clientId: obj.clientId, addOns: response.addOns });
                  }
                  resolve(response);
                }, function (error) {
                  reject(error);
                });
              }));

            case 2:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this);
    }));

    return function UPDATE_ADD_ON(_x16, _x17) {
      return _ref32.apply(this, arguments);
    };
  }(),
  ACTION_GET_MESSAGE_MODAL: function ACTION_GET_MESSAGE_MODAL(_ref34) {
    var state = _ref34.state,
        commit = _ref34.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getMessages;
    var clientId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.clientId);
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.get(apiUrl, {
      params: {
        clientId: clientId
      }
    }).then(function (response) {
      state.submissionMessage = response.data.data.submissionMessage;
      state.changeOrderMessage = response.data.data.changeOrderMessage;
    });
  },
  ACTION_CHANGE_NOTIFICATION: function ACTION_CHANGE_NOTIFICATION(_ref35, isChecked) {
    var state = _ref35.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.changeNotification;
    var body = {
      isChecked: isChecked,
      userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.userId)
    };
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, body).then(function (response) {
      // Vue.prototype.$toastr('success', (isChecked ? 'Enable' : 'Disable') + ' sending email.', '');
      state.isCheckedNotification = isChecked;
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_UPDATE_SECONDARY_AM: function ACTION_UPDATE_SECONDARY_AM(_ref36, obj) {
    var state = _ref36.state,
        commit = _ref36.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateSecondaryAM;
    var body = {
      clientId: obj.clientId,
      userId: obj.user.id
    };
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, body).then(function (response) {
      commit('MUTATION_UPDATE_SECONDARY_AM', obj);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Update secondary successfully', '');
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_UPDATE_VALIDATORS_TO_CLIENT: function ACTION_UPDATE_VALIDATORS_TO_CLIENT(_ref37, obj) {
    var state = _ref37.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateValidatorsToClient;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_SUB_CLIENT: function ACTION_UPDATE_SUB_CLIENT(_ref38, obj) {
    var state = _ref38.state,
        commit = _ref38.commit;

    var apiUrl = obj.isReseller !== undefined ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateReseller : Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateClientManager;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, obj).then(function (response) {
      if (obj.isReseller !== undefined) {
        commit('MUTATION_UPDATE_RESELLER', obj);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Update successfully', '');
      } else {
        // commit('MUTATION_UPDATE_RESELLER', obj);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Update successfully', '');
      }
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_ADD_CLIENT: function () {
    var _ref39 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(_ref40, obj) {
      var commit = _ref40.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.addClient;
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
                  resolve(response);
                  commit('MUTATION_UPDATE_CLIENT_LIST', response.data);
                }, function (error) {
                  reject(error);
                });
              }));

            case 2:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this);
    }));

    return function ACTION_ADD_CLIENT(_x18, _x19) {
      return _ref39.apply(this, arguments);
    };
  }(),
  ACTION_GET_ALL_USERS: function ACTION_GET_ALL_USERS(_ref41) {
    var state = _ref41.state,
        commit = _ref41.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getAllUsers;
    state.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.get(apiUrl, {
      params: {
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.userId)
      }
    }).then(function (response) {
      state.isLoading = false;
      commit('MUTATION_SET_ALL_USER', response.data.userProfiles || []);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_CREATE_USER: function ACTION_CREATE_USER(_ref42, obj) {
    var state = _ref42.state,
        commit = _ref42.commit;

    obj.email = obj.email.toLowerCase();
    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.createUser;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, obj).then(function (response) {
      if (response && response.data && response.data.message === null) {
        commit('MUTATION_CREATE_USER', response.data.userProfile);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Create successfully', '');
      } else {
        if (response.data.message === __WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].messageErrors.emailIsDuplicated) {
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', 'Email is duplicated!', '');
        }
      }
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', 'Create user unsuccessfully', '');
    });
  },
  ACTION_EDIT_USER: function ACTION_EDIT_USER(_ref43, obj) {
    var state = _ref43.state,
        commit = _ref43.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateUser;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, obj).then(function (response) {
      commit('MUTATION_UPDATE_USER', response.data.userProfile);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Update successfully', '');
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', 'Update user unsuccessfully', '');
    });
  },
  ACTION_UPDATE_READ_ONLY: function ACTION_UPDATE_READ_ONLY(_ref44, obj) {
    var state = _ref44.state,
        commit = _ref44.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateReadOnly;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, obj).then(function (response) {
      if (response && response.data) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Update successfully', '');
      }
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_ACTION_DELETE_USER: function ACTION_ACTION_DELETE_USER(_ref45, obj) {
    var state = _ref45.state,
        commit = _ref45.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.deleteUser;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('DELETE', obj)).then(function (response) {
        if (response && response.userProfile) {
          commit('MUTATION_REMOVE_USER_IN_LIST', response.userProfile);
        }
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_FORCE_RESET_PASSWORD: function ACTION_FORCE_RESET_PASSWORD(_ref46, userId) {
    var commit = _ref46.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().staff.forceResetPassword;
    var body = { userId: userId };
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, body).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Email successful sent', '');
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', 'Email unsuccessful sent');
    });
  },
  ACTION_SAVE_CLIENT_NAME: function ACTION_SAVE_CLIENT_NAME(_ref47, obj) {
    var commit = _ref47.commit;

    // obj = {
    //   clientId: clientId,
    //   clientName: clientName
    // }
    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateClientName;
    var body = { id: obj.clientId, clientName: obj.clientName };
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.post(apiUrl, body).then(function (response) {
      if (response.data.message) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', response.data.message ? response.data.message : 'Save client name unsuccessful', '');
      } else {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Save client name successful', '');
      }
    }).catch(function () {});
  },
  ACTION_GET_ALL_VALIDATORS: function ACTION_GET_ALL_VALIDATORS(_ref48) {
    var state = _ref48.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getAllValidators;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', {})).then(function (response) {
        resolve(response);
        state.validators = response.validators;
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_VALIDATORS_BY_CLIENT_ID: function ACTION_GET_VALIDATORS_BY_CLIENT_ID(_ref49, clientId) {
    var state = _ref49.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getValidatorsByClientId + '/' + clientId;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_CREATE_VALIDATOR: function ACTION_CREATE_VALIDATOR(_ref50, obj) {
    var state = _ref50.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.addValidator;
    var body = {
      name: obj.name,
      field: obj.field
    };
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Successfully created', '');
      }, function (error) {
        reject(error);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('warning', 'Unsuccessfully created', '');
      });
    });
  },
  ACTION_UPDATE_VALIDATOR: function ACTION_UPDATE_VALIDATOR(_ref51, obj) {
    var state = _ref51.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.addValidator;
    var body = {
      id: obj.id,
      name: obj.name,
      field: obj.field
    };
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Successfully updated', '');
      }, function (error) {
        reject(error);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('warning', 'Unsuccessfully updated', '');
      });
    });
  },
  ACTION_DELETE_VALIDATOR: function ACTION_DELETE_VALIDATOR(_ref52, id) {
    var state = _ref52.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.deleteValidator;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', { params: { validatorId: id } })).then(function (response) {
        resolve(response);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('info', 'Successfully deleted', '');
      }, function (error) {
        reject(error);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('warning', 'Unsuccessfully deleted', '');
      });
    });
  },
  ACTION_GET_CLIENT_SCHEDULER_CONFIG: function ACTION_GET_CLIENT_SCHEDULER_CONFIG(_ref53, clientId) {
    var state = _ref53.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getSchedulerConfiguration;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', { params: { clientId: clientId } })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EMAIL_TAGS: function ACTION_GET_EMAIL_TAGS(_ref54) {
    var state = _ref54.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getAvailableEmailTags;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SAVE_CONFIGURATIONS: function ACTION_SAVE_CONFIGURATIONS(_ref55, configs) {
    var state = _ref55.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.saveConfigurations;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', configs), 100000).then(function (response) {
        resolve(response);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$toastr('error', error, '');
        reject(error);
      });
    });
  },
  ACTION_SAVE_EMAIL_TEMPLATES: function ACTION_SAVE_EMAIL_TEMPLATES(_ref56, templates) {
    var state = _ref56.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().settings.saveEmailTemplates;
    var body = { templates: templates };
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_UPLOAD_LOGO: function ACTION_UPLOAD_LOGO(_ref57, obj) {
    var state = _ref57.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.uploadAvatar;
    var body = {
      clientId: obj.clientId,
      imageFile: obj.imageFile
    };

    var formData = new FormData();
    formData.append('content', obj.imageFile);
    formData.append('clientId', obj.clientId);

    console.log('body:', body, 'formData:', formData);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["b" /* buildOptionsFormData */])('POST', formData)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS: function ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS(_ref58, clientId) {
    var state = _ref58.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getClientEventSchedulerStatus;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', { params: { clientId: clientId } })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS: function ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS(_ref59, obj) {
    var state = _ref59.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.updateClientEventSchedulerStatus;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_DELETE_CLIENT: function ACTION_DELETE_CLIENT(_ref60, body) {
    var state = _ref60.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.deleteClient;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_LIST_EM: function ACTION_GET_LIST_EM(_ref61, body) {
    var state = _ref61.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getListEM;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', body)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_VALIDATORS_BY_EVENT_ID: function ACTION_GET_VALIDATORS_BY_EVENT_ID(_ref62, eventId) {
    var state = _ref62.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getValidatorsByEventId + '/' + eventId;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', { params: { eventId: eventId } })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SYNC_SHIFTBOARD_BASE_DATA: function ACTION_SYNC_SHIFTBOARD_BASE_DATA(_ref63) {
    var state = _ref63.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.syncBasicShiftBoard, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('POST')).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_PROGRAM_CLIENT: function ACTION_GET_PROGRAM_CLIENT(_ref64, clientId) {
    var state = _ref64.state,
        commit = _ref64.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getProgramClient;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', { params: { clientId: clientId } })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_CLIENTS_PAGING: function ACTION_GET_CLIENTS_PAGING(_ref65, params) {
    var commit = _ref65.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["c" /* getEndPoint */])().clients.getClientsPaging, Object(__WEBPACK_IMPORTED_MODULE_8__utils_api_call__["a" /* buildOptions */])('GET', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__consts__["a" /* default */].LOCAL_STORE.userId) }) })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 2109 */,
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOKEN: 'HEARTBEAT_TOKEN',
  REFRESH_TOKEN: 'HEARTBEAT_REFRESH_TOKEN'
});

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(9);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var mutations = {
  MUTATION_DO_LOGIN: function MUTATION_DO_LOGIN(state, response) {
    if (response.data.message !== null) {
      state.loginError = true;
      // remove local storage
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.token);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.userId);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.role);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.userName);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientId);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientName);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.googleAPIKey);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.addOns);
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.isForceResetPassword);
      state.clientId = null;
    } else {
      // save local storage
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.isForceResetPassword, response.data.forceResetPassword);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.token, response.data.token);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.userId, response.data.userId);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.role, response.data.role);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.userName, response.data.userName);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.googleAPIKey, response.data.googleAPIKey);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.addOns, response.data.addOns);
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.isBingMap, response.data.useBingMap);
      if ([__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.accountManager, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.eventManager, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.admin].indexOf(response.data.role) < 0) {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientId, response.data.clientId);
      } else {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientId, 0);
      }

      if ([__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.client].indexOf(response.data.role) < 0) {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientName, 'CHOOSE CLIENT');
      } else {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientName, response.data.clientName);
        state.clientName = response.data.clientName;
      }

      // save state
      state.clientId = response.data.role === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].USER_ROLE.client ? response.data.clientId : 0;
      state.googleAPIKey = response.data.googleAPIKey;
      state.loginError = false;
      state.isCheckedNotification = response.data && response.data.isChecked;
      state.addOns = response.data && response.data.addOns;
    }
  },
  MUTATION_DO_LOGOUT: function MUTATION_DO_LOGOUT(state) {
    // remove all local storage
    var keys = __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE;
    for (var key in keys) {
      if (keys.hasOwnProperty(key)) {
        var element = keys[key];
        localStorage.removeItem(element);
      }
    }
    // localStorage.removeItem(constants.LOCAL_STORE.userId);
    // localStorage.removeItem(constants.LOCAL_STORE.token);
    // localStorage.removeItem(constants.LOCAL_STORE.role);
    // localStorage.removeItem(constants.LOCAL_STORE.googleAPIKey);
    // remove all from state
    state.clientName = '';
    state.loginError = null;
  },
  MUTATION_SET_CLIENTS: function MUTATION_SET_CLIENTS(state, clients) {
    state.clientsList = clients;
  },
  MUTATION_SET_SELECT_CLIENT: function MUTATION_SET_SELECT_CLIENT(state, itemSelected) {
    state.selectedClient = itemSelected;
    state.clientId = itemSelected.id;
    state.clientName = itemSelected.clientName;
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientId, itemSelected.id);
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.clientName, itemSelected.clientName);
  },
  MUTATION_SET_ERROR: function MUTATION_SET_ERROR(state, errorObj) {
    state.isError = errorObj.isError;
    state.errorMessage = errorObj.errorMessage;
  },
  MUTATION_SET_TOKEN_VALID: function MUTATION_SET_TOKEN_VALID(state, status) {
    state.isValidToken = status;
  },
  MUTATION_SET_LOGIN_EMAIL: function MUTATION_SET_LOGIN_EMAIL(state, email) {
    state.loginEmail = email;
  },
  MUTATION_IS_RESET_PASSWORD_SUCCESS: function MUTATION_IS_RESET_PASSWORD_SUCCESS(state, isResetPasswordSuccess) {
    state.isResetPasswordSuccess = isResetPasswordSuccess;
  },
  MUTATION_IS_SUBMITTED: function MUTATION_IS_SUBMITTED(state, isSubmitted) {
    state.isSubmitted = isSubmitted;
  },
  MUTATION_ALLOW_LOGIN: function MUTATION_ALLOW_LOGIN(state, isAllowed) {
    state.allowLogin = isAllowed;
  },
  MUTATION_SET_LIST_AM: function MUTATION_SET_LIST_AM(state, listAM) {
    state.listAM = listAM;
  },
  MUTATION_SET_KEYWORD_SEARCH_CLIENTS: function MUTATION_SET_KEYWORD_SEARCH_CLIENTS(state, keyword) {
    state.keywordSearchClient = keyword;
  },
  MUTATION_RESET_SEARCH_CLIENTS: function MUTATION_RESET_SEARCH_CLIENTS(state) {
    state.keywordSearchClient = '';
  },
  MUTATION_UPDATE_CLIENT_LIST: function MUTATION_UPDATE_CLIENT_LIST(state, client) {
    state.clientsList.push(client);
  },
  MUTATION_UPDATE_ADDON_CLIENT: function MUTATION_UPDATE_ADDON_CLIENT(state, updateAddOns) {
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].LOCAL_STORE.addOns, updateAddOns.addOns);
    state.clientsList.forEach(function (client, index) {
      if (client.id === updateAddOns.clientId) {
        state.clientsList[index].addOns = updateAddOns.addOns;
      }
    });
  },
  MUTATION_UPDATE_SECONDARY_AM: function MUTATION_UPDATE_SECONDARY_AM(state, obj) {
    state.clientsList.forEach(function (element, index) {
      if (element.id === obj.clientId) {
        if (obj.isAdd) {
          state.clientsList[index].secondaryAMList.push(obj.user);
        } else {
          state.clientsList[index].secondaryAMList.forEach(function (ele, id) {
            if (ele.id === obj.user.id) {
              state.clientsList[index].secondaryAMList.splice(id, 1);
            }
          });
        }
      }
    });
  },
  MUTATION_UPDATE_RESELLER: function MUTATION_UPDATE_RESELLER(state, obj) {
    state.clientsList.forEach(function (element, index) {
      if (element.id === obj.clientManager) {
        state.clientsList[index].isResellerCheck = obj.isReseller;
      }
    });
  },
  MUTATION_SET_ALL_USER: function MUTATION_SET_ALL_USER(state, users) {
    state.userList = users;
  },
  MUTATION_CREATE_USER: function MUTATION_CREATE_USER(state, obj) {
    state.userList.push(obj);
  },
  MUTATION_UPDATE_USER: function MUTATION_UPDATE_USER(state, obj) {
    state.userList.find(function (user, index) {
      if (obj.id === user.id) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            state.userList[index][key] = obj[key];
          }
        }
      }
    });
  },
  MUTATION_SET_MANAGER_VIEW: function MUTATION_SET_MANAGER_VIEW(state, view) {
    state.managerView = view;
  },
  MUTATION_REMOVE_USER_IN_LIST: function MUTATION_REMOVE_USER_IN_LIST(state, obj) {
    var user = state.userList.find(function (user) {
      return user.id === obj.id;
    });
    var index = state.userList.indexOf(user);
    state.userList.splice(index, 1);
  },
  MUTATION_SET_RECENT_CLIENTS: function MUTATION_SET_RECENT_CLIENTS(state, clients) {
    state.recentClientsList = clients;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__states__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(2116);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_0__states__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(9);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

var getters = {
  GETTERS_SHOW_RELATED_EVENT: function GETTERS_SHOW_RELATED_EVENT(state) {
    return state.showRelatedEvents;
  },
  GETTERS_LIST_EVENT_RELATED: function GETTERS_LIST_EVENT_RELATED(state) {
    return state.listEventRelated;
  },
  GETTERS_LIST_EVENT_STATUS: function GETTERS_LIST_EVENT_STATUS(state) {
    return state.listEventStatus;
  },
  GETTERS_LIST_EVENT: function GETTERS_LIST_EVENT(state) {
    return state.listEvent;
  },
  GETTERS_COUNT_EVENT_BY_STATUS: function GETTERS_COUNT_EVENT_BY_STATUS(state) {
    return function (status) {
      var statusArr = [status];
      if (status === '') {
        statusArr = state.listEventStatus;
      }
      var count = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.countTotalEvent), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var countObj = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(statusArr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var statusItem = _step2.value;

              if (countObj.status.toLowerCase() === statusItem.toLowerCase()) {
                count += countObj.count;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return count;
    };
  },
  GETTERS_COUNT_UNREAD_EVENT_BY_STATUS: function GETTERS_COUNT_UNREAD_EVENT_BY_STATUS(state) {
    return function (status) {
      var statusArr = [status];
      if (status === '') {
        statusArr = state.listEventStatus;
      }
      var count = 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.countTotalEvent), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var countObj = _step3.value;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(statusArr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var statusItem = _step4.value;

              if (countObj.status.toLowerCase() === statusItem.toLowerCase()) {
                count += countObj.unread;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return count;
    };
  },
  GETTERS_GET_EXPAND_ID: function GETTERS_GET_EXPAND_ID(state) {
    return state.expandId;
  },
  GETTERS_GET_ITEM_RELATED_INFO: function GETTERS_GET_ITEM_RELATED_INFO(state) {
    return state.relatedItemInfo;
  },
  GETTERS_GET_COLUMN_WIDTH: function GETTERS_GET_COLUMN_WIDTH(state) {
    return state.columnWidth;
  },
  GETTERS_LIST_ON_SITE_CONTACT: function GETTERS_LIST_ON_SITE_CONTACT(state) {
    return state.listOnSiteContact;
  },
  GETTERS_CREATE_EVENT_FLAG: function GETTERS_CREATE_EVENT_FLAG(state) {
    return state.flagCreateEvent;
  },
  GETTERS_SUBMIT_ALL_EVENT_SUCCESS: function GETTERS_SUBMIT_ALL_EVENT_SUCCESS(state) {
    return state.submitAllEventSuccess;
  },
  GETTERS_MESSAGE_ERROR: function GETTERS_MESSAGE_ERROR(state) {
    return state.messageError;
  },
  GETTERS_GET_LOCK_IDS: function GETTERS_GET_LOCK_IDS(state) {
    return state.lockIds;
  },
  GETTERS_ERROR_CODES: function GETTERS_ERROR_CODES(state) {
    return state.errorCodes;
  },
  GETTERS_IS_LOADING: function GETTERS_IS_LOADING(state) {
    return state.isLoading;
  },
  GETTERS_IS_UPDATING: function GETTERS_IS_UPDATING(state) {
    return state.isUpdating;
  },
  GETTERS_GET_EVENT_HISTORY: function GETTERS_GET_EVENT_HISTORY(state) {
    var histories = state.histories;

    if (histories.length === 0) {
      return [];
    }

    var result = [];
    histories.forEach(function (history, index) {
      var fields = history.fieldsChange;
      var items = [];
      fields.forEach(function (field, index) {
        var newCustom = '';
        var previousCustom = '';
        if (field.fieldName === 'ADDITIONAL SERVICES') {
          var newValue = __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].cleanArray(field.newValue.split(',')).join();
          var previousValue = __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].cleanArray(field.previousValue.split(',')).join();
          var listAdditionalServicesKey = __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].listAdditionalServicesKey;
          for (var key in listAdditionalServicesKey) {
            if (listAdditionalServicesKey.hasOwnProperty(key)) {
              var element = listAdditionalServicesKey[key];
              var text = __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].mappingKeyToTextAdditionalServices(element);
              newCustom = newCustom === '' ? newValue.replace(key, ' ' + text) : newCustom.replace(key, ' ' + text);
              previousCustom = previousCustom === '' ? previousValue.replace(key, ' ' + text) : previousCustom.replace(key, ' ' + text);
            }
          }
        }
        items.push({
          fields: field.fieldName,
          new_value: newCustom === '' ? field.newValue : newCustom,
          previous_value: previousCustom === '' ? field.previousValue : previousCustom
        });
      });
      result.push({
        userName: history.userName,
        timeModified: history.timeModified,
        fieldsChangeCount: history.fieldsChangeCount,
        items: items,
        additionalComment: history.additionalComment
      });
    });
    return result;
  },
  GETTERS_GET_EVENT_DETAIL_HISTORY: function GETTERS_GET_EVENT_DETAIL_HISTORY(state) {
    return state.eventDetailHistory;
  },
  GETTERS_GET_IS_LOADING_EVENT_DETAIL_HISTORY: function GETTERS_GET_IS_LOADING_EVENT_DETAIL_HISTORY(state) {
    return state.isLoadingEventDetailHistory;
  },
  GETTER_GET_COLUMN_TABLE_USER: function GETTER_GET_COLUMN_TABLE_USER(state) {
    return state.columnTableUserWidth;
  },
  GETTER_GET_COLUMN_TABLE_STAFFING: function GETTER_GET_COLUMN_TABLE_STAFFING(state) {
    return state.columnTableStaffingWidth;
  },
  GETTERS_EVENTS_BY_DATES: function GETTERS_EVENTS_BY_DATES(state) {
    return state.listApprovedEvent;
  },
  GETTERS_TOTAL_EVENTS: function GETTERS_TOTAL_EVENTS(state) {
    return state.totalApprovedEvents;
  },
  GETTERS_DATES_HAS_DATA: function GETTERS_DATES_HAS_DATA(state) {
    return state.datesHasData;
  },
  GETTERS_LOCKED_DATES: function GETTERS_LOCKED_DATES(state) {
    return state.lockedDates;
  },
  GETTERS_DATE_RANGE_HAS_DATA: function GETTERS_DATE_RANGE_HAS_DATA(state) {
    return state.dateRangeHasData;
  },
  GETTER_IS_LOADING_MODAL: function GETTER_IS_LOADING_MODAL(state) {
    return state.isLoadingModal;
  },
  GETTER_IS_LOADING_PARTICIPANT: function GETTER_IS_LOADING_PARTICIPANT(state) {
    return state.isLoadingParticipant;
  },
  GETTER_GET_EVENT_FOR_CHANGE_ORDER: function GETTER_GET_EVENT_FOR_CHANGE_ORDER(state) {
    return state.eventDetailChangeOrder;
  },
  GETTER_GET_STAFF_LIST: function GETTER_GET_STAFF_LIST(state) {
    return state.staffList;
  },
  GETTER_GET_OPEN_ASSIGN_STAFF_MODAL: function GETTER_GET_OPEN_ASSIGN_STAFF_MODAL(state) {
    return state.openEventStaffModal;
  },
  GETTER_GET_STAFF_ASSIGN_LIST: function GETTER_GET_STAFF_ASSIGN_LIST(state) {
    return function (type) {
      switch (type) {
        case 'lead':
          return state.staffLead;
        case 'screener':
          return state.staffScreener;
        case 'phlebotomist':
          return state.staffConcierge;
        default:
          return [];
      }
    };
  },
  GETTER_GET_EVENT_LIST_REPORTS: function GETTER_GET_EVENT_LIST_REPORTS(state) {
    return state.manageEventReports;
  },
  GETTER_GET_SLIDER_VALUE_REPORTS: function GETTER_GET_SLIDER_VALUE_REPORTS(state) {
    return state.sliderValue;
  },
  GETTER_GET_STAFF_DETAIL: function GETTER_GET_STAFF_DETAIL(state) {
    return state.staffDetail;
  },
  GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES: function GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES(state) {
    return state.colTableEmailHistories;
  },
  GETTER_LIST_EVENT_GROUP: function GETTER_LIST_EVENT_GROUP(state) {
    return state.listEventGroup;
  },
  GETTER_LIST_SINGLE_EVENT: function GETTER_LIST_SINGLE_EVENT(state) {
    return state.listSingleEvent;
  },
  GETTER_CURRENT_EVENT: function GETTER_CURRENT_EVENT(state) {
    return state.currentEvent;
  },
  GETTER_IS_DOWNLOADING: function GETTER_IS_DOWNLOADING(state) {
    return state.isDownloading;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__consts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loading_constants__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_api_call__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_request__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_streamFile__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__states__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_izi_toast__ = __webpack_require__(265);







var _this = this;













var _ = __webpack_require__(32);

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_7_axios___default.a);

var actions = {
  ACTION_SUBMIT_EVENT: function ACTION_SUBMIT_EVENT(_ref, item) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateEvent;
    item.lastModifiedBy = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId);
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.post(apiStr, item).then(function (response) {
      commit('MUTATION_DELETE_EVENT_AT_LOCAL', item.id);
      dispatch('ACTION_GET_EVENT_COUNT');
      commit('MUTATION_DELETE_EVENT_AT_LOCAL_MANAGE_TAB', item.id);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Submit event successful', '');
    }).catch(function (ex) {
      console.log(ex);
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["d" /* showApiCallbackErrorMessage */])(ex);
    });
  },
  ACTION_GET_EVENT_COUNT_BY_CLIENT: function ACTION_GET_EVENT_COUNT_BY_CLIENT(_ref2, clientIds) {
    var commit = _ref2.commit;

    if (_.isEmpty(clientIds)) {
      return;
    }
    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.countEvents;
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiStr, {
      params: {
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId),
        clientIdList: clientIds.join(','),
        isTotal: true
      }
    }).then(function (response) {
      if (!response.data || response.data.message !== null) {
        console.log('get count by clientId error:', response.data && response.data.message || '');
        return;
      }
      var resCounters = response.data.countTotalEventsByClient || [];
      commit('MUTATION_CLEAR_COUNT_CLIENT');
      resCounters.forEach(function (item) {
        var counter = {};
        counter.clientId = item.clientId;
        counter.countTotalEventsByStatus = item.countEventsByStatus;
        commit('MUTATION_SET_COUNT_CLIENT', counter);
      });
    });
  },
  ACTION_GET_EVENT_COUNT: function ACTION_GET_EVENT_COUNT(_ref3) {
    var commit = _ref3.commit;
    var countTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var clientIdList = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId);
    if (countTotal) {
      clientIdList = 0;
    }
    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.countEvents;
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiStr, {
      params: {
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId),
        clientIdList: clientIdList,
        isTotal: false
      }
    }).then(function (response) {
      if (!response.data) return;
      if (response.data.message !== null) {
        console.log('request error:', response.data.message);
      } else {
        __WEBPACK_IMPORTED_MODULE_14__states__["a" /* default */].countTotalEvent = [];
        var countTotalEvent = response.data.countTotalEventsByClient[0].countEventsByStatus || [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(countTotalEvent), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var countItem = _step.value;

            commit('MUTATION_SET_COUNT_TOTAL', countItem);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    });
  },
  ACTION_GET_EVENT_LIST: function ACTION_GET_EVENT_LIST(_ref4, params) {
    var dispatch = _ref4.dispatch,
        commit = _ref4.commit,
        state = _ref4.state;

    state.listEvent = [];
    state.isLoading = true;
    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEvents;
    return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiStr, {
      params: {
        userId: params.userId || localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId),
        status: params.status.join() || '',
        clientId: params.clientId || localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId),
        currentPage: parseInt(params.options.currentPage) || 1,
        itemsPerPage: 1000, // (params.options.itemsPerPage === 'SHOW ALL') ? 10000 : (parseInt(params.options.itemsPerPage) || 10),
        sortType: params.options.sortType || 'isChangeOrder',
        sortReverse: params.options.sortReverse || false,
        programId: params.programId
      }
    }).then(function (response) {
      state.isLoading = false;
      if (!response.data) return;
      if (response.data.message !== null) {
        console.log('request error:', response.data.message);
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('error', response.data.message, '');
      } else {
        if (response.data.events === null) {
          response.data.events = [];
        }
        response.data.events.forEach(function (element, index) {
          element.timeStartModel = element.startTime;
          element.contact = element.contactName ? {
            contactName: element.contactName,
            contactEmail: '',
            contactPhone: ''
          } : [];
          element.showCollapse = state.expandId === element.id;
          element.lastModifiedAt *= 1000;
          element.durationBackup = element.duration;
          element.shippingAddressBackup = element.shippingAddress;
          element.eventNameBackup = element.eventName;
          element.isSuggestChanges = false;

          // listEvent.forEach((element, index) => {
          element['additionalServices'] = _.cloneDeep(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].addOns);
          element.disableDuration = false;
          var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.addOns);
          var arrAddOns = strAddOns.split(',');
          var arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
          var fields = __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].fields;
          element['additionalServices'].forEach(function (service) {
            // show / hide
            arrAddOns.forEach(function (ele) {
              if (ele === service.key) {
                service.isShow = true;
                if (ele === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
                  service.isShow = parseInt(element[fields.event.projPart]) < 34;
                }
                // Used to check if small Site Concierge based on small Site Model
                if (ele === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
                  service.isShow = strAddOns.indexOf('smallSiteModel') >= 0 && arrOnOff.indexOf('smallSiteModel') >= 0 && parseInt(element[fields.event.projPart]) < 34;
                }
              }
            });
            // on / off
            arrOnOff.forEach(function (ele) {
              if (ele === service.key) {
                service.value = true;
              }
            });
          });
          // });
        }, _this);
      }
      commit('MUTATION_SET_EVENT_LIST', response.data.events);
      if (state.flagCreateEvent === true && params.status.join().toLowerCase() === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].eventStatus.drafts) {
        dispatch('ACTION_CREATE_NEW_EVENT');
      }
      // dispatch('ACTION_GET_EVENT_COUNT');
    });
  },
  ACTION_SET_EXPAND_ID: function ACTION_SET_EXPAND_ID(_ref5, expandObj) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit('MUTATION_SET_EXPAND_ID', expandObj.isExpand ? expandObj.id : expandObj.id === state.expandId ? -1 : expandObj.id);
  },
  setUserId: function setUserId(_ref6, id) {
    var commit = _ref6.commit;

    commit('setUserId', id);
  },
  ACTION_CREATE_NEW_EVENT: function ACTION_CREATE_NEW_EVENT(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var newEvent = _.cloneDeep(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].initEvent);
    newEvent.clientId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId);
    newEvent.createdBy = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId);
    newEvent.lastModifiedByUserName = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userName);
    newEvent.clientName = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientName);
    state.currentEvent = newEvent;
    // Vue.prototype.$toastr('info', 'Create new event successful', '');
  },
  ACTION_UPDATE_EVENT: function ACTION_UPDATE_EVENT(_ref8, eventItem) {
    var dispatch = _ref8.dispatch,
        commit = _ref8.commit,
        state = _ref8.state;

    state.isUpdating = true;
    state.indexOfItemModifying = eventItem.index;
    var model = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, eventItem, {
      id: parseInt(eventItem.id),
      lastModifiedBy: parseInt(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId)),
      clientId: parseInt(eventItem.clientId)
    });
    return dispatch('ACTION_REQUEST_UPDATE_EVENT', model).then(function (response) {
      if (state.messageError === '') {
        if (!eventItem.id) eventItem.id = response.data.event.id;
        eventItem.shippingAddress = response.data.event.shippingAddress;
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Update event successful', '');
      }
    });
  },
  ACTION_DUPLICATE_EVENT: function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref10, _ref11) {
      var dispatch = _ref10.dispatch,
          commit = _ref10.commit;
      var item = _ref11.item,
          _ref11$status = _ref11.status,
          status = _ref11$status === undefined ? null : _ref11$status,
          _ref11$isAddToList = _ref11.isAddToList,
          isAddToList = _ref11$isAddToList === undefined ? true : _ref11$isAddToList;
      var newEvent;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newEvent = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);

              newEvent.id = 0;
              newEvent.index = 0;
              newEvent.status = status || item.status;
              return _context.abrupt('return', dispatch('ACTION_REQUEST_UPDATE_EVENT', newEvent).then(function (response) {
                if (isAddToList) {
                  commit('MUTATION_CREATE_NEW_EVENT', response.data.event);
                }

                if (__WEBPACK_IMPORTED_MODULE_14__states__["a" /* default */].messageError === '') {
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Duplicate event successful', '');
                }
              }));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function ACTION_DUPLICATE_EVENT(_x2, _x3) {
      return _ref9.apply(this, arguments);
    };
  }(),
  ACTION_REQUEST_UPDATE_EVENT: function () {
    var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref13, item, successMessage) {
      var dispatch = _ref13.dispatch,
          commit = _ref13.commit,
          state = _ref13.state;
      var eventItem, apiStr;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              eventItem = _.cloneDeep(item);

              if (item.index >= 0 && item.index < state.listEvent.length) {
                state.indexOfItemModifying = item.index;
              }
              apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateEvent;
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(apiStr, eventItem).then(function (response) {
                  var eventId = response.data && response.data.event.id || 0;
                  if (response.data.statusCode === 'CREATED') {
                    commit('MUTATION_SET_EVENT_LIST_CREATE', response.data && response.data.event);
                  }

                  if (state.indexOfItemModifying >= 0 && state.listEvent.length > 0 && state.listEvent[state.indexOfItemModifying].id === 0) {
                    commit('MUTATION_UPDATE_EVENT_ID', eventId);
                  }
                  if (response.data.event.status === 'APPROVED') {
                    dispatch('ACTION_GET_EVENT_DETAIL_HISTORY', eventId);
                  }
                  commit('MUTATION_UPDATE_EVENT', response.data && response.data.event ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(response.data.event, { contact: item.contact }) : null);
                  commit('MUTATION_UPDATE_EVENT_IN_LIST', response.data && response.data.event ? response.data.event : null);
                  // dispatch('ACTION_GET_EVENT_LIST', JSON.parse(localStorage.getItem(constants.LOCAL_STORE.pagingOptions)));
                  dispatch('ACTION_GET_EVENT_COUNT');
                  commit('MUTATION_SET_MESSAGE_ERROR', response.data && response.data.message || '');
                  state.isUpdating = false;
                  resolve(response);
                }).catch(function (ex) {
                  state.isUpdating = false;
                  var errorMessage = ex.response && ex.response.data && ex.response.data.message || 'Internal server error.';
                  commit('MUTATION_SET_MESSAGE_ERROR', errorMessage);
                  Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["d" /* showApiCallbackErrorMessage */])(ex);
                  reject(ex);
                });
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function ACTION_REQUEST_UPDATE_EVENT(_x4, _x5, _x6) {
      return _ref12.apply(this, arguments);
    };
  }(),
  ACTION_APPROVE_EVENT: function () {
    var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref15, event) {
      var dispatch = _ref15.dispatch,
          commit = _ref15.commit;
      var eventItem;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              eventItem = _.cloneDeep(event);

              eventItem.status = __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].eventStatus.approved.toUpperCase();
              eventItem.lastModifiedBy = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId);
              _context3.next = 5;
              return dispatch('ACTION_REQUEST_UPDATE_EVENT', eventItem).then(function () {
                if (__WEBPACK_IMPORTED_MODULE_14__states__["a" /* default */].showRelatedEvents === true) {
                  commit('MUTATION_SET_LIST_BACK');
                }
                commit('MUTATION_DELETE_EVENT_AT_LOCAL', eventItem.id);
                dispatch('ACTION_GET_EVENT_COUNT');
                // dispatch('ACTION_GET_EVENT_LIST', JSON.parse(localStorage.getItem(constants.LOCAL_STORE.pagingOptions)));
              });

            case 5:
              if (__WEBPACK_IMPORTED_MODULE_14__states__["a" /* default */].messageError === '') {
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Approve event successful', '');
              }

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function ACTION_APPROVE_EVENT(_x7, _x8) {
      return _ref14.apply(this, arguments);
    };
  }(),
  ACTION_EXPORT_TO_EXCEL: function ACTION_EXPORT_TO_EXCEL() {
    // call Api
    var clientId = Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId));
    if (clientId !== 0) {
      var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.exportExcel + '/?clientId=' + clientId + '&userId=' + localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId);
      window.open(apiUrl);
    } else {
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Please select client before exporting.', '');
    }
  },
  ACTION_SET_LIST_EVENT_STATUS: function ACTION_SET_LIST_EVENT_STATUS(_ref16, eventStatus) {
    var commit = _ref16.commit;

    commit('MUTATION_SET_LIST_EVENT_STATUS', eventStatus);
  },
  ACTION_SUGGEST_CHANGES: function () {
    var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref18, eventItem) {
      var dispatch = _ref18.dispatch,
          commit = _ref18.commit,
          state = _ref18.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              eventItem.status = __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].eventStatus.review.toUpperCase();
              eventItem.lastModifiedBy = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId);
              eventItem.lastModifiedAt = new Date().getTime();
              _context4.next = 5;
              return dispatch('ACTION_REQUEST_UPDATE_EVENT', eventItem);

            case 5:
              if (state.showRelatedEvents === true) {
                commit('MUTATION_SET_LIST_BACK');
              }
              commit('MUTATION_DELETE_EVENT_AT_LOCAL', eventItem.id);
              if (state.messageError === '') {
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Suggest change event successful', '');
              }

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function ACTION_SUGGEST_CHANGES(_x9, _x10) {
      return _ref17.apply(this, arguments);
    };
  }(),
  ACTION_SET_ITEM_RELATED: function ACTION_SET_ITEM_RELATED(_ref19, eventItem) {
    var commit = _ref19.commit;

    // get item related info
    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getRelatedItemInfo;
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
      params: {
        eventId: eventItem.id,
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId)
      }
    }).then(function (response) {
      commit('MUTATION_SET_ITEM_RELATED', {
        item: eventItem,
        relatedInfo: response.data.countTotalEventsByStatus
      });
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_SET_LIST_BACK: function ACTION_SET_LIST_BACK(_ref20) {
    var commit = _ref20.commit;

    commit('MUTATION_SET_LIST_BACK');
  },
  ACTION_GET_EVENT_RELATED: function ACTION_GET_EVENT_RELATED(_ref21, params) {
    var commit = _ref21.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventsRelated;
    if (params.status.length === 0) {
      commit('MUTATION_SET_EVENTS_RELATED', []);
      return;
    }
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
      params: {
        eventId: params.eventId,
        status: params.status.join(),
        currentPage: parseInt(params.options.currentPage),
        itemsPerPage: parseInt(params.options.itemsPerPage),
        sortType: params.options.sortType,
        sortReverse: params.options.sortReverse,
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId)
      }
    }).then(function (response) {
      commit('MUTATION_SET_EVENTS_RELATED', response.data.events);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_DELETE_EVENT: function ACTION_DELETE_EVENT(_ref22, eventItem) {
    var dispatch = _ref22.dispatch,
        commit = _ref22.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.deleteEvent;
    return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
      params: {
        eventId: eventItem.id,
        userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId)
      }
    }).then(function (response) {
      commit('MUTATION_DELETE_EVENT_AT_LOCAL', eventItem.id);
      dispatch('ACTION_GET_EVENT_LIST', JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.pagingOptions)));
      dispatch('ACTION_GET_EVENT_COUNT');
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Delete event successful', '');
    }).catch(function (response) {
      console.log(response);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', response.data && response.data.message || '', '');
    });
  },
  ACTION_SUBMIT_EVENTS: function ACTION_SUBMIT_EVENTS(_ref23, _ref24) {
    var dispatch = _ref23.dispatch,
        commit = _ref23.commit;
    var clientId = _ref24.clientId,
        eventIds = _ref24.eventIds;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.submitEvents;
    var params = {
      clientId: clientId,
      eventIds: eventIds
    };
    return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(apiUrl, { params: params }).then(function (response) {
      if (response.data.eventList !== null && response.data.eventList.length > 0) {
        response.data.eventList.forEach(function (e) {
          var index = eventIds.indexOf(e.id);
          eventIds.splice(index, 1);

          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toast.error('Unable to submit event \'' + e.eventName + '\'. Please review and try again.', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_15__utils_izi_toast__["a" /* default */].optError));
        });
      }

      commit('MUTATION_DELETE_EVENTS', eventIds);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_SUBMIT_ALL_EVENT: function ACTION_SUBMIT_ALL_EVENT(_ref25) {
    var dispatch = _ref25.dispatch,
        commit = _ref25.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.submitAllEvent;
    var params = {
      userId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId)),
      clientId: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId))
    };
    return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(apiUrl, { params: params }).then(function (response) {
      if (response.data.eventList !== null && response.data.eventList.length > 0) {
        response.data.eventList.forEach(function (e) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toast.error('Unable to submit event \'' + e.eventName + '\'. Please review and try again.', '', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_15__utils_izi_toast__["a" /* default */].optError));
        }, _this);

        commit('MUTATION_SET_EVENT_LIST', response.data.eventList);
        commit('MUTATION_SET_ERROR_CODE', response.data.errorCodes);
        // state.submitAllEventSuccess = false;
        // commit('MUTATION_SET_MESSAGE_ERROR', response.data.message || '')
      } else {
        commit('MUTATION_SET_EVENT_LIST', []);
        // show modal submit all event success
      }
      dispatch('ACTION_GET_EVENT_COUNT');
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_RESTORE_LIST_EVENT: function ACTION_RESTORE_LIST_EVENT(_ref26) {
    var commit = _ref26.commit;

    commit('MUTATION_RESTORE_LIST_EVENT');
  },
  ACTION_SET_SHOW_RELATED_EVENT: function ACTION_SET_SHOW_RELATED_EVENT(_ref27, showRelated) {
    var commit = _ref27.commit;

    commit('MUTATION_SET_SHOW_RELATED_EVENT', showRelated);
  },
  ACTION_RESET_EXPAND_ID: function ACTION_RESET_EXPAND_ID(_ref28) {
    var commit = _ref28.commit;

    commit('MUTATION_RESET_EXPAND_ID');
  },
  ACTION_SAVE_COLUMN_WIDTH: function ACTION_SAVE_COLUMN_WIDTH(_ref29, resizeObj) {
    var commit = _ref29.commit,
        state = _ref29.state;

    var isTableUser = resizeObj.isTableUser;
    var colName = isTableUser ? 'firstName' : 'eventName';
    var el = document.getElementById(colName);
    var elWidth = el.getBoundingClientRect().width;
    var column = isTableUser ? state.columnTableUserWidth[colName] : state.columnWidth[colName];
    var next = column.next;
    var width = 0;
    do {
      if (colName === resizeObj.colName) {
        elWidth = parseFloat(resizeObj.newWidth);
      } else {
        elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
      }
      commit('MUTATION_SAVE_COLUMN_WIDTH', { colName: colName, newSize: elWidth, isTableUser: isTableUser });
      width = parseFloat(width) + elWidth;

      colName = column.next;
      el = document.getElementById(colName);
      column = isTableUser ? state.columnTableUserWidth[colName] : state.columnWidth[colName];
      next = column.next;
    } while (next);

    // save action column width
    if (el) {
      elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
      commit('MUTATION_SAVE_COLUMN_WIDTH', { colName: colName, newSize: elWidth, isTableUser: isTableUser });
      width = parseFloat(width) + elWidth;
    }
    var tbHeaderId = 'dt-header';
    var tbBodyId = 'dt-body';
    var dtHeaderEl = document.getElementById(tbHeaderId);
    var dtBodyEl = document.getElementById(tbBodyId);
    dtHeaderEl.style.width = resizeObj.newHeaderWidth + 'px';
    if (dtBodyEl) {
      dtBodyEl.style.width = resizeObj.newHeaderWidth + 'px';
    }
  },
  ACTION_SAVE_COLUMN_STAFFING_WIDTH: function ACTION_SAVE_COLUMN_STAFFING_WIDTH(_ref30, resizeObj) {
    var commit = _ref30.commit,
        state = _ref30.state;

    var colName = 'firstName';
    var el = document.getElementById(colName);
    var elWidth = el.getBoundingClientRect().width;
    var column = state.columnTableStaffingWidth[colName];
    var next = column.next;
    var width = 0;
    do {
      if (colName === resizeObj.colName) {
        elWidth = parseFloat(resizeObj.newWidth);
      } else {
        elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
      }
      commit('MUTATION_SAVE_COLUMN_STAFFING_WIDTH', { colName: colName, newSize: elWidth });
      width = parseFloat(width) + elWidth;

      colName = column.next;
      el = document.getElementById(colName);
      column = state.columnTableStaffingWidth[colName];
      next = column.next;
    } while (next);

    // save action column width
    elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
    commit('MUTATION_SAVE_COLUMN_STAFFING_WIDTH', { colName: colName, newSize: elWidth });
    width = parseFloat(width) + elWidth;
    var tbHeaderId = 'dt-header';
    var tbBodyId = 'dt-body';
    var dtHeaderEl = document.getElementById(tbHeaderId);
    var dtBodyEl = document.getElementById(tbBodyId);
    dtHeaderEl.style.width = resizeObj.newHeaderWidth + 'px';
    dtBodyEl.style.width = resizeObj.newHeaderWidth + 'px';
  },
  ACTION_GET_LIST_ON_SITE_CONTACT: function () {
    var _ref31 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref32, keyword) {
      var commit = _ref32.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(keyword === null || keyword === '')) {
                _context5.next = 3;
                break;
              }

              commit('MUTATION_SET_LIST_ON_SITE_CONTACT', []);
              return _context5.abrupt('return');

            case 3:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getOnSiteContact;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
                params: {
                  keyword: keyword,
                  clientId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId),
                  userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId)
                }
              }).then(function (response) {
                if (response.data.contacts !== null) {
                  response.data.contacts.forEach(function (element) {
                    element.contactNameDecoration = element.contactName.toLowerCase().replace(keyword, '<b>' + keyword + '</b>');
                  });
                  commit('MUTATION_SET_LIST_ON_SITE_CONTACT', response.data.contacts);
                } else {
                  commit('MUTATION_SET_LIST_ON_SITE_CONTACT', []);
                }
              }).catch(function (response) {
                console.log(response);
              });

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function ACTION_GET_LIST_ON_SITE_CONTACT(_x11, _x12) {
      return _ref31.apply(this, arguments);
    };
  }(),
  CREATE_EVENT_FLAG: function () {
    var _ref33 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref34, isCreate) {
      var commit = _ref34.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return commit('MUTATION_CREATE_EVENT_FLAG', isCreate);

            case 2:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function CREATE_EVENT_FLAG(_x13, _x14) {
      return _ref33.apply(this, arguments);
    };
  }(),
  ACTION_RESET_COLUMN_SIZE: function ACTION_RESET_COLUMN_SIZE(_ref35) {
    var commit = _ref35.commit;

    var colName = 'eventName';
    var column = __WEBPACK_IMPORTED_MODULE_14__states__["a" /* default */].columnWidth[colName];
    var next = column.next;

    do {
      commit('MUTATION_RESET_COLUMN_SIZE', colName);

      colName = column.next;
      column = __WEBPACK_IMPORTED_MODULE_14__states__["a" /* default */].columnWidth[colName];
      next = column.next;
    } while (next);
    commit('MUTATION_RESET_COLUMN_SIZE', colName);
  },
  ACTION_REMOVE_LOCK_EVENTS: function () {
    var _ref36 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var userId, apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              userId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId);
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.removeEventLockList;
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
                params: {
                  userId: userId
                }
              }).then(function (response) {});

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function ACTION_REMOVE_LOCK_EVENTS() {
      return _ref36.apply(this, arguments);
    };
  }(),
  ACTION_LOCK_EVENT_LIST: function () {
    var _ref37 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(_ref38) {
      var state = _ref38.state;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventLockList;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl).then(function (response) {
                console.log('Locked events: ', response.data);
                state.lockIds.eventIds = response.data.eventIds !== null ? response.data.eventIds : [];
                state.lockIds.userIds = response.data.userIds !== null ? response.data.userIds : [];
              });

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));

    return function ACTION_LOCK_EVENT_LIST(_x15) {
      return _ref37.apply(this, arguments);
    };
  }(),
  ACTION_LOCK_EVENT: function ACTION_LOCK_EVENT(_ref39, lockObj) {
    var state = _ref39.state;

    var index = state.lockIds.eventIds.indexOf(lockObj.eventId);
    if (index === -1 && lockObj.isLocked) {
      state.lockIds.eventIds.push(lockObj.eventId);
      state.lockIds.userIds.push(lockObj.userId);
    }
    if (index !== -1 && !lockObj.isLocked && state.lockIds.userIds[index] === lockObj.userId.toString()) {
      state.lockIds.eventIds.splice(index, 1);
      state.lockIds.userIds.splice(index, 1);
    }
    console.log(index, lockObj.isLocked, state.lockIds.userIds[index], lockObj.userId.toString(), state.lockIds.userIds[index] === lockObj.userId.toString());
  },
  ACTION_SET_SUBMIT_ALL_EVENT_SUCCESS: function ACTION_SET_SUBMIT_ALL_EVENT_SUCCESS(_ref40, submitAllEventSuccess) {
    var commit = _ref40.commit,
        state = _ref40.state;

    state.submitAllEventSuccess = submitAllEventSuccess;
  },
  ACTION_RESTART_LIST_EVENT_STATUS: function ACTION_RESTART_LIST_EVENT_STATUS(_ref41, listStatus) {
    var state = _ref41.state;

    state.listEventStatus = listStatus;
  },
  ACTION_SET_MESSAGE_ERROR: function ACTION_SET_MESSAGE_ERROR(_ref42, message) {
    var state = _ref42.state,
        commit = _ref42.commit;

    commit('MUTATION_SET_MESSAGE_ERROR', message);
  },
  ACTION_GET_EVENT_HISTORY: function () {
    var _ref43 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(_ref44, eventId) {
      var state = _ref44.state,
          commit = _ref44.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventHistory;
              _context9.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
                params: {
                  eventId: eventId
                }
              }).then(function (response) {
                if (response.status !== 200 || response.data.message) {
                  console.log('error:', response);
                }
                commit('MUTATION_SET_EVENT_HISTORY', response.data.events);
              });

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this);
    }));

    return function ACTION_GET_EVENT_HISTORY(_x16, _x17) {
      return _ref43.apply(this, arguments);
    };
  }(),
  ACTION_GET_EVENT_DETAIL_HISTORY: function ACTION_GET_EVENT_DETAIL_HISTORY(_ref45, eventId) {
    var state = _ref45.state,
        commit = _ref45.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventHistory;
    commit('MUTATION_SET_IS_LOADING_EVENT_HISTORY', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          eventId: eventId
        }
      })).then(function (response) {
        commit('MUTATION_SET_EVENT_DETAIL_HISTORY', response);
        resolve(response);
      }, function (error) {
        reject(error);
      }).finally(function () {
        commit('MUTATION_SET_IS_LOADING_EVENT_HISTORY', false);
      });
    });
  },
  ACTION_UPDATE_EVENT_ADD_ON: function () {
    var _ref46 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(_ref47, obj) {
      var state = _ref47.state,
          commit = _ref47.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateAddOn;
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(apiUrl, obj).then(function (response) {
                  commit('MUTATION_UPDATE_ADDON', { obj: obj, addOns: response.data.addOns });
                  resolve(response);
                }).catch(function (response) {
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('error', 'Update event unsuccessful');
                  reject(response);
                });
              }));

            case 2:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this);
    }));

    return function ACTION_UPDATE_EVENT_ADD_ON(_x18, _x19) {
      return _ref46.apply(this, arguments);
    };
  }(),
  ACTION_CHANGE_EVENT_STATUS: function () {
    var _ref48 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(_ref49, obj) {
      var dispatch = _ref49.dispatch,
          state = _ref49.state,
          commit = _ref49.commit;
      var apiUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.changeEventStatus;
              _context11.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.post(apiUrl, obj).then(function (response) {
                if (response.status !== 200 || response.data.message) {
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('error', 'Update event unsuccessful');
                } else {
                  commit('MUTATION_DELETE_EVENT_AT_LOCAL', obj.eventId);
                  dispatch('ACTION_GET_EVENT_COUNT');
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Update event successful', '');
                }
              }).catch(function (response) {
                console.log('error:', response);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('error', 'Update event unsuccessful');
              });

            case 3:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this);
    }));

    return function ACTION_CHANGE_EVENT_STATUS(_x20, _x21) {
      return _ref48.apply(this, arguments);
    };
  }(),
  ACTION_GET_EVENTS_BY_DATES: function ACTION_GET_EVENTS_BY_DATES(_ref50, obj) {
    var commit = _ref50.commit,
        state = _ref50.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventsByDates;
    // set limit begin dates
    var numberLimitBegin = obj.noBeginDates;
    var numberLimitEnd = obj.noEndDates === '60+' ? 100 : obj.noEndDates;

    state.keywordSearchEvent = obj.keyword;
    var body = {
      noBeginDates: numberLimitBegin,
      noEndDates: numberLimitEnd, // 100 is represent for 60+, can be any number which is bigger than 60
      selectedDate: obj.selectedDate,
      clientId: obj.clientId,
      keyword: obj.keyword,
      currentPage: obj.currentPage || 1,
      itemsPerPage: obj.itemsPerPage === null || obj.itemsPerPage === undefined ? 25 : obj.itemsPerPage,
      sortType: obj.sortType || 'dateTime',
      eventStatusRequest: obj.eventStatus && obj.eventStatus.toUpperCase() || 'ALL',
      eventStatus: [obj.status || 'APPROVED'],
      requireReport: obj.requireReport || null
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      state.isLoading = true;
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        state.isLoading = false;
        if (response.approvedEvents === null) {
          response.approvedEvents = [];
        }
        response.approvedEvents.forEach(function (elementParent, index) {
          elementParent.events.forEach(function (element, index) {
            element.timeStartModel = element.startTime;
            element.contact = {
              contactName: element.contactName,
              contactEmail: '',
              contactPhone: ''
            };
            element.showCollapse = state.expandId === element.id;
            element.lastModifiedAt *= 1000;
            element.durationBackup = element.duration;
            element.shippingAddressBackup = element.shippingAddress;
            element.eventNameBackup = element.eventName;
            element.isSuggestChanges = false;

            // listEvent.forEach((element, index) => {
            element['additionalServices'] = _.cloneDeep(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].addOns);
            element.disableDuration = false;
            var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.addOns);
            var arrAddOns = strAddOns.split(',');
            var arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
            var fields = __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].fields;
            element['additionalServices'].forEach(function (service) {
              // show / hide
              arrAddOns.forEach(function (ele) {
                if (ele === service.key) {
                  service.isShow = true;
                  if (ele === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
                    service.isShow = parseInt(element[fields.event.projPart]) < 34;
                  }
                  // Used to check if small Site Concierge based on small Site Model
                  if (ele === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
                    service.isShow = strAddOns.indexOf('smallSiteModel') >= 0 && arrOnOff.indexOf('smallSiteModel') >= 0 && parseInt(element[fields.event.projPart]) < 34;
                  }
                }
              });
              // on / off
              arrOnOff.forEach(function (ele) {
                if (ele === service.key) {
                  service.value = true;
                }
              });
            });
          }, _this);
        }, _this);
        commit('MUTATION_SET_APPROVED_EVENTS', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, response, {
          changeFilter: obj.changeFilter,
          currentPage: obj.currentPage
        }));
        commit('MUTATION_SEARCH_APPROVED_EVENT', state.keywordSearchEvent);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_DATE_HAS_DATA: function ACTION_GET_DATE_HAS_DATA(_ref51, selectedDate) {
    var commit = _ref51.commit,
        state = _ref51.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getDateHasData;
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl, {
      params: {
        selectedDate: selectedDate
      }
    }).then(function (response) {
      if (response.status !== 200 || response.data.message) {
        console.log('error:', response);
      }
      commit('MUTATION_SET_DATE_HAS_DATA', response.data.daysHasData || []);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_LOCKED_DATE: function ACTION_LOCKED_DATE(_ref52) {
    var commit = _ref52.commit,
        state = _ref52.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getLockedDate;
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiUrl).then(function (response) {
      if (response.status !== 200 || response.data.message) {
        console.log('error:', response);
      }
      commit('MUTATION_SET_LOCKED_DATE', response.data.dates || []);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_GET_DATE_RANGE_HAS_DATA: function ACTION_GET_DATE_RANGE_HAS_DATA(_ref53, dateRange) {
    var commit = _ref53.commit,
        state = _ref53.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getDateRangeHasData;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate
        }
      })).then(function (response) {
        resolve(response);
        commit('MUTATION_SET_DATE_RANGE_HAS_DATA', response.datesHasData || []);
      });
    });
  },
  ACTION_GET_EVENT_BY_ID: function ACTION_GET_EVENT_BY_ID(_ref54, eventId) {
    var state = _ref54.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventById;
    var id = eventId || state.eventDetailId;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      state.isLoadingModal = true;
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', { params: { eventId: id } })).then(function (response) {
        state.isLoadingModal = false;
        state.isLoading = false; // set it to false when finish loading event detail
        state.eventDetailId = id;
        var element = response.event;
        element.timeStartModel = element.startTime;
        element.contact = {
          contactName: element.contactName,
          contactEmail: '',
          contactPhone: ''
        };
        element.showCollapse = state.expandId === element.id;
        element.lastModifiedAt *= 1000;
        element.durationBackup = element.duration;
        element.shippingAddressBackup = element.shippingAddress;
        element.eventNameBackup = element.eventName;
        element.isSuggestChanges = false;
        element['additionalServices'] = _.cloneDeep(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].addOns);
        element.disableDuration = false;
        var strAddOns = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.addOns);
        var arrAddOns = strAddOns.split(',');
        var arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
        var fields = __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].fields;
        element['additionalServices'].forEach(function (service) {
          // show / hide
          arrAddOns.forEach(function (ele) {
            if (ele === service.key) {
              service.isShow = true;
              if (ele === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].listAdditionalServicesKey.smallSiteModel) {
                service.isShow = parseInt(element[fields.event.projPart]) < 34;
              }
              // Used to check if small Site Concierge based on small Site Model
              if (ele === __WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].listAdditionalServicesKey.smallSiteConcierge) {
                service.isShow = strAddOns.indexOf('smallSiteModel') >= 0 && arrOnOff.indexOf('smallSiteModel') >= 0 && parseInt(element[fields.event.projPart]) < 34;
              }
            }
          });
          // on / off
          arrOnOff.forEach(function (ele) {
            if (ele === service.key) {
              service.value = true;
            }
          });
        });
        state.eventDetailChangeOrder = element;
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_STAFFING: function ACTION_GET_EVENT_STAFFING(_ref55, eventId) {
    var state = _ref55.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventStaffing;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // state.isLoadingModal = true;
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', { params: { eventId: eventId || state.eventDetailId } })).then(function (response) {
        // state.isLoadingModal = false;
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_BLOCK_DATE: function ACTION_BLOCK_DATE(_ref56, selectedDate) {
    var commit = _ref56.commit,
        state = _ref56.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.blockDate;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', selectedDate)).then(function (response) {
        commit('MUTATION_SET_LOCKED_DATE', response.dates || []);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_OPEN_DATE: function ACTION_OPEN_DATE(_ref57, selectedDate) {
    var commit = _ref57.commit,
        state = _ref57.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.openDate;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', selectedDate)).then(function (response) {
        commit('MUTATION_SET_LOCKED_DATE', response.dates || []);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_BLOCK_OR_OPEN_ALL_SLOTS: function ACTION_BLOCK_OR_OPEN_ALL_SLOTS(_ref58, obj) {
    var state = _ref58.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.blockOrOpenSlots;
    var body = {
      eventId: obj.eventId,
      duration: obj.duration,
      blocked: obj.blocked
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_CHANGE_DURATION: function ACTION_CHANGE_DURATION(_ref59, obj) {
    var state = _ref59.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.changeDuration;
    var body = {
      eventId: obj.eventId || state.eventDetailId,
      duration: obj.duration,
      blocked: null
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_BLOCK_OPEN_STAFFING: function ACTION_BLOCK_OPEN_STAFFING(_ref60, staffingArr) {
    var state = _ref60.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateEventStaffing;
    var body = {
      eventSlot: staffingArr
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_CLEAR_SLOT: function ACTION_CLEAR_SLOT(_ref61, slot) {
    var state = _ref61.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.clearSingleSlot;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', slot)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_TRACKING_STATUS: function ACTION_GET_TRACKING_STATUS(_ref62, obj) {
    var state = _ref62.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getTrackingStatus + '/' + obj.eventId + '/' + obj.trackingNumber;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
        console.log('get tracking status res:', response);
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW: function ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW(_ref63, _ref64) {
    var state = _ref63.state;
    var clientId = _ref64.clientId,
        programId = _ref64.programId;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.countEvents;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          userId: localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.userId),
          clientIdList: clientId,
          isTotal: true,
          programId: programId
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_BY_STATUS: function ACTION_GET_EVENT_BY_STATUS(_ref65, obj) {
    var state = _ref65.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventByStatus;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          clientId: obj.clientId,
          status: obj.status
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_URL_FOR_PACKING_SLIP: function ACTION_GET_URL_FOR_PACKING_SLIP(_ref66) {
    var state = _ref66.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getURLForPackingSlip;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {})).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_DOWNLOAD_PACKING_SLIP: function ACTION_DOWNLOAD_PACKING_SLIP(_ref67, token) {
    var state = _ref67.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getPackingSlip + '/?token=' + token;
    window.open(apiUrl);
  },
  ACTION_GET_STAFF_LIST: function ACTION_GET_STAFF_LIST(_ref68, obj) {
    var state = _ref68.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().clients.getStaffLIst;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          keyword: obj.keyword || '',
          currentPage: obj.currentPage || 1,
          itemsPerPage: obj.itemsPerPage || 25,
          sortType: obj.sortType || 'firstName',
          sortReverse: obj.sortReverse || false
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_CREATE_STAFF: function ACTION_CREATE_STAFF(_ref69, staff) {
    var state = _ref69.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().clients.updateStaff;
    var body = staff;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        if (!response.message) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Save staff successfully', '');
        }
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_DELETE_STAFF: function ACTION_DELETE_STAFF(_ref70, staff) {
    var state = _ref70.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().clients.deleteStaff;
    var body = staff;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        if (!response.message) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Delete staff successfully', '');
        }
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_ADD_STAFF_SLOT: function ACTION_ADD_STAFF_SLOT(_ref71, data) {
    var state = _ref71.state;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getStaffMaxSlots;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', data)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_ALL_AVAILABLE_STAFFS: function ACTION_GET_ALL_AVAILABLE_STAFFS(_ref72, obj) {
    var state = _ref72.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getAllAvailableStaffs;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          eventId: obj.eventId || 0,
          role: obj.role || '',
          searchString: obj.searchString || ''
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_ASSIGN_STAFF: function ACTION_ASSIGN_STAFF(_ref73, data) {
    var state = _ref73.state;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.assignStaff;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiStr, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', data)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_STAFF: function ACTION_GET_EVENT_STAFF(_ref74, eventId) {
    var dispatch = _ref74.dispatch,
        commit = _ref74.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventStaff;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          eventId: eventId || 0
        }
      })).then(function (response) {
        if (!response.message) {
          commit('MUTATION_SAVE_EVENT_STAFF', { listType: 'staffLead', data: response.staffLead || [] });
          commit('MUTATION_SAVE_EVENT_STAFF', { listType: 'staffScreener', data: response.staffScreener || [] });
          commit('MUTATION_SAVE_EVENT_STAFF', { listType: 'staffConcierge', data: response.staffConcierge || [] });
        }
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_REPORT_CHART: function ACTION_GET_EVENT_REPORT_CHART(_ref75, data) {
    var dispatch = _ref75.dispatch,
        commit = _ref75.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventReportChart;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          eventId: data.eventId || 0,
          status: (data.reportType || 'upcoming').toUpperCase()
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_IS_LIVE_EVENT: function ACTION_UPDATE_IS_LIVE_EVENT(_ref76, obj) {
    var dispatch = _ref76.dispatch,
        commit = _ref76.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateIsLiveEvent;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SEARCH_RELATED_EVENTS: function ACTION_SEARCH_RELATED_EVENTS(_ref77, obj) {
    var state = _ref77.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.searchRelatedEvents;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          eventId: obj.eventId || 0,
          searchString: obj.searchString || ''
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_ADD_REMOVE_RELATED_EVENTS: function ACTION_ADD_REMOVE_RELATED_EVENTS(_ref78, obj) {
    var state = _ref78.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.addOrRemoveRelatedEvents;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_DEFAULT_EMAIL_TEMPLATE: function ACTION_GET_DEFAULT_EMAIL_TEMPLATE(_ref79, obj) {
    var state = _ref79.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getDefaultEmailTemplate;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          eventId: obj.eventId || 0,
          singleEvent: obj.isSingleEvent
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SEND_ON_SITE_CONTACT_EMAIL: function ACTION_SEND_ON_SITE_CONTACT_EMAIL(_ref80, obj) {
    var state = _ref80.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.sendOnSiteContactEmail;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_HISTORIES_BY_ID: function ACTION_GET_EVENT_HISTORIES_BY_ID(_ref81, params) {
    var state = _ref81.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventHistoriesById;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', params)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EMAIL_HISTORY_DETAILS: function ACTION_GET_EMAIL_HISTORY_DETAILS(_ref82, id) {
    var state = _ref82.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEmailHistoryDetails;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {
        params: {
          historyId: id
        }
      })).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_ADD_PARTICIPANT: function ACTION_ADD_PARTICIPANT(_ref83, obj) {
    var state = _ref83.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.addParticipant;
    if (obj.isUpdating) {
      apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateParticipant;
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  UPDATE_MAX_NUMBER_FLU_SHOT: function UPDATE_MAX_NUMBER_FLU_SHOT(_ref84, obj) {
    var state = _ref84.state;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateMaxNumberSlotFluShot;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', obj)).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_SEARCH_PARTICIPANT: function ACTION_SEARCH_PARTICIPANT(_ref85, params) {
    var state = _ref85.state,
        commit = _ref85.commit;

    state.isLoadingParticipant = __WEBPACK_IMPORTED_MODULE_10__loading_constants__["a" /* default */].LOADING;
    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.searchParticipant;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', params)).then(function (response) {
        state.isLoadingParticipant = __WEBPACK_IMPORTED_MODULE_10__loading_constants__["a" /* default */].LOADED;
        resolve(response);
      }).catch(function (error) {
        state.isLoadingParticipant = __WEBPACK_IMPORTED_MODULE_10__loading_constants__["a" /* default */].INIT;
        reject(error);
      });
    });
  },
  ACTION_GENERATE_PACKING_SLIP: function ACTION_GENERATE_PACKING_SLIP(_ref86, param) {
    var state = _ref86.state;

    var apiStr = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.generatePackingSlip;
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].axios.get(apiStr, {
      params: {
        eventId: param
      },
      responseType: 'blob'
    }).then(function (response) {
      var date = new Date();
      // eslint-disable-next-line
      var month = ('0' + (date.getMonth() + 1)).slice(-2);
      var filename = 'PackingSlip_' + month + '_' + date.getFullYear();
      // download file
      Object(__WEBPACK_IMPORTED_MODULE_13__utils_streamFile__["a" /* streamXlsxFileWithBlob */])(response.data, filename);
    }).catch(function (error) {
      console.log(error);
    });
  },
  ACTION_RESEND_BIO_SURVEY: function ACTION_RESEND_BIO_SURVEY(_ref87, params) {
    var state = _ref87.state,
        commit = _ref87.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.resendBiometricSurvey, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', params)).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  ACTION_CANCEL_ALL_APPOINTMENTS: function ACTION_CANCEL_ALL_APPOINTMENTS(_ref88, eventId) {
    var state = _ref88.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.cancelAllAppointments, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', eventId)).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENTS_DATES: function ACTION_GET_EVENTS_DATES(_ref89, params) {
    var state = _ref89.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.getEventsByDates, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', params)).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  ACTION_DOWNLOAD_BULK_EVENTS_TEMPLATE: function ACTION_DOWNLOAD_BULK_EVENTS_TEMPLATE() {
    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.bulkCreateEventTemplate;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET', {})).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_UPLOAD_FILE_BULK_CREATE_EVENTS: function ACTION_UPLOAD_FILE_BULK_CREATE_EVENTS(_ref90, params) {
    var state = _ref90.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.uploadBulkCreateEvent, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', params)).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  ACTION_GET_UPLOAD_HISTORIES: function ACTION_GET_UPLOAD_HISTORIES(_ref91, params) {
    var state = _ref91.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.uploadHistories + ('?currentPage=' + params.currentPage + '&itemsPerPage=' + params.itemsPerPage + '&clientId=' + params.clientId), Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_DOWNLOAD_UPLOADED_FILE: function ACTION_DOWNLOAD_UPLOADED_FILE(_ref92, params) {
    var state = _ref92.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.downloadUploadedFile + ('?fileId=' + params.fileId + '&clientId=' + params.clientId), Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_NEXT_ZINDEX: function ACTION_UPDATE_NEXT_ZINDEX(_ref93, elementId) {
    var state = _ref93.state;

    var element = document.getElementById(elementId);
    if (!element) return;
    element.style.zIndex = ++state.zIndex;
  },
  ACTION_EXPORT_PARTICIPANT_REPORT: function ACTION_EXPORT_PARTICIPANT_REPORT(_ref94, programId) {
    var dispatch = _ref94.dispatch,
        state = _ref94.state,
        commit = _ref94.commit;

    if (!programId) programId = 0;
    var clientId = Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts__["a" /* default */].LOCAL_STORE.clientId));
    if (clientId !== 0) {
      commit('MUTATION_SET_IS_DOWNLOADING', true);
      var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.exportParticipantReport + '/?clientId=' + clientId + '&programId=' + programId;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
          var anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response);
          anchor.target = '_blank';
          anchor.download = 'ParticipantReport.csv';
          anchor.click();
          resolve();
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('error', 'Can not download CSV file!', '');
          reject(err);
        }).finally(function () {
          commit('MUTATION_SET_IS_DOWNLOADING', false);
        });
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Please select client before exporting.', '');
    }
  },
  ACTION_UPDATE_EVENT_SHIFTBOARD: function ACTION_UPDATE_EVENT_SHIFTBOARD(_ref95, params) {
    var dispatch = _ref95.dispatch,
        state = _ref95.state,
        commit = _ref95.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["c" /* getEndPoint */])().events.updateEventShiftboard.replace('{eventId}', params.eventId);
    var body = { workgroupId: params.workgroupId, role: params.role };
    state.isLoadingModal = true;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_11__utils_api_call__["a" /* buildOptions */])('POST', body)).then(function (response) {
        resolve(response);
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('info', 'Save event shiftboard successfully', '');
        state.isLoadingModal = false;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$toastr('error', 'Can not save event shiftboard', '');
        reject(err);
        state.isLoadingModal = false;
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = streamXlsxFileWithBlob;
function streamXlsxFileWithBlob(data, fileName) {
  var url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', '' + fileName);
  document.body.appendChild(link);
  link.click();
}

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array_helper__ = __webpack_require__(402);









__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);

var mutations = {
  MUTATION_CLEAR_COUNT_CLIENT: function MUTATION_CLEAR_COUNT_CLIENT(state) {
    state.countClientEvent = [];
  },
  MUTATION_SET_COUNT_CLIENT: function MUTATION_SET_COUNT_CLIENT(state, counter) {
    state.countClientEvent.push(counter);
  },
  MUTATION_SET_COUNT_TOTAL: function MUTATION_SET_COUNT_TOTAL(state, countItem) {
    state.countTotalEvent.push({
      status: countItem.status.toLowerCase(),
      count: parseInt(countItem.countTotal),
      unread: parseInt(countItem.unread) || 0
    });
  },
  MUTATION_SET_EVENT_LIST: function MUTATION_SET_EVENT_LIST(state, events) {
    var eventsWithIndex = [];
    if (events === null) {
      events = [];
    }
    events.forEach(function (item, index) {
      item.index = index;
      eventsWithIndex.push(item);
    });
    state.listEvent = eventsWithIndex;
    state.showRelatedEvents = false;
  },
  MUTATION_SET_EXPAND_ID: function MUTATION_SET_EXPAND_ID(state, expandId) {
    state.expandId = state.expandId === expandId ? -1 : expandId;
  },
  setUserId: function setUserId(state, id) {
    state.userId = id;
  },
  MUTATION_UPDATE_EVENT: function MUTATION_UPDATE_EVENT(state, eventRespond) {
    if (eventRespond !== null && eventRespond.status === 'APPROVED') {
      var arrEvent = state.listEvent.filter(function (x) {
        return x.id !== eventRespond.id;
      });
      state.listEvent = arrEvent;
      return;
    }
    var currentIndex = eventRespond.index === undefined || eventRespond.index === null ? state.indexOfItemModifying : eventRespond.index;
    if (currentIndex < 0 || currentIndex >= state.listEvent.length || eventRespond === null) {
      return;
    }
    state.listEvent[currentIndex].isLive = eventRespond.isLive;
    state.listEvent[currentIndex].eventName = eventRespond.eventName;
    state.listEvent[currentIndex].durationBackup = eventRespond.duration;
    state.listEvent[currentIndex].shippingAddressBackup = eventRespond.shippingAddress;
    state.listEvent[currentIndex].eventNameBackup = eventRespond.eventName;
    state.listEvent[currentIndex].startTime = eventRespond.startTime;
    state.listEvent[currentIndex].contact = eventRespond.contact;
  },
  MUTATION_UPDATE_EVENT_ID: function MUTATION_UPDATE_EVENT_ID(state, id) {
    if (!state.indexOfItemModifying || state.indexOfItemModifying < 0 || state.indexOfItemModifying >= state.listEvent.length || id === null || id === undefined) {
      return;
    }
    state.listEvent[state.indexOfItemModifying].id = id;
    state.currentEventId = id;
  },
  MUTATION_SET_LIST_EVENT_STATUS: function MUTATION_SET_LIST_EVENT_STATUS(state, eventStatus) {
    if (eventStatus === null || eventStatus === '' || eventStatus === undefined) {
      state.listEventStatus = [];
      return;
    }
    var index = state.listEventStatus.indexOf(eventStatus.toUpperCase());
    if (index === -1) {
      state.listEventStatus.push(eventStatus.toUpperCase());
    } else {
      state.listEventStatus.splice(index, 1);
    }
  },
  MUTATION_SET_ITEM_RELATED: function MUTATION_SET_ITEM_RELATED(state, eventItem) {
    if (eventItem === null || eventItem === undefined) {
      return;
    }
    var newEvent = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, eventItem.item);
    newEvent.relatedInfo = eventItem.relatedInfo;
    state.listBackup = state.listEvent;
    state.listEvent = [newEvent];
    state.listEventRelated = [];
    state.showRelatedEvents = true;
  },
  MUTATION_SET_LIST_BACK: function MUTATION_SET_LIST_BACK(state) {
    state.showRelatedEvents = false;
    state.listEventRelated = [];
    state.listEvent = state.listBackup;
  },
  MUTATION_SET_EVENTS_RELATED: function MUTATION_SET_EVENTS_RELATED(state, arrEvent) {
    if (arrEvent === null || arrEvent === undefined) {
      return;
    }
    state.listEventRelated = arrEvent;
  },
  MUTATION_DELETE_EVENT_AT_LOCAL: function MUTATION_DELETE_EVENT_AT_LOCAL(state, id) {
    if (state.listEvent.length === 1) {
      state.listEvent.pop();
      return;
    }
    for (var i = 0; i < state.listEvent.length; i++) {
      if (state.listEvent[i].id === id) {
        state.listEvent.splice(i, 1);
        return;
      }
    }
  },
  MUTATION_DELETE_EVENT_AT_LOCAL_MANAGE_TAB: function MUTATION_DELETE_EVENT_AT_LOCAL_MANAGE_TAB(state, id) {
    state.listApprovedEvent.forEach(function (element) {
      element.events.forEach(function (event, index) {
        if (event.id === id) {
          element.events.splice(index, 1);
          state.totalApprovedEvents = state.totalApprovedEvents - 1;
        }
      });
    });
  },
  MUTATION_DELETE_EVENTS: function MUTATION_DELETE_EVENTS(state, ids) {
    state.listEvent = state.listEvent.filter(function (e) {
      return !ids.includes(e.id);
    });
  },
  MUTATION_CREATE_NEW_EVENT: function MUTATION_CREATE_NEW_EVENT(state, newEvent) {
    if (newEvent === null || newEvent === undefined) {
      return;
    }
    var arrEvent = state.listEvent;
    state.listEvent = [newEvent].concat(arrEvent);
    state.listEvent.forEach(function (element, index) {
      element.index = index;
      element.showCollapse = index === 0;
    });
    state.flagCreateEvent = false;
  },
  MUTATION_RESTORE_LIST_EVENT: function MUTATION_RESTORE_LIST_EVENT(state) {
    state.listEventStatus = [];
    state.listEvent = state.listBackup;
  },
  MUTATION_SET_SHOW_RELATED_EVENT: function MUTATION_SET_SHOW_RELATED_EVENT(state, showRelated) {
    state.listEventStatus = [];
    state.showRelatedEvents = showRelated;
  },
  MUTATION_RESET_EXPAND_ID: function MUTATION_RESET_EXPAND_ID(state) {
    state.expandId = -1;
  },
  MUTATION_SAVE_COLUMN_WIDTH: function MUTATION_SAVE_COLUMN_WIDTH(state, resizeObj) {
    if (resizeObj.isTableUser) {
      state.columnTableUserWidth[resizeObj.colName].size = parseFloat(resizeObj.newSize);
    } else {
      state.columnWidth[resizeObj.colName].size = parseFloat(resizeObj.newSize);
    }
  },
  MUTATION_SAVE_COLUMN_STAFFING_WIDTH: function MUTATION_SAVE_COLUMN_STAFFING_WIDTH(state, resizeObj) {
    state.columnTableStaffingWidth[resizeObj.colName].size = parseFloat(resizeObj.newSize);
  },
  MUTATION_SAVE_COLUMN_WIDTH_TABLE_EMAIL_HISTORIES: function MUTATION_SAVE_COLUMN_WIDTH_TABLE_EMAIL_HISTORIES(state, resizeObj) {
    state.colTableEmailHistories[resizeObj.colName].size = parseFloat(resizeObj.newWidth);
  },
  MUTATION_SET_LIST_ON_SITE_CONTACT: function MUTATION_SET_LIST_ON_SITE_CONTACT(state, listContact) {
    state.listOnSiteContact = listContact;
    // state.columnWidth[resizeObj.colNameRight].size = parseFloat(resizeObj.newWidthRight);
  },
  MUTATION_CREATE_EVENT_FLAG: function MUTATION_CREATE_EVENT_FLAG(state, isCreate) {
    state.flagCreateEvent = isCreate;
  },
  MUTATION_RESET_COLUMN_SIZE: function MUTATION_RESET_COLUMN_SIZE(state, colName) {
    if (state.columnWidth[colName]) {
      state.columnWidth[colName].size = 0;
    }
    if (state.columnTableUserWidth[colName]) {
      state.columnTableUserWidth[colName].size = 0;
    }
  },
  MUTATION_RESET_COLUMN_SIZE_STAFFING: function MUTATION_RESET_COLUMN_SIZE_STAFFING(state, colName) {
    if (state.columnTableStaffingWidth[colName]) {
      state.columnTableStaffingWidth[colName].size = 0;
    }
  },
  MUTATION_SET_MESSAGE_ERROR: function MUTATION_SET_MESSAGE_ERROR(state, message) {
    state.messageError = message;
  },
  MUTATION_SET_ERROR_CODE: function MUTATION_SET_ERROR_CODE(state, errorCodes) {
    if (errorCodes === undefined || errorCodes === null) {
      state.errorCodes = null;
      return;
    }
    state.errorCodes = errorCodes;
  },
  MUTATION_SET_EVENT_HISTORY: function MUTATION_SET_EVENT_HISTORY(state, histories) {
    if (!histories) {
      state.histories = [];
    } else {
      state.histories = histories;
    }
  },
  MUTATION_SET_EVENT_DETAIL_HISTORY: function MUTATION_SET_EVENT_DETAIL_HISTORY(state, response) {
    if (!response.events) {
      state.eventDetailHistory = [];
    } else {
      var histories = [];
      response.events.forEach(function (historyGroup) {
        var date = new Date(historyGroup.timeModified);
        historyGroup.fieldsChange.forEach(function (history) {
          histories.push({
            fieldName: history.fieldName,
            newValue: history.newValue,
            oldValue: history.previousValue,
            updatedBy: historyGroup.userName,
            timeModified: date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
          });
        });
      });
      state.eventDetailHistory = histories;
    }
  },
  MUTATION_SET_IS_LOADING_EVENT_HISTORY: function MUTATION_SET_IS_LOADING_EVENT_HISTORY(state, isLoading) {
    state.isLoadingEventDetailHistory = isLoading;
  },
  MUTATION_UPDATE_ADDON: function MUTATION_UPDATE_ADDON(state, updateObj) {
    if (!state.listEvent || !state.listEvent.length) return;
    if (state.listEvent[updateObj.obj.index] != null) {
      state.listEvent[updateObj.obj.index].addOns = updateObj.addOns;
      var services = state.listEvent[updateObj.obj.index].additionalServices;
      var rs = [];
      services.forEach(function (item) {
        if (item.key === updateObj.obj.key) {
          item.value = updateObj.obj.value;
        }
        rs.push(item);
      });
      state.listEvent[updateObj.obj.index].additionalServices = rs;
    }
  },
  MUTATION_UPDATE_EVENT_IN_LIST: function MUTATION_UPDATE_EVENT_IN_LIST(state, event) {
    if (event === null) return;
    event.lastModifiedAt *= 1000;
    state.listEvent.forEach(function (item) {
      if (item.id === event.id) {
        for (var key in event) {
          if (event.hasOwnProperty(key)) {
            item[key] = event[key];
          }
        }
      }
    });
  },
  MUTATION_SET_APPROVED_EVENTS: function MUTATION_SET_APPROVED_EVENTS(state, events) {
    if (events.changeFilter || events.currentPage === 1) {
      state.listApprovedEvent = [];
    }
    events.approvedEvents.forEach(function (el) {
      var eventObj = state.listApprovedEvent.find(function (event) {
        return event.clientId === el.clientId;
      });
      var index = state.listApprovedEvent.indexOf(eventObj);
      if (index >= 0) {
        var _state$listApprovedEv;

        (_state$listApprovedEv = state.listApprovedEvent[index].events).push.apply(_state$listApprovedEv, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(el.events));
      } else {
        state.listApprovedEvent.push(el);
      }
    });
    state.listApprovedEventBackup = __WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"](state.listApprovedEvent);
  },
  MUTATION_SEARCH_APPROVED_EVENT: function MUTATION_SEARCH_APPROVED_EVENT(state, keyword) {
    keyword = keyword ? keyword.toLowerCase() : '';
    if (keyword === '') {
      state.listApprovedEvent = __WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"](state.listApprovedEventBackup);
      state.totalApprovedEvents = 0;
      state.listApprovedEvent.forEach(function (client) {
        state.totalApprovedEvents += client.events.length;
      });
      return;
    }
    if (state.listApprovedEventBackup.length > 0) {
      state.listApprovedEvent = __WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"](state.listApprovedEventBackup);
    }
    var result = [];
    state.listApprovedEvent.forEach(function (client) {
      if (searchEvent(client, keyword)) {
        var clientItem = __WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"](client);
        clientItem.events = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(client.events), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.eventName !== null && item.eventName.toLowerCase().indexOf(keyword) >= 0 || (item.contactName !== null && item.contactName !== undefined ? item.contactName.toLowerCase().indexOf(keyword) >= 0 : false) || item.prefDate !== null && item.prefDate.toLowerCase().indexOf(keyword) >= 0 || (item.state !== null && item.state !== undefined ? item.state.toLowerCase().indexOf(keyword) >= 0 : false)) {
              clientItem.events.push(item);
            }
            if (client.clientName !== null && client.clientName.toLowerCase().indexOf(keyword) >= 0 && clientItem.events.length === 0 || client.eventManagerName !== null && client.eventManagerName.toLowerCase().indexOf(keyword) >= 0 && clientItem.events.length === 0) {
              var _clientItem$events;

              (_clientItem$events = clientItem.events).push.apply(_clientItem$events, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(client.events));
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        result.push(clientItem);
      }
    });
    state.listApprovedEvent = result;
    state.totalApprovedEvents = 0;
    state.listApprovedEvent.forEach(function (client) {
      state.totalApprovedEvents += client.events.length;
    });
  },
  MUTATION_SET_DATE_HAS_DATA: function MUTATION_SET_DATE_HAS_DATA(state, dates) {
    state.datesHasData = dates;
  },
  MUTATION_SET_LOCKED_DATE: function MUTATION_SET_LOCKED_DATE(state, dates) {
    // date = [{
    //   id,
    //   getLockedDate: 'MM/DD/YYYY'
    // }];
    var arr = [];
    dates.forEach(function (item, index) {
      arr.push(item.lockedDate);
    });
    state.lockedDates = arr;
  },
  MUTATION_SET_DATE_RANGE_HAS_DATA: function MUTATION_SET_DATE_RANGE_HAS_DATA(state, dates) {
    state.dateRangeHasData = dates;
  },
  MUTATION_SET_IS_LOADING: function MUTATION_SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  MUTATION_SAVE_STAFF_LIST: function MUTATION_SAVE_STAFF_LIST(state, list) {
    state.staffList = list;
  },
  MUTATION_CREATE_NEW_TEMP_STAFF: function MUTATION_CREATE_NEW_TEMP_STAFF(state) {
    state.staffList = [{
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      role: '',
      payRates: 0,
      address: '',
      events: '',
      isEditing: true
    }].concat(state.staffList || []);
    state.expandId = 0;
  },
  MUTATION_SAVE_EVENT_STAFF: function MUTATION_SAVE_EVENT_STAFF(state, list) {
    state[list.listType] = list.data;
  },
  MUTATION_SAVE_ASSIGN_STAFF_MODAL_KEY: function MUTATION_SAVE_ASSIGN_STAFF_MODAL_KEY(state, key) {
    state.openEventStaffModal = key;
  },
  MUTATION_SAVE_MANAGE_EVENT_REPORTS: function MUTATION_SAVE_MANAGE_EVENT_REPORTS(state, eventList) {
    state.manageEventReports = eventList;
  },
  MUTATION_SAVE_SLIDER_VALUE_REPORTS: function MUTATION_SAVE_SLIDER_VALUE_REPORTS(state, value) {
    state.sliderValue = value;
  },
  MUTATION_SET_STAFF_DETAIL: function MUTATION_SET_STAFF_DETAIL(state, obj) {
    state.staffDetail = obj;
  },
  MUTATION_SORT_EVENT_BY_FIELD_NAME: function MUTATION_SORT_EVENT_BY_FIELD_NAME(state, sortObj) {
    state.listEvent.sort(__WEBPACK_IMPORTED_MODULE_7__utils_array_helper__["a" /* default */].sortFunction(sortObj.fieldName, sortObj.isReverse, sortObj.fieldType));
  },
  MUTATION_SET_CURRENT_EVENT: function MUTATION_SET_CURRENT_EVENT(state, data) {
    state.currentEvent = data;
  },
  MUTATION_SET_CURRENT_RELATED_EVENTS: function MUTATION_SET_CURRENT_RELATED_EVENTS(state, data) {
    state.currentEvent.relatedEvents = __WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"](data);
  },
  MUTATION_SET_LIST_EVENT_GROUP: function MUTATION_SET_LIST_EVENT_GROUP(state, data) {
    state.listEventGroup = data;
  },
  MUTATION_UPDATE_EVENT_GROUP: function MUTATION_UPDATE_EVENT_GROUP(state, _ref) {
    var groupId = _ref.groupId,
        groupName = _ref.groupName,
        data = _ref.data;

    var group = state.listEventGroup.find(function (e) {
      return e.id === groupId;
    });
    if (!data) {
      state.listEventGroup = state.listEventGroup.filter(function (e) {
        return e.id !== groupId;
      });
      state.listSingleEvent = state.listSingleEvent.concat(group.data);
      sortDate(state.listSingleEvent, state.sort.reverse);
      return;
    }

    var eventId = data.eventId;
    var relatedEventIds = data.relatedEventsId;
    if (!group) {
      var groupData = state.listSingleEvent.filter(function (e) {
        return relatedEventIds.includes(e.id);
      });
      sortDate(groupData, state.sort.reverse);

      var newGroup = { id: eventId, name: groupName, data: groupData };
      setMinMaxDate(newGroup);

      state.listEventGroup.push(newGroup);
      state.listSingleEvent = state.listSingleEvent.filter(function (e) {
        return !relatedEventIds.includes(e.id);
      });
    } else {
      var eventsInSingleList = state.listSingleEvent.filter(function (e) {
        return relatedEventIds.includes(e.id);
      });
      var eventsInGroup = group.data.filter(function (e) {
        return relatedEventIds.includes(e.id);
      });
      var eventsShouldNotInGroup = group.data.filter(function (e) {
        return !relatedEventIds.includes(e.id);
      });

      var _groupData = eventsInGroup.concat(eventsInSingleList);
      sortDate(_groupData, state.sort.reverse);

      var _newGroup = { id: eventId, name: groupName, data: _groupData };
      setMinMaxDate(_newGroup);
      state.listEventGroup.splice(state.listEvent.indexOf(function (e) {
        return e.id === groupId;
      }), 1, _newGroup);
      state.listSingleEvent = state.listSingleEvent.filter(function (e) {
        return !relatedEventIds.includes(e.id);
      });
      state.listSingleEvent = state.listSingleEvent.concat(eventsShouldNotInGroup);
    }

    sortDate(state.listSingleEvent, state.sort.reverse);

    function sortDate(data, reverse) {
      data.sort(function (a, b) {
        return reverse ? new Date(b.prefDate) - new Date(a.prefDate) : new Date(a.prefDate) - new Date(b.prefDate);
      });
    }

    function setMinMaxDate(group) {
      if (!group.data || !group.data.length) return;
      group.minDateEventGroup = group.data[0].prefDate;
      group.maxDateEventGroup = group.data[group.data.length - 1].prefDate;
    }
  },
  MUTATION_UPDATE_EVENT_GROUP_NAME: function MUTATION_UPDATE_EVENT_GROUP_NAME(state, _ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        data = _ref2.data;

    var group = state.listEventGroup.find(function (item) {
      return item.id === id;
    });
    if (!group) return;
    group.name = name;
  },
  MUTATION_SET_LIST_SINGLE_EVENT: function MUTATION_SET_LIST_SINGLE_EVENT(state, data) {
    state.listSingleEvent = data;
  },
  MUTATION_SET_SORT_DATA: function MUTATION_SET_SORT_DATA(state, data) {
    state.sort.type = data.type;
    state.sort.reverse = data.reverse;
  },
  MUTATION_SET_EVENT_LIST_CREATE: function MUTATION_SET_EVENT_LIST_CREATE(state, newEvent) {
    if (newEvent === null || newEvent === undefined) {
      return;
    }
    var arrEvent = state.listEvent;
    state.listEvent = [newEvent].concat(arrEvent);
  },
  MUTATION_SET_IS_DOWNLOADING: function MUTATION_SET_IS_DOWNLOADING(state, status) {
    state.isDownloading = status;
  }
};

function searchEvent(client, keyword) {
  if (client.clientName !== null && client.clientName.toLowerCase().indexOf(keyword) >= 0 || (client.eventManagerName !== null && client.eventManagerName !== undefined ? client.eventManagerName.toLowerCase().indexOf(keyword) >= 0 : false)) {
    return true;
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(client.events), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.eventName !== null && item.eventName.toLowerCase().indexOf(keyword) >= 0 || (item.contactName !== null && item.contactName !== undefined ? item.contactName.toLowerCase().indexOf(keyword) >= 0 : false) || item.prefDate !== null && item.prefDate.toLowerCase().indexOf(keyword) >= 0 || (item.state !== null && item.state !== undefined ? item.state.toLowerCase().indexOf(keyword) >= 0 : false)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultState__ = __webpack_require__(2124);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__defaultState__["a" /* default */]
});

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_call__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_request__ = __webpack_require__(141);



var _constants$ACTION_CON;





// const actionUpdateMFAStatus = ({commit, state, dispatch}, data) => {
//   commit(constants.MUTATION_UPDATE_MFA_TYPE, data.type);
//   return new Promise((resolve, reject) => {
//     const body = {};
//
//     if (data.changedPhone) {
//       body.phone = data.phone;
//     }
//     apiRequest(getEndPoints().mfa.updateMFAStatus.replace('{type}', data.type).replace('{flow}', data.flow), buildOptions('POST', body))
//       .then(response => {
//         resolve(response);
//       })
//       .catch(error => reject(error));
//   });
// };

// const actionUpdateMFAConfirm = ({commit, state, dispatch}, data) => {
//   return new Promise((resolve, reject) => {
//     apiRequest(getEndPoints().mfa.updateMFAConfirm.replace('{type}', data.type).replace('{flow}', data.flow), buildOptions('POST', data))
//       .then(response => {
//         resolve(response);
//       })
//       .catch(error => {
//         reject(error);
//       });
//   });
// };

var actionSendNewCodeMFA = function actionSendNewCodeMFA(_ref, data) {
  var commit = _ref.commit,
      state = _ref.state,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["c" /* getEndPoint */])().mfa.sendNewCode, Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["a" /* buildOptions */])('POST', data)).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
    });
  });
};

var actionConfirmLoginMFA = function actionConfirmLoginMFA(_ref2, data) {
  var commit = _ref2.commit,
      state = _ref2.state,
      dispatch = _ref2.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["c" /* getEndPoint */])().mfa.confirmLogin, Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["a" /* buildOptions */])('POST', data)).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      return reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (_constants$ACTION_CON = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_constants$ACTION_CON, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ACTION_CONFIRM_LOGIN_MFA, actionConfirmLoginMFA), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_constants$ACTION_CON, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ACTION_SEND_NEW_CODE_MFA, actionSendNewCodeMFA), _constants$ACTION_CON);

/***/ }),
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(268);



var mfaData = function mfaData(mfa) {
  return mfa;
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].GETTER_MFA_DATA, mfaData));

/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(268);


var _constants$MUTATION_U;



var updateMFAType = function updateMFAType(mfa, type) {
  mfa.type = type;
};

var updateMFAFlow = function updateMFAFlow(mfa, flow) {
  mfa.flow = flow;
};

var updateMFALogin = function updateMFALogin(mfa, login) {
  mfa.login = login;
};

var updateMfaData = function updateMfaData(state, mfaData) {
  state.mfaData = {
    email: mfaData.email,
    phone: mfaData.phone
  };
  state.type = mfaData.mfaType;
  state.flow = mfaData.flow;
};

/* harmony default export */ __webpack_exports__["a"] = (_constants$MUTATION_U = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_constants$MUTATION_U, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].MUTATION_UPDATE_MFA_TYPE, updateMFAType), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_constants$MUTATION_U, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].MUTATION_UPDATE_MFA_FLOW, updateMFAFlow), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_constants$MUTATION_U, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].MUTATION_UPDATE_MFA_LOGIN, updateMFALogin), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_constants$MUTATION_U, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].MUTATION_UPDATE_MFA_DATA, updateMfaData), _constants$MUTATION_U);

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_js__ = __webpack_require__(9);


var defaultState = {
  type: null,
  flow: __WEBPACK_IMPORTED_MODULE_0__consts_js__["a" /* default */].mfaFlow.init,
  login: {},
  mfaData: {}
};

/* harmony default export */ __webpack_exports__["a"] = (defaultState);

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultState__ = __webpack_require__(2129);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__defaultState__["a" /* default */]
});

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_call__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_request__ = __webpack_require__(141);






var updateSettings = function updateSettings(_ref, data) {
  var commit = _ref.commit,
      state = _ref.state,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["c" /* getEndPoint */])().settings.updateValidator, Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["a" /* buildOptions */])('POST', data)).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ACTION_UPDATE_SETTINGS, updateSettings));

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import constants from './constants';

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import constants from './constants';

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import constCommon from '@/_consts.js';

var defaultState = {
  isLoadding: 0
};

/* harmony default export */ __webpack_exports__["a"] = (defaultState);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultState__ = __webpack_require__(2134);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__defaultState__["a" /* default */]
});

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api_call__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_request__ = __webpack_require__(141);






var resendEmail = function resendEmail(_ref, data) {
  var commit = _ref.commit,
      state = _ref.state,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["c" /* getEndPoint */])().emailHistory.resendEmail, Object(__WEBPACK_IMPORTED_MODULE_2__utils_api_call__["a" /* buildOptions */])('POST', data)).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ACTION_RESEND_EMAIL, resendEmail));

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import constants from './constants';

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import constants from './constants';

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import constCommon from '@/_consts.js';

var defaultState = {
  isLoadding: 0
};

/* harmony default export */ __webpack_exports__["a"] = (defaultState);

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export actions */
/* unused harmony export getters */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_request__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_call__ = __webpack_require__(140);






var state = {};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CREATE_USER_IF_NOT_EXIST */], function (_ref, body, options) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_request__["a" /* makeCall */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_api_call__["c" /* getEndPoint */])().oauth2.createUserIfNotExist, Object(__WEBPACK_IMPORTED_MODULE_4__utils_api_call__["a" /* buildOptions */])('POST', body, null, options)).then(function (response) {
      return resolve(response);
    }).catch(function (error) {
      return reject(error);
    });
  });
});

var getters = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__states__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(2140);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_0__states__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var state = {
  sbWorkgroups: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var getters = {
  GETTER_SB_WORKGROUPS: function GETTER_SB_WORKGROUPS(state) {
    return state.sbWorkgroups;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_call__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_request__ = __webpack_require__(141);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

var actions = {
  ACTION_GET_SB_WORKGROUPS: function ACTION_GET_SB_WORKGROUPS(_ref) {
    var commit = _ref.commit;

    var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_4__utils_api_call__["c" /* getEndPoint */])().shiftboard.getWorkgroups;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_request__["a" /* makeCall */])(apiUrl, Object(__WEBPACK_IMPORTED_MODULE_4__utils_api_call__["a" /* buildOptions */])('GET')).then(function (response) {
        resolve(response);
        commit('MUTATION_UPDATE_SB_WORKGROUPS', response || []);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

var mutations = {
  MUTATION_UPDATE_SB_WORKGROUPS: function MUTATION_UPDATE_SB_WORKGROUPS(state, data) {
    state.sbWorkgroups = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d387de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(2258);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d387de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/infoWindow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] infoWindow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5d387de2", Component.options)
  } else {
    hotAPI.reload("data-v-5d387de2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2257 */,
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("div", { ref: "flyaway" }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d387de2", esExports)
  }
}

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a8bf5130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(2263);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2260)
}
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a8bf5130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/map.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] map.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a8bf5130", Component.options)
  } else {
    hotAPI.reload("data-v-a8bf5130", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2261);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("559c8fc5", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a8bf5130\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./map.vue", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a8bf5130\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./map.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.vue-map-container {\n  position: relative;\n}\n.vue-map-container .vue-map {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n.vue-map-hidden {\n  display: none;\n}\n", ""]);

// exports


/***/ }),
/* 2262 */,
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-map-container" },
    [
      _c("div", { ref: "vue-map", staticClass: "vue-map" }),
      _vm._v(" "),
      _c("div", { staticClass: "vue-map-hidden" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("visible")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a8bf5130", esExports)
  }
}

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c3be001_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(2268);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2265)
}
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c3be001_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] streetViewPanorama.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c3be001", Component.options)
  } else {
    hotAPI.reload("data-v-4c3be001", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2266);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7d36ca0c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c3be001\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./streetViewPanorama.vue", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c3be001\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./streetViewPanorama.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "\n.vue-street-view-pano-container {\n  position: relative;\n}\n.vue-street-view-pano-container .vue-street-view-pano {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n", ""]);

// exports


/***/ }),
/* 2267 */,
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-street-view-pano-container" },
    [
      _c("div", {
        ref: "vue-street-view-pano",
        staticClass: "vue-street-view-pano"
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c3be001", esExports)
  }
}

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_373387b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(2271);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_373387b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/placeInput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] placeInput.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-373387b2", Component.options)
  } else {
    hotAPI.reload("data-v-373387b2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2270 */,
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", [
    _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      class: _vm.className,
      attrs: { type: "text", placeholder: _vm.placeholder }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-373387b2", esExports)
  }
}

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_12ce438c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(2277);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_12ce438c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/autocomplete.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] autocomplete.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-12ce438c", Component.options)
  } else {
    hotAPI.reload("data-v-12ce438c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    attrs: { type: "text", placeholder: _vm.placeholder },
    domProps: { value: _vm.value }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12ce438c", esExports)
  }
}

/***/ }),
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[881]);


// WEBPACK FOOTER //
// static/js/app.b137d0effa62ede7aae8.js